import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null | undefined;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /**
   * Custom scalar for exact decimal values
   * Maps to DECIMAL(14,10) in the database
   */
  Decimal: { input: string; output: string; }
  /** Int64 represents a 64-bit integer */
  Int64: { input: number; output: number; }
  /** Custom scalar for raw JSON values */
  JSON: { input: Record<string, unknown>; output: Record<string, unknown>; }
  /**
   * Custom scalar a type that can either be a string containing an integer or an integer.
   * Empty strings are treated as zero.
   */
  StringInt: { input: number; output: number; }
  /** Time represents a timestamp */
  Time: { input: Date; output: Date; }
  /** Upload represents a file upload request */
  Upload: { input: globalThis.File; output: globalThis.File; }
};

/**
 * The categories of referenced pages that may be automatically appended to a
 * generated ACORD form's PDF.
 */
export enum AcordAppendType {
  /** Additional insured endorsement pages. */
  AdditionalInsuredEndorsements = 'ADDITIONAL_INSURED_ENDORSEMENTS',
  /** Additional interest and loss payee pages. */
  AdditionalInterestsLossPayees = 'ADDITIONAL_INTERESTS_LOSS_PAYEES',
  /** Declaration pages and schedules. */
  DeclarationPagesAndSchedules = 'DECLARATION_PAGES_AND_SCHEDULES',
  /** Never append any referenced pages. */
  NeverAppend = 'NEVER_APPEND',
  /** Other referenced endorsement pages. */
  OtherReferencedEndorsements = 'OTHER_REFERENCED_ENDORSEMENTS',
  /** Waiver of subrogation endorsement pages. */
  WaiverOfSubrogation = 'WAIVER_OF_SUBROGATION'
}

/** The set of append categories enabled for a single ACORD form. */
export type AcordFormAppendRule = {
  __typename?: 'ACORDFormAppendRule';
  /** The categories of pages to automatically append for this form. */
  appendTypes: Array<AcordAppendType>;
  /** The ACORD form these append categories apply to. */
  formType: AcordFormType;
};

/** Input for the set of append categories enabled for a single ACORD form. */
export type AcordFormAppendRuleInput = {
  /** The categories of pages to automatically append for this form. */
  appendTypes: Array<AcordAppendType>;
  /** The ACORD form these append categories apply to. */
  formType: AcordFormType;
};

/**
 * Agency-level configuration governing ACORD COI/EOI/ID-card generation.
 *
 * Each agency is seeded with the current default configuration. Scalar fields may
 * be null and then resolve to Cara's current default; null or empty list fields
 * mean the agency has configured no append rules or prompt rules. Use the
 * descriptionOfOperationsMode EMPTY enum value (not null) to intentionally leave
 * the DOO box blank.
 */
export type AcordFormConfiguration = {
  __typename?: 'ACORDFormConfiguration';
  /**
   * Per-form automatic PDF page-append rules. Null or an empty list means the
   * agency has configured no append rules.
   */
  appendRules?: Maybe<Array<AcordFormAppendRule>>;
  /**
   * How the Description of Operations box on ACORD 25 and ACORD 30 is populated.
   * Null means use the Cara default.
   */
  descriptionOfOperationsMode?: Maybe<DescriptionOfOperationsMode>;
  /** Base64-encoded agency logo stamped on ACORD 50 ID cards, if any. */
  idCardLogoBase64Data?: Maybe<Scalars['String']['output']>;
  /** How limit-box numbers are formatted. Null means use the Cara default. */
  numberFormat?: Maybe<AcordNumberFormat>;
  /**
   * Where producer person/contact fields on model-filled ACORD forms come from.
   * Null means use the Cara default (configured Producer Information).
   */
  producerInformationSource?: Maybe<AcordProducerInformationSource>;
  /**
   *   Ordered, section-scoped rules injected into ACORD prompts at generation time.
   * Null or an empty list means the agency has configured no rules.
   */
  rules?: Maybe<Array<AcordFormRule>>;
};

/**
 * Input for an agency's ACORD COI/EOI configuration overrides. Scalar fields are
 * overrides: a null scalar resets that setting to the Cara default rather than
 * clearing it. The list fields are agency-owned and are written in full
 * (replace-all); ordering is taken from array position. Send null for
 * descriptionOfOperationsMode or numberFormat to revert to the default, EMPTY
 * (for DOO) to intentionally leave the box blank, or null/an empty list for
 * rules/appendRules to configure no rules. Preset list values are copied to each
 * agency when it is created and are not re-injected.
 */
export type AcordFormConfigurationInput = {
  /**
   * Per-form automatic PDF page-append rules. Null or an empty list configures no
   * append rules. Preset rules are seeded when the agency is created and are not
   * re-injected.
   */
  appendRules?: InputMaybe<Array<AcordFormAppendRuleInput>>;
  /**
   * How the Description of Operations box on ACORD 25 and ACORD 30 is populated.
   * Null reverts to the Cara default.
   */
  descriptionOfOperationsMode?: InputMaybe<DescriptionOfOperationsMode>;
  /** Base64-encoded agency logo stamped on ACORD 50 ID cards, if any. */
  idCardLogoBase64Data?: InputMaybe<Scalars['String']['input']>;
  /** How limit-box numbers are formatted. Null reverts to the Cara default. */
  numberFormat?: InputMaybe<AcordNumberFormat>;
  /**
   * Where producer person/contact fields on model-filled ACORD forms come from.
   * Null reverts to the Cara default (configured Producer Information).
   */
  producerInformationSource?: InputMaybe<AcordProducerInformationSource>;
  /**
   * Ordered, section-scoped rules injected into ACORD prompts at generation time.
   * Null or an empty list configures no rules. Preset rules are seeded when the
   * agency is created and are not re-injected.
   */
  rules?: InputMaybe<Array<AcordFormRuleInput>>;
};

/**
 * A single section-scoped rule in the rules engine. The condition describes when
 * the rule applies; the phrasing is the exact text Cara injects, supporting
 * [[placeholder]]-style interpolation for values the model fills in.
 */
export type AcordFormRule = {
  __typename?: 'ACORDFormRule';
  /** Plain-language description of when the rule applies. */
  condition: Scalars['String']['output'];
  /** The ACORD form this rule applies to. */
  formType: AcordFormType;
  /** Unique identifier for the rule. */
  id: Scalars['ID']['output'];
  /** Whether this rule was pre-populated from current prompt language. */
  isPreset: Scalars['Boolean']['output'];
  /** The exact phrasing Cara injects, with optional [[placeholder]] slots. */
  phrasing: Scalars['String']['output'];
  /**
   * The section of the form this rule is scoped to. Null for a form-level rule on
   * a form that has no scoped sections (e.g. ACORD 28). When present, the section
   * must belong to formType.
   */
  section?: Maybe<AcordFormSection>;
};

/**
 * Input for a single section-scoped rule. Omit id to create a new rule; the
 * server assigns one. The isPreset flag is server-owned and preserved by id.
 */
export type AcordFormRuleInput = {
  /** Plain-language description of when the rule applies. */
  condition: Scalars['String']['input'];
  /** The ACORD form this rule applies to. */
  formType: AcordFormType;
  /** Unique identifier for the rule. Omit to create a new rule. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The exact phrasing Cara injects, with optional [[placeholder]] slots. */
  phrasing: Scalars['String']['input'];
  /**
   * The section of the form this rule is scoped to. Omit for a form-level rule on
   * a form that has no scoped sections (e.g. ACORD 28). When present, the section
   * must belong to formType.
   */
  section?: InputMaybe<AcordFormSection>;
};

/**
 * A section of an ACORD form that a rule can be scoped to. ACORD 28 has no
 * scoped sections in this release.
 *
 * The ACORD 20/21/22/23/29 certificates each expose only their remarks box. Every
 * other box on those forms is a structured cell — a limit, a date, a policy number
 * or a lettered tick — which the policy answers on its own and which no phrasing
 * rule should be able to reword.
 */
export enum AcordFormSection {
  /** The remarks box on ACORD 20. */
  Acord_20Remarks = 'ACORD_20_REMARKS',
  /** The remarks box on ACORD 21. */
  Acord_21Remarks = 'ACORD_21_REMARKS',
  /** The remarks box on ACORD 22. */
  Acord_22Remarks = 'ACORD_22_REMARKS',
  /** The remarks box on ACORD 23. */
  Acord_23Remarks = 'ACORD_23_REMARKS',
  /** The location description box on ACORD 24. */
  Acord_24LocationDescription = 'ACORD_24_LOCATION_DESCRIPTION',
  /** The special conditions box on ACORD 24. */
  Acord_24SpecialConditions = 'ACORD_24_SPECIAL_CONDITIONS',
  /** The Description of Operations box on ACORD 25. */
  Acord_25DescriptionOfOperations = 'ACORD_25_DESCRIPTION_OF_OPERATIONS',
  /** The coverage information box on ACORD 27. */
  Acord_27CoverageInformation = 'ACORD_27_COVERAGE_INFORMATION',
  /** The property information box on ACORD 27. */
  Acord_27PropertyInformation = 'ACORD_27_PROPERTY_INFORMATION',
  /** The remarks box on ACORD 27. */
  Acord_27Remarks = 'ACORD_27_REMARKS',
  /** The remarks box on ACORD 29. */
  Acord_29Remarks = 'ACORD_29_REMARKS',
  /**
   * The Description of Operations box on ACORD 30. Governed by the same
   * descriptionOfOperationsMode as ACORD 25.
   */
  Acord_30DescriptionOfOperations = 'ACORD_30_DESCRIPTION_OF_OPERATIONS'
}

/** The ACORD forms that the agency-level COI/EOI configuration applies to. */
export enum AcordFormType {
  /** ACORD 20 - Certificate of Aviation Liability Insurance */
  Acord_20 = 'ACORD_20',
  /** ACORD 21 - Certificate of Aircraft Insurance */
  Acord_21 = 'ACORD_21',
  /** ACORD 22 - Intermodal Interchange Certificate of Insurance */
  Acord_22 = 'ACORD_22',
  /** ACORD 23 - Vehicle or Equipment Certificate of Insurance */
  Acord_23 = 'ACORD_23',
  /** ACORD 24 - Certificate of Property Insurance */
  Acord_24 = 'ACORD_24',
  /** ACORD 25 - Certificate of Liability Insurance */
  Acord_25 = 'ACORD_25',
  /** ACORD 27 - Evidence of Property Insurance */
  Acord_27 = 'ACORD_27',
  /** ACORD 28 - Evidence of Commercial Property Insurance */
  Acord_28 = 'ACORD_28',
  /** ACORD 29 - Evidence of Flood Insurance */
  Acord_29 = 'ACORD_29',
  /** ACORD 30 - Certificate of Insurance for garage businesses */
  Acord_30 = 'ACORD_30'
}

/** How numbers are formatted inside limit boxes on ACORD 24, 25, 27, and 28. */
export enum AcordNumberFormat {
  /** Format limit amounts with comma thousands separators (e.g. 1,000,000). */
  Commas = 'COMMAS',
  /** Format limit amounts without separators (e.g. 1000000). */
  NoCommas = 'NO_COMMAS'
}

/** Where producer person/contact fields on model-filled ACORD forms come from. */
export enum AcordProducerInformationSource {
  /**
   * Allow Cara to fill the producer/authorized-representative name and producer
   * contact fields from workspace instructions. The agency firm name and address
   * always come from configured Producer Information. When instructions omit a
   * producer field, the current workspace user is the name/email fallback.
   */
  CaraFromInstructions = 'CARA_FROM_INSTRUCTIONS',
  /**
   * Use the applicable agency- or user-level configured Producer Information (or
   * liability COI fallback).
   */
  ConfiguredDefault = 'CONFIGURED_DEFAULT'
}

/** AMS360Configuration contains configuration for the AMS360 integration */
export type Ams360Configuration = {
  __typename?: 'AMS360Configuration';
  /** AMS360 Agency Number */
  agencyNo: Scalars['String']['output'];
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey: Scalars['String']['output'];
  /** AMS360 App Key for authentication */
  appKey: Scalars['String']['output'];
  /**
   * When a synced task has no due date, the suspense due date is this many business days
   * after the sync time (weekends skipped). Defaults to 3 when unset.
   */
  defaultTaskDueBusinessDays?: Maybe<Scalars['Int']['output']>;
  /**
   * If enabled, will sync accounts from Cara to AMS360. When disabled, Cara will not create
   * tasks or notes for clients that don't already exist in AMS360.
   */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to AMS360 as activities. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to AMS360 as suspenses. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /**
   * Determines who suspenses (tasks) created from calls are assigned to. Defaults to
   * ACCOUNT_EXECUTIVE (the historical behavior) when unset.
   */
  taskAssignmentMethod?: Maybe<Ams360TaskAssignmentMethod>;
};

/** The method to use to assign suspenses (tasks) created in AMS360 from calls */
export enum Ams360TaskAssignmentMethod {
  /**
   * Assign to the account CSR (the policy's CSR), i.e. the account manager shown at the
   * top of the AMS360 account summary.
   */
  AccountCsr = 'ACCOUNT_CSR',
  /**
   * Assign to the account executive (the policy's executive code). This is the default
   * and matches the historical behavior.
   */
  AccountExecutive = 'ACCOUNT_EXECUTIVE'
}

/**
 * An account represents a customer of an agency. They represent either an individual or a business.
 * An agency can have a contact with multiple accounts.
 */
export type Account = {
  __typename?: 'Account';
  /** Businesses owned or operated by this account. */
  account: AccountDetails;
  /** The agency that manages this account. */
  agency: Agency;
  /** Active insurance policies held by this account. */
  businessPolicies: Array<BusinessPolicy>;
  /** Certificates of liability insurance held by this account. */
  certificatesOfLiabilityInsurance: Array<CertificateOfLiabilityInsurance>;
  /** Contacts associated with this account. */
  contacts: Array<AccountContact>;
  /** When the account record was created. */
  createdAt: Scalars['Time']['output'];
  /** Files associated with this account. */
  files: Array<File>;
  /** Unique identifier for the account. */
  id: Scalars['ID']['output'];
  /** Service requests submitted by this account. */
  serviceRequests: Array<ServiceRequest>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
  /** When the account record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type AccountContact = {
  __typename?: 'AccountContact';
  /** Accounts associated with this contact */
  accounts: Array<Account>;
  /** When the contact record was created. */
  createdAt: Scalars['Time']['output'];
  /** The contact's email address */
  email: Scalars['String']['output'];
  /** Unique identifier for the contact */
  id: Scalars['ID']['output'];
  /** The contact's name */
  name: Scalars['String']['output'];
  /** The contact's phone number */
  phone: Scalars['String']['output'];
  /** When the contact record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

/** Interface defining the common fields required for both business and individual accounts */
export type AccountDetails = {
  /** Primary email address for contacting the account holder */
  email: Scalars['String']['output'];
  /** Mailing address for the account holder */
  mailingAddress: Address;
  /** The full name of the account holder - either legal business name or individual's name */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the account holder */
  phone: Scalars['String']['output'];
};

/** The type of account - either a business or individual account. */
export enum AccountType {
  /** Account represents a business entity */
  Business = 'BUSINESS',
  /** Account represents an individual person */
  Individual = 'INDIVIDUAL'
}

/** Account user represents an authenticated user of an account */
export type AccountUser = {
  __typename?: 'AccountUser';
  /** The account this user is associated with */
  accounts: Array<Account>;
  /** When the account user was created */
  createdAt: Scalars['Time']['output'];
  /** Email of the account user */
  email: Scalars['String']['output'];
  /** Unique identifier for the account user */
  id: Scalars['ID']['output'];
  /** Name of the account user */
  name: Scalars['String']['output'];
  /** When the account user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Response from the account user sign in mutation */
export type AccountUserSignInResponse = {
  __typename?: 'AccountUserSignInResponse';
  /** The account user that was signed in */
  accountUser: AccountUser;
};

/**
 * Actions that can be performed on resources.
 * These are the operations that can be permitted or restricted. These must be combined with a resource
 * to form a valid permission (and only certain combinations are validated, documented in api/auth/permissions.go).
 */
export enum Action {
  /** Assign a resource to a user */
  Assign = 'ASSIGN',
  /** Cancel an operation or policy */
  Cancel = 'CANCEL',
  /** Create a new resource */
  Create = 'CREATE',
  /** Delete a resource */
  Delete = 'DELETE',
  /** Disable an active resource */
  Disable = 'DISABLE',
  /** Enable a disabled resource */
  Enable = 'ENABLE',
  /** List multiple resources */
  List = 'LIST',
  /** Read/view a resource */
  Read = 'READ',
  /** Reinstate a canceled policy */
  Reinstate = 'REINSTATE',
  /** Renew a policy or subscription */
  Renew = 'RENEW',
  /** Resolve a request or issue */
  Resolve = 'RESOLVE',
  /** Send mail through a resource */
  Send = 'SEND',
  /** Share a resource with another agency */
  Share = 'SHARE',
  /** Sign in to a system */
  SignIn = 'SIGN_IN',
  /** Sign out of a system */
  SignOut = 'SIGN_OUT',
  /** Synchronize with external system */
  Sync = 'SYNC',
  /** Update an existing resource */
  Update = 'UPDATE',
  /** Upload a file or data */
  Upload = 'UPLOAD'
}

/** Details for a request to add an additional insured to a policy */
export type AddAdditionalInsuredRequest = {
  __typename?: 'AddAdditionalInsuredRequest';
  /** Address of the additional insured */
  address: Address;
  /** Name of the additional insured */
  name: Scalars['String']['output'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['output'];
};

/** Input type for adding an additional insured request */
export type AddAdditionalInsuredRequestInput = {
  /** Address of the additional insured */
  address: AddressInput;
  /** Name of the additional insured */
  name: Scalars['String']['input'];
  /** Relationship between the policyholder and additional insured */
  relationship: Scalars['String']['input'];
};

/**
 * What adding recipients did: rows whose address is already listed, and rows past the cap of
 * 50, are left out.
 */
export type AddEmailBulkSendRecipientsResult = {
  __typename?: 'AddEmailBulkSendRecipientsResult';
  added: Scalars['Int']['output'];
  bulkSend: EmailBulkSend;
  duplicatesSkipped: Scalars['Int']['output'];
  overCap: Scalars['Int']['output'];
};

/** Input type for adding a comment to a service request */
export type AddServiceRequestCommentInput = {
  /** The content of the comment */
  content: Scalars['String']['input'];
};

/** Describes an address that can be accepted as input */
export type Address = {
  __typename?: 'Address';
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['output'];
  /** First line of the address. */
  line1: Scalars['String']['output'];
  /** Optional second line of the address. */
  line2?: Maybe<Scalars['String']['output']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['output'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: Maybe<Scalars['String']['output']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['output'];
};

/** Describes an address that can be accepted as input */
export type AddressInput = {
  /**
   *  Level 3 administrative division depending on country. For example, this is
   * the city in the U.S., a muncipality in Austria, a ward in Singapore, etc.
   */
  city: Scalars['String']['input'];
  /** First line of the address. */
  line1: Scalars['String']['input'];
  /** Optional second line of the address. */
  line2?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Country-specific mailing identifier, e.g. ZIP Code in the U.S., Post Code
   * in the U.K., etc.
   */
  postalCode: Scalars['String']['input'];
  /**
   *  Level 2 administrative division depending on country. For example, this is
   * the county in the U.S., prefectural city in China, division in India, etc.
   */
  subZone?: InputMaybe<Scalars['String']['input']>;
  /**
   *  Level 1 administrative division depending on country. For example, this is
   * the state in the U.S., the province in Canada, etc.
   */
  zone: Scalars['String']['input'];
};

/** Input for creating a new version of a workflow execution with adjusted inputs */
export type AdjustWorkflowInputsInput = {
  /** The inputs to replace in the new version */
  inputs: Array<CreateWorkflowInputEntry>;
};

/**
 * One non-disabled seat with binary outcomes for whether they performed each
 * tracked action within the fixed active window (see AdminAnalyticsTotals.activeDefinition).
 * Note: createdArtifact implies usedWorkspace, since artifacts are produced inside
 * workspaces and keyed on the workspace creation time.
 */
export type AdminAnalyticsActiveUser = {
  __typename?: 'AdminAnalyticsActiveUser';
  /** Uploaded at least one document to the knowledge base in the active window. */
  addedToKnowledgeBase: Scalars['Boolean']['output'];
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  /** Produced a tracked artifact (filled template / generated form or doc) in the active window. */
  createdArtifact: Scalars['Boolean']['output'];
  /** True when the user performed any activating action (workspace or email). */
  isActive: Scalars['Boolean']['output'];
  lastActivityAt?: Maybe<Scalars['Time']['output']>;
  /** Had a sign-in code generated within the active window (self-service or admin-generated). */
  loggedIn: Scalars['Boolean']['output'];
  /** Sent inbound email to Cara in the active window. */
  usedEmail: Scalars['Boolean']['output'];
  /** Created or used a workspace in the active window. */
  usedWorkspace: Scalars['Boolean']['output'];
};

export type AdminAnalyticsActivityBucket = {
  __typename?: 'AdminAnalyticsActivityBucket';
  activityType: AdminAnalyticsActivityType;
  count: Scalars['Int']['output'];
  periodStart: Scalars['Time']['output'];
};

/**
 * Two-dimensional activity matrix: users (rows) × workspace presets and
 * template types (columns). Powers the per-user usage heatmap below the
 * "Active users" section.
 */
export type AdminAnalyticsActivityMatrix = {
  __typename?: 'AdminAnalyticsActivityMatrix';
  /**
   * Percentage change in total matrix activity (all users) for the second half of
   * the filtered range vs the first half. Same semantics as row activityDeltaPct.
   */
  activityDeltaPct?: Maybe<Scalars['Int']['output']>;
  /** One row per user with non-zero activity, sorted by descending totalActivities. */
  rows: Array<AdminAnalyticsActivityMatrixRow>;
  /** Template/form-type columns in display order. */
  templateTypes: Array<AdminAnalyticsActivityMatrixDimension>;
  /** Workspace-preset columns in display order. */
  workspacePresets: Array<AdminAnalyticsActivityMatrixDimension>;
};

export type AdminAnalyticsActivityMatrixDimension = {
  __typename?: 'AdminAnalyticsActivityMatrixDimension';
  /**
   * For a workspace preset column, the preset's key, in the format of
   * AdminAnalyticsWorkspaceBreakdown.key, or __OTHER__ for the presets past the
   * column cap. For a template column, the template type.
   */
  key: Scalars['String']['output'];
  /**
   * Human-readable label for the column header. A workspace preset is named as
   * AdminAnalyticsWorkspaceBreakdown names it.
   */
  label: Scalars['String']['output'];
};

export type AdminAnalyticsActivityMatrixRow = {
  __typename?: 'AdminAnalyticsActivityMatrixRow';
  /** Percentage change in activities compared to the prior half of the filtered range, if any. */
  activityDeltaPct?: Maybe<Scalars['Int']['output']>;
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  /**
   * Average number of USER-role messages per workspace for this team member
   * across workspaces created in the filter window. 0 when the user has no
   * workspaces in the window or when WORKSPACE activity is masked.
   */
  avgUserMessagesPerWorkspace: Scalars['Float']['output'];
  /** Counts parallel to AdminAnalyticsActivityMatrix.templateTypes. */
  templateTypeCounts: Array<Scalars['Int']['output']>;
  /** Sum of all workspace-preset and template-type counts for this user. */
  totalActivities: Scalars['Int']['output'];
  /** Counts parallel to AdminAnalyticsActivityMatrix.workspacePresets. */
  workspacePresetCounts: Array<Scalars['Int']['output']>;
};

/** Activity categories shown in the admin analytics dashboard. */
export enum AdminAnalyticsActivityType {
  Call = 'CALL',
  Email = 'EMAIL',
  KnowledgeBaseUpload = 'KNOWLEDGE_BASE_UPLOAD',
  Workspace = 'WORKSPACE'
}

/** A choice in the analytics access profile filter: a profile, or no profile. */
export type AdminAnalyticsAgencyProfileOption = {
  __typename?: 'AdminAnalyticsAgencyProfileOption';
  /** Null for the users no access profile governs. */
  agencyProfileId?: Maybe<Scalars['String']['output']>;
  isDefault: Scalars['Boolean']['output'];
  /** Null for the users no access profile governs. */
  name?: Maybe<Scalars['String']['output']>;
};

export type AdminAnalyticsAmsWriteIntegration = {
  __typename?: 'AdminAnalyticsAmsWriteIntegration';
  failed: Scalars['Int']['output'];
  integrationType: IntegrationType;
  succeeded: Scalars['Int']['output'];
};

export type AdminAnalyticsAmsWritePeriod = {
  __typename?: 'AdminAnalyticsAmsWritePeriod';
  failed: Scalars['Int']['output'];
  periodStart: Scalars['Time']['output'];
  /** False for a period that ended before recordingStartedAt. */
  recorded: Scalars['Boolean']['output'];
  succeeded: Scalars['Int']['output'];
};

export type AdminAnalyticsAmsWriteRecordType = {
  __typename?: 'AdminAnalyticsAmsWriteRecordType';
  /** Plural display label, e.g. Notes. */
  label: Scalars['String']['output'];
  /** The integration operation, e.g. PUSH_NOTE, or OTHER for one without a label. */
  recordType: Scalars['String']['output'];
  succeeded: Scalars['Int']['output'];
};

export type AdminAnalyticsAmsWriteSource = {
  __typename?: 'AdminAnalyticsAmsWriteSource';
  source: AdminAnalyticsAmsWriteSourceType;
  succeeded: Scalars['Int']['output'];
};

export enum AdminAnalyticsAmsWriteSourceType {
  /** Cara, asked by a user in a workspace or run by a workflow. */
  Cara = 'CARA',
  /** Voice AI, after a call. */
  VoiceAi = 'VOICE_AI'
}

/**
 * Records Cara wrote to the agency's integrations (AMS, CRM and Zapier), counted one per
 * record, never per tool call.
 */
export type AdminAnalyticsAmsWrites = {
  __typename?: 'AdminAnalyticsAmsWrites';
  byIntegration: Array<AdminAnalyticsAmsWriteIntegration>;
  byRecordType: Array<AdminAnalyticsAmsWriteRecordType>;
  /** Empty when voiceAiExcluded. */
  bySource: Array<AdminAnalyticsAmsWriteSource>;
  failed: Scalars['Int']['output'];
  /** Whether the agency has an integration that isn't deleted. */
  hasIntegration: Scalars['Boolean']['output'];
  /** One entry per period from the start of the date filter, or recordingStartedAt, to its end. */
  overTime: Array<AdminAnalyticsAmsWritePeriod>;
  /** When the agency's first write was recorded, whatever the filters. Null if none was. */
  recordingStartedAt?: Maybe<Scalars['Time']['output']>;
  succeeded: Scalars['Int']['output'];
  /**
   * True under a user, access profile, workspace preset or started-by filter, which Voice AI
   * writes have no value for, so they aren't counted. unfilteredSections then lists
   * VOICE_AI_AMS_WRITES.
   */
  voiceAiExcluded: Scalars['Boolean']['output'];
};

export type AdminAnalyticsDateRange = {
  __typename?: 'AdminAnalyticsDateRange';
  after?: Maybe<Scalars['Time']['output']>;
  before?: Maybe<Scalars['Time']['output']>;
};

/** A CSV export of one Analytics table. Only the agency user who asked for it can see or download it. */
export type AdminAnalyticsExport = {
  __typename?: 'AdminAnalyticsExport';
  createdAt: Scalars['Time']['output'];
  /** When the file is deleted. Null until the export is READY. */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  status: AdminAnalyticsExportStatus;
  table: AdminAnalyticsExportTable;
};

export enum AdminAnalyticsExportStatus {
  /** The file has been deleted. Export again for a new one. */
  Expired = 'EXPIRED',
  Failed = 'FAILED',
  /** The file can be downloaded until expiresAt. */
  Ready = 'READY',
  Running = 'RUNNING'
}

/** An Analytics table that can be exported as a CSV file. */
export enum AdminAnalyticsExportTable {
  /** One row per artifact, at its latest version. */
  Artifacts = 'ARTIFACTS',
  /** One row per workspace. */
  Workspaces = 'WORKSPACES'
}

export type AdminAnalyticsFilterInput = {
  /** Filter activity charts to selected activity categories. */
  activityTypes?: InputMaybe<Array<AdminAnalyticsActivityType>>;
  /**
   * Filter user-attributed activity to the users this access profile governs today, including
   * those on it as the agency default. It must be a profile of the one agency in scope.
   * Mutually exclusive with withoutAgencyProfile.
   */
  agencyProfileId?: InputMaybe<Scalars['ID']['input']>;
  /** Filter user-attributed activity to a single agency user. */
  agencyUserId?: InputMaybe<Scalars['ID']['input']>;
  /** Group activity over time by day or week. Defaults to WEEK. */
  granularity?: InputMaybe<AdminAnalyticsGranularity>;
  /**
   * When true, aggregate the parent organization and all direct child subagencies.
   * Defaults to false (parent-only). Ignored when subagencyId is set.
   */
  includeAllSubagencies?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter analytics to activities that occurred in this range. */
  occurredAt?: InputMaybe<DateFilter>;
  /**
   * Filter workspace analytics to workspaces started this way. Activity that isn't a
   * workspace, such as calls and emails, can't match it.
   */
  startedBy?: InputMaybe<AdminAnalyticsStartedBy>;
  /**
   * When set, scope analytics to this direct child subagency.
   * Must be a child of the caller's organization (from_agency_id = org, to_agency_id = this id).
   * Mutually exclusive with includeAllSubagencies.
   */
  subagencyId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When true, filter user-attributed activity to the users no access profile governs: admins,
   * and everyone when the agency has no default profile. Needs a single agency in scope.
   */
  withoutAgencyProfile?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter workspace analytics to a workspace preset. */
  workspacePreset?: InputMaybe<Scalars['String']['input']>;
};

/** Time grouping used for activity charts. */
export enum AdminAnalyticsGranularity {
  Day = 'DAY',
  Week = 'WEEK'
}

/** A labelled histogram bucket (e.g. "1-5 tool calls" → 12 workspaces). */
export type AdminAnalyticsHistogramBucket = {
  __typename?: 'AdminAnalyticsHistogramBucket';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

/**
 * Illustrative incremental revenue attributable to Cara above baseline close rate.
 * Per-client logistic close likelihood is computed server-side; multiply
 * expectedIncrementalAccounts by avg account premium and commissionRate on the
 * client to convert into agency revenue dollars.
 */
export type AdminAnalyticsIncrementalRevenue = {
  __typename?: 'AdminAnalyticsIncrementalRevenue';
  /** Average incremental close likelihood across workspace clients (excludes tickets). */
  avgCloseLikelihood: Scalars['Float']['output'];
  /**
   * Distinct clients (normalized client tag) with positive quote/renewal engagement
   * in the filter window. Null-tagged workspaces each count as their own client.
   */
  clientsConsidered: Scalars['Int']['output'];
  /**
   * Share of policy premium booked as agency revenue (commission). Fixed backend
   * assumption used to convert modeled incremental premium into revenue; not
   * user-configurable.
   */
  commissionRate: Scalars['Float']['output'];
  /**
   * Sum of modeled incremental close probabilities across clients and unlinked
   * quote-request tickets (fractional accounts, e.g. 2.4 = ~2–3 expected new accounts).
   * Premium and commission assumptions are per account, not per underlying policy.
   */
  expectedIncrementalAccounts: Scalars['Float']['output'];
};

export type AdminAnalyticsKbSearchPerUser = {
  __typename?: 'AdminAnalyticsKBSearchPerUser';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  searchCount: Scalars['Int']['output'];
};

/**
 * Knowledge-base search-tool usage in the filter window. Surfaces how often
 * the team actually queries the KB, not just how often they upload to it.
 */
export type AdminAnalyticsKbSearchUsage = {
  __typename?: 'AdminAnalyticsKBSearchUsage';
  /** Per-user breakdown sorted by descending search count. */
  perUser: Array<AdminAnalyticsKbSearchPerUser>;
  /** Distinct users who ran at least one KB search. */
  searcherCount: Scalars['Int']['output'];
  /** Total number of SEARCH_KNOWLEDGE_BASE tool invocations. */
  totalSearches: Scalars['Int']['output'];
};

/**
 * Net knowledge base document count at the end of each reporting period,
 * computed using created_at / deleted_at so the line decreases when docs are removed.
 */
export type AdminAnalyticsKbSnapshot = {
  __typename?: 'AdminAnalyticsKBSnapshot';
  documentCount: Scalars['Int']['output'];
  periodStart: Scalars['Time']['output'];
};

export type AdminAnalyticsKnowledgeBaseUpload = {
  __typename?: 'AdminAnalyticsKnowledgeBaseUpload';
  agencyUserId?: Maybe<Scalars['ID']['output']>;
  agencyUserName?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  documentTitle: Scalars['String']['output'];
  documentType: Scalars['String']['output'];
  pageCount: Scalars['Int']['output'];
};

export type AdminAnalyticsPresetRanking = {
  __typename?: 'AdminAnalyticsPresetRanking';
  /** The rank in the previous period. Null when the preset had no workspaces then. */
  previousRank?: Maybe<Scalars['Int']['output']>;
  /** Presets with the same workspaceCount share a rank. */
  rank: Scalars['Int']['output'];
  usage: AdminAnalyticsPresetUsage;
};

/**
 * Workspaces started from each preset in the date range, keyed and labeled as
 * AdminAnalyticsWorkspaceBreakdown keys and labels them, so the counts match it.
 */
export type AdminAnalyticsPresetRankings = {
  __typename?: 'AdminAnalyticsPresetRankings';
  /** Workspaces started without a preset, which aren't ranked. Null when there are none. */
  noPreset?: Maybe<AdminAnalyticsPresetUsage>;
  /** Most workspaces first. */
  presets: Array<AdminAnalyticsPresetRanking>;
  /**
   * The period of the same length just before the date range, which previousRank compares
   * with. Null when the range has no start, as on All time, or that period had no workspaces
   * from a preset.
   */
  previousPeriod?: Maybe<AdminAnalyticsPreviousPeriod>;
  /**
   * How many weeks the date range spans, from its first workspace's week when it has no
   * start. Each overTime holds the latest weeks the page charts.
   */
  weekCount: Scalars['Int']['output'];
};

/** The workspaces started from one preset, or without one. */
export type AdminAnalyticsPresetUsage = {
  __typename?: 'AdminAnalyticsPresetUsage';
  customPresetArchived: Scalars['Boolean']['output'];
  isCustomPreset: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** One entry per week, Monday to Sunday in UTC, including weeks with no workspaces. */
  overTime: Array<AdminAnalyticsPresetWeek>;
  /**
   * The agency's users who started a workspace from the preset, most workspaces first. Cara
   * staff test accounts are left out, as on User activity.
   */
  users: Array<AdminAnalyticsPresetUser>;
  /**
   * Workspaces with no user attached, such as those started by a Zapier integration. Null when
   * the preset has none.
   */
  withoutUser?: Maybe<AdminAnalyticsPresetWithoutUser>;
  /** Counts every workspace, including those of the test accounts that users leaves out. */
  workspaceCount: Scalars['Int']['output'];
};

export type AdminAnalyticsPresetUser = {
  __typename?: 'AdminAnalyticsPresetUser';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  lastUsedAt: Scalars['Time']['output'];
  workspaceCount: Scalars['Int']['output'];
};

export type AdminAnalyticsPresetWeek = {
  __typename?: 'AdminAnalyticsPresetWeek';
  weekStart: Scalars['Time']['output'];
  workspaceCount: Scalars['Int']['output'];
};

export type AdminAnalyticsPresetWithoutUser = {
  __typename?: 'AdminAnalyticsPresetWithoutUser';
  lastUsedAt: Scalars['Time']['output'];
  workspaceCount: Scalars['Int']['output'];
};

export type AdminAnalyticsPreviousPeriod = {
  __typename?: 'AdminAnalyticsPreviousPeriod';
  after: Scalars['Time']['output'];
  /** Exclusive, so the period's last moment is just before it. */
  before: Scalars['Time']['output'];
};

export type AdminAnalyticsReport = {
  __typename?: 'AdminAnalyticsReport';
  activeUsers: Array<AdminAnalyticsActiveUser>;
  activityMatrix: AdminAnalyticsActivityMatrix;
  activityOverTime: Array<AdminAnalyticsActivityBucket>;
  amsWrites: AdminAnalyticsAmsWrites;
  dateRange: AdminAnalyticsDateRange;
  generatedAt: Scalars['Time']['output'];
  incrementalRevenue: AdminAnalyticsIncrementalRevenue;
  kbDocumentHistory: Array<AdminAnalyticsKbSnapshot>;
  kbSearchUsage: AdminAnalyticsKbSearchUsage;
  knowledgeBaseUploads: Array<AdminAnalyticsKnowledgeBaseUpload>;
  presetRankings: AdminAnalyticsPresetRankings;
  templateBreakdown: Array<AdminAnalyticsTemplateBreakdown>;
  templateLibrary: AdminAnalyticsTemplateLibrary;
  timeSavings: AdminAnalyticsTimeSavings;
  toolBreakdown: Array<AdminAnalyticsToolBreakdown>;
  totals: AdminAnalyticsTotals;
  /**
   * Sections the active filters can't apply to. Empty without a user, access profile,
   * started-by or workspace preset filter.
   */
  unfilteredSections: Array<AdminAnalyticsUnfilteredSection>;
  userUsage: Array<AdminAnalyticsUserUsage>;
  workspaceBreakdown: Array<AdminAnalyticsWorkspaceBreakdown>;
  workspaceStats: AdminAnalyticsWorkspaceStats;
};

/**
 * A section of the report that some filters can't apply to, because its activity has no user
 * or isn't a workspace. Calls, Voice AI writes, emails and knowledge base uploads are left out
 * of the report, and quote request tickets out of incrementalRevenue. kbDocumentHistory,
 * templateLibrary and the actions in activeUsers still cover everything.
 */
export enum AdminAnalyticsSection {
  ActiveUsers = 'ACTIVE_USERS',
  Calls = 'CALLS',
  Emails = 'EMAILS',
  KnowledgeBaseHistory = 'KNOWLEDGE_BASE_HISTORY',
  KnowledgeBaseUploads = 'KNOWLEDGE_BASE_UPLOADS',
  RevenueServiceTickets = 'REVENUE_SERVICE_TICKETS',
  TemplateLibrary = 'TEMPLATE_LIBRARY',
  VoiceAiAmsWrites = 'VOICE_AI_AMS_WRITES'
}

/** A filter that narrows the report to some users' activity or to some workspaces. */
export enum AdminAnalyticsSegmentFilter {
  AgencyProfile = 'AGENCY_PROFILE',
  StartedBy = 'STARTED_BY',
  User = 'USER',
  WorkspacePreset = 'WORKSPACE_PRESET'
}

/**
 * What started a workspace. When more than one applies, the order of precedence is TRIGGER,
 * ZAPIER, EMAIL, SERVICE_TICKET, so a workspace a trigger started from an email counts as
 * TRIGGER.
 */
export enum AdminAnalyticsStartedBy {
  Email = 'EMAIL',
  /** A user, with none of the others applying. */
  Manual = 'MANUAL',
  ServiceTicket = 'SERVICE_TICKET',
  Trigger = 'TRIGGER',
  Zapier = 'ZAPIER'
}

export type AdminAnalyticsTemplateBreakdown = {
  __typename?: 'AdminAnalyticsTemplateBreakdown';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  templateType: Scalars['String']['output'];
};

/** Counts of active (non-archived) templates saved in the agency library. */
export type AdminAnalyticsTemplateLibrary = {
  __typename?: 'AdminAnalyticsTemplateLibrary';
  customFormCount: Scalars['Int']['output'];
  htmlTemplateCount: Scalars['Int']['output'];
  wordTemplateCount: Scalars['Int']['output'];
};

/** Server-computed estimated time saved for the filter window. */
export type AdminAnalyticsTimeSavings = {
  __typename?: 'AdminAnalyticsTimeSavings';
  breakdown: Array<AdminAnalyticsTimeSavingsBreakdown>;
  totalMinutes: Scalars['Int']['output'];
};

export type AdminAnalyticsTimeSavingsBreakdown = {
  __typename?: 'AdminAnalyticsTimeSavingsBreakdown';
  activityCount: Scalars['Int']['output'];
  category: AdminAnalyticsTimeSavingsCategory;
  label: Scalars['String']['output'];
  minutes: Scalars['Int']['output'];
};

/** Category used in the estimated time-saved breakdown. */
export enum AdminAnalyticsTimeSavingsCategory {
  Call = 'CALL',
  Email = 'EMAIL',
  Workspace = 'WORKSPACE'
}

/** Workspace tool invocation counts aggregated from plan stage events. */
export type AdminAnalyticsToolBreakdown = {
  __typename?: 'AdminAnalyticsToolBreakdown';
  count: Scalars['Int']['output'];
  /** Human-readable label for display in the admin dashboard. */
  label: Scalars['String']['output'];
  /**
   * CaraWorkspaceTool enum string when known, otherwise the raw typeString
   * recorded by the LLM (e.g. dynamic FILL_TEMPLATE_* names).
   */
  toolType: Scalars['String']['output'];
};

export type AdminAnalyticsTotals = {
  __typename?: 'AdminAnalyticsTotals';
  /**
   * Human-readable description of what "active" means for this report, e.g.
   * "workspace or email in the last 14 days".
   */
  activeDefinition: Scalars['String']['output'];
  activeUsers: Scalars['Int']['output'];
  inactiveUsers: Scalars['Int']['output'];
  totalActivities: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
  totalEmails: Scalars['Int']['output'];
  totalKnowledgeBasePages: Scalars['Int']['output'];
  totalKnowledgeBaseUploads: Scalars['Int']['output'];
  /**
   * Total indexed pages Cara reviewed in the filter window: workspace-attached
   * file pages plus knowledge base document pages.
   */
  totalPagesReviewed: Scalars['Int']['output'];
  totalTemplateReferences: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  /** Every workspace the filters match, including those no user started, such as Zapier's. */
  totalWorkspaces: Scalars['Int']['output'];
};

/** A section the active filters can't apply to, and which of them it can't apply. */
export type AdminAnalyticsUnfilteredSection = {
  __typename?: 'AdminAnalyticsUnfilteredSection';
  filters: Array<AdminAnalyticsSegmentFilter>;
  section: AdminAnalyticsSection;
};

export type AdminAnalyticsUserUsage = {
  __typename?: 'AdminAnalyticsUserUsage';
  agencyUserEmail: Scalars['String']['output'];
  agencyUserId: Scalars['ID']['output'];
  agencyUserName: Scalars['String']['output'];
  emailCount: Scalars['Int']['output'];
  knowledgeBaseUploadCount: Scalars['Int']['output'];
  lastActivityAt?: Maybe<Scalars['Time']['output']>;
  totalActivities: Scalars['Int']['output'];
  workspaceCount: Scalars['Int']['output'];
};

/**
 * How analytics names and counts a workspace's preset, wherever a preset appears.
 *
 * A custom preset shows its current title, so renaming one relabels its past
 * workspaces. Custom presets with exactly the same title count as one row; a
 * deleted one counts in its own row with customPresetArchived set. A built-in
 * shows its launcher title and never merges with a custom preset of the same
 * name. A workspace with no preset is "Custom workspace".
 */
export type AdminAnalyticsWorkspaceBreakdown = {
  __typename?: 'AdminAnalyticsWorkspaceBreakdown';
  count: Scalars['Int']['output'];
  /** The custom preset's display name. Null for a built-in. */
  customPreset?: Maybe<Scalars['String']['output']>;
  customPresetArchived: Scalars['Boolean']['output'];
  /**
   * Identifies the row, as label cannot: a built-in and a custom preset can share
   * a label. It is preset:<code> for a built-in, custom:<title> for custom
   * presets, custom-deleted:<title> for deleted ones, and none for no preset.
   * An untitled custom preset is custom:id:<id>, or custom-deleted-untitled once
   * deleted.
   */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  preset?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

/**
 * Aggregate complexity / output statistics across workspaces in the filter window.
 * Powers the "Workspace insights" card.
 */
export type AdminAnalyticsWorkspaceStats = {
  __typename?: 'AdminAnalyticsWorkspaceStats';
  /** Average number of generated artifacts (forms / templates / docs) per workspace. */
  avgArtifactsPerWorkspace: Scalars['Float']['output'];
  /** Average indexed file pages among workspaces with at least one attached file page. */
  avgPagesPerWorkspace: Scalars['Float']['output'];
  /** Average number of tool invocations per workspace. */
  avgToolCallsPerWorkspace: Scalars['Float']['output'];
  /** Maximum artifacts produced in any single workspace. */
  maxArtifactsPerWorkspace: Scalars['Int']['output'];
  /** Maximum file pages in a workspace that has at least one attached file page. */
  maxPagesPerWorkspace: Scalars['Int']['output'];
  /** Maximum tool invocations recorded in any single workspace. */
  maxToolCallsPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile artifacts produced per workspace. */
  medianArtifactsPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile file pages among workspaces with at least one attached file page. */
  medianPagesPerWorkspace: Scalars['Int']['output'];
  /** 50th-percentile tool invocations per workspace. */
  medianToolCallsPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile artifacts produced per workspace. */
  p90ArtifactsPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile file pages among workspaces with at least one attached file page. */
  p90PagesPerWorkspace: Scalars['Int']['output'];
  /** 90th-percentile tool invocations per workspace. */
  p90ToolCallsPerWorkspace: Scalars['Int']['output'];
  /**
   * Distribution of workspaces by tool-call count, bucketed for charting.
   * Buckets are in ascending order; sum of counts == totalWorkspaces.
   */
  toolCallDistribution: Array<AdminAnalyticsHistogramBucket>;
  totalWorkspaces: Scalars['Int']['output'];
};

/** Result from generating an admin sign-in code or URL for a given agency */
export type AdminSignInCode = {
  __typename?: 'AdminSignInCode';
  /**
   * The raw sign-in code. For external agency users this is what the user enters; for internal
   * sessions it is the code embedded in loginUrl.
   */
  code: Scalars['String']['output'];
  /** When the code expires */
  expiresAt: Scalars['Time']['output'];
  /** Whether this is an internal (Oyster employee) session */
  isInternal: Scalars['Boolean']['output'];
  /** The full sign-in URL (only set for internal Oyster employee sessions). */
  loginUrl?: Maybe<Scalars['String']['output']>;
};

/** Agency represents an insurance agency that works with Oyster. */
export type Agency = {
  __typename?: 'Agency';
  /**
   * The brand of the agency's default design. Returns the defaults, with configured false,
   * until there is one, so a caller never has to handle its absence.
   */
  brand: AgencyBrand;
  /** The child agencies of the agency, if any */
  childAgencies: Array<Agency>;
  /** Agency-wide configuration and settings */
  configuration: AgencyConfiguration;
  /** Timestamp the agency was created */
  createdAt: Scalars['Time']['output'];
  /**
   * The design new documents start with. Null when the agency has not chosen one, when the
   * caller cannot see it, and while agency_brand_design_enabled is off.
   */
  defaultDesign?: Maybe<AgencyDesign>;
  /**
   * The designs the caller can see, archived ones left out, the default first. Empty while
   * agency_brand_design_enabled is off.
   */
  designs: Array<AgencyDesign>;
  /** Display name of the agency */
  displayName: Scalars['String']['output'];
  /**
   * Short unique handle used in Cara trigger aliases
   * (cara-{emailNamespace}-{suffix}@inbox.getcara.ai). Assigned automatically at
   * create; change later in agency settings. Empty for legacy agencies that have
   * not claimed one yet.
   */
  emailNamespace: Scalars['String']['output'];
  /** The entitlements for the agency */
  entitlements: Array<SubscriptionEntitlement>;
  /**
   * Agency-wide Florida producer license number.
   * Used only as a backup when the selected default Producer Information has none.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific).
   */
  floridaLicenseNumber: Scalars['String']['output'];
  /** Unique identifier for the agency */
  id: Scalars['ID']['output'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['output'];
  /** Mailing address of the agency */
  mailingAddress: Address;
  /** Legal name of the agency */
  name: Scalars['String']['output'];
  /**
   * Agency-wide National Producer Number (NPN).
   * Used only as a backup when the selected default Producer Information has none.
   */
  nationalProducerNumber: Scalars['String']['output'];
  /** The initially selected onboarding date for the agency based on when they created their account */
  onboardingDate?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether creating an outbound voice agent requires acknowledging the current
   * compliance disclosure (no acknowledgment yet, or an older disclosure version).
   */
  outboundVoiceComplianceAcknowledgmentRequired: Scalars['Boolean']['output'];
  /** Current outbound voice compliance disclosure to present when acknowledgment is required. */
  outboundVoiceComplianceDisclosure: OutboundVoiceComplianceDisclosure;
  /** The parent agency of the agency, if any */
  parentAgency?: Maybe<Agency>;
  /** Phone number of the agency */
  phone: Scalars['String']['output'];
  /** All producer information for this agency scope. */
  producerInformations: Array<ProducerInformation>;
  /** The Stripe customer ID for the agency */
  stripeCustomerId: Scalars['String']['output'];
  /** The Stripe subscription ID for the agency, if they have one */
  stripeSubscriptionId?: Maybe<Scalars['String']['output']>;
  /** The subscription information for the agency user */
  subscription?: Maybe<AgencySubscription>;
  /** Timestamp the agency was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The users associated with this agency */
  users: Array<AgencyUser>;
  /** The voice agents associated with this agency */
  voiceAgents: Array<VoiceAgent>;
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['output'];
};

/** Association between two agencies */
export type AgencyAssociation = {
  __typename?: 'AgencyAssociation';
  /** When the association was created */
  createdAt: Scalars['Time']['output'];
  /** The relationship between the two agencies */
  relationship: AgencyAssociationRelationship;
  /** When the association was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Relationship between two agencies */
export type AgencyAssociationRelationship = {
  __typename?: 'AgencyAssociationRelationship';
  /** Attributes of the relationship */
  attributes: Array<AgencyAssociationRelationshipAttribute>;
  /** Type of the relationship */
  type: AgencyAssociationRelationshipType;
};

export enum AgencyAssociationRelationshipAttribute {
  /**
   * Indicates that the parent agency is billed for usage of the child agency, and is delegated
   * the abilities to assign and manage seats and voice agents for the child agency.
   */
  FederatedBilling = 'FEDERATED_BILLING'
}

export enum AgencyAssociationRelationshipType {
  /** The "from" agency is a parent of the "to" agency */
  Parent = 'PARENT'
}

/**
 * An agency's brand: the colors and typefaces every document it generates follows.
 * One per agency.
 */
export type AgencyBrand = {
  __typename?: 'AgencyBrand';
  /** Family name of the typeface body text is set in, from the installed catalog. */
  bodyTypeface: Scalars['String']['output'];
  /** False until the first save. Reads return defaults without creating a stored row. */
  configured: Scalars['Boolean']['output'];
  /**
   * How each kind of element is set: its size, leading, spacing and page-break behavior.
   *
   * A list rather than a field per element so a new element does not change the shape, and
   * so an element the server has not heard of is simply one the client ignores.
   */
  elements: Array<BrandElementStyle>;
  /**
   * What the running footer prints. The page number is added for you in the bottom right
   * when nothing else claims that corner, so a footer need not ask for one. Switching the
   * footer off removes it too: a document then prints no page number at all.
   */
  footer?: Maybe<BrandSlots>;
  /**
   * What the running header prints, by position. Null throughout leaves each corner to
   * whatever the document or its template puts there.
   */
  header?: Maybe<BrandSlots>;
  /** Family name of the typeface headings are set in. Often the same as the body. */
  headingTypeface: Scalars['String']['output'];
  /** The saved row ID. Null until the brand is first saved. */
  id?: Maybe<Scalars['ID']['output']>;
  /**
   * The agency's marks, one per background they are made for. A header slot or the agent picks
   * the variant that reads on the surface it lands on.
   */
  logos: Array<BrandLogo>;
  /**
   * The page margin, in inches. Null throughout means the renderer keeps the margin it
   * already used, so a brand saved before this existed prints unchanged.
   */
  margins?: Maybe<BrandMargins>;
  /** The palette, in the order a chooser shows it. */
  palette: BrandPalette;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * How the agency sounds. Handed to the model in words, so it steers phrasing rather than
   * guaranteeing it.
   */
  voice?: Maybe<BrandVoice>;
};

/** Agency-wide configuration and settings */
export type AgencyConfiguration = {
  __typename?: 'AgencyConfiguration';
  /**
   * Agency-level configuration governing ACORD COI/EOI/ID-card generation. Always
   * present; its fields hold only the agency's overrides, with null fields meaning
   * "use the Cara default" (see ACORDFormConfiguration).
   */
  acordFormConfiguration: AcordFormConfiguration;
  /** Settings for the emails Cara drafts for the agency. Null until an admin first saves them. */
  email?: Maybe<AgencyEmailConfiguration>;
  /**
   * HIPAA privacy settings for the agency. Only globally authorized internal
   * users may change these settings.
   */
  hipaaPrivacyMode: HipaaPrivacyModeConfiguration;
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfiguration;
  /** Notification settings for the agency */
  notifications: NotificationSettings;
  /**
   * Record that an agency user acknowledged the outbound voice compliance disclosure.
   * Null until the first outbound voice agent create that requires acknowledgment.
   * Not writable via updateAgency — only set when creating an outbound voice agent.
   */
  outboundVoiceComplianceAcknowledgment?: Maybe<OutboundVoiceComplianceAcknowledgment>;
  /**
   * Visibility policy for objects (workspaces, presets, templates, forms) within
   * the agency. Currently only controls whether PRIVATE visibility is allowed for
   * members; agency admins always retain read access regardless.
   */
  visibility: AgencyVisibilityPolicy;
};

/** Input for Agency-wide configuration and settings */
export type AgencyConfigurationInput = {
  /** The default COI configuration for the agency */
  liabilityCOIConfiguration: CertificateOfLiabilityAgencyConfigurationInput;
};

/**
 * AgencyDeletionLog records a permanent audit entry each time an agency is deleted.
 * This record is never cascade-deleted so it survives after the agency row is gone.
 */
export type AgencyDeletionLog = {
  __typename?: 'AgencyDeletionLog';
  /** Identifier of the agency that was deleted */
  agencyId: Scalars['ID']['output'];
  /** Display name of the agency at the time of deletion */
  agencyName: Scalars['String']['output'];
  /** Timestamp when the agency was deleted */
  deletedAt: Scalars['Time']['output'];
  /** Identifier of the user who performed the deletion */
  deletedByUserId: Scalars['ID']['output'];
  /** Display name of the user who performed the deletion */
  deletedByUserName: Scalars['String']['output'];
  /** Unique identifier for the deletion log entry */
  id: Scalars['ID']['output'];
};

/**
 * One complete look an agency can give its documents: a brand, and the pages printed before
 * and after them. An agency keeps several, and at most one is its default, which new
 * documents start with.
 */
export type AgencyDesign = {
  __typename?: 'AgencyDesign';
  /** Left out of Agency.designs. A document that uses an archived design keeps rendering with it. */
  archived: Scalars['Boolean']['output'];
  /** Always configured: a design is a brand somebody chose. */
  brand: AgencyBrand;
  /**
   * The Library Style this design was converted from, when it was. Null too when the Style is
   * archived or hidden from the caller.
   */
  convertedFromStyle?: Maybe<HtmlDocumentTemplate>;
  /** Null for the design made from the agency's brand when designs arrived. */
  createdBy?: Maybe<AgencyUser>;
  id: Scalars['ID']['output'];
  includedPages: AgencyDesignIncludedPages;
  /** Whether new documents start with this design. Only an admin chooses it. */
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  visibility: VisibilityConfig;
};

/**
 * The pages a design prints around a document. A document linked to a template prints the
 * template's pages instead, and these only when its export asks for them.
 */
export type AgencyDesignIncludedPages = {
  __typename?: 'AgencyDesignIncludedPages';
  after: Array<AgencyDesignPage>;
  before: Array<AgencyDesignPage>;
};

export type AgencyDesignIncludedPagesInput = {
  after: Array<Scalars['String']['input']>;
  before: Array<Scalars['String']['input']>;
};

/**
 * A design as the editor saves it. The brand fields mean what they do in
 * UpdateAgencyBrandInput: on an update every optional field left null keeps what is saved,
 * and an empty value clears it.
 */
export type AgencyDesignInput = {
  bodyTypeface: Scalars['String']['input'];
  elements?: InputMaybe<Array<BrandElementStyleInput>>;
  /**
   * The updatedAt the editor opened the design at. An update made since refuses the save with
   * CONFLICT, so one person's save never silently replaces another's. Null skips the check.
   */
  expectedUpdatedAt?: InputMaybe<Scalars['Time']['input']>;
  footer?: InputMaybe<BrandSlotsInput>;
  header?: InputMaybe<BrandSlotsInput>;
  headingTypeface: Scalars['String']['input'];
  /**
   * Files from uploadAgencyDesignPage, or ones the design already has. Null keeps the saved
   * pages, and a new design starts with none.
   */
  includedPages?: InputMaybe<AgencyDesignIncludedPagesInput>;
  logos?: InputMaybe<Array<BrandLogoInput>>;
  margins?: InputMaybe<BrandMarginsInput>;
  name: Scalars['String']['input'];
  palette: BrandPaletteInput;
  /** Null keeps the saved visibility, and a new design is PUBLIC. */
  visibility?: InputMaybe<VisibilityConfigInput>;
  voice?: InputMaybe<BrandVoiceInput>;
};

export type AgencyDesignPage = {
  __typename?: 'AgencyDesignPage';
  /** Null when the file has since been deleted. */
  file?: Maybe<File>;
  fileId: Scalars['String']['output'];
  /** Whether the file is a PDF. Export skips a page that is not, so the editor warns about it. */
  printable: Scalars['Boolean']['output'];
};

export type AgencyEmailConfiguration = {
  __typename?: 'AgencyEmailConfiguration';
  /**
   * Rules Cara follows in every email it drafts for the agency, with or without a template.
   * They always apply: a template's own guidelines only add to them and give way where the two
   * disagree. Both win over Cara's memories.
   */
  guidelines: Array<Scalars['String']['output']>;
};

/** Input for filtering agencies */
export type AgencyFilterInput = {
  /** The name of the agency */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new agency */
export type AgencyInput = {
  /** Agency-wide configuration and settings */
  configuration: AgencyConfigurationInput;
  /** Display name of the agency */
  displayName: Scalars['String']['input'];
  /** URL of the agency's logo */
  logoUrl: Scalars['String']['input'];
  /** Mailing address of the agency */
  mailingAddress: AddressInput;
  /** Legal name of the agency */
  name: Scalars['String']['input'];
  /** Phone number of the agency */
  phone: Scalars['String']['input'];
  /** URL of the agency's wordmark */
  wordmarkUrl: Scalars['String']['input'];
};

/**
 * A profile is the app an agency hands to a group of its users: which presets
 * greet them on the home screen, which pages appear in their sidebar, and what
 * they are allowed to do. Admins author profiles and assign them to teams and
 * individual users.
 *
 * Every agency user resolves to exactly one profile. A direct assignment wins
 * over a team assignment; a user matched by nothing falls back to the agency's
 * default profile; an agency with no default leaves its users on the permissions
 * their role already grants.
 *
 * Profiles govern users with the USER role. Agency admins are never subject to
 * one, not even the default: they author profiles and have to be able to repair a
 * bad one, so they cannot be assigned and no profile narrows what they see.
 *
 * Agency profiles are gated behind the AGENCY_PROFILE_MANAGEMENT subscription
 * entitlement (Enterprise plan). Without it, profiles cannot be created and
 * existing ones stop restricting anything.
 */
export type AgencyProfile = {
  __typename?: 'AgencyProfile';
  /** Timestamp when the profile was archived (soft delete). Null for active profiles. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * How many distinct people use this profile, counting both team-assigned and
   * individually-assigned users. Someone on two of its teams counts once.
   * Admin-only, as with `teams`.
   */
  assignedUserCount: Scalars['Int']['output'];
  /** The configuration of the profile. */
  configuration: AgencyProfileConfiguration;
  /** Timestamp when the profile was created */
  createdAt: Scalars['Time']['output'];
  /** Agency user that created this profile */
  createdBy: AgencyUser;
  /** What this profile is for. Shown to admins only. */
  description: Scalars['String']['output'];
  /** Unique identifier for the profile */
  id: Scalars['ID']['output'];
  /**
   * Whether users with no assignment of their own land on this profile. At most
   * one profile per agency is the default, and promoting one demotes the other.
   */
  isDefault: Scalars['Boolean']['output'];
  /** Name of the profile. Unique within an agency (case-insensitive). */
  name: Scalars['String']['output'];
  /**
   * Teams assigned to this profile. A team grants exactly one profile, so
   * assigning a team here removes it from the profile it was on.
   *
   * Admin-only, unlike the rest of the profile: a user reaches their own profile
   * through `AgencyUser.profile` to render their app, and who else is on it is
   * not part of that.
   */
  teams: Array<Team>;
  /** Timestamp when the profile was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Users assigned to this profile individually, not counting those who reach it
   * through one of its teams. Admin-only, as with `teams`.
   */
  users: Array<AgencyUser>;
  /** The current version number of this profile, incremented on each update. */
  version: Scalars['Int64']['output'];
};

/**
 * Where the profile governing a user came from. A user can sit under more than
 * one rule at once — assigned directly and a member of an assigned team — so the
 * source names which one won rather than which ones exist.
 */
export enum AgencyProfileAssignmentSource {
  /** The agency default, which covers every user no other rule reaches. */
  Default = 'DEFAULT',
  /** Assigned to the user by name. Outranks any team the user belongs to. */
  Direct = 'DIRECT',
  /**
   * Inherited from one of the user's teams, none of them assigning the user
   * directly.
   */
  Team = 'TEAM'
}

/**
 * One thing an agency can let a group of its users do.
 *
 * Capabilities, not raw permissions, are what an admin grants. A permission like
 * FILE:UPLOAD is not a decision anybody makes on its own — it is what "run
 * workspaces" and "upload a Word template" both happen to need — so the editor
 * offers the product surface and the server works out the permissions behind it.
 *
 * Three rules make that safe:
 *
 * - Granting a capability grants everything it needs, including the capabilities
 *   it lists as prerequisites. Nothing has to be ticked twice.
 * - A profile only ever narrows. Expanding a capability can hand out a permission
 *   the user's role does not have, and the intersection at sign-in drops it, so
 *   the catalog is deliberately generous rather than exact.
 * - Every action the API enforces on a governed resource is reachable from some
 *   capability. An action no capability grants would be denied to every profiled
 *   user with no way to turn it back on, so
 *   TestCatalogGrantsEveryEnforcedAction fails if one appears.
 */
export enum AgencyProfileCapability {
  /** Compare a document with the agency's AMS and review the differences */
  AmsReconciliationReview = 'AMS_RECONCILIATION_REVIEW',
  /** Write approved reconciliation changes to the AMS, including creating an account */
  AmsReconciliationWrite = 'AMS_RECONCILIATION_WRITE',
  /** Edit inbound call details */
  CallsInboundManage = 'CALLS_INBOUND_MANAGE',
  /** Open the inbound call log, recordings, and transcripts */
  CallsInboundView = 'CALLS_INBOUND_VIEW',
  /** Schedule, dial, and cancel outbound calls */
  CallsOutboundManage = 'CALLS_OUTBOUND_MANAGE',
  /** Open the outbound call queue */
  CallsOutboundView = 'CALLS_OUTBOUND_VIEW',
  /** See the call report */
  CallsReportView = 'CALLS_REPORT_VIEW',
  /** Delete a client */
  ClientsDelete = 'CLIENTS_DELETE',
  /** Add and edit clients and their contacts */
  ClientsManage = 'CLIENTS_MANAGE',
  /** Open the client list and client records */
  ClientsView = 'CLIENTS_VIEW',
  /** Write, edit, and delete notes on a client */
  ClientNotesWrite = 'CLIENT_NOTES_WRITE',
  /** Read email threads Cara drafts and triages */
  EmailsView = 'EMAILS_VIEW',
  /** Connect systems, edit connections, and trigger syncs */
  IntegrationsManage = 'INTEGRATIONS_MANAGE',
  /** See connected AMS and CRM systems */
  IntegrationsView = 'INTEGRATIONS_VIEW',
  /** Delete documents from a knowledge base */
  KnowledgeBaseDocumentsDelete = 'KNOWLEDGE_BASE_DOCUMENTS_DELETE',
  /** Add and update documents: uploads, pasted text, and web pages */
  KnowledgeBaseDocumentsWrite = 'KNOWLEDGE_BASE_DOCUMENTS_WRITE',
  /** Organize folders and who can see them */
  KnowledgeBaseOrganize = 'KNOWLEDGE_BASE_ORGANIZE',
  /** Search knowledge bases and open their documents */
  KnowledgeBaseUse = 'KNOWLEDGE_BASE_USE',
  /** Upload and edit Excel templates */
  LibraryExcelManage = 'LIBRARY_EXCEL_MANAGE',
  /** Use Excel templates */
  LibraryExcelUse = 'LIBRARY_EXCEL_USE',
  /** Add custom forms and edit their field mappings */
  LibraryFormsManage = 'LIBRARY_FORMS_MANAGE',
  /** Use custom forms */
  LibraryFormsUse = 'LIBRARY_FORMS_USE',
  /** Use the agency's branding styles */
  LibraryStylesUse = 'LIBRARY_STYLES_USE',
  /** Create and edit styles and letter templates */
  LibraryTemplatesManage = 'LIBRARY_TEMPLATES_MANAGE',
  /** Use letter and document templates */
  LibraryTemplatesUse = 'LIBRARY_TEMPLATES_USE',
  /** Upload and edit Word templates */
  LibraryWordManage = 'LIBRARY_WORD_MANAGE',
  /** Use Word templates */
  LibraryWordUse = 'LIBRARY_WORD_USE',
  /** Connect a mailbox and choose who else may send as it */
  MailboxConnect = 'MAILBOX_CONNECT',
  /** Send mail through a connected mailbox and manage their own signatures */
  MailboxSend = 'MAILBOX_SEND',
  /** See connected mailboxes and disconnect their own */
  MailboxView = 'MAILBOX_VIEW',
  /** Save, edit, and delete memories */
  MemoryManage = 'MEMORY_MANAGE',
  /** See saved memories */
  MemoryView = 'MEMORY_VIEW',
  /** Build and edit presets */
  PresetsAuthor = 'PRESETS_AUTHOR',
  /** Run the agency's presets */
  PresetsRun = 'PRESETS_RUN',
  /** Share presets with other agencies */
  PresetsShare = 'PRESETS_SHARE',
  /** Open the servicing queue */
  ServicingView = 'SERVICING_VIEW',
  /** Open, edit, and resolve service requests */
  ServicingWork = 'SERVICING_WORK',
  /** Create teams and change their membership */
  TeamsManage = 'TEAMS_MANAGE',
  /** See teams and who belongs to them */
  TeamsView = 'TEAMS_VIEW',
  /** Create a voice agent */
  VoiceAgentsCreate = 'VOICE_AGENTS_CREATE',
  /** Change how an existing voice agent answers */
  VoiceAgentsUpdate = 'VOICE_AGENTS_UPDATE',
  /** See the agency's voice agents */
  VoiceAgentsView = 'VOICE_AGENTS_VIEW',
  /** Start workspaces, chat in them, and attach files */
  WorkspacesRun = 'WORKSPACES_RUN',
  /** Open workspaces and the documents they produce */
  WorkspacesView = 'WORKSPACES_VIEW'
}

/**
 * Everything an admin can grant, grouped the way the settings page draws it:
 * modules, the surfaces inside each, and the capabilities on offer for each
 * surface. The three levels are the app's own shape, not the permission model's.
 */
export type AgencyProfileCapabilityCatalog = {
  __typename?: 'AgencyProfileCapabilityCatalog';
  groups: Array<AgencyProfileCapabilityGroup>;
};

/**
 * One module in the capability editor — a group of related surfaces an agency
 * would name as one thing, e.g. \"Copilot\" or \"Calls\".
 */
export type AgencyProfileCapabilityGroup = {
  __typename?: 'AgencyProfileCapabilityGroup';
  /** One line on what this module is, shown under the heading. */
  hint: Scalars['String']['output'];
  /** The surfaces inside it, in display order. */
  sections: Array<AgencyProfileCapabilitySection>;
  /** Heading, e.g. "Library". */
  title: Scalars['String']['output'];
};

/** One capability as the editor draws it, with everything granting it pulls in. */
export type AgencyProfileCapabilityOption = {
  __typename?: 'AgencyProfileCapabilityOption';
  /** The capability granted. */
  capability: AgencyProfileCapability;
  /** The permissions this capability confers, for admins who want the detail. */
  grants: Array<AgencyProfilePermission>;
  /** Why it exists, or what it does not cover. */
  hint: Scalars['String']['output'];
  /** What ticking it lets someone do, e.g. "Run the agency's presets". */
  label: Scalars['String']['output'];
  /** Sidebar entries this capability makes reachable. */
  navigation: Array<AgencyProfileNavigationOption>;
  /**
   * Capabilities granted along with this one. Ticking a capability ticks these,
   * and unticking one of these unticks whatever required it, so the stored set is
   * always closed under this relation.
   */
  requires: Array<AgencyProfileCapability>;
};

/**
 * One surface inside a module: a page, or a tab within one. Settings is one
 * section per settings page, since those pages have nothing in common beyond
 * living behind the same gear.
 */
export type AgencyProfileCapabilitySection = {
  __typename?: 'AgencyProfileCapabilitySection';
  /** The capabilities on offer, in display order. */
  capabilities: Array<AgencyProfileCapabilityOption>;
  /** One line on what this surface is, shown beside the heading. */
  hint: Scalars['String']['output'];
  /** Heading, e.g. "Word templates". */
  title: Scalars['String']['output'];
};

/** The configuration of a profile. */
export type AgencyProfileConfiguration = {
  __typename?: 'AgencyProfileConfiguration';
  /**
   * What this profile lets its users do. Closed under the `requires` relation:
   * every prerequisite of a capability here is here too.
   */
  capabilities: Array<AgencyProfileCapability>;
  /** The home screen configuration of the profile. */
  homeScreen: AgencyProfileHomeScreen;
  /** The navigation configuration of the profile. */
  navigation: Array<NavigationItem>;
  /**
   * The permissions `capabilities` works out to, deduplicated and sorted. Derived
   * on read, never stored and never accepted as input — an admin grants product
   * surface and the server decides which permissions that needs.
   */
  permissions: Array<AgencyProfilePermission>;
};

/** Home screen configuration for a profile. */
export type AgencyProfileHomeScreen = {
  __typename?: 'AgencyProfileHomeScreen';
  /**
   * Whether users may pin, unpin, and reorder presets for themselves. Off locks
   * the home screen to `pins` and stops the client from writing home pins back
   * to the user's own preferences.
   */
  allowUserCustomization: Scalars['Boolean']['output'];
  /**
   * Whether the free-form Ask Cara input appears above the presets. Off leaves
   * users with the pinned presets and nothing else to type into.
   */
  askCaraEnabled: Scalars['Boolean']['output'];
  /**
   * Presets on the home screen, in display order. When customization is allowed
   * these are the starting set for a user who has pinned nothing; when it is not,
   * they are the whole home screen.
   */
  pins: Array<AgencyUserHomePin>;
};

/** Input for a profile's home screen configuration. */
export type AgencyProfileHomeScreenInput = {
  /** Whether users may rearrange their own home screen. */
  allowUserCustomization: Scalars['Boolean']['input'];
  /** Whether the free-form Ask Cara input appears. */
  askCaraEnabled: Scalars['Boolean']['input'];
  /** Presets on the home screen, in display order. */
  pins: Array<AgencyUserHomePinInput>;
};

/**
 * Input for updating a profile. Every field replaces its stored counterpart
 * wholesale, because each is edited as a whole on the settings page and a partial
 * list has no meaning.
 */
export type AgencyProfileInput = {
  /**
   * What these users can do. Prerequisites are filled in server-side, so a client
   * may send only the capabilities an admin ticked; a capability naming one this
   * list omits is added rather than rejected.
   */
  capabilities: Array<AgencyProfileCapability>;
  /** What this profile is for. */
  description: Scalars['String']['input'];
  /** Home screen configuration. */
  homeScreen: AgencyProfileHomeScreenInput;
  /**
   * Whether this profile catches users with no assignment of their own. Setting
   * it demotes whichever profile was the default. Clearing it on the current
   * default leaves the agency with none, and its unassigned users keep whatever
   * their role grants.
   */
  isDefault: Scalars['Boolean']['input'];
  /** Name of the profile. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
  /** Sidebar entries these users can see. */
  navigation: Array<NavigationItem>;
  /**
   * Teams assigned to this profile, replacing the current list. Each team named
   * here is removed from the profile it was on.
   */
  teamIds: Array<Scalars['String']['input']>;
  /**
   * Users assigned individually, replacing the current list. Each user named here
   * is removed from the profile they were on. Users who reach this profile
   * through one of `teamIds` do not need an entry.
   */
  userIds: Array<Scalars['String']['input']>;
};

/** A sidebar entry a profile can show or hide, as offered in the capability editor. */
export type AgencyProfileNavigationOption = {
  __typename?: 'AgencyProfileNavigationOption';
  /** Tabs within this page. Hiding the page hides them with it. */
  children: Array<AgencyProfileNavigationOption>;
  /** The sidebar entry. */
  item: NavigationItem;
  /**
   * How the entry reads in the sidebar, e.g. "Library › Word Templates". Tabs
   * carry their own name alone, since the page above them supplies the path.
   */
  label: Scalars['String']['output'];
};

/** The actions a profile grants on one resource. */
export type AgencyProfilePermission = {
  __typename?: 'AgencyProfilePermission';
  /** The actions granted. Empty is equivalent to omitting the resource entirely. */
  actions: Array<Action>;
  /** The resource these actions apply to. */
  resource: Resource;
};

/** Describes the type of update that occurred to an agency profile */
export enum AgencyProfileUpdateType {
  /** The profile was archived */
  ArchiveAgencyProfile = 'ARCHIVE_AGENCY_PROFILE',
  /** The profile was created */
  CreateAgencyProfile = 'CREATE_AGENCY_PROFILE',
  /** The profile was updated */
  UpdateAgencyProfile = 'UPDATE_AGENCY_PROFILE'
}

/** Describes a particular version of an agency profile (internal use for DB versioning) */
export type AgencyProfileVersion = {
  __typename?: 'AgencyProfileVersion';
  /** The full agency profile object for this version */
  agencyProfile: AgencyProfile;
  /**
   * Teams assigned to this profile as of this version. Written for history only;
   * reads take assignments from the assignment tables.
   */
  assignedTeamIds: Array<Scalars['String']['output']>;
  /**
   * Users assigned directly to this profile as of this version. Written for
   * history only; reads take assignments from the assignment tables.
   */
  assignedUserIds: Array<Scalars['String']['output']>;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is private */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<Scalars['String']['output']>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<AgencyProfileUpdateType>;
  /** The version number of this agency profile version */
  version: Scalars['Int64']['output'];
};

/**
 * Per-agency override for converting raw usage into billable quantities at confirmation time.
 * Optional match dimensions (costEventType, modelId) are null on the override to match any value.
 */
export type AgencyRateOverride = {
  __typename?: 'AgencyRateOverride';
  /** Replacement conversion rule (ABSOLUTE strategy only) */
  conversionRule?: Maybe<Scalars['JSON']['output']>;
  /** Raw cost event type filter; null matches any type */
  costEventType?: Maybe<CostEventType>;
  createdAt: Scalars['Time']['output'];
  /** Human-readable description for admin/support */
  description?: Maybe<Scalars['String']['output']>;
  /** When this override becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** When this override expires; null means no expiry */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Customer-facing meter this override applies to */
  meterCode: ConsumptionMeterCode;
  /** Model filter; null matches any model */
  modelId?: Maybe<Scalars['String']['output']>;
  /** Multiplier applied to default converted quantity (MULTIPLIER strategy only) */
  multiplier?: Maybe<Scalars['Decimal']['output']>;
  /** Raw unit being converted (mirrors consumption_event.raw_unit) */
  rawUnit: CostEventUnit;
  /** How this override adjusts conversion */
  strategy: AgencyRateOverrideStrategy;
  updatedAt: Scalars['Time']['output'];
};

/** How an agency rate override adjusts billable quantity conversion. */
export enum AgencyRateOverrideStrategy {
  /** Replace the default conversion rule with conversionRule. */
  Absolute = 'ABSOLUTE',
  /** Apply multiplier to the default converted quantity. */
  Multiplier = 'MULTIPLIER'
}

/** Response from the agency sign in mutation */
export type AgencySignInResponse = {
  __typename?: 'AgencySignInResponse';
  /** The agency user that was signed in */
  agencyUser: AgencyUser;
};

/** Subscription information for the agency */
export type AgencySubscription = {
  __typename?: 'AgencySubscription';
  /** The agency that owns this subscription. */
  agencyId: Scalars['ID']['output'];
  /**
   * When an admin last confirmed the agency's annual renewal. Written only by
   * confirmAnnualRenewal and preserved across Stripe sync. Never cleared: a
   * confirmation counts only toward the renewal whose 30 day notice period it
   * falls in (see annualRenewalReviewOpen).
   */
  annualRenewalConfirmedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Next anniversary of the subscription term, as a UTC calendar date (date
   * components only; not an instant). Counted in whole years from trialEndDate
   * when it is later than startDate, else from startDate, and stays on the
   * renewal day until that UTC day ends. A February 29 anniversary falls on
   * February 28 in other years. Null unless state is ACTIVE and one of those
   * dates is set. Unrelated to nextBillingDate, which follows invoice cadence.
   */
  annualRenewalDate?: Maybe<Scalars['Time']['output']>;
  /**
   * True when an admin should be asked to review the upcoming renewal: the plan is
   * BASIC or PRO, today is within the 30 days before annualRenewalDate or on it,
   * and neither annualRenewalConfirmedAt nor standardSunsetRenewalConfirmedAt
   * falls in those 30 days.
   */
  annualRenewalReviewOpen: Scalars['Boolean']['output'];
  /**
   * Live estimate of overage charges for the current (not yet invoiced) usage period.
   * Same aggregation as period-close billing; labeled an estimate until the period closes.
   * Agency users with subscription update permission only. Null when the subscription
   * is unmetered or the period is unavailable.
   */
  currentOverageBillEstimate?: Maybe<OverageBillEstimate>;
  /** Current-period agency-wide platform-unit overage vs the org overage budget. */
  currentOverageSpendStatus?: Maybe<OverageSpendStatus>;
  /**
   * Included usage allowances for the current usage period per meter.
   * Null when the subscription or period is unavailable, or platform overrides
   * are incomplete.
   */
  currentUsageAllowances?: Maybe<AgencyUsageAllowances>;
  /**
   * The active usage metering period for allotments and consumption totals.
   * Windows are computed from usageBillingAnchor (or nextBillingDate fallback)
   * and usageCycle (monthly when unset). Day progress (daysTotal/elapsed/remaining)
   * uses timezone when provided; otherwise UTC.
   */
  currentUsagePeriod?: Maybe<AgencyUsagePeriod>;
  /**
   * Billable usage consumed in the current usage period per meter.
   * Agency users with subscription update permission only. Daily buckets use timezone when provided; otherwise UTC.
   * Null when the subscription or period is unavailable.
   */
  currentUsageReport?: Maybe<AgencyUsageReport>;
  /**
   * The entitlements for the subscription
   * @deprecated Use the entitlements field on the agency instead. This field will be removed in a future version.
   */
  entitlements: Array<SubscriptionEntitlement>;
  /**
   * Max knowledge-base page overage spend (USD) for the billing period above the
   * included allotment. Null / 0 / >0 semantics match platformUnitOverageLimitDollars.
   */
  kbPageOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** The amount due for the next billing period */
  nextBillingAmount?: Maybe<Scalars['Float']['output']>;
  /** The date the next billing period for the subscription will start */
  nextBillingDate?: Maybe<Scalars['Time']['output']>;
  /** The number of seats purchased for the agency */
  numSeats: Scalars['Int']['output'];
  /** The number of seats currently in use for the agency */
  numSeatsActive: Scalars['Int']['output'];
  /** The minimum number of seats allowed for the subscription */
  numSeatsMinimum: Scalars['Int']['output'];
  /** The number of voice agents currently in use for the agency */
  numVoiceAgents: Scalars['Int']['output'];
  /** The number of voice agents currently in use for the agency */
  numVoiceAgentsActive: Scalars['Int']['output'];
  /** The period of the subscription */
  period?: Maybe<SubscriptionPeriod>;
  /** The plan that the agency is subscribed to */
  plan?: Maybe<SubscriptionPlan>;
  /**
   * How included usage allotments are determined.
   * PER_SEAT / PLATFORM = metered usage billing.
   * UNMETERED = unlimited capacity (no allotments, limits, or customer-facing usage UI);
   * set manually for agencies that should not see trial limits.
   * Null = legacy Pro (fixed trial allotments for Triggers / Outbound Voice until
   * moved to PER_SEAT or PLATFORM). New subscriptions always write an explicit
   * value; Stripe sync preserves null so no backfill is required.
   */
  planBillingType?: Maybe<PlanBillingType>;
  /**
   * Max platform-unit overage spend (USD) the agency may incur in a billing
   * period above the shared included allotment.
   * Null or 0 = no overage allowed (hard stop at included).
   * >0 = dollar cap. Unlimited usage requires an unmetered subscription
   * (planBillingType unset / not PER_SEAT or PLATFORM). Stored on the agency
   * subscription JSONB; Stripe sync must not wipe this field. UI may display this
   * as units at the platform overage rate.
   */
  platformUnitOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** When the agency dismissed the post-confirmation sunset renewal banner. */
  standardSunsetRenewalBannerDismissedAt?: Maybe<Scalars['Time']['output']>;
  /** When the agency confirmed their legacy Standard sunset renewal selection. */
  standardSunsetRenewalConfirmedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The date the subscription started, straight from Stripe. Unlike trialEndDate
   * this is set for every subscription, so it is the reliable basis for deriving
   * renewal dates.
   */
  startDate?: Maybe<Scalars['Time']['output']>;
  /** The state of the subscription for the agency */
  state: SubscriptionState;
  /** The date the trial period for the subscription will end */
  trialEndDate?: Maybe<Scalars['Time']['output']>;
  /**
   * Negotiated included amounts per meter for platform contracts. Stored on the
   * agency subscription; used when planBillingType is PLATFORM.
   */
  usageAllotmentOverrides?: Maybe<UsageAllotmentOverrides>;
  /**
   * Stripe billing_cycle_anchor (or start_date) used as the calendar basis for
   * usage metering windows with usageCycle. Persisted on Stripe sync so
   * currentUsagePeriod does not Retrieve from Stripe on every Usage page load.
   * Null until the first sync after this field existed; then nextBillingDate is
   * used as a best-effort fallback.
   */
  usageBillingAnchor?: Maybe<Scalars['Time']['output']>;
  /**
   * Usage metering cadence for allotments. When unset (null), metering defaults
   * to monthly regardless of subscription payment period.
   */
  usageCycle?: Maybe<UsageCycle>;
  /**
   * Billable usage for a selectable historical window. Requires subscription update permission.
   * Returns agency-wide KB/voice totals and per-user platform units.
   * CUSTOM requires inclusive startDay and endDay calendar dates; timezone
   * determines their midnight boundaries.
   */
  usageHistory?: Maybe<AgencyUsageHistory>;
  /**
   * Paginated overage settlement history for closed periods. Returns PENDING, PAID,
   * and FAILED by default; excludes PROCESSING (Stripe delivery in progress) and
   * SKIPPED unless includeSkipped is true.
   * Agency users with subscription update permission only.
   */
  usageOverageInvoices: UsageOverageInvoiceConnection;
  /**
   * Max voice-minute overage spend (USD) for the billing period above the included
   * allotment. Null / 0 / >0 semantics match platformUnitOverageLimitDollars.
   */
  voiceMinuteOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentOverageBillEstimateArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentUsagePeriodArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionCurrentUsageReportArgs = {
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Subscription information for the agency */
export type AgencySubscriptionUsageHistoryArgs = {
  endDay?: InputMaybe<Scalars['Time']['input']>;
  startDay?: InputMaybe<Scalars['Time']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  window: AgencyUsageWindow;
};


/** Subscription information for the agency */
export type AgencySubscriptionUsageOverageInvoicesArgs = {
  cursor?: InputMaybe<Scalars['String']['input']>;
  includeSkipped?: InputMaybe<Scalars['Boolean']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<UsageOverageInvoiceStatus>;
};

/** Included usage allowances for the active billing period across all meters. */
export type AgencyUsageAllowances = {
  __typename?: 'AgencyUsageAllowances';
  kbPages: UsageMeterAllowance;
  platformUnits: UsageMeterAllowance;
  voiceMinutes: UsageMeterAllowance;
};

/** Historical usage scoped to the requesting agency user. End is exclusive. */
export type AgencyUsageHistory = {
  __typename?: 'AgencyUsageHistory';
  /** Agency-wide totals. Available only to agency admins. */
  agencyTotals?: Maybe<AgencyUsageHistoryTotals>;
  end: Scalars['Time']['output'];
  /**
   * Platform units by user, highest first. Admins receive all attributed users;
   * non-admins receive only their own row.
   */
  platformUnitsByUser: Array<AgencyUsageUserAmount>;
  start: Scalars['Time']['output'];
  timezone: Scalars['String']['output'];
};

/** Agency-wide billable totals for a historical usage window. */
export type AgencyUsageHistoryTotals = {
  __typename?: 'AgencyUsageHistoryTotals';
  kbPages: Scalars['Int']['output'];
  voiceMinutes: Scalars['Int']['output'];
};

/**
 * The agency's active usage metering period. Period end is exclusive: usage
 * queries use occurred_at >= start AND occurred_at < end.
 */
export type AgencyUsagePeriod = {
  __typename?: 'AgencyUsagePeriod';
  /**
   * Calendar days elapsed in the period in the requested timezone (UTC when unset),
   * counting the start day as day 1. Aligns with daily chart recorded/projected cutover.
   */
  daysElapsed: Scalars['Int']['output'];
  /**
   * Calendar days remaining before the period ends, in the requested timezone
   * (UTC when unset).
   */
  daysRemaining: Scalars['Int']['output'];
  /**
   * Total calendar days in the usage period, counted in the requested timezone
   * (UTC when unset). Matches the length of daily buckets on currentUsageReport.
   */
  daysTotal: Scalars['Int']['output'];
  /** When the current usage period ends (exclusive) */
  end: Scalars['Time']['output'];
  /** When the current usage period started */
  start: Scalars['Time']['output'];
  /** Usage metering cadence for this period */
  usageCycle: UsageCycle;
};

/** Billable usage consumed in the current billing period per meter. */
export type AgencyUsageReport = {
  __typename?: 'AgencyUsageReport';
  kbPages: UsageMeterAmount;
  platformUnits: UsageMeterAmount;
  /**
   * Platform units used per agency user in this billing period, highest first.
   * Users with zero usage are omitted.
   */
  platformUnitsByUser: Array<AgencyUsageUserAmount>;
  /**
   * IANA timezone used for daily bucket boundaries. Echoes the resolved timezone
   * from the currentUsageReport(timezone:) argument (UTC when unset/invalid).
   */
  timezone: Scalars['String']['output'];
  voiceMinutes: UsageMeterAmount;
};

/** Platform-unit consumption attributed to one agency user in the current period. */
export type AgencyUsageUserAmount = {
  __typename?: 'AgencyUsageUserAmount';
  agencyUserId: Scalars['ID']['output'];
  used: Scalars['Decimal']['output'];
};

/** Preset calendar or usage-period window for usage history. */
export enum AgencyUsageWindow {
  CurrentUsagePeriod = 'CURRENT_USAGE_PERIOD',
  Custom = 'CUSTOM',
  Last_7Days = 'LAST_7_DAYS',
  LastDay = 'LAST_DAY',
  PreviousUsagePeriod = 'PREVIOUS_USAGE_PERIOD'
}

export type AgencyUser = {
  __typename?: 'AgencyUser';
  /**
   * Whether the legacy Accounts and Policies sidebar tabs are hidden for this
   * user's agency. Resolves off the same gate as frontendFlags, so the two can
   * never disagree.
   * @deprecated Use frontendFlags and test for hide_accounts_policies_tabs. Retained so AIS bundles already running in browsers keep resolving; safe to remove once those have cycled.
   */
  accountsPoliciesTabsHidden: Scalars['Boolean']['output'];
  /** Agency the user is associated with */
  agency: Agency;
  /** Attributes of the agency user */
  attributes: AgencyUserAttributes;
  /** Timestamp the agency user was created */
  createdAt: Scalars['Time']['output'];
  /**
   * Current-period platform-unit overage for this user vs their dollar budget.
   * Null when the agency subscription/period is unavailable.
   */
  currentOverageSpendStatus?: Maybe<OverageSpendStatus>;
  /** Email of the user */
  email: Scalars['String']['output'];
  /**
   * Names of the Statsig gates enabled for this caller, from the registry in
   * pkg/core/statsig/frontend_flags.go. An absent name is off. Flags go here rather
   * than in a Boolean field per flag -- see the Feature Flags section of CLAUDE.md.
   */
  frontendFlags: Array<Scalars['String']['output']>;
  /**
   * Whether the signed-in user has an owned or shared mailbox accessible for
   * composing, including connections that need reconnecting. Independent of the
   * mailbox feature flag. False for other users or an unconfigured mailbox runtime.
   */
  hasAccessibleMailbox: Scalars['Boolean']['output'];
  /**
   * Whether this user may create a workspace at HIGH (Exhaustive) effort: the
   * effort_level_selector_enabled and effort_level_high_enabled gates are on, and
   * the agency is charged for usage past its included allotment, which takes a
   * PER_SEAT or PLATFORM planBillingType with usage_overage_billing_enabled and
   * usage_overage_billing_charge_enabled on for the agency. createCaraWorkspace
   * refuses HIGH whenever this is false, so a client that shows HIGH as unavailable
   * while it is false never offers a level the server would turn down.
   */
  highEffortEnabled: Scalars['Boolean']['output'];
  /** ID of the user */
  id: Scalars['ID']['output'];
  /** Timestamp the agency user was last viewed new features */
  lastViewedNewFeatures?: Maybe<Scalars['Time']['output']>;
  /**
   * The built-in presets this user may create a workspace for at LOW effort: every
   * preset, with every output format and template, while the
   * effort_level_selector_enabled gate is on, and none while it is off.
   * @deprecated LOW is open exactly when frontendFlags reports effort_level_selector_enabled.
   */
  lowEffortOffers: Array<CaraWorkspaceLowEffortOffer>;
  /** Name of the user */
  name: Scalars['String']['output'];
  /**
   * Whether outbound calling UI (Calls → Outbound) is enabled for this user/org.
   * Backed by the cara_outbound_calls_enabled Statsig gate.
   */
  outboundCallsEnabled: Scalars['Boolean']['output'];
  /** Permissions the agency user has */
  permissions: Array<Permission>;
  /**
   * Max spend (USD) this user may incur on platform-unit overage in a billing
   * period, priced at the published overage rate.
   * Null or 0 = this user may not incur overage.
   * >0 = dollar cap. Counts only this user's units after the shared included
   * allotment is exhausted (phased). Minutes and KB pages have no per-user limit.
   */
  platformUnitOverageLimitDollars?: Maybe<Scalars['Float']['output']>;
  /** Preferences for the agency user */
  preferences: AgencyUserPreferences;
  /** All producer information for this agency user scope. */
  producerInformations: Array<ProducerInformation>;
  /**
   * The profile that applies to this user, or null when their agency has no
   * profile that reaches them. Read it for the home screen and sidebar; the
   * permissions it implies are already folded into `permissions`.
   *
   * Anyone may read their own. Reading another user's needs profile-management
   * access, and returns null rather than an error for callers without it, so a
   * colleague's configuration is not enumerable.
   */
  profile?: Maybe<AgencyProfile>;
  /** Roles of the agency user */
  roles: Array<Role>;
  /**
   * Whether customer-facing usage-based billing is enabled for this user/org
   * (Usage/Limits settings, overage enforcement, spend emails). True only when
   * the Statsig usage_dashboard gate is on and the agency subscription has an
   * explicit PER_SEAT or PLATFORM planBillingType (null/UNMETERED stay hidden).
   */
  settingsUsageTabEnabled: Scalars['Boolean']['output'];
  /** State of the agency user */
  state: AgencyUserState;
  /**
   * Returns all teams this agency user is a member of. For the current agency
   * user the resolver short-circuits on the principal's already-loaded team
   * membership; for other agency users it queries the database. Available to
   * any agency user with read access to teams (the @authorize check runs
   * against the *caller's* permissions, not the targeted user's).
   */
  teams: Array<Team>;
  /** Timestamp the agency user was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * A user's access: their roles, and the profile assigned to them directly (null
 * when none is).
 */
export type AgencyUserAccessInput = {
  profileId?: InputMaybe<Scalars['ID']['input']>;
  roles: Array<Role>;
};

/** Additional attributes for the agency user */
export type AgencyUserAttributes = {
  __typename?: 'AgencyUserAttributes';
  /** Go-to-market attributes for the agency user */
  gtm: AgencyUserGtmAttributes;
};

/** Input for updating the attributes of an agency user */
export type AgencyUserAttributesInput = {
  /** The go-to-market attributes of the agency user */
  gtm?: InputMaybe<AgencyUserGtmAttributesInput>;
};

/** Desktop notification preferences for workspace completion */
export type AgencyUserDesktopNotificationPreferences = {
  __typename?: 'AgencyUserDesktopNotificationPreferences';
  /** Whether desktop notifications for workspace completion are enabled */
  enabled: Scalars['Boolean']['output'];
  /**
   * The minimum number of minutes a workspace must be working before a completion
   * notification is sent. One of: 1, 2, 5, 10.
   */
  workspaceCompletionIntervalMinutes: Scalars['Int']['output'];
};

/** Input for desktop notification preferences for workspace completion */
export type AgencyUserDesktopNotificationPreferencesInput = {
  /** Whether desktop notifications for workspace completion are enabled */
  enabled: Scalars['Boolean']['input'];
  /**
   * The minimum number of minutes a workspace must be working before a completion
   * notification is sent. One of: 1, 2, 5, 10.
   */
  workspaceCompletionIntervalMinutes: Scalars['Int']['input'];
};

export type AgencyUserGtmAttributes = {
  __typename?: 'AgencyUserGTMAttributes';
  /** Whether the agency user is a billing contact for the agency */
  billingContact: Scalars['Boolean']['output'];
  /** Whether the agency user is a primary contact for the agency */
  primaryContact: Scalars['Boolean']['output'];
};

/** Input for updating the go-to-market attributes of an agency user */
export type AgencyUserGtmAttributesInput = {
  /** Whether the agency user is a billing contact for the agency */
  billingContact?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the agency user is the primary contact for the agency */
  primaryContact?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * One pin in the home-page tray: either a built-in use case or a custom
 * preset. The preset is stored as an id and joined on the client against
 * the presets the user may run; an archived or unshared pin fails to join
 * and is dropped on the next save.
 */
export type AgencyUserHomePin = {
  __typename?: 'AgencyUserHomePin';
  /**
   * The custom preset this pin runs. Null on a use-case pin. Resolved on the
   * client against the presets the user may run; not re-gated on read.
   */
  customPresetId?: Maybe<Scalars['ID']['output']>;
  /** The built-in use case this pin runs. Null on a custom-preset pin. */
  useCase?: Maybe<CaraWorkspaceUseCase>;
};

/**
 * One entry in a home-page pin arrangement. Exactly one of `useCase` and
 * `customPresetId` must be set. A pin with both or with neither is rejected, and the
 * whole update fails: it would render as nothing, and silently shortening someone's
 * arrangement hides the bug that sent it.
 */
export type AgencyUserHomePinInput = {
  /** The custom preset to pin. Omit on a use-case pin. */
  customPresetId?: InputMaybe<Scalars['ID']['input']>;
  /** The built-in use case to pin. Omit on a custom-preset pin. */
  useCase?: InputMaybe<CaraWorkspaceUseCase>;
};

/**
 * One agency user (a member of the caller's agency staff, not a client) to create
 * in a batch
 */
export type AgencyUserImportInput = {
  /** Email of the agency user, which identifies them */
  email: Scalars['String']['input'];
  /** Name of the agency user */
  name: Scalars['String']['input'];
  /** The access profile to assign; rejected for an admin */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the agency user */
  roles: Array<Role>;
  /** The teams to add the user to */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** What became of one agency user in a createAgencyUsers batch, identified by email */
export type AgencyUserImportResult = {
  __typename?: 'AgencyUserImportResult';
  /** The email the row was for, normalized */
  email: Scalars['String']['output'];
  /** Why the row was not created, when it failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The user created, when the row succeeded */
  user?: Maybe<AgencyUser>;
};

/** Input for creating a new agency user */
export type AgencyUserInput = {
  /** Email of the agency user */
  email: Scalars['String']['input'];
  /** Name of the agency user */
  name: Scalars['String']['input'];
  /**
   * The access profile to assign the new user to. Omit it to leave them on
   * whatever their teams or the agency default provide. Rejected for a user whose
   * roles include ADMIN, since no profile governs an admin.
   */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** Roles of the agency user */
  roles: Array<Role>;
};

/** Preferences for the agency user */
export type AgencyUserPreferences = {
  __typename?: 'AgencyUserPreferences';
  /**
   * Default visibility used when creating new visibility-bearing Cara objects.
   * Existing objects keep their own visibility until explicitly changed.
   */
  defaultVisibility: VisibilityConfig;
  /** Desktop notification preferences for workspace completion */
  desktopNotifications: AgencyUserDesktopNotificationPreferences;
  /**
   * Pins on the home page, in display order. Built-in use cases and custom
   * presets share one list so they can interleave. Empty means no arrangement
   * — there is no default set.
   */
  homePins: Array<AgencyUserHomePin>;
  /**
   * Whether the memory system is disabled for this agency user. When true, Cara
   * does not inject any extracted/saved memories into prompts for this user. The
   * default (false) is "memory enabled", so users who haven't opted out get
   * memory injection automatically.
   */
  memoryDisabled: Scalars['Boolean']['output'];
  /**
   * The mode for overriding the COI configuration for the agency user, if any. If not specified,
   * the agency's COI configuration is used.
   */
  overrideCOIConfigurationMode?: Maybe<CoiConfigurationMode>;
};

/** Input for preferences for the agency user */
export type AgencyUserPreferencesInput = {
  /**
   * Default visibility used when creating new visibility-bearing Cara objects.
   * If omitted, the existing preference is preserved.
   */
  defaultVisibility?: InputMaybe<VisibilityConfigInput>;
  /** Desktop notification preferences for workspace completion */
  desktopNotifications?: InputMaybe<AgencyUserDesktopNotificationPreferencesInput>;
  /**
   * What is pinned to the home page, in display order. Replaces the stored list
   * wholesale, because the client owns the ordering and a partial update has no
   * meaning. Null means do not change. An empty list clears the arrangement.
   */
  homePins?: InputMaybe<Array<AgencyUserHomePinInput>>;
  /**
   * Disable the memory system for this agency user. True opts the user out of
   * memory injection; false re-enables it. Null means do not change.
   */
  memoryDisabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The mode for overriding the COI configuration for the agency user. If not specified,
   * the existing value is preserved.
   */
  overrideCOIConfigurationMode?: InputMaybe<CoiConfigurationMode>;
};

/**
 * The profile governing one user and the rule that put them there. Read this to
 * edit a user's assignment: `source` says whether changing it means editing the
 * user or editing a team.
 */
export type AgencyUserProfileAssignment = {
  __typename?: 'AgencyUserProfileAssignment';
  /** The profile in force for the user. */
  profile: AgencyProfile;
  /** Which rule put the user on it. */
  source: AgencyProfileAssignmentSource;
  /**
   * The team the profile came from. Set only when source is TEAM, and names the
   * team whose assignment won when the user belongs to several.
   */
  team?: Maybe<Team>;
};

export enum AgencyUserState {
  /** The user is active and can access the agency */
  Active = 'ACTIVE',
  /** The user is disabled and cannot access the agency */
  Disabled = 'DISABLED'
}

/**
 * Agency-wide policy that constrains the visibility levels available to members.
 * Updated through the existing updateAgency mutation by an agency admin.
 */
export type AgencyVisibilityPolicy = {
  __typename?: 'AgencyVisibilityPolicy';
  /**
   * When true, members may not set objects to PRIVATE — the minimum allowed
   * visibility for new or updated objects becomes SHARED. Existing PRIVATE rows
   * are not retroactively coerced; the policy applies on the next mutation only.
   */
  disallowPrivate: Scalars['Boolean']['output'];
};

/**
 * Input type for updating an agency's visibility policy. Mirrors
 * AgencyVisibilityPolicy. Used as a nested field in updateAgency input flows.
 */
export type AgencyVisibilityPolicyInput = {
  disallowPrivate: Scalars['Boolean']['input'];
};

/** AgencyZoomConfiguration contains configuration for the Agency Zoom integration */
export type AgencyZoomConfiguration = {
  __typename?: 'AgencyZoomConfiguration';
  /** If enabled, will sync accounts from Cara to Agency Zoom. */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to Agency Zoom. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** If enabled, allows users to log in to Agency Zoom via SSO. */
  isSSOLogin: Scalars['Boolean']['output'];
  /** Agency Zoom username for basic authentication */
  username: Scalars['String']['output'];
};

export type AgencyZoomContactEntry = {
  __typename?: 'AgencyZoomContactEntry';
  birthday?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomCustomerFields = {
  __typename?: 'AgencyZoomCustomerFields';
  annualRevenue?: Maybe<Scalars['StringInt']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  contactMiddleName?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isBusinessCustomer?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['StringInt']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
  totalPayroll?: Maybe<Scalars['StringInt']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomDriverFields = {
  __typename?: 'AgencyZoomDriverFields';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  relationship?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomLeadFields = {
  __typename?: 'AgencyZoomLeadFields';
  agencyNumber?: Maybe<Scalars['String']['output']>;
  annualRevenue?: Maybe<Scalars['StringInt']['output']>;
  assignTo?: Maybe<Scalars['StringInt']['output']>;
  birthday?: Maybe<Scalars['String']['output']>;
  businessClassification?: Maybe<Scalars['String']['output']>;
  businessEntity?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactDate?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  csrId?: Maybe<Scalars['StringInt']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  leadSourceId?: Maybe<Scalars['StringInt']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  nextExpirationDate?: Maybe<Scalars['String']['output']>;
  nickname?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  numberOfEmployees?: Maybe<Scalars['StringInt']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  pipelineId?: Maybe<Scalars['StringInt']['output']>;
  quoteDate?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  stageId?: Maybe<Scalars['StringInt']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  streetAddress?: Maybe<Scalars['String']['output']>;
  streetAddress2?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
  totalPayroll?: Maybe<Scalars['StringInt']['output']>;
  xDate?: Maybe<Scalars['String']['output']>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomOpportunityFields = {
  __typename?: 'AgencyZoomOpportunityFields';
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadId?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  product?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomPolicyFields = {
  __typename?: 'AgencyZoomPolicyFields';
  agencyNumber?: Maybe<Scalars['String']['output']>;
  agentId?: Maybe<Scalars['StringInt']['output']>;
  bindDate?: Maybe<Scalars['String']['output']>;
  brokerFee?: Maybe<Scalars['StringInt']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  csrId?: Maybe<Scalars['StringInt']['output']>;
  customerId?: Maybe<Scalars['StringInt']['output']>;
  departmentCode?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['String']['output']>;
  groupCode?: Maybe<Scalars['String']['output']>;
  insuredName?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadSourceId?: Maybe<Scalars['StringInt']['output']>;
  lineOfBusiness?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['StringInt']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  priorCarrierName?: Maybe<Scalars['String']['output']>;
  priorExpiryDate?: Maybe<Scalars['String']['output']>;
  priorPolicyNumber?: Maybe<Scalars['String']['output']>;
  renewalDate?: Maybe<Scalars['String']['output']>;
  soldDate?: Maybe<Scalars['String']['output']>;
  standardCarrierCode?: Maybe<Scalars['String']['output']>;
  standardProductLineCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusReason?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomQuoteFields = {
  __typename?: 'AgencyZoomQuoteFields';
  carrierCode?: Maybe<Scalars['String']['output']>;
  carrierId?: Maybe<Scalars['StringInt']['output']>;
  items?: Maybe<Scalars['StringInt']['output']>;
  leadId?: Maybe<Scalars['StringInt']['output']>;
  premium?: Maybe<Scalars['StringInt']['output']>;
  productLineCode?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['StringInt']['output']>;
};

export type AgencyZoomTaskFields = {
  __typename?: 'AgencyZoomTaskFields';
  assigneeId?: Maybe<Scalars['StringInt']['output']>;
  comments?: Maybe<Scalars['String']['output']>;
  contactEmail?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['StringInt']['output']>;
  dueDatetime?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['StringInt']['output']>;
  invitees?: Maybe<Array<Scalars['String']['output']>>;
  leadId?: Maybe<Scalars['StringInt']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
  timeSpecific?: Maybe<Scalars['Boolean']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type AgencyZoomVehicleFields = {
  __typename?: 'AgencyZoomVehicleFields';
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  opportunityId?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['StringInt']['output']>;
};

/** Represents a tool for managing all AgencyZoom entities (customers, leads, policies, tasks, etc.). */
export type AgencyZoomWriteTool = {
  __typename?: 'AgencyZoomWriteTool';
  input: AgencyZoomWriteToolInput;
  output: AgencyZoomWriteToolOutput;
};

export type AgencyZoomWriteToolInput = {
  __typename?: 'AgencyZoomWriteToolInput';
  contacts?: Maybe<Array<AgencyZoomContactEntry>>;
  customer?: Maybe<AgencyZoomCustomerFields>;
  driver?: Maybe<AgencyZoomDriverFields>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  lead?: Maybe<AgencyZoomLeadFields>;
  noteContent?: Maybe<Scalars['String']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<AgencyZoomOpportunityFields>;
  policy?: Maybe<AgencyZoomPolicyFields>;
  quote?: Maybe<AgencyZoomQuoteFields>;
  task?: Maybe<AgencyZoomTaskFields>;
  vehicle?: Maybe<AgencyZoomVehicleFields>;
};

export type AgencyZoomWriteToolOutput = {
  __typename?: 'AgencyZoomWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type Ams360ActivityAttachmentFields = {
  __typename?: 'Ams360ActivityAttachmentFields';
  activityId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  storageOption?: Maybe<Scalars['String']['output']>;
};

export type Ams360ActivityCommentFields = {
  __typename?: 'Ams360ActivityCommentFields';
  action?: Maybe<Scalars['String']['output']>;
  activityId?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
};

export type Ams360ActivityFields = {
  __typename?: 'Ams360ActivityFields';
  action?: Maybe<Scalars['String']['output']>;
  agencyNumber?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type Ams360CustomerContactFields = {
  __typename?: 'Ams360CustomerContactFields';
  address1?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360CustomerFields = {
  __typename?: 'Ams360CustomerFields';
  accountExecName?: Maybe<Scalars['String']['output']>;
  accountRepName?: Maybe<Scalars['String']['output']>;
  acquisition?: Maybe<Scalars['String']['output']>;
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  alternateBillingAddress1?: Maybe<Scalars['String']['output']>;
  alternateBillingAddress2?: Maybe<Scalars['String']['output']>;
  alternateBillingCity?: Maybe<Scalars['String']['output']>;
  alternateBillingCountry?: Maybe<Scalars['String']['output']>;
  alternateBillingCounty?: Maybe<Scalars['String']['output']>;
  alternateBillingName?: Maybe<Scalars['String']['output']>;
  alternateBillingState?: Maybe<Scalars['String']['output']>;
  alternateBillingZipCode?: Maybe<Scalars['String']['output']>;
  autoCheckActivePolicyTypes?: Maybe<Scalars['Boolean']['output']>;
  branchName?: Maybe<Scalars['String']['output']>;
  brokerName?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  businessOrigin?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactPreferenceNotes?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  customerAddedDate?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  customerIsActive?: Maybe<Scalars['Boolean']['output']>;
  customerType?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  departmentName?: Maybe<Scalars['String']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  electronicDelivery?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  employeeAccessSecured?: Maybe<Scalars['Boolean']['output']>;
  excludeFromPurge?: Maybe<Scalars['Boolean']['output']>;
  excludeFromTargetList?: Maybe<Scalars['Boolean']['output']>;
  faxPhone?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  formalSalutation?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  inBusinessSince?: Maybe<Scalars['String']['output']>;
  informalSalutation?: Maybe<Scalars['String']['output']>;
  isBrokerCustomer?: Maybe<Scalars['Boolean']['output']>;
  knownByAgencySince?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  marketingSolicitation?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  multiEntityCustomerType?: Maybe<Scalars['String']['output']>;
  notation?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  otherPhone?: Maybe<Scalars['String']['output']>;
  pagerPhone?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyTypeBenefits?: Maybe<Scalars['Boolean']['output']>;
  policyTypeCommercial?: Maybe<Scalars['Boolean']['output']>;
  policyTypeFinancialServices?: Maybe<Scalars['Boolean']['output']>;
  policyTypeHealth?: Maybe<Scalars['Boolean']['output']>;
  policyTypeLife?: Maybe<Scalars['Boolean']['output']>;
  policyTypeNonPAndC?: Maybe<Scalars['Boolean']['output']>;
  policyTypePersonal?: Maybe<Scalars['Boolean']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  preferredDistributionMethod?: Maybe<Scalars['String']['output']>;
  referralLocation?: Maybe<Scalars['String']['output']>;
  referralName?: Maybe<Scalars['String']['output']>;
  secondaryEmail?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  trackReceivables?: Maybe<Scalars['String']['output']>;
  useAlternateBillingAddress?: Maybe<Scalars['Boolean']['output']>;
  useAlternateBillingName?: Maybe<Scalars['Boolean']['output']>;
  webAddress?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360PolicyContactFields = {
  __typename?: 'Ams360PolicyContactFields';
  address1?: Maybe<Scalars['String']['output']>;
  address2?: Maybe<Scalars['String']['output']>;
  businessPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  faxPhone?: Maybe<Scalars['String']['output']>;
  formalSalutation?: Maybe<Scalars['String']['output']>;
  informalSalutation?: Maybe<Scalars['String']['output']>;
  isForeign?: Maybe<Scalars['String']['output']>;
  lobId?: Maybe<Scalars['String']['output']>;
  mobilePhone?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  pagerPhone?: Maybe<Scalars['String']['output']>;
  policyContactId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  preferredContactMethod?: Maybe<Scalars['String']['output']>;
  residencePhone?: Maybe<Scalars['String']['output']>;
  responsibility?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type Ams360PolicyFields = {
  __typename?: 'Ams360PolicyFields';
  billMethod?: Maybe<Scalars['String']['output']>;
  brokerCode?: Maybe<Scalars['String']['output']>;
  csrCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  descriptionBPol?: Maybe<Scalars['String']['output']>;
  excludeFromDownload?: Maybe<Scalars['String']['output']>;
  excludeFromPurge?: Maybe<Scalars['String']['output']>;
  execCode?: Maybe<Scalars['String']['output']>;
  isBusinessNewToAgency?: Maybe<Scalars['String']['output']>;
  isContinuous?: Maybe<Scalars['String']['output']>;
  isFilteredByBusinessType?: Maybe<Scalars['String']['output']>;
  isFinanced?: Maybe<Scalars['String']['output']>;
  isMultipleEntity?: Maybe<Scalars['String']['output']>;
  issuedState?: Maybe<Scalars['String']['output']>;
  notRenewable?: Maybe<Scalars['String']['output']>;
  parentCoCode?: Maybe<Scalars['String']['output']>;
  parentCompanyName?: Maybe<Scalars['String']['output']>;
  policyEffDate?: Maybe<Scalars['String']['output']>;
  policyExpDate?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNo?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
  transactionDescription?: Maybe<Scalars['String']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
  writingCoCode?: Maybe<Scalars['String']['output']>;
  writingCompanyName?: Maybe<Scalars['String']['output']>;
};

export type Ams360SuspenseFields = {
  __typename?: 'Ams360SuspenseFields';
  action?: Maybe<Scalars['String']['output']>;
  assignToEmployeeName?: Maybe<Scalars['String']['output']>;
  assignedByEmployeeName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  policyEffectiveDate?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
};

export type Ams360UploadDocumentFields = {
  __typename?: 'Ams360UploadDocumentFields';
  action?: Maybe<Scalars['String']['output']>;
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  customerId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** Represents a tool for managing all AMS360 entities (customers/contacts/activities/policies/suspenses). */
export type Ams360WriteTool = {
  __typename?: 'Ams360WriteTool';
  input: Ams360WriteToolInput;
  output: Ams360WriteToolOutput;
};

export type Ams360WriteToolInput = {
  __typename?: 'Ams360WriteToolInput';
  activity?: Maybe<Ams360ActivityFields>;
  activityAttachment?: Maybe<Ams360ActivityAttachmentFields>;
  activityComment?: Maybe<Ams360ActivityCommentFields>;
  customer?: Maybe<Ams360CustomerFields>;
  customerContact?: Maybe<Ams360CustomerContactFields>;
  operation?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<Ams360PolicyFields>;
  policyContact?: Maybe<Ams360PolicyContactFields>;
  suspense?: Maybe<Ams360SuspenseFields>;
  uploadDocument?: Maybe<Ams360UploadDocumentFields>;
};

export type Ams360WriteToolOutput = {
  __typename?: 'Ams360WriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * Account-scoped certificate browse result. `supported` is false when the account's
 * integration does not sync CERTIFICATE knowledge-graph entities; when false, the
 * connection is always empty and clients should hide certificate pinning.
 */
export type AmsAccountCertificatesResult = {
  __typename?: 'AmsAccountCertificatesResult';
  connection: KnowledgeGraphEntityConnection;
  supported: Scalars['Boolean']['output'];
};

/**
 * One candidate AMS account.
 *
 * displayName, email and phone are populated only for candidates a name search
 * returned; the AMS's other searches return an external ID alone. accountId is null
 * until the account is imported (see importAmsAccountByExternalId).
 */
export type AmsAccountMatch = {
  __typename?: 'AmsAccountMatch';
  /** The code an agent knows the account by: its lookup code, else its Epic client number. */
  accountCode?: Maybe<Scalars['String']['output']>;
  accountId?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  externalId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  /**
   * Epic's ClientLookupCode, the short code agents know the account by. Null when
   * neither the name search nor the knowledge graph supplied it.
   */
  lookupCode?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  reason: AmsAccountMatchReason;
};

/**
 * Why an account is suggested, so the suggestion can be judged rather than merely accepted.
 *
 * The subject is whatever was searched from -- a document in reconciliation, a
 * client in suggestedAmsAccounts -- so one reason means one strength of evidence
 * in both.
 *
 * The CLIENT_LINK reasons are the exception: nothing was searched for, and the
 * account is offered because a link to it already exists. They are graded by the
 * weakest step in the chain that produced that link rather than by a search.
 */
export enum AmsAccountMatchReason {
  /**
   * The client this workspace is filed under is already linked to this account, and
   * nothing in that chain was a guess: a person filed the workspace, or an AMS
   * identifier settled it.
   */
  ClientLink = 'CLIENT_LINK',
  /**
   * The same existing link, reached through a workspace that was filed under its
   * client on a name alone. The account is only as right as that name match, which
   * is worth saying before a document is written against it.
   */
  ClientLinkNameOnly = 'CLIENT_LINK_NAME_ONLY',
  /** Only the email reached this account. */
  Email = 'EMAIL',
  /** The lookup code searched for is this account's own. */
  LookupCode = 'LOOKUP_CODE',
  /** The name and the email both reached this account. */
  NameAndEmail = 'NAME_AND_EMAIL',
  /** Only the phone number reached this account. */
  Phone = 'PHONE',
  /** The policy number searched for is on one of this account's policies. */
  PolicyNumber = 'POLICY_NUMBER',
  /** Only the name reached this account, and close enough that name matching calls them the same. */
  SimilarName = 'SIMILAR_NAME'
}

/**
 * One account-scoped policy-number group in the document picker. Applied Epic
 * emits one POLICY entity per line, so `policyIds` can contain several entities
 * that share one policy number. `documentCount` counts distinct files across the
 * whole group.
 */
export type AmsAccountPolicyGroup = {
  __typename?: 'AmsAccountPolicyGroup';
  /** Number of distinct documents related to any policy entity in the group. */
  documentCount: Scalars['Int']['output'];
  /**
   * User-facing policy label. Usually the policy number; falls back to the
   * policy entity's display name when the AMS did not supply one.
   */
  label: Scalars['String']['output'];
  /** POLICY entity IDs included in this group. */
  policyIds: Array<Scalars['ID']['output']>;
  /** Canonical policy number for this group, when supplied by the AMS. */
  policyNumber?: Maybe<Scalars['String']['output']>;
};

export type AmsAccountSearchResult = {
  __typename?: 'AmsAccountSearchResult';
  entities: Array<KnowledgeGraphEntity>;
  noSupportedAms: Scalars['Boolean']['output'];
};

/** Which refresh scope amsAccountSyncStatus describes. */
export enum AmsAccountSyncScope {
  /** The account and its policies, without their detail, certificates or files. */
  Destinations = 'DESTINATIONS',
  /** The fast documents-scope refresh the picker's document list waits on. */
  Documents = 'DOCUMENTS',
  /**
   * The slower structured-scope refresh that enriches policies and
   * certificates for AMS context pins.
   */
  Structured = 'STRUCTURED'
}

/**
 * Lightweight freshness/status snapshot for one AMS account. The picker polls
 * this (instead of the heavyweight amsAccountDocuments query) while a background
 * refresh runs, and refetches documents once syncedAt advances.
 */
export type AmsAccountSyncStatus = {
  __typename?: 'AmsAccountSyncStatus';
  /** The account entity; syncedAt is the freshness signal the client polls. */
  account: KnowledgeGraphEntity;
  /**
   * Whether a refresh workflow is currently running or recently failed.
   * Temporal is the source of truth — no status is persisted.
   */
  refreshState: AmsRefreshState;
};

/** An agency in the AMS's structure, with the branches filed under it. */
export type AmsAgency = {
  __typename?: 'AmsAgency';
  branches: Array<AmsCodeOption>;
  /** The code the AMS stores. */
  code: Scalars['String']['output'];
  /** The words the AMS shows for it. */
  label: Scalars['String']['output'];
};

/**
 * What one apply wrote: written counts the changes that landed and refused lists the
 * ones that did not. An apply that certainly wrote nothing errors instead.
 */
export type AmsApplyResult = {
  __typename?: 'AmsApplyResult';
  refused: Array<AmsRefusedChange>;
  written: Scalars['Int']['output'];
};

/**
 * One field a reviewer approved for writing, with the value to write, which may have
 * been edited in review. itemKey mirrors AmsFieldVerdict.itemKey and is required to
 * address a list item.
 */
export type AmsApprovedFieldInput = {
  fieldPath: Scalars['String']['input'];
  itemKey?: InputMaybe<Scalars['String']['input']>;
  /** The keys of the items the field's item sits under, outermost first: the ITEM levels of AmsFieldVerdict.placement above its own. A write to an item the AMS lacks creates it under them. */
  parentKeys?: InputMaybe<Array<Scalars['String']['input']>>;
  value: Scalars['String']['input'];
};

export type AmsBrowseAccount = {
  __typename?: 'AmsBrowseAccount';
  address?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  lookupCode?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  ref: AmsRef;
};

export type AmsBrowseAccountsInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  /** 1 to 50; 25 by default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** A name, email, phone, lookup code or policy number. */
  query: Scalars['String']['input'];
};

export type AmsBrowseAccountsResult = {
  __typename?: 'AmsBrowseAccountsResult';
  accounts: Array<AmsBrowseAccount>;
  page: AmsBrowsePage;
};

export type AmsBrowseActivitiesInput = {
  account: AmsRefInput;
};

/** An existing activity that can receive an email attachment. */
export type AmsBrowseActivity = {
  __typename?: 'AmsBrowseActivity';
  displayName: Scalars['String']['output'];
  ref: AmsRef;
};

/** What the AMS browser can do with one of the agency's integrations. */
export type AmsBrowseCapability = {
  __typename?: 'AmsBrowseCapability';
  /** The AMS's name, such as "Applied Epic". */
  displayName: Scalars['String']['output'];
  /** Whether the browser lists an account's or a policy's files. */
  filesBrowsable: Scalars['Boolean']['output'];
  integrationId: Scalars['String']['output'];
  integrationType: IntegrationType;
  pickableKinds: Array<AmsRefKind>;
};

export type AmsBrowseCertificate = {
  __typename?: 'AmsBrowseCertificate';
  holder?: Maybe<Scalars['String']['output']>;
  issuedAt?: Maybe<Scalars['Time']['output']>;
  ref: AmsRef;
  title?: Maybe<Scalars['String']['output']>;
};

export type AmsBrowseCertificatesInput = {
  /** An ACCOUNT ref. */
  account: AmsRefInput;
  after?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  issuedFrom?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  issuedTo?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 50; 25 by default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Words of the certificate's title or holder. */
  query?: InputMaybe<Scalars['String']['input']>;
};

export type AmsBrowseCertificatesResult = {
  __typename?: 'AmsBrowseCertificatesResult';
  certificates: Array<AmsBrowseCertificate>;
  page: AmsBrowsePage;
};

export type AmsBrowseFile = {
  __typename?: 'AmsBrowseFile';
  attachedAt?: Maybe<Scalars['Time']['output']>;
  extension?: Maybe<Scalars['String']['output']>;
  folderPath?: Maybe<Scalars['String']['output']>;
  ref: AmsRef;
  selectable: Scalars['Boolean']['output'];
  title: Scalars['String']['output'];
  /** Why the file cannot be picked, worded for the user, when selectable is false. */
  unselectableReason?: Maybe<Scalars['String']['output']>;
};

/** Kinds of file the AMS browser filters by, each a set of file extensions. */
export enum AmsBrowseFileType {
  Document = 'DOCUMENT',
  Email = 'EMAIL',
  Image = 'IMAGE',
  Pdf = 'PDF',
  Spreadsheet = 'SPREADSHEET'
}

export type AmsBrowseFilesInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  attachedFrom?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  attachedTo?: InputMaybe<Scalars['String']['input']>;
  /**
   * A folder path, its names separated by "/", such as "Policy/Proposal": files
   * in that folder or any folder under it, ignoring case.
   */
  folder?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 50; 50 by default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The ACCOUNT or POLICY whose own files to list. */
  scope: AmsRefInput;
  /** Words the file's title must hold. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Any of these kinds of file; all when empty. */
  types?: InputMaybe<Array<AmsBrowseFileType>>;
};

export type AmsBrowseFilesResult = {
  __typename?: 'AmsBrowseFilesResult';
  files: Array<AmsBrowseFile>;
  page: AmsBrowsePage;
};

/** A selectable document folder or category applicable to an account. */
export type AmsBrowseFolder = {
  __typename?: 'AmsBrowseFolder';
  displayName: Scalars['String']['output'];
  ref: AmsRef;
};

export type AmsBrowseFoldersInput = {
  /** The account whose applicable folders are listed. */
  account: AmsRefInput;
};

/** One page of AMS browser results. */
export type AmsBrowsePage = {
  __typename?: 'AmsBrowsePage';
  /** Continues the list after this page; null on the last page. */
  nextCursor?: Maybe<Scalars['String']['output']>;
  /**
   * How many records the list holds across every page, under its filters; null
   * when the read could not tell, as a search or a live read that stopped
   * before the end.
   */
  total?: Maybe<Scalars['Int']['output']>;
};

export type AmsBrowsePoliciesInput = {
  /** An ACCOUNT ref. */
  account: AmsRefInput;
  after?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  expiresFrom?: InputMaybe<Scalars['String']['input']>;
  /** YYYY-MM-DD, inclusive. */
  expiresTo?: InputMaybe<Scalars['String']['input']>;
  /** 1 to 50; 25 by default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Part of a policy number, or words of the carrier's name. */
  query?: InputMaybe<Scalars['String']['input']>;
  /** Any of these statuses; all when empty. */
  statuses?: InputMaybe<Array<AmsBrowsePolicyStatus>>;
};

export type AmsBrowsePoliciesResult = {
  __typename?: 'AmsBrowsePoliciesResult';
  page: AmsBrowsePage;
  policies: Array<AmsBrowsePolicy>;
};

export type AmsBrowsePolicy = {
  __typename?: 'AmsBrowsePolicy';
  carrier?: Maybe<Scalars['String']['output']>;
  /** YYYY-MM-DD. */
  expirationDate?: Maybe<Scalars['String']['output']>;
  lineOfBusiness?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  ref: AmsRef;
  status?: Maybe<Scalars['String']['output']>;
};

/** A policy a policy-number search found, with the account that holds it. */
export type AmsBrowsePolicyMatch = {
  __typename?: 'AmsBrowsePolicyMatch';
  /** Null when the AMS no longer holds the policy's account. */
  account?: Maybe<AmsBrowseAccount>;
  policy: AmsBrowsePolicy;
};

export type AmsBrowsePolicySearchInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['String']['input'];
  /** 1 to 50; 25 by default. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** A policy number. A query with no digit finds nothing. */
  query: Scalars['String']['input'];
};

export type AmsBrowsePolicySearchResult = {
  __typename?: 'AmsBrowsePolicySearchResult';
  matches: Array<AmsBrowsePolicyMatch>;
  page: AmsBrowsePage;
};

/** The status groups the AMS browser filters policies by. */
export enum AmsBrowsePolicyStatus {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED',
  Expired = 'EXPIRED',
  NonRenewed = 'NON_RENEWED',
  Quote = 'QUOTE'
}

/**
 * An AMS's list of the values a coded field may take, in the AMS's own order. Sent once
 * per result and shared by every verdict whose optionsId names it.
 */
export type AmsCodeList = {
  __typename?: 'AmsCodeList';
  /**
   * Names the list: an AMS lookup such as Gender, a lookup fetched for one country such as
   * StateProvince:USA, or StateProvince joined across the supported countries for a state with
   * no country beside it. Not an id: Apollo would merge every agency's list for a lookup
   * into one cache entry.
   */
  lookupType: Scalars['String']['output'];
  options: Array<AmsCodeOption>;
};

/** One value a coded field may take. */
export type AmsCodeOption = {
  __typename?: 'AmsCodeOption';
  /** The code the AMS stores. */
  code: Scalars['String']['output'];
  /** The words the AMS shows for it. */
  label: Scalars['String']['output'];
};

/**
 * What one detection pass read out of a document before any account was chosen.
 * Returned by prepareAmsReconciliation, to be handed back to amsReconciliationTargets.
 */
export type AmsDetectedEntities = {
  __typename?: 'AmsDetectedEntities';
  accountEmail?: Maybe<Scalars['String']['output']>;
  accountName?: Maybe<Scalars['String']['output']>;
  accountPhone?: Maybe<Scalars['String']['output']>;
  applicant: Scalars['Boolean']['output'];
  businessAuto: Scalars['Boolean']['output'];
  commercialProperty: Scalars['Boolean']['output'];
  /** The insured's own contact person, which prefills an account created from the document. */
  contactFirstName?: Maybe<Scalars['String']['output']>;
  contactLastName?: Maybe<Scalars['String']['output']>;
  generalLiability: Scalars['Boolean']['output'];
  homeowner: Scalars['Boolean']['output'];
  personalAuto: Scalars['Boolean']['output'];
  personalUmbrella: Scalars['Boolean']['output'];
  policyNumber?: Maybe<Scalars['String']['output']>;
  workersCompensation: Scalars['Boolean']['output'];
};

/**
 * The round-trip form of AmsDetectedEntities: pass back what prepareAmsReconciliation
 * returned rather than authoring values.
 */
export type AmsDetectedEntitiesInput = {
  accountEmail?: InputMaybe<Scalars['String']['input']>;
  accountName?: InputMaybe<Scalars['String']['input']>;
  accountPhone?: InputMaybe<Scalars['String']['input']>;
  applicant: Scalars['Boolean']['input'];
  businessAuto: Scalars['Boolean']['input'];
  commercialProperty?: Scalars['Boolean']['input'];
  generalLiability: Scalars['Boolean']['input'];
  homeowner?: Scalars['Boolean']['input'];
  personalAuto?: Scalars['Boolean']['input'];
  personalUmbrella?: Scalars['Boolean']['input'];
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  workersCompensation?: Scalars['Boolean']['input'];
};

/**
 * How review re-judges an edited value against what the AMS holds. The pass already
 * compared the field this way; review must not guess it from the text, or a ZIP
 * reads as the same number as one without its leading zero.
 */
export enum AmsFieldComparison {
  /** A dollar amount, compared as a number. */
  Currency = 'CURRENCY',
  /** A calendar date. */
  Date = 'DATE',
  /** A phone number, compared on its digits. */
  Phone = 'PHONE',
  /** Plain text. Case and runs of whitespace are ignored, and nothing else. */
  Text = 'TEXT'
}

/**
 * One field's reconciliation outcome. For a field of a list item (a coverage line,
 * vehicle, premise, subject of insurance and so on), itemKey identifies the item, since
 * fieldPath alone is not unique across items. It is opaque: send it back as given and
 * do not parse it or show it.
 */
export type AmsFieldVerdict = {
  __typename?: 'AmsFieldVerdict';
  /** How an edited value is compared with currentValue. */
  comparison: AmsFieldComparison;
  currentValue?: Maybe<Scalars['String']['output']>;
  /**
   * The field's name for a person, e.g. "Mailing address · City" or
   * "Coverage CGL · Limit 1". fieldPath remains what a write addresses.
   */
  fieldLabel: Scalars['String']['output'];
  /** The field's own name, e.g. "City". */
  fieldName: Scalars['String']['output'];
  fieldPath: Scalars['String']['output'];
  itemKey?: Maybe<Scalars['String']['output']>;
  /** Why nothing on this field's list item can be written, e.g. an item the AMS lacks. Null when it can. */
  itemReadOnlyReason?: Maybe<Scalars['String']['output']>;
  /**
   * What a list item was matched to its AMS counterpart on, such as "year, make and
   * model", when that was weaker than its own identifier. Null otherwise.
   */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /**
   * The list each supported value of the optionsDependOn field gives this field, in order;
   * the first serves a value that matches none. Empty when optionsDependOn is null.
   */
  optionsByValue: Array<AmsOptionsChoice>;
  /**
   * The fieldPath, on the same item, whose value picks this field's list, e.g. a state's
   * list follows its address's country. Null when the list is fixed, or when a supported
   * country's list couldn't be read and the field is free text.
   */
  optionsDependOn?: Maybe<Scalars['String']['output']>;
  /**
   * The lookupType of the result's codeLists entry holding the values this field may take,
   * when the AMS lists them. Null for a free-text field.
   */
  optionsId?: Maybe<Scalars['String']['output']>;
  outcome: AmsVerdictOutcome;
  /**
   * Every level the field sits under, outermost first, and how review draws each: e.g. the
   * premise list, one premise, the heading over its rating blocks, and the Construction
   * block. Empty for a line's own field that no layout heads.
   */
  placement: Array<AmsPlacementLevel>;
  proposedValue?: Maybe<Scalars['String']['output']>;
  /** Why an apply cannot write this field, such as a field Epic does not store. Null when it can. */
  readOnlyReason?: Maybe<Scalars['String']['output']>;
  recommendedAction?: Maybe<Scalars['String']['output']>;
  /** The document text the proposed value was read from, quoted. */
  sourceQuote: Scalars['String']['output'];
};

/** How a list's items are drawn. */
export enum AmsItemDisplay {
  /** Each item is a block inside the card that holds the list. */
  Block = 'BLOCK',
  /** Each item is its own card. */
  Card = 'CARD'
}

export enum AmsLogStatus {
  /**
   * The AMS may hold the email without having said so. Logging it again may add a second
   * copy.
   */
  CouldNotConfirm = 'COULD_NOT_CONFIRM',
  /** The AMS refused the email, or Cara couldn't attempt it. Nothing was added. */
  CouldNotLog = 'COULD_NOT_LOG',
  Logged = 'LOGGED',
  Logging = 'LOGGING',
  NotLogged = 'NOT_LOGGED',
  /** The email hasn't sent yet. Cara logs it when it does. */
  Scheduled = 'SCHEDULED',
  /** Cara can't log emails to the agency's AMS yet. */
  Unsupported = 'UNSUPPORTED'
}

/** Why Cara didn't log a sent email to the AMS by itself. */
export enum AmsNotLoggedReason {
  /** No AMS logged the agency's emails when the email sent. */
  LoggingOff = 'LOGGING_OFF',
  /** No recipient matches an account in the AMS. */
  NoMatch = 'NO_MATCH',
  /** More than one recipient matches, and together they lead to several accounts. */
  RecipientsMatchSeveral = 'RECIPIENTS_MATCH_SEVERAL',
  /** Sent from Outlook, which Cara never logs by itself. Derived when read, never stored. */
  SentFromOutlook = 'SENT_FROM_OUTLOOK',
  /** One recipient leads to several accounts, so an agent chooses. */
  SeveralMatch = 'SEVERAL_MATCH',
  /** The agent chose not to log the email. */
  Skipped = 'SKIPPED',
  /** Cara can't log emails to the agency's AMS yet. */
  UnsupportedAms = 'UNSUPPORTED_AMS',
  /**
   * Cara logs emails to the agency's AMS, but not through this kind of connection, such
   * as an Applied Epic API connection. Derived when read, never stored.
   */
  UnsupportedConnection = 'UNSUPPORTED_CONNECTION'
}

/** The code list a coded field offers when the field it depends on holds `value`. */
export type AmsOptionsChoice = {
  __typename?: 'AmsOptionsChoice';
  /** The lookupType of the codeLists entry this field offers while the field it depends on holds `value`. */
  optionsId: Scalars['String']['output'];
  /** The code the field it depends on holds, e.g. USA. */
  value: Scalars['String']['output'];
};

/** One level a field sits under. */
export type AmsPlacementLevel = {
  __typename?: 'AmsPlacementLevel';
  display: AmsSectionDisplay;
  /** How a CARD_LIST's items are drawn. CARD on any other level. */
  itemDisplay: AmsItemDisplay;
  /** Tells the level from its siblings: a section's heading, or an item's key as itemKey gives it. Opaque. */
  key: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** An ITEM's: what it was matched to its AMS counterpart on, when that was weaker than its own identifier. */
  matchedOn?: Maybe<Scalars['String']['output']>;
  /** An ITEM's: why nothing on it can be written. Null when it can. */
  readOnlyReason?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the level is a record an apply writes whole: a list item, or a section's
   * record card. A block or heading inside one is not, nor is a list. A field with no
   * record level is one of the line's own.
   */
  record: Scalars['Boolean']['output'];
};

/**
 * A policy matched by the top-level policy-number search, paired with its owning
 * account so the picker can load the policy's documents (which are account-scoped)
 * and freshen them via the per-account refresh.
 */
export type AmsPolicySearchResult = {
  __typename?: 'AmsPolicySearchResult';
  /**
   * The policy's owning ACCOUNT entity. Null only when the relationship can't be
   * resolved within a document-capable integration (an orphaned policy).
   */
  account?: Maybe<KnowledgeGraphEntity>;
  /** The matched POLICY entity (its searchMetadata carries policy number, carrier, dates). */
  policy: KnowledgeGraphEntity;
};

export enum AmsPushOutcome {
  /** The AMS refused the email, or Cara couldn't attempt it. Nothing was added. */
  Failed = 'FAILED',
  Logged = 'LOGGED',
  /** The AMS connection is signed out, so nothing was added. An admin reconnects it. */
  SignedOut = 'SIGNED_OUT',
  /** The AMS didn't confirm it saved the email, which may already be on the client's record. */
  Unconfirmed = 'UNCONFIRMED'
}

/**
 * Which canonical schema to reconcile a document against. Each maps to its own
 * extraction target and AMS-side resolution.
 */
export enum AmsReconciliationLineOfBusiness {
  Applicant = 'APPLICANT',
  BusinessAuto = 'BUSINESS_AUTO',
  CommercialProperty = 'COMMERCIAL_PROPERTY',
  GeneralLiability = 'GENERAL_LIABILITY',
  Homeowner = 'HOMEOWNER',
  PersonalAuto = 'PERSONAL_AUTO',
  PersonalUmbrella = 'PERSONAL_UMBRELLA',
  WorkersCompensation = 'WORKERS_COMPENSATION'
}

/**
 * One Applied Epic policy, as the picker nests destinations under it: the policy's
 * application and each of its lines.
 */
export type AmsReconciliationPolicyGroup = {
  __typename?: 'AmsReconciliationPolicyGroup';
  detail?: Maybe<Scalars['String']['output']>;
  /**
   * Keyed on Epic's PolicyID, not the policy number, which can be unassigned or change
   * at renewal. Opaque.
   */
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/**
 * Everything step one needs before the user has chosen anything: what the document says
 * and which accounts it could mean. Reads only — no account is imported and nothing is
 * written.
 */
export type AmsReconciliationPrep = {
  __typename?: 'AmsReconciliationPrep';
  detected: AmsDetectedEntities;
  /**
   * The agency's reconcilable AMS integration, which createAmsAccount needs when no
   * match carries one, as in CREATE_NEW. Null when the agency has no Applied Epic
   * integration.
   */
  integrationId?: Maybe<Scalars['String']['output']>;
  /**
   * The destinations the document asked for, as they would sit on an account created
   * from it: grouped under the document's policy number, none of them available,
   * since Cara cannot create a policy or line in Epic.
   */
  newAccountTargets: Array<AmsReconciliationTarget>;
  startingState: AmsReconciliationStartingState;
  /** Ranked best-first. Empty in the CREATE_NEW state. */
  suggestedAccounts: Array<AmsAccountMatch>;
  /** Set only in the WORKSPACE_CLIENT state. */
  workspaceClientAccount?: Maybe<AmsAccountMatch>;
};

/**
 * The result of one AMS reconciliation pass over one document, for one line of
 * business.
 */
export type AmsReconciliationResult = {
  __typename?: 'AmsReconciliationResult';
  codeLists: Array<AmsCodeList>;
  unmappedFindings: Array<AmsUnmappedFinding>;
  verdicts: Array<AmsFieldVerdict>;
};

/**
 * Where to read the document text a reconciliation pass runs against. Set either
 * fileId, or messageId with workspaceId; any other combination is rejected.
 */
export type AmsReconciliationSourceInput = {
  /** A workspace file's already-extracted text. */
  fileId?: InputMaybe<Scalars['String']['input']>;
  /** A Cara chat message's ID. See workspaceId. */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The workspace messageId belongs to, since a message is only addressable within
   * it. Required with messageId; unused with fileId.
   */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Which step-one state the flow opens in, derived from the account lookup. */
export enum AmsReconciliationStartingState {
  /** Nothing matched, so the run will create an account. */
  CreateNew = 'CREATE_NEW',
  /** No linked client, but the document's identifiers matched at least one account. */
  Suggested = 'SUGGESTED',
  /** The workspace's client is already linked to an AMS account; it is prefilled. */
  WorkspaceClient = 'WORKSPACE_CLIENT'
}

/**
 * One place a reconciliation pass could write, for one account.
 *
 * available is false for a destination this account has no record for; it is listed
 * but not selectable. An absence is only meaningful once the account has finished
 * syncing; see AmsReconciliationTargets.syncing.
 */
export type AmsReconciliationTarget = {
  __typename?: 'AmsReconciliationTarget';
  /**
   * Whether a record backing this destination already exists on the account. False rows
   * are destinations the document asked for and the account lacks; they carry a line of
   * business and a field count but no policy to write them to.
   */
  available: Scalars['Boolean']['output'];
  detail?: Maybe<Scalars['String']['output']>;
  /** True when the detection pass found this destination in the source text. */
  detectedFromDocument: Scalars['Boolean']['output'];
  /**
   * Stable identity for one destination. Line of business alone is not unique: two
   * commercial policies each have their own applicant section.
   */
  id: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /**
   * Null for a policy line Cara can list but has no canonical schema for, such as
   * business owners. Such a destination cannot be reconciled.
   */
  lineOfBusiness?: Maybe<AmsReconciliationLineOfBusiness>;
  /**
   * The Applied Epic policy this destination sits on; null for a destination the
   * account lacks. label and detail are relative to the policy, so name the
   * destination elsewhere by prefixing the group's label.
   */
  policyGroup?: Maybe<AmsReconciliationPolicyGroup>;
  policyId?: Maybe<Scalars['String']['output']>;
  /** True when an apply for this destination can complete, rather than only review it. */
  writable: Scalars['Boolean']['output'];
};

/** An account's destinations and whether they are still syncing. */
export type AmsReconciliationTargets = {
  __typename?: 'AmsReconciliationTargets';
  /**
   * True while a refresh is running for this account. A freshly imported account has
   * no policies until it lands, so poll until this clears before trusting an
   * unavailable destination.
   */
  syncing: Scalars['Boolean']['output'];
  targets: Array<AmsReconciliationTarget>;
};

export type AmsReconciliationTargetsInput = {
  accountId: Scalars['ID']['input'];
  detected: AmsDetectedEntitiesInput;
};

/**
 * An AMS record by its own identity: the integration it lives in, its kind and
 * the AMS's ID for it. The same whether the record was found in the synced tables
 * or read live.
 */
export type AmsRef = {
  __typename?: 'AmsRef';
  /**
   * The account's external ID, or the account a folder is applicable to. Set for every
   * kind but ACCOUNT; an AMS that
   * finds a policy only through its account needs it to look the policy up.
   */
  accountExternalId?: Maybe<Scalars['String']['output']>;
  /** The AMS's ID for the record, as the record's normalized row holds it. */
  externalId: Scalars['String']['output'];
  integrationId: Scalars['String']['output'];
  kind: AmsRefKind;
};

export type AmsRefInput = {
  accountExternalId?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  integrationId: Scalars['String']['input'];
  kind: AmsRefKind;
};

/** The kinds of AMS record the AMS browser can pick. */
export enum AmsRefKind {
  Account = 'ACCOUNT',
  Activity = 'ACTIVITY',
  Certificate = 'CERTIFICATE',
  File = 'FILE',
  Folder = 'FOLDER',
  Policy = 'POLICY'
}

/** Whether a background AMS refresh is running for an account. */
export enum AmsRefreshState {
  /** The most recent refresh workflow failed (e.g. bad credentials, AMS outage). */
  Failed = 'FAILED',
  /** No refresh is running (includes "the last refresh completed"). */
  Idle = 'IDLE',
  /** A refresh workflow is currently fetching from the AMS. */
  Running = 'RUNNING'
}

/** Why an approved change did not land. */
export enum AmsRefusalKind {
  /** It was never sent: a check or the read before it failed, or the request ended or the AMS stopped answering first. */
  NotWritten = 'NOT_WRITTEN',
  /** The AMS refused it. */
  RefusedByAms = 'REFUSED_BY_AMS',
  /** It was sent but no answer came back, so the AMS may or may not have applied it. */
  Unconfirmed = 'UNCONFIRMED'
}

/** An approved change that did not land, named as the verdict that proposed it. */
export type AmsRefusedChange = {
  __typename?: 'AmsRefusedChange';
  /** The proposing verdict's fieldPath, which with itemKey and parentKeys picks out the change. */
  fieldPath: Scalars['String']['output'];
  /** The proposing verdict's itemKey: the list item the change addressed. Null for a field outside any list. */
  itemKey?: Maybe<Scalars['String']['output']>;
  kind: AmsRefusalKind;
  /** The AMS's reason in its own words when kind is REFUSED_BY_AMS, else Cara's. */
  message: Scalars['String']['output'];
  /** The keys of the items the change's item sits under, outermost first, as the approval sent them. */
  parentKeys: Array<Scalars['String']['output']>;
};

/** How review draws one level a field sits under. */
export enum AmsSectionDisplay {
  /** A card of fields: a record, or a block inside a card. */
  Card = 'CARD',
  /** A list, whose items follow as ITEM levels. */
  CardList = 'CARD_LIST',
  /** A label over the levels below, with no card of its own. */
  Heading = 'HEADING',
  /** One item of the list above. */
  Item = 'ITEM'
}

/** Something the document stated that fits no field this line of business tracks. */
export type AmsUnmappedFinding = {
  __typename?: 'AmsUnmappedFinding';
  location: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

/**
 * One field's reconciliation outcome from an AMS reconciliation pass: what a
 * document proposes versus what the AMS currently holds.
 */
export enum AmsVerdictOutcome {
  /** The document states a value the AMS has nothing for. */
  AbsentFromAms = 'ABSENT_FROM_AMS',
  /** The document's stated value matches what the AMS currently holds. */
  Agrees = 'AGREES',
  /** The AMS holds a value for this field, and it differs from the document. */
  Differs = 'DIFFERS',
  /**
   * The AMS holds a value the document doesn't state. proposedValue is null and
   * source is empty: the document is silent, not contradicting.
   */
  OnlyInAms = 'ONLY_IN_AMS'
}

/** Input for creating a new version of a workflow execution with appended tasks */
export type AppendWorkflowTasksInput = {
  /** The task definition keys to append to the execution */
  taskDefinitionKeys: Array<WorkflowTaskDefinitionKey>;
};

/**
 * Legacy tool for generating Excel files by executing Python scripts.
 * Kept so historical workspace events that used APPLICATION_FILE_GENERATOR continue to load.
 * New Excel work goes through XLSX_EDITOR. Each successful run stored a new downloadable file.
 * EDIT_UPLOADED read a source XLSX (user upload); the source file in storage was not modified.
 */
export type ApplicationFileGeneratorTool = {
  __typename?: 'ApplicationFileGeneratorTool';
  /** The input arguments for the file generation */
  input: ApplicationFileGeneratorToolInput;
  /** The result of the file generation operation */
  output: ApplicationFileGeneratorToolOutput;
};

/**
 * Input arguments for the ApplicationFileGeneratorTool.
 * Contains all necessary information to generate an application file.
 */
export type ApplicationFileGeneratorToolInput = {
  __typename?: 'ApplicationFileGeneratorToolInput';
  /** The ID of the file being created or updated */
  fileId: Scalars['String']['output'];
  /** The type of file to generate. Required. Valid values: "XLSX". */
  fileType: Scalars['String']['output'];
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** The requirements for the file */
  requirements: Scalars['String']['output'];
  /** The ID of a source file to use as a starting point (optional) */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The title of the file */
  title: Scalars['String']['output'];
};

/**
 * Result of an ApplicationFileGeneratorTool operation.
 * Contains information about the generated file.
 */
export type ApplicationFileGeneratorToolOutput = {
  __typename?: 'ApplicationFileGeneratorToolOutput';
  /** Any error message if the script failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the generated file */
  fileId: Scalars['String']['output'];
  /**
   * The Python code that was used to generate the file.
   * This is returned so you can see what code was used and modify it if needed.
   */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** Any remarks or instructions for subsequent operations on this file. */
  remarks?: Maybe<Scalars['String']['output']>;
  /** The standard error from the Python script execution */
  stderr?: Maybe<Scalars['String']['output']>;
  /** The standard output from the Python script execution */
  stdout?: Maybe<Scalars['String']['output']>;
  /** Whether the Python script executed successfully */
  success: Scalars['Boolean']['output'];
  /** Any validation warnings or errors */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the generated file passed validation */
  validationPassed?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the artifact */
  version: Scalars['Int']['output'];
};

export type AppliedEpicActivityTaskInput = {
  __typename?: 'AppliedEpicActivityTaskInput';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
};

export type AppliedEpicAddActivityNoteFields = {
  __typename?: 'AppliedEpicAddActivityNoteFields';
  activityId?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
};

/** AppliedEpicApiCredentials contains the credentials for the Applied Epic API integration */
export type AppliedEpicApiCredentials = {
  __typename?: 'AppliedEpicApiCredentials';
  /** API key for the Applied Epic API integration */
  key: Scalars['String']['output'];
  /** API secret for the Applied Epic API integration */
  secret: Scalars['String']['output'];
};

/** AppliedEpicApiCredentials contains the credentials for the Applied Epic API integration */
export type AppliedEpicApiCredentialsInput = {
  /** API key for the Applied Epic API integration */
  key: Scalars['String']['input'];
  /** API secret for the Applied Epic API integration */
  secret: Scalars['String']['input'];
};

export type AppliedEpicCertAutoSectionFields = {
  __typename?: 'AppliedEpicCertAutoSectionFields';
  allOwnedAutos?: Maybe<Scalars['Boolean']['output']>;
  anyAuto?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  hiredAutos?: Maybe<Scalars['Boolean']['output']>;
  limitsBodilyInjuryPerAccident?: Maybe<Scalars['String']['output']>;
  limitsBodilyInjuryPerPerson?: Maybe<Scalars['String']['output']>;
  limitsCombinedSingleLimitEachAccident?: Maybe<Scalars['String']['output']>;
  limitsPropertyDamagePerAccident?: Maybe<Scalars['String']['output']>;
  nonOwnedAutos?: Maybe<Scalars['Boolean']['output']>;
  scheduledAutos?: Maybe<Scalars['Boolean']['output']>;
};

export type AppliedEpicCertExcessSectionFields = {
  __typename?: 'AppliedEpicCertExcessSectionFields';
  deductibleRetention?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  limitsAggregate?: Maybe<Scalars['String']['output']>;
  limitsEachOccurrence?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCertGlSectionFields = {
  __typename?: 'AppliedEpicCertGLSectionFields';
  commercialGeneralLiability?: Maybe<Scalars['Boolean']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  limitsDamageToRentedPremises?: Maybe<Scalars['String']['output']>;
  limitsEachOccurrence?: Maybe<Scalars['String']['output']>;
  limitsGeneralAggregate?: Maybe<Scalars['String']['output']>;
  limitsMedicalExpense?: Maybe<Scalars['String']['output']>;
  limitsPersonalAndAdvertisingInjury?: Maybe<Scalars['String']['output']>;
  limitsProductsCompletedOperationsAggregate?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCertWcSectionFields = {
  __typename?: 'AppliedEpicCertWCSectionFields';
  description?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityDiseaseEachEmployee?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityDiseasePolicyLimit?: Maybe<Scalars['String']['output']>;
  limitsEmployersLiabilityEachAccident?: Maybe<Scalars['String']['output']>;
  workersCompensationStatutoryLimits?: Maybe<Scalars['Boolean']['output']>;
};

export type AppliedEpicCommercialBuildingInput = {
  __typename?: 'AppliedEpicCommercialBuildingInput';
  annualRevenues?: Maybe<Scalars['Int64']['output']>;
  buildingDescription?: Maybe<Scalars['String']['output']>;
  buildingId?: Maybe<Scalars['Int']['output']>;
  buildingNumber?: Maybe<Scalars['Int']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  interestCode?: Maybe<Scalars['String']['output']>;
  numberOfFullTimeEmployees?: Maybe<Scalars['Int']['output']>;
  numberOfPartTimeEmployees?: Maybe<Scalars['Int']['output']>;
  occupiedArea?: Maybe<Scalars['Int']['output']>;
  totalBuildingArea?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicCommercialLossHistoryItemInput = {
  __typename?: 'AppliedEpicCommercialLossHistoryItemInput';
  amountPaid?: Maybe<Scalars['Int']['output']>;
  amountReserved?: Maybe<Scalars['Int']['output']>;
  claimOpenCode?: Maybe<Scalars['String']['output']>;
  dateOfClaim?: Maybe<Scalars['String']['output']>;
  dateOfOccurrence?: Maybe<Scalars['String']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOfOccurrenceOrClaim?: Maybe<Scalars['String']['output']>;
  lineType?: Maybe<Scalars['String']['output']>;
  lossHistoryId?: Maybe<Scalars['Int']['output']>;
  subrogationCode?: Maybe<Scalars['String']['output']>;
  typeOfLoss?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicCommercialStatusSectionInput = {
  __typename?: 'AppliedEpicCommercialStatusSectionInput';
  attached?: Maybe<Scalars['Boolean']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
};

/** AppliedEpicConfiguration contains configuration for the Applied Epic integration */
export type AppliedEpicConfiguration = {
  __typename?: 'AppliedEpicConfiguration';
  /** API credentials for Applied Epic integration */
  apiCredentials?: Maybe<AppliedEpicApiCredentials>;
  /** SDK key for Applied Epic integration */
  sdkCredentials?: Maybe<AppliedEpicSdkCredentials>;
  /** Type of Applied Epic integration */
  type: AppliedEpicIntegrationType;
};

export type AppliedEpicCreateActivityFields = {
  __typename?: 'AppliedEpicCreateActivityFields';
  activityCode?: Maybe<Scalars['String']['output']>;
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  contactNumber?: Maybe<Scalars['String']['output']>;
  contactVia?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Array<Scalars['String']['output']>>;
  policyId?: Maybe<Scalars['String']['output']>;
  tasks?: Maybe<Array<AppliedEpicActivityTaskInput>>;
};

export type AppliedEpicCreateCertificateOfInsuranceFields = {
  __typename?: 'AppliedEpicCreateCertificateOfInsuranceFields';
  automobileLiability?: Maybe<AppliedEpicCertAutoSectionFields>;
  certificateTypeDescription?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  excessUmbrella?: Maybe<AppliedEpicCertExcessSectionFields>;
  generalLiability?: Maybe<AppliedEpicCertGlSectionFields>;
  holderCity?: Maybe<Scalars['String']['output']>;
  holderName?: Maybe<Scalars['String']['output']>;
  holderStateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  holderStreet1?: Maybe<Scalars['String']['output']>;
  holderStreet2?: Maybe<Scalars['String']['output']>;
  holderZipOrPostalCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourcePolicyId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workersComp?: Maybe<AppliedEpicCertWcSectionFields>;
};

/** AppliedEpicIntegrationType defines the type of Applied Epic integration */
export enum AppliedEpicIntegrationType {
  /** API integration */
  Api = 'API',
  /** SDK integration */
  Sdk = 'SDK'
}

export type AppliedEpicManageCommercialOtherNamedInsuredFields = {
  __typename?: 'AppliedEpicManageCommercialOtherNamedInsuredFields';
  action?: Maybe<Scalars['String']['output']>;
  businessTypeCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  glCode?: Maybe<Scalars['String']['output']>;
  naics?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameTypeCode?: Maybe<Scalars['String']['output']>;
  otherNamedInsuredId?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  sic?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManageCommercialPremiseFields = {
  __typename?: 'AppliedEpicManageCommercialPremiseFields';
  action?: Maybe<Scalars['String']['output']>;
  buildings?: Maybe<Array<AppliedEpicCommercialBuildingInput>>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  isBlanketLocation?: Maybe<Scalars['Boolean']['output']>;
  locationNumber?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  premiseId?: Maybe<Scalars['Int']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManageCommercialPriorCarrierFields = {
  __typename?: 'AppliedEpicManageCommercialPriorCarrierFields';
  action?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  expirationYear?: Maybe<Scalars['Int']['output']>;
  inceptionYear?: Maybe<Scalars['Int']['output']>;
  lob?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  priorCarrierId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicManageCommercialRemarkFields = {
  __typename?: 'AppliedEpicManageCommercialRemarkFields';
  action?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  printOnForm?: Maybe<Scalars['Boolean']['output']>;
  remarkId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicManagePersonalGaragingLocationFields = {
  __typename?: 'AppliedEpicManagePersonalGaragingLocationFields';
  action?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  isPrimaryPremise?: Maybe<Scalars['Boolean']['output']>;
  locationId?: Maybe<Scalars['Int']['output']>;
  locationNumber?: Maybe<Scalars['Int']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicManagePersonalRemarkFields = {
  __typename?: 'AppliedEpicManagePersonalRemarkFields';
  action?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  printOnForm?: Maybe<Scalars['Boolean']['output']>;
  remarkId?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicPersonalLossHistoryItemInput = {
  __typename?: 'AppliedEpicPersonalLossHistoryItemInput';
  amountPaid?: Maybe<Scalars['Float']['output']>;
  delete?: Maybe<Scalars['Boolean']['output']>;
  descriptionOf?: Maybe<Scalars['String']['output']>;
  lineTypeCode?: Maybe<Scalars['String']['output']>;
  lossDate?: Maybe<Scalars['String']['output']>;
  lossHistoryId?: Maybe<Scalars['Int']['output']>;
  lossType?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicPersonalPriorCoverageInput = {
  __typename?: 'AppliedEpicPersonalPriorCoverageInput';
  expirationDate?: Maybe<Scalars['String']['output']>;
  lineTypeCode?: Maybe<Scalars['String']['output']>;
  priorCarrier?: Maybe<Scalars['String']['output']>;
  priorPolicyNumber?: Maybe<Scalars['String']['output']>;
  slot?: Maybe<Scalars['Int']['output']>;
};

/** AppliedEpicSdkCredentials contains the credentials for the Applied Epic SDK integration */
export type AppliedEpicSdkCredentials = {
  __typename?: 'AppliedEpicSdkCredentials';
  /** API secret for the Applied Epic SDK integration */
  authKey: Scalars['String']['output'];
  /** Base URL for the Applied Epic SDK integration */
  baseUrl: Scalars['String']['output'];
  /** API key for the Applied Epic SDK integration */
  databaseName: Scalars['String']['output'];
};

/** AppliedEpicSdkCredentials contains the credentials for the Applied Epic SDK integration */
export type AppliedEpicSdkCredentialsInput = {
  /** Auth key for the Applied Epic SDK integration */
  authKey: Scalars['String']['input'];
  /** Base URL for the Applied Epic SDK integration */
  baseUrl: Scalars['String']['input'];
  /** Database name for the Applied Epic SDK integration */
  databaseName: Scalars['String']['input'];
};

export type AppliedEpicUnderwritingAnswerInput = {
  __typename?: 'AppliedEpicUnderwritingAnswerInput';
  answer?: Maybe<Scalars['String']['output']>;
  explanation?: Maybe<Scalars['String']['output']>;
  questionId?: Maybe<Scalars['Int']['output']>;
  questionNumber?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialApplicantFields = {
  __typename?: 'AppliedEpicUpdateCommercialApplicantFields';
  businessStartedDate?: Maybe<Scalars['String']['output']>;
  businessTypeCode?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  descriptionOfPrimaryOperations?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  glCode?: Maybe<Scalars['String']['output']>;
  naicsCode?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  natureOfBusinessCode?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialGeneralInfoFields = {
  __typename?: 'AppliedEpicUpdateCommercialGeneralInfoFields';
  answers?: Maybe<Array<AppliedEpicUnderwritingAnswerInput>>;
  clientId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdateCommercialLossHistoryFields = {
  __typename?: 'AppliedEpicUpdateCommercialLossHistoryFields';
  checkIfNone?: Maybe<Scalars['Boolean']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  items?: Maybe<Array<AppliedEpicCommercialLossHistoryItemInput>>;
  policyId?: Maybe<Scalars['String']['output']>;
  totalLosses?: Maybe<Scalars['Float']['output']>;
};

export type AppliedEpicUpdateCommercialStatusFields = {
  __typename?: 'AppliedEpicUpdateCommercialStatusFields';
  accountNumber?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  companyPolicyOrProgramName?: Maybe<Scalars['String']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  isRenewal?: Maybe<Scalars['Boolean']['output']>;
  methodOfPayment?: Maybe<Scalars['String']['output']>;
  minimumPremium?: Maybe<Scalars['Float']['output']>;
  paymentPlanCode?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyPremium?: Maybe<Scalars['Float']['output']>;
  programCode?: Maybe<Scalars['String']['output']>;
  sections?: Maybe<Array<AppliedEpicCommercialStatusSectionInput>>;
};

export type AppliedEpicUpdatePersonalApplicantFields = {
  __typename?: 'AppliedEpicUpdatePersonalApplicantFields';
  applicantName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  employer?: Maybe<Scalars['String']['output']>;
  insuredName?: Maybe<Scalars['String']['output']>;
  maritalStatusCode?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  socialSecurityNumber?: Maybe<Scalars['String']['output']>;
  stateOrProvinceCode?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  zipOrPostalCode?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalGeneralInfoFields = {
  __typename?: 'AppliedEpicUpdatePersonalGeneralInfoFields';
  answers?: Maybe<Array<AppliedEpicUnderwritingAnswerInput>>;
  clientId?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPaymentPlanFields = {
  __typename?: 'AppliedEpicUpdatePersonalPaymentPlanFields';
  billingCode?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dayOfMonthDue?: Maybe<Scalars['Int']['output']>;
  deposit?: Maybe<Scalars['Float']['output']>;
  estimatedTotalPremium?: Maybe<Scalars['Float']['output']>;
  firstPaymentDueDate?: Maybe<Scalars['String']['output']>;
  methodCode?: Maybe<Scalars['String']['output']>;
  paymentPlanCode?: Maybe<Scalars['String']['output']>;
  payorCode?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPolicySectionsFields = {
  __typename?: 'AppliedEpicUpdatePersonalPolicySectionsFields';
  clientId?: Maybe<Scalars['String']['output']>;
  companyPlan?: Maybe<Scalars['String']['output']>;
  isPersonalAutoSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isPersonalInlandMarineSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isPersonalUmbrellaSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isResidentialSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  isWatercraftSectionAttached?: Maybe<Scalars['Boolean']['output']>;
  otherSection1?: Maybe<Scalars['String']['output']>;
  otherSection2?: Maybe<Scalars['String']['output']>;
  otherSection3?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUpdatePersonalPriorCoverageFields = {
  __typename?: 'AppliedEpicUpdatePersonalPriorCoverageFields';
  clientId?: Maybe<Scalars['String']['output']>;
  lossItems?: Maybe<Array<AppliedEpicPersonalLossHistoryItemInput>>;
  lossesAtAnyLocationYesNo?: Maybe<Scalars['String']['output']>;
  noPriorCoverage?: Maybe<Scalars['Boolean']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  priorCoverages?: Maybe<Array<AppliedEpicPersonalPriorCoverageInput>>;
  yearsLossesAtAnyLocation?: Maybe<Scalars['Int']['output']>;
};

export type AppliedEpicUpdateTaskFields = {
  __typename?: 'AppliedEpicUpdateTaskFields';
  activityId?: Maybe<Scalars['String']['output']>;
  addNotes?: Maybe<Array<Scalars['String']['output']>>;
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type AppliedEpicUploadDocumentFields = {
  __typename?: 'AppliedEpicUploadDocumentFields';
  activityId?: Maybe<Scalars['String']['output']>;
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  folder?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/**
 * Represents a tool for managing Applied Epic write operations: creating
 * activities (with notes and tasks), adding notes to an existing activity,
 * updating a task (mark complete / change status / append notes / reschedule /
 * reassign), creating ACORD 25
 * (Liability) Certificates of Insurance, and uploading documents.
 */
export type AppliedEpicWriteTool = {
  __typename?: 'AppliedEpicWriteTool';
  input: AppliedEpicWriteToolInput;
  output: AppliedEpicWriteToolOutput;
};

export type AppliedEpicWriteToolInput = {
  __typename?: 'AppliedEpicWriteToolInput';
  addActivityNote?: Maybe<AppliedEpicAddActivityNoteFields>;
  createActivity?: Maybe<AppliedEpicCreateActivityFields>;
  createCertificateOfInsurance?: Maybe<AppliedEpicCreateCertificateOfInsuranceFields>;
  manageCommercialOtherNamedInsured?: Maybe<AppliedEpicManageCommercialOtherNamedInsuredFields>;
  manageCommercialPremise?: Maybe<AppliedEpicManageCommercialPremiseFields>;
  manageCommercialPriorCarrier?: Maybe<AppliedEpicManageCommercialPriorCarrierFields>;
  manageCommercialRemark?: Maybe<AppliedEpicManageCommercialRemarkFields>;
  managePersonalGaragingLocation?: Maybe<AppliedEpicManagePersonalGaragingLocationFields>;
  managePersonalRemark?: Maybe<AppliedEpicManagePersonalRemarkFields>;
  operation?: Maybe<Scalars['String']['output']>;
  updateCommercialApplicant?: Maybe<AppliedEpicUpdateCommercialApplicantFields>;
  updateCommercialGeneralInfo?: Maybe<AppliedEpicUpdateCommercialGeneralInfoFields>;
  updateCommercialLossHistory?: Maybe<AppliedEpicUpdateCommercialLossHistoryFields>;
  updateCommercialStatus?: Maybe<AppliedEpicUpdateCommercialStatusFields>;
  updatePersonalApplicant?: Maybe<AppliedEpicUpdatePersonalApplicantFields>;
  updatePersonalGeneralInfo?: Maybe<AppliedEpicUpdatePersonalGeneralInfoFields>;
  updatePersonalPaymentPlan?: Maybe<AppliedEpicUpdatePersonalPaymentPlanFields>;
  updatePersonalPolicySections?: Maybe<AppliedEpicUpdatePersonalPolicySectionsFields>;
  updatePersonalPriorCoverage?: Maybe<AppliedEpicUpdatePersonalPriorCoverageFields>;
  updateTask?: Maybe<AppliedEpicUpdateTaskFields>;
  uploadDocument?: Maybe<AppliedEpicUploadDocumentFields>;
};

export type AppliedEpicWriteToolOutput = {
  __typename?: 'AppliedEpicWriteToolOutput';
  activityId?: Maybe<Scalars['String']['output']>;
  attachmentId?: Maybe<Scalars['String']['output']>;
  automobileLiabilityId?: Maybe<Scalars['String']['output']>;
  certificateId?: Maybe<Scalars['String']['output']>;
  createdTaskIds?: Maybe<Array<Scalars['String']['output']>>;
  excessUmbrellaId?: Maybe<Scalars['String']['output']>;
  generalLiabilityId?: Maybe<Scalars['String']['output']>;
  holderId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  recordId?: Maybe<Scalars['String']['output']>;
  success: Scalars['Boolean']['output'];
  taskId?: Maybe<Scalars['String']['output']>;
  taskStatus?: Maybe<Scalars['String']['output']>;
  workersCompId?: Maybe<Scalars['String']['output']>;
};

export type ApplyAmsReconciliationInput = {
  approved: Array<AmsApprovedFieldInput>;
  lineOfBusiness: AmsReconciliationLineOfBusiness;
  policyId: Scalars['ID']['input'];
};

/**
 * Deprecated compatibility input for archiveWordDocumentTemplates. New callers
 * should use UpdateWordDocumentTemplatesInput with updateWordDocumentTemplates.
 */
export type ArchiveWordDocumentTemplatesInput = {
  /** Whether to archive the Word document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Word document templates.
   * Existing documents generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Mode for creating an Ascend program */
export enum AscendProgramCreationMode {
  /** Bundle with an existing quote */
  BundleWithExistingQuote = 'BUNDLE_WITH_EXISTING_QUOTE',
  /** Create a new program */
  CreateProgram = 'CREATE_PROGRAM',
  /** Use a specific program ID */
  UseSpecificProgramId = 'USE_SPECIFIC_PROGRAM_ID'
}

/** BasicAuth contains username/password credentials */
export type BasicAuth = {
  __typename?: 'BasicAuth';
  /** Password for basic authentication */
  password: Scalars['String']['output'];
  /** Username for basic authentication */
  username: Scalars['String']['output'];
};

/** BearerAuth contains a bearer token for authentication */
export type BearerAuth = {
  __typename?: 'BearerAuth';
  /** Bearer token for authentication */
  token: Scalars['String']['output'];
};

/** A blanket additional insured for the certificate */
export type BlanketAdditionalInsuredCertificateOption = {
  __typename?: 'BlanketAdditionalInsuredCertificateOption';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The ID of the blanket additional insured */
  id: Scalars['ID']['output'];
  /** The policy this blanket additional insured is associated with */
  policy: BusinessPolicy;
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

export enum BrandColorRole {
  Accent = 'ACCENT',
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Surface = 'SURFACE',
  Text = 'TEXT'
}

export type BrandColorScheme = {
  __typename?: 'BrandColorScheme';
  /** Stable, and stored nowhere: a saved brand keeps its colors, not the color scheme they came from. */
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  note: Scalars['String']['output'];
  palette: BrandPalette;
};

/**
 * The kinds of element a brand sets separately.
 *
 * A brand written by a newer server can carry an element an older one does not know. The
 * older server drops that entry when it reads the brand rather than failing the whole
 * record.
 */
export enum BrandElement {
  Body = 'BODY',
  ChartLabel = 'CHART_LABEL',
  Heading_1 = 'HEADING_1',
  Heading_2 = 'HEADING_2',
  RunningFooter = 'RUNNING_FOOTER',
  RunningHeader = 'RUNNING_HEADER',
  TableCell = 'TABLE_CELL',
  TableHeader = 'TABLE_HEADER',
  /** The tint every other body row of a table takes. */
  TableStripe = 'TABLE_STRIPE'
}

/**
 * How one kind of element is set.
 *
 * Every field is nullable and means "leave it to the document" when absent, so a brand
 * constrains only what an agency actually chose and the renderer keeps its own defaults
 * for the rest.
 */
export type BrandElementStyle = {
  __typename?: 'BrandElementStyle';
  bold?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Which palette role this element takes its color from. A role rather than a hex, so
   * changing the palette moves every element that referenced it.
   */
  colorRole?: Maybe<BrandColorRole>;
  element: BrandElement;
  /**
   * Which palette role paints behind the element. The table header and table stripe draw it;
   * on any other element it is kept but nothing draws it.
   */
  fillRole?: Maybe<BrandColorRole>;
  /** Family from the installed catalog. Null follows the brand's body or heading face. */
  fontFamily?: Maybe<Scalars['String']['output']>;
  italic?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Multiple of the size, so 1.4 is 1.4x. Not a length, because a leading fixed in points
   * stops tracking the size the moment somebody changes it.
   */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /**
   * Widow and orphan control: the fewest lines that may be left at the bottom of a page,
   * and the fewest that may be carried to the top of the next.
   */
  linesKeptAtBottom?: Maybe<Scalars['Int']['output']>;
  linesKeptAtTop?: Maybe<Scalars['Int']['output']>;
  /** Start this element on a fresh page. */
  pageBreakBefore?: Maybe<Scalars['Boolean']['output']>;
  /** Point size, as printed. Below 8pt is unreadable on paper whatever it looks like on screen. */
  sizePt?: Maybe<Scalars['Float']['output']>;
  spaceAbovePt?: Maybe<Scalars['Float']['output']>;
  spaceBelowPt?: Maybe<Scalars['Float']['output']>;
};

export type BrandElementStyleInput = {
  bold?: InputMaybe<Scalars['Boolean']['input']>;
  colorRole?: InputMaybe<BrandColorRole>;
  element: BrandElement;
  fillRole?: InputMaybe<BrandColorRole>;
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  italic?: InputMaybe<Scalars['Boolean']['input']>;
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  linesKeptAtBottom?: InputMaybe<Scalars['Int']['input']>;
  linesKeptAtTop?: InputMaybe<Scalars['Int']['input']>;
  pageBreakBefore?: InputMaybe<Scalars['Boolean']['input']>;
  sizePt?: InputMaybe<Scalars['Float']['input']>;
  spaceAbovePt?: InputMaybe<Scalars['Float']['input']>;
  spaceBelowPt?: InputMaybe<Scalars['Float']['input']>;
};

export type BrandLogo = {
  __typename?: 'BrandLogo';
  file: File;
  variant: BrandLogoVariant;
};

export type BrandLogoInput = {
  fileId: Scalars['String']['input'];
  variant: BrandLogoVariant;
};

export enum BrandLogoVariant {
  /** For dark backgrounds: a cover painted in the primary color. */
  Dark = 'DARK',
  /** For light backgrounds: the body of a page. */
  Light = 'LIGHT'
}

/**
 * The page margin an agency sets once, in inches.
 *
 * Inches rather than points because this is the number a printer, a page-setup dialog and
 * an agency's own brand guide all state it in.
 */
export type BrandMargins = {
  __typename?: 'BrandMargins';
  bottomIn?: Maybe<Scalars['Float']['output']>;
  /**
   * Off means the brand sets no margin and the renderer keeps its own; the sides are kept so
   * it can be switched back on. Null is on.
   */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  leftIn?: Maybe<Scalars['Float']['output']>;
  rightIn?: Maybe<Scalars['Float']['output']>;
  topIn?: Maybe<Scalars['Float']['output']>;
};

export type BrandMarginsInput = {
  bottomIn?: InputMaybe<Scalars['Float']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  leftIn?: InputMaybe<Scalars['Float']['input']>;
  rightIn?: InputMaybe<Scalars['Float']['input']>;
  topIn?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * The five roles a document draws from. Every generated stylesheet maps these onto
 * CSS variables, so a document references a role rather than a color.
 */
export type BrandPalette = {
  __typename?: 'BrandPalette';
  /** Callouts and highlights, used sparingly. */
  accentHex: Scalars['String']['output'];
  /** Headings, rules, table headers, and the cover fill. */
  primaryHex: Scalars['String']['output'];
  /** A second brand color for accents that should not compete with the primary. */
  secondaryHex: Scalars['String']['output'];
  /** The page behind everything. Usually white or very near it. */
  surfaceHex: Scalars['String']['output'];
  /** Body text. */
  textHex: Scalars['String']['output'];
};

export type BrandPaletteInput = {
  accentHex: Scalars['String']['input'];
  primaryHex: Scalars['String']['input'];
  secondaryHex: Scalars['String']['input'];
  surfaceHex: Scalars['String']['input'];
  textHex: Scalars['String']['input'];
};

/** A logo in a running header or footer corner, in place of text. */
export type BrandSlotLogo = {
  __typename?: 'BrandSlotLogo';
  /** How tall the mark prints, in points. Unset takes the renderer's default. */
  maxHeightPt?: Maybe<Scalars['Float']['output']>;
  variant: BrandLogoVariant;
};

export type BrandSlotLogoInput = {
  maxHeightPt?: InputMaybe<Scalars['Float']['input']>;
  variant: BrandLogoVariant;
};

/**
 * The three positions a running header or footer prints in.
 *
 * Plain text, because the renderer already resolves {page}, {pages} and {date} inside a
 * slot. An empty string clears the corner; null leaves it to the document.
 */
export type BrandSlots = {
  __typename?: 'BrandSlots';
  center?: Maybe<Scalars['String']['output']>;
  centerLogo?: Maybe<BrandSlotLogo>;
  /**
   * Off means the brand contributes nothing here and a document keeps whatever it or its
   * template has; the slots are kept so it can be switched back on. Null is on, so a brand
   * saved before this existed prints unchanged.
   */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  left?: Maybe<Scalars['String']['output']>;
  /** A logo in the corner instead of text. When both are set the logo wins. */
  leftLogo?: Maybe<BrandSlotLogo>;
  right?: Maybe<Scalars['String']['output']>;
  rightLogo?: Maybe<BrandSlotLogo>;
};

export type BrandSlotsInput = {
  center?: InputMaybe<Scalars['String']['input']>;
  centerLogo?: InputMaybe<BrandSlotLogoInput>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  left?: InputMaybe<Scalars['String']['input']>;
  /** A logo in the corner instead of text. When both are set the logo wins. */
  leftLogo?: InputMaybe<BrandSlotLogoInput>;
  right?: InputMaybe<Scalars['String']['input']>;
  rightLogo?: InputMaybe<BrandSlotLogoInput>;
};

/**
 * A typeface an agency may choose, from the set the renderer has installed.
 *
 * The catalog is closed on purpose: a family the render image does not carry falls
 * back silently at print time, and the substitute's metrics move every line break in
 * the document.
 */
export type BrandTypeface = {
  __typename?: 'BrandTypeface';
  /**
   * The font-family the stylesheet emits for this face, ending in a generic. A preview
   * that sets the bare family name instead shows whatever the viewer happens to have,
   * which is how a preview comes to disagree with the print it is previewing.
   */
  cssStack: Scalars['String']['output'];
  family: Scalars['String']['output'];
  /**
   * The proprietary family this one matches the metrics of, when it matches one.
   * A document written for Arial keeps its line breaks when set in a face that does.
   */
  metricAlias?: Maybe<Scalars['String']['output']>;
};

export type BrandVoice = {
  __typename?: 'BrandVoice';
  /** Words and claims the agency never puts in a document. */
  avoid?: Maybe<Scalars['String']['output']>;
  /** Words and names the agency uses, and the ones it uses instead of the common term. */
  terminology?: Maybe<Scalars['String']['output']>;
  /** How client-facing documents should read. */
  tone?: Maybe<Scalars['String']['output']>;
};

export type BrandVoiceInput = {
  avoid?: InputMaybe<Scalars['String']['input']>;
  terminology?: InputMaybe<Scalars['String']['input']>;
  tone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Arguments for buildHtmlDocumentRenderUrl. Grouped in one input so new fields can be added without
 * breaking existing GraphQL callers.
 */
export type BuildHtmlDocumentRenderUrlInput = {
  /**
   * The artifact to render. Leave it out to join the attachments alone, prefix then suffix;
   * version, styleId, skipTemplateFiles, includeDesignPages and producerInformationId are then
   * refused.
   */
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Prints the design's start and end pages, outermost, where they would otherwise be left
   * out: around a document linked to a template, or with skipTemplateFiles.
   */
  includeDesignPages?: InputMaybe<Scalars['Boolean']['input']>;
  prefixAttachments: Array<PdfRenderAttachmentInput>;
  /** ACORD template form only: producer information ID for signature stamping */
  producerInformationId?: InputMaybe<Scalars['ID']['input']>;
  /** Fit only when the requested version is the latest non-final HTML draft and the caller may update it. Historical and final selections keep their content. */
  refitDesign?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Leaves out the pages the document's look brings: its template's, and its design's on a
   * document with no template. For a caller whose attachments name every page to print.
   */
  skipTemplateFiles?: InputMaybe<Scalars['Boolean']['input']>;
  styleId?: InputMaybe<Scalars['String']['input']>;
  suffixAttachments: Array<PdfRenderAttachmentInput>;
  /** The version of artifactId to render. Leave it out to render the latest. */
  version?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};

/**
 * Represents a tool that makes a bulk draft and changes who it goes to. A bulk draft is one
 * email per client on a list, each an ordinary draft in the workspace. Nothing in this tool
 * sends: the agent sends from the bulk draft's page.
 */
export type BulkEmailDraftTool = {
  __typename?: 'BulkEmailDraftTool';
  input: BulkEmailDraftToolInput;
  output?: Maybe<BulkEmailDraftToolOutput>;
};

/** Input for the ADD operation, which adds clients to a bulk draft. */
export type BulkEmailDraftToolAddInput = {
  __typename?: 'BulkEmailDraftToolAddInput';
  bulkSendId: Scalars['String']['output'];
  recipients: Array<BulkEmailDraftToolRecipientInput>;
};

/**
 * Input for the CREATE operation, which makes a bulk draft in this workspace with its first
 * recipients.
 */
export type BulkEmailDraftToolCreateInput = {
  __typename?: 'BulkEmailDraftToolCreateInput';
  name: Scalars['String']['output'];
  recipients: Array<BulkEmailDraftToolRecipientInput>;
};

/** Input for the FILL operation, which drafts the email of each recipient it names. */
export type BulkEmailDraftToolFillInput = {
  __typename?: 'BulkEmailDraftToolFillInput';
  brief: Scalars['String']['output'];
  bulkSendId: Scalars['String']['output'];
  recipients: Array<BulkEmailDraftToolFillRecipientInput>;
};

/** One recipient for FILL to draft, and the template version its email is written from. */
export type BulkEmailDraftToolFillRecipientInput = {
  __typename?: 'BulkEmailDraftToolFillRecipientInput';
  recipientId: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
  templateVersion?: Maybe<Scalars['Int64']['output']>;
};

export type BulkEmailDraftToolInput = {
  __typename?: 'BulkEmailDraftToolInput';
  add?: Maybe<BulkEmailDraftToolAddInput>;
  create?: Maybe<BulkEmailDraftToolCreateInput>;
  fill?: Maybe<BulkEmailDraftToolFillInput>;
  operation: Scalars['String']['output'];
  remove?: Maybe<BulkEmailDraftToolRemoveInput>;
};

/**
 * Result of a BulkEmailDraftTool operation: the bulk draft as it now stands, and what the
 * call changed.
 */
export type BulkEmailDraftToolOutput = {
  __typename?: 'BulkEmailDraftToolOutput';
  added: Scalars['Int']['output'];
  bulkSendId: Scalars['String']['output'];
  /** Clients left out because their address was already on the list. */
  duplicatesSkipped: Scalars['Int']['output'];
  /**
   * Entries left out because they had no name or an email address that isn't one, as
   * written: the first 20.
   */
  invalidEntries?: Maybe<Array<Scalars['String']['output']>>;
  /** How many entries were left out because they had no name or an email address that isn't one. */
  invalidEntryCount: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  /** Recipient IDs REMOVE named that weren't on the list. */
  notListed?: Maybe<Array<Scalars['String']['output']>>;
  /** Clients left out because a bulk draft holds at most 50. */
  overCap: Scalars['Int']['output'];
  /** Everyone on the list now, in order. */
  recipients: Array<BulkEmailDraftToolRecipient>;
  removed: Scalars['Int']['output'];
};

export type BulkEmailDraftToolRecipient = {
  __typename?: 'BulkEmailDraftToolRecipient';
  draftState: EmailBulkSendDraftState;
  email?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  recipientId: Scalars['String']['output'];
};

/** A client to add to a bulk draft. */
export type BulkEmailDraftToolRecipientInput = {
  __typename?: 'BulkEmailDraftToolRecipientInput';
  email?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

/** Input for the REMOVE operation, which takes clients off a bulk draft. */
export type BulkEmailDraftToolRemoveInput = {
  __typename?: 'BulkEmailDraftToolRemoveInput';
  bulkSendId: Scalars['String']['output'];
  recipientIds: Array<Scalars['String']['output']>;
};

/** Account details specific to a business account */
export type BusinessAccount = AccountDetails & {
  __typename?: 'BusinessAccount';
  /** The 'Doing Business As' (DBA) name if different from legal name */
  dba: Scalars['String']['output'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['output'];
  /** Mailing address for the business */
  mailingAddress: Address;
  /** The legal name of the business */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['output'];
  /** Website URL for the business */
  website: Scalars['String']['output'];
};

/** Business Policy represents the business or commercial insurance policy */
export type BusinessPolicy = {
  __typename?: 'BusinessPolicy';
  /** The account this policy is associated with */
  account: Account;
  /** The agency user that sources or owns the policy */
  agencyUser: AgencyUser;
  /** The broker providing this policy, if any */
  broker?: Maybe<InsuranceCarrier>;
  /** If the policy was canceled or nonrenewed, information about the latest instance of cancellation or nonrenewal */
  cancellation?: Maybe<BusinessPolicyCancellation>;
  /** The carrier providing this policy */
  carrier: InsuranceCarrier;
  /** The date the policy object was originally created */
  createdAt: Scalars['Time']['output'];
  /** Detailed information extracted from the policy document, if available */
  details?: Maybe<BusinessPolicyExtractedDetails>;
  /** The timestamp when this policy expires */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** All attached files for this policy */
  files: Array<File>;
  /** The internal ID of the policy */
  id: Scalars['ID']['output'];
  /** The timestamp when this policy is inforce */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this policy was issued */
  issuedAt?: Maybe<Scalars['Time']['output']>;
  /** The market this policy was written in */
  market: InsuranceMarket;
  /** The number or external identifier associated with this policy within the carrier system */
  policyNumber: Scalars['String']['output'];
  /** The pricing information for this policy */
  pricing: BusinessPolicyPricing;
  /** The number or external identifier associated with this quote within the carrier system */
  quoteNumber: Scalars['String']['output'];
  /** If the policy was reinstated, information about the latest instance of when it was reinstated */
  reinstatement?: Maybe<BusinessPolicyReinstatement>;
  /** If this policy was renewed from another policy, information about the renewal and its previous versions */
  renewal?: Maybe<BusinessPolicyRenewal>;
  /** The current state of the policy */
  state: PolicyState;
  /** The type of insurance this policy represents */
  type: InsuranceType;
  /** The date this policy object was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<BusinessPolicyVersion>>;
};

/** Details about agency billing for a business policy */
export type BusinessPolicyAgencyBilling = {
  __typename?: 'BusinessPolicyAgencyBilling';
  /** The type of agency billing used */
  type: BusinessPolicyAgencyBillingType;
};

/** The type of agency billing used for the policy */
export enum BusinessPolicyAgencyBillingType {
  /** Billing is handled through Ascend */
  Ascend = 'ASCEND',
  /** Billing is handled manually */
  Manual = 'MANUAL'
}

/** The billing type of policy, indicating how the policy is billed */
export enum BusinessPolicyBillingType {
  /** Policy is billed by the agency and then paid to the carrier */
  Agency = 'AGENCY',
  /** Policy is billed directly by the carrier */
  Direct = 'DIRECT',
  /** Billing type is unknown or not specified */
  Unknown = 'UNKNOWN'
}

/** A blanket additional insured for the policy */
export type BusinessPolicyBlanketAdditionalInsured = {
  __typename?: 'BusinessPolicyBlanketAdditionalInsured';
  /** The description of the blanket additional insured */
  description: Scalars['String']['output'];
  /** The form numbers that reference the blanket additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the blanket additional insured is included */
  reasoning: Scalars['String']['output'];
  /** The type of the blanket additional insured */
  type: Scalars['String']['output'];
};

/** Detailed information about a policy cancellation */
export type BusinessPolicyCancellation = {
  __typename?: 'BusinessPolicyCancellation';
  /** The date and time when the cancellation was initiated */
  canceledAt: Scalars['Time']['output'];
  /** The entity that initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** The date and time when the cancellation becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** The reason for the cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A detailed description of the cancellation reason */
  reasonDescription: Scalars['String']['output'];
  /** The commission that the agency will return to the carrier or broker */
  returnCommission: Scalars['Float']['output'];
  /** The premium that the agency will return to the customer */
  returnPremium: Scalars['Float']['output'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** The reason for policy cancellation */
export enum BusinessPolicyCancellationReason {
  /** Agency found better coverage for the insured */
  AgencyFoundBetterCoverage = 'AGENCY_FOUND_BETTER_COVERAGE',
  /** Agency found a better price for the insured */
  AgencyFoundBetterPrice = 'AGENCY_FOUND_BETTER_PRICE',
  /** Carrier closed the insurance class */
  CarrierClosedClass = 'CARRIER_CLOSED_CLASS',
  /** Cancellation due to loss history */
  CarrierLossHistory = 'CARRIER_LOSS_HISTORY',
  /** Carrier cancelled due to non-payment */
  CarrierNonpayment = 'CARRIER_NONPAYMENT',
  /** Carrier's underwriting decision */
  CarrierUnderwritingReason = 'CARRIER_UNDERWRITING_REASON',
  /** Insured closed their business */
  InsuredClosedBusiness = 'INSURED_CLOSED_BUSINESS',
  /** Insured found better coverage elsewhere */
  InsuredFoundBetterCoverage = 'INSURED_FOUND_BETTER_COVERAGE',
  /** Insured found a better price elsewhere */
  InsuredFoundBetterPrice = 'INSURED_FOUND_BETTER_PRICE',
  /** Insured failed to make payments */
  InsuredNonpayment = 'INSURED_NONPAYMENT',
  /** Insured no longer has exposure requiring coverage */
  InsuredNoExposure = 'INSURED_NO_EXPOSURE',
  /** Other unspecified reason */
  Other = 'OTHER'
}

/** The source of the policy cancellation */
export enum BusinessPolicyCancellationSource {
  /** Cancellation initiated by the agency */
  Agency = 'AGENCY',
  /** Cancellation initiated by the carrier */
  Carrier = 'CARRIER',
  /** Cancellation initiated by the insured */
  Insured = 'INSURED'
}

/** The type of policy cancellation */
export enum BusinessPolicyCancellationType {
  /** Standard cancellation of the policy */
  Cancellation = 'CANCELLATION',
  /** Non-renewal of the policy */
  Nonrenewal = 'NONRENEWAL',
  /** Expiration of the quote without conversion to a policy */
  QuoteExpired = 'QUOTE_EXPIRED'
}

/** Description of a policy coverage or exclusion */
export type BusinessPolicyCoverageOrExclusionDescription = {
  __typename?: 'BusinessPolicyCoverageOrExclusionDescription';
  /** The description of the coverage or exclusion */
  description: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  policyQuotes: Array<Scalars['String']['output']>;
  /** The title of the coverage or exclusion */
  title: Scalars['String']['output'];
};

/** An endorsement for the policy */
export type BusinessPolicyEndorsement = {
  __typename?: 'BusinessPolicyEndorsement';
  /** The form numbers that reference the endorsement */
  formNumbers: Array<Scalars['String']['output']>;
  /** Whether the endorsement is included */
  included: Scalars['Boolean']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the endorsement is included */
  reasoning: Scalars['String']['output'];
};

/** The endorsements for the policy */
export type BusinessPolicyEndorsements = {
  __typename?: 'BusinessPolicyEndorsements';
  /** Whether the primary and non-contributory coverage endorsement is included */
  primaryAndNonContributoryCoverage: BusinessPolicyEndorsement;
  /** Whether the waiver of subrogation endorsement is included */
  waiverOfSubrogation: BusinessPolicyEndorsement;
};

/** Entity involved in the policy */
export type BusinessPolicyEntity = {
  __typename?: 'BusinessPolicyEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Extra limits for the policy, not covered by the standard limits */
export type BusinessPolicyExtraInsuranceLimit = {
  __typename?: 'BusinessPolicyExtraInsuranceLimit';
  /** The limit for the extra coverage */
  limit: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Policy details extracted from the policy document */
export type BusinessPolicyExtractedDetails = {
  __typename?: 'BusinessPolicyExtractedDetails';
  /** The blanket additional insureds for the policy */
  blanketAdditionalInsureds: Array<BusinessPolicyBlanketAdditionalInsured>;
  /** The carrier on the policy */
  carrier?: Maybe<BusinessPolicyEntity>;
  /** The carrier's NAIC code */
  carrierNaic?: Maybe<Scalars['String']['output']>;
  /** The coverage descriptions for the policy */
  coverageDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** The deductible for the policy */
  deductible?: Maybe<Scalars['Float']['output']>;
  /** The endorsements for the policy */
  endorsements: BusinessPolicyEndorsements;
  /** The exclusion descriptions for the policy */
  exclusionDescriptions: Array<BusinessPolicyCoverageOrExclusionDescription>;
  /** Extra limits for the policy, not covered by the standard limits */
  extraLimits: Array<BusinessPolicyExtraInsuranceLimit>;
  /** The insured on the policy */
  insured?: Maybe<BusinessPolicyEntity>;
  /** The limits for the policy */
  limits: BusinessPolicyInsuranceLimits;
  /** The insured locations for the policy */
  locations: Array<BusinessPolicyLocation>;
  /** The named additional insureds for the policy */
  namedAdditionalInsureds: Array<BusinessPolicyNamedAdditionalInsured>;
  /** The policy number */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** A summary of the policy details */
  summary?: Maybe<Scalars['String']['output']>;
};

/** Limits for the policy. The policy has the coverage and associated limit if the value is non null or zero. */
export type BusinessPolicyInsuranceLimits = {
  __typename?: 'BusinessPolicyInsuranceLimits';
  cyberAggregateLimit?: Maybe<Scalars['Float']['output']>;
  cyberRetentionLimit?: Maybe<Scalars['Float']['output']>;
  glAggregateLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glMedicalPerPersonLimit?: Maybe<Scalars['Float']['output']>;
  glPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  glPersonalAndAdvertisingInjuryLimit?: Maybe<Scalars['Float']['output']>;
  glProductsAndCompletedOperationsLimit?: Maybe<Scalars['Float']['output']>;
  glRentedPremisesDamageLimit?: Maybe<Scalars['Float']['output']>;
  propertyBuildingLimit?: Maybe<Scalars['Float']['output']>;
  propertyContentsLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessAggregateLimit?: Maybe<Scalars['Float']['output']>;
  umbrellaOrExcessPerOccurrenceLimit?: Maybe<Scalars['Float']['output']>;
  wcPerAccidentLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseaseEmployeeLimit?: Maybe<Scalars['Float']['output']>;
  wcPerDiseasePolicyLimit?: Maybe<Scalars['Float']['output']>;
};

/** A location covered by the business policy */
export type BusinessPolicyLocation = {
  __typename?: 'BusinessPolicyLocation';
  /** The address of the location */
  address: Address;
  /** The limits for the location */
  limits: BusinessPolicyInsuranceLimits;
};

/** A named additional insured for the policy */
export type BusinessPolicyNamedAdditionalInsured = {
  __typename?: 'BusinessPolicyNamedAdditionalInsured';
  /** The address of the named additional insured */
  address: Address;
  /** The form numbers that reference the named additional insured */
  formNumbers: Array<Scalars['String']['output']>;
  /** The type of the named additional insured */
  name: Scalars['String']['output'];
  /** Supporting quotes from the policy document */
  quotes: Array<Scalars['String']['output']>;
  /** The reasoning for why the named additional insured is included */
  reasoning: Scalars['String']['output'];
};

/** Represents all pricing information for a policy */
export type BusinessPolicyPricing = {
  __typename?: 'BusinessPolicyPricing';
  /** The adjusted commission that the agency will receive for this policy, which is the estimated commission minus any returns to the carrier or broker. If the policy is not canceled, this will be nil. */
  adjustedCommission?: Maybe<Scalars['Float']['output']>;
  /** The adjusted premium that the agency will receive for this policy, which is the premium minus any returns to the customer. If the policy is not canceled, this will be nil. */
  adjustedPremium?: Maybe<Scalars['Float']['output']>;
  /** The adjusted revenue that the agency will receive for this policy, which is the estimated revenue minus any returns to the customer. If the policy is not canceled, this will be the same as estimatedRevenue */
  adjustedRevenue: Scalars['Float']['output'];
  /** If billing type is AGENCY, this specifies information about the agency bill */
  agencyBilling?: Maybe<BusinessPolicyAgencyBilling>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['output'];
  /** The billing type */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['output'];
  /** Estimate of the commission the agency will receive for this policy */
  estimatedCommission: Scalars['Float']['output'];
  /** Estimate of the revenue the agency will receive for this policy */
  estimatedRevenue: Scalars['Float']['output'];
  /** The interval type of payment plan. Required if this is a direct-billed policy */
  intervalType?: Maybe<PaymentIntervalType>;
  /** The minimum premium that must be paid for policy, regardless of cancellation, if any */
  minimumEarnedPremium: Scalars['Float']['output'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['output'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['output'];
  /** The premium for this policy */
  premium: Scalars['Float']['output'];
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['output'];
  /** The total price paid for this policy */
  total: Scalars['Float']['output'];
};

/** Information about a policy reinstatement */
export type BusinessPolicyReinstatement = {
  __typename?: 'BusinessPolicyReinstatement';
  /** The date and time when the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['output'];
  /** A description of the reason for reinstatement */
  reasonDescription: Scalars['String']['output'];
  /** The date and time when the reinstatement was processed */
  reinstatedAt: Scalars['Time']['output'];
};

/** Information about policy renewals */
export type BusinessPolicyRenewal = {
  __typename?: 'BusinessPolicyRenewal';
  /** List of policies that renew this policy */
  nextPolicies: Array<BusinessPolicy>;
  /** List of previous policies that this policy renews */
  previousPolicies: Array<BusinessPolicy>;
};

/** Describes the reason why an application was updated */
export enum BusinessPolicyUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum BusinessPolicyUpdateType {
  /** The policy was canceled and is no longer active */
  CancelPolicy = 'CANCEL_POLICY',
  /** The policy was created */
  CreatePolicy = 'CREATE_POLICY',
  /** The policy expired and its no longer active */
  ExpirePolicy = 'EXPIRE_POLICY',
  /** The policy was set to inforce */
  InforcePolicy = 'INFORCE_POLICY',
  /** The policy was reinstated after previously being canceled */
  ReinstatePolicy = 'REINSTATE_POLICY',
  /** The policy was created as a renewal */
  RenewPolicy = 'RENEW_POLICY',
  /** The policy was updated with new details extracted from the policy document */
  UpdateExtractedDetails = 'UPDATE_EXTRACTED_DETAILS',
  /** The policy was updated. Requires manual inspection of the policy to determine the actual update */
  UpdatePolicy = 'UPDATE_POLICY'
}

/** Describes a particular version of a policy */
export type BusinessPolicyVersion = {
  __typename?: 'BusinessPolicyVersion';
  /** The full policy object that includes all of the updates made in this version and all previous versions */
  businessPolicy: BusinessPolicy;
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another policy version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous policy version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<BusinessPolicyVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<BusinessPolicyUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<BusinessPolicyUpdateType>;
  /** The version number of this policy version */
  version: Scalars['Int64']['output'];
};

export enum CoiConfigurationMode {
  /**
   * Use the agency's information as the contact information and producer name.
   * This is the default mode.
   */
  Agency = 'AGENCY',
  /** Use the user's information as the contact information and producer name */
  User = 'USER'
}

/** Represents a phone call recorded through the Retell system */
export type Call = {
  __typename?: 'Call';
  /** The account associated with this call, if any */
  account?: Maybe<Account>;
  /** The agency associated with this call */
  agency: Agency;
  /** The timestamp when this call was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether this conversation was inbound or placed by an outbound call job.
   * Defaults to INBOUND for legacy rows.
   */
  direction: CallDirection;
  /** The reason the call was disconnected, available once the call has ended */
  disconnectionReason?: Maybe<CallDisconnectionReason>;
  /** The timestamp when the call ended, if completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the call in the external call system (currently this is always Retell) */
  externalId: Scalars['String']['output'];
  /**
   * The name of the other party on the call (caller for inbound, customer for outbound),
   * available once the call has ended
   */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was from (caller for inbound, agency line for outbound) */
  fromNumber: Scalars['String']['output'];
  /** Unique identifier for the call */
  id: Scalars['ID']['output'];
  /** The outbound call job linked to this conversation, if any. */
  outboundCall?: Maybe<OutboundCall>;
  /** The URL of the recording of the call, available once the call has ended */
  recordingUrl?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this call was marked as seen/reviewed */
  seenAt?: Maybe<Scalars['Time']['output']>;
  /** The user who marked this call as seen */
  seenByUser?: Maybe<AgencyUser>;
  /** The sentiment of the call, available once the call has ended */
  sentiment?: Maybe<CallSentiment>;
  /** The service requests associated with this call, if any */
  serviceRequests: Array<ServiceRequest>;
  /** The timestamp when the call started */
  startedAt: Scalars['Time']['output'];
  /** The status of the call */
  status: CallStatus;
  /** Whether the call was successful, available once the call has ended */
  successful?: Maybe<Scalars['Boolean']['output']>;
  /** A summary of the call, available once the call has ended */
  summary?: Maybe<Scalars['String']['output']>;
  /** The phone number the call was to (agency line for inbound, customer for outbound) */
  toNumber: Scalars['String']['output'];
  /** The transcript of the call, available once the call has ended */
  transcript: Array<CallTranscriptObject>;
  /**
   * The voice agent configuration that was active at the time this call was created.
   * Returns null only for calls that have no voice agent attached.
   */
  voiceAgentConfiguration?: Maybe<VoiceAgentConfiguration>;
};

/** A cursor-paginated connection of Call records. */
export type CallConnection = {
  __typename?: 'CallConnection';
  edges: Array<CallEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Call counts for a single day */
export type CallDailyCount = {
  __typename?: 'CallDailyCount';
  /** Number of calls that started outside business hours */
  afterHoursCalls: Scalars['Int']['output'];
  /** Number of calls that started during business hours */
  businessHoursCalls: Scalars['Int']['output'];
  /** The date (start of day in the agency's timezone) */
  date: Scalars['Time']['output'];
  /** Total number of calls on this date */
  totalCalls: Scalars['Int']['output'];
};

export enum CallDirection {
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

/** The reason why a call was disconnected */
export enum CallDisconnectionReason {
  /** Expected behavior where AI agent hangs up the call */
  AgentHangup = 'AGENT_HANGUP',
  /** Expected behavior where AI agent transferred the call */
  CallTransfer = 'CALL_TRANSFER',
  /** Error where concurrency limit reached - add a retry with exponential backoff or consider enterprise plan */
  ConcurrencyLimitReached = 'CONCURRENCY_LIMIT_REACHED',
  /** The number dialed is busy */
  DialBusy = 'DIAL_BUSY',
  /** Dialing failed, might be due to callee number being non-existent, or the agent number is marked as spam and got blocked */
  DialFailed = 'DIAL_FAILED',
  /** The number dialed did not answer */
  DialNoAnswer = 'DIAL_NO_ANSWER',
  /** Error where Retell's ASR encountered a problem */
  ErrorAsr = 'ERROR_ASR',
  /** Error where frontend audio websocket received unspecified payload */
  ErrorFrontendCorruptedPayload = 'ERROR_FRONTEND_CORRUPTED_PAYLOAD',
  /** Error where system failed to retrieve dynamic variables for inbound phone call */
  ErrorInboundWebhook = 'ERROR_INBOUND_WEBHOOK',
  /** Error where LLM websocket received unspecified payload */
  ErrorLlmWebsocketCorruptPayload = 'ERROR_LLM_WEBSOCKET_CORRUPT_PAYLOAD',
  /** Error where LLM websocket connection broke during the call */
  ErrorLlmWebsocketLostConnection = 'ERROR_LLM_WEBSOCKET_LOST_CONNECTION',
  /** Error where LLM websocket did not open between Retell server and backend, likely because the Custom LLM URL is incorrect or LLM server is not reachable */
  ErrorLlmWebsocketOpen = 'ERROR_LLM_WEBSOCKET_OPEN',
  /** Error where LLM websocket received a closing signal other than 1000 from your server */
  ErrorLlmWebsocketRuntime = 'ERROR_LLM_WEBSOCKET_RUNTIME',
  /** Error where system has not received audio from Twilio or web frontend for a while after connection has established */
  ErrorNoAudioReceived = 'ERROR_NO_AUDIO_RECEIVED',
  /** Error, unspecified Retell side problem */
  ErrorRetell = 'ERROR_RETELL',
  /** Error where Twilio websocket connection between Retell server encountered an error */
  ErrorTwilio = 'ERROR_TWILIO',
  /** Error, unknown error */
  ErrorUnknown = 'ERROR_UNKNOWN',
  /** Error where user did not join web call within 30s after calling startWebCall */
  ErrorUserNotJoined = 'ERROR_USER_NOT_JOINED',
  /** Expected behavior where call was terminated due to the "end_call_after_silence_ms" setting reached after long inactivity */
  Inactivity = 'INACTIVITY',
  /** Expected behavior where call was terminated due to the "drop_call_if_machine_detected" setting triggering when a voicemail or similar is detected */
  MachineDetected = 'MACHINE_DETECTED',
  /** Expected behavior where call was terminated due to maximum duration reached */
  MaxDurationReached = 'MAX_DURATION_REACHED',
  /** Error where no valid payment registered on file, or service shut down due to bill overdue */
  NoValidPayment = 'NO_VALID_PAYMENT',
  /** Error where phone call is 30s or more apart from registering */
  RegisteredCallTimeout = 'REGISTERED_CALL_TIMEOUT',
  /** Error where scam was detected for that particular agent */
  ScamDetected = 'SCAM_DETECTED',
  /** Expected behavior where user hangs up the call */
  UserHangup = 'USER_HANGUP',
  /** Expected behavior where AI agent reached voicemail when voicemail settings were configured */
  VoicemailReached = 'VOICEMAIL_REACHED'
}

/** Count of calls for a given disconnection reason */
export type CallDisconnectionReasonCount = {
  __typename?: 'CallDisconnectionReasonCount';
  /** Number of calls with this disconnection reason */
  count: Scalars['Int']['output'];
  /** The disconnection reason */
  reason: CallDisconnectionReason;
};

/** An edge in a paginated Call connection. */
export type CallEdge = {
  __typename?: 'CallEdge';
  cursor: Scalars['String']['output'];
  node: Call;
};

/** Call feedback details */
export type CallFeedback = {
  __typename?: 'CallFeedback';
  /** Predefined reasons for negative feedback (multiple selection allowed) */
  reasons?: Maybe<Array<CallQualityFeedbackNegativeReason>>;
};

export type CallFilterInput = {
  /** The agency ID to filter by */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by whether the call is archived (default is false) */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by call direction. Omit to return calls of any direction. */
  direction?: InputMaybe<CallDirection>;
  /** Filter by disconnection reason */
  disconnectionReason?: InputMaybe<CallDisconnectionReason>;
  /** Filter by when the call ended */
  duration?: InputMaybe<NumericFilter>;
  /** Filter by caller phone number (partial match) */
  fromNumber?: InputMaybe<Scalars['String']['input']>;
  /** The sentiment of the call */
  sentiment?: InputMaybe<CallSentiment>;
  /** Filter by when the call started */
  startedAt?: InputMaybe<DateFilter>;
  /** The status of the call */
  status?: InputMaybe<CallStatus>;
  /** Filter by whether the call was successful */
  successful?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by the phone number the call was transferred to (partial match, searches transcript) */
  transferredToNumber?: InputMaybe<Scalars['String']['input']>;
  /** The voice agent ID to filter by */
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/** Summary of caller-initiated hangups */
export type CallHangupCounts = {
  __typename?: 'CallHangupCounts';
  /** Total number of calls where the caller hung up */
  total: Scalars['Int']['output'];
  /** Number of calls where the caller hung up within 20 seconds */
  underTwentySeconds: Scalars['Int']['output'];
};

/**
 * Predefined reasons for negative call feedback
 * Simple, user-friendly language
 */
export enum CallQualityFeedbackNegativeReason {
  /** Cara repeated herself too frequently */
  CaraRepeatedTooMuch = 'CARA_REPEATED_TOO_MUCH',
  /** Cara didn't understand what I was saying */
  Misunderstanding = 'MISUNDERSTANDING',
  /** Other issue (specify in comment) */
  Other = 'OTHER',
  /** Poor audio quality, hard to hear */
  PoorAudioQuality = 'POOR_AUDIO_QUALITY',
  /** Time to resolution was too long */
  ResolutionTooLong = 'RESOLUTION_TOO_LONG',
  /** slow responses */
  SlowResponses = 'SLOW_RESPONSES',
  /** Cara didn't ask the right questions */
  WrongWorkflow = 'WRONG_WORKFLOW'
}

/** Aggregated call report data */
export type CallReport = {
  __typename?: 'CallReport';
  /** Average duration of completed calls in seconds */
  averageDurationSeconds: Scalars['Float']['output'];
  /** Call counts grouped by date, with business hours breakdown */
  dailyCounts: Array<CallDailyCount>;
  /** Call counts grouped by disconnection reason */
  disconnectionReasonCounts: Array<CallDisconnectionReasonCount>;
  /** Number of calls that lasted more than 60 seconds */
  fullCallCount: Scalars['Int']['output'];
  /** Summary of caller-initiated hangups */
  hangupCounts: CallHangupCounts;
  /** Number of calls that lasted between 20 and 60 seconds */
  midCallCount: Scalars['Int']['output'];
  /** Number of calls with positive sentiment */
  positiveCalls: Scalars['Int']['output'];
  /** Counts of service requests by type across the filtered calls */
  serviceRequestTypeCounts: Array<CallServiceRequestTypeCount>;
  /** Number of calls that lasted less than 20 seconds */
  shortCallCount: Scalars['Int']['output'];
  /** Number of calls marked as successful */
  successfulCalls: Scalars['Int']['output'];
  /** Total number of calls in the report */
  totalCalls: Scalars['Int']['output'];
};

/** The sentiment analysis result for a call */
export enum CallSentiment {
  /** The call had an overall negative tone/sentiment */
  Negative = 'NEGATIVE',
  /** The call had a neutral or mixed tone/sentiment */
  Neutral = 'NEUTRAL',
  /** The call had an overall positive tone/sentiment */
  Positive = 'POSITIVE'
}

/** Count of service requests for a given type */
export type CallServiceRequestTypeCount = {
  __typename?: 'CallServiceRequestTypeCount';
  /** Number of service requests of this type */
  count: Scalars['Int']['output'];
  /** The service request type */
  type: ServiceRequestType;
};

/** Sortable fields for searchCalls */
export enum CallSortField {
  Customer = 'CUSTOMER',
  DisconnectionReason = 'DISCONNECTION_REASON',
  Duration = 'DURATION',
  FromNumber = 'FROM_NUMBER',
  Sentiment = 'SENTIMENT',
  StartedAt = 'STARTED_AT',
  Status = 'STATUS'
}

/** Sort specification for searchCalls */
export type CallSortInput = {
  direction: SortDirection;
  field: CallSortField;
};

/** The current status of a call */
export enum CallStatus {
  /** The call has ended */
  Completed = 'COMPLETED',
  /** The call has ended with an error */
  Error = 'ERROR',
  /** The call is in progress */
  InProgress = 'IN_PROGRESS',
  /** The call has been registered with Retell */
  Registered = 'REGISTERED'
}

/** Represents a single utterance or action in the call transcript */
export type CallTranscriptObject = {
  __typename?: 'CallTranscriptObject';
  /** The content of the utterance or tool result */
  content: Scalars['String']['output'];
  /** The duration in seconds of the utterance or tool result */
  durationSeconds: Scalars['Float']['output'];
  /** The role of the participant or action in the transcript */
  role: CallTranscriptRole;
  /** The offset in seconds from the start of the call when the utterance or tool result was spoken or executed */
  startTimeOffsetSeconds: Scalars['Float']['output'];
  /** The arguments passed to the tool in JSON format if this is a tool invocation */
  toolArgumentsJson?: Maybe<Scalars['String']['output']>;
  /** The ID of the tool call if this is a tool invocation or result */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** The name of the tool being called if this is a tool invocation */
  toolName?: Maybe<Scalars['String']['output']>;
};

/** The role of a participant or action in the call transcript */
export enum CallTranscriptRole {
  /** Represents speech from the AI agent */
  Agent = 'AGENT',
  /** Represents a tool being called by the agent */
  ToolInvocation = 'TOOL_INVOCATION',
  /** Represents the result returned from a tool call */
  ToolResult = 'TOOL_RESULT',
  /** Represents speech from the human user */
  User = 'USER'
}

/** Input for canceling a business policy */
export type CancelBusinessPolicyInput = {
  /** Who initiated the cancellation */
  canceledBy: BusinessPolicyCancellationSource;
  /** When the cancellation becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** The reason for cancellation */
  reason: BusinessPolicyCancellationReason;
  /** A description of the cancellation reason */
  reasonDescription: Scalars['String']['input'];
  /** The commission amount to be returned */
  returnCommission: Scalars['Float']['input'];
  /** The premium amount to be returned */
  returnPremium: Scalars['Float']['input'];
  /** The type of cancellation */
  type: BusinessPolicyCancellationType;
};

/** Details for a request to cancel a policy */
export type CancelPolicyRequest = {
  __typename?: 'CancelPolicyRequest';
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['output'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['output'];
};

/** Input type for canceling a policy request */
export type CancelPolicyRequestInput = {
  /** ID of the policy to be cancelled */
  policyId: Scalars['String']['input'];
  /** Reason for cancelling the policy */
  reason: Scalars['String']['input'];
};

/** Input for cancelling a workflow execution */
export type CancelWorkflowExecutionInput = {
  /** The ID of the execution to cancel */
  id: Scalars['ID']['input'];
  /** The version of the execution to cancel */
  version: Scalars['Int64']['input'];
};

/**
 * One materialized section instance of a sectioned DOCX artifact produced by the
 * DOCX_EDITOR tool's CREATE_FROM_TEMPLATE flow. A sectioned document is assembled by
 * generating each section as its own standalone DOCX file and then combining those files,
 * in order, into the final document. The same repeatable template section can appear as
 * multiple instances, each with its own distinct id.
 */
export type CaraDocxSection = {
  __typename?: 'CaraDocxSection';
  /**
   * A short synopsis of what was filled into this section, generated when the section was
   * created or last edited. Null when no synopsis was recorded.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The file generated for this section */
  file: File;
  /**
   * The unique ID of this section instance within the artifact. This is the id passed to
   * EDIT_SECTION / DELETE_SECTION (and ADD_SECTION's afterSectionId) to target the section.
   */
  id: Scalars['ID']['output'];
  /** The Python code that generated this section's standalone DOCX file */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** The ID of the WordDocumentTemplate section this instance was generated from. */
  templateSectionId: Scalars['String']['output'];
  /** The human-readable title of the section. */
  title: Scalars['String']['output'];
};

/** A workspace for Cara to execute tasks and produce artifacts */
export type CaraWorkspace = {
  __typename?: 'CaraWorkspace';
  /** The agency this workspace is associated with */
  agency?: Maybe<Agency>;
  /** The agency user the created this workspace */
  agencyUser?: Maybe<AgencyUser>;
  /** The timestamp when this workspace was archived */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The artifacts produced in this workspace */
  artifacts: Array<CaraWorkspaceArtifact>;
  /**
   * The clients this workspace is filed under, oldest link first.
   *
   * Plural because client_workspace is: it carries no unique constraint on
   * workspace_id. Policy currently permits at most one, enforced by
   * linkClientWorkspace rather than by the schema, so this holds zero or one today
   * and relaxing that rule needs no change here.
   *
   * suggestedClientsForWorkspace returns nothing once this is non-empty, so read it
   * first when choosing between showing an association and offering to make one.
   */
  clients: Array<Client>;
  /** The timestamp when this workspace was created */
  createdAt: Scalars['Time']['output'];
  /** The custom preset used for this workspace, if any */
  customPreset?: Maybe<CustomPreset>;
  /**
   * The clients each of this workspace's documents is on: the workspace's clients
   * unless someone removed it, plus any it was attached to. Documents on no client
   * are left out. Unbatched, so meant for one workspace at a time, not a list.
   */
  documentClients: Array<WorkspaceDocumentClients>;
  /**
   * How much effort this workspace runs at. Null means the preset's default, which
   * is MEDIUM for every preset today. AUTO means the server has not chosen yet,
   * which it does before the first model call.
   */
  effortLevel?: Maybe<CaraWorkspaceEffortLevel>;
  /**
   * The message whose turn moved a LOW workspace to LOW_MEDIUM, which is where
   * clients show the change. Null for every other level.
   */
  effortRaisedMessageId?: Maybe<Scalars['String']['output']>;
  /**
   * Why the server raised this workspace's effort above what was requested, recorded
   * for support. Clients tell the user only that the level changed, not why. Null
   * when the workspace is running at the level it was created with, which is the
   * common case.
   */
  effortRaisedReason?: Maybe<Scalars['String']['output']>;
  /** The files associated with this workspace */
  files: Array<File>;
  /** The unique identifier for this workspace */
  id: Scalars['ID']['output'];
  /** The integration that initiated this workspace, if any */
  integration?: Maybe<Integration>;
  /** The messages exchanged in this workspace */
  messages: Array<CaraWorkspaceMessage>;
  /**
   * The metadata for this workspace, usable for searching and filtering. These are usually
   * automatically generated by AI, but can be overridden by the agent.
   */
  metadata: CaraWorkspaceMetadata;
  /** The plan stages in this workspace */
  planStages: Array<CaraWorkspacePlanStage>;
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: Maybe<CaraWorkspacePreset>;
  /** The schema version of the Cara workspace */
  schemaVersion: CaraWorkspaceSchemaVersion;
  /** The service request this workspace is handling, if any */
  serviceRequest?: Maybe<ServiceRequest>;
  /** The current state of this workspace */
  state: CaraWorkspaceState;
  /** A brief title describing this workspace, initially set by AI but can be overridden by the agent */
  title: Scalars['String']['output'];
  /** The trigger run that created this workspace, if any. Present means Triggered. */
  triggerRun?: Maybe<TriggerRun>;
  /** The timestamp when this workspace was last modified */
  updatedAt: Scalars['Time']['output'];
  /**
   * The visibility configuration for this workspace (PRIVATE / SHARED / PUBLIC).
   * Stored on cara_workspace visibility columns for fast list/search filtering.
   * Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
  /**
   * Total active execution time across plan stages in milliseconds: sum of (endedAt - start)
   * for each stage, where start is startedAt when set, otherwise createdAt. Omits idle
   * calendar time between stages (e.g. when a customer revisits the workspace days later).
   * Null when no stage has an endedAt after its start reference.
   */
  workDurationMs?: Maybe<Scalars['Int']['output']>;
};

/** A pinned AMS record persisted on a workspace message. */
export type CaraWorkspaceAmsContextEntry = {
  __typename?: 'CaraWorkspaceAmsContextEntry';
  /** Human-readable label from the knowledge graph (policy number, account name, etc.). */
  displayName: Scalars['String']['output'];
  entityId: Scalars['ID']['output'];
  entityType: KnowledgeGraphEntityType;
  integrationId: Scalars['ID']['output'];
  role?: Maybe<Scalars['String']['output']>;
  scope?: Maybe<Scalars['String']['output']>;
};

/** A pinned AMS knowledge-graph record submitted with a workspace message. */
export type CaraWorkspaceAmsContextInput = {
  /** The knowledge graph entity ID for the pinned record. */
  entityId: Scalars['ID']['input'];
  /** The entity type the client selected. Must match the knowledge graph row. */
  entityType: KnowledgeGraphEntityType;
  /** The integration that owns the entity. */
  integrationId: Scalars['ID']['input'];
  /**
   * Prompt-read lane role, e.g. "[Option 1] ", matching the file-name prefix that
   * uploads in the same lane receive. Lets a multi-lane task tell which lane an
   * AMS record was pinned in.
   */
  role?: InputMaybe<Scalars['String']['input']>;
  /** Optional sub-scope within the entity (reserved for future picker granularity). */
  scope?: InputMaybe<Scalars['String']['input']>;
};

/** An AMS record pinned from the AMS browser, persisted on a workspace message. */
export type CaraWorkspaceAmsRefEntry = {
  __typename?: 'CaraWorkspaceAmsRefEntry';
  displayName: Scalars['String']['output'];
  ref: AmsRef;
  role?: Maybe<Scalars['String']['output']>;
};

/** An AMS record pinned from the AMS browser and submitted with a workspace message. */
export type CaraWorkspaceAmsRefInput = {
  /**
   * The record's label as the browser showed it (account name, policy number, file
   * title), kept so the pin renders without a lookup.
   */
  displayName: Scalars['String']['input'];
  ref: AmsRefInput;
  /** Prompt-read lane role, as on CaraWorkspaceAmsContextInput. */
  role?: InputMaybe<Scalars['String']['input']>;
};

/** An artifact produced during execution of a Cara workspace */
export type CaraWorkspaceArtifact = {
  __typename?: 'CaraWorkspaceArtifact';
  /** The application file details if this is an application file artifact (e.g., XLSX, DOCX) */
  applicationFile?: Maybe<CaraWorkspaceArtifactApplicationFile>;
  /** The timestamp when the artifact was created */
  createdAt: Scalars['Time']['output'];
  /** The custom form fill details if this is a custom form artifact */
  customForm?: Maybe<CaraWorkspaceArtifactCustomForm>;
  /**
   * How this HTML document version fits its Design's pages. Null for other artifacts, final
   * versions, Style-linked documents, documents with no Design, and agencies without Designs.
   */
  designFitState?: Maybe<DocumentDesignFitState>;
  /** The document details if this is a document artifact */
  document?: Maybe<CaraWorkspaceArtifactDocument>;
  /** Whether this artifact has been edited by the user since it was generated */
  editedAt?: Maybe<Scalars['Time']['output']>;
  /** The email details if this is an email artifact */
  email?: Maybe<CaraWorkspaceArtifactEmail>;
  /** The ID of the artifact */
  id: Scalars['String']['output'];
  /** The PDF file details if this is a PDF file artifact */
  pdf?: Maybe<CaraWorkspaceArtifactPdfFile>;
  /**
   * Whether this HTML document version prints its template's Legacy look when it has no Design: its
   * template is Legacy, or the document printed that look before its template left Legacy. Setting
   * no Design decides the same way. False for other artifacts and agencies without Designs.
   */
  printsLegacyLook: Scalars['Boolean']['output'];
  /**
   * How many times Cara has revised this version without being asked again.
   *
   * A version is the request; a revision is the work to satisfy it. Cara rendering a
   * document, finding it wrong and fixing it is the same version arrived at properly,
   * not a new one the reader asked for - so those show as 1.1, 1.2 while the next
   * request is 2. Zero for a version nothing has revised.
   */
  revision: Scalars['Int']['output'];
  /** The ID of the stage that created this artifact */
  stageId: Scalars['String']['output'];
  /** The template form details if this is a template form artifact */
  templateForm?: Maybe<CaraWorkspaceArtifactTemplateForm>;
  /** The type of artifact (document, PDF file, or template form) */
  type: CaraWorkspaceArtifactType;
  /**
   * The version of the artifact, monotonically increasing.
   *
   * A version is what somebody asked for: it moves when a new request produces a new
   * artifact, and not otherwise.
   */
  version: Scalars['Int']['output'];
  /**
   * The visibility configuration for this artifact (PRIVATE / SHARED / PUBLIC).
   * Snapshotted from the parent workspace at creation; can be later narrowed or
   * widened independently via updateCaraWorkspaceArtifact. Effective read access
   * is the intersection: an artifact is never more visible than its workspace.
   */
  visibility: VisibilityConfig;
};

export type CaraWorkspaceArtifactApplicationFile = {
  __typename?: 'CaraWorkspaceArtifactApplicationFile';
  /**
   * The Excel spreadsheet template that was used to generate this XLSX artifact, resolved
   * from the stored (templateId, templateVersion) tuple and pinned to the exact template
   * version captured at generation time. Null when this artifact was not produced from an
   * Excel spreadsheet template. As with wordDocumentTemplate, this returns the historical
   * snapshot rather than the current latest version of the library template.
   */
  excelSpreadsheetTemplate?: Maybe<ExcelSpreadsheetTemplate>;
  /** The Python code that generates this application file */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /**
   * The ordered section instances that make up a sectioned DOCX artifact produced by
   * DOCX_EDITOR CREATE_FROM_TEMPLATE. Each instance records the template section it came
   * from so the section can be regenerated, reordered, added, or deleted and the document
   * re-combined. Empty for non-sectioned DOCX artifacts (CREATE, EDIT_UPLOADED) and all
   * XLSX artifacts.
   */
  sections?: Maybe<Array<CaraDocxSection>>;
  /** The user-uploaded file that served as a starting point for this artifact, if any */
  sourceFile?: Maybe<File>;
  /**
   * The worksheets that XLSX_EDITOR filled in this workbook, in the order they were filled.
   * Each entry records the template tab it came from so the tab can be re-edited later.
   * Empty for XLSX artifacts that were not produced from a template and all DOCX artifacts.
   */
  tabs?: Maybe<Array<CaraXlsxTab>>;
  /** The title of the application file */
  title: Scalars['String']['output'];
  /** The type of application file (e.g., "XLSX", "DOCX"). */
  type: Scalars['String']['output'];
  /**
   * The Word document template that was used to generate this DOCX artifact, resolved
   * from the stored (templateId, templateVersion) tuple and pinned to the exact template
   * version captured at generation time. Null when this artifact was not produced from a
   * Word document template (e.g. CREATE from scratch, EDIT_UPLOADED from a user-uploaded
   * DOCX, any XLSX, or any artifact predating template provenance tracking). The library
   * template may have been updated or archived since this artifact was generated; this
   * resolver returns the historical snapshot rather than the current latest version.
   */
  wordDocumentTemplate?: Maybe<WordDocumentTemplate>;
};

/** Input for updating a Cara workspace artifact application file */
export type CaraWorkspaceArtifactApplicationFileInput = {
  /** The title of the application file */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A reader's comment on a run of text in a document, or on an area of a rendered page. A text
 * comment's place is an anchor into the text rather than a position, so it survives Cara
 * rewriting the document around it. An area comment on a logo, a chart or blank space keeps its
 * box instead, with the page size it was drawn on.
 */
export type CaraWorkspaceArtifactComment = {
  __typename?: 'CaraWorkspaceArtifactComment';
  /**
   * The text the comment points at. An area comment drawn over no words the document has
   * carries an empty anchor and is located by its region alone.
   */
  anchor: CaraWorkspaceArtifactCommentAnchor;
  artifactId: Scalars['String']['output'];
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /** Where the anchor lands in the document as it reads now. Derived on read, never stored. */
  placement?: Maybe<CaraWorkspaceArtifactCommentPlacement>;
  /**
   * The box this comment was drawn as on the rendered pages, when it was. A comment made by
   * selecting text has none.
   */
  region?: Maybe<CaraWorkspaceArtifactCommentRegion>;
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  /** Who closed it. UNKNOWN when the stored value is one this server does not recognize. */
  resolvedBy?: Maybe<CaraWorkspaceArtifactCommentResolvedBy>;
  workspaceId: Scalars['String']['output'];
};

/**
 * The selection as it was made: the quoted text, the text either side of it, and which of the
 * quote's appearances it was.
 */
export type CaraWorkspaceArtifactCommentAnchor = {
  __typename?: 'CaraWorkspaceArtifactCommentAnchor';
  contentHash: Scalars['String']['output'];
  occurrence: Scalars['Int']['output'];
  occurrenceCount: Scalars['Int']['output'];
  prefix: Scalars['String']['output'];
  quote: Scalars['String']['output'];
  suffix: Scalars['String']['output'];
};

export type CaraWorkspaceArtifactCommentInput = {
  body: Scalars['String']['input'];
  prefix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The selected text, and up to a few words either side of it, as the editor shows them. Left
   * out when the comment was drawn as a box on the rendered pages instead.
   */
  quote?: InputMaybe<Scalars['String']['input']>;
  /**
   * A box drawn on the rendered pages. The server reads the words inside it and anchors the
   * comment to them when the document has those words; otherwise the comment is kept as an
   * area located by the box.
   */
  region?: InputMaybe<CaraWorkspaceArtifactCommentRegionInput>;
  suffix?: InputMaybe<Scalars['String']['input']>;
  /**
   * The version of the document the reader was looking at. The selection or box is read and
   * placed against that version; left out, the latest is used.
   */
  version?: InputMaybe<Scalars['Int']['input']>;
};

export type CaraWorkspaceArtifactCommentPlacement = {
  __typename?: 'CaraWorkspaceArtifactCommentPlacement';
  /** The text at the placement as it reads now. The quote on every exact tier. */
  matchedText: Scalars['String']['output'];
  /** Zero-based appearance of matchedText in the current document; absent for an orphan. */
  occurrence?: Maybe<Scalars['Int']['output']>;
  tier: CaraWorkspaceArtifactCommentTier;
};

/**
 * The box a comment was drawn as, as fractions of the rendered page from its top-left corner,
 * with the size of that page so the box can be given in pixels or points at any zoom.
 */
export type CaraWorkspaceArtifactCommentRegion = {
  __typename?: 'CaraWorkspaceArtifactCommentRegion';
  height: Scalars['Float']['output'];
  left: Scalars['Float']['output'];
  /**
   * True when the box held no words, so nearby printed text was tried instead. The anchor's
   * quote says whether that text could be located in the document.
   */
  nearby: Scalars['Boolean']['output'];
  page: Scalars['Int']['output'];
  /**
   * What that page printed, its start and end, bounded to a few hundred characters. It locates
   * the box in the markup when the coordinates no longer can: the renderer decides where pages
   * break, so nothing in the document names the page a box was drawn on. Absent when the page
   * printed no text at all.
   */
  pageContext?: Maybe<Scalars['String']['output']>;
  pageHeightPt: Scalars['Float']['output'];
  /**
   * The rendered page's size in PDF points (1/72 inch), read from the render the box was drawn
   * on.
   */
  pageWidthPt: Scalars['Float']['output'];
  revision: Scalars['Int']['output'];
  /** The style the pages were rendered with, when it was not the document's own. */
  styleId?: Maybe<Scalars['String']['output']>;
  top: Scalars['Float']['output'];
  /**
   * The document version and revision the pages were rendered from, which say what the box was
   * drawn over rather than where that content is now: the same version can be revised in place,
   * so both must match the document as it stands for the box to still describe it.
   */
  version: Scalars['Int']['output'];
  width: Scalars['Float']['output'];
};

/**
 * A rectangle on one rendered page, as fractions of the page's width and height from its
 * top-left corner.
 */
export type CaraWorkspaceArtifactCommentRegionInput = {
  height: Scalars['Float']['input'];
  left: Scalars['Float']['input'];
  page: Scalars['Int']['input'];
  /** The revision shown when the region was selected. Stale regions must be selected again. */
  revision?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The style the pages were rendered with, when it was not the document's own, so the server
   * renders the same pages before reading the box.
   */
  styleId?: InputMaybe<Scalars['String']['input']>;
  top: Scalars['Float']['input'];
  width: Scalars['Float']['input'];
};

export enum CaraWorkspaceArtifactCommentResolvedBy {
  /** The comment was handed to Cara in a message. */
  Cara = 'CARA',
  Unknown = 'UNKNOWN',
  User = 'USER'
}

export enum CaraWorkspaceArtifactCommentTier {
  /** The text is unchanged since the comment was made. */
  Hash = 'HASH',
  /** The quoted text was edited; the placement is the closest match. */
  Nearest = 'NEAREST',
  /** The quoted text is gone. The comment attaches to nothing rather than to a guess. */
  Orphan = 'ORPHAN',
  StablePopulation = 'STABLE_POPULATION',
  UniqueInContext = 'UNIQUE_IN_CONTEXT',
  UniqueQuote = 'UNIQUE_QUOTE'
}

/**
 * A page of artifact summaries, newest-composed first. `totalCount` counts
 * artifacts rather than versions, as the edges do.
 */
export type CaraWorkspaceArtifactConnection = {
  __typename?: 'CaraWorkspaceArtifactConnection';
  edges: Array<CaraWorkspaceArtifactEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/**
 * A custom PDF form fill artifact produced by Cara.
 * Stores fill data for a specific custom form template; the filled PDF is rendered on demand.
 */
export type CaraWorkspaceArtifactCustomForm = {
  __typename?: 'CaraWorkspaceArtifactCustomForm';
  /** The custom form template used to produce this fill artifact. */
  customForm: CustomForm;
  /** The human-readable title of this filled form artifact. */
  title: Scalars['String']['output'];
};

/** A document artifact generated by Cara */
export type CaraWorkspaceArtifactDocument = {
  __typename?: 'CaraWorkspaceArtifactDocument';
  /**
   * Whether the agency brand styles this document. Set when the document is created while
   * agency_brand_design_enabled is on for its agency and the agency has a default design, so
   * documents from before then keep their own look.
   */
  brandApplied?: Maybe<Scalars['Boolean']['output']>;
  /** The content of the document */
  content: Scalars['String']['output'];
  /**
   * The design this version names. A version that names none and carries the brand prints with
   * the design made from the agency's saved brand, never the current default. resolvedDesign is
   * the design a version prints with.
   */
  designId?: Maybe<Scalars['String']['output']>;
  /**
   * Set when someone marked this version final. The version then renders with the brand frozen
   * here, whatever later happens to its design.
   */
  final?: Maybe<CaraWorkspaceArtifactFinal>;
  /** The ID of the HTML document template used to create this document, if any */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /**
   * The pages this version declares and the sheets it printed when Cara's review ran out of rounds
   * without making them agree. Null when the version fits, was not measured, or was edited by hand
   * since.
   */
  pageCheck?: Maybe<CaraWorkspaceArtifactPageCheck>;
  /**
   * The design this version prints with, found the way the renderer finds it: the one frozen on a
   * final version, else the design the version names, else, for a version that carries the brand,
   * the design made from the agency's saved brand. Null when none applies and while
   * agency_brand_design_enabled is off. Named even when the design is archived or hidden from the
   * caller, because the version still prints with it.
   */
  resolvedDesign?: Maybe<CaraWorkspaceArtifactResolvedDesign>;
  /**
   * The ID of the source this document was converted from:
   * - For CONVERT_HTML_TO_TEMPLATE: the source HTML artifact ID
   * When regenerating, use the same conversion operation with this ID.
   */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Input for updating a Cara workspace artifact document */
export type CaraWorkspaceArtifactDocumentInput = {
  /** The content of the document */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type CaraWorkspaceArtifactEdge = {
  __typename?: 'CaraWorkspaceArtifactEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspaceArtifactSummary;
};

/**
 * An email composed in the workspace. Two exits: written into the agent's
 * connected mailbox as a native draft (the mailbox copy then becomes the live
 * draft and this artifact its provenance), or sent directly behind the user's
 * explicit send click. Attachments are held by reference so a send always
 * picks up the latest version of the attached artifact.
 */
export type CaraWorkspaceArtifactEmail = {
  __typename?: 'CaraWorkspaceArtifactEmail';
  /**
   * Where this email is logged in the AMS when it sends. Null when nobody has chosen, so
   * Cara matches the To recipients at send. Not part of contentRevision.
   */
  amsLog?: Maybe<CaraWorkspaceEmailAmsLog>;
  /**
   * Workspace artifacts attached by reference (attach resolves the latest
   * version at send time)
   */
  attachmentArtifactIds: Array<Scalars['String']['output']>;
  /** Uploaded workspace files attached by reference */
  attachmentFileIds: Array<Scalars['String']['output']>;
  /**
   * The files behind attachmentFileIds, so the composer can name an attachment
   * that is not in the workspace's own file list -- a chart Cara generated and
   * attached, which CaraWorkspace.files leaves out so that only the outputs Cara
   * chose to attach reach an email. An ID whose file has since been deleted has
   * no entry here.
   */
  attachmentFiles: Array<File>;
  /** The BCC recipients */
  bcc: Array<CaraWorkspaceEmailRecipient>;
  /** The canonical body as a conservative, Outlook-safe HTML subset */
  bodyHtml: Scalars['String']['output'];
  /** The CC recipients */
  cc: Array<CaraWorkspaceEmailRecipient>;
  /**
   * An opaque fingerprint of the composition above, and the token a reviewer
   * carries back to sendMailboxEmail. A save rewrites a version in place, so the
   * version number alone cannot tell anyone that the words moved under them; two
   * compositions that read identically share a revision, so a save that changes
   * nothing leaves a review standing.
   */
  contentRevision: Scalars['String']['output'];
  /** The connected mailbox this email is composed to send from */
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  /** The signature appended to the body, by reference */
  signatureId?: Maybe<Scalars['String']['output']>;
  /** The message this email replies to or forwards; null for a fresh email */
  source?: Maybe<CaraWorkspaceEmailSource>;
  /** The subject line of the email */
  subject: Scalars['String']['output'];
  /** The template this email was drafted from. Null for an email written without one. */
  template?: Maybe<CaraWorkspaceEmailTemplateUse>;
  /** The primary recipients */
  to: Array<CaraWorkspaceEmailRecipient>;
};

/**
 * Input for updating a Cara workspace email artifact. Omitted fields are left
 * unchanged; a present empty recipient or attachment list clears it, and the
 * omittable fields below distinguish an explicit null (clear it) from absence.
 */
export type CaraWorkspaceArtifactEmailInput = {
  /**
   * Where the email is logged in the AMS when it sends, chosen by the caller for the To
   * recipients as they stand after this save. Null clears the choice, so Cara matches the
   * recipients at send.
   */
  amsLog?: InputMaybe<CaraWorkspaceEmailAmsLogInput>;
  /** Workspace artifacts attached by reference */
  attachmentArtifactIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Uploaded workspace files attached by reference */
  attachmentFileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The BCC recipients */
  bcc?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
  /** The body as a conservative, Outlook-safe HTML subset */
  bodyHtml?: InputMaybe<Scalars['String']['input']>;
  /** The CC recipients */
  cc?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
  /**
   * The contentRevision the writer last read. Supplied, the save is refused when
   * the stored composition has moved since — a second tab or a colleague editing
   * the same draft would otherwise be overwritten without either of them seeing
   * it. Omitted, the save is unconditional.
   */
  expectedContentRevision?: InputMaybe<Scalars['String']['input']>;
  /** The connected mailbox this email is composed to send from. Null unpicks it. */
  mailboxAccountId?: InputMaybe<Scalars['String']['input']>;
  /** The signature appended to the body, by reference. Null removes it. */
  signatureId?: InputMaybe<Scalars['String']['input']>;
  /** The message this email replies to or forwards. Null detaches the reply. */
  source?: InputMaybe<CaraWorkspaceEmailSourceInput>;
  /** The subject line of the email */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** The primary recipients */
  to?: InputMaybe<Array<CaraWorkspaceEmailRecipientInput>>;
};

/**
 * Narrows caraWorkspaceArtifacts for callers that pick a single artifact out of the
 * agency's library, such as an attachment picker, rather than rendering all of it.
 */
export type CaraWorkspaceArtifactFilter = {
  /**
   * When true, returns only archived artifacts (`archivedAt` set); when false or
   * omitted, only active ones. A filter that names `ids` and omits this sees both
   * states, so an email's stored attachment ids still resolve after one is archived.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Resolves specific artifacts by ID, for a caller holding IDs it stored earlier —
   * an email's attachments, say — and needing their titles back. The artifacts may
   * live in any workspace the caller can read, so this is not scoped to one workspace.
   *
   * An explicit id list defines the result set and `limit` does not truncate it: every
   * named id the caller can see comes back, whatever the limit says. At most 200 ids may
   * be named at once, and a longer list is refused rather than trimmed.
   *
   * Visibility is unchanged by naming an ID: an artifact the caller could not have
   * found by search is simply absent from the results, and an id in another agency, an
   * id the caller may not read, and an id that never existed are indistinguishable — so
   * this cannot be used to learn which IDs exist in workspaces the caller cannot open.
   *
   * Combines with `search` and `types` by intersection: an id also has to match those.
   * An empty list means no id restriction, not "match nothing". Ordering is unaffected
   * — results stay most-recently-updated first, not in the order the ids were given.
   */
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * Caps the number of artifacts returned, clamped into 1..100, so an out-of-range
   * value is silently pulled into that range rather than erroring or meaning
   * "unbounded". Omitting it returns every artifact the caller can see, which is
   * what the documents view relies on: it renders the whole list and cannot ask
   * for a second page.
   */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Substring matched case-insensitively against the artifact title, the title of the
   * workspace that produced it, and that workspace's client name; an artifact is kept
   * when any one of the three contains it. Whitespace-only terms are ignored rather
   * than matching everything.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Keeps only artifacts of these types. An empty list means no type restriction, not
   * "match nothing".
   */
  types?: InputMaybe<Array<CaraWorkspaceArtifactType>>;
};

/** The look a document version was frozen with when it was marked final. */
export type CaraWorkspaceArtifactFinal = {
  __typename?: 'CaraWorkspaceArtifactFinal';
  /** Whether the final version prints its design’s start and end pages. */
  includeDesignPages: Scalars['Boolean']['output'];
  markedAt: Scalars['Time']['output'];
};

export type CaraWorkspaceArtifactMetadata = {
  __typename?: 'CaraWorkspaceArtifactMetadata';
  /** The user that created the workspace this artifact belongs to (resolved AgencyUser) */
  agencyUser?: Maybe<AgencyUser>;
  /** The client name from the workspace, blank if not available */
  clientName: Scalars['String']['output'];
  /** The ID of the template being filled out if this is a template form artifact */
  templateId?: Maybe<DocumentType>;
  /** The ID of the workspace this artifact belongs to */
  workspaceId: Scalars['String']['output'];
  /** The title of the workspace this artifact belongs to */
  workspaceTitle: Scalars['String']['output'];
  /**
   * The user that created the workspace this artifact belongs to
   * @deprecated Use agencyUser instead
   */
  workspaceUser?: Maybe<Scalars['String']['output']>;
};

export type CaraWorkspaceArtifactPdfFile = {
  __typename?: 'CaraWorkspaceArtifactPDFFile';
  /** The URL to download the PDF file if it is hosted externally */
  externalUrl?: Maybe<Scalars['String']['output']>;
  /** The ID of the original file this artifact was created from */
  fileId?: Maybe<Scalars['String']['output']>;
  /** The title of the PDF file */
  title: Scalars['String']['output'];
};

/** What Cara's review measured on a document version it could not make fit. */
export type CaraWorkspaceArtifactPageCheck = {
  __typename?: 'CaraWorkspaceArtifactPageCheck';
  /**
   * The sheets the document declares: one per cara-page section, and one more for each page break
   * it requests inside a section
   */
  declaredPages: Scalars['Int']['output'];
  /** The sheets the rendered PDF printed */
  printedPages: Scalars['Int']['output'];
};

export type CaraWorkspaceArtifactRefitResult = {
  __typename?: 'CaraWorkspaceArtifactRefitResult';
  artifact: CaraWorkspaceArtifact;
  outcome: DocumentRefitOutcome;
};

/**
 * The design a document version prints with, as anyone who can read the document may see it: its
 * name and state, not the design itself, which the reader may not be able to open.
 */
export type CaraWorkspaceArtifactResolvedDesign = {
  __typename?: 'CaraWorkspaceArtifactResolvedDesign';
  /** Whether the design is archived, so it can no longer be chosen. */
  archived: Scalars['Boolean']['output'];
  /** Null on a final version whose record names no design. */
  designId?: Maybe<Scalars['String']['output']>;
  /**
   * Whether the version has start or end pages of its design to print: on a final version, those
   * frozen with it. Only pages recorded as PDFs count, as only those print.
   */
  hasPages: Scalars['Boolean']['output'];
  /** On a final version, the name the design had when the version was marked. */
  name: Scalars['String']['output'];
};

/**
 * A lightweight artifact summary for the documents view.
 * Contains artifact information with a reference to its workspace and all versions.
 */
export type CaraWorkspaceArtifactSummary = {
  __typename?: 'CaraWorkspaceArtifactSummary';
  /**
   * When the artifact was archived out of the Documents lists, null while it is
   * active. Archiving hides the artifact from `caraWorkspaceArtifacts` and
   * `Client.artifacts` by default and changes nothing else: it stays in its
   * workspace, `caraWorkspaceArtifact` still returns it, and the statics render
   * endpoints still serve it. Set and cleared by `updateCaraWorkspaceArtifacts`.
   */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * When the artifact first existed: the creation time of the earliest version
   * the caller may read. Unlike `createdAt` it never moves, which is what makes
   * it safe to order and page a list by.
   *
   * "The caller may read" is the same qualification the rest of the summary
   * carries: visibility is stamped per version, so a reader shown only the later
   * versions of an artifact sees the earliest of those.
   */
  composedAt: Scalars['Time']['output'];
  /**
   * When the version this summary stands at was written. A summary reports the
   * artifact's latest version, so this moves forward every time Cara revises the
   * artifact; `composedAt` is the one that does not.
   */
  createdAt: Scalars['Time']['output'];
  /**
   * The mailbox an EMAIL is set to send from, from the same version as the rest
   * of the summary. Null when it names none (the composer then uses the sender's
   * default mailbox) and for every other type.
   */
  emailMailboxAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * An EMAIL's current recipients, from the same version as the rest of the
   * summary. Null for every other type.
   */
  emailRecipients?: Maybe<CaraWorkspaceEmailRecipients>;
  /**
   * The sent bulk email that held this EMAIL back: it was on the recipient list,
   * and Send left it a draft in Cara. Null for an email Send handed off, while the
   * bulk email is still a draft, and for every other type.
   */
  heldBackFromBulkSendId?: Maybe<Scalars['String']['output']>;
  /**
   * Why Send held this EMAIL back, as the bulk draft page says it. A blank
   * template field or changed recipients clear once fixed; a missing address, a
   * duplicate or a failed draft is as of Send. Null when it isn't held back.
   */
  heldBackReason?: Maybe<Scalars['String']['output']>;
  /** The ID of the artifact */
  id: Scalars['ID']['output'];
  /** The latest version number of this artifact */
  latestVersion: Scalars['Int']['output'];
  /** The metadata for this artifact */
  metadata: CaraWorkspaceArtifactMetadata;
  /** The title of the artifact (from document.title, pdf.title, or template form type) */
  title: Scalars['String']['output'];
  /** The type of artifact (document, PDF file, or template form) */
  type: CaraWorkspaceArtifactType;
  /** The timestamp when the artifact was last updated */
  updatedAt: Scalars['Time']['output'];
  /** All versions of this artifact, newest first */
  versions: Array<CaraWorkspaceArtifact>;
  /**
   * The URL to view this artifact in the statics service, null for artifact types
   * that render no file there. An EMAIL is one: it is composed in the workspace
   * and leaves through a mailbox, so it has nothing to link to.
   */
  viewUrl?: Maybe<Scalars['String']['output']>;
  /** The workspace this artifact belongs to */
  workspace: CaraWorkspace;
};

/** A template form artifact (e.g. stored ACORD data) */
export type CaraWorkspaceArtifactTemplateForm = {
  __typename?: 'CaraWorkspaceArtifactTemplateForm';
  /**
   * The user who saved this version from the form editor; null when Cara wrote
   * it, and when editedByAgencyUserId names a user who no longer exists.
   */
  editedBy?: Maybe<AgencyUser>;
  /**
   * The agency user who saved this version from the form editor; null when Cara
   * wrote it.
   */
  editedByAgencyUserId?: Maybe<Scalars['ID']['output']>;
  /** The human-readable label of the template, usually indicating the named insured or the policyholder */
  label: Scalars['String']['output'];
  /**
   * The earlier version whose fields a user restored in this one; null when
   * this version was not restored.
   */
  restoredFromVersion?: Maybe<Scalars['Int']['output']>;
  /** The ID of the template being filled out */
  templateId: DocumentType;
  /** The human-readable title of the template (e.g., "ACORD 25") */
  title: Scalars['String']['output'];
};

export enum CaraWorkspaceArtifactType {
  /** A custom PDF form fill artifact produced by filling a custom form template. */
  CustomForm = 'CUSTOM_FORM',
  /**
   * A legacy document type. Value kept while there are cara workspaces in the DB that have
   * created artifacts of this type. This is needed to ensure they unmarshal correctly
   * @deprecated This type is no longer used.
   */
  Document = 'DOCUMENT',
  /** A HTML document artifact */
  DocumentHtml = 'DOCUMENT_HTML',
  /** A Word document artifact (.docx) */
  DocxFile = 'DOCX_FILE',
  /**
   * An email composed in the workspace. Rows created by a retired legacy document
   * type share this value and carry no payload, so readers must tolerate a nil email.
   */
  Email = 'EMAIL',
  /**
   * A legacy document type. Value kept while there are cara workspaces in the DB that have
   * created artifacts of this type. This is needed to ensure they unmarshal correctly
   * @deprecated This type is no longer used.
   */
  HtmlDocument = 'HTML_DOCUMENT',
  /** A PDF document artifact */
  PdfFile = 'PDF_FILE',
  /** A template form artifact (e.g. stored ACORD data) */
  TemplateForm = 'TEMPLATE_FORM',
  /** An Excel spreadsheet artifact (.xlsx) */
  XlsxFile = 'XLSX_FILE'
}

/**
 * Narrows searchCaraWorkspaceArtifacts. Omitting it entirely reads every artifact
 * the caller may see, which is the same reach `caraWorkspaceArtifacts` has.
 */
export type CaraWorkspaceArtifactsFilterInput = {
  /** When true, return only artifacts from workspaces the authenticated user opened. */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Narrows to the artifacts belonging to emails the outbox filter matches.
   *
   * The artifact library is the outbox's third source — the emails Cara composed,
   * whether or not one ever reached a mailbox — and this is how a filtered outbox
   * narrows it in step with the two mailbox ledgers.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  /**
   * Keeps only artifacts of these types. An empty list means no type restriction,
   * not "match nothing".
   */
  types?: InputMaybe<Array<CaraWorkspaceArtifactType>>;
};

/** A paginated connection of Cara workspaces */
export type CaraWorkspaceConnection = {
  __typename?: 'CaraWorkspaceConnection';
  edges: Array<CaraWorkspaceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a Cara workspace connection */
export type CaraWorkspaceEdge = {
  __typename?: 'CaraWorkspaceEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspace;
};

/**
 * How much effort Cara spends on a workspace. The level is what the server resolves
 * the model, the thinking level, the prompts, and the available tools from, together
 * with the preset — so the same level means different things for different presets.
 *
 * Chosen when the workspace is created. The server may raise it once, from LOW to
 * MEDIUM before the first model call, and records why in effortRaisedReason; it can
 * never be lowered, and nothing else can change it once the conversation has
 * started, because the level binds the model family and earlier turns' thought
 * signatures are replayed on every later one.
 *
 * The exception is LOW_MEDIUM, which the server moves a LOW workspace to partway
 * through. That move is one way.
 *
 * Analysis and verification presets label the levels Focused, Comprehensive and
 * Exhaustive; Ask Cara and the Generate use cases label them Low, Medium and High.
 * AUTO is a request for the server to choose one.
 */
export enum CaraWorkspaceEffortLevel {
  /**
   * Auto: not a level of its own, but a request for the server to choose one. It
   * takes the highest of what the documents the workspace starts with call for —
   * LOW for 85 pages or fewer, MEDIUM up to 1,000, and HIGH beyond that — and what
   * the opening message asks it to fill: MEDIUM for more than 3 templates and
   * forms in all, more than 5 sections to write on one Word or Excel template, or
   * more than 1,000 fields on one custom form, and HIGH for more than 6, 12 or
   * 2,500. It falls back to MEDIUM wherever the request could not have named the
   * level itself. A workspace reports AUTO only until its first run replaces it
   * with the chosen level, and runs as MEDIUM if read in between.
   */
  Auto = 'AUTO',
  /**
   * Exhaustive: MEDIUM's agent loop on the strongest reasoning model at its highest
   * thinking effort, with three times the turn budget, for the hardest long-running
   * work. Only valid at creation, behind its rollout gate, for an agency charged for
   * overage; see AgencyUser.highEffortEnabled.
   */
  High = 'HIGH',
  /**
   * Focused: read the attached documents inline in a single pass, without waiting
   * for them to index and without retrieval tools on the first stage. Faster and
   * cheaper, at the cost of the breadth a retrieval loop gives. Only valid at
   * creation; see CaraWorkspaceMessageInput.effortLevel for when.
   */
  Low = 'LOW',
  /**
   * Focused, moved onto a stronger model partway through. The workspace keeps
   * reading its documents inline as LOW does, and from the turn of
   * effortRaisedMessageId on it runs on the stronger model with MEDIUM's turn
   * budget. Only the server sets it, when the Focused model is unavailable or a
   * turn asks for more than Focused is sized for, and records why in
   * effortRaisedReason. Rejected as a request.
   */
  LowMedium = 'LOW_MEDIUM',
  /**
   * Comprehensive: index the files, then run the multi-tool agent loop. The default
   * for every preset.
   */
  Medium = 'MEDIUM'
}

/** A choice of where an email is logged in the AMS when it sends. */
export type CaraWorkspaceEmailAmsLog = {
  __typename?: 'CaraWorkspaceEmailAmsLog';
  /**
   * The To addresses, lowercased and sorted, the choice was made for. A send to other
   * addresses ignores it and matches them again.
   */
  chosenForTo: Array<Scalars['String']['output']>;
  /** Optional record below the client account. */
  filingTarget?: Maybe<EmailAmsFilingTarget>;
  setBy: EmailAmsLogSetter;
  /** The agent who chose, when setBy is AGENT. */
  setByUserId?: Maybe<Scalars['String']['output']>;
  /** The AMS record to log to. Null means the email is not logged. */
  target?: Maybe<AmsRef>;
};

export type CaraWorkspaceEmailAmsLogInput = {
  /** Optional record below the client account. */
  filingTarget?: InputMaybe<EmailAmsFilingTargetInput>;
  /**
   * An ACCOUNT in the AMS that logs the agency's sent emails. Null chooses not to log the
   * email.
   */
  target?: InputMaybe<AmsRefInput>;
};

/** An email recipient with an optional display name */
export type CaraWorkspaceEmailRecipient = {
  __typename?: 'CaraWorkspaceEmailRecipient';
  /** The recipient's email address */
  email: Scalars['String']['output'];
  /** The recipient's display name; empty when only an address is known */
  name: Scalars['String']['output'];
};

/** An email recipient input */
export type CaraWorkspaceEmailRecipientInput = {
  /** The recipient's email address */
  email: Scalars['String']['input'];
  /** The recipient's display name; empty when only an address is known */
  name: Scalars['String']['input'];
};

/** The recipients of an email artifact. */
export type CaraWorkspaceEmailRecipients = {
  __typename?: 'CaraWorkspaceEmailRecipients';
  bcc: Array<CaraWorkspaceEmailRecipient>;
  cc: Array<CaraWorkspaceEmailRecipient>;
  to: Array<CaraWorkspaceEmailRecipient>;
};

/**
 * How a composed email derives from an existing message. The provider
 * generates threading headers from the source, so replies thread correctly for
 * the recipient.
 */
export enum CaraWorkspaceEmailReplyMode {
  Forward = 'FORWARD',
  Reply = 'REPLY',
  ReplyAll = 'REPLY_ALL'
}

/** The message a composed email replies to or forwards */
export type CaraWorkspaceEmailSource = {
  __typename?: 'CaraWorkspaceEmailSource';
  /** The durable RFC 5322 Message-ID of the source */
  messageId: Scalars['String']['output'];
  /** How the composed email derives from the source */
  mode: CaraWorkspaceEmailReplyMode;
  /** The provider's ID for the source message, in the sending account */
  providerMessageId: Scalars['String']['output'];
  /** The conversation the source belongs to */
  threadId: Scalars['String']['output'];
};

/** Input for the message a composed email replies to or forwards */
export type CaraWorkspaceEmailSourceInput = {
  messageId: Scalars['String']['input'];
  mode: CaraWorkspaceEmailReplyMode;
  providerMessageId: Scalars['String']['input'];
  threadId: Scalars['String']['input'];
};

/** Which template, and which version of it, an email was drafted from. */
export type CaraWorkspaceEmailTemplateUse = {
  __typename?: 'CaraWorkspaceEmailTemplateUse';
  /**
   * The template's placeholder labels when the draft was made, from its subject and body
   * including the Cara section instructions, normalized and in order of first use. Send and
   * Schedule are refused while any of them is still written as [[label]].
   */
  placeholderLabels: Array<Scalars['String']['output']>;
  templateId: Scalars['String']['output'];
  /**
   * The template's version when the draft was made. A newer version means the template
   * changed after this draft was made.
   */
  templateVersion: Scalars['Int64']['output'];
};

/** Reference to an existing file. Mirrors SearchFileResult: { id, integrationId? }. */
export type CaraWorkspaceExistingFileInput = {
  /** The ID of the existing file */
  id: Scalars['ID']['input'];
  /** The integration ID of the existing file */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Represents either a new file upload or an existing file reference.
 * Exactly one of upload or fileId must be provided.
 */
export type CaraWorkspaceFileInput = {
  /**
   * Reference to an existing file result from searchFiles.
   * If integrationId is null, id refers to an uploaded agency file.
   * If integrationId is provided, id refers to a knowledge graph entity ID that must
   * be fetched from the integration and stored as an agency file.
   */
  existing?: InputMaybe<CaraWorkspaceExistingFileInput>;
  /** New file content to upload */
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

export type CaraWorkspaceFilterInput = {
  /** The ID of the agency to filter by */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the agency user to filter by (workspace creator/owner) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** The preset of the Cara workspace to filter by (exact match) */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** The state of the Cara workspace to filter by (exact match) */
  state?: InputMaybe<CaraWorkspaceState>;
  /** The title of the Cara workspace to filter by (case-insensitive contains operator) */
  title?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A preset a workspace may be created for at LOW effort, with the output formats
 * LOW is accepted with for it.
 */
export type CaraWorkspaceLowEffortOffer = {
  __typename?: 'CaraWorkspaceLowEffortOffer';
  outputFormats: Array<CaraWorkspaceOutputFormat>;
  preset: CaraWorkspacePreset;
  /**
   * Whether LOW is also accepted with a template or form to fill. Excel templates
   * and custom forms are requested by ID alone, so outputFormats cannot say.
   */
  templates: Scalars['Boolean']['output'];
};

/** A message exchanged between a user and agent in a Cara workspace */
export type CaraWorkspaceMessage = {
  __typename?: 'CaraWorkspaceMessage';
  /**
   * AMS records pinned from the AMS picker for this message (account, policy,
   * certificate, or file). FILE entries also appear in fileIds after download.
   */
  amsContext?: Maybe<Array<CaraWorkspaceAmsContextEntry>>;
  /**
   * AMS records pinned from the AMS browser by their AMS identity. FILE entries also
   * appear in fileIds after download.
   */
  amsRefs?: Maybe<Array<CaraWorkspaceAmsRefEntry>>;
  /** The content of the message */
  content: Scalars['String']['output'];
  /**
   * The IDs of the custom forms the user attached for this message. Cara uses the PDF editor
   * tool (LIST / DESCRIBE / FILL) for these forms.
   */
  customFormIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The IDs of the documents for which templates should be generated. This should only be specified
   * when the preset is GENERATE_TEMPLATE.
   */
  documentIds?: Maybe<Array<DocumentType>>;
  /**
   * The IDs of the Excel spreadsheet templates the user pre-selected. Cara will call
   * REQUEST_EXCEL_SPREADSHEET_TEMPLATES with GET_CONTENT for each ID and produce
   * a workbook using XLSX_EDITOR CREATE_FROM_TEMPLATE.
   */
  excelSpreadsheetTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the message in the external system */
  externalId: Scalars['String']['output'];
  /** The files associated with this message */
  files: Array<File>;
  /** The generated follow up options to display to the user for possible selection. */
  followUpOptions?: Maybe<CaraWorkspaceMessageFollowUpOptions>;
  /**
   * The IDs of the HTML document templates the user pre-selected. Cara will call
   * REQUEST_DOCUMENT_STYLE_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using FILE_EDITOR.
   */
  htmlDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID of the message */
  id: Scalars['ID']['output'];
  /** The delivery format the user chose for the workspace output. Null means TEXT. */
  outputFormat?: Maybe<CaraWorkspaceOutputFormat>;
  /** The preset metadata for the message */
  presetMetadata?: Maybe<Scalars['JSON']['output']>;
  /** The role of the message sender (user or agent) */
  role: CaraWorkspaceMessageRole;
  /** The selected follow up option by the user. */
  selectedFollowUp?: Maybe<CaraWorkspaceMessageFollowUpOption>;
  /** The timestamp when the message was created */
  timestamp: Scalars['Time']['output'];
  /**
   * The use case this message was launched from, when it came from a launcher tile
   * rather than free-form chat. Narrows the preset: prompts read it to pick their
   * wording, and the home page reads it to rank what a user reaches for.
   */
  useCase?: Maybe<CaraWorkspaceUseCase>;
  /**
   * The IDs of the Word document templates the user pre-selected. Cara will call
   * REQUEST_WORD_DOCUMENT_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using DOCX_EDITOR CREATE_FROM_TEMPLATE.
   */
  wordDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Ephemeral Word, Excel, or PDF file produced from a Cara agent message. Exactly one of
 * contentBase64 or downloadUrl is set, depending on where the format is rendered.
 */
export type CaraWorkspaceMessageExport = {
  __typename?: 'CaraWorkspaceMessageExport';
  /** Base64-encoded file bytes. Null for PDF, which is rendered by the statics service. */
  contentBase64?: Maybe<Scalars['String']['output']>;
  /**
   * Single-use, short-lived URL that renders and downloads the file. Set only for PDF.
   * The URL is minted after authorization and is consumed on first request.
   */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** Suggested download filename */
  fileName: Scalars['String']['output'];
  /** MIME type of the file */
  mimeType: Scalars['String']['output'];
};

/** Export format for a Cara workspace agent message download. */
export enum CaraWorkspaceMessageExportFormat {
  Docx = 'DOCX',
  Pdf = 'PDF',
  Xlsx = 'XLSX'
}

export type CaraWorkspaceMessageFollowUpInput = {
  /** The ID of the follow up option to select. */
  id: Scalars['ID']['input'];
  /** The prompt generated by the LLM to accomplish this follow up task */
  prompt: Scalars['String']['input'];
};

/** A follow up option to display to the user for possible selection. */
export type CaraWorkspaceMessageFollowUpOption = {
  __typename?: 'CaraWorkspaceMessageFollowUpOption';
  /** The ID of the follow up option. */
  id: Scalars['ID']['output'];
  /** A prompt generated by the LLM to accomplish this follow up task */
  prompt: Scalars['String']['output'];
  /** A short title describing the follow up option to display to the user. */
  title: Scalars['String']['output'];
  /**
   * The type of the follow up option. This determines the action to take when the user selects the option
   * and what options to display on the frontend for the follow up.
   */
  type: CaraWorkspaceMessageFollowUpOptionType;
};

/** The type of follow up option to display to the user. */
export enum CaraWorkspaceMessageFollowUpOptionType {
  /** A custom follow up option that is generated by the LLM to accomplish this follow up task. */
  Custom = 'CUSTOM'
}

/** The generated follow up options to display to the user for possible selection. */
export type CaraWorkspaceMessageFollowUpOptions = {
  __typename?: 'CaraWorkspaceMessageFollowUpOptions';
  /** The timestamp when the follow up options were generated. */
  generationCompletedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when the follow up options were generated. */
  generationStartedAt?: Maybe<Scalars['Time']['output']>;
  /** The options to display to the user for possible selection. */
  options?: Maybe<Array<CaraWorkspaceMessageFollowUpOption>>;
};

export type CaraWorkspaceMessageInput = {
  /**
   * AMS records pinned from the AMS picker. FILE entries are downloaded and added to
   * fileIds; all entries are stored here for audit and prompt attribution.
   */
  amsContext?: InputMaybe<Array<CaraWorkspaceAmsContextInput>>;
  /**
   * AMS records pinned from the AMS browser by their AMS identity. FILE entries are
   * downloaded and added to fileIds.
   */
  amsRefs?: InputMaybe<Array<CaraWorkspaceAmsRefInput>>;
  /**
   * Client to file the new workspace under. Only consulted when this message creates
   * a workspace, the same as `visibility`.
   */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the custom forms the user attached for this message. Cara uses the PDF editor
   * tool (LIST / DESCRIBE / FILL) for these forms.
   */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The ID of the custom preset to use for this workspace */
  customPresetId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the documents for which templates should be generated. This should only be specified
   * when the preset is GENERATE_TEMPLATE.
   */
  documentIds?: InputMaybe<Array<DocumentType>>;
  /**
   * How much effort the workspace should run at. Consulted only when this message
   * creates a workspace; the level is chosen once and a follow-up cannot change it.
   * Null means the custom preset's defaultEffortLevel when one is named, and the
   * server's default otherwise: AUTO while the effort_level_selector_enabled and
   * effort_level_auto_enabled gates are both on, and MEDIUM otherwise.
   *
   * LOW is accepted for any preset, any custom preset, and a workspace with no
   * preset while the effort_level_selector_enabled gate is on. The built-in
   * Coverage Comparison also needs at least one document. The server raises LOW to
   * MEDIUM by itself when the documents turn out to be past what a single inline
   * pass can read.
   * HIGH is accepted only when AgencyUser.highEffortEnabled is true. AUTO is
   * accepted while the effort_level_selector_enabled and effort_level_auto_enabled
   * gates are both on, and only ever chooses a level the request could have named;
   * with either gate off it means MEDIUM. LOW_MEDIUM is never accepted at
   * creation. Follow-up messages that send a level other than the workspace's own
   * are rejected, except that a LOW_MEDIUM workspace still accepts LOW.
   */
  effortLevel?: InputMaybe<CaraWorkspaceEffortLevel>;
  /**
   * The email draft in this workspace that the message asks Cara to revise, such as the one a
   * composer redraft names. Read by addCaraWorkspaceMessage only.
   */
  emailDraftArtifactId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The email template the agent picked in the composer for Cara to redraft the email named by
   * emailDraftArtifactId from. It needs emailDraftArtifactId. Read by addCaraWorkspaceMessage only.
   */
  emailTemplateId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The IDs of the Excel spreadsheet templates the user pre-selected. Cara will call
   * REQUEST_EXCEL_SPREADSHEET_TEMPLATES with GET_CONTENT for each ID and produce
   * a workbook using XLSX_EDITOR CREATE_FROM_TEMPLATE.
   */
  excelSpreadsheetTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Reference to an existing file result from searchFiles. */
  existingFiles?: InputMaybe<Array<CaraWorkspaceExistingFileInput>>;
  /** Any files to add to the message */
  files: Array<Scalars['Upload']['input']>;
  /** The follow up option to select, if any. */
  followUp?: InputMaybe<CaraWorkspaceMessageFollowUpInput>;
  /**
   * The IDs of the HTML document templates the user pre-selected. Cara will call
   * REQUEST_DOCUMENT_STYLE_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using FILE_EDITOR.
   */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The content of the message to add */
  message: Scalars['String']['input'];
  /**
   * When true, custom forms and output templates pinned on the workspace's custom preset
   * are not injected automatically. Use for launcher UIs where the user explicitly
   * chooses which library forms and templates to fill. Non-UI flows (e.g. email) omit this.
   */
  omitPresetOutputTemplates?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The delivery format for the workspace output. Defaults to TEXT when omitted.
   * HTML_TEMPLATE / WORD_TEMPLATE expect the corresponding template ID list to be set.
   */
  outputFormat?: InputMaybe<CaraWorkspaceOutputFormat>;
  /**
   * The preset for this workspace, if any. This indicates a specific task or goal for the workspace
   * and can be used to guide the AI in its execution.
   */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Any additional preset-specific JSON content used to configure that preset. */
  presetMetadata?: InputMaybe<Scalars['JSON']['input']>;
  /**
   * A document whose open comments this message asks Cara to work through. The comments are
   * expanded into the message for Cara and marked as handed over.
   */
  processCommentsArtifactId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the service request this workspace is associated with, if any */
  serviceRequestId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The use case the caller launched, narrowing `preset` to one errand inside it.
   * Supersedes the legacy `Use Case: <id>` line in `message`, which is still read
   * when this is omitted so older clients keep working.
   */
  useCase?: InputMaybe<CaraWorkspaceUseCase>;
  /**
   * Optional visibility configuration. Only consulted when this message creates a
   * new workspace (i.e. no existing workspace ID is supplied). Defaults to PUBLIC.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
  /**
   * The IDs of the Word document templates the user pre-selected. Cara will call
   * REQUEST_WORD_DOCUMENT_TEMPLATES with GET_CONTENT for each ID and produce
   * a document using DOCX_EDITOR CREATE_FROM_TEMPLATE.
   */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The role of a message in a Cara workspace conversation */
export enum CaraWorkspaceMessageRole {
  /** A message from the AI agent */
  Agent = 'AGENT',
  /** A message from the human user */
  User = 'USER'
}

/** The metadata for a Cara workspace */
export type CaraWorkspaceMetadata = {
  __typename?: 'CaraWorkspaceMetadata';
  /** The name of the client that this workspace is for */
  clientName?: Maybe<Scalars['String']['output']>;
  /** Keywords that can be used to search and filter this workspace */
  keywords: Array<Scalars['String']['output']>;
};

/**
 * The delivery format for a workspace's final output. Generic across presets,
 * though currently only surfaced for Coverage Comparison (Policy Check).
 */
export enum CaraWorkspaceOutputFormat {
  /** Populate a user-selected HTML document template (via htmlDocumentTemplateIds). */
  HtmlTemplate = 'HTML_TEMPLATE',
  /** Markdown text rendered in-product (the default). */
  Text = 'TEXT',
  /** Populate a user-selected Word document template (via wordDocumentTemplateIds). */
  WordTemplate = 'WORD_TEMPLATE',
  /** A structured Excel file using a Cara-defined layout. */
  Xlsx = 'XLSX'
}

/** A stage in the execution plan of a Cara workspace task */
export type CaraWorkspacePlanStage = {
  __typename?: 'CaraWorkspacePlanStage';
  /** The timestamp when the plan stage was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when execution of the plan stage completed */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The sequence of events that occurred during stage execution */
  events: Array<CaraWorkspacePlanStageEvent>;
  /** The ID of the plan stage */
  id: Scalars['ID']['output'];
  /** The ID of the message that initiated this plan stage */
  initiatedByMessageId: Scalars['String']['output'];
  /**
   * Confirmed billable platform units for this TASK stage's response
   * (workspace:{stageId}:response), summed from consumption_event.
   * Null for non-TASK stages or when none are recorded yet.
   */
  platformUnitsUsed?: Maybe<Scalars['Decimal']['output']>;
  /** The details of the process attachments plan stage */
  processAttachmentsDetails?: Maybe<CaraWorkspacePlanStageProcessAttachmentDetails>;
  /** The prompt that was computed to start execution of this stage (human message) */
  prompt: Scalars['String']['output'];
  /** The outcome or findings from executing this plan stage */
  result: Scalars['String']['output'];
  /** The timestamp when execution of the plan stage began */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current execution state of the plan stage */
  state: CaraWorkspacePlanStageState;
  /** The type of plan stage */
  type: CaraWorkspacePlanStageType;
};

/** An event that occurs during the execution of a plan stage */
export type CaraWorkspacePlanStageEvent = {
  __typename?: 'CaraWorkspacePlanStageEvent';
  /** The content or description of the event */
  content?: Maybe<Scalars['String']['output']>;
  /** The timestamp when the event ended */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** The error message if the tool call failed */
  error?: Maybe<Scalars['String']['output']>;
  /** The ID of the event in the external system */
  externalId: Scalars['String']['output'];
  /** The ID of the event */
  id: Scalars['ID']['output'];
  /** The timestamp when the event was created */
  startedAt: Scalars['Time']['output'];
  /**
   * The opaque provider signature required to replay this event's content (thinking
   * blocks for Anthropic, function-call parts for Gemini). Set on THOUGHT events the
   * model produced itself, and on TOOL_CALL events whose provider signs the call.
   */
  thoughtSignature?: Maybe<Scalars['String']['output']>;
  /** A brief title of the event */
  title?: Maybe<Scalars['String']['output']>;
  /** The tool call details if this event is a tool invocation */
  toolCall?: Maybe<CaraWorkspaceToolCall>;
  /** The type of the event (thought or tool call) */
  type: CaraWorkspacePlanStageEventType;
};

/** The type of event that can occur during a plan stage execution */
export enum CaraWorkspacePlanStageEventType {
  /**
   * A server-generated summary that replaces older conversation history when the
   * LLM provider compacts the message history. Replayed to the LLM on subsequent
   * turns in place of the summarized history; not rendered to users.
   */
  Compaction = 'COMPACTION',
  /** An internal reasoning step by the agent */
  Thought = 'THOUGHT',
  /** An invocation of an external tool or API */
  ToolCall = 'TOOL_CALL'
}

/** The details of the process attachments plan stage */
export type CaraWorkspacePlanStageProcessAttachmentDetails = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails';
  /** The progress of each file being processed */
  progress: Array<CaraWorkspacePlanStageProcessAttachmentFileProgress>;
};

export type CaraWorkspacePlanStageProcessAttachmentFileProgress = {
  __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress';
  /** The error encountered while processing the file */
  error?: Maybe<Scalars['String']['output']>;
  /** The file being processed */
  file: File;
  /** The progress of the file being processed (as a decimal between 0 and 1) */
  progress: Scalars['Float']['output'];
};

/** The state of a plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageState {
  /** The stage has failed to complete */
  Failed = 'FAILED',
  /** The stage is actively processing a task */
  InProgress = 'IN_PROGRESS',
  /** The stage is planned but not yet started */
  Planned = 'PLANNED',
  /** The stage has been completed successfully */
  Success = 'SUCCESS'
}

/** The type of plan stage in a Cara workspace */
export enum CaraWorkspacePlanStageType {
  /** A plan stage that processes attached files */
  ProcessAttachments = 'PROCESS_ATTACHMENTS',
  /** A plan stage that performs a task */
  Task = 'TASK'
}

/** A preset for Cara to execute tasks and produce artifacts */
export enum CaraWorkspacePreset {
  /** A preset for reviewing a certificate of liability insurance for correctness */
  CertificateReview = 'CERTIFICATE_REVIEW',
  /**
   * A preset for reviewing insurance claims against policy coverage, analyzing misrepresentation risk,
   * and providing E&O mitigation recommendations
   */
  ClaimsReview = 'CLAIMS_REVIEW',
  /** A preset for classifying business operations using NAICS, SIC, and GL codes */
  CommercialClassification = 'COMMERCIAL_CLASSIFICATION',
  /**
   * A preset for processing carrier commission statements across any line of business: parse every
   * statement whatever its shape into one transaction register, foot each file to its own stated total
   * before any figure is reported, map the register onto a saved destination layout, and where a
   * commission schedule or a prior period is supplied recompute each line against its agreed rate,
   * attribute period over period movement to rate, volume, and book change, and allocate to producers
   */
  CommissionProcessing = 'COMMISSION_PROCESSING',
  /** A preset for reviewing a contract and comparing its requirements to a quote or policy */
  ContractReview = 'CONTRACT_REVIEW',
  /** A preset for comparing insurance coverage between two policies or quotes */
  CoverageComparison = 'COVERAGE_COMPARISON',
  /**
   * A preset for analyzing gaps between current coverage and exposure across commercial and personal
   * lines, verifying exposure with external sources, and recommending additional lines of business
   */
  CoverageGapAnalysis = 'COVERAGE_GAP_ANALYSIS',
  /** A preset for exploring a document and asking questions about it */
  DocumentExploration = 'DOCUMENT_EXPLORATION',
  /**
   * A preset for auditing an employee benefits carrier invoice: prove the bill's own lines foot to its
   * stated total, rebuild the expected charge for every subscriber from the enrollment roster and the
   * bound rates, reconcile the difference into a subscriber level exception register that accounts for
   * the whole variance, separate timing differences from carrier errors, and draft the credit request
   * the exceptions support
   */
  EbBillingAudit = 'EB_BILLING_AUDIT',
  /**
   * A preset for normalizing an employee benefits census: parse a census from a PDF or spreadsheet
   * whatever its columns are called, derive attained ages and coverage tiers, resolve dependents and
   * duplicates, reconcile every row from input to output, and either map the result onto a saved
   * destination layout for a carrier or enrollment platform or return an exception report against the
   * census itself
   */
  EbCensusNormalization = 'EB_CENSUS_NORMALIZATION',
  /**
   * A preset for reviewing the claims experience of a self funded, level funded, or experience rated
   * employee benefits group: establish whether the report is on an incurred or a paid basis, compute
   * member months and per member per month cost with the medical and pharmacy split, trend it without
   * running the line into months the carrier has not finished paying, measure large claim
   * concentration, test which claimants pierced the specific deductible and what the stop loss
   * contract says about filing them, and separate what the documents compute from what only the
   * carrier can answer
   */
  EbClaimsReview = 'EB_CLAIMS_REVIEW',
  /**
   * A preset for employee benefits contribution analysis at renewal: reconcile the current billed
   * premium against the census, model employer/employee cost-sharing scenarios, solve a structure to
   * an employer budget target, run ACA affordability and carrier participation checks, and produce a
   * payroll-ready deduction schedule
   */
  EbContributionAnalysis = 'EB_CONTRIBUTION_ANALYSIS',
  /**
   * A preset for reviewing an employee benefits document against the carrier documents it was derived
   * from: verify an employee benefits guide or a contributions worksheet field by field against rate
   * sheets, plan documents, and contribution decisions, check the per-pay deduction math, and return
   * the corrections to make before the document is distributed
   */
  EbDocumentReview = 'EB_DOCUMENT_REVIEW',
  /**
   * A preset for building the employee facing material an employee benefits open enrollment runs on: the
   * election form, the benefits guide, or the announcement and FAQ. Selects the few figures and benefit
   * provisions an employee needs to choose a plan out of the much larger set the carrier documents
   * carry, computes the per paycheck deduction at a pay calendar established from the documents rather
   * than assumed, and holds any figure it cannot trace to a source out of the document as a labeled
   * blank so it reaches a person before it reaches an employee
   */
  EbEnrollmentMaterials = 'EB_ENROLLMENT_MATERIALS',
  /**
   * A preset for making employee benefits carrier quotes comparable: reprice every quoted option on one
   * comparison census whatever shape its rates arrived in, reconcile each option's own arithmetic before
   * it is allowed into the comparison, and return a normalized cost and benefit comparison, the funding
   * and contract differences behind it, and a shortlist with reasons
   */
  EbQuoteAnalysis = 'EB_QUOTE_ANALYSIS',
  /**
   * A preset for generating a certificate of liability insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateCertificateOfLiabilityInsurance = 'GENERATE_CERTIFICATE_OF_LIABILITY_INSURANCE',
  /**
   * A preset for generating evidence of property insurance
   * @deprecated Use GENERATE_TEMPLATE instead
   */
  GenerateEvidenceOfPropertyInsurance = 'GENERATE_EVIDENCE_OF_PROPERTY_INSURANCE',
  /** A preset for generating a quote proposal */
  GenerateQuoteProposal = 'GENERATE_QUOTE_PROPOSAL',
  /** A preset for generating a template for a document */
  GenerateTemplate = 'GENERATE_TEMPLATE',
  /**
   * A preset for analyzing loss runs for new business submissions, compiling claims history,
   * researching external risk signals (OSHA, news, litigation), and producing an underwriter-facing
   * risk mitigation statement to support preferred rate consideration
   */
  LossRunAnalysis = 'LOSS_RUN_ANALYSIS',
  /**
   * A preset for risk matching: extract risk details from documents, optionally enrich
   * company data via web, and query the knowledge base for market placement recommendations
   */
  RiskMatching = 'RISK_MATCHING',
  /**
   * A preset for generating a comprehensive client-facing risk management report with deep industry
   * research, regulatory and compliance analysis, company-specific risk findings, and prioritized
   * mitigation recommendations
   */
  RiskReport = 'RISK_REPORT',
  /** A preset for SOV analysis */
  SovAnalysis = 'SOV_ANALYSIS',
  /** A preset for analyzing commercial underwriting documents and providing comprehensive analysis */
  UnderwritingAnalysis = 'UNDERWRITING_ANALYSIS'
}

export enum CaraWorkspaceSchemaVersion {
  /**
   * The initial version of the Cara workspace schema, based in the Python codebase.
   * These workspaces are now deprecated.
   */
  V0 = 'V0',
  /** The next version of the Cara workspace schema, based in the Go codebase. */
  V1 = 'V1',
  /**
   * The current version of the Cara workspace schema, still based in Go, but leveraging
   * a different execution architecture. It doesn't change the data model of the workspace,
   * but it does change the way the workspace is executed.
   */
  V2 = 'V2'
}

/** Sort field for Cara workspace search */
export enum CaraWorkspaceSortField {
  AgencyUser = 'AGENCY_USER',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  Preset = 'PRESET',
  State = 'STATE',
  Title = 'TITLE',
  UpdatedAt = 'UPDATED_AT'
}

/** Sort input for Cara workspace search */
export type CaraWorkspaceSortInput = {
  direction: SortDirection;
  field: CaraWorkspaceSortField;
};

/** The state of a Cara workspace, indicating its current execution status */
export enum CaraWorkspaceState {
  /** The workspace is created but not yet started */
  Created = 'CREATED',
  /** The workspace has finished processing the task and is idle */
  Idle = 'IDLE',
  /** The workspace is waiting for user input to continue */
  WaitingForInput = 'WAITING_FOR_INPUT',
  /** The workspace is actively processing a task */
  Working = 'WORKING'
}

/** Represents the different types of tools that can be called within a Cara workspace. */
export enum CaraWorkspaceTool {
  /** Used to manage AgencyZoom entities (customers, leads, policies, tasks, etc.) with full field access. */
  AgencyzoomWrite = 'AGENCYZOOM_WRITE',
  /** Used to manage AMS360 entities (customers/contacts/activities/policies/suspenses) with full field access. */
  Ams360Write = 'AMS360_WRITE',
  /** Legacy Excel generator. Kept so historical workspace events that used this tool continue to load; new Excel work goes through XLSX_EDITOR. */
  ApplicationFileGenerator = 'APPLICATION_FILE_GENERATOR',
  /** Used to manage Applied Epic write operations: create activities with notes and tasks, add notes to an activity, update a task (mark complete / change status / append notes / reschedule / reassign), create ACORD 25 Certificates of Insurance, and upload documents. */
  AppliedEpicWrite = 'APPLIED_EPIC_WRITE',
  /**
   * Used to make a bulk draft, one email per client on a list, and to change who is on it.
   * None of its operations sends.
   */
  BulkEmailDraft = 'BULK_EMAIL_DRAFT',
  /** Used to execute Python scripts in a sandbox environment. */
  CodeExecution = 'CODE_EXECUTION',
  /** Used to mark a task as completed and record its outcome. */
  CompleteTask = 'COMPLETE_TASK',
  /** Used to create or edit Word (.docx) documents. */
  DocxEditor = 'DOCX_EDITOR',
  /**
   * Retired document-drafting tool. No longer registered with the agent; the value
   * remains so historical tool calls replay.
   */
  DraftDocument = 'DRAFT_DOCUMENT',
  /**
   * Used to compose an email as a workspace draft, to revise that draft, and to copy it
   * into the agent's connected mailbox. None of its operations sends.
   */
  DraftEmail = 'DRAFT_EMAIL',
  /** Used to draft an outbound call for scheduling. The user reviews and confirms the draft before the call is placed. */
  DraftOutboundCall = 'DRAFT_OUTBOUND_CALL',
  /** Used to manage EZLynx entities (notes/calls/policies) with full field access. */
  EzlynxWrite = 'EZLYNX_WRITE',
  /** Used to create or edit a file. */
  FileEditor = 'FILE_EDITOR',
  /** Used to fill out a template such as an ACORD form. */
  FillTemplate = 'FILL_TEMPLATE',
  /** Used to retrieve one client's profile, linked AMS accounts, and owner. */
  GetClient = 'GET_CLIENT',
  /** Used to manage HawkSoft log entries and receipts with full field access. */
  HawksoftWrite = 'HAWKSOFT_WRITE',
  /** Used to look up integration metadata such as employee lists / pipeline IDs / lead sources. */
  ListIntegrationObjects = 'LIST_INTEGRATION_OBJECTS',
  /** Used to list the mailboxes the agent may send email from. It reads only. */
  ListMailboxes = 'LIST_MAILBOXES',
  /** Used to save a memory the user has explicitly asked Cara to remember. */
  MemoryCreate = 'MEMORY_CREATE',
  /** Used to re-rank the active memory context when the conversation topic shifts. */
  MemoryRefresh = 'MEMORY_REFRESH',
  /** Used to manage NowCerts entities (insureds, prospects, policies, tasks, notes, etc.) with full field access. */
  NowcertsWrite = 'NOWCERTS_WRITE',
  /** Used to organize the knowledge base by creating folders and moving documents into them. */
  OrganizeKnowledgeBase = 'ORGANIZE_KNOWLEDGE_BASE',
  /** Used to edit and manipulate PDF documents specifically. */
  PdfEditor = 'PDF_EDITOR',
  /** Use to peek at files to get a sense for their content textually or visually */
  PeekFile = 'PEEK_FILE',
  /** Used to manage QQCatalyst prospects notes tasks x-dates policies and files. */
  QqcatalystWrite = 'QQCATALYST_WRITE',
  /** Fetch HTML document templates ONLY when the user explicitly requested one, asked what templates exist, or pre-selected one. Do not use for generic document requests. */
  RequestDocumentStyleTemplates = 'REQUEST_DOCUMENT_STYLE_TEMPLATES',
  /** Used to list the agency's email templates and read one before DRAFT_EMAIL fills it. */
  RequestEmailTemplates = 'REQUEST_EMAIL_TEMPLATES',
  /** Used to request a list of available Excel (.xlsx) spreadsheet templates for filling. */
  RequestExcelSpreadsheetTemplates = 'REQUEST_EXCEL_SPREADSHEET_TEMPLATES',
  /** Used to request per-integration tools to be provisioned on demand. */
  RequestIntegrationTools = 'REQUEST_INTEGRATION_TOOLS',
  /** Used to request a list of tools that can be used to fill out a template. */
  RequestTemplateTools = 'REQUEST_TEMPLATE_TOOLS',
  /** Used to request a list of available Word (.docx) document templates for filling. */
  RequestWordDocumentTemplates = 'REQUEST_WORD_DOCUMENT_TEMPLATES',
  /**
   * Used to search the agency's AMS directly (live) for an account and its contacts, policies, notes, and files.
   * @deprecated Superseded by SEARCH_INTEGRATION; kept so stored tool calls still resolve.
   */
  SearchAmsLive = 'SEARCH_AMS_LIVE',
  /** Used to find a client in the agency's book by name, email, or phone. */
  SearchClients = 'SEARCH_CLIENTS',
  /** Used to search a client's history across its other workspaces: what was said and concluded there, and the documents each produced. */
  SearchClientHistory = 'SEARCH_CLIENT_HISTORY',
  /** Used to search through files and documents within the workspace. */
  SearchFile = 'SEARCH_FILE',
  /**
   * Used to find accounts, policies, claims, certificates, activities and
   * opportunities in the agency's integrated systems with a filter tree, pulling
   * related records and chosen field bundles in one call.
   */
  SearchIntegration = 'SEARCH_INTEGRATION',
  /** Used to search through the organization's knowledge base for relevant information. */
  SearchKnowledgeBase = 'SEARCH_KNOWLEDGE_BASE',
  /**
   * Used to search through entities stored and related to the organization, such as synced accounts and policies.
   * @deprecated Superseded by SEARCH_INTEGRATION; kept so stored tool calls still resolve.
   */
  SearchKnowledgeGraph = 'SEARCH_KNOWLEDGE_GRAPH',
  /** Used to search the internet for relevant information. */
  SearchWeb = 'SEARCH_WEB',
  /**
   * Used by one recipient's drafting run in a bulk email, and only there, to write that
   * recipient's email. It cannot send.
   */
  SubmitBulkEmail = 'SUBMIT_BULK_EMAIL',
  /** Used when the LLM needs to process information or make decisions by thinking through a problem. */
  Think = 'THINK',
  /**
   * A revision recorded by the standalone tool that preceded DRAFT_EMAIL's UPDATE_DRAFT
   * operation. Only stored events carry it; nothing writes it.
   */
  UpdateEmailDraft = 'UPDATE_EMAIL_DRAFT',
  /**
   * Used to add a new document to the organization's knowledge base, or replace an
   * existing document with a new version, from a file attached to the workspace.
   */
  UpdateKnowledgeBase = 'UPDATE_KNOWLEDGE_BASE',
  /** Used to write to an integration. */
  WriteIntegration = 'WRITE_INTEGRATION',
  /** Used to create, edit, and fill Excel (.xlsx) workbooks — ad-hoc, from uploads, or from agency spreadsheet templates. */
  XlsxEditor = 'XLSX_EDITOR',
  /** Used to push data to Zapier webhooks (notes/tasks/accounts/documents). */
  ZapierWrite = 'ZAPIER_WRITE'
}

/**
 * Represents a tool-shaped operation in a Cara workspace.
 * Most are invoked by the LLM. Deterministic replayable calls use ORCHESTRATED.
 */
export type CaraWorkspaceToolCall = {
  __typename?: 'CaraWorkspaceToolCall';
  agencyzoomWriteTool?: Maybe<AgencyZoomWriteTool>;
  ams360WriteTool?: Maybe<Ams360WriteTool>;
  applicationFileGeneratorTool?: Maybe<ApplicationFileGeneratorTool>;
  appliedEpicWriteTool?: Maybe<AppliedEpicWriteTool>;
  /**
   * DEPRECATED: The arguments passed to the tool in JSON format.
   * This field is deprecated in favor of strongly-typed argument fields in specific tool types.
   */
  argumentsJson: Scalars['String']['output'];
  bulkEmailDraftTool?: Maybe<BulkEmailDraftTool>;
  codeExecutionTool?: Maybe<CodeExecutionTool>;
  completeTaskTool?: Maybe<CompleteTaskTool>;
  docxEditorTool?: Maybe<DocxEditorTool>;
  draftDocumentTool?: Maybe<DraftDocumentTool>;
  draftEmailTool?: Maybe<DraftEmailTool>;
  draftOutboundCallTool?: Maybe<DraftOutboundCallTool>;
  ezlynxWriteTool?: Maybe<EzlynxWriteTool>;
  fileEditorTool?: Maybe<FileEditorTool>;
  fillTemplateTool?: Maybe<FillTemplateTool>;
  getClientTool?: Maybe<GetClientTool>;
  hawksoftWriteTool?: Maybe<HawksoftWriteTool>;
  /**
   * The unique identifier for this tool call instance.
   * Used for tracking and referencing specific tool invocations.
   */
  id: Scalars['String']['output'];
  /** The serialized input parameters for this tool call, derived from the strongly-typed tool fields. */
  inputJson?: Maybe<Scalars['String']['output']>;
  /**
   * The raw JSON input provided by the LLM for this tool call. Some tools store this when
   * the input shape provided by the LLM is different from the shape that the tool schema
   * stores. This is used only to reconstruct the original tool call input when sending a
   * follow up API call to the LLM.
   */
  inputString?: Maybe<Scalars['String']['output']>;
  /**
   * Who initiated the invocation. ORCHESTRATED calls are replayed so later model
   * turns can use their outputs.
   */
  invocationSource?: Maybe<CaraWorkspaceToolInvocationSource>;
  listIntegrationObjectsTool?: Maybe<ListIntegrationObjectsTool>;
  listMailboxesTool?: Maybe<ListMailboxesTool>;
  memoryCreateTool?: Maybe<MemoryCreateTool>;
  memoryRefreshTool?: Maybe<MemoryRefreshTool>;
  /**
   * DEPRECATED: The name of the tool being called.
   * This field is deprecated in favor of using specific tool types.
   */
  name: Scalars['String']['output'];
  nowcertsWriteTool?: Maybe<NowCertsWriteTool>;
  organizeKnowledgeBaseTool?: Maybe<OrganizeKnowledgeBaseTool>;
  /** The serialized output for this tool call, derived from the strongly-typed tool fields. */
  outputJson?: Maybe<Scalars['String']['output']>;
  pdfEditorTool?: Maybe<PdfEditorTool>;
  peekFileTool?: Maybe<PeekFileTool>;
  qqcatalystWriteTool?: Maybe<QqCatalystWriteTool>;
  requestDocumentStyleTemplatesTool?: Maybe<RequestDocumentStyleTemplatesTool>;
  requestEmailTemplatesTool?: Maybe<RequestEmailTemplatesTool>;
  requestExcelSpreadsheetTemplatesTool?: Maybe<RequestExcelSpreadsheetTemplatesTool>;
  requestIntegrationToolsTool?: Maybe<RequestIntegrationToolsTool>;
  requestTemplateToolsTool?: Maybe<RequestTemplateToolsTool>;
  requestWordDocumentTemplatesTool?: Maybe<RequestWordDocumentTemplatesTool>;
  /**
   * DEPRECATED: The result of the tool call in JSON format.
   * This field is deprecated in favor of strongly-typed result fields in specific tool types.
   */
  result: Scalars['String']['output'];
  searchAmsLiveTool?: Maybe<SearchAmsLiveTool>;
  searchClientHistoryTool?: Maybe<SearchClientHistoryTool>;
  searchClientsTool?: Maybe<SearchClientsTool>;
  searchFileTool?: Maybe<SearchFileTool>;
  searchIntegrationTool?: Maybe<SearchIntegrationTool>;
  searchKnowledgeBaseTool?: Maybe<SearchKnowledgeBaseTool>;
  searchKnowledgeGraphTool?: Maybe<SearchKnowledgeGraphTool>;
  searchWebTool?: Maybe<SearchWebTool>;
  submitBulkEmailTool?: Maybe<SubmitBulkEmailTool>;
  thinkTool?: Maybe<ThinkTool>;
  /**
   * The exact timestamp when this tool call was made.
   * Used for auditing and tracking the sequence of tool calls.
   */
  timestamp: Scalars['Time']['output'];
  /** The type of tool call. */
  type?: Maybe<CaraWorkspaceTool>;
  /**
   * The string representation of the tool call type, in case it's not a valid type.
   * This happens when the type of the tool differs from the LLMs perspective (e.g. the
   * dynamic FILL_TEMPLATE_* tool names) or the LLM called a tool that is not supported.
   */
  typeString: Scalars['String']['output'];
  updateEmailDraftTool?: Maybe<UpdateEmailDraftTool>;
  updateKnowledgeBaseTool?: Maybe<UpdateKnowledgeBaseTool>;
  writeIntegrationTool?: Maybe<WriteIntegrationTool>;
  xlsxEditorTool?: Maybe<XlsxEditorTool>;
  zapierWriteTool?: Maybe<ZapierWriteTool>;
};

/**
 * Identifies who initiated a persisted workspace tool call. Legacy records omit this
 * field and are treated as MODEL calls.
 */
export enum CaraWorkspaceToolInvocationSource {
  /** The model selected and invoked the tool during its normal decision loop. */
  Model = 'MODEL',
  /**
   * Cara deterministically invoked the tool outside the model decision loop. These
   * calls are replayed to the model so later turns can use their outputs.
   */
  Orchestrated = 'ORCHESTRATED'
}

/**
 * A specific job inside a CaraWorkspacePreset. The preset picks the prompt
 * and tools; the use case picks wording, source roles, and which optional
 * fields to show. Values are the upper-cased form of the legacy
 * `Use Case: <id>` line so older clients stay interchangeable.
 */
export enum CaraWorkspaceUseCase {
  /** Compare a commission period against the prior one */
  AnalyzeCommission = 'ANALYZE_COMMISSION',
  /** Open-ended Q&A about an uploaded policy, quote, or binder */
  AskPolicyQuestion = 'ASK_POLICY_QUESTION',
  /** Build the open enrollment announcement and FAQ for employees */
  BuildAnnouncement = 'BUILD_ANNOUNCEMENT',
  /** Build the employee benefits guide for open enrollment */
  BuildBenefitsGuide = 'BUILD_BENEFITS_GUIDE',
  /**
   * Turn carrier rates into an employer and employee split per plan and tier, with several
   * employee benefits contribution structures priced side by side
   */
  BuildContributionWorksheet = 'BUILD_CONTRIBUTION_WORKSHEET',
  /**
   * Turn a chosen employee benefits contribution structure into per pay period deductions by plan,
   * tier, and class
   */
  BuildDeductionSchedule = 'BUILD_DEDUCTION_SCHEDULE',
  /** Build the employee benefits enrollment election form */
  BuildEnrollmentForm = 'BUILD_ENROLLMENT_FORM',
  /** Build the employer-facing comparison of the employee benefits finalists */
  BuildFinalistComparison = 'BUILD_FINALIST_COMPARISON',
  /** Build the internal employee benefits marketing grid across quoted options */
  BuildMarketingGrid = 'BUILD_MARKETING_GRID',
  /** Review classifications across a book of business in bulk */
  BulkClassReview = 'BULK_CLASS_REVIEW',
  /** Verify a quote or policy matches what was submitted on the application */
  CheckAgainstApplication = 'CHECK_AGAINST_APPLICATION',
  /** Assess errors and omissions exposure on a claim */
  CheckEoRisk = 'CHECK_EO_RISK',
  /** Classify business operations using ISO general liability codes */
  ClassifyIsoGl = 'CLASSIFY_ISO_GL',
  /** Classify business operations using NAICS codes */
  ClassifyNaics = 'CLASSIFY_NAICS',
  /** Classify business operations using SIC codes */
  ClassifySic = 'CLASSIFY_SIC',
  /** Normalize an employee benefits census and report its exceptions */
  CleanAndValidate = 'CLEAN_AND_VALIDATE',
  /** Pull insurance requirements from a lease and check against existing coverage */
  CompareLeaseToPolicy = 'COMPARE_LEASE_TO_POLICY',
  /** Side-by-side comparison of competing quote or policy options */
  CompareQuotes = 'COMPARE_QUOTES',
  /** Review what changed from the expiring policy to the renewal offer */
  CompareRenewal = 'COMPARE_RENEWAL',
  /** Compile claims history from loss runs */
  CompileLossHistory = 'COMPILE_LOSS_HISTORY',
  /** Convert commission statements into one register */
  ConvertStatement = 'CONVERT_STATEMENT',
  /**
   * Price the current employee benefits plan, the renewal, and any quoted options on one census,
   * split employer versus employee
   */
  CreateAnalysis = 'CREATE_ANALYSIS',
  /** Build any other client-facing document from source data */
  CreateOtherDocument = 'CREATE_OTHER_DOCUMENT',
  /** Build a competitive coverage proposal from quote options */
  CreateQuoteProposal = 'CREATE_QUOTE_PROPOSAL',
  /** Build a renewal proposal summarizing changes to an expiring policy */
  CreateRenewalProposal = 'CREATE_RENEWAL_PROPOSAL',
  /** Build a plain-language summary or client notice */
  CreateSummaryDocument = 'CREATE_SUMMARY_DOCUMENT',
  /** Comprehensive analysis of exclusions across all forms */
  ExploreExclusions = 'EXPLORE_EXCLUSIONS',
  /** Cross-fill an ACORD form from source documents */
  FillAcordForm = 'FILL_ACORD_FORM',
  /** Fill a due diligence questionnaire */
  FillDueDiligence = 'FILL_DUE_DILIGENCE',
  /** Fill a non-ACORD PDF form */
  FillOtherPdf = 'FILL_OTHER_PDF',
  /** Find alternative carriers for an existing risk */
  FindAlternativeCarriers = 'FIND_ALTERNATIVE_CARRIERS',
  /** Map an employee benefits census onto an enrollment platform or carrier layout */
  FormatForPlatform = 'FORMAT_FOR_PLATFORM',
  /** Full coverage gap analysis with recommended additional lines */
  FullGapAnalysis = 'FULL_GAP_ANALYSIS',
  /** Fill an ACORD certificate from a binder or policy */
  GenerateCertificate = 'GENERATE_CERTIFICATE',
  /** Generate auto ID cards from policy data */
  GenerateIdCards = 'GENERATE_ID_CARDS',
  /** Generate a client-facing risk management report */
  GenerateRiskReport = 'GENERATE_RISK_REPORT',
  /** Identify prioritized risk mitigations */
  IdentifyRiskMitigations = 'IDENTIFY_RISK_MITIGATIONS',
  /** Investigate a suspected material misrepresentation */
  InvestigatePotentialMisrep = 'INVESTIGATE_POTENTIAL_MISREP',
  /** Produce an underwriter-facing rate negotiation statement */
  NegotiateRenewalRate = 'NEGOTIATE_RENEWAL_RATE',
  /**
   * Reprice every quoted employee benefits option on one census and reproduce each carrier's own
   * total
   */
  NormalizeQuotes = 'NORMALIZE_QUOTES',
  /** Match a new submission to markets */
  PlaceNewSubmission = 'PLACE_NEW_SUBMISSION',
  /** Read an employee benefits group's claims experience ahead of the renewal conversation */
  PreRenewalReview = 'PRE_RENEWAL_REVIEW',
  /** Review an employee benefits group's claims experience and what is driving its cost */
  QuarterlyReview = 'QUARTERLY_REVIEW',
  /** Audit the first employee benefits carrier invoice after implementation */
  ReconcileFirstInvoice = 'RECONCILE_FIRST_INVOICE',
  /** Audit an ongoing employee benefits carrier invoice against enrollment and the bound rates */
  ReconcileMonthlyInvoice = 'RECONCILE_MONTHLY_INVOICE',
  /** Reconcile the accounting record of commission received against the management system */
  ReconcileReceipts = 'RECONCILE_RECEIPTS',
  /** Check what commission statements paid against what was owed */
  ReconcileStatement = 'RECONCILE_STATEMENT',
  /** Research alternative classifications to open up markets */
  ResearchAlternativeClassifications = 'RESEARCH_ALTERNATIVE_CLASSIFICATIONS',
  /** Research external risk signals behind a claim */
  ResearchClaimContext = 'RESEARCH_CLAIM_CONTEXT',
  /** Verify completeness and consistency of ACORD forms */
  ReviewAcords = 'REVIEW_ACORDS',
  /** Review an application for inconsistencies and underwriting issues */
  ReviewApplication = 'REVIEW_APPLICATION',
  /**
   * Check an employee benefits guide against the rate sheets, plan documents, and contributions
   * behind it
   */
  ReviewBenefitsGuide = 'REVIEW_BENEFITS_GUIDE',
  /** Plan next steps on an open claim */
  ReviewClaimPlanNextSteps = 'REVIEW_CLAIM_PLAN_NEXT_STEPS',
  /** Walk claim scenarios against current coverage */
  ReviewClaimScenarios = 'REVIEW_CLAIM_SCENARIOS',
  /** Review a claim against policy coverage to assess viability */
  ReviewClaimViability = 'REVIEW_CLAIM_VIABILITY',
  /** Check a certificate or evidence of insurance for accuracy and completeness */
  ReviewCoiEoi = 'REVIEW_COI_EOI',
  /** Compare a COI requirements list to the underlying policy documents */
  ReviewCoiRequirements = 'REVIEW_COI_REQUIREMENTS',
  /** Review current coverage against exposure */
  ReviewCurrentCoverage = 'REVIEW_CURRENT_COVERAGE',
  /** Review industry trends relevant to a risk */
  ReviewIndustryTrends = 'REVIEW_INDUSTRY_TRENDS',
  /** Check supplemental or carrier-specific forms for errors and omissions */
  ReviewSupplementals = 'REVIEW_SUPPLEMENTALS',
  /** Extract coverage requirements from a vendor or subcontractor agreement */
  ReviewVendorContract = 'REVIEW_VENDOR_CONTRACT',
  /** Solve for the employee benefits contribution structure that meets an employer's budget target */
  SolveToBudget = 'SOLVE_TO_BUDGET',
  /** Build a Statement of Values by researching a list of addresses */
  SovAddressOnly = 'SOV_ADDRESS_ONLY',
  /** Build a Statement of Values from documents, verified and enriched with public data */
  SovDocumentsAndWeb = 'SOV_DOCUMENTS_AND_WEB',
  /** Build a Statement of Values from uploaded documents alone */
  SovDocumentOnly = 'SOV_DOCUMENT_ONLY',
  /** Detailed summary of limits, sublimits, deductibles, and retentions */
  SummarizeCoverage = 'SUMMARIZE_COVERAGE',
  /** Verify an existing classification against the described operations */
  VerifyClassification = 'VERIFY_CLASSIFICATION',
  /** Check an employee benefits contributions worksheet against the carrier rate sheets */
  VerifyContributions = 'VERIFY_CONTRIBUTIONS',
  /** Verify insured details against supporting documents and public data */
  VerifyInsuredInfo = 'VERIFY_INSURED_INFO'
}

/**
 * One filled worksheet of an XLSX artifact produced by the XLSX_EDITOR tool. Unlike DOCX
 * sections, tabs are not separate files: the workbook is filled in place, one worksheet at a
 * time, so a tab records only what was written and the program that wrote it.
 */
export type CaraXlsxTab = {
  __typename?: 'CaraXlsxTab';
  /**
   * A short synopsis of what was written to this worksheet, generated when the tab was
   * filled or last edited. Null when no synopsis was recorded.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The worksheet name in the generated workbook */
  name: Scalars['String']['output'];
  /** The Python program that filled this worksheet, kept for debugging and audit */
  pythonCode?: Maybe<Scalars['String']['output']>;
  /** The ID of the template tab this worksheet was filled from */
  templateTabId: Scalars['String']['output'];
};

/**
 * Configuration for a business's auto liability policy's Certificate of Insurance (COI).
 * Contains details about auto coverage types, limits, and policy information.
 */
export type CertificateAutoLiabilitySection = {
  __typename?: 'CertificateAutoLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** Whether coverage applies to any auto */
  anyAutoLiability: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Whether coverage applies only to hired autos */
  hiredAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Coverage limit for bodily injury per accident */
  limitBodilyInjuryPerAccident: Scalars['Float']['output'];
  /** Coverage limit for bodily injury per person */
  limitBodilyInjuryPerPerson: Scalars['Float']['output'];
  /** Coverage limit for each accident */
  limitCombinedSingleLimitPerAccident: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for property damage per accident */
  limitPropertyDamagePerAccident: Scalars['Float']['output'];
  /** Whether coverage applies only to non-owned autos */
  nonOwnedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether coverage applies only to owned autos */
  ownedAutosOnlyLiability: Scalars['Boolean']['output'];
  /** The auto liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the auto liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether coverage applies only to scheduled autos */
  scheduledAutosOnlyLiability: Scalars['Boolean']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateEntity represents an entity involved in the insurance certificate. */
export type CertificateEntity = {
  __typename?: 'CertificateEntity';
  /** The address of the entity */
  address: Address;
  /** The name of the entity */
  name: Scalars['String']['output'];
};

/** Input for a certificate entity */
export type CertificateEntityInput = {
  /** The address of the entity */
  address: AddressInput;
  /** The name of the entity */
  name: Scalars['String']['input'];
};

/** Input for the holder of the certificate */
export type CertificateHolderInput = {
  /** The address of the holder */
  address: AddressInput;
  /** The name of the holder */
  name: Scalars['String']['input'];
};

/**
 * Configuration for a business's liability policy's Certificate of Insurance (COI).
 * Contains details about coverage types, limits, and policy information.
 */
export type CertificateLiabilitySection = {
  __typename?: 'CertificateLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** How the general aggregate limit applies - per policy, project, location or other */
  generalAggregateLimitAppliesPer: GeneralAggregateLimitAppliesPerType;
  /** Description of other general aggregate limit application if type is OTHER */
  generalAggregateLimitAppliesPerOther?: Maybe<Scalars['String']['output']>;
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for damage to rented premises per occurrence */
  limitDamageToPremisesEachOccurrence: Scalars['Float']['output'];
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerOccurrence: Scalars['Float']['output'];
  /** Coverage limit for medical expenses per person */
  limitMedicalExpensePerPerson: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** Coverage limit for personal and advertising injury */
  limitPersonalAndAdvertisingInjury: Scalars['Float']['output'];
  /** Coverage limit for products and completed operations */
  limitProductsAndCompletedOperations: Scalars['Float']['output'];
  /** The liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the liability coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

/** CertificateLimit represents a limit associated with an insurance certificate. */
export type CertificateLimit = {
  __typename?: 'CertificateLimit';
  /** The amount of the limit */
  amount: Scalars['Float']['output'];
  /** The name of the limit */
  name: Scalars['String']['output'];
};

/** Configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfiguration = {
  __typename?: 'CertificateOfLiabilityAgencyConfiguration';
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['output'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data: Scalars['String']['output'];
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['output'];
  /** Fax number of the agency contact person for COI-related inquiries */
  contactFax: Scalars['String']['output'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['output'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['output'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntity;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['output'];
};

/** Input configuration for an agency's Certificate of Insurance (COI) settings */
export type CertificateOfLiabilityAgencyConfigurationInput = {
  /** The name of the authorized representative */
  authorizedRepName: Scalars['String']['input'];
  /** Base64-encoded signature image data used for signing COIs */
  authorizedRepSignatureBase64Data?: InputMaybe<Scalars['String']['input']>;
  /** Email address of the agency contact person for COI-related inquiries */
  contactEmail: Scalars['String']['input'];
  /** Name of the agency contact person for COI-related inquiries */
  contactName: Scalars['String']['input'];
  /** Phone number of the agency contact person for COI-related inquiries */
  contactPhone: Scalars['String']['input'];
  /** The producer entity information that appears on COIs issued by this agency */
  producer: CertificateEntityInput;
  /** Whether to render the COI fields in all caps */
  renderAllCaps: Scalars['Boolean']['input'];
};

/** Configuration for a business's Certificate of Insurance (COI) */
export type CertificateOfLiabilityInsurance = {
  __typename?: 'CertificateOfLiabilityInsurance';
  /** Configuration for the agency that produced the COI */
  agency: CertificateOfLiabilityAgencyConfiguration;
  /** Configuration for the business's auto liability policy's Certificate of Insurance (COI) */
  autoLiability?: Maybe<CertificateAutoLiabilitySection>;
  /** The certificate number for the COI */
  certificateNumber: Scalars['String']['output'];
  /** The date the COI was created */
  createdAt: Scalars['Time']['output'];
  /** Description of the business's operations, used for generating COIs */
  descriptionOfOperations: Scalars['String']['output'];
  /** The URL that the COI can be downloaded at */
  downloadUrl: Scalars['String']['output'];
  /** The holder entity information that appears on COIs issued by this business */
  holder: CertificateEntity;
  /** The unique identifier for the certificate */
  id: Scalars['ID']['output'];
  /** The insured entity information that appears on COIs issued by this business */
  insured: CertificateEntity;
  /** Configuration for the business's liability policy's Certificate of Insurance (COI) */
  liability?: Maybe<CertificateLiabilitySection>;
  /** Configuration for the business's other policy's Certificate of Insurance (COI) */
  other?: Maybe<CertificateOtherSection>;
  /** Configuration for the business's umbrella or excess liability policy's Certificate of Insurance (COI) */
  umbrellaOrExcessLiability?: Maybe<CertificateUmbrellaOrExcessLiabilitySection>;
  /** The date the COI was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The URL that the COI can be viewed at */
  viewUrl: Scalars['String']['output'];
  /** Configuration for the business's workers' compensation policy's Certificate of Insurance (COI) */
  workersCompensation?: Maybe<CertificateWorkersCompensationSection>;
};

/**
 * Configuration for any other type of policy's Certificate of Insurance (COI).
 * Contains details about the coverage type, limits, and policy information.
 */
export type CertificateOtherSection = {
  __typename?: 'CertificateOtherSection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Description of the type of coverage */
  coverageType: Scalars['String']['output'];
  /** List of coverage limits and their amounts */
  limits: Array<CertificateLimit>;
  /** The other policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

export enum CertificateType {
  /** Certificate of Liability Insurance */
  Liability = 'LIABILITY',
  /** Certificate of Property Insurance */
  Property = 'PROPERTY'
}

/**
 * Configuration for a business's umbrella or excess liability policy's Certificate of Insurance (COI).
 * Contains details about umbrella/excess coverage, limits, and policy information.
 */
export type CertificateUmbrellaOrExcessLiabilitySection = {
  __typename?: 'CertificateUmbrellaOrExcessLiabilitySection';
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['output'];
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Deductible amount for the coverage */
  deductible: Scalars['Float']['output'];
  /** Whether this is excess liability coverage */
  excessLiability: Scalars['Boolean']['output'];
  /** Type of liability coverage - either claims made or occurrence based */
  liabilityCoverageType: LiabilityCoverageType;
  /** Coverage limit for each occurrence */
  limitEachOccurrence: Scalars['Float']['output'];
  /** General aggregate coverage limit */
  limitGeneralAggregate: Scalars['Float']['output'];
  /** Amount of any other coverage limit */
  limitOtherAmount: Scalars['Float']['output'];
  /** Name of any other coverage limit */
  limitOtherName: Scalars['String']['output'];
  /** The umbrella or excess liability policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the umbrella/excess coverage */
  policyNumber: Scalars['String']['output'];
  /** Retention limit for the coverage */
  retentionLimit: Scalars['Float']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
  /** Whether this is umbrella liability coverage */
  umbrellaLiability: Scalars['Boolean']['output'];
};

/**
 * Configuration for a business's workers' compensation policy's Certificate of Insurance (COI).
 * Contains details about workers' comp coverage, limits, and policy information.
 */
export type CertificateWorkersCompensationSection = {
  __typename?: 'CertificateWorkersCompensationSection';
  /** NAIC code of the carrier */
  carrierNaic: Scalars['String']['output'];
  /** Name of the carrier */
  carrierName: Scalars['String']['output'];
  /** Name of any party excluded from coverage */
  excludedPartyName?: Maybe<Scalars['String']['output']>;
  /** Coverage limit per accident */
  limitPerAccident: Scalars['Float']['output'];
  /** Coverage limit per employee */
  limitPerEmployee: Scalars['Float']['output'];
  /** Coverage limit per policy */
  limitPerPolicy: Scalars['Float']['output'];
  /** Whether the coverage limits are provided per statute */
  limitsStatutory: Scalars['Boolean']['output'];
  /** The workers' compensation policy this COI configuration is associated with, if any */
  policy?: Maybe<BusinessPolicy>;
  /** Date the policy becomes effective */
  policyEffectiveDate: Scalars['Time']['output'];
  /** Date the policy expires */
  policyExpirationDate: Scalars['Time']['output'];
  /** Policy number for the workers' compensation coverage */
  policyNumber: Scalars['String']['output'];
  /** Whether subrogation is waived */
  subrogationWaiver: Scalars['Boolean']['output'];
};

export type ChangeEmailBulkSendTimeInput = {
  /** One per Change time click, so a repeated click returns the batch the first one moved. */
  attemptId: Scalars['String']['input'];
  /** When the first email goes out, at least 5 minutes ahead. */
  sendAt: Scalars['Time']['input'];
};

export type ChooseSmartFillOptionInput = {
  bucketId: Scalars['ID']['input'];
  expectedBucketRevision: Scalars['Int64']['input'];
  /** How the page presents the question: context only, never a source fact. */
  label?: InputMaybe<Scalars['String']['input']>;
  /**
   * Option labels the page displayed for those searches, in display order. A
   * sample of a searchable list, not its complete contents.
   */
  options: Array<Scalars['String']['input']>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  propertyId: Scalars['ID']['input'];
  /** Searches the browser already typed into the question's search box. */
  queries?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The resolve request whose decision assigned the property. */
  requestId: Scalars['ID']['input'];
  sectionHeading?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces and agency users are not modeled
 * here and have no Go type either. They are join rows, and the reads that back
 * those fields resolve through them to the entity on the far side, so nothing
 * needs to name the row itself. ClientAmsAccount is the exception: a link exists
 * before the account behind it syncs, so the row is what there is to return.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type Client = {
  __typename?: 'Client';
  /**
   * Null when nothing is known about the address. Because Address requires line1,
   * city, zone and postalCode together while the stored columns are individually
   * nullable, a partially known address reports empty strings for the parts that
   * are unknown rather than being dropped.
   */
  address?: Maybe<Address>;
  /**
   * The agency user primarily responsible for this client, if one is assigned.
   * Additional users in other roles are recorded separately.
   */
  agencyUserOwner?: Maybe<AgencyUser>;
  /**
   * Agency users associated with this client beyond agencyUserOwner, oldest link
   * first. The producer/servicer relationship on the link is not exposed: nothing
   * reads it, so an edge type in the shape of TeamMember would carry data no caller
   * wants. That remains the way to expose it if that changes.
   */
  agencyUsers: Array<AgencyUser>;
  /**
   * The AMS accounts this client resolves to, primary first. A link naming another
   * agency's integration, or a deleted one, is left out.
   */
  amsAccounts: Array<ClientAmsAccount>;
  /**
   * Artifacts Cara generated for this client, newest first by the artifact's own
   * timestamp rather than by when it was associated -- the backfill stamps every
   * association in one pass, so link order carries no meaning.
   *
   * Spans every workspace linked to the client, so an artifact here may belong to a
   * workspace other than the one being viewed. Documents a user removed from the
   * client are excluded.
   *
   * Filtered to what the caller can see, matching the caraWorkspaceArtifacts query,
   * and to active artifacts: an archived one is archived everywhere it is listed,
   * and comes back through the archived Documents view rather than here.
   *
   * Paginated by a keyset on the sort key, so a page is stable as documents are
   * added. A cursor is only valid with the sort it was issued under. first defaults
   * to 50 and is capped at 200. Resolved per client rather than batched, so
   * selecting it on a list query is N+1; it is meant for one client at a time.
   */
  artifacts: ClientArtifactConnection;
  /**
   * How much is attached to this client, for comparing two records -- which is how
   * the merge queue says which of a duplicate pair is the real one.
   */
  associationCounts: ClientAssociationCounts;
  createdAt: Scalars['Time']['output'];
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Source tags for this client's own fields. Sparse: a field a person typed in
   * directly carries none, and a tag applies only while the client still holds
   * the value it describes -- so editing a value retires its tag without anything
   * having to go and find it.
   *
   * AMS_SOURCED and CARA_GENERATED are derived by comparing the client's value
   * against the normalized rows behind its links, so they cannot fall out of step
   * with a sync. A stored tag wins over a derived one for the same field -- a
   * person who confirmed a value has said something the comparison cannot -- and
   * an AMS wins over Cara, which is reading its own earlier guess.
   */
  fieldProvenance?: Maybe<Array<ClientFieldProvenance>>;
  /**
   * Files people uploaded for this client, newest first. Deleted files and files a
   * user removed from the client are excluded. Paginated and sorted like artifacts
   * above.
   */
  files: ClientFileConnection;
  id: Scalars['ID']['output'];
  /**
   * Whether this client holds commercial lines. Independent of isPersonal -- both
   * may be true, for example a sole proprietor holding personal and commercial
   * policies.
   */
  isCommercial: Scalars['Boolean']['output'];
  /** Whether this client holds personal lines. See isCommercial. */
  isPersonal: Scalars['Boolean']['output'];
  /**
   * The linked workspace updated most recently, among those the caller can see and
   * that are not archived. Null for a client with no such workspace. Batched, so
   * it is cheap enough to select on every row of the Clients list.
   */
  latestWorkspace?: Maybe<ClientWorkspaceSummary>;
  name: Scalars['String']['output'];
  /**
   * Unresolved pairs this client is on one side of, most alike first, so the detail
   * view can raise a possible duplicate where someone will meet it rather than only
   * in the queue. Empty for almost every client.
   */
  pendingMergeCandidates: Array<ClientMergeCandidate>;
  phone?: Maybe<Scalars['String']['output']>;
  /**
   * Synced AMS accounts that look like this client, best first, for the picker to
   * offer when the user links one by hand.
   *
   * Ranked from the client's own name, email and phone; an exact email or phone
   * match outranks any name score, and a name alone is never presented as more
   * than a similar name. Accounts another client already holds are left out, since
   * one AMS account belongs to at most one client and linking it would be refused.
   *
   * Empty for an agency whose AMS syncs no accounts, and for one with no AMS at
   * all. Those agencies reach their accounts through the AMS browser, which falls
   * back to a live AMS lookup.
   */
  suggestedAmsAccounts: Array<AmsAccountMatch>;
  updateInitiatorId: Scalars['String']['output'];
  /**
   * What last wrote this record. Lets a re-runnable backfill avoid overwriting
   * anything a human asserted.
   */
  updateInitiatorType: UpdateInitiatorType;
  updatedAt: Scalars['Time']['output'];
};


/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces and agency users are not modeled
 * here and have no Go type either. They are join rows, and the reads that back
 * those fields resolve through them to the entity on the far side, so nothing
 * needs to name the row itself. ClientAmsAccount is the exception: a link exists
 * before the account behind it syncs, so the row is what there is to return.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type ClientArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientArtifactFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClientDocumentSortInput>;
};


/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces and agency users are not modeled
 * here and have no Go type either. They are join rows, and the reads that back
 * those fields resolve through them to the entity on the far side, so nothing
 * needs to name the row itself. ClientAmsAccount is the exception: a link exists
 * before the account behind it syncs, so the row is what there is to return.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type ClientFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFileFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClientDocumentSortInput>;
};


/**
 * A business or individual the agency serves. "Client" rather than "insured"
 * because the relationship starts before any coverage does: a prospect with neither
 * a policy nor a quote is still a client. Distinct from a contact -- the humans
 * attached to a policy are not Client records.
 *
 * Address and contact fields are absent for a large share of records. The knowledge
 * graph is the only trustworthy source for them and most agencies have no synced
 * AMS data, so a client with only a name is a complete record of what is known
 * rather than a partial one.
 *
 * The rows linking a client to its workspaces and agency users are not modeled
 * here and have no Go type either. They are join rows, and the reads that back
 * those fields resolve through them to the entity on the far side, so nothing
 * needs to name the row itself. ClientAmsAccount is the exception: a link exists
 * before the account behind it syncs, so the row is what there is to return.
 *
 * The two enums above stay in this schema only so their Go constants keep being
 * generated. No field is typed on either, so gqlgen validates nothing at the
 * boundary, and the columns they describe carry no CHECK constraint.
 */
export type ClientSuggestedAmsAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The role an agency user plays on a client. Producer and Servicer are user
 * designations; automated processes only ever assign UNASSIGNED.
 */
export enum ClientAgencyUserRelationship {
  Producer = 'PRODUCER',
  Servicer = 'SERVICER',
  Unassigned = 'UNASSIGNED'
}

/**
 * One client-to-AMS-account link.
 *
 * The field returns the link rather than the AMS account itself: a link exists as
 * soon as the pair is stored, while the synced account behind it often does not,
 * so returning the account would make most links disappear.
 */
export type ClientAmsAccount = {
  __typename?: 'ClientAmsAccount';
  /**
   * The synced account behind the link. Null is ordinary rather than an error: a
   * user can link an account Cara has not synced yet, which is the common case for
   * the 61% of agencies with no synced AMS data.
   */
  account?: Maybe<KnowledgeGraphEntity>;
  /** The AMS's own identifier for the account. */
  amsExternalId: Scalars['String']['output'];
  integrationId: Scalars['ID']['output'];
  /** Which AMS this account lives in, resolved from the agency's integrations. */
  integrationType: IntegrationType;
  /**
   * Whether this is the account an automated write targets. At most one per
   * client, which the database enforces.
   */
  isPrimary: Scalars['Boolean']['output'];
};

/**
 * Names one of a client's AMS links. The integration and the external id are its
 * identity; the entity id is a convenience, checked against the pair rather than
 * trusted, and derived from it when the caller gives none.
 */
export type ClientAmsAccountInput = {
  amsExternalId: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
  /**
   * The synced account, when the caller has one. Stored alongside the AMS
   * identifier rather than instead of it, so a link can be made before any sync.
   *
   * Omitting it does not assert there is none: the server resolves the account
   * from the pair, and stores null only when no sync has produced one.
   */
  knowledgeGraphEntityId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * A page of a client's documents.
 *
 * No totalCount: an exact total needs a count over every matching row, which is
 * the scan the page size exists to avoid, and nothing in the UI needs the number
 * badly enough to pay for it. hasNextPage answers what a "Load more" needs.
 */
export type ClientArtifactConnection = {
  __typename?: 'ClientArtifactConnection';
  edges: Array<ClientArtifactEdge>;
  pageInfo: PageInfo;
};

export type ClientArtifactEdge = {
  __typename?: 'ClientArtifactEdge';
  cursor: Scalars['String']['output'];
  node: CaraWorkspaceArtifactSummary;
};

/**
 * Narrows a client's artifacts. Every field is optional, and the set ones must all
 * match.
 */
export type ClientArtifactFilterInput = {
  /** Artifacts from workspaces this agency user opened. */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Artifacts whose newest version was created at or after this time. */
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Case-insensitive substring match on the title of the artifact's latest version,
   * which is the title the list shows.
   */
  search?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Counts of what hangs off a client. Each is a grouped count over one link table,
 * so unlike the document connections below this is cheap enough to select for
 * every row of a list.
 *
 * No document count, for the reason ClientArtifactConnection gives for having no
 * totalCount, and because most documents are reached through a linked workspace --
 * so workspaces already carries most of that signal.
 */
export type ClientAssociationCounts = {
  __typename?: 'ClientAssociationCounts';
  amsAccounts: Scalars['Int']['output'];
  notes: Scalars['Int']['output'];
  workspaces: Scalars['Int']['output'];
};

export type ClientConnection = {
  __typename?: 'ClientConnection';
  edges: Array<ClientEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Input for creating a certificate of insurance on the client side */
export type ClientCreateCertificateInput = {
  /**
   * If the holder is an additional insured, and is one of the allowed blanket or named insureds,
   * then this is the ID of the additional insured.
   */
  additionalInsuredId?: InputMaybe<Scalars['String']['input']>;
  /** The holder of the certificate. */
  holder: CertificateHolderInput;
  /** Whether the holder is an additional insured. */
  isAdditionalInsured: Scalars['Boolean']['input'];
  /** Whether the holder is an additional insured, but not an allowed blanket or named insured. */
  isOtherAdditionalInsured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Any additional notes for the agency to review when creating the certificate. */
  notes: Scalars['String']['input'];
  /**
   * If the holder is an additional insured, but not an allowed blanket or named insured,
   * then this is the relationship of the additional insured to the holder.
   */
  otherAdditionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
};

/** Result of creating a certificate of insurance on the client side */
export type ClientCreateCertificateResult = {
  __typename?: 'ClientCreateCertificateResult';
  /** The certificate of insurance that was created, if successful. */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  /** The result code of the client create certificate result */
  code: ClientCreateCertificateResultCode;
  /** If the certificate was not created, the service request that was created for the agency to review. */
  serviceRequest?: Maybe<ServiceRequest>;
};

/** The result code of the client create certificate result */
export enum ClientCreateCertificateResultCode {
  /** There was an error creating the certificate, and a service request was created for the agency to review. */
  Error = 'ERROR',
  /** A policy may need to be endorsed prior to certificate creation, and a service request was created for the agency to handle. */
  RequiresEndorsement = 'REQUIRES_ENDORSEMENT',
  /** The certificate request needs to be reviewed prior to creation, and a service request was created for the agency to review. */
  RequiresReview = 'REQUIRES_REVIEW',
  /** The certificate was successfully created. */
  Success = 'SUCCESS'
}

export enum ClientDocumentSortField {
  /** When the document was created. For an artifact, its newest version. */
  CreatedAt = 'CREATED_AT',
  /** The artifact title or file name, case-insensitively. */
  Name = 'NAME'
}

/**
 * Direction defaults per field when omitted -- NAME ascending, CREATED_AT
 * descending. Omitting the input entirely sorts by CREATED_AT descending.
 */
export type ClientDocumentSortInput = {
  direction?: InputMaybe<SortDirection>;
  field: ClientDocumentSortField;
};

export type ClientEdge = {
  __typename?: 'ClientEdge';
  cursor: Scalars['String']['output'];
  node: Client;
};

/**
 * A field of a client's record whose source can be shown. The values are spelled
 * as the Client type spells the fields themselves.
 */
export enum ClientField {
  /**
   * The whole mailing address, compared and confirmed as one unit rather than
   * line by line: a merge of parts would invent an address the client never had.
   */
  Address = 'ADDRESS',
  Email = 'EMAIL',
  /** The client's own name, not a contact's. */
  Name = 'NAME',
  Phone = 'PHONE'
}

/**
 * One field's source tag. Fields with no tag are those someone typed in
 * directly, which the record shows plainly.
 *
 * Named for the client because `field` is a ClientField and the row carries a
 * client id: a contact's or a policy's fields need their own type rather than a
 * breaking change to this one. FieldSource is deliberately not named that way --
 * where a value came from means the same thing whatever holds it.
 */
export type ClientFieldProvenance = {
  __typename?: 'ClientFieldProvenance';
  /** Who confirmed the value. Set only on HUMAN_CONFIRMED. */
  confirmedBy?: Maybe<AgencyUser>;
  field: ClientField;
  /**
   * Stable within a record, but an AMS-sourced tag is derived rather than stored,
   * so its id is synthesized and means nothing to the database.
   */
  id: Scalars['ID']['output'];
  /**
   * Which AMS the value was copied from. Set only on AMS_SOURCED: Cara is an
   * integration of its own in the normalized tables, and naming it here would
   * read as a system of record it is not.
   */
  integrationType?: Maybe<IntegrationType>;
  /** When the value was confirmed, or last written in the system it came from. */
  recordedAt: Scalars['Time']['output'];
  source: FieldSource;
  /**
   * The AMS login the sync recorded as having last touched the account. Set only
   * on AMS_SOURCED, and not a Cara user: most AMSes report a bare username, and
   * some report an employee code, so a client should check it names a person
   * before showing it.
   */
  sourceUpdatedBy?: Maybe<Scalars['String']['output']>;
  /**
   * An opaque token for the value this tag describes: a rendering made for
   * comparison, not for display -- a phone arrives as E.164 and an address as its
   * parts joined by "|". Echo it back to confirmClientField; do not show it.
   *
   * A tag is served only while the client's field still renders to this.
   */
  value: Scalars['String']['output'];
};

export type ClientFileConnection = {
  __typename?: 'ClientFileConnection';
  edges: Array<ClientFileEdge>;
  pageInfo: PageInfo;
};

export type ClientFileEdge = {
  __typename?: 'ClientFileEdge';
  cursor: Scalars['String']['output'];
  node: File;
};

/**
 * Narrows a client's files. Every field is optional, and the set ones must all
 * match.
 */
export type ClientFileFilterInput = {
  /** Files uploaded at or after this time. */
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Case-insensitive substring match on the file name. */
  search?: InputMaybe<Scalars['String']['input']>;
};

export type ClientFilterInput = {
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  /** False for clients with no owner assigned, true for clients with one. */
  hasOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to clients holding commercial or personal lines. Both may be set, in
   * which case a client matching either is returned.
   */
  isCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Case-insensitive substring match on name. This is what the
   * workspace-association picker searches on.
   */
  nameQuery?: InputMaybe<Scalars['String']['input']>;
  /**
   * Case-insensitive substring match on name, any name merged into the client,
   * or email. A query with three or more digits also matches phone numbers
   * regardless of formatting.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Clients whose record was updated at or after this time. */
  updatedAfter?: InputMaybe<Scalars['Time']['input']>;
};

export type ClientGroupMergeInput = {
  /**
   * Merged in this order, which is also the order the default rule fills the
   * survivor's blanks from: the first absorbed client with a value wins. At most
   * nine, none repeated and none the survivor.
   */
  absorbedClientIds: Array<Scalars['String']['input']>;
  /** Omitted or empty means every field follows the default rule. */
  fields?: InputMaybe<ClientMergeFieldSourcesInput>;
  survivorClientId: Scalars['String']['input'];
};

/** Fields a user can set when creating a client. */
export type ClientInput = {
  address?: InputMaybe<AddressInput>;
  /**
   * The agency user primarily responsible for this client. Must belong to the
   * caller's agency.
   */
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isCommercial: Scalars['Boolean']['input'];
  isPersonal: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * How a client association was established, in descending order of confidence.
 * Stored per association, since different links for one client can be established
 * different ways.
 */
export enum ClientMatchMethod {
  /** A successful AMS write that returned an external ID. Deterministic. */
  AmsWrite = 'AMS_WRITE',
  /**
   * The name declared its own identity with "doing business as", and the legal half
   * matched another client exactly. No threshold is consulted, so this ranks with
   * the deterministic methods rather than the scored ones.
   */
  DbaDeclaration = 'DBA_DECLARATION',
  /** Exact, case-insensitive email match. */
  EmailExact = 'EMAIL_EXACT',
  /** IDF-weighted token similarity above the "likely" threshold. */
  IdfSimilarity = 'IDF_SIMILARITY',
  /**
   * Name similarity corroborated by at least one structured attribute. Name
   * similarity alone is never sufficient to establish a link.
   */
  NamePlusAttribute = 'NAME_PLUS_ATTRIBUTE',
  /** Exact match after normalization of case, punctuation, and legal suffix. */
  NormalizedName = 'NORMALIZED_NAME',
  /** Exact phone match on E.164 values. */
  PhoneExact = 'PHONE_EXACT',
  /** An AMS entity a workspace tool call already resolved. Deterministic. */
  ToolCallEntity = 'TOOL_CALL_ENTITY'
}

/**
 * How confident the matcher is that a suggested client is the workspace's client.
 *
 * Mirrors the matching library's own verdicts rather than a score band the client
 * re-derives, so the UI, the backfill and the merge queue describe a pair the same
 * way. There is no DIFFERENT: those are not suggested at all.
 */
export enum ClientMatchVerdict {
  /**
   * Close enough to show, not close enough to act on. The strings do not contain
   * enough information to decide.
   */
  Ambiguous = 'AMBIGUOUS',
  /**
   * Identical after normalization, or after word boundaries are removed. Decided by
   * key equality, with no threshold involved.
   */
  Exact = 'EXACT',
  /**
   * Scored above the auto-merge threshold. Note that threshold is provisional until
   * the matcher is calibrated, so this is a strong hint, not a fact.
   */
  Likely = 'LIKELY'
}

/**
 * One pair of clients that may or may not be the same client, awaiting a person's
 * decision.
 *
 * The pair is unordered -- clientA and clientB are stored in a fixed order so the
 * same two clients cannot be queued twice, and that order carries no meaning about
 * which should survive a merge.
 */
export type ClientMergeCandidate = {
  __typename?: 'ClientMergeCandidate';
  clientA: Client;
  clientB: Client;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  reason: ClientMergeCandidateReason;
  resolvedAt?: Maybe<Scalars['Time']['output']>;
  /** Null while PENDING. */
  resolvedBy?: Maybe<AgencyUser>;
  /**
   * How alike the two names are, 0 to 1. Only meaningful for NAME_AMBIGUOUS; the
   * deterministic reasons report 1.
   */
  score: Scalars['Float']['output'];
  status: ClientMergeCandidateStatus;
};

export type ClientMergeCandidateConnection = {
  __typename?: 'ClientMergeCandidateConnection';
  edges: Array<ClientMergeCandidateEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClientMergeCandidateEdge = {
  __typename?: 'ClientMergeCandidateEdge';
  cursor: Scalars['String']['output'];
  node: ClientMergeCandidate;
};

/**
 * Why the matcher declined to decide, which is also how much a human should trust
 * the pairing before acting on it.
 */
export enum ClientMergeCandidateReason {
  /**
   * Two clients resolved to the same AMS account. Deterministic rather than
   * scored, so these are the pairs closest to being safe to merge unattended.
   */
  AmsLinkAmbiguous = 'AMS_LINK_AMBIGUOUS',
  /**
   * The same client appears to be present in two connected AMSes. Common: 53 of
   * 196 agencies with active integrations have more than one.
   */
  CrossIntegration = 'CROSS_INTEGRATION',
  /**
   * Name scoring landed in the band no threshold separates. Weakest signal here:
   * the information that would decide it -- address, phone, FEIN -- is not in the
   * name.
   */
  NameAmbiguous = 'NAME_AMBIGUOUS',
  /**
   * A person picked the pair by hand from the Clients list, so the matcher never
   * scored it. Only ever seen resolved: the pair went straight to MERGED. score
   * reports 1.
   */
  UserSelected = 'USER_SELECTED'
}

/**
 * Where a pair stands. Both resolved states are permanent as far as matching is
 * concerned -- neither is re-raised by a later backfill run.
 */
export enum ClientMergeCandidateStatus {
  /**
   * A person said these are different clients. Sticky: no later run may re-queue
   * the pair or merge it automatically.
   */
  KeptSeparate = 'KEPT_SEPARATE',
  /** Merged, with clientA and clientB naming the survivor and the absorbed record. */
  Merged = 'MERGED',
  Pending = 'PENDING'
}

/**
 * Which client each attribute of a many-way merge is taken from, named by id. Each
 * id must be the survivor or one of the absorbed clients. Otherwise as
 * ClientMergeFieldsInput: an omitted field follows the default rule, and a given
 * one takes that client's value as it stands.
 */
export type ClientMergeFieldSourcesInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  agencyUserOwner?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Field-level choices for a merge. An omitted field follows the default rule
 * described on mergeClients; a given one takes that record's value as it stands,
 * so choosing ABSORBED for a field the absorbed record has blank clears it.
 *
 * The address is chosen as a unit. Merging it part by part would invent a third
 * address that neither client ever had.
 *
 * The name is not choosable: the survivor keeps its own. The backfill finds a
 * client by its current name and a merged client by the name it was merged
 * under, so a survivor renamed to the absorbed name would leave its old name
 * nowhere the backfill can see, and the next run would recreate it. Choosing
 * which record survives is how the name is chosen.
 *
 * Lines of business are not choosable: a client that held commercial lines on
 * either record holds them on the merged one.
 */
export type ClientMergeFieldsInput = {
  address?: InputMaybe<ClientMergeValueSource>;
  agencyUserOwner?: InputMaybe<ClientMergeValueSource>;
  email?: InputMaybe<ClientMergeValueSource>;
  phone?: InputMaybe<ClientMergeValueSource>;
};

export type ClientMergeInput = {
  absorbedClientId: Scalars['ID']['input'];
  /** Omitted or empty means every field follows the default rule. */
  fields?: InputMaybe<ClientMergeFieldsInput>;
  survivorClientId: Scalars['ID']['input'];
};

/**
 * Which record's value the merged client keeps for a field the two records
 * disagree on.
 */
export enum ClientMergeValueSource {
  Absorbed = 'ABSORBED',
  Survivor = 'SURVIVOR'
}

/**
 * A free-form note a user wrote on a client.
 *
 * Notepad-style on purpose: plain text, no formatting model, no mentions, no
 * attachments. AI-generated notes are out of scope for this phase, and client-level
 * "memories" are a separate later concept rather than a richer version of this.
 *
 * There is no edit history. An edit rewrites the body and bumps updatedAt, so
 * author plus those two timestamps is the whole provenance a note carries.
 */
export type ClientNote = {
  __typename?: 'ClientNote';
  /**
   * Who wrote the note. Stays the original author across edits, since an edit
   * rewrites the body rather than creating a new note.
   */
  author?: Maybe<AgencyUser>;
  body: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  updatedAt: Scalars['Time']['output'];
};

export enum ClientSortField {
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT'
}

/**
 * Direction defaults per field when omitted -- NAME ascending for an alphabetical
 * list, UPDATED_AT descending for most-recent-first.
 */
export type ClientSortInput = {
  direction?: InputMaybe<SortDirection>;
  field: ClientSortField;
};

/**
 * A client a workspace might belong to.
 *
 * Suggestions only. Confirming one is an explicit user action through
 * linkClientWorkspace -- nothing here links automatically, because a wrong link
 * buries a workspace under the wrong client's history and is close to invisible
 * afterwards.
 */
export type ClientSuggestion = {
  __typename?: 'ClientSuggestion';
  client: Client;
  /**
   * IDF-weighted token similarity, 0 to 1, for ordering and for showing the user
   * how strong a match is. Exact matches score 1.0.
   */
  score: Scalars['Float']['output'];
  verdict: ClientMatchVerdict;
};

export type ClientToolAmsAccount = {
  __typename?: 'ClientToolAmsAccount';
  /** The account's identifier within that AMS. */
  externalId: Scalars['String']['output'];
  /** Which AMS the account lives in, for example HAWKSOFT or APPLIED_EPIC. */
  integrationType: Scalars['String']['output'];
  /** True for the account treated as this client's primary AMS record. */
  isPrimary: Scalars['Boolean']['output'];
};

export type ClientToolArtifact = {
  __typename?: 'ClientToolArtifact';
  createdAt: Scalars['String']['output'];
  /** Artifact id. Identifies the artifact across all of its versions. */
  id: Scalars['String']['output'];
  latestVersion: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  type: Scalars['String']['output'];
  /**
   * The workspace this artifact was produced in. It may not be the current one --
   * reusing another workspace's artifact is the point of this tool.
   */
  workspaceId: Scalars['String']['output'];
  workspaceTitle: Scalars['String']['output'];
};

export type ClientToolFile = {
  __typename?: 'ClientToolFile';
  createdAt: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * The lean client shape both SEARCH_CLIENTS and GET_CLIENT return. Kept small on
 * purpose -- these land in the agent's context, and a full profile per search hit
 * would crowd out the rest of the conversation.
 */
export type ClientToolSummary = {
  __typename?: 'ClientToolSummary';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isCommercial: Scalars['Boolean']['output'];
  isPersonal: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type ClientToolWorkspace = {
  __typename?: 'ClientToolWorkspace';
  /**
   * Documents this workspace holds for the client: artifacts Cara generated and
   * files people uploaded. Documents a user removed from the client are excluded.
   */
  artifacts: Array<ClientToolArtifact>;
  /**
   * Passages from the conversation that matched the query, in conversation order,
   * each prefixed with who said it. A "Cara:" passage is a finding; a "User:"
   * passage is what someone asked or asserted, which may be a premise rather than
   * a fact.
   */
  excerpts: Array<Scalars['String']['output']>;
  files: Array<ClientToolFile>;
  id: Scalars['String']['output'];
  /**
   * Keywords extracted when the workspace's work was completed. Empty for a
   * workspace that has not finished a run.
   */
  keywords: Array<Scalars['String']['output']>;
  /**
   * The opening of the longest reply Cara gave in that workspace. A comparison or
   * review states its conclusions first, so this is usually the summary.
   */
  summary: Scalars['String']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

/**
 * The little of a workspace a client row needs to say what was last worked on.
 * Narrow rather than a CaraWorkspace because that type is wide, and the Clients
 * list selects this for every row.
 */
export type ClientWorkspaceSummary = {
  __typename?: 'ClientWorkspaceSummary';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

/**
 * An output file produced by CODE_EXECUTION and stored as an agency file.
 * Today these are typically chart PNGs; the type is not limited to charts.
 */
export type CodeExecutionOutputFile = {
  __typename?: 'CodeExecutionOutputFile';
  /** Agency file id for the stored output file (S3 key and statics path segment). */
  id: Scalars['ID']['output'];
  /** MIME type of the stored output file. */
  mimeType: Scalars['String']['output'];
  /** Download filename including extension (e.g. premium_trends.png). */
  name: Scalars['String']['output'];
  /** Stable statics URL to preview or download the output file. */
  url: Scalars['String']['output'];
};

/**
 * Tool for executing Python in a secure sandbox for analysis, charts, verification, and targeted scraping.
 * This is complementary to XLSX_EDITOR and DOCX_EDITOR — do not use this tool to produce XLSX or DOCX office files.
 */
export type CodeExecutionTool = {
  __typename?: 'CodeExecutionTool';
  /** The input arguments for the code execution operation */
  input: CodeExecutionToolInput;
  /** The result of the code execution operation */
  output: CodeExecutionToolOutput;
};

/** Input arguments for the CODE_EXECUTION tool. */
export type CodeExecutionToolInput = {
  __typename?: 'CodeExecutionToolInput';
  /** Runnable Python 3 source executed as-is in the sandbox (no server-side code generation). */
  pythonScript: Scalars['String']['output'];
  /**
   * Optional workspace file IDs to stage into the sandbox before the script runs.
   * Intended for data-analysis inputs (e.g. .csv, .json, .txt, .xlsx, .pdf). Use XLSX_EDITOR / DOCX_EDITOR for creating, editing, repairing, or exporting Excel/Word files.
   * Files are written to /tmp/<file_id> in the sandbox, except a PDF, which is staged as its extracted page text at /tmp/<file_id>.txt. Omit when no staged files are required.
   */
  sourceFileIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Short human-readable label for this run shown in the workspace timeline. */
  title: Scalars['String']['output'];
};

/** Result of a CODE_EXECUTION tool invocation. */
export type CodeExecutionToolOutput = {
  __typename?: 'CodeExecutionToolOutput';
  /** Output files saved as agency files with stable statics URLs. */
  outputFiles: Array<CodeExecutionOutputFile>;
  /** Short guidance for follow-up turns e.g. retry hints. */
  remarks?: Maybe<Scalars['String']['output']>;
  /** Process exit code from the sandbox Python invocation. */
  returnCode: Scalars['Int']['output'];
  /** Captured stderr truncated when large. */
  stderr?: Maybe<Scalars['String']['output']>;
  /** Captured stdout truncated when large. */
  stdout?: Maybe<Scalars['String']['output']>;
};

/** Code block style */
export type CodeStyle = {
  __typename?: 'CodeStyle';
  /** Background color in hex format (e.g. '#f1f5f9') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Border radius in pixels (e.g. 3.0) */
  borderRadiusPx?: Maybe<Scalars['Float']['output']>;
  /** Text color in hex format (e.g. '#1e293b') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (e.g. 'Courier New', 'Roboto Mono') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 9.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Padding in em units (e.g. 0.2) */
  paddingEm?: Maybe<Scalars['Float']['output']>;
};

/** Input for code block style */
export type CodeStyleInput = {
  /** Code block background color as a hex string */
  backgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Border radius for code block corners in pixels */
  borderRadiusPx?: InputMaybe<Scalars['Float']['input']>;
  /** Code text color as a hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for code text */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for code text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Padding for the code block in em units */
  paddingEm?: InputMaybe<Scalars['Float']['input']>;
};

/**
 * Represents a tool for completing a specific task or action.
 * Used when the LLM needs to perform a concrete action based on its analysis.
 */
export type CompleteTaskTool = {
  __typename?: 'CompleteTaskTool';
  /** The input arguments for the task completion */
  input: CompleteTaskToolInput;
  /** The result of the task completion attempt */
  output: CompleteTaskToolOutput;
};

/**
 * Input arguments for the CompleteTaskTool.
 * Contains all necessary information to complete a specific task.
 */
export type CompleteTaskToolInput = {
  __typename?: 'CompleteTaskToolInput';
  /** The name of the client or entity the task is for */
  clientName: Scalars['String']['output'];
  /** Keywords associated with the task for categorization and search */
  keywords: Array<Scalars['String']['output']>;
  /** Whether the task requires additional input from a human agent */
  needsAgentInput: Scalars['Boolean']['output'];
};

/**
 * Result of a CompleteTaskTool operation.
 * Indicates whether the task was completed successfully.
 */
export type CompleteTaskToolOutput = {
  __typename?: 'CompleteTaskToolOutput';
  /** Whether the task completion was successful */
  success: Scalars['Boolean']['output'];
};

/**
 * A consumption event represents customer-facing usage tracked for billing.
 * Raw vendor/API COGS remain in cost_event; this table is the customer usage ledger.
 */
export type ConsumptionEvent = {
  __typename?: 'ConsumptionEvent';
  /** Agency rate override applied at confirmation time, if any */
  agencyRateOverrideId?: Maybe<Scalars['String']['output']>;
  /** Key identifying the billable product unit, e.g. workspace:{stageId}:response */
  billableUnitKey?: Maybe<Scalars['String']['output']>;
  /** Call context, when applicable */
  callId?: Maybe<Scalars['String']['output']>;
  /** Optional link to a related cost_event row (temporary migration aid) */
  costEventId?: Maybe<Scalars['String']['output']>;
  /** Type of underlying cost/usage (mirrors cost_event.type) */
  costEventType: CostEventType;
  /** When this record was created */
  createdAt: Scalars['Time']['output'];
  /** Custom form context, when applicable (e.g. custom PDF form fill or ingestion) */
  customFormId?: Maybe<Scalars['String']['output']>;
  /** Email thread context, when applicable */
  emailThreadId?: Maybe<Scalars['String']['output']>;
  /** Excel spreadsheet template context, when applicable (e.g. Excel template fill or ingestion) */
  excelSpreadsheetTemplateId?: Maybe<Scalars['String']['output']>;
  /** File chunk index, when applicable */
  fileChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** File context, when applicable */
  fileId?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the consumption event */
  id: Scalars['ID']['output'];
  /** Idempotency key for retry-safe usage recording */
  idempotencyKey: Scalars['String']['output'];
  /** Knowledge base document chunk index, when applicable */
  knowledgeBaseDocumentChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** Knowledge base document context, when applicable */
  knowledgeBaseDocumentId?: Maybe<Scalars['String']['output']>;
  /** Provider-specific or low-volume details not modeled as columns */
  metadata: Scalars['JSON']['output'];
  /** Customer-facing meter code, set at confirmation time */
  meterCode?: Maybe<ConsumptionMeterCode>;
  /** Model identifier when applicable (e.g. LLM model ID) */
  modelId?: Maybe<Scalars['String']['output']>;
  /** When this usage occurred */
  occurredAt: Scalars['Time']['output'];
  /** Billable quantity after rate conversion, set at confirmation time */
  quantityBillable?: Maybe<Scalars['Decimal']['output']>;
  /** Raw quantity consumed before billable-unit conversion */
  quantityRaw: Scalars['Decimal']['output'];
  /** Rate line used at confirmation time */
  rateLineId?: Maybe<Scalars['String']['output']>;
  /** Rate schedule version used at confirmation time */
  rateScheduleVersionId?: Maybe<Scalars['String']['output']>;
  /** Unit for quantityRaw (mirrors cost_event.unit) */
  rawUnit: CostEventUnit;
  /** Stage event context, when applicable */
  stageEventId?: Maybe<Scalars['String']['output']>;
  /** Stage context, when applicable */
  stageId?: Maybe<Scalars['String']['output']>;
  /** Tool call context, when applicable */
  toolCallId?: Maybe<Scalars['String']['output']>;
  /** Tool call type, when applicable */
  toolCallType?: Maybe<CaraWorkspaceTool>;
  /** Total cost in dollars for this raw usage (COGS owned by this table) */
  totalCostDollars: Scalars['Decimal']['output'];
  /** Cost per raw unit in dollars (COGS owned by this table) */
  unitCostDollars: Scalars['Decimal']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** When usage was confirmed billable */
  usageConfirmedAt?: Maybe<Scalars['Time']['output']>;
  /** Current lifecycle status of this usage row */
  usageStatus: ConsumptionUsageStatus;
  /** Optional reason for the current usage status (e.g. void reason) */
  usageStatusReason?: Maybe<Scalars['String']['output']>;
  /** Word document template context, when applicable (e.g. Word template fill or ingestion) */
  wordDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** Workspace context, when applicable */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/** Customer-facing billing meter codes. */
export enum ConsumptionMeterCode {
  /** Knowledge base document pages processed */
  KbPage = 'KB_PAGE',
  /** Generic platform usage (LLM tokens, API requests, sandbox time, etc.) */
  PlatformUnit = 'PLATFORM_UNIT',
  /** Voice agent call time */
  VoiceMinute = 'VOICE_MINUTE'
}

/** Lifecycle status for a customer usage ledger row. */
export enum ConsumptionUsageStatus {
  /** Usage confirmed and counted toward billing, limits, and invoices. */
  Billable = 'BILLABLE',
  /** Internal-only usage not billed to the customer. */
  Internal = 'INTERNAL',
  /** Usage recorded but not yet confirmed billable. */
  Pending = 'PENDING',
  /** Shadow-mode usage recorded for comparison without billing impact. */
  Shadow = 'SHADOW',
  /** Usage voided (failed, cancelled, or otherwise non-billable work). */
  Void = 'VOID'
}

/** A cost event represents a single cost incurred in the system */
export type CostEvent = {
  __typename?: 'CostEvent';
  /** When this record was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the cost event */
  id: Scalars['ID']['output'];
  /**
   * Additional metadata about the cost event
   * e.g. {"workspace_id": "ws_123", "stage_id": "stage_456", "tool_call_id": "tool_789"}
   */
  metadata: CostEventMetadata;
  /** When this cost event occurred */
  occurredAt: Scalars['Time']['output'];
  /** The quantity of units consumed */
  quantity: Scalars['Int']['output'];
  /** The total cost in dollars */
  totalCostDollars: Scalars['Decimal']['output'];
  /** The type of cost event */
  type: CostEventType;
  /** The unit of the quantity (e.g. 'seconds', 'tokens', 'bytes') */
  unit: CostEventUnit;
  /** The cost per unit in dollars */
  unitCostDollars: Scalars['Decimal']['output'];
  /** When this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type CostEventMetadata = {
  __typename?: 'CostEventMetadata';
  /** If this cost event is related to a call, the ID of the call */
  callId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a custom form, the ID of the custom form */
  customFormId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the email thread this cost event belongs to */
  emailThreadId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to an Excel spreadsheet template, the ID of the template */
  excelSpreadsheetTemplateId?: Maybe<Scalars['ID']['output']>;
  /** If this cost event is related to a file chunk, the index of the chunk */
  fileChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a file, the ID of the file */
  fileId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base document chunk, the index of the chunk */
  knowledgeBaseDocumentChunkIndex?: Maybe<Scalars['Int']['output']>;
  /** If this cost event is related to a knowledge base document, the ID of the document */
  knowledgeBaseDocumentId?: Maybe<Scalars['String']['output']>;
  /** If this cost event is related to a knowledge base policy, the ID of the policy */
  knowledgeBasePolicyId?: Maybe<Scalars['String']['output']>;
  /** The search context size used for the perplexity search */
  perplexitySearchContextSize?: Maybe<Scalars['String']['output']>;
  /** The model used for the perplexity search */
  perplexitySearchModel?: Maybe<Scalars['String']['output']>;
  /** The ID of the stage event this cost event belongs to */
  stageEventId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the stage this cost event belongs to */
  stageId?: Maybe<Scalars['ID']['output']>;
  /** The tag for this cost event, indicating the context that the cost event was incurred in */
  tag: CostEventMetadataTag;
  /** The ID of the stage event this cost event belongs to, if specifically invoked by a tool call */
  toolCallId?: Maybe<Scalars['ID']['output']>;
  /** The type of the tool call this cost event belongs to */
  toolCallType?: Maybe<CaraWorkspaceTool>;
  /** If this cost event is related to a Word document template, the ID of the template */
  wordDocumentTemplateId?: Maybe<Scalars['ID']['output']>;
  /** The ID of the workspace this cost event belongs to */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

/** Tags that indicate the context in which a cost event was incurred */
export enum CostEventMetadataTag {
  /** Cost incurred while reading a document for AMS reconciliation: detecting which account it concerns, and extracting it against a line of business */
  AmsReconciliation = 'AMS_RECONCILIATION',
  /** Cost incurred while drafting one recipient's email of a bulk email in a workspace */
  BulkEmailDraft = 'BULK_EMAIL_DRAFT',
  /** Cost incurred while generating the base fill prompt for a custom form (Claude) */
  CustomFormIngestionBasePrompt = 'CUSTOM_FORM_INGESTION_BASE_PROMPT',
  /** Cost incurred while running per-crop Gemini vision for custom form checkbox/radio/select fields */
  CustomFormIngestionButtonVision = 'CUSTOM_FORM_INGESTION_BUTTON_VISION',
  /** Cost incurred while running batch Gemini vision for custom form field identification (text/number/date path) */
  CustomFormIngestionFieldVision = 'CUSTOM_FORM_INGESTION_FIELD_VISION',
  /** Cost incurred while running batch Gemini vision for custom form select fallback (anchor PDF path) */
  CustomFormIngestionSelectFallbackVision = 'CUSTOM_FORM_INGESTION_SELECT_FALLBACK_VISION',
  /** Cost incurred while classifying an email thread */
  EmailThreadClassify = 'EMAIL_THREAD_CLASSIFY',
  /** Cost incurred while formatting an email thread */
  EmailThreadFormat = 'EMAIL_THREAD_FORMAT',
  /** Cost incurred while generating an email response */
  EmailThreadGenerateResponse = 'EMAIL_THREAD_GENERATE_RESPONSE',
  /** Cost incurred while parsing service requests from an email thread */
  EmailThreadParseServiceRequests = 'EMAIL_THREAD_PARSE_SERVICE_REQUESTS',
  /** Cost incurred while ingesting an Excel spreadsheet template tab (extracting fields and fillGuidance via LLM) */
  ExcelSpreadsheetTemplateIngestion = 'EXCEL_SPREADSHEET_TEMPLATE_INGESTION',
  /** Cost incurred while indexing a document in a knowledge base */
  KnowledgeBaseIndexDocument = 'KNOWLEDGE_BASE_INDEX_DOCUMENT',
  /** Cost incurred while indexing a policy in the accounts and policies section of the knowlege module */
  KnowledgeBaseIndexPolicy = 'KNOWLEDGE_BASE_INDEX_POLICY',
  /** Cost attributed to the memory dream phase (synthesis, consolidation, eviction) */
  MemoryDream = 'MEMORY_DREAM',
  /** Cost attributed to the memory extraction phase (extracting candidates from workspace conversations) */
  MemoryExtraction = 'MEMORY_EXTRACTION',
  /** Cost attributed to the memory reconciliation phase (deduplicating candidates against existing memories) */
  MemoryReconciliation = 'MEMORY_RECONCILIATION',
  /** Cost incurred while searching a file in a workspace */
  PerplexityWebSearch = 'PERPLEXITY_WEB_SEARCH',
  /** Cost incurred while analyzing a phone conversation */
  PhoneCallAnalyzeConversation = 'PHONE_CALL_ANALYZE_CONVERSATION',
  /** Cost incurred while answering a question on inbound phone call */
  PhoneCallAnswerPolicyQuestion = 'PHONE_CALL_ANSWER_POLICY_QUESTION',
  /** Cost incurred while detecting which email addresses to send email notifications to */
  PhoneCallDetectEmailNotifications = 'PHONE_CALL_DETECT_EMAIL_NOTIFICATIONS',
  /** Cost incurred while enhancing a phone call transcript with Gemini */
  PhoneCallEnhanceTranscript = 'PHONE_CALL_ENHANCE_TRANSCRIPT',
  /** Cost incurred while handling an inbound phone call */
  PhoneCallHandleInbound = 'PHONE_CALL_HANDLE_INBOUND',
  /** Cost incurred while handling an outbound phone call */
  PhoneCallHandleOutbound = 'PHONE_CALL_HANDLE_OUTBOUND',
  /** Cost incurred while parsing service requests from a phone call */
  PhoneCallParseServiceRequests = 'PHONE_CALL_PARSE_SERVICE_REQUESTS',
  /** Cost incurred while generating clarifying questions for the Convert-to-Preset wizard */
  PresetGenerationClarifyingQuestions = 'PRESET_GENERATION_CLARIFYING_QUESTIONS',
  /** Cost incurred while drafting the preset prompt for the Convert-to-Preset wizard */
  PresetGenerationDrafting = 'PRESET_GENERATION_DRAFTING',
  SmartFillLearning = 'SMART_FILL_LEARNING',
  /** Cost incurred while resolving one live form against one bucket for Smart Fill */
  SmartFillResolve = 'SMART_FILL_RESOLVE',
  /** Cost incurred while extracting a reviewed Super Copy draft from a web source */
  SmartFillSuperCopyExtract = 'SMART_FILL_SUPER_COPY_EXTRACT',
  /** Cost incurred while converting a Cara workspace into a Smart Fill client bucket */
  SmartFillWorkspaceConvert = 'SMART_FILL_WORKSPACE_CONVERT',
  /** Cost incurred while answering a Question for Cara condition of an email trigger */
  TriggerEmailQuestion = 'TRIGGER_EMAIL_QUESTION',
  /** Cost incurred while ingesting a Word document template section (extracting placeholders and fillGuidance via LLM) */
  WordDocumentTemplateIngestion = 'WORD_DOCUMENT_TEMPLATE_INGESTION',
  /** Cost incurred while reviewing citations in a workspace */
  WorkspaceCitationReview = 'WORKSPACE_CITATION_REVIEW',
  /** Cost incurred while generating follow up options for a message in a workspace */
  WorkspaceGenerateFollowUpOptions = 'WORKSPACE_GENERATE_FOLLOW_UP_OPTIONS',
  /** Cost incurred while generating a title for a workspace */
  WorkspaceGenerateTitle = 'WORKSPACE_GENERATE_TITLE',
  /** Cost incurred while indexing a file in a workspace */
  WorkspaceIndexFile = 'WORKSPACE_INDEX_FILE',
  /** Cost incurred while generating a response in a workspace */
  WorkspaceResponse = 'WORKSPACE_RESPONSE',
  /** Cost incurred while searching a knowledge base from a workspace */
  WorkspaceSearchKnowledgeBase = 'WORKSPACE_SEARCH_KNOWLEDGE_BASE',
  /** Cost incurred while thinking in a workspace */
  WorkspaceThought = 'WORKSPACE_THOUGHT',
  /** Cost incurred while making a tool call from a workspace */
  WorkspaceToolCall = 'WORKSPACE_TOOL_CALL'
}

/** Cost event types that can occur in the system */
export enum CostEventType {
  /** Cost event for call duration, measured in seconds */
  CallDuration = 'CALL_DURATION',
  /** Cost event for embedding input tokens */
  EmbeddingInput = 'EMBEDDING_INPUT',
  /** Cost event for HTTP requests */
  HttpRequest = 'HTTP_REQUEST',
  /** Cost event for LLM cache read operations */
  LlmCacheRead = 'LLM_CACHE_READ',
  /** Cost event for LLM cache write operations */
  LlmCacheWrite = 'LLM_CACHE_WRITE',
  /** Cost event for LLM input tokens */
  LlmInput = 'LLM_INPUT',
  /** Cost event for LLM output tokens */
  LlmOutput = 'LLM_OUTPUT',
  /** Cost event for Modal sandbox CPU core-seconds */
  ModalCpuSecond = 'MODAL_CPU_SECOND',
  /** Cost event for Modal sandbox GiB-seconds (memory time) */
  ModalGbSecond = 'MODAL_GB_SECOND',
  /** Cost event for Reducto service credit usage */
  ReductoCredit = 'REDUCTO_CREDIT',
  /** Cost event for reranking input tokens */
  RerankInput = 'RERANK_INPUT'
}

/** Units for cost events */
export enum CostEventUnit {
  /** Nominal unit, used to represent a discrete count (e.g. number of files, number of requests, etc.) */
  Nominal = 'NOMINAL',
  /** Time-based unit */
  Second = 'SECOND',
  /** Token-based unit */
  Token = 'TOKEN'
}

/** CreateAMS360IntegrationInput contains the input for creating an AMS360 integration */
export type CreateAms360IntegrationInput = {
  /** AMS360 Agency Number */
  agencyNo: Scalars['String']['input'];
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey: Scalars['String']['input'];
  /** AMS360 App Key for authentication */
  appKey: Scalars['String']['input'];
};

/** Input for creating a new account contact */
export type CreateAccountContactInput = {
  /** The contact's email address */
  email: Scalars['String']['input'];
  /** The contact's name */
  name: Scalars['String']['input'];
  /** The contact's phone number */
  phone: Scalars['String']['input'];
};

/** Input for creating a new agency account */
export type CreateAccountInput = {
  /** If provided, ID of an existing contact to associate with the account */
  associateContactId?: InputMaybe<Scalars['String']['input']>;
  /** Business account details */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Contact details for the account, if a new contact should be created */
  contact?: InputMaybe<CreateAccountContactInput>;
  /** Individual account details */
  individual?: InputMaybe<CreateIndividualAccountInput>;
  /** The type of account - either a business or individual account. */
  type: AccountType;
};

/** Input for creating a new agency */
export type CreateAgencyInput = {
  /** Agency details */
  agency: AgencyInput;
  /** The initially selected onboarding date for the agency based on when they created their account */
  onboardingDate?: InputMaybe<Scalars['Time']['input']>;
  /**
   * The ID of the parent agency, if the agency is a child agency. Users usually
   * have the SELF:AGENCY:CREATE permission, so that they can sign up as standalone
   * customers. However, specifying this field requires the ORGANIZATION:AGENCY:CREATE
   * permission (as is implied by the scopeResource argument). This will only be granted
   * to admins of the agency they are currently logged in for.
   */
  parentAgencyId?: InputMaybe<Scalars['String']['input']>;
  /** Users to create for the agency */
  users: Array<AgencyUserInput>;
};

/**
 * Input for creating a profile. Configuration is not accepted here: a new profile
 * starts from the full set of grants its agency's roles already allow, and the
 * admin narrows it on the detail page.
 */
export type CreateAgencyProfileInput = {
  /**
   * What this profile is for. Required — an unexplained profile is one nobody
   * else can safely assign.
   */
  description: Scalars['String']['input'];
  /** Name of the profile. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
};

/** CreateAgencyZoomIntegrationInput contains the input for creating an Agency Zoom integration */
export type CreateAgencyZoomIntegrationInput = {
  /** If enabled, allows users to log in to Agency Zoom via SSO. */
  isSSOLogin: Scalars['Boolean']['input'];
  /** Agency Zoom password for basic authentication */
  password: Scalars['String']['input'];
  /** Agency Zoom username for basic authentication */
  username: Scalars['String']['input'];
};

export type CreateAmsAccountInput = {
  /** The agency the account is filed under, one of amsAgencyStructure's. */
  agencyCode: Scalars['String']['input'];
  /** One of that agency's branches. */
  branchCode: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  /** The primary contact's first name. */
  firstName?: InputMaybe<Scalars['String']['input']>;
  integrationId: Scalars['ID']['input'];
  /** The primary contact's last name, which Epic requires of every client. */
  lastName: Scalars['String']['input'];
  /** Fills both of Epic's name fields, AccountName and BusinessName. */
  name: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
};

/** CreateAppliedEpicIntegrationInput contains the input for creating an Applied Epic integration */
export type CreateAppliedEpicIntegrationInput = {
  /** API credentials for the Applied Epic integration */
  apiCredentials?: InputMaybe<AppliedEpicApiCredentialsInput>;
  /** SDK credentials for the Applied Epic integration */
  sdkCredentials?: InputMaybe<AppliedEpicSdkCredentialsInput>;
  /** Type of Applied Epic integration */
  type: AppliedEpicIntegrationType;
};

/** Input for creating a new business record */
export type CreateBusinessAccountInput = {
  /** Doing Business As (DBA) name, if different from legal name */
  dba: Scalars['String']['input'];
  /** Primary email address for contacting the business */
  email: Scalars['String']['input'];
  /** Mailing address for the business */
  mailingAddress: AddressInput;
  /** Legal name of the business */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the business */
  phone: Scalars['String']['input'];
  /** Website URL for the business */
  website: Scalars['String']['input'];
};

/** Input for creating multiple business policies */
export type CreateBusinessPoliciesInput = {
  /** ID of the account to create policies for */
  accountId: Scalars['String']['input'];
  /** List of policies to create */
  policies: Array<CreateBusinessPolicyInput>;
};

/** Input for creating a single business policy */
export type CreateBusinessPolicyInput = {
  /** Type of agency billing */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** ID of the agency user who sourced the policy */
  agencyUserId: Scalars['String']['input'];
  /** Reference ID for existing Ascend quote */
  ascendExistingQuoteRefId?: InputMaybe<Scalars['String']['input']>;
  /** Mode for creating Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of the Ascend program */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** Type of billing for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** ID of the broker, if applicable */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId: Scalars['String']['input'];
  /** Estimated commission percentage */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** Unique identifier for the policy, used only for Ascend program referencing (an ID is actually generated by the server) */
  id: Scalars['String']['input'];
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market: InsuranceMarket;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium: Scalars['Float']['input'];
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Payment interval of the policy. If billed via ASCEND, leave this blank */
  paymentIntervalType?: InputMaybe<PaymentIntervalType>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** Quote number from carrier */
  quoteNumber: Scalars['String']['input'];
  /** Current state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
  /** Type of insurance policy */
  type: InsuranceType;
};

/** Input for creating a certificate of insurance */
export type CreateCertificateInput = {
  /** The ID of the account this certificate is associated with */
  accountId: Scalars['ID']['input'];
  /** Whether additional insured coverage is included */
  additionalInsured: Scalars['Boolean']['input'];
  /** Description of the operations covered by the certificate */
  descriptionOfOperations: Scalars['String']['input'];
  /** The holder of the certificate */
  holder: CertificateHolderInput;
};

/** Options for creating a certificate of insurance on the client side */
export type CreateCertificateOptions = {
  __typename?: 'CreateCertificateOptions';
  /** The allowed blanket additional insureds for this certificate */
  allowedBlanketAdditionalInsureds: Array<BlanketAdditionalInsuredCertificateOption>;
  /** The allowed named additional insureds for this certificate */
  allowedNamedAdditionalInsureds: Array<NamedAdditionalInsuredCertificateOption>;
};

/** Details for a request to create a Certificate of Insurance */
export type CreateCertificateRequest = {
  __typename?: 'CreateCertificateRequest';
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['output'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: Maybe<Scalars['String']['output']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: Maybe<Scalars['String']['output']>;
  /** Address of the certificate holder */
  address: Address;
  /** Name of the certificate holder */
  name: Scalars['String']['output'];
};

/** Input type for creating a Certificate of Insurance request */
export type CreateCertificateRequestInput = {
  /** Whether the certificate holder should be listed as additional insured */
  additionalInsured: Scalars['Boolean']['input'];
  /** Relationship between policyholder and additional insured, if applicable */
  additionalInsuredRelationship?: InputMaybe<Scalars['String']['input']>;
  /** Additional details about the relationship, if applicable */
  additionalInsuredRelationshipDescription?: InputMaybe<Scalars['String']['input']>;
  /** Address of the certificate holder */
  address: AddressInput;
  /** Name of the certificate holder */
  name: Scalars['String']['input'];
};

/** CreateEzLynxIntegrationInput contains the input for creating an EZLynx integration */
export type CreateEzLynxIntegrationInput = {
  /** EZLynx app secret for authentication. Optional. */
  appSecret?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client secret for authentication. Optional - required only for API mode. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, explicitly marks this as a CSV import-only integration (no API access), even when credentials are present.
   * When false and credentials are provided, both CSV import and API usage are allowed.
   * Defaults to false.
   */
  csvImportOnly: Scalars['Boolean']['input'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx password for authentication. Optional. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** CreateHawksoftIntegrationInput contains the input for creating a Hawksoft integration */
export type CreateHawksoftIntegrationInput = {
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['input'];
};

export type CreateHtmlDocumentTemplateFromStarterInput = {
  starterId: Scalars['String']['input'];
};

/** CreateHubSpotIntegrationInput contains the input for creating a HubSpot integration */
export type CreateHubSpotIntegrationInput = {
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['input'];
  /** Field mappings for call syncing */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** Field mappings for task syncing */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
};

/** CreateImageRightIntegrationInput contains the input for creating an ImageRight integration */
export type CreateImageRightIntegrationInput = {
  /** ImageRight password for authentication */
  password: Scalars['String']['input'];
  /**
   * ImageRight server URL. ImageRight is self-hosted per-agency, so each agency
   * provides the base URL of their own ImageRight server.
   */
  serverUrl: Scalars['String']['input'];
  /** ImageRight username for authentication */
  username: Scalars['String']['input'];
};

/** Input for creating a new business record */
export type CreateIndividualAccountInput = {
  /** Primary email address for contacting the individual */
  email: Scalars['String']['input'];
  /** Mailing address for the individual */
  mailingAddress: AddressInput;
  /** Full name of the individual */
  name: Scalars['String']['input'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['input'];
};

/** CreateIntegrationInput contains the input for creating an integration */
export type CreateIntegrationInput = {
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: InputMaybe<CreateAgencyZoomIntegrationInput>;
  /** Configuration for the AMS360 integration */
  ams360?: InputMaybe<CreateAms360IntegrationInput>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: InputMaybe<CreateAppliedEpicIntegrationInput>;
  /** Configuration for the EZLynx integration */
  ezlynx?: InputMaybe<CreateEzLynxIntegrationInput>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<CreateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<CreateHubSpotIntegrationInput>;
  /** Configuration for the ImageRight integration */
  imageRight?: InputMaybe<CreateImageRightIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<CreateNowCertsIntegrationInput>;
  /** Type of integration */
  type: IntegrationType;
};

/** Input for creating a new text document in the knowledge base */
export type CreateKnowledgeBaseTextDocumentInput = {
  /** The text of the document */
  content: Scalars['String']['input'];
  /** The cosmetic folder to create the document in. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title: Scalars['String']['input'];
};

/** Input for creating a URL-sourced document in the knowledge base */
export type CreateKnowledgeBaseUrlDocumentInput = {
  /** The cosmetic folder to create the URL document in. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
  /** How often to sync the content */
  frequency: UrlMonitorFrequency;
  /** How to fetch the content (download file vs screenshot webpage) */
  sourceType: UrlSourceType;
  /** The title for this document */
  title: Scalars['String']['input'];
  /** The URL to fetch content from */
  url: Scalars['String']['input'];
};

export type CreateMemoryInput = {
  category: MemoryCategory;
  content: Scalars['String']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  scope: MemoryScope;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  surface?: InputMaybe<MemorySurface>;
  type: MemoryType;
};

/** CreateNowCertsIntegrationInput contains the input for creating a NowCerts integration */
export type CreateNowCertsIntegrationInput = {
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['input'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['input'];
  /** NowCerts password for basic authentication */
  password: Scalars['String']['input'];
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * If omitted or blank, no referral source will be set.
   */
  prospectReferralSource?: InputMaybe<Scalars['String']['input']>;
  /** NowCerts username for basic authentication */
  username: Scalars['String']['input'];
};

export type CreateOutboundCallInput = {
  callConfig: OutboundCallConfigInput;
  customer: OutboundCallCustomerInput;
  retryPolicy?: InputMaybe<OutboundCallRetryPolicyInput>;
  schedule: OutboundCallScheduleInput;
  /**
   * How this job was created. Defaults to MANUAL when omitted.
   * Copilot draft confirmations should pass COPILOT + workspaceId + draftArtifactId
   * so the draft tool output is updated with the created outboundCallId.
   */
  source?: InputMaybe<OutboundCallSourceInput>;
  /** Visibility is stored but not yet enforced in list queries. */
  visibility?: InputMaybe<VisibilityConfigInput>;
  voiceAgentId: Scalars['String']['input'];
};

/** Input type for creating a new service request */
export type CreateServiceRequestInput = {
  /** The ID of the account to associate this service request with */
  accountId: Scalars['String']['input'];
  /** Details specific to additional insured requests */
  addAdditionalInsured?: InputMaybe<AddAdditionalInsuredRequestInput>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: InputMaybe<CancelPolicyRequestInput>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: InputMaybe<CreateCertificateRequestInput>;
  /** Additional details about the request */
  details: Scalars['String']['input'];
  /** Details specific to document requests */
  documentRequest?: InputMaybe<DocumentRequestInput>;
  /** Details specific to question requests */
  question?: InputMaybe<QuestionRequestInput>;
  /** Type of service request */
  type: ServiceRequestType;
};

export type CreateSmartFillBucketInput = {
  /** A complete entity-tree document. IDs must be omitted; the server mints them. */
  document: Scalars['JSON']['input'];
  name: Scalars['String']['input'];
  operationId: Scalars['ID']['input'];
  /** COPY and MANUAL are accepted; WORKSPACE is created by conversion. */
  origin: SmartFillBucketOrigin;
  visibility?: InputMaybe<SmartFillBucketVisibility>;
};

export type CreateTriggerDefinitionInput = {
  eventMatcher: TriggerEventMatcherInput;
  name: Scalars['String']['input'];
  target: TriggerTargetInput;
  visibility?: InputMaybe<VisibilityConfigInput>;
};

export type CreateVoiceAgentInput = {
  /** Whether this agent receives inbound calls or places outbound calls. Defaults to INBOUND. */
  direction?: InputMaybe<VoiceAgentDirection>;
  /** The name of the voice agent */
  name: Scalars['String']['input'];
  /**
   * Disclosure version the user acknowledged. Required when creating an outbound agent
   * if the agency has not acknowledged the current disclosure version.
   */
  outboundComplianceDisclosureVersion?: InputMaybe<Scalars['String']['input']>;
};

/** Input for creating a new workflow definition */
export type CreateWorkflowDefinitionInput = {
  /** Explains what this workflow does */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The input slots this workflow expects */
  inputs?: InputMaybe<Array<WorkflowDefinitionInputSlotInput>>;
  /** A human-readable name for the workflow */
  label: Scalars['String']['input'];
  /** The tasks and their input bindings */
  nodes: Array<WorkflowDefinitionNodeInput>;
};

/** Input for creating a new workflow execution */
export type CreateWorkflowExecutionInput = {
  /** The ID of the workflow definition to execute */
  definitionId: Scalars['String']['input'];
  /** The version of the workflow definition to execute */
  definitionVersion: Scalars['Int64']['input'];
  /** The inputs to provide to the workflow */
  inputs: Array<CreateWorkflowInputEntry>;
  /** The ID of a parent workflow execution, if this is a chained execution */
  parentWorkflowId?: InputMaybe<Scalars['String']['input']>;
  /** The version of the parent workflow execution */
  parentWorkflowVersion?: InputMaybe<Scalars['Int64']['input']>;
};

/** An individual input entry for creating a workflow execution */
export type CreateWorkflowInputEntry = {
  /** Whether this input represents an enumerable collection */
  enumerable?: Scalars['Boolean']['input'];
  /** File input, required when type is FILE. Accepts uploads, existing file references, or integration file references. */
  file?: InputMaybe<CaraWorkspaceFileInput>;
  /** JSON input, required when type is JSON */
  json?: InputMaybe<Scalars['JSON']['input']>;
  /** A human-readable label for this input */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Text input, required when type is TEXT */
  text?: InputMaybe<Scalars['String']['input']>;
  /** The type of input */
  type: WorkflowInputType;
};

/** A custom fillable PDF form uploaded by an agency user. */
export type CustomForm = {
  __typename?: 'CustomForm';
  /** The agency that owns this custom form. Queryable as a full Agency object. */
  agency: Agency;
  /** The timestamp when this form was archived, or null if it is still active. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The base fill prompt generated by AI during ingestion. Used as the default fill
   * instructions when no custom prompt has been provided by the user.
   */
  basePrompt: Scalars['String']['output'];
  /** The timestamp when this form was first created. */
  createdAt: Scalars['Time']['output'];
  /** The agency user who uploaded this form. */
  createdBy: AgencyUser;
  /** An error message describing why processing failed. Only set when status is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * User-supplied fill-time instructions that supplement the base prompt.
   * Applied every time this form is filled by Cara.
   */
  fillPrompt: Scalars['String']['output'];
  /** The unique identifier for this custom form. */
  id: Scalars['ID']['output'];
  /**
   * Guidance provided at upload time to help Cara interpret ambiguous fields
   * (e.g. checkboxes, limit formats, percentages). Used during ingestion only.
   */
  ingestionGuidance: Scalars['String']['output'];
  /** The extracted field schema for this form. Null until the form has finished processing. */
  schema?: Maybe<CustomFormSchema>;
  /** The current processing status of this form. */
  status: CustomFormStatus;
  /** The original PDF file used as the template for this form. Queryable as a full File object. */
  templateFile: File;
  /** The human-readable name of this form shown in the library. */
  title: Scalars['String']['output'];
  /** The timestamp when this form was last updated. */
  updatedAt: Scalars['Time']['output'];
  /** The current version number of this form, incremented on each update. */
  version: Scalars['Int64']['output'];
  /**
   * The visibility configuration for this custom form (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
};

/** A single fillable field within a custom PDF form. */
export type CustomFormField = {
  __typename?: 'CustomFormField';
  /**
   * Options applicable to checkbox/button fields (on/off PDF values).
   * Null for non-checkbox fields. Radio and select use choiceOptions.
   */
  buttonOptions?: Maybe<CustomFormFieldButtonOptions>;
  /**
   * Ordered choice metadata for radio and select fields.
   * Each entry has the exact PDF export value and an optional human label.
   * Null for non-choice fields, or when no proven exports were available.
   */
  choiceOptions?: Maybe<Array<CustomFormFieldChoiceOption>>;
  /** The default value to use when source documents don't provide a definitive value. */
  defaultValue?: Maybe<Scalars['String']['output']>;
  /** A description of what value this field expects and how to fill it. */
  description: Scalars['String']['output'];
  /** The reason this field is excluded, if excluded is true. */
  excludeReason?: Maybe<Scalars['String']['output']>;
  /** Whether this field is excluded from filling (e.g. signatures, internal IDs). */
  excluded: Scalars['Boolean']['output'];
  /** The unique key identifying this field within the form schema. */
  key: Scalars['String']['output'];
  /**
   * The exact PDF AcroForm field name used by probes and fillpdf.
   * Not the human-readable label; that lives in description.
   */
  name: Scalars['String']['output'];
  /**
   * Options applicable to text-type fields (e.g. maximum length).
   * Null for non-text fields.
   */
  textOptions?: Maybe<CustomFormFieldTextOptions>;
  /** The type of this field, which determines how it should be filled. */
  type: CustomFormFieldType;
};

/**
 * Options that apply to checkbox/button custom form fields (on/off PDF values).
 * Not used for radio or select fields; those use choiceOptions.
 */
export type CustomFormFieldButtonOptions = {
  __typename?: 'CustomFormFieldButtonOptions';
  /** The PDF value written when the button is in the OFF (unchecked) state. */
  offValue?: Maybe<Scalars['String']['output']>;
  /** The PDF value written when the button is in the ON (checked/selected) state. */
  onValue?: Maybe<Scalars['String']['output']>;
};

/**
 * A single selectable choice for a radio or select custom form field.
 * exportValue is the exact PDF fill value; label is an optional human-readable
 * description of that choice (e.g. from vision or select display text).
 */
export type CustomFormFieldChoiceOption = {
  __typename?: 'CustomFormFieldChoiceOption';
  /** The exact PDF export/fill value for this choice. */
  exportValue: Scalars['String']['output'];
  /** Optional human-readable label for this choice. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Options that apply to text-type custom form fields. */
export type CustomFormFieldTextOptions = {
  __typename?: 'CustomFormFieldTextOptions';
  /** Maximum allowed character length for this field, if constrained. */
  maxLength?: Maybe<Scalars['Int']['output']>;
};

/** The type of a field in a custom form schema. */
export enum CustomFormFieldType {
  /** A boolean button (checkbox) field with distinct on/off values. */
  Button = 'BUTTON',
  /** A date input field. */
  Date = 'DATE',
  /** A numeric input field. */
  Number = 'NUMBER',
  /** A radio button field with mutually exclusive options. */
  Radio = 'RADIO',
  /** A dropdown or list-selection field with a fixed set of options. */
  Select = 'SELECT',
  /** A free-text input field. */
  Text = 'TEXT'
}

/** A summary of a custom form from the library, used in LIST and DESCRIBE operations. */
export type CustomFormListItem = {
  __typename?: 'CustomFormListItem';
  /** A brief description of this custom form's purpose. */
  description: Scalars['String']['output'];
  /** The unique identifier for this custom form. */
  id: Scalars['String']['output'];
  /**
   * The fill instructions for this form generated during ingestion.
   * Only populated for the DESCRIBE operation.
   */
  instructions?: Maybe<Scalars['String']['output']>;
  /** The human-readable name of this custom form. */
  name: Scalars['String']['output'];
  /** The JSON field schema for this form. Only populated for the DESCRIBE operation. */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** The extracted schema describing all fields in a custom PDF form. */
export type CustomFormSchema = {
  __typename?: 'CustomFormSchema';
  /** The list of fillable fields extracted from the PDF. */
  fields: Array<CustomFormField>;
  /** A brief description of the form's purpose and typical use case. */
  purpose: Scalars['String']['output'];
  /** The human-readable title of the form. */
  title: Scalars['String']['output'];
};

/** The processing status of a custom form. */
export enum CustomFormStatus {
  /** Processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** Ingestion is in progress. */
  Processing = 'PROCESSING',
  /** Ingestion is enqueued but work has not started yet. */
  Queued = 'QUEUED',
  /** The form has been processed and is ready to fill. */
  Ready = 'READY'
}

/** Identifies the artifact produced by a FILL operation on a library custom form. */
export type CustomFormToolArtifact = {
  __typename?: 'CustomFormToolArtifact';
  /** The ID of the created or updated custom form artifact. */
  id: Scalars['String']['output'];
  /** The version number of the artifact. */
  version: Scalars['Int']['output'];
};

/** Describes the type of update that occurred to a custom form */
export enum CustomFormUpdateType {
  /** The custom form was archived */
  ArchiveCustomForm = 'ARCHIVE_CUSTOM_FORM',
  /** The custom form was created */
  CreateCustomForm = 'CREATE_CUSTOM_FORM',
  /** The custom form was updated */
  UpdateCustomForm = 'UPDATE_CUSTOM_FORM'
}

/** Describes a particular version of a custom form (internal use for DB versioning) */
export type CustomFormVersion = {
  __typename?: 'CustomFormVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full custom form object for this version */
  customForm: CustomForm;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is private */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<Scalars['String']['output']>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<CustomFormUpdateType>;
  /** The version number of this custom form version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the customForms list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without
 * breaking the query signature.
 */
export type CustomFormsFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type CustomPreset = {
  __typename?: 'CustomPreset';
  /**
   * The agencies this preset has been shared with. Owner-agency only: the
   * directive binds the scope check to the preset's owning agency, so
   * cross-agency grantees are denied (they use myAccess instead).
   */
  accessList: Array<CustomPresetAccess>;
  /** The agency this custom preset is associated with */
  agency: Agency;
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['output'];
  /** The timestamp when this custom preset was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['output'];
  /** The timestamp when this custom preset was created */
  createdAt: Scalars['Time']['output'];
  /**
   * The user that created this custom preset. Null for a cross-agency grantee viewing a
   * shared preset: attribution is agency-level only (see the agency field), so the author
   * is not exposed cross-agency.
   */
  createdBy?: Maybe<AgencyUser>;
  /**
   * Custom forms offered as generation-time defaults in workspaces created from
   * this preset. See wordDocumentTemplates for semantics.
   */
  customForms: Array<CustomForm>;
  /**
   * The effort level a workspace created from this preset runs at when the request
   * names none; null means the server's default, which is AUTO while the
   * effort_level_selector_enabled and effort_level_auto_enabled gates are both on
   * and MEDIUM otherwise. A default the caller may not use runs at MEDIUM rather
   * than refusing the run, since a shared preset can reach agencies on other plans:
   * LOW needs effort_level_selector_enabled, AUTO needs both gates, and HIGH needs
   * AgencyUser.highEffortEnabled. Never LOW_MEDIUM.
   */
  defaultEffortLevel?: Maybe<CaraWorkspaceEffortLevel>;
  /** The description of the custom preset */
  description: Scalars['String']['output'];
  /** The files that are used as context for the custom preset */
  files: Array<File>;
  /**
   * Progress and outcome of the AI run that produced this preset. Null on a preset
   * created by hand. Poll it while state is GENERATING.
   */
  generation?: Maybe<PresetGeneration>;
  /**
   * HTML document templates offered as generation-time defaults in workspaces
   * created from this preset. See wordDocumentTemplates for semantics.
   */
  htmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** The ID of the custom preset */
  id: Scalars['ID']['output'];
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: Maybe<CaraWorkspacePreset>;
  /**
   * Whether the calling agency owns this preset. False when the preset is shared
   * with the agency (and always false for admins, who do not own presets).
   */
  isOwner: Scalars['Boolean']['output'];
  /**
   * The calling agency's access grant for this preset when it is shared with them.
   * Null if the calling agency owns the preset (use isOwner instead) or has no grant.
   */
  myAccess?: Maybe<CustomPresetAccess>;
  /**
   * Whether this preset is finished and usable. Only READY presets can be run,
   * shared, or offered as a choice; GENERATING and FAILED presets appear in the
   * preset list so the user can watch progress, retry, or delete them.
   *
   * Stored in the version document like the rest of the preset. Generation writes
   * its steps with updatePrivate set, so a run does not fill the preset's history
   * with versions a user did not make.
   */
  state: CustomPresetState;
  /** The title of the custom preset */
  title: Scalars['String']['output'];
  /** The timestamp when this custom preset was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this custom preset */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this custom preset. The first version in this list will be this version
   * (i.e. identical to the current custom preset), followed by the version before that, and so-forth.
   * Owner-agency only (history can contain pre-share snapshots): the directive binds the scope
   * check to the preset's owning agency, so cross-agency grantees are denied.
   */
  versionHistory?: Maybe<Array<CustomPresetVersion>>;
  /**
   * The visibility configuration for this custom preset (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content, so changing it does not create a new version.
   * Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
  /**
   * Output templates (structure Cara fills in) offered as defaults at generation
   * time in workspaces created from this preset — the same behavior as
   * pre-selecting them on a message. They are not attached to the workspace at
   * creation, and are distinct from files (context Cara reads).
   */
  wordDocumentTemplates: Array<WordDocumentTemplate>;
};

/**
 * Access control granting an agency access to a custom preset shared with it by
 * another (parent) agency. Only shared grants are stored here; ownership is
 * determined by agency_custom_preset.agency_id, not entries in this table.
 */
export type CustomPresetAccess = {
  __typename?: 'CustomPresetAccess';
  /** The agency this access grant is for (the child agency the preset is shared with). */
  agency: Agency;
  /** The timestamp when this access was granted */
  createdAt: Scalars['Time']['output'];
  /** The role this agency has for the custom preset */
  role: CustomPresetAccessRole;
  /** The timestamp when this access was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * The role an agency has for accessing a shared custom preset.
 * Note: Ownership is determined by agency_custom_preset.agency_id, not this table.
 */
export enum CustomPresetAccessRole {
  /** The agency can read and run this shared custom preset (read-only). */
  Viewer = 'VIEWER'
}

export type CustomPresetInput = {
  /** Whether the custom preset allows file uploads */
  allowFileUpload: Scalars['Boolean']['input'];
  /** The base prompt for the custom preset */
  basePrompt: Scalars['String']['input'];
  /**
   * The IDs of the custom forms to offer as generation-time defaults in
   * workspaces created from this preset. Replaces the existing list.
   */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The effort level workspaces created from this preset default to. Null means the
   * server's default; see CustomPreset.defaultEffortLevel. Replaces the existing
   * value. LOW_MEDIUM is rejected.
   */
  defaultEffortLevel?: InputMaybe<CaraWorkspaceEffortLevel>;
  /** The description of the custom preset */
  description: Scalars['String']['input'];
  /** The IDs of the existing files that should be kept as context for the custom preset */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The IDs of the HTML document templates to offer as generation-time defaults
   * in workspaces created from this preset. Replaces the existing list.
   */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The preset that this custom preset inherits from, if any */
  inheritFromPreset?: InputMaybe<CaraWorkspacePreset>;
  /** The title of the custom preset */
  title: Scalars['String']['input'];
  /** The files to upload if an existing file is not provided */
  uploadFiles?: InputMaybe<Array<Scalars['Upload']['input']>>;
  /**
   * Optional visibility configuration. When omitted on create, defaults to
   * PUBLIC. When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
  /**
   * The IDs of the Word document templates to offer as generation-time defaults
   * in workspaces created from this preset. Replaces the existing list.
   */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Whether a custom preset is finished and usable. */
export enum CustomPresetState {
  /**
   * Generation failed. The preset stays in the list carrying generation.error so
   * the user can retry or delete it, but it cannot be run or shared.
   */
  Failed = 'FAILED',
  /**
   * GeneratePresetWorkflow is still building this preset. Its base prompt is not
   * written yet, so it cannot be run or shared.
   */
  Generating = 'GENERATING',
  /**
   * GeneratePresetWorkflow finished and wrote the whole document, but the author
   * has not looked it over yet. Usable exactly as READY is — run, edit, share —
   * and the first manual save promotes it to READY.
   */
  NeedsReview = 'NEEDS_REVIEW',
  /** Usable. Every preset created by hand is READY from the moment it exists. */
  Ready = 'READY'
}

/** Describes the reason why a custom preset was updated */
export enum CustomPresetUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a custom preset */
export enum CustomPresetUpdateType {
  /** The custom preset was archived */
  ArchiveCustomPreset = 'ARCHIVE_CUSTOM_PRESET',
  /** The custom preset was created */
  CreateCustomPreset = 'CREATE_CUSTOM_PRESET',
  /** An AI generation run wrote to the custom preset */
  GenerateCustomPreset = 'GENERATE_CUSTOM_PRESET',
  /** The custom preset was unarchived */
  UnarchiveCustomPreset = 'UNARCHIVE_CUSTOM_PRESET',
  /** The custom preset was updated */
  UpdateCustomPreset = 'UPDATE_CUSTOM_PRESET'
}

/** Describes a particular version of a custom preset */
export type CustomPresetVersion = {
  __typename?: 'CustomPresetVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full custom preset object that includes all of the updates made in this version and all previous versions */
  customPreset: CustomPreset;
  /** Produces a human-readable string that can be used to diff against another custom preset version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous custom preset version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<CustomPresetVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<CustomPresetUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<CustomPresetUpdateType>;
  /** The version number of this custom preset version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the customPresets list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without
 * breaking the query signature.
 */
export type CustomPresetsFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** Custom CSS property that doesn't fit into the structured schema */
export type CustomStyle = {
  __typename?: 'CustomStyle';
  /** CSS properties to apply to the selector */
  properties: Array<CustomStyleProperty>;
  /** CSS selector (e.g. '.header', '#footer') */
  selector: Scalars['String']['output'];
};

/** Input for custom CSS block */
export type CustomStyleInput = {
  /** List of CSS properties to apply to the selector */
  properties: Array<CustomStylePropertyInput>;
  /** CSS selector string (e.g. '.my-class', 'h2.special') */
  selector: Scalars['String']['input'];
};

/** Custom CSS property */
export type CustomStyleProperty = {
  __typename?: 'CustomStyleProperty';
  /** CSS property name (e.g. 'margin', 'padding', 'border') */
  name: Scalars['String']['output'];
  /** CSS property value (e.g. '2em 0', '1px solid #cbd5e1') */
  value: Scalars['String']['output'];
};

/** Input for custom CSS property */
export type CustomStylePropertyInput = {
  /** CSS property name (e.g. 'border', 'background-color') */
  name: Scalars['String']['input'];
  /** CSS property value (e.g. '1px solid #000', '#fafafa') */
  value: Scalars['String']['input'];
};

/**
 * Database-specific details attached to a DATABASE span. Rich by design so the
 * viewer can show what ran, against what, and how it resolved.
 */
export type DbQuery = {
  __typename?: 'DBQuery';
  /**
   * Bound query arguments, sanitized for storage: truncated and with byte payloads
   * elided. Stored as text so the viewer can render them without column types.
   */
  args: Array<Scalars['String']['output']>;
  /**
   * High-level calling function (e.g. GetTraceByID), for grouping in the viewer.
   * Empty when the query was instrumented without a named caller.
   */
  function: Scalars['String']['output'];
  /** db.operation.name (SELECT, INSERT, UPDATE, ...). */
  operation: Scalars['String']['output'];
  /** Rows affected (writes) or returned (reads), when known. */
  rowsAffected?: Maybe<Scalars['Int']['output']>;
  /** The SQL statement (db.query.text). */
  statement: Scalars['String']['output'];
  /** db.system.name (e.g. postgresql). */
  system: Scalars['String']['output'];
  /** db.collection.name (the primary relation the statement targets). */
  table: Scalars['String']['output'];
};

/** Filter for date ranges */
export type DateFilter = {
  /** Filter for dates after this timestamp (inclusive) */
  after?: InputMaybe<Scalars['Time']['input']>;
  /** Filter for dates before this timestamp (exclusive) */
  before?: InputMaybe<Scalars['Time']['input']>;
};

/** Day of the week enum */
export enum DayOfWeek {
  /** Friday */
  Friday = 'FRIDAY',
  /** Monday */
  Monday = 'MONDAY',
  /** Saturday */
  Saturday = 'SATURDAY',
  /** Sunday */
  Sunday = 'SUNDAY',
  /** Thursday */
  Thursday = 'THURSDAY',
  /** Tuesday */
  Tuesday = 'TUESDAY',
  /** Wednesday */
  Wednesday = 'WEDNESDAY'
}

/**
 * How the Description of Operations (DOO) box on ACORD 25 and ACORD 30 should be
 * populated. Both carry the same box, so one mode governs both.
 */
export enum DescriptionOfOperationsMode {
  /** Strict ACORD FIG standard: locations, operations, and vehicles only. */
  AcordFigStrict = 'ACORD_FIG_STRICT',
  /** Current Cara default behavior. */
  CaraDefault = 'CARA_DEFAULT',
  /** Leave the Description of Operations blank. */
  Empty = 'EMPTY'
}

/**
 * Data used to generated the document. The fields in here must map to the fields
 * required by the document type.
 */
export type DocumentData = {
  __typename?: 'DocumentData';
  /** Placeholder required by GraphQL schema validation. ACORD form data is stored in Go-only fields above. */
  schemaPlaceholder?: Maybe<Scalars['Boolean']['output']>;
};

export type DocumentDesignFitState = {
  __typename?: 'DocumentDesignFitState';
  /** Changes whenever the Design is saved. */
  appearanceKey: Scalars['String']['output'];
  /** Changes only when the Design's page geometry changes. */
  layoutKey: Scalars['String']['output'];
  /** The version's pages were laid out for another Design or layout, or its words changed since. */
  needsRefit: Scalars['Boolean']['output'];
  /**
   * The last fit of this version under its Design's current layout measured it and kept its
   * content, because no rewrite printed the same pages.
   */
  refused: Scalars['Boolean']['output'];
};

/** Where the pages printed before or after a document made from a template come from. */
export enum DocumentPagesSource {
  /** The pages of the document's design. */
  Design = 'DESIGN',
  /** Nothing is printed at this end. */
  None = 'NONE',
  /** The template's own start or end PDFs. */
  Template = 'TEMPLATE'
}

export enum DocumentRefitOutcome {
  /** The document changed while the fit ran, so the fit was not saved; the next open fits it again if it is still stale. */
  Changed = 'CHANGED',
  Refitted = 'REFITTED',
  RefitFailed = 'REFIT_FAILED',
  RefitPending = 'REFIT_PENDING',
  Unchanged = 'UNCHANGED'
}

/** Details for a request for policy-related documents */
export type DocumentRequest = {
  __typename?: 'DocumentRequest';
  /** Type of document being requested */
  type: DocumentRequestType;
};

/** Input type for requesting policy-related documents */
export type DocumentRequestInput = {
  /** Type of document being requested */
  type?: InputMaybe<DocumentRequestType>;
};

/** Types of documents that can be requested */
export enum DocumentRequestType {
  /** Insurance binder document */
  Binder = 'BINDER',
  /** Certificate of Insurance */
  Certificate = 'CERTIFICATE',
  /** Policy endorsement document */
  Endorsement = 'ENDORSEMENT',
  /** Other document types */
  Other = 'OTHER',
  /** Full policy documentation */
  PolicyDocument = 'POLICY_DOCUMENT'
}

/** The type of document depending on which different fields in `Document` are populated */
export enum DocumentType {
  Acord_1 = 'ACORD_1',
  Acord_2 = 'ACORD_2',
  Acord_3 = 'ACORD_3',
  Acord_4 = 'ACORD_4',
  Acord_20 = 'ACORD_20',
  Acord_21 = 'ACORD_21',
  Acord_22 = 'ACORD_22',
  Acord_23 = 'ACORD_23',
  Acord_24 = 'ACORD_24',
  Acord_25 = 'ACORD_25',
  Acord_27 = 'ACORD_27',
  Acord_28 = 'ACORD_28',
  Acord_29 = 'ACORD_29',
  Acord_30 = 'ACORD_30',
  Acord_35 = 'ACORD_35',
  Acord_36 = 'ACORD_36',
  Acord_37 = 'ACORD_37',
  Acord_45 = 'ACORD_45',
  Acord_50 = 'ACORD_50',
  Acord_50Al = 'ACORD_50_AL',
  Acord_50AnyState = 'ACORD_50_ANY_STATE',
  Acord_50Ar = 'ACORD_50_AR',
  Acord_50Az = 'ACORD_50_AZ',
  Acord_50Ca = 'ACORD_50_CA',
  Acord_50Co = 'ACORD_50_CO',
  Acord_50Ct = 'ACORD_50_CT',
  Acord_50Fl = 'ACORD_50_FL',
  Acord_50Ga = 'ACORD_50_GA',
  Acord_50Hi = 'ACORD_50_HI',
  Acord_50Ia = 'ACORD_50_IA',
  Acord_50Id = 'ACORD_50_ID',
  Acord_50Il = 'ACORD_50_IL',
  Acord_50In = 'ACORD_50_IN',
  Acord_50Ky = 'ACORD_50_KY',
  Acord_50La = 'ACORD_50_LA',
  Acord_50Md = 'ACORD_50_MD',
  Acord_50Me = 'ACORD_50_ME',
  Acord_50Mi = 'ACORD_50_MI',
  Acord_50Mo = 'ACORD_50_MO',
  Acord_50Ms = 'ACORD_50_MS',
  Acord_50Nd = 'ACORD_50_ND',
  Acord_50Ne = 'ACORD_50_NE',
  Acord_50Nj = 'ACORD_50_NJ',
  Acord_50NjSet = 'ACORD_50_NJ_SET',
  Acord_50Ok = 'ACORD_50_OK',
  Acord_50Pa = 'ACORD_50_PA',
  Acord_50PaSet = 'ACORD_50_PA_SET',
  Acord_50Ri = 'ACORD_50_RI',
  Acord_50Sc = 'ACORD_50_SC',
  Acord_50Sd = 'ACORD_50_SD',
  Acord_50Tn = 'ACORD_50_TN',
  Acord_50Tx = 'ACORD_50_TX',
  Acord_50Vt = 'ACORD_50_VT',
  Acord_50Wv = 'ACORD_50_WV',
  Acord_70 = 'ACORD_70',
  Acord_71 = 'ACORD_71',
  Acord_75 = 'ACORD_75',
  Acord_80 = 'ACORD_80',
  Acord_81 = 'ACORD_81',
  Acord_82 = 'ACORD_82',
  Acord_83 = 'ACORD_83',
  Acord_84 = 'ACORD_84',
  Acord_88 = 'ACORD_88',
  Acord_89 = 'ACORD_89',
  Acord_89AnyState = 'ACORD_89_ANY_STATE',
  Acord_89Ca = 'ACORD_89_CA',
  Acord_89Nv = 'ACORD_89_NV',
  Acord_89Ny = 'ACORD_89_NY',
  Acord_90Ak = 'ACORD_90_AK',
  Acord_90Al = 'ACORD_90_AL',
  Acord_90AnyState = 'ACORD_90_ANY_STATE',
  Acord_90Ar = 'ACORD_90_AR',
  Acord_90Az = 'ACORD_90_AZ',
  Acord_90Ca = 'ACORD_90_CA',
  Acord_90Co = 'ACORD_90_CO',
  Acord_90Ct = 'ACORD_90_CT',
  Acord_90Dc = 'ACORD_90_DC',
  Acord_90De = 'ACORD_90_DE',
  Acord_90Fl = 'ACORD_90_FL',
  Acord_90Ga = 'ACORD_90_GA',
  Acord_90Hi = 'ACORD_90_HI',
  Acord_90Ia = 'ACORD_90_IA',
  Acord_90Id = 'ACORD_90_ID',
  Acord_90Il = 'ACORD_90_IL',
  Acord_90In = 'ACORD_90_IN',
  Acord_90Ks = 'ACORD_90_KS',
  Acord_90Ky = 'ACORD_90_KY',
  Acord_90La = 'ACORD_90_LA',
  Acord_90Ma = 'ACORD_90_MA',
  Acord_90Md = 'ACORD_90_MD',
  Acord_90Me = 'ACORD_90_ME',
  Acord_90Mi = 'ACORD_90_MI',
  Acord_90Mn = 'ACORD_90_MN',
  Acord_90Mo = 'ACORD_90_MO',
  Acord_90Ms = 'ACORD_90_MS',
  Acord_90Mt = 'ACORD_90_MT',
  Acord_90Nc = 'ACORD_90_NC',
  Acord_90Nd = 'ACORD_90_ND',
  Acord_90Ne = 'ACORD_90_NE',
  Acord_90Nh = 'ACORD_90_NH',
  Acord_90Nj = 'ACORD_90_NJ',
  Acord_90Nm = 'ACORD_90_NM',
  Acord_90Nv = 'ACORD_90_NV',
  Acord_90Ny = 'ACORD_90_NY',
  Acord_90Oh = 'ACORD_90_OH',
  Acord_90Ok = 'ACORD_90_OK',
  Acord_90Or = 'ACORD_90_OR',
  Acord_90Pa = 'ACORD_90_PA',
  Acord_90Ri = 'ACORD_90_RI',
  Acord_90Sc = 'ACORD_90_SC',
  Acord_90Sd = 'ACORD_90_SD',
  Acord_90Tn = 'ACORD_90_TN',
  Acord_90Tx = 'ACORD_90_TX',
  Acord_90Ut = 'ACORD_90_UT',
  Acord_90Va = 'ACORD_90_VA',
  Acord_90Vt = 'ACORD_90_VT',
  Acord_90Wa = 'ACORD_90_WA',
  Acord_90Wi = 'ACORD_90_WI',
  Acord_90Wv = 'ACORD_90_WV',
  Acord_90Wy = 'ACORD_90_WY',
  Acord_101 = 'ACORD_101',
  Acord_125 = 'ACORD_125',
  Acord_126 = 'ACORD_126',
  Acord_127 = 'ACORD_127',
  Acord_128 = 'ACORD_128',
  Acord_129 = 'ACORD_129',
  Acord_130 = 'ACORD_130',
  Acord_131 = 'ACORD_131',
  Acord_132 = 'ACORD_132',
  Acord_133 = 'ACORD_133',
  Acord_137Al = 'ACORD_137_AL',
  Acord_137AnyState = 'ACORD_137_ANY_STATE',
  Acord_137Ar = 'ACORD_137_AR',
  Acord_137Az = 'ACORD_137_AZ',
  Acord_137Ca = 'ACORD_137_CA',
  Acord_137Co = 'ACORD_137_CO',
  Acord_137Ct = 'ACORD_137_CT',
  Acord_137De = 'ACORD_137_DE',
  Acord_137Fl = 'ACORD_137_FL',
  Acord_137Ga = 'ACORD_137_GA',
  Acord_137Ia = 'ACORD_137_IA',
  Acord_137Id = 'ACORD_137_ID',
  Acord_137Il = 'ACORD_137_IL',
  Acord_137In = 'ACORD_137_IN',
  Acord_137Ks = 'ACORD_137_KS',
  Acord_137Ky = 'ACORD_137_KY',
  Acord_137La = 'ACORD_137_LA',
  Acord_137Ma = 'ACORD_137_MA',
  Acord_137Md = 'ACORD_137_MD',
  Acord_137Me = 'ACORD_137_ME',
  Acord_137Mi = 'ACORD_137_MI',
  Acord_137Mn = 'ACORD_137_MN',
  Acord_137Mo = 'ACORD_137_MO',
  Acord_137Ms = 'ACORD_137_MS',
  Acord_137Mt = 'ACORD_137_MT',
  Acord_137Nc = 'ACORD_137_NC',
  Acord_137Nd = 'ACORD_137_ND',
  Acord_137Ne = 'ACORD_137_NE',
  Acord_137Nh = 'ACORD_137_NH',
  Acord_137Nj = 'ACORD_137_NJ',
  Acord_137Nm = 'ACORD_137_NM',
  Acord_137Nv = 'ACORD_137_NV',
  Acord_137Ny = 'ACORD_137_NY',
  Acord_137Oh = 'ACORD_137_OH',
  Acord_137Ok = 'ACORD_137_OK',
  Acord_137Or = 'ACORD_137_OR',
  Acord_137Pa = 'ACORD_137_PA',
  Acord_137Ri = 'ACORD_137_RI',
  Acord_137Sc = 'ACORD_137_SC',
  Acord_137Sd = 'ACORD_137_SD',
  Acord_137Tn = 'ACORD_137_TN',
  Acord_137Tx = 'ACORD_137_TX',
  Acord_137Ut = 'ACORD_137_UT',
  Acord_137Va = 'ACORD_137_VA',
  Acord_137Vt = 'ACORD_137_VT',
  Acord_137Wa = 'ACORD_137_WA',
  Acord_137Wi = 'ACORD_137_WI',
  Acord_137Wv = 'ACORD_137_WV',
  Acord_137Wy = 'ACORD_137_WY',
  Acord_140 = 'ACORD_140',
  Acord_141 = 'ACORD_141',
  Acord_143 = 'ACORD_143',
  Acord_144 = 'ACORD_144',
  Acord_145 = 'ACORD_145',
  Acord_146 = 'ACORD_146',
  Acord_147 = 'ACORD_147',
  Acord_148 = 'ACORD_148',
  Acord_149 = 'ACORD_149',
  Acord_152 = 'ACORD_152',
  Acord_155 = 'ACORD_155',
  Acord_160 = 'ACORD_160',
  Acord_163 = 'ACORD_163',
  Acord_175 = 'ACORD_175',
  Acord_180 = 'ACORD_180',
  Acord_185 = 'ACORD_185',
  Acord_186 = 'ACORD_186',
  Acord_187 = 'ACORD_187',
  Acord_193 = 'ACORD_193',
  Acord_195 = 'ACORD_195',
  Acord_196 = 'ACORD_196',
  Acord_210 = 'ACORD_210',
  Acord_211 = 'ACORD_211',
  Acord_281 = 'ACORD_281',
  Acord_282 = 'ACORD_282',
  Acord_283 = 'ACORD_283',
  Acord_285 = 'ACORD_285',
  Acord_301 = 'ACORD_301',
  Acord_302 = 'ACORD_302',
  Acord_303 = 'ACORD_303',
  Acord_304 = 'ACORD_304',
  Acord_305 = 'ACORD_305',
  Acord_306 = 'ACORD_306',
  Acord_307 = 'ACORD_307',
  Acord_308 = 'ACORD_308',
  Acord_401 = 'ACORD_401',
  Acord_402 = 'ACORD_402',
  Acord_403 = 'ACORD_403',
  Acord_404 = 'ACORD_404',
  Acord_406 = 'ACORD_406',
  Acord_410 = 'ACORD_410',
  Acord_501 = 'ACORD_501',
  Acord_502 = 'ACORD_502',
  Acord_503 = 'ACORD_503',
  Acord_611 = 'ACORD_611',
  Acord_801 = 'ACORD_801',
  Acord_802 = 'ACORD_802',
  Acord_803 = 'ACORD_803',
  Acord_807 = 'ACORD_807',
  Acord_810 = 'ACORD_810',
  Acord_811 = 'ACORD_811',
  Acord_815 = 'ACORD_815',
  Acord_823 = 'ACORD_823',
  Acord_825 = 'ACORD_825',
  Acord_827 = 'ACORD_827',
  Acord_828 = 'ACORD_828',
  Acord_829 = 'ACORD_829',
  Acord_830 = 'ACORD_830',
  Acord_832 = 'ACORD_832',
  Acord_833 = 'ACORD_833',
  Acord_834 = 'ACORD_834',
  Acord_838 = 'ACORD_838'
}

/** Represents a single documentation result. */
export type DocumentationResult = {
  __typename?: 'DocumentationResult';
  /** Snippet or content excerpt from the documentation */
  content: Scalars['String']['output'];
  /** Path or URL to the documentation */
  path: Scalars['String']['output'];
  /** Title of the documentation result */
  title: Scalars['String']['output'];
};

/**
 * Represents a tool for creating or editing Word (.docx) documents.
 * Used when the LLM needs to create or edit a Word document.
 */
export type DocxEditorTool = {
  __typename?: 'DocxEditorTool';
  /** The input arguments for the Word document creation or editing */
  input: DocxEditorToolInput;
  /** The result of the Word document creation or editing operation */
  output: DocxEditorToolOutput;
};

/**
 * Input arguments for the DocxEditorToolAddSectionInput.
 * Contains all necessary information to add a section to a Word document.
 */
export type DocxEditorToolAddSectionInput = {
  __typename?: 'DocxEditorToolAddSectionInput';
  /** The section ID to add this section after, blank if inserting at the start */
  afterSectionId?: Maybe<Scalars['String']['output']>;
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolCreateFromTemplateInput.
 * Contains all necessary information to create a Word document from a template.
 */
export type DocxEditorToolCreateFromTemplateInput = {
  __typename?: 'DocxEditorToolCreateFromTemplateInput';
  /** The requirements for each section to create */
  sections: Array<DocxEditorToolCreateFromTemplateSectionInput>;
  /** The template ID */
  templateId: Scalars['String']['output'];
};

export type DocxEditorToolCreateFromTemplateSectionInput = {
  __typename?: 'DocxEditorToolCreateFromTemplateSectionInput';
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolCreateInput.
 * Contains all necessary information to create a Word document.
 */
export type DocxEditorToolCreateInput = {
  __typename?: 'DocxEditorToolCreateInput';
  /** The requirements for the document */
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolDeleteSectionInput.
 * Contains all necessary information to delete a section of a Word document.
 */
export type DocxEditorToolDeleteSectionInput = {
  __typename?: 'DocxEditorToolDeleteSectionInput';
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditInput.
 * Contains all necessary information to edit a Word document.
 */
export type DocxEditorToolEditInput = {
  __typename?: 'DocxEditorToolEditInput';
  /** The ID of the document to edit */
  artifactId: Scalars['String']['output'];
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditSectionInput.
 * Contains all necessary information to edit one or more sections of a Word document in a
 * single call. Every edited section must belong to the same template-based document.
 */
export type DocxEditorToolEditSectionInput = {
  __typename?: 'DocxEditorToolEditSectionInput';
  /** The sections to edit */
  sections: Array<DocxEditorToolEditSectionItemInput>;
};

/** A single section edit within a DocxEditorToolEditSectionInput. */
export type DocxEditorToolEditSectionItemInput = {
  __typename?: 'DocxEditorToolEditSectionItemInput';
  /** The requirements for the section */
  requirements: Scalars['String']['output'];
  /** The section ID */
  sectionId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolEditUploadedInput.
 * Contains all necessary information to edit a Word document.
 */
export type DocxEditorToolEditUploadedInput = {
  __typename?: 'DocxEditorToolEditUploadedInput';
  /** The requirements for the document */
  requirements: Scalars['String']['output'];
  /** The content of the document */
  sourceFileId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorTool.
 * Contains all necessary information to create or edit a Word document.
 */
export type DocxEditorToolInput = {
  __typename?: 'DocxEditorToolInput';
  /** The input for the ADD_SECTION operation */
  addSection?: Maybe<DocxEditorToolAddSectionInput>;
  /** The input for the CREATE operation */
  create?: Maybe<DocxEditorToolCreateInput>;
  /** The input for the CREATE_FROM_TEMPLATE operation */
  createFromTemplate?: Maybe<DocxEditorToolCreateFromTemplateInput>;
  /** The input for the DELETE_SECTION operation */
  deleteSection?: Maybe<DocxEditorToolDeleteSectionInput>;
  /** The input for the EDIT_CREATED operation */
  edit?: Maybe<DocxEditorToolEditInput>;
  /** The input for the EDIT_SECTION operation */
  editSection?: Maybe<DocxEditorToolEditSectionInput>;
  /** The input for the EDIT_UPLOADED operation */
  editUploaded?: Maybe<DocxEditorToolEditUploadedInput>;
  /** The input for the INSPECT_ARTIFACT operation */
  inspectArtifact?: Maybe<DocxEditorToolInspectArtifactInput>;
  /** The input for the INSPECT_UPLOADED operation */
  inspectUploaded?: Maybe<DocxEditorToolInspectUploadedInput>;
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** Short human-readable label for this operation shown in the workspace timeline and artifact cards. */
  title: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolInspectArtifactInput.
 * Contains all necessary information to inspect a Word document.
 */
export type DocxEditorToolInspectArtifactInput = {
  __typename?: 'DocxEditorToolInspectArtifactInput';
  /** The ID of the artifact to inspect */
  artifactId: Scalars['String']['output'];
};

/**
 * Input arguments for the DocxEditorToolInspectUploadedInput.
 * Contains all necessary information to inspect a Word document.
 */
export type DocxEditorToolInspectUploadedInput = {
  __typename?: 'DocxEditorToolInspectUploadedInput';
  /** The ID of the file to inspect */
  fileId: Scalars['String']['output'];
};

/**
 * Output of the DocxEditorTool.
 * Contains information about the created or edited Word document.
 */
export type DocxEditorToolOutput = {
  __typename?: 'DocxEditorToolOutput';
  /** The ID of the Word document */
  artifactId?: Maybe<Scalars['String']['output']>;
  /**
   * The DOCX inspection of the Word document if requested by the tool, and if either
   * an ad-hoc document created in the workspace or one that was created by editing
   * a user-uploaded file. Omitted if created from a template.
   */
  docxInspection?: Maybe<Scalars['String']['output']>;
  /**
   * A description of the sections created or edited. Omitted if not a sectioned document,
   * such as an ad-hoc document created in the workspace or one that was created by editing
   * a user-uploaded file.
   */
  sections?: Maybe<Array<DocxEditorToolSectionOutput>>;
  /** The version of the artifact */
  version?: Maybe<Scalars['Int']['output']>;
};

/**
 * Output of a field of a section of a Word document.
 * Contains information about the field.
 */
export type DocxEditorToolSectionFieldOutput = {
  __typename?: 'DocxEditorToolSectionFieldOutput';
  /** The ID of the field */
  id: Scalars['String']['output'];
  /** The placeholder text for the field */
  placeholder: Scalars['String']['output'];
  /** The value of the field */
  value: Scalars['String']['output'];
};

/**
 * Output of a section of a Word document.
 * Contains information about the section.
 */
export type DocxEditorToolSectionOutput = {
  __typename?: 'DocxEditorToolSectionOutput';
  /** The description of the section that was generated by the LLM */
  description?: Maybe<Scalars['String']['output']>;
  /** The fields of the section */
  fieldValues?: Maybe<Array<DocxEditorToolSectionFieldOutput>>;
  /** The ID of the section */
  id: Scalars['String']['output'];
  /** The ID of the original template section this section was generated from */
  templateSectionId: Scalars['String']['output'];
};

/**
 * A retired document-drafting tool, no longer registered with the agent. The
 * type remains so historical tool calls replay.
 */
export type DraftDocumentTool = {
  __typename?: 'DraftDocumentTool';
  /** The input arguments for document drafting */
  input: DraftDocumentToolInput;
  /** The result of the document drafting operation */
  output: DraftDocumentToolOutput;
};

/**
 * Input arguments for the DraftDocumentTool.
 * Contains all necessary information to draft a document.
 */
export type DraftDocumentToolInput = {
  __typename?: 'DraftDocumentToolInput';
  /** The ID of the document artifact being created */
  artifactId: Scalars['String']['output'];
  /** The HTML content of the document */
  htmlContent: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/**
 * Result of a DraftDocumentTool operation.
 * Contains information about the created document artifact.
 */
export type DraftDocumentToolOutput = {
  __typename?: 'DraftDocumentToolOutput';
  /** The ID of the created document artifact */
  artifactId: Scalars['String']['output'];
};

/**
 * Represents a tool for composing an email and saving it as a workspace draft.
 * Nothing in this tool sends it.
 */
export type DraftEmailTool = {
  __typename?: 'DraftEmailTool';
  /** The input arguments for email drafting */
  input: DraftEmailToolInput;
  /** The result of the email drafting operation */
  output: DraftEmailToolOutput;
};

/** The current visible version of an attached workspace artifact. */
export type DraftEmailToolAttachmentArtifact = {
  __typename?: 'DraftEmailToolAttachmentArtifact';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: CaraWorkspaceArtifactType;
  version: Scalars['Int']['output'];
};

/** File metadata needed to identify and edit an email attachment. Storage details are omitted. */
export type DraftEmailToolAttachmentFile = {
  __typename?: 'DraftEmailToolAttachmentFile';
  id: Scalars['String']['output'];
  mimeType: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

/**
 * Input for the CREATE_DRAFT operation, which composes an email and saves it as a
 * workspace draft.
 */
export type DraftEmailToolCreateDraftInput = {
  __typename?: 'DraftEmailToolCreateDraftInput';
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  attachmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  bcc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  bodyHtml: Scalars['String']['output'];
  cc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  to: Array<DraftEmailToolRecipientInput>;
};

/**
 * Input for the CREATE_FROM_TEMPLATE operation, which builds an email from an agency email
 * template with the values and section texts Cara passes and saves it as a workspace draft
 * the way CREATE_DRAFT does.
 */
export type DraftEmailToolCreateFromTemplateInput = {
  __typename?: 'DraftEmailToolCreateFromTemplateInput';
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  attachmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  bcc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  cc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  sections: Array<DraftEmailToolTemplateSectionText>;
  templateId: Scalars['String']['output'];
  templateVersion: Scalars['Int64']['output'];
  to: Array<DraftEmailToolRecipientInput>;
  values: Array<DraftEmailToolTemplateValue>;
};

/**
 * Input arguments for the DraftEmailTool.
 *
 * Two shapes meet here. `operation` and the sub-object it names are what the model
 * sends and what a call is recorded as. Beneath them are the shapes DRAFT_EMAIL
 * recorded when it was three tools and one email per call: `subject`, `bodyHtml`,
 * `to`, `cc`, `bcc` and `attachmentArtifactIds`, and, older still, `artifactId`,
 * `toEmail`, `toName` and `body`. Events written then are still read back through
 * this type, so the composer card reads whichever shape is populated.
 *
 * Only the operation fields carry tool descriptions, so they are the whole of
 * the schema the model is given.
 */
export type DraftEmailToolInput = {
  __typename?: 'DraftEmailToolInput';
  /** The ID the calling model chose for the email artifact */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** Workspace artifact IDs attached to the email */
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  /** The BCC recipients */
  bcc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** The body content of the email, as plain text */
  body?: Maybe<Scalars['String']['output']>;
  /** The body as HTML */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** The CC recipients */
  cc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  createDraft?: Maybe<DraftEmailToolCreateDraftInput>;
  createFromTemplate?: Maybe<DraftEmailToolCreateFromTemplateInput>;
  operation: Scalars['String']['output'];
  placeDraftInMailbox?: Maybe<DraftEmailToolPlaceDraftInMailboxInput>;
  readDraft?: Maybe<DraftEmailToolReadDraftInput>;
  /** The subject line of the email */
  subject: Scalars['String']['output'];
  /** The primary recipients */
  to?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** The single recipient's email address */
  toEmail?: Maybe<Scalars['String']['output']>;
  /** The single recipient's name */
  toName?: Maybe<Scalars['String']['output']>;
  updateDraft?: Maybe<DraftEmailToolUpdateDraftInput>;
};

/**
 * Result of a DraftEmailTool operation. UpdateEmailDraftTool also uses this shape
 * for its legacy recorded output.
 *
 * `version` and `subject` are absent on events recorded before the output carried
 * them, which is why neither is required.
 */
export type DraftEmailToolOutput = {
  __typename?: 'DraftEmailToolOutput';
  /** The ID of the email artifact */
  artifactId: Scalars['String']['output'];
  /**
   * Readable metadata for the current artifact attachments, in attachment order.
   * Unavailable artifacts keep their IDs in email.attachmentArtifactIds but have no metadata here.
   */
  attachmentArtifacts?: Maybe<Array<DraftEmailToolAttachmentArtifact>>;
  /**
   * Readable metadata for the current file attachments, in attachment order.
   * Unavailable files keep their IDs in email.attachmentFileIds but have no metadata here.
   */
  attachmentFiles?: Maybe<Array<DraftEmailToolAttachmentFile>>;
  /** The body a draft made from a template was saved with, since the call's input has none. */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /**
   * The fingerprint of the composition READ_DRAFT returned, which identifies those
   * exact words for a later reader. Revisions carry attachment additions and removals
   * rather than a fingerprint, so nothing takes this back as an argument.
   */
  contentRevision?: Maybe<Scalars['String']['output']>;
  /** The current saved composition returned by READ_DRAFT. Includes composer edits. */
  email?: Maybe<CaraWorkspaceArtifactEmail>;
  /** The mailbox PLACE_DRAFT_IN_MAILBOX wrote the draft into */
  mailboxEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The placeholder labels a draft made from a template left blank because Cara gave them an
   * empty value. The agent fills them in or removes them before the email can be sent.
   */
  missingFields?: Maybe<Array<Scalars['String']['output']>>;
  /** The current saved subject */
  subject?: Maybe<Scalars['String']['output']>;
  /** The current artifact version returned by the operation */
  version?: Maybe<Scalars['Int']['output']>;
  /** The provider's link to the mailbox draft, when it hands one back */
  webLink?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for the PLACE_DRAFT_IN_MAILBOX operation, which copies a draft into the
 * agent's connected mailbox as a native draft.
 */
export type DraftEmailToolPlaceDraftInMailboxInput = {
  __typename?: 'DraftEmailToolPlaceDraftInMailboxInput';
  artifactId: Scalars['String']['output'];
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
};

/** Reads the current saved composition, including changes made in the composer. */
export type DraftEmailToolReadDraftInput = {
  __typename?: 'DraftEmailToolReadDraftInput';
  artifactId: Scalars['String']['output'];
};

/** A recipient the model addresses an email to. */
export type DraftEmailToolRecipientInput = {
  __typename?: 'DraftEmailToolRecipientInput';
  email: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** Which template a redraft uses and what Cara fills it with. */
export type DraftEmailToolTemplateInput = {
  __typename?: 'DraftEmailToolTemplateInput';
  sections: Array<DraftEmailToolTemplateSectionText>;
  templateId: Scalars['String']['output'];
  templateVersion: Scalars['Int64']['output'];
  values: Array<DraftEmailToolTemplateValue>;
};

export type DraftEmailToolTemplateSectionText = {
  __typename?: 'DraftEmailToolTemplateSectionText';
  bodyHtml: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

/**
 * What Cara puts in place of one placeholder. A list of these stands in for a map, which a
 * tool schema can't express.
 */
export type DraftEmailToolTemplateValue = {
  __typename?: 'DraftEmailToolTemplateValue';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/**
 * Input for the UPDATE_DRAFT operation, which writes a revision of a draft as a new
 * version of the same artifact. Every editable field is optional because the call is
 * a patch: an absent field keeps its current value, an empty recipient list clears
 * that list, and the attachments change only by the IDs this call names.
 */
export type DraftEmailToolUpdateDraftInput = {
  __typename?: 'DraftEmailToolUpdateDraftInput';
  addAttachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  addAttachmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  artifactId: Scalars['String']['output'];
  bcc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  bodyHtml?: Maybe<Scalars['String']['output']>;
  cc?: Maybe<Array<DraftEmailToolRecipientInput>>;
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  removeAttachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  removeAttachmentFileIds?: Maybe<Array<Scalars['String']['output']>>;
  removeTemplate?: Maybe<Scalars['Boolean']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  template?: Maybe<DraftEmailToolTemplateInput>;
  to?: Maybe<Array<DraftEmailToolRecipientInput>>;
};

/**
 * Represents a tool for drafting an outbound call proposal.
 * The LLM fills in call details from workspace context; the user reviews, edits, and confirms.
 */
export type DraftOutboundCallTool = {
  __typename?: 'DraftOutboundCallTool';
  /** The input arguments for the outbound call draft */
  input: DraftOutboundCallToolInput;
  /** The result of the draft operation (echoed artifactId) */
  output: DraftOutboundCallToolOutput;
};

/** Input arguments for the DraftOutboundCallTool. */
export type DraftOutboundCallToolInput = {
  __typename?: 'DraftOutboundCallToolInput';
  /**
   * Optional. Omit on the first draft — the server assigns a stable artifact ID.
   * When updating a prior draft, pass the artifactId from that tool's output.
   */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** What Cara should accomplish on the call. */
  callObjective: Scalars['String']['output'];
  /** Direct callback number Cara should give if the customer needs to call back. */
  callbackPhone?: Maybe<Scalars['String']['output']>;
  /** Background context about the customer to help Cara personalize the call. */
  customerContext?: Maybe<Scalars['String']['output']>;
  /** Customer's full name. */
  customerName?: Maybe<Scalars['String']['output']>;
  /** Customer's phone number in E.164 format (+12125551234). */
  customerPhone?: Maybe<Scalars['String']['output']>;
  /** Custom call guidelines or instructions for Cara. */
  guidelines?: Maybe<Scalars['String']['output']>;
  /** Whether Cara should leave a voicemail if the customer doesn't answer. */
  leaveVoicemail: Scalars['Boolean']['output'];
  /** ISO 8601 datetime for when the call should be placed. */
  scheduledAt?: Maybe<Scalars['String']['output']>;
  /** IANA timezone for the scheduled time, e.g. America/New_York. */
  timezone: Scalars['String']['output'];
};

/** Result of a DraftOutboundCallTool operation. */
export type DraftOutboundCallToolOutput = {
  __typename?: 'DraftOutboundCallToolOutput';
  /** The artifact ID echoed back from the input. */
  artifactId: Scalars['String']['output'];
  /**
   * Set after the user confirms the draft via createOutboundCall.
   * When present, the UI shows the confirmed/scheduled state instead of the editable form
   * (survives refresh). Written by the API — not by the DRAFT_OUTBOUND_CALL tool itself.
   */
  outboundCallId?: Maybe<Scalars['String']['output']>;
  /**
   * Schedule snapshot from confirmation (null when the call was queued immediately).
   * Written together with outboundCallId.
   */
  scheduledAt?: Maybe<Scalars['Time']['output']>;
};

/** Element-specific styles */
export type ElementStyles = {
  __typename?: 'ElementStyles';
  /** Code block styles */
  code: CodeStyle;
  /** Heading styles */
  headings: HeadingStyles;
  /** Image styles */
  image: ImageStyle;
  /** Link styles */
  link: LinkStyle;
  /** List styles */
  list: ListStyle;
  /** Paragraph styles */
  paragraph: ParagraphStyle;
  /** Table styles */
  table: TableStyle;
};

/** Input for element-specific styles */
export type ElementStylesInput = {
  /** Code block style settings */
  code?: InputMaybe<CodeStyleInput>;
  /** Heading styles (for h1-h6) */
  headings?: InputMaybe<HeadingStylesInput>;
  /** Image style settings */
  image?: InputMaybe<ImageStyleInput>;
  /** Link style settings */
  link?: InputMaybe<LinkStyleInput>;
  /** List style settings */
  list?: InputMaybe<ListStyleInput>;
  /** Paragraph style settings */
  paragraph?: InputMaybe<ParagraphStyleInput>;
  /** Table style settings */
  table?: InputMaybe<TableStyleInput>;
};

/** Represents an email message in a thread */
export type Email = {
  __typename?: 'Email';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Carbon copy recipients of the email */
  cc: Array<EmailParticipant>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Hash of the email content for deduplication */
  hash: Scalars['String']['output'];
  /** Unique identifier for the email */
  id: Scalars['ID']['output'];
  /** Message-ID this email is replying to, if any */
  inReplyToMessageId?: Maybe<Scalars['String']['output']>;
  /** Unique Message-ID header value from the email */
  messageId: Scalars['String']['output'];
  /** Role of the sender (agent, Cara, or participant) */
  senderRole: EmailSenderRole;
  /** Timestamp when the email was sent */
  sentAt: Scalars['Time']['output'];
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** ID of the thread this email belongs to */
  threadId: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
};

export type EmailAmsCandidate = {
  __typename?: 'EmailAmsCandidate';
  /** The account as an email's amsLog target names it. */
  account: AmsRef;
  accountEntityId: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  matchedAddresses: Array<EmailAmsMatchedAddress>;
};

export type EmailAmsChoice = {
  __typename?: 'EmailAmsChoice';
  /** The target's name, set when target is. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Optional record below the client account. */
  filingTarget?: Maybe<EmailAmsFilingTarget>;
  /** The account to log to. Null means the agent chose not to log the email. */
  target?: Maybe<AmsRef>;
};

/** A record below the required client account. */
export type EmailAmsFilingTarget = {
  __typename?: 'EmailAmsFilingTarget';
  /** The label shown when the record was chosen. */
  displayName: Scalars['String']['output'];
  /** Optional folder combined with a policy or activity target. */
  folder?: Maybe<AmsRef>;
  /** The combined folder's label, set by the server. */
  folderDisplayName?: Maybe<Scalars['String']['output']>;
  /** The record identity, including the chosen account. */
  ref: AmsRef;
};

export type EmailAmsFilingTargetInput = {
  /** The label shown when the record was chosen. */
  displayName: Scalars['String']['input'];
  /** Optional folder combined with a policy or activity target. */
  folder?: InputMaybe<AmsRefInput>;
  /** The combined folder's label when it was chosen. */
  folderDisplayName?: InputMaybe<Scalars['String']['input']>;
  /** The record identity, including the chosen account. */
  ref: AmsRefInput;
};

export type EmailAmsLogCodeOption = {
  __typename?: 'EmailAmsLogCodeOption';
  code: Scalars['String']['output'];
  label: Scalars['String']['output'];
};

/** The kind of AMS record that receives a sent email. */
export enum EmailAmsLogDestination {
  Activity = 'ACTIVITY',
  Attachment = 'ATTACHMENT',
  Note = 'NOTE',
  Suspense = 'SUSPENSE'
}

export type EmailAmsLogOptions = {
  __typename?: 'EmailAmsLogOptions';
  activityCodes: Array<EmailAmsLogCodeOption>;
  companies: Array<EmailAmsLogCodeOption>;
  destinations: Array<EmailAmsLogDestination>;
  employees: Array<EmailAmsLogCodeOption>;
  preference: EmailAmsLogPreference;
};

export type EmailAmsLogPreference = {
  __typename?: 'EmailAmsLogPreference';
  activityCode?: Maybe<Scalars['String']['output']>;
  assignToEmployeeCode?: Maybe<Scalars['String']['output']>;
  assignedByEmployeeCode?: Maybe<Scalars['String']['output']>;
  companyCode?: Maybe<Scalars['String']['output']>;
  destination: EmailAmsLogDestination;
};

export type EmailAmsLogPreferenceInput = {
  activityCode?: InputMaybe<Scalars['String']['input']>;
  assignToEmployeeCode?: InputMaybe<Scalars['String']['input']>;
  assignedByEmployeeCode?: InputMaybe<Scalars['String']['input']>;
  companyCode?: InputMaybe<Scalars['String']['input']>;
  destination: EmailAmsLogDestination;
};

export enum EmailAmsLogSetter {
  Agent = 'AGENT',
  Cara = 'CARA'
}

/**
 * The accounts an email's To recipients lead to in the AMS that logs the agency's sent
 * emails. Cara logs an email by itself only on ONE_MATCH; otherwise an agent chooses.
 */
export type EmailAmsMatch = {
  __typename?: 'EmailAmsMatch';
  /** The recipient-matched accounts, narrowed when a policy number breaks a tie, by display name. */
  candidates: Array<EmailAmsCandidate>;
  /**
   * The choice saved on the email, when a send to these To addresses would use it. Null
   * when nobody chose for them, so Cara goes by the outcome.
   */
  choice?: Maybe<EmailAmsChoice>;
  /** Record kinds available below the required client account. */
  filingKinds: Array<AmsRefKind>;
  integrationId: Scalars['String']['output'];
  integrationType: IntegrationType;
  /** Whether Cara can log emails to this AMS. False shows the AMS as not supported yet. */
  isSupported: Scalars['Boolean']['output'];
  outcome: EmailAmsMatchOutcome;
};

export enum EmailAmsMatchOutcome {
  NoMatch = 'NO_MATCH',
  /** The recipients lead to one account, or a policy number breaks a tie between them. */
  OneMatch = 'ONE_MATCH',
  /** More than one recipient matches, and together they lead to several accounts. */
  RecipientsMatchSeveral = 'RECIPIENTS_MATCH_SEVERAL',
  /** One recipient matches, and leads to several accounts. */
  SeveralMatch = 'SEVERAL_MATCH'
}

export type EmailAmsMatchedAddress = {
  __typename?: 'EmailAmsMatchedAddress';
  /** Lowercased. */
  address: Scalars['String']['output'];
  /** ACCOUNT when the address is the account's own, CONTACT when it is one of its contacts'. */
  matchedVia: KnowledgeGraphEntityType;
};

/**
 * Emails to many clients, sent together. Cara drafts it in a workspace as a bulk draft: a
 * list of recipients, each with an ordinary email draft of its own in that workspace, from its
 * own template or none. Sending it makes it a batch, whose emails go out one at a time and show
 * in Outgoing like any other.
 */
export type EmailBulkSend = {
  __typename?: 'EmailBulkSend';
  /** What Send did. Null while it's a bulk draft. */
  action?: Maybe<EmailBulkSendAction>;
  /**
   * Whether Change time can move the current round: a Schedule all, not cancelled, none of whose
   * round's emails has gone out.
   */
  canChangeTime: Scalars['Boolean']['output'];
  /**
   * Whether Cancel makes the batch a bulk draft again: a first round none of whose emails has gone
   * out. Otherwise Cancel cancels the rest and the batch stays sent.
   */
  cancelReturnsToDraft: Scalars['Boolean']['output'];
  /** When the sender cancelled the emails that hadn't gone out yet. */
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  /** How far Cara has got drafting the recipients' emails. */
  draftProgress: EmailBulkSendDraftProgress;
  /** When the first email goes out. Null while it's a bulk draft, and for MOVE_TO_DRAFTS. */
  firstSendAt?: Maybe<Scalars['Time']['output']>;
  fromAddress?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * True while the batch is due but waits for another batch from its mailbox to finish, as a
   * mailbox sends one batch at a time.
   */
  isWaitingForMailbox: Scalars['Boolean']['output'];
  /** The mailbox it goes out from. Null while it's a bulk draft. */
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  /** What the agent calls it in Outgoing, such as "Renewal reminder · Oct 12". */
  name: Scalars['String']['output'];
  /**
   * The emails Send held back that were later sent or saved to a mailbox on their own, counted
   * as progress counts the batch's. Kept out of progress, as they aren't the batch's. Here total
   * is these emails, scheduled is those scheduled or sending on their own, and heldBack and
   * notSent are always 0.
   */
  outsideBatchProgress: EmailBulkSendProgress;
  /** How far the sent emails have got, across every round. All zero while it's a bulk draft. */
  progress: EmailBulkSendProgress;
  /** At most 50, in the order they were added, no address twice. */
  recipients: Array<EmailBulkSendRecipient>;
  /**
   * How many emails Send the rest would send: drafted, ready and never sent, nor waiting or
   * going. 0 while the current round has emails to send, for Move all to drafts and for a bulk
   * draft.
   */
  restCount: Scalars['Int']['output'];
  /**
   * How far the current round has got: the emails its Send handed off, each by its newest send.
   * The same as progress but for heldBack and notSent, which are always 0, until Send the rest.
   */
  roundProgress: EmailBulkSendProgress;
  /** When the agent sent it. Null while it's a bulk draft. */
  sentAt?: Maybe<Scalars['Time']['output']>;
  sentBy?: Maybe<AgencyUser>;
  /** The workspace Cara drafted it in, which holds every recipient's email. */
  workspaceId: Scalars['String']['output'];
};

export enum EmailBulkSendAction {
  /** Save every ready email as its own draft in the sending mailbox. Nothing is sent. */
  MoveToDrafts = 'MOVE_TO_DRAFTS',
  /** Send every ready email from a picked time, about 10 seconds apart. */
  ScheduleAll = 'SCHEDULE_ALL',
  /** Send every ready email now, about 10 seconds apart. */
  SendAll = 'SEND_ALL'
}

export type EmailBulkSendDraftProgress = {
  __typename?: 'EmailBulkSendDraftProgress';
  failed: Scalars['Int']['output'];
  /** Recipients whose drafting run has ended, drafted or failed. */
  finished: Scalars['Int']['output'];
  /** Recipients Cara has been asked to draft: every one but NOT_DRAFTED. */
  total: Scalars['Int']['output'];
};

export enum EmailBulkSendDraftState {
  /** The email is drafted. It may still be held back by a blank field or a missing address. */
  Drafted = 'DRAFTED',
  /** A drafting run is writing this recipient's email. */
  Drafting = 'DRAFTING',
  /** The last drafting run failed. Only Cara, asked in the workspace, drafts it again. */
  Failed = 'FAILED',
  /**
   * No email drafted yet, as for a client added on the page. It stays so until the agent asks
   * Cara in the workspace to draft it, and Send leaves it out.
   */
  NotDrafted = 'NOT_DRAFTED'
}

/** How far a batch's emails have got, one count per email by its newest send. */
export type EmailBulkSendProgress = {
  __typename?: 'EmailBulkSendProgress';
  /** Cancelled before they went out; they are drafts in Cara again. */
  cancelled: Scalars['Int']['output'];
  failed: Scalars['Int']['output'];
  /** Drafted emails on the recipient list that Send held back and nobody has sent or saved to a mailbox since. */
  heldBack: Scalars['Int']['output'];
  /** Saved as drafts in the sending mailbox and never sent. */
  inDrafts: Scalars['Int']['output'];
  /** Recipients with no sendStatus: never drafted, or whose draft was deleted from the mailbox unsent. Zero before Send. */
  notSent: Scalars['Int']['output'];
  /** Waiting to go out: Queued for Send all, Scheduled for Schedule all, or not yet saved for Move all to drafts. */
  scheduled: Scalars['Int']['output'];
  sending: Scalars['Int']['output'];
  sent: Scalars['Int']['output'];
  /** Emails in the batch. */
  total: Scalars['Int']['output'];
};

/** One client a bulk email goes to, and the email Cara drafted for them. */
export type EmailBulkSendRecipient = {
  __typename?: 'EmailBulkSendRecipient';
  /** The AMS account the agent picked this client from, when they did. */
  amsAccountId?: Maybe<Scalars['String']['output']>;
  /** The email drafted for this recipient. Null until its first draft exists. */
  artifactId?: Maybe<Scalars['String']['output']>;
  draftState: EmailBulkSendDraftState;
  /**
   * Null for a client Cara listed without an address until a drafting run finds one; Send
   * leaves the recipient out while it's null.
   */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * Why this recipient's drafted email is left out of the send, such as "First name is blank"
   * or "Couldn't draft this email". Null when it's ready, and before it's drafted.
   */
  heldBackReason?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  /**
   * True for an email Send held back that was later sent or saved to a mailbox on its own,
   * which the bulk send's progress leaves out.
   */
  isOutsideBatch: Scalars['Boolean']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** Why the email's newest send failed, when sendStatus is FAILED. */
  sendFailureKind?: Maybe<OutboundEmailFailureKind>;
  /**
   * Where this recipient's email stands since Send, by the same rules as the bulk send's
   * progress. Null before Send, for a recipient with no drafted email, and for a held-back email
   * saved to a mailbox on its own and then deleted there.
   */
  sendStatus?: Maybe<EmailBulkSendRecipientSendStatus>;
};

/** A client the agent adds to a bulk draft on its page, picked in client search or typed. */
export type EmailBulkSendRecipientInput = {
  amsAccountId?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Where a sent bulk email's email stands: its newest send's status, or what Send left it as. */
export enum EmailBulkSendRecipientSendStatus {
  /** Cancelled before it went out; it's a draft in Cara again. */
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  /** Left out by Send, and still only a draft in Cara. */
  HeldBack = 'HELD_BACK',
  /** Saved as a draft in the sending mailbox and not sent. */
  InDrafts = 'IN_DRAFTS',
  /** Move all to drafts couldn't save it to the mailbox. */
  SaveFailed = 'SAVE_FAILED',
  /** Waiting to go out: Queued for Send all, Scheduled for Schedule all, or not yet saved for Move all to drafts. */
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

/** Represents a draft of an email message in a thread */
export type EmailDraft = {
  __typename?: 'EmailDraft';
  /** Body content of the email */
  body: Scalars['String']['output'];
  /** Sender of the email */
  from: EmailParticipant;
  /** Subject line of the email */
  subject: Scalars['String']['output'];
  /** Primary recipients of the email */
  to: Array<EmailParticipant>;
};

/** Represents a participant (sender or recipient) of an email */
export type EmailParticipant = {
  __typename?: 'EmailParticipant';
  /** Email address of the participant */
  email: Scalars['String']['output'];
  /** Display name of the participant */
  name: Scalars['String']['output'];
};

/** Role of an email sender in the context of the system */
export enum EmailSenderRole {
  /** Message sent by an agency agent */
  Agent = 'AGENT',
  /** Message sent by the Cara AI assistant */
  Cara = 'CARA',
  /** Message sent by a known client */
  Client = 'CLIENT',
  /** Message sent by any other participant */
  Participant = 'PARTICIPANT'
}

/**
 * An email someone at the agency writes once for Cara to send many times. Text outside the
 * Cara sections in bodyHtml is sent word for word, with each [[placeholder]] holding a value Cara
 * finds or left blank for the agent when it finds none.
 */
export type EmailTemplate = {
  __typename?: 'EmailTemplate';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The body, with placeholders written as their label in double square brackets
   * ([[renewal date]]) and Cara sections as <div data-cara-section="id"> holding the instruction
   * for that section.
   */
  bodyHtml: Scalars['String']['output'];
  /**
   * Whether the caller may edit or archive the template or change its visibility: they need the
   * EMAIL_TEMPLATE UPDATE permission and must be its creator or an admin.
   */
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  /** Who made the template. Null when that user no longer exists. */
  createdBy?: Maybe<AgencyUser>;
  /**
   * Rules Cara follows when it writes this template's Cara sections, on top of the agency's
   * guidelines for every email, which win where the two disagree.
   */
  guidelines: Array<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
  /**
   * Who saved the latest version. Null when the save wasn't made by an agency user or the user
   * no longer exists.
   */
  updatedBy?: Maybe<AgencyUser>;
  /**
   * How many email drafts recorded this template on a version written in the last 30 days,
   * counted once each. Null when the count couldn't be read.
   */
  usageLast30Days?: Maybe<Scalars['Int']['output']>;
  /**
   * Unix milliseconds of the latest edit. A draft records the version it was made from, so a
   * newer version means the template changed after the draft was made.
   */
  version: Scalars['Int64']['output'];
  /** Who can see the template and have Cara draft from it. */
  visibility: VisibilityConfig;
  /** Helps Cara decide when to suggest this template. Null when its author left it blank. */
  whenToUse?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplateCaraSection = {
  __typename?: 'EmailTemplateCaraSection';
  id: Scalars['String']['output'];
  /** What the template's author asked Cara to write here. */
  instruction: Scalars['String']['output'];
};

/** An email template as GET shows it to Cara: the fixed wording and the parts Cara fills. */
export type EmailTemplateFillList = {
  __typename?: 'EmailTemplateFillList';
  /**
   * The body. Text outside the Cara sections is sent word for word, with each [[placeholder]]
   * replaced by the value Cara gives for it.
   */
  bodyHtml: Scalars['String']['output'];
  /** The parts Cara writes for each email, in body order. */
  caraSections: Array<EmailTemplateCaraSection>;
  /**
   * Rules for writing the Cara sections, on top of the agency's guidelines, which win where the
   * two disagree.
   */
  guidelines: Array<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  /**
   * Every placeholder in the subject and body, Cara section instructions included, once each
   * in order of first use.
   */
  placeholders: Array<EmailTemplatePlaceholder>;
  subject: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  /** The version read. A draft passes it back, so one written from an older version is refused. */
  templateVersion: Scalars['Int64']['output'];
};

/** An email template as LIST shows it to Cara. */
export type EmailTemplateInfo = {
  __typename?: 'EmailTemplateInfo';
  name: Scalars['String']['output'];
  templateId: Scalars['String']['output'];
  /** When the template's author says to use it. Null when they left it blank. */
  whenToUse?: Maybe<Scalars['String']['output']>;
};

export type EmailTemplateInput = {
  bodyHtml: Scalars['String']['input'];
  guidelines: Array<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  subject: Scalars['String']['input'];
  /**
   * When omitted on create, the template is PUBLIC. When omitted on update, its visibility is
   * kept.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
  whenToUse?: InputMaybe<Scalars['String']['input']>;
};

export type EmailTemplatePlaceholder = {
  __typename?: 'EmailTemplatePlaceholder';
  /** The label written between [[ and ]], normalized: lowercase with spaces collapsed. */
  label: Scalars['String']['output'];
};

export enum EmailTemplateUpdateReasonCode {
  /** Placeholder until a reason is needed */
  Unknown = 'UNKNOWN'
}

export enum EmailTemplateUpdateType {
  CreateEmailTemplate = 'CREATE_EMAIL_TEMPLATE',
  UpdateEmailTemplate = 'UPDATE_EMAIL_TEMPLATE'
}

/** One saved version of an email template. */
export type EmailTemplateVersion = {
  __typename?: 'EmailTemplateVersion';
  createdAt: Scalars['Time']['output'];
  emailTemplate: EmailTemplate;
  updateInitiatorId: Scalars['String']['output'];
  updateInitiatorType: UpdateInitiatorType;
  updatePrivate: Scalars['Boolean']['output'];
  updateReason?: Maybe<Scalars['String']['output']>;
  updateReasonCode?: Maybe<EmailTemplateUpdateReasonCode>;
  updateTypes: Array<EmailTemplateUpdateType>;
  version: Scalars['Int64']['output'];
};

/** Represents an email thread */
export type EmailThread = {
  __typename?: 'EmailThread';
  /** The account associated with this email, if any */
  account?: Maybe<Account>;
  /** The agency associated with this email */
  agency: Agency;
  /** Attachments in the email thread */
  attachments: Array<File>;
  /** Timestamp when this record was created */
  createdAt: Scalars['Time']['output'];
  /** The email address of the participant who initiated the thread */
  fromEmail: Scalars['String']['output'];
  /** The name of the participant who initiated the thread */
  fromName: Scalars['String']['output'];
  /** Unique identifier for the thread */
  id: Scalars['ID']['output'];
  /** Emails in the thread from participants, clients, and agents */
  participantEmails: Array<Email>;
  /** Service requests associated with this thread */
  serviceRequests: Array<ServiceRequest>;
  /** State of the thread */
  state: EmailThreadState;
  /** The subject of the thread */
  subject: Scalars['String']['output'];
  /** The summary of the thread */
  summary: Scalars['String']['output'];
  /** Timestamp when this record was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The role of the participant that the email thread is waiting for in order to proceed */
  waitingFor?: Maybe<EmailSenderRole>;
  /** The Cara workspace this email thread is associated with, if any */
  workspace?: Maybe<CaraWorkspace>;
};

/** Represents the state of an email thread */
export enum EmailThreadState {
  /** The thread is active and waiting for a response */
  Active = 'ACTIVE',
  /** The invocation has ended */
  Ended = 'ENDED'
}

/**
 * Embedding-specific details attached to an EMBEDDING span. A provider-owned primitive
 * (text/content → vectors) that underlies the search and indexing paths.
 */
export type Embedding = {
  __typename?: 'Embedding';
  /** Total cost in dollars for this embedding call. */
  costDollars: Scalars['Decimal']['output'];
  /** Dimensionality of the produced vectors. */
  dimensions: Scalars['Int']['output'];
  /** Number of inputs embedded in this call. */
  inputCount: Scalars['Int']['output'];
  /** gen_ai.usage.input_tokens. */
  inputTokens: Scalars['Int']['output'];
  /**
   * Whether this was a corpus-indexing (DOCUMENT) or search-time (QUERY) embedding.
   * Null when unset.
   */
  inputType?: Maybe<EmbeddingInputType>;
  /**
   * Per-input debug payload. Never the vectors. May be omitted or truncated for very large
   * document batches (inputCount remains exact).
   */
  inputs: Array<EmbeddingInput>;
  /** Input modality. Null when unset. */
  modality?: Maybe<EmbeddingModality>;
  /** gen_ai.provider.name (e.g. voyage). */
  providerName: Scalars['String']['output'];
  /** gen_ai.request.model (e.g. voyage-multimodal-3, voyage-4-large). */
  requestModel: Scalars['String']['output'];
  /** Whether an input exceeded the model's max and was silently truncated. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * A single input to an embedding call. Query embeddings carry text; document embeddings
 * carry a source reference (sourceType + sourceId) that resolves via source.
 */
export type EmbeddingInput = {
  __typename?: 'EmbeddingInput';
  /**
   * The chunk's sequence number within the source document, when the embedded item is a
   * chunk of a larger document. Together with sourceId it identifies the exact chunk.
   */
  chunkId?: Maybe<Scalars['Int']['output']>;
  /** The resolved source object, when this input references one. */
  source?: Maybe<TraceSource>;
  /** The id of the embedded object, for document embeddings. */
  sourceId?: Maybe<Scalars['String']['output']>;
  /** The kind of object embedded, for document embeddings. */
  sourceType?: Maybe<TraceSourceType>;
  /** The embedded text for a query embedding (truncated); null for document embeddings. */
  text?: Maybe<Scalars['String']['output']>;
  /** Input tokens attributed to this item, when known. */
  tokens?: Maybe<Scalars['Int']['output']>;
  /** Whether this input was truncated to fit the model's max. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Whether an embedding was produced for corpus indexing or for a search query. Significant
 * because providers like Voyage encode the two differently.
 */
export enum EmbeddingInputType {
  Document = 'DOCUMENT',
  Query = 'QUERY'
}

/** The modality of an embedding's input. */
export enum EmbeddingModality {
  Image = 'IMAGE',
  Multimodal = 'MULTIMODAL',
  Text = 'TEXT'
}

/** Details for a request to endorse a policy */
export type EndorsePolicyRequest = {
  __typename?: 'EndorsePolicyRequest';
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['output'];
};

/** Input type for endorsing a policy request */
export type EndorsePolicyRequestInput = {
  /** ID of the policy to be endorsed */
  policyId: Scalars['String']['input'];
};

/**
 * An Excel (.xlsx) spreadsheet template stored for the agency. The uploaded workbook is the
 * unit of authoring; its worksheets become the template's tabs, which are discovered during
 * ingestion and filled independently when Cara generates a workbook from this template.
 */
export type ExcelSpreadsheetTemplate = {
  __typename?: 'ExcelSpreadsheetTemplate';
  /** The agency this Excel spreadsheet template is associated with */
  agency: Agency;
  /** The timestamp when this Excel spreadsheet template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this Excel spreadsheet template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this Excel spreadsheet template */
  createdBy: AgencyUser;
  /** The description of the Excel spreadsheet template */
  description: Scalars['String']['output'];
  /** An error message describing why the template processing failed. Only set when state is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * Optional guidance for Cara when filling this template. Applies to the whole workbook;
   * per-tab instructions live on the tab's fillGuidance.
   */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the Excel spreadsheet template */
  id: Scalars['ID']['output'];
  /** The processing status of the Excel spreadsheet template. */
  state?: Maybe<ExcelSpreadsheetTemplateState>;
  /**
   * The worksheets of the uploaded workbook, in workbook order. Discovered during ingestion;
   * callers annotate them (setup guidance, static/required flags) but never add or remove them.
   */
  tabs: Array<ExcelSpreadsheetTemplateTab>;
  /** The uploaded Excel (XLSX) workbook this template fills from */
  templateFile?: Maybe<File>;
  /** The title of the Excel spreadsheet template */
  title: Scalars['String']['output'];
  /** The timestamp when this Excel spreadsheet template was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this Excel spreadsheet template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this Excel spreadsheet template. The first version in this list
   * will be this version (i.e. identical to the current template), followed by the version
   * before that, and so-forth.
   */
  versionHistory?: Maybe<Array<ExcelSpreadsheetTemplateVersion>>;
  /**
   * The visibility configuration for this template (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC.
   */
  visibility: VisibilityConfig;
};

/**
 * Excel spreadsheet template info for agency library templates.
 * GET_CONTENT includes the template's tabs (with their fill guidance and fields); LIST omits them.
 */
export type ExcelSpreadsheetTemplateInfo = {
  __typename?: 'ExcelSpreadsheetTemplateInfo';
  /** The timestamp when the template was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created the template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** Optional operator guidance for filling this template (follow when present). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the template */
  id: Scalars['String']['output'];
  /** The name of the template */
  name: Scalars['String']['output'];
  /** The tabs of the template, in workbook order */
  tabs: Array<ExcelSpreadsheetTemplateTab>;
};

/** Input for creating or updating an Excel spreadsheet template */
export type ExcelSpreadsheetTemplateInput = {
  /** The description of the Excel spreadsheet template */
  description: Scalars['String']['input'];
  /**
   * Optional guidance for Cara when filling this template (shown when listing templates in
   * workspace tools).
   */
  fillGuidance?: InputMaybe<Scalars['String']['input']>;
  /**
   * The tabs of the template. Tabs are discovered from the uploaded workbook during ingestion,
   * so entries only carry the authoring metadata a user can edit and must reference an existing
   * tab by ID. Omit on create, and omit on update to leave tab metadata untouched.
   */
  tabs?: InputMaybe<Array<ExcelSpreadsheetTemplateTabInput>>;
  /** The ID of the existing workbook file to keep on update. Omit when uploading a new file. */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the Excel spreadsheet template */
  title: Scalars['String']['input'];
  /** The XLSX workbook to upload (required on create, or to replace the workbook on update) */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
  /**
   * Optional visibility configuration. When omitted on create, the template defaults to PUBLIC.
   * When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** The processing status of an Excel spreadsheet template. */
export enum ExcelSpreadsheetTemplateState {
  /** The template processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** The template is being processed. */
  Processing = 'PROCESSING',
  /** The template is queued for processing. */
  Queued = 'QUEUED',
  /** The template has been processed and is ready to fill. */
  Ready = 'READY'
}

/** One worksheet of an Excel spreadsheet template's workbook. */
export type ExcelSpreadsheetTemplateTab = {
  __typename?: 'ExcelSpreadsheetTemplateTab';
  /** The data fields to fill in this tab. These are extracted by the LLM in a pre-processing step. */
  fields: Array<ExcelSpreadsheetTemplateTabField>;
  /**
   * Description of the tab's purpose, layout, and any fill instructions to provide to the LLM.
   * This is extracted by the LLM in a pre-processing step.
   */
  fillGuidance: Scalars['String']['output'];
  /** The ID of the tab. Stable across re-ingestion as long as the worksheet keeps its name. */
  id: Scalars['ID']['output'];
  /** The worksheet name as it appears in the workbook. Unique within a template. */
  name: Scalars['String']['output'];
  /**
   * Indicates whether this tab is required (i.e. must be filled in every workbook generated
   * from this template). Optional tabs that Cara does not fill are removed from the generated
   * workbook.
   */
  required: Scalars['Boolean']['output'];
  /**
   * Optional user-provided guidance supplied when the template is created/edited. It is fed to
   * the LLM at ingestion time to help it produce a more accurate fillGuidance for this tab
   * (e.g. clarifying which cells matter, how rows repeat, or what must be left untouched).
   */
  setupGuidance?: Maybe<Scalars['String']['output']>;
  /**
   * Indicates whether this tab is static (i.e. reference or boilerplate content that is copied
   * verbatim into every generated workbook and never filled by the LLM).
   */
  static: Scalars['Boolean']['output'];
};

/** A data field to fill in an Excel spreadsheet template tab. */
export type ExcelSpreadsheetTemplateTabField = {
  __typename?: 'ExcelSpreadsheetTemplateTabField';
  /**
   * The A1 reference (cell or range) the value belongs in, when the tab's layout pins it to a
   * fixed address (e.g. "C12" or "B4:B20"). Empty when the target must be located at fill time
   * by scanning for its label.
   */
  cell: Scalars['String']['output'];
  /** The fill guidance for the field */
  fillGuidance: Scalars['String']['output'];
  /**
   * The worksheet text that labels this field's input cell, verbatim. Used to locate the target
   * at fill time when the address is not fixed.
   */
  label: Scalars['String']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
};

/**
 * Input for the authoring metadata of an Excel spreadsheet template tab. The tab itself is
 * discovered from the workbook; only these fields are author-editable.
 */
export type ExcelSpreadsheetTemplateTabInput = {
  /** The ID of the existing tab to update. */
  id: Scalars['String']['input'];
  /** Indicates whether this tab must be filled in every workbook generated from this template. */
  required: Scalars['Boolean']['input'];
  /**
   * Optional user-provided guidance fed to the LLM at ingestion time to help it produce a more
   * accurate fillGuidance for this tab. Trimmed server-side; blank values are stored as null.
   */
  setupGuidance?: InputMaybe<Scalars['String']['input']>;
  /**
   * Indicates whether this tab is copied verbatim into every generated workbook instead of
   * being filled by the LLM.
   */
  static: Scalars['Boolean']['input'];
};

/** Describes the reason why an Excel spreadsheet template was updated */
export enum ExcelSpreadsheetTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occurred to an Excel spreadsheet template */
export enum ExcelSpreadsheetTemplateUpdateType {
  /** The Excel spreadsheet template was archived */
  ArchiveExcelSpreadsheetTemplate = 'ARCHIVE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was created */
  CreateExcelSpreadsheetTemplate = 'CREATE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template processing finished */
  FinishProcessingExcelSpreadsheetTemplate = 'FINISH_PROCESSING_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template processing was started */
  StartProcessingExcelSpreadsheetTemplate = 'START_PROCESSING_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was unarchived */
  UnarchiveExcelSpreadsheetTemplate = 'UNARCHIVE_EXCEL_SPREADSHEET_TEMPLATE',
  /** The Excel spreadsheet template was updated */
  UpdateExcelSpreadsheetTemplate = 'UPDATE_EXCEL_SPREADSHEET_TEMPLATE'
}

/** Describes a particular version of an Excel spreadsheet template */
export type ExcelSpreadsheetTemplateVersion = {
  __typename?: 'ExcelSpreadsheetTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** The full Excel spreadsheet template object that includes all of the updates made in this version and all previous versions */
  excelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<ExcelSpreadsheetTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<ExcelSpreadsheetTemplateUpdateType>;
  /** The version number of this Excel spreadsheet template version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the excelSpreadsheetTemplates list query. Wraps visibility filters today; future
 * filter dimensions (search, archived inclusion, etc.) can be added here without breaking the
 * query signature.
 */
export type ExcelSpreadsheetTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** Arguments for exportCaraWorkspaceMessage. */
export type ExportCaraWorkspaceMessageInput = {
  format: CaraWorkspaceMessageExportFormat;
  messageId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};

export type ExtractSuperCopyInput = {
  blocks: Array<SuperCopyBlockInput>;
  screenshot: Scalars['Upload']['input'];
  source: SuperCopySourceInput;
};

/** EzLynxConfiguration contains configuration for the EZLynx integration */
export type EzLynxConfiguration = {
  __typename?: 'EzLynxConfiguration';
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: Maybe<Scalars['String']['output']>;
  /**
   * If true, this integration is configured for CSV import only (no API access).
   * When false and credentials are present, both CSV import and API modes are available.
   * Defaults to false.
   */
  csvImportOnly: Scalars['Boolean']['output'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: Maybe<Scalars['String']['output']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: Maybe<Scalars['String']['output']>;
};

export type EzlynxCallFields = {
  __typename?: 'EzlynxCallFields';
  applicantId?: Maybe<Scalars['String']['output']>;
  callerName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  summary?: Maybe<Scalars['String']['output']>;
};

export type EzlynxNoteFields = {
  __typename?: 'EzlynxNoteFields';
  applicantId?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type EzlynxPolicyFields = {
  __typename?: 'EzlynxPolicyFields';
  accountId?: Maybe<Scalars['String']['output']>;
  agencyCode?: Maybe<Scalars['String']['output']>;
  agencyCommission?: Maybe<Scalars['Float']['output']>;
  annualPremium?: Maybe<Scalars['Float']['output']>;
  billingCompany?: Maybe<Scalars['Int']['output']>;
  billingType?: Maybe<Scalars['Int']['output']>;
  carrierId?: Maybe<Scalars['Int']['output']>;
  department?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  fullTermPremium?: Maybe<Scalars['Float']['output']>;
  lob?: Maybe<Scalars['String']['output']>;
  lobOriginationDate?: Maybe<Scalars['String']['output']>;
  masterCompany?: Maybe<Scalars['Int']['output']>;
  naicCode?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyStatusId?: Maybe<Scalars['Int']['output']>;
  producerCode?: Maybe<Scalars['String']['output']>;
  producerCodeOverride?: Maybe<Scalars['String']['output']>;
  ratingState?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  transactionType?: Maybe<Scalars['String']['output']>;
  writingCompany?: Maybe<Scalars['String']['output']>;
  writtenPremium?: Maybe<Scalars['Float']['output']>;
};

export type EzlynxWriteTool = {
  __typename?: 'EzlynxWriteTool';
  input: EzlynxWriteToolInput;
  output: EzlynxWriteToolOutput;
};

export type EzlynxWriteToolInput = {
  __typename?: 'EzlynxWriteToolInput';
  call?: Maybe<EzlynxCallFields>;
  note?: Maybe<EzlynxNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<EzlynxPolicyFields>;
};

export type EzlynxWriteToolOutput = {
  __typename?: 'EzlynxWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Feedback record */
export type Feedback = {
  __typename?: 'Feedback';
  /** Agency this feedback belongs to */
  agency: Agency;
  /** User who submitted the feedback */
  agencyUser: AgencyUser;
  /** Call (for call feedback) */
  call?: Maybe<Call>;
  /** User-provided comment for feedback */
  comment?: Maybe<Scalars['String']['output']>;
  /** When feedback was created */
  createdAt: Scalars['Time']['output'];
  /** When feedback was soft deleted (null if not deleted) */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** User-provided feedback details (structure varies by scope) */
  feedback: FeedbackContent;
  /** Unique identifier */
  id: Scalars['ID']['output'];
  /** Message (for message feedback) */
  message?: Maybe<CaraWorkspaceMessage>;
  /** Rating (for message and call feedback: UP or DOWN) */
  rating?: Maybe<MessageRating>;
  /** Scope of feedback */
  scope: FeedbackScope;
  /** When feedback was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Workspace (for message feedback)
   * Note: preset and custom_preset_id can be found via workspace lookup
   */
  workspace?: Maybe<CaraWorkspace>;
};

export type FeedbackContent = {
  __typename?: 'FeedbackContent';
  call?: Maybe<CallFeedback>;
  message?: Maybe<MessageFeedback>;
};

/** Feedback scope - what entity is being rated */
export enum FeedbackScope {
  /** Call rating */
  Call = 'CALL',
  /** Message rating (thumbs up/down) */
  Message = 'MESSAGE'
}

/** Where a field's value came from, so the record can say which values to trust. */
export enum FieldSource {
  /**
   * Matches what the AMS holds. Derived by comparing against the normalized rows
   * behind the client's linked account rather than stored, so it cannot fall out
   * of step with the sync -- and so it cannot tell a value copied from the AMS
   * from one a person typed that happens to agree.
   */
  AmsSourced = 'AMS_SOURCED',
  /**
   * Matches what Cara filled in, and nobody has confirmed it since. The weakest
   * tag: it says a value was derived rather than read from a system of record, so
   * a reader should treat it as a claim to check.
   *
   * Derived the same way AMS_SOURCED is, from normalized rows Cara wrote for a
   * client whose agency has no AMS. EPD-2486 is what fills those rows in bulk;
   * until it runs, few clients have any.
   */
  CaraGenerated = 'CARA_GENERATED',
  /** A person confirmed it, whatever it was before. */
  HumanConfirmed = 'HUMAN_CONFIRMED'
}

/**
 * A file describes a document that is attached to an object, with
 * metadata and URLs to fetch it.
 */
export type File = {
  __typename?: 'File';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp this file was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the entity that this file is associated with */
  entityRefId: Scalars['String']['output'];
  /** The type of entity that this file is associated with */
  entityRefType: FileEntityRefType;
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The unique identifier of the file */
  id: Scalars['ID']['output'];
  /** The file MIME type */
  mimeType: Scalars['String']['output'];
  /** The file name, for display and download purposes */
  name: Scalars['String']['output'];
  /** The notes associated with the file */
  notes: Scalars['String']['output'];
  /** The size of the file in bytes */
  size: Scalars['Int']['output'];
  /** The type of the file */
  type: FileType;
  /** The timestamp this file was updated */
  updatedAt: Scalars['Time']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['output'];
};

/**
 * The FILE_EDITOR arguments offered while cara_document_generate_operation_enabled is on. The calling
 * model writes a brief and the document writer produces the HTML.
 */
export type FileEditorDocumentOperationToolInput = {
  __typename?: 'FileEditorDocumentOperationToolInput';
  /** Whether a write may remove more than half of an existing document's visible text. */
  allowLargeDeletion?: Maybe<Scalars['Boolean']['output']>;
  /** The existing artifact for REVISE or READ, or the conversion source. */
  fileId: Scalars['String']['output'];
  /** The library template a GENERATE fills, when the user requested or pre-selected one. */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** The document operation to run. */
  operation: Scalars['String']['output'];
  /** Whether a REVISE or GENERATE of an existing document renames it to the title. */
  renameDocument?: Maybe<Scalars['Boolean']['output']>;
  /** What a new document must contain for GENERATE, or the requested changes for REVISE. */
  requirements: Scalars['String']['output'];
  /** The title of a new document or conversion. */
  title: Scalars['String']['output'];
};

/**
 * Represents a tool for creating or editing a file.
 * Used when the LLM needs to create or edit a file.
 */
export type FileEditorTool = {
  __typename?: 'FileEditorTool';
  /** The input arguments for the file creation or editing */
  input: FileEditorToolInput;
  /** The result of the file creation or editing operation */
  output: FileEditorToolOutput;
};

/**
 * Input arguments for the FileEditorTool, as persisted on the tool call. Every call unmarshals into
 * this type, and the model is offered it while cara_document_generate_operation_enabled is off. With
 * the gate on the model is offered FileEditorDocumentOperationToolInput, whose fields are a subset.
 */
export type FileEditorToolInput = {
  __typename?: 'FileEditorToolInput';
  /** Whether a write may remove more than half of an existing document's visible text. */
  allowLargeDeletion?: Maybe<Scalars['Boolean']['output']>;
  /** The content of the file */
  content: Scalars['String']['output'];
  /** The content type of the file */
  contentType: Scalars['String']['output'];
  /** The ID of the file being created or edited. For CONVERT_PDF_TO_HTML this is the PDF file ID. For CONVERT_HTML_TO_TEMPLATE this is the source HTML artifact ID. */
  fileId: Scalars['String']['output'];
  /** The ID of the HTML document template used for this document, when applying a saved library template. */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** The operation of the file editor */
  operation: Scalars['String']['output'];
  /** Whether a REVISE or GENERATE of an existing document renames it to the title. */
  renameDocument?: Maybe<Scalars['Boolean']['output']>;
  /** The text to replace */
  replaceText: Scalars['String']['output'];
  /** What a new document must contain for GENERATE, or requested changes to an existing document for REVISE. */
  requirements: Scalars['String']['output'];
  /** The title of the file */
  title: Scalars['String']['output'];
};

/**
 * Result of a FileEditorTool operation.
 * Contains information about the created or edited file.
 */
export type FileEditorToolOutput = {
  __typename?: 'FileEditorToolOutput';
  /** Content returned when the operation is READ */
  content?: Maybe<Scalars['String']['output']>;
  /** The ID of the created or edited file */
  fileId: Scalars['String']['output'];
  /**
   * The ID of the HTML document template used to create this artifact, if any.
   * Preserved automatically when regenerating an existing document.
   */
  htmlDocumentTemplateId?: Maybe<Scalars['String']['output']>;
  /** Any remarks or notes about the file */
  remarks?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the source this document was converted from:
   * - For CONVERT_HTML_TO_TEMPLATE: the source HTML artifact ID
   * When regenerating, use the same conversion operation with this ID.
   */
  sourceFileId?: Maybe<Scalars['String']['output']>;
  /** The content of the created or edited file */
  version: Scalars['Int']['output'];
};

/** FileEntityRefType describes the type of entity that a file is associated with. */
export enum FileEntityRefType {
  /** The file is associated with an account */
  Account = 'ACCOUNT',
  /** A logo stored for the agency brand. */
  AgencyBrand = 'AGENCY_BRAND',
  /** The file was imported from an AMS record, keyed integrationId:kind:externalId */
  AmsFile = 'AMS_FILE',
  /** The file is associated with a Cara workspace */
  CaraWorkspace = 'CARA_WORKSPACE',
  /** The file is associated with a code execution tool call */
  CodeExecutionToolCall = 'CODE_EXECUTION_TOOL_CALL',
  /** The file is associated with a custom form */
  CustomForm = 'CUSTOM_FORM',
  /** The file is associated with a custom preset */
  CustomPreset = 'CUSTOM_PRESET',
  /** The file is associated with an email thread */
  EmailThread = 'EMAIL_THREAD',
  /** The file is associated with an Excel spreadsheet template */
  ExcelSpreadsheetTemplate = 'EXCEL_SPREADSHEET_TEMPLATE',
  /** The file is associated with an HTML document template */
  HtmlDocumentTemplate = 'HTML_DOCUMENT_TEMPLATE',
  /** The file is associated with a knowledge graph entity */
  KnowledgeGraphEntity = 'KNOWLEDGE_GRAPH_ENTITY',
  /** The file is associated with a policy */
  Policy = 'POLICY',
  /** The file is associated with a service request */
  ServiceRequest = 'SERVICE_REQUEST',
  /** The file is associated with a Word document template */
  WordDocumentTemplate = 'WORD_DOCUMENT_TEMPLATE',
  /** The file is associated with a workflow execution */
  Workflow = 'WORKFLOW'
}

/** File role describes a type of file related to an object */
export enum FileType {
  /** The file is a form generated as part of an application */
  ApplicationForm = 'APPLICATION_FORM',
  /** The file is a binder, a pre-coverage confirmation document */
  Binder = 'BINDER',
  /** The file is a certificate of insurance */
  Certificate = 'CERTIFICATE',
  /** The file is an endorsement, affixed to the policy document */
  Endorsement = 'ENDORSEMENT',
  /** The file is an invoice, generally for internal tracking purposes */
  Invoice = 'INVOICE',
  /** The file is a lost policy release, issued when a policy is canceled by the customer */
  LostPolicyRelease = 'LOST_POLICY_RELEASE',
  /** The file is a notice of cancellation, issued when a policy is being canceled or nonrenewed by the carrier */
  NoticeOfCancellation = 'NOTICE_OF_CANCELLATION',
  /** The file is of another type */
  Other = 'OTHER',
  /** The file is a policy document */
  PolicyDocument = 'POLICY_DOCUMENT',
  /** The file is a quote document */
  QuoteDocument = 'QUOTE_DOCUMENT'
}

/**
 * Represents a tool for filling out a template.
 * Used when the LLM needs to fill out a template such as an ACORD form.
 */
export type FillTemplateTool = {
  __typename?: 'FillTemplateTool';
  /** The input arguments for the template filling */
  input: FillTemplateToolInput;
  /** The result of the template filling */
  output: FillTemplateToolOutput;
};

/**
 * Input arguments for the FillTemplateTool.
 * Contains all necessary information to fill out a template.
 */
export type FillTemplateToolInput = {
  __typename?: 'FillTemplateToolInput';
  artifactId?: Maybe<Scalars['String']['output']>;
  /** The ID of the template being filled out */
  templateId: DocumentType;
};

/**
 * Result of a FillTemplateTool operation.
 * Contains information about the filled template.
 */
export type FillTemplateToolOutput = {
  __typename?: 'FillTemplateToolOutput';
  /** The ID of the filled template */
  artifactId: Scalars['String']['output'];
  /** The version of the filled template */
  version: Scalars['Int']['output'];
};

/** Result of a direct (live) AMS account search. */
export type FindAmsAccountResult = {
  __typename?: 'FindAmsAccountResult';
  /**
   * The matched account entity, possibly a just-created minimal placeholder
   * whose documents are still importing. Null when no supported AMS matched.
   */
  account?: Maybe<KnowledgeGraphEntity>;
  /**
   * All accounts matched by a multi-result live AMS name search. Exact email,
   * phone, lookup-code, and policy searches return either zero or one entry.
   */
  accounts: Array<KnowledgeGraphEntity>;
  /** Whether a background import/refresh workflow was started for the account. */
  enqueued: Scalars['Boolean']['output'];
};

/** A font to load in the HTML document template */
export type Font = {
  __typename?: 'Font';
  /** The name of the font */
  name: Scalars['String']['output'];
  /** The variants of the font */
  variants: Array<FontVariant>;
};

/** A variant of a font */
export type FontVariant = {
  __typename?: 'FontVariant';
  /** The source of the font variant */
  src: Scalars['String']['output'];
  /** The style of the font variant */
  style: Scalars['String']['output'];
  /** The weight of the font variant */
  weight: Scalars['Int']['output'];
};

/** How the general aggregate limit applies to a liability policy */
export enum GeneralAggregateLimitAppliesPerType {
  /** Limit applies in some other way */
  Other = 'OTHER',
  /** Limit applies per location */
  PerLocation = 'PER_LOCATION',
  /** Limit applies per policy */
  PerPolicy = 'PER_POLICY',
  /** Limit applies per project */
  PerProject = 'PER_PROJECT'
}

/**
 * Input for generatePresetQuestions: the source workspaces plus the wizard
 * choices already made, so generated questions do not re-ask what the user has
 * already provided.
 */
export type GeneratePresetQuestionsInput = {
  /** The base preset the user chose (or the wizard auto-detected), if any. */
  basePresetOverride?: InputMaybe<CaraWorkspacePreset>;
  /** Custom forms the user already selected for the preset, if any. */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** HTML document templates the user already selected for the preset, if any. */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Free-text description of the output formats the user already provided, if any. */
  outputFormatsText?: InputMaybe<Scalars['String']['input']>;
  /** The workspaces to derive clarifying questions from. At least one is required. */
  sourceWorkspaceIds: Array<Scalars['String']['input']>;
  /** Word document templates the user already selected for the preset, if any. */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** LLM-specific details attached to a GENERATION span. */
export type Generation = {
  __typename?: 'Generation';
  /** Total cost in dollars for this generation (domain extension, not OTel). */
  costDollars: Scalars['Decimal']['output'];
  /** gen_ai.response.finish_reasons */
  finishReasons?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Opaque generation request payload (provider-specific shape).
   * Maps to gen_ai.input / cara.gen_ai.input.
   */
  input: Scalars['JSON']['output'];
  /** gen_ai.operation.name (e.g. chat, generate_content, text_completion). */
  operationName: Scalars['String']['output'];
  /**
   * Opaque generation response payload (provider-specific shape).
   * Maps to gen_ai.output / cara.gen_ai.output.
   */
  output?: Maybe<Scalars['JSON']['output']>;
  /** Latitude prompt name, if the generation used a managed prompt. */
  promptName?: Maybe<Scalars['String']['output']>;
  /** Latitude prompt version, if the generation used a managed prompt. */
  promptVersion?: Maybe<Scalars['String']['output']>;
  /** gen_ai.provider.name (e.g. anthropic, aws.bedrock, gcp.vertex_ai). */
  providerName: Scalars['String']['output'];
  /** gen_ai.request.model */
  requestModel: Scalars['String']['output'];
  /** gen_ai.response.model */
  responseModel?: Maybe<Scalars['String']['output']>;
  /** gen_ai.request.stream */
  stream: Scalars['Boolean']['output'];
  /**
   * Time to first streaming chunk in milliseconds. Maps to gen_ai.response.time_to_first_chunk
   * (convert seconds ↔ ms at the OTel boundary).
   */
  timeToFirstChunkMs?: Maybe<Scalars['Int']['output']>;
  /** Token usage for this generation. */
  usage: TokenUsage;
};

export type GetClientTool = {
  __typename?: 'GetClientTool';
  input: GetClientToolInput;
  output?: Maybe<GetClientToolOutput>;
};

export type GetClientToolInput = {
  __typename?: 'GetClientToolInput';
  /** The client id, as returned by SEARCH_CLIENTS. */
  clientId: Scalars['String']['output'];
};

export type GetClientToolOutput = {
  __typename?: 'GetClientToolOutput';
  /** Street address, when any part of it is known. */
  address?: Maybe<Scalars['String']['output']>;
  /** Accounts in the agency's management systems that this client is linked to. */
  amsAccounts: Array<ClientToolAmsAccount>;
  client: ClientToolSummary;
  /** How many workspaces are linked to this client. */
  linkedWorkspaceCount: Scalars['Int']['output'];
  /** Display name of the agency user who owns this client, when one is assigned. */
  owner?: Maybe<Scalars['String']['output']>;
};

/** Input for querying feedback with optional filters */
export type GetFeedbackInput = {
  /** Agency ID filter (admin only - automatically restricted to caller's agency for agency users) */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Agency user ID filter (for filtering by specific user) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Call ID filter (for call feedback) */
  callId?: InputMaybe<Scalars['String']['input']>;
  /** Message ID filter (for message feedback) */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** Scope filter (message or call) */
  scope?: InputMaybe<FeedbackScope>;
  /** Workspace ID filter (for message feedback) */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Information about an HTML document template for use in Cara workspace. */
export type HtmlDocumentTemplateInfo = {
  __typename?: 'HTMLDocumentTemplateInfo';
  /** The HTML body template content. Only included when GET_CONTENT operation is used (HTML templates). */
  bodyHTML?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this template was created */
  createdAt: Scalars['Time']['output'];
  /** The name of the user who created this template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** The unique identifier for this template */
  id: Scalars['String']['output'];
  /** The title/name of the template */
  name: Scalars['String']['output'];
  /** The names of files used as prefixes (for informational context) */
  prefixFileNames: Array<Scalars['String']['output']>;
  /** The names of files used as suffixes (for informational context) */
  suffixFileNames: Array<Scalars['String']['output']>;
  /**
   * Deprecated: legacy field. Kept for backward compatibility with old clients;
   * not used by Cara when ranking templates.
   * @deprecated No longer used; legacy values may still appear for older templates.
   */
  useCase?: Maybe<HtmlDocumentTemplateUseCase>;
};

export type HawksoftAttachmentFields = {
  __typename?: 'HawksoftAttachmentFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  logNote?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

/** HawksoftConfiguration contains configuration for the Hawksoft integration */
export type HawksoftConfiguration = {
  __typename?: 'HawksoftConfiguration';
  /** Hawksoft agency ID */
  agencyId: Scalars['String']['output'];
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes: Scalars['Boolean']['output'];
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests: Scalars['Boolean']['output'];
  /**
   * If specified, and overrideTaskAssignmentMethod is SPECIFIED_EMAIL, this email will be used
   * to assign tasks in HawkSoft.
   */
  overrideTaskAssignmentEmail?: Maybe<Scalars['String']['output']>;
  /**
   * If specified, overrides the field used to determine who to assign tasks to. The default
   * is the CSR field.
   */
  overrideTaskAssignmentMethod?: Maybe<HawksoftTaskAssignmentMethod>;
};

export type HawksoftLogNoteFields = {
  __typename?: 'HawksoftLogNoteFields';
  channel?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  note?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

export type HawksoftReceiptFields = {
  __typename?: 'HawksoftReceiptFields';
  channel?: Maybe<Scalars['Int']['output']>;
  clientId?: Maybe<Scalars['String']['output']>;
  invoices?: Maybe<Array<HawksoftReceiptInvoice>>;
  logNote?: Maybe<Scalars['String']['output']>;
  officeId?: Maybe<Scalars['Int']['output']>;
  payMethod?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  taskAssignedToEmail?: Maybe<Scalars['String']['output']>;
  taskAssignedToRole?: Maybe<Scalars['String']['output']>;
  taskCategory?: Maybe<Scalars['String']['output']>;
  taskDescription?: Maybe<Scalars['String']['output']>;
  taskDueDate?: Maybe<Scalars['String']['output']>;
  taskTitle?: Maybe<Scalars['String']['output']>;
};

export type HawksoftReceiptInvoice = {
  __typename?: 'HawksoftReceiptInvoice';
  amount?: Maybe<Scalars['Float']['output']>;
  invoiceId?: Maybe<Scalars['String']['output']>;
};

/** The method to use to assign tasks in HawkSoft */
export enum HawksoftTaskAssignmentMethod {
  ClientFieldAgent1 = 'CLIENT_FIELD_AGENT1',
  ClientFieldAgent2 = 'CLIENT_FIELD_AGENT2',
  ClientFieldAgent3 = 'CLIENT_FIELD_AGENT3',
  ClientFieldCsr = 'CLIENT_FIELD_CSR',
  ClientFieldProducer = 'CLIENT_FIELD_PRODUCER',
  SpecifiedEmail = 'SPECIFIED_EMAIL'
}

/** Represents a tool for managing HawkSoft log entries and attachments. */
export type HawksoftWriteTool = {
  __typename?: 'HawksoftWriteTool';
  input: HawksoftWriteToolInput;
  output: HawksoftWriteToolOutput;
};

export type HawksoftWriteToolInput = {
  __typename?: 'HawksoftWriteToolInput';
  attachment?: Maybe<HawksoftAttachmentFields>;
  logNote?: Maybe<HawksoftLogNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  receipt?: Maybe<HawksoftReceiptFields>;
};

export type HawksoftWriteToolOutput = {
  __typename?: 'HawksoftWriteToolOutput';
  clientId?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

/** Configuration for headers and footers on document pages */
export type HeaderFooterConfig = {
  __typename?: 'HeaderFooterConfig';
  /** Footer configuration with left, center, and right slots */
  footer: HeaderFooterSlots;
  /** Header configuration with left, center, and right slots */
  header: HeaderFooterSlots;
};

/** Input for headers and footers configuration */
export type HeaderFooterConfigInput = {
  /** Footer configuration with left, center, and right slots */
  footer?: InputMaybe<HeaderFooterSlotsInput>;
  /** Header configuration with left, center, and right slots */
  header?: InputMaybe<HeaderFooterSlotsInput>;
};

/** Image configuration for a header or footer slot */
export type HeaderFooterImage = {
  __typename?: 'HeaderFooterImage';
  /** Metadata for the image file */
  file: File;
  /**
   * Optional gap between the image's inner edge and the body content area (in points).
   * When set with no paddingPt, the image is anchored flush to the page edge and this
   * space is reserved entirely on the body-content side. When both fields are unset,
   * the image is centered inside the margin zone.
   */
  innerGapPt?: Maybe<Scalars['Float']['output']>;
  /** Optional maximum height for the rendered image (in points) */
  maxHeightPt?: Maybe<Scalars['Float']['output']>;
  /** Optional vertical padding between the image and the page edge (in points) */
  paddingPt?: Maybe<Scalars['Float']['output']>;
};

/** Image input for a header or footer slot */
export type HeaderFooterImageInput = {
  /** Reference an existing uploaded file by ID */
  fileId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional gap between the image's inner edge and the body content area (in points).
   * When set with no paddingPt, the image is anchored flush to the page edge and this
   * space is reserved entirely on the body-content side. When both fields are unset,
   * the image is centered inside the margin zone.
   */
  innerGapPt?: InputMaybe<Scalars['Float']['input']>;
  /** Optional maximum height for the rendered image (in points) */
  maxHeightPt?: InputMaybe<Scalars['Float']['input']>;
  /** Optional vertical padding between the image and the page edge (in points) */
  paddingPt?: InputMaybe<Scalars['Float']['input']>;
  /** Upload a new image for this slot */
  upload?: InputMaybe<Scalars['Upload']['input']>;
};

/** Configuration for a single header or footer slot (left, center, or right) */
export type HeaderFooterSlot = {
  __typename?: 'HeaderFooterSlot';
  /** Optional image to display in this slot. Supports a single image per slot. */
  image?: Maybe<HeaderFooterImage>;
  /**
   * The text content for this slot. Supports placeholders: {page} for current page number,
   * {pages} for total page count, {date} for current date in MM/DD/YYYY format.
   */
  text?: Maybe<Scalars['String']['output']>;
};

/** Input for a single header or footer slot (left, center, or right) */
export type HeaderFooterSlotInput = {
  /** Optional image to display in this slot. Supports a single image per slot. */
  image?: InputMaybe<HeaderFooterImageInput>;
  /**
   * The text content for this slot. Supports placeholders: {page} for current page number,
   * {pages} for total page count, {date} for current date in MM/DD/YYYY format.
   */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Slots for header or footer (left, center, right) */
export type HeaderFooterSlots = {
  __typename?: 'HeaderFooterSlots';
  /** Content for the center slot */
  center?: Maybe<HeaderFooterSlot>;
  /** Content for the left slot */
  left?: Maybe<HeaderFooterSlot>;
  /** Content for the right slot */
  right?: Maybe<HeaderFooterSlot>;
};

/** Input for header or footer slots (left, center, right) */
export type HeaderFooterSlotsInput = {
  /** Content for the center slot */
  center?: InputMaybe<HeaderFooterSlotInput>;
  /** Content for the left slot */
  left?: InputMaybe<HeaderFooterSlotInput>;
  /** Content for the right slot */
  right?: InputMaybe<HeaderFooterSlotInput>;
};

/** Individual heading style */
export type HeadingStyle = {
  __typename?: 'HeadingStyle';
  /** Text color in hex format (e.g. '#0f172a') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (overrides global typography when set) */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 18.0 for h1, 15.0 for h2) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font style (e.g. 'normal', 'italic') */
  fontStyle?: Maybe<Scalars['String']['output']>;
  /** Font weight as a number (e.g. 600 for semi-bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.4) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 0.4) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 1.2) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** When true, emit page-break-before so the heading starts on a new page */
  pageBreakBefore?: Maybe<Scalars['Boolean']['output']>;
};

/** Input for a single heading level style */
export type HeadingStyleInput = {
  /** Text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for this heading level */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for this heading level */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font style for this heading level (e.g. 'italic') */
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  /** Font weight for this heading level (e.g. 700) */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for this heading level (unitless multiplier) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** If true, a page break is forced before this heading */
  pageBreakBefore?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Heading styles for all levels */
export type HeadingStyles = {
  __typename?: 'HeadingStyles';
  /** H1 styles */
  h1: HeadingStyle;
  /** H2 styles */
  h2: HeadingStyle;
  /** H3 styles */
  h3: HeadingStyle;
  /** H4 styles */
  h4: HeadingStyle;
  /** H5 styles */
  h5: HeadingStyle;
  /** H6 styles */
  h6: HeadingStyle;
};

/** Input for heading styles (all levels) */
export type HeadingStylesInput = {
  /** Style settings for h1 headings */
  h1?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h2 headings */
  h2?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h3 headings */
  h3?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h4 headings */
  h4?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h5 headings */
  h5?: InputMaybe<HeadingStyleInput>;
  /** Style settings for h6 headings */
  h6?: InputMaybe<HeadingStyleInput>;
};

/** HIPAA privacy settings for an agency */
export type HipaaPrivacyModeConfiguration = {
  __typename?: 'HipaaPrivacyModeConfiguration';
  /** Whether HIPAA privacy mode is enabled. Defaults to false. */
  enabled: Scalars['Boolean']['output'];
};

/** Input for changing an agency's HIPAA privacy settings */
export type HipaaPrivacyModeConfigurationInput = {
  /** Whether HIPAA privacy mode is enabled */
  enabled: Scalars['Boolean']['input'];
};

/** A HTML document artifact */
export type HtmlDocument = {
  __typename?: 'HtmlDocument';
  /** The HTML content of the document */
  content: Scalars['String']['output'];
  /** The ID of the document */
  id: Scalars['ID']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/**
 * A credential for the statics measurement routes of one version of an HTML document. It admits one
 * request, made within a minute of issue.
 */
export type HtmlDocumentRenderGrant = {
  __typename?: 'HtmlDocumentRenderGrant';
  /** Sent as the grant query parameter on one statics request. */
  token: Scalars['String']['output'];
};

/** Result of buildHtmlDocumentRenderUrl containing the fully-constructed statics URL. */
export type HtmlDocumentRenderUrl = {
  __typename?: 'HtmlDocumentRenderUrl';
  /** Null when no Design refit was requested. */
  outcome?: Maybe<DocumentRefitOutcome>;
  /** The statics URL to open in a new tab to render the PDF */
  url: Scalars['String']['output'];
};

/** A custom preset for Cara to execute tasks and produce artifacts */
export type HtmlDocumentTemplate = {
  __typename?: 'HtmlDocumentTemplate';
  /** The agency this HTML document template is associated with */
  agency: Agency;
  /** The timestamp when this HTML document template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The base style to inherit from. Can be a built-in style or another custom style.
   * Built-in styles are prefixed with 'builtin:' (e.g. 'builtin:classic-professional')
   */
  baseStyleId?: Maybe<Scalars['String']['output']>;
  /** The HTML body template with placeholders for LLM content generation */
  bodyTemplate?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this HTML document template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this HTML document template */
  createdBy: AgencyUser;
  /** The description of the HTML document template */
  description: Scalars['String']['output'];
  /**
   * The design documents made from this template start with, when the caller can read it and
   * designs are on for the agency.
   */
  design?: Maybe<AgencyDesign>;
  /** The design documents made from this template start with, when designSource is DESIGN. */
  designId?: Maybe<Scalars['String']['output']>;
  /** Which design documents made from this template start on. */
  designSource: TemplateDesignSource;
  /**
   * Where the pages after a document made from this template come from, by the same rule as
   * startPages.
   */
  endPages: DocumentPagesSource;
  /** Configuration for headers and footers on document pages */
  headerFooter?: Maybe<HeaderFooterConfig>;
  /** The ID of the HTML document template */
  id: Scalars['ID']['output'];
  /** The files that are used as prefixes for the HTML document template */
  prefixFiles: Array<File>;
  /**
   * Whether the template's body prints its own letterhead and footer. A design then still sets
   * colors and type, but prints no header, footer or page number of its own and reserves no room
   * for them.
   */
  printsOwnHeaderFooter: Scalars['Boolean']['output'];
  /**
   * Where the pages before a document made from this template come from while the document has a
   * design. A template that never chose prints its own start PDFs when it has them, and its design's
   * otherwise. A document with no design prints the template's own, so a template whose designSource
   * is NONE or LEGACY keeps this choice for when one of its documents is given a design.
   */
  startPages: DocumentPagesSource;
  /** The style of the HTML document template */
  style: HtmlDocumentTemplateStyle;
  /** The files that are used as suffixes for the HTML document template */
  suffixFiles: Array<File>;
  /** The title of the HTML document template */
  title: Scalars['String']['output'];
  /** The timestamp when this HTML document template was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Deprecated: legacy field. Returns null for templates created after the field was retired,
   * but may still echo a previously persisted value on older templates.
   * @deprecated No longer used; legacy values may still be returned for older templates.
   */
  useCase?: Maybe<HtmlDocumentTemplateUseCase>;
  /** The version of this HTML document template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this HTML document template. The first version in this list will be this version
   * (i.e. identical to the current HTML document template), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<HtmlDocumentTemplateVersion>>;
  /**
   * The visibility configuration for this HTML document template
   * (PRIVATE / SHARED / PUBLIC). Lives on the parent row only — visibility is
   * metadata, not part of the versioned content. Defaults to PUBLIC for all rows
   * on migration.
   */
  visibility: VisibilityConfig;
};

export type HtmlDocumentTemplateInput = {
  /** The base style ID that should be used as fallback styles. */
  baseStyleId?: InputMaybe<Scalars['String']['input']>;
  /** The HTML body template with placeholders for LLM content generation */
  bodyTemplate?: InputMaybe<Scalars['String']['input']>;
  /** The description of the HTML document template */
  description: Scalars['String']['input'];
  /**
   * The design documents made from this template start with. Omitted leaves it as it is; null
   * clears it. Required with designSource DESIGN and refused with any other.
   */
  designId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Which design documents made from this template start on. Omitted, a designId sent alone sets
   * DESIGN or, when null, DEFAULT. LEGACY is accepted only on a template that is LEGACY already.
   */
  designSource?: InputMaybe<TemplateDesignSource>;
  /** Where the pages after a document come from. Omitted leaves the choice as it is. */
  endPages?: InputMaybe<DocumentPagesSource>;
  /** Configuration for headers and footers on document pages */
  headerFooter?: InputMaybe<HeaderFooterConfigInput>;
  /** The ID of the existing prefix file to keep */
  prefixFileId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether the template's body prints its own letterhead and footer. Null keeps the stored value
   * on update and means false on create.
   */
  printsOwnHeaderFooter?: InputMaybe<Scalars['Boolean']['input']>;
  /** Where the pages before a document come from. Omitted leaves the choice as it is. */
  startPages?: InputMaybe<DocumentPagesSource>;
  /** Optional style overrides merged on top of the base style (from baseStyleId). When provided, only non-nil fields are applied. */
  style?: InputMaybe<HtmlDocumentTemplateStyleInput>;
  /** The ID of the existing suffix file to keep */
  suffixFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the HTML document template */
  title: Scalars['String']['input'];
  /** The prefix file to upload if an existing prefix file is not provided */
  uploadPrefixFile?: InputMaybe<Scalars['Upload']['input']>;
  /** The suffix file to upload if an existing suffix file is not provided */
  uploadSuffixFile?: InputMaybe<Scalars['Upload']['input']>;
  /** Deprecated: accepted for backward compatibility but silently ignored. */
  useCase?: InputMaybe<HtmlDocumentTemplateUseCase>;
  /**
   * Optional visibility configuration. When omitted on create, defaults to
   * PUBLIC. When omitted on update, the existing visibility is preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** A ready-made template an agency can copy into its library. */
export type HtmlDocumentTemplateStarter = {
  __typename?: 'HtmlDocumentTemplateStarter';
  description: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

/** The style of a HTML document template */
export type HtmlDocumentTemplateStyle = {
  __typename?: 'HtmlDocumentTemplateStyle';
  /**
   * Accent color in hex format (e.g. '#92400e'). Exposed as CSS variables --accent-color,
   * --accent-color-light (~12% tint) and --on-accent-color (contrast-safe text on the accent).
   */
  accentColorHex?: Maybe<Scalars['String']['output']>;
  /** Custom CSS properties that don't fit into the structured schema */
  customStyles?: Maybe<Array<CustomStyle>>;
  /** Element-specific styles */
  elements: ElementStyles;
  /** The fonts to load in the HTML document template */
  fonts: Array<Font>;
  /** Page layout settings */
  page: PageStyle;
  /** Primary brand color in hex format (e.g. '#2563eb'). Exposed as CSS variable --primary-color. */
  primaryColorHex?: Maybe<Scalars['String']['output']>;
  /**
   * Light tint of primary color for backgrounds (auto-computed at ~12% mix when null).
   * Exposed as CSS variable --primary-color-light.
   */
  primaryColorLightHex?: Maybe<Scalars['String']['output']>;
  /** Secondary brand color in hex format (e.g. '#64748b'). Exposed as CSS variable --secondary-color. */
  secondaryColorHex?: Maybe<Scalars['String']['output']>;
  /**
   * Light tint of secondary color for backgrounds (auto-computed at ~12% mix when null).
   * Exposed as CSS variable --secondary-color-light.
   */
  secondaryColorLightHex?: Maybe<Scalars['String']['output']>;
  /** Typography settings */
  typography: TypographyStyle;
};

/** Input for HTML document template style (partial override merged over base style) */
export type HtmlDocumentTemplateStyleInput = {
  /** Additional custom CSS blocks to append */
  customStyles?: InputMaybe<Array<CustomStyleInput>>;
  /** Element-specific style overrides (headings, tables, etc.) */
  elements?: InputMaybe<ElementStylesInput>;
  /** Page settings (size, margin, background color) */
  page?: InputMaybe<PageStyleInput>;
  /** Primary color for document highlights, as a CSS hex string */
  primaryColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Lighter variant of the primary color, as a hex string */
  primaryColorLightHex?: InputMaybe<Scalars['String']['input']>;
  /** Secondary color for document highlights, as a CSS hex string */
  secondaryColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Lighter variant of the secondary color, as a hex string */
  secondaryColorLightHex?: InputMaybe<Scalars['String']['input']>;
  /** Typography settings (base font, size, color) */
  typography?: InputMaybe<TypographyStyleInput>;
};

/** Describes the reason why a HTML document template was updated */
export enum HtmlDocumentTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a HTML document template */
export enum HtmlDocumentTemplateUpdateType {
  /** The HTML document template was archived */
  ArchiveHtmlDocumentTemplate = 'ARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was created */
  CreateHtmlDocumentTemplate = 'CREATE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was unarchived */
  UnarchiveHtmlDocumentTemplate = 'UNARCHIVE_HTML_DOCUMENT_TEMPLATE',
  /** The HTML document template was updated */
  UpdateHtmlDocumentTemplate = 'UPDATE_HTML_DOCUMENT_TEMPLATE'
}

/**
 * Deprecated: kept for backward compatibility with older clients; no longer used by the UI.
 * Values are no longer set on new templates and never read by the backend, but legacy values
 * already persisted on existing templates may still round-trip.
 */
export enum HtmlDocumentTemplateUseCase {
  CertificateOfInsurance = 'CERTIFICATE_OF_INSURANCE',
  General = 'GENERAL',
  Letter = 'LETTER',
  None = 'NONE',
  Proposal = 'PROPOSAL',
  Report = 'REPORT'
}

/** Describes a particular version of a HTML document template */
export type HtmlDocumentTemplateVersion = {
  __typename?: 'HtmlDocumentTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another HTML document template version. */
  diffableJson: Scalars['String']['output'];
  /** The full HTML document template object that includes all of the updates made in this version and all previous versions */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /** The version number of the previous HTML document template version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<HtmlDocumentTemplateVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<HtmlDocumentTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<HtmlDocumentTemplateUpdateType>;
  /** The version number of this HTML document template version */
  version: Scalars['Int64']['output'];
};

/**
 * Filter for the htmlDocumentTemplates list query. Wraps visibility filters
 * today; future filter dimensions (search, archived inclusion, etc.) can be
 * added here without breaking the query signature.
 */
export type HtmlDocumentTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/** HttpHeader defines a header of an HTTP request or response */
export type HttpHeader = {
  __typename?: 'HttpHeader';
  /** The name of the header */
  name: Scalars['String']['output'];
  /** The value of the header */
  value: Scalars['String']['output'];
};

/** HttpRequest defines the HTTP request that caused the error */
export type HttpRequest = {
  __typename?: 'HttpRequest';
  /** The body of the request */
  body: Scalars['String']['output'];
  /** The content type of the request body, extracted from the headers */
  contentType: Scalars['String']['output'];
  /** The headers of the request */
  headers: Array<HttpHeader>;
  /** The HTTP method of the request */
  method: Scalars['String']['output'];
  /** The URL of the request */
  url: Scalars['String']['output'];
};

/** HttpError defines the error that occurred during an HTTP request */
export type HttpRequestResponse = {
  __typename?: 'HttpRequestResponse';
  /** The HTTP request that caused the error */
  request?: Maybe<HttpRequest>;
  /** The HTTP response that caused the error */
  response?: Maybe<HttpResponse>;
};

/** HttpResponse defines the HTTP response that caused the error */
export type HttpResponse = {
  __typename?: 'HttpResponse';
  /** The body of the response */
  body: Scalars['String']['output'];
  /** The headers of the response */
  headers: Array<HttpHeader>;
  /** The HTTP status code of the response */
  statusCode: Scalars['Int']['output'];
};

/** HubSpotCallFieldMappings defines field mappings for call syncing */
export type HubSpotCallFieldMappings = {
  __typename?: 'HubSpotCallFieldMappings';
  /** Field mappings when syncing calls as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing calls as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotCallFieldMappingsInput defines field mappings for call syncing. Only one of ticketFields or dealFields should be provided, based on callSyncType. */
export type HubSpotCallFieldMappingsInput = {
  /** Field mappings when syncing calls as deals. Required when callSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing calls as tickets. Required when callSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotCallSyncType defines how calls are synced to HubSpot */
export enum HubSpotCallSyncType {
  /** Sync calls as deals */
  Deal = 'DEAL',
  /** Sync calls as engagement calls */
  EngagementCall = 'ENGAGEMENT_CALL',
  /** Sync calls as engagement notes */
  EngagementNote = 'ENGAGEMENT_NOTE',
  /** Sync calls as tickets */
  Ticket = 'TICKET'
}

/** HubSpotConfiguration contains configuration for the HubSpot integration */
export type HubSpotConfiguration = {
  __typename?: 'HubSpotConfiguration';
  /** Personal Access Token for HubSpot API authentication */
  accessToken: Scalars['String']['output'];
  /** Field mappings for call syncing */
  callFieldMappings?: Maybe<HubSpotCallFieldMappings>;
  /** The pipeline ID to use when syncing calls as tickets or deals */
  callPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing calls as tickets or deals */
  callStageId?: Maybe<Scalars['String']['output']>;
  /** How calls should be synced to HubSpot */
  callSyncType?: Maybe<HubSpotCallSyncType>;
  /** If enabled, will sync accounts from Cara to HubSpot */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to HubSpot */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to HubSpot */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** Field mappings for task syncing */
  taskFieldMappings?: Maybe<HubSpotTaskFieldMappings>;
  /** The pipeline ID to use when syncing tasks as tickets or deals */
  taskPipelineId?: Maybe<Scalars['String']['output']>;
  /** The stage ID to use when syncing tasks as tickets or deals */
  taskStageId?: Maybe<Scalars['String']['output']>;
  /** How tasks should be synced to HubSpot */
  taskSyncType?: Maybe<HubSpotTaskSyncType>;
};

/** HubSpotFieldMapping defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMapping = {
  __typename?: 'HubSpotFieldMapping';
  /** The name of the field in Cara */
  caraField: Scalars['String']['output'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['output'];
};

/** HubSpotFieldMappingInput defines how a Cara field maps to a HubSpot field */
export type HubSpotFieldMappingInput = {
  /** The name of the field in Cara */
  caraField: Scalars['String']['input'];
  /** The name of the field in HubSpot */
  hubspotField: Scalars['String']['input'];
};

export type HubSpotPipeline = {
  __typename?: 'HubSpotPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotPipelineStage = {
  __typename?: 'HubSpotPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
};

/** HubSpotTaskFieldMappings defines field mappings for task syncing */
export type HubSpotTaskFieldMappings = {
  __typename?: 'HubSpotTaskFieldMappings';
  /** Field mappings when syncing tasks as deals */
  dealFields: Array<HubSpotFieldMapping>;
  /** Field mappings when syncing tasks as tickets */
  ticketFields: Array<HubSpotFieldMapping>;
};

/** HubSpotTaskFieldMappingsInput defines field mappings for task syncing. Only one of ticketFields or dealFields should be provided, based on taskSyncType. */
export type HubSpotTaskFieldMappingsInput = {
  /** Field mappings when syncing tasks as deals. Required when taskSyncType is DEAL, must not be provided otherwise. */
  dealFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
  /** Field mappings when syncing tasks as tickets. Required when taskSyncType is TICKET, must not be provided otherwise. */
  ticketFields?: InputMaybe<Array<HubSpotFieldMappingInput>>;
};

/** HubSpotTaskSyncType defines how tasks are synced to HubSpot */
export enum HubSpotTaskSyncType {
  /** Sync tasks as deals */
  Deal = 'DEAL',
  /** Sync tasks as engagement tasks */
  EngagementTask = 'ENGAGEMENT_TASK',
  /** Sync tasks as tickets */
  Ticket = 'TICKET'
}

export type HubSpotTicketPipeline = {
  __typename?: 'HubSpotTicketPipeline';
  archived: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  stages: Array<HubSpotTicketPipelineStage>;
  updatedAt: Scalars['String']['output'];
};

export type HubSpotTicketPipelineStage = {
  __typename?: 'HubSpotTicketPipelineStage';
  archived: Scalars['Boolean']['output'];
  displayOrder: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  ticketState: Scalars['String']['output'];
};

/** Identities that a particular user can take on. These are intrinsically determined by the system and cannot be changed by the user. */
export enum Identity {
  /** Administrator access to the API, grants the GLOBAL scope. */
  Admin = 'ADMIN',
  /** Agency client access to the API, grants the SELF scope by default, and limits access to client-only resources. */
  AgencyClient = 'AGENCY_CLIENT',
  /** Agency user access to the API, grants the ORGANIZATION scope by default, and limits access to agency-only resources. */
  AgencyUser = 'AGENCY_USER',
  /** Anonymous access to the API, grants no scope and strictly limits the user to only public resources. */
  Anonymous = 'ANONYMOUS'
}

/** Represents a reference to an image stored in the cache */
export type ImageReference = {
  __typename?: 'ImageReference';
  /** The cache key for the image */
  cacheKey: Scalars['String']['output'];
  /** The MIME type of the image */
  mimeType: Scalars['String']['output'];
  /** The size of the image in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
};

/**
 * ImageRightConfiguration contains configuration for the ImageRight integration.
 * The password is stored but never exposed through the API.
 */
export type ImageRightConfiguration = {
  __typename?: 'ImageRightConfiguration';
  /**
   * ImageRight server URL. ImageRight is self-hosted per-agency, so each agency
   * provides the base URL of their own ImageRight server.
   */
  serverUrl: Scalars['String']['output'];
  /** ImageRight username for authentication */
  username: Scalars['String']['output'];
};

/** Image style */
export type ImageStyle = {
  __typename?: 'ImageStyle';
  /** Whether height should be automatically calculated */
  heightAuto: Scalars['Boolean']['output'];
  /** Maximum width as a percentage (e.g. 100.0) */
  maxWidthPct?: Maybe<Scalars['Float']['output']>;
  /** Page break behavior (e.g. 'avoid') */
  pageBreakInside?: Maybe<Scalars['String']['output']>;
};

/** Input for image style */
export type ImageStyleInput = {
  /** If true, image height is automatically calculated */
  heightAuto?: InputMaybe<Scalars['Boolean']['input']>;
  /** Maximum width as a percentage of the page width (0-100) */
  maxWidthPct?: InputMaybe<Scalars['Float']['input']>;
  /** CSS page-break-inside value for images (e.g. 'avoid') */
  pageBreakInside?: InputMaybe<Scalars['String']['input']>;
};

export type ImportAmsAccountByExternalIdInput = {
  /** Placeholder company name until the refresh replaces it. */
  displayName?: InputMaybe<Scalars['String']['input']>;
  externalId: Scalars['String']['input'];
  integrationId: Scalars['ID']['input'];
};

/** The local record an import produced. */
export type ImportAmsAccountResult = {
  __typename?: 'ImportAmsAccountResult';
  accountId: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * True when the account's structured refresh is in flight, so the caller can start
   * polling rather than reading an empty destination list as an absence.
   */
  syncing: Scalars['Boolean']['output'];
};

/** One column of an import file, as the server that validates the rows defines it. */
export type ImportColumn = {
  __typename?: 'ImportColumn';
  /** For a list column: values are added to a record's, never removed. */
  addOnly: Scalars['Boolean']['output'];
  /** Compared exactly as written, case and list order included, rather than normalized. */
  compareLiterally: Scalars['Boolean']['output'];
  /** The allowed values of an ENUM column. Null when they come from optionsFrom. */
  enumValues?: Maybe<Array<Scalars['String']['output']>>;
  /** Set when a record is added; a different value on an existing record is refused. */
  fixedOnceAdded: Scalars['Boolean']['output'];
  /** The property of a row this column maps to. */
  key: Scalars['String']['output'];
  /** The column header. */
  label: Scalars['String']['output'];
  /** The cell holds a list of values of the column's type. */
  multiple: Scalars['Boolean']['output'];
  /** Where an ENUM column's allowed values come from, when enumValues is null. */
  optionsFrom?: Maybe<ImportColumnOptionsSource>;
  /** A row without a value here is refused. */
  required: Scalars['Boolean']['output'];
  type: ImportColumnType;
};

/** Where a column's allowed values come from when they are not fixed by the schema. */
export enum ImportColumnOptionsSource {
  /**
   * The labels of the line-of-business catalog being saved alongside the rows. The page
   * holds that catalog, possibly with unsaved edits, so it supplies the values.
   */
  LineOfBusinessCatalog = 'LINE_OF_BUSINESS_CATALOG'
}

/** The type of value an import column holds. */
export enum ImportColumnType {
  Boolean = 'BOOLEAN',
  Date = 'DATE',
  Email = 'EMAIL',
  /** One of the column's allowed values. */
  Enum = 'ENUM',
  Number = 'NUMBER',
  Phone = 'PHONE',
  String = 'STRING'
}

/** The columns of one kind of import, and how a row is matched to an existing record. */
export type ImportSchema = {
  __typename?: 'ImportSchema';
  /** In template order. */
  columns: Array<ImportColumn>;
  /** The columns that together identify a record. */
  keyColumns: Array<Scalars['String']['output']>;
  /** The key column to change so that two rows sharing the rest of the key can both be kept. */
  tieBreaker?: Maybe<Scalars['String']['output']>;
};

export enum IndexingStatus {
  /** The document has been indexed */
  Completed = 'COMPLETED',
  /** The document failed to index */
  Failed = 'FAILED',
  /** The document is being indexed */
  Indexing = 'INDEXING',
  /** The document has not started indexing yet */
  Unknown = 'UNKNOWN'
}

/** Account details specific to an individual account holder */
export type IndividualAccount = AccountDetails & {
  __typename?: 'IndividualAccount';
  /** Primary email address for contacting the individual */
  email: Scalars['String']['output'];
  /** Mailing address for the individual */
  mailingAddress: Address;
  /** The full name of the individual */
  name: Scalars['String']['output'];
  /** Primary phone number for contacting the individual */
  phone: Scalars['String']['output'];
};

/** Represents an insurance carrier or broker that can provide policies */
export type InsuranceCarrier = {
  __typename?: 'InsuranceCarrier';
  /** If available, the ID of this carrier in Ascend */
  ascendId?: Maybe<Scalars['String']['output']>;
  /** Human readable short identifier of this carrier */
  id: Scalars['String']['output'];
  /** True if this insurance entity is a broker which we use to access a carrier */
  isBroker: Scalars['Boolean']['output'];
  /** True if this insurance entity is a carrier with binding authority */
  isCarrier: Scalars['Boolean']['output'];
  /** Legal name of this carrier */
  name: Scalars['String']['output'];
  /** The types of insurance policies supported by this carrier */
  supportedPolicies?: Maybe<Array<InsuranceType>>;
};

/** Describes the market the insurance policy was written in. */
export enum InsuranceMarket {
  /** The admitted market */
  Admitted = 'ADMITTED',
  /** The Excess and Surplus (E&S) market */
  ExcessAndSurplus = 'EXCESS_AND_SURPLUS'
}

/** Insurance type for business insurance */
export enum InsuranceType {
  /** Insurance coverage for accidents and health-related incidents */
  AccidentAndHealth = 'ACCIDENT_AND_HEALTH',
  /** Comprehensive coverage package for business owners */
  BusinessOwners = 'BUSINESS_OWNERS',
  /** Coverage for vehicles used in commercial operations */
  CommercialAuto = 'COMMERCIAL_AUTO',
  /** Protection against cyber risks and data breaches */
  Cyber = 'CYBER',
  /** Coverage for directors and officers against liability claims */
  DirectorsAndOfficers = 'DIRECTORS_AND_OFFICERS',
  /** Protection against employment-related claims */
  EmploymentPracticesLiability = 'EMPLOYMENT_PRACTICES_LIABILITY',
  /** Coverage for professional mistakes and oversights */
  ErrorsAndOmission = 'ERRORS_AND_OMISSION',
  /** Additional liability coverage beyond standard policies */
  Excess = 'EXCESS',
  /** Basic liability coverage for business operations */
  GeneralLiability = 'GENERAL_LIABILITY',
  /** Specialized coverage for jewelry businesses */
  JewelersBlock = 'JEWELERS_BLOCK',
  /** Other types of insurance coverage not listed */
  Other = 'OTHER',
  /** Combined package of multiple insurance coverages */
  Package = 'PACKAGE',
  /** Coverage for product-related liability claims */
  ProductLiability = 'PRODUCT_LIABILITY',
  /** Coverage for professional services liability */
  ProfessionalLiability = 'PROFESSIONAL_LIABILITY',
  /** Coverage for business property and assets */
  Property = 'PROPERTY',
  /** Insurance for rental properties or equipment */
  Rental = 'RENTAL',
  /** Coverage for goods in transit and transportation risks */
  ShippingAndTransportation = 'SHIPPING_AND_TRANSPORTATION',
  /** Umbrella liability coverage */
  Umbrella = 'UMBRELLA',
  /** Coverage for employee work-related injuries */
  WorkersCompensation = 'WORKERS_COMPENSATION'
}

/** Integration represents a connection to an external system */
export type Integration = {
  __typename?: 'Integration';
  /** The agency this integration belongs to. Resolved via a batched loader. */
  agency: Agency;
  /** Authorization credentials for the integration */
  authorization?: Maybe<IntegrationAuthorization>;
  /**
   * Whether Cara can log sent emails to this integration's AMS, so turning on
   * logsSentEmails would have an effect. False for an AMS Cara can't write emails to
   * yet, and for anything that isn't an AMS.
   */
  canLogSentEmails: Scalars['Boolean']['output'];
  /**
   * Why canLogSentEmails is false: UNSUPPORTED_CONNECTION for a connection its AMS can't
   * log emails through, else UNSUPPORTED_AMS. Null when it is true.
   */
  cannotLogSentEmailsReason?: Maybe<AmsNotLoggedReason>;
  /** Configuration for the integration */
  configuration: IntegrationConfiguration;
  /** Timestamp of when the integration was created */
  createdAt: Scalars['Time']['output'];
  /** Timestamp of when the integration was deleted, if applicable */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  emailLogDestinations: Array<EmailAmsLogDestination>;
  emailLogPreference?: Maybe<EmailAmsLogPreference>;
  /** Unique identifier for the integration */
  id: Scalars['ID']['output'];
  /** Timestamp of when the integration last synced data */
  lastSyncedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether emails sent from Cara are logged to this AMS. At most one integration per
   * agency has it on.
   */
  logsSentEmails: Scalars['Boolean']['output'];
  /** Current state of the integration */
  state: IntegrationState;
  /**
   * Sync logs for the integration, ordered by startedAt descending.
   * When limit is provided, at most that many of the most recent logs are returned.
   * When type is provided, only logs of that sync type are returned.
   */
  syncLogs: Array<IntegrationSyncLog>;
  /** Type of integration */
  type: IntegrationType;
  /** Timestamp of when the integration was last updated */
  updatedAt: Scalars['Time']['output'];
};


/** Integration represents a connection to an external system */
export type IntegrationSyncLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<IntegrationSyncType>;
};

/** IntegrationAuthorization contains credentials for authenticating with the integration */
export type IntegrationAuthorization = {
  __typename?: 'IntegrationAuthorization';
  /** Basic authentication credentials */
  basicAuth?: Maybe<BasicAuth>;
  /** Bearer token authentication credentials */
  bearerAuth?: Maybe<BearerAuth>;
};

/**
 * Describes all actions a given integration type supports. Surfaced to the UI
 * by the `integrationCapabilities` query so that the workflow builder can
 * render context-sensitive configuration for OUTPUT_INTEGRATION and
 * INPUT_AMS_READ tasks.
 */
export type IntegrationCapability = {
  __typename?: 'IntegrationCapability';
  /** The actions this integration supports */
  actions: Array<IntegrationCapabilityAction>;
  /** A human-readable label */
  label: Scalars['String']['output'];
  /** The integration type this capability describes */
  type: IntegrationType;
};

/**
 * A specific action a particular integration supports (e.g. "create note",
 * "upload attachment", "search accounts"). Each action carries its own JSON
 * schema describing the configuration fields the UI should render.
 */
export type IntegrationCapabilityAction = {
  __typename?: 'IntegrationCapabilityAction';
  /** JSON Schema describing the per-action configuration fields */
  configSchema: Scalars['JSON']['output'];
  /** Explains what the action does */
  description: Scalars['String']['output'];
  /** JSON Schema describing the 'what to write' / inbound payload shape */
  inputSchema?: Maybe<Scalars['JSON']['output']>;
  /** A stable identifier for the action (e.g. 'create_note') */
  key: Scalars['String']['output'];
  /** READ vs WRITE classification */
  kind: IntegrationCapabilityKind;
  /** A human-readable label */
  label: Scalars['String']['output'];
};

/** Classifies what an integration capability does */
export enum IntegrationCapabilityKind {
  /** Read records from the integration */
  Read = 'READ',
  /** Write records into the integration */
  Write = 'WRITE'
}

/** IntegrationConfiguration contains configuration for the integration */
export type IntegrationConfiguration = {
  __typename?: 'IntegrationConfiguration';
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: Maybe<AgencyZoomConfiguration>;
  /** Configuration for the AMS360 integration */
  ams360?: Maybe<Ams360Configuration>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: Maybe<AppliedEpicConfiguration>;
  /** Configuration for the EZLynx integration */
  ezlynx?: Maybe<EzLynxConfiguration>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: Maybe<HawksoftConfiguration>;
  /** Configuration for the HubSpot integration */
  hubspot?: Maybe<HubSpotConfiguration>;
  /** Configuration for the ImageRight integration */
  imageRight?: Maybe<ImageRightConfiguration>;
  /** Configuration for the NowCerts integration */
  nowcerts?: Maybe<NowCertsConfiguration>;
  /** Configuration for the QQCatalyst integration */
  qqcatalyst?: Maybe<QqCatalystConfiguration>;
  /** Configuration for the Zapier integration */
  zapier?: Maybe<ZapierConfiguration>;
};

export type IntegrationMetadataItem = {
  __typename?: 'IntegrationMetadataItem';
  children?: Maybe<Array<IntegrationMetadataItem>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/** IntegrationState defines the current state of an integration */
export enum IntegrationState {
  /** Integration is active and functioning */
  Active = 'ACTIVE',
  /** Integration has been created but not yet configured */
  Created = 'CREATED',
  /** Integration has been disabled */
  Disabled = 'DISABLED',
  /** Integration is in process of being configured */
  Pending = 'PENDING'
}

/** IntegrationSyncError defines the error that occurred during a sync operation */
export type IntegrationSyncError = {
  __typename?: 'IntegrationSyncError';
  /** The error code */
  code: IntegrationSyncErrorCode;
  /** The name of the function that caused the error */
  functionName?: Maybe<Scalars['String']['output']>;
  /** The parameters passed to the function that caused the error */
  functionParams?: Maybe<Scalars['JSON']['output']>;
  /** Any HTTP request or response that is related to the error */
  http?: Maybe<HttpRequestResponse>;
  /** The unique identifier for the error */
  id: Scalars['ID']['output'];
  /** The error message */
  message: Scalars['String']['output'];
  /** Whether the error is retryable */
  retryable: Scalars['Boolean']['output'];
  /** The timestamp of the error */
  timestamp: Scalars['Time']['output'];
};

/** IntegrationSyncErrorCode defines the code of an error that occurred during a sync operation */
export enum IntegrationSyncErrorCode {
  /** The sync operation failed due to an authentication error */
  ApiAuthError = 'API_AUTH_ERROR',
  /** The sync operation failed due to a conflict error */
  ApiConflict = 'API_CONFLICT',
  /** The sync operation failed due to a rate limit exceeded error */
  ApiRateLimitExceeded = 'API_RATE_LIMIT_EXCEEDED',
  /** The sync operation failed due to a server error */
  ApiServerError = 'API_SERVER_ERROR',
  /** The sync operation failed due to a timeout error */
  ApiTimeout = 'API_TIMEOUT',
  /** The sync operation failed due to an API error */
  ApiUnknownError = 'API_UNKNOWN_ERROR',
  /** The sync operation failed due to an internal timeout */
  DeadlineExceeded = 'DEADLINE_EXCEEDED',
  /** The sync operation failed due to a missing call */
  MissingCall = 'MISSING_CALL',
  /** The sync operation failed due to a not found error */
  NotFound = 'NOT_FOUND',
  /** The sync operation was superseded by a new sync operation */
  Superceded = 'SUPERCEDED',
  /** The sync operation failed due to an unknown error */
  Unknown = 'UNKNOWN',
  /** The sync operation failed because of an invalid or unsupported operation */
  UnsupportedOperation = 'UNSUPPORTED_OPERATION',
  /** The sync operation failed due to a validation error */
  ValidationError = 'VALIDATION_ERROR',
  /**
   * The sync workflow aborted before normal finalization (e.g. an activity
   * exhausted its retries and bubbled an error up). Any previously recorded
   * errors on the sync log remain in place; this code is appended by the
   * workflow's cleanup path to explain why the log was force-finalized.
   */
  WorkflowAborted = 'WORKFLOW_ABORTED'
}

/** A record of a sync operation for an integration */
export type IntegrationSyncLog = {
  __typename?: 'IntegrationSyncLog';
  /** The call that is associated with this sync operation, if any. */
  associatedCall?: Maybe<Call>;
  /** Timestamp of when the sync operation completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Progress of the sync operation */
  entitiesSynced: Scalars['Int']['output'];
  /** The integration entities that were written during this sync operation, if any. */
  entitiesWritten: Array<KnowledgeGraphEntity>;
  /** Any errors that occurred during the sync operation. */
  errors: Array<IntegrationSyncError>;
  /** Unique identifier for the sync log */
  id: Scalars['ID']['output'];
  /** The ID of the entity that initiated the sync operation */
  initiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the sync operation */
  initiatorType: UpdateInitiatorType;
  /** The integration that this sync log is associated with */
  integration: Integration;
  /**
   * Last error message from the sync operation
   * @deprecated Use errors instead. Will be removed in a future release.
   */
  lastError?: Maybe<Scalars['String']['output']>;
  /** The service requests were being synced as part of this sync operation, if any. */
  serviceRequests: Array<ServiceRequest>;
  /** Timestamp of when the sync operation started */
  startedAt: Scalars['Time']['output'];
  /** State of the sync operation */
  state: IntegrationSyncState;
  /** The type of the sync operation */
  type: IntegrationSyncType;
};

/** A cursor-paginated connection of IntegrationSyncLog records. */
export type IntegrationSyncLogConnection = {
  __typename?: 'IntegrationSyncLogConnection';
  edges: Array<IntegrationSyncLogEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** An edge in a paginated IntegrationSyncLog connection. */
export type IntegrationSyncLogEdge = {
  __typename?: 'IntegrationSyncLogEdge';
  cursor: Scalars['String']['output'];
  node: IntegrationSyncLog;
};

/** Sort fields for searchIntegrationSyncLogs. Only these columns are allowed. */
export enum IntegrationSyncLogSortField {
  CompletedAt = 'COMPLETED_AT',
  Duration = 'DURATION',
  EntitiesSynced = 'ENTITIES_SYNCED',
  StartedAt = 'STARTED_AT'
}

/** Sort input for searchIntegrationSyncLogs. */
export type IntegrationSyncLogSortInput = {
  direction: SortDirection;
  field: IntegrationSyncLogSortField;
};

/** IntegrationSyncState defines the current state of a sync operation */
export enum IntegrationSyncState {
  /** Sync operation has completed */
  Completed = 'COMPLETED',
  /** Sync operation has failed */
  Failed = 'FAILED',
  /** Sync operation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** IntegrationSyncType defines the type of sync operation */
export enum IntegrationSyncType {
  /** Sync operation is a read operation */
  Read = 'READ',
  /** Sync operation is a write operation */
  Write = 'WRITE'
}

/** IntegrationType defines the type of integration, including AMS, CRM, and more. */
export enum IntegrationType {
  /** AMS360 agency management system integration */
  Ams_360 = 'AMS_360',
  /** Applied Epic agency management system integration */
  AmsAppliedEpic = 'AMS_APPLIED_EPIC',
  /** EZLynx agency management system integration */
  AmsEzlynx = 'AMS_EZLYNX',
  /** Hawksoft agency management system integration */
  AmsHawksoft = 'AMS_HAWKSOFT',
  /** ImageRight document management system integration. Requires an active AMS360 integration. */
  AmsImageright = 'AMS_IMAGERIGHT',
  /** NowCerts agency management system integration */
  AmsNowcerts = 'AMS_NOWCERTS',
  /** QQCatalyst agency management system integration */
  AmsQqcatalyst = 'AMS_QQCATALYST',
  /**
   * Cara itself, as the source of records it holds rather than reads: a client
   * an agent typed in, or one Cara extracted from a workspace. Which of the two
   * wrote a row is on the row's provenance, not on this type.
   *
   * Unlike every other value, an agency never configures this one. One is
   * created per agency on first use, to key that agency's Cara-held records.
   */
  Cara = 'CARA',
  /** Agency Zoom CRM integration */
  CrmAgencyZoom = 'CRM_AGENCY_ZOOM',
  /** HubSpot CRM integration */
  CrmHubspot = 'CRM_HUBSPOT',
  /** Zapier integration */
  Zapier = 'ZAPIER'
}

/**
 * Filter input for the integrations query.
 *
 * In agency/organization scope, the resolver overrides agencyId with the caller's
 * principal organization ID — other values of agencyId are ignored to prevent scope
 * escape. In global (admin) scope, agencyId is honored if set and otherwise omitted.
 */
export type IntegrationsFilterInput = {
  /** Restrict to integrations for this agency. Honored in global scope; overridden in org scope. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Only integrations with at least one sync log in state FAILED in the last 24 hours. */
  hasRecentErrors?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only integrations whose lastSyncedAt is strictly after this timestamp. */
  lastSyncedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only integrations whose lastSyncedAt is strictly before this timestamp. */
  lastSyncedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Case-insensitive match against agency name and integration ID. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to integrations in this state. */
  state?: InputMaybe<IntegrationState>;
  /** Restrict to integrations of this type. */
  type?: InputMaybe<IntegrationType>;
};

export type KnowledgeBase = {
  __typename?: 'KnowledgeBase';
  /**
   * List of agencies that have been granted access to this knowledge base.
   * Only visible to the owner agency.
   */
  accessList: Array<KnowledgeBaseAccess>;
  /** The timestamp when this knowledge base was created */
  createdAt: Scalars['Time']['output'];
  /** The timestamp when this knowledge base was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The documents in this knowledge base */
  documents: Array<KnowledgeBaseDocument>;
  /**
   * Cosmetic folders used to organize documents in this knowledge base.
   * Folders do not affect retrieval or indexing.
   */
  folders: Array<KnowledgeBaseFolder>;
  /**
   * Enables owner-configured priority content matching for documents in this
   * knowledge base.
   */
  guidedRetrievalEnabled: Scalars['Boolean']['output'];
  /** The unique identifier for this knowledge base */
  id: Scalars['ID']['output'];
  /**
   * Whether this knowledge base is owned by the current user's agency.
   * If false, the KB is shared with the current agency.
   * Note: For ADMIN identities, this is always false (admins don't own KBs).
   */
  isOwner: Scalars['Boolean']['output'];
  /**
   * The current user's agency's access role for this knowledge base.
   * Null if the current agency owns this KB (use isOwner instead).
   * Note: For ADMIN identities, this is always null (admins have implicit global access).
   */
  myAccess?: Maybe<KnowledgeBaseAccess>;
  /**
   * The agency that owns this knowledge base (for shared KBs).
   * No auth directive - if you can see the KB, you can see basic owner info.
   */
  ownerAgency?: Maybe<Agency>;
  /** The title of this knowledge base */
  title: Scalars['String']['output'];
  /** The timestamp when this knowledge base was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of the knowledge base schema */
  version: KnowledgeBaseVersion;
};

/** Access control for agencies to knowledge bases */
export type KnowledgeBaseAccess = {
  __typename?: 'KnowledgeBaseAccess';
  /**
   * The agency that has been granted access.
   * No auth directive - access is already controlled at the KnowledgeBase.accessList level
   * (only owners can see the access list).
   */
  agency: Agency;
  /** The timestamp when this access was granted */
  createdAt: Scalars['Time']['output'];
  /** The role this agency has for the knowledge base */
  role: KnowledgeBaseAccessRole;
  /** The timestamp when this access was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * The role an agency has for accessing a shared knowledge base.
 * Note: Ownership is determined by knowledge_base.agency_id, not this table.
 */
export enum KnowledgeBaseAccessRole {
  /** The agency can read and upload documents to this knowledge base */
  Contributor = 'CONTRIBUTOR',
  /** The agency can only read from this knowledge base */
  Viewer = 'VIEWER'
}

/** A document that is part of a knowledge base */
export type KnowledgeBaseDocument = {
  __typename?: 'KnowledgeBaseDocument';
  /**
   * Instructions for how the information in this document should be used when
   * answering questions (max 500 characters). Shown to the AI alongside the
   * document content.
   */
  contextNote?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this document was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this document */
  createdBy: AgencyUser;
  /** The timestamp when this document was deleted, if it was deleted */
  deletedAt?: Maybe<Scalars['Time']['output']>;
  /** The description of this document */
  description: Scalars['String']['output'];
  /**
   * Preferred user-facing name for FILE documents in the knowledge base UI and
   * when Cara refers to the document. Does not alter indexed content, embeddings,
   * or semantic content retrieval. Only populated for FILE documents.
   */
  displayName?: Maybe<Scalars['String']['output']>;
  /**
   * The ID that groups all versions of this document together.
   * For the first version, this equals the document's own ID.
   * Note: String (not ID) because multiple documents share this value.
   */
  documentGroupId: Scalars['String']['output'];
  /**
   * Example user questions that should cause Cara to include this document as
   * priority content (max 500 characters).
   */
  exampleQuestions?: Maybe<Scalars['String']['output']>;
  /** The file underlying a FILE-type document in the knowledge base */
  file?: Maybe<KnowledgeBaseDocumentFile>;
  /** The cosmetic folder containing this document. Null or empty means root. */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for this document */
  id: Scalars['ID']['output'];
  /** The status of the document indexing */
  indexingStatus: KnowledgeBaseDocumentIndexingStatus;
  /** The metadata of the document if it has been generated */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The data underlying a TEXT-type document in the knowledge base */
  text?: Maybe<KnowledgeBaseDocumentText>;
  /** The title of this document */
  title: Scalars['String']['output'];
  /** The type of document in this knowledge base */
  type: KnowledgeBaseDocumentType;
  /** The timestamp when this document was last updated */
  updatedAt: Scalars['Time']['output'];
  /**
   * Error from the most recent failed sync, derived from sync logs.
   * Only populated when type is URL and last sync failed.
   */
  urlLastSyncError?: Maybe<Scalars['String']['output']>;
  /**
   * Timestamp of the last successful sync, derived from sync logs.
   * Only populated when type is URL.
   */
  urlLastSyncedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Configuration for URL-sourced documents.
   * Only populated when type is URL.
   */
  urlSource?: Maybe<KnowledgeBaseDocumentUrlSource>;
  /**
   * Sync logs for URL-sourced documents.
   * Only populated when type is URL. Returns most recent syncs first.
   */
  urlSyncLogs: Array<UrlDocumentSyncLog>;
  /**
   * Current sync status derived from the latest sync log.
   * Only populated when type is URL.
   */
  urlSyncStatus?: Maybe<UrlDocumentSyncState>;
  /** All versions of this document, ordered by version number descending (newest first). */
  versionHistory: Array<KnowledgeBaseDocument>;
  /** The version number of this document (1, 2, 3, etc.) */
  versionNumber: Scalars['Int']['output'];
};

/** An embedding of a document in the knowledge base */
export type KnowledgeBaseDocumentEmbedding = {
  __typename?: 'KnowledgeBaseDocumentEmbedding';
  /**
   * Block types contained in this chunk (V2 only).
   * Values like "Table", "Text", "Section Header", etc. from Reducto.
   */
  blockTypes?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Claude-generated context preamble for contextual retrieval (V2 only).
   * Situates the chunk within the overall document.
   */
  chunkContext?: Maybe<Scalars['String']['output']>;
  /** The data underlying this chunk */
  chunkData: Scalars['String']['output'];
  /**
   * Combined content for embedding and BM25 search (V2 only).
   * Contains context preamble + chunk content. This is what gets embedded.
   */
  chunkEmbedContent?: Maybe<Scalars['String']['output']>;
  /** The hash of the chunk */
  chunkHash: Scalars['String']['output'];
  /** The end position of the chunk in the document */
  chunkPosEnd: Scalars['Int']['output'];
  /** The start position of the chunk in the document */
  chunkPosStart: Scalars['Int']['output'];
  /** The sequence number of the chunk in the document */
  chunkSeq: Scalars['Int']['output'];
  /** The timestamp when this chunk was created */
  createdAt: Scalars['Time']['output'];
  /** The embedding of the chunk */
  embedding?: Maybe<Array<Scalars['Float']['output']>>;
  /**
   * MIME type of the source document (V2 only).
   * E.g., "application/pdf", "text/plain"
   */
  fileType?: Maybe<Scalars['String']['output']>;
  /** The metadata of the chunk */
  metadata?: Maybe<KnowledgeBaseDocumentMetadata>;
  /** The name of the embedding model used */
  modelName: Scalars['String']['output'];
  /** The revision of the embedding model used */
  modelRevision: Scalars['String']['output'];
  /**
   * Page numbers from the source document that this chunk spans (V2 only).
   * Derived from Reducto BBox.Page data.
   */
  pageNumbers?: Maybe<Array<Scalars['Int']['output']>>;
  /** The timestamp when this chunk was updated */
  updatedAt: Scalars['Time']['output'];
};

/** File metadata underlying a FILE-type document in the knowledge base */
export type KnowledgeBaseDocumentFile = {
  __typename?: 'KnowledgeBaseDocumentFile';
  /** The timestamp this file was created */
  createdAt: Scalars['Time']['output'];
  /** The SHA256 hash of the file bytes */
  hash: Scalars['String']['output'];
  /** The MIME type of the uploaded file */
  mimeType: Scalars['String']['output'];
  /** The name of the uploaded file */
  name: Scalars['String']['output'];
  /** The size of the uploaded file in bytes */
  size: Scalars['Int']['output'];
  /** The public URL to fetch the file, if the file is visible to the user */
  url?: Maybe<Scalars['String']['output']>;
};

/** The status of the document indexing */
export type KnowledgeBaseDocumentIndexingStatus = {
  __typename?: 'KnowledgeBaseDocumentIndexingStatus';
  /** The timestamp when the indexing was completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The error that occurred during the indexing, if any */
  error?: Maybe<Scalars['String']['output']>;
  /** The progress of the indexing */
  progress?: Maybe<Scalars['Float']['output']>;
  /** The timestamp when the indexing was started */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The status of the indexing */
  status: IndexingStatus;
};

/** The metadata of a document in the knowledge base */
export type KnowledgeBaseDocumentMetadata = {
  __typename?: 'KnowledgeBaseDocumentMetadata';
  /** The keywords of the document (V1 format - flat list) */
  keywords?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * Structured keywords organized by category (V2 format).
   * Only populated for V2 knowledge bases.
   */
  keywordsStructured?: Maybe<KnowledgeBaseKeywords>;
  /** The purpose of the document */
  purpose: Scalars['String']['output'];
  /** The summary of the document */
  summary: Scalars['String']['output'];
  /** The title of the document */
  title: Scalars['String']['output'];
};

/** Content underlying a TEXT-type document in the knowledge base */
export type KnowledgeBaseDocumentText = {
  __typename?: 'KnowledgeBaseDocumentText';
  /** The content of this document */
  content: Scalars['String']['output'];
};

/** The type of document in a knowledge base */
export enum KnowledgeBaseDocumentType {
  /** A file that was uploaded into the knowledge base */
  File = 'FILE',
  /** A document that was written as part of the knowledge base */
  Text = 'TEXT',
  /** A document sourced from a URL (either downloaded or captured as screenshot) */
  Url = 'URL'
}

/**
 * Configuration for a URL-sourced document.
 * Sync state (status, lastSyncedAt, errors) is derived from urlSyncLogs on KnowledgeBaseDocument.
 */
export type KnowledgeBaseDocumentUrlSource = {
  __typename?: 'KnowledgeBaseDocumentURLSource';
  /** How often to sync the content */
  frequency: UrlMonitorFrequency;
  /** Whether automatic syncing is paused */
  isPaused: Scalars['Boolean']['output'];
  /** How to fetch the content (download vs screenshot) */
  sourceType: UrlSourceType;
  /** The URL to fetch content from */
  url: Scalars['String']['output'];
};

/** Cosmetic folder metadata for organizing knowledge base documents. */
export type KnowledgeBaseFolder = {
  __typename?: 'KnowledgeBaseFolder';
  /** The timestamp when this folder was created */
  createdAt: Scalars['Time']['output'];
  /** The unique identifier for this folder */
  id: Scalars['ID']['output'];
  /** The display name of this folder */
  name: Scalars['String']['output'];
  /** The parent folder ID. Null means this folder is at the root. */
  parentFolderId?: Maybe<Scalars['String']['output']>;
  /** The timestamp when this folder was last updated */
  updatedAt: Scalars['Time']['output'];
};

/**
 * Structured keywords organized by category for V2 knowledge bases.
 * Used for filtering and organization in the UI.
 */
export type KnowledgeBaseKeywords = {
  __typename?: 'KnowledgeBaseKeywords';
  /** Insurance carriers mentioned in the document */
  carrier?: Maybe<Array<Scalars['String']['output']>>;
  /** Document type (e.g., Appetite guide, Application, Underwriting guidelines) */
  documentType?: Maybe<Array<Scalars['String']['output']>>;
  /** Industries mentioned (e.g., Construction, Manufacturing, Restaurant) */
  industry?: Maybe<Array<Scalars['String']['output']>>;
  /** Lines of business (e.g., Workers Comp, General Liability, Commercial Auto) */
  lineOfBusiness?: Maybe<Array<Scalars['String']['output']>>;
  /** US states mentioned (2-letter codes like CA, NY, TX) */
  state?: Maybe<Array<Scalars['String']['output']>>;
  /** Other important keywords that don't fit into the above categories */
  uncategorized?: Maybe<Array<Scalars['String']['output']>>;
};

/** The version of the knowledge base schema */
export enum KnowledgeBaseVersion {
  /** Version 2 of the knowledge base */
  V2 = 'V2'
}

/** KnowledgeGraphEntity represents an entity in the knowledge graph */
export type KnowledgeGraphEntity = {
  __typename?: 'KnowledgeGraphEntity';
  /** The timestamp of when the entity was created */
  createdAt: Scalars['Time']['output'];
  /** The display name of the entity (like full name, company name, ticket title, etc.) */
  displayName: Scalars['String']['output'];
  /** The ID of the entity in the external system */
  externalId: Scalars['String']['output'];
  /** Unique identifier for the entity */
  id: Scalars['ID']['output'];
  /** The integration this entity is associated with */
  integration: Integration;
  /** The ID of the entity in the internal system */
  internalId: Scalars['String']['output'];
  /** The timestamp of when the entity was last modified */
  modifiedAt: Scalars['Time']['output'];
  /** The properties of the entity as a JSON object */
  properties: Scalars['JSON']['output'];
  /** Entities related to this entity (used by the explorer) */
  relatedEntities: Array<KnowledgeGraphRelatedEntity>;
  /** The search metadata of the entity */
  searchMetadata: KnowledgeGraphEntitySearchMetadata;
  /** The secondary information of the entity (like email, status, etc.) */
  secondaryInfo?: Maybe<Scalars['String']['output']>;
  /** The timestamp of when the entity was last synced */
  syncedAt: Scalars['Time']['output'];
  /** The type of entity */
  type: KnowledgeGraphEntityType;
  /** The timestamp of when the entity was last modified */
  updatedAt: Scalars['Time']['output'];
};

export enum KnowledgeGraphEntityAccountType {
  /** The account is a business */
  Business = 'BUSINESS',
  /** The account is an individual */
  Individual = 'INDIVIDUAL'
}

/** KnowledgeGraphEntityConnection holds a page of knowledge graph entities */
export type KnowledgeGraphEntityConnection = {
  __typename?: 'KnowledgeGraphEntityConnection';
  /** The entities in this page */
  nodes: Array<KnowledgeGraphEntity>;
  /** Pagination info */
  pageInfo: PageInfo;
  /** Total count of matching entities */
  totalCount: Scalars['Int']['output'];
};

/** KnowledgeGraphEntityFilter is used to filter knowledge graph entities in the explorer */
export type KnowledgeGraphEntityFilter = {
  /** Cursor for pagination */
  after?: InputMaybe<Scalars['String']['input']>;
  /** Required: the agency whose entities to browse */
  agencyId: Scalars['ID']['input'];
  /** Restrict to entities of this type */
  entityType?: InputMaybe<KnowledgeGraphEntityType>;
  /** Fetch a single entity by its internal KG ID */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Restrict to entities from this specific integration */
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  /** Maximum number of entities to return (default 50) */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Full-text search against entity name / description */
  query?: InputMaybe<Scalars['String']['input']>;
};

/**
 * KnowledgeGraphEntitySearchMetadata represents the search metadata of the entity. It can be used to store
 * structured data that can be used to search for the entity. The metadata that is stored depends on the
 * type of the entity.
 */
export type KnowledgeGraphEntitySearchMetadata = {
  __typename?: 'KnowledgeGraphEntitySearchMetadata';
  /** The account metadata of the entity */
  account?: Maybe<KnowledgeGraphEntitySearchMetadataAccount>;
  /** The call log metadata of the entity */
  call?: Maybe<KnowledgeGraphEntitySearchMetadataCall>;
  /** The contact metadata of the entity */
  contact?: Maybe<KnowledgeGraphEntitySearchMetadataContact>;
  /**
   * The FEIN (Federal Employer Identification Number) of the entity. Typically
   * populated on commercial account entities and, for AppliedEpic, on policy
   * entities whose commercial application carries a FirstNamedInsuredFEIN.
   */
  fein?: Maybe<Scalars['String']['output']>;
  /** The file metadata of the entity */
  file?: Maybe<KnowledgeGraphEntitySearchMetadataFile>;
  /** The note metadata of the entity */
  note?: Maybe<KnowledgeGraphEntitySearchMetadataNote>;
  /** The policy metadata of the entity */
  policy?: Maybe<KnowledgeGraphEntitySearchMetadataPolicy>;
  /**
   * The SSN (Social Security Number) of the entity. Typically populated on
   * personal account entities and, for AppliedEpic, on policy entities whose
   * commercial application carries a FirstNamedInsuredSocialSecurityNumber.
   */
  ssn?: Maybe<Scalars['String']['output']>;
  /** The task metadata of the entity */
  task?: Maybe<KnowledgeGraphEntitySearchMetadataTask>;
};

/** KnowledgeGraphEntitySearchMetadataAccount represents the account metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataAccount = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataAccount';
  /** The type of the account */
  dba?: Maybe<Scalars['String']['output']>;
  /** The email of the account */
  email?: Maybe<Scalars['String']['output']>;
  /**
   * The integration-assigned short code for the account (e.g. AppliedEpic
   * LookupCode). Unique within an agency; commonly used by AMS users to
   * disambiguate accounts that share an email or phone number.
   */
  lookupCode?: Maybe<Scalars['String']['output']>;
  /** The address of the account */
  mailingAddress?: Maybe<Address>;
  /** The NAICS code of the account */
  naics?: Maybe<Scalars['String']['output']>;
  /** The name of the account */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the account */
  phone?: Maybe<Scalars['String']['output']>;
  /** The type of the account */
  type?: Maybe<KnowledgeGraphEntityAccountType>;
  /** The website of the account */
  website?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataCall represents the call metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataCall = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataCall';
  /** The action taken during the call */
  action?: Maybe<Scalars['String']['output']>;
  /** The name of the caller */
  fromName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is from */
  fromNumber?: Maybe<Scalars['String']['output']>;
  /** The unique identifier for the call */
  id: Scalars['String']['output'];
  /** The result of the call */
  result?: Maybe<Scalars['String']['output']>;
  /** The start date and time of the call */
  startDate?: Maybe<Scalars['Time']['output']>;
  /** The name of the recipient */
  toName?: Maybe<Scalars['String']['output']>;
  /** The phone number the call is to */
  toNumber?: Maybe<Scalars['String']['output']>;
  /** The type of the call (e.g., inbound, outbound) */
  type?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataContact represents the contact metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataContact = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataContact';
  /** The email of the contact */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the contact */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the contact */
  phone?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataFile represents the file metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataFile = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataFile';
  /** The creation date of the file */
  createdAt?: Maybe<Scalars['Time']['output']>;
  /** The creator of the file */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The download URL of the file */
  downloadUrl?: Maybe<Scalars['String']['output']>;
  /** The expiration date of the download URL */
  downloadUrlExpiresAt?: Maybe<Scalars['Time']['output']>;
  /** The ID of the folder that the file is in */
  folderId?: Maybe<Scalars['String']['output']>;
  /** The name of the folder that the file is in */
  folderName?: Maybe<Scalars['String']['output']>;
  /** The MIME type of the file */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The name of the file */
  name?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataNote represents the note metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataNote = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataNote';
  /** The create date of the note */
  createDate?: Maybe<Scalars['Time']['output']>;
  /** The created by of the note */
  createdBy?: Maybe<Scalars['String']['output']>;
  /** The subject of the note */
  subject?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataPolicy represents the policy metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataPolicy = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataPolicy';
  /** Whether the policy is currently active/in-force */
  active?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the insurance carrier (e.g. "State Farm", "Progressive") */
  carrier?: Maybe<Scalars['String']['output']>;
  /** The expiration date of the policy */
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /** The inforce date of the policy */
  inforceAt?: Maybe<Scalars['Time']['output']>;
  /** The policy number of the entity */
  policyNumber?: Maybe<Scalars['String']['output']>;
  /** The total premium amount for the policy */
  premium?: Maybe<Scalars['Float']['output']>;
  /** The status of the policy as reported by the AMS (e.g. "Active", "Cancelled", "Expired") */
  status?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntitySearchMetadataTask represents the task metadata of the entity */
export type KnowledgeGraphEntitySearchMetadataTask = {
  __typename?: 'KnowledgeGraphEntitySearchMetadataTask';
  /** The description of the task */
  description?: Maybe<Scalars['String']['output']>;
  /** The title of the task */
  title?: Maybe<Scalars['String']['output']>;
};

/** KnowledgeGraphEntityType represents the type of entity in the knowledge graph */
export enum KnowledgeGraphEntityType {
  /** The entity represents a client or an account */
  Account = 'ACCOUNT',
  /** The entity represents an activity, or a log of something that happened */
  Activity = 'ACTIVITY',
  /** The entity represents a call with a client */
  Call = 'CALL',
  /** The entity represents a certificate of insurance issued by the agency */
  Certificate = 'CERTIFICATE',
  /** The entity represents an insurance claim, or a loss reported against a policy */
  Claim = 'CLAIM',
  /** The entity represents a contact or individual */
  Contact = 'CONTACT',
  /** The entity represents an email sent to or received from a client */
  Email = 'EMAIL',
  /** The entity represents a file */
  File = 'FILE',
  /** The entity represents a note left by a user */
  Note = 'NOTE',
  /** The entity represents a policy */
  Policy = 'POLICY',
  /** The entity represents an SMS sent to or received from a client */
  Sms = 'SMS',
  /** The entity represents a ticket or issue */
  Ticket = 'TICKET'
}

/** KnowledgeGraphRelatedEntity represents a related entity in the knowledge graph */
export type KnowledgeGraphRelatedEntity = {
  __typename?: 'KnowledgeGraphRelatedEntity';
  /** The related entity */
  entity: KnowledgeGraphEntity;
  /** The type of relationship between the entities */
  relationshipType: Scalars['String']['output'];
};

export type LearnSmartFillFromEditsInput = {
  bucketId: Scalars['ID']['input'];
  learnHints: Scalars['Boolean']['input'];
  observations: Array<SmartFillLearningObservationInput>;
  operationId: Scalars['ID']['input'];
  saveMissing: Scalars['Boolean']['input'];
  scopeEntityId?: InputMaybe<Scalars['ID']['input']>;
};

/** Type of liability coverage for a policy */
export enum LiabilityCoverageType {
  /** Claims-made coverage applies to claims made during the policy period */
  ClaimsMade = 'CLAIMS_MADE',
  /** Occurrence coverage applies to incidents that occur during the policy period */
  Occurrence = 'OCCURRENCE'
}

/** Link style */
export type LinkStyle = {
  __typename?: 'LinkStyle';
  /** Text color in hex format (e.g. '#475569') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Text decoration (e.g. 'none', 'underline') */
  textDecoration?: Maybe<Scalars['String']['output']>;
};

/** Input for link style */
export type LinkStyleInput = {
  /** Link text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** CSS text-decoration value (e.g. 'underline', 'none') */
  textDecoration?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a tool for looking up integration metadata such as employee lists / pipeline IDs / lead sources. */
export type ListIntegrationObjectsTool = {
  __typename?: 'ListIntegrationObjectsTool';
  input: ListIntegrationObjectsToolInput;
  output: ListIntegrationObjectsToolOutput;
};

export type ListIntegrationObjectsToolInput = {
  __typename?: 'ListIntegrationObjectsToolInput';
  category: Scalars['String']['output'];
  integration: Scalars['String']['output'];
  query?: Maybe<Scalars['String']['output']>;
};

export type ListIntegrationObjectsToolOutput = {
  __typename?: 'ListIntegrationObjectsToolOutput';
  items: Array<IntegrationMetadataItem>;
  success: Scalars['Boolean']['output'];
};

/**
 * Represents a tool that lists the mailboxes the agent may send email from. It
 * takes no arguments, so it carries no input: the mailboxes are the workspace
 * user's, and a filter the model could pass would only be a filter it could get
 * wrong.
 */
export type ListMailboxesTool = {
  __typename?: 'ListMailboxesTool';
  /** The mailboxes the agent may send as */
  output: ListMailboxesToolOutput;
};

/**
 * One mailbox as the model sees it. The provider, the grant, and the folder map
 * are all absent on purpose: a field the model can see is a field it will quote
 * back to the agent.
 */
export type ListMailboxesToolMailbox = {
  __typename?: 'ListMailboxesToolMailbox';
  /** The name the address shows, when the provider reports one */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The address mail from this mailbox comes from */
  email: Scalars['String']['output'];
  /**
   * Whether this is the agent's own default mailbox. A shared mailbox's owner's
   * default does not apply to the agent.
   */
  isDefault: Scalars['Boolean']['output'];
  /** The ID to pass as mailboxAccountId to DRAFT_EMAIL */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * Whether the agent connected this mailbox themselves or is one of the people
   * it is shared with
   */
  ownership: ListMailboxesToolOwnership;
  /** Whether the mailbox can be written to, or has to be reconnected first */
  status: MailboxAccountStatus;
};

/** Result of a ListMailboxesTool operation. */
export type ListMailboxesToolOutput = {
  __typename?: 'ListMailboxesToolOutput';
  /**
   * Every mailbox the agent may send as, connected or not. The agent's default
   * comes first, then their other own mailboxes, then shared mailboxes.
   */
  mailboxes: Array<ListMailboxesToolMailbox>;
};

/**
 * Whose address a listed mailbox is. Sharing does not move ownership, so this is
 * the difference between the agent's own address and a colleague's or a team's.
 */
export enum ListMailboxesToolOwnership {
  Own = 'OWN',
  Shared = 'SHARED'
}

/** List style */
export type ListStyle = {
  __typename?: 'ListStyle';
  /** List item bottom margin in em units (e.g. 0.3) */
  itemMarginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 1.0) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Left margin in em units (e.g. 1.5) */
  marginLeftEm?: Maybe<Scalars['Float']['output']>;
};

/** Input for list style */
export type ListStyleInput = {
  /** Bottom margin for each list item in em units */
  itemMarginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin after the list in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Left margin for lists in em units */
  marginLeftEm?: InputMaybe<Scalars['Float']['input']>;
};

/** A correlated log line captured during a trace. */
export type LogRecord = {
  __typename?: 'LogRecord';
  /** Structured log fields (zap fields serialized to JSON). */
  attributes: Scalars['JSON']['output'];
  /** OTel log ID. */
  id: Scalars['ID']['output'];
  /** Log message. */
  message: Scalars['String']['output'];
  /** OTel log severity. */
  severity: LogSeverity;
  /** When the log was emitted. */
  timestamp: Scalars['Time']['output'];
  /** Workspace this log is associated with, if any. */
  workspace?: Maybe<CaraWorkspace>;
};

export type LogRecordConnection = {
  __typename?: 'LogRecordConnection';
  edges: Array<LogRecordEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LogRecordEdge = {
  __typename?: 'LogRecordEdge';
  cursor: Scalars['String']['output'];
  node: LogRecord;
};

/** Severity of a correlated log record. */
export enum LogSeverity {
  Debug = 'DEBUG',
  Error = 'ERROR',
  Info = 'INFO',
  Warn = 'WARN'
}

/**
 * A connected mailbox as the product API exposes it. Credentials, the
 * optimistic-concurrency version, and the sync cursor stay on the persist
 * row — they are not queryable.
 */
export type MailboxAccount = {
  __typename?: 'MailboxAccount';
  /**
   * The mailbox's folders, read from the provider on request: names change and
   * user-created folders come and go, so they are never served from the stored
   * row.
   *
   * The owner sees the full tree. Other people who may send as this mailbox see
   * only standard-role folders, without parent links or custom folder names.
   */
  folders: Array<MailboxFolder>;
  id: Scalars['ID']['output'];
  identity: MailboxIdentity;
  /**
   * Preselected in the composer for its owner. At most one mailbox per owner is
   * the default.
   *
   * Answered for the caller rather than from the row: sharing does not move
   * ownership, so a colleague's default is their preference and reads as false
   * here. Only the owner may set it.
   */
  isDefault: Scalars['Boolean']['output'];
  /**
   * Monitoring of selected folders in this mailbox. Only its owner may read this;
   * sharing send access does not share subscription health or controls.
   */
  monitoring?: Maybe<MailboxMonitoring>;
  owner: MailboxOwner;
  provider: MailboxProvider;
  status: MailboxAccountStatus;
  /**
   * Who may send as this mailbox, on top of the owner, who always may. PRIVATE
   * is a personal mailbox; SHARED names the users and teams that may send from
   * it. PUBLIC is the agency-wide address (support@, hello@): everyone in the
   * agency may send as it, including people hired after the grant. The default
   * is PRIVATE — PUBLIC is a deliberate share, not an omitted one.
   *
   * Only the owner may change this, so a client should offer the editor only
   * when owner.agencyUserId is the signed-in user.
   */
  visibility: VisibilityConfig;
};

/**
 * Connection health of a connected mailbox. Closed set so a persisted row
 * cannot carry an unregistered value.
 */
export enum MailboxAccountStatus {
  /** The grant is usable. The runtime may refresh tokens behind the scenes. */
  Connected = 'CONNECTED',
  /**
   * The grant is dead (revoked, or persist failed after a token rotation).
   * The mailbox is unusable until the owner reconnects.
   */
  NeedsReconnect = 'NEEDS_RECONNECT'
}

/** A mailbox's bulk emails against the most it may send in any 24 hours. */
export type MailboxBulkSendUsage = {
  __typename?: 'MailboxBulkSendUsage';
  dailyLimit: Scalars['Int']['output'];
  /**
   * The earliest time, at or after both now and notBefore, that a batch of count emails can
   * start sending without Send refusing it for the daily limit. Null when count alone is past
   * dailyLimit.
   */
  earliestSendAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Bulk emails sent, going out or scheduled from a day before now to a day after it: the
   * window Send checks, so a batch scheduled for tomorrow counts too.
   */
  usedInDailyWindow: Scalars['Int']['output'];
};


/** A mailbox's bulk emails against the most it may send in any 24 hours. */
export type MailboxBulkSendUsageEarliestSendAtArgs = {
  count: Scalars['Int']['input'];
  notBefore?: InputMaybe<Scalars['Time']['input']>;
};

/**
 * The ceilings a composer should refuse against before it sends anything to the
 * server. Published rather than copied into a client bundle, because a copied
 * number goes on refusing at the old value for as long as that bundle is loaded
 * in someone's tab. The server enforces each of these again on the write.
 */
export type MailboxComposeLimits = {
  __typename?: 'MailboxComposeLimits';
  /**
   * The largest total of attachment bytes the server will accept on one email.
   * The same number send and draft-write refuse against (`InternalAttachmentLimit`),
   * published so a composer can stop an oversized file before it is uploaded.
   */
  attachmentBytes: Scalars['Int']['output'];
  /**
   * The largest email body, in bytes of HTML, the server will accept. Pasted
   * images live in the body as base64 data: URIs, so this is what a screenshot
   * pasted into a draft is measured against, and it is the ceiling a body of them
   * reaches long before the attachment ceiling.
   */
  bodyBytes: Scalars['Int']['output'];
};

/**
 * A draft Cara wrote into a connected mailbox, as the product API exposes it.
 * The draft itself lives in the provider and the provider stays the source of
 * truth, so what is queryable here is what Cara stamped when it created the draft plus what
 * Cara has since done to it — never a guess at the mailbox's current contents.
 */
export type MailboxDraft = {
  __typename?: 'MailboxDraft';
  artifactVersion: Scalars['Int']['output'];
  createdAt: Scalars['Time']['output'];
  /**
   * Who asked Cara for the email. Null once that user is offboarded; the draft
   * record stays.
   */
  createdByUserId?: Maybe<Scalars['String']['output']>;
  /** When the provider copy was last compared to Cara's recorded baseline. */
  externalEditsCheckedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Whether the provider copy differs from Cara's last saved content.
   * Separate from syncState, which compares Cara's artifact. A null
   * externalEditsCheckedAt means unknown, not agreement.
   */
  externallyEdited: Scalars['Boolean']['output'];
  /**
   * The address the draft is sitting under, denormalized from the mailbox so a
   * reader can tell whose Drafts folder holds it without a second query.
   */
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The mailbox holding the draft. The row is deleted with the account, so this
   * always names a mailbox that exists — unlike the retained IDs on OutboundEmail
   * and MailboxEvent.
   */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * When the provider stopped holding the draft. Non-null makes the row a record
   * of a draft rather than a draft: nothing is waiting in the Drafts folder any
   * more.
   */
  retiredAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Why the mailbox stopped holding it: sent_via_cara, sent_externally,
   * deleted_externally, vanished, superseded, or retracted. Empty while it is
   * live. Open text for the same reason MailboxEvent.reason is — a new way for a
   * draft to leave should not need a migration.
   *
   * The three an agent's own mail client produces each say what was found, and
   * none of them is a guess. `sent_externally` is written with a copy in hand that
   * the mailbox no longer calls a draft, which is the one thing that proves a
   * send. `deleted_externally` is written with the draft found in the mailbox's
   * trash, so it is a deletion rather than a word for one. `vanished` is the
   * residual, and the only one resting on an absence: nothing carrying this
   * Message-ID is reachable in the mailbox at all, which a purge, a Message-ID the
   * provider never reported, and a copy the search cannot see produce alike.
   *
   * `retiredAt` is when Cara noticed, not when the mail went out. The send time is
   * on the `OutboundEmail` for this artifact, whose `sentExternally` marks the
   * same event from the send log's side.
   */
  retiredReason: Scalars['String']['output'];
  /**
   * Set only when the send went through Cara. An agent who pressed send in their
   * own client sent mail Cara never saw go, and this stays null.
   */
  sentViaCaraAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The subject of the artifact version the mailbox copy was written from, rather
   * than of the draft as it stands: an agent who retitled the draft in Outlook
   * changed something Cara cannot see, and reporting what Cara handed over is the
   * honest answer.
   */
  subject: Scalars['String']['output'];
  /**
   * Whether the copy in the mailbox still carries what the EMAIL artifact says,
   * answered against the artifact as it stands right now rather than as it stood
   * when the draft was written. A composer disables its "update the draft" button
   * on IN_SYNC and enables it on everything else; the other three each want
   * different wording, which is why this is not a boolean.
   *
   * Only IN_SYNC is a promise, and only about Cara's side of the exchange: an
   * agent who retitled or rewrote the draft in their own mail client changed
   * something Cara cannot see, and no value here reflects it.
   */
  syncState: MailboxDraftSyncState;
  updatedAt: Scalars['Time']['output'];
  /**
   * Opens the draft in the provider's own client. Empty when the provider handed
   * back no link, and stale once retiredAt is set, because what it addresses is
   * the provider's copy.
   */
  webLink: Scalars['String']['output'];
  /**
   * The EMAIL artifact the draft was written from, and the version the mailbox
   * copy holds. A version behind the artifact's own means the copy in the mailbox
   * is stale.
   */
  workspaceArtifactId?: Maybe<Scalars['String']['output']>;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

export type MailboxDraftConnection = {
  __typename?: 'MailboxDraftConnection';
  edges: Array<MailboxDraftEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MailboxDraftEdge = {
  __typename?: 'MailboxDraftEdge';
  cursor: Scalars['String']['output'];
  node: MailboxDraft;
};

/**
 * What checking one parked draft against its mailbox came to.
 *
 * The first five are conclusions: the mailbox was asked and the ledger now agrees
 * with what it holds. `UNREACHABLE`, `MAILBOX_DISCONNECTED` and `NOT_REACHED` are
 * not conclusions, and none may be rendered as `UNCHANGED` even though all four
 * leave the row as it was: one means the draft is still sitting in the Drafts
 * folder, the others mean nobody got an answer, and those rows are worth asking
 * about again — once the mailbox is reconnected, where that is what stopped it.
 */
export enum MailboxDraftReconciliation {
  /**
   * A send Cara owns is in flight over this artifact version, so the sent copy in
   * the mailbox is that send's doing rather than anyone's hand. The draft is left
   * for the send path to retire.
   */
  Deferred = 'DEFERRED',
  /**
   * The draft is no longer somewhere it can be sent from, and nothing says it was.
   * Retired as `deleted_externally` where the mailbox is holding it in the trash,
   * and as `vanished` where nothing carrying its Message-ID could be found at all
   * — see `MailboxDraft.retiredReason`.
   *
   * A draft the agent merely moved to another folder is not this: it comes back
   * `UNCHANGED`, with the row re-pointed at where the mailbox now keeps it.
   */
  GoneUnproven = 'GONE_UNPROVEN',
  /**
   * The mailbox cannot be asked and syncing again will not get further: the
   * connection is dead, was never consented to, carries no scope for this read, or
   * has no mail account behind it. The row stands as it was — the draft is still in
   * the Drafts folder as far as anyone knows — and reconnecting the mailbox is what
   * makes it answerable again.
   */
  MailboxDisconnected = 'MAILBOX_DISCONNECTED',
  /**
   * The sync ran out of time before this draft's turn, so nothing was asked about
   * it. Syncing again is what settles it.
   */
  NotReached = 'NOT_REACHED',
  /**
   * The mailbox holds a sent copy of the mail Cara drafted, so the agent sent it
   * from their own client. The draft is retired and the send is now on the
   * outbound log marked `sentExternally`.
   */
  SentExternally = 'SENT_EXTERNALLY',
  /**
   * The mailbox holds a sent copy of mail Cara itself put on the wire — a send
   * that reached the provider and lost the answer. The send is corrected to sent
   * and the draft retires as `sent_via_cara`.
   */
  SentViaCara = 'SENT_VIA_CARA',
  /**
   * Nothing to record: the mailbox still holds the draft, or the row had already
   * been retired before this look. A draft the agent moved to another folder is
   * reported here too — the mailbox still holds it and it is still theirs to send,
   * and all that changed is where the row has to look for it next time.
   */
  Unchanged = 'UNCHANGED',
  /**
   * The mailbox was asked and would not answer: rate limited, or too slow. The row
   * stands as it was and the next sync can settle it.
   */
  Unreachable = 'UNREACHABLE'
}

/**
 * One draft's result from `reconcileMailboxDrafts`, carrying both what was
 * concluded and the row as it now stands, so a client can settle that row without
 * re-reading the list it came from.
 */
export type MailboxDraftReconciliationResult = {
  __typename?: 'MailboxDraftReconciliationResult';
  /**
   * The draft as it stands after the look: retired, with its reason, where the
   * reconciliation retired it, and unchanged otherwise. Always present, including
   * for `UNREACHABLE` and `NOT_REACHED`, so every row a client asked about has
   * something to render.
   */
  draft: MailboxDraft;
  /**
   * The draft this result is about, so a client can match results to rows without
   * selecting anything from `draft`.
   */
  mailboxDraftId: Scalars['String']['output'];
  reconciliation: MailboxDraftReconciliation;
};

/**
 * How the copy of an email sitting in a mailbox stands against the EMAIL artifact
 * it was written from. The two ways an email moves are separate values because
 * they read differently to whoever is looking at it: one is Cara's revision to
 * accept, the other is a person's edit that may be their own from another tab.
 */
export enum MailboxDraftSyncState {
  /**
   * Cara wrote a newer version of the email after this draft was pushed. The
   * mailbox holds words that were current once and are not any more.
   */
  ArtifactVersionAhead = 'ARTIFACT_VERSION_AHEAD',
  /**
   * The artifact is on the version the mailbox holds, but its words have changed
   * since — a person edited the email, which rewrites a version in place rather
   * than raising it.
   */
  ContentChanged = 'CONTENT_CHANGED',
  /**
   * The mailbox holds the artifact's current version and its current words.
   * There is nothing to push, so pushing again would only touch the draft's
   * timestamp in the provider.
   */
  InSync = 'IN_SYNC',
  /**
   * Nothing here can establish whether the copy matches: the draft has been
   * retired so there is no copy left, or it names no artifact, or it predates the
   * fingerprint being recorded. Reported as not in sync, because the alternative
   * is telling someone an email is safely parked when nothing checked.
   */
  Unknown = 'UNKNOWN'
}

export type MailboxDraftsFilterInput = {
  /**
   * When true, return only drafts written from the authenticated user's own
   * requests.
   */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Include drafts the mailbox no longer holds. Off by default: the question the
   * list is asked is "what is waiting in the Drafts folder", and a retired row is
   * an answer to a different one.
   */
  includeRetired?: InputMaybe<Scalars['Boolean']['input']>;
  mailboxAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Narrows to the drafts belonging to emails the outbox filter matches. See
   * OutboxFilterInput for why this is answered against the whole email rather
   * than against the draft row.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  workspaceArtifactId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * One entry in the mailbox audit trail: what Cara did in a connected mailbox,
 * who caused it, and when. Entries are written once and never changed or
 * removed, and they survive the mailbox they describe — disconnecting an
 * integration must not erase the record of what was done through it.
 *
 * No subjects, senders, recipients, bodies or attachments are retained here.
 * Lifecycle entries are agency-readable. Notification entries and correlation
 * metadata include private message references and are restricted to the owner.
 */
export type MailboxEvent = {
  __typename?: 'MailboxEvent';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  /** The agency user who acted, empty when initiatorType is not AGENCY_USER. */
  initiatorId: Scalars['String']['output'];
  /**
   * Whether a person did this or Cara did. WORKFLOW means no human pressed
   * anything — a background token refresh, or a copilot tool acting inside a
   * workspace run. AGENCY_USER carries that user in `initiatorId`.
   */
  initiatorType: UpdateInitiatorType;
  /**
   * The mailbox this concerns. Retained after a disconnect, so it may name a
   * mailbox that no longer exists.
   */
  mailboxAccountId?: Maybe<Scalars['String']['output']>;
  mailboxDraftId?: Maybe<Scalars['String']['output']>;
  /** Owner-only: null for other viewers, who also never see NOTIFICATION_ACTIVITY entries. */
  notification?: Maybe<MailboxNotificationAudit>;
  occurredAt: Scalars['Time']['output'];
  /**
   * Why, in the vocabulary of the event type: how a grant died for
   * REAUTH_REQUIRED, how a draft left the mailbox for DRAFT_RETIRED. Empty where
   * the type needs no qualifier.
   */
  reason: Scalars['String']['output'];
  /**
   * The person whose request Cara was acting on, where Cara acted rather than
   * the person. Kept apart from initiatorId on purpose: an automated action
   * taken on someone's behalf is still an automated action.
   */
  requestedByUserId?: Maybe<Scalars['String']['output']>;
  type: MailboxEventType;
  /**
   * The EMAIL artifact the draft was written from, and the version this event
   * concerns, so the trail lines up against the artifact's own history.
   */
  workspaceArtifactId?: Maybe<Scalars['String']['output']>;
};

/**
 * What happened in a mailbox. Each value reconstructs a transition in a row that
 * records only its current state. Sends are absent: an outbound send is its own
 * record.
 */
export enum MailboxEventType {
  /** A mailbox was connected for the first time. */
  Connected = 'CONNECTED',
  /**
   * The mailbox was forgotten and its credentials deleted. The event outlives
   * the account row it names, so the ID it carries resolves to nothing.
   */
  Disconnected = 'DISCONNECTED',
  /** Cara wrote an email artifact into the mailbox as a native draft. */
  DraftCreated = 'DRAFT_CREATED',
  /** Cara updated the recorded location of a draft moved within the mailbox. */
  DraftRelocated = 'DRAFT_RELOCATED',
  /**
   * The provider stopped holding the draft — sent, superseded, retracted, or
   * deleted from the mailbox by its owner. `reason` says which.
   */
  DraftRetired = 'DRAFT_RETIRED',
  /**
   * Cara pushed the artifact's current state onto a draft already in the
   * mailbox. The draft row keeps only the newest version it was synced to, so
   * this is the only record that a draft was pushed more than once.
   */
  DraftSynced = 'DRAFT_SYNCED',
  /** Notifications may have been missed; Cara will recheck its drafts. */
  MonitoringInterrupted = 'MONITORING_INTERRUPTED',
  /** The owner asked Cara to monitor the selected folders in this mailbox. */
  MonitoringStarted = 'MONITORING_STARTED',
  /** The owner asked Cara to stop monitoring this mailbox. */
  MonitoringStopped = 'MONITORING_STOPPED',
  /** An authenticated notification receipt, dispatch result or processing attempt. */
  NotificationActivity = 'NOTIFICATION_ACTIVITY',
  /**
   * Cara found the stored grant dead and stopped using the mailbox. Recorded
   * once per death, not once per operation that trips over it.
   */
  ReauthRequired = 'REAUTH_REQUIRED',
  /**
   * A dead grant was repaired by fresh consent for the same provider account.
   * Distinct from CONNECTED so a timeline can pair a repair with the
   * REAUTH_REQUIRED that prompted it.
   */
  Reconnected = 'RECONNECTED'
}

/**
 * Which timeline to read. At most one subject may be named, and each maps onto
 * an index the table was built with; naming none reads the agency-wide feed.
 */
export type MailboxEventsFilterInput = {
  mailboxAccountId?: InputMaybe<Scalars['String']['input']>;
  /** Select notifications (true), lifecycle (false), or both (omitted), before limiting. */
  notificationActivity?: InputMaybe<Scalars['Boolean']['input']>;
  workspaceArtifactId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A folder on a connected mailbox. User-created folders have no standard role;
 * parentId is null for a top-level folder.
 */
export type MailboxFolder = {
  __typename?: 'MailboxFolder';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  parentId?: Maybe<Scalars['ID']['output']>;
  role?: Maybe<MailboxFolderRole>;
};

/**
 * Standard folder roles every provider exposes, named after IMAP SPECIAL-USE
 * (RFC 6154). User-created folders are omitted from this enum.
 */
export enum MailboxFolderRole {
  Archive = 'ARCHIVE',
  Drafts = 'DRAFTS',
  Inbox = 'INBOX',
  Junk = 'JUNK',
  Sent = 'SENT',
  Trash = 'TRASH'
}

/**
 * Who the mailbox sends as, captured at connect and verified on reconnect.
 * A reconsent that signs into a different provider account must not inherit
 * this mailbox's cursor and message IDs.
 */
export type MailboxIdentity = {
  __typename?: 'MailboxIdentity';
  displayName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  providerAccountId: Scalars['String']['output'];
};

/**
 * A message reference and folder name captured on first observation. No email
 * headers or content are retained. This is not current state or delivery confirmation.
 * Only the mailbox owner may read it.
 */
export type MailboxMessageActivity = {
  __typename?: 'MailboxMessageActivity';
  /** First-observed name; empty means no historical name is available. */
  folderName: Scalars['String']['output'];
  /** Current folder mapping, not a historical direction or delivery claim. */
  folderRole?: Maybe<MailboxFolderRole>;
  id: Scalars['ID']['output'];
  mailboxAccountId: Scalars['String']['output'];
  providerMessageId: Scalars['String']['output'];
  /** When Cara first recorded this provider message, not when it was sent. */
  recordedAt: Scalars['Time']['output'];
};

/**
 * A folder Cara watches in this mailbox: one the owner chose (or a standard one
 * until they choose), or one an active email trigger needs.
 */
export type MailboxMonitoredFolder = {
  __typename?: 'MailboxMonitoredFolder';
  /** Watched because an active email trigger needs it, not because the owner chose it. */
  addedForTriggers: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  /** The last registration attempt could not find this folder. */
  missing: Scalars['Boolean']['output'];
  /** The name recorded when this folder was selected; the full path for a folder added for email triggers. */
  name: Scalars['String']['output'];
};

/**
 * The owner's monitoring preference and the subscription's current health.
 * Credentials, subscription identifiers, and provider responses stay private.
 */
export type MailboxMonitoring = {
  __typename?: 'MailboxMonitoring';
  /** An unexpired subscription accepts deliveries, including while stopping; false during handover. */
  active: Scalars['Boolean']['output'];
  enabled: Scalars['Boolean']['output'];
  expiresAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The owner's selection, or Inbox, Drafts and Sent until one is made, then the
   * folders active email triggers need.
   */
  folders: Array<MailboxMonitoredFolder>;
  /** The maximum folder selection accepted by the server. */
  maxMonitoredFolders: Scalars['Int']['output'];
  /** Folders email triggers asked for that are not watched, as of the last maintenance pass. */
  notes: Array<MailboxMonitoringNote>;
  /** Safe, actionable text from the server; empty when no problem is known. */
  problem: Scalars['String']['output'];
  /** Null when no problem is known. Use this, not the wording, to choose an action. */
  problemKind?: Maybe<MailboxMonitoringProblemKind>;
  /** Whether delete notifications are processed. Only Cara-created messages are affected. */
  processDeletes: Scalars['Boolean']['output'];
  /** Whether update notifications are processed. Only Cara-created messages are affected. */
  processUpdates: Scalars['Boolean']['output'];
  /** Monitoring is enabled and a subscription handover or tracked-draft recheck is pending. */
  recovering: Scalars['Boolean']['output'];
};

/** A folder left unwatched at the last maintenance pass, and why. */
export type MailboxMonitoringNote = {
  __typename?: 'MailboxMonitoringNote';
  code: MailboxMonitoringNoteCode;
  /** The folder as the trigger named it (path, standard role or ID), or the folder's name. Empty for UNKNOWN, which has no public folder detail. */
  folder: Scalars['String']['output'];
};

/** Why a folder an email trigger asks for is not watched. */
export enum MailboxMonitoringNoteCode {
  /** The mailbox already watches as many folders as Cara allows. */
  FolderLimit = 'FOLDER_LIMIT',
  /** An email trigger names a folder this mailbox does not have. */
  TriggerFolderMissing = 'TRIGGER_FOLDER_MISSING',
  /** Some requested folders could not be watched; details are unavailable. Returned at most once per account, after known notes. */
  Unknown = 'UNKNOWN'
}

/** The action needed to address a monitoring problem, without provider diagnostics. */
export enum MailboxMonitoringProblemKind {
  FoldersUnavailable = 'FOLDERS_UNAVAILABLE',
  ReconnectRequired = 'RECONNECT_REQUIRED',
  TemporaryFailure = 'TEMPORARY_FAILURE',
  Throttled = 'THROTTLED',
  Unsupported = 'UNSUPPORTED'
}

/** Sanitized processing metadata. An open attempt is not proof of success. */
export type MailboxNotificationAudit = {
  __typename?: 'MailboxNotificationAudit';
  attemptId: Scalars['String']['output'];
  /** The message change, or empty for a subscription signal. */
  changeType: Scalars['String']['output'];
  errorKind: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
  outcome: Scalars['String']['output'];
  providerMessageId: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  receiptId: Scalars['String']['output'];
  /** The subscription signal, or empty for a message change. */
  watchSignal: Scalars['String']['output'];
};

/** An already-readable, disconnectable account; no nested mailbox data. */
export type MailboxOffboardingAccount = {
  __typename?: 'MailboxOffboardingAccount';
  emailAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

/**
 * Who connected the mailbox and holds its OAuth grant. Routing does not use
 * this; product uses it for authorization and the settings UI. agencyUserId is
 * the agency employee, not a client-portal user. Sharing a mailbox does not move
 * ownership: the owner is still the only person who can reconnect it or change
 * who it is shared with.
 */
export type MailboxOwner = {
  __typename?: 'MailboxOwner';
  agencyId: Scalars['String']['output'];
  agencyUserId: Scalars['String']['output'];
};

/**
 * Which mail service a connected mailbox is authorized against. Adding a
 * provider is this enum plus an adapter; product code routes on the stored
 * value rather than on integration-specific types.
 */
export enum MailboxProvider {
  Outlook = 'OUTLOOK'
}

/**
 * An email signature authored in Cara. No provider exposes the signature a user
 * configured in its own client, so outgoing mail carries what Cara appends.
 * Visibility decides who else may pick it; the author always can.
 */
export type MailboxSignature = {
  __typename?: 'MailboxSignature';
  bodyHtml: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  /**
   * Preselected in the composer for its author. At most one signature per author
   * is the default.
   */
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  owner: MailboxOwner;
  updatedAt: Scalars['Time']['output'];
  visibility: VisibilityConfig;
};

export type MailboxSignatureInput = {
  bodyHtml: Scalars['String']['input'];
  /**
   * Omit to create. Supplying an ID edits that signature, and only its author
   * may: ownership comes from the authenticated principal, never from this ID.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  /** Who else may pick this signature. Defaults to PRIVATE. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Margin settings for all sides */
export type MarginStyle = {
  __typename?: 'MarginStyle';
  /** Bottom margin in inches (e.g. 0.75) */
  bottomIn?: Maybe<Scalars['Float']['output']>;
  /** Left margin in inches (e.g. 0.75) */
  leftIn?: Maybe<Scalars['Float']['output']>;
  /** Right margin in inches (e.g. 0.75) */
  rightIn?: Maybe<Scalars['Float']['output']>;
  /** Top margin in inches (e.g. 0.75) */
  topIn?: Maybe<Scalars['Float']['output']>;
};

/** Input for margin settings */
export type MarginStyleInput = {
  /** Bottom margin in inches */
  bottomIn?: InputMaybe<Scalars['Float']['input']>;
  /** Left margin in inches */
  leftIn?: InputMaybe<Scalars['Float']['input']>;
  /** Right margin in inches */
  rightIn?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in inches */
  topIn?: InputMaybe<Scalars['Float']['input']>;
};

export type MemoriesInput = {
  /** Filter by agent (for admin views) */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by category */
  category?: InputMaybe<MemoryCategory>;
  /** Maximum number of memories to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** Filter by scope */
  scope?: InputMaybe<MemoryScope>;
  /** Filter by pinned status */
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter by surface */
  surface?: InputMaybe<MemorySurface>;
  /** Filter by type */
  type?: InputMaybe<MemoryType>;
};

/**
 * A single, self-contained fact or preference derived from interactions with Cara.
 * Memories are atomic (one piece of information each) and self-contained (interpretable
 * without the originating conversation).
 */
export type Memory = {
  __typename?: 'Memory';
  /** How many times this memory has been injected into a prompt. Computed from the memory_access log. */
  accessCount: Scalars['Int']['output'];
  /** The agency this memory belongs to */
  agency: Agency;
  /** The agent this memory belongs to (null for ORGANIZATION scope) */
  agencyUser?: Maybe<AgencyUser>;
  /** Topical domain of the memory (orthogonal to surface) */
  category: MemoryCategory;
  /**
   * The self-contained text of the memory. All references are resolved and
   * the text is interpretable without the originating conversation.
   */
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  /** The user who created this memory */
  createdBy?: Maybe<AgencyUser>;
  deletedAt?: Maybe<Scalars['Time']['output']>;
  id: Scalars['ID']['output'];
  /** Keywords for secondary retrieval filtering within broad categories */
  keywords: Array<Scalars['String']['output']>;
  /** When this memory was last injected into a prompt. Computed from the memory_access log. */
  lastAccessedAt?: Maybe<Scalars['Time']['output']>;
  /** How and where this memory was created */
  provenance: MemoryProvenance;
  /** Organization-wide or agent-specific */
  scope: MemoryScope;
  /** Whether this memory is always included regardless of budget pressure */
  sticky: Scalars['Boolean']['output'];
  /** Product surface this memory is scoped to. Null means cross-surface. */
  surface?: Maybe<MemorySurface>;
  /** What kind of information: preference, correction, or procedure */
  type: MemoryType;
  updatedAt: Scalars['Time']['output'];
};

/**
 * Topical domain the memory applies to. Orthogonal to MemorySurface --
 * a memory can target a specific product surface, a topic, or both.
 */
export enum MemoryCategory {
  /** Carrier preferences and relationships */
  Carrier = 'CARRIER',
  /** Communication style, tone, and formatting */
  Communication = 'COMMUNICATION',
  /** Coverage knowledge and preferences */
  Coverage = 'COVERAGE',
  /** Document formatting and templates */
  Documentation = 'DOCUMENTATION',
  /** Catch-all for memories that don't fit other categories */
  General = 'GENERAL',
  /** Process and workflow preferences */
  Workflow = 'WORKFLOW'
}

export type MemoryConnection = {
  __typename?: 'MemoryConnection';
  edges: Array<MemoryEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

/** Tool for explicitly saving a memory the user has asked Cara to remember. */
export type MemoryCreateTool = {
  __typename?: 'MemoryCreateTool';
  /** The input arguments for the memory create operation */
  input: MemoryCreateToolInput;
  /** The result of the memory create operation */
  output: MemoryCreateToolOutput;
};

/**
 * Input arguments for the MEMORY_CREATE tool. Content, type, category, and
 * scope are passed as strings because the underlying tool schema (exposed to
 * the LLM) is reflection-derived; the resolver upcasts them to the typed
 * MemoryType / MemoryCategory / MemoryScope enums.
 */
export type MemoryCreateToolInput = {
  __typename?: 'MemoryCreateToolInput';
  category: Scalars['String']['output'];
  content: Scalars['String']['output'];
  keywords: Array<Scalars['String']['output']>;
  scope: Scalars['String']['output'];
  surface?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

/**
 * Result of the MEMORY_CREATE tool. Status is 'saved' on success or 'failed'
 * on a terminal error. Scope reflects the actual scope the memory was saved
 * under (may differ from the request if the caller lacks admin permissions).
 */
export type MemoryCreateToolOutput = {
  __typename?: 'MemoryCreateToolOutput';
  memoryId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  scope: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type MemoryEdge = {
  __typename?: 'MemoryEdge';
  cursor: Scalars['String']['output'];
  node: Memory;
};

/** Provenance information: where and how a memory was created. */
export type MemoryProvenance = {
  __typename?: 'MemoryProvenance';
  /** Message that triggered extraction, if any */
  messageId?: Maybe<Scalars['String']['output']>;
  /** How this memory was created */
  source: MemorySource;
  /**
   * IDs of the memories this one was derived from. Populated for SYNTHESIZED
   * and MERGED sources so an admin can trace a dream-phase decision back to
   * its inputs; empty for EXTRACTED and MANUAL.
   */
  sourceIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Workspace where this memory was extracted from, if any */
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * Tool for re-ranking the cached memory context when the conversation topic
 * has shifted significantly from the original task.
 */
export type MemoryRefreshTool = {
  __typename?: 'MemoryRefreshTool';
  /** The input arguments for the memory refresh operation */
  input: MemoryRefreshToolInput;
  /** The result of the memory refresh operation */
  output: MemoryRefreshToolOutput;
};

/** Input arguments for the MEMORY_REFRESH tool. */
export type MemoryRefreshToolInput = {
  __typename?: 'MemoryRefreshToolInput';
  reason: Scalars['String']['output'];
};

/**
 * A memory entry returned by MEMORY_REFRESH. Carries just the fields the LLM
 * needs to reason over the memory and the id so the UI can deep-link or
 * attribute it. The full Memory entity is intentionally not embedded -- this
 * keeps the persisted tool-call payload small and avoids dragging
 * forceResolver fields (agency, agencyUser, accessCount, ...) into the
 * tool-call serialization path.
 */
export type MemoryRefreshToolMemory = {
  __typename?: 'MemoryRefreshToolMemory';
  category: MemoryCategory;
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  scope: MemoryScope;
  surface?: Maybe<MemorySurface>;
};

/**
 * Result of the MEMORY_REFRESH tool. The refreshed memories are returned as a
 * structured list so both the LLM and the UI can consume them directly. The
 * list is persisted on the workspace tool-call history and re-rendered into
 * every subsequent LLM prompt, so the memories are visible to the model on
 * the very next turn -- no cached workspace write needed.
 */
export type MemoryRefreshToolOutput = {
  __typename?: 'MemoryRefreshToolOutput';
  /** Memories selected as relevant for the refreshed context. Empty when no memories matched. */
  memories: Array<MemoryRefreshToolMemory>;
  /**
   * Number of memories selected. Equivalent to memories.length but exposed
   * separately so tool-call event consumers that don't traverse the list
   * (logs, metrics) can read the count cheaply.
   */
  memoriesRefreshed: Scalars['Int']['output'];
  status: Scalars['String']['output'];
};

/**
 * Whether a memory is scoped to the entire organization or to an individual agent.
 * Agent-scoped memories take precedence over organization-scoped memories on the same topic.
 */
export enum MemoryScope {
  /** Individual agent: communication style, output format, workflow habits */
  Agent = 'AGENT',
  /** Agency-wide: carrier preferences, compliance requirements, SOPs, terminology */
  Organization = 'ORGANIZATION'
}

/**
 * Filters for the memory-management list. Values within one field are ORed;
 * different fields are ANDed.
 */
export type MemorySearchFilterInput = {
  categories?: InputMaybe<Array<MemoryCategory>>;
  /**
   * Include memories whose surface is null. When no surfaces are supplied, true
   * selects cross-surface memories only; omitting this field leaves surface unfiltered.
   */
  includeCrossSurface?: InputMaybe<Scalars['Boolean']['input']>;
  /** True selects pinned memories; false selects unpinned memories. */
  pinned?: InputMaybe<Scalars['Boolean']['input']>;
  /** Case-insensitive text search across content, keywords, and memory labels. */
  query?: InputMaybe<Scalars['String']['input']>;
  scopes?: InputMaybe<Array<MemoryScope>>;
  /** Specific product surfaces to include. */
  surfaces?: InputMaybe<Array<MemorySurface>>;
  types?: InputMaybe<Array<MemoryType>>;
};

/** How the memory was created. */
export enum MemorySource {
  /** Automatically extracted from a conversation by the async extraction loop */
  Extracted = 'EXTRACTED',
  /** Manually created by the user */
  Manual = 'MANUAL',
  /** Merged by the dream phase from two or more existing memories */
  Merged = 'MERGED',
  /** Synthesized by the dream phase from two or more existing memories */
  Synthesized = 'SYNTHESIZED'
}

/**
 * Product surface a memory is scoped to. A null surface means the memory
 * applies regardless of surface (e.g. an org-wide carrier preference).
 */
export enum MemorySurface {
  /** Applies to Copilot */
  Copilot = 'COPILOT',
  /** Applies to Email AI */
  EmailAi = 'EMAIL_AI',
  /** Applies to Voice */
  Voice = 'VOICE'
}

/** What kind of information the memory captures. */
export enum MemoryType {
  /** A correction to a previous mistake or misunderstanding */
  Correction = 'CORRECTION',
  /** How the agent or agency wants things done */
  Preference = 'PREFERENCE',
  /** A step-by-step process or standard operating procedure */
  Procedure = 'PROCEDURE'
}

/** Message feedback details */
export type MessageFeedback = {
  __typename?: 'MessageFeedback';
  /** Predefined reasons for negative feedback (multiple selection allowed) */
  reasons?: Maybe<Array<MessageFeedbackNegativeReason>>;
};

/**
 * Predefined reasons for negative message feedback
 * Simple, user-friendly language
 */
export enum MessageFeedbackNegativeReason {
  /** Missing important information */
  MissingInformation = 'MISSING_INFORMATION',
  /** Didn't understand what I was asking */
  Misunderstanding = 'MISUNDERSTANDING',
  /** Not helpful */
  NotHelpful = 'NOT_HELPFUL',
  /** Other reason (please explain) */
  Other = 'OTHER',
  /** Too slow */
  TooSlow = 'TOO_SLOW',
  /** Too verbose */
  TooVerbose = 'TOO_VERBOSE',
  /** Wrong information in the form or response */
  WrongInformation = 'WRONG_INFORMATION'
}

/** Message rating type */
export enum MessageRating {
  /** Thumbs down */
  Down = 'DOWN',
  /** Thumbs up */
  Up = 'UP'
}

export type Mutation = {
  __typename?: 'Mutation';
  /** Account user sign in to the Oyster platform */
  accountUserSignIn?: Maybe<AccountUserSignInResponse>;
  /** Account user sign out of the Oyster platform */
  accountUserSignOut: Scalars['Boolean']['output'];
  /**
   * Comment on a selection in a document, or on a box drawn on its rendered pages. A selection
   * is rejected when it cannot be placed in the stored document, which means the editor and the
   * document have diverged. A box is never rejected for its words: one over a logo, a chart or
   * blank space is kept as an area comment.
   */
  addCaraWorkspaceArtifactComment: CaraWorkspaceArtifactComment;
  /** Update a Cara workspace */
  addCaraWorkspaceMessage: CaraWorkspace;
  /**
   * Attaches a document the read-time derivation does not supply: one whose
   * workspace is not linked to this client, or a file uploaded elsewhere.
   *
   * Idempotent, and clears a previous removal of the same document -- both states
   * are the one row.
   *
   * An artifact the caller cannot read is reported as missing rather than refused,
   * so this cannot test whether one exists. Files carry no per-user visibility, so
   * for them the client's agency is the whole check.
   */
  addClientArtifact: Client;
  /** Attaches a file to a client. See addClientArtifact. */
  addClientFile: Client;
  /** Associates an existing contact with an account */
  addContactAssociation: AccountContact;
  /** Adds clients to a bulk draft, skipping an address already listed and anything past 50. */
  addEmailBulkSendRecipients: AddEmailBulkSendRecipientsResult;
  /** Add a comment to a service request */
  addServiceRequestComment: ServiceRequest;
  /** Adds a single user to a team. Admin-only. */
  addTeamMember: Team;
  /** Agency sign in to the Oyster platform */
  agencySignIn?: Maybe<AgencySignInResponse>;
  /** Agency sign out of the Oyster platform */
  agencySignOut: Scalars['Boolean']['output'];
  /**
   * Save answers to the bucket's questions, for its line of business or for the
   * carrier site carrierSiteId names. They are kept when newer forms rebuild the
   * bucket. FORBIDDEN while the gate is off, and for a carrier site while
   * smart_fill_carrier_sites_enabled is off.
   */
  answerSmartFillFormBucket: SmartFillFormBucketQuestions;
  /**
   * Writes approved reconciliation findings back to the AMS. Gate on
   * AmsReconciliationTarget.writable: not every line of business is accepted.
   */
  applyAmsReconciliation: AmsApplyResult;
  applySmartFillLearning: SmartFillLearningOperation;
  /**
   * Take a design out of the list. Documents that use it keep rendering with it. The default
   * design is refused; make another design the default first.
   */
  archiveAgencyDesign: AgencyDesign;
  /**
   * Archives a profile (soft delete). Its users fall back to the agency default,
   * or to their role's permissions when there is none. Admin-only.
   */
  archiveAgencyProfile: AgencyProfile;
  /**
   * Hides the template from the list and the composer. Drafts and sent emails made from it are
   * unchanged.
   */
  archiveEmailTemplate: EmailTemplate;
  /**
   * Soft-delete outbound calls that are not in a scheduled/pending state.
   * Scheduled calls must be cancelled first.
   */
  archiveOutboundCalls: Scalars['Boolean']['output'];
  /**
   * Archives a team (soft delete). Admin-only.
   * Archived team IDs remain in visibility access lists harmlessly — the
   * visibility filter ignores them since archived teams have no members.
   */
  archiveTeam: Team;
  archiveTriggerDefinition: TriggerDefinition;
  /**
   * Deprecated compatibility mutation for older clients. Use
   * updateWordDocumentTemplates instead.
   * @deprecated Use updateWordDocumentTemplates instead.
   */
  archiveWordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Build a one-time render URL for a PDF-renderable workspace artifact with optional prefix/suffix PDFs.
   * Supports HTML documents, ACORD template forms, and custom forms. Inline Upload files are stored
   * in cache with a short TTL and are only valid for a single render. Existing file IDs (from the
   * workspace, message, or template) are passed through unchanged. Without an artifactId nothing is
   * rendered, and the prefix then suffix attachments are joined in order; at least two are required.
   */
  buildHtmlDocumentRenderUrl: HtmlDocumentRenderUrl;
  /** Cancel the specified business insurance policy */
  cancelBusinessPolicy: BusinessPolicy;
  /**
   * Cancel the rest: every email still waiting to go out is cancelled and becomes a draft in
   * Cara again. Emails already sent, or being handed to Outlook, are left to finish. When none
   * has gone out yet, the batch becomes a bulk draft again. Only the person who sent it may
   * cancel it.
   */
  cancelEmailBulkSend: EmailBulkSend;
  /**
   * Cancel a queued send before its deadline, or a SCHEDULED email before its send
   * time; the email becomes a normal unsent draft in Cara and Outlook is not
   * contacted. Only the human who queued it may cancel it.
   */
  cancelMailboxEmail: OutboundEmail;
  /**
   * Cancel this caller's matching send, including during attachment preparation.
   * False means the attempt has not registered yet, not that it is cancelled;
   * the caller may retry while its cancellation window remains open.
   */
  cancelMailboxEmailPreparation: Scalars['Boolean']['output'];
  cancelOutboundCall: OutboundCall;
  /**
   * Schedules a sent batch's current round, none of whose emails has gone out, for a new time,
   * as Schedule all does. Refused once any of them went out, or past the mailbox's daily bulk
   * limit, leaving it as it was. Only the person who sent it may change it.
   */
  changeEmailBulkSendTime: EmailBulkSend;
  /**
   * Chooses which displayed option of a searchable question states one bucket
   * fact, for questions whose options appear only after typing a search. One
   * model call; the browser still verifies the selection it makes.
   */
  chooseSmartFillOption: SmartFillOptionChoice;
  /**
   * Clears the calling user's rule for one destination field and records a
   * CORRECTION revocation event for future learning.
   */
  clearSmartFillOverrides: Scalars['Int']['output'];
  /** Create a certificate of insurance on the client side */
  clientCreateCertificate?: Maybe<ClientCreateCertificateResult>;
  /**
   * Records that an admin confirmed the agency's upcoming annual renewal by
   * setting annualRenewalConfirmedAt to now. Does not change Stripe: apply plan,
   * period, or seat changes with updateSubscription first. Fails unless the plan
   * is BASIC or PRO and today is within the 30 days before annualRenewalDate or on
   * it.
   */
  confirmAnnualRenewal: AgencySubscription;
  /**
   * Records that a person confirmed a client field. Confirming the same field
   * again re-stamps it rather than adding a second tag.
   *
   * value is what the person had in front of them. The mutation refuses if the
   * field no longer reads that, so a confirmation cannot land on a value someone
   * else saved while the confirmer was looking at the old one. It is compared the
   * way the tag is read back, so a difference in spacing or case is not a refusal.
   */
  confirmClientField: ClientFieldProvenance;
  /**
   * Builds one bucket from a workspace's filled ACORD forms, in the shape the
   * site profiles learn, and links it to the workspace. Without artifactIds it
   * reads every ACORD form in the workspace that has a mapping. Call again with
   * the same operationId until the conversion completes.
   */
  convertAcordArtifactsToSmartFillBucket: SmartFillWorkspaceConversion;
  convertWorkspaceToSmartFillBuckets: SmartFillWorkspaceConversion;
  /** Creates a new account */
  createAccount: Account;
  /**
   * A link that downloads a READY export's file for 5 minutes. Only the agency user who asked for
   * the export can get one.
   */
  createAdminAnalyticsExportDownloadUrl: Scalars['String']['output'];
  /**
   * Creates an admin sign-in code or URL for a given agency. For internal (Oyster employee) sessions,
   * omit agencyUserId. For external (agency user) sessions, provide the agencyUserId.
   */
  createAdminSignInCode: AdminSignInCode;
  /** Creates a new agency */
  createAgency: Agency;
  /** Add a design. It is never the default; an admin chooses that with setDefaultAgencyDesign. */
  createAgencyDesign: AgencyDesign;
  /**
   * Create a new set of producer information at the agency level.
   * Available to agency admins only.
   */
  createAgencyProducerInformation: ProducerInformation;
  /**
   * Creates a profile in the current agency. Admin-only and gated behind the
   * AGENCY_PROFILE_MANAGEMENT entitlement. The new profile grants everything the agency's
   * roles allow and shows the whole sidebar, so assigning it before it has been
   * narrowed changes nothing for its users.
   */
  createAgencyProfile: AgencyProfile;
  /** Adds an agency user to an agency */
  createAgencyUser: AgencyUser;
  /**
   * Create a new set of producer information at the agency user level.
   * Available to the specified user or an agency admin.
   */
  createAgencyUserProducerInformation: ProducerInformation;
  /**
   * Adds several agency users (staff, as createAgencyUser adds one) to the caller's
   * agency in one transaction. A row that cannot be created is reported in its result
   * and the rest are created; the whole call is refused when the agency lacks seats for
   * its valid rows, or while the agency_user_csv_import_enabled gate is off. At most 100
   * users per call.
   */
  createAgencyUsers: Array<AgencyUserImportResult>;
  /**
   * Creates an account in the AMS from a document's detected details, then imports it
   * like importAmsAccountByExternalId. With no existing account to check against the
   * per-account whitelist, it is refused unless the integration is enabled for it.
   */
  createAmsAccount: ImportAmsAccountResult;
  /** Create business insurance policies according to specification */
  createBusinessPolicies: Array<BusinessPolicy>;
  /** Create a new Cara workspace */
  createCaraWorkspace: CaraWorkspace;
  /** Create a certificate of insurance */
  createCertificate?: Maybe<CertificateOfLiabilityInsurance>;
  createClient: Client;
  createClientNote: ClientNote;
  /** Creates a new account contact */
  createContact: AccountContact;
  /** Create a new custom preset */
  createCustomPreset: CustomPreset;
  createEmailTemplate: EmailTemplate;
  /** Create a new Excel spreadsheet template */
  createExcelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /**
   * Issue a short-lived grant for the paged editor to read the statics service's measurements of
   * one version of a document: where its pages break, and the margins, header and footer printed
   * around them. Statics refuses those requests without a grant for that version, so one is issued
   * only to a caller who can read it. Visibility is set per version.
   */
  createHtmlDocumentRenderGrant: HtmlDocumentRenderGrant;
  /** Create a new HTML document template */
  createHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Copy a starter into the agency's library as a new template the agency owns and can edit. */
  createHtmlDocumentTemplateFromStarter: HtmlDocumentTemplate;
  /** Create a new integration */
  createIntegration?: Maybe<Integration>;
  /** Create a cosmetic folder inside a knowledge base. */
  createKnowledgeBaseFolder: KnowledgeBase;
  /** Create a new document in the knowledge base */
  createKnowledgeBaseTextDocument: KnowledgeBaseDocument;
  /**
   * Create a new URL-sourced document in the knowledge base.
   * This will set up automatic syncing at the specified frequency.
   */
  createKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  /**
   * Write an EMAIL artifact into a connected mailbox as a native draft, waiting in
   * the Drafts folder to be finished and sent from the mail client itself. This
   * does not send: a draft nobody pressed send on has not gone anywhere.
   *
   * Saving the same email again updates the copy already in the mailbox rather
   * than leaving two, so a second call is a refresh rather than a duplicate. An
   * email parks in one Drafts folder at a time, so naming a different mailbox
   * while a live draft exists is refused rather than leaving a copy in each.
   *
   * artifactVersion pins the composition the caller was looking at, and
   * contentRevision pins the words themselves — a person editing the same draft in
   * another tab rewrites the version in place, which only a fingerprint of the
   * content can catch. contentRevision is nullable because a caller that rendered
   * no composition has no revision to hold, but a client that showed this email to
   * a person must send one: what lands in the Drafts folder is one keystroke from
   * being sent by hand, so the words saved have to be the words that were read.
   *
   * The mailbox must be one the caller may send as — theirs, or shared with them —
   * decided by the mailbox's visibility for the same reason sendMailboxEmail
   * decides it there. An email that has already been sent is refused: a copy in
   * the Drafts folder would only offer it for a second send.
   */
  createMailboxDraft: MailboxDraft;
  /**
   * Create a memory. ORGANIZATION-scoped memories require ORGANIZATION:MEMORY:CREATE
   * (admins by default); AGENT-scoped memories require SELF:MEMORY:CREATE (any agent)
   * and are automatically scoped to the caller. The fine-grained scope-vs-permission
   * match is enforced in the resolver since no memory id exists yet to derive scope.
   */
  createMemory: Memory;
  createOutboundCall: OutboundCall;
  /** Create a service request */
  createServiceRequest: ServiceRequest;
  createSmartFillBucket: SmartFillBucket;
  /**
   * Creates a new team in the current agency. Admin-only and gated behind the
   * TEAM_MANAGEMENT entitlement.
   */
  createTeam: Team;
  createTriggerDefinition: TriggerDefinition;
  /** Create a voice agent */
  createVoiceAgent: VoiceAgent;
  /** Create a new Word document template */
  createWordDocumentTemplate: WordDocumentTemplate;
  /**
   * Create a new workflow definition. Scoped to the caller's own agency
   * since no resource exists yet to derive scope from.
   */
  createWorkflowDefinition: WorkflowDefinition;
  /**
   * Create and start a new workflow execution. Scoped to the caller's
   * agency; the resolver performs the additional check that the requested
   * definition is reachable from this agency (or is a built-in).
   */
  createWorkflowExecution: WorkflowExecution;
  /**
   * Permanently deletes an agency and all of its data. The agency must not have an active
   * subscription. Only accessible by global admins.
   */
  deleteAgency: Scalars['Boolean']['output'];
  /** Deletes the specified business insurance policy */
  deleteBusinessPolicy?: Maybe<BusinessPolicy>;
  deleteCaraWorkspaceArtifactComment: Scalars['Boolean']['output'];
  /**
   * Deletes the client and cascades to its workspace, AMS account and agency-user
   * links. The workspaces themselves are not touched.
   */
  deleteClient: Scalars['Boolean']['output'];
  deleteClientNote: Scalars['Boolean']['output'];
  /** Delete feedback (soft delete) */
  deleteFeedback: Feedback;
  /** Delete a file. Returns the deleted file, if successful. */
  deleteFile?: Maybe<File>;
  /** Delete a document by its ID */
  deleteKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Delete an empty cosmetic folder from a knowledge base. */
  deleteKnowledgeBaseFolder: KnowledgeBase;
  /**
   * Delete selected documents and cosmetic folders from a knowledge base. Folders
   * must be empty after the selected documents and folders are removed.
   */
  deleteKnowledgeBaseItems: KnowledgeBase;
  /**
   * Delete a signature the caller authored. Sharing a signature lets a colleague
   * pick it, not destroy it, so one merely shared with the caller is refused —
   * as is one that does not exist, with the same answer.
   *
   * Mail already sent keeps the signature it carried, because the body was
   * composed at send time. An unsent EMAIL artifact still naming this signature
   * is refused at send until the sender picks another.
   */
  deleteMailboxSignature: Scalars['Boolean']['output'];
  /** Soft-delete a memory. ORGANIZATION memories require admin permissions. */
  deleteMemory: Memory;
  /**
   * Delete a set of producer information.
   * Admins may delete any PI in their agency; users may only delete their own user-level PI.
   */
  deleteProducerInformation: Scalars['Boolean']['output'];
  /** Soft-delete a bucket while preserving its event history. */
  deleteSmartFillBucket: Scalars['Boolean']['output'];
  /**
   * Convert an organization memory to a personal memory belonging to the caller.
   * Requires organization memory update permissions. The caller's personal memories
   * are returned unchanged so retries are safe; other users' personal memories are rejected.
   */
  demoteMemory: Memory;
  dialOutboundCall: OutboundCall;
  /** Disable an agency user from the current account */
  disableAgencyUser: AgencyUser;
  /**
   * Forget a connected mailbox: revoke the grant where the provider supports it
   * and delete the stored credentials. The send log survives.
   * Available with rollout off; subscription and resource permissions still apply.
   */
  disconnectMailbox: Scalars['Boolean']['output'];
  /** Dismisses the post-confirmation Standard sunset renewal banner for the agency. */
  dismissStandardSunsetRenewalBanner: AgencySubscription;
  /** Copy a design under a new name. The copy is never the default. */
  duplicateAgencyDesign: AgencyDesign;
  /** Enable an agency user from the current account */
  enableAgencyUser: AgencyUser;
  /**
   * Fit the latest document to its Design when its page layout is stale. Joins an active fit,
   * or replaces it when supersede is true. Returns the latest saved artifact and fit outcome
   * after a bounded wait; a pending fit continues independently of the caller.
   */
  ensureCaraWorkspaceArtifactFitsDesign: CaraWorkspaceArtifactRefitResult;
  /**
   * Convert a completed Cara agent message into an ephemeral Word, Excel, or PDF download.
   * The file is never persisted as a workspace artifact or agency file. Word and Excel are
   * returned inline as bytes; PDF returns a single-use URL rendered by the statics service.
   */
  exportCaraWorkspaceMessage: CaraWorkspaceMessageExport;
  extractSuperCopy: SuperCopyDraft;
  /**
   * Searches the agency's document-capable AMS integrations directly (live API
   * call) by account name, exact email, phone, or Applied Epic lookup code — the
   * fallback for when knowledge-graph search finds nothing. Name search returns
   * all matching candidates for explicit selection. Exact searches import the
   * single match and enqueue its background document import.
   */
  findAmsAccount: FindAmsAccountResult;
  /**
   * Live-searches the agency's document-capable AMS integrations for a policy by its
   * number (currently Applied Epic only) — the "Policies" mode fallback for when
   * knowledge-graph search finds nothing. On a hit the policy's owning account is
   * imported as a minimal entity and a background refresh is enqueued; the result is
   * that account (the picker lands on the account browse while it syncs).
   */
  findAmsPolicy: FindAmsAccountResult;
  /**
   * Generate up to 5 clarifying questions for the Convert-to-Preset wizard,
   * tailored to the selected workspaces' content. Runs one fast-model LLM call
   * synchronously and returns the questions (each with 2-4 selectable options and
   * a free-text fallback); it persists nothing. Gated by the
   * convert_workspace_to_preset_enabled Statsig flag.
   */
  generatePresetQuestions: Array<PresetClarifyingQuestion>;
  /**
   * The caller's general buckets for the workspace, generated from the
   * workspace's own contents when it has none. Pass a new operationId for each
   * attempt and call again with it until it completes. FORBIDDEN while the gate
   * is off.
   */
  generateSmartFillWorkspaceBucket: SmartFillBucketGeneration;
  /**
   * Share a custom preset with a federated child agency (read/run only, VIEWER role).
   * Requires CUSTOM_PRESET:SHARE on the owning agency, which only agency admins (and
   * platform admins) hold. The preset must be PUBLIC and not archived. The target
   * must be a FEDERATED_BILLING child agency. Idempotent: re-sharing an already-shared
   * preset returns the existing grant without error.
   */
  grantCustomPresetAccess: CustomPresetAccess;
  /**
   * Grant access to a knowledge base for another agency.
   * Only the owner of the knowledge base can grant access.
   * The target agency must be a child agency with FEDERATED_BILLING.
   */
  grantKnowledgeBaseAccess: KnowledgeBaseAccess;
  /**
   * Imports one AMS account by (integrationId, externalId) and enqueues its background
   * refresh, returning the local record. Account matching imports nothing, so a chosen
   * match needs this before its destinations can be listed.
   */
  importAmsAccountByExternalId: ImportAmsAccountResult;
  /**
   * Imports like importEmailAmsAccount, for pushing a sent email, with the authorization
   * of searchAmsAccountsForOutboundEmail.
   */
  importAmsAccountForOutboundEmail: EmailAmsChoice;
  /**
   * Makes sure an account searchEmailAmsAccounts found is known to Cara, so an email can
   * be logged to it. Reads it from the AMS when Cara hasn't synced it.
   */
  importEmailAmsAccount: EmailAmsChoice;
  /**
   * Records that the two clients are different, permanently. No later backfill run
   * re-raises the pair, though a person can still merge them by hand.
   */
  keepClientsSeparate: ClientMergeCandidate;
  learnSmartFillFromEdits: SmartFillLearningOperation;
  /**
   * Links an AMS account to a client, or refreshes the link when it already
   * exists. A client's first link becomes its primary, since an automated write
   * needs a defined target; later links take it only when asked.
   *
   * Refused for an integration that holds no AMS accounts, which is every CRM and
   * any integration no longer active.
   */
  linkClientAmsAccount: ClientAmsAccount;
  /**
   * Links a workspace to a client, returning the updated client.
   *
   * Idempotent: linking a workspace already linked to this client succeeds and
   * changes nothing. The schema permits a workspace under more than one client and
   * the resolver rejects it, so the one-client-per-workspace rule can be relaxed
   * later without a migration.
   *
   * replaceExisting re-files a workspace another client already holds, dropping
   * that link in the same transaction. It defaults to false so a caller has to mean
   * it: the workspace disappears from the other client's history.
   */
  linkClientWorkspace: Client;
  /**
   * Freeze a document version's look: the brand it renders with now is stored on the version,
   * which renders with it from then on. A version with no design is frozen with none. Marking a
   * version already final changes nothing.
   */
  markCaraWorkspaceArtifactFinal: CaraWorkspaceArtifact;
  /**
   * Merges the absorbed client into the survivor and returns the survivor.
   *
   * The absorbed client keeps its row but leaves every list, pointing at the
   * survivor so a stale id still resolves. Its workspaces, AMS accounts, users,
   * notes and documents move across; where both held the same association the
   * survivor's is kept. Attributes follow fields where given. Otherwise the
   * survivor keeps every value it has and takes the absorbed record's only where
   * its own is blank.
   *
   * A merge with any field given is stamped as asserted by the caller, which is
   * what stops the backfill overwriting the chosen values afterwards. A merge with
   * none leaves the survivor's provenance as it was.
   *
   * The pair itself is the record of the decision: a queued question about these
   * two clients is answered by the merge, and a pair nobody queued is recorded as
   * USER_SELECTED so the history finds it. An earlier KEPT_SEPARATE verdict on the
   * pair is overruled; the person merging has the last word.
   *
   * Authorized on the survivor alone. The two clients must belong to one agency,
   * which puts the absorbed client in the caller's agency too.
   */
  mergeClients: Client;
  /**
   * Merges every absorbed client into the survivor and returns the survivor. Each
   * is merged as mergeClients describes, in order, and all in one transaction: if
   * any one fails, nothing is merged.
   *
   * Authorized on the survivor alone, as mergeClients is.
   */
  mergeManyClients: Client;
  /** Move one or more documents into a cosmetic folder. Null folder means root. */
  moveKnowledgeBaseDocumentsToFolder: Array<KnowledgeBaseDocument>;
  /** Move a cosmetic folder under a new parent folder. Null parent means root. */
  moveKnowledgeBaseFolder: KnowledgeBase;
  /** Move selected documents and cosmetic folders into a cosmetic folder. Null folder means root. */
  moveKnowledgeBaseItemsToFolder: KnowledgeBase;
  pauseTriggerDefinition: TriggerDefinition;
  /**
   * Reads a document and reports which AMS account it concerns, importing nothing.
   * Detected identifiers are matched against the AMS live, since the knowledge graph
   * only knows synced accounts. A mutation because each call runs an LLM detection
   * and live AMS searches.
   */
  prepareAmsReconciliation: AmsReconciliationPrep;
  /**
   * Convert a personal memory to an organization memory in the caller's agency.
   * Requires organization memory update permissions. Already-organizational memories
   * are returned unchanged so retries are safe.
   */
  promoteMemory: Memory;
  /**
   * Logs a sent email to the AMS now, waiting for the AMS to answer. Only the email's
   * sender, or someone who manages the agency's mailboxes, may. Refused before anything is
   * written while the email is logged or being logged, or when Cara couldn't confirm an
   * earlier attempt and logAgainAnyway isn't set.
   */
  pushOutboundEmailToAms: PushOutboundEmailToAmsResult;
  /**
   * Ask the mailboxes what became of these drafts, and report what each one turned
   * out to be. This is how a draft an agent sent from their own mail client is
   * ever noticed: the provider drops it from the Drafts folder and tells nobody,
   * and only a Message-ID search against the mailbox can prove where it went.
   *
   * This writes: a draft found sent is retired and its send is filed on the
   * outbound log. It is safe to call repeatedly and from two tabs at once — a
   * repeat collides on an index rather than filing a second record.
   *
   * Read the list first, render it from what the ledger knows, then call this with
   * the ids on screen and settle each row as its result arrives.
   *
   * Name at most 50 drafts, the page size of the ledger lists. A longer list is
   * refused whole rather than truncated.
   *
   * Every draft named must be one the caller could already read through
   * `searchMailboxDrafts`. A draft that does not exist and one belonging to a
   * colleague's private workspace are refused identically, so this cannot be used
   * to test whether an id exists.
   *
   * Ordinary failure is per draft, not per call: a rate-limited mailbox comes back
   * as `UNREACHABLE` on its own rows, and a pass that runs out of time comes back
   * as `NOT_REACHED` on the rest, while every draft that was settled keeps its
   * answer.
   */
  reconcileMailboxDrafts: Array<MailboxDraftReconciliationResult>;
  recordSmartFillEvent: SmartFillEvent;
  /** Atomically records at most 100 attempts. INVALIDATED is terminal for an attempt. */
  recordSmartFillRetryEvidence: Scalars['Boolean']['output'];
  /** Reinstate the specified business insurance policy */
  reinstateBusinessPolicy: BusinessPolicy;
  /**
   * Removes a document from a client without touching the document itself. It stays
   * in its own workspace; this records that it is not relevant to this client, which
   * has to outlast the workspace link that would otherwise keep supplying it.
   *
   * Returns the client so the caller's cache updates from the response, matching
   * linkClientWorkspace below rather than making the caller refetch.
   */
  removeClientArtifact: Client;
  /** Removes a file from a client. See removeClientArtifact. */
  removeClientFile: Client;
  /** Removes an association between an account and a contact */
  removeContactAssociation: AccountContact;
  removeEmailBulkSendRecipients: EmailBulkSend;
  /** Removes a single user from a team. Admin-only. */
  removeTeamMember: Team;
  /** Rename a cosmetic folder inside a knowledge base. */
  renameKnowledgeBaseFolder: KnowledgeBase;
  /** Renew the specified business insurance policy */
  renewBusinessPolicy: BusinessPolicy;
  /**
   * Renew now: list this mailbox's folders again and renew or re-register its
   * subscriptions at once, instead of at the next scheduled renewal. Only the
   * owner may do this, regardless of admin scope. Returns the account once the
   * pass finishes or waiting times out; inspect monitoring for current health.
   */
  renewMailboxWatch: MailboxAccount;
  /**
   * Replace a document with a new version.
   * Creates a new document with the same documentGroupId, incremented version number,
   * and marks the old document as not the latest version.
   */
  replaceKnowledgeBaseDocument: KnowledgeBaseDocument;
  /**
   * Requests a background refresh of an account's data from the underlying AMS
   * (via the AmsAccountRefreshWorkflow; never a full-book sync). With force=false
   * the server only enqueues when the account is stale (older than the 1h
   * staleness window); with force=true it enqueues unless the account synced
   * within the last 60 seconds. Returns immediately — poll amsAccountSyncStatus.
   *
   * scope limits the refresh to one run; omitted, DOCUMENTS and STRUCTURED both
   * start. Pass STRUCTURED to read only policies and certificates, DESTINATIONS to
   * list only policies. An integration without scoped fetching refreshes fully under
   * any scope, reported through the DOCUMENTS status.
   */
  requestAmsAccountRefresh: RequestAmsAccountRefreshResult;
  /**
   * Move a SCHEDULED email to a new send time, or send it now. Only the human
   * who scheduled it may. Refused once its delivery has started, and while
   * scheduled sending is turned off.
   */
  rescheduleMailboxEmail: OutboundEmail;
  resolveCaraWorkspaceArtifactComment: CaraWorkspaceArtifactComment;
  /** Resolve a service request */
  resolveServiceRequest: ServiceRequest;
  /**
   * Resolve one live form against one bucket: user rules first, then a single
   * direct model call for the remaining destinations. Values are read from the
   * bucket and formatted server side; model-backed resolves persist the exact
   * prompt and decoded output as best-effort private evidence.
   */
  resolveSmartFill: SmartFillResolveResult;
  /**
   * Saves a new artifact version authored by the caller whose editable fields
   * hold what they held in version. Returns the latest version unchanged when
   * they already do. Fails with CONFLICT when baseVersion is no longer the
   * latest.
   */
  restoreTemplateFormVersion: CaraWorkspaceArtifact;
  resumeTriggerDefinition: TriggerDefinition;
  /**
   * Restore the bucket as it was before learning first changed it. Edits made
   * since then are discarded, and the field hints the caller learned from it are
   * removed unless they were edited later.
   */
  revertSmartFillBucketLearning: SmartFillBucket;
  /**
   * Un-share a custom preset from an agency. Requires CUSTOM_PRESET:SHARE on the
   * owning agency (admin-only). Cascades removal of the preset from the child
   * agency's users' favorites. Idempotent.
   */
  revokeCustomPresetAccess: Scalars['Boolean']['output'];
  /**
   * Revoke access to a knowledge base for an agency.
   * Only the owner of the knowledge base can revoke access.
   */
  revokeKnowledgeBaseAccess: Scalars['Boolean']['output'];
  /**
   * Runs an AMS reconciliation pass: extracts the source's document text against the
   * line of business's canonical schema, compares it field by field against the
   * policy's current AMS data, and returns the verdicts. Nothing is written or
   * persisted. A mutation because each call runs an LLM extraction and live AMS reads.
   */
  runAmsReconciliation: AmsReconciliationResult;
  /**
   * Saves edited template form fields as a new artifact version authored by the
   * caller. Fails with CONFLICT when baseVersion is no longer the latest.
   */
  saveTemplateFormFields: CaraWorkspaceArtifact;
  /**
   * Save the approved composition and queue its send on the server. Closing the
   * composer or browser does not cancel it. The returned sendAfter is the deadline
   * for cancelling this send explicitly.
   *
   * With sendAt, schedule it for that time instead (needs the
   * mailbox_scheduled_send_enabled gate). The email's Outlook draft is checked
   * first: one already sent from Outlook is recorded as sent and refused, and
   * nothing is scheduled if Outlook can't be reached.
   */
  scheduleMailboxEmail: ScheduleMailboxEmailResult;
  /**
   * Sends, schedules or saves to drafts every ready email of a bulk draft; held-back emails
   * stay drafts. Refused while any email is still being drafted, past 50, or past the
   * mailbox's daily bulk limit.
   */
  sendEmailBulkSend: EmailBulkSend;
  /**
   * Send an EMAIL artifact immediately from a connected mailbox. The composer
   * uses scheduleMailboxEmail for its cancellation window. Models only draft
   * EMAIL artifacts; both send mutations require an authenticated human's approval. artifactVersion and contentRevision together pin what the
   * caller was looking at — a send is refused when the artifact has been edited
   * since. Both are needed because they catch different edits: a revision from
   * Cara arrives as a new version, while a person editing the same draft in
   * another tab rewrites the version in place and only moves the content
   * revision.
   *
   * The mailbox must be one the caller may send as — theirs, or one shared with
   * them.
   */
  sendMailboxEmail: OutboundEmail;
  /**
   * Send the rest: sends or schedules, as a new round from the batch's mailbox, every email of a
   * sent batch that never went out and is ready, once its current round has nothing left to
   * send. Refused past the mailbox's daily bulk limit. Only the person who sent it may.
   */
  sendRestOfEmailBulkSend: EmailBulkSend;
  /**
   * Set the agency's overage dollar budget for a meter in the billing period.
   * Pass null or 0 for limitDollars to disallow overage. Takes effect immediately.
   */
  setAgencyMeterOverageLimit: AgencySubscription;
  /**
   * Set a user's platform-unit overage dollar budget for the billing period
   * (phased units after included is exhausted, at the overage rate).
   * Pass null or 0 for limitDollars to disallow per-user overage. Takes effect
   * immediately.
   */
  setAgencyUserOverageLimit: AgencyUser;
  /**
   * Render a document with another design, as a new version of it, which is returned. A null
   * designId means no design: the document prints with its template's own look when the template is
   * LEGACY, else the plain base, and with its template's own start and end pages. Refused for a
   * document linked to a Library Style: those keep the look the Style gives them.
   */
  setCaraWorkspaceArtifactDesign: CaraWorkspaceArtifact;
  /**
   * Make a design the one new documents start with, in place of the current default. A
   * document that names its design keeps it. Admins only.
   */
  setDefaultAgencyDesign: AgencyDesign;
  /**
   * Make a mailbox the one the caller's composer opens on. Only the mailbox's
   * owner may call this, whatever scope the caller holds, and a mailbox merely
   * shared with them is refused with the same answer as one that does not exist.
   *
   * Marking a second mailbox clears the first, so this is how the default moves
   * as well as how it is first set.
   */
  setDefaultMailbox: MailboxAccount;
  setIntegrationEmailLogPreference: Integration;
  /**
   * Turns logging of sent emails to this AMS on or off. Refused for an integration
   * that isn't an AMS, and while another of the agency's AMSes logs them.
   */
  setIntegrationLogsSentEmails: Integration;
  /**
   * Choose at least one folder to monitor. Only the owner may change this.
   * New messages are recorded outside Drafts; Drafts also reports edits and deletions.
   * Selecting a parent does not select its children.
   */
  setMailboxMonitoredFolders: MailboxAccount;
  /**
   * Monitoring is always on for a connected Outlook mailbox: enabled false is
   * refused with a validation error. Enabled true enables a legacy unmonitored
   * mailbox, then starts or joins maintenance. An already-enabled mailbox is
   * returned without changing its due time; maintenance may do nothing if it is
   * not due. Use renewMailboxWatch to request maintenance now. Only the owner
   * may call this, regardless of admin scope. A started workflow returns the
   * account even if waiting times out or monitoring needs owner action; inspect
   * monitoring for current health.
   */
  setMailboxMonitoring: MailboxAccount;
  /**
   * Choose whether update and delete notifications are processed for messages
   * Cara created. Only the owner may change this. These preferences do not
   * disable monitoring or change subscription scope; arrivals, placement
   * departures and explicit reconciliation are unaffected.
   */
  setMailboxMonitoringEvents: MailboxAccount;
  /**
   * Change who may send as a mailbox. Only the mailbox's owner may call this,
   * whatever scope the caller holds. PUBLIC makes the mailbox an agency-wide
   * address — everyone in the agency may send as it, including future hires.
   */
  setMailboxVisibility: MailboxAccount;
  /**
   * Sets the parent agency for an existing standalone agency, converting it into a subagency.
   * The agency must have no current parent. Only accessible by global admins.
   * The child agency's subscription will be reset to ENTERPRISE/ANNUAL with no Stripe billing.
   */
  setParentAgency: Agency;
  /** Moves the primary flag to this link, clearing it from whichever held it. */
  setPrimaryClientAmsAccount: ClientAmsAccount;
  /**
   * Starts exporting a table in the background. Refused with CONFLICT while the caller's export
   * of the table is still running, or when the agency is already building a few exports. A
   * subagency or all-subagencies filter is refused with BAD_REQUEST unless the agency has
   * subagency exports turned on.
   */
  startAdminAnalyticsExport: AdminAnalyticsExport;
  /**
   * Start generating a custom preset from one or more source workspaces. Creates
   * the preset in state GENERATING and starts GeneratePresetWorkflow in the same
   * transaction, so a Temporal failure rolls the preset back and surfaces a server
   * error rather than leaving a preset nothing will ever finish.
   *
   * Poll the returned preset with the customPreset query to follow progress: state
   * goes GENERATING -> READY or FAILED, and generation.step names the work in
   * flight. Gated by the convert_workspace_to_preset_enabled Statsig flag.
   */
  startPresetGeneration: CustomPreset;
  /** Start a trace analysis for a given trace. */
  startTraceAnalysis: TraceAnalysis;
  /** Stop a Cara workspace that is currently working (V2 only) */
  stopCaraWorkspace: CaraWorkspace;
  /** Submit call rating */
  submitCallRating: Feedback;
  /** Submit or update message rating (thumbs up/down) */
  submitMessageRating: Feedback;
  /**
   * Switch a confirmed email's sender, removing its old mailbox draft before saving
   * the new sender and optionally creating a replacement. Provider actions on this
   * email are excluded while it runs. Content edits remain possible; optimistic
   * revision checks can report a conflict after the old draft has been removed.
   */
  switchMailboxDraft: SwitchMailboxDraftResult;
  /** Sync an integration */
  syncIntegration?: Maybe<Integration>;
  /**
   * Manually trigger a sync for a URL-sourced document.
   * This runs immediately regardless of the scheduled frequency.
   */
  syncKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  undoSmartFillLearning: SmartFillLearningOperation;
  /**
   * Removes one link, reporting false for a pair the client does not hold. A
   * client left with exactly one link takes the primary flag, by the same rule
   * that gives it to a first link.
   */
  unlinkClientAmsAccount: Scalars['Boolean']['output'];
  /**
   * Unlinks a workspace from a client, returning the updated client. The workspace
   * itself is untouched and keeps all of its own content.
   *
   * Idempotent: unlinking a workspace that is not linked succeeds.
   */
  unlinkClientWorkspace: Client;
  /** Let a final version follow its design again. */
  unmarkCaraWorkspaceArtifactFinal: CaraWorkspaceArtifact;
  /** Updates an existing account */
  updateAccount: Account;
  /** Update an existing agency */
  updateAgency: Agency;
  /**
   * Replaces the brand of the agency's default design, creating a default design named
   * "Agency brand" when there is none. Rejects a typeface the renderer does not have,
   * because that choice would be undone silently at print time rather than reported.
   * @deprecated Use updateAgencyDesign.
   */
  updateAgencyBrand: AgencyBrand;
  /** Save a design. Documents that use it follow the change, except versions marked final. */
  updateAgencyDesign: AgencyDesign;
  /**
   * Replaces the guidelines Cara follows in every email it drafts for the caller's agency.
   * Blank guidelines are dropped; more than 10 others are refused.
   */
  updateAgencyEmailGuidelines: AgencyEmailConfiguration;
  /** Replaces a profile's configuration and assignments. Admin-only. */
  updateAgencyProfile: AgencyProfile;
  /** Update the roles of an agency user */
  updateAgencyUser: AgencyUser;
  /** Updates the preferences for the current agency user */
  updateAgencyUserPreferences: AgencyUser;
  /** Update the specified business insurance policy */
  updateBusinessPolicy: BusinessPolicy;
  /** Update multiple calls */
  updateCalls: Array<Call>;
  updateCaraWorkspaceArtifact: CaraWorkspaceArtifact;
  /**
   * Applies one update to every named artifact, across workspaces, and returns
   * their summaries afterwards. All or nothing: an id the caller cannot read,
   * whether cross-agency, hidden by visibility, or nonexistent, fails the whole
   * call as "artifact not found". Bounded like `CaraWorkspaceArtifactFilter.ids`.
   * Agency-scoped because a selection spans workspaces; each artifact's workspace
   * is checked inside.
   */
  updateCaraWorkspaceArtifacts: Array<CaraWorkspaceArtifactSummary>;
  /** Update multiple Cara workspaces */
  updateCaraWorkspaces: Array<CaraWorkspace>;
  updateClient: Client;
  /** Rewrites the body. Only the body is mutable; author and client are fixed. */
  updateClientNote: ClientNote;
  /** Updates an existing account contact */
  updateContact: AccountContact;
  updateCustomForm: CustomForm;
  /** Update a custom preset */
  updateCustomPreset: CustomPreset;
  /** Update multiple custom presets (e.g. archiving) */
  updateCustomPresets: Array<CustomPreset>;
  /**
   * Saves the input as a new version. Refused with CONFLICT when the template has changed
   * since expectedVersion was read.
   */
  updateEmailTemplate: EmailTemplate;
  /** Update an Excel spreadsheet template */
  updateExcelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** Update multiple Excel spreadsheet templates (e.g. archiving or changing visibility) */
  updateExcelSpreadsheetTemplates: Array<ExcelSpreadsheetTemplate>;
  /** Update a HTML document template */
  updateHtmlDocumentTemplate: HtmlDocumentTemplate;
  /** Update multiple HTML document templates (e.g. archiving) */
  updateHtmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** Update an integration */
  updateIntegration: Integration;
  /** Update a knowledge base by its ID */
  updateKnowledgeBase?: Maybe<KnowledgeBase>;
  /**
   * Update access role for an agency on a knowledge base.
   * Only the owner of the knowledge base can update access.
   */
  updateKnowledgeBaseAccess: KnowledgeBaseAccess;
  /** Update a document by its ID */
  updateKnowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Update settings for a URL-sourced document (frequency, pause/resume). */
  updateKnowledgeBaseURLDocument: KnowledgeBaseDocument;
  /** Update the timestamp of the last viewed new features modal */
  updateLastViewedNewFeatures: Scalars['Time']['output'];
  /** Update a memory. ORGANIZATION memories require admin permissions. */
  updateMemory: Memory;
  updateOutboundCall: OutboundCall;
  /**
   * Update an existing set of producer information.
   * Admins may update any PI in their agency; users may only update their own user-level PI.
   */
  updateProducerInformation: ProducerInformation;
  /** Update a service request */
  updateServiceRequest: ServiceRequest;
  updateSmartFillBucket: SmartFillBucket;
  /** Updates the subscription for the current account */
  updateSubscription: AgencySubscription;
  /** Updates an existing team's name, description, or full member list. Admin-only. */
  updateTeam: Team;
  updateTriggerDefinition: TriggerDefinition;
  /** Update a voice agent */
  updateVoiceAgent: VoiceAgent;
  /** Update a Word document template */
  updateWordDocumentTemplate: WordDocumentTemplate;
  /** Update multiple Word document templates */
  updateWordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Update an existing workflow definition (creates a new version). Scoped
   * via the WORKFLOW_DEFINITION being updated so the directive denies
   * cross-agency edits.
   */
  updateWorkflowDefinition: WorkflowDefinition;
  /** Upload a file associated with an account */
  uploadAccountFile: File;
  /**
   * Store a logo for a design's brand. The file is returned; the `logos` list is set when
   * the design is saved, which is where the variant is chosen.
   */
  uploadAgencyBrandLogo: File;
  /**
   * Store a PDF to print before or after the documents that use a design. The file is
   * returned; a design's includedPages are set when the design is saved.
   */
  uploadAgencyDesignPage: File;
  uploadCustomForm: CustomForm;
  /** Upload a file associated with an HTML document template */
  uploadHtmlDocumentTemplateFile: File;
  /** Update a document by its ID */
  uploadKnowledgeBaseFileDocument: Array<KnowledgeBaseDocument>;
  /** Upload a file associated with a policy */
  uploadPolicyFile: File;
  /** Upload a file associated with a workspace */
  uploadWorkspaceFile: File;
  /** Create a signature, or edit one the caller authored. */
  upsertMailboxSignature: MailboxSignature;
  upsertSmartFillOverride: SmartFillOverride;
};


export type MutationAccountUserSignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationAddCaraWorkspaceArtifactCommentArgs = {
  artifactId: Scalars['ID']['input'];
  input: CaraWorkspaceArtifactCommentInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationAddCaraWorkspaceMessageArgs = {
  id: Scalars['ID']['input'];
  input: CaraWorkspaceMessageInput;
};


export type MutationAddClientArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationAddClientFileArgs = {
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationAddContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationAddEmailBulkSendRecipientsArgs = {
  id: Scalars['ID']['input'];
  recipients: Array<EmailBulkSendRecipientInput>;
};


export type MutationAddServiceRequestCommentArgs = {
  id: Scalars['ID']['input'];
  input: AddServiceRequestCommentInput;
};


export type MutationAddTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationAgencySignInArgs = {
  code?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
};


export type MutationAnswerSmartFillFormBucketArgs = {
  answers: Array<SmartFillFormAnswerInput>;
  bucketId: Scalars['ID']['input'];
  carrierSiteId?: InputMaybe<Scalars['ID']['input']>;
  expectedRevision: Scalars['Int64']['input'];
};


export type MutationApplyAmsReconciliationArgs = {
  input: ApplyAmsReconciliationInput;
};


export type MutationApplySmartFillLearningArgs = {
  entryIds: Array<Scalars['ID']['input']>;
  operationId: Scalars['ID']['input'];
};


export type MutationArchiveAgencyDesignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveAgencyProfileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveOutboundCallsArgs = {
  ids: Array<Scalars['ID']['input']>;
};


export type MutationArchiveTeamArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveTriggerDefinitionArgs = {
  id: Scalars['ID']['input'];
};


export type MutationArchiveWordDocumentTemplatesArgs = {
  input: ArchiveWordDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationBuildHtmlDocumentRenderUrlArgs = {
  input: BuildHtmlDocumentRenderUrlInput;
};


export type MutationCancelBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: CancelBusinessPolicyInput;
};


export type MutationCancelEmailBulkSendArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelMailboxEmailArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCancelMailboxEmailPreparationArgs = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  attemptId: Scalars['String']['input'];
};


export type MutationCancelOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationChangeEmailBulkSendTimeArgs = {
  id: Scalars['ID']['input'];
  input: ChangeEmailBulkSendTimeInput;
};


export type MutationChooseSmartFillOptionArgs = {
  input: ChooseSmartFillOptionInput;
};


export type MutationClearSmartFillOverridesArgs = {
  fieldKey: Scalars['String']['input'];
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
};


export type MutationClientCreateCertificateArgs = {
  accountId: Scalars['ID']['input'];
  input: ClientCreateCertificateInput;
};


export type MutationConfirmClientFieldArgs = {
  clientId: Scalars['ID']['input'];
  field: ClientField;
  value: Scalars['String']['input'];
};


export type MutationConvertAcordArtifactsToSmartFillBucketArgs = {
  artifactIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  operationId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationConvertWorkspaceToSmartFillBucketsArgs = {
  operationId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateAccountArgs = {
  input: CreateAccountInput;
};


export type MutationCreateAdminAnalyticsExportDownloadUrlArgs = {
  id: Scalars['ID']['input'];
};


export type MutationCreateAdminSignInCodeArgs = {
  agencyId: Scalars['ID']['input'];
  agencyUserId?: InputMaybe<Scalars['ID']['input']>;
  expiresInSeconds?: InputMaybe<Scalars['Int']['input']>;
};


export type MutationCreateAgencyArgs = {
  input: CreateAgencyInput;
};


export type MutationCreateAgencyDesignArgs = {
  input: AgencyDesignInput;
};


export type MutationCreateAgencyProducerInformationArgs = {
  agencyId: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationCreateAgencyProfileArgs = {
  input: CreateAgencyProfileInput;
};


export type MutationCreateAgencyUserArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  input: AgencyUserInput;
};


export type MutationCreateAgencyUserProducerInformationArgs = {
  agencyUserId: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationCreateAgencyUsersArgs = {
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  inputs: Array<AgencyUserImportInput>;
};


export type MutationCreateAmsAccountArgs = {
  input: CreateAmsAccountInput;
};


export type MutationCreateBusinessPoliciesArgs = {
  req: CreateBusinessPoliciesInput;
};


export type MutationCreateCaraWorkspaceArgs = {
  input: CaraWorkspaceMessageInput;
};


export type MutationCreateCertificateArgs = {
  input: CreateCertificateInput;
};


export type MutationCreateClientArgs = {
  input: ClientInput;
};


export type MutationCreateClientNoteArgs = {
  body: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationCreateContactArgs = {
  input: CreateAccountContactInput;
};


export type MutationCreateCustomPresetArgs = {
  input: CustomPresetInput;
};


export type MutationCreateEmailTemplateArgs = {
  input: EmailTemplateInput;
};


export type MutationCreateExcelSpreadsheetTemplateArgs = {
  input: ExcelSpreadsheetTemplateInput;
};


export type MutationCreateHtmlDocumentRenderGrantArgs = {
  artifactId: Scalars['ID']['input'];
  styleId?: InputMaybe<Scalars['String']['input']>;
  version: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationCreateHtmlDocumentTemplateArgs = {
  input: HtmlDocumentTemplateInput;
};


export type MutationCreateHtmlDocumentTemplateFromStarterArgs = {
  input: CreateHtmlDocumentTemplateFromStarterInput;
};


export type MutationCreateIntegrationArgs = {
  input: CreateIntegrationInput;
};


export type MutationCreateKnowledgeBaseFolderArgs = {
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationCreateKnowledgeBaseTextDocumentArgs = {
  input: CreateKnowledgeBaseTextDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationCreateKnowledgeBaseUrlDocumentArgs = {
  input: CreateKnowledgeBaseUrlDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationCreateMailboxDraftArgs = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision?: InputMaybe<Scalars['String']['input']>;
  mailboxAccountId: Scalars['String']['input'];
};


export type MutationCreateMemoryArgs = {
  input: CreateMemoryInput;
};


export type MutationCreateOutboundCallArgs = {
  input: CreateOutboundCallInput;
};


export type MutationCreateServiceRequestArgs = {
  input: CreateServiceRequestInput;
};


export type MutationCreateSmartFillBucketArgs = {
  input: CreateSmartFillBucketInput;
};


export type MutationCreateTeamArgs = {
  input: TeamInput;
};


export type MutationCreateTriggerDefinitionArgs = {
  input: CreateTriggerDefinitionInput;
};


export type MutationCreateVoiceAgentArgs = {
  input: CreateVoiceAgentInput;
};


export type MutationCreateWordDocumentTemplateArgs = {
  input: WordDocumentTemplateInput;
};


export type MutationCreateWorkflowDefinitionArgs = {
  input: CreateWorkflowDefinitionInput;
};


export type MutationCreateWorkflowExecutionArgs = {
  input: CreateWorkflowExecutionInput;
};


export type MutationDeleteAgencyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteCaraWorkspaceArtifactCommentArgs = {
  commentId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationDeleteClientArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteClientNoteArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFeedbackArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteFileArgs = {
  fileId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationDeleteKnowledgeBaseItemsArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationDeleteMailboxSignatureArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteProducerInformationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteSmartFillBucketArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDemoteMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDialOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDisconnectMailboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDuplicateAgencyDesignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnableAgencyUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEnsureCaraWorkspaceArtifactFitsDesignArgs = {
  artifactId: Scalars['String']['input'];
  supersede?: InputMaybe<Scalars['Boolean']['input']>;
};


export type MutationExportCaraWorkspaceMessageArgs = {
  input: ExportCaraWorkspaceMessageInput;
};


export type MutationExtractSuperCopyArgs = {
  input: ExtractSuperCopyInput;
};


export type MutationFindAmsAccountArgs = {
  query: Scalars['String']['input'];
};


export type MutationFindAmsPolicyArgs = {
  query: Scalars['String']['input'];
};


export type MutationGeneratePresetQuestionsArgs = {
  input: GeneratePresetQuestionsInput;
};


export type MutationGenerateSmartFillWorkspaceBucketArgs = {
  operationId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationGrantCustomPresetAccessArgs = {
  agencyId: Scalars['ID']['input'];
  customPresetId: Scalars['ID']['input'];
};


export type MutationGrantKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
};


export type MutationImportAmsAccountByExternalIdArgs = {
  input: ImportAmsAccountByExternalIdInput;
};


export type MutationImportAmsAccountForOutboundEmailArgs = {
  account: AmsRefInput;
  outboundEmailId: Scalars['ID']['input'];
};


export type MutationImportEmailAmsAccountArgs = {
  account: AmsRefInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationKeepClientsSeparateArgs = {
  candidateId: Scalars['ID']['input'];
};


export type MutationLearnSmartFillFromEditsArgs = {
  input: LearnSmartFillFromEditsInput;
};


export type MutationLinkClientAmsAccountArgs = {
  clientId: Scalars['ID']['input'];
  input: ClientAmsAccountInput;
  isPrimary?: Scalars['Boolean']['input'];
};


export type MutationLinkClientWorkspaceArgs = {
  clientId: Scalars['ID']['input'];
  replaceExisting?: Scalars['Boolean']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationMarkCaraWorkspaceArtifactFinalArgs = {
  artifactId: Scalars['String']['input'];
  includeDesignPages?: InputMaybe<Scalars['Boolean']['input']>;
  version: Scalars['Int']['input'];
};


export type MutationMergeClientsArgs = {
  input: ClientMergeInput;
};


export type MutationMergeManyClientsArgs = {
  input: ClientGroupMergeInput;
};


export type MutationMoveKnowledgeBaseDocumentsToFolderArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationMoveKnowledgeBaseItemsToFolderArgs = {
  documentIds: Array<Scalars['ID']['input']>;
  folderId?: InputMaybe<Scalars['String']['input']>;
  folderIds: Array<Scalars['String']['input']>;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationPauseTriggerDefinitionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
};


export type MutationPrepareAmsReconciliationArgs = {
  input: PrepareAmsReconciliationInput;
};


export type MutationPromoteMemoryArgs = {
  id: Scalars['ID']['input'];
};


export type MutationPushOutboundEmailToAmsArgs = {
  id: Scalars['ID']['input'];
  input: PushOutboundEmailToAmsInput;
};


export type MutationReconcileMailboxDraftsArgs = {
  mailboxDraftIds: Array<Scalars['ID']['input']>;
};


export type MutationRecordSmartFillEventArgs = {
  input: RecordSmartFillEventInput;
};


export type MutationRecordSmartFillRetryEvidenceArgs = {
  input: Array<SmartFillRetryEvidenceInput>;
};


export type MutationReinstateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: ReinstateBusinessPolicyInput;
};


export type MutationRemoveClientArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  clientId: Scalars['ID']['input'];
};


export type MutationRemoveClientFileArgs = {
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
};


export type MutationRemoveContactAssociationArgs = {
  accountId: Scalars['String']['input'];
  contactId: Scalars['String']['input'];
};


export type MutationRemoveEmailBulkSendRecipientsArgs = {
  id: Scalars['ID']['input'];
  recipientIds: Array<Scalars['String']['input']>;
};


export type MutationRemoveTeamMemberArgs = {
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
};


export type MutationRenameKnowledgeBaseFolderArgs = {
  folderId: Scalars['String']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
};


export type MutationRenewBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: RenewBusinessPolicyInput;
};


export type MutationRenewMailboxWatchArgs = {
  id: Scalars['ID']['input'];
};


export type MutationReplaceKnowledgeBaseDocumentArgs = {
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
};


export type MutationRequestAmsAccountRefreshArgs = {
  accountId: Scalars['ID']['input'];
  force?: Scalars['Boolean']['input'];
  scope?: InputMaybe<AmsAccountSyncScope>;
};


export type MutationRescheduleMailboxEmailArgs = {
  id: Scalars['ID']['input'];
  input: RescheduleMailboxEmailInput;
};


export type MutationResolveCaraWorkspaceArtifactCommentArgs = {
  commentId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationResolveServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: ResolveServiceRequestInput;
};


export type MutationResolveSmartFillArgs = {
  input: ResolveSmartFillInput;
};


export type MutationRestoreTemplateFormVersionArgs = {
  artifactId: Scalars['ID']['input'];
  baseVersion: Scalars['Int']['input'];
  version: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationResumeTriggerDefinitionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
};


export type MutationRevertSmartFillBucketLearningArgs = {
  expectedRevision: Scalars['Int64']['input'];
  id: Scalars['ID']['input'];
};


export type MutationRevokeCustomPresetAccessArgs = {
  agencyId: Scalars['ID']['input'];
  customPresetId: Scalars['ID']['input'];
};


export type MutationRevokeKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationRunAmsReconciliationArgs = {
  input: RunAmsReconciliationInput;
};


export type MutationSaveTemplateFormFieldsArgs = {
  artifactId: Scalars['ID']['input'];
  baseVersion: Scalars['Int']['input'];
  fields: Array<TemplateFormFieldEditInput>;
  workspaceId: Scalars['ID']['input'];
};


export type MutationScheduleMailboxEmailArgs = {
  input: ScheduleMailboxEmailInput;
};


export type MutationSendEmailBulkSendArgs = {
  id: Scalars['ID']['input'];
  input: SendEmailBulkSendInput;
};


export type MutationSendMailboxEmailArgs = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision: Scalars['String']['input'];
  mailboxAccountId: Scalars['String']['input'];
};


export type MutationSendRestOfEmailBulkSendArgs = {
  id: Scalars['ID']['input'];
  input: SendRestOfEmailBulkSendInput;
};


export type MutationSetAgencyMeterOverageLimitArgs = {
  agencyId: Scalars['ID']['input'];
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
  meterCode: ConsumptionMeterCode;
};


export type MutationSetAgencyUserOverageLimitArgs = {
  agencyUserId: Scalars['ID']['input'];
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
};


export type MutationSetCaraWorkspaceArtifactDesignArgs = {
  artifactId: Scalars['String']['input'];
  designId?: InputMaybe<Scalars['String']['input']>;
};


export type MutationSetDefaultAgencyDesignArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetDefaultMailboxArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSetIntegrationEmailLogPreferenceArgs = {
  id: Scalars['ID']['input'];
  input: EmailAmsLogPreferenceInput;
};


export type MutationSetIntegrationLogsSentEmailsArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetMailboxMonitoredFoldersArgs = {
  folderIds: Array<Scalars['ID']['input']>;
  id: Scalars['ID']['input'];
};


export type MutationSetMailboxMonitoringArgs = {
  enabled: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};


export type MutationSetMailboxMonitoringEventsArgs = {
  id: Scalars['ID']['input'];
  processDeletes: Scalars['Boolean']['input'];
  processUpdates: Scalars['Boolean']['input'];
};


export type MutationSetMailboxVisibilityArgs = {
  id: Scalars['ID']['input'];
  visibility: VisibilityConfigInput;
};


export type MutationSetParentAgencyArgs = {
  agencyId: Scalars['ID']['input'];
  numSeats: Scalars['Int']['input'];
  numVoiceAgents: Scalars['Int']['input'];
  parentAgencyId: Scalars['ID']['input'];
};


export type MutationSetPrimaryClientAmsAccountArgs = {
  amsExternalId: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type MutationStartAdminAnalyticsExportArgs = {
  input: StartAdminAnalyticsExportInput;
};


export type MutationStartPresetGenerationArgs = {
  input: StartPresetGenerationInput;
};


export type MutationStartTraceAnalysisArgs = {
  traceId: Scalars['ID']['input'];
};


export type MutationStopCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSubmitCallRatingArgs = {
  input: SubmitCallRatingInput;
};


export type MutationSubmitMessageRatingArgs = {
  input: SubmitMessageRatingInput;
};


export type MutationSwitchMailboxDraftArgs = {
  input: SwitchMailboxDraftInput;
};


export type MutationSyncIntegrationArgs = {
  id: Scalars['ID']['input'];
};


export type MutationSyncKnowledgeBaseUrlDocumentArgs = {
  id: Scalars['ID']['input'];
};


export type MutationUndoSmartFillLearningArgs = {
  entryIds: Array<Scalars['ID']['input']>;
  operationId: Scalars['ID']['input'];
};


export type MutationUnlinkClientAmsAccountArgs = {
  amsExternalId: Scalars['String']['input'];
  clientId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
};


export type MutationUnlinkClientWorkspaceArgs = {
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationUnmarkCaraWorkspaceArtifactFinalArgs = {
  artifactId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
};


export type MutationUpdateAccountArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
};


export type MutationUpdateAgencyArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgencyInput;
};


export type MutationUpdateAgencyBrandArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  input: UpdateAgencyBrandInput;
};


export type MutationUpdateAgencyDesignArgs = {
  id: Scalars['ID']['input'];
  input: AgencyDesignInput;
};


export type MutationUpdateAgencyEmailGuidelinesArgs = {
  guidelines: Array<Scalars['String']['input']>;
};


export type MutationUpdateAgencyProfileArgs = {
  id: Scalars['ID']['input'];
  input: AgencyProfileInput;
};


export type MutationUpdateAgencyUserArgs = {
  id: Scalars['ID']['input'];
  input: UpdateAgencyUserInput;
};


export type MutationUpdateAgencyUserPreferencesArgs = {
  input: AgencyUserPreferencesInput;
};


export type MutationUpdateBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
  req: UpdateBusinessPolicyInput;
};


export type MutationUpdateCallsArgs = {
  callIds: Array<Scalars['ID']['input']>;
  input: UpdateCallInput;
};


export type MutationUpdateCaraWorkspaceArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  input: UpdateCaraWorkspaceArtifactInput;
  version: Scalars['Int']['input'];
  workspaceId: Scalars['ID']['input'];
};


export type MutationUpdateCaraWorkspaceArtifactsArgs = {
  artifactIds: Array<Scalars['ID']['input']>;
  input: UpdateCaraWorkspaceArtifactsInput;
};


export type MutationUpdateCaraWorkspacesArgs = {
  input: UpdateCaraWorkspaceInput;
  workspaceIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateClientArgs = {
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
};


export type MutationUpdateClientNoteArgs = {
  body: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};


export type MutationUpdateContactArgs = {
  id: Scalars['ID']['input'];
  input: CreateAccountContactInput;
};


export type MutationUpdateCustomFormArgs = {
  id: Scalars['ID']['input'];
  input: UpdateCustomFormInput;
};


export type MutationUpdateCustomPresetArgs = {
  id: Scalars['ID']['input'];
  input: CustomPresetInput;
};


export type MutationUpdateCustomPresetsArgs = {
  input: UpdateCustomPresetsInput;
  presetIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateEmailTemplateArgs = {
  expectedVersion: Scalars['Int64']['input'];
  id: Scalars['ID']['input'];
  input: EmailTemplateInput;
};


export type MutationUpdateExcelSpreadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
  input: ExcelSpreadsheetTemplateInput;
};


export type MutationUpdateExcelSpreadsheetTemplatesArgs = {
  input: UpdateExcelSpreadsheetTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  input: HtmlDocumentTemplateInput;
};


export type MutationUpdateHtmlDocumentTemplatesArgs = {
  input: UpdateHtmlDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateIntegrationArgs = {
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
};


export type MutationUpdateKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseInput;
};


export type MutationUpdateKnowledgeBaseAccessArgs = {
  agencyId: Scalars['ID']['input'];
  knowledgeBaseId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
};


export type MutationUpdateKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseDocumentInput;
};


export type MutationUpdateKnowledgeBaseUrlDocumentArgs = {
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseUrlDocumentInput;
};


export type MutationUpdateMemoryArgs = {
  input: UpdateMemoryInput;
};


export type MutationUpdateOutboundCallArgs = {
  id: Scalars['ID']['input'];
  input: UpdateOutboundCallInput;
};


export type MutationUpdateProducerInformationArgs = {
  id: Scalars['ID']['input'];
  input: ProducerInformationInput;
};


export type MutationUpdateServiceRequestArgs = {
  id: Scalars['ID']['input'];
  input: UpdateServiceRequestInput;
};


export type MutationUpdateSmartFillBucketArgs = {
  id: Scalars['ID']['input'];
  input: UpdateSmartFillBucketInput;
};


export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


export type MutationUpdateTeamArgs = {
  id: Scalars['ID']['input'];
  input: TeamInput;
};


export type MutationUpdateTriggerDefinitionArgs = {
  input: UpdateTriggerDefinitionInput;
};


export type MutationUpdateVoiceAgentArgs = {
  id: Scalars['ID']['input'];
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
  input: VoiceAgentInput;
  transferDirectoryChanges?: InputMaybe<Array<TransferDirectoryChangeInput>>;
};


export type MutationUpdateWordDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
  input: WordDocumentTemplateInput;
};


export type MutationUpdateWordDocumentTemplatesArgs = {
  input: UpdateWordDocumentTemplatesInput;
  templateIds: Array<Scalars['ID']['input']>;
};


export type MutationUpdateWorkflowDefinitionArgs = {
  input: UpdateWorkflowDefinitionInput;
};


export type MutationUploadAccountFileArgs = {
  accountId: Scalars['ID']['input'];
  file: UploadFileInput;
};


export type MutationUploadAgencyBrandLogoArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  file: UploadFileInput;
};


export type MutationUploadAgencyDesignPageArgs = {
  file: UploadFileInput;
};


export type MutationUploadCustomFormArgs = {
  input: UploadCustomFormInput;
};


export type MutationUploadHtmlDocumentTemplateFileArgs = {
  file: UploadFileInput;
  templateId: Scalars['ID']['input'];
};


export type MutationUploadKnowledgeBaseFileDocumentArgs = {
  input: UploadKnowledgeBaseFileDocumentInput;
  knowledgeBaseId: Scalars['ID']['input'];
};


export type MutationUploadPolicyFileArgs = {
  file: UploadFileInput;
  policyId: Scalars['ID']['input'];
};


export type MutationUploadWorkspaceFileArgs = {
  file: UploadFileInput;
  workspaceId: Scalars['ID']['input'];
};


export type MutationUpsertMailboxSignatureArgs = {
  input: MailboxSignatureInput;
};


export type MutationUpsertSmartFillOverrideArgs = {
  input: UpsertSmartFillOverrideInput;
};

/** A named additional insured for the certificate */
export type NamedAdditionalInsuredCertificateOption = {
  __typename?: 'NamedAdditionalInsuredCertificateOption';
  /** The address of the named additional insured */
  address: Address;
  /** The ID of the named additional insured */
  id: Scalars['ID']['output'];
  /** The name of the named additional insured */
  name: Scalars['String']['output'];
  /** The policy this named additional insured is associated with */
  policy: BusinessPolicy;
};

/**
 * One entry in the sidebar a profile can show or hide. Values name a page, or a
 * tab within a page, and correspond one-for-one to the navigation the AIS app
 * renders — `navigation.test.tsx` fails when the two drift apart.
 */
export enum NavigationItem {
  /** Communication › Calls */
  Calls = 'CALLS',
  /** Communication › Calls › Inbound */
  CallsInbound = 'CALLS_INBOUND',
  /** Communication › Calls › Outbound */
  CallsOutbound = 'CALLS_OUTBOUND',
  /** Communication › Calls › Report */
  CallsReport = 'CALLS_REPORT',
  /** Knowledge › Clients */
  Clients = 'CLIENTS',
  /** Copilot › Documents */
  Documents = 'DOCUMENTS',
  /** Communication › Mailbox › Inbox */
  Emails = 'EMAILS',
  /** Knowledge › Knowledge Base */
  KnowledgeBase = 'KNOWLEDGE_BASE',
  /** Copilot › Library › Custom Forms */
  LibraryCustomForms = 'LIBRARY_CUSTOM_FORMS',
  /** Copilot › Library › Excel Templates */
  LibraryExcelTemplates = 'LIBRARY_EXCEL_TEMPLATES',
  /** Copilot › Library › Styles */
  LibraryStyles = 'LIBRARY_STYLES',
  /** Copilot › Library › Templates */
  LibraryTemplates = 'LIBRARY_TEMPLATES',
  /** Copilot › Library › Word Templates */
  LibraryWordTemplates = 'LIBRARY_WORD_TEMPLATES',
  /** Communication › Mailbox › Outgoing */
  MailboxOutgoing = 'MAILBOX_OUTGOING',
  /** Copilot › Presets */
  Presets = 'PRESETS',
  /** Servicing › Service Requests */
  Servicing = 'SERVICING',
  /** Settings › Integrations */
  SettingsIntegrations = 'SETTINGS_INTEGRATIONS',
  /** Settings › Mailboxes */
  SettingsMailboxes = 'SETTINGS_MAILBOXES',
  /** Settings › Memory */
  SettingsMemory = 'SETTINGS_MEMORY',
  /** Settings › Teams */
  SettingsTeams = 'SETTINGS_TEAMS',
  /** Settings › Voice AI */
  SettingsVoice = 'SETTINGS_VOICE',
  /** Copilot › Workspaces */
  Workspaces = 'WORKSPACES'
}

/** Notification settings for the agency */
export type NotificationSettings = {
  __typename?: 'NotificationSettings';
  /** Whether to send notifications when a new call is created */
  enableNewCallNotifications: Scalars['Boolean']['output'];
  /** Whether to send notifications when a new service request is created */
  enableNewServiceRequestNotifications: Scalars['Boolean']['output'];
  /** Email addresses to send new call notifications to */
  newCallNotificationEmailRecipients: Array<Scalars['String']['output']>;
  /** Email addresses to send new service request notifications to */
  newServiceRequestNotificationEmailRecipients: Array<Scalars['String']['output']>;
};

export type NowCertsCallFields = {
  __typename?: 'NowCertsCallFields';
  action?: Maybe<Scalars['String']['output']>;
  callLogId?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['String']['output']>;
  fromName?: Maybe<Scalars['String']['output']>;
  fromNumber?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  result?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  toName?: Maybe<Scalars['String']['output']>;
  toNumber?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NowCertsClaimFields = {
  __typename?: 'NowCertsClaimFields';
  additionalComments?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  claimNumber?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateAmount?: Maybe<Array<NowCertsDateAmount>>;
  dateOfLoss?: Maybe<Scalars['String']['output']>;
  describeLocation?: Maybe<Scalars['String']['output']>;
  descriptionOfLoss?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  policeOrFire?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  reportNumber?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** NowCertsConfiguration contains configuration for the NowCerts integration */
export type NowCertsConfiguration = {
  __typename?: 'NowCertsConfiguration';
  /** If enabled, will sync accounts from Cara to NowCerts. */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * If omitted or blank, no referral source will be set.
   */
  prospectReferralSource?: Maybe<Scalars['String']['output']>;
  /** NowCerts username for basic authentication */
  username: Scalars['String']['output'];
};

export type NowCertsCustomFieldSimple = {
  __typename?: 'NowCertsCustomFieldSimple';
  text?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type NowCertsDateAmount = {
  __typename?: 'NowCertsDateAmount';
  amount?: Maybe<Scalars['Float']['output']>;
  date?: Maybe<Scalars['String']['output']>;
};

export type NowCertsDriverFields = {
  __typename?: 'NowCertsDriverFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  cdlDate?: Maybe<Scalars['String']['output']>;
  cdlYear?: Maybe<Scalars['Int']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  companyDriverNumber?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverAddressState?: Maybe<Scalars['String']['output']>;
  driverLicenseClass?: Maybe<Scalars['String']['output']>;
  driverLicenseStatusCode?: Maybe<Scalars['String']['output']>;
  driverOccupations?: Maybe<Array<Scalars['String']['output']>>;
  driverTypeCode?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  excluded?: Maybe<Scalars['Boolean']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  hireDate?: Maybe<Scalars['String']['output']>;
  industryName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  licenseYear?: Maybe<Scalars['Int']['output']>;
  licensedDate?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  occupationClassCode?: Maybe<Scalars['String']['output']>;
  occupationDesc?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  terminationDate?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsFileFields = {
  __typename?: 'NowCertsFileFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  folderId?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  visibleToInsured?: Maybe<Scalars['Boolean']['output']>;
};

export type NowCertsInsuredFields = {
  __typename?: 'NowCertsInsuredFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coInsuredDateOfBirth?: Maybe<Scalars['String']['output']>;
  coInsuredFirstName?: Maybe<Scalars['String']['output']>;
  coInsuredLastName?: Maybe<Scalars['String']['output']>;
  coInsuredMiddleName?: Maybe<Scalars['String']['output']>;
  commercialName?: Maybe<Scalars['String']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  customFieldsSimple?: Maybe<Array<NowCertsCustomFieldSimple>>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  email2?: Maybe<Scalars['String']['output']>;
  email3?: Maybe<Scalars['String']['output']>;
  fax?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greetingName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredId?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Array<Scalars['String']['output']>>;
  middleName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  preferredLanguage?: Maybe<Scalars['String']['output']>;
  primaryAgencyOfficeLocationName?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  sicCode?: Maybe<Scalars['String']['output']>;
  smsPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeOfBusiness?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  xDatesAndLinesOfBusiness?: Maybe<Array<NowCertsXDateAndLineOfBusiness>>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsNoteFields = {
  __typename?: 'NowCertsNoteFields';
  body?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  hide?: Maybe<Scalars['Boolean']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isStickyNote?: Maybe<Scalars['Boolean']['output']>;
  noteType?: Maybe<Scalars['String']['output']>;
  opportunityDatabaseId?: Maybe<Scalars['String']['output']>;
  parentNoteId?: Maybe<Scalars['String']['output']>;
  policiesDatabaseIds?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  stickyNoteColor?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type NowCertsOpportunityFields = {
  __typename?: 'NowCertsOpportunityFields';
  agencyCommission?: Maybe<Scalars['Float']['output']>;
  assignedTo?: Maybe<Array<Scalars['String']['output']>>;
  costOfLead?: Maybe<Scalars['Float']['output']>;
  createdFromRenewal?: Maybe<Scalars['Boolean']['output']>;
  currentStageDueDate?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  neededBy?: Maybe<Scalars['String']['output']>;
  opportunityStageName?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Array<Scalars['String']['output']>>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  referralSourceContactName?: Maybe<Scalars['String']['output']>;
  referralSourceName?: Maybe<Scalars['String']['output']>;
  winProbability?: Maybe<Scalars['String']['output']>;
};

export type NowCertsPolicyFields = {
  __typename?: 'NowCertsPolicyFields';
  agencyCommissionPercent?: Maybe<Scalars['Float']['output']>;
  agencyCommissionValue?: Maybe<Scalars['Float']['output']>;
  agencyFee?: Maybe<Scalars['Float']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  billingType?: Maybe<Scalars['String']['output']>;
  bindDate?: Maybe<Scalars['String']['output']>;
  binderId?: Maybe<Scalars['String']['output']>;
  blanketAI?: Maybe<Scalars['Boolean']['output']>;
  blanketWS?: Maybe<Scalars['Boolean']['output']>;
  businessSubType?: Maybe<Scalars['String']['output']>;
  businessType?: Maybe<Scalars['String']['output']>;
  cancellationDate?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  checkPolicyOnNumber?: Maybe<Scalars['Boolean']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  financeCompanyName?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isPolicyRenewal?: Maybe<Scalars['Boolean']['output']>;
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  lineOfBusinessNames?: Maybe<Array<Scalars['String']['output']>>;
  manualStatus?: Maybe<Scalars['String']['output']>;
  mgaName?: Maybe<Scalars['String']['output']>;
  mortgageBilled?: Maybe<Scalars['Boolean']['output']>;
  nonPremium?: Maybe<Scalars['Float']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  packageName?: Maybe<Scalars['String']['output']>;
  parentPolicyId?: Maybe<Scalars['String']['output']>;
  policyFee?: Maybe<Scalars['Float']['output']>;
  policyTerm?: Maybe<Scalars['Int']['output']>;
  policyURL?: Maybe<Scalars['String']['output']>;
  premium?: Maybe<Scalars['Float']['output']>;
  premiumSent?: Maybe<Scalars['String']['output']>;
  productName?: Maybe<Scalars['String']['output']>;
  referralSourceCompanyName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  statusChangeDate?: Maybe<Scalars['String']['output']>;
  taxes?: Maybe<Scalars['Float']['output']>;
};

export type NowCertsPrincipalFields = {
  __typename?: 'NowCertsPrincipalFields';
  birthday?: Maybe<Scalars['String']['output']>;
  businessEmail?: Maybe<Scalars['String']['output']>;
  businessFax?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dlNumber?: Maybe<Scalars['String']['output']>;
  dlState?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  homePhone?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  isDriver?: Maybe<Scalars['Boolean']['output']>;
  isPrimary?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  matchRecordBaseOnName?: Maybe<Scalars['Boolean']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  officePhone?: Maybe<Scalars['String']['output']>;
  personalEmail?: Maybe<Scalars['String']['output']>;
  personalFax?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type NowCertsPropertyFields = {
  __typename?: 'NowCertsPropertyFields';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  anyAreaLeasedToOthers?: Maybe<Scalars['String']['output']>;
  attachToPolicyNumber?: Maybe<Scalars['String']['output']>;
  buildingNumber?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionOfOperations?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  locationNumber?: Maybe<Scalars['String']['output']>;
  numStories?: Maybe<Scalars['Float']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  propertyUse?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

export type NowCertsProspectFields = {
  __typename?: 'NowCertsProspectFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  agents?: Maybe<Array<Scalars['String']['output']>>;
  businessType?: Maybe<Scalars['String']['output']>;
  cellPhone?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  coInsuredDateOfBirth?: Maybe<Scalars['String']['output']>;
  coInsuredFirstName?: Maybe<Scalars['String']['output']>;
  coInsuredLastName?: Maybe<Scalars['String']['output']>;
  coInsuredMiddleName?: Maybe<Scalars['String']['output']>;
  commercialName?: Maybe<Scalars['String']['output']>;
  csrs?: Maybe<Array<Scalars['String']['output']>>;
  customerId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  dba?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fein?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  greetingName?: Maybe<Scalars['String']['output']>;
  insuredId?: Maybe<Scalars['String']['output']>;
  insuredType?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  leadSource?: Maybe<Array<Scalars['String']['output']>>;
  middleName?: Maybe<Scalars['String']['output']>;
  naic?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  referralSource?: Maybe<Scalars['String']['output']>;
  referralSourceCompanyName?: Maybe<Scalars['String']['output']>;
  smsPhone?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  yearBusinessStarted?: Maybe<Scalars['StringInt']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type NowCertsTagFields = {
  __typename?: 'NowCertsTagFields';
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  tagNames?: Maybe<Array<Scalars['String']['output']>>;
};

export type NowCertsTaskFields = {
  __typename?: 'NowCertsTaskFields';
  assignedTo?: Maybe<Array<Scalars['String']['output']>>;
  categoryName?: Maybe<Scalars['String']['output']>;
  completion?: Maybe<Scalars['Int']['output']>;
  creatorName?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  opportunityDatabaseId?: Maybe<Scalars['String']['output']>;
  policiesDatabaseIds?: Maybe<Array<Scalars['String']['output']>>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  stageName?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  supervisorName?: Maybe<Scalars['String']['output']>;
  tagDescription?: Maybe<Scalars['String']['output']>;
  tagName?: Maybe<Scalars['String']['output']>;
  taskDatabaseId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  workGroupName?: Maybe<Scalars['String']['output']>;
};

export type NowCertsVehicleFields = {
  __typename?: 'NowCertsVehicleFields';
  active?: Maybe<Scalars['Boolean']['output']>;
  deductibleCollision?: Maybe<Scalars['Int']['output']>;
  deductibleComprehensive?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  drivers?: Maybe<Array<Scalars['String']['output']>>;
  estimatedAnnualDistance?: Maybe<Scalars['String']['output']>;
  hasSalvage?: Maybe<Scalars['Boolean']['output']>;
  insuredDatabaseId?: Maybe<Scalars['String']['output']>;
  insuredEmail?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  policyDatabaseId?: Maybe<Scalars['String']['output']>;
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  registrationExpirationDate?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  typeOfUse?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  visible?: Maybe<Scalars['Boolean']['output']>;
  year?: Maybe<Scalars['StringInt']['output']>;
};

/** Represents a tool for managing all NowCerts entities (insureds/prospects/policies/tasks/notes/etc.). */
export type NowCertsWriteTool = {
  __typename?: 'NowCertsWriteTool';
  input: NowCertsWriteToolInput;
  output: NowCertsWriteToolOutput;
};

export type NowCertsWriteToolInput = {
  __typename?: 'NowCertsWriteToolInput';
  call?: Maybe<NowCertsCallFields>;
  claim?: Maybe<NowCertsClaimFields>;
  driver?: Maybe<NowCertsDriverFields>;
  file?: Maybe<NowCertsFileFields>;
  insured?: Maybe<NowCertsInsuredFields>;
  note?: Maybe<NowCertsNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  opportunity?: Maybe<NowCertsOpportunityFields>;
  policy?: Maybe<NowCertsPolicyFields>;
  principal?: Maybe<NowCertsPrincipalFields>;
  property?: Maybe<NowCertsPropertyFields>;
  prospect?: Maybe<NowCertsProspectFields>;
  tag?: Maybe<NowCertsTagFields>;
  task?: Maybe<NowCertsTaskFields>;
  vehicle?: Maybe<NowCertsVehicleFields>;
};

export type NowCertsWriteToolOutput = {
  __typename?: 'NowCertsWriteToolOutput';
  entityId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type NowCertsXDateAndLineOfBusiness = {
  __typename?: 'NowCertsXDateAndLineOfBusiness';
  lineOfBusinessName?: Maybe<Scalars['String']['output']>;
  xDate?: Maybe<Scalars['String']['output']>;
};

export type NumericFilter = {
  /** Filter for numbers greater than this value */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** Filter for numbers less than this value */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
};

/** A knowledge base document (latest version) in the LIST hierarchy. */
export type OrganizeKnowledgeBaseDocumentInfo = {
  __typename?: 'OrganizeKnowledgeBaseDocumentInfo';
  id: Scalars['String']['output'];
  /**
   * The user-facing name for this document: display name when set, otherwise the
   * indexed metadata title, otherwise the persisted title (typically the upload
   * filename for FILE documents).
   */
  title: Scalars['String']['output'];
};

/**
 * A folder in the LIST hierarchy, nesting its child folders and a sample of its
 * documents.
 */
export type OrganizeKnowledgeBaseFolderNode = {
  __typename?: 'OrganizeKnowledgeBaseFolderNode';
  /** Folders nested directly under this one. */
  childFolders?: Maybe<Array<OrganizeKnowledgeBaseFolderNode>>;
  /**
   * The number of documents directly in this folder (all versions counted once);
   * under a query this counts only the matching documents. May exceed
   * len(documents) when more than the per-folder sample limit are present.
   */
  docCount: Scalars['Int']['output'];
  /** A sample of the documents directly in this folder, up to a per-folder limit. */
  documents?: Maybe<Array<OrganizeKnowledgeBaseDocumentInfo>>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

/**
 * A knowledge base the agent can write to, returned by LIST when the agency has
 * more than one and none was specified.
 */
export type OrganizeKnowledgeBaseInfo = {
  __typename?: 'OrganizeKnowledgeBaseInfo';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type OrganizeKnowledgeBaseTool = {
  __typename?: 'OrganizeKnowledgeBaseTool';
  input: OrganizeKnowledgeBaseToolInput;
  output: OrganizeKnowledgeBaseToolOutput;
};

/** Input for the CREATE_FOLDER action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolCreateFolderInput = {
  __typename?: 'OrganizeKnowledgeBaseToolCreateFolderInput';
  folderName: Scalars['String']['output'];
  parentFolderId?: Maybe<Scalars['String']['output']>;
};

/** Result of the CREATE_FOLDER action. */
export type OrganizeKnowledgeBaseToolCreateFolderOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolCreateFolderOutput';
  folderId: Scalars['String']['output'];
  folderName: Scalars['String']['output'];
};

/**
 * Input for the OrganizeKnowledgeBaseTool. Set action and fill the matching
 * sub-object. Use LIST first to discover folder and document IDs (it returns a
 * nested folder tree with a document count per folder). CREATE_FOLDER makes a
 * folder. MOVE_DOCUMENTS moves documents into one.
 */
export type OrganizeKnowledgeBaseToolInput = {
  __typename?: 'OrganizeKnowledgeBaseToolInput';
  action: Scalars['String']['output'];
  createFolder?: Maybe<OrganizeKnowledgeBaseToolCreateFolderInput>;
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  list?: Maybe<OrganizeKnowledgeBaseToolListInput>;
  moveDocuments?: Maybe<OrganizeKnowledgeBaseToolMoveDocumentsInput>;
};

/** Input for the LIST action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolListInput = {
  __typename?: 'OrganizeKnowledgeBaseToolListInput';
  query?: Maybe<Scalars['String']['output']>;
};

/** Result of the LIST action: the knowledge base's folder tree and documents. */
export type OrganizeKnowledgeBaseToolListOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolListOutput';
  /**
   * True when a query was applied so the listing contains only matching documents
   * and the folders that hold them.
   */
  filtered: Scalars['Boolean']['output'];
  /** The root-level folders. Each nests its child folders and a document sample. */
  folders?: Maybe<Array<OrganizeKnowledgeBaseFolderNode>>;
  /**
   * Populated only when the agency has multiple knowledge bases and none was
   * specified. Call LIST again with one of these IDs.
   */
  knowledgeBases?: Maybe<Array<OrganizeKnowledgeBaseInfo>>;
  /** The number of documents at the root. May exceed len(rootDocuments). */
  rootDocumentCount: Scalars['Int']['output'];
  /** Documents at the root of the knowledge base (in no folder), up to a limit. */
  rootDocuments?: Maybe<Array<OrganizeKnowledgeBaseDocumentInfo>>;
  /** The total number of documents in the knowledge base across all folders. */
  totalDocumentCount: Scalars['Int']['output'];
};

/** Input for the MOVE_DOCUMENTS action of the OrganizeKnowledgeBaseTool. */
export type OrganizeKnowledgeBaseToolMoveDocumentsInput = {
  __typename?: 'OrganizeKnowledgeBaseToolMoveDocumentsInput';
  destinationFolderId?: Maybe<Scalars['String']['output']>;
  documentIds: Array<Scalars['String']['output']>;
};

/** Result of the MOVE_DOCUMENTS action. */
export type OrganizeKnowledgeBaseToolMoveDocumentsOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolMoveDocumentsOutput';
  movedDocumentIds: Array<Scalars['String']['output']>;
};

/**
 * Result of an OrganizeKnowledgeBaseTool operation. The sub-object matching the
 * requested action is populated.
 */
export type OrganizeKnowledgeBaseToolOutput = {
  __typename?: 'OrganizeKnowledgeBaseToolOutput';
  action: Scalars['String']['output'];
  /** A question to ask the user when requiresClarification is true. */
  clarificationMessage?: Maybe<Scalars['String']['output']>;
  createFolder?: Maybe<OrganizeKnowledgeBaseToolCreateFolderOutput>;
  knowledgeBaseId: Scalars['String']['output'];
  list?: Maybe<OrganizeKnowledgeBaseToolListOutput>;
  moveDocuments?: Maybe<OrganizeKnowledgeBaseToolMoveDocumentsOutput>;
  /** True when the tool needs the user to confirm which knowledge base to use. */
  requiresClarification: Scalars['Boolean']['output'];
  success: Scalars['Boolean']['output'];
};

/**
 * An outbound call job: schedule, dial intent, retry policy, and attempt timeline.
 * Conversation details live on the linked Call row once Retell connects.
 */
export type OutboundCall = {
  __typename?: 'OutboundCall';
  /** The agency that owns this outbound call */
  agency: Agency;
  /** Prompt and behavior configuration for the call */
  callConfig: OutboundCallConfig;
  /**
   * Phone conversations placed for this job (oldest first), resolved from Call rows
   * linked by outboundCallId. Dial attempt history is derived from these Calls —
   * not an embedded JSON array on the job.
   */
  calls: Array<Call>;
  /** When this outbound call job was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created this outbound call */
  createdBy: AgencyUser;
  /** Customer contact details for this call */
  customer: OutboundCallCustomer;
  /** Unique identifier for the outbound call job */
  id: Scalars['ID']['output'];
  /** The most recent linked phone conversation, if any */
  latestCall?: Maybe<Call>;
  /** Retry behavior for this job */
  retryPolicy: OutboundCallRetryPolicy;
  /** When the call should be placed */
  schedule: OutboundCallSchedule;
  /** How this outbound call was created */
  source: OutboundCallSource;
  /** Current job status */
  status: OutboundCallStatus;
  /** When this outbound call job was last updated */
  updatedAt: Scalars['Time']['output'];
  /** Optimistic concurrency / version stamp (Unix ms) */
  version: Scalars['Int64']['output'];
  /**
   * Visibility controls for this outbound call.
   * Stored but not yet enforced in list queries — defaults to PUBLIC.
   */
  visibility: VisibilityConfig;
  /** The outbound voice agent that will place this call */
  voiceAgent: VoiceAgent;
};

export type OutboundCallConfig = {
  __typename?: 'OutboundCallConfig';
  callObjective: Scalars['String']['output'];
  /**
   * Optional direct callback number Cara should give the customer on this call.
   * When omitted, Cara uses the agency phone from voice agent settings.
   */
  callbackPhone?: Maybe<Scalars['String']['output']>;
  customerContext?: Maybe<Scalars['String']['output']>;
  /**
   * File IDs for context extraction on this call.
   * TODO: UI and ingestion deferred — field kept for forward compatibility
   * (same pattern as OutboundCall.visibility). Always empty until wired.
   */
  fileIds: Array<Scalars['String']['output']>;
  guidelines?: Maybe<Scalars['String']['output']>;
  leaveVoicemail: Scalars['Boolean']['output'];
};

export type OutboundCallConfigInput = {
  callObjective: Scalars['String']['input'];
  /** Optional direct callback number for this call. Omit to use the agency phone. */
  callbackPhone?: InputMaybe<Scalars['String']['input']>;
  customerContext?: InputMaybe<Scalars['String']['input']>;
  /**
   * TODO: UI and ingestion deferred — field kept for forward compatibility
   * (same pattern as visibility). Clients should omit or send [].
   */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  guidelines?: InputMaybe<Scalars['String']['input']>;
  leaveVoicemail: Scalars['Boolean']['input'];
};

/** A cursor-paginated connection of OutboundCall records. */
export type OutboundCallConnection = {
  __typename?: 'OutboundCallConnection';
  edges: Array<OutboundCallEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundCallCustomer = {
  __typename?: 'OutboundCallCustomer';
  /**
   * Customer's full name. Cara addresses them by first name on the call;
   * verification matches against the full name.
   */
  name?: Maybe<Scalars['String']['output']>;
  phone: Scalars['String']['output'];
};

export type OutboundCallCustomerInput = {
  /**
   * Customer's full name (required). Cara addresses them by first name on the call;
   * verification matches against the full name.
   */
  name?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
};

export type OutboundCallDailyCount = {
  __typename?: 'OutboundCallDailyCount';
  completed: Scalars['Int']['output'];
  date: Scalars['Time']['output'];
  failed: Scalars['Int']['output'];
  scheduled: Scalars['Int']['output'];
  totalCalls: Scalars['Int']['output'];
};

/** An edge in a paginated OutboundCall connection. */
export type OutboundCallEdge = {
  __typename?: 'OutboundCallEdge';
  cursor: Scalars['String']['output'];
  node: OutboundCall;
};

/**
 * Rolling-window usage of AI outbound calls to a customer phone number.
 * Count includes placed dials and in-flight scheduled jobs. Used by the
 * create/edit UI and the pre-dial gate.
 */
export type OutboundCallFrequency = {
  __typename?: 'OutboundCallFrequency';
  /** Outbound jobs toward the limit for this phone in the window. */
  count: Scalars['Int']['output'];
  /** Maximum calls allowed in the window (currently 3). */
  limit: Scalars['Int']['output'];
  /** How many additional calls may still be placed (limit - count, floored at 0). */
  remaining: Scalars['Int']['output'];
  /** Length of the rolling window in days (currently 30). */
  windowDays: Scalars['Int']['output'];
};

export type OutboundCallReport = {
  __typename?: 'OutboundCallReport';
  dailyCounts: Array<OutboundCallDailyCount>;
  statusCounts: Array<OutboundCallStatusCount>;
  totalCalls: Scalars['Int']['output'];
  voicemailEnabledCount: Scalars['Int']['output'];
};

export type OutboundCallReportFilterInput = {
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

export type OutboundCallRetryPolicy = {
  __typename?: 'OutboundCallRetryPolicy';
  maxAttempts: Scalars['Int']['output'];
  retryAfterVoicemail: Scalars['Boolean']['output'];
  retryIntervalMinutes: Scalars['Int']['output'];
};

export type OutboundCallRetryPolicyInput = {
  maxAttempts?: InputMaybe<Scalars['Int']['input']>;
  retryAfterVoicemail?: InputMaybe<Scalars['Boolean']['input']>;
  retryIntervalMinutes?: InputMaybe<Scalars['Int']['input']>;
};

export type OutboundCallSchedule = {
  __typename?: 'OutboundCallSchedule';
  /** When to place the call. Null means immediate once the job is started. */
  scheduledAt?: Maybe<Scalars['Time']['output']>;
  timezone: Scalars['String']['output'];
};

export type OutboundCallScheduleInput = {
  /** When true, scheduledAt is required. When false, the call is placed as soon as the job starts. */
  scheduleLater: Scalars['Boolean']['input'];
  scheduledAt?: InputMaybe<Scalars['Time']['input']>;
  timezone: Scalars['String']['input'];
};

/** Sortable fields for searchOutboundCalls */
export enum OutboundCallSortField {
  CreatedBy = 'CREATED_BY',
  Customer = 'CUSTOMER',
  Objective = 'OBJECTIVE',
  Phone = 'PHONE',
  ScheduledAt = 'SCHEDULED_AT',
  Status = 'STATUS'
}

/** Sort specification for searchOutboundCalls */
export type OutboundCallSortInput = {
  direction: SortDirection;
  field: OutboundCallSortField;
};

export type OutboundCallSource = {
  __typename?: 'OutboundCallSource';
  emailThreadId?: Maybe<Scalars['String']['output']>;
  trigger: OutboundCallSourceTrigger;
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * Provenance for how an outbound call job was created.
 * Omit on CreateOutboundCallInput to default to MANUAL.
 * Not set by DRAFT_OUTBOUND_CALL — clients pass this when confirming/creating the job.
 */
export type OutboundCallSourceInput = {
  /**
   * Draft artifact ID from DRAFT_OUTBOUND_CALL. When provided with workspaceId,
   * createOutboundCall links the created job onto that draft's tool output
   * (outboundCallId) so confirmation survives refresh. Not stored on OutboundCallSource.
   */
  draftArtifactId?: InputMaybe<Scalars['String']['input']>;
  /** Required when trigger is EMAIL. Email thread that initiated the draft. */
  emailThreadId?: InputMaybe<Scalars['String']['input']>;
  trigger: OutboundCallSourceTrigger;
  /** Required when trigger is COPILOT. Workspace that produced the draft. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

export enum OutboundCallSourceTrigger {
  Copilot = 'COPILOT',
  Email = 'EMAIL',
  Manual = 'MANUAL'
}

export enum OutboundCallStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Dialing = 'DIALING',
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  NoAnswer = 'NO_ANSWER',
  PendingConfirmation = 'PENDING_CONFIRMATION',
  Scheduled = 'SCHEDULED',
  VoicemailLeft = 'VOICEMAIL_LEFT'
}

export type OutboundCallStatusCount = {
  __typename?: 'OutboundCallStatusCount';
  count: Scalars['Int']['output'];
  status: OutboundCallStatus;
};

export enum OutboundCallUpdateType {
  CancelOutboundCall = 'CANCEL_OUTBOUND_CALL',
  CreateOutboundCall = 'CREATE_OUTBOUND_CALL',
  UpdateOutboundCall = 'UPDATE_OUTBOUND_CALL'
}

export type OutboundCallsFilterInput = {
  /** When true, return only outbound calls created by the authenticated user. */
  createdByMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter to outbound calls created by a specific agency user. */
  createdByUserId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<OutboundCallStatus>;
  /** Reserved for future visibility enforcement. */
  visibility?: InputMaybe<VisibilityListFilterInput>;
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One email a human committed to sending: what went out, from which connected
 * mailbox, and how it resolved. Written once when the send is claimed and once
 * more when it resolves; nothing else mutates it, so the row is its own audit
 * trail.
 */
export type OutboundEmail = {
  __typename?: 'OutboundEmail';
  /**
   * Where the email stands in the AMS. Null when no AMS logs the agency's sent emails, or
   * the email never sent.
   */
  amsLog?: Maybe<OutboundEmailAmsLog>;
  artifactVersion: Scalars['Int']['output'];
  attachments: Array<OutboundEmailAttachment>;
  bcc: Array<OutboundEmailAddress>;
  /**
   * The bulk email whose batch made this send. Null for an email sent on its own,
   * including a held-back bulk email sent later.
   */
  bulkSendId?: Maybe<Scalars['String']['output']>;
  /**
   * Milliseconds left to cancel, calculated using the server's clock when this
   * field is resolved. Zero once the window closes or the send is resolved.
   * Clients must account for request time when counting down this duration.
   */
  cancellationRemainingMs: Scalars['Int']['output'];
  cc: Array<OutboundEmailAddress>;
  createdAt: Scalars['Time']['output'];
  /**
   * How the send failed, classified rather than described. Null on any status
   * but FAILED.
   *
   * This is what a reader branches on. `failureReason` is prose, free to be
   * reworded by a later deploy, so pick your wording from this field and keep
   * the reason as detail behind it.
   */
  failureKind?: Maybe<OutboundEmailFailureKind>;
  /**
   * Why a FAILED send failed, in a sentence written for the person who clicked
   * send. Empty on every other status.
   *
   * Rows written before this field was humanized carry the provider's own error
   * text instead, which is diagnostic rather than actionable: render it as detail
   * a reader can reach for, never as the headline.
   */
  failureReason: Scalars['String']['output'];
  fromAddress: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /**
   * The RFC 5322 Message-ID of the sent mail when the provider reported one:
   * the durable key for recognizing replies.
   */
  internetMessageId: Scalars['String']['output'];
  /**
   * The connected mailbox it was sent from, denormalized: the ID is retained
   * even after that mailbox is disconnected.
   */
  mailboxAccountId: Scalars['String']['output'];
  /**
   * The send time the agent picked with Schedule send: scheduleMailboxEmail's
   * (or rescheduleMailboxEmail's) sendAt. Kept after the email is sent, fails or
   * is cancelled, so the record can say what it was scheduled for. Null for Send
   * now.
   */
  scheduledFor?: Maybe<Scalars['Time']['output']>;
  /** The end of the cancellation window. Null once delivery starts. */
  sendAfter?: Maybe<Scalars['Time']['output']>;
  /**
   * True when Cara asked the provider to send and never learned the outcome, so
   * the recipient may or may not have this email. Retrying such a send can
   * deliver it twice, which is why this is a field rather than something a client
   * infers from `failureReason`: the wording of a failure may be rewritten, and a
   * reworded message must not be able to reclassify a dangerous state as a safe
   * one.
   *
   * Read as a fact about Cara's knowledge, not about the mail. True never means
   * "sent" and false never means "not sent" — it means only that nothing here can
   * answer the question.
   *
   * False on SENDING and SENT: a resolved send is confirmed by definition, and an
   * unresolved one is still expected to answer for itself. A SENDING row that has
   * stopped moving is a client-side judgement about elapsed time, which the
   * server has no business making on its behalf.
   */
  sendUnconfirmed: Scalars['Boolean']['output'];
  sentAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Who clicked send, or who scheduled a SCHEDULED email: only they may edit it
   * while it waits. Null once that user is offboarded.
   */
  sentBy?: Maybe<AgencyUser>;
  /** Who clicked send. Null once that user is offboarded; the send itself stays. */
  sentByUserId?: Maybe<Scalars['String']['output']>;
  /**
   * True when the mail left the mailbox without passing through Cara: the agent
   * opened a draft Cara had written into their Drafts folder and pressed send in
   * their own mail client. Cara reconstructed the send afterwards from the copy
   * the provider holds, which is why several fields a Cara send always carries
   * are empty here rather than missing:
   *
   * `sentByUserId` is null, because nobody clicked send in Cara. The attachment
   * manifest is empty and the body was never recorded, because the sent copy
   * reports neither without further calls the send log has no reader for.
   * `subject`, the recipients, and `sentAt` come from the provider's own record
   * of the message that went out, so they reflect any edit made in the mail
   * client rather than what Cara last handed over.
   *
   * Such a send closes its artifact version exactly as a Cara send does: the
   * recipient has the email, so sending it again takes a new draft.
   */
  sentExternally: Scalars['Boolean']['output'];
  status: OutboundEmailStatus;
  subject: Scalars['String']['output'];
  /**
   * The recipients and subject as sent. On a SCHEDULED email they are the
   * email's latest version, since edits while it waits change what will go out.
   */
  to: Array<OutboundEmailAddress>;
  updatedAt: Scalars['Time']['output'];
  /** The EMAIL artifact that was sent, and the version the click committed. */
  workspaceArtifactId: Scalars['String']['output'];
  workspaceId?: Maybe<Scalars['String']['output']>;
};

/**
 * A recipient as recorded on the send, stamped at send time rather than
 * resolved later: the record must survive the contact changing.
 */
export type OutboundEmailAddress = {
  __typename?: 'OutboundEmailAddress';
  email: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

/** Where a sent email stands in the AMS that logs the agency's sent emails. */
export type OutboundEmailAmsLog = {
  __typename?: 'OutboundEmailAmsLog';
  /** The client the email was logged to, or the latest attempt tried. */
  accountDisplayName?: Maybe<Scalars['String']['output']>;
  /** Whether the viewer may push the email to the AMS now. */
  canPush: Scalars['Boolean']['output'];
  /** Why the latest attempt failed, written for the agent, when status is COULD_NOT_LOG. */
  failureMessage?: Maybe<Scalars['String']['output']>;
  /** The AMS the email was logged to, or would be logged to now. */
  integrationType: IntegrationType;
  loggedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Why the email isn't logged, when status is NOT_LOGGED. Null when nothing recorded why,
   * such as a missed start: the email can still be pushed. When status is UNSUPPORTED,
   * UNSUPPORTED_CONNECTION for a connection its AMS can't log emails through, else null.
   */
  notLoggedReason?: Maybe<AmsNotLoggedReason>;
  status: AmsLogStatus;
};

/**
 * What rode along, by name and size. The bytes stay in artifact and file
 * storage; this is the manifest.
 */
export type OutboundEmailAttachment = {
  __typename?: 'OutboundEmailAttachment';
  name: Scalars['String']['output'];
  size: Scalars['Int64']['output'];
};

export type OutboundEmailConnection = {
  __typename?: 'OutboundEmailConnection';
  edges: Array<OutboundEmailEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type OutboundEmailEdge = {
  __typename?: 'OutboundEmailEdge';
  cursor: Scalars['String']['output'];
  node: OutboundEmail;
};

/**
 * Why a send failed, in the vocabulary the mailbox provider contract classifies
 * failures with. Every value but the last two names a verdict a provider gave.
 *
 * Values exist to be branched on, so a client that meets one it does not know
 * must fall back to generic wording rather than guess — new providers can add
 * reactions this enum has to grow for.
 */
export enum OutboundEmailFailureKind {
  /** Authentication worked but there is no usable mailbox behind it. */
  AccountUnavailable = 'ACCOUNT_UNAVAILABLE',
  /** The organization requires an administrator to approve this app. */
  ConsentRequired = 'CONSENT_REQUIRED',
  /**
   * Cara's own send died before the provider gave any verdict. Not a provider
   * kind: these rows exist because the question was never answered, so the
   * `failureReason` written for them is the only account of what happened and is
   * addressed to a person.
   */
  Interrupted = 'INTERRUPTED',
  /** The provider refused one or more recipient addresses; nothing was sent. */
  InvalidRecipients = 'INVALID_RECIPIENTS',
  /** The item the send referred to does not resolve any more. */
  NotFound = 'NOT_FOUND',
  /** The grant is alive but lacks a scope the send needed. */
  PermissionDenied = 'PERMISSION_DENIED',
  /** The authorization grant is dead; the mailbox must be reconnected. */
  ReauthRequired = 'REAUTH_REQUIRED',
  /** The provider rate-limited the request; trying later is the remedy. */
  Throttled = 'THROTTLED',
  /** The message or an attachment exceeds a provider ceiling. */
  TooLarge = 'TOO_LARGE',
  /** The provider failed temporarily. Retrying should work. */
  Transient = 'TRANSIENT',
  /** The provider answered and the adapter could not classify the answer. */
  Unknown = 'UNKNOWN',
  /**
   * No kind was captured. Says nothing about the failure itself — only that
   * `failureReason` on this row may be raw provider text.
   */
  Unrecorded = 'UNRECORDED',
  /** The operation does not apply to this item or account. */
  Unsupported = 'UNSUPPORTED'
}

export enum OutboundEmailSortField {
  CreatedAt = 'CREATED_AT',
  SentAt = 'SENT_AT',
  Status = 'STATUS',
  Subject = 'SUBJECT'
}

export type OutboundEmailSortInput = {
  direction: SortDirection;
  field: OutboundEmailSortField;
};

/**
 * How a send resolved. A row exists only because a human clicked send or
 * scheduled a send. SENDING includes the cancellation window and delivery in
 * progress. A row still SENDING long after its delivery started means the process
 * died mid-send — outcome unknown.
 */
export enum OutboundEmailStatus {
  Cancelled = 'CANCELLED',
  Failed = 'FAILED',
  /**
   * Waiting for a send time the agent picked (Schedule send). Becomes SENDING
   * when that time comes; cancel and reschedule work until then. An Outlook draft
   * saved before it was scheduled stays linked and is the one sent.
   */
  Scheduled = 'SCHEDULED',
  Sending = 'SENDING',
  Sent = 'SENT'
}

export type OutboundEmailsFilterInput = {
  mailboxAccountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Narrows to the sends belonging to emails the outbox filter matches. See
   * OutboxFilterInput for why this is answered against the whole email rather
   * than against the send row.
   */
  outbox?: InputMaybe<OutboxFilterInput>;
  /** When true, return only sends the authenticated user committed. */
  sentByMe?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<OutboundEmailStatus>;
  workspaceArtifactId?: InputMaybe<Scalars['ID']['input']>;
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/** Stored record that an agency user acknowledged a specific outbound voice compliance disclosure. */
export type OutboundVoiceComplianceAcknowledgment = {
  __typename?: 'OutboundVoiceComplianceAcknowledgment';
  /** When the acknowledgment was recorded */
  acknowledgedAt: Scalars['Time']['output'];
  /** Agency user who acknowledged the disclosure */
  acknowledgedByUserId: Scalars['ID']['output'];
  /** Disclosure text version that was shown and acknowledged */
  disclosureVersion: Scalars['String']['output'];
};

/** Versioned outbound voice compliance disclosure presented before first outbound agent creation. */
export type OutboundVoiceComplianceDisclosure = {
  __typename?: 'OutboundVoiceComplianceDisclosure';
  /** Checkbox label the user must accept before proceeding */
  acknowledgmentLabel: Scalars['String']['output'];
  /** Introductory paragraph before the sections */
  intro: Scalars['String']['output'];
  /** Body sections of the disclosure */
  sections: Array<OutboundVoiceComplianceDisclosureSection>;
  /** Dialog title */
  title: Scalars['String']['output'];
  /** Stable identifier for this disclosure text. Bumped when the text materially changes. */
  version: Scalars['String']['output'];
};

/** One headed section of the outbound voice compliance disclosure */
export type OutboundVoiceComplianceDisclosureSection = {
  __typename?: 'OutboundVoiceComplianceDisclosureSection';
  /** Section body (plain text; paragraphs separated by blank lines) */
  body: Scalars['String']['output'];
  /** Section heading */
  heading: Scalars['String']['output'];
};

/**
 * Narrows a source of the outbox by a property of the whole email rather than of
 * the record being read.
 *
 * Every field here is answered against the email -- the artifact, its draft and
 * its sends together -- and not against the row the query is walking. That is
 * what makes it safe to hand the same `OutboxFilterInput` to all three of
 * `searchCaraWorkspaceArtifacts`, `searchMailboxDrafts` and `searchOutboundEmails`
 * and merge the results: a matching email is matched in every ledger that holds a
 * record of it, so a client merging the three lists sees each matching email
 * whole, with the same status it would have had unfiltered. A filter answered
 * against one row at a time could not promise that -- it would drop the send and
 * keep the draft, and the merged row would report "waiting in Drafts" for an
 * email that had already failed to go out.
 *
 * An email with no artifact id to gather its records under is matched on the
 * record at hand, since there is nothing else it could be matched on.
 *
 * Omitting the input entirely narrows nothing.
 */
export type OutboxFilterInput = {
  /**
   * Keeps only emails this user had a hand in: they opened the workspace it was
   * composed in, asked Cara for the draft, or committed the send. One field for
   * the three, because "my email" means all of them and the ledgers name them
   * differently.
   */
  actedByUserID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Keeps only emails with activity after this instant -- composed, drafted or
   * sent since then. The outbox is ordered by last activity, so this is the lower
   * bound on the column it is already sorted by.
   */
  activeAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Keeps only one bulk email's emails. */
  bulkSendID?: InputMaybe<Scalars['String']['input']>;
  /**
   * The instant before which an unresolved send counts as INTERRUPTED rather than
   * SENDING. The client that draws the badge owns this threshold. With no value,
   * SENDING and INTERRUPTED both select every unresolved send.
   */
  interruptedBefore?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Keeps only emails that reached this mailbox, as a draft or as a send. An
   * email Cara composed and never wrote into a mailbox reaches none, and is
   * therefore never a match.
   */
  mailboxAccountID?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Free text over what the email is called and who it went to: the artifact's
   * title in any version, the subject stamped on any send of it, and the
   * recipients recorded on those sends.
   *
   * Drafts contribute nothing but their artifact's title. The provider owns a
   * draft's contents, so Cara stores neither the words nor the addressees of one
   * and has nothing else about it to search.
   */
  query?: InputMaybe<Scalars['String']['input']>;
  /**
   * Keeps only emails whose derived status is one of these. An empty list means
   * no restriction, not "match nothing".
   */
  statuses?: InputMaybe<Array<OutboxStatus>>;
};

/**
 * How far an email has got, in the vocabulary the outbox badges it with.
 *
 * Derived, never stored. One email leaves records in three ledgers -- the
 * artifact Cara composed, the draft written into a mailbox, and the send -- and
 * the furthest of those that exists decides the value: a send outranks the draft
 * it was sent from, and a draft outranks the artifact it was written from. No
 * column holds this, so every read that narrows by it derives it again.
 *
 * CHECKING has no value here. It describes a row whose provider copy is being
 * re-read at this moment, which is a fact about one open tab rather than about
 * the email, and a stored ledger has no way to answer for it.
 */
export enum OutboxStatus {
  /** The sender cancelled this send during its cancellation window. */
  Cancelled = 'CANCELLED',
  /** Retired for a reason this build does not recognize. */
  Closed = 'CLOSED',
  /** Written in Cara and never put in a mailbox: no draft, no send. */
  Composed = 'COMPOSED',
  /** The provider refused the send, or Cara could not establish that it happened. */
  Failed = 'FAILED',
  /** Gone from the Drafts folder with nothing in the mailbox to say it was sent. */
  GoneUnproven = 'GONE_UNPROVEN',
  /**
   * Still unresolved long enough that the process handling it is presumed dead.
   * Only distinguishable from SENDING when the caller supplies
   * `interruptedBefore`; without it the two are the same set.
   */
  Interrupted = 'INTERRUPTED',
  /** Sitting in a Drafts folder, waiting for somebody to send it. */
  InMailbox = 'IN_MAILBOX',
  /** The draft was replaced by a newer draft of the same email. */
  Replaced = 'REPLACED',
  /** Waiting for a send time the agent picked. */
  Scheduled = 'SCHEDULED',
  /** Handed to the provider and not yet resolved. */
  Sending = 'SENDING',
  /**
   * Sent through Cara, or sent from a draft Cara later found gone with a sent
   * copy of its own in the mailbox.
   */
  Sent = 'SENT',
  /**
   * A sent copy is in the mailbox but the send went out from the mail client, so
   * Cara has no delivery record of it.
   */
  SentFromMailClient = 'SENT_FROM_MAIL_CLIENT',
  /** Cara withdrew the draft from the mailbox. */
  Withdrawn = 'WITHDRAWN'
}

/** Live overage charge for the open usage period. Pre-tax; tax appears on the Stripe invoice. */
export type OverageBillEstimate = {
  __typename?: 'OverageBillEstimate';
  deliveryMethod: OverageDeliveryMethod;
  estimatedChargeDate: Scalars['Time']['output'];
  isEstimate: Scalars['Boolean']['output'];
  lineItems: Array<OverageBillLineItem>;
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  subtotalDollars: Scalars['Float']['output'];
  totalDollars: Scalars['Float']['output'];
};

/** Per-meter overage line shared by the live estimate and settled invoices. */
export type OverageBillLineItem = {
  __typename?: 'OverageBillLineItem';
  amountDollars: Scalars['Float']['output'];
  billableUnitsUsed: Scalars['Decimal']['output'];
  includedUnits: Scalars['Int']['output'];
  meterCode: ConsumptionMeterCode;
  overageUnits: Scalars['Decimal']['output'];
  ratePerUnit: Scalars['Float']['output'];
};

/** How an overage charge is delivered on Stripe. */
export enum OverageDeliveryMethod {
  OnNextSubscriptionInvoice = 'ON_NEXT_SUBSCRIPTION_INVOICE',
  Standalone = 'STANDALONE'
}

/**
 * Platform-unit spend vs an optional dollar overage budget.
 * Org-wide: units above the shared included allotment.
 * Per-user: that user's platform units after the shared included pool is
 * exhausted (phased overage), not all of the user's units.
 * The configured budget lives on AgencySubscription /
 * AgencyUser.platformUnitOverageLimitDollars — not duplicated here.
 */
export type OverageSpendStatus = {
  __typename?: 'OverageSpendStatus';
  /** True when overageDollars is at or above 80% of the effective budget. */
  alertThresholdReached: Scalars['Boolean']['output'];
  /**
   * Equivalent unit quantity for the configured dollar budget at the published
   * overage rate. Null when the meter has no published overage rate.
   */
  equivalentUnitsLimit?: Maybe<Scalars['Decimal']['output']>;
  /** True when overageDollars is at or above the effective budget (nil limit = 0). */
  limitReached: Scalars['Boolean']['output'];
  /** Units converted to USD at the published platform-unit overage rate. */
  overageDollars: Scalars['Float']['output'];
  /** Platform units counted toward this scope's budget. */
  overageUnits: Scalars['Decimal']['output'];
  /**
   * overageDollars / configured budget. Null when the meter has no published
   * overage rate.
   */
  percentOfLimit?: Maybe<Scalars['Float']['output']>;
};

export type PdfEditorTool = {
  __typename?: 'PDFEditorTool';
  /** The input arguments for the PDF editing */
  input: PdfEditorToolInput;
  /** The result of the PDF editing operation */
  output: PdfEditorToolOutput;
};

export type PdfEditorToolInput = {
  __typename?: 'PDFEditorToolInput';
  /** The ID of an existing custom form artifact to update with new field values. */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** A JSON object whose keys match the field keys from DESCRIBE and values are the fill data. */
  fieldsJson?: Maybe<Scalars['String']['output']>;
  /** The instructions for filling out the form */
  formFillInstructions: Scalars['String']['output'];
  /** The ID of the custom form from the library to describe or fill. */
  formId?: Maybe<Scalars['String']['output']>;
  inputFiles: Array<PdfEditorToolInputFile>;
  /** The operation to perform on the PDF editor */
  operation: Scalars['String']['output'];
};

export type PdfEditorToolInputFile = {
  __typename?: 'PDFEditorToolInputFile';
  fileIdOrArtifactId: Scalars['String']['output'];
  fileName: Scalars['String']['output'];
};

export type PdfEditorToolOutput = {
  __typename?: 'PDFEditorToolOutput';
  /** The artifact produced by a FILL operation on a library custom form. */
  artifact?: Maybe<CustomFormToolArtifact>;
  /** The ID of the artifact resulting from the PDF edit */
  artifactId?: Maybe<Scalars['String']['output']>;
  /**
   * The ID of the file resulting from the PDF edit
   * @deprecated Use artifactId instead. This field is kept for backward compatibility with existing tool calls.
   */
  fileId?: Maybe<Scalars['String']['output']>;
  /** The described custom form including schema and fill instructions (populated for DESCRIBE operation). */
  form?: Maybe<CustomFormListItem>;
  /** The list of available custom forms from the library (populated for LIST operation). */
  forms?: Maybe<Array<CustomFormListItem>>;
  /** The result of the PDF edit operation */
  result: Scalars['String']['output'];
  /** The version of the artifact resulting from the PDF edit */
  version?: Maybe<Scalars['Int']['output']>;
};

/** Page information for cursor-based pagination */
export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor?: Maybe<Scalars['String']['output']>;
  hasNextPage: Scalars['Boolean']['output'];
};

export type PageStyle = {
  __typename?: 'PageStyle';
  /** Page background color in hex format (e.g. '#ffffff') */
  backgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Page margins in inches */
  margin: MarginStyle;
  /** Page size in standard paper sizes (e.g. 'A4', 'Letter', 'Legal') */
  size?: Maybe<Scalars['String']['output']>;
};

/** Input for page layout settings */
export type PageStyleInput = {
  /** Background color for the page, as a CSS hex string (e.g. '#ffffff') */
  backgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Margin settings for the page */
  margin?: InputMaybe<MarginStyleInput>;
  /** Page size (e.g. 'letter', 'A4', or custom) */
  size?: InputMaybe<Scalars['String']['input']>;
};

/** Paragraph style */
export type ParagraphStyle = {
  __typename?: 'ParagraphStyle';
  /** Text color in hex format (e.g. '#334155') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Font family name (overrides global typography when set) */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Font size in points (e.g. 11.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font style (e.g. 'normal', 'italic') */
  fontStyle?: Maybe<Scalars['String']['output']>;
  /** Font weight as a number (e.g. 400, 600) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.6) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
  /** Bottom margin in em units (e.g. 0.9) */
  marginBottomEm?: Maybe<Scalars['Float']['output']>;
  /** Top margin in em units (e.g. 0.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** Minimum number of lines at the bottom of a page (e.g. 3) */
  orphans?: Maybe<Scalars['Int']['output']>;
  /** When true, emit page-break-before so the paragraph starts on a new page */
  pageBreakBefore?: Maybe<Scalars['Boolean']['output']>;
  /** Minimum number of lines at the top of a page (e.g. 3) */
  widows?: Maybe<Scalars['Int']['output']>;
};

/** Input for paragraph style */
export type ParagraphStyleInput = {
  /** Text color as a CSS hex string */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for paragraph text */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for paragraph text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font style for paragraph text (e.g. 'italic') */
  fontStyle?: InputMaybe<Scalars['String']['input']>;
  /** Font weight for paragraph text */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for paragraph text (unitless multiplier) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
  /** Bottom margin in em units */
  marginBottomEm?: InputMaybe<Scalars['Float']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** Minimum number of lines of a paragraph that must be left at the bottom of a page */
  orphans?: InputMaybe<Scalars['Int']['input']>;
  /** If true, a page break is forced before this paragraph */
  pageBreakBefore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Minimum number of lines of a paragraph that must be at the top of a page */
  widows?: InputMaybe<Scalars['Int']['input']>;
};

/** PaymentIntervalType enumerates the interval of a fee occurrence */
export enum PaymentIntervalType {
  /** Describes an annual payment */
  Annual = 'ANNUAL',
  /** Describes a monthly payment */
  Monthly = 'MONTHLY',
  /** Describes a non-recurring payment */
  None = 'NONE',
  /** Describes a quarterly payment */
  Quarterly = 'QUARTERLY'
}

/**
 * Input for a single prefix or suffix attachment in a PDF render request.
 * Exactly one of fileId, file, or artifactId must be set. Artifact refs render the
 * latest version of that workspace artifact as a PDF using its own styling/template.
 */
export type PdfRenderAttachmentInput = {
  /** ID of a sibling PDF-renderable workspace artifact (HTML document, ACORD form, custom form, or PDF file) to render and append */
  artifactId?: InputMaybe<Scalars['ID']['input']>;
  /** Inline upload for an ephemeral attachment (stored in cache, not persisted) */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** ID of an existing file accessible to this agency (workspace file, message file, or template prefix/suffix) */
  fileId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * Represents a tool for peeking at files.
 * Used when the LLM needs to get a sense for the content of a file.
 */
export type PeekFileTool = {
  __typename?: 'PeekFileTool';
  /** The input arguments for the file peeking */
  input: PeekFileToolInput;
  /** The result of the file peeking operation */
  output: PeekFileToolOutput;
};

/**
 * Input arguments for the PeekFileTool.
 * Contains the file ID to peek at.
 */
export type PeekFileToolInput = {
  __typename?: 'PeekFileToolInput';
  /** The ID of the file to peek at */
  fileId: Scalars['String']['output'];
  /** The type of output to return */
  outputType: Scalars['String']['output'];
};

/**
 * Result of a PeekFileTool operation.
 * Contains the peeked file content.
 */
export type PeekFileToolOutput = {
  __typename?: 'PeekFileToolOutput';
  /** Any comments to the LLM about the peeked file */
  comment: Scalars['String']['output'];
  /** The peeked file content */
  content: Scalars['String']['output'];
  /** References to images stored in cache (preferred over images field) */
  imageRefs?: Maybe<Array<ImageReference>>;
  /** Reference to text content stored in cache (preferred over content field) */
  textRef?: Maybe<TextReference>;
  /** Whether the file was truncated */
  truncated: Scalars['Boolean']['output'];
};

/** Type representing a permission to access a resource */
export type Permission = {
  __typename?: 'Permission';
  /** The action that the permission allows */
  action: Action;
  /** The resource that the permission applies to */
  resource: Resource;
  /** The scope that the permission applies to */
  scope: Scope;
};

/**
 * Input type for specifying permissions in directives.
 * Either 'scopes' should be provided (Category 2: fixed scopes) OR the directive
 * should include a scopeResource (Category 1: dynamic scopes), but not both.
 */
export type PermissionInput = {
  /** The action that the permission allows. */
  action: Action;
  /** The resource that the permission applies to. */
  resource: Resource;
  /**
   * Explicit list of scopes that grant this permission (Category 2).
   * If provided, the user must have this permission at ANY of the listed scopes.
   * Mutually exclusive with scopeResource on the directive.
   */
  scopes?: InputMaybe<Array<Scope>>;
};

/** How included usage allotments are determined for a subscription. */
export enum PlanBillingType {
  /** Included usage scales with purchased seats using plan formulas. */
  PerSeat = 'PER_SEAT',
  /** Included usage is negotiated per contract via usageAllotmentOverrides. */
  Platform = 'PLATFORM',
  /**
   * No included allotments or overage budgets (unlimited capacity). Customer-facing
   * usage dashboard, limits, enforcement, and spend alerts stay hidden.
   */
  Unmetered = 'UNMETERED'
}

/** The enumeration of states for business policy */
export enum PolicyState {
  /** The policy is in the process of being bound or finalized */
  Binding = 'BINDING',
  /** The policy has been terminated or canceled before its expiration date */
  Canceled = 'CANCELED',
  /** The policy has reached its expiration date and is no longer active */
  Expired = 'EXPIRED',
  /** The policy is currently active and in force */
  Inforce = 'INFORCE',
  /** The policy is in a pending state, awaiting further action or information */
  Pending = 'PENDING',
  /** The state of the policy is unknown or not determined */
  Unknown = 'UNKNOWN'
}

export type PrepareAmsReconciliationInput = {
  source: AmsReconciliationSourceInput;
  /** Lets step one prefill the account linked to this workspace's client. */
  workspaceId?: InputMaybe<Scalars['ID']['input']>;
};

/**
 * A single clarifying question generated for the Convert-to-Preset wizard
 * (EPD-2005). The wizard renders the question with its selectable options; the
 * user picks one or, when allowFreeText is true, types their own answer. The
 * chosen answers are fed back into startPresetGeneration as
 * PresetGenerationQaAnswerInput.
 */
export type PresetClarifyingQuestion = {
  __typename?: 'PresetClarifyingQuestion';
  /**
   * Whether the user may supply a free-text answer instead of choosing an option.
   * Always true today: every question offers a free-text fallback.
   */
  allowFreeText: Scalars['Boolean']['output'];
  /**
   * Stable identifier for this question, used as a client-side key. Not
   * persisted: regenerating the questions produces fresh ids.
   */
  id: Scalars['ID']['output'];
  /** Between 2 and 4 selectable answer options. */
  options: Array<Scalars['String']['output']>;
  /** The question to ask the user, specific to the selected workspaces' content. */
  question: Scalars['String']['output'];
};

/**
 * Progress and outcome of the one AI generation run that produced a custom preset.
 * Null on a preset created by hand.
 *
 * Lives on the preset's parent row, not in its versioned document: it changes
 * several times per run, and a versioned write would mint a user-visible preset
 * version per progress step.
 */
export type PresetGeneration = {
  __typename?: 'PresetGeneration';
  /** When the run finished, whether it succeeded or failed. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Why generation failed, safe to show the user. Set only when the preset's state
   * is FAILED.
   */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * The wizard choices the run was started with. Null on a run started before this
   * field existed; every run since records it, so a preset can be re-generated from
   * the same inputs and a support question about why a preset came out the way it
   * did can be answered from the row.
   */
  request?: Maybe<PresetGenerationRequest>;
  /** When the workflow picked the run up. */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The step in flight. Null once the run has finished, whether it succeeded or
   * failed.
   */
  step?: Maybe<PresetGenerationStep>;
};

/**
 * A clarifying question and the answer the user gave it, as recorded on the run
 * that consumed them.
 */
export type PresetGenerationQaAnswer = {
  __typename?: 'PresetGenerationQaAnswer';
  answer: Scalars['String']['output'];
  question: Scalars['String']['output'];
};

/** Input for a single clarifying-question answer supplied to startPresetGeneration. */
export type PresetGenerationQaAnswerInput = {
  answer: Scalars['String']['input'];
  question: Scalars['String']['input'];
};

/**
 * The wizard choices a generation run was started with, kept on the run so the
 * inputs that produced a preset can be read back from it.
 */
export type PresetGenerationRequest = {
  __typename?: 'PresetGenerationRequest';
  /** The base preset the user pinned, if they overrode auto-detection. */
  basePresetOverride?: Maybe<CaraWorkspacePreset>;
  /** Custom forms the resulting preset was asked to default to. */
  customFormIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Files supplied as additional context for the run. */
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  /** HTML document templates the resulting preset was asked to default to. */
  htmlDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Free-text description of the desired output formats. */
  outputFormatsText?: Maybe<Scalars['String']['output']>;
  /** Answers to the clarifying questions from the wizard turn before the run. */
  qaAnswers?: Maybe<Array<PresetGenerationQaAnswer>>;
  /** The workspaces the preset was generated from. */
  sourceWorkspaceIds: Array<Scalars['String']['output']>;
  /** Word document templates the resulting preset was asked to default to. */
  wordDocumentTemplateIds?: Maybe<Array<Scalars['String']['output']>>;
};

/** The step GeneratePresetWorkflow is currently on. */
export enum PresetGenerationStep {
  /** Resolving which output templates and forms the preset should default to. */
  DetectingTemplates = 'DETECTING_TEMPLATES',
  /** Drafting the preset's base prompt. */
  DraftingPrompt = 'DRAFTING_PROMPT',
  /** Digesting the source workspaces to understand what the user was doing. */
  ReviewingWorkspaces = 'REVIEWING_WORKSPACES'
}

/** Result from previewing an update to the subscription */
export type PreviewUpdateSubscriptionResult = {
  __typename?: 'PreviewUpdateSubscriptionResult';
  /** The checkout URL to redirect the customer to, in case a new subscription needs to be created */
  checkoutUrl?: Maybe<Scalars['String']['output']>;
  /** Payment secret required in case a payment method is required to complete the subscription update */
  clientSecret?: Maybe<Scalars['String']['output']>;
  /** Preview of the invoice that would be generated for the subscription update */
  invoicePreview?: Maybe<UpdateSubscriptionInvoicePreview>;
};

/**
 * A set of producer information and signature for use in certificates and documents.
 * Can be defined at the agency level (shared by all users) or at the individual user level.
 */
export type ProducerInformation = {
  __typename?: 'ProducerInformation';
  /** Address of the agency */
  agencyAddress: Address;
  /** Name of the agency associated with this producer information */
  agencyName: Scalars['String']['output'];
  /** Email address of the contact person */
  contactEmail: Scalars['String']['output'];
  /** Fax number of the contact person */
  contactFax: Scalars['String']['output'];
  /** Name of the contact person */
  contactName: Scalars['String']['output'];
  /** Phone number of the contact person */
  contactPhone: Scalars['String']['output'];
  /** When this producer information was created */
  createdAt: Scalars['Time']['output'];
  /**
   * Florida producer license number.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific),
   * from this Producer Information setting (or a user-selected producer profile).
   */
  floridaLicenseNumber: Scalars['String']['output'];
  /** Unique identifier for this producer information */
  id: Scalars['ID']['output'];
  /** Whether this is the default set of producer information for the scope it belongs to */
  isDefault: Scalars['Boolean']['output'];
  /**
   * National Producer Number (NPN).
   * Auto-filled onto ACORD forms that include a producer national identifier field
   * from this Producer Information setting (or a user-selected producer profile).
   */
  nationalProducerNumber: Scalars['String']['output'];
  /** Name of the producer */
  producerName: Scalars['String']['output'];
  /** Base64-encoded JPEG signature image of the producer */
  producerSignatureJpegBase64: Scalars['String']['output'];
  /** When this producer information was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating or updating producer information */
export type ProducerInformationInput = {
  /** Address of the agency */
  agencyAddress: AddressInput;
  /** Name of the agency associated with this producer information */
  agencyName: Scalars['String']['input'];
  /** Email address of the contact person */
  contactEmail: Scalars['String']['input'];
  /** Fax number of the contact person */
  contactFax: Scalars['String']['input'];
  /** Name of the contact person */
  contactName: Scalars['String']['input'];
  /** Phone number of the contact person */
  contactPhone: Scalars['String']['input'];
  /**
   * Florida producer license number.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific),
   * from this Producer Information setting (or a user-selected producer profile).
   */
  floridaLicenseNumber: Scalars['String']['input'];
  /**
   * Whether this is the default set of producer information for the scope it belongs to.
   * Setting this to true will unset the default flag on any other producer information
   * in the same scope (agency or user).
   */
  isDefault: Scalars['Boolean']['input'];
  /**
   * National Producer Number (NPN).
   * Auto-filled onto ACORD forms that include a producer national identifier field
   * from this Producer Information setting (or a user-selected producer profile).
   */
  nationalProducerNumber: Scalars['String']['input'];
  /** Name of the producer */
  producerName: Scalars['String']['input'];
  /** Base64-encoded JPEG signature image of the producer. */
  producerSignatureJpegBase64: Scalars['String']['input'];
};

export type PushOutboundEmailToAmsInput = {
  /** Optional record below the client account. */
  filingTarget?: InputMaybe<EmailAmsFilingTargetInput>;
  /**
   * Logs the email even though an earlier attempt may have reached the AMS, which can add
   * a second copy. Without it, such an email is refused.
   */
  logAgainAnyway?: Scalars['Boolean']['input'];
  /**
   * An ACCOUNT in the AMS that logs the agency's sent emails. Null logs to the client the
   * latest attempt tried, else the one chosen before the send, else the one the recipients
   * match.
   */
  target?: InputMaybe<AmsRefInput>;
};

export type PushOutboundEmailToAmsResult = {
  __typename?: 'PushOutboundEmailToAmsResult';
  email: OutboundEmail;
  outcome: AmsPushOutcome;
};

export type QqCatalystAcordFields = {
  __typename?: 'QQCatalystAcordFields';
  acordFormId?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type QqCatalystAdditionalContactFields = {
  __typename?: 'QQCatalystAdditionalContactFields';
  commercial?: Maybe<Scalars['Boolean']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  parentContactId?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryContact?: Maybe<Scalars['Boolean']['output']>;
  residenceTypeId?: Maybe<Scalars['Int']['output']>;
};

/** QQCatalyst carrier */
export type QqCatalystCarrier = {
  __typename?: 'QQCatalystCarrier';
  /** QQCatalyst carrier id */
  carrierId: Scalars['Int']['output'];
  /** Carrier name */
  name: Scalars['String']['output'];
};

/** One book-size count from QQCatalyst */
export type QqCatalystCategoryCount = {
  __typename?: 'QQCatalystCategoryCount';
  /** Category name */
  category: Scalars['String']['output'];
  /** Record count in that category */
  count: Scalars['Int']['output'];
};

/** QQCatalystConfiguration contains configuration for the QQCatalyst integration */
export type QqCatalystConfiguration = {
  __typename?: 'QQCatalystConfiguration';
  /** Carriers cached on the integration at connect */
  carriers?: Maybe<Array<QqCatalystCarrier>>;
  /** Book-size counts last reported by QQCatalyst. Refreshed at the start of a read sync. */
  categoryCounts?: Maybe<Array<QqCatalystCategoryCount>>;
  /** Customer sources for the default office */
  customerSources?: Maybe<Array<QqCatalystCustomerSource>>;
  /** Default office used for prospect insert and search */
  defaultLocationId?: Maybe<Scalars['Int']['output']>;
  /** Employees available for task assignment */
  employees?: Maybe<Array<QqCatalystEmployee>>;
  /** If enabled, will create prospects in QQCatalyst when the caller is unknown. */
  enableSyncAccounts: Scalars['Boolean']['output'];
  /** If enabled, will sync calls from Cara to QQCatalyst. */
  enableSyncCalls: Scalars['Boolean']['output'];
  /** If enabled, will sync tasks from Cara to QQCatalyst. */
  enableSyncTasks: Scalars['Boolean']['output'];
  /** Lines of business cached at connect */
  linesOfBusiness?: Maybe<Array<QqCatalystLineOfBusiness>>;
  /** Offices available to the connected user */
  locations?: Maybe<Array<QqCatalystLocation>>;
  /** Policy sources for the default office */
  policySources?: Maybe<Array<QqCatalystPolicySource>>;
  /** Who synced tasks are assigned to. Defaults to CSR. */
  taskAssignment?: Maybe<QqCatalystTaskAssignment>;
  /** Employee id used when taskAssignment is SPECIFIED_EMPLOYEE */
  taskAssignmentEmployeeId?: Maybe<Scalars['Int']['output']>;
};

export type QqCatalystContactFields = {
  __typename?: 'QQCatalystContactFields';
  agentId?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  contactType?: Maybe<Scalars['String']['output']>;
  csrId?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** QQCatalyst customer source */
export type QqCatalystCustomerSource = {
  __typename?: 'QQCatalystCustomerSource';
  /** Customer source id */
  customerSourceId: Scalars['Int']['output'];
  /** Source name */
  name: Scalars['String']['output'];
};

export type QqCatalystDriverFields = {
  __typename?: 'QQCatalystDriverFields';
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  isNamedInsured?: Maybe<Scalars['Boolean']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  licenseNumber?: Maybe<Scalars['String']['output']>;
  licenseState?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  policyDetailId?: Maybe<Scalars['String']['output']>;
};

/** QQCatalyst employee */
export type QqCatalystEmployee = {
  __typename?: 'QQCatalystEmployee';
  /** Display name */
  displayName: Scalars['String']['output'];
  /** QQCatalyst employee id */
  employeeId: Scalars['Int']['output'];
};

export type QqCatalystFileFields = {
  __typename?: 'QQCatalystFileFields';
  artifactVersion?: Maybe<Scalars['Int']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

export type QqCatalystInlandMarineFields = {
  __typename?: 'QQCatalystInlandMarineFields';
  amount?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  itemName?: Maybe<Scalars['String']['output']>;
  manufacturer?: Maybe<Scalars['String']['output']>;
  maximumItem?: Maybe<Scalars['Float']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  policyDetailId?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
};

/** QQCatalyst line of business */
export type QqCatalystLineOfBusiness = {
  __typename?: 'QQCatalystLineOfBusiness';
  /** ACORD code */
  acordCode?: Maybe<Scalars['String']['output']>;
  /** System line id */
  id: Scalars['Int']['output'];
  /** Line name */
  name: Scalars['String']['output'];
};

/** QQCatalyst office */
export type QqCatalystLocation = {
  __typename?: 'QQCatalystLocation';
  /** Whether this is the user's default office */
  isDefault: Scalars['Boolean']['output'];
  /** QQCatalyst location id */
  locationId: Scalars['Int']['output'];
  /** Office display name */
  locationName: Scalars['String']['output'];
};

export type QqCatalystNoteFields = {
  __typename?: 'QQCatalystNoteFields';
  comment?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  important?: Maybe<Scalars['Boolean']['output']>;
  policyId?: Maybe<Scalars['String']['output']>;
};

export type QqCatalystPolicyFields = {
  __typename?: 'QQCatalystPolicyFields';
  agentId?: Maybe<Scalars['String']['output']>;
  carrierId?: Maybe<Scalars['String']['output']>;
  contactId?: Maybe<Scalars['String']['output']>;
  csrId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  effectiveDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  lobId?: Maybe<Scalars['String']['output']>;
  namedInsureds?: Maybe<Array<Scalars['String']['output']>>;
  policyId?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policySourceId?: Maybe<Scalars['String']['output']>;
  quoteDescription?: Maybe<Scalars['String']['output']>;
  quoteId?: Maybe<Scalars['String']['output']>;
  quotePremium?: Maybe<Scalars['Float']['output']>;
  quoteStatus?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  totalPremium?: Maybe<Scalars['Float']['output']>;
};

/** QQCatalyst policy source */
export type QqCatalystPolicySource = {
  __typename?: 'QQCatalystPolicySource';
  /** Source name */
  name: Scalars['String']['output'];
  /** Policy source id */
  policySourceId: Scalars['Int']['output'];
};

/** Who Cara assigns QQCatalyst tasks to. */
export enum QqCatalystTaskAssignment {
  /** The account's agent. */
  Agent = 'AGENT',
  /** The account's CSR. This is the default. */
  Csr = 'CSR',
  /** A specific employee chosen on the connect form. */
  SpecifiedEmployee = 'SPECIFIED_EMPLOYEE'
}

export type QqCatalystTaskFields = {
  __typename?: 'QQCatalystTaskFields';
  contactId?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  taskId?: Maybe<Scalars['String']['output']>;
};

export type QqCatalystVehicleFields = {
  __typename?: 'QQCatalystVehicleFields';
  bodyType?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  policyDetailId?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleUse?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

/** Manages QQCatalyst prospects notes tasks x-dates policies coverage rows and files. */
export type QqCatalystWriteTool = {
  __typename?: 'QQCatalystWriteTool';
  input: QqCatalystWriteToolInput;
  output: QqCatalystWriteToolOutput;
};

export type QqCatalystWriteToolInput = {
  __typename?: 'QQCatalystWriteToolInput';
  acord?: Maybe<QqCatalystAcordFields>;
  additionalContact?: Maybe<QqCatalystAdditionalContactFields>;
  contact?: Maybe<QqCatalystContactFields>;
  driver?: Maybe<QqCatalystDriverFields>;
  file?: Maybe<QqCatalystFileFields>;
  inlandMarine?: Maybe<QqCatalystInlandMarineFields>;
  note?: Maybe<QqCatalystNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  policy?: Maybe<QqCatalystPolicyFields>;
  task?: Maybe<QqCatalystTaskFields>;
  vehicle?: Maybe<QqCatalystVehicleFields>;
  xdate?: Maybe<QqCatalystXDateFields>;
};

export type QqCatalystWriteToolOutput = {
  __typename?: 'QQCatalystWriteToolOutput';
  contactId?: Maybe<Scalars['String']['output']>;
  entityId?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type QqCatalystXDateFields = {
  __typename?: 'QQCatalystXDateFields';
  contactId?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  lobId?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  period?: Maybe<Scalars['String']['output']>;
  relatedPolicyId?: Maybe<Scalars['String']['output']>;
  xdateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type Query = {
  __typename?: 'Query';
  /**
   * Returns a single account by ID. This endpoint verifies that the caller is
   * associated with the requested account.
   */
  account?: Maybe<Account>;
  /** Get the current client account user */
  accountUser?: Maybe<AccountUser>;
  /**
   * Returns a list of all accounts. This endpoint returns only accounts that the
   * caller is associated with (either as an agency user or as a client user).
   */
  accounts: Array<Account>;
  /**
   * The choices for the analytics access profile filter: the agency's active profiles, oldest
   * first, then the users no profile governs. Empty when the agency has no profiles or lacks the
   * access profile feature. The agency is the caller's, or subagencyId when it is a direct
   * child, as in adminAnalyticsReport.
   */
  adminAnalyticsAgencyProfileOptions: Array<AdminAnalyticsAgencyProfileOption>;
  /**
   * The caller's latest export of each table from the last day or so. Empty when Analytics
   * exports are off for the caller.
   */
  adminAnalyticsExports: Array<AdminAnalyticsExport>;
  /** Get agency-scoped product usage analytics for admins. */
  adminAnalyticsReport: AdminAnalyticsReport;
  /** Returns a list of all agencies in the system. Only accessible by admin users. */
  agencies: Array<Agency>;
  /** Get an agency by its unique identifier */
  agency?: Maybe<Agency>;
  /** Returns a profile by its ID. */
  agencyProfile?: Maybe<AgencyProfile>;
  /**
   * Returns everything an admin can grant in a profile, grouped for display.
   * Static reference data — the same for every agency.
   */
  agencyProfileCapabilityCatalog: AgencyProfileCapabilityCatalog;
  /**
   * Returns all active profiles in an agency, oldest first. Admin-only. Defaults
   * to the caller's own agency; naming another one is for the consoles that
   * administer an agency from outside it.
   */
  agencyProfiles: Array<AgencyProfile>;
  /** Get the current agency user */
  agencyUser?: Maybe<AgencyUser>;
  /**
   * The columns of an agency user CSV import, with the caller's agency's access profiles
   * and teams as their allowed values. createAgencyUsers checks rows against the same
   * definitions.
   */
  agencyUserImportSchema: ImportSchema;
  /**
   * Returns the profile in force for one user and the rule that put them there,
   * or null when no profile reaches them. Null for an admin, whom no profile
   * governs.
   */
  agencyUserProfileAssignment?: Maybe<AgencyUserProfileAssignment>;
  /** Get all agency users for the current account */
  agencyUsers: Array<AgencyUser>;
  /**
   * Returns CERTIFICATE entities related to an account. Only Applied Epic syncs
   * CERTIFICATE rows today; other integrations return supported=false with an empty
   * connection so clients can hide certificate pinning instead of showing "none found".
   */
  amsAccountCertificates: AmsAccountCertificatesResult;
  /**
   * Returns an account's documents (FILE entities), most-recently-modified first,
   * paginated. Scope with `policyId` (documents attached to one POLICY entity),
   * `policyIds` (documents attached to any entity in a policy-number group), or
   * `looseFilesOnly: true` (documents with no policy); with none of those, returns
   * all of the account's documents. `query` filters documents by name. `accountId`
   * is the account's KnowledgeGraphEntity ID.
   */
  amsAccountDocuments: KnowledgeGraphEntityConnection;
  /**
   * Returns POLICY entities related to an account, one row per AMS line (Applied Epic
   * granularity). For pinning individual policy lines via amsContext — not grouped
   * by policy number.
   */
  amsAccountPolicies: KnowledgeGraphEntityConnection;
  /**
   * Lists an account's policies grouped by normalized policy number. This hides
   * integration-specific line granularity (notably Applied Epic) while retaining
   * the member POLICY entity IDs needed to filter documents.
   */
  amsAccountPolicyGroups: Array<AmsAccountPolicyGroup>;
  /**
   * Returns the freshness/status snapshot for an AMS account. scope defaults to
   * DOCUMENTS; pass STRUCTURED to track the sibling refresh that enriches
   * policies and certificates instead.
   */
  amsAccountSyncStatus: AmsAccountSyncStatus;
  /**
   * The agencies a new account in the AMS can be filed under, each with its branches, in
   * the AMS's order. createAmsAccount takes one agency and one of its branches. Read live
   * from the integration; an agency with no branches is left out.
   */
  amsAgencyStructure: Array<AmsAgency>;
  /**
   * Searches one integration's accounts: the synced ones, or the AMS live when none
   * synced matches.
   */
  amsBrowseAccounts: AmsBrowseAccountsResult;
  /** Lists the account's most recent activities that accept email attachments. */
  amsBrowseActivities: Array<AmsBrowseActivity>;
  /** What the AMS browser can do with each of the agency's active integrations. */
  amsBrowseCapabilities: Array<AmsBrowseCapability>;
  /** Lists an account's certificates, newest first. */
  amsBrowseCertificates: AmsBrowseCertificatesResult;
  /**
   * Lists the files of one account (not its policies') or of one policy, newest
   * attached first.
   */
  amsBrowseFiles: AmsBrowseFilesResult;
  /** Lists folders and categories applicable to an account in its integration. */
  amsBrowseFolders: Array<AmsBrowseFolder>;
  /** Lists an account's policies, latest expiring first, one row per policy term. */
  amsBrowsePolicies: AmsBrowsePoliciesResult;
  /**
   * Finds one integration's policies by policy number, each with its account:
   * the synced ones, or the AMS live when none synced matches.
   */
  amsBrowsePolicySearch: AmsBrowsePolicySearchResult;
  /**
   * Lists the destinations a reconciliation pass could write to on one account, with
   * detection tags.
   */
  amsReconciliationTargets: AmsReconciliationTargets;
  /**
   * The color schemes offered before anyone picks a color by hand. The unconfigured brand is
   * always one of them.
   */
  brandColorSchemes: Array<BrandColorScheme>;
  /** How each element is set before anybody changes it, which is what a revert restores. */
  brandElementDefaults: Array<BrandElementStyle>;
  /**
   * Every typeface a brand may choose, which is every typeface the renderer has
   * installed. Offering one it does not have repaginates every document set in it.
   */
  brandTypefaces: Array<BrandTypeface>;
  businessPolicies: Array<BusinessPolicy>;
  /** Get a single business policy by ID */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** Get a call by its ID */
  call: Call;
  /** Get aggregated call report data */
  callReport: CallReport;
  /**
   * Get a list of calls
   * @deprecated Use searchCalls for paginated results
   */
  calls: Array<Call>;
  /** Get a Cara workspace by its ID */
  caraWorkspace?: Maybe<CaraWorkspace>;
  caraWorkspaceArtifact?: Maybe<CaraWorkspaceArtifactSummary>;
  /** Comments on a document, oldest first, each placed in the document as it reads now. */
  caraWorkspaceArtifactComments: Array<CaraWorkspaceArtifactComment>;
  /**
   * Get a list of Cara workspace artifacts for the documents view.
   * This query returns artifacts grouped by artifact ID, with all versions included.
   * Each artifact includes a reference to its workspace.
   * This is optimized to return only the minimal data needed to render the documents view,
   * avoiding the overhead of loading full workspace data (messages, plan stages, etc.).
   */
  caraWorkspaceArtifacts: Array<CaraWorkspaceArtifactSummary>;
  /**
   * Get Cara workspaces for the agency.
   * Deprecated: use searchCaraWorkspaces for paginated, server-side filtered results.
   * @deprecated Use searchCaraWorkspaces for paginated, server-side filtered results
   */
  caraWorkspaces: Array<CaraWorkspace>;
  carriers: Array<InsuranceCarrier>;
  /** Get a certificate of insurance by its certificate number */
  certificate?: Maybe<CertificateOfLiabilityInsurance>;
  client?: Maybe<Client>;
  /**
   * The merge queue for the caller's agency, highest-scoring first.
   *
   * Defaults to PENDING. Passing a resolved status reads the history instead,
   * which is the only way to find a merge after the fact.
   */
  clientMergeCandidates: ClientMergeCandidateConnection;
  /** A client's notepad, newest first. */
  clientNotes: Array<ClientNote>;
  /**
   * The Clients list, and the search behind the workspace-association picker.
   * Scoped to the caller's agency unless the caller holds GLOBAL scope.
   */
  clients: ClientConnection;
  /** Returns a single account contact by ID. Only accessible by agency users. */
  contact?: Maybe<AccountContact>;
  /** Returns a list of all account contacts. Only accessible by agency users. */
  contacts: Array<AccountContact>;
  /** Get the options for creating a certificate of insurance */
  createCertificateOptions?: Maybe<CreateCertificateOptions>;
  customForm: CustomForm;
  customForms: Array<CustomForm>;
  /**
   * Get a custom preset by its ID. Fixed scopes (rather than a dynamic
   * CUSTOM_PRESET scope) because the resolver body is the authoritative
   * row-level gate: it enforces per-user PRIVATE/SHARED visibility for
   * own-agency presets and the cross-agency shared-preset read gate
   * (grant + PUBLIC + not archived + live federation) for foreign ones.
   */
  customPreset: CustomPreset;
  /** Get custom presets for the agency */
  customPresets: Array<CustomPreset>;
  /**
   * The Cara default ACORD COI/EOI configuration. Agencies persist only their
   * overrides (see ACORDFormConfiguration); a null override field resolves to the
   * matching value returned here. The Settings UI reads this to display effective
   * values and to pre-populate the preset rules for an agency that has not
   * customized a setting, without baking the default into the persisted object.
   */
  defaultACORDFormConfiguration: AcordFormConfiguration;
  emailAmsLogOptions: EmailAmsLogOptions;
  emailBulkSend?: Maybe<EmailBulkSend>;
  /**
   * The agency's most recent bulk emails, drafts included, newest first. Empty while bulk
   * send is off.
   */
  emailBulkSends: Array<EmailBulkSend>;
  /**
   * A template, archived or not. Null while the email templates gate is off. A missing ID,
   * another agency's template and one the caller can't see all answer the same NOT_FOUND.
   */
  emailTemplate?: Maybe<EmailTemplate>;
  /**
   * The agency's templates that are not archived, newest first. Empty while the email templates
   * gate is off.
   */
  emailTemplates: Array<EmailTemplate>;
  /** Get a thread by its ID */
  emailThread: EmailThread;
  /** Get a list of threads */
  emailThreads: Array<EmailThread>;
  /** Get an Excel spreadsheet template by its ID */
  excelSpreadsheetTemplate: ExcelSpreadsheetTemplate;
  /** Get Excel spreadsheet templates for the agency */
  excelSpreadsheetTemplates: Array<ExcelSpreadsheetTemplate>;
  /**
   * Get child agencies that can be granted access to knowledge bases.
   * Returns agencies where the current agency is the parent with FEDERATED_BILLING.
   */
  federatedChildAgencies: Array<Agency>;
  /** Get feedback based on filters. */
  getFeedback: Array<Feedback>;
  /** Get a HTML document template by its ID */
  htmlDocumentTemplate: HtmlDocumentTemplate;
  /**
   * Ready-made templates the agency can copy into its library. Empty while designs are off for the
   * agency.
   */
  htmlDocumentTemplateStarters: Array<HtmlDocumentTemplateStarter>;
  /** Get HTML document templates for the agency */
  htmlDocumentTemplates: Array<HtmlDocumentTemplate>;
  /** Get all deal pipelines from HubSpot */
  hubspotDealPipelines: Array<HubSpotPipeline>;
  /** Get all ticket pipelines from HubSpot */
  hubspotTicketPipelines: Array<HubSpotTicketPipeline>;
  /** Get an integration by its ID */
  integration?: Maybe<Integration>;
  /**
   * List capabilities for all supported integrations (read + write). The
   * workflow builder uses this to render dynamic configuration UI for
   * OUTPUT_INTEGRATION and INPUT_AMS_READ tasks.
   */
  integrationCapabilities: Array<IntegrationCapability>;
  /**
   * Get an integration sync log by its ID. Used for the admin sync-log detail view
   * and deep linking into the sync-log drawer.
   */
  integrationSyncLog?: Maybe<IntegrationSyncLog>;
  /**
   * Get integrations. In agency scope, returns only integrations for the caller's agency.
   * In global (admin) scope, returns across all agencies, optionally filtered by agencyId.
   */
  integrations: Array<Integration>;
  /** Get a knowledge base by its ID */
  knowledgeBase?: Maybe<KnowledgeBase>;
  /** Get a document by its ID */
  knowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  /** Get all knowledge bases (owned by the current agency + shared with the current agency) */
  knowledgeBases: Array<KnowledgeBase>;
  /** Browse and search knowledge graph entities for a given agency. Requires GLOBAL scope. */
  knowledgeGraphEntities: KnowledgeGraphEntityConnection;
  /** The newest readable sent email per artifact, for at most 50 unique artifact IDs. */
  latestSentOutboundEmails: Array<OutboundEmail>;
  /**
   * The mailboxes the authenticated user may send from: the ones they connected,
   * plus any shared with them or one of their teams. A colleague's unshared
   * mailbox is never returned, and neither is one shared with someone else.
   */
  mailboxAccounts: Array<MailboxAccount>;
  mailboxBulkSendUsage: MailboxBulkSendUsage;
  /**
   * The composer's ceilings. Constant for the deployment and free to answer, so
   * it takes no arguments and reads nothing; a composer asks for it alongside the
   * mailboxes it is already loading.
   */
  mailboxComposeLimits: MailboxComposeLimits;
  /**
   * The agency's mailbox lifecycle trail, with private notification activity
   * visible only to each mailbox's owner. Other viewers never receive notification
   * rows or private correlation metadata. No ordinary-mail content is retained.
   *
   * Filtering by an email reads its story oldest first. Filtering by a mailbox,
   * or not at all, reads newest first. Visibility and the optional activity stream
   * filter apply before the limit (default 200, maximum 500).
   */
  mailboxEvents: Array<MailboxEvent>;
  /**
   * Read one owned mailbox's full folder tree when opening its monitoring picker,
   * without making a live provider call for every account in mailboxAccounts.
   * Sharing send access does not grant access to this tree.
   */
  mailboxFolders: Array<MailboxFolder>;
  /**
   * Messages recorded by monitoring, newest recorded first (default 200, maximum
   * 500). Owner-only even when send access is shared. Existing recorded messages
   * are included; mail from before monitoring or outside watched folders is not.
   */
  mailboxMessageActivity: Array<MailboxMessageActivity>;
  /**
   * Minimal offboarding choices, also available when mailbox rollout is off.
   * Only already-readable accounts the caller may disconnect are returned.
   * Admin offboarding permission does not grant discovery of private accounts.
   * Subscription entitlement is still required. This never contacts a provider.
   */
  mailboxOffboardingAccounts: Array<MailboxOffboardingAccount>;
  /**
   * The providers this deployment can actually connect a mailbox to, not the
   * ones the schema knows how to name: an adapter registers at startup only when
   * its app registration is present, so an environment without those credentials
   * answers with an empty list. A settings page offers a provider to connect only
   * if it appears here.
   */
  mailboxProviders: Array<MailboxProvider>;
  /**
   * The signatures the caller may pick in the composer: their own, the
   * agency-wide ones, and any shared with them or their teams.
   */
  mailboxSignatures: Array<MailboxSignature>;
  /**
   * Matches a sent email's To addresses like resolveEmailAmsAccounts, for pushing it. Only
   * those who may push the email may. The choice is the client a push naming none logs
   * to. Null when no AMS logs the agency's emails. Unlike resolveEmailAmsAccounts, refused
   * while email logging is off, like the push it serves.
   */
  matchAmsAccountsForOutboundEmail?: Maybe<EmailAmsMatch>;
  /**
   * List memories for the caller's agency. Agents see their own agent-scoped
   * memories plus all organization memories. Admins can filter by agencyUserId.
   */
  memories: Array<Memory>;
  /** Get a single memory by ID. */
  memory: Memory;
  outboundCall: OutboundCall;
  /**
   * Rolling 30-day AI outbound call usage for a customer phone in the caller's agency.
   * Used by the schedule dialog to show N of 3 before place/schedule.
   * Organization scope only — the count is keyed by principal.OrgID.
   */
  outboundCallFrequency: OutboundCallFrequency;
  outboundCallReport: OutboundCallReport;
  /** @deprecated Use searchOutboundCalls for paginated results */
  outboundCalls: Array<OutboundCall>;
  /**
   * Matches an email's To addresses to accounts in the AMS that logs the agency's sent
   * emails, ignoring the agency's own addresses. Null when no AMS logs the agency's emails.
   */
  resolveEmailAmsAccounts?: Maybe<EmailAmsMatch>;
  /**
   * Searches AMS accounts (KnowledgeGraphEntity type=ACCOUNT) across the caller's
   * agency integrations that support document browsing. Matches account name, email,
   * phone, and lookup code; a query that matches a policy number also returns the
   * policy's owning account. An empty query returns the most recently modified
   * accounts so the picker can show an initial browseable list. Returns an empty
   * list when the agency has no document-capable AMS integration.
   */
  searchAmsAccounts: AmsAccountSearchResult;
  /**
   * Searches like searchEmailAmsAccounts, for pushing a sent email: its workspace may be
   * gone, or one the pusher can't read, so only those who may push the email may search.
   */
  searchAmsAccountsForOutboundEmail: Array<AmsBrowseAccount>;
  /**
   * Searches the agency's Applied Epic integration live, importing nothing, so it finds
   * accounts searchAmsAccounts cannot because Cara has not synced them. An email- or
   * phone-shaped query is searched as that; a code-shaped one is also tried as a lookup
   * code and policy number. Empty when the agency has no Applied Epic integration.
   */
  searchAmsAccountsLive: Array<AmsAccountMatch>;
  /**
   * Searches POLICY entities by policy number across the caller's agency integrations
   * that support document browsing, returning each match with its owning account so the
   * picker's "Policies" mode can land directly on a policy's documents. Only matches
   * policies already synced to the knowledge graph (use findAmsPolicy for a live lookup
   * of an unsynced policy). Returns an empty list for a blank query or when the agency
   * has no document-capable AMS integration.
   */
  searchAmsPolicies: Array<AmsPolicySearchResult>;
  /** Search calls with cursor-based pagination */
  searchCalls: CallConnection;
  /**
   * The artifacts the caller may read, newest-composed first, one page at a time.
   *
   * Same rows and same reach as `caraWorkspaceArtifacts` — agency-scoped, then
   * filtered by each artifact's own visibility. Archive state is not applied: the
   * outbox reads this as a ledger, and an archived email still went out.
   *
   * Ordered by `composedAt` rather than by the summary's `createdAt` or
   * `updatedAt`: a revised artifact must not jump the queue, because a client
   * merging this list with another (the outbox merges it with the mailbox draft
   * and send ledgers) relies on an artifact never sorting after a record made
   * from it.
   */
  searchCaraWorkspaceArtifacts: CaraWorkspaceArtifactConnection;
  /** Search Cara workspaces with cursor-based pagination, server-side filtering and sorting */
  searchCaraWorkspaces: CaraWorkspaceConnection;
  /**
   * Searches documentation for a given query string.
   * Returns a SearchDocumentationResult containing matched documentation.
   */
  searchDocumentation: SearchDocumentationResult;
  /**
   * Searches the accounts of the AMS that logs the agency's sent emails, for an email in
   * the workspace: the synced ones, or the AMS live when none synced matches.
   */
  searchEmailAmsAccounts: Array<AmsBrowseAccount>;
  /** Get a file by ID */
  searchFiles: Array<SearchFileResult>;
  /** Search integration sync logs with cursor-based pagination, server-side filtering and sorting. */
  searchIntegrationSyncLogs: IntegrationSyncLogConnection;
  /**
   * The drafts Cara has written into the agency's connected mailboxes, newest
   * first. There is no sort argument: the list answers "what is waiting", and
   * waiting is measured in one direction.
   *
   * Scoped like `searchOutboundEmails`: a draft is as readable as the email it
   * was written from, and an agency admin reads them all.
   */
  searchMailboxDrafts: MailboxDraftConnection;
  /**
   * Search the memories visible to the caller using stable, newest-first cursor
   * pagination. Defaults to 25 results and accepts at most 100 per page.
   */
  searchMemories: MemoryConnection;
  /** Search outbound calls with cursor-based pagination */
  searchOutboundCalls: OutboundCallConnection;
  /**
   * The outbound send log, newest first: the emails Cara sent that the caller may
   * read. Each row carries the audience of the draft it was composed from, so a
   * send from a private workspace stays as private as the draft was, and an
   * agency admin reads the whole log as the compliance record the agency is
   * accountable for.
   */
  searchOutboundEmails: OutboundEmailConnection;
  /**
   * Searches the caller's agency for parties to address an email to: CONTACT and
   * ACCOUNT entities that have an email address, across every ACTIVE AMS
   * integration the agency has connected. Unlike `searchAmsAccounts`, not
   * restricted to document-capable integrations.
   *
   * Matches contact and account name, either email address, and the entity's
   * display name; every whitespace-separated token must match at least one of
   * them. Returns an empty list until some whitespace-separated token reaches
   * three characters, and when the agency has no active AMS integration.
   *
   * Colleagues are not included: the client merges AgencyUser results in.
   */
  searchRecipients: Array<RecipientSuggestion>;
  /**
   * Search trace analyses with cursor-based pagination, server-side filtering and sorting.
   * Requires GLOBAL (admin) scope.
   */
  searchTraceAnalysis: TraceAnalysisConnection;
  /**
   * Search traces with cursor-based pagination, server-side filtering and sorting.
   * Requires GLOBAL (admin) scope.
   */
  searchTraces: TraceConnection;
  /** Get a service request by ID, if the current user is associated with the service request */
  serviceRequest?: Maybe<ServiceRequest>;
  /**
   * Get all service requests associated with any accounts that belong to the agency of the
   * currently logged in agency user, or the account ID if specified and if the user has
   * permission to view them.
   */
  serviceRequests: Array<ServiceRequest>;
  smartFillBucket: SmartFillBucket;
  /** The bucket profiles, most carriers first; empty while site profiles are off for the caller. */
  smartFillBucketProfiles: Array<SmartFillBucketProfile>;
  smartFillBuckets: Array<SmartFillBucket>;
  /**
   * The carrier sites a bucket can be configured for; empty while the gate or
   * smart_fill_carrier_sites_enabled is off.
   */
  smartFillCarrierSites: Array<SmartFillCarrierSite>;
  /**
   * The bucket's questions: its line of business's in general, or one carrier
   * site's when carrierSiteId names one. Null while the gate is off, when the
   * bucket is not a general bucket, or when the caller cannot see it or its
   * workspace. FORBIDDEN for a carrier site while smart_fill_carrier_sites_enabled
   * is off.
   */
  smartFillFormBucketQuestions?: Maybe<SmartFillFormBucketQuestions>;
  /**
   * The caller's general buckets, most recently built first (up to 100). Empty
   * while the smart_fill_acord_buckets_enabled gate is off.
   */
  smartFillFormBuckets: Array<SmartFillFormBucket>;
  smartFillLearningOperation: SmartFillLearningOperation;
  /** The calling user's current correction rules for one form. */
  smartFillOverrides: Array<SmartFillOverride>;
  /** At most 100 keys. Global retry ordering, not permission to write or change values. */
  smartFillRetryAdvice: Array<SmartFillRetryAdvice>;
  /** Recent visible buckets explicitly linked by workspace conversion (up to 100). */
  smartFillWorkspaceBuckets: Array<SmartFillBucket>;
  /**
   * Get a span by its OTel span ID, fully hydrated — including the heavy detail payloads
   * that the trace waterfall path (Trace.rootSpans / Span.children) omits. This is what
   * backs the span detail pane when a span is selected.
   * Requires GLOBAL (admin) scope.
   */
  span?: Maybe<Span>;
  /** Returns a link to the subscription management page for the current account */
  subscriptionManagementLinks?: Maybe<SubscriptionManagementLinks>;
  /**
   * Clients this workspace might belong to, best first.
   *
   * Empty until the workspace has completed a run: the name this matches on is
   * extracted from the first run's summary, so an empty list means "too early to
   * say" rather than "no candidates". Empty also for a workspace already linked to
   * a client, since there is nothing left to suggest.
   */
  suggestedClientsForWorkspace: Array<ClientSuggestion>;
  /**
   * Returns a team by its ID. Accessible to admins and members of the team.
   * Resolver enforces membership for non-admin callers.
   */
  team?: Maybe<Team>;
  /** Returns all teams within the current agency. Admin-only. */
  teams: Array<Team>;
  /**
   * The editable fields of a template form artifact version (the latest when
   * version is omitted), with who last set each one.
   */
  templateFormEditorState: TemplateFormEditorState;
  /**
   * Get a trace by its OTel trace ID. Used for the trace detail / waterfall view.
   * Requires GLOBAL (admin) scope.
   */
  trace?: Maybe<Trace>;
  /**
   * Get a trace analysis by its ID.
   * Requires GLOBAL (admin) scope.
   */
  traceAnalysis?: Maybe<TraceAnalysis>;
  /**
   * Get correlated log records for a trace, with optional span/severity filtering.
   * Requires GLOBAL (admin) scope.
   */
  traceLogs: LogRecordConnection;
  /**
   * The columns of a transfer directory CSV import. The server that validates a saved
   * directory defines them, so the import page and the save agree on what a row needs.
   */
  transferDirectoryImportSchema: ImportSchema;
  triggerDefinition?: Maybe<TriggerDefinition>;
  triggerDefinitions: Array<TriggerDefinition>;
  /** What the email trigger create page can offer: eligible Outlook mailboxes, users, access profiles and presets. */
  triggerEmailBuilderOptions: TriggerEmailBuilderOptions;
  /** One eligible mailbox's current folders, listed from the provider (Drafts excluded). */
  triggerEmailFolders: Array<TriggerEmailFolderOption>;
  /**
   * Mailbox trigger runs the caller may see, newest first: one trigger's, or every
   * mailbox trigger's when triggerDefinitionId is omitted.
   */
  triggerEmailRuns: Array<TriggerEmailRun>;
  triggerEvent?: Maybe<TriggerEvent>;
  /**
   * Recent trigger events for the caller's agency, newest received_at first.
   * Keyset-paginated on (received_at, id). With triggerDefinitionId, only events
   * that produced a run for that trigger are returned.
   */
  triggerEvents: TriggerEventConnection;
  /**
   * Accessible matching history, newest immutable receivedAt/queuedAt first, then
   * source kind and id (C order), descending. First must be 1..50. Opaque versioned
   * cursors bind caller, agency and filters, never authority. Every page rechecks
   * current access. Unshown rows from either source remain eligible. New arrivals
   * after the first page's ceiling require refresh; filters/status/access are not
   * a historical snapshot. A source failure fails the whole page without advancing.
   */
  triggerExecutionHistory: TriggerExecutionHistoryConnection;
  /** Get a voice agent by its ID */
  voiceAgent: VoiceAgent;
  /** Get the default voice agent configuration */
  voiceAgentDefaultConfiguration: VoiceAgentConfiguration;
  /** Get the provider and language capabilities used by voice-agent settings. */
  voiceAgentLanguageSupport: VoiceAgentLanguageSupport;
  /** Get a list of voice agents */
  voiceAgents: Array<VoiceAgent>;
  /** Get a Word document template by its ID */
  wordDocumentTemplate: WordDocumentTemplate;
  /** Get Word document templates for the agency */
  wordDocumentTemplates: Array<WordDocumentTemplate>;
  /**
   * Get a workflow definition by ID. Scoped via WORKFLOW_DEFINITION so the
   * directive denies access if the definition belongs to another agency.
   */
  workflowDefinition?: Maybe<WorkflowDefinition>;
  /** List workflow definitions for the current agency */
  workflowDefinitions: Array<WorkflowDefinition>;
  /**
   * Get a workflow execution by ID, returning the latest version. Scoped via
   * WORKFLOW_EXECUTION so the directive denies access if the execution
   * belongs to another agency.
   */
  workflowExecution?: Maybe<WorkflowExecution>;
  /** List workflow executions for the current agency */
  workflowExecutions: Array<WorkflowExecution>;
  /**
   * List all available task definitions from the registry. Returns the
   * definitions with their input/output schemas so the UI can build
   * workflow definitions.
   */
  workflowTaskDefinitions: Array<WorkflowTaskDefinition>;
  /** Get aggregated workspace analytics for the admin dashboard */
  workspaceReport: WorkspaceReport;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAccountArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAdminAnalyticsAgencyProfileOptionsArgs = {
  subagencyId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAdminAnalyticsReportArgs = {
  filter?: InputMaybe<AdminAnalyticsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgenciesArgs = {
  filter?: InputMaybe<AgencyFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyArgs = {
  id?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyProfileArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyProfilesArgs = {
  agencyId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAgencyUserProfileAssignmentArgs = {
  agencyUserId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountCertificatesArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountDocumentsArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  looseFilesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  policyId?: InputMaybe<Scalars['ID']['input']>;
  policyIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountPoliciesArgs = {
  accountId: Scalars['ID']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountPolicyGroupsArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAccountSyncStatusArgs = {
  accountId: Scalars['ID']['input'];
  scope?: InputMaybe<AmsAccountSyncScope>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsAgencyStructureArgs = {
  integrationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowseAccountsArgs = {
  input: AmsBrowseAccountsInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowseActivitiesArgs = {
  input: AmsBrowseActivitiesInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowseCertificatesArgs = {
  input: AmsBrowseCertificatesInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowseFilesArgs = {
  input: AmsBrowseFilesInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowseFoldersArgs = {
  input: AmsBrowseFoldersInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowsePoliciesArgs = {
  input: AmsBrowsePoliciesInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsBrowsePolicySearchArgs = {
  input: AmsBrowsePolicySearchInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryAmsReconciliationTargetsArgs = {
  input: AmsReconciliationTargetsInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryBusinessPolicyArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallReportArgs = {
  filter?: InputMaybe<CallFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCallsArgs = {
  filter?: InputMaybe<CallFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArtifactArgs = {
  artifactId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArtifactCommentsArgs = {
  artifactId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspaceArtifactsArgs = {
  filter?: InputMaybe<CaraWorkspaceArtifactFilter>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCaraWorkspacesArgs = {
  filter?: InputMaybe<CaraWorkspaceFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCertificateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientMergeCandidatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<ClientMergeCandidateStatus>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientNotesArgs = {
  clientId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryClientsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<ClientSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryContactArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCreateCertificateOptionsArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomFormArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomFormsArgs = {
  filter?: InputMaybe<CustomFormsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomPresetArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryCustomPresetsArgs = {
  filter?: InputMaybe<CustomPresetsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailAmsLogOptionsArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailBulkSendArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailBulkSendsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  unsentOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryEmailThreadArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryExcelSpreadsheetTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryExcelSpreadsheetTemplatesArgs = {
  filter?: InputMaybe<ExcelSpreadsheetTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryGetFeedbackArgs = {
  input: GetFeedbackInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHtmlDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHtmlDocumentTemplatesArgs = {
  filter?: InputMaybe<HtmlDocumentTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHubspotDealPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryHubspotTicketPipelinesArgs = {
  integrationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationSyncLogArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryIntegrationsArgs = {
  filter?: InputMaybe<IntegrationsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeBaseArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeBaseDocumentArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryKnowledgeGraphEntitiesArgs = {
  filter: KnowledgeGraphEntityFilter;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryLatestSentOutboundEmailsArgs = {
  workspaceArtifactIds: Array<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMailboxBulkSendUsageArgs = {
  mailboxAccountId: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMailboxEventsArgs = {
  filter?: InputMaybe<MailboxEventsFilterInput>;
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMailboxFoldersArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMailboxMessageActivityArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  mailboxAccountId: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMatchAmsAccountsForOutboundEmailArgs = {
  outboundEmailId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMemoriesArgs = {
  input?: InputMaybe<MemoriesInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryMemoryArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallFrequencyArgs = {
  excludeOutboundCallId?: InputMaybe<Scalars['ID']['input']>;
  phone: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallReportArgs = {
  filter?: InputMaybe<OutboundCallReportFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryOutboundCallsArgs = {
  filter?: InputMaybe<OutboundCallsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryResolveEmailAmsAccountsArgs = {
  artifactId: Scalars['String']['input'];
  toAddresses: Array<Scalars['String']['input']>;
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsAccountsForOutboundEmailArgs = {
  outboundEmailId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsAccountsLiveArgs = {
  input: SearchAmsAccountsLiveInput;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchAmsPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CallFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CallSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCaraWorkspaceArtifactsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CaraWorkspaceArtifactsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchCaraWorkspacesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchCaraWorkspacesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<CaraWorkspaceSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchDocumentationArgs = {
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchEmailAmsAccountsArgs = {
  query: Scalars['String']['input'];
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchFilesArgs = {
  filters: SearchFileFilter;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchIntegrationSyncLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchIntegrationSyncLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<IntegrationSyncLogSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchMailboxDraftsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MailboxDraftsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchMemoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MemorySearchFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchOutboundCallsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundCallsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OutboundCallSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchOutboundEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundEmailsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<OutboundEmailSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchRecipientsArgs = {
  entityTypes?: InputMaybe<Array<KnowledgeGraphEntityType>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchTraceAnalysisArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchTraceAnalysisFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraceAnalysisSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySearchTracesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchTracesFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<TraceSortInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryServiceRequestArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryServiceRequestsArgs = {
  accountId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillBucketArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillBucketsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillFormBucketQuestionsArgs = {
  bucketId: Scalars['ID']['input'];
  carrierSiteId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillLearningOperationArgs = {
  operationId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillOverridesArgs = {
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillRetryAdviceArgs = {
  keys: Array<SmartFillRetryKeyInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySmartFillWorkspaceBucketsArgs = {
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySpanArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QuerySuggestedClientsForWorkspaceArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTeamArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTemplateFormEditorStateArgs = {
  artifactId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
  workspaceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceAnalysisArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTraceLogsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TraceLogsFilterInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  traceId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerDefinitionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerEmailBuilderOptionsArgs = {
  definitionId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerEmailFoldersArgs = {
  accountId: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerEmailRunsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
  triggerDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerEventArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerEventsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  triggerDefinitionId?: InputMaybe<Scalars['ID']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryTriggerExecutionHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TriggerExecutionHistoryFilter>;
  first?: Scalars['Int']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryVoiceAgentArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryVoiceAgentsArgs = {
  filter?: InputMaybe<VoiceAgentsFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWordDocumentTemplateArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWordDocumentTemplatesArgs = {
  filter?: InputMaybe<WordDocumentTemplatesFilterInput>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkflowDefinitionArgs = {
  id: Scalars['ID']['input'];
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkflowExecutionArgs = {
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int64']['input']>;
};


/**
 * Root operation types. Declared empty here so GraphQL.js / frontend codegen can
 * merge the many `extend type Query|Mutation|Subscription` blocks across schema
 * files; gqlgen invents these automatically, but graphql-codegen does not.
 */
export type QueryWorkspaceReportArgs = {
  filter: WorkspaceReportFilter;
};

/** Details for a request for questions about policies, account, or billing, etc. */
export type QuestionRequest = {
  __typename?: 'QuestionRequest';
  /** ID of the policy related to the question, if applicable */
  policyId?: Maybe<Scalars['String']['output']>;
  /** Question from the customer */
  question: Scalars['String']['output'];
  /** Type of question */
  type: QuestionRequestType;
};

/** Input type for requesting questions */
export type QuestionRequestInput = {
  /** ID of the policy related to the question, if applicable */
  policyId?: InputMaybe<Scalars['String']['input']>;
  /** Question from the customer */
  question: Scalars['String']['input'];
  /** Type of question */
  type?: InputMaybe<QuestionRequestType>;
};

/** Types of questions that can be requested */
export enum QuestionRequestType {
  /** Question about account management */
  Account = 'ACCOUNT',
  /** Question about billing and payments */
  Billing = 'BILLING',
  /** Other questions */
  Other = 'OTHER',
  /** Question about policies */
  Policy = 'POLICY'
}

/**
 * One addressable party the mail composer can offer for a To/CC/BCC field.
 * Sourced from the agency's AMS knowledge graph; the client merges its own
 * colleague list (AgencyUser) into the same shape before rendering.
 */
export type RecipientSuggestion = {
  __typename?: 'RecipientSuggestion';
  /**
   * The knowledge-graph ID of the AMS account when the suggestion is the account
   * itself. Null for a contact.
   */
  amsAccountId?: Maybe<Scalars['String']['output']>;
  /**
   * Secondary line in the dropdown: for a contact, the account they belong to;
   * for an account, its own name when it differs from the display name.
   */
  description?: Maybe<Scalars['String']['output']>;
  /**
   * The email address to send to. Always present — the search never returns a
   * party without one.
   */
  email: Scalars['String']['output'];
  /** Display name for the chip, when the AMS supplied one. */
  name?: Maybe<Scalars['String']['output']>;
};

/**
 * One observability event. FILL events carry per-field decision metadata
 * (field key, status, reason, confidence, source, property ID) and write
 * verification outcomes; COPY events record Super Copy captures; CORRECTION
 * events are written server side when override rules change.
 *
 * Requiredness is enforced server side per action: FILL requires bucketId,
 * bucketRevision, formFingerprint, formSnapshotHash, requestId, and
 * promptVersion (modelId only when a model call happened); COPY requires
 * bucketId.
 */
export type RecordSmartFillEventInput = {
  action: SmartFillEventAction;
  bucketId?: InputMaybe<Scalars['ID']['input']>;
  bucketRevision?: InputMaybe<Scalars['Int64']['input']>;
  formFingerprint?: InputMaybe<Scalars['String']['input']>;
  formSnapshotHash?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['JSON']['input']>;
  modelId?: InputMaybe<Scalars['String']['input']>;
  operationId: Scalars['ID']['input'];
  /**
   * Optional gzip-compressed page HTML captured alongside the action, stored
   * as opaque private evidence like the screenshot.
   */
  pageHtml?: InputMaybe<Scalars['Upload']['input']>;
  promptVersion?: InputMaybe<Scalars['String']['input']>;
  requestId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional page screenshot captured alongside the action (PNG). Stored as
   * opaque private evidence referenced from the event row; the event metadata
   * itself stays value-free.
   */
  screenshot?: InputMaybe<Scalars['Upload']['input']>;
};

/** Input for reinstating a business policy */
export type ReinstateBusinessPolicyInput = {
  /** When the reinstatement becomes effective */
  effectiveAt: Scalars['Time']['input'];
  /** A description of why the policy is being reinstated */
  reasonDescription: Scalars['String']['input'];
};

/** Input for renewing a business policy */
export type RenewBusinessPolicyInput = {
  /** The agency billing type, if applicable */
  agencyBillingType?: InputMaybe<BusinessPolicyAgencyBillingType>;
  /** Additional fees collected by the agency as revenue. */
  agencyFees: Scalars['Float']['input'];
  /** How to create the Ascend program */
  ascendProgramCreationMode?: InputMaybe<AscendProgramCreationMode>;
  /** ID of specific Ascend program to use */
  ascendProgramId?: InputMaybe<Scalars['String']['input']>;
  /** The billing type for the policy */
  billingType: BusinessPolicyBillingType;
  /** Fees collected by the wholesale broker */
  brokerFees: Scalars['Float']['input'];
  /** The estimated commission the agency earns on this policy */
  estimatedCommission: Scalars['Float']['input'];
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into force */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees: Scalars['Float']['input'];
  /** Fees collected by the carrier to administer the policy or program */
  policyFees: Scalars['Float']['input'];
  /** The policy number, if available */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium: Scalars['Float']['input'];
  /** The quote number associated with the renewal */
  quoteNumber: Scalars['String']['input'];
  /** The state of the policy */
  state: PolicyState;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes: Scalars['Float']['input'];
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total: Scalars['Float']['input'];
};

/** Result of requesting a background AMS account refresh. */
export type RequestAmsAccountRefreshResult = {
  __typename?: 'RequestAmsAccountRefreshResult';
  /**
   * Whether a refresh workflow was started (or was already running). False means
   * the server's freshness policy declined: the account synced within the
   * staleness window (force=false) or within the rate limit (force=true).
   */
  enqueued: Scalars['Boolean']['output'];
  /**
   * The account's CURRENT syncedAt — the client's poll baseline. The refresh is
   * complete when amsAccountSyncStatus.account.syncedAt advances past this.
   */
  syncedAt: Scalars['Time']['output'];
};

/**
 * HTML document templates from the agency library. ONLY when the user explicitly requested a template, asked what templates exist, or pre-selected one.
 *
 * DO NOT use for generic document requests (quotes, proposals, reports, letters). Do not LIST to find a template that fits.
 *
 * Operations:
 * - LIST: ONLY to resolve a user-named template to an ID or when the user asked what templates exist.
 * - GET_CONTENT: ONLY when applying a template the user requested or pre-selected.
 */
export type RequestDocumentStyleTemplatesTool = {
  __typename?: 'RequestDocumentStyleTemplatesTool';
  /** The input arguments for requesting HTML document templates */
  input: RequestDocumentStyleTemplatesToolInput;
  /** The result containing template information (metadata for LIST or body HTML for GET_CONTENT) */
  output: RequestDocumentStyleTemplatesToolOutput;
};

/**
 * Input arguments for the RequestDocumentStyleTemplatesTool.
 * Supports two operations: LIST (returns metadata without body HTML) and GET_CONTENT (returns body HTML for a specific template).
 */
export type RequestDocumentStyleTemplatesToolInput = {
  __typename?: 'RequestDocumentStyleTemplatesToolInput';
  /** The operation to perform: LIST returns template metadata without body HTML GET_CONTENT returns the body HTML for a specific template. */
  operation: Scalars['String']['output'];
  /** The template ID to get content for. Required when operation is GET_CONTENT. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of a RequestDocumentStyleTemplatesTool operation.
 * For LIST operation: contains array of templates with metadata (no bodyHTML).
 * For GET_CONTENT operation: contains array with single template including bodyHTML.
 */
export type RequestDocumentStyleTemplatesToolOutput = {
  __typename?: 'RequestDocumentStyleTemplatesToolOutput';
  /** The list of HTML document templates. For LIST contains all templates without bodyHTML. For GET_CONTENT contains single template with bodyHTML. */
  templates: Array<HtmlDocumentTemplateInfo>;
};

/**
 * Tool for reading the agency's email templates: LIST the ones Cara may draft from, then GET one
 * template's placeholders and Cara sections for DRAFT_EMAIL CREATE_FROM_TEMPLATE to fill.
 */
export type RequestEmailTemplatesTool = {
  __typename?: 'RequestEmailTemplatesTool';
  input: RequestEmailTemplatesToolInput;
  output?: Maybe<RequestEmailTemplatesToolOutput>;
};

export type RequestEmailTemplatesToolInput = {
  __typename?: 'RequestEmailTemplatesToolInput';
  operation: Scalars['String']['output'];
  templateId?: Maybe<Scalars['String']['output']>;
};

/** Result of RequestEmailTemplatesTool: LIST fills templates and GET fills template. */
export type RequestEmailTemplatesToolOutput = {
  __typename?: 'RequestEmailTemplatesToolOutput';
  template?: Maybe<EmailTemplateFillList>;
  templates?: Maybe<Array<EmailTemplateInfo>>;
};

/** Tool for requesting Excel (.xlsx) spreadsheet templates */
export type RequestExcelSpreadsheetTemplatesTool = {
  __typename?: 'RequestExcelSpreadsheetTemplatesTool';
  /** The input arguments for the Excel spreadsheet template request */
  input: RequestExcelSpreadsheetTemplatesToolInput;
  /** The result of the Excel spreadsheet template request */
  output?: Maybe<RequestExcelSpreadsheetTemplatesToolOutput>;
};

/**
 * Input for RequestExcelSpreadsheetTemplatesTool.
 * LIST returns Excel template metadata; GET_CONTENT returns the tabs and fields of one template.
 */
export type RequestExcelSpreadsheetTemplatesToolInput = {
  __typename?: 'RequestExcelSpreadsheetTemplatesToolInput';
  /** Operation: LIST (available Excel templates) or GET_CONTENT (tabs and fields for one template by templateId). */
  operation: Scalars['String']['output'];
  /** Required when operation is GET_CONTENT. The template ID from LIST. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of RequestExcelSpreadsheetTemplatesTool.
 * LIST: array of Excel templates (metadata only). GET_CONTENT: a single template including its tabs.
 */
export type RequestExcelSpreadsheetTemplatesToolOutput = {
  __typename?: 'RequestExcelSpreadsheetTemplatesToolOutput';
  /** The matching Excel spreadsheet templates */
  templates: Array<ExcelSpreadsheetTemplateInfo>;
};

/** Represents a meta-tool for requesting per-integration tools to be provisioned on demand. */
export type RequestIntegrationToolsTool = {
  __typename?: 'RequestIntegrationToolsTool';
  /** The input arguments for the integration tool request */
  input: RequestIntegrationToolsToolInput;
  /** The result of the integration tool request */
  output: RequestIntegrationToolsToolOutput;
};

/** Input arguments for the RequestIntegrationToolsTool. */
export type RequestIntegrationToolsToolInput = {
  __typename?: 'RequestIntegrationToolsToolInput';
  /** The IDs of the integration tools to provision */
  toolIds: Array<Scalars['String']['output']>;
};

/** Result of a RequestIntegrationToolsTool operation. */
export type RequestIntegrationToolsToolOutput = {
  __typename?: 'RequestIntegrationToolsToolOutput';
  /** The list of tools that are now available */
  availableTools: Array<Scalars['String']['output']>;
};

/**
 * Represents a tool for requesting a list of tools that can be used to fill out a template.
 * Used when the LLM needs to request a list of tools that can be used to fill out a template.
 */
export type RequestTemplateToolsTool = {
  __typename?: 'RequestTemplateToolsTool';
  /** The input arguments for the template tool request */
  input: RequestTemplateToolsToolInput;
  /** The result of the template tool request */
  output: RequestTemplateToolsToolOutput;
};

/**
 * Input arguments for the RequestTemplateToolsTool.
 * Contains the template ID to request tools for.
 */
export type RequestTemplateToolsToolInput = {
  __typename?: 'RequestTemplateToolsToolInput';
  /**
   * The state used to resolve template IDs that name a form published per state
   * (those ending in _ANY_STATE) to that state's edition of the form.
   */
  primaryRiskState?: Maybe<Scalars['String']['output']>;
  /** The ID of the template to request tools for */
  templateIds: Array<Scalars['String']['output']>;
};

/**
 * Result of a RequestTemplateToolsTool operation.
 * Contains the list of tools that can be used to fill out the template.
 */
export type RequestTemplateToolsToolOutput = {
  __typename?: 'RequestTemplateToolsToolOutput';
  /** The list of tools that can be used to fill out the template */
  availableTools: Array<Scalars['String']['output']>;
};

/** Tool for requesting Word (.docx) document templates */
export type RequestWordDocumentTemplatesTool = {
  __typename?: 'RequestWordDocumentTemplatesTool';
  /** The input arguments for the word document template request */
  input: RequestWordDocumentTemplatesToolInput;
  /** The result of the word document template request */
  output?: Maybe<RequestWordDocumentTemplatesToolOutput>;
};

/**
 * Input for RequestWordDocumentTemplatesTool.
 * LIST returns Word template metadata; GET_CONTENT returns detailed information for a specific template.
 */
export type RequestWordDocumentTemplatesToolInput = {
  __typename?: 'RequestWordDocumentTemplatesToolInput';
  /** Operation: LIST (available Word templates) or GET_CONTENT (wordTemplateFileId for one template by templateId). */
  operation: Scalars['String']['output'];
  /** Required when operation is GET_CONTENT. The template ID from LIST. */
  templateId?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of RequestWordDocumentTemplatesTool.
 * LIST: array of Word templates (metadata only). GET_CONTENT: single template with wordTemplateFileId and docxInspection when available.
 */
export type RequestWordDocumentTemplatesToolOutput = {
  __typename?: 'RequestWordDocumentTemplatesToolOutput';
  templates: Array<WordDocumentTemplateInfo>;
};

/**
 * Rerank-specific details attached to a RERANK span. The score distribution is the
 * high-value signal: low top scores mean the answer was synthesized from weak matches.
 */
export type Rerank = {
  __typename?: 'Rerank';
  /** Candidates actually submitted to the reranker. */
  candidateCount: Scalars['Int']['output'];
  /**
   * Candidates that existed before a cap was applied; null when no cap was hit.
   * A value greater than candidateCount means candidates were dropped pre-rerank.
   */
  candidatesAvailable?: Maybe<Scalars['Int']['output']>;
  /** Total cost in dollars for this rerank call. */
  costDollars: Scalars['Decimal']['output'];
  /**
   * Gap between the last-kept and first-cut score. A tiny margin means the cutoff was
   * near-arbitrary and a relevant result may have just missed.
   */
  cutoffMargin?: Maybe<Scalars['Float']['output']>;
  /** Whether reranking errored and the caller fell back to the input order. */
  fellBack: Scalars['Boolean']['output'];
  /** Mean relevance score across candidates. */
  meanScore?: Maybe<Scalars['Float']['output']>;
  /** Lowest relevance score. */
  minScore?: Maybe<Scalars['Float']['output']>;
  /** gen_ai.provider.name (e.g. cohere, voyage). */
  providerName: Scalars['String']['output'];
  /** What the rerank serves. Null when unset. */
  purpose?: Maybe<RerankPurpose>;
  /** What candidates were scored against (user query, conversation context, or a field name). */
  query: Scalars['String']['output'];
  /** gen_ai.request.model (e.g. rerank-v4.0-pro). */
  requestModel: Scalars['String']['output'];
  /** Number of results returned (kept). */
  resultCount: Scalars['Int']['output'];
  /**
   * The candidate funnel: scores for all candidates plus snippets for the kept set and a
   * few near-misses.
   */
  results?: Maybe<Array<RerankResult>>;
  /** The requested top-k, when applicable. */
  topK?: Maybe<Scalars['Int']['output']>;
  /** Highest relevance score (0-1). */
  topScore?: Maybe<Scalars['Float']['output']>;
};

/**
 * What a rerank call serves. KG_PROPERTY_FIELDS is schema relevance (a field name vs.
 * property keys), not content relevance, so retrieval-quality views should exclude it.
 */
export enum RerankPurpose {
  FileChunks = 'FILE_CHUNKS',
  KbChunks = 'KB_CHUNKS',
  KgPropertyFields = 'KG_PROPERTY_FIELDS',
  Memory = 'MEMORY'
}

/**
 * A single candidate in a rerank funnel: its scores, final rank, and whether it survived
 * the cut. Snippets are present for the kept set and a few near-misses (redacted/truncated).
 */
export type RerankResult = {
  __typename?: 'RerankResult';
  /**
   * The chunk's sequence number within the source document, when the candidate is a chunk
   * of a larger document (KB / file search). Null for whole-object sources (e.g. a memory).
   * Together with id it identifies the exact chunk.
   */
  chunkId?: Maybe<Scalars['Int']['output']>;
  /** Stable identifier of the candidate's source (memory id, KB document id, file id). */
  id: Scalars['String']['output'];
  /** The pre-rerank score the candidate carried in (e.g. hybrid/RRF), when supplied. */
  inputScore?: Maybe<Scalars['Float']['output']>;
  /** Whether the candidate survived the top-k / threshold cut. */
  kept: Scalars['Boolean']['output'];
  /** Final rank after reranking (0-based). */
  rank: Scalars['Int']['output'];
  /** The rerank relevance score (0-1). */
  score: Scalars['Float']['output'];
  /** A redacted, truncated preview of the candidate content. */
  snippet?: Maybe<Scalars['String']['output']>;
  /** The resolved source object (memory, KB document, file), fetched from sourceType + id. */
  source?: Maybe<TraceSource>;
  /**
   * The kind of object id refers to; null for sources with no resolvable object (e.g. KG
   * property fields).
   */
  sourceType?: Maybe<TraceSourceType>;
};

export type RescheduleMailboxEmailInput = {
  /** The new send time, at least five minutes ahead. Omit to send it now. */
  sendAt?: InputMaybe<Scalars['Time']['input']>;
};

/** Input type for resolving a service request */
export type ResolveServiceRequestInput = {
  /** Files attached to the resolution */
  files: Array<Scalars['Upload']['input']>;
  /** Internal notes about the resolution */
  notes: Scalars['String']['input'];
};

export type ResolveSmartFillInput = {
  bucketId: Scalars['ID']['input'];
  expectedBucketRevision: Scalars['Int64']['input'];
  fields: Array<SmartFillResolveFieldInput>;
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  formSnapshotHash: Scalars['String']['input'];
  groups?: InputMaybe<Array<SmartFillGroupInput>>;
  /** Idempotency and audit linkage for this resolve request. */
  requestId: Scalars['ID']['input'];
  /**
   * Optional section paste: narrows the source document to this entity's
   * subtree plus its ancestors' own properties before matching.
   */
  scopeEntityId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional; single-page resolves omit it. */
  session?: InputMaybe<SmartFillSessionContextInput>;
  url: Scalars['String']['input'];
};

/**
 * Resource types that can be accessed in the system.
 * These represent the entities that permissions can be granted on.
 */
export enum Resource {
  /** Account belonging to an agency */
  Account = 'ACCOUNT',
  /** Account user, aka an agency client */
  AccountUser = 'ACCOUNT_USER',
  /** Insurance agency entity */
  Agency = 'AGENCY',
  /** Profile — a bundle of home screen, sidebar, and permission policy assigned to agency users */
  AgencyProfile = 'AGENCY_PROFILE',
  /** Agency user/employee entity */
  AgencyUser = 'AGENCY_USER',
  /** Reconciling a document against the agency's AMS: READ compares, UPDATE writes approved changes to the AMS */
  AmsReconciliation = 'AMS_RECONCILIATION',
  /** Agency product usage analytics (admin dashboard) */
  Analytics = 'ANALYTICS',
  /** Business insurance policy */
  BusinessPolicy = 'BUSINESS_POLICY',
  /** Phone call record */
  Call = 'CALL',
  /** Cara workspace for AI interactions */
  CaraWorkspace = 'CARA_WORKSPACE',
  /** Insurance carrier */
  Carrier = 'CARRIER',
  /** Certificate of insurance */
  Certificate = 'CERTIFICATE',
  /** A business or individual the agency serves (not the legacy ACCOUNT entity) */
  Client = 'CLIENT',
  /** A pair of clients awaiting a person's merge-or-keep-separate decision */
  ClientMergeCandidate = 'CLIENT_MERGE_CANDIDATE',
  /** Free-form note a user wrote on a client */
  ClientNote = 'CLIENT_NOTE',
  /** Contact/person entity associated with accounts */
  Contact = 'CONTACT',
  /** Custom fillable PDF forms */
  CustomForm = 'CUSTOM_FORM',
  /** Custom presets */
  CustomPreset = 'CUSTOM_PRESET',
  /** Email template an agency admin writes for Cara to reuse */
  EmailTemplate = 'EMAIL_TEMPLATE',
  /** Email thread */
  EmailThread = 'EMAIL_THREAD',
  /** Excel spreadsheet template (.xlsx library templates) */
  ExcelSpreadsheetTemplate = 'EXCEL_SPREADSHEET_TEMPLATE',
  /** User feedback */
  Feedback = 'FEEDBACK',
  /** Uploaded files associated with entities */
  File = 'FILE',
  /** HTML document template (library styles and letter templates) */
  HtmlDocumentTemplate = 'HTML_DOCUMENT_TEMPLATE',
  /** Third-party integration */
  Integration = 'INTEGRATION',
  /** Knowledge base */
  KnowledgeBase = 'KNOWLEDGE_BASE',
  /** Document in knowledge base */
  KnowledgeBaseDocument = 'KNOWLEDGE_BASE_DOCUMENT',
  /** Connected mailbox and the outbound email send log */
  Mailbox = 'MAILBOX',
  /** Email signature authored in Cara and appended to outbound mail */
  MailboxSignature = 'MAILBOX_SIGNATURE',
  /** Agent or organization memory */
  Memory = 'MEMORY',
  /** Outbound call job (schedule, dial intent, retries) */
  OutboundCall = 'OUTBOUND_CALL',
  /** Producer information and signature for certificates and documents */
  ProducerInformation = 'PRODUCER_INFORMATION',
  /** Role */
  Role = 'ROLE',
  /** Service request from clients */
  ServiceRequest = 'SERVICE_REQUEST',
  /** Smart Fill form mappings, buckets, and Super Copy evidence */
  SmartFill = 'SMART_FILL',
  /** Subscription and billing settings */
  Subscription = 'SUBSCRIPTION',
  /** Team — a grouping of agency users used to scope shared visibility */
  Team = 'TEAM',
  /** Versioned agency workflow trigger definition */
  TriggerDefinition = 'TRIGGER_DEFINITION',
  /** Voice agent configuration */
  VoiceAgent = 'VOICE_AGENT',
  /** Word document template (.docx library templates) */
  WordDocumentTemplate = 'WORD_DOCUMENT_TEMPLATE',
  /** Workflow definition (reusable blueprint of tasks and bindings) */
  WorkflowDefinition = 'WORKFLOW_DEFINITION',
  /** Workflow execution (a single run of a workflow definition) */
  WorkflowExecution = 'WORKFLOW_EXECUTION',
  /** Workflow task (a single task instance within an execution's DAG) */
  WorkflowTask = 'WORKFLOW_TASK'
}

/**
 * Roles that a particular user can take on. These can be specified by the user to grant or revoke certain permissions.
 * Currently, these are only applicable for users whose identity is AGENCY_USER. However, the framework is general enough
 * to support internal access control and role-based permissions for other identities.
 */
export enum Role {
  /** Admin access to the API, grants all permissions within the identity's scope. */
  Admin = 'ADMIN',
  /** User access to the API, grants access to non-billing related permissions within the identity's scope. */
  User = 'USER'
}

export type RunAmsReconciliationInput = {
  lineOfBusiness: AmsReconciliationLineOfBusiness;
  policyId: Scalars['ID']['input'];
  source: AmsReconciliationSourceInput;
};

/**
 * Sandbox-specific details attached to a SANDBOX span: one isolated code execution.
 * Resource usage is the clincher for a dedicated type, mirroring token usage on Generation.
 *
 * inputFileIds/outputFileIds are stored on the span (the surrounding tool call also holds
 * them, but the execution-level record aids debugging); the inputFiles/outputFiles fields
 * resolve them to File objects on demand.
 */
export type Sandbox = {
  __typename?: 'Sandbox';
  /** Total cost in dollars for this execution. */
  costDollars: Scalars['Decimal']['output'];
  /** Process exit code (0 = success). */
  exitCode: Scalars['Int']['output'];
  /** Files staged into the sandbox, resolved from inputFileIds. */
  inputFiles: Array<File>;
  /** Files generated by the execution, resolved from outputFileIds. */
  outputFiles: Array<File>;
  /** Runtime packages requested for the execution. */
  packages: Array<Scalars['String']['output']>;
  /** Execution provider (e.g. modal). */
  provider: Scalars['String']['output'];
  /** Billable CPU/memory usage, when Modal reported it before termination. */
  resourceUsage?: Maybe<SandboxResourceUsage>;
  /** Runtime (e.g. python3). */
  runtime: Scalars['String']['output'];
  /** The executed code, truncated to a cap at the producer. */
  script: Scalars['String']['output'];
  /** Captured stderr, truncated for storage. */
  stderr: Scalars['String']['output'];
  /** Byte size of the (stored) stderr. */
  stderrBytes: Scalars['Int']['output'];
  /** Captured stdout, truncated for storage. */
  stdout: Scalars['String']['output'];
  /** Byte size of the (stored) stdout. */
  stdoutBytes: Scalars['Int']['output'];
};

/**
 * Modal's billable sandbox resource usage. Nanosecond counters are exposed as Float
 * because they overflow a 32-bit GraphQL Int.
 */
export type SandboxResourceUsage = {
  __typename?: 'SandboxResourceUsage';
  cpuCoreNanosecs: Scalars['Float']['output'];
  memGibNanosecs: Scalars['Float']['output'];
};

/**
 * The composition approved by a human for a send with a five-second cancellation
 * window. contentRevision identifies the stored draft the composition was based on.
 */
export type ScheduleMailboxEmailInput = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  /** Unique per click; prevents a stale Cancel from stopping a later send of the same version. */
  attemptId?: InputMaybe<Scalars['String']['input']>;
  /** Milliseconds left in the click's five-second window after pending saves. Defaults to 5000; cannot exceed it. */
  cancellationWindowMs?: InputMaybe<Scalars['Int']['input']>;
  contentRevision: Scalars['String']['input'];
  email: CaraWorkspaceArtifactEmailInput;
  mailboxAccountId: Scalars['String']['input'];
  /**
   * Schedule send: send at this time instead of after the cancellation window.
   * At least five minutes ahead, with no upper limit. The email waits as SCHEDULED,
   * and its Outlook draft, if it has one, stays linked. cancellationWindowMs is
   * ignored when this is set.
   */
  sendAt?: InputMaybe<Scalars['Time']['input']>;
};

/** The accepted send and the revision saved from the approved composition. */
export type ScheduleMailboxEmailResult = {
  __typename?: 'ScheduleMailboxEmailResult';
  contentRevision: Scalars['String']['output'];
  email: OutboundEmail;
};

/**
 * Scope that is granted based on the identity and role of a user. It impacts the breadth and depth of data that a user can access.
 * For example, an ADMIN with GLOBAL scope can access all resources across all organizations, while a USER with ORGANIZATION scope
 * can only access resources within their organization. A USER with SELF scope can only access resources that they own.
 */
export enum Scope {
  /** Global scope, grants access to all resources across all organizations. */
  Global = 'GLOBAL',
  /** Organization scope, grants access to resources within the organization. */
  Organization = 'ORGANIZATION',
  /** Self scope, grants access to resources that the user owns. */
  Self = 'SELF',
  /** Sub-organization scope, grants access to resources within related organizations. */
  SubOrganization = 'SUB_ORGANIZATION'
}

/**
 * Specifies which resource to use for deriving scope (Category 1).
 * The system determines applicable scopes by checking the principal's relationship
 * to this resource (ownership, org membership, or admin status).
 */
export type ScopeResourceInput = {
  /**
   * Field names containing the resource ID (from resolver arguments).
   * Supports hierarchical fallback: tries each field in order until a non-nil value is found.
   *
   * Three names are resolved specially: "@principalId" and "@principalOrgId" come from
   * the caller, and "@fieldValue" is the value of the field being authorized. The last
   * one is only available to @authorizeInput, where the field's value is usually the
   * resource id and the enclosing field's arguments cannot reach it.
   */
  idFields?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Field name containing multiple resource IDs (for batch operations). */
  multiIdField?: InputMaybe<Scalars['String']['input']>;
  /** Field name on parent object containing the resource ID. */
  parentIdField?: InputMaybe<Scalars['String']['input']>;
  /** The resource type to check the principal's relationship against. */
  resource: Resource;
};

export type SearchAmsAccountsLiveInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
};

export type SearchAmsLiveTool = {
  __typename?: 'SearchAmsLiveTool';
  input: SearchAmsLiveToolInput;
  output?: Maybe<SearchAmsLiveToolOutput>;
};

/** Input arguments for the SearchAmsLiveTool. */
export type SearchAmsLiveToolInput = {
  __typename?: 'SearchAmsLiveToolInput';
  /** The client email address to search by */
  email?: Maybe<Scalars['String']['output']>;
  /** Which data bundles to fetch live */
  include?: Maybe<Array<Scalars['String']['output']>>;
  /** Fields to include for each returned entity */
  includeFields?: Maybe<Array<Scalars['String']['output']>>;
  /** The AMS account lookup code */
  lookupCode?: Maybe<Scalars['String']['output']>;
  /** The client/business name to search by */
  name?: Maybe<Scalars['String']['output']>;
  /** The client phone number to search by */
  phone?: Maybe<Scalars['String']['output']>;
  /** Only return policies whose policy numbers match these values */
  policyNumbers?: Maybe<Array<Scalars['String']['output']>>;
  /** Text filter for the notes and files bundles */
  query?: Maybe<Scalars['String']['output']>;
};

/**
 * Output of the SearchAmsLiveTool: the matched account with its contacts
 * and policies in the unified normalized shape.
 */
export type SearchAmsLiveToolOutput = {
  __typename?: 'SearchAmsLiveToolOutput';
  /**
   * The matched accounts in normalized form. Exactly one when the search was
   * unambiguous. When an email/phone/name search matches several accounts and
   * policyNumbers is provided, contains only accounts with matching policies.
   * Without policyNumbers, contains every candidate account and the per-account
   * bundles are omitted so the caller can disambiguate.
   */
  accounts?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's contacts in normalized form */
  contacts?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * The account's most recent files (attachment metadata only) in normalized
   * form, filtered by query
   */
  files?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's most recent notes in normalized form, filtered by query */
  notes?: Maybe<Array<Scalars['JSON']['output']>>;
  /** The account's policies (one per policy line) in normalized form */
  policies?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * Partial-failure warnings. A data bundle named here failed to fetch — its
   * data is UNKNOWN rather than empty. Consider retrying or telling the user.
   */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

/** Filter input for searchCaraWorkspaces query */
export type SearchCaraWorkspacesFilterInput = {
  /** Filter by agency ID */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Filter by agency user ID */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /**
   * When true, return ONLY archived workspaces (archived_at IS NOT NULL). When
   * false or omitted, return only active workspaces (the default, archived_at IS
   * NULL). Used to power the archived-workspaces view.
   */
  archived?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to workspaces linked to this client.
   *
   * Combined with the always-on visibility predicate, this is how the client detail
   * view lists a client's work without showing workspaces the caller cannot open.
   */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on custom preset ID (mutually exclusive with preset) */
  customPresetId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on built-in preset enum value */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Free-text search across title, client name, and keywords (ILIKE with trigram index) */
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict to rows that are SHARED with the caller (excludes rows the caller
   * created themselves). Useful for the "Shared with me" view.
   */
  sharedWithMe?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Restrict to rows that are SHARED with this specific team. The caller still
   * needs membership-based or admin access to see the row at all; this just
   * narrows the result set.
   */
  sharedWithTeamId?: InputMaybe<Scalars['String']['input']>;
  /** Exact match on workspace state */
  state?: InputMaybe<CaraWorkspaceState>;
  /** Filter workspaces updated since this timestamp */
  updatedAfter?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Restrict to a specific visibility level. Layered on top of the always-on
   * per-principal visibility filter — if you ask for PRIVATE, you only see
   * PRIVATE rows YOU can already read.
   */
  visibilityLevel?: InputMaybe<Visibility>;
};

export type SearchClientHistoryTool = {
  __typename?: 'SearchClientHistoryTool';
  input: SearchClientHistoryToolInput;
  output?: Maybe<SearchClientHistoryToolOutput>;
};

export type SearchClientHistoryToolInput = {
  __typename?: 'SearchClientHistoryToolInput';
  /**
   * The client id, as returned by SEARCH_CLIENTS or named in the workspace's
   * client context.
   */
  clientId: Scalars['String']['output'];
  /** Cap on workspaces returned. Defaults to 5 when omitted. */
  limit?: Maybe<Scalars['Int']['output']>;
  /**
   * Words to look for in the conversations. Matched as search terms, not as a
   * question.
   */
  query: Scalars['String']['output'];
};

export type SearchClientHistoryToolOutput = {
  __typename?: 'SearchClientHistoryToolOutput';
  /**
   * Documents attached to the client that do not belong to a workspace listed
   * above: attached directly, or produced in a workspace outside this page.
   * Newest first.
   */
  otherArtifacts: Array<ClientToolArtifact>;
  otherFiles: Array<ClientToolFile>;
  /**
   * False when no passage matched the query and the list fell back to the most
   * recent workspaces, so their excerpts are empty.
   */
  queryMatched: Scalars['Boolean']['output'];
  /** True when more workspaces qualified than were returned. */
  truncated: Scalars['Boolean']['output'];
  /**
   * Workspaces whose conversation matched, best match first, or the client's most
   * recent workspaces when nothing matched. The current workspace is never
   * included.
   */
  workspaces: Array<ClientToolWorkspace>;
};

export type SearchClientsTool = {
  __typename?: 'SearchClientsTool';
  input: SearchClientsToolInput;
  output?: Maybe<SearchClientsToolOutput>;
};

export type SearchClientsToolInput = {
  __typename?: 'SearchClientsToolInput';
  /** Cap on returned matches. Defaults to 10 when omitted. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** Free-text fragment matched against client name, email, and phone. */
  query: Scalars['String']['output'];
};

export type SearchClientsToolOutput = {
  __typename?: 'SearchClientsToolOutput';
  /** Matches, best-guess order. Empty when nothing matched. */
  clients: Array<ClientToolSummary>;
  /** True when matches were cut off by the limit, so the query should be narrowed. */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Result type for the searchDocumentation query,
 * containing a list of DocumentationResult objects.
 */
export type SearchDocumentationResult = {
  __typename?: 'SearchDocumentationResult';
  /** Array of matching documentation results (non-null, list of non-null items) */
  results: Array<DocumentationResult>;
};

export type SearchFileFilter = {
  search?: InputMaybe<Scalars['String']['input']>;
  /**
   * Restrict to files this agency uploaded. A caller that can only act on an
   * agency_file row otherwise pays a scored knowledge-graph search per integration
   * for results it discards.
   */
  uploadedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SearchFileResult = {
  __typename?: 'SearchFileResult';
  /** The ID of the file */
  id: Scalars['ID']['output'];
  /** The integration this file is associated with */
  integration?: Maybe<Integration>;
  /** The name of the file */
  name: Scalars['String']['output'];
};

/**
 *   Represents a tool for searching through files.
 * Used when the LLM needs to find information in specific files.
 */
export type SearchFileTool = {
  __typename?: 'SearchFileTool';
  /** The input arguments for the file search */
  input: SearchFileToolInput;
  /** The result of the file search operation */
  output: SearchFileToolOutput;
};

/**
 * Input arguments for the SearchFileTool.
 * Contains the search queries to be executed.
 */
export type SearchFileToolInput = {
  __typename?: 'SearchFileToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchFileToolQuery>;
};

/**
 * Result of a SearchFileTool operation.
 * Contains the search results and their citations.
 */
export type SearchFileToolOutput = {
  __typename?: 'SearchFileToolOutput';
  /** List of answers found in the files */
  results: Array<SearchFileToolResult>;
};

/**
 * Individual search query for the SearchFileTool.
 * Contains all parameters needed for a single file search.
 */
export type SearchFileToolQuery = {
  __typename?: 'SearchFileToolQuery';
  /** The ID of the file to search in. Empty when the query names its files in fileIds. */
  fileId: Scalars['String']['output'];
  /**
   * Files to ask the same query of. Each is searched and answered on its own, as if
   * the query had been sent once per file.
   */
  fileIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual answer from a file search.
 * Contains the answer and its supporting citations.
 */
export type SearchFileToolResult = {
  __typename?: 'SearchFileToolResult';
  /** The answer text found in the file */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchFileToolResultCitation>;
  /** The ID of the file containing the answer */
  fileId: Scalars['String']['output'];
  /**
   * The name of the file containing the answer, which tells apart the answers to
   * one query asked of several files. Empty on answers recorded before it existed.
   */
  fileName: Scalars['String']['output'];
  /** The original query that produced this answer */
  query: Scalars['String']['output'];
};

/**
 * Citation for a file search result.
 * Provides specific location and context for the answer.
 */
export type SearchFileToolResultCitation = {
  __typename?: 'SearchFileToolResultCitation';
  /** A link to the specific location in the file */
  link: Scalars['String']['output'];
};

/** A SEARCH_INTEGRATION input the tool rejected, with enough to correct it. */
export type SearchIntegrationError = {
  __typename?: 'SearchIntegrationError';
  /** The kind of problem, such as BAD_OP or UNKNOWN_FIELD. */
  code: Scalars['String']['output'];
  /** What is wrong. */
  message: Scalars['String']['output'];
  /** The JSON path of the offending node, such as include[0].where.and[1]. */
  path?: Maybe<Scalars['String']['output']>;
  /** The values that would have been accepted, where there is a closed set. */
  valid?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * A node of a SEARCH_INTEGRATION filter tree: exactly one of and, or, or a leaf
 * (field and op). negate applies to any node.
 */
export type SearchIntegrationFilter = {
  __typename?: 'SearchIntegrationFilter';
  /** Child nodes that must all hold. */
  and?: Maybe<Array<SearchIntegrationFilter>>;
  /** The field a leaf tests. */
  field?: Maybe<Scalars['String']['output']>;
  /** Whether the node is inverted. */
  negate?: Maybe<Scalars['Boolean']['output']>;
  /** The operator a leaf applies. */
  op?: Maybe<Scalars['String']['output']>;
  /** Child nodes at least one of which holds. */
  or?: Maybe<Array<SearchIntegrationFilter>>;
  /** The value a leaf compares against. */
  value?: Maybe<Scalars['String']['output']>;
  /** The values an IN or NOT_IN leaf compares against. */
  values?: Maybe<Array<Scalars['String']['output']>>;
};

/** One relation SEARCH_INTEGRATION pulls for each root. */
export type SearchIntegrationInclude = {
  __typename?: 'SearchIntegrationInclude';
  /** The field bundles to return for each related row. */
  bundles?: Maybe<Array<Scalars['String']['output']>>;
  /** The most related rows to return per root. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The relation to pull. */
  relation: Scalars['String']['output'];
  /** The filter over the relation's fields. */
  where?: Maybe<SearchIntegrationFilter>;
};

/**
 * Filter input for the searchIntegrationSyncLogs query.
 *
 * In organization scope, agencyId in the filter is ignored; the caller's
 * principal organization ID is always enforced.
 */
export type SearchIntegrationSyncLogsFilterInput = {
  /** Restrict to sync logs for this agency. Honored in global scope; overridden in org scope. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs triggered by this call ID. */
  associatedCallId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs whose error list contains an error with this code. */
  errorCode?: InputMaybe<IntegrationSyncErrorCode>;
  /** Restrict to sync logs initiated by the given actor id. */
  initiatorId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs initiated by the given actor type. */
  initiatorType?: InputMaybe<UpdateInitiatorType>;
  /** Restrict to sync logs for this integration. */
  integrationId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to sync logs whose integration is of this type. */
  integrationType?: InputMaybe<IntegrationType>;
  /** Only sync logs whose completed_at - started_at <= this many milliseconds. */
  maxDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only sync logs whose completed_at - started_at >= this many milliseconds. */
  minDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** When true, only sync logs with at least one retryable error. */
  retryableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only sync logs that started strictly after this timestamp. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only sync logs that started strictly before this timestamp. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict to sync logs in this state. */
  state?: InputMaybe<IntegrationSyncState>;
  /** Restrict to sync logs of this type (READ or WRITE). */
  type?: InputMaybe<IntegrationSyncType>;
};

export type SearchIntegrationTool = {
  __typename?: 'SearchIntegrationTool';
  input: SearchIntegrationToolInput;
  output?: Maybe<SearchIntegrationToolOutput>;
};

/** Input arguments for the SearchIntegrationTool. */
export type SearchIntegrationToolInput = {
  __typename?: 'SearchIntegrationToolInput';
  /** The field bundles to return for each root. */
  bundles?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The root entity to find: ACCOUNT, POLICY, CLAIM, CERTIFICATE, ACTIVITY or
   * OPPORTUNITY.
   */
  find: Scalars['String']['output'];
  /** The related objects to pull for each root. */
  include?: Maybe<Array<SearchIntegrationInclude>>;
  /** The most roots to return. */
  limit?: Maybe<Scalars['Int']['output']>;
  /** The filter tree choosing which roots match. */
  where: SearchIntegrationFilter;
};

/**
 * Output of the SearchIntegrationTool: matching roots with their bundles and
 * related objects, or a validation error the caller can fix.
 */
export type SearchIntegrationToolOutput = {
  __typename?: 'SearchIntegrationToolOutput';
  /** Why the input was rejected, when it was. */
  error?: Maybe<SearchIntegrationError>;
  /** Whether more roots match than were returned. */
  hasMore?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The matching roots, each with a key per requested bundle and a related key
   * holding its includes.
   */
  results?: Maybe<Array<Scalars['JSON']['output']>>;
  /**
   * SQL when the results come from the synced normalized tables, LIVE when they
   * were read live from the agency's AMS.
   */
  source?: Maybe<Scalars['String']['output']>;
  /**
   * Notes on partial results: a bundle that failed to load, a capped candidate
   * list, a live read.
   */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
};

export type SearchKnowledgeBaseTool = {
  __typename?: 'SearchKnowledgeBaseTool';
  /** The input arguments for the knowledge base search */
  input: SearchKnowledgeBaseToolInput;
  /** The result of the knowledge base search operation */
  output: SearchKnowledgeBaseToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeBaseTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeBaseToolInput = {
  __typename?: 'SearchKnowledgeBaseToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeBaseToolQuery>;
  userQuery: Scalars['String']['output'];
};

/**
 * Result of a SearchKnowledgeBaseTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeBaseToolOutput = {
  __typename?: 'SearchKnowledgeBaseToolOutput';
  /** The answer to the user's query */
  answer: Scalars['String']['output'];
  /** List of citations actually used in the response */
  citations: Array<SearchKnowledgeBaseToolResultCitation>;
  /** List of documents found in the knowledge base */
  documents: Array<SearchKnowledgeBaseToolResultDocument>;
};

/**
 * Individual search query for the SearchKnowledgeBaseTool.
 * Contains the query to be executed against the knowledge base.
 */
export type SearchKnowledgeBaseToolQuery = {
  __typename?: 'SearchKnowledgeBaseToolQuery';
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Citation for a knowledge base search result.
 * Provides specific location and context for the answer.
 */
export type SearchKnowledgeBaseToolResultCitation = {
  __typename?: 'SearchKnowledgeBaseToolResultCitation';
  /** A link to the specific location in the knowledge base */
  link: Scalars['String']['output'];
};

/**
 * Individual answer from a knowledge base search.
 * Contains the answer and its supporting citations.
 */
export type SearchKnowledgeBaseToolResultDocument = {
  __typename?: 'SearchKnowledgeBaseToolResultDocument';
  /** The ID of the document */
  id: Scalars['String']['output'];
  /** The metadata for the document */
  metadata: KnowledgeBaseDocumentMetadata;
  /** The relevant pages of the document */
  relevantPages: Array<SearchKnowledgeBaseToolResultPage>;
};

/** Represents a page from a knowledge base document. */
export type SearchKnowledgeBaseToolResultPage = {
  __typename?: 'SearchKnowledgeBaseToolResultPage';
  /** The citation for the page */
  citation: SearchKnowledgeBaseToolResultCitation;
  /** The index of the page */
  pageIndex: Scalars['Int']['output'];
};

/**
 * Represents a tool for searching the knowledge graph.
 * Used when the LLM needs to find information from the internal knowledge graph.
 */
export type SearchKnowledgeGraphTool = {
  __typename?: 'SearchKnowledgeGraphTool';
  /** The input arguments for the knowledge graph search */
  input: SearchKnowledgeGraphToolInput;
  /** The result of the knowledge graph search operation */
  output: SearchKnowledgeGraphToolOutput;
};

/**
 * Input arguments for the SearchKnowledgeGraphTool.
 * Contains the search queries to be executed.
 */
export type SearchKnowledgeGraphToolInput = {
  __typename?: 'SearchKnowledgeGraphToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchKnowledgeGraphToolQuery>;
};

/**
 * Result of a SearchKnowledgeGraphTool operation.
 * Contains the search results and their citations.
 */
export type SearchKnowledgeGraphToolOutput = {
  __typename?: 'SearchKnowledgeGraphToolOutput';
  /** List of answers found in the knowledge graph */
  entities: Array<KnowledgeGraphEntity>;
};

/**
 * Individual search query for the SearchKnowledgeGraphTool.
 * Contains the query to be executed against the knowledge graph.
 */
export type SearchKnowledgeGraphToolQuery = {
  __typename?: 'SearchKnowledgeGraphToolQuery';
  /** List of fields to include in the search */
  includeFields: Array<Scalars['String']['output']>;
  /** The search query string */
  query: Scalars['String']['output'];
};

/** Filter input for searchTraceAnalysis. */
export type SearchTraceAnalysisFilterInput = {
  /** Restrict to analyses whose trace belongs to this agency. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to completed analyses that include this issue category. */
  category?: InputMaybe<TraceAnalysisIssueCategory>;
  /** Only analyses created strictly after this timestamp. */
  createdAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only analyses created strictly before this timestamp. */
  createdBefore?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict to completed analyses with this outcome. */
  outcome?: InputMaybe<TraceAnalysisOutcome>;
  /**
   * Free-text search. Split on whitespace into terms; an analysis matches only if
   * every term matches (AND), and a term matches when it is a case-insensitive
   * substring of the analysis id, trace id, result summary, root-cause summary, or
   * the associated trace name.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to completed analyses with this severity. */
  severity?: InputMaybe<TraceAnalysisSeverity>;
  /** Restrict to analyses whose trace belongs to this workspace stage. */
  stageId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to analyses in this lifecycle state. */
  state?: InputMaybe<TraceAnalysisState>;
  /** Restrict to analyses for this trace. */
  traceId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to analyses whose trace is in this derived status. */
  traceStatus?: InputMaybe<TraceStatus>;
  /** Restrict to analyses whose trace belongs to this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/** Filter input for searchTraces. */
export type SearchTracesFilterInput = {
  /** Restrict to traces for this agency. */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** Only traces that ended in error. */
  hasError?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only traces with duration <= this many milliseconds. */
  maxDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation input tokens are <= this many. */
  maxInputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation output tokens are <= this many. */
  maxOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces with total cost <= this amount in dollars. */
  maxTotalCostDollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Only traces with duration >= this many milliseconds. */
  minDurationMs?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation input tokens are >= this many. */
  minInputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces whose aggregate generation output tokens are >= this many. */
  minOutputTokens?: InputMaybe<Scalars['Int']['input']>;
  /** Only traces with total cost >= this amount in dollars. */
  minTotalCostDollars?: InputMaybe<Scalars['Decimal']['input']>;
  /** Case-insensitive substring match against gen_ai.operation.name on any span. */
  operationName?: InputMaybe<Scalars['String']['input']>;
  /** Case-insensitive substring match against gen_ai.request.model on any generation span. */
  requestModel?: InputMaybe<Scalars['String']['input']>;
  /**
   * Free-text search. Split on whitespace into terms; a trace matches only if every term
   * matches (AND), and a term matches when it is a case-insensitive substring of the trace
   * name, error message, trace id, or any correlated log message. So "claude error" finds
   * traces matching both "claude" and "error" across those fields.
   */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to traces that include a span of this kind. */
  spanKind?: InputMaybe<SpanKind>;
  /** Restrict to traces for this workspace stage. */
  stageId?: InputMaybe<Scalars['String']['input']>;
  /** Only traces that started strictly after this timestamp. */
  startedAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only traces that started strictly before this timestamp. */
  startedBefore?: InputMaybe<Scalars['Time']['input']>;
  /**
   * Restrict to traces in this derived status. The resolver applies the same rules
   * as Trace.status (cancelledAt, child span endedAt/error).
   */
  status?: InputMaybe<TraceStatus>;
  /** Restrict to traces for this workspace. */
  workspaceId?: InputMaybe<Scalars['String']['input']>;
};

/**
 * Represents a tool for searching the web.
 * Used when the LLM needs to find information from the internet.
 */
export type SearchWebTool = {
  __typename?: 'SearchWebTool';
  /** The input arguments for the web search */
  input: SearchWebToolInput;
  /** The result of the web search operation */
  output: SearchWebToolOutput;
};

/**
 * Input arguments for the SearchWebTool.
 * Contains the search queries to be executed.
 */
export type SearchWebToolInput = {
  __typename?: 'SearchWebToolInput';
  /** List of search queries to be executed */
  queries: Array<SearchWebToolQuery>;
  /**
   * Search mode determines the depth and model used for the search.
   * Use "basic" (default) for simple lookups or when a single query is sufficient.
   * Use "pro" for complex research, multi-step verification, or comprehensive synthesis across many sources.
   */
  searchMode?: Maybe<Scalars['String']['output']>;
};

/**
 * Result of a SearchWebTool operation.
 * Contains the search results and their citations.
 */
export type SearchWebToolOutput = {
  __typename?: 'SearchWebToolOutput';
  /** List of search results */
  results: Array<SearchWebToolResult>;
};

/**
 * Individual search query for the SearchWebTool.
 * Contains all parameters needed for a single web search.
 */
export type SearchWebToolQuery = {
  __typename?: 'SearchWebToolQuery';
  /** Keywords to help refine the search */
  keywords: Scalars['String']['output'];
  /** The search query string */
  query: Scalars['String']['output'];
};

/**
 * Individual result from a web search.
 * Contains the answer and its supporting citations.
 */
export type SearchWebToolResult = {
  __typename?: 'SearchWebToolResult';
  /** The answer text found from web sources */
  answer: Scalars['String']['output'];
  /** Citations supporting the answer */
  citations: Array<SearchWebToolResultCitation>;
  /** The original query that produced this result */
  query: Scalars['String']['output'];
};

/**
 * Citation for a web search result.
 * Provides specific source information for the answer.
 */
export type SearchWebToolResultCitation = {
  __typename?: 'SearchWebToolResultCitation';
  /** The title of the web page */
  title: Scalars['String']['output'];
  /** The URL of the web page containing the citation */
  url: Scalars['String']['output'];
};

export type SendEmailBulkSendInput = {
  action: EmailBulkSendAction;
  /** One per Send click, so a repeated click returns the batch the first one started. */
  attemptId: Scalars['String']['input'];
  mailboxAccountId: Scalars['String']['input'];
  /**
   * When SCHEDULE_ALL's first email goes out, at least 5 minutes ahead. Refused for the
   * other actions.
   */
  sendAt?: InputMaybe<Scalars['Time']['input']>;
};

export type SendRestOfEmailBulkSendInput = {
  /** SEND_ALL or SCHEDULE_ALL. */
  action: EmailBulkSendAction;
  /** One per Send the rest click, so a repeated click returns the batch the first one sent. */
  attemptId: Scalars['String']['input'];
  /** When SCHEDULE_ALL's first email goes out, at least 5 minutes ahead. Refused for SEND_ALL. */
  sendAt?: InputMaybe<Scalars['Time']['input']>;
};

/** Represents a service request submitted by a merchant */
export type ServiceRequest = {
  __typename?: 'ServiceRequest';
  /** The account associated with the service request */
  account?: Maybe<Account>;
  /** Details specific to additional insured requests */
  addAdditionalInsured?: Maybe<AddAdditionalInsuredRequest>;
  /** The agency user that is assigned to this service request */
  assignee?: Maybe<AgencyUser>;
  /** The business policy associated with the service request, if any */
  businessPolicy?: Maybe<BusinessPolicy>;
  /** The calls that this service request was created from, if any */
  calls: Array<Call>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: Maybe<CancelPolicyRequest>;
  /** The email of the client that this service request is associated with, if not associated with an account */
  clientEmail?: Maybe<Scalars['String']['output']>;
  /** The name of the client that this service request is associated with, if not associated with an account */
  clientName?: Maybe<Scalars['String']['output']>;
  /** The phone number of the client that this service request is associated with, if not associated with an account */
  clientPhone?: Maybe<Scalars['String']['output']>;
  /** When the request was closed, if applicable */
  closedAt?: Maybe<Scalars['Time']['output']>;
  /** The comments associated with this service request */
  comments: Array<ServiceRequestComment>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: Maybe<CreateCertificateRequest>;
  /** When the request was created */
  createdAt: Scalars['Time']['output'];
  /** Additional details about the request */
  details: Scalars['String']['output'];
  /** Details specific to document requests */
  documentRequest?: Maybe<DocumentRequest>;
  /** The date and time that this service request is due, if any */
  dueAt?: Maybe<Scalars['Time']['output']>;
  /** The email thread that this service request was created from, if any */
  emailThreads: Array<EmailThread>;
  /** Details specific to policy endorsement requests */
  endorsePolicy?: Maybe<EndorsePolicyRequest>;
  /** Unique identifier for the service request */
  id: Scalars['ID']['output'];
  /** Details specific to question requests */
  question?: Maybe<QuestionRequest>;
  /** Resolution of the service request, if applicable */
  resolution?: Maybe<ServiceRequestResolution>;
  /** Files attached to the service request's resolution */
  resolutionFiles: Array<File>;
  /** Current state of the request */
  state: ServiceRequestState;
  /** Type of service request */
  type: ServiceRequestType;
  /** When the request was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this policy */
  version: Scalars['Int64']['output'];
  /** The previous versions of this policy. The first version in this list will be this version (i.e. identical to the current policy), followed by the version before that, and so-forth. */
  versionHistory?: Maybe<Array<ServiceRequestVersion>>;
};

export type ServiceRequestComment = {
  __typename?: 'ServiceRequestComment';
  /** The agency user that created the comment */
  agencyUser: AgencyUser;
  /** The content of the comment */
  content: Scalars['String']['output'];
  /** The date and time that the comment was created */
  createdAt: Scalars['Time']['output'];
  /** The ID of the comment */
  id: Scalars['ID']['output'];
  /** The date and time that the comment was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Describes the resolution of a service request */
export type ServiceRequestResolution = {
  __typename?: 'ServiceRequestResolution';
  /** Internal notes about the resolution */
  notes: Scalars['String']['output'];
};

/** Current state of a service request */
export enum ServiceRequestState {
  /** Request has been completed */
  Closed = 'CLOSED',
  /** Request is still being processed */
  Open = 'OPEN'
}

/** Type of service request that can be created */
export enum ServiceRequestType {
  /** Request to add an additional insured to a policy */
  AddAdditionalInsured = 'ADD_ADDITIONAL_INSURED',
  /** Request to cancel an existing policy */
  CancelPolicy = 'CANCEL_POLICY',
  /** Request to create a Certificate of Insurance */
  CreateCertificate = 'CREATE_CERTIFICATE',
  /** Request for policy-related documents */
  DocumentRequest = 'DOCUMENT_REQUEST',
  /** Request to modify/endorse an existing policy */
  EndorsePolicy = 'ENDORSE_POLICY',
  /** Other miscellaneous requests */
  Other = 'OTHER',
  /** Question about policies, account, or billing, etc. */
  Question = 'QUESTION',
  /** Request to get a new quote for insurance */
  QuoteRequest = 'QUOTE_REQUEST'
}

/** Describes the reason why an application was updated */
export enum ServiceRequestUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a policy */
export enum ServiceRequestUpdateType {
  /** A comment was added to the service request */
  AddServiceRequestComment = 'ADD_SERVICE_REQUEST_COMMENT',
  /** The service request was assigned to an agency user */
  AssignServiceRequest = 'ASSIGN_SERVICE_REQUEST',
  /** The service request was closed */
  CloseServiceRequest = 'CLOSE_SERVICE_REQUEST',
  /** The service request was created */
  CreateServiceRequest = 'CREATE_SERVICE_REQUEST',
  /** The service request was enriched */
  EnrichServiceRequest = 'ENRICH_SERVICE_REQUEST',
  /** The service request was updated */
  UpdateServiceRequest = 'UPDATE_SERVICE_REQUEST',
  /** The due date of the service request was updated */
  UpdateServiceRequestDueAt = 'UPDATE_SERVICE_REQUEST_DUE_AT'
}

/** Describes a particular version of a service request */
export type ServiceRequestVersion = {
  __typename?: 'ServiceRequestVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another service request version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous service request version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<ServiceRequestVersion>;
  /** The full service request object that includes all of the updates made in this version and all previous versions */
  serviceRequest: ServiceRequest;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<ServiceRequestUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<ServiceRequestUpdateType>;
  /** The version number of this service request version */
  version: Scalars['Int64']['output'];
};

/** Where the value a record holds for a question came from. */
export enum SmartFillAnswerSource {
  Agent = 'AGENT',
  /** The bucket held it already, from its forms or its workspace. */
  Bucket = 'BUCKET',
  Missing = 'MISSING'
}

/**
 * A revisioned entity-tree document: entities own scalar properties and child
 * entities, and repeated children with the same relation are separate records.
 * The document shape is validated server side; see smartfill.BucketDocument.
 */
export type SmartFillBucket = {
  __typename?: 'SmartFillBucket';
  canEdit: Scalars['Boolean']['output'];
  createdAt: Scalars['Time']['output'];
  document: Scalars['JSON']['output'];
  /**
   * Learning has changed the bucket since it was last restored, so the version
   * from before those changes can be restored.
   */
  hasLearnedChanges: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  operationId: Scalars['ID']['output'];
  origin: SmartFillBucketOrigin;
  revision: Scalars['Int64']['output'];
  updatedAt: Scalars['Time']['output'];
  visibility: SmartFillBucketVisibility;
};

/** One filled ACORD form a general bucket was built from. */
export type SmartFillBucketForm = {
  __typename?: 'SmartFillBucketForm';
  artifactId: Scalars['ID']['output'];
  /** The form's title, such as ACORD 125. */
  title: Scalars['String']['output'];
  /** The version of the form the bucket was last built from. */
  version: Scalars['Int']['output'];
};

/** The caller's general buckets for a workspace, or a conversion still generating one. */
export type SmartFillBucketGeneration = {
  __typename?: 'SmartFillBucketGeneration';
  /** Empty until there is a bucket. */
  bucketIds: Array<Scalars['ID']['output']>;
  completed: Scalars['Boolean']['output'];
};

export enum SmartFillBucketOrigin {
  Copy = 'COPY',
  Manual = 'MANUAL',
  Workspace = 'WORKSPACE'
}

/**
 * A kind of bucket, such as personal auto: the facts one product's carrier quote
 * flows ask for, from the reference flows Smart Fill was verified against.
 */
export type SmartFillBucketProfile = {
  __typename?: 'SmartFillBucketProfile';
  carriers: Array<Scalars['String']['output']>;
  /** Asked by the most carriers first. */
  facts: Array<SmartFillBucketProfileFact>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

/** One fact a profile's carriers ask for, named the way bucket properties name it. */
export type SmartFillBucketProfileFact = {
  __typename?: 'SmartFillBucketProfileFact';
  /** How many of the profile's carriers ask for the fact. */
  carrierCount: Scalars['Int']['output'];
  /** A bucket value kind, such as TEXT or DATE. */
  kind: Scalars['String']['output'];
  label: Scalars['String']['output'];
  /** The type of the entity that owns the fact, such as client, person or vehicle. */
  ownerType: Scalars['String']['output'];
  /** The relations from the bucket root to that entity, such as drivers; empty on the root. */
  relationPath: Scalars['String']['output'];
  semanticKey: Scalars['String']['output'];
};

export enum SmartFillBucketVisibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** A carrier site whose questions a recorded reference flow captured. */
export type SmartFillCarrierSite = {
  __typename?: 'SmartFillCarrierSite';
  carrier: Scalars['String']['output'];
  host: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  product: Scalars['String']['output'];
  /** How many bucket facts the site's questions ask for. */
  questionCount: Scalars['Int']['output'];
};

export enum SmartFillDecisionSource {
  Model = 'MODEL',
  User = 'USER'
}

export enum SmartFillDecisionStatus {
  /** No auto-write; reason explains why and a suggestion may be attached. */
  Review = 'REVIEW',
  /** A user rule says to always leave this destination blank. */
  Skip = 'SKIP',
  /** The value is safe to write automatically. */
  Write = 'WRITE'
}

export type SmartFillDestinationContextInput = {
  autocomplete?: InputMaybe<Scalars['String']['input']>;
  /** Optional context for the same semantic projections used during filling. */
  groupId?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<SmartFillGroupInput>>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<SmartFillOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  sectionHeading?: InputMaybe<Scalars['String']['input']>;
  type: SmartFillFieldType;
};

/** One immutable observability record; metadata never contains values. */
export type SmartFillEvent = {
  __typename?: 'SmartFillEvent';
  action: SmartFillEventAction;
  bucketId?: Maybe<Scalars['ID']['output']>;
  createdAt: Scalars['Time']['output'];
  formFingerprint?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  metadata: Scalars['JSON']['output'];
  modelId?: Maybe<Scalars['String']['output']>;
  operationId: Scalars['ID']['output'];
  promptVersion?: Maybe<Scalars['String']['output']>;
  requestId?: Maybe<Scalars['ID']['output']>;
};

export enum SmartFillEventAction {
  Copy = 'COPY',
  Correction = 'CORRECTION',
  Fill = 'FILL'
}

export type SmartFillFieldDecision = {
  __typename?: 'SmartFillFieldDecision';
  confidence: Scalars['Float']['output'];
  fieldId: Scalars['String']['output'];
  fieldKey: Scalars['String']['output'];
  /** For COMBOBOX only: exact, semantically equivalent option labels the browser may select. */
  optionMatchLabels?: Maybe<Array<Scalars['String']['output']>>;
  /** Exact source-backed suggestion labels for selecting an option. */
  optionSelectionLabels?: Maybe<Array<Scalars['String']['output']>>;
  propertyId?: Maybe<Scalars['ID']['output']>;
  /**
   * Populated for REVIEW decisions, e.g. NO_MATCH or OPTION_MISMATCH. On a WRITE,
   * ASSUMED_OPTION or ASSUMED_DAY names an assumption for the agent to check.
   */
  reason?: Maybe<Scalars['String']['output']>;
  source: SmartFillDecisionSource;
  status: SmartFillDecisionStatus;
  value?: Maybe<Scalars['String']['output']>;
};

/** The generalizable meaning a HINT teaches, derived from a chosen property. */
export type SmartFillFieldIntent = {
  __typename?: 'SmartFillFieldIntent';
  entityKind?: Maybe<Scalars['String']['output']>;
  entityRole?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['String']['output']>;
  propertyName?: Maybe<Scalars['String']['output']>;
};

/** The type of a form field detected by the Smart Fill extension. */
export enum SmartFillFieldType {
  /**
   * A clickable mutually-exclusive choice group (segmented control, pill row).
   * SELECT-shaped: options carry opaque values the extension maps to elements.
   */
  Button = 'BUTTON',
  Checkbox = 'CHECKBOX',
  /** An editable choice control requiring a verified, unique option selection. */
  Combobox = 'COMBOBOX',
  Date = 'DATE',
  Email = 'EMAIL',
  /** A native month control; the submitted value is YYYY-MM. */
  Month = 'MONTH',
  Number = 'NUMBER',
  Phone = 'PHONE',
  Radio = 'RADIO',
  Select = 'SELECT',
  Text = 'TEXT',
  Textarea = 'TEXTAREA'
}

export type SmartFillFormAnswerInput = {
  ownerType: Scalars['String']['input'];
  recordIndex: Scalars['Int']['input'];
  relationPath: Scalars['String']['input'];
  semanticKey: Scalars['String']['input'];
  /** An empty value clears the answer. */
  value: Scalars['String']['input'];
};

/**
 * A general bucket Smart Fill keeps for one line of business in a workspace:
 * built from the workspace's filled ACORD forms for that line when a Cara run
 * finishes, or generated from the workspace itself when the agent asks. The agent
 * completes it by answering what it leaves open, for the line in general or for
 * one carrier site.
 */
export type SmartFillFormBucket = {
  __typename?: 'SmartFillFormBucket';
  answerCount: Scalars['Int']['output'];
  bucket: SmartFillBucket;
  builtAt: Scalars['Time']['output'];
  /** The carrier site the agent last configured it for; null until they do. */
  carrierSiteId?: Maybe<Scalars['ID']['output']>;
  /** The ACORD forms it was built from; empty for a bucket generated from the workspace. */
  forms: Array<SmartFillBucketForm>;
  /** The line of business's name, such as Personal auto or Restaurants. */
  lineOfBusiness: Scalars['String']['output'];
  /** The bucket profile of its line of business. */
  profileId: Scalars['ID']['output'];
  workspaceId: Scalars['ID']['output'];
  workspaceTitle: Scalars['String']['output'];
};

/** A general bucket checked against its line of business, or against one carrier site. */
export type SmartFillFormBucketQuestions = {
  __typename?: 'SmartFillFormBucketQuestions';
  /** Questions every record answers, from the bucket or the agent. */
  answeredCount: Scalars['Int']['output'];
  formBucket: SmartFillFormBucket;
  questions: Array<SmartFillFormQuestion>;
  /** Pass back as expectedRevision when answering. */
  revision: Scalars['Int64']['output'];
  /** The carrier site the questions are for; null for the line of business in general. */
  site?: Maybe<SmartFillCarrierSite>;
};

/**
 * One bucket fact a view of the bucket asks for: in a carrier site's own words,
 * or by the fact's name for the line of business in general.
 */
export type SmartFillFormQuestion = {
  __typename?: 'SmartFillFormQuestion';
  answers: Array<SmartFillFormQuestionAnswer>;
  fieldType: SmartFillFieldType;
  /** The value kind an answer is stored as, such as TEXT or BOOLEAN. */
  kind: Scalars['String']['output'];
  /** The fact's name in the bucket profiles, when it differs from the question. */
  label?: Maybe<Scalars['String']['output']>;
  options: Array<Scalars['String']['output']>;
  ownerType: Scalars['String']['output'];
  question: Scalars['String']['output'];
  relationPath: Scalars['String']['output'];
  section?: Maybe<Scalars['String']['output']>;
  semanticKey: Scalars['String']['output'];
};

/** What one record in the bucket holds for a question. */
export type SmartFillFormQuestionAnswer = {
  __typename?: 'SmartFillFormQuestionAnswer';
  /** False for the record an answer would add when the bucket has none. */
  recordExists: Scalars['Boolean']['output'];
  /** The record's place among the bucket's records of this kind. */
  recordIndex: Scalars['Int']['output'];
  recordLabel: Scalars['String']['output'];
  source: SmartFillAnswerSource;
  value?: Maybe<Scalars['String']['output']>;
};

/** One validated destination-group-to-source-entity binding. */
export type SmartFillGroupBinding = {
  __typename?: 'SmartFillGroupBinding';
  entityId: Scalars['ID']['output'];
  /** IDs of fields authorized for this row-specific binding. */
  fieldIds: Array<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  rows: Array<SmartFillRowIdentity>;
};

/** One structural section of the live form; repeated rows share a repeatSetId. */
export type SmartFillGroupInput = {
  /** Visible section instructions; not part of repeated-row identity. */
  description?: InputMaybe<Scalars['String']['input']>;
  groupId: Scalars['String']['input'];
  label?: InputMaybe<Scalars['String']['input']>;
  ordinal?: InputMaybe<Scalars['Int']['input']>;
  parentId?: InputMaybe<Scalars['String']['input']>;
  repeatSetId?: InputMaybe<Scalars['String']['input']>;
};

export type SmartFillLearningEntry = {
  __typename?: 'SmartFillLearningEntry';
  canApply: Scalars['Boolean']['output'];
  canUndo: Scalars['Boolean']['output'];
  entityLabel?: Maybe<Scalars['String']['output']>;
  fieldLabel: Scalars['String']['output'];
  /** True while this entry still owns an active, inserted field hint. */
  hintLearned: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  status: SmartFillLearningStatus;
  value: Scalars['String']['output'];
};

/** A finalized human edit, never keystrokes, prefills or an automatic write. */
export type SmartFillLearningObservationInput = {
  destination: SmartFillDestinationContextInput;
  /** Optional verified source entity placement; not an inferred person identity. */
  entityId?: InputMaybe<Scalars['ID']['input']>;
  fieldKey: Scalars['String']['input'];
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  /** At most 20 live verified fill anchors; checked against current source facts, never sent to the interpretation model. */
  placementAnchors?: InputMaybe<Array<SmartFillLearningPlacementAnchorInput>>;
  submittedValue?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

/** Private operation receipt; values are not copied to audit metadata. */
export type SmartFillLearningOperation = {
  __typename?: 'SmartFillLearningOperation';
  bucketId: Scalars['ID']['output'];
  bucketRevision: Scalars['Int64']['output'];
  elapsedMs: Scalars['Int']['output'];
  entries: Array<SmartFillLearningEntry>;
  id: Scalars['ID']['output'];
  modelCalls: Scalars['Int']['output'];
};

export type SmartFillLearningPlacementAnchorInput = {
  destination: SmartFillDestinationContextInput;
  propertyId: Scalars['ID']['input'];
  value: Scalars['String']['input'];
};

export enum SmartFillLearningStatus {
  Conflict = 'CONFLICT',
  FactSaved = 'FACT_SAVED',
  Failed = 'FAILED',
  HintLearned = 'HINT_LEARNED',
  Ignored = 'IGNORED',
  NeedsReview = 'NEEDS_REVIEW',
  Undone = 'UNDONE'
}

/**
 * The option one searchable question should select, when one displayed option
 * is a plausible answer from the bucket fact.
 */
export type SmartFillOptionChoice = {
  __typename?: 'SmartFillOptionChoice';
  /** The fact does not state this option outright; the agent should check it. */
  assumed: Scalars['Boolean']['output'];
  confidence: Scalars['Float']['output'];
  label?: Maybe<Scalars['String']['output']>;
  /** New short searches to try when no displayed option fits. */
  searchQueries: Array<Scalars['String']['output']>;
};

/** One select or radio choice with its submitted value and human label. */
export type SmartFillOptionInput = {
  label?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

/** One current correction rule owned by the calling user, keyed to a form. */
export type SmartFillOverride = {
  __typename?: 'SmartFillOverride';
  action: SmartFillOverrideAction;
  createdAt: Scalars['Time']['output'];
  fieldKey: Scalars['String']['output'];
  fingerprintVersion: Scalars['Int']['output'];
  formFingerprint: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  /** Present for HINT rules; describes the taught field meaning. */
  intent?: Maybe<SmartFillFieldIntent>;
  updatedAt: Scalars['Time']['output'];
};

export enum SmartFillOverrideAction {
  /**
   * Teach what this field means so the model matches it confidently against any
   * bucket. Bucket-independent; injected into the match prompt as a strong prior.
   */
  Hint = 'HINT',
  /** Always leave this destination blank, regardless of bucket. */
  Skip = 'SKIP'
}

export type SmartFillPlacementInput = {
  entityId: Scalars['ID']['input'];
  groupId: Scalars['String']['input'];
  rows: Array<SmartFillRowIdentityInput>;
};

/** One fillable control of the live form. */
export type SmartFillResolveFieldInput = {
  autocomplete?: InputMaybe<Scalars['String']['input']>;
  /** Page-lifetime DOM identity used to apply the returned decisions. */
  fieldId: Scalars['String']['input'];
  /** Durable occurrence-aware structural key used for correction rules. */
  fieldKey: Scalars['String']['input'];
  groupId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  options?: InputMaybe<Array<SmartFillOptionInput>>;
  placeholder?: InputMaybe<Scalars['String']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Nearest heading above the field on the page ("Driver 2", "Garaging address").
   * Gives the resolver the record a field belongs to when the page has no
   * fieldset or group structure to say so.
   */
  sectionHeading?: InputMaybe<Scalars['String']['input']>;
  type: SmartFillFieldType;
};

export type SmartFillResolveResult = {
  __typename?: 'SmartFillResolveResult';
  /**
   * The repeated-entity bindings that survived validation, so continuous-fill
   * sessions can record which source records are now placed.
   */
  bindings: Array<SmartFillGroupBinding>;
  bucketId: Scalars['ID']['output'];
  bucketRevision: Scalars['Int64']['output'];
  decisions: Array<SmartFillFieldDecision>;
  formSnapshotHash: Scalars['String']['output'];
  /** Null when every destination was decided by user rules without the model. */
  modelId?: Maybe<Scalars['String']['output']>;
  promptVersion: Scalars['String']['output'];
  requestId: Scalars['ID']['output'];
};

export type SmartFillRetryAdvice = {
  __typename?: 'SmartFillRetryAdvice';
  /** Results are returned in input order, with this explicit input index. */
  keyIndex: Scalars['Int']['output'];
  methods: Array<SmartFillRetryMethodAdvice>;
};

export type SmartFillRetryEvidenceInput = {
  /** The version observed before this attempt; unchanged on later invalidation. */
  adviceVersion?: InputMaybe<Scalars['Int64']['input']>;
  attemptId: Scalars['ID']['input'];
  key: SmartFillRetryKeyInput;
  methodId: Scalars['String']['input'];
  outcome: SmartFillRetryEvidenceOutcome;
};

export enum SmartFillRetryEvidenceOutcome {
  Invalidated = 'INVALIDATED',
  VerifiedSuccess = 'VERIFIED_SUCCESS'
}

/** Opaque form/control identities and origins; never labels, selectors or answers. */
export type SmartFillRetryKeyInput = {
  embeddingOrigin: Scalars['String']['input'];
  fieldKey: Scalars['String']['input'];
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  mechanicalContractHash: Scalars['String']['input'];
  mechanicalContractVersion: Scalars['Int']['input'];
  origin: Scalars['String']['input'];
  registryVersion: Scalars['Int']['input'];
};

export type SmartFillRetryMethodAdvice = {
  __typename?: 'SmartFillRetryMethodAdvice';
  methodId: Scalars['String']['output'];
  successCount: Scalars['Int64']['output'];
  version: Scalars['Int64']['output'];
};

export type SmartFillRowIdentity = {
  __typename?: 'SmartFillRowIdentity';
  collectionId: Scalars['String']['output'];
  rowId: Scalars['String']['output'];
};

export type SmartFillRowIdentityInput = {
  collectionId: Scalars['String']['input'];
  rowId: Scalars['String']['input'];
};

/** Verified placements from one document and logical form, at one source revision. */
export type SmartFillSessionContextInput = {
  bucketId: Scalars['ID']['input'];
  bucketRevision: Scalars['Int64']['input'];
  placements: Array<SmartFillPlacementInput>;
};

/** One asynchronous workspace conversion. */
export type SmartFillWorkspaceConversion = {
  __typename?: 'SmartFillWorkspaceConversion';
  bucketIds: Array<Scalars['ID']['output']>;
  completed: Scalars['Boolean']['output'];
  operationId: Scalars['ID']['output'];
  workflowId: Scalars['ID']['output'];
};

/** Sort direction */
export enum SortDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/**
 * A single observation within a trace (span, generation, tool call, embedding, rerank,
 * sandbox execution, HTTP exchange, or database query).
 *
 * Detail loading is lazy, keyed off the entry point used to fetch the span — not off the
 * selection set. The heavy detail payloads are hydrated ONLY when a span is fetched via
 * the `span(id)` query. On the trace waterfall path (`trace`/`searchTraces` -> rootSpans
 * -> children) the resolver loads a lightweight summary instead, so it does not read
 * every span's payload up front:
 *   - generation, toolCall, embedding, and rerank carry their summary fields, but their
 *     heavy subfields are null: generation.input/output, toolCall.arguments/result,
 *     embedding.inputs, rerank.results.
 *   - sandbox, http, and dbQuery are null entirely.
 * Selecting one of those fields on the waterfall path returns null — the field still
 * resolves, it is simply not hydrated there. To show a span's full detail, fetch
 * `span(id)`. (This contract is enforced by the resolver wiring, not by the type system:
 * the fields are nullable and always selectable.)
 */
export type Span = {
  __typename?: 'Span';
  /** Additional span attributes */
  attributes: Scalars['JSON']['output'];
  /**
   * Child spans, ordered by startedAt. Loaded as lightweight summaries (like
   * Trace.rootSpans); the heavy detail payloads are null here — fetch `span(id)` for a
   * span's full detail. See Span.
   */
  children: Array<Span>;
  /** Database query details when kind is DATABASE. */
  dbQuery?: Maybe<DbQuery>;
  /** Duration in milliseconds, if complete. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** Embedding details when kind is EMBEDDING. */
  embedding?: Maybe<Embedding>;
  /** When the span ended, if complete. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** Human-readable error message when status is ERROR. */
  error?: Maybe<Scalars['String']['output']>;
  /** error.type from OTel semantic conventions. */
  errorType?: Maybe<Scalars['String']['output']>;
  /** LLM details when kind is GENERATION. */
  generation?: Maybe<Generation>;
  /**
   * True when this span has at least one child in the database. Useful for
   * lazy-loading UIs that need to show an expand toggle without fetching
   * the full child subtree.
   */
  hasChildren: Scalars['Boolean']['output'];
  /** HTTP details when kind is HTTP. */
  http?: Maybe<HttpRequestResponse>;
  /** OTel span ID. */
  id: Scalars['ID']['output'];
  /** Observation kind for viewer grouping. */
  kind: SpanKind;
  /** Log records emitted during this span. */
  logs: Array<LogRecord>;
  /** Human-readable span name (e.g. chat claude-sonnet-4-6, execute_tool search_file). */
  name: Scalars['String']['output'];
  /** gen_ai.operation.name when applicable. */
  operationName?: Maybe<Scalars['String']['output']>;
  /** Rerank details when kind is RERANK. */
  rerank?: Maybe<Rerank>;
  /** Sandbox execution details when kind is SANDBOX. */
  sandbox?: Maybe<Sandbox>;
  /** When the span started. */
  startedAt: Scalars['Time']['output'];
  /**
   * Derived: IN_PROGRESS when endedAt is null; ERROR when endedAt is set and error
   * is present; otherwise OK.
   */
  status: SpanStatus;
  /** Tool details when kind is TOOL. */
  toolCall?: Maybe<TraceToolCall>;
};

/** Kind of observation within a trace. Supplements gen_ai.operation.name for viewer grouping. */
export enum SpanKind {
  /** A database query (OTel database client span). */
  Database = 'DATABASE',
  /** An embedding (text/content → vectors) call. */
  Embedding = 'EMBEDDING',
  /** An LLM generation (sync or streaming). */
  Generation = 'GENERATION',
  /** An outbound or inbound HTTP request (OTel HTTP client/server span). */
  Http = 'HTTP',
  /** A rerank call (query + candidates → scored reordering). */
  Rerank = 'RERANK',
  /** An isolated code execution in a sandbox (e.g. Modal). */
  Sandbox = 'SANDBOX',
  /** Generic nested work unit (retrieval, orchestration, etc.). */
  Span = 'SPAN',
  /** A tool invocation. */
  Tool = 'TOOL'
}

/** Status of a span, derived at read time from endedAt and error. */
export enum SpanStatus {
  /** Span ended with an error (OTel status Error). */
  Error = 'ERROR',
  /** Span has not ended yet (endedAt is null). */
  InProgress = 'IN_PROGRESS',
  /** Span ended without an error (OTel status Ok). */
  Ok = 'OK'
}

export type StartAdminAnalyticsExportInput = {
  /**
   * The dashboard's filters, checked as adminAnalyticsReport checks them. The file's times
   * are in UTC, as the date filter's days are.
   */
  filter?: InputMaybe<AdminAnalyticsFilterInput>;
  table: AdminAnalyticsExportTable;
};

/**
 * Input for startPresetGeneration: the source workspaces plus the wizard choices
 * that shape the generated preset.
 */
export type StartPresetGenerationInput = {
  /** Optional override of the auto-detected base preset. */
  basePresetOverride?: InputMaybe<CaraWorkspacePreset>;
  /** Optional custom forms the resulting preset should default to. */
  customFormIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional IDs of files to supply as additional context for generation. */
  fileIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional HTML document templates the resulting preset should default to. */
  htmlDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Optional free-text description of the desired output formats. */
  outputFormatsText?: InputMaybe<Scalars['String']['input']>;
  /** Optional answers to clarifying questions from a prior wizard turn. */
  qaAnswers?: InputMaybe<Array<PresetGenerationQaAnswerInput>>;
  /** The workspaces to generate the preset from. At least one is required. */
  sourceWorkspaceIds: Array<Scalars['String']['input']>;
  /** Optional Word document templates the resulting preset should default to. */
  wordDocumentTemplateIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Represents the tool that ends one recipient's drafting run in a bulk email by writing that
 * recipient's email: from the template the run was given, or in Cara's own words when it was
 * given none. Its output is DRAFT_EMAIL's.
 */
export type SubmitBulkEmailTool = {
  __typename?: 'SubmitBulkEmailTool';
  input: SubmitBulkEmailToolInput;
  output?: Maybe<DraftEmailToolOutput>;
};

/**
 * A run with a template fills in values and sections; a run without one writes the subject
 * and body. A recipient listed without an address also takes the address the run found, or
 * noEmailFound. The schema the model is given has only the fields that apply.
 */
export type SubmitBulkEmailToolInput = {
  __typename?: 'SubmitBulkEmailToolInput';
  bodyHtml?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  noEmailFound?: Maybe<Scalars['Boolean']['output']>;
  sections?: Maybe<Array<DraftEmailToolTemplateSectionText>>;
  subject?: Maybe<Scalars['String']['output']>;
  values?: Maybe<Array<DraftEmailToolTemplateValue>>;
};

/** Input for submitting call rating */
export type SubmitCallRatingInput = {
  /** Call ID */
  callId: Scalars['String']['input'];
  /**
   * Custom comment for additional details (optional, but required when OTHER is selected as a reason)
   * Can be provided with any reason for additional context
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Rating: up or down */
  rating: MessageRating;
  /**
   * Predefined reasons (multiple selection allowed, optional for thumbs up)
   * - For DOWN rating: select reasons for what went wrong
   * - For UP rating: optional, can leave blank for quick feedback
   */
  reasons?: InputMaybe<Array<CallQualityFeedbackNegativeReason>>;
};

/** Input for submitting message rating (thumbs up/down) */
export type SubmitMessageRatingInput = {
  /**
   * Custom comment for additional details (optional, but required when OTHER is selected as a reason)
   * Can be provided with any reason for additional context
   */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** Message being rated */
  messageId: Scalars['String']['input'];
  /** Rating: up or down */
  rating: MessageRating;
  /**
   * Predefined reasons (multiple selection allowed, optional for thumbs up)
   * - For DOWN rating: select reasons for what went wrong
   * - For UP rating: optional, can leave blank for quick feedback
   */
  reasons?: InputMaybe<Array<MessageFeedbackNegativeReason>>;
  /** Workspace containing the message */
  workspaceId: Scalars['String']['input'];
};

export type Subscription = {
  __typename?: 'Subscription';
  /** Subscribe to Cara workspace updates */
  watchCaraWorkspace: CaraWorkspace;
  /**
   * Subscribe to real-time updates for a workflow execution, including task
   * state changes and new events. Scoped via WORKFLOW_EXECUTION so the
   * directive denies cross-agency subscriptions.
   */
  watchWorkflowExecution: WorkflowExecution;
  /**
   * Subscribe to real-time task events for a specific task. Scoped via
   * WORKFLOW_TASK so the directive denies cross-agency subscriptions.
   */
  watchWorkflowTaskEvents: WorkflowTaskEvent;
};


export type SubscriptionWatchCaraWorkspaceArgs = {
  id: Scalars['ID']['input'];
};


export type SubscriptionWatchWorkflowExecutionArgs = {
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
};


export type SubscriptionWatchWorkflowTaskEventsArgs = {
  taskId: Scalars['ID']['input'];
};

/** Entitlements for the subscription */
export enum SubscriptionEntitlement {
  /** The entitlement to use advanced voice customization */
  AdvancedVoiceCustomization = 'ADVANCED_VOICE_CUSTOMIZATION',
  /**
   * The entitlement to author agency profiles that set the home screen, sidebar,
   * and permission policy for groups of agency users
   */
  AgencyProfileManagement = 'AGENCY_PROFILE_MANAGEMENT',
  /** The entitlement to connect AMS and CRM integrations (not available on Basic) */
  AmsCrmIntegrations = 'AMS_CRM_INTEGRATIONS',
  /** The entitlement to edit the fields of Cara-filled ACORD forms in the browser (all plans) */
  CopilotAcordEditor = 'COPILOT_ACORD_EDITOR',
  /** The entitlement to use the PDF Editor tool */
  CopilotPdfEditor = 'COPILOT_PDF_EDITOR',
  /** The entitlement to use Pro-tier Copilot presets (Underwriting Analysis, SOV & COPE, Claims Review, Loss Run Analysis) */
  CopilotProPresets = 'COPILOT_PRO_PRESETS',
  /** The entitlement to enable creation of and federate billing for sub agencies */
  FederatedBilling = 'FEDERATED_BILLING',
  /** The entitlement to connect and use mailboxes (Pro and Enterprise only) */
  Mailboxes = 'MAILBOXES',
  /** The entitlement to manage teams (groups of agency users) used to scope shared visibility */
  TeamManagement = 'TEAM_MANAGEMENT',
  /**
   * The entitlement to set visibility (PRIVATE / SHARED) on workspaces, presets,
   * templates, and forms. Without this, all objects remain PUBLIC.
   */
  VisibilityControl = 'VISIBILITY_CONTROL',
  /** The entitlement to enable voice agent account lookup (Account Policy Question tool; Pro and Enterprise only) */
  VoiceAccountLookup = 'VOICE_ACCOUNT_LOOKUP',
  /** The entitlement to create and manage workflow trigger definitions (Pro and Enterprise only) */
  WorkflowTriggers = 'WORKFLOW_TRIGGERS'
}

export type SubscriptionManagementLinks = {
  __typename?: 'SubscriptionManagementLinks';
  /** The link to the update subscription page for the agency */
  previewUpdateSubscription: PreviewUpdateSubscriptionResult;
  /** The link to the update payment method page for the agency */
  updatePaymentMethodUrl: Scalars['String']['output'];
};


export type SubscriptionManagementLinksPreviewUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};

/** The period of the subscription */
export enum SubscriptionPeriod {
  /** The subscription is yearly */
  Annual = 'ANNUAL',
  /** The subscription is monthly */
  Monthly = 'MONTHLY'
}

/** The plan that the agency is subscribed to */
export enum SubscriptionPlan {
  /** The basic subscription plan */
  Basic = 'BASIC',
  /** The premium subscription plan */
  Enterprise = 'ENTERPRISE',
  /** The pro subscription plan */
  Pro = 'PRO',
  /**
   * The standard subscription plan
   * @deprecated This plan is no longer available for new accounts.
   */
  Standard = 'STANDARD'
}

/** The state of the subscription for the agency */
export enum SubscriptionState {
  /**
   * The subscription is active and paid, or Stripe has it past due while a
   * payment toward it is still processing (e.g. an ACH debit settling). A failed
   * payment moves it back to OVERDUE.
   */
  Active = 'ACTIVE',
  /** The subscription has expired due to cancellation or nonpayment */
  Expired = 'EXPIRED',
  /** The subscription is active but unpaid */
  Overdue = 'OVERDUE',
  /** The subscription is currently paused */
  Paused = 'PAUSED',
  /** The subscription is currently in a trial period and active */
  Trial = 'TRIAL'
}

export type SuperCopyBlockInput = {
  id: Scalars['ID']['input'];
  tag: Scalars['String']['input'];
  text: Scalars['String']['input'];
};

export enum SuperCopyBoundaryKind {
  Region = 'REGION',
  WholePage = 'WHOLE_PAGE'
}

export type SuperCopyDraft = {
  __typename?: 'SuperCopyDraft';
  clients: Array<SuperCopyDraftClient>;
  modelId: Scalars['String']['output'];
  source: SuperCopySource;
};

export type SuperCopyDraftClient = {
  __typename?: 'SuperCopyDraftClient';
  groups: Array<SuperCopyGroup>;
  id: Scalars['ID']['output'];
  suggestedName: Scalars['String']['output'];
};

/** Source-backed record structure. Null means unclassified, not a generic contact. */
export type SuperCopyEntity = {
  __typename?: 'SuperCopyEntity';
  confidence: Scalars['Float']['output'];
  evidence: SuperCopyEvidence;
  parentGroupId?: Maybe<Scalars['ID']['output']>;
  relation: Scalars['String']['output'];
  role?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SuperCopyEvidence = {
  __typename?: 'SuperCopyEvidence';
  blockIds: Array<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type SuperCopyGroup = {
  __typename?: 'SuperCopyGroup';
  entity?: Maybe<SuperCopyEntity>;
  id: Scalars['ID']['output'];
  kind: SuperCopyGroupKind;
  label: Scalars['String']['output'];
  values: Array<SuperCopyValue>;
};

export enum SuperCopyGroupKind {
  Address = 'ADDRESS',
  Agency = 'AGENCY',
  Business = 'BUSINESS',
  Contact = 'CONTACT',
  Custom = 'CUSTOM',
  Policy = 'POLICY'
}

export enum SuperCopyReviewState {
  Accepted = 'ACCEPTED',
  Custom = 'CUSTOM',
  Edited = 'EDITED',
  Unknown = 'UNKNOWN'
}

export type SuperCopySource = {
  __typename?: 'SuperCopySource';
  boundaryFingerprint: Scalars['String']['output'];
  boundaryKind: SuperCopyBoundaryKind;
  boundaryLabel: Scalars['String']['output'];
  screenshotCoverage: Scalars['String']['output'];
  title: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type SuperCopySourceInput = {
  boundaryFingerprint: Scalars['String']['input'];
  boundaryKind: SuperCopyBoundaryKind;
  boundaryLabel: Scalars['String']['input'];
  screenshotCoverage: Scalars['String']['input'];
  title: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type SuperCopyValue = {
  __typename?: 'SuperCopyValue';
  confidence: Scalars['Float']['output'];
  evidence: SuperCopyEvidence;
  extractedValue: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  label: Scalars['String']['output'];
  reviewState: SuperCopyReviewState;
  semanticKey: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SwitchMailboxDraftInput = {
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision: Scalars['String']['input'];
  createDraft: Scalars['Boolean']['input'];
  mailboxDraftId: Scalars['String']['input'];
  nextMailboxAccountId: Scalars['String']['input'];
};

/**
 * The saved sender is returned even if the provider refused the optional new draft.
 * The composition remains in Cara and the caller may retry saving it to the mailbox.
 */
export type SwitchMailboxDraftResult = {
  __typename?: 'SwitchMailboxDraftResult';
  artifact: CaraWorkspaceArtifact;
  draftError?: Maybe<Scalars['String']['output']>;
  mailboxDraft?: Maybe<MailboxDraft>;
};

/** Table style */
export type TableStyle = {
  __typename?: 'TableStyle';
  /** Border collapse setting (e.g. 'collapse') */
  borderCollapse?: Maybe<Scalars['String']['output']>;
  /** Cell border style (e.g. '1px solid #cbd5e1') */
  cellBorder?: Maybe<Scalars['String']['output']>;
  /** Cell padding in em units (e.g. 0.4) */
  cellPaddingEm?: Maybe<Scalars['Float']['output']>;
  /** Font size in points (e.g. 10.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Header background color in hex format (e.g. '#e2e8f0') */
  headerBackgroundColorHex?: Maybe<Scalars['String']['output']>;
  /** Header text color in hex format (e.g. '#0f172a') */
  headerColorHex?: Maybe<Scalars['String']['output']>;
  /** Header font weight as a number (e.g. 600) */
  headerFontWeight?: Maybe<Scalars['Int']['output']>;
  /** Top margin in em units (e.g. 1.0) */
  marginTopEm?: Maybe<Scalars['Float']['output']>;
  /** When true, table header rows repeat on each page when the table spans multiple pages */
  repeatHeaders?: Maybe<Scalars['Boolean']['output']>;
  /** Width as a percentage (e.g. 100.0) */
  widthPct?: Maybe<Scalars['Float']['output']>;
  /** Background color for zebra-striped even rows in hex format (e.g. '#f8fafc'). When set, alternating rows are styled. */
  zebraStripeColorHex?: Maybe<Scalars['String']['output']>;
};

/** Input for table style */
export type TableStyleInput = {
  /** CSS border-collapse style ('collapse', 'separate') */
  borderCollapse?: InputMaybe<Scalars['String']['input']>;
  /** CSS border property for cells (e.g. '1px solid #ccc') */
  cellBorder?: InputMaybe<Scalars['String']['input']>;
  /** Cell padding in em units */
  cellPaddingEm?: InputMaybe<Scalars['Float']['input']>;
  /** Font size in points for table text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Header background color as a hex string */
  headerBackgroundColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Header text color as a hex string */
  headerColorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font weight of table header text */
  headerFontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Top margin in em units */
  marginTopEm?: InputMaybe<Scalars['Float']['input']>;
  /** If true, table headers are repeated on each page */
  repeatHeaders?: InputMaybe<Scalars['Boolean']['input']>;
  /** Table width as a percentage of the page width (0-100) */
  widthPct?: InputMaybe<Scalars['Float']['input']>;
  /** Background color for zebra striped rows as a hex string */
  zebraStripeColorHex?: InputMaybe<Scalars['String']['input']>;
};

/**
 * A team is a grouping of agency users used to scope SHARED visibility on
 * workspaces, presets, templates, and forms. Teams do not grant or restrict
 * permissions on their own — they only affect what objects a user can see when
 * those objects are set to SHARED visibility with the team in the access list.
 *
 * Team management is gated behind the TEAM_MANAGEMENT subscription entitlement
 * (Enterprise plan). Without the entitlement, teams cannot be created or used
 * to scope visibility.
 */
export type Team = {
  __typename?: 'Team';
  /** Agency the team belongs to */
  agency: Agency;
  /** Timestamp when the team was archived (soft delete). Null for active teams. */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** Timestamp when the team was created */
  createdAt: Scalars['Time']['output'];
  /** Agency user that created this team */
  createdBy: AgencyUser;
  /** Optional description of the team */
  description?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the team */
  id: Scalars['ID']['output'];
  /** Number of members in the team */
  memberCount: Scalars['Int']['output'];
  /** Members of the team */
  members: Array<TeamMember>;
  /** Name of the team. Unique within an agency (case-insensitive). */
  name: Scalars['String']['output'];
  /** Timestamp when the team was last updated */
  updatedAt: Scalars['Time']['output'];
};

/** Input for creating or updating a team. */
export type TeamInput = {
  /** Optional description of the team */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial set of agency user IDs to add as members.
   * For updateTeam, this replaces the full member list.
   */
  memberUserIds: Array<Scalars['String']['input']>;
  /** Name of the team. Must be unique within the agency (case-insensitive). */
  name: Scalars['String']['input'];
};

/** A user's membership in a team. */
export type TeamMember = {
  __typename?: 'TeamMember';
  /** Timestamp when the user was added to the team */
  addedAt: Scalars['Time']['output'];
  /** The agency user that is a member of the team */
  user: AgencyUser;
};

/** Which design documents made from a template start on. */
export enum TemplateDesignSource {
  /** The design the workspace's documents already use, else the agency's default design. */
  Default = 'DEFAULT',
  /** The design designId names. */
  Design = 'DESIGN',
  /**
   * No design: documents print with the template's own saved look and its own start and end pages
   * until one is given a design. Only migrated templates are LEGACY; it cannot be chosen otherwise,
   * and a template switched away from it first leaves its look in a new LEGACY copy.
   */
  Legacy = 'LEGACY',
  /**
   * No design: documents print with the renderer's plain base, without the template's Style settings
   * or header and footer, until one is given a design.
   */
  None = 'NONE'
}

/** The fields of one template form version, as the in-browser editor needs them. */
export type TemplateFormEditorState = {
  __typename?: 'TemplateFormEditorState';
  /**
   * False when this form, version, or viewer cannot be edited; the client shows the
   * read-only preview instead.
   */
  editable: Scalars['Boolean']['output'];
  fields: Array<TemplateFormFieldState>;
  /**
   * The newest version of the artifact. Saves are made against it, so a viewer of
   * an older version cannot save.
   */
  latestVersion: Scalars['Int']['output'];
  /**
   * What each page of the version's PDF prints, in order: the form's own pages,
   * then the continuation sheets and overflow copies behind it. Pages past the
   * last are files attached behind the form. Null when the server cannot plan
   * the PDF, in which case no sheet's fields are offered.
   */
  pages?: Maybe<Array<TemplateFormPage>>;
  /**
   * Whether the agency's certificate settings print every text value in capital
   * letters, which the PDF does whatever case a value was typed in.
   */
  printsInAllCaps: Scalars['Boolean']['output'];
  /**
   * Whether the viewer may restore this older version's fields as a new latest
   * version; false for the latest version itself.
   */
  restorable: Scalars['Boolean']['output'];
  version: Scalars['Int']['output'];
};

export type TemplateFormFieldEditInput = {
  /** Text for a text widget; the checked export value or "Off" for a checkbox. */
  value: Scalars['String']['input'];
  /** The widget name, as TemplateFormFieldState.widgetName gives it. */
  widgetName: Scalars['String']['input'];
};

export enum TemplateFormFieldKind {
  Checkbox = 'CHECKBOX',
  Text = 'TEXT'
}

/** Whose value a template form field holds: a user's, or Cara's. */
export enum TemplateFormFieldProvenance {
  /**
   * The current, non-empty value is Cara's: she filled it, or a user set the
   * field back to what her latest fill maps to it.
   */
  CaraFilled = 'CARA_FILLED',
  /** The field is empty, and Cara's latest fill leaves it empty. */
  Untouched = 'UNTOUCHED',
  /**
   * A user saved the current value from the form editor, or it was carried
   * forward from such a save, and it differs from what Cara's latest fill maps
   * to the field.
   */
  UserEdited = 'USER_EDITED'
}

/** One editable widget of a template form version. */
export type TemplateFormFieldState = {
  __typename?: 'TemplateFormFieldState';
  /**
   * The form that prints what this widget's box cannot hold, e.g. "ACORD 101";
   * null when text past the edge of the box is cut off.
   */
  continuedOn?: Maybe<Scalars['String']['output']>;
  /** The value a checkbox exports when checked; null for text widgets. */
  exportValue?: Maybe<Scalars['String']['output']>;
  kind: TemplateFormFieldKind;
  /**
   * The stored field this widget fills, e.g. "Location_A.Construction_BuildingArea",
   * behind its sheet's title for a widget on a sheet, e.g. "ACORD 101 #1.F0_P10_NamedInsured_FullName_A0".
   */
  label: Scalars['String']['output'];
  lastEditedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * The user whose save set the current value: null unless provenance is
   * USER_EDITED, and null then when that user no longer exists.
   */
  lastEditedBy?: Maybe<AgencyUser>;
  /** The longest text the widget accepts; null when the PDF sets no limit. */
  maxLength?: Maybe<Scalars['Int']['output']>;
  provenance: TemplateFormFieldProvenance;
  /** What Cara's latest fill maps to this field, when a user-edited value differs from it. */
  suggestion?: Maybe<Scalars['String']['output']>;
  /**
   * The stored value before render-time formatting: text for a text widget, the
   * export value (e.g. "1" or "Off") for a checkbox.
   */
  value: Scalars['String']['output'];
  /**
   * The fully qualified PDF widget name, as the template names it. A widget on a
   * continuation sheet or overflow copy is named behind the ID of its sheet and a
   * slash, e.g. "acord_101#1/F[0].P1[0].NamedInsured_FullName_A[0]".
   */
  widgetName: Scalars['String']['output'];
};

/** One page of a template form version's PDF. */
export type TemplateFormPage = {
  __typename?: 'TemplateFormPage';
  /**
   * The ID of the sheet the page is part of, which names the sheet's widgets in
   * TemplateFormFieldState.widgetName; null for a page of the form itself.
   */
  sheet?: Maybe<Scalars['String']['output']>;
};

/** Represents a reference to text content stored in the cache */
export type TextReference = {
  __typename?: 'TextReference';
  /** The cache key for the text content */
  cacheKey: Scalars['String']['output'];
  /** The size of the text content in bytes */
  sizeBytes?: Maybe<Scalars['Int']['output']>;
  /** Whether the content was truncated */
  truncated: Scalars['Boolean']['output'];
};

/**
 * Represents a tool that allows the LLM to think through a problem or task.
 * This tool is used when the LLM needs to process information or make decisions.
 */
export type ThinkTool = {
  __typename?: 'ThinkTool';
  /** The input arguments for the think operation */
  input: ThinkToolInput;
  /** The result of the thinking operation */
  output: ThinkToolOutput;
};

/**
 * Input arguments for the ThinkTool.
 * Used to provide context and purpose for the thinking operation.
 */
export type ThinkToolInput = {
  __typename?: 'ThinkToolInput';
  /** The detailed thought process */
  thought: Scalars['String']['output'];
  /** A brief title describing the thinking task */
  title: Scalars['String']['output'];
};

/**
 * Result of a ThinkTool operation.
 * Indicates whether the thinking process was successful.
 */
export type ThinkToolOutput = {
  __typename?: 'ThinkToolOutput';
  /** Whether the thinking operation completed successfully */
  success: Scalars['Boolean']['output'];
};

/**
 * Token usage for an LLM generation.
 * Maps to gen_ai.usage.* attributes.
 */
export type TokenUsage = {
  __typename?: 'TokenUsage';
  /** gen_ai.usage.cache_creation.input_tokens */
  cacheCreationInputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.cache_read.input_tokens */
  cacheReadInputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.input_tokens */
  inputTokens: Scalars['Int']['output'];
  /** gen_ai.usage.output_tokens */
  outputTokens: Scalars['Int']['output'];
  /**
   * Tokens spent on internal reasoning that is not part of the returned output.
   * Disjoint from outputTokens, and billed at the output rate.
   */
  thinkingTokens: Scalars['Int']['output'];
};

/** Represents a tool call that was made in the context of an email conversation */
export type ToolCall = {
  __typename?: 'ToolCall';
  /** The arguments passed to the tool in JSON format */
  argumentsJson: Scalars['String']['output'];
  /** The ID of the tool call */
  id: Scalars['String']['output'];
  /** The name of the tool being called */
  name: Scalars['String']['output'];
  /** The result of the tool call */
  result: Scalars['String']['output'];
  /** Timestamp when this tool call was made */
  timestamp: Scalars['Time']['output'];
};

/** A top-level trace representing one agent run or user request. */
export type Trace = {
  __typename?: 'Trace';
  /** Analysis state and results for this trace. */
  analysis?: Maybe<TraceAnalysis>;
  /** Set when the associated Temporal workflow was cancelled. Drives CANCELLED status. */
  cancelledAt?: Maybe<Scalars['Time']['output']>;
  /** Duration in milliseconds, if complete. */
  durationMs?: Maybe<Scalars['Int']['output']>;
  /** When the trace ended. */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /** Human-readable error message if status is ERROR. */
  error?: Maybe<Scalars['String']['output']>;
  /** error.type from OTel semantic conventions. */
  errorType?: Maybe<Scalars['String']['output']>;
  /** OTel trace ID. */
  id: Scalars['ID']['output'];
  /**
   * High-level trace input (e.g. user message, task prompt).
   * May be truncated for storage.
   */
  input?: Maybe<Scalars['JSON']['output']>;
  /** All log records in this trace, ordered by timestamp. */
  logs: Array<LogRecord>;
  /** Additional trace-level metadata and tags. */
  metadata: Scalars['JSON']['output'];
  /** Human-readable trace name (e.g. cara.workspace.execute_task_step). */
  name: Scalars['String']['output'];
  /**
   * High-level trace output (e.g. final agent response).
   * May be truncated for storage.
   */
  output?: Maybe<Scalars['JSON']['output']>;
  /**
   * Root spans (parentSpanId is null), ordered by startedAt. Loaded as lightweight
   * summaries — the heavy detail payloads are null here; fetch `span(id)` for a span's
   * full detail. See Span.
   */
  rootSpans: Array<Span>;
  /** Total number of spans in this trace. */
  spanCount: Scalars['Int']['output'];
  /** When the trace started. */
  startedAt: Scalars['Time']['output'];
  /**
   * Derived: CANCELLED when cancelledAt is set; IN_PROGRESS when endedAt is null;
   * ERROR when the trace or any span recorded an error; otherwise OK.
   */
  status: TraceStatus;
  /** Aggregate cost in dollars across all generations in this trace. */
  totalCostDollars: Scalars['Decimal']['output'];
  /** Aggregate token usage across all generations in this trace. */
  totalUsage: TokenUsage;
  /** Associated workspace, if any. */
  workspace?: Maybe<CaraWorkspace>;
};

/**
 * Trace analysis job and results for a single trace. The analysis agent produces
 * markdown (analysis) for human-readable narrative and structured output (result)
 * for filtering and triage. Only populate result when state is COMPLETED.
 */
export type TraceAnalysis = {
  __typename?: 'TraceAnalysis';
  /**
   * Full narrative in Markdown for the trace detail view: timeline, context,
   * and explanation. May elaborate beyond result.summary but must not contradict
   * result.outcome, category, or primaryIssue. Populated when state is COMPLETED.
   */
  analysis?: Maybe<Scalars['String']['output']>;
  /** When the analysis job was enqueued. */
  createdAt: Scalars['Time']['output'];
  /** The ID of the Cursor agent that ran the analysis (to open in the UI) */
  cursorAgentId?: Maybe<Scalars['String']['output']>;
  /** The ID of the Cursor run that ran the analysis (to open in the UI) */
  cursorRunId?: Maybe<Scalars['String']['output']>;
  /**
   * When the analysis agent finished (success or failure). Null while QUEUED or
   * RUNNING.
   */
  endedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Error message if the analysis job itself failed (agent crash, timeout, invalid
   * output). Not the trace's error — that belongs in result.rootCauseSummary.
   * Populated when state is FAILED.
   */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique ID of this analysis run. */
  id: Scalars['ID']['output'];
  /**
   * Structured triage output for search, dashboards, and alerts. Populated when
   * state is COMPLETED. The analysis agent must set every required field; see
   * field descriptions on TraceAnalysisResult for how to choose values.
   */
  result?: Maybe<TraceAnalysisResult>;
  /** When the analysis agent began processing the trace. Null while QUEUED. */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Lifecycle state of the analysis job. Set by the orchestrator, not the
   * analysis agent.
   */
  state: TraceAnalysisState;
  /** The trace this analysis belongs to. */
  trace: Trace;
  /** When the analysis record was last updated. */
  updatedAt: Scalars['Time']['output'];
};

export type TraceAnalysisConnection = {
  __typename?: 'TraceAnalysisConnection';
  edges: Array<TraceAnalysisEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraceAnalysisEdge = {
  __typename?: 'TraceAnalysisEdge';
  cursor: Scalars['String']['output'];
  node: TraceAnalysis;
};

/**
 * Supporting evidence for a trace analysis issue: an interpretive claim linked to
 * spans and logs. Do not restate raw span names without interpretation.
 */
export type TraceAnalysisEvidence = {
  __typename?: 'TraceAnalysisEvidence';
  /**
   * A single interpretive claim (not a span name or raw error string). Example:
   * "KB rerank top score was 0.28, below the usual adequate threshold."
   */
  claim: Scalars['String']['output'];
  /**
   * Correlated log IDs when the claim depends on log context not captured on the
   * span (workflow warnings, stuck-loop detector messages). Omit when span data
   * alone is sufficient.
   */
  logIds?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * OTel span IDs that directly support the claim. Use the earliest span that
   * establishes the fact (e.g. the failing TOOL span, the RERANK span with low
   * topScore). At least one span is required per evidence entry.
   */
  spanIds: Array<Scalars['String']['output']>;
};

/** A distinct issue identified during trace analysis. */
export type TraceAnalysisIssue = {
  __typename?: 'TraceAnalysisIssue';
  /** One or more categories classifying this issue. */
  categories: Array<TraceAnalysisIssueCategory>;
  /**
   * Supporting interpretive claims with span and log IDs. At least one entry per
   * issue when the issue is non-obvious.
   */
  evidence: Array<TraceAnalysisEvidence>;
  /**
   * 2-4 sentences explaining what happened, why it matters, and how it relates
   * to the run outcome.
   */
  summary: Scalars['String']['output'];
  /** Short title, 4-10 words. */
  title: Scalars['String']['output'];
};

/**
 * Top-level issue category for filtering and dashboards. Every primaryIssue
 * belongs to exactly one category; finer detail (tool name, loop type, etc.)
 * belongs in rootCauseSummary and issues.
 */
export enum TraceAnalysisIssueCategory {
  /**
   * Agent loop did not complete normally: stuck loops, iteration cap, or no
   * COMPLETE_TASK.
   */
  AgentOrchestration = 'AGENT_ORCHESTRATION',
  /**
   * Producing user-facing deliverables: documents, forms, templates, sandbox
   * code outputs.
   */
  Artifact = 'ARTIFACT',
  /**
   * Third-party services outside the agency corpus: web search and AMS/CRM
   * integrations.
   */
  ExternalService = 'EXTERNAL_SERVICE',
  /** File or attachment access and parsing (PEEK_FILE, ingest, Reducto). */
  File = 'FILE',
  /** Timeouts, cancellation, or Cara platform infrastructure. */
  Infrastructure = 'INFRASTRUCTURE',
  /** LLM provider calls and output quality (GENERATION spans). */
  Llm = 'LLM',
  /** Cost, latency, or other quality concerns without a functional failure. */
  Operational = 'OPERATIONAL',
  /**
   * Could not find or rank relevant context (file/KB/KG/memory search;
   * embedding and rerank spans).
   */
  Retrieval = 'RETRIEVAL',
  /** Tool input validation or execution not better explained by a category above. */
  ToolCall = 'TOOL_CALL',
  /** Root cause could not be determined. */
  Unknown = 'UNKNOWN',
  /**
   * User-side cause: ambiguous or missing input, misuse of the product, or
   * agency misconfiguration the user could have resolved. Use when the primary
   * root cause is not a Cara bug or infra failure — e.g. required attachment
   * not uploaded, unclear instructions the agent could not disambiguate, or
   * incorrect expectations about what Cara can do. Pair with outcome USER_ERROR
   * when the user did not get an acceptable result for this reason.
   */
  UserError = 'USER_ERROR'
}

/**
 * High-level outcome of a completed trace analysis. Describes the user-visible
 * result of the agent run. May differ from Trace.status (e.g. Trace.status OK
 * with outcome DEGRADED when retrieval was weak). Set from the trace's final
 * deliverable and error spans, not from infrastructure health alone. Use
 * category and primaryIssue for the technical root cause.
 */
export enum TraceAnalysisOutcome {
  /**
   * Trace.cancelledAt is set or the workflow/activity was cancelled before the
   * task finished.
   */
  Cancelled = 'CANCELLED',
  /**
   * The user received a usable result but quality was compromised: weak rerank
   * scores, rerank fallback, minor truncation, elevated cost/latency, or
   * recoverable tool errors that the agent worked around. Prefer this over
   * FAILURE when the workspace output still addresses the user's request.
   */
  Degraded = 'DEGRADED',
  /**
   * The task failed for any other functional reason: agent stuck or incomplete,
   * retrieval miss, artifact/form failure, integration API error, LLM error, etc.
   * Pick the most specific category; use FAILURE when the user did not get an
   * acceptable result and USER_ERROR does not apply.
   */
  Failure = 'FAILURE',
  /**
   * Failed due to Cara platform or provider infrastructure: internal database
   * errors, unrecoverable HTTP failures to LLM/embedding providers, Modal/sandbox
   * platform errors, or integration endpoints that are down. Do not use for
   * agency misconfiguration (INTEGRATION_NOT_CONFIGURED) or tool argument errors.
   */
  InfrastructureError = 'INFRASTRUCTURE_ERROR',
  /**
   * The user received a satisfactory result: COMPLETE_TASK was called (or the
   * trace output answers the prompt) with no significant quality concerns in
   * retrieval, cost, or latency. Trace.status may be OK or ERROR if a non-fatal
   * span errored but the task still completed.
   */
  Success = 'SUCCESS',
  /**
   * The trace or a dominant activity exceeded its timeout (Temporal
   * start-to-close, sandbox ~60s, Reducto poll timeout, etc.) before completing.
   */
  Timeout = 'TIMEOUT',
  /**
   * The user did not get an acceptable result primarily because of user-side
   * input or behavior: ambiguous or contradictory instructions, missing required
   * attachments or data, misuse of the product, or agency misconfiguration the
   * user could have resolved. Cara may have behaved reasonably given what it had.
   * Pair with category USER_ERROR. Prefer over FAILURE when engineering changes
   * would not have fixed the run without different user input.
   */
  UserError = 'USER_ERROR'
}

/**
 * An actionable recommendation from the analysis. Each item should be something
 * a developer or operator can do — not a restatement of what went wrong.
 */
export type TraceAnalysisRecommendation = {
  __typename?: 'TraceAnalysisRecommendation';
  /**
   * Imperative next step. Example: "Review prompt version copilot_contextual v2.3
   * — generation truncated on turn 4." Be specific; avoid vague "investigate
   * further" without a target.
   */
  action: Scalars['String']['output'];
  /**
   * How urgently to act on this recommendation relative to others in the same
   * analysis.
   */
  priority: TraceAnalysisRecommendationPriority;
  /**
   * Brief justification tied to trace evidence. Explain why this action addresses
   * the root cause.
   */
  rationale: Scalars['String']['output'];
  /**
   * The single span most relevant to this recommendation, if any. Use the span
   * a reviewer should open first in the trace viewer.
   */
  spanId?: Maybe<Scalars['String']['output']>;
};

/**
 * Priority of a trace analysis recommendation. Guides ordering in review UIs;
 * independent of severity (a LOW-severity trace can still have a HIGH-priority
 * fix for a recurring misconfiguration).
 */
export enum TraceAnalysisRecommendationPriority {
  /** Immediate action required (e.g. stop a runaway loop, fix a broken integration). */
  Critical = 'CRITICAL',
  /** Likely fix for the reported issue; do this before closing the investigation. */
  High = 'HIGH',
  /** Nice-to-have improvement or preventive suggestion. */
  Low = 'LOW',
  /** Should be addressed when investigating this class of trace. */
  Medium = 'MEDIUM'
}

/**
 * Structured output from a completed trace analysis. Populated by the analysis
 * agent when TraceAnalysis.state is COMPLETED. All fields are required except
 * rootCauseSpanId (set when a single span is clearly responsible; omit when the
 * cause is distributed or inconclusive).
 */
export type TraceAnalysisResult = {
  __typename?: 'TraceAnalysisResult';
  /**
   * Union of categories across issues, for filtering and dashboards. Populated
   * from issues at write time.
   */
  categories?: Maybe<Array<TraceAnalysisIssueCategory>>;
  /**
   * Distinct issues identified during analysis. Every HIGH/CRITICAL severity
   * analysis should include at least one issue. Prefer fewer, stronger issues
   * over exhaustive span listing.
   */
  issues?: Maybe<Array<TraceAnalysisIssue>>;
  /**
   * User-visible result of the run. Judge from trace input/output, whether
   * COMPLETE_TASK was reached, and whether the final response satisfies the
   * prompt — not from Trace.status alone.
   */
  outcome: TraceAnalysisOutcome;
  /**
   * Ordered actionable next steps for an engineer reviewing this trace. Include
   * at least one when outcome is not SUCCESS; may be empty for clean SUCCESS
   * runs. Do not duplicate issue summaries verbatim.
   */
  recommendations?: Maybe<Array<TraceAnalysisRecommendation>>;
  /**
   * OTel span ID of the root-cause span — typically the first ERROR span on the
   * critical path, or the RERANK/GENERATION/TOOL span that best explains the
   * failure. Null when cause is workflow-level (e.g. distributed stuck loop)
   * or indeterminate.
   */
  rootCauseSpanId?: Maybe<Scalars['String']['output']>;
  /**
   * One sentence naming what failed, where, and why. Include tool name,
   * integration, model, or loop type here (not as enum values). Example: "Turn 6
   * SEARCH_KNOWLEDGE_BASE rerank topScore 0.19; agent synthesized from weak
   * matches."
   */
  rootCauseSummary: Scalars['String']['output'];
  /**
   * Urgency for human triage. CRITICAL for runaway loops, hard failures, or
   * clearly wrong customer-facing output; LOW for successful runs with minor
   * anomalies. Should correlate with but not duplicate outcome (a DEGRADED run
   * can be LOW if the issue is minor).
   */
  severity: TraceAnalysisSeverity;
  /**
   * One or two sentences for a trace list or alert. State what the user asked
   * for, what happened, and the bottom line. Do not include span IDs (those
   * belong in issues).
   */
  summary: Scalars['String']['output'];
};

/**
 * Triage priority for a completed trace analysis. Reflects urgency for human
 * review, not the technical severity of the underlying span error.
 */
export enum TraceAnalysisSeverity {
  /** Clear failure, data loss risk, or runaway cost/loop; needs prompt attention. */
  Critical = 'CRITICAL',
  /** Likely customer-impacting or materially wrong output; should be reviewed. */
  High = 'HIGH',
  /**
   * Informational: successful run worth noting (e.g. slightly elevated cost) but
   * no action required.
   */
  Low = 'LOW',
  /**
   * Worth reviewing when debugging similar workspaces, but not blocking or
   * customer-impacting on its own.
   */
  Medium = 'MEDIUM'
}

/** Sort fields for searchTraceAnalysis. */
export enum TraceAnalysisSortField {
  CreatedAt = 'CREATED_AT',
  EndedAt = 'ENDED_AT',
  Outcome = 'OUTCOME',
  Severity = 'SEVERITY',
  StartedAt = 'STARTED_AT',
  TraceDuration = 'TRACE_DURATION',
  TraceStartedAt = 'TRACE_STARTED_AT',
  TraceTotalCost = 'TRACE_TOTAL_COST'
}

export type TraceAnalysisSortInput = {
  direction: SortDirection;
  field: TraceAnalysisSortField;
};

/** State of a trace analysis job. */
export enum TraceAnalysisState {
  /** Analysis was cancelled before completion. */
  Cancelled = 'CANCELLED',
  /** Analysis finished successfully. analysis and result are populated. */
  Completed = 'COMPLETED',
  /**
   * Analysis failed before producing results. error is populated; analysis and
   * result are null.
   */
  Failed = 'FAILED',
  /** Analysis is queued and has not started. */
  Queued = 'QUEUED',
  /** Analysis is in progress. */
  Running = 'RUNNING'
}

export type TraceConnection = {
  __typename?: 'TraceConnection';
  edges: Array<TraceEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TraceEdge = {
  __typename?: 'TraceEdge';
  cursor: Scalars['String']['output'];
  node: Trace;
};

/** Filter input for traceLogs. */
export type TraceLogsFilterInput = {
  /** Minimum log severity (inclusive). */
  minSeverity?: InputMaybe<LogSeverity>;
  /** Case-insensitive search against log message and attributes. */
  search?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to logs under this span. */
  spanId?: InputMaybe<Scalars['ID']['input']>;
  /** Only logs emitted strictly after this timestamp. */
  timestampAfter?: InputMaybe<Scalars['Time']['input']>;
  /** Only logs emitted strictly before this timestamp. */
  timestampBefore?: InputMaybe<Scalars['Time']['input']>;
};

/** Sort fields for searchTraces. */
export enum TraceSortField {
  Duration = 'DURATION',
  InputTokens = 'INPUT_TOKENS',
  OutputTokens = 'OUTPUT_TOKENS',
  StartedAt = 'STARTED_AT',
  TotalCost = 'TOTAL_COST'
}

export type TraceSortInput = {
  direction: SortDirection;
  field: TraceSortField;
};

/**
 * The resolved object behind a rerank candidate or embedding input. Exactly one field is
 * populated, selected by the parent's sourceType + id; the rest are null. Resolved on
 * demand so trace reads don't eagerly load every referenced object.
 */
export type TraceSource = {
  __typename?: 'TraceSource';
  file?: Maybe<File>;
  knowledgeBaseDocument?: Maybe<KnowledgeBaseDocument>;
  memory?: Maybe<Memory>;
};

/**
 * The kind of object a rerank candidate or embedding input refers to. Drives which field
 * of TraceSource is populated. KG property-field reranks have no resolvable object and
 * carry a null sourceType.
 */
export enum TraceSourceType {
  File = 'FILE',
  KnowledgeBaseDocument = 'KNOWLEDGE_BASE_DOCUMENT',
  Memory = 'MEMORY'
}

/**
 * Execution status of a trace, derived at read time from the trace's endedAt,
 * cancelledAt, and span errors.
 */
export enum TraceStatus {
  /** Cancelled before completion. */
  Cancelled = 'CANCELLED',
  /** Completed with an error. */
  Error = 'ERROR',
  /**
   * Trace is still running (endedAt is null and not cancelled). Spans are exported
   * end-only, so in-progress is determined by the trace's own endedAt, not spans.
   */
  InProgress = 'IN_PROGRESS',
  /** Completed successfully. */
  Ok = 'OK'
}

/**
 * Tool-specific details attached to a TOOL span.
 * Named TraceToolCall to avoid collision with email.graphqls ToolCall.
 */
export type TraceToolCall = {
  __typename?: 'TraceToolCall';
  /** gen_ai.tool.call.arguments (serialized text). */
  arguments: Scalars['String']['output'];
  /** gen_ai.tool.call.id */
  callId?: Maybe<Scalars['String']['output']>;
  /** Error message if the tool call failed. */
  error?: Maybe<Scalars['String']['output']>;
  /** Whether the tool call failed. */
  failed: Scalars['Boolean']['output'];
  /** gen_ai.tool.name */
  name: Scalars['String']['output'];
  /** gen_ai.tool.call.result (serialized text). May be truncated for storage. */
  result?: Maybe<Scalars['String']['output']>;
};

/**
 * A transfer directory row the editor changed: from and to edit it, from alone deletes it,
 * to alone adds it.
 */
export type TransferDirectoryChangeInput = {
  /** The row as loaded, JSON-encoded. */
  from?: InputMaybe<Scalars['String']['input']>;
  /** The row as edited, JSON-encoded. */
  to?: InputMaybe<Scalars['String']['input']>;
};

export enum TriggerAuditLevel {
  Error = 'ERROR',
  Info = 'INFO',
  Warning = 'WARNING'
}

export type TriggerAuditLog = {
  __typename?: 'TriggerAuditLog';
  /** Admission/dispatch attempt this log belongs to, when applicable. */
  attempt?: Maybe<Scalars['Int']['output']>;
  createdAt: Scalars['Time']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  level: TriggerAuditLevel;
  message: Scalars['String']['output'];
  triggerEventId: Scalars['String']['output'];
  triggerRunId?: Maybe<Scalars['String']['output']>;
  /** Timeline event kind. */
  type: TriggerAuditType;
};

export enum TriggerAuditType {
  /** TriggerRunWorkflow acquired a capacity lease. */
  CapacityAcquired = 'CAPACITY_ACQUIRED',
  /** Capacity lease released (workflow complete or orphan reconcile). */
  CapacityReleased = 'CAPACITY_RELEASED',
  /** Route + Match finished for the event. */
  EvaluationCompleted = 'EVALUATION_COMPLETED',
  /** Normalized event row was created (or dedupe hit). */
  EventReceived = 'EVENT_RECEIVED',
  /** Event or run failed permanently. */
  Failed = 'FAILED',
  /** A TriggerRun was inserted QUEUED for a matching definition. */
  RunQueued = 'RUN_QUEUED',
  /** Target execution (workspace) was created and the run marked LAUNCHED. */
  TargetLaunched = 'TARGET_LAUNCHED'
}

export type TriggerCallAnalyzedConfig = {
  __typename?: 'TriggerCallAnalyzedConfig';
  callType: TriggerCallType;
  minimumDurationSeconds: Scalars['Int']['output'];
  routing: TriggerCallRouting;
};

export type TriggerCallAnalyzedConfigInput = {
  callType?: TriggerCallType;
  minimumDurationSeconds?: Scalars['Int']['input'];
  routing?: TriggerCallRouting;
};

export enum TriggerCallRouting {
  AnyAccount = 'ANY_ACCOUNT',
  NewBusiness = 'NEW_BUSINESS',
  Service = 'SERVICE'
}

export enum TriggerCallType {
  Any = 'ANY',
  Inbound = 'INBOUND',
  Outbound = 'OUTBOUND'
}

export type TriggerCaraAddressConfig = {
  __typename?: 'TriggerCaraAddressConfig';
  emailSuffix: Scalars['String']['output'];
  hasAttachments: Scalars['Boolean']['output'];
  /** Null means any sender domain. */
  senderDomain?: Maybe<Scalars['String']['output']>;
  /** Null means any subject. */
  subjectContains?: Maybe<Scalars['String']['output']>;
};

export type TriggerCaraAddressConfigInput = {
  emailSuffix: Scalars['String']['input'];
  hasAttachments?: Scalars['Boolean']['input'];
  senderDomain?: InputMaybe<Scalars['String']['input']>;
  subjectContains?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerDefinition = {
  __typename?: 'TriggerDefinition';
  archivedAt?: Maybe<Scalars['Time']['output']>;
  createdAt: Scalars['Time']['output'];
  eventMatcher: TriggerEventMatcher;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  status: TriggerDefinitionStatus;
  target: TriggerTarget;
  updatedAt: Scalars['Time']['output'];
  version: Scalars['Int64']['output'];
  visibility: VisibilityConfig;
};

export enum TriggerDefinitionStatus {
  Active = 'ACTIVE',
  Paused = 'PAUSED'
}

export enum TriggerDefinitionUpdateReasonCode {
  Unknown = 'UNKNOWN'
}

export enum TriggerDefinitionUpdateType {
  CreateTriggerDefinition = 'CREATE_TRIGGER_DEFINITION',
  PauseTriggerDefinition = 'PAUSE_TRIGGER_DEFINITION',
  ResumeTriggerDefinition = 'RESUME_TRIGGER_DEFINITION',
  UpdateTriggerDefinition = 'UPDATE_TRIGGER_DEFINITION'
}

export type TriggerDefinitionVersion = {
  __typename?: 'TriggerDefinitionVersion';
  createdAt: Scalars['Time']['output'];
  prevVersion?: Maybe<Scalars['Int64']['output']>;
  triggerDefinition: TriggerDefinition;
  updateInitiatorId: Scalars['String']['output'];
  updateInitiatorType: UpdateInitiatorType;
  updatePrivate: Scalars['Boolean']['output'];
  updateReason?: Maybe<Scalars['String']['output']>;
  updateReasonCode?: Maybe<TriggerDefinitionUpdateReasonCode>;
  updateTypes: Array<TriggerDefinitionUpdateType>;
  version: Scalars['Int64']['output'];
};

export type TriggerEmailAccountOption = {
  __typename?: 'TriggerEmailAccountOption';
  address: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  ownerUserId: Scalars['ID']['output'];
  status: MailboxAccountStatus;
};

export type TriggerEmailAccountScope = {
  __typename?: 'TriggerEmailAccountScope';
  accountId: Scalars['ID']['output'];
  folders: TriggerEmailSelectedFolders;
};

export type TriggerEmailAccountScopeInput = {
  accountId: Scalars['ID']['input'];
  folders: TriggerEmailSelectedFoldersInput;
};

export enum TriggerEmailAddressKind {
  /** Values are access-profile IDs in this agency. */
  AccessProfile = 'ACCESS_PROFILE',
  /** Values are complete email addresses. */
  Address = 'ADDRESS',
  /** Values are domains without @ or wildcards. */
  Domain = 'DOMAIN',
  /** Values are IDs of active users in this agency. */
  User = 'USER'
}

/**
 * Sender and recipient share address-match semantics. Values contain complete
 * addresses, domains, active-user IDs, or access-profile IDs according to kind.
 */
export type TriggerEmailAddressMatch = {
  __typename?: 'TriggerEmailAddressMatch';
  includeSubdomains: Scalars['Boolean']['output'];
  kind: TriggerEmailAddressKind;
  valueMode: TriggerEmailValueMode;
  values: Array<Scalars['String']['output']>;
};

export type TriggerEmailAddressMatchInput = {
  includeSubdomains?: Scalars['Boolean']['input'];
  kind: TriggerEmailAddressKind;
  valueMode?: TriggerEmailValueMode;
  values: Array<Scalars['String']['input']>;
};

/**
 * ALL accounts (including future eligible Outlook accounts). Standard roles and
 * case-insensitive FULL paths are resolved per account during renewal. No basenames,
 * fuzzy matching, or inheritance of another account's provider IDs.
 * Standard roles are Mailbox folder roles except DRAFTS, which triggers reject.
 * allFolders cannot be combined with nonempty standard roles or paths.
 */
export type TriggerEmailAllFolders = {
  __typename?: 'TriggerEmailAllFolders';
  allFolders: Scalars['Boolean']['output'];
  includeJunkAndDeleted: Scalars['Boolean']['output'];
  paths: Array<Scalars['String']['output']>;
  standard: Array<MailboxFolderRole>;
};

export type TriggerEmailAllFoldersInput = {
  allFolders?: Scalars['Boolean']['input'];
  includeJunkAndDeleted?: Scalars['Boolean']['input'];
  paths?: Array<Scalars['String']['input']>;
  standard?: Array<MailboxFolderRole>;
};

/** Only newly arriving messages trigger this version; moving existing mail does not. */
export enum TriggerEmailArrivalMode {
  New = 'NEW'
}

/**
 * Count non-inline attachments satisfying ALL row criteria. MIME/extension lists
 * are alternatives, unlike text/name/address values which support ANY/ALL.
 */
export type TriggerEmailAttachmentCondition = {
  __typename?: 'TriggerEmailAttachmentCondition';
  extensions: Array<Scalars['String']['output']>;
  maximumBytes?: Maybe<Scalars['Int64']['output']>;
  maximumCount?: Maybe<Scalars['Int']['output']>;
  mimeTypes: Array<Scalars['String']['output']>;
  minimumBytes?: Maybe<Scalars['Int64']['output']>;
  minimumCount: Scalars['Int']['output'];
  name?: Maybe<TriggerEmailTextMatch>;
};

export type TriggerEmailAttachmentConditionInput = {
  extensions?: Array<Scalars['String']['input']>;
  maximumBytes?: InputMaybe<Scalars['Int64']['input']>;
  maximumCount?: InputMaybe<Scalars['Int']['input']>;
  mimeTypes?: Array<Scalars['String']['input']>;
  minimumBytes?: InputMaybe<Scalars['Int64']['input']>;
  minimumCount?: Scalars['Int']['input'];
  name?: InputMaybe<TriggerEmailTextMatchInput>;
};

export type TriggerEmailBuilderOptions = {
  __typename?: 'TriggerEmailBuilderOptions';
  accounts: Array<TriggerEmailAccountOption>;
  builtInPresets: Array<TriggerEmailBuiltInPresetOption>;
  presets: Array<TriggerEmailPresetOption>;
  privacySupported: Scalars['Boolean']['output'];
  profiles: Array<TriggerEmailProfileOption>;
  users: Array<TriggerEmailUserOption>;
};

export type TriggerEmailBuiltInPresetOption = {
  __typename?: 'TriggerEmailBuiltInPresetOption';
  preset: CaraWorkspacePreset;
  useCases: Array<CaraWorkspaceUseCase>;
};

/**
 * Current connected-mailbox configuration, not a historical version snapshot.
 * A null rule means no extra conditions, not an empty condition group.
 */
export type TriggerEmailConfig = {
  __typename?: 'TriggerEmailConfig';
  arrivals: TriggerEmailArrivalMode;
  privacy: TriggerEmailPrivacy;
  rule?: Maybe<TriggerEmailRule>;
  schemaVersion: Scalars['Int']['output'];
  scope: TriggerEmailScope;
  timezone?: Maybe<Scalars['String']['output']>;
};

export type TriggerEmailConfigInput = {
  arrivals?: TriggerEmailArrivalMode;
  privacy?: TriggerEmailPrivacy;
  rule?: InputMaybe<TriggerEmailRuleInput>;
  schemaVersion?: Scalars['Int']['input'];
  scope: TriggerEmailScopeInput;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

export type TriggerEmailFolderOption = {
  __typename?: 'TriggerEmailFolderOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
};

export type TriggerEmailPhraseCondition = {
  __typename?: 'TriggerEmailPhraseCondition';
  field: TriggerEmailPhraseField;
  match: TriggerEmailTextMatch;
};

export type TriggerEmailPhraseConditionInput = {
  field: TriggerEmailPhraseField;
  match: TriggerEmailTextMatchInput;
};

export enum TriggerEmailPhraseField {
  Body = 'BODY',
  Subject = 'SUBJECT',
  SubjectOrBody = 'SUBJECT_OR_BODY'
}

export type TriggerEmailPresetOption = {
  __typename?: 'TriggerEmailPresetOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  ready: Scalars['Boolean']['output'];
  visibility: VisibilityConfig;
};

export enum TriggerEmailPrivacy {
  /** The resulting workspace uses agency-wide visibility. */
  Agency = 'AGENCY',
  /** Share the resulting workspace with owners of mailbox copies that match. */
  MatchedMailboxOwners = 'MATCHED_MAILBOX_OWNERS'
}

export type TriggerEmailProfileOption = {
  __typename?: 'TriggerEmailProfileOption';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TriggerEmailPromptCondition = {
  __typename?: 'TriggerEmailPromptCondition';
  prompt: Scalars['String']['output'];
};

export type TriggerEmailPromptConditionInput = {
  prompt: Scalars['String']['input'];
};

export type TriggerEmailRecipientCondition = {
  __typename?: 'TriggerEmailRecipientCondition';
  field: TriggerEmailRecipientField;
  match: TriggerEmailAddressMatch;
};

export type TriggerEmailRecipientConditionInput = {
  field: TriggerEmailRecipientField;
  match: TriggerEmailAddressMatchInput;
};

export enum TriggerEmailRecipientField {
  Cc = 'CC',
  To = 'TO',
  ToOrCc = 'TO_OR_CC'
}

/**
 * Stable unique IDs, one payload for the leaf kind; AND/OR nonempty, NOT one child.
 * Limits: depth 8, nodes 128, values 32, prompt nodes 3, prompt bytes 2048.
 * Runtime must preserve ERROR separately from FALSE (including NOT).
 */
export type TriggerEmailRule = {
  __typename?: 'TriggerEmailRule';
  attachment?: Maybe<TriggerEmailAttachmentCondition>;
  children: Array<TriggerEmailRule>;
  id: Scalars['ID']['output'];
  kind: TriggerEmailRuleKind;
  phrase?: Maybe<TriggerEmailPhraseCondition>;
  prompt?: Maybe<TriggerEmailPromptCondition>;
  recipient?: Maybe<TriggerEmailRecipientCondition>;
  sender?: Maybe<TriggerEmailAddressMatch>;
  time?: Maybe<TriggerEmailTimeCondition>;
};

export type TriggerEmailRuleInput = {
  attachment?: InputMaybe<TriggerEmailAttachmentConditionInput>;
  children?: Array<TriggerEmailRuleInput>;
  id: Scalars['ID']['input'];
  kind: TriggerEmailRuleKind;
  phrase?: InputMaybe<TriggerEmailPhraseConditionInput>;
  prompt?: InputMaybe<TriggerEmailPromptConditionInput>;
  recipient?: InputMaybe<TriggerEmailRecipientConditionInput>;
  sender?: InputMaybe<TriggerEmailAddressMatchInput>;
  time?: InputMaybe<TriggerEmailTimeConditionInput>;
};

export enum TriggerEmailRuleKind {
  /** Every child rule must match. */
  And = 'AND',
  /** Match non-inline attachment metadata, not attachment contents. */
  Attachment = 'ATTACHMENT',
  /** Negate exactly one child; evaluation errors are not converted to matches. */
  Not = 'NOT',
  /** At least one child rule must match. */
  Or = 'OR',
  /** Match subject or body text. */
  Phrase = 'PHRASE',
  /** Classify using the configured prompt condition. */
  Prompt = 'PROMPT',
  /** Match visible To/CC recipient addresses, never BCC. */
  Recipient = 'RECIPIENT',
  /** Match the sender address. */
  Sender = 'SENDER',
  /** Match the received time using the configuration's IANA timezone. */
  Time = 'TIME'
}

/**
 * One mailbox-trigger run, with no mail content. Same-agency admins may read all
 * runs. Other viewers must still have current workspace access AND belong to the
 * run's frozen privacy audience: Agency allows agency viewers, Shared only owners
 * with a committed positive mailbox-copy match for this run, Private only its first
 * matching owner. Manual workspace sharing alone is not mailbox-match evidence.
 * Without a workspace, including pending runs, only the first matching owner and
 * same-agency admins may read. Missing match provenance, or missing/unknown frozen
 * privacy once a workspace exists, does not authorize non-admin history reads.
 */
export type TriggerEmailRun = {
  __typename?: 'TriggerEmailRun';
  /** When the workspace was created. */
  dispatchedAt?: Maybe<Scalars['Time']['output']>;
  error?: Maybe<TriggerEventError>;
  id: Scalars['ID']['output'];
  /** When the email matched and the run was queued. */
  queuedAt: Scalars['Time']['output'];
  state: TriggerRunState;
  /** The mailbox trigger this run belongs to. */
  triggerDefinitionId: Scalars['ID']['output'];
  /** The workspace this run created, once launched. */
  workspaceId?: Maybe<Scalars['ID']['output']>;
};

export type TriggerEmailScope = {
  __typename?: 'TriggerEmailScope';
  accounts: Array<TriggerEmailAccountScope>;
  folders?: Maybe<TriggerEmailAllFolders>;
  mode: TriggerEmailScopeMode;
};

export type TriggerEmailScopeInput = {
  accounts?: Array<TriggerEmailAccountScopeInput>;
  folders?: InputMaybe<TriggerEmailAllFoldersInput>;
  mode: TriggerEmailScopeMode;
};

export enum TriggerEmailScopeMode {
  /** All eligible Outlook accounts, including future accounts, with per-account folder resolution. */
  All = 'ALL',
  /** Only the explicitly selected account IDs. */
  Selected = 'SELECTED'
}

/**
 * Provider IDs resolved at setup, scoped to this account. Empty is NOT all.
 * Drafts never match, including under allFolders. The extra checkbox applies only
 * under allFolders; explicit non-draft IDs may include Junk/Deleted folders.
 * allFolders cannot be combined with nonempty ids.
 */
export type TriggerEmailSelectedFolders = {
  __typename?: 'TriggerEmailSelectedFolders';
  allFolders: Scalars['Boolean']['output'];
  ids: Array<Scalars['ID']['output']>;
  includeJunkAndDeleted: Scalars['Boolean']['output'];
};

export type TriggerEmailSelectedFoldersInput = {
  allFolders?: Scalars['Boolean']['input'];
  ids?: Array<Scalars['ID']['input']>;
  includeJunkAndDeleted?: Scalars['Boolean']['input'];
};

export type TriggerEmailTextMatch = {
  __typename?: 'TriggerEmailTextMatch';
  caseSensitive: Scalars['Boolean']['output'];
  operator: TriggerEmailTextOperator;
  valueMode: TriggerEmailValueMode;
  values: Array<Scalars['String']['output']>;
};

export type TriggerEmailTextMatchInput = {
  caseSensitive?: Scalars['Boolean']['input'];
  operator: TriggerEmailTextOperator;
  valueMode?: TriggerEmailValueMode;
  values: Array<Scalars['String']['input']>;
};

export enum TriggerEmailTextOperator {
  Contains = 'CONTAINS',
  EndsWith = 'ENDS_WITH',
  Equals = 'EQUALS',
  Regex = 'REGEX',
  StartsWith = 'STARTS_WITH'
}

/**
 * Wall-clock minutes and named weekdays. BETWEEN is [minute,endMinute), including
 * overnight windows belonging to their start day. Explicit IANA timezone required.
 */
export type TriggerEmailTimeCondition = {
  __typename?: 'TriggerEmailTimeCondition';
  endMinute?: Maybe<Scalars['Int']['output']>;
  minute: Scalars['Int']['output'];
  operator: TriggerEmailTimeOperator;
  weekdays: Array<TriggerEmailWeekday>;
};

export type TriggerEmailTimeConditionInput = {
  endMinute?: InputMaybe<Scalars['Int']['input']>;
  minute: Scalars['Int']['input'];
  operator: TriggerEmailTimeOperator;
  weekdays: Array<TriggerEmailWeekday>;
};

export enum TriggerEmailTimeOperator {
  /** At or after the configured wall-clock minute on the selected weekday. */
  After = 'AFTER',
  /** Earlier than the configured wall-clock minute on the selected weekday. */
  Before = 'BEFORE',
  /** Half-open [minute,endMinute); overnight windows belong to their start day. */
  Between = 'BETWEEN'
}

export type TriggerEmailUserOption = {
  __typename?: 'TriggerEmailUserOption';
  email: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  state: AgencyUserState;
};

export enum TriggerEmailValueMode {
  /** Every value in this leaf matches; distinct from an AND group of child rules. */
  All = 'ALL',
  /** At least one value in this leaf matches; distinct from an OR group of child rules. */
  Any = 'ANY'
}

/** Named weekdays in Monday-to-Sunday order; interpreted in the configuration's IANA timezone. */
export enum TriggerEmailWeekday {
  Friday = 'FRIDAY',
  Monday = 'MONDAY',
  Saturday = 'SATURDAY',
  Sunday = 'SUNDAY',
  Thursday = 'THURSDAY',
  Tuesday = 'TUESDAY',
  Wednesday = 'WEDNESDAY'
}

export type TriggerEvaluationSummary = {
  __typename?: 'TriggerEvaluationSummary';
  /** Definitions returned by route lookup before Match filters. */
  candidateCount: Scalars['Int']['output'];
  /** Counts of non-match reasons (paused, subject_mismatch, …). */
  reasonCounts?: Maybe<Scalars['JSON']['output']>;
  /** Sample non-matches for debugging (capped). */
  samples?: Maybe<Array<Scalars['JSON']['output']>>;
};

/**
 * A normalized inbound occurrence (email, call, schedule tick) awaiting or after
 * evaluation. One event may fan out to many TriggerRuns when multiple definitions match.
 */
export type TriggerEvent = {
  __typename?: 'TriggerEvent';
  auditLogs: Array<TriggerAuditLog>;
  error?: Maybe<TriggerEventError>;
  evaluatedAt?: Maybe<Scalars['Time']['output']>;
  /**
   * Route/match diagnostics recorded when the event was evaluated. Match count is
   * not stored — use runs length (or filter runs) instead.
   */
  evaluationSummary?: Maybe<TriggerEvaluationSummary>;
  eventType: TriggerEventType;
  id: Scalars['ID']['output'];
  /** When the underlying occurrence happened. */
  occurredAt: Scalars['Time']['output'];
  /** Normalized matching payload (email.received / schedule.due / call.analyzed). */
  payload: Scalars['JSON']['output'];
  /** When Cara ingested the event. */
  receivedAt: Scalars['Time']['output'];
  runs: Array<TriggerRun>;
  /** Provider-side event id used with sourceType/instance for provenance. */
  sourceEventId: Scalars['String']['output'];
  /** Provider-side instance that produced the event (mailbox, agent, …). */
  sourceInstanceId: Scalars['String']['output'];
  /** Provider that produced the event (Mailgun, Gmail, schedule, Retell, …). */
  sourceType: TriggerSourceType;
  state: TriggerEventState;
  /** Optional subject id paired with subjectType (email thread id or call id). */
  subjectId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional Cara entity kind this event is about. Paired with subjectId: both set
   * or both null (EMAIL_THREAD / CALL). Not free-text — provenance lives in source*.
   */
  subjectType?: Maybe<TriggerSubjectType>;
};

export type TriggerEventConnection = {
  __typename?: 'TriggerEventConnection';
  edges: Array<TriggerEventEdge>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TriggerEventEdge = {
  __typename?: 'TriggerEventEdge';
  cursor: Scalars['String']['output'];
  node: TriggerEvent;
};

export type TriggerEventError = {
  __typename?: 'TriggerEventError';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
};

/**
 * Event type plus exactly one matching config: Cara address, legacy mailbox,
 * connected email, schedule, or call. emailConfig selects connected Outlook
 * accounts, folders and condition trees; mailboxConfig is the legacy mailbox
 * matcher. Top-level TriggerDefinition slots are eventMatcher / target
 * (and output later).
 */
export type TriggerEventMatcher = {
  __typename?: 'TriggerEventMatcher';
  callAnalyzedConfig?: Maybe<TriggerCallAnalyzedConfig>;
  caraAddressConfig?: Maybe<TriggerCaraAddressConfig>;
  emailConfig?: Maybe<TriggerEmailConfig>;
  eventType: TriggerEventType;
  mailboxConfig?: Maybe<TriggerMailboxConfig>;
  scheduleConfig?: Maybe<TriggerScheduleConfig>;
};

export type TriggerEventMatcherInput = {
  callAnalyzedConfig?: InputMaybe<TriggerCallAnalyzedConfigInput>;
  caraAddressConfig?: InputMaybe<TriggerCaraAddressConfigInput>;
  emailConfig?: InputMaybe<TriggerEmailConfigInput>;
  eventType: TriggerEventType;
  mailboxConfig?: InputMaybe<TriggerMailboxConfigInput>;
  scheduleConfig?: InputMaybe<TriggerScheduleConfigInput>;
};

export enum TriggerEventState {
  /** Routing and matching finished; matched runs are queued (or none matched). */
  Evaluated = 'EVALUATED',
  /** Evaluation failed permanently; will not be re-matched. */
  Failed = 'FAILED',
  /** Ingested; routing and matching have not run yet. */
  Pending = 'PENDING'
}

export enum TriggerEventType {
  CallAnalyzed = 'CALL_ANALYZED',
  EmailReceived = 'EMAIL_RECEIVED',
  ScheduleDue = 'SCHEDULE_DUE'
}

export type TriggerExecutionHistoryConnection = {
  __typename?: 'TriggerExecutionHistoryConnection';
  edges: Array<TriggerExecutionHistoryEdge>;
  pageInfo: PageInfo;
};

/** A transient read projection of exactly one existing source, not a stored run. */
export type TriggerExecutionHistoryEdge = {
  __typename?: 'TriggerExecutionHistoryEdge';
  cursor: Scalars['String']['output'];
  emailRun?: Maybe<TriggerEmailRun>;
  event?: Maybe<TriggerEvent>;
  summary: Scalars['String']['output'];
};

/**
 * Filters are ANDed before authorization-scoped page limits. Search terms are
 * literal, case-insensitive substrings of the visible summary plus type label.
 * State maps email QUEUED/LAUNCHED/FAILED to PENDING/EVALUATED/FAILED; this is launch
 * provenance, not the Temporal child's execution state. Since is an inclusive instant.
 */
export type TriggerExecutionHistoryFilter = {
  search?: InputMaybe<Array<Scalars['String']['input']>>;
  since?: InputMaybe<Scalars['Time']['input']>;
  state?: InputMaybe<TriggerEventState>;
  triggerDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  type?: InputMaybe<TriggerEventType>;
};

export enum TriggerExecutionType {
  /** Cara workspace created as the run's execution. */
  CaraWorkspace = 'CARA_WORKSPACE'
}

export type TriggerMailboxConfig = {
  __typename?: 'TriggerMailboxConfig';
  /** Null means any folder. Otherwise requires an exact folder match. */
  folder?: Maybe<Scalars['String']['output']>;
  hasAttachments: Scalars['Boolean']['output'];
  integrationId: Scalars['String']['output'];
  /** Null means any sender domain. */
  senderDomain?: Maybe<Scalars['String']['output']>;
  /** Null means any subject. */
  subjectContains?: Maybe<Scalars['String']['output']>;
};

export type TriggerMailboxConfigInput = {
  folder?: InputMaybe<Scalars['String']['input']>;
  hasAttachments?: Scalars['Boolean']['input'];
  integrationId: Scalars['String']['input'];
  senderDomain?: InputMaybe<Scalars['String']['input']>;
  subjectContains?: InputMaybe<Scalars['String']['input']>;
};

/**
 * One matched trigger definition firing for a TriggerEvent. Created QUEUED after
 * Match; TriggerRunWorkflow acquires capacity and launches the target as a child.
 */
export type TriggerRun = {
  __typename?: 'TriggerRun';
  /**
   * How many times capacity was successfully acquired for this run (increments on
   * admit, including re-admits after release). Deferrals do not increment.
   */
  attemptCount: Scalars['Int']['output'];
  /** When capacity was acquired and launch began. */
  dispatchStartedAt?: Maybe<Scalars['Time']['output']>;
  /** When launch completed successfully (typically when state becomes LAUNCHED). */
  dispatchedAt?: Maybe<Scalars['Time']['output']>;
  error?: Maybe<TriggerEventError>;
  /** Id of the created execution once launched. */
  executionId?: Maybe<Scalars['String']['output']>;
  /** Kind of created execution once launched. */
  executionType?: Maybe<TriggerExecutionType>;
  id: Scalars['ID']['output'];
  /** Snapshot of why Match succeeded (route key, filters, …). */
  matchDetails?: Maybe<Scalars['JSON']['output']>;
  /**
   * Why capacity acquire last deferred this run while state is QUEUED. Cleared when
   * capacity is acquired. Null when eligible / not currently deferred. History of
   * deferrals lives in audit logs, not sticky columns.
   */
  queueReason?: Maybe<TriggerRunQueueReason>;
  /** When the run entered QUEUED after a successful Match. */
  queuedAt: Scalars['Time']['output'];
  state: TriggerRunState;
  /** Registered target kind to launch (workspace.run). */
  targetType: TriggerTargetType;
  /** Definition that matched (version pinned via triggerDefinitionVersion). */
  triggerDefinition: TriggerDefinition;
  /** Definition version snapshotted when the run was queued. */
  triggerDefinitionVersion: Scalars['Int64']['output'];
  /** Parent event this run was matched from. */
  triggerEvent: TriggerEvent;
};

export enum TriggerRunQueueReason {
  /** Agency concurrent trigger capacity limit reached. */
  AgencyLimit = 'AGENCY_LIMIT',
  /** Platform-wide concurrent trigger capacity limit reached. */
  PlatformCapacity = 'PLATFORM_CAPACITY'
}

export enum TriggerRunState {
  /** Launch failed permanently (e.g. PermanentLaunchError); will not be restarted. */
  Failed = 'FAILED',
  /**
   * Launch completed and a target execution (e.g. Cara workspace) was created.
   * Workspace success/failure after this is owned by CaraWorkspaceV2 — a LAUNCHED
   * run does not flip back if the child workspace fails.
   */
  Launched = 'LAUNCHED',
  /**
   * Matched and waiting for capacity admission / launch. Independent of the
   * launched workspace: a run can stay QUEUED after a failed TriggerRun workflow
   * once capacity is released; reconcile may restart it.
   */
  Queued = 'QUEUED'
}

export type TriggerScheduleConfig = {
  __typename?: 'TriggerScheduleConfig';
  /**
   * How long after a scheduled time we still emit that occurrence if the sweep
   * ran late. Not how far back the launched workspace should look at data.
   */
  catchUpHours: Scalars['Int']['output'];
  /**
   * Standard 5-field cron (minute hour day-of-month month day-of-week), evaluated
   * in timezone. Example: "0 9 * * 1-5" is weekdays at 09:00 local.
   */
  cron: Scalars['String']['output'];
  /** IANA timezone the cron fields are interpreted in (e.g. America/New_York). */
  timezone: Scalars['String']['output'];
};

export type TriggerScheduleConfigInput = {
  /**
   * How long after a scheduled time we still emit that occurrence if the sweep
   * ran late. Defaults to 24. Must be at least 1.
   */
  catchUpHours?: Scalars['Int']['input'];
  /**
   * Standard 5-field cron (minute hour day-of-month month day-of-week), evaluated
   * in timezone.
   */
  cron: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export enum TriggerSourceType {
  Gmail = 'GMAIL',
  /** Connected mailbox when the sync did not name a provider. */
  Mailbox = 'MAILBOX',
  Mailgun = 'MAILGUN',
  Outlook = 'OUTLOOK',
  Retell = 'RETELL',
  Schedule = 'SCHEDULE'
}

export enum TriggerSubjectType {
  /** Cara call record (subjectId = call id), not the provider call id. */
  Call = 'CALL',
  /** Cara email thread (subjectId = email thread id). */
  EmailThread = 'EMAIL_THREAD'
}

export type TriggerTarget = {
  __typename?: 'TriggerTarget';
  /**
   * Optional built-in preset, the alternative to presetId. Set together with useCase,
   * the same pair a workspace launched from the preset catalog carries.
   */
  preset?: Maybe<CaraWorkspacePreset>;
  /**
   * Optional custom preset. Same as starting a workspace with a preset selected.
   * Null means no preset (prompt-only workspace). May be combined with prompt.
   */
  presetId?: Maybe<Scalars['String']['output']>;
  /**
   * Optional additional user prompt. Same as the freeform message when starting a
   * workspace. May be combined with a preset, or used alone. Null means no prompt.
   */
  prompt?: Maybe<Scalars['String']['output']>;
  type: TriggerTargetType;
  /** The built-in use case within preset. Requires preset. */
  useCase?: Maybe<CaraWorkspaceUseCase>;
};

export type TriggerTargetInput = {
  /** Optional built-in preset. Mutually exclusive with presetId. */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Optional custom preset. Null for a prompt-only workspace. */
  presetId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional additional user prompt. Same mechanism as starting a workspace with
   * a freeform message (alone or on top of a preset). Null means no prompt.
   */
  prompt?: InputMaybe<Scalars['String']['input']>;
  type?: TriggerTargetType;
  /** The built-in use case within preset. Requires preset. */
  useCase?: InputMaybe<CaraWorkspaceUseCase>;
};

export enum TriggerTargetType {
  WorkspaceRun = 'WORKSPACE_RUN'
}

/** Typography settings */
export type TypographyStyle = {
  __typename?: 'TypographyStyle';
  /** Text color in hex format (e.g. '#334155') */
  colorHex?: Maybe<Scalars['String']['output']>;
  /** Base font family name (e.g. 'Charter ITC TT', 'Inter', 'Source Serif Pro') */
  fontFamily?: Maybe<Scalars['String']['output']>;
  /** Base font size in points (e.g. 11.0) */
  fontSizePt?: Maybe<Scalars['Float']['output']>;
  /** Font weight as a number (e.g. 400 for normal, 600 for semi-bold, 700 for bold) */
  fontWeight?: Maybe<Scalars['Int']['output']>;
  /** Line height as a unitless multiplier (e.g. 1.6) */
  lineHeight?: Maybe<Scalars['Float']['output']>;
};

/** Input for typography settings */
export type TypographyStyleInput = {
  /** Base text color, as a CSS hex string (e.g. '#222222') */
  colorHex?: InputMaybe<Scalars['String']['input']>;
  /** Font family for base document text (e.g. 'Arial', 'Helvetica Neue', etc.) */
  fontFamily?: InputMaybe<Scalars['String']['input']>;
  /** Font size in points for base text */
  fontSizePt?: InputMaybe<Scalars['Float']['input']>;
  /** Font weight for base text (e.g. 400 for normal, 700 for bold) */
  fontWeight?: InputMaybe<Scalars['Int']['input']>;
  /** Line height for base text (unitless multiplier, e.g. 1.4) */
  lineHeight?: InputMaybe<Scalars['Float']['input']>;
};

/** What initiated the sync operation */
export enum UrlDocumentSyncInitiator {
  /** Sync was triggered on document creation */
  Initial = 'INITIAL',
  /** Sync was triggered manually by a user */
  Manual = 'MANUAL',
  /** Sync was triggered by the scheduled cron job */
  Scheduled = 'SCHEDULED'
}

/** A record of a sync operation for a URL-sourced document */
export type UrlDocumentSyncLog = {
  __typename?: 'URLDocumentSyncLog';
  /** Timestamp of when the sync operation completed */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** Whether the content changed from the previous version */
  contentChanged?: Maybe<Scalars['Boolean']['output']>;
  /** The content hash of the fetched content (for detecting changes) */
  contentHash?: Maybe<Scalars['String']['output']>;
  /** Size of the fetched content in bytes */
  contentSize?: Maybe<Scalars['Int']['output']>;
  /** Error message if the sync failed */
  error?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the sync log */
  id: Scalars['ID']['output'];
  /** What initiated this sync operation */
  initiator: UrlDocumentSyncInitiator;
  /** The ID of the new document version created (if content changed) */
  newVersionID?: Maybe<Scalars['String']['output']>;
  /** Timestamp of when the sync operation started */
  startedAt: Scalars['Time']['output'];
  /** Current state of the sync operation */
  state: UrlDocumentSyncState;
};

/** The state of a URL document sync operation */
export enum UrlDocumentSyncState {
  /** Sync operation completed successfully */
  Completed = 'COMPLETED',
  /** Sync operation failed */
  Failed = 'FAILED',
  /** Sync operation is in progress */
  InProgress = 'IN_PROGRESS'
}

/** How often the URL should be synced */
export enum UrlMonitorFrequency {
  /** Sync once per day */
  Daily = 'DAILY',
  /** Sync once per month */
  Monthly = 'MONTHLY',
  /** Sync once per week */
  Weekly = 'WEEKLY'
}

/** The type of URL source - determines how content is fetched */
export enum UrlSourceType {
  /** Direct file download (PDF) */
  Download = 'DOWNLOAD',
  /** Webpage screenshot capture */
  Webpage = 'WEBPAGE'
}

/** UpdateAMS360IntegrationInput contains the input for updating an AMS360 integration */
export type UpdateAms360IntegrationInput = {
  /** AMS360 Agency Number */
  agencyNo?: InputMaybe<Scalars['String']['input']>;
  /** AMS360 App Access to Agency Key for authentication */
  appAccessToAgencyKey?: InputMaybe<Scalars['String']['input']>;
  /** AMS360 App Key for authentication */
  appKey?: InputMaybe<Scalars['String']['input']>;
  /**
   * When a synced task has no due date, the suspense due date is this many business days
   * after the sync time (weekends skipped). Defaults to 3 when unset.
   */
  defaultTaskDueBusinessDays?: InputMaybe<Scalars['Int']['input']>;
  /**
   * If enabled, will sync accounts from Cara to AMS360. When disabled, Cara will not create
   * tasks or notes for clients that don't already exist in AMS360.
   */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to AMS360 as activities. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to AMS360 as suspenses. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Determines who suspenses (tasks) created from calls are assigned to. Defaults to
   * ACCOUNT_EXECUTIVE (the historical behavior) when unset.
   */
  taskAssignmentMethod?: InputMaybe<Ams360TaskAssignmentMethod>;
};

/** Input for updating an existing account record */
export type UpdateAccountInput = {
  /** Business account details to update, if the account is a business */
  business?: InputMaybe<CreateBusinessAccountInput>;
  /** Individual account details to update, if the account is an individual */
  individual?: InputMaybe<CreateIndividualAccountInput>;
};

/**
 * Every optional field left null keeps what is saved. To clear one, send it empty: [] for a
 * list, or an object whose fields are all null.
 */
export type UpdateAgencyBrandInput = {
  bodyTypeface: Scalars['String']['input'];
  /**
   * An element equal to its brandElementDefaults entry is stored as untouched, so it follows
   * any later change to the defaults.
   */
  elements?: InputMaybe<Array<BrandElementStyleInput>>;
  footer?: InputMaybe<BrandSlotsInput>;
  header?: InputMaybe<BrandSlotsInput>;
  headingTypeface: Scalars['String']['input'];
  logos?: InputMaybe<Array<BrandLogoInput>>;
  margins?: InputMaybe<BrandMarginsInput>;
  palette: BrandPaletteInput;
  voice?: InputMaybe<BrandVoiceInput>;
};

/** Input for updating an existing agency */
export type UpdateAgencyInput = {
  /**
   * Set the agency's ACORD COI/EOI configuration overrides (DOO mode, PDF append
   * rules, ID-card logo, number formatting, and the section-scoped rules list).
   * Omit to leave the configuration unchanged. When present, the override is
   * replaced wholesale: any field left null reverts that setting to the Cara
   * default (see ACORDFormConfigurationInput).
   */
  acordFormConfiguration?: InputMaybe<AcordFormConfigurationInput>;
  /** Display name of the agency */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Short unique handle for Cara trigger aliases
   * (cara-{emailNamespace}-{suffix}@inbox.getcara.ai). Fails with a validation
   * error if another agency already claimed it.
   */
  emailNamespace?: InputMaybe<Scalars['String']['input']>;
  /** Extra entitlements to set for the agency */
  extraEntitlements?: InputMaybe<Array<SubscriptionEntitlement>>;
  /**
   * Agency-wide Florida producer license number.
   * Used only as a backup when the selected default Producer Information has none.
   * Printed onto ACORD forms when the risk is in Florida (or the form is Florida-specific).
   */
  floridaLicenseNumber?: InputMaybe<Scalars['String']['input']>;
  /**
   * HIPAA privacy settings. Omit or pass null to leave the current settings
   * unchanged. Only globally authorized internal users may set them.
   */
  hipaaPrivacyMode?: InputMaybe<HipaaPrivacyModeConfigurationInput>;
  /** Mailing address of the agency */
  mailingAddress?: InputMaybe<AddressInput>;
  /** Legal name of the agency */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Agency-wide National Producer Number (NPN).
   * Used only as a backup when the selected default Producer Information has none.
   */
  nationalProducerNumber?: InputMaybe<Scalars['String']['input']>;
  /** The onboarding date for the agency */
  onboardingDate?: InputMaybe<Scalars['Time']['input']>;
  /** Phone number of the agency */
  phone?: InputMaybe<Scalars['String']['input']>;
  /**
   * Agency-wide visibility policy. Currently only `disallowPrivate` is supported,
   * which (when true) prevents members from creating or updating objects with
   * PRIVATE visibility — they must choose at least SHARED. Existing PRIVATE rows
   * are not retroactively coerced; the gate only applies on the next mutation
   * per object.
   */
  visibility?: InputMaybe<AgencyVisibilityPolicyInput>;
};

/** Input for updating an agency user */
export type UpdateAgencyUserInput = {
  /** The attributes of the agency user */
  attributes?: InputMaybe<AgencyUserAttributesInput>;
  /** The email address of the agency user */
  email?: InputMaybe<Scalars['String']['input']>;
  /**
   * The access the caller last saw for this user. When given, the update is
   * refused with CONFLICT if the user's roles or direct profile have changed
   * since, so a stale page cannot overwrite someone else's change.
   */
  expectedAccess?: InputMaybe<AgencyUserAccessInput>;
  /** The name of the agency user */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The access profile to assign the user to. Null removes the direct assignment,
   * which drops the user back to whatever their teams or the agency default
   * provide; omitting the field leaves the assignment untouched. Rejected for a
   * user whose roles include ADMIN, since no profile governs an admin.
   */
  profileId?: InputMaybe<Scalars['String']['input']>;
  /** The roles of the agency user */
  roles?: InputMaybe<Array<Role>>;
};

/** UpdateAgencyZoomIntegrationInput contains the input for updating an Agency Zoom integration */
export type UpdateAgencyZoomIntegrationInput = {
  /** If enabled, will sync accounts from Cara to Agency Zoom. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to Agency Zoom. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update whether the Agency Zoom integration uses Vertafore SSO login. */
  isSSOLogin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the Agency Zoom integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Update the Agency Zoom integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/**
 * UpdateAppliedEpicIntegrationInput contains the input for updating an Applied Epic integration.
 * Provide the credential set matching the integration type to rotate stored credentials.
 */
export type UpdateAppliedEpicIntegrationInput = {
  /** Updated API credentials for the Applied Epic integration. All fields must be provided together. */
  apiCredentials?: InputMaybe<AppliedEpicApiCredentialsInput>;
  /** Updated SDK credentials for the Applied Epic integration. All fields must be provided together. */
  sdkCredentials?: InputMaybe<AppliedEpicSdkCredentialsInput>;
  /**
   * Type of Applied Epic integration. If omitted the existing type is kept.
   * Provide the credential set matching the type when switching.
   */
  type?: InputMaybe<AppliedEpicIntegrationType>;
};

/** Input for updating an existing business policy */
export type UpdateBusinessPolicyInput = {
  /** Additional fees collected by the agency as revenue. */
  agencyFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the agency user who sourced the policy */
  agencyUserId?: InputMaybe<Scalars['String']['input']>;
  /** Fees collected by the wholesale broker */
  brokerFees?: InputMaybe<Scalars['Float']['input']>;
  /** ID of the broker */
  brokerId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the insurance carrier */
  carrierId?: InputMaybe<Scalars['String']['input']>;
  /** Estimated commission percentage */
  estimatedCommission?: InputMaybe<Scalars['Float']['input']>;
  /** When the policy expires */
  expiresAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy goes into effect */
  inforceAt?: InputMaybe<Scalars['Time']['input']>;
  /** When the policy was issued */
  issuedAt?: InputMaybe<Scalars['Time']['input']>;
  /** Insurance market the policy is written in */
  market?: InputMaybe<InsuranceMarket>;
  /** Minimum earned premium for the policy */
  minimumEarnedPremium?: InputMaybe<Scalars['Float']['input']>;
  /** Other fees incurred on this policy, not collected by the agency as revenue */
  otherFees?: InputMaybe<Scalars['Float']['input']>;
  /** Fees collected by the carrier to administer the policy or program */
  policyFees?: InputMaybe<Scalars['Float']['input']>;
  /** Policy number once issued */
  policyNumber?: InputMaybe<Scalars['String']['input']>;
  /** The actual premium of the policy */
  premium?: InputMaybe<Scalars['Float']['input']>;
  /** Quote number from carrier */
  quoteNumber?: InputMaybe<Scalars['String']['input']>;
  /** Current state of the policy */
  state?: InputMaybe<PolicyState>;
  /** Taxes levied on the policy premium and any taxable fees */
  taxes?: InputMaybe<Scalars['Float']['input']>;
  /** Total amount to charge for the policy, including premium and all taxes and fees */
  total?: InputMaybe<Scalars['Float']['input']>;
  /** Type of insurance policy */
  type?: InputMaybe<InsuranceType>;
  /** Reason for updating the policy */
  updateReason: Scalars['String']['input'];
};

/** Input for updating calls */
export type UpdateCallInput = {
  /** Whether to archive the call */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Mark the call as seen/reviewed (sets seenAt timestamp and seenByUserId) */
  markSeen?: InputMaybe<Scalars['Boolean']['input']>;
};

/**
 * Input for updating a Cara workspace artifact
 * # TODO: Some way to enforce having one or the other type of input, but not both?
 */
export type UpdateCaraWorkspaceArtifactInput = {
  /** The application file details to update */
  applicationFile?: InputMaybe<CaraWorkspaceArtifactApplicationFileInput>;
  /** The document details to update */
  document?: InputMaybe<CaraWorkspaceArtifactDocumentInput>;
  /** The email details to update */
  email?: InputMaybe<CaraWorkspaceArtifactEmailInput>;
  /**
   * When set, replaces the artifact's visibility configuration. Subject to the
   * same plan-entitlement and admin-disallow-private gates as workspace
   * visibility. Omitting leaves the existing artifact visibility unchanged.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/**
 * Input for updating several Cara workspace artifacts at once, such as archiving
 * a selection from the documents view.
 */
export type UpdateCaraWorkspaceArtifactsInput = {
  /**
   * True archives the artifacts, false restores them. See
   * `CaraWorkspaceArtifactSummary.archivedAt` for what archiving does and does
   * not change.
   */
  archived: Scalars['Boolean']['input'];
};

/** Input for updating a Cara workspace */
export type UpdateCaraWorkspaceInput = {
  /** Whether to archive the Cara workspace */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** The title of the Cara workspace */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated visibility. Omit to leave the existing visibility unchanged. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/**
 * Every field is optional and an omitted one is left alone, so a partial save
 * cannot clobber what the backfill enriched. Clearing a field is not expressible,
 * matching the other patch-style updates in this schema.
 */
export type UpdateClientInput = {
  address?: InputMaybe<AddressInput>;
  agencyUserOwnerId?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  isCommercial?: InputMaybe<Scalars['Boolean']['input']>;
  isPersonal?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomFormInput = {
  /** Archive the form. Archive-only updates are allowed even while processing. */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A replacement PDF file. If provided, the form will be reprocessed. */
  file?: InputMaybe<Scalars['Upload']['input']>;
  /** Updated fill-time instructions for Cara, if changing. */
  fillPrompt?: InputMaybe<Scalars['String']['input']>;
  /** Updated ingestion guidance. If changed, may trigger reprocessing. */
  ingestionGuidance?: InputMaybe<Scalars['String']['input']>;
  /** New title for the form, if changing. */
  title?: InputMaybe<Scalars['String']['input']>;
  /** Updated visibility. Omit to leave the existing visibility unchanged. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Input for updating custom presets (e.g. archiving) */
export type UpdateCustomPresetsInput = {
  /** Whether to archive the custom presets */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the custom presets. Existing
   * workspaces created from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Represents a tool for revising an email draft already saved in the workspace. */
export type UpdateEmailDraftTool = {
  __typename?: 'UpdateEmailDraftTool';
  /** The input arguments for the revision */
  input: UpdateEmailDraftToolInput;
  /** The result of the revision */
  output: DraftEmailToolOutput;
};

/**
 * Input arguments for the UpdateEmailDraftTool.
 *
 * Every editable field is optional because the call is a patch: an absent field
 * keeps its current value and an empty list clears one.
 */
export type UpdateEmailDraftToolInput = {
  __typename?: 'UpdateEmailDraftToolInput';
  /** The email artifact being revised */
  artifactId: Scalars['String']['output'];
  /** Replacement list of attached workspace artifact IDs */
  attachmentArtifactIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Replacement BCC list */
  bcc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** Replacement body, as HTML */
  bodyHtml?: Maybe<Scalars['String']['output']>;
  /** Replacement CC list */
  cc?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
  /** Replacement subject line */
  subject?: Maybe<Scalars['String']['output']>;
  /** Replacement list of primary recipients */
  to?: Maybe<Array<CaraWorkspaceEmailRecipient>>;
};

/** Input for bulk-updating Excel spreadsheet templates */
export type UpdateExcelSpreadsheetTemplatesInput = {
  /** Whether to archive the Excel spreadsheet templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Excel spreadsheet templates.
   * Existing workbooks generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UpdateEzLynxIntegrationInput contains the input for updating an EZLynx integration */
export type UpdateEzLynxIntegrationInput = {
  /** EZLynx app secret for authentication. Optional. */
  appSecret?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client ID for authentication. Optional - required only for API mode. */
  clientId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx client secret for authentication. Optional - required only for API mode. */
  clientSecret?: InputMaybe<Scalars['String']['input']>;
  /**
   * If true, explicitly marks this as CSV import-only integration.
   * Defaults to false.
   * When credentials are provided, this should be false to allow both CSV import and API usage.
   */
  csvImportOnly: Scalars['Boolean']['input'];
  /** EZLynx integration group ID. Optional - required only for API mode. */
  integrationGroupId?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx password for authentication. Optional. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** EZLynx username for authentication. Optional - required only for API mode. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateHawksoftIntegrationInput contains the input for updating a Hawksoft integration */
export type UpdateHawksoftIntegrationInput = {
  /** If enabled, will sync call notes to the appropriate contact based on the caller's number. */
  enableSyncCallNotes?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync service requests as tasks to the agent. */
  enableSyncServiceRequests?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Input for updating HTML document templates (e.g. archiving) */
export type UpdateHtmlDocumentTemplatesInput = {
  /** Whether to archive the HTML document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the HTML document templates.
   * Existing documents that reference them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UpdateHubSpotIntegrationInput contains the input for updating a HubSpot integration */
export type UpdateHubSpotIntegrationInput = {
  /** Field mappings for call syncing. Required fields depend on callSyncType. */
  callFieldMappings?: InputMaybe<HubSpotCallFieldMappingsInput>;
  /** The pipeline ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing calls as tickets or deals. Required when callSyncType is TICKET or DEAL. */
  callStageId?: InputMaybe<Scalars['String']['input']>;
  /** How calls should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  callSyncType?: InputMaybe<HubSpotCallSyncType>;
  /** If enabled, will sync accounts from Cara to HubSpot. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to HubSpot. When enabled, callSyncType and appropriate field mappings must be provided. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to HubSpot. When enabled, taskSyncType and appropriate field mappings must be provided. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Field mappings for task syncing. Required fields depend on taskSyncType. */
  taskFieldMappings?: InputMaybe<HubSpotTaskFieldMappingsInput>;
  /** The pipeline ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskPipelineId?: InputMaybe<Scalars['String']['input']>;
  /** The stage ID to use when syncing tasks as tickets or deals. Required when taskSyncType is TICKET or DEAL. */
  taskStageId?: InputMaybe<Scalars['String']['input']>;
  /** How tasks should be synced to HubSpot. When set to TICKET or DEAL, corresponding field mappings must be provided. */
  taskSyncType?: InputMaybe<HubSpotTaskSyncType>;
};

/** UpdateImageRightIntegrationInput contains the input for updating an ImageRight integration */
export type UpdateImageRightIntegrationInput = {
  /** Update the ImageRight integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Update the ImageRight integration to use a new server URL. */
  serverUrl?: InputMaybe<Scalars['String']['input']>;
  /** Update the ImageRight integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the type of entity that initiated an update */
export enum UpdateInitiatorType {
  /** Agency client indicates an authenticated agency client */
  AgencyClient = 'AGENCY_CLIENT',
  /** Agency user indicates an authenticated agency user */
  AgencyUser = 'AGENCY_USER',
  /** Anonymous indicates an unauthenticated external user */
  Anonymous = 'ANONYMOUS',
  /** Cronjob indicates a scheduled automated job */
  Cronjob = 'CRONJOB',
  /** Oyster indicates an internal employee at Oyster */
  Oyster = 'OYSTER',
  /** Workflow indicates a Temporal workflow */
  Workflow = 'WORKFLOW'
}

/** UpdateIntegrationInput contains the input for updating an integration */
export type UpdateIntegrationInput = {
  /** Configuration for the Agency Zoom integration */
  agencyZoom?: InputMaybe<UpdateAgencyZoomIntegrationInput>;
  /** Configuration for the AMS360 integration */
  ams360?: InputMaybe<UpdateAms360IntegrationInput>;
  /** Configuration for the Applied Epic integration */
  appliedEpic?: InputMaybe<UpdateAppliedEpicIntegrationInput>;
  /** Configuration for the EZLynx integration */
  ezlynx?: InputMaybe<UpdateEzLynxIntegrationInput>;
  /** Configuration for the Hawksoft integration */
  hawksoft?: InputMaybe<UpdateHawksoftIntegrationInput>;
  /** Configuration for the HubSpot integration */
  hubspot?: InputMaybe<UpdateHubSpotIntegrationInput>;
  /** Configuration for the ImageRight integration */
  imageRight?: InputMaybe<UpdateImageRightIntegrationInput>;
  /** Configuration for the NowCerts integration */
  nowcerts?: InputMaybe<UpdateNowCertsIntegrationInput>;
  /** Configuration for the QQCatalyst integration */
  qqcatalyst?: InputMaybe<UpdateQqCatalystIntegrationInput>;
  /** Current state of the integration */
  state?: InputMaybe<IntegrationState>;
};

/** Input for updating a document in the knowledge base */
export type UpdateKnowledgeBaseDocumentInput = {
  /** The content of the document, if this is a text document */
  content?: InputMaybe<Scalars['String']['input']>;
  /**
   * Instructions for how the information in this document should be used when
   * answering questions (max 500 characters). Shown to the AI alongside the
   * document content.
   */
  contextNote?: InputMaybe<Scalars['String']['input']>;
  /**
   * Preferred user-facing name for FILE documents in the knowledge base UI and
   * when Cara refers to the document. Does not alter indexed content, embeddings,
   * or semantic content retrieval. Only accepted for FILE documents. Max 100
   * characters. Pass an empty string or whitespace to clear.
   */
  displayName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Example user questions that should cause Cara to include this document as
   * priority content (max 500 characters).
   */
  exampleQuestions?: InputMaybe<Scalars['String']['input']>;
  /** The title of the document */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Input for updating a knowledge base */
export type UpdateKnowledgeBaseInput = {
  /**
   * Enables owner-configured priority content matching for documents in this
   * knowledge base.
   */
  guidedRetrievalEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateKnowledgeBaseTool = {
  __typename?: 'UpdateKnowledgeBaseTool';
  /** The input arguments for the knowledge base update */
  input: UpdateKnowledgeBaseToolInput;
  /** The result of the knowledge base update operation */
  output: UpdateKnowledgeBaseToolOutput;
};

/**
 * Input arguments for the UpdateKnowledgeBaseTool. Adds a file that is attached to
 * the workspace to the knowledge base, either as a new document or as a new version
 * of an existing one. On the first call, provide only fileId (and optionally
 * knowledgeBaseId/title); the tool decides whether it is a new document or an edit.
 * If the tool responds asking for confirmation, call it again with either
 * replaceDocumentId (to replace) or forceNew (to add as new).
 */
export type UpdateKnowledgeBaseToolInput = {
  __typename?: 'UpdateKnowledgeBaseToolInput';
  fileId: Scalars['String']['output'];
  folderId?: Maybe<Scalars['String']['output']>;
  forceNew?: Maybe<Scalars['Boolean']['output']>;
  knowledgeBaseId?: Maybe<Scalars['String']['output']>;
  replaceDocumentId?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Result of an UpdateKnowledgeBaseTool operation. */
export type UpdateKnowledgeBaseToolOutput = {
  __typename?: 'UpdateKnowledgeBaseToolOutput';
  /** When the file looks like a possible edit, the ID of the best-matching existing document. */
  bestMatchDocumentId?: Maybe<Scalars['String']['output']>;
  /**
   * When the file looks like a possible edit, the user-facing name of the
   * best-matching existing document (display name when set, otherwise indexed
   * metadata title, otherwise persisted title).
   */
  bestMatchTitle?: Maybe<Scalars['String']['output']>;
  /** A human-readable question to ask the user when requiresClarification is true. */
  clarificationMessage?: Maybe<Scalars['String']['output']>;
  /** The ID of the created/updated document. Empty when requiresClarification is true. */
  documentId: Scalars['String']['output'];
  /** Whether indexing of the document was started. */
  indexingStarted: Scalars['Boolean']['output'];
  /** The ID of the knowledge base written to. Empty when requiresClarification is true. */
  knowledgeBaseId: Scalars['String']['output'];
  /**
   * True when the tool needs the user to confirm a decision (new vs. edit, or which
   * knowledge base) before writing. When true, no write occurred; ask the user the
   * question in clarificationMessage and then call the tool again with the answer.
   */
  requiresClarification: Scalars['Boolean']['output'];
  /** The similarity (0-100) between the incoming file and the best-matching existing document. */
  similarityPercent?: Maybe<Scalars['Int']['output']>;
  /**
   * The user-facing name of the resulting document: display name when set,
   * otherwise the indexed metadata title, otherwise the persisted title
   * (typically the upload filename for FILE documents).
   */
  title: Scalars['String']['output'];
  /** The version number of the resulting document (1 for a new document). */
  versionNumber: Scalars['Int']['output'];
};

/** Input for updating a URL-sourced document's settings */
export type UpdateKnowledgeBaseUrlDocumentInput = {
  /** Update the sync frequency */
  frequency?: InputMaybe<UrlMonitorFrequency>;
  /** Pause or resume automatic syncing */
  isPaused?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the title */
  title?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateMemoryInput = {
  category?: InputMaybe<MemoryCategory>;
  content?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  keywords?: InputMaybe<Array<Scalars['String']['input']>>;
  sticky?: InputMaybe<Scalars['Boolean']['input']>;
  surface?: InputMaybe<MemorySurface>;
  type?: InputMaybe<MemoryType>;
};

/** UpdateNowCertsIntegrationInput contains the input for updating a NowCerts integration */
export type UpdateNowCertsIntegrationInput = {
  /** If enabled, will sync accounts from Cara to NowCerts. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to NowCerts. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to NowCerts. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Update the NowCerts integration to use a new password. */
  password?: InputMaybe<Scalars['String']['input']>;
  /**
   * The referral source value to set when creating a prospect in NowCerts.
   * Pass an empty string to clear an existing value. If omitted (null), the current value is unchanged.
   */
  prospectReferralSource?: InputMaybe<Scalars['String']['input']>;
  /** Update the NowCerts integration to use a new username. */
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateOutboundCallInput = {
  callConfig?: InputMaybe<OutboundCallConfigInput>;
  customer?: InputMaybe<OutboundCallCustomerInput>;
  retryPolicy?: InputMaybe<OutboundCallRetryPolicyInput>;
  schedule?: InputMaybe<OutboundCallScheduleInput>;
  visibility?: InputMaybe<VisibilityConfigInput>;
  voiceAgentId?: InputMaybe<Scalars['String']['input']>;
};

/** UpdateQQCatalystIntegrationInput contains the input for updating a QQCatalyst integration */
export type UpdateQqCatalystIntegrationInput = {
  /**
   * Default office used for prospect insert and search.
   * Null clears the office. Omit to leave the current office unchanged.
   */
  defaultLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** If enabled, will create prospects in QQCatalyst when the caller is unknown. */
  enableSyncAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync calls from Cara to QQCatalyst. */
  enableSyncCalls?: InputMaybe<Scalars['Boolean']['input']>;
  /** If enabled, will sync tasks from Cara to QQCatalyst. */
  enableSyncTasks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Who synced tasks are assigned to */
  taskAssignment?: InputMaybe<QqCatalystTaskAssignment>;
  /**
   * Employee id used when taskAssignment is SPECIFIED_EMPLOYEE.
   * Null clears the employee. Omit to leave the current employee unchanged.
   */
  taskAssignmentEmployeeId?: InputMaybe<Scalars['Int']['input']>;
};

/** Input type for updating a service request */
export type UpdateServiceRequestInput = {
  /** Details specific to additional insured requests */
  addAdditionalInsured?: InputMaybe<AddAdditionalInsuredRequestInput>;
  /** The ID of the agency user that is assigned to this service request */
  assigneeId?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to policy cancellation requests */
  cancelPolicy?: InputMaybe<CancelPolicyRequestInput>;
  /** The email of the client that this service request is associated with */
  clientEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the client that this service request is associated with */
  clientName?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the client that this service request is associated with */
  clientPhone?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to Certificate of Insurance requests */
  createCertificate?: InputMaybe<CreateCertificateRequestInput>;
  /** Additional details about the request */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Details specific to document requests */
  documentRequest?: InputMaybe<DocumentRequestInput>;
  /** The date and time that this service request is due */
  dueAt?: InputMaybe<Scalars['Time']['input']>;
  /** Details specific to question requests */
  question?: InputMaybe<QuestionRequestInput>;
};

export type UpdateSmartFillBucketInput = {
  /**
   * A complete replacement document. Existing node IDs must be preserved for
   * nodes that keep their place; new nodes omit IDs and are minted server side.
   */
  document?: InputMaybe<Scalars['JSON']['input']>;
  expectedRevision: Scalars['Int64']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  visibility?: InputMaybe<SmartFillBucketVisibility>;
};

/** Input for previewing an update to the subscription */
export type UpdateSubscriptionInput = {
  /** The agency ID to update the subscription for */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** The period to update the subscription to */
  period?: InputMaybe<SubscriptionPeriod>;
  /** The plan to update the subscription to */
  plan?: InputMaybe<SubscriptionPlan>;
  /** The number of seats to update the subscription to */
  seats?: InputMaybe<Scalars['Int']['input']>;
  /** The number of voice agents to update the subscription to */
  voiceAgents?: InputMaybe<Scalars['Int']['input']>;
};

/** Preview of the invoice that would be generated for the subscription update */
export type UpdateSubscriptionInvoicePreview = {
  __typename?: 'UpdateSubscriptionInvoicePreview';
  /** The amount due for the invoice */
  amountDue: Scalars['Float']['output'];
  /** The amount paid for the invoice */
  amountPaid: Scalars['Float']['output'];
  /** The discount total of the invoice */
  discountTotal: Scalars['Float']['output'];
  /** Whether the invoice is a recurring invoice (false) or whether this is the next invoice (true) */
  isNextInvoice: Scalars['Boolean']['output'];
  /** The line items that would be included in the invoice */
  lineItems: Array<UpdateSubscriptionInvoicePreviewLineItem>;
  /** The subtotal of the invoice */
  subTotal: Scalars['Float']['output'];
  /** The tax total of the invoice */
  taxTotal: Scalars['Float']['output'];
  /** The total of the invoice */
  total: Scalars['Float']['output'];
};

/** Line item for the invoice */
export type UpdateSubscriptionInvoicePreviewLineItem = {
  __typename?: 'UpdateSubscriptionInvoicePreviewLineItem';
  /** The name of the line item */
  name: Scalars['String']['output'];
  /** The quantity of the line item */
  quantity: Scalars['Int']['output'];
  /** The total amount of the line item */
  totalAmount: Scalars['Float']['output'];
  /** The unit amount of the line item */
  unitAmount: Scalars['Float']['output'];
};

export type UpdateTriggerDefinitionInput = {
  eventMatcher?: InputMaybe<TriggerEventMatcherInput>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  target?: InputMaybe<TriggerTargetInput>;
  version: Scalars['Int64']['input'];
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Input for bulk-updating Word document templates */
export type UpdateWordDocumentTemplatesInput = {
  /** Whether to archive the Word document templates */
  archive?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional visibility configuration to apply to the Word document templates.
   * Existing documents generated from them keep their current visibility.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** Input for updating an existing workflow definition */
export type UpdateWorkflowDefinitionInput = {
  /** Updated description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the definition to update */
  id: Scalars['ID']['input'];
  /** Updated input slots (replaces all slots) */
  inputs?: InputMaybe<Array<WorkflowDefinitionInputSlotInput>>;
  /** Updated label */
  label?: InputMaybe<Scalars['String']['input']>;
  /** Updated tasks and bindings (replaces all nodes) */
  nodes?: InputMaybe<Array<WorkflowDefinitionNodeInput>>;
  /** The current version (for optimistic concurrency) */
  version: Scalars['Int64']['input'];
};

export type UploadCustomFormInput = {
  file: Scalars['Upload']['input'];
  ingestionGuidance?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
  /** Optional visibility configuration. Defaults to PUBLIC when omitted. */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

/** UploadFileInput represents a file upload request */
export type UploadFileInput = {
  /** The file to upload */
  file: Scalars['Upload']['input'];
  /** The notes associated with the file */
  notes: Scalars['String']['input'];
  /** The type of the file */
  type: FileType;
  /** Whether the file is visible to the user */
  visible: Scalars['Boolean']['input'];
};

/** Input for uploading a new file document in the knowledge base */
export type UploadKnowledgeBaseFileDocumentInput = {
  /** The files to upload */
  files: Array<Scalars['Upload']['input']>;
  /** The cosmetic folder to upload the documents into. Null means root. */
  folderId?: InputMaybe<Scalars['String']['input']>;
};

export type UpsertSmartFillOverrideInput = {
  action: SmartFillOverrideAction;
  /**
   * For HINT, the bucket property the user picked; the server derives the
   * generalizable intent from it and keeps it only as provenance.
   */
  bucketId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional live destination context for the same semantic conversions used during fill. */
  destination?: InputMaybe<SmartFillDestinationContextInput>;
  fieldKey: Scalars['String']['input'];
  /**
   * For HINT without a propertyId: the value the user typed into the field, and
   * for choice controls the option value the page submits. The server finds the
   * single bucket property it could have come from using the same formatting
   * fills use, so a date, phone, or option label matches its stored value. The
   * value is the user's own correction made inside Cara's UI.
   */
  fieldType?: InputMaybe<SmartFillFieldType>;
  fingerprintVersion: Scalars['Int']['input'];
  formFingerprint: Scalars['String']['input'];
  matchSubmittedValue?: InputMaybe<Scalars['String']['input']>;
  matchValue?: InputMaybe<Scalars['String']['input']>;
  propertyId?: InputMaybe<Scalars['ID']['input']>;
};

/** Per-agency override of included usage amounts for platform (contract) plans. */
export type UsageAllotmentOverrides = {
  __typename?: 'UsageAllotmentOverrides';
  kbPages?: Maybe<Scalars['Int']['output']>;
  platformUnits?: Maybe<Scalars['Int']['output']>;
  voiceMinutes?: Maybe<Scalars['Int']['output']>;
};

/**
 * Usage metering cadence for included allotments. May differ from how often the
 * base subscription is invoiced when usageCycle is set explicitly as an override.
 */
export enum UsageCycle {
  Annual = 'ANNUAL',
  Monthly = 'MONTHLY'
}

/** Included allowance for a single meter in the current billing period. */
export type UsageMeterAllowance = {
  __typename?: 'UsageMeterAllowance';
  included: Scalars['Int']['output'];
  meterCode: ConsumptionMeterCode;
  /** Overage unit price in USD. Zero when overage billing is not configured. */
  overageRatePerUnit: Scalars['Float']['output'];
  unitLabel: Scalars['String']['output'];
};

/** Consumed amount for a single meter in the current billing period. */
export type UsageMeterAmount = {
  __typename?: 'UsageMeterAmount';
  /**
   * Per-day BILLABLE totals for the current period, zero-filled for missing days.
   * Length matches the number of local calendar days spanned by the billing
   * period in AgencyUsageReport.timezone.
   */
  daily: Array<UsageMeterDailyAmount>;
  meterCode: ConsumptionMeterCode;
  used: Scalars['Decimal']['output'];
};

/**
 * Billable quantity for one calendar day within the current usage period,
 * in AgencyUsageReport.timezone.
 */
export type UsageMeterDailyAmount = {
  __typename?: 'UsageMeterDailyAmount';
  /**
   * Calendar day this bucket covers, encoded as UTC midnight of that local
   * Y-M-D in AgencyUsageReport.timezone (date components only; not a UTC instant).
   */
  date: Scalars['Time']['output'];
  /** BILLABLE quantity_billable summed for this day. */
  used: Scalars['Decimal']['output'];
};

/** Settled overage invoice for one closed usage period. */
export type UsageOverageInvoice = {
  __typename?: 'UsageOverageInvoice';
  createdAt: Scalars['Time']['output'];
  deliveryMethod: OverageDeliveryMethod;
  hostedInvoiceUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  lineItems: Array<OverageBillLineItem>;
  paidAt?: Maybe<Scalars['Time']['output']>;
  periodEnd: Scalars['Time']['output'];
  periodStart: Scalars['Time']['output'];
  status: UsageOverageInvoiceStatus;
  stripeInvoiceId?: Maybe<Scalars['String']['output']>;
  subtotalDollars: Scalars['Float']['output'];
  totalDollars: Scalars['Float']['output'];
};

export type UsageOverageInvoiceConnection = {
  __typename?: 'UsageOverageInvoiceConnection';
  edges: Array<UsageOverageInvoiceEdge>;
  pageInfo: PageInfo;
};

export type UsageOverageInvoiceEdge = {
  __typename?: 'UsageOverageInvoiceEdge';
  cursor: Scalars['String']['output'];
  node: UsageOverageInvoice;
};

/** Settlement status for a closed usage period's overage invoice. */
export enum UsageOverageInvoiceStatus {
  Failed = 'FAILED',
  Paid = 'PAID',
  /** Stripe delivery complete; charge not yet collected. Shown as "Scheduled". */
  Pending = 'PENDING',
  /**
   * Period claimed; Stripe delivery in progress. Internal only — not shown in
   * customer billing history until promoted to PENDING.
   */
  Processing = 'PROCESSING',
  /** Period processed with $0 overage. */
  Skipped = 'SKIPPED'
}

/**
 * Visibility levels that govern who can see and interact with a visibility-bearing
 * object (workspace, custom preset, document template, custom form, etc.).
 *
 * Default for all objects is PUBLIC, preserving the historical behaviour where
 * every member of an agency could see every object.
 *
 * * PRIVATE — only the creator may read or modify the object. Agency admins
 *             retain read access for compliance.
 * * SHARED  — the creator plus the explicit user/team access list may read or
 *             modify. Useful for limiting visibility to a project group without
 *             making the object visible to the entire agency.
 * * PUBLIC  — the entire agency may read and use the object.
 */
export enum Visibility {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
  Shared = 'SHARED'
}

/**
 * The materialized visibility configuration on an object. The `userIds` and
 * `teamIds` lists are only meaningful when `level == SHARED`; for PRIVATE/PUBLIC
 * they are empty. The `users` and `teams` fields resolve those references for the
 * current viewer; entries the viewer cannot otherwise see are still surfaced by
 * ID so the access-list editor can show them. Resolution lives at the resolver
 * layer in a follow-up phase.
 */
export type VisibilityConfig = {
  __typename?: 'VisibilityConfig';
  level: Visibility;
  teamIds: Array<Scalars['String']['output']>;
  userIds: Array<Scalars['String']['output']>;
};

/**
 * Input type used by mutations that accept a visibility configuration.
 * When omitted on create, the object is created PUBLIC. `userIds` and `teamIds`
 * are ignored unless `level == SHARED`.
 */
export type VisibilityConfigInput = {
  level: Visibility;
  teamIds?: InputMaybe<Array<Scalars['String']['input']>>;
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

/**
 * Optional per-list filter that narrows by visibility membership on top of
 * the always-on per-principal visibility filter. All fields are optional and
 * combine via AND.
 */
export type VisibilityListFilterInput = {
  /**
   * When true, restrict to SHARED rows the caller is a target of but did not
   * create themselves — the "Shared with me" view.
   */
  sharedWithMe?: InputMaybe<Scalars['Boolean']['input']>;
  /** Restrict to SHARED rows that include this team in their access list. */
  sharedWithTeamId?: InputMaybe<Scalars['String']['input']>;
  /** Restrict to a specific visibility level (PRIVATE / SHARED / PUBLIC). */
  visibilityLevel?: InputMaybe<Visibility>;
};

/** Represents a voice agent */
export type VoiceAgent = {
  __typename?: 'VoiceAgent';
  /** The agency associated with this voice agent configuration */
  agency: Agency;
  /** The voice agent configuration */
  configuration: VoiceAgentConfiguration;
  /** Timestamp of when the voice agent was created */
  createdAt: Scalars['Time']['output'];
  /** Whether this agent receives inbound calls or places outbound calls */
  direction: VoiceAgentDirection;
  /** The ID of the voice agent */
  id: Scalars['ID']['output'];
  /** The name of the voice agent */
  name: Scalars['String']['output'];
  /**
   * Locked AI/recording disclosure appended after the outbound intro at dial time.
   * Null for inbound agents. Not editable from Cara settings.
   */
  outboundIntroComplianceDisclosure?: Maybe<Scalars['String']['output']>;
  /** The phone number of the voice agent */
  phoneNumber: Scalars['String']['output'];
  /** The state of the voice agent */
  state: VoiceAgentState;
  /** Timestamp of when the voice agent was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this voice agent. Incremented on each configuration update. */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this voice agent. The first version in this list will be this version
   * (i.e. identical to the current voice agent), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<VoiceAgentVersion>>;
};

/**
 * Types of customer information the APQ (Account / Policy / Quote) lookup tool is allowed to
 * surface to Cara during a call. Each value gates a distinct block of the lookup_customer
 * response served by the Retell webhook.
 */
export enum VoiceAgentAccountLookupDataType {
  /** Basic account records (name, ID) discovered for the caller. */
  AccountDetails = 'ACCOUNT_DETAILS',
  /**
   * Client notes (subject and body text) associated with the caller's integration
   * accounts via the same knowledge-graph lookup as policy details. May contain
   * sensitive or confidential information about the caller.
   */
  ClientNotes = 'CLIENT_NOTES',
  /**
   * Business policy details (carrier, premium, dates) from synced AMS integrations.
   * When enabled, Cara also receives related integration account and contact context
   * for the caller (no separate toggle required).
   */
  PolicyDetails = 'POLICY_DETAILS',
  /**
   * Summaries of the caller's most recent phone interactions, including inbound calls
   * and outbound jobs Cara placed to this number (objective, context, and attempt summary).
   */
  PreviousCalls = 'PREVIOUS_CALLS',
  /** Open and recently-closed service requests / tickets on the caller's accounts. */
  ServiceRequests = 'SERVICE_REQUESTS'
}

/** Represents a voice agent configuration */
export type VoiceAgentConfiguration = {
  __typename?: 'VoiceAgentConfiguration';
  /**
   * The APQ (Account / Policy / Quote) lookup tool configuration. Controls whether
   * Cara can call lookup_customer during the call and which categories of customer
   * data it is allowed to receive in the response.
   */
  accountLookup: VoiceAgentConfigurationAccountLookup;
  /** The agency configuration that Cara should use */
  agency: VoiceAgentConfigurationAgency;
  /** The name of the voice agent that Cara should use, if it should override the default voice agent name (which is Cara) */
  agentName?: Maybe<Scalars['String']['output']>;
  /** The behavior of how Cara should handle the caller's request */
  callBehavior: VoiceAgentConfigurationCallBehavior;
  /** The global custom instructions that Cara should use, if any */
  globalCustomInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * The intro phrase that Cara should use, if it should override the default intro phrase.
   * Stored per voice agent — inbound and outbound agents each have their own phrase.
   * Inbound out-of-office (time-off) custom intros are separate and do not apply to outbound.
   */
  introPhrase?: Maybe<Scalars['String']['output']>;
  /**
   * Deprecated single-language projection for cached clients. Returns the first
   * entry of languages.
   * @deprecated Use languages instead. Returns the first selected language.
   */
  language: VoiceAgentLanguage;
  /** The languages that Cara should understand and speak */
  languages: Array<VoiceAgentLanguage>;
  /** The model configuration that Cara should use */
  model: VoiceAgentConfigurationModel;
  /** The notifications that Cara should use */
  notifications: VoiceAgentConfigurationNotifications;
  /**
   * Default outbound call behavior for agents that place outbound calls.
   * Null for inbound agents; required for outbound agents (enforced in validation).
   */
  outboundCallBehavior?: Maybe<VoiceAgentConfigurationOutboundCallBehavior>;
  /** The behavior of how Cara should handle the caller's request */
  taskBehavior: VoiceAgentConfigurationTaskBehavior;
  /** The transfer configuration for the voice agent */
  transfer: VoiceAgentConfigurationTransfer;
};

/**
 * Configuration for the APQ (Account / Policy / Quote) lookup tool that Cara uses to
 * read context about the caller during a live call.
 */
export type VoiceAgentConfigurationAccountLookup = {
  __typename?: 'VoiceAgentConfigurationAccountLookup';
  /**
   * Whether Cara is allowed to call the lookup_customer tool at all. When false, the
   * webhook returns a single disabled-message response and no account, policy, service
   * request, call, or knowledge graph data is shared with the model.
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * The categories of information the lookup tool is allowed to return when enabled
   * is true. Categories not listed here are stripped from the response before it
   * reaches Cara.
   */
  includedDataTypes: Array<VoiceAgentAccountLookupDataType>;
};

/** Input type for configuring the APQ (Account / Policy / Quote) lookup tool. */
export type VoiceAgentConfigurationAccountLookupInput = {
  /** Whether Cara is allowed to call the lookup_customer tool at all. */
  enabled: Scalars['Boolean']['input'];
  /** The categories of customer information the lookup tool may return when enabled. */
  includedDataTypes: Array<VoiceAgentAccountLookupDataType>;
};

/** Agency configuration overrides for the voice agent */
export type VoiceAgentConfigurationAgency = {
  __typename?: 'VoiceAgentConfigurationAgency';
  /** The address of the agency that Cara should use, if it is different from the agency address in the agency configuration */
  address?: Maybe<Scalars['String']['output']>;
  /** The business hours of the agency that Cara, if specified. Otherwise, Cara will not present any information about business hours. */
  businessHours?: Maybe<Scalars['String']['output']>;
  /** The email of the agency that Cara should use, if it is different from the agency contact email in the agency configuration */
  email?: Maybe<Scalars['String']['output']>;
  /** The name of the agency that Cara should use, if it is different from the agency name in the agency configuration */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number of the agency that Cara should use, if it is different from the agency contact phone number in the agency configuration */
  phone?: Maybe<Scalars['String']['output']>;
  /** The website of the agency that Cara should use, if it is different from the agency website in the agency configuration */
  website?: Maybe<Scalars['String']['output']>;
};

/** Input type for agency configuration overrides for the voice agent */
export type VoiceAgentConfigurationAgencyInput = {
  /** The address of the agency that Cara should use, if it is different from the agency address in the agency configuration */
  address?: InputMaybe<Scalars['String']['input']>;
  /** The business hours of the agency that Cara, if specified. Otherwise, Cara will not present any information about business hours. */
  businessHours?: InputMaybe<Scalars['String']['input']>;
  /** The email of the agency that Cara should use, if it is different from the agency contact email in the agency configuration */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The name of the agency that Cara should use, if it is different from the agency name in the agency configuration */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number of the agency that Cara should use, if it is different from the agency contact phone number in the agency configuration */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The website of the agency that Cara should use, if it is different from the agency website in the agency configuration */
  website?: InputMaybe<Scalars['String']['input']>;
};

export type VoiceAgentConfigurationCallBehavior = {
  __typename?: 'VoiceAgentConfigurationCallBehavior';
  /** If set and startSpeaker is USER, the AI will begin the conversation after waiting for the user for the duration (in milliseconds) specified. If not set, the agent will wait indefinitely for the user to speak. */
  beginAfterUserSilenceMs?: Maybe<Scalars['Int']['output']>;
  /**
   * Additional contact information fields Cara must collect from every caller.
   * One field per line, e.g. policy type, policy number.
   */
  customRequiredContactInfo: Array<Scalars['String']['output']>;
  /** The rapport building strategy that Cara should use */
  rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding;
  /** Whether Cara should reference policy information when handling the caller's request */
  referencePolicyInfo: Scalars['Boolean']['output'];
  /** Whether Cara should repeat critical information to the caller */
  repeatCriticalInfo: Scalars['Boolean']['output'];
  /** The required contact information that Cara should collect from the caller */
  requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>;
  /** Who starts the conversation - the AI agent or the user */
  startSpeaker: VoiceAgentStartSpeaker;
};

/** Input type for configuring call behavior settings for the voice agent */
export type VoiceAgentConfigurationCallBehaviorInput = {
  /** If set and startSpeaker is USER, the AI will begin the conversation after waiting for the user for the duration (in milliseconds) specified. If not set, the agent will wait indefinitely for the user to speak. */
  beginAfterUserSilenceMs?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Additional contact information fields Cara must collect from every caller.
   * One field per line, e.g. policy type, policy number.
   */
  customRequiredContactInfo: Array<Scalars['String']['input']>;
  /** The rapport building strategy that Cara should use */
  rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding;
  /** Whether Cara should reference policy information when handling the caller's request */
  referencePolicyInfo: Scalars['Boolean']['input'];
  /** The critical information that Cara should repeat to the caller */
  repeatCriticalInfo: Scalars['Boolean']['input'];
  /** The required contact information that Cara should collect from the caller */
  requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>;
  /** Who starts the conversation - the AI agent or the user */
  startSpeaker: VoiceAgentStartSpeaker;
};

/** The rapport building strategy that Cara should use with callers */
export enum VoiceAgentConfigurationCallBehaviorRapportBuilding {
  /** Cara should converse with the caller */
  BuildRapport = 'BUILD_RAPPORT',
  /** Cara maintains professional warmth with natural, varied responses */
  Cordial = 'CORDIAL',
  /** Cara should not try to build rapport, but will engage in conversation if needed */
  Neutral = 'NEUTRAL',
  /** Cara will more strictly adhere to the task at hand */
  TaskFocused = 'TASK_FOCUSED'
}

/** Types of critical information that Cara should repeat back to the caller */
export enum VoiceAgentConfigurationCallBehaviorRepeatCriticalInfoType {
  /** The caller's business name */
  BusinessName = 'BUSINESS_NAME',
  /** The caller's date of birth */
  DateOfBirth = 'DATE_OF_BIRTH',
  /** The caller's email */
  Email = 'EMAIL',
  /** The caller's FEIN or social security number */
  FeinOrSocialSecurityNumber = 'FEIN_OR_SOCIAL_SECURITY_NUMBER',
  /** The caller's license number */
  LicenseNumber = 'LICENSE_NUMBER',
  /** The caller's name */
  Name = 'NAME',
  /** The caller's phone number */
  Phone = 'PHONE',
  /** The caller's policy numbers */
  PolicyNumber = 'POLICY_NUMBER'
}

/**
 * Types of required contact information that Cara should collect from the caller
 * Clients must tolerate new enum values because capabilities are added over time.
 */
export enum VoiceAgentConfigurationCallBehaviorRequiredContactInfoType {
  /** The caller's email */
  Email = 'EMAIL',
  /** The insurance line of business used for Voice 3.5 transfer routing */
  LineOfBusiness = 'LINE_OF_BUSINESS',
  /** The caller's phone number */
  Phone = 'PHONE'
}

export type VoiceAgentConfigurationInput = {
  /**
   * The APQ lookup tool configuration. Required so that the mutation explicitly
   * encodes whether the lookup tool is enabled and which data categories Cara may
   * receive.
   */
  accountLookup: VoiceAgentConfigurationAccountLookupInput;
  /** The agency configuration that Cara should use */
  agency: VoiceAgentConfigurationAgencyInput;
  /** The name of the voice agent that Cara should use, if it should override the default voice agent name (which is Cara) */
  agentName?: InputMaybe<Scalars['String']['input']>;
  /** The behavior of how Cara should handle the caller's request */
  callBehavior: VoiceAgentConfigurationCallBehaviorInput;
  /** The global custom instructions that Cara should use, if any */
  globalCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * The intro phrase that Cara should use, if it should override the default intro phrase.
   * Stored per voice agent — inbound and outbound agents each have their own phrase.
   * Inbound out-of-office (time-off) custom intros are separate and do not apply to outbound.
   */
  introPhrase?: InputMaybe<Scalars['String']['input']>;
  /**
   * Deprecated single-language input for cached clients. Ignored when languages is
   * provided. MULTI preserves the agent's existing languages list; a concrete
   * scalar replaces it.
   * @deprecated Use languages instead. Accepted during the migration window for cached clients.
   */
  language?: InputMaybe<VoiceAgentLanguage>;
  /**
   * The languages that Cara should understand and speak. Nullable during the
   * compatibility window so cached clients can omit it and send legacy language.
   */
  languages?: InputMaybe<Array<VoiceAgentLanguage>>;
  /** The model configuration that Cara should use */
  model: VoiceAgentConfigurationModelInput;
  /** The notifications that Cara should use */
  notifications: VoiceAgentConfigurationNotificationsInput;
  /**
   * Default outbound call behavior for agents that place outbound calls.
   * Omit or null for inbound agents; required for outbound agents (enforced in validation).
   */
  outboundCallBehavior?: InputMaybe<VoiceAgentConfigurationOutboundCallBehaviorInput>;
  /** The behavior of how Cara should handle the caller's request */
  taskBehavior: VoiceAgentConfigurationTaskBehaviorInput;
  /** The transfer configuration for the voice agent */
  transfer: VoiceAgentConfigurationTransferInput;
};

/** The voice model configuration that Cara should use */
export type VoiceAgentConfigurationModel = {
  __typename?: 'VoiceAgentConfigurationModel';
  /** If set to true, the agent will dynamically adjust how quickly it responds based on the user's speech rate and past turn-taking behavior in the call */
  enableDynamicResponsiveness: Scalars['Boolean']['output'];
  /** If set to true, will enable dynamic voice speed adjustment based on the user's speech rate and conversation context */
  enableDynamicVoiceSpeed: Scalars['Boolean']['output'];
  /** The responsiveness of the model that Cara should use ([0,1] default 0.9, higher is more responsive less latency) */
  responsiveness: Scalars['Float']['output'];
  /** The voice that Cara should use */
  voice: VoiceAgentConfigurationModelVoice;
  /** The voice speed that Cara should use ([0.5, 2]default 1.06) */
  voiceSpeed: Scalars['Float']['output'];
  /** The voice speed that Cara should use ([0,2] default 1) */
  voiceTemperature: Scalars['Float']['output'];
  /** The voice volume that Cara should use ([0,2] default 1) */
  voiceVolume: Scalars['Float']['output'];
};

/** Input type for configuring model settings for the voice agent */
export type VoiceAgentConfigurationModelInput = {
  /** If set to true, the agent will dynamically adjust how quickly it responds based on the user's speech rate and past turn-taking behavior in the call */
  enableDynamicResponsiveness: Scalars['Boolean']['input'];
  /** If set to true, will enable dynamic voice speed adjustment based on the user's speech rate and conversation context */
  enableDynamicVoiceSpeed: Scalars['Boolean']['input'];
  /** The responsiveness of the model that Cara should use ([0,1] default 0.9, higher is more responsive less latency) */
  responsiveness: Scalars['Float']['input'];
  /** The voice that Cara should use */
  voice: VoiceAgentConfigurationModelVoice;
  /** The voice speed that Cara should use ([0.5, 2]default 1.06) */
  voiceSpeed: Scalars['Float']['input'];
  /** The voice speed that Cara should use ([0,2] default 1) */
  voiceTemperature: Scalars['Float']['input'];
  /** The voice volume that Cara should use ([0,2] default 1) */
  voiceVolume: Scalars['Float']['input'];
};

/** The voice that Cara should use */
export enum VoiceAgentConfigurationModelVoice {
  Andrea = 'ANDREA',
  Ashley = 'ASHLEY',
  Charlotte = 'CHARLOTTE',
  Chloe = 'CHLOE',
  Cimo = 'CIMO',
  Crystal = 'CRYSTAL',
  Eleanor = 'ELEANOR',
  Evie = 'EVIE',
  Grace = 'GRACE',
  Hailey = 'HAILEY',
  HaileyBrazilian = 'HAILEY_BRAZILIAN',
  Isabel = 'ISABEL',
  Kate = 'KATE',
  Marissa = 'MARISSA',
  May = 'MAY',
  MinimaxGrace = 'MINIMAX_GRACE',
  Nia = 'NIA',
  Rita = 'RITA',
  Sophie = 'SOPHIE',
  Susan = 'SUSAN',
  Zuri = 'ZURI'
}

/** The notifications that Cara should use */
export type VoiceAgentConfigurationNotifications = {
  __typename?: 'VoiceAgentConfigurationNotifications';
  /** Custom routing instructions to determine how to route call notifications */
  dynamicEmailRoutingCustomInstructions?: Maybe<Scalars['String']['output']>;
  /**
   * Whether to dynamically route call notifications automatically to the mentioned
   * or transferred agent.
   */
  enableDynamicEmailRoutingToAgencyUsers: Scalars['Boolean']['output'];
  /** The static email addresses that Cara should use to send notifications */
  staticEmails: Array<Scalars['String']['output']>;
};

export type VoiceAgentConfigurationNotificationsInput = {
  /** Custom routing instructions to determine how to route call notifications */
  dynamicEmailRoutingCustomInstructions?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to dynamically route call notifications automatically to the mentioned
   * or transferred agent.
   */
  enableDynamicEmailRoutingToAgencyUsers: Scalars['Boolean']['input'];
  /** The static email addresses that Cara should use to send notifications */
  staticEmails: Array<Scalars['String']['input']>;
};

/** Default outbound call behavior for outbound voice agents */
export type VoiceAgentConfigurationOutboundCallBehavior = {
  __typename?: 'VoiceAgentConfigurationOutboundCallBehavior';
  /** Whether Cara should leave a voicemail when the customer does not answer */
  leaveVoicemail: Scalars['Boolean']['output'];
  /**
   * Whether Cara should verify the customer's identity at the start of the call.
   * Defaults to false.
   */
  verifyIdentity: Scalars['Boolean']['output'];
  /** The message Cara should leave when voicemail is reached */
  voicemailMessage: Scalars['String']['output'];
};

export type VoiceAgentConfigurationOutboundCallBehaviorInput = {
  /** Whether Cara should leave a voicemail when the customer does not answer */
  leaveVoicemail: Scalars['Boolean']['input'];
  /**
   * Whether Cara should verify the customer's identity at the start of the call.
   * Defaults to false.
   */
  verifyIdentity: Scalars['Boolean']['input'];
  /** The message Cara should leave when voicemail is reached */
  voicemailMessage: Scalars['String']['input'];
};

export type VoiceAgentConfigurationQuestionsAuto = {
  __typename?: 'VoiceAgentConfigurationQuestionsAuto';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The auto insurance questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsAutoType>;
};

export type VoiceAgentConfigurationQuestionsAutoInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The auto insurance questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsAutoType>;
};

export enum VoiceAgentConfigurationQuestionsAutoType {
  /** Whether the client would like comprehensive and collision coverage on the vehicle */
  ComprehensiveAndCollisionCoverage = 'COMPREHENSIVE_AND_COLLISION_COVERAGE',
  /** Confirm if this is a business auto or personal auto quote if not already known */
  ConfirmBusinessOrPersonalAuto = 'CONFIRM_BUSINESS_OR_PERSONAL_AUTO',
  /** Collect the drivers license number for EACH driver if available */
  DriversLicenseNumbers = 'DRIVERS_LICENSE_NUMBERS',
  /** Count of drivers to be listed on the policy */
  DriverCount = 'DRIVER_COUNT',
  /** List of all drivers including first and last name, their respective gender, and birth date */
  DriverDetails = 'DRIVER_DETAILS',
  /** The estimated annual mileage */
  EstimatedAnnualMileage = 'ESTIMATED_ANNUAL_MILEAGE',
  /** The current estimated value of the vehicle if known */
  EstimatedVehicleValue = 'ESTIMATED_VEHICLE_VALUE',
  /** Garaging address including the street address, city or town, state, and zip code */
  GaragingAddress = 'GARAGING_ADDRESS',
  /** Any prior accidents or violations in the past five years for any driver */
  PriorAccidentsOrViolations = 'PRIOR_ACCIDENTS_OR_VIOLATIONS',
  /** When the vehicle was acquired (purchase date) */
  VehicleAcquisitionDate = 'VEHICLE_ACQUISITION_DATE',
  /** How many vehicles are they looking to insure on this quote */
  VehicleCount = 'VEHICLE_COUNT',
  /** Vehicle use: pleasure, business, or both */
  VehicleUse = 'VEHICLE_USE',
  /** V.I.N. (vehicle identification number) or the year, make, model, and trim of each vehicle */
  VinOrVehicleDetails = 'VIN_OR_VEHICLE_DETAILS'
}

export type VoiceAgentConfigurationQuestionsCommercialCommon = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>;
};

export type VoiceAgentConfigurationQuestionsCommercialCommonInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialCommonType {
  /** Ask for the business legal name and DBA (doing business as) name */
  BusinessLegalNameAndDba = 'BUSINESS_LEGAL_NAME_AND_DBA',
  /** Ask about the business operations to understand what kind of business they are in */
  BusinessOperations = 'BUSINESS_OPERATIONS',
  /** Ask when the business was started or acquired */
  BusinessStartDate = 'BUSINESS_START_DATE',
  /** Ask for the estimated revenue for the next twelve months */
  EstimatedAnnualRevenue = 'ESTIMATED_ANNUAL_REVENUE'
}

export type VoiceAgentConfigurationQuestionsCommercialLiability = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial liability questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>;
};

export type VoiceAgentConfigurationQuestionsCommercialLiabilityInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial liability questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialLiabilityType {
  /** The coverage limits if the customer knows what coverage limits they want */
  CoverageLimits = 'COVERAGE_LIMITS',
  /** If the business sells goods then understand if they import the goods, manufacture the goods, or sell the goods under their own label */
  ImportManufactureOrSellUnderOwnLabel = 'IMPORT_MANUFACTURE_OR_SELL_UNDER_OWN_LABEL',
  /** Addresses for all locations to be insured with at least one address to mail the policy to */
  LocationAddresses = 'LOCATION_ADDRESSES',
  /** The business's estimated revenue from each type of operation split by location */
  RevenueByOperationAndLocation = 'REVENUE_BY_OPERATION_AND_LOCATION',
  /** Ask at least two additional underwriting questions sequentially based on the business type */
  UnderwritingQuestions = 'UNDERWRITING_QUESTIONS'
}

export type VoiceAgentConfigurationQuestionsCommercialProperty = {
  __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial property questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>;
};

export type VoiceAgentConfigurationQuestionsCommercialPropertyInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial property questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>;
};

export enum VoiceAgentConfigurationQuestionsCommercialPropertyType {
  /** Address of the building including the street address, town or city, state, and zip code */
  BuildingAddress = 'BUILDING_ADDRESS',
  /** How much coverage do they need: building coverage, contents coverage, and tenants betterments and improvements coverage if applicable */
  CoverageAmounts = 'COVERAGE_AMOUNTS',
  /** Collect the exterior wall type: masonry like cement block or brick, or something else like stucco, vinyl, etc. */
  ExteriorWallType = 'EXTERIOR_WALL_TYPE',
  /** If fire or burglar alarms are present and if they sound locally or are monitored by a third party */
  FireOrBurglarAlarms = 'FIRE_OR_BURGLAR_ALARMS',
  /** Collect the framing type: the building will either have wood or metal framing */
  FramingType = 'FRAMING_TYPE',
  /** Any other locations to insure */
  OtherLocations = 'OTHER_LOCATIONS',
  /** If the customer owns or rents the building */
  OwnershipStatus = 'OWNERSHIP_STATUS',
  /** The address for their primary home if this is not the primary home */
  PrimaryHomeAddress = 'PRIMARY_HOME_ADDRESS',
  /** If this is their primary or secondary home */
  PrimaryOrSecondaryHome = 'PRIMARY_OR_SECONDARY_HOME',
  /** If there are prior losses in the last five years */
  PriorLosses = 'PRIOR_LOSSES',
  /** If it is for residential or personal like homeowners, condo, or tenant */
  ResidentialOrPersonalType = 'RESIDENTIAL_OR_PERSONAL_TYPE',
  /** For business customers ask if they have a sprinkler system in the ceiling */
  SprinklerSystem = 'SPRINKLER_SYSTEM',
  /** Square footage for each location */
  SquareFootage = 'SQUARE_FOOTAGE',
  /** Year built, including the year updated for roofing, plumbing, electrical, and HVAC */
  YearBuiltAndUpdates = 'YEAR_BUILT_AND_UPDATES'
}

/** The custom questions that Cara should ask the caller based on the line of business */
export type VoiceAgentConfigurationQuestionsCustomQuote = {
  __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote';
  /** The line of business that the custom questions should be based on */
  lineOfBusiness: Scalars['String']['output'];
  /** The quote questions that Cara should ask the caller */
  questions: Array<Scalars['String']['output']>;
};

/** The custom questions that Cara should ask the caller based on the line of business */
export type VoiceAgentConfigurationQuestionsCustomQuoteInput = {
  /** The line of business that the custom questions should be based on */
  lineOfBusiness: Scalars['String']['input'];
  /** The quote questions that Cara should ask the caller */
  questions: Array<Scalars['String']['input']>;
};

/** The qualification questions that Cara should ask the caller */
export type VoiceAgentConfigurationQuestionsQualification = {
  __typename?: 'VoiceAgentConfigurationQuestionsQualification';
  /** The custom qualification questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The qualification questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsQualificationType>;
};

/** Input type for configuring qualification questions for the voice agent */
export type VoiceAgentConfigurationQuestionsQualificationInput = {
  /** The custom qualification questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The qualification questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsQualificationType>;
};

export enum VoiceAgentConfigurationQuestionsQualificationType {
  /** Ask if they have a prior policy and are looking to switch */
  HavePriorPolicy = 'HAVE_PRIOR_POLICY',
  /** Ask the reason why they are requesting a quote */
  ReasonForQuote = 'REASON_FOR_QUOTE'
}

export type VoiceAgentConfigurationQuestionsWorkersCompensation = {
  __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The workers compensation questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>;
};

export type VoiceAgentConfigurationQuestionsWorkersCompensationInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The workers compensation questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>;
};

export enum VoiceAgentConfigurationQuestionsWorkersCompensationType {
  /** If the company uses 1099s that do not carry workers compensation then collect the annual 1099 payments */
  Contractor_1099Payments = 'CONTRACTOR_1099_PAYMENTS',
  /** Collect the count of full time and part time W2 workers per location with a split between full time vs part time */
  EmployeeCountByTypeAndLocation = 'EMPLOYEE_COUNT_BY_TYPE_AND_LOCATION',
  /** FEIN (federal employer identification number) */
  Fein = 'FEIN',
  /** Address for each location with employees to be covered */
  LocationAddressesWithEmployees = 'LOCATION_ADDRESSES_WITH_EMPLOYEES',
  /** If they would like to cover owners and officers in the workers compensation, collect the full name and ownership percentage for each */
  OwnerOfficerCoverage = 'OWNER_OFFICER_COVERAGE',
  /** Collect the payroll of full time and part time W2 workers per location with a split between full time vs part time payroll */
  PayrollByTypeAndLocation = 'PAYROLL_BY_TYPE_AND_LOCATION',
  /** Ask two additional underwriting questions sequentially based on the business type */
  UnderwritingQuestions = 'UNDERWRITING_QUESTIONS'
}

/** The task behavior configuration that Cara should use */
export type VoiceAgentConfigurationTaskBehavior = {
  __typename?: 'VoiceAgentConfigurationTaskBehavior';
  /** The business lines that Cara should handle */
  businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine;
  /** How Cara should handle coi tasks */
  coi: VoiceAgentConfigurationTaskBehaviorCoi;
  /** How Cara should handle fnol tasks */
  fnol: VoiceAgentConfigurationTaskBehaviorFnol;
  /** How Cara should handle lpr tasks */
  lpr: VoiceAgentConfigurationTaskBehaviorLpr;
  /** The general instructions that Cara should use when handling other business lines */
  otherBusinessLinesGeneralInstructions: Scalars['String']['output'];
  /** The task instructions that Cara should use when handling other business lines */
  otherBusinessLinesTaskInstructions: Scalars['String']['output'];
  /** How Cara should handle quote tasks */
  quote: VoiceAgentConfigurationTaskBehaviorQuote;
  /** How Cara should handle service tasks */
  service: VoiceAgentConfigurationTaskBehaviorService;
};

/** The business line that Cara should handle */
export enum VoiceAgentConfigurationTaskBehaviorBusinessLine {
  /** Handle all business lines */
  All = 'ALL',
  /** Handle commercial business lines */
  Commercial = 'COMMERCIAL',
  /** Handle other business lines */
  Other = 'OTHER',
  /** Handle personal business lines */
  Personal = 'PERSONAL'
}

export type VoiceAgentConfigurationTaskBehaviorCoi = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI';
  /** The custom instructions that Cara should use when taking COI information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking COI information over the phone */
  enabled: Scalars['Boolean']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorCoiInput = {
  /** The custom instructions that Cara should use when taking COI information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking COI information over the phone */
  enabled: Scalars['Boolean']['input'];
};

export type VoiceAgentConfigurationTaskBehaviorFnol = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL';
  /** The auto insurance FNOL questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationTaskBehaviorFnolAuto;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationTaskBehaviorFnolCommercialLiability;
  /** The commercial property FNOL questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationTaskBehaviorFnolCommercialProperty;
  /** The custom instructions that Cara should use when taking FNOL information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking FNOL information over the phone */
  enabled: Scalars['Boolean']['output'];
  /** The workers compensation FNOL questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensation;
};

export type VoiceAgentConfigurationTaskBehaviorFnolAuto = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The auto FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolAutoInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The auto FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolAutoType {
  /** Identify the drivers of the vehicles involved. Get the drivers first and last name as well as any contact info */
  DriverIdentification = 'DRIVER_IDENTIFICATION',
  /** Identify if anyone was hurt and if so who. Collect the first and last name of all those injured and any contact information */
  InjuryIdentification = 'INJURY_IDENTIFICATION',
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and what caused the loss */
  LossDescription = 'LOSS_DESCRIPTION',
  /** Collect the location the loss occurred including the street address, town, state, and zip if available */
  LossLocation = 'LOSS_LOCATION',
  /** Ask for a police report number and for them to send a copy in via email if possible */
  PoliceReportRequest = 'POLICE_REPORT_REQUEST',
  /** Identify how many cars or other pieces of property were damaged. Collect the VINs for damaged vehicles if possible */
  VehicleDamageAssessment = 'VEHICLE_DAMAGE_ASSESSMENT',
  /** Collect the make, model, plate number, and year of the vehicles if VIN is not available */
  VehicleDetailsIfNoVin = 'VEHICLE_DETAILS_IF_NO_VIN'
}

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialLiability = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType {
  /** Collect the name and available contact information of the injured parties */
  InjuredPartiesInfo = 'INJURED_PARTIES_INFO',
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and who was injured or what property was damaged */
  LossDescription = 'LOSS_DESCRIPTION',
  /** Location that the loss occurred including the street address, city or town, state, and zip */
  LossLocation = 'LOSS_LOCATION',
  /** For other liability types, confirm what material or action from the insured is involved */
  OtherLiabilityMaterialOrAction = 'OTHER_LIABILITY_MATERIAL_OR_ACTION',
  /** If there is a police report, collect the report number if available */
  PoliceReportNumber = 'POLICE_REPORT_NUMBER',
  /** Determine if the loss was premise liability and confirm ownership/tenant status */
  PremiseLiabilityOwnership = 'PREMISE_LIABILITY_OWNERSHIP',
  /** For product liability, collect the products involved in the incident */
  ProductLiabilityProducts = 'PRODUCT_LIABILITY_PRODUCTS',
  /** For product liability, confirm if the insured is the manufacturer, importer, brand owner, or vendor */
  ProductLiabilityRole = 'PRODUCT_LIABILITY_ROLE',
  /** Collect the name and available contact info for any witnesses */
  WitnessesInfo = 'WITNESSES_INFO'
}

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialProperty = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The commercial property FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The commercial property FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType {
  /** Collect the date the loss occurred */
  LossDate = 'LOSS_DATE',
  /** Take a description of the loss meaning what happened and what caused the loss. The cause of loss includes: fire, theft, lightning, hail, water, or wind */
  LossDescriptionAndCause = 'LOSS_DESCRIPTION_AND_CAUSE',
  /** Collect the location the loss occurred including the street address, town, state, and zip */
  LossLocation = 'LOSS_LOCATION',
  /** Ask for a police report number if available and for them to send a copy in via email */
  PoliceReportRequest = 'POLICE_REPORT_REQUEST',
  /** If there was damage to a structure, confirm if they are still able to use the property or if they need to temporarily move offsite */
  PropertyUsability = 'PROPERTY_USABILITY'
}

export type VoiceAgentConfigurationTaskBehaviorFnolInput = {
  /** The auto insurance FNOL questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationTaskBehaviorFnolAutoInput;
  /** The commercial liability FNOL questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityInput;
  /** The commercial property FNOL questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyInput;
  /** The custom instructions that Cara should use when taking FNOL information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking FNOL information over the phone */
  enabled: Scalars['Boolean']['input'];
  /** The workers compensation FNOL questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationInput;
};

export type VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensation = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation';
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The workers compensation FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>;
};

export type VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationInput = {
  /** The custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The workers compensation FNOL questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>;
};

export enum VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType {
  /** Confirm employer federal employer identification number (FEIN). This is also known as the business tax ID. */
  ConfirmFein = 'CONFIRM_FEIN',
  /** Employee address, phone, and email if available */
  EmployeeContactInfo = 'EMPLOYEE_CONTACT_INFO',
  /** Employee date of birth */
  EmployeeDateOfBirth = 'EMPLOYEE_DATE_OF_BIRTH',
  /** Employee number of dependents if available */
  EmployeeDependents = 'EMPLOYEE_DEPENDENTS',
  /** Employee date of hire and if they are still employed by the business */
  EmployeeHireDateAndStatus = 'EMPLOYEE_HIRE_DATE_AND_STATUS',
  /** Employee job title or occupation in the business */
  EmployeeJobTitle = 'EMPLOYEE_JOB_TITLE',
  /** Employee marital status if available */
  EmployeeMaritalStatus = 'EMPLOYEE_MARITAL_STATUS',
  /** Employee first name and last name */
  EmployeeName = 'EMPLOYEE_NAME',
  /** Average weekly wages for the employee */
  EmployeeWeeklyWages = 'EMPLOYEE_WEEKLY_WAGES',
  /** Collect a description of how the injury occurred. Ask clarifying questions to completely understand the situation. Ask at least two clarifying questions. */
  InjuryDescription = 'INJURY_DESCRIPTION',
  /** If available, collect OSHA case number or injury reporting number */
  OshaCaseNumber = 'OSHA_CASE_NUMBER'
}

export type VoiceAgentConfigurationTaskBehaviorInput = {
  /** The business lines that Cara should handle */
  businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine;
  /** How Cara should handle coi tasks */
  coi: VoiceAgentConfigurationTaskBehaviorCoiInput;
  /** How Cara should handle fnol tasks */
  fnol: VoiceAgentConfigurationTaskBehaviorFnolInput;
  /** How Cara should handle lpr tasks */
  lpr: VoiceAgentConfigurationTaskBehaviorLprInput;
  /** How Cara should handle quote tasks */
  quote: VoiceAgentConfigurationTaskBehaviorQuoteInput;
  /** How Cara should handle service tasks */
  service: VoiceAgentConfigurationTaskBehaviorServiceInput;
};

export type VoiceAgentConfigurationTaskBehaviorLpr = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR';
  /** The custom instructions that Cara should use when taking LPR information over the phone */
  customInstructions: Scalars['String']['output'];
  /** Whether Cara should handle taking LPR (Loss Prevention Review) information over the phone */
  enabled: Scalars['Boolean']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorLprInput = {
  /** The custom instructions that Cara should use when taking LPR information over the phone */
  customInstructions: Scalars['String']['input'];
  /** Whether Cara should handle taking LPR (Loss Prevention Review) information over the phone */
  enabled: Scalars['Boolean']['input'];
};

export type VoiceAgentConfigurationTaskBehaviorQuote = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote';
  /** The common non-commercial questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationQuestionsAuto;
  /** The common commercial questions that Cara should ask the caller */
  commercialCommon: VoiceAgentConfigurationQuestionsCommercialCommon;
  /** The commercial liability questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationQuestionsCommercialLiability;
  /** The commercial property questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationQuestionsCommercialProperty;
  /** The custom questions that Cara should ask the caller */
  custom: Array<VoiceAgentConfigurationQuestionsCustomQuote>;
  /** Whether Cara should handle quote tasks */
  enabled: Scalars['Boolean']['output'];
  /** The qualification questions that Cara should ask the caller */
  qualification: VoiceAgentConfigurationQuestionsQualification;
  /** The common non-commercial questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationQuestionsWorkersCompensation;
};

export type VoiceAgentConfigurationTaskBehaviorQuoteInput = {
  /** The common non-commercial questions that Cara should ask the caller */
  auto: VoiceAgentConfigurationQuestionsAutoInput;
  /** The common commercial questions that Cara should ask the caller */
  commercialCommon: VoiceAgentConfigurationQuestionsCommercialCommonInput;
  /** The commercial liability questions that Cara should ask the caller */
  commercialLiability: VoiceAgentConfigurationQuestionsCommercialLiabilityInput;
  /** The commercial property questions that Cara should ask the caller */
  commercialProperty: VoiceAgentConfigurationQuestionsCommercialPropertyInput;
  /** The custom questions that Cara should ask the caller */
  custom: Array<VoiceAgentConfigurationQuestionsCustomQuoteInput>;
  /** Whether Cara should handle quote tasks */
  enabled: Scalars['Boolean']['input'];
  /** The qualification questions that Cara should ask the caller */
  qualification: VoiceAgentConfigurationQuestionsQualificationInput;
  /** The common non-commercial questions that Cara should ask the caller */
  workersCompensation: VoiceAgentConfigurationQuestionsWorkersCompensationInput;
};

export type VoiceAgentConfigurationTaskBehaviorService = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorService';
  /** Whether Cara should handle add driver tasks */
  addDriver: VoiceAgentConfigurationTaskBehaviorServiceAddDriver;
  /** Whether Cara should handle add location tasks */
  addLocation: VoiceAgentConfigurationTaskBehaviorServiceAddLocation;
  /** Whether Cara should handle add vehicle tasks */
  addVehicle: VoiceAgentConfigurationTaskBehaviorServiceAddVehicle;
  /** Whether Cara should handle service tasks */
  enabled: Scalars['Boolean']['output'];
  /** The custom service requests that Cara should handle */
  other: Scalars['String']['output'];
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddDriver = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-driver service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddDriverInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-driver service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>;
};

/** The questions Cara should ask when adding a driver to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddDriverType {
  /** New driver's date of birth */
  DriverDateOfBirth = 'DRIVER_DATE_OF_BIRTH',
  /** New driver's gender */
  DriverGender = 'DRIVER_GENDER',
  /** The driver's license number for each new driver if available. If collected, repeat back the number to confirm understanding and do not ask another question until the caller responds */
  DriverLicenseNumber = 'DRIVER_LICENSE_NUMBER',
  /** New driver's first and last name */
  DriverName = 'DRIVER_NAME'
}

export type VoiceAgentConfigurationTaskBehaviorServiceAddLocation = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-location service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddLocationInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-location service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>;
};

/** The questions Cara should ask when adding a location to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddLocationType {
  /** For commercial liability policies, the associated revenue for this new address (if any) */
  ClRevenueForLocation = 'CL_REVENUE_FOR_LOCATION',
  /** Coverage limits requested for this location */
  CoverageLimitsRequested = 'COVERAGE_LIMITS_REQUESTED',
  /** Any addresses to be removed, if any */
  LocationsToRemove = 'LOCATIONS_TO_REMOVE',
  /** Confirm whether the new location is owned or leased/rented */
  LocationOwnershipStatus = 'LOCATION_OWNERSHIP_STATUS',
  /** Full street address of the new location */
  NewLocationAddress = 'NEW_LOCATION_ADDRESS',
  /** Requested effective date for this change */
  RequestedEffectiveDate = 'REQUESTED_EFFECTIVE_DATE',
  /** For workers compensation policies, the associated payroll and employee count for this location */
  WcPayrollAndEmployeeCountForLocation = 'WC_PAYROLL_AND_EMPLOYEE_COUNT_FOR_LOCATION'
}

export type VoiceAgentConfigurationTaskBehaviorServiceAddVehicle = {
  __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle';
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['output']>;
  /** The add-vehicle service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>;
};

export type VoiceAgentConfigurationTaskBehaviorServiceAddVehicleInput = {
  /** Additional custom questions that Cara should ask the caller */
  customQuestions: Array<Scalars['String']['input']>;
  /** The add-vehicle service questions that Cara should ask the caller */
  questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>;
};

/** The questions Cara should ask when adding a vehicle to a policy */
export enum VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType {
  /** Whether comprehensive and collision coverage is desired in addition to liability coverage */
  DesiredCoveragesComprehensiveAndCollision = 'DESIRED_COVERAGES_COMPREHENSIVE_AND_COLLISION',
  /** Any driver or vehicle changes related to this request (e.g., new drivers to add or vehicles to remove). If adding a new driver, collect the appropriate information for that as well */
  DriverOrVehicleChanges = 'DRIVER_OR_VEHICLE_CHANGES',
  /** The estimated annual mileage for this vehicle */
  EstimatedAnnualMileage = 'ESTIMATED_ANNUAL_MILEAGE',
  /** The VIN (vehicle identification number) or the year, make, model, and trim of the vehicle */
  VinOrVehicleDetails = 'VIN_OR_VEHICLE_DETAILS'
}

export type VoiceAgentConfigurationTaskBehaviorServiceInput = {
  /** Whether Cara should handle add driver tasks */
  addDriver: VoiceAgentConfigurationTaskBehaviorServiceAddDriverInput;
  /** Whether Cara should handle add location tasks */
  addLocation: VoiceAgentConfigurationTaskBehaviorServiceAddLocationInput;
  /** Whether Cara should handle add vehicle tasks */
  addVehicle: VoiceAgentConfigurationTaskBehaviorServiceAddVehicleInput;
  /** Whether Cara should handle service tasks */
  enabled: Scalars['Boolean']['input'];
  /** The custom service requests that Cara should handle */
  other: Scalars['String']['input'];
};

/** The transfer configuration for the voice agent */
export type VoiceAgentConfigurationTransfer = {
  __typename?: 'VoiceAgentConfigurationTransfer';
  /** The behavior of how Cara transfers calls, if different from the default behavior (default IMMEDIATE) */
  behavior: VoiceAgentTransferBehavior;
  /** Whether to collect the purpose of the call from the caller prior to transferring the call */
  collectPurpose: Scalars['Boolean']['output'];
  /** The directory of phone numbers to transfer the call to */
  directory: Array<VoiceAgentConfigurationTransferDirectoryEntry>;
  /**
   * Whether Cara is allowed to transfer calls to external parties (carriers, lenders, etc.).
   * When false, external directory entries are ignored.
   */
  enableExternalTransfer: Scalars['Boolean']['output'];
  /** Whether to allow Cara to transfer calls to other numbers */
  enabled: Scalars['Boolean']['output'];
  /** Deprecated: mirrored from externalTransferBehavior on save. Use externalTransferBehavior instead. */
  externalTransferAllowInternalFallback: Scalars['Boolean']['output'];
  /**
   * How Cara routes between internal and external transfer directories when external
   * transfer is enabled. Unset stored values resolve to EXTERNAL_FIRST_INTERNAL_FALLBACK.
   */
  externalTransferBehavior: VoiceAgentExternalTransferBehavior;
  /**
   * Deprecated: use per-entry callTypes on external directory entries instead.
   * Retained for backward compatibility; no longer read by the transfer resolver or UI.
   */
  externalTransferCallTypes?: Maybe<Array<VoiceAgentTransferCallType>>;
  /** The number of times Cara should attempt to transfer the call to other numbers if the first attempt fails */
  fallbackAttempts: Scalars['Int']['output'];
  /** The transfer hours of the agency that Cara should use */
  hours: VoiceAgentConfigurationTransferHours;
  /** Built-in and agency-defined line-of-business values available for Voice 3.5 transfer routing. */
  lineOfBusinessCatalog: Array<VoiceAgentTransferLineOfBusiness>;
  /** How long to ring before hanging up in milliseconds ([5000, 30000] default 15000) */
  ringDurationMs: Scalars['Int']['output'];
  /** SIP mode for cold transfers only (default INVITE; REFER optional). Warm transfer always uses REFER and ignores this field. */
  sipTransferMode?: Maybe<VoiceAgentSipTransferMode>;
  /** Scheduled time off periods when transfers should be disabled */
  timeOffSchedules: Array<VoiceAgentConfigurationTransferTimeOffSchedule>;
  /**
   * How Cara should time transfers for cancellation / lost policy release calls (CANCELLATION).
   * Emitted to Retell as LPR_FIRST_TRANSFER.
   */
  transferBehaviorCancellation: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for certificate of insurance calls (COI). */
  transferBehaviorCoi: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for FNOL and claims calls (CLAIMS). */
  transferBehaviorFnol: VoiceAgentTransferBehavior;
  /**
   * How Cara should time transfers for new quote calls (Retell requested_call_type NEW_BUSINESS).
   * Applies when the new cold transfer flow is on, in addition to the global Transfer Behavior setting.
   */
  transferBehaviorQuote: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for billing and policy service calls (BILLING, OTHER_SERVICING). */
  transferBehaviorService: VoiceAgentTransferBehavior;
  /** Message Cara speaks before transferring the call. Empty uses the product default. */
  transferMessage: Scalars['String']['output'];
  /**
   * How Cara performs transfers (COLD, WARM, or AGENTIC). Maps to Retell TRANSFER_TYPE at runtime.
   * Default COLD.
   */
  transferType: VoiceAgentTransferType;
  /**
   * When transfers are enabled and warm transfer is off, use the newer Retell cold-transfer conversation flow
   * (round-robin and updated transfer tooling). When false, use the legacy cold-transfer flow. Ignored when warm transfer is on.
   */
  useNewColdTransferConversationFlow: Scalars['Boolean']['output'];
  /**
   * Whether to introduce the caller and the purpose of the call to the human agent when transferring the call.
   * Deprecated: prefer transferType. Kept in sync on save for backward compatibility.
   */
  warmTransfer: Scalars['Boolean']['output'];
};

/** A directory entry for the voice agent's transfer configuration */
export type VoiceAgentConfigurationTransferDirectoryEntry = {
  __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry';
  /**
   * Known alternate names, nicknames, or common mispronunciations for this entry.
   * Used to improve name matching accuracy.
   */
  aliases?: Maybe<Array<Scalars['String']['output']>>;
  /** The call types this entry is eligible for. An empty list means eligible for all call types. */
  callTypes?: Maybe<Array<VoiceAgentTransferCallType>>;
  /**
   * The department for this entry (e.g. "Liability", "Claims").
   * When set, all entries sharing the same department token score equally, enabling round-robin.
   * At least one of name or department must be set for new entries; legacy entries use label only.
   */
  department?: Maybe<Scalars['String']['output']>;
  /**
   * Whether this entry is an internal agency contact or an external party.
   * External entries are excluded from call types that restrict external routing (e.g. new business quotes).
   */
  entryType?: Maybe<VoiceAgentTransferDirectoryEntryType>;
  /** The extension to dial after connecting (optional) */
  extension?: Maybe<Scalars['String']['output']>;
  /** The label of the directory entry (name, department, etc.) */
  label: Scalars['String']['output'];
  /** Lines of business this entry handles. An empty list means eligible for every line of business. */
  lineOfBusinessIds: Array<Scalars['String']['output']>;
  /**
   * The person's name for this entry (e.g. "Joe Becker" for internal, "State Farm" for external).
   * When set, used for person-specific matching. At least one of name or department must be set
   * for new entries; legacy entries use label only. For external entries, use the carrier or vendor
   * name as shown in the AMS (often surfaced by lookup_customer at call start).
   */
  name?: Maybe<Scalars['String']['output']>;
  /** The phone number to transfer the call to */
  number: Scalars['String']['output'];
  /**
   * Servicing-person code for this directory entry (e.g. CSR in AMS360, agent code in HawkSoft).
   * When provided, an exact match against the caller's servicing code from lookup_customer
   * (or phone-based KG lookup) takes highest priority for transfer routing.
   */
  servicingCode?: Maybe<Scalars['String']['output']>;
  /** The criteria to give Cara to decide if she should transfer the call to this directory entry */
  transferCriteria: Scalars['String']['output'];
};

export type VoiceAgentConfigurationTransferDirectoryEntryInput = {
  /**
   * Known alternate names, nicknames, or common mispronunciations for this entry.
   * Used to improve name matching accuracy.
   */
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The call types this entry is eligible for. An empty list means eligible for all call types. */
  callTypes?: InputMaybe<Array<VoiceAgentTransferCallType>>;
  /**
   * The department for this entry (e.g. "Liability", "Claims").
   * When set, all entries sharing the same department token score equally, enabling round-robin.
   * At least one of name or department must be set for new entries; legacy entries use label only.
   */
  department?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether this entry is an internal agency contact or an external party.
   * External entries are excluded from call types that restrict external routing (e.g. new business quotes).
   */
  entryType?: InputMaybe<VoiceAgentTransferDirectoryEntryType>;
  /** The extension to dial after connecting (optional) */
  extension?: InputMaybe<Scalars['String']['input']>;
  /** The label of the directory entry (name, department, etc.) */
  label: Scalars['String']['input'];
  /**
   * Lines of business this entry handles. Omit during an update to preserve existing selections;
   * an empty list clears restrictions and makes the entry eligible for every line of business.
   */
  lineOfBusinessIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * The person's name for this entry (e.g. "Joe Becker" for internal, "State Farm" for external).
   * When set, used for person-specific matching. At least one of name or department must be set
   * for new entries; legacy entries use label only. For external entries, use the carrier or vendor
   * name as shown in the AMS (often surfaced by lookup_customer at call start).
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The phone number to transfer the call to */
  number: Scalars['String']['input'];
  /**
   * Servicing-person code for this directory entry (e.g. CSR in AMS360, agent code in HawkSoft).
   * When provided, an exact match against the caller's servicing code from lookup_customer
   * (or phone-based KG lookup) takes highest priority for transfer routing.
   */
  servicingCode?: InputMaybe<Scalars['String']['input']>;
  /** The criteria to give Cara to decide if she should transfer the call to this directory entry */
  transferCriteria: Scalars['String']['input'];
};

export type VoiceAgentConfigurationTransferHours = {
  __typename?: 'VoiceAgentConfigurationTransferHours';
  friday: VoiceAgentConfigurationTransferHoursDay;
  /** The hours to enable tranfer for each day of the week */
  monday: VoiceAgentConfigurationTransferHoursDay;
  saturday: VoiceAgentConfigurationTransferHoursDay;
  sunday: VoiceAgentConfigurationTransferHoursDay;
  thursday: VoiceAgentConfigurationTransferHoursDay;
  /** The timezone that Cara should use to calculate transfer hours */
  timezone: Scalars['String']['output'];
  tuesday: VoiceAgentConfigurationTransferHoursDay;
  wednesday: VoiceAgentConfigurationTransferHoursDay;
};

export type VoiceAgentConfigurationTransferHoursDay = {
  __typename?: 'VoiceAgentConfigurationTransferHoursDay';
  /** Whether transfer is enabled for this day */
  enabled: Scalars['Boolean']['output'];
  /** The end hour of the business day */
  endHour: Scalars['Int']['output'];
  /** The end minute of the business day */
  endMinute: Scalars['Int']['output'];
  /** The start time of the business day */
  startHour: Scalars['Int']['output'];
  /** The start minute of the business day */
  startMinute: Scalars['Int']['output'];
};

export type VoiceAgentConfigurationTransferHoursDayInput = {
  /** Whether transfer is enabled for this day */
  enabled: Scalars['Boolean']['input'];
  /** The end hour of the business day */
  endHour: Scalars['Int']['input'];
  /** The end minute of the business day */
  endMinute: Scalars['Int']['input'];
  /** The start time of the business day */
  startHour: Scalars['Int']['input'];
  /** The start minute of the business day */
  startMinute: Scalars['Int']['input'];
};

export type VoiceAgentConfigurationTransferHoursInput = {
  friday: VoiceAgentConfigurationTransferHoursDayInput;
  /** The hours to enable tranfer for each day of the week */
  monday: VoiceAgentConfigurationTransferHoursDayInput;
  saturday: VoiceAgentConfigurationTransferHoursDayInput;
  sunday: VoiceAgentConfigurationTransferHoursDayInput;
  thursday: VoiceAgentConfigurationTransferHoursDayInput;
  /** The timezone that Cara should use to calculate transfer hours */
  timezone: Scalars['String']['input'];
  tuesday: VoiceAgentConfigurationTransferHoursDayInput;
  wednesday: VoiceAgentConfigurationTransferHoursDayInput;
};

export type VoiceAgentConfigurationTransferInput = {
  /** The behavior of how Cara transfers calls, if different from the default behavior (default IMMEDIATE) */
  behavior: VoiceAgentTransferBehavior;
  /** Whether to collect the purpose of the call from the caller prior to transferring the call */
  collectPurpose: Scalars['Boolean']['input'];
  /** The directory of phone numbers to transfer the call to */
  directory: Array<VoiceAgentConfigurationTransferDirectoryEntryInput>;
  /**
   * Whether Cara is allowed to transfer calls to external parties (carriers, lenders, etc.).
   * When false, external directory entries are ignored.
   */
  enableExternalTransfer: Scalars['Boolean']['input'];
  /** Whether to allow Cara to transfer calls to other numbers */
  enabled: Scalars['Boolean']['input'];
  /** Deprecated: omitted on save; mirrored from externalTransferBehavior by the API. */
  externalTransferAllowInternalFallback?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * How Cara routes between internal and external transfer directories when external
   * transfer is enabled. When omitted on save, the server keeps the existing value or
   * defaults to EXTERNAL_FIRST_INTERNAL_FALLBACK for new agents.
   */
  externalTransferBehavior?: InputMaybe<VoiceAgentExternalTransferBehavior>;
  /**
   * Deprecated: use per-entry callTypes on external directory entries instead.
   * Retained for backward compatibility; no longer read by the transfer resolver or UI.
   */
  externalTransferCallTypes?: InputMaybe<Array<VoiceAgentTransferCallType>>;
  /** The number of times Cara should attempt to transfer the call to other numbers if the first attempt fails */
  fallbackAttempts: Scalars['Int']['input'];
  /** The transfer hours of the agency that Cara should use */
  hours: VoiceAgentConfigurationTransferHoursInput;
  /**
   * Built-in and agency-defined line-of-business values available for Voice 3.5 transfer routing.
   * Omit during an update to preserve the existing catalog. For Voice 3.5, an empty list resets
   * the catalog to the built-in values.
   */
  lineOfBusinessCatalog?: InputMaybe<Array<VoiceAgentTransferLineOfBusinessInput>>;
  /** How long to ring before hanging up in milliseconds ([5000, 30000] default 15000) */
  ringDurationMs: Scalars['Int']['input'];
  /** SIP mode for cold transfers only (default INVITE; REFER optional). Warm transfer always uses REFER and ignores this field. */
  sipTransferMode?: InputMaybe<VoiceAgentSipTransferMode>;
  /** Scheduled time off periods when transfers should be disabled */
  timeOffSchedules?: InputMaybe<Array<VoiceAgentConfigurationTransferTimeOffScheduleInput>>;
  /**
   * How Cara should time transfers for cancellation / lost policy release calls (CANCELLATION).
   * Emitted to Retell as LPR_FIRST_TRANSFER.
   */
  transferBehaviorCancellation: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for certificate of insurance calls (COI). */
  transferBehaviorCoi: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for FNOL and claims calls (CLAIMS). */
  transferBehaviorFnol: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for new quote calls (Retell requested_call_type NEW_BUSINESS). */
  transferBehaviorQuote: VoiceAgentTransferBehavior;
  /** How Cara should time transfers for billing and policy service calls (BILLING, OTHER_SERVICING). */
  transferBehaviorService: VoiceAgentTransferBehavior;
  /** Message Cara speaks before transferring the call. Empty uses the product default. */
  transferMessage: Scalars['String']['input'];
  /** How Cara performs transfers (COLD, WARM, or AGENTIC). Maps to Retell TRANSFER_TYPE at runtime. */
  transferType: VoiceAgentTransferType;
  /**
   * When transfers are enabled and warm transfer is off, use the newer Retell cold-transfer conversation flow
   * (round-robin and updated transfer tooling). When false, use the legacy cold-transfer flow. Ignored when warm transfer is on.
   * Omit to leave the saved value unchanged on update (backward compatible for older API clients).
   */
  useNewColdTransferConversationFlow?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to introduce the caller and the purpose of the call to the human agent when transferring the call.
   * Deprecated: prefer transferType. Kept in sync on save for backward compatibility.
   */
  warmTransfer: Scalars['Boolean']['input'];
};

/** Configuration for a DAILY_BREAKS schedule (recurring weekly - pick days of the week, e.g., every Monday) */
export type VoiceAgentConfigurationTransferTimeOffDailyBreak = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak';
  /** Days of the week for DAILY_BREAKS schedules. Allows multiple days. Recurring weekly (e.g., every Monday, every Tuesday). */
  daysOfWeek: Array<DayOfWeek>;
  /** The end hour of the time off period (0-23) */
  endHour: Scalars['Int']['output'];
  /** The end minute of the time off period (0-59) */
  endMinute: Scalars['Int']['output'];
  /** The start hour of the time off period (0-23) */
  startHour: Scalars['Int']['output'];
  /** The start minute of the time off period (0-59) */
  startMinute: Scalars['Int']['output'];
};

/** Input for a DAILY_BREAKS schedule configuration (recurring weekly - pick days) */
export type VoiceAgentConfigurationTransferTimeOffDailyBreakInput = {
  /** Days of the week for DAILY_BREAKS schedules. Allows multiple days. Recurring weekly (e.g., every Monday, every Tuesday). */
  daysOfWeek: Array<DayOfWeek>;
  /** The end hour of the time off period (0-23) */
  endHour: Scalars['Int']['input'];
  /** The end minute of the time off period (0-59) */
  endMinute: Scalars['Int']['input'];
  /** The start hour of the time off period (0-23) */
  startHour: Scalars['Int']['input'];
  /** The start minute of the time off period (0-59) */
  startMinute: Scalars['Int']['input'];
};

/** A time off schedule for disabling transfers during specific times or dates */
export type VoiceAgentConfigurationTransferTimeOffSchedule = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule';
  /** Additional instructions to append to global custom instructions during this scheduled time off period */
  additionalInstructions?: Maybe<Scalars['String']['output']>;
  /** Custom introduction phrase to use during this scheduled time off period */
  customIntro?: Maybe<Scalars['String']['output']>;
  /** Configuration for DAILY_BREAKS schedules. Only populated when type is DAILY_BREAKS. */
  dailyBreak?: Maybe<VoiceAgentConfigurationTransferTimeOffDailyBreak>;
  /** Unique identifier for this schedule */
  id: Scalars['String']['output'];
  /** Optional name/description for the schedule (e.g., "Lunch Break", "Christmas Holiday") */
  name?: Maybe<Scalars['String']['output']>;
  /** Configuration for SCHEDULED_CLOSURES schedules. Only populated when type is SCHEDULED_CLOSURES. */
  scheduledClosure?: Maybe<VoiceAgentConfigurationTransferTimeOffScheduledClosure>;
  /** The type of schedule: DAILY_BREAKS for recurring weekly schedules (pick days, e.g., every Monday), SCHEDULED_CLOSURES for specific dates */
  type: VoiceAgentTransferTimeOffScheduleType;
};

/** Input for a time off schedule */
export type VoiceAgentConfigurationTransferTimeOffScheduleInput = {
  /** Additional instructions to append to global custom instructions during this scheduled time off period */
  additionalInstructions?: InputMaybe<Scalars['String']['input']>;
  /** Custom introduction phrase to use during this scheduled time off period */
  customIntro?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for DAILY_BREAKS schedules. Only used when type is DAILY_BREAKS. */
  dailyBreak?: InputMaybe<VoiceAgentConfigurationTransferTimeOffDailyBreakInput>;
  /** Unique identifier for this schedule. If not provided, a new schedule will be created. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Optional name/description for this schedule */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Configuration for SCHEDULED_CLOSURES schedules. Only used when type is SCHEDULED_CLOSURES. */
  scheduledClosure?: InputMaybe<VoiceAgentConfigurationTransferTimeOffScheduledClosureInput>;
  /** The type of schedule: DAILY_BREAKS for recurring weekly schedules (pick days, e.g., every Monday), SCHEDULED_CLOSURES for specific dates. Optional - if not provided, schedule fields will be hidden. */
  type?: InputMaybe<VoiceAgentTransferTimeOffScheduleType>;
};

/** Configuration for a SCHEDULED_CLOSURES schedule (specific date or date range) */
export type VoiceAgentConfigurationTransferTimeOffScheduledClosure = {
  __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure';
  /** Start date for the closure (YYYY-MM-DD format) */
  date: Scalars['String']['output'];
  /** End date for the closure (YYYY-MM-DD format). Optional for single-day schedules. */
  endDate?: Maybe<Scalars['String']['output']>;
};

/** Input for a SCHEDULED_CLOSURES schedule configuration */
export type VoiceAgentConfigurationTransferTimeOffScheduledClosureInput = {
  /** Start date for the closure (YYYY-MM-DD format) */
  date: Scalars['String']['input'];
  /** End date for the closure (YYYY-MM-DD format). Optional for single-day schedules. */
  endDate?: InputMaybe<Scalars['String']['input']>;
};

/** The call direction handled by a voice agent */
export enum VoiceAgentDirection {
  /** The agent receives inbound calls on its phone number */
  Inbound = 'INBOUND',
  /** The agent places outbound notification calls to customers */
  Outbound = 'OUTBOUND'
}

/** How Cara routes between internal and external transfer directories. */
export enum VoiceAgentExternalTransferBehavior {
  /**
   * Score internal and external entries together; try external at lower confidence from
   * KG carrier data before internal round-robin.
   */
  BestMatch = 'BEST_MATCH',
  /**
   * Try external directory first when routing_scope is EXTERNAL; fall back to internal
   * when external matching fails or the external number does not answer.
   */
  ExternalFirstInternalFallback = 'EXTERNAL_FIRST_INTERNAL_FALLBACK',
  /** Only route to external directory entries; return NONE when no confident external match. */
  ExternalOnly = 'EXTERNAL_ONLY'
}

export type VoiceAgentInput = {
  /** The voice agent configuration */
  configuration: VoiceAgentConfigurationInput;
  /** The name of the voice agent */
  name: Scalars['String']['input'];
};

/** The language of a voice agent */
export enum VoiceAgentLanguage {
  /** Afrikaans (South Africa) */
  AfZa = 'AF_ZA',
  /** Arabic (Saudi Arabia) */
  ArSa = 'AR_SA',
  /** Bulgarian (Bulgaria) */
  BgBg = 'BG_BG',
  /** Catalan (Spain) */
  CaEs = 'CA_ES',
  /** Czech (Czech Republic) */
  CsCz = 'CS_CZ',
  /** Danish (Denmark) */
  DaDk = 'DA_DK',
  /** German (Germany) */
  DeDe = 'DE_DE',
  /** Greek (Greece) */
  ElGr = 'EL_GR',
  /** English (Australia) */
  EnAu = 'EN_AU',
  /** English (United Kingdom) */
  EnGb = 'EN_GB',
  /** English (India) */
  EnIn = 'EN_IN',
  /** English (New Zealand) */
  EnNz = 'EN_NZ',
  /** English (United States) */
  EnUs = 'EN_US',
  /** Spanish (Latin America) */
  Es_419 = 'ES_419',
  /** Spanish (Spain) */
  EsEs = 'ES_ES',
  /** Persian (Iran) */
  FaIr = 'FA_IR',
  /** Filipino (Philippines) */
  FilPh = 'FIL_PH',
  /** Finnish (Finland) */
  FiFi = 'FI_FI',
  /** French (Canada) */
  FrCa = 'FR_CA',
  /** French (France) */
  FrFr = 'FR_FR',
  /** Hebrew (Israel) */
  HeIl = 'HE_IL',
  /** Hindi (India) */
  HiIn = 'HI_IN',
  /** Croatian (Croatia) */
  HrHr = 'HR_HR',
  /** Hungarian (Hungary) */
  HuHu = 'HU_HU',
  /** Indonesian (Indonesia) */
  IdId = 'ID_ID',
  /** Italian (Italy) */
  ItIt = 'IT_IT',
  /** Japanese (Japan) */
  JaJp = 'JA_JP',
  /** Kannada (India) */
  KnIn = 'KN_IN',
  /** Korean (Korea) */
  KoKr = 'KO_KR',
  /** Marathi (India) */
  MrIn = 'MR_IN',
  /** Malay (Malaysia) */
  MsMy = 'MS_MY',
  /**
   * Legacy multi-language token (Spanish and English). Wire-only for cached
   * clients; never stored and never sent to Retell.
   * @deprecated Use an explicit languages list instead. MULTI is accepted on legacy language input only during the migration window.
   */
  Multi = 'MULTI',
  /** Dutch (Belgium) */
  NlBe = 'NL_BE',
  /** Dutch (Netherlands) */
  NlNl = 'NL_NL',
  /** Norwegian (Norway) */
  NoNo = 'NO_NO',
  /** Polish (Poland) */
  PlPl = 'PL_PL',
  /** Portuguese (Brazil) */
  PtBr = 'PT_BR',
  /** Portuguese (Portugal) */
  PtPt = 'PT_PT',
  /** Romanian (Romania) */
  RoRo = 'RO_RO',
  /** Russian (Russia) */
  RuRu = 'RU_RU',
  /** Slovak (Slovakia) */
  SkSk = 'SK_SK',
  /** Slovenian (Slovenia) */
  SlSi = 'SL_SI',
  /** Swedish (Sweden) */
  SvSe = 'SV_SE',
  /** Tamil (India) */
  TaIn = 'TA_IN',
  /** Thai (Thailand) */
  ThTh = 'TH_TH',
  /** Turkish (Turkey) */
  TrTr = 'TR_TR',
  /** Ukrainian (Ukraine) */
  UkUa = 'UK_UA',
  /** Vietnamese (Vietnam) */
  ViVn = 'VI_VN',
  /** Cantonese (China) */
  YueCn = 'YUE_CN',
  /** Chinese (China) */
  ZhCn = 'ZH_CN'
}

/** Provider and language capabilities used to keep voice-agent settings valid. */
export type VoiceAgentLanguageSupport = {
  __typename?: 'VoiceAgentLanguageSupport';
  /**
   * English locales. Selecting only these does not yet narrow the language picker;
   * the agent still routes to Cartesia.
   */
  englishLanguages: Array<VoiceAgentLanguage>;
  providers: Array<VoiceProviderLanguageSupport>;
  voices: Array<VoiceAgentVoiceProviderSupport>;
};

/** SIP signaling for cold transfers. INVITE (default) or REFER. Warm transfers always use REFER. */
export enum VoiceAgentSipTransferMode {
  /** SIP INVITE (most common) */
  Invite = 'INVITE',
  /** SIP REFER */
  Refer = 'REFER'
}

/** Who starts the conversation - the AI agent or the user */
export enum VoiceAgentStartSpeaker {
  /** The AI agent speaks first */
  Agent = 'AGENT',
  /** The AI agent waits for the user to speak first */
  User = 'USER'
}

/** The state of a voice agent */
export enum VoiceAgentState {
  /** The voice agent is online and ready to receive calls */
  Active = 'ACTIVE'
}

/** The behavior of how Cara transfers calls */
export enum VoiceAgentTransferBehavior {
  /** Cara will transfer the call after attempting to handle the caller's request */
  AttemptHandling = 'ATTEMPT_HANDLING',
  /** Cara will transfer the call immediately */
  Immediate = 'IMMEDIATE'
}

/** The call types that a transfer directory entry can handle */
export enum VoiceAgentTransferCallType {
  Billing = 'BILLING',
  Cancellation = 'CANCELLATION',
  Claims = 'CLAIMS',
  Coi = 'COI',
  NewBusiness = 'NEW_BUSINESS',
  OtherServicing = 'OTHER_SERVICING'
}

/** Whether a transfer directory entry is an internal agency contact or an external party */
export enum VoiceAgentTransferDirectoryEntryType {
  /** An external party (e.g., carrier, vendor) */
  External = 'EXTERNAL',
  /** An internal agency staff member (e.g., agent, CSR) */
  Internal = 'INTERNAL'
}

/** An agency-defined line of business used to classify and route Voice 3.5 transfers. */
export type VoiceAgentTransferLineOfBusiness = {
  __typename?: 'VoiceAgentTransferLineOfBusiness';
  /** Short semantic definition used by the Retell classifier. */
  description: Scalars['String']['output'];
  /** Example caller phrases that identify this line of business. */
  examples: Array<Scalars['String']['output']>;
  /** Stable identifier used by directory entries and round-robin pools. */
  id: Scalars['String']['output'];
  /** User-facing name shown in settings and supplied to the Retell classifier. */
  label: Scalars['String']['output'];
};

/** Input for an agency-defined Voice 3.5 transfer line of business. */
export type VoiceAgentTransferLineOfBusinessInput = {
  /** Short semantic definition used by the Retell classifier. */
  description: Scalars['String']['input'];
  /** Example caller phrases that identify this line of business. */
  examples: Array<Scalars['String']['input']>;
  /** Stable identifier used by directory entries and round-robin pools. */
  id: Scalars['String']['input'];
  /** User-facing name shown in settings and supplied to the Retell classifier. */
  label: Scalars['String']['input'];
};

export enum VoiceAgentTransferTimeOffScheduleType {
  /** Recurring weekly schedule - pick days of the week (e.g., every Monday, every Tuesday-Wednesday) */
  DailyBreaks = 'DAILY_BREAKS',
  /** Specific date or date range (e.g., holiday, one-time closure) */
  ScheduledClosures = 'SCHEDULED_CLOSURES'
}

/** How Cara performs call transfers (maps to Retell TRANSFER_TYPE at runtime). */
export enum VoiceAgentTransferType {
  Agentic = 'AGENTIC',
  Cold = 'COLD',
  Warm = 'WARM'
}

/** Describes the reason why a voice agent was updated */
export enum VoiceAgentUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occurred to a voice agent */
export enum VoiceAgentUpdateType {
  /** The voice agent was created */
  CreateVoiceAgent = 'CREATE_VOICE_AGENT',
  /** The voice agent was updated */
  UpdateVoiceAgent = 'UPDATE_VOICE_AGENT'
}

/** Describes a particular version of a voice agent */
export type VoiceAgentVersion = {
  __typename?: 'VoiceAgentVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another voice agent version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous voice agent version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<VoiceAgentVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<VoiceAgentUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<VoiceAgentUpdateType>;
  /** The version number of this voice agent version */
  version: Scalars['Int64']['output'];
  /** The full voice agent object that includes all of the updates made in this version and all previous versions */
  voiceAgent: VoiceAgent;
};

/** The primary provider and custom-voice flag for a selectable Cara voice. */
export type VoiceAgentVoiceProviderSupport = {
  __typename?: 'VoiceAgentVoiceProviderSupport';
  custom: Scalars['Boolean']['output'];
  provider: VoiceProvider;
  voice: VoiceAgentConfigurationModelVoice;
};

/** Filter for the voiceAgents list query */
export type VoiceAgentsFilterInput = {
  /** Restrict results to agents with this call direction */
  direction?: InputMaybe<VoiceAgentDirection>;
};

/** A Retell text-to-speech provider used by voice agents. */
export enum VoiceProvider {
  Cartesia = 'CARTESIA',
  ElevenLabs = 'ELEVEN_LABS',
  Minimax = 'MINIMAX',
  Platform = 'PLATFORM'
}

/**
 * The languages available to a text-to-speech provider, plus preference metadata
 * used by the language picker and voice router.
 */
export type VoiceProviderLanguageSupport = {
  __typename?: 'VoiceProviderLanguageSupport';
  /**
   * Default voice to coerce to when the selected voice is not offered by this
   * provider (Grace for Cartesia, MiniMax Grace for MiniMax, Grace for ElevenLabs).
   */
  defaultVoice: VoiceAgentConfigurationModelVoice;
  languages: Array<VoiceAgentLanguage>;
  /**
   * Languages that prefer this provider when the full selection is covered by it.
   * Empty for providers that are not preferred for any language.
   */
  preferredLanguages: Array<VoiceAgentLanguage>;
  provider: VoiceProvider;
};

/**
 * A Word (.docx) document template stored for the agency. Separate from HTML document templates:
 * metadata and the template file only (no HTML body, styles, or headers/footers).
 */
export type WordDocumentTemplate = {
  __typename?: 'WordDocumentTemplate';
  /** The agency this Word document template is associated with */
  agency: Agency;
  /** The timestamp when this Word document template was archived (soft deleted) */
  archivedAt?: Maybe<Scalars['Time']['output']>;
  /** The timestamp when this Word document template was created */
  createdAt: Scalars['Time']['output'];
  /** The user that created this Word document template */
  createdBy: AgencyUser;
  /** The description of the Word document template */
  description: Scalars['String']['output'];
  /** An error message describing why the template processing failed. Only set when state is FAILED. */
  error?: Maybe<Scalars['String']['output']>;
  /** Optional guidance for Cara when filling this template (included in workspace tool output for the model). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the Word document template */
  id: Scalars['ID']['output'];
  /** The sections of the Word document template */
  sections: Array<WordDocumentTemplateSection>;
  /** The processing status of the Word document template. */
  state?: Maybe<WordDocumentTemplateState>;
  /** The Word (DOCX) template file */
  templateFile?: Maybe<File>;
  /** The title of the Word document template */
  title: Scalars['String']['output'];
  /** The timestamp when this Word document template was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version of this Word document template */
  version: Scalars['Int64']['output'];
  /**
   * The previous versions of this Word document template. The first version in this list will be this version
   * (i.e. identical to the current Word document template), followed by the version before that, and so-forth.
   */
  versionHistory?: Maybe<Array<WordDocumentTemplateVersion>>;
  /**
   * The visibility configuration for this template (PRIVATE / SHARED / PUBLIC).
   * Lives on the parent row only — visibility is metadata, not part of the
   * versioned content. Defaults to PUBLIC for all rows on migration.
   */
  visibility: VisibilityConfig;
};

/**
 * Word document template info for agency library templates.
 * GET_CONTENT includes the DOCX file id and, when inspection succeeds, docxInspection (omitted on LIST).
 */
export type WordDocumentTemplateInfo = {
  __typename?: 'WordDocumentTemplateInfo';
  /** The timestamp when the template was created */
  createdAt: Scalars['Time']['output'];
  /** The user who created the template */
  createdBy: Scalars['String']['output'];
  /** The description of the template */
  description: Scalars['String']['output'];
  /** Optional operator guidance for filling this template (follow when present). */
  fillGuidance?: Maybe<Scalars['String']['output']>;
  /** The ID of the template */
  id: Scalars['String']['output'];
  /** The name of the template */
  name: Scalars['String']['output'];
  /** The sections of the template */
  sections: Array<WordDocumentTemplateSection>;
};

/** Input for creating or updating a Word document template */
export type WordDocumentTemplateInput = {
  /** The description of the Word document template */
  description: Scalars['String']['input'];
  /** Optional guidance for Cara when filling this template (shown when listing templates in workspace tools). */
  fillGuidance?: InputMaybe<Scalars['String']['input']>;
  /** The sections of the Word document template */
  sections: Array<WordDocumentTemplateSectionInput>;
  /**
   * The ID of the existing template file to keep on update. Omit when uploading a new file.
   * @deprecated Use the sections instead
   */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the Word document template */
  title: Scalars['String']['input'];
  /**
   * The DOCX file to upload (create, or replace on update)
   * @deprecated Use the sections instead
   */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
  /**
   * Optional visibility configuration. When omitted on create, the template
   * defaults to PUBLIC. When omitted on update, the existing visibility is
   * preserved.
   */
  visibility?: InputMaybe<VisibilityConfigInput>;
};

export type WordDocumentTemplateSection = {
  __typename?: 'WordDocumentTemplateSection';
  /** The data fields required to fill the section. These are extracted by the LLM in a pre-processing step. */
  fields: Array<WordDocumentTemplateSectionField>;
  /**
   * Description of the section's purpose and content, and any fill instructions to provide to the LLM. This is
   * extracted by the LLM in a pre-processing step.
   */
  fillGuidance: Scalars['String']['output'];
  /** The ID of the Word document template section */
  id: Scalars['ID']['output'];
  /** Indicates whether this section can be generated multiple times for the same document. */
  repeatable: Scalars['Boolean']['output'];
  /**
   * Indicates whether this section is required (i.e. must be included in every document generated
   * from this template). Optional sections may be omitted by the LLM based on the request context.
   */
  required: Scalars['Boolean']['output'];
  /**
   * Optional user-provided guidance supplied when the template is created/edited. It is fed to the LLM at
   * ingestion time to help it produce a more accurate fillGuidance for this section (e.g. clarifying which
   * placeholders matter, how rows repeat, or what boilerplate must be preserved).
   */
  setupGuidance?: Maybe<Scalars['String']['output']>;
  /** Indicates whether this section is static (i.e. not a dynamic section that is filled by the LLM) */
  static: Scalars['Boolean']['output'];
  /** The Word (DOCX) template file */
  templateFile: File;
  /** The title of this section */
  title: Scalars['String']['output'];
};

/** A data field present in a section to fill */
export type WordDocumentTemplateSectionField = {
  __typename?: 'WordDocumentTemplateSectionField';
  /** The fill guidance for the field */
  fillGuidance: Scalars['String']['output'];
  /** The name of the field */
  name: Scalars['String']['output'];
  /** The placeholder text for the corresponding fields */
  placeholder: Scalars['String']['output'];
};

/** Input for a section of a Word document template */
export type WordDocumentTemplateSectionInput = {
  /**
   * The ID of an existing section to update. Omit for newly added sections. When provided on
   * update, the backend matches this entry to the existing section with the same ID so that
   * pre-extracted metadata (fill guidance, fields) is preserved across reorders.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this section can be generated multiple times for the same document. */
  repeatable: Scalars['Boolean']['input'];
  /**
   * Indicates whether this section is required (i.e. must be included in every document generated
   * from this template). Optional sections may be omitted by the LLM based on the request context.
   */
  required: Scalars['Boolean']['input'];
  /**
   * Optional user-provided guidance fed to the LLM at ingestion time to help it produce a more accurate
   * fillGuidance for this section. Trimmed server-side; blank values are stored as null.
   */
  setupGuidance?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this section is static (i.e. not a dynamic section that is filled by the LLM) */
  static: Scalars['Boolean']['input'];
  /** The ID of the existing template file to keep on update. Omit when uploading a new file. */
  templateFileId?: InputMaybe<Scalars['String']['input']>;
  /** The title of the section */
  title: Scalars['String']['input'];
  /** The DOCX file to upload (create, or replace on update) */
  uploadTemplate?: InputMaybe<Scalars['Upload']['input']>;
};

/** The processing status of a Word document template. */
export enum WordDocumentTemplateState {
  /** The template processing failed. See the error field for details. */
  Failed = 'FAILED',
  /** The template is being processed. */
  Processing = 'PROCESSING',
  /** The template is queued for processing. */
  Queued = 'QUEUED',
  /** The template has been processed and is ready to fill. */
  Ready = 'READY'
}

/** Describes the reason why a Word document template was updated */
export enum WordDocumentTemplateUpdateReasonCode {
  /** Placeholder reason codes until the use case becomes more clear */
  Unknown = 'UNKNOWN'
}

/** Describes the type of update that occured to a Word document template */
export enum WordDocumentTemplateUpdateType {
  /** The Word document template was archived */
  ArchiveWordDocumentTemplate = 'ARCHIVE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was created */
  CreateWordDocumentTemplate = 'CREATE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template processing finished */
  FinishProcessingWordDocumentTemplate = 'FINISH_PROCESSING_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template processing was started */
  StartProcessingWordDocumentTemplate = 'START_PROCESSING_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was unarchived */
  UnarchiveWordDocumentTemplate = 'UNARCHIVE_WORD_DOCUMENT_TEMPLATE',
  /** The Word document template was updated */
  UpdateWordDocumentTemplate = 'UPDATE_WORD_DOCUMENT_TEMPLATE'
}

/** Describes a particular version of a Word document template */
export type WordDocumentTemplateVersion = {
  __typename?: 'WordDocumentTemplateVersion';
  /** The date this version was created */
  createdAt: Scalars['Time']['output'];
  /** Produces a human-readable string that can be used to diff against another Word document template version. */
  diffableJson: Scalars['String']['output'];
  /** The version number of the previous Word document template version, if there is any. If this field is null, then this version is the only version */
  previousVersion?: Maybe<WordDocumentTemplateVersion>;
  /** The ID of the entity that initiated the update, depending on the type */
  updateInitiatorId: Scalars['String']['output'];
  /** The type of the entity that initiated the update */
  updateInitiatorType: UpdateInitiatorType;
  /** Indicates whether this update is 'private' in the sense that it should not be displayed to the policyholder */
  updatePrivate: Scalars['Boolean']['output'];
  /** A human-readable description of the reason why this update was made */
  updateReason?: Maybe<Scalars['String']['output']>;
  /** A programmatic representation of the reason why this update was made */
  updateReasonCode?: Maybe<WordDocumentTemplateUpdateReasonCode>;
  /** The types of updates made between this version and the previous version */
  updateTypes: Array<WordDocumentTemplateUpdateType>;
  /** The version number of this Word document template version */
  version: Scalars['Int64']['output'];
  /** The full Word document template object that includes all of the updates made in this version and all previous versions */
  wordDocumentTemplate: WordDocumentTemplate;
};

/**
 * Filter for the wordDocumentTemplates list query. Wraps visibility filters
 * today; future filter dimensions (search, archived inclusion, etc.) can be
 * added here without breaking the query signature.
 */
export type WordDocumentTemplatesFilterInput = {
  visibility?: InputMaybe<VisibilityListFilterInput>;
};

/**
 * An artifact produced by a task. Exactly one of `file` or `markdown` is
 * populated, matching the `type` discriminator.
 */
export type WorkflowArtifact = {
  __typename?: 'WorkflowArtifact';
  /** Populated when type is FILE */
  file?: Maybe<WorkflowArtifactFile>;
  /** Populated when type is MARKDOWN */
  markdown?: Maybe<WorkflowArtifactMarkdown>;
  /** The artifact name */
  name: Scalars['String']['output'];
  /** The type of this artifact */
  type: WorkflowArtifactType;
};

/** A file-based artifact stored in the file storage system */
export type WorkflowArtifactFile = {
  __typename?: 'WorkflowArtifactFile';
  /** The file ID in the file storage system */
  fileId: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
  /** A download URL for the file */
  url?: Maybe<Scalars['String']['output']>;
};

/** Inline Markdown content produced by a task */
export type WorkflowArtifactMarkdown = {
  __typename?: 'WorkflowArtifactMarkdown';
  /** The Markdown content */
  content: Scalars['String']['output'];
};

/** The type of an artifact produced by a task */
export enum WorkflowArtifactType {
  /** A file stored in the file storage system */
  File = 'FILE',
  /** Markdown content stored inline */
  Markdown = 'MARKDOWN'
}

/** Describes the origin of a binding value within a workflow definition */
export type WorkflowBindingSource = {
  __typename?: 'WorkflowBindingSource';
  /** Optional dotted path to extract a sub-field from the resolved value */
  path?: Maybe<Scalars['String']['output']>;
  /** The output key from the upstream task (when type is TASK_OUTPUT) */
  sourceOutputKey?: Maybe<Scalars['String']['output']>;
  /** The upstream task's definition key (when type is TASK_OUTPUT) */
  sourceTaskKey?: Maybe<Scalars['String']['output']>;
  /** A literal JSON value (when type is STATIC) */
  staticValue?: Maybe<Scalars['JSON']['output']>;
  /** The source kind */
  type: WorkflowBindingSourceType;
  /** The schema key of the workflow-level input (when type is WORKFLOW_INPUT) */
  workflowInputKey?: Maybe<Scalars['String']['output']>;
};

/** Input for specifying a binding source when creating or updating a definition */
export type WorkflowBindingSourceInput = {
  /** Optional dotted path to extract a sub-field from the resolved value */
  path?: InputMaybe<Scalars['String']['input']>;
  /** The output key from the upstream task (required when type is TASK_OUTPUT) */
  sourceOutputKey?: InputMaybe<Scalars['String']['input']>;
  /** The upstream task's definition key (required when type is TASK_OUTPUT) */
  sourceTaskKey?: InputMaybe<Scalars['String']['input']>;
  /** A literal JSON value (required when type is STATIC) */
  staticValue?: InputMaybe<Scalars['JSON']['input']>;
  /** The source kind */
  type: WorkflowBindingSourceType;
  /** The schema key of the workflow-level input (required when type is WORKFLOW_INPUT) */
  workflowInputKey?: InputMaybe<Scalars['String']['input']>;
};

/** Identifies where a task input value comes from in a workflow definition */
export enum WorkflowBindingSourceType {
  /** The value is a literal JSON value baked into the definition */
  Static = 'STATIC',
  /** The value comes from a specific upstream task's output */
  TaskOutput = 'TASK_OUTPUT',
  /** The value comes from a workflow-level input (e.g. uploaded documents) */
  WorkflowInput = 'WORKFLOW_INPUT'
}

/** A citation linking a claim in a task output to source evidence */
export type WorkflowCitation = {
  __typename?: 'WorkflowCitation';
  /** The excerpt from the source file */
  excerpt: Scalars['String']['output'];
  /** Unique identifier for the citation */
  id: Scalars['ID']['output'];
  /** The page number in the source file */
  pageNumber: Scalars['Int']['output'];
  /** The title of the section containing the citation */
  sectionTitle: Scalars['String']['output'];
  /** The source file that contains the cited evidence */
  sourceFileId: Scalars['String']['output'];
};

/**
 * A workflow definition is a reusable blueprint that declares which tasks
 * to run and how their inputs are wired. The UI builds these; at execution
 * time the definition is materialized into concrete tasks and dependency edges.
 */
export type WorkflowDefinition = {
  __typename?: 'WorkflowDefinition';
  /** When the definition was created */
  createdAt: Scalars['Time']['output'];
  /** Explains what this workflow does */
  description: Scalars['String']['output'];
  /** Unique identifier for the definition */
  id: Scalars['ID']['output'];
  /** The input slots this workflow expects at execution time */
  inputs: Array<WorkflowDefinitionInputSlot>;
  /** A human-readable name (e.g. 'Policy Comparison', 'Forms Audit') */
  label: Scalars['String']['output'];
  /** The tasks in this workflow and their input bindings */
  nodes: Array<WorkflowDefinitionNode>;
  /** When the definition was last updated */
  updatedAt: Scalars['Time']['output'];
  /** Monotonically increasing version number */
  version: Scalars['Int64']['output'];
};

/**
 * Declares a named input slot on a workflow definition. Slots describe the
 * values the workflow expects at execution time, how many of each kind are
 * allowed, and whether the slot fans out over multiple values.
 */
export type WorkflowDefinitionInputSlot = {
  __typename?: 'WorkflowDefinitionInputSlot';
  /** For FILE slots, the list of accepted MIME types (empty = any) */
  acceptedMimeTypes: Array<Scalars['String']['output']>;
  /** Explains what the slot is for */
  description: Scalars['String']['output'];
  /** Whether consumers can iterate (fan out) over this slot's values */
  enumerable: Scalars['Boolean']['output'];
  /** The schema key used to reference this slot from bindings */
  key: Scalars['String']['output'];
  /** The kind of value this slot accepts */
  kind: WorkflowInputSlotKind;
  /** A human-readable label for this slot */
  label: Scalars['String']['output'];
  /** Maximum number of values allowed (0 for unbounded) */
  maxCount: Scalars['Int']['output'];
  /** Minimum number of values required (defaults to 1) */
  minCount: Scalars['Int']['output'];
};

/** Input for declaring a workflow definition input slot in create/update mutations */
export type WorkflowDefinitionInputSlotInput = {
  /** For FILE slots, the list of accepted MIME types (empty = any) */
  acceptedMimeTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Explains what the slot is for */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether consumers can iterate (fan out) over this slot's values */
  enumerable?: Scalars['Boolean']['input'];
  /** The schema key used to reference this slot from bindings */
  key: Scalars['String']['input'];
  /** The kind of value this slot accepts */
  kind: WorkflowInputSlotKind;
  /** A human-readable label for this slot */
  label: Scalars['String']['input'];
  /** Maximum number of values allowed (0 for unbounded) */
  maxCount?: Scalars['Int']['input'];
  /** Minimum number of values required (defaults to 1) */
  minCount?: Scalars['Int']['input'];
};

/** A node in a workflow definition, representing one task and its input bindings */
export type WorkflowDefinitionNode = {
  __typename?: 'WorkflowDefinitionNode';
  /** How each input field is wired to a source */
  bindings: Array<WorkflowInputBinding>;
  /**
   * Static per-node configuration. Keys match the task's configSchema field keys.
   * Stored at definition-authoring time and materialized into the task at execution
   * time; not resolved through the binding system.
   */
  config?: Maybe<Scalars['JSON']['output']>;
  /** If set, this node runs once per element in the specified upstream list output */
  forEach?: Maybe<WorkflowForEach>;
  /** Which task definition this node runs */
  taskDefinitionKey: WorkflowTaskDefinitionKey;
};

/** Input for specifying a node when creating or updating a definition */
export type WorkflowDefinitionNodeInput = {
  /** How each input field is wired to a source */
  bindings: Array<WorkflowInputBindingInput>;
  /** Static per-node configuration (keys match the task's configSchema field keys) */
  config?: InputMaybe<Scalars['JSON']['input']>;
  /** If set, this node runs once per element in the specified upstream list output */
  forEach?: InputMaybe<WorkflowForEachInput>;
  /** Which task definition this node runs */
  taskDefinitionKey: WorkflowTaskDefinitionKey;
};

/**
 * A workflow execution represents a single run of a workflow definition.
 * Each execution contains a DAG of tasks, inputs, and outputs.
 */
export type WorkflowExecution = {
  __typename?: 'WorkflowExecution';
  /** Child workflow executions spawned from this one */
  childExecutions: Array<WorkflowExecution>;
  /** When the execution completed, failed, or was cancelled */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** When the execution was created */
  createdAt: Scalars['Time']['output'];
  /** The error that caused this execution to fail, if any */
  error?: Maybe<WorkflowExecutionError>;
  /** Unique identifier for the execution */
  id: Scalars['ID']['output'];
  /** The inputs provided to this execution */
  inputs: Array<WorkflowInput>;
  /** The final outputs produced by this execution */
  outputs: Array<WorkflowOutput>;
  /** The parent workflow execution that spawned this one, if any */
  parentExecution?: Maybe<WorkflowExecution>;
  /** The previous version number, if this execution was versioned from a prior run */
  prevVersion?: Maybe<Scalars['Int64']['output']>;
  /** When the execution started running */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current state of the execution */
  state: WorkflowExecutionState;
  /** The tasks in this execution's DAG */
  tasks: Array<WorkflowTask>;
  /** When the execution was last updated */
  updatedAt: Scalars['Time']['output'];
  /** The version number of this execution */
  version: Scalars['Int64']['output'];
};

/** An error that occurred during workflow execution or task execution */
export type WorkflowExecutionError = {
  __typename?: 'WorkflowExecutionError';
  /** A machine-readable error code, if available */
  code?: Maybe<Scalars['String']['output']>;
  /** A human-readable error message */
  message: Scalars['String']['output'];
};

/** The state of a workflow execution */
export enum WorkflowExecutionState {
  /** The execution was cancelled */
  Cancelled = 'CANCELLED',
  /** The execution completed successfully */
  Completed = 'COMPLETED',
  /** The execution failed */
  Failed = 'FAILED',
  /** The execution is queued and has not yet started */
  Queued = 'QUEUED',
  /** The execution is currently running */
  Running = 'RUNNING'
}

/** A file provided as workflow input */
export type WorkflowFileInput = {
  __typename?: 'WorkflowFileInput';
  /** The file ID in the file storage system */
  fileId: Scalars['String']['output'];
  /** The MIME type of the file */
  mimeType: Scalars['String']['output'];
  /** The original file name */
  name: Scalars['String']['output'];
};

/**
 * Declares that a definition node iterates over an upstream list, creating N
 * task instances at runtime (one per element).
 *
 * The iteration source is exactly one of:
 *   - a task output (set `sourceTaskKey` + `sourceOutputKey`), or
 *   - a workflow input slot (set `sourceWorkflowInputKey`), which iterates over
 *     the N `WorkflowInput` records that share that schema key.
 */
export type WorkflowForEach = {
  __typename?: 'WorkflowForEach';
  /** The input key on this task that receives the individual element */
  inputKey: Scalars['String']['output'];
  /** The output key on the upstream task that contains the list (task-output source) */
  sourceOutputKey?: Maybe<Scalars['String']['output']>;
  /** The upstream task whose output drives the iteration (task-output source) */
  sourceTaskKey?: Maybe<Scalars['String']['output']>;
  /**
   * The workflow input slot whose records drive the iteration (workflow-input
   * source). The slot must be declared enumerable at authoring time.
   */
  sourceWorkflowInputKey?: Maybe<Scalars['String']['output']>;
};

/**
 * Input for specifying a forEach iteration when creating or updating a definition.
 *
 * Exactly one of {sourceTaskKey+sourceOutputKey, sourceWorkflowInputKey} must be set.
 */
export type WorkflowForEachInput = {
  /** The input key on this task that receives the individual element */
  inputKey: Scalars['String']['input'];
  /** The output key on the upstream task that contains the list (task-output source) */
  sourceOutputKey?: InputMaybe<Scalars['String']['input']>;
  /** The upstream task whose output drives the iteration (task-output source) */
  sourceTaskKey?: InputMaybe<Scalars['String']['input']>;
  /** The workflow input slot whose records drive the iteration (workflow-input source) */
  sourceWorkflowInputKey?: InputMaybe<Scalars['String']['input']>;
};

/** A workflow input represents a value provided to a workflow execution at runtime */
export type WorkflowInput = {
  __typename?: 'WorkflowInput';
  /** When the input was created */
  createdAt: Scalars['Time']['output'];
  /** Whether this input represents an enumerable collection */
  enumerable: Scalars['Boolean']['output'];
  /** File input details, populated when type is FILE */
  file?: Maybe<WorkflowFileInput>;
  /** Unique identifier for the input */
  id: Scalars['ID']['output'];
  /** JSON input details, populated when type is JSON */
  json?: Maybe<WorkflowJsonInput>;
  /** A human-readable label for this input */
  label?: Maybe<Scalars['String']['output']>;
  /** The key used to reference this input in the workflow definition */
  schemaKey: Scalars['String']['output'];
  /** Text input details, populated when type is TEXT */
  text?: Maybe<WorkflowTextInput>;
  /** The type of this input */
  type: WorkflowInputType;
};

/**
 * Declares how one task input field gets its value in a workflow definition.
 * The workflow builder UI creates these; at execution time they are resolved
 * against the concrete workflow state.
 */
export type WorkflowInputBinding = {
  __typename?: 'WorkflowInputBinding';
  /** The task input field key this binding satisfies */
  inputKey: Scalars['String']['output'];
  /** Where the value comes from */
  source: WorkflowBindingSource;
};

/** Input for specifying an input binding when creating or updating a definition */
export type WorkflowInputBindingInput = {
  /** The task input field key this binding satisfies */
  inputKey: Scalars['String']['input'];
  /** Where the value comes from */
  source: WorkflowBindingSourceInput;
};

/** Classifies what kind of values a workflow input slot accepts */
export enum WorkflowInputSlotKind {
  /** A selection from an AMS/CRM integration (e.g. a specific account/policy) */
  AmsSelection = 'AMS_SELECTION',
  /** A file upload slot (documents, spreadsheets, images, etc.) */
  File = 'FILE',
  /** A structured JSON slot */
  Json = 'JSON',
  /** A text slot (single string) */
  Text = 'TEXT'
}

/** The type of a workflow input */
export enum WorkflowInputType {
  /** A file upload */
  File = 'FILE',
  /** A structured JSON value */
  Json = 'JSON',
  /** A text value */
  Text = 'TEXT'
}

/**
 * Classifies the runtime value kind that flows through a wf.Input slot.
 * Used by the binding picker to filter compatible sources.
 */
export enum WorkflowInputValueKind {
  /** A boolean */
  Bool = 'BOOL',
  /** A file reference (wf.FileRef) */
  File = 'FILE',
  /** A structured JSON object */
  Json = 'JSON',
  /** A list of values */
  List = 'LIST',
  /** A number */
  Number = 'NUMBER',
  /** A map/record (string keys → any values) */
  Record = 'RECORD',
  /** A text string */
  Text = 'TEXT'
}

/** A structured JSON value provided as workflow input */
export type WorkflowJsonInput = {
  __typename?: 'WorkflowJSONInput';
  /** The JSON data */
  data: Scalars['JSON']['output'];
  /** The JSON schema describing the shape of the data, if available */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** A structured JSON output with its schema */
export type WorkflowJsonOutput = {
  __typename?: 'WorkflowJSONOutput';
  /** The JSON data */
  data: Scalars['JSON']['output'];
  /** The JSON schema describing the shape of the data */
  schema?: Maybe<Scalars['JSON']['output']>;
};

/** A message event from a task */
export type WorkflowMessageEvent = {
  __typename?: 'WorkflowMessageEvent';
  /** The message content */
  content: Scalars['String']['output'];
  /** The message level */
  level: WorkflowMessageLevel;
};

/** The level of a message event */
export enum WorkflowMessageLevel {
  /** A debug message (non-user-facing) */
  Debug = 'DEBUG',
  /** An info message (user-facing) */
  Info = 'INFO'
}

/** A final output produced by a workflow execution */
export type WorkflowOutput = {
  __typename?: 'WorkflowOutput';
  /** File artifact, populated when type is ARTIFACT */
  artifact?: Maybe<WorkflowArtifact>;
  /** When the output was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the output */
  id: Scalars['ID']['output'];
  /** Structured JSON output, populated when type is JSON */
  json?: Maybe<WorkflowJsonOutput>;
  /** A human-readable label for this output */
  label: Scalars['String']['output'];
  /** The task outputs that contributed to this workflow output */
  sourceTaskOutputs: Array<WorkflowTaskOutput>;
  /** The task that produced this output */
  task?: Maybe<WorkflowTask>;
  /** Text content, populated when type is TEXT */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of this output */
  type: WorkflowOutputType;
};

/** The type of a workflow output */
export enum WorkflowOutputType {
  /** A file artifact */
  Artifact = 'ARTIFACT',
  /** A structured JSON output */
  Json = 'JSON',
  /** A text output */
  Text = 'TEXT'
}

/** A progress update event from a task */
export type WorkflowProgressEvent = {
  __typename?: 'WorkflowProgressEvent';
  /** A description of the current progress */
  message: Scalars['String']['output'];
  /** Progress percentage, if available (0.0-1.0) */
  percent: Scalars['Float']['output'];
};

/** A retrieval event from a task */
export type WorkflowRetrievalEvent = {
  __typename?: 'WorkflowRetrievalEvent';
  /** The query used for retrieval */
  query: Scalars['String']['output'];
  /** The number of results retrieved */
  resultCount: Scalars['Int']['output'];
};

/** An event indicating a sub-agent was spawned */
export type WorkflowSpawnEvent = {
  __typename?: 'WorkflowSpawnEvent';
  /** A description of what the spawned agent will do */
  description: Scalars['String']['output'];
  /** The ID of the spawned agent or task */
  spawnedTaskId: Scalars['String']['output'];
};

/** A workflow task is a runtime instance of a task in the execution DAG */
export type WorkflowTask = {
  __typename?: 'WorkflowTask';
  /** When the task completed, failed, or was skipped */
  completedAt?: Maybe<Scalars['Time']['output']>;
  /** The configuration for the task */
  config: Scalars['JSON']['output'];
  /** When the task was created */
  createdAt: Scalars['Time']['output'];
  /** The definition key identifying which kind of task this is (used for registry lookup) */
  definitionKey: WorkflowTaskDefinitionKey;
  /** The tasks that this task depends on */
  dependencies: Array<WorkflowTask>;
  /** The tasks that depend on this task */
  dependents: Array<WorkflowTask>;
  /** The error that caused this task to fail, if any */
  error?: Maybe<WorkflowExecutionError>;
  /** The event stream for this task */
  events: Array<WorkflowTaskEvent>;
  /** The input key that receives per-element values in iterated tasks (null for non-iterated tasks) */
  forEachInputKey?: Maybe<Scalars['String']['output']>;
  /** Unique identifier for the task */
  id: Scalars['ID']['output'];
  /** The resolved inputs for this task */
  inputs: Array<WorkflowTaskInput>;
  /** The total number of iterations in this task's group (null for non-iterated tasks) */
  iterationCount?: Maybe<Scalars['Int']['output']>;
  /** Groups iterated instances by definition node key (null for non-iterated tasks) */
  iterationGroupKey?: Maybe<Scalars['String']['output']>;
  /** The iteration index within an iteration group (null for non-iterated tasks) */
  iterationIndex?: Maybe<Scalars['Int']['output']>;
  /** The latest attempt number for this task */
  latestAttempt: Scalars['Int']['output'];
  /** The outputs produced by this task */
  outputs: Array<WorkflowTaskOutput>;
  /** When the task started running */
  startedAt?: Maybe<Scalars['Time']['output']>;
  /** The current state of the task */
  state: WorkflowTaskState;
  /** When the task was last updated */
  updatedAt: Scalars['Time']['output'];
};


/** A workflow task is a runtime instance of a task in the execution DAG */
export type WorkflowTaskEventsArgs = {
  attempt?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Describes one configuration field of a task definition. Config fields are
 * resolved from the per-node config blob at execution time, not from bindings.
 */
export type WorkflowTaskConfigFieldDescriptor = {
  __typename?: 'WorkflowTaskConfigFieldDescriptor';
  /** An optional default value as JSON */
  default?: Maybe<Scalars['JSON']['output']>;
  /** Explains what this config field does */
  description: Scalars['String']['output'];
  /** Whether this config field accepts a list value */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this config field */
  label: Scalars['String']['output'];
  /** Whether this config field is required */
  required: Scalars['Boolean']['output'];
};

/**
 * A task definition describes an available task kind in the workflow system.
 * This is read-only metadata from the task registry, used by the UI to
 * build workflow definitions.
 */
export type WorkflowTaskDefinition = {
  __typename?: 'WorkflowTaskDefinition';
  /** The configuration fields this task accepts (stored at design time, not bound) */
  configSchema: Array<WorkflowTaskConfigFieldDescriptor>;
  /** Explains what this task does */
  description: Scalars['String']['output'];
  /** The input fields this task expects (data-flow slots; wired via bindings) */
  inputSchema: Array<WorkflowTaskInputFieldDescriptor>;
  /** The definition key (matches WorkflowTaskDefinitionKey enum) */
  key: WorkflowTaskDefinitionKey;
  /** A human-readable name for this task kind */
  label: Scalars['String']['output'];
  /** The output fields this task produces */
  outputSchema: Array<WorkflowTaskOutputFieldDescriptor>;
};

/**
 * The definition key identifying which kind of workflow task this is (e.g. document_classification, forms_analysis).
 * Used to look up metadata and executor in the task definition registry.
 */
export enum WorkflowTaskDefinitionKey {
  /** Aggregate upstream values (deterministic or LLM-driven) */
  Aggregate = 'AGGREGATE',
  /** Claims analysis */
  ClaimsAnalysis = 'CLAIMS_ANALYSIS',
  /** Compare two upstream values and report semantic differences */
  Compare = 'COMPARE',
  /** Coverage analysis */
  CoverageAnalysis = 'COVERAGE_ANALYSIS',
  /** Coverage enumeration */
  CoverageEnumeration = 'COVERAGE_ENUMERATION',
  /** Document classification (input processing) */
  DocumentClassification = 'DOCUMENT_CLASSIFICATION',
  /** Extract structured entities from input (config-driven) */
  Extract = 'EXTRACT',
  /** Forms analysis */
  FormsAnalysis = 'FORMS_ANALYSIS',
  /** Read records from an AMS/CRM integration */
  InputAmsRead = 'INPUT_AMS_READ',
  /** Document input processing (OCR, page splitting) */
  InputDocument = 'INPUT_DOCUMENT',
  /** JSON input processing (validation, passthrough) */
  InputJson = 'INPUT_JSON',
  /** Spreadsheet input processing (parses rows into structured objects) */
  InputSpreadsheet = 'INPUT_SPREADSHEET',
  /** Text input processing (passthrough, optional splitting) */
  InputText = 'INPUT_TEXT',
  /** Perform a web lookup / external search */
  InputWebLookup = 'INPUT_WEB_LOOKUP',
  /** Generate an output document (PDF, Word, Excel, CSV) */
  OutputDocument = 'OUTPUT_DOCUMENT',
  /** Output generation */
  OutputGeneration = 'OUTPUT_GENERATION',
  /** Write results into an external integration (AMS/CRM/etc.) */
  OutputIntegration = 'OUTPUT_INTEGRATION',
  /** Risk profile analysis */
  RiskProfile = 'RISK_PROFILE',
  /** Search space determination */
  SearchSpaceDetermination = 'SEARCH_SPACE_DETERMINATION',
  /** Verify an upstream value against a reference */
  Verify = 'VERIFY',
  /** WRS research */
  WrsResearch = 'WRS_RESEARCH'
}

/** An event emitted by a task during execution */
export type WorkflowTaskEvent = {
  __typename?: 'WorkflowTaskEvent';
  /** The attempt number this event was emitted during */
  attempt: Scalars['Int']['output'];
  /** When the event was emitted */
  createdAt: Scalars['Time']['output'];
  /** Error details, populated for ERROR events */
  error?: Maybe<WorkflowExecutionError>;
  /** Unique identifier for the event */
  id: Scalars['ID']['output'];
  /** Message content, populated for MESSAGE events */
  message?: Maybe<WorkflowMessageEvent>;
  /** Progress details, populated for PROGRESS events */
  progress?: Maybe<WorkflowProgressEvent>;
  /** Retrieval details, populated for RETRIEVAL events */
  retrieval?: Maybe<WorkflowRetrievalEvent>;
  /** The ordering of this event within its attempt */
  sequence: Scalars['Int']['output'];
  /** Spawn details, populated for AGENT_SPAWNED events */
  spawnEvent?: Maybe<WorkflowSpawnEvent>;
  /** Thinking content, populated for THINKING events */
  thinking?: Maybe<WorkflowThinkingEvent>;
  /** A human-readable summary of the event */
  title: Scalars['String']['output'];
  /** Tool call details, populated for TOOL_CALL events */
  toolCall?: Maybe<WorkflowToolCallEvent>;
  /** The type of event */
  type: WorkflowTaskEventType;
};

/** The type of a task event */
export enum WorkflowTaskEventType {
  /** A sub-agent completed */
  AgentCompleted = 'AGENT_COMPLETED',
  /** A sub-agent was spawned */
  AgentSpawned = 'AGENT_SPAWNED',
  /** An error occurred */
  Error = 'ERROR',
  /** A message from the task */
  Message = 'MESSAGE',
  /** An output is ready */
  OutputReady = 'OUTPUT_READY',
  /** A progress update */
  Progress = 'PROGRESS',
  /** The task is retrieving information */
  Retrieval = 'RETRIEVAL',
  /** The task is thinking or reasoning */
  Thinking = 'THINKING',
  /** The task is calling a tool */
  ToolCall = 'TOOL_CALL',
  /** A non-fatal warning */
  Warning = 'WARNING'
}

/** A resolved input for a workflow task, recording where the value came from */
export type WorkflowTaskInput = {
  __typename?: 'WorkflowTaskInput';
  /** When the task input was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the task input */
  id: Scalars['ID']['output'];
  /** The input key this binding satisfies (matches a struct field json tag) */
  key: Scalars['String']['output'];
  /** The task output that provided this value, if type is TASK_OUTPUT */
  taskOutput?: Maybe<WorkflowTaskOutput>;
  /** The source type of this input */
  type: WorkflowTaskInputSourceType;
  /** The workflow input that provided this value, if type is WORKFLOW_INPUT */
  workflowInput?: Maybe<WorkflowInput>;
};

/**
 * Describes one input field of a task definition. Used by the workflow builder
 * UI to show what a task needs and how each input should be wired.
 */
export type WorkflowTaskInputFieldDescriptor = {
  __typename?: 'WorkflowTaskInputFieldDescriptor';
  /**
   * The value kinds this input slot can accept. Empty means any kind is acceptable.
   * Only relevant for INPUT-kind fields; ignored for DATA, CONFIG, and FILE fields.
   */
  acceptedKinds: Array<WorkflowInputValueKind>;
  /**
   * Whether this input slot accepts multiple bindings (fan-in). When true, the
   * task receives a list even if only one binding is wired.
   * Only relevant for INPUT-kind fields that are declared as list slots.
   */
  acceptsMany: Scalars['Boolean']['output'];
  /** An optional default value as JSON */
  default?: Maybe<Scalars['JSON']['output']>;
  /** Explains what this input is for */
  description: Scalars['String']['output'];
  /** Classifies the input as data flow, configuration, or file */
  fieldKind: WorkflowTaskInputFieldKind;
  /** Whether the field accepts multiple values (list input) */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this input */
  label: Scalars['String']['output'];
  /** Whether this input must be bound for the task to run */
  required: Scalars['Boolean']['output'];
};

/** Classifies how a task input field gets its value */
export enum WorkflowTaskInputFieldKind {
  /** A workflow-level configuration value (e.g. output format, audience) */
  Config = 'CONFIG',
  /** An input that flows from an upstream task's output (data dependency) */
  Data = 'DATA',
  /** A file reference provided as workflow input */
  File = 'FILE',
  /** A polymorphic input slot that can accept any compatible kind (file, text, JSON, etc.) */
  Input = 'INPUT'
}

/** The source type of a task input */
export enum WorkflowTaskInputSourceType {
  /** The input came from an upstream task's output */
  TaskOutput = 'TASK_OUTPUT',
  /** The input came from a workflow-level input */
  WorkflowInput = 'WORKFLOW_INPUT'
}

/** An output produced by a workflow task */
export type WorkflowTaskOutput = {
  __typename?: 'WorkflowTaskOutput';
  /** File artifact, populated when type is ARTIFACT */
  artifact?: Maybe<WorkflowArtifact>;
  /** Citations supporting this output */
  citations: Array<WorkflowCitation>;
  /** When the output was created */
  createdAt: Scalars['Time']['output'];
  /** Unique identifier for the task output */
  id: Scalars['ID']['output'];
  /** Structured JSON output, populated when type is JSON */
  json?: Maybe<WorkflowJsonOutput>;
  /** The output key under which this is stored in state (task-scoped: taskID:key) */
  key: Scalars['String']['output'];
  /** The ordering of this output within the task */
  sequence: Scalars['Int']['output'];
  /** Text content, populated when type is TEXT */
  text?: Maybe<Scalars['String']['output']>;
  /** The type of this output */
  type: WorkflowTaskOutputType;
};

/**
 * Describes one output field of a task definition. Used by the workflow builder
 * to show what outputs are available for downstream binding.
 */
export type WorkflowTaskOutputFieldDescriptor = {
  __typename?: 'WorkflowTaskOutputFieldDescriptor';
  /** If set, this list output has 1:1 correspondence with the named input field */
  correlatesWithInput?: Maybe<Scalars['String']['output']>;
  /** Explains what this output contains */
  description: Scalars['String']['output'];
  /** Whether this output is a workflow-level artifact (e.g. a generated report) */
  isArtifact: Scalars['Boolean']['output'];
  /** Whether this output field is a list */
  isList: Scalars['Boolean']['output'];
  /** The field key (matches the Go struct json tag) */
  key: Scalars['String']['output'];
  /** A human-readable name for this output */
  label: Scalars['String']['output'];
};

/** The type of a task output */
export enum WorkflowTaskOutputType {
  /** A file artifact */
  Artifact = 'ARTIFACT',
  /** A structured JSON output */
  Json = 'JSON',
  /** A text output */
  Text = 'TEXT'
}

/** The state of a workflow task */
export enum WorkflowTaskState {
  /** The task completed successfully */
  Completed = 'COMPLETED',
  /** The task failed */
  Failed = 'FAILED',
  /** The task is waiting for its dependencies to complete */
  Pending = 'PENDING',
  /** The task is currently running */
  Running = 'RUNNING',
  /** The task was skipped because a dependency failed or a condition was not met */
  Skipped = 'SKIPPED',
  /** The task is a placeholder waiting for fan-out expansion */
  WaitingForFanout = 'WAITING_FOR_FANOUT'
}

/** A text value provided as workflow input */
export type WorkflowTextInput = {
  __typename?: 'WorkflowTextInput';
  /** The text content */
  data: Scalars['String']['output'];
};

/** A thinking/reasoning event from a task */
export type WorkflowThinkingEvent = {
  __typename?: 'WorkflowThinkingEvent';
  /** The thinking content */
  content: Scalars['String']['output'];
};

/** A tool call event from a task */
export type WorkflowToolCallEvent = {
  __typename?: 'WorkflowToolCallEvent';
  /** The input to the tool */
  input?: Maybe<Scalars['JSON']['output']>;
  /** The output from the tool, if completed */
  output?: Maybe<Scalars['JSON']['output']>;
  /** The name of the tool being called */
  toolName: Scalars['String']['output'];
};

/** Workspace success and error counts for a single calendar day */
export type WorkspaceDailyCount = {
  __typename?: 'WorkspaceDailyCount';
  /** The calendar date these counts apply to (UTC midnight) */
  date: Scalars['Time']['output'];
  /** Number of workspaces that ended in an error state on this date */
  errorCount: Scalars['Int']['output'];
  /** Number of workspaces that completed successfully on this date */
  successCount: Scalars['Int']['output'];
};

export type WorkspaceDocumentClients = {
  __typename?: 'WorkspaceDocumentClients';
  clients: Array<Client>;
  /** A CaraWorkspaceArtifact id, standing for every version of it, or a File id. */
  documentId: Scalars['String']['output'];
};

/** Performance metrics for a single workspace preset within a filter window */
export type WorkspacePresetStat = {
  __typename?: 'WorkspacePresetStat';
  /** Total number of workspaces using this preset in the filter window */
  count: Scalars['Int']['output'];
  /** Fraction of workspaces using this preset that ended in an error state (0.0–1.0) */
  errorRate: Scalars['Float']['output'];
  /** Median (p50) workspace duration in milliseconds */
  medianDurationMs: Scalars['Int']['output'];
  /** 95th-percentile workspace duration in milliseconds */
  p95DurationMs: Scalars['Int']['output'];
  /** The preset these metrics apply to */
  preset: CaraWorkspacePreset;
};

/** Aggregated analytics for workspaces matching a given filter window */
export type WorkspaceReport = {
  __typename?: 'WorkspaceReport';
  /** Number of workspaces currently in an active (non-terminal) state */
  activeCount: Scalars['Int']['output'];
  /** Number of workspaces that reached a terminal state today */
  completedTodayCount: Scalars['Int']['output'];
  /** Workspace success and error counts grouped by day for the filter window */
  dailyCounts: Array<WorkspaceDailyCount>;
  /** Fraction of workspaces that ended in an error state (0.0–1.0) */
  errorRate: Scalars['Float']['output'];
  /** Per-preset performance breakdown for the filter window */
  presetStats: Array<WorkspacePresetStat>;
  /** Aggregated tool call failures across all workspaces in the filter window */
  toolCallFailures: Array<WorkspaceToolCallFailure>;
  /** Total number of workspaces created in the filter window */
  totalCount: Scalars['Int']['output'];
};

/** Filter parameters for workspace analytics reports */
export type WorkspaceReportFilter = {
  /** Restrict results to a single agency; omit to aggregate across all agencies */
  agencyId?: InputMaybe<Scalars['String']['input']>;
  /** End of the reporting window (inclusive); defaults to now when omitted */
  endDate?: InputMaybe<Scalars['Time']['input']>;
  /** Restrict results to workspaces using this preset */
  preset?: InputMaybe<CaraWorkspacePreset>;
  /** Start of the reporting window (inclusive); defaults to 30 days ago when omitted */
  startDate?: InputMaybe<Scalars['Time']['input']>;
};

/** Aggregated failure statistics for a single tool across all workspaces in the filter window */
export type WorkspaceToolCallFailure = {
  __typename?: 'WorkspaceToolCallFailure';
  /** Absolute number of failed calls to this tool in the filter window */
  failureCount: Scalars['Int']['output'];
  /** Fraction of all calls to this tool that failed (0.0–1.0) */
  failureRate: Scalars['Float']['output'];
  /** The most frequently occurring error message for this tool, truncated to 80 characters */
  mostCommonError: Scalars['String']['output'];
  /** The name of the tool that failed, as recorded in the plan stage event data */
  toolName: Scalars['String']['output'];
};

/**
 * Represents a tool for writing to an integration.
 * Used when the LLM needs to write to an integration.
 */
export type WriteIntegrationTool = {
  __typename?: 'WriteIntegrationTool';
  /** The input arguments for the integration write */
  input: WriteIntegrationToolInput;
  /** The result of the integration write operation */
  output: WriteIntegrationToolOutput;
};

export type WriteIntegrationToolAccount = {
  __typename?: 'WriteIntegrationToolAccount';
  accountType: Scalars['String']['output'];
  address: Address;
  businessName: Scalars['String']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  phone: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateNoteInput = {
  __typename?: 'WriteIntegrationToolCreateNoteInput';
  body: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type WriteIntegrationToolCreateTaskInput = {
  __typename?: 'WriteIntegrationToolCreateTaskInput';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dueDate?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
};

/** Input arguments for the WriteIntegrationTool. */
export type WriteIntegrationToolInput = {
  __typename?: 'WriteIntegrationToolInput';
  account: WriteIntegrationToolAccount;
  /**
   * The type of entity to write. This must be one of the following values:
   * - CREATE_NOTE
   * - CREATE_TASK
   * - UPLOAD_DOCUMENT
   * - UPSERT_ACCOUNT
   */
  action: Scalars['String']['output'];
  agentName: Scalars['String']['output'];
  createNote?: Maybe<WriteIntegrationToolCreateNoteInput>;
  createTask?: Maybe<WriteIntegrationToolCreateTaskInput>;
  uploadDocument?: Maybe<WriteIntegrationToolUploadDocumentInput>;
};

export type WriteIntegrationToolOutput = {
  __typename?: 'WriteIntegrationToolOutput';
  /** The ID of the entity that was created or updated */
  id: Scalars['String']['output'];
  /** The message from the integration write operation */
  message: Scalars['String']['output'];
  /** The result of the integration write operation */
  success: Scalars['Boolean']['output'];
};

export type WriteIntegrationToolUploadDocumentInput = {
  __typename?: 'WriteIntegrationToolUploadDocumentInput';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  source: Scalars['String']['output'];
};

/**
 * Represents a tool for creating, editing, and filling Excel (.xlsx) workbooks —
 * ad-hoc from scratch, from a user-uploaded file, or from an agency spreadsheet template.
 */
export type XlsxEditorTool = {
  __typename?: 'XlsxEditorTool';
  /** The input arguments for the workbook create, edit, fill, or inspect */
  input: XlsxEditorToolInput;
  /** The result of the workbook operation */
  output: XlsxEditorToolOutput;
};

/**
 * Input arguments for the ADD_TAB operation of the XlsxEditorTool.
 * Restores one previously-omitted or deleted optional template tab into the delivered workbook.
 */
export type XlsxEditorToolAddTabInput = {
  __typename?: 'XlsxEditorToolAddTabInput';
  /** The ID of the workbook artifact */
  artifactId: Scalars['String']['output'];
  /** Optional requirements when filling or re-editing the restored tab */
  requirements?: Maybe<Scalars['String']['output']>;
  /** The template tab ID to restore */
  tabId: Scalars['String']['output'];
};

/** Input arguments for the CREATE_FROM_TEMPLATE operation of the XlsxEditorTool. */
export type XlsxEditorToolCreateFromTemplateInput = {
  __typename?: 'XlsxEditorToolCreateFromTemplateInput';
  /** The requirements for each tab to fill */
  tabs: Array<XlsxEditorToolTabInput>;
  /** The template ID */
  templateId: Scalars['String']['output'];
};

/**
 * Input arguments for the CREATE operation of the XlsxEditorTool.
 * Creates a new ad-hoc Excel workbook from scratch.
 */
export type XlsxEditorToolCreateInput = {
  __typename?: 'XlsxEditorToolCreateInput';
  /** The requirements for the workbook */
  requirements: Scalars['String']['output'];
};

/**
 * Input arguments for the DELETE_TAB operation of the XlsxEditorTool.
 * Removes one optional template tab from the delivered workbook while retaining it in the working workbook for later restoration.
 */
export type XlsxEditorToolDeleteTabInput = {
  __typename?: 'XlsxEditorToolDeleteTabInput';
  /** The ID of the workbook artifact */
  artifactId: Scalars['String']['output'];
  /** The template tab ID to remove from delivery */
  tabId: Scalars['String']['output'];
};

/**
 * Input arguments for the EDIT operation of the XlsxEditorTool.
 * Edits an existing ad-hoc or upload-derived workbook artifact. Template-provenance artifacts must use EDIT_TAB instead.
 */
export type XlsxEditorToolEditInput = {
  __typename?: 'XlsxEditorToolEditInput';
  /** The ID of the artifact to edit */
  artifactId: Scalars['String']['output'];
  /** The requirements for the edit */
  requirements: Scalars['String']['output'];
  /** Optional override of the source file used as the edit base */
  sourceFileId?: Maybe<Scalars['String']['output']>;
};

/** Input arguments for the EDIT_TAB operation of the XlsxEditorTool. */
export type XlsxEditorToolEditTabInput = {
  __typename?: 'XlsxEditorToolEditTabInput';
  /** The ID of the workbook artifact to edit */
  artifactId: Scalars['String']['output'];
  /** The tabs to edit */
  tabs: Array<XlsxEditorToolTabInput>;
};

/**
 * Input arguments for the EDIT_UPLOADED operation of the XlsxEditorTool.
 * Creates a new artifact by editing a user-uploaded XLSX; the uploaded source file is not modified.
 */
export type XlsxEditorToolEditUploadedInput = {
  __typename?: 'XlsxEditorToolEditUploadedInput';
  /** The requirements for the edit */
  requirements: Scalars['String']['output'];
  /** The ID of the uploaded source file */
  sourceFileId: Scalars['String']['output'];
};

/**
 * Input arguments for the XlsxEditorTool.
 * Carries the operation plus exactly one operation-specific payload.
 */
export type XlsxEditorToolInput = {
  __typename?: 'XlsxEditorToolInput';
  /** The input for the ADD_TAB operation */
  addTab?: Maybe<XlsxEditorToolAddTabInput>;
  /** The input for the CREATE operation */
  create?: Maybe<XlsxEditorToolCreateInput>;
  /** The input for the CREATE_FROM_TEMPLATE operation */
  createFromTemplate?: Maybe<XlsxEditorToolCreateFromTemplateInput>;
  /** The input for the DELETE_TAB operation */
  deleteTab?: Maybe<XlsxEditorToolDeleteTabInput>;
  /** The input for the EDIT operation */
  edit?: Maybe<XlsxEditorToolEditInput>;
  /** The input for the EDIT_TAB operation */
  editTab?: Maybe<XlsxEditorToolEditTabInput>;
  /** The input for the EDIT_UPLOADED operation */
  editUploaded?: Maybe<XlsxEditorToolEditUploadedInput>;
  /** The input for the INSPECT_ARTIFACT operation */
  inspectArtifact?: Maybe<XlsxEditorToolInspectArtifactInput>;
  /** The operation to perform */
  operation: Scalars['String']['output'];
  /** Short human-readable label for this operation shown in the workspace timeline and artifact cards. */
  title: Scalars['String']['output'];
};

/** Input arguments for the INSPECT_ARTIFACT operation of the XlsxEditorTool. */
export type XlsxEditorToolInspectArtifactInput = {
  __typename?: 'XlsxEditorToolInspectArtifactInput';
  /** The ID of the artifact to inspect */
  artifactId: Scalars['String']['output'];
};

/** Result of an XlsxEditorTool operation. */
export type XlsxEditorToolOutput = {
  __typename?: 'XlsxEditorToolOutput';
  /** The ID of the workbook artifact that was created or updated */
  artifactId?: Maybe<Scalars['String']['output']>;
  /** Any remarks or instructions for subsequent operations on this file */
  remarks?: Maybe<Scalars['String']['output']>;
  /** The standard error from the Python script execution */
  stderr?: Maybe<Scalars['String']['output']>;
  /** The standard output from the Python script execution */
  stdout?: Maybe<Scalars['String']['output']>;
  /** Whether the Python script executed successfully. Present for whole-workbook CREATE / EDIT / EDIT_UPLOADED. */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** A description of the tabs that were filled or edited. Present for template operations. */
  tabs?: Maybe<Array<XlsxEditorToolTabOutput>>;
  /** Any validation warnings or errors */
  validationMessage?: Maybe<Scalars['String']['output']>;
  /** Whether the generated file passed validation */
  validationPassed?: Maybe<Scalars['Boolean']['output']>;
  /** The version of the artifact */
  version?: Maybe<Scalars['Int']['output']>;
  /**
   * Recoverable validation notes. A tab named here was skipped (unknown, static,
   * empty requirements) or a required tab was omitted — the workbook was still
   * produced from the tabs that were filled. Follow up with EDIT_TAB when a
   * required tab is listed here. Also used for idempotent ADD_TAB / DELETE_TAB no-ops.
   */
  warnings?: Maybe<Array<Scalars['String']['output']>>;
  /** Structured XLSX inspection of the workbook when requested by INSPECT_ARTIFACT. */
  xlsxInspection?: Maybe<Scalars['String']['output']>;
};

/** One tab's fill or edit instructions within an XlsxEditorTool call. */
export type XlsxEditorToolTabInput = {
  __typename?: 'XlsxEditorToolTabInput';
  /** The requirements for this tab */
  requirements: Scalars['String']['output'];
  /** The template tab ID */
  tabId: Scalars['String']['output'];
};

/** Output for one tab of an XlsxEditorTool operation. */
export type XlsxEditorToolTabOutput = {
  __typename?: 'XlsxEditorToolTabOutput';
  /** A summary of what was written to the worksheet, produced by the fill step */
  description?: Maybe<Scalars['String']['output']>;
  /** The worksheet name */
  name: Scalars['String']['output'];
  /**
   * Anything the fill program reported it could not place on this worksheet. Empty when the
   * program placed every value it was given.
   */
  notes?: Maybe<Scalars['String']['output']>;
  /** The ID of the template tab this worksheet was filled from */
  templateTabId: Scalars['String']['output'];
};

export type ZapierAccountFields = {
  __typename?: 'ZapierAccountFields';
  address?: Maybe<ZapierAddressFields>;
  businessName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
};

export type ZapierAddressFields = {
  __typename?: 'ZapierAddressFields';
  city?: Maybe<Scalars['String']['output']>;
  line1?: Maybe<Scalars['String']['output']>;
  line2?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  zone?: Maybe<Scalars['String']['output']>;
};

/** ZapierConfiguration contains configuration for the Zapier integration */
export type ZapierConfiguration = {
  __typename?: 'ZapierConfiguration';
  /** API key for Zapier integration */
  apiKey: Scalars['String']['output'];
  /** Subscriptions to Zapier webhooks */
  subscriptions: Array<ZapierSubscription>;
};

export type ZapierDocumentFields = {
  __typename?: 'ZapierDocumentFields';
  email?: Maybe<Scalars['String']['output']>;
  fileId?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
};

/** ZapierEventType defines the types of events that can trigger a Zapier webhook. */
export enum ZapierEventType {
  /** Triggered when an account is created or updated. */
  AccountCreateOrUpdate = 'ACCOUNT_CREATE_OR_UPDATE',
  /** Triggered when a call is created. */
  CallCreate = 'CALL_CREATE',
  /** Triggered when a document is uploaded. */
  DocumentUpload = 'DOCUMENT_UPLOAD',
  /** Triggered when a note is created. */
  NoteCreate = 'NOTE_CREATE',
  /** Triggered when a task is created. */
  TaskCreate = 'TASK_CREATE'
}

export type ZapierNoteFields = {
  __typename?: 'ZapierNoteFields';
  body?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** ZapierSubscription defines a subscription to a Zapier webhook. */
export type ZapierSubscription = {
  __typename?: 'ZapierSubscription';
  /** Zapier event type */
  eventType: ZapierEventType;
  /** Zapier hook URL */
  hookUrl: Scalars['String']['output'];
};

export type ZapierTaskFields = {
  __typename?: 'ZapierTaskFields';
  assigneeEmail?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  dueDate?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** Represents a tool for pushing data to Zapier webhooks (notes/tasks/accounts/documents). */
export type ZapierWriteTool = {
  __typename?: 'ZapierWriteTool';
  input: ZapierWriteToolInput;
  output: ZapierWriteToolOutput;
};

export type ZapierWriteToolInput = {
  __typename?: 'ZapierWriteToolInput';
  account?: Maybe<ZapierAccountFields>;
  document?: Maybe<ZapierDocumentFields>;
  note?: Maybe<ZapierNoteFields>;
  operation?: Maybe<Scalars['String']['output']>;
  task?: Maybe<ZapierTaskFields>;
};

export type ZapierWriteToolOutput = {
  __typename?: 'ZapierWriteToolOutput';
  message: Scalars['String']['output'];
  success: Scalars['Boolean']['output'];
};

export type AccountFieldsFragment = { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } };

export type AccountBusinessPolicyFieldsFragment = { __typename?: 'Account', businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } }> };

export type AccountCertificateOfLiabilityInsuranceFieldsFragment = { __typename?: 'Account', certificatesOfLiabilityInsurance: Array<{ __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } }> };

export type AccountContactFieldsFragment = { __typename?: 'Account', contacts: Array<{ __typename?: 'AccountContact', email: string, id: string, name: string, phone: string }> };

export type AccountServiceRequestFieldsFragment = { __typename?: 'Account', serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }> };

export type GetAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountsQuery = { __typename?: 'Query', accounts: Array<{ __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } }> };

export type GetAccountQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAccountQuery = { __typename?: 'Query', account?: { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } }>, certificatesOfLiabilityInsurance: Array<{ __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } }>, contacts: Array<{ __typename?: 'AccountContact', email: string, id: string, name: string, phone: string }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }> } | null | undefined };

export type ContactFieldsFragment = { __typename?: 'AccountContact', email: string, id: string, name: string, phone: string };

export type GetContactsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContactsQuery = { __typename?: 'Query', contacts: Array<{ __typename?: 'AccountContact', email: string, id: string, name: string, phone: string }> };

export type CreateAccountMutationVariables = Exact<{
  input: CreateAccountInput;
}>;


export type CreateAccountMutation = { __typename?: 'Mutation', createAccount: { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } } };

export type UpdateAccountMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAccountInput;
}>;


export type UpdateAccountMutation = { __typename?: 'Mutation', updateAccount: { __typename?: 'Account', createdAt: Date, id: string, type: AccountType, account: { __typename?: 'BusinessAccount', dba: string, website: string, email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | { __typename?: 'IndividualAccount', email: string, name: string, phone: string, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } } };

export type CreateAgencyMutationVariables = Exact<{
  input: CreateAgencyInput;
}>;


export type CreateAgencyMutation = { __typename?: 'Mutation', createAgency: { __typename?: 'Agency', id: string } };

export type AgencyProfileHomeScreenFieldsFragment = { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> };

export type AppliedAgencyProfileFieldsFragment = { __typename?: 'AgencyProfile', id: string, name: string, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } };

export type AgencyProfileSummaryFieldsFragment = { __typename?: 'AgencyProfile', id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, teams: Array<{ __typename?: 'Team', id: string, name: string }> };

export type AgencyProfileAssignmentFieldsFragment = { __typename?: 'AgencyProfile', id: string, name: string, isDefault: boolean, users: Array<{ __typename?: 'AgencyUser', id: string }>, teams: Array<{ __typename?: 'Team', id: string }> };

export type AgencyProfileFieldsFragment = { __typename?: 'AgencyProfile', createdAt: Date, updatedAt: Date, id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, capabilities: Array<AgencyProfileCapability>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } }, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string }>, teams: Array<{ __typename?: 'Team', id: string, name: string }> };

export type AgencyProfileNavigationOptionFieldsFragment = { __typename?: 'AgencyProfileNavigationOption', item: NavigationItem, label: string };

export type GetAgencyProfilesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyProfilesQuery = { __typename?: 'Query', agencyProfiles: Array<{ __typename?: 'AgencyProfile', id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, teams: Array<{ __typename?: 'Team', id: string, name: string }> }> };

export type GetAgencyProfileAssignmentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyProfileAssignmentsQuery = { __typename?: 'Query', agencyProfiles: Array<{ __typename?: 'AgencyProfile', id: string, name: string, isDefault: boolean, users: Array<{ __typename?: 'AgencyUser', id: string }>, teams: Array<{ __typename?: 'Team', id: string }> }> };

export type GetAgencyProfileQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetAgencyProfileQuery = { __typename?: 'Query', agencyProfile?: { __typename?: 'AgencyProfile', createdAt: Date, updatedAt: Date, id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, capabilities: Array<AgencyProfileCapability>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } }, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string }>, teams: Array<{ __typename?: 'Team', id: string, name: string }> } | null | undefined };

export type GetAgencyProfileCapabilityCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyProfileCapabilityCatalogQuery = { __typename?: 'Query', agencyProfileCapabilityCatalog: { __typename?: 'AgencyProfileCapabilityCatalog', groups: Array<{ __typename?: 'AgencyProfileCapabilityGroup', title: string, hint: string, sections: Array<{ __typename?: 'AgencyProfileCapabilitySection', title: string, hint: string, capabilities: Array<{ __typename?: 'AgencyProfileCapabilityOption', capability: AgencyProfileCapability, label: string, hint: string, requires: Array<AgencyProfileCapability>, grants: Array<{ __typename?: 'AgencyProfilePermission', resource: Resource, actions: Array<Action> }>, navigation: Array<{ __typename?: 'AgencyProfileNavigationOption', item: NavigationItem, label: string }> }> }> }> } };

export type CreateAgencyProfileMutationVariables = Exact<{
  input: CreateAgencyProfileInput;
}>;


export type CreateAgencyProfileMutation = { __typename?: 'Mutation', createAgencyProfile: { __typename?: 'AgencyProfile', createdAt: Date, updatedAt: Date, id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, capabilities: Array<AgencyProfileCapability>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } }, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string }>, teams: Array<{ __typename?: 'Team', id: string, name: string }> } };

export type UpdateAgencyProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AgencyProfileInput;
}>;


export type UpdateAgencyProfileMutation = { __typename?: 'Mutation', updateAgencyProfile: { __typename?: 'AgencyProfile', createdAt: Date, updatedAt: Date, id: string, name: string, description: string, isDefault: boolean, assignedUserCount: number, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, capabilities: Array<AgencyProfileCapability>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } }, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string }>, teams: Array<{ __typename?: 'Team', id: string, name: string }> } };

export type ArchiveAgencyProfileMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveAgencyProfileMutation = { __typename?: 'Mutation', archiveAgencyProfile: { __typename?: 'AgencyProfile', id: string, archivedAt?: Date | null | undefined } };

export type AgencyProfileOptionFieldsFragment = { __typename?: 'AgencyProfile', id: string, name: string, description: string };

export type GetAgencyProfileOptionsQueryVariables = Exact<{
  agencyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAgencyProfileOptionsQuery = { __typename?: 'Query', agencyProfiles: Array<{ __typename?: 'AgencyProfile', id: string, name: string, description: string }> };

export type GetAgencyUserProfileOptionsQueryVariables = Exact<{
  agencyId?: InputMaybe<Scalars['ID']['input']>;
  agencyUserId: Scalars['ID']['input'];
}>;


export type GetAgencyUserProfileOptionsQuery = { __typename?: 'Query', agencyProfiles: Array<{ __typename?: 'AgencyProfile', id: string, name: string, description: string }>, agencyUserProfileAssignment?: { __typename?: 'AgencyUserProfileAssignment', source: AgencyProfileAssignmentSource, profile: { __typename?: 'AgencyProfile', id: string, name: string, description: string }, team?: { __typename?: 'Team', id: string, name: string } | null | undefined } | null | undefined };

export type ProducerInformationFieldsFragment = { __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } };

export type AgencySubscriptionFieldsFragment = { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean };

export type AgencySubscriptionUsageFieldsFragment = { __typename?: 'AgencySubscription', agencyId: string, platformUnitOverageLimitDollars?: number | null | undefined, kbPageOverageLimitDollars?: number | null | undefined, voiceMinuteOverageLimitDollars?: number | null | undefined, currentUsagePeriod?: { __typename?: 'AgencyUsagePeriod', start: Date, end: Date, daysTotal: number, daysElapsed: number, daysRemaining: number, usageCycle: UsageCycle } | null | undefined, currentUsageAllowances?: { __typename?: 'AgencyUsageAllowances', platformUnits: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, voiceMinutes: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, kbPages: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number } } | null | undefined, currentUsageReport?: { __typename?: 'AgencyUsageReport', timezone: string, platformUnits: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, voiceMinutes: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, kbPages: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> } } | null | undefined, currentOverageSpendStatus?: { __typename?: 'OverageSpendStatus', overageUnits: string, overageDollars: number, equivalentUnitsLimit?: string | null | undefined, percentOfLimit?: number | null | undefined, limitReached: boolean, alertThresholdReached: boolean } | null | undefined, currentOverageBillEstimate?: { __typename?: 'OverageBillEstimate', periodStart: Date, periodEnd: Date, estimatedChargeDate: Date, deliveryMethod: OverageDeliveryMethod, totalDollars: number, isEstimate: boolean, lineItems: Array<{ __typename?: 'OverageBillLineItem', meterCode: ConsumptionMeterCode, overageUnits: string, ratePerUnit: number, amountDollars: number }> } | null | undefined };

export type ChildAgencySubscriptionFieldsFragment = { __typename?: 'AgencySubscription', numSeats: number, numSeatsActive: number, numVoiceAgents: number, state: SubscriptionState };

export type ChildAgencyFieldsFragment = { __typename?: 'Agency', id: string, name: string, subscription?: { __typename?: 'AgencySubscription', numSeats: number, numSeatsActive: number, numVoiceAgents: number, state: SubscriptionState } | null | undefined, users: Array<{ __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }>, voiceAgents: Array<{ __typename?: 'VoiceAgent', id: string }> };

export type AcordFormConfigurationFieldsFragment = { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined };

export type AgencyFieldsFragment = { __typename?: 'Agency', id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined };

export type AgencyUserFieldsFragment = { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState };

export type LoggedInAgencyUserFieldsFragment = { __typename?: 'AgencyUser', lastViewedNewFeatures?: Date | null | undefined, settingsUsageTabEnabled: boolean, frontendFlags: Array<string>, highEffortEnabled: boolean, hasAccessibleMailbox: boolean, outboundCallsEnabled: boolean, id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState, teams: Array<{ __typename?: 'Team', id: string }>, profile?: { __typename?: 'AgencyProfile', id: string, name: string, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } } | null | undefined, permissions: Array<{ __typename?: 'Permission', scope: Scope, resource: Resource, action: Action }>, preferences: { __typename?: 'AgencyUserPreferences', overrideCOIConfigurationMode?: CoiConfigurationMode | null | undefined, memoryDisabled: boolean, desktopNotifications: { __typename?: 'AgencyUserDesktopNotificationPreferences', enabled: boolean, workspaceCompletionIntervalMinutes: number }, defaultVisibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, homePins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> }, agency: { __typename?: 'Agency', id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined } };

export type PreviewUpdateSubscriptionResultFieldsFragment = { __typename?: 'PreviewUpdateSubscriptionResult', checkoutUrl?: string | null | undefined, clientSecret?: string | null | undefined, invoicePreview?: { __typename?: 'UpdateSubscriptionInvoicePreview', subTotal: number, taxTotal: number, discountTotal: number, total: number, amountPaid: number, amountDue: number, isNextInvoice: boolean, lineItems: Array<{ __typename?: 'UpdateSubscriptionInvoicePreviewLineItem', name: string, quantity: number, unitAmount: number, totalAmount: number }> } | null | undefined };

export type GetAgencyUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyUserQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', lastViewedNewFeatures?: Date | null | undefined, settingsUsageTabEnabled: boolean, frontendFlags: Array<string>, highEffortEnabled: boolean, hasAccessibleMailbox: boolean, outboundCallsEnabled: boolean, id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState, teams: Array<{ __typename?: 'Team', id: string }>, profile?: { __typename?: 'AgencyProfile', id: string, name: string, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } } | null | undefined, permissions: Array<{ __typename?: 'Permission', scope: Scope, resource: Resource, action: Action }>, preferences: { __typename?: 'AgencyUserPreferences', overrideCOIConfigurationMode?: CoiConfigurationMode | null | undefined, memoryDisabled: boolean, desktopNotifications: { __typename?: 'AgencyUserDesktopNotificationPreferences', enabled: boolean, workspaceCompletionIntervalMinutes: number }, defaultVisibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, homePins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> }, agency: { __typename?: 'Agency', id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined } } | null | undefined };

export type GetDefaultAcordFormConfigurationQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDefaultAcordFormConfigurationQuery = { __typename?: 'Query', defaultACORDFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } };

export type AgencyUsageFieldsFragment = { __typename?: 'Agency', id: string, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string, roles: Array<Role>, state: AgencyUserState, platformUnitOverageLimitDollars?: number | null | undefined, currentOverageSpendStatus?: { __typename?: 'OverageSpendStatus', overageUnits: string, overageDollars: number, equivalentUnitsLimit?: string | null | undefined, percentOfLimit?: number | null | undefined, limitReached: boolean, alertThresholdReached: boolean } | null | undefined }>, subscription?: { __typename?: 'AgencySubscription', agencyId: string, platformUnitOverageLimitDollars?: number | null | undefined, kbPageOverageLimitDollars?: number | null | undefined, voiceMinuteOverageLimitDollars?: number | null | undefined, currentUsagePeriod?: { __typename?: 'AgencyUsagePeriod', start: Date, end: Date, daysTotal: number, daysElapsed: number, daysRemaining: number, usageCycle: UsageCycle } | null | undefined, currentUsageAllowances?: { __typename?: 'AgencyUsageAllowances', platformUnits: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, voiceMinutes: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, kbPages: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number } } | null | undefined, currentUsageReport?: { __typename?: 'AgencyUsageReport', timezone: string, platformUnits: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, voiceMinutes: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, kbPages: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> } } | null | undefined, currentOverageSpendStatus?: { __typename?: 'OverageSpendStatus', overageUnits: string, overageDollars: number, equivalentUnitsLimit?: string | null | undefined, percentOfLimit?: number | null | undefined, limitReached: boolean, alertThresholdReached: boolean } | null | undefined, currentOverageBillEstimate?: { __typename?: 'OverageBillEstimate', periodStart: Date, periodEnd: Date, estimatedChargeDate: Date, deliveryMethod: OverageDeliveryMethod, totalDollars: number, isEstimate: boolean, lineItems: Array<{ __typename?: 'OverageBillLineItem', meterCode: ConsumptionMeterCode, overageUnits: string, ratePerUnit: number, amountDollars: number }> } | null | undefined } | null | undefined };

export type GetAgencyUsageQueryVariables = Exact<{
  timezone?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetAgencyUsageQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', agency: { __typename?: 'Agency', id: string, users: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string, roles: Array<Role>, state: AgencyUserState, platformUnitOverageLimitDollars?: number | null | undefined, currentOverageSpendStatus?: { __typename?: 'OverageSpendStatus', overageUnits: string, overageDollars: number, equivalentUnitsLimit?: string | null | undefined, percentOfLimit?: number | null | undefined, limitReached: boolean, alertThresholdReached: boolean } | null | undefined }>, subscription?: { __typename?: 'AgencySubscription', agencyId: string, platformUnitOverageLimitDollars?: number | null | undefined, kbPageOverageLimitDollars?: number | null | undefined, voiceMinuteOverageLimitDollars?: number | null | undefined, currentUsagePeriod?: { __typename?: 'AgencyUsagePeriod', start: Date, end: Date, daysTotal: number, daysElapsed: number, daysRemaining: number, usageCycle: UsageCycle } | null | undefined, currentUsageAllowances?: { __typename?: 'AgencyUsageAllowances', platformUnits: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, voiceMinutes: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number }, kbPages: { __typename?: 'UsageMeterAllowance', meterCode: ConsumptionMeterCode, included: number, unitLabel: string, overageRatePerUnit: number } } | null | undefined, currentUsageReport?: { __typename?: 'AgencyUsageReport', timezone: string, platformUnits: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, voiceMinutes: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> }, kbPages: { __typename?: 'UsageMeterAmount', meterCode: ConsumptionMeterCode, used: string, daily: Array<{ __typename?: 'UsageMeterDailyAmount', date: Date, used: string }> } } | null | undefined, currentOverageSpendStatus?: { __typename?: 'OverageSpendStatus', overageUnits: string, overageDollars: number, equivalentUnitsLimit?: string | null | undefined, percentOfLimit?: number | null | undefined, limitReached: boolean, alertThresholdReached: boolean } | null | undefined, currentOverageBillEstimate?: { __typename?: 'OverageBillEstimate', periodStart: Date, periodEnd: Date, estimatedChargeDate: Date, deliveryMethod: OverageDeliveryMethod, totalDollars: number, isEstimate: boolean, lineItems: Array<{ __typename?: 'OverageBillLineItem', meterCode: ConsumptionMeterCode, overageUnits: string, ratePerUnit: number, amountDollars: number }> } | null | undefined } | null | undefined } } | null | undefined };

export type GetUsageOverageInvoicesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  cursor?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetUsageOverageInvoicesQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', agency: { __typename?: 'Agency', subscription?: { __typename?: 'AgencySubscription', usageOverageInvoices: { __typename?: 'UsageOverageInvoiceConnection', edges: Array<{ __typename?: 'UsageOverageInvoiceEdge', cursor: string, node: { __typename?: 'UsageOverageInvoice', id: string, periodStart: Date, periodEnd: Date, status: UsageOverageInvoiceStatus, totalDollars: number, hostedInvoiceUrl?: string | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } } | null | undefined } } | null | undefined };

export type GetAgencyUsageHistoryQueryVariables = Exact<{
  window: AgencyUsageWindow;
  timezone?: InputMaybe<Scalars['String']['input']>;
  startDay?: InputMaybe<Scalars['Time']['input']>;
  endDay?: InputMaybe<Scalars['Time']['input']>;
}>;


export type GetAgencyUsageHistoryQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', agency: { __typename?: 'Agency', subscription?: { __typename?: 'AgencySubscription', usageHistory?: { __typename?: 'AgencyUsageHistory', start: Date, end: Date, timezone: string, agencyTotals?: { __typename?: 'AgencyUsageHistoryTotals', voiceMinutes: number, kbPages: number } | null | undefined, platformUnitsByUser: Array<{ __typename?: 'AgencyUsageUserAmount', agencyUserId: string, used: string }> } | null | undefined } | null | undefined } } | null | undefined };

export type GetAgencyUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyUsersQuery = { __typename?: 'Query', agencyUsers: Array<{ __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }> };

export type GetChildAgenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetChildAgenciesQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', agency: { __typename?: 'Agency', childAgencies: Array<{ __typename?: 'Agency', id: string, name: string, subscription?: { __typename?: 'AgencySubscription', numSeats: number, numSeatsActive: number, numVoiceAgents: number, state: SubscriptionState } | null | undefined, users: Array<{ __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }>, voiceAgents: Array<{ __typename?: 'VoiceAgent', id: string }> }> } } | null | undefined };

export type UpdateAgencyUserPreferencesMutationVariables = Exact<{
  input: AgencyUserPreferencesInput;
}>;


export type UpdateAgencyUserPreferencesMutation = { __typename?: 'Mutation', updateAgencyUserPreferences: { __typename?: 'AgencyUser', lastViewedNewFeatures?: Date | null | undefined, settingsUsageTabEnabled: boolean, frontendFlags: Array<string>, highEffortEnabled: boolean, hasAccessibleMailbox: boolean, outboundCallsEnabled: boolean, id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState, teams: Array<{ __typename?: 'Team', id: string }>, profile?: { __typename?: 'AgencyProfile', id: string, name: string, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } } | null | undefined, permissions: Array<{ __typename?: 'Permission', scope: Scope, resource: Resource, action: Action }>, preferences: { __typename?: 'AgencyUserPreferences', overrideCOIConfigurationMode?: CoiConfigurationMode | null | undefined, memoryDisabled: boolean, desktopNotifications: { __typename?: 'AgencyUserDesktopNotificationPreferences', enabled: boolean, workspaceCompletionIntervalMinutes: number }, defaultVisibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, homePins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> }, agency: { __typename?: 'Agency', id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined } } };

export type CreateAgencyUserMutationVariables = Exact<{
  input: AgencyUserInput;
}>;


export type CreateAgencyUserMutation = { __typename?: 'Mutation', createAgencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type CreateAgencyUsersMutationVariables = Exact<{
  inputs: Array<AgencyUserImportInput> | AgencyUserImportInput;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateAgencyUsersMutation = { __typename?: 'Mutation', createAgencyUsers: Array<{ __typename?: 'AgencyUserImportResult', email: string, error?: string | null | undefined, user?: { __typename?: 'AgencyUser', id: string } | null | undefined }> };

export type UpdateAgencyUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAgencyUserInput;
}>;


export type UpdateAgencyUserMutation = { __typename?: 'Mutation', updateAgencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type DisableAgencyUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisableAgencyUserMutation = { __typename?: 'Mutation', disableAgencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type EnableAgencyUserMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EnableAgencyUserMutation = { __typename?: 'Mutation', enableAgencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type GetSubscriptionUpdateLinkQueryVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type GetSubscriptionUpdateLinkQuery = { __typename?: 'Query', subscriptionManagementLinks?: { __typename?: 'SubscriptionManagementLinks', previewUpdateSubscription: { __typename?: 'PreviewUpdateSubscriptionResult', checkoutUrl?: string | null | undefined, clientSecret?: string | null | undefined, invoicePreview?: { __typename?: 'UpdateSubscriptionInvoicePreview', subTotal: number, taxTotal: number, discountTotal: number, total: number, amountPaid: number, amountDue: number, isNextInvoice: boolean, lineItems: Array<{ __typename?: 'UpdateSubscriptionInvoicePreviewLineItem', name: string, quantity: number, unitAmount: number, totalAmount: number }> } | null | undefined } } | null | undefined };

export type GetSubscriptionUpdatePaymentLinkQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSubscriptionUpdatePaymentLinkQuery = { __typename?: 'Query', subscriptionManagementLinks?: { __typename?: 'SubscriptionManagementLinks', updatePaymentMethodUrl: string } | null | undefined };

export type UpdateSubscriptionMutationVariables = Exact<{
  input: UpdateSubscriptionInput;
}>;


export type UpdateSubscriptionMutation = { __typename?: 'Mutation', updateSubscription: { __typename?: 'AgencySubscription', plan?: SubscriptionPlan | null | undefined, period?: SubscriptionPeriod | null | undefined, numSeats: number, numVoiceAgents: number } };

export type DismissStandardSunsetRenewalBannerMutationVariables = Exact<{ [key: string]: never; }>;


export type DismissStandardSunsetRenewalBannerMutation = { __typename?: 'Mutation', dismissStandardSunsetRenewalBanner: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } };

export type ConfirmAnnualRenewalMutationVariables = Exact<{ [key: string]: never; }>;


export type ConfirmAnnualRenewalMutation = { __typename?: 'Mutation', confirmAnnualRenewal: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } };

export type CreateAgencyUserForAgencyMutationVariables = Exact<{
  agencyId: Scalars['ID']['input'];
  input: AgencyUserInput;
}>;


export type CreateAgencyUserForAgencyMutation = { __typename?: 'Mutation', createAgencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type UpdateLastViewedNewFeaturesMutationVariables = Exact<{ [key: string]: never; }>;


export type UpdateLastViewedNewFeaturesMutation = { __typename?: 'Mutation', updateLastViewedNewFeatures: Date };

export type UpdateAgencyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateAgencyInput;
}>;


export type UpdateAgencyMutation = { __typename?: 'Mutation', updateAgency: { __typename?: 'Agency', id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined } };

export type GetAgencyProducerInformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyProducerInformationsQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', agency: { __typename?: 'Agency', producerInformations: Array<{ __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } } | null | undefined };

export type CreateAgencyProducerInformationMutationVariables = Exact<{
  agencyId: Scalars['ID']['input'];
  input: ProducerInformationInput;
}>;


export type CreateAgencyProducerInformationMutation = { __typename?: 'Mutation', createAgencyProducerInformation: { __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } };

export type UpdateProducerInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ProducerInformationInput;
}>;


export type UpdateProducerInformationMutation = { __typename?: 'Mutation', updateProducerInformation: { __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } };

export type DeleteProducerInformationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteProducerInformationMutation = { __typename?: 'Mutation', deleteProducerInformation: boolean };

export type GetUserProducerInformationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserProducerInformationsQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', producerInformations: Array<{ __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined };

export type CreateAgencyUserProducerInformationMutationVariables = Exact<{
  agencyUserId: Scalars['ID']['input'];
  input: ProducerInformationInput;
}>;


export type CreateAgencyUserProducerInformationMutation = { __typename?: 'Mutation', createAgencyUserProducerInformation: { __typename?: 'ProducerInformation', id: string, isDefault: boolean, agencyName: string, contactName: string, contactEmail: string, contactPhone: string, contactFax: string, producerName: string, nationalProducerNumber: string, floridaLicenseNumber: string, producerSignatureJpegBase64: string, createdAt: Date, updatedAt: Date, agencyAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } };

export type SetAgencyMeterOverageLimitMutationVariables = Exact<{
  agencyId: Scalars['ID']['input'];
  meterCode: ConsumptionMeterCode;
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SetAgencyMeterOverageLimitMutation = { __typename?: 'Mutation', setAgencyMeterOverageLimit: { __typename?: 'AgencySubscription', agencyId: string, platformUnitOverageLimitDollars?: number | null | undefined, kbPageOverageLimitDollars?: number | null | undefined, voiceMinuteOverageLimitDollars?: number | null | undefined } };

export type SetAgencyUserOverageLimitMutationVariables = Exact<{
  agencyUserId: Scalars['ID']['input'];
  limitDollars?: InputMaybe<Scalars['Float']['input']>;
}>;


export type SetAgencyUserOverageLimitMutation = { __typename?: 'Mutation', setAgencyUserOverageLimit: { __typename?: 'AgencyUser', id: string, platformUnitOverageLimitDollars?: number | null | undefined } };

export type AgencyBrandRenderFieldsFragment = { __typename?: 'AgencyBrand', id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> };

export type AgencyBrandFieldsFragment = { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> };

export type AgencyDesignPageFieldsFragment = { __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined };

export type AgencyDesignIncludedPagesFieldsFragment = { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> };

export type AgencyDesignFieldsFragment = { __typename?: 'AgencyDesign', id: string, name: string, isDefault: boolean, updatedAt: Date, convertedFromStyle?: { __typename?: 'HtmlDocumentTemplate', id: string, title: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, brand: { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> }, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } };

export type GetAgencyDesignsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyDesignsQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, brand: { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> }, designs: Array<{ __typename?: 'AgencyDesign', id: string, name: string, isDefault: boolean, updatedAt: Date, convertedFromStyle?: { __typename?: 'HtmlDocumentTemplate', id: string, title: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, brand: { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> }, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } }>, defaultDesign?: { __typename?: 'AgencyDesign', id: string } | null | undefined } | null | undefined, brandTypefaces: Array<{ __typename?: 'BrandTypeface', family: string, metricAlias?: string | null | undefined, cssStack: string }>, brandColorSchemes: Array<{ __typename?: 'BrandColorScheme', key: string, name: string, note: string, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string } }>, brandElementDefaults: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> };

export type UploadAgencyBrandLogoMutationVariables = Exact<{
  file: UploadFileInput;
}>;


export type UploadAgencyBrandLogoMutation = { __typename?: 'Mutation', uploadAgencyBrandLogo: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } };

export type UploadAgencyDesignPageMutationVariables = Exact<{
  file: UploadFileInput;
}>;


export type UploadAgencyDesignPageMutation = { __typename?: 'Mutation', uploadAgencyDesignPage: { __typename?: 'File', id: string, name: string, mimeType: string } };

export type CreateAgencyDesignMutationVariables = Exact<{
  input: AgencyDesignInput;
}>;


export type CreateAgencyDesignMutation = { __typename?: 'Mutation', createAgencyDesign: { __typename?: 'AgencyDesign', id: string, name: string, isDefault: boolean, updatedAt: Date, convertedFromStyle?: { __typename?: 'HtmlDocumentTemplate', id: string, title: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, brand: { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> }, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } };

export type UpdateAgencyDesignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AgencyDesignInput;
}>;


export type UpdateAgencyDesignMutation = { __typename?: 'Mutation', updateAgencyDesign: { __typename?: 'AgencyDesign', id: string, name: string, isDefault: boolean, updatedAt: Date, convertedFromStyle?: { __typename?: 'HtmlDocumentTemplate', id: string, title: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, brand: { __typename?: 'AgencyBrand', configured: boolean, updatedAt?: Date | null | undefined, id?: string | null | undefined, bodyTypeface: string, headingTypeface: string, voice?: { __typename?: 'BrandVoice', terminology?: string | null | undefined, tone?: string | null | undefined, avoid?: string | null | undefined } | null | undefined, palette: { __typename?: 'BrandPalette', primaryHex: string, secondaryHex: string, accentHex: string, surfaceHex: string, textHex: string }, margins?: { __typename?: 'BrandMargins', enabled?: boolean | null | undefined, topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } | null | undefined, header?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, footer?: { __typename?: 'BrandSlots', enabled?: boolean | null | undefined, left?: string | null | undefined, center?: string | null | undefined, right?: string | null | undefined, leftLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, centerLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined, rightLogo?: { __typename?: 'BrandSlotLogo', variant: BrandLogoVariant, maxHeightPt?: number | null | undefined } | null | undefined } | null | undefined, logos: Array<{ __typename?: 'BrandLogo', variant: BrandLogoVariant, file: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } }>, elements: Array<{ __typename?: 'BrandElementStyle', element: BrandElement, fontFamily?: string | null | undefined, sizePt?: number | null | undefined, lineHeight?: number | null | undefined, spaceAbovePt?: number | null | undefined, spaceBelowPt?: number | null | undefined, bold?: boolean | null | undefined, italic?: boolean | null | undefined, colorRole?: BrandColorRole | null | undefined, fillRole?: BrandColorRole | null | undefined, linesKeptAtBottom?: number | null | undefined, linesKeptAtTop?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }> }, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } };

export type DuplicateAgencyDesignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DuplicateAgencyDesignMutation = { __typename?: 'Mutation', duplicateAgencyDesign: { __typename?: 'AgencyDesign', id: string } };

export type ArchiveAgencyDesignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveAgencyDesignMutation = { __typename?: 'Mutation', archiveAgencyDesign: { __typename?: 'AgencyDesign', id: string, archived: boolean } };

export type SetDefaultAgencyDesignMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultAgencyDesignMutation = { __typename?: 'Mutation', setDefaultAgencyDesign: { __typename?: 'AgencyDesign', id: string, isDefault: boolean } };

export type GetAgencyDesignChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyDesignChoicesQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, designs: Array<{ __typename?: 'AgencyDesign', id: string, name: string, isDefault: boolean, visibility: { __typename?: 'VisibilityConfig', level: Visibility }, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } }> } | null | undefined };

export type AmsRefFieldsFragment = { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined };

export type AmsBrowsePageFieldsFragment = { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined };

export type AmsBrowseCapabilitiesQueryVariables = Exact<{ [key: string]: never; }>;


export type AmsBrowseCapabilitiesQuery = { __typename?: 'Query', amsBrowseCapabilities: Array<{ __typename?: 'AmsBrowseCapability', integrationId: string, integrationType: IntegrationType, displayName: string, pickableKinds: Array<AmsRefKind>, filesBrowsable: boolean }> };

export type AmsBrowseAccountsQueryVariables = Exact<{
  input: AmsBrowseAccountsInput;
}>;


export type AmsBrowseAccountsQuery = { __typename?: 'Query', amsBrowseAccounts: { __typename?: 'AmsBrowseAccountsResult', accounts: Array<{ __typename?: 'AmsBrowseAccount', name: string, lookupCode?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }>, page: { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined } } };

export type AmsBrowsePolicyFieldsFragment = { __typename?: 'AmsBrowsePolicy', policyNumber?: string | null | undefined, carrier?: string | null | undefined, lineOfBusiness?: string | null | undefined, status?: string | null | undefined, expirationDate?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } };

export type AmsBrowseAccountFieldsFragment = { __typename?: 'AmsBrowseAccount', name: string, lookupCode?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } };

export type AmsBrowsePolicySearchQueryVariables = Exact<{
  input: AmsBrowsePolicySearchInput;
}>;


export type AmsBrowsePolicySearchQuery = { __typename?: 'Query', amsBrowsePolicySearch: { __typename?: 'AmsBrowsePolicySearchResult', matches: Array<{ __typename?: 'AmsBrowsePolicyMatch', policy: { __typename?: 'AmsBrowsePolicy', policyNumber?: string | null | undefined, carrier?: string | null | undefined, lineOfBusiness?: string | null | undefined, status?: string | null | undefined, expirationDate?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }, account?: { __typename?: 'AmsBrowseAccount', name: string, lookupCode?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined }>, page: { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined } } };

export type AmsBrowsePoliciesQueryVariables = Exact<{
  input: AmsBrowsePoliciesInput;
}>;


export type AmsBrowsePoliciesQuery = { __typename?: 'Query', amsBrowsePolicies: { __typename?: 'AmsBrowsePoliciesResult', policies: Array<{ __typename?: 'AmsBrowsePolicy', policyNumber?: string | null | undefined, carrier?: string | null | undefined, lineOfBusiness?: string | null | undefined, status?: string | null | undefined, expirationDate?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }>, page: { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined } } };

export type AmsBrowseCertificatesQueryVariables = Exact<{
  input: AmsBrowseCertificatesInput;
}>;


export type AmsBrowseCertificatesQuery = { __typename?: 'Query', amsBrowseCertificates: { __typename?: 'AmsBrowseCertificatesResult', certificates: Array<{ __typename?: 'AmsBrowseCertificate', title?: string | null | undefined, holder?: string | null | undefined, issuedAt?: Date | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }>, page: { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined } } };

export type AmsBrowseFilesQueryVariables = Exact<{
  input: AmsBrowseFilesInput;
}>;


export type AmsBrowseFilesQuery = { __typename?: 'Query', amsBrowseFiles: { __typename?: 'AmsBrowseFilesResult', files: Array<{ __typename?: 'AmsBrowseFile', title: string, extension?: string | null | undefined, attachedAt?: Date | null | undefined, folderPath?: string | null | undefined, selectable: boolean, unselectableReason?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }>, page: { __typename?: 'AmsBrowsePage', nextCursor?: string | null | undefined, total?: number | null | undefined } } };

export type AmsBrowseFoldersQueryVariables = Exact<{
  input: AmsBrowseFoldersInput;
}>;


export type AmsBrowseFoldersQuery = { __typename?: 'Query', amsBrowseFolders: Array<{ __typename?: 'AmsBrowseFolder', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> };

export type AmsBrowseActivitiesQueryVariables = Exact<{
  input: AmsBrowseActivitiesInput;
}>;


export type AmsBrowseActivitiesQuery = { __typename?: 'Query', amsBrowseActivities: Array<{ __typename?: 'AmsBrowseActivity', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> };

export type AmsAccountSearchResultFieldsFragment = { __typename?: 'KnowledgeGraphEntity', id: string, externalId: string, displayName: string, modifiedAt: Date, searchMetadata: { __typename?: 'KnowledgeGraphEntitySearchMetadata', account?: { __typename?: 'KnowledgeGraphEntitySearchMetadataAccount', email?: string | null | undefined, phone?: string | null | undefined, lookupCode?: string | null | undefined } | null | undefined }, integration: { __typename?: 'Integration', id: string, type: IntegrationType } };

export type SearchAmsAccountsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchAmsAccountsQuery = { __typename?: 'Query', searchAmsAccounts: { __typename?: 'AmsAccountSearchResult', noSupportedAms: boolean, entities: Array<{ __typename?: 'KnowledgeGraphEntity', id: string, externalId: string, displayName: string, modifiedAt: Date, searchMetadata: { __typename?: 'KnowledgeGraphEntitySearchMetadata', account?: { __typename?: 'KnowledgeGraphEntitySearchMetadataAccount', email?: string | null | undefined, phone?: string | null | undefined, lookupCode?: string | null | undefined } | null | undefined }, integration: { __typename?: 'Integration', id: string, type: IntegrationType } }> } };

export type RequestAmsAccountRefreshMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
  force: Scalars['Boolean']['input'];
  scope?: InputMaybe<AmsAccountSyncScope>;
}>;


export type RequestAmsAccountRefreshMutation = { __typename?: 'Mutation', requestAmsAccountRefresh: { __typename?: 'RequestAmsAccountRefreshResult', enqueued: boolean, syncedAt: Date } };

export type AmsFieldVerdictFieldsFragment = { __typename?: 'AmsFieldVerdict', itemKey?: string | null | undefined, fieldPath: string, fieldLabel: string, fieldName: string, outcome: AmsVerdictOutcome, comparison: AmsFieldComparison, currentValue?: string | null | undefined, proposedValue?: string | null | undefined, sourceQuote: string, recommendedAction?: string | null | undefined, readOnlyReason?: string | null | undefined, itemReadOnlyReason?: string | null | undefined, matchedOn?: string | null | undefined, optionsId?: string | null | undefined, optionsDependOn?: string | null | undefined, placement: Array<{ __typename?: 'AmsPlacementLevel', key: string, label: string, display: AmsSectionDisplay, itemDisplay: AmsItemDisplay, record: boolean, matchedOn?: string | null | undefined, readOnlyReason?: string | null | undefined }>, optionsByValue: Array<{ __typename?: 'AmsOptionsChoice', value: string, optionsId: string }> };

export type AmsCodeListFieldsFragment = { __typename?: 'AmsCodeList', lookupType: string, options: Array<{ __typename?: 'AmsCodeOption', code: string, label: string }> };

export type RunAmsReconciliationMutationVariables = Exact<{
  input: RunAmsReconciliationInput;
}>;


export type RunAmsReconciliationMutation = { __typename?: 'Mutation', runAmsReconciliation: { __typename?: 'AmsReconciliationResult', verdicts: Array<{ __typename?: 'AmsFieldVerdict', itemKey?: string | null | undefined, fieldPath: string, fieldLabel: string, fieldName: string, outcome: AmsVerdictOutcome, comparison: AmsFieldComparison, currentValue?: string | null | undefined, proposedValue?: string | null | undefined, sourceQuote: string, recommendedAction?: string | null | undefined, readOnlyReason?: string | null | undefined, itemReadOnlyReason?: string | null | undefined, matchedOn?: string | null | undefined, optionsId?: string | null | undefined, optionsDependOn?: string | null | undefined, placement: Array<{ __typename?: 'AmsPlacementLevel', key: string, label: string, display: AmsSectionDisplay, itemDisplay: AmsItemDisplay, record: boolean, matchedOn?: string | null | undefined, readOnlyReason?: string | null | undefined }>, optionsByValue: Array<{ __typename?: 'AmsOptionsChoice', value: string, optionsId: string }> }>, codeLists: Array<{ __typename?: 'AmsCodeList', lookupType: string, options: Array<{ __typename?: 'AmsCodeOption', code: string, label: string }> }> } };

export type AmsDetectedEntitiesFieldsFragment = { __typename?: 'AmsDetectedEntities', accountName?: string | null | undefined, accountEmail?: string | null | undefined, accountPhone?: string | null | undefined, policyNumber?: string | null | undefined, generalLiability: boolean, businessAuto: boolean, commercialProperty: boolean, workersCompensation: boolean, personalAuto: boolean, homeowner: boolean, personalUmbrella: boolean, applicant: boolean, contactFirstName?: string | null | undefined, contactLastName?: string | null | undefined };

export type AmsAccountMatchFieldsFragment = { __typename?: 'AmsAccountMatch', integrationId: string, externalId: string, lookupCode?: string | null | undefined, accountCode?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, reason: AmsAccountMatchReason, accountId?: string | null | undefined };

export type AmsReconciliationTargetFieldsFragment = { __typename?: 'AmsReconciliationTarget', id: string, lineOfBusiness?: AmsReconciliationLineOfBusiness | null | undefined, available: boolean, writable: boolean, policyId?: string | null | undefined, label: string, detail?: string | null | undefined, detectedFromDocument: boolean, policyGroup?: { __typename?: 'AmsReconciliationPolicyGroup', id: string, label: string, detail?: string | null | undefined } | null | undefined };

export type PrepareAmsReconciliationMutationVariables = Exact<{
  input: PrepareAmsReconciliationInput;
}>;


export type PrepareAmsReconciliationMutation = { __typename?: 'Mutation', prepareAmsReconciliation: { __typename?: 'AmsReconciliationPrep', startingState: AmsReconciliationStartingState, integrationId?: string | null | undefined, detected: { __typename?: 'AmsDetectedEntities', accountName?: string | null | undefined, accountEmail?: string | null | undefined, accountPhone?: string | null | undefined, policyNumber?: string | null | undefined, generalLiability: boolean, businessAuto: boolean, commercialProperty: boolean, workersCompensation: boolean, personalAuto: boolean, homeowner: boolean, personalUmbrella: boolean, applicant: boolean, contactFirstName?: string | null | undefined, contactLastName?: string | null | undefined }, workspaceClientAccount?: { __typename?: 'AmsAccountMatch', integrationId: string, externalId: string, lookupCode?: string | null | undefined, accountCode?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, reason: AmsAccountMatchReason, accountId?: string | null | undefined } | null | undefined, suggestedAccounts: Array<{ __typename?: 'AmsAccountMatch', integrationId: string, externalId: string, lookupCode?: string | null | undefined, accountCode?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, reason: AmsAccountMatchReason, accountId?: string | null | undefined }>, newAccountTargets: Array<{ __typename?: 'AmsReconciliationTarget', id: string, lineOfBusiness?: AmsReconciliationLineOfBusiness | null | undefined, available: boolean, writable: boolean, policyId?: string | null | undefined, label: string, detail?: string | null | undefined, detectedFromDocument: boolean, policyGroup?: { __typename?: 'AmsReconciliationPolicyGroup', id: string, label: string, detail?: string | null | undefined } | null | undefined }> } };

export type AmsReconciliationTargetsQueryVariables = Exact<{
  input: AmsReconciliationTargetsInput;
}>;


export type AmsReconciliationTargetsQuery = { __typename?: 'Query', amsReconciliationTargets: { __typename?: 'AmsReconciliationTargets', syncing: boolean, targets: Array<{ __typename?: 'AmsReconciliationTarget', id: string, lineOfBusiness?: AmsReconciliationLineOfBusiness | null | undefined, available: boolean, writable: boolean, policyId?: string | null | undefined, label: string, detail?: string | null | undefined, detectedFromDocument: boolean, policyGroup?: { __typename?: 'AmsReconciliationPolicyGroup', id: string, label: string, detail?: string | null | undefined } | null | undefined }> } };

export type ImportAmsAccountByExternalIdMutationVariables = Exact<{
  input: ImportAmsAccountByExternalIdInput;
}>;


export type ImportAmsAccountByExternalIdMutation = { __typename?: 'Mutation', importAmsAccountByExternalId: { __typename?: 'ImportAmsAccountResult', accountId: string, displayName?: string | null | undefined, syncing: boolean } };

export type CreateAmsAccountMutationVariables = Exact<{
  input: CreateAmsAccountInput;
}>;


export type CreateAmsAccountMutation = { __typename?: 'Mutation', createAmsAccount: { __typename?: 'ImportAmsAccountResult', accountId: string, displayName?: string | null | undefined, syncing: boolean } };

export type ApplyAmsReconciliationMutationVariables = Exact<{
  input: ApplyAmsReconciliationInput;
}>;


export type ApplyAmsReconciliationMutation = { __typename?: 'Mutation', applyAmsReconciliation: { __typename?: 'AmsApplyResult', written: number, refused: Array<{ __typename?: 'AmsRefusedChange', itemKey?: string | null | undefined, parentKeys: Array<string>, fieldPath: string, kind: AmsRefusalKind, message: string }> } };

export type SearchAmsAccountsLiveQueryVariables = Exact<{
  input: SearchAmsAccountsLiveInput;
}>;


export type SearchAmsAccountsLiveQuery = { __typename?: 'Query', searchAmsAccountsLive: Array<{ __typename?: 'AmsAccountMatch', integrationId: string, externalId: string, lookupCode?: string | null | undefined, accountCode?: string | null | undefined, displayName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, reason: AmsAccountMatchReason, accountId?: string | null | undefined }> };

export type AmsAgencyStructureQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
}>;


export type AmsAgencyStructureQuery = { __typename?: 'Query', amsAgencyStructure: Array<{ __typename?: 'AmsAgency', code: string, label: string, branches: Array<{ __typename?: 'AmsCodeOption', code: string, label: string }> }> };

export type AdminAnalyticsPresetUsageFieldsFragment = { __typename?: 'AdminAnalyticsPresetUsage', key: string, label: string, isCustomPreset: boolean, customPresetArchived: boolean, workspaceCount: number, overTime: Array<{ __typename?: 'AdminAnalyticsPresetWeek', weekStart: Date, workspaceCount: number }>, users: Array<{ __typename?: 'AdminAnalyticsPresetUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, workspaceCount: number, lastUsedAt: Date }>, withoutUser?: { __typename?: 'AdminAnalyticsPresetWithoutUser', workspaceCount: number, lastUsedAt: Date } | null | undefined };

export type AdminAnalyticsReportFieldsFragment = { __typename?: 'AdminAnalyticsReport', generatedAt: Date, dateRange: { __typename?: 'AdminAnalyticsDateRange', after?: Date | null | undefined, before?: Date | null | undefined }, totals: { __typename?: 'AdminAnalyticsTotals', totalUsers: number, activeUsers: number, inactiveUsers: number, activeDefinition: string, totalActivities: number, totalWorkspaces: number, totalCalls: number, totalEmails: number, totalKnowledgeBaseUploads: number, totalKnowledgeBasePages: number, totalPagesReviewed: number, totalTemplateReferences: number }, timeSavings: { __typename?: 'AdminAnalyticsTimeSavings', totalMinutes: number, breakdown: Array<{ __typename?: 'AdminAnalyticsTimeSavingsBreakdown', category: AdminAnalyticsTimeSavingsCategory, label: string, minutes: number, activityCount: number }> }, incrementalRevenue: { __typename?: 'AdminAnalyticsIncrementalRevenue', clientsConsidered: number, expectedIncrementalAccounts: number, avgCloseLikelihood: number, commissionRate: number }, activityOverTime: Array<{ __typename?: 'AdminAnalyticsActivityBucket', periodStart: Date, activityType: AdminAnalyticsActivityType, count: number }>, userUsage: Array<{ __typename?: 'AdminAnalyticsUserUsage', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, knowledgeBaseUploadCount: number }>, activeUsers: Array<{ __typename?: 'AdminAnalyticsActiveUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, usedWorkspace: boolean, usedEmail: boolean, createdArtifact: boolean, addedToKnowledgeBase: boolean, loggedIn: boolean, isActive: boolean }>, workspaceBreakdown: Array<{ __typename?: 'AdminAnalyticsWorkspaceBreakdown', label: string, preset?: string | null | undefined, key: string, customPreset?: string | null | undefined, state?: string | null | undefined, count: number, customPresetArchived: boolean }>, templateBreakdown: Array<{ __typename?: 'AdminAnalyticsTemplateBreakdown', label: string, templateType: string, count: number }>, templateLibrary: { __typename?: 'AdminAnalyticsTemplateLibrary', customFormCount: number, htmlTemplateCount: number, wordTemplateCount: number }, kbDocumentHistory: Array<{ __typename?: 'AdminAnalyticsKBSnapshot', periodStart: Date, documentCount: number }>, toolBreakdown: Array<{ __typename?: 'AdminAnalyticsToolBreakdown', toolType: string, label: string, count: number }>, workspaceStats: { __typename?: 'AdminAnalyticsWorkspaceStats', totalWorkspaces: number, avgToolCallsPerWorkspace: number, medianToolCallsPerWorkspace: number, p90ToolCallsPerWorkspace: number, maxToolCallsPerWorkspace: number, avgArtifactsPerWorkspace: number, medianArtifactsPerWorkspace: number, p90ArtifactsPerWorkspace: number, maxArtifactsPerWorkspace: number, avgPagesPerWorkspace: number, medianPagesPerWorkspace: number, p90PagesPerWorkspace: number, maxPagesPerWorkspace: number, toolCallDistribution: Array<{ __typename?: 'AdminAnalyticsHistogramBucket', label: string, count: number }> }, kbSearchUsage: { __typename?: 'AdminAnalyticsKBSearchUsage', totalSearches: number, searcherCount: number, perUser: Array<{ __typename?: 'AdminAnalyticsKBSearchPerUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, searchCount: number }> }, amsWrites: { __typename?: 'AdminAnalyticsAmsWrites', hasIntegration: boolean, recordingStartedAt?: Date | null | undefined, voiceAiExcluded: boolean, succeeded: number, failed: number, bySource: Array<{ __typename?: 'AdminAnalyticsAmsWriteSource', source: AdminAnalyticsAmsWriteSourceType, succeeded: number }>, byIntegration: Array<{ __typename?: 'AdminAnalyticsAmsWriteIntegration', integrationType: IntegrationType, succeeded: number, failed: number }>, byRecordType: Array<{ __typename?: 'AdminAnalyticsAmsWriteRecordType', recordType: string, label: string, succeeded: number }>, overTime: Array<{ __typename?: 'AdminAnalyticsAmsWritePeriod', periodStart: Date, succeeded: number, failed: number, recorded: boolean }> }, presetRankings: { __typename?: 'AdminAnalyticsPresetRankings', weekCount: number, previousPeriod?: { __typename?: 'AdminAnalyticsPreviousPeriod', after: Date, before: Date } | null | undefined, presets: Array<{ __typename?: 'AdminAnalyticsPresetRanking', rank: number, previousRank?: number | null | undefined, usage: { __typename?: 'AdminAnalyticsPresetUsage', key: string, label: string, isCustomPreset: boolean, customPresetArchived: boolean, workspaceCount: number, overTime: Array<{ __typename?: 'AdminAnalyticsPresetWeek', weekStart: Date, workspaceCount: number }>, users: Array<{ __typename?: 'AdminAnalyticsPresetUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, workspaceCount: number, lastUsedAt: Date }>, withoutUser?: { __typename?: 'AdminAnalyticsPresetWithoutUser', workspaceCount: number, lastUsedAt: Date } | null | undefined } }>, noPreset?: { __typename?: 'AdminAnalyticsPresetUsage', key: string, label: string, isCustomPreset: boolean, customPresetArchived: boolean, workspaceCount: number, overTime: Array<{ __typename?: 'AdminAnalyticsPresetWeek', weekStart: Date, workspaceCount: number }>, users: Array<{ __typename?: 'AdminAnalyticsPresetUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, workspaceCount: number, lastUsedAt: Date }>, withoutUser?: { __typename?: 'AdminAnalyticsPresetWithoutUser', workspaceCount: number, lastUsedAt: Date } | null | undefined } | null | undefined }, unfilteredSections: Array<{ __typename?: 'AdminAnalyticsUnfilteredSection', section: AdminAnalyticsSection, filters: Array<AdminAnalyticsSegmentFilter> }> };

export type GetAdminAnalyticsReportQueryVariables = Exact<{
  filter?: InputMaybe<AdminAnalyticsFilterInput>;
}>;


export type GetAdminAnalyticsReportQuery = { __typename?: 'Query', adminAnalyticsReport: { __typename?: 'AdminAnalyticsReport', generatedAt: Date, dateRange: { __typename?: 'AdminAnalyticsDateRange', after?: Date | null | undefined, before?: Date | null | undefined }, totals: { __typename?: 'AdminAnalyticsTotals', totalUsers: number, activeUsers: number, inactiveUsers: number, activeDefinition: string, totalActivities: number, totalWorkspaces: number, totalCalls: number, totalEmails: number, totalKnowledgeBaseUploads: number, totalKnowledgeBasePages: number, totalPagesReviewed: number, totalTemplateReferences: number }, timeSavings: { __typename?: 'AdminAnalyticsTimeSavings', totalMinutes: number, breakdown: Array<{ __typename?: 'AdminAnalyticsTimeSavingsBreakdown', category: AdminAnalyticsTimeSavingsCategory, label: string, minutes: number, activityCount: number }> }, incrementalRevenue: { __typename?: 'AdminAnalyticsIncrementalRevenue', clientsConsidered: number, expectedIncrementalAccounts: number, avgCloseLikelihood: number, commissionRate: number }, activityOverTime: Array<{ __typename?: 'AdminAnalyticsActivityBucket', periodStart: Date, activityType: AdminAnalyticsActivityType, count: number }>, userUsage: Array<{ __typename?: 'AdminAnalyticsUserUsage', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, knowledgeBaseUploadCount: number }>, activeUsers: Array<{ __typename?: 'AdminAnalyticsActiveUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, usedWorkspace: boolean, usedEmail: boolean, createdArtifact: boolean, addedToKnowledgeBase: boolean, loggedIn: boolean, isActive: boolean }>, workspaceBreakdown: Array<{ __typename?: 'AdminAnalyticsWorkspaceBreakdown', label: string, preset?: string | null | undefined, key: string, customPreset?: string | null | undefined, state?: string | null | undefined, count: number, customPresetArchived: boolean }>, templateBreakdown: Array<{ __typename?: 'AdminAnalyticsTemplateBreakdown', label: string, templateType: string, count: number }>, templateLibrary: { __typename?: 'AdminAnalyticsTemplateLibrary', customFormCount: number, htmlTemplateCount: number, wordTemplateCount: number }, kbDocumentHistory: Array<{ __typename?: 'AdminAnalyticsKBSnapshot', periodStart: Date, documentCount: number }>, toolBreakdown: Array<{ __typename?: 'AdminAnalyticsToolBreakdown', toolType: string, label: string, count: number }>, workspaceStats: { __typename?: 'AdminAnalyticsWorkspaceStats', totalWorkspaces: number, avgToolCallsPerWorkspace: number, medianToolCallsPerWorkspace: number, p90ToolCallsPerWorkspace: number, maxToolCallsPerWorkspace: number, avgArtifactsPerWorkspace: number, medianArtifactsPerWorkspace: number, p90ArtifactsPerWorkspace: number, maxArtifactsPerWorkspace: number, avgPagesPerWorkspace: number, medianPagesPerWorkspace: number, p90PagesPerWorkspace: number, maxPagesPerWorkspace: number, toolCallDistribution: Array<{ __typename?: 'AdminAnalyticsHistogramBucket', label: string, count: number }> }, kbSearchUsage: { __typename?: 'AdminAnalyticsKBSearchUsage', totalSearches: number, searcherCount: number, perUser: Array<{ __typename?: 'AdminAnalyticsKBSearchPerUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, searchCount: number }> }, amsWrites: { __typename?: 'AdminAnalyticsAmsWrites', hasIntegration: boolean, recordingStartedAt?: Date | null | undefined, voiceAiExcluded: boolean, succeeded: number, failed: number, bySource: Array<{ __typename?: 'AdminAnalyticsAmsWriteSource', source: AdminAnalyticsAmsWriteSourceType, succeeded: number }>, byIntegration: Array<{ __typename?: 'AdminAnalyticsAmsWriteIntegration', integrationType: IntegrationType, succeeded: number, failed: number }>, byRecordType: Array<{ __typename?: 'AdminAnalyticsAmsWriteRecordType', recordType: string, label: string, succeeded: number }>, overTime: Array<{ __typename?: 'AdminAnalyticsAmsWritePeriod', periodStart: Date, succeeded: number, failed: number, recorded: boolean }> }, presetRankings: { __typename?: 'AdminAnalyticsPresetRankings', weekCount: number, previousPeriod?: { __typename?: 'AdminAnalyticsPreviousPeriod', after: Date, before: Date } | null | undefined, presets: Array<{ __typename?: 'AdminAnalyticsPresetRanking', rank: number, previousRank?: number | null | undefined, usage: { __typename?: 'AdminAnalyticsPresetUsage', key: string, label: string, isCustomPreset: boolean, customPresetArchived: boolean, workspaceCount: number, overTime: Array<{ __typename?: 'AdminAnalyticsPresetWeek', weekStart: Date, workspaceCount: number }>, users: Array<{ __typename?: 'AdminAnalyticsPresetUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, workspaceCount: number, lastUsedAt: Date }>, withoutUser?: { __typename?: 'AdminAnalyticsPresetWithoutUser', workspaceCount: number, lastUsedAt: Date } | null | undefined } }>, noPreset?: { __typename?: 'AdminAnalyticsPresetUsage', key: string, label: string, isCustomPreset: boolean, customPresetArchived: boolean, workspaceCount: number, overTime: Array<{ __typename?: 'AdminAnalyticsPresetWeek', weekStart: Date, workspaceCount: number }>, users: Array<{ __typename?: 'AdminAnalyticsPresetUser', agencyUserId: string, agencyUserName: string, agencyUserEmail: string, workspaceCount: number, lastUsedAt: Date }>, withoutUser?: { __typename?: 'AdminAnalyticsPresetWithoutUser', workspaceCount: number, lastUsedAt: Date } | null | undefined } | null | undefined }, unfilteredSections: Array<{ __typename?: 'AdminAnalyticsUnfilteredSection', section: AdminAnalyticsSection, filters: Array<AdminAnalyticsSegmentFilter> }> } };

export type GetAdminAnalyticsAgencyProfileOptionsQueryVariables = Exact<{
  subagencyId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetAdminAnalyticsAgencyProfileOptionsQuery = { __typename?: 'Query', adminAnalyticsAgencyProfileOptions: Array<{ __typename?: 'AdminAnalyticsAgencyProfileOption', agencyProfileId?: string | null | undefined, name?: string | null | undefined, isDefault: boolean }> };

export type AdminAnalyticsExportFieldsFragment = { __typename?: 'AdminAnalyticsExport', id: string, table: AdminAnalyticsExportTable, status: AdminAnalyticsExportStatus, createdAt: Date, expiresAt?: Date | null | undefined };

export type GetAdminAnalyticsExportsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAdminAnalyticsExportsQuery = { __typename?: 'Query', adminAnalyticsExports: Array<{ __typename?: 'AdminAnalyticsExport', id: string, table: AdminAnalyticsExportTable, status: AdminAnalyticsExportStatus, createdAt: Date, expiresAt?: Date | null | undefined }> };

export type StartAdminAnalyticsExportMutationVariables = Exact<{
  input: StartAdminAnalyticsExportInput;
}>;


export type StartAdminAnalyticsExportMutation = { __typename?: 'Mutation', startAdminAnalyticsExport: { __typename?: 'AdminAnalyticsExport', id: string, table: AdminAnalyticsExportTable, status: AdminAnalyticsExportStatus, createdAt: Date, expiresAt?: Date | null | undefined } };

export type CreateAdminAnalyticsExportDownloadUrlMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CreateAdminAnalyticsExportDownloadUrlMutation = { __typename?: 'Mutation', createAdminAnalyticsExportDownloadUrl: string };

export type AgencySignInFieldsFragment = { __typename?: 'AgencySignInResponse', agencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string } };

export type SignInMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type SignInMutation = { __typename?: 'Mutation', agencySignIn?: { __typename?: 'AgencySignInResponse', agencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string } } | null | undefined };

export type SignInCompleteMutationVariables = Exact<{
  email: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type SignInCompleteMutation = { __typename?: 'Mutation', agencySignIn?: { __typename?: 'AgencySignInResponse', agencyUser: { __typename?: 'AgencyUser', id: string, email: string, name: string } } | null | undefined };

export type SignOutMutationVariables = Exact<{ [key: string]: never; }>;


export type SignOutMutation = { __typename?: 'Mutation', agencySignOut: boolean };

export type BusinessPolicyDetailFieldsFragment = { __typename?: 'BusinessPolicy', market: InsuranceMarket, quoteNumber: string, account: { __typename?: 'Account', contacts: Array<{ __typename?: 'AccountContact', email: string, id: string, name: string, phone: string }> }, agencyUser: { __typename?: 'AgencyUser', id: string, name: string }, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, cancellation?: { __typename?: 'BusinessPolicyCancellation', canceledAt: Date, canceledBy: BusinessPolicyCancellationSource, effectiveAt: Date, type: BusinessPolicyCancellationType, reason: BusinessPolicyCancellationReason, reasonDescription: string, returnCommission: number, returnPremium: number } | null | undefined, details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number }, reinstatement?: { __typename?: 'BusinessPolicyReinstatement', reinstatedAt: Date, effectiveAt: Date, reasonDescription: string } | null | undefined, renewal?: { __typename?: 'BusinessPolicyRenewal', nextPolicies: Array<{ __typename?: 'BusinessPolicy', id: string }>, previousPolicies: Array<{ __typename?: 'BusinessPolicy', id: string }> } | null | undefined };

export type BusinessPolicyFileFieldsFragment = { __typename?: 'BusinessPolicy', files: Array<{ __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined }> };

export type BusinessPolicyFieldsFragment = { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } };

export type InsuranceCarrierFieldsFragment = { __typename?: 'InsuranceCarrier', id: string, name: string, isCarrier: boolean, isBroker: boolean };

export type GetInsuranceCarriersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceCarriersQuery = { __typename?: 'Query', carriers: Array<{ __typename?: 'InsuranceCarrier', id: string, name: string, isCarrier: boolean, isBroker: boolean }> };

export type GetBusinessPoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBusinessPoliciesQuery = { __typename?: 'Query', businessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } }> };

export type GetBusinessPolicyQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetBusinessPolicyQuery = { __typename?: 'Query', businessPolicy?: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, market: InsuranceMarket, quoteNumber: string, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string }, contacts: Array<{ __typename?: 'AccountContact', email: string, id: string, name: string, phone: string }> }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string }, agencyUser: { __typename?: 'AgencyUser', id: string, name: string }, broker?: { __typename?: 'InsuranceCarrier', id: string, name: string } | null | undefined, cancellation?: { __typename?: 'BusinessPolicyCancellation', canceledAt: Date, canceledBy: BusinessPolicyCancellationSource, effectiveAt: Date, type: BusinessPolicyCancellationType, reason: BusinessPolicyCancellationReason, reasonDescription: string, returnCommission: number, returnPremium: number } | null | undefined, details?: { __typename?: 'BusinessPolicyExtractedDetails', deductible?: number | null | undefined, policyNumber?: string | null | undefined, summary?: string | null | undefined, blanketAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyBlanketAdditionalInsured', type: string, description: string }>, carrier?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, coverageDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, exclusionDescriptions: Array<{ __typename?: 'BusinessPolicyCoverageOrExclusionDescription', description: string, policyQuotes: Array<string>, title: string }>, extraLimits: Array<{ __typename?: 'BusinessPolicyExtraInsuranceLimit', limit: number, name: string }>, insured?: { __typename?: 'BusinessPolicyEntity', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } } | null | undefined, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined }, locations: Array<{ __typename?: 'BusinessPolicyLocation', address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string }, limits: { __typename?: 'BusinessPolicyInsuranceLimits', cyberAggregateLimit?: number | null | undefined, cyberRetentionLimit?: number | null | undefined, glAggregateLimit?: number | null | undefined, glMedicalPerOccurrenceLimit?: number | null | undefined, glMedicalPerPersonLimit?: number | null | undefined, glPerOccurrenceLimit?: number | null | undefined, glPersonalAndAdvertisingInjuryLimit?: number | null | undefined, glProductsAndCompletedOperationsLimit?: number | null | undefined, glRentedPremisesDamageLimit?: number | null | undefined, propertyBuildingLimit?: number | null | undefined, propertyContentsLimit?: number | null | undefined, umbrellaOrExcessAggregateLimit?: number | null | undefined, umbrellaOrExcessPerOccurrenceLimit?: number | null | undefined, wcPerAccidentLimit?: number | null | undefined, wcPerDiseaseEmployeeLimit?: number | null | undefined, wcPerDiseasePolicyLimit?: number | null | undefined } }>, namedAdditionalInsureds: Array<{ __typename?: 'BusinessPolicyNamedAdditionalInsured', name: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }> } | null | undefined, pricing: { __typename?: 'BusinessPolicyPricing', billingType: BusinessPolicyBillingType, premium: number, agencyFees: number, brokerFees: number, policyFees: number, otherFees: number, taxes: number, total: number, intervalType?: PaymentIntervalType | null | undefined, estimatedCommission: number }, reinstatement?: { __typename?: 'BusinessPolicyReinstatement', reinstatedAt: Date, effectiveAt: Date, reasonDescription: string } | null | undefined, renewal?: { __typename?: 'BusinessPolicyRenewal', nextPolicies: Array<{ __typename?: 'BusinessPolicy', id: string }>, previousPolicies: Array<{ __typename?: 'BusinessPolicy', id: string }> } | null | undefined, files: Array<{ __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined }> } | null | undefined };

export type CreateBusinessPoliciesMutationVariables = Exact<{
  input: CreateBusinessPoliciesInput;
}>;


export type CreateBusinessPoliciesMutation = { __typename?: 'Mutation', createBusinessPolicies: Array<{ __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } }> };

export type UpdateBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateBusinessPolicyInput;
}>;


export type UpdateBusinessPolicyMutation = { __typename?: 'Mutation', updateBusinessPolicy: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } } };

export type DeleteBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteBusinessPolicyMutation = { __typename?: 'Mutation', deleteBusinessPolicy?: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } } | null | undefined };

export type CancelBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CancelBusinessPolicyInput;
}>;


export type CancelBusinessPolicyMutation = { __typename?: 'Mutation', cancelBusinessPolicy: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } } };

export type RenewBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RenewBusinessPolicyInput;
}>;


export type RenewBusinessPolicyMutation = { __typename?: 'Mutation', renewBusinessPolicy: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } } };

export type ReinstateBusinessPolicyMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ReinstateBusinessPolicyInput;
}>;


export type ReinstateBusinessPolicyMutation = { __typename?: 'Mutation', reinstateBusinessPolicy: { __typename?: 'BusinessPolicy', expiresAt?: Date | null | undefined, id: string, inforceAt?: Date | null | undefined, issuedAt?: Date | null | undefined, policyNumber: string, state: PolicyState, type: InsuranceType, account: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', email: string, name: string } | { __typename?: 'IndividualAccount', email: string, name: string } }, carrier: { __typename?: 'InsuranceCarrier', id: string, name: string } } };

export type UploadPolicyFileMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
  file: UploadFileInput;
}>;


export type UploadPolicyFileMutation = { __typename?: 'Mutation', uploadPolicyFile: { __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined } };

export type CallFieldsFragment = { __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined };

export type CallTranscriptFieldsFragment = { __typename?: 'Call', recordingUrl?: string | null | undefined, sentiment?: CallSentiment | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> };

export type GetCallsQueryVariables = Exact<{
  filter?: InputMaybe<CallFilterInput>;
}>;


export type GetCallsQuery = { __typename?: 'Query', calls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined }> };

export type SearchCallsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CallFilterInput>;
  sort?: InputMaybe<CallSortInput>;
}>;


export type SearchCallsQuery = { __typename?: 'Query', searchCalls: { __typename?: 'CallConnection', totalCount: number, edges: Array<{ __typename?: 'CallEdge', cursor: string, node: { __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type GetCallQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCallQuery = { __typename?: 'Query', call: { __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> } };

export type CallReportFieldsFragment = { __typename?: 'CallReport', dailyCounts: Array<{ __typename?: 'CallDailyCount', date: Date, totalCalls: number, businessHoursCalls: number, afterHoursCalls: number }>, hangupCounts: { __typename?: 'CallHangupCounts', total: number, underTwentySeconds: number }, serviceRequestTypeCounts: Array<{ __typename?: 'CallServiceRequestTypeCount', type: ServiceRequestType, count: number }> };

export type GetCallReportQueryVariables = Exact<{
  filter?: InputMaybe<CallFilterInput>;
}>;


export type GetCallReportQuery = { __typename?: 'Query', callReport: { __typename?: 'CallReport', dailyCounts: Array<{ __typename?: 'CallDailyCount', date: Date, totalCalls: number, businessHoursCalls: number, afterHoursCalls: number }>, hangupCounts: { __typename?: 'CallHangupCounts', total: number, underTwentySeconds: number }, serviceRequestTypeCounts: Array<{ __typename?: 'CallServiceRequestTypeCount', type: ServiceRequestType, count: number }> } };

export type UpdateCallsMutationVariables = Exact<{
  callIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateCallInput;
}>;


export type UpdateCallsMutation = { __typename?: 'Mutation', updateCalls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined }> };

export type ApplicationFileGeneratorToolFieldsFragment = { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } };

export type DocxEditorToolFieldsFragment = { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } };

export type XlsxEditorToolFieldsFragment = { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } };

export type CodeExecutionToolFieldsFragment = { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } };

export type SearchIntegrationFilterFieldsFragment = { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined };

export type SearchIntegrationFilterChildFieldsFragment = { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined };

export type SearchIntegrationFilterGrandchildFieldsFragment = { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined };

export type SearchIntegrationFilterLeafFieldsFragment = { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined };

export type CaraWorkspaceOverviewFieldsFragment = { __typename?: 'CaraWorkspace', createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type CaraWorkspaceArtifactFieldsFragment = { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined };

export type FillTemplateToolFieldsFragment = { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } };

export type CaraWorkspaceFieldsFragment = { __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type CustomPresetFieldsFragment = { __typename?: 'CustomPreset', createdAt: Date, description: string, id: string, isOwner: boolean, state: CustomPresetState, title: string, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string }, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, myAccess?: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type CustomPresetDetailFieldsFragment = { __typename?: 'CustomPreset', allowFileUpload: boolean, basePrompt: string, defaultEffortLevel?: CaraWorkspaceEffortLevel | null | undefined, inheritFromPreset?: CaraWorkspacePreset | null | undefined, createdAt: Date, description: string, id: string, isOwner: boolean, state: CustomPresetState, title: string, updatedAt: Date, customForms: Array<{ __typename?: 'CustomForm', id: string, title: string }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, htmlDocumentTemplates: Array<{ __typename?: 'HtmlDocumentTemplate', id: string, title: string }>, wordDocumentTemplates: Array<{ __typename?: 'WordDocumentTemplate', id: string, title: string }>, agency: { __typename?: 'Agency', id: string, name: string }, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, myAccess?: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type CustomPresetAccessFieldsFragment = { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } };

export type HtmlDocumentTemplateFieldsFragment = { __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined };

export type WordDocumentTemplateFieldsFragment = { __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type ExcelSpreadsheetTemplateFieldsFragment = { __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type GetCaraWorkspaceQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceQuery = { __typename?: 'Query', caraWorkspace?: { __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } | null | undefined };

export type GetCaraWorkspacesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCaraWorkspacesQuery = { __typename?: 'Query', caraWorkspaces: Array<{ __typename?: 'CaraWorkspace', createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type SearchCaraWorkspacesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchCaraWorkspacesFilterInput>;
  sort?: InputMaybe<CaraWorkspaceSortInput>;
}>;


export type SearchCaraWorkspacesQuery = { __typename?: 'Query', searchCaraWorkspaces: { __typename?: 'CaraWorkspaceConnection', totalCount: number, edges: Array<{ __typename?: 'CaraWorkspaceEdge', cursor: string, node: { __typename?: 'CaraWorkspace', createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type CaraWorkspaceArtifactSummaryWithContentFieldsFragment = { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, workspace: { __typename?: 'CaraWorkspace', id: string, state: CaraWorkspaceState }, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, type: CaraWorkspaceArtifactType, version: number, revision: number, createdAt: Date, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, document?: { __typename?: 'CaraWorkspaceArtifactDocument', content: string, title: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string } | null | undefined }>, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', clientName: string, templateId?: DocumentType | null | undefined, workspaceId: string, workspaceUser?: string | null | undefined, workspaceTitle: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type CaraWorkspaceArtifactSummaryFieldsFragment = { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', clientName: string, templateId?: DocumentType | null | undefined, workspaceId: string, workspaceUser?: string | null | undefined, workspaceTitle: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined }, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, type: CaraWorkspaceArtifactType, version: number, revision: number, createdAt: Date, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string } | null | undefined }> };

export type GetCaraWorkspaceArtifactsQueryVariables = Exact<{
  filter?: InputMaybe<CaraWorkspaceArtifactFilter>;
}>;


export type GetCaraWorkspaceArtifactsQuery = { __typename?: 'Query', caraWorkspaceArtifacts: Array<{ __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', clientName: string, templateId?: DocumentType | null | undefined, workspaceId: string, workspaceUser?: string | null | undefined, workspaceTitle: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined }, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, type: CaraWorkspaceArtifactType, version: number, revision: number, createdAt: Date, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string } | null | undefined }> }> };

export type OutboxArtifactFieldsFragment = { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, latestVersion: number, composedAt: Date, emailMailboxAccountId?: string | null | undefined, heldBackFromBulkSendId?: string | null | undefined, heldBackReason?: string | null | undefined, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string }, emailRecipients?: { __typename?: 'CaraWorkspaceEmailRecipients', to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> } | null | undefined };

export type SearchOutboxArtifactsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<CaraWorkspaceArtifactsFilterInput>;
}>;


export type SearchOutboxArtifactsQuery = { __typename?: 'Query', searchCaraWorkspaceArtifacts: { __typename?: 'CaraWorkspaceArtifactConnection', totalCount: number, edges: Array<{ __typename?: 'CaraWorkspaceArtifactEdge', cursor: string, node: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, latestVersion: number, composedAt: Date, emailMailboxAccountId?: string | null | undefined, heldBackFromBulkSendId?: string | null | undefined, heldBackReason?: string | null | undefined, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string }, emailRecipients?: { __typename?: 'CaraWorkspaceEmailRecipients', to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type SearchAttachableArtifactsQueryVariables = Exact<{
  filter?: InputMaybe<CaraWorkspaceArtifactFilter>;
}>;


export type SearchAttachableArtifactsQuery = { __typename?: 'Query', caraWorkspaceArtifacts: Array<{ __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, updatedAt: Date, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string, workspaceTitle: string, clientName: string } }> };

export type GetCaraWorkspaceEmailArtifactQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceEmailArtifactQuery = { __typename?: 'Query', caraWorkspaceArtifact?: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', version: number, email?: { __typename?: 'CaraWorkspaceArtifactEmail', bodyHtml: string, contentRevision: string } | null | undefined }> } | null | undefined };

export type GetCaraWorkspaceArtifactQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceArtifactQuery = { __typename?: 'Query', caraWorkspaceArtifact?: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, workspace: { __typename?: 'CaraWorkspace', id: string, state: CaraWorkspaceState }, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, type: CaraWorkspaceArtifactType, version: number, revision: number, createdAt: Date, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, document?: { __typename?: 'CaraWorkspaceArtifactDocument', content: string, title: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string } | null | undefined }>, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', clientName: string, templateId?: DocumentType | null | undefined, workspaceId: string, workspaceUser?: string | null | undefined, workspaceTitle: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } } | null | undefined };

export type TemplateFormFieldStateFieldsFragment = { __typename?: 'TemplateFormFieldState', widgetName: string, label: string, kind: TemplateFormFieldKind, value: string, exportValue?: string | null | undefined, maxLength?: number | null | undefined, continuedOn?: string | null | undefined, provenance: TemplateFormFieldProvenance, lastEditedAt?: Date | null | undefined, suggestion?: string | null | undefined, lastEditedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined };

export type TemplateFormEditorStateFieldsFragment = { __typename?: 'TemplateFormEditorState', version: number, latestVersion: number, editable: boolean, restorable: boolean, printsInAllCaps: boolean, fields: Array<{ __typename?: 'TemplateFormFieldState', widgetName: string, label: string, kind: TemplateFormFieldKind, value: string, exportValue?: string | null | undefined, maxLength?: number | null | undefined, continuedOn?: string | null | undefined, provenance: TemplateFormFieldProvenance, lastEditedAt?: Date | null | undefined, suggestion?: string | null | undefined, lastEditedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined }>, pages?: Array<{ __typename?: 'TemplateFormPage', sheet?: string | null | undefined }> | null | undefined };

export type GetTemplateFormEditorStateQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTemplateFormEditorStateQuery = { __typename?: 'Query', templateFormEditorState: { __typename?: 'TemplateFormEditorState', version: number, latestVersion: number, editable: boolean, restorable: boolean, printsInAllCaps: boolean, fields: Array<{ __typename?: 'TemplateFormFieldState', widgetName: string, label: string, kind: TemplateFormFieldKind, value: string, exportValue?: string | null | undefined, maxLength?: number | null | undefined, continuedOn?: string | null | undefined, provenance: TemplateFormFieldProvenance, lastEditedAt?: Date | null | undefined, suggestion?: string | null | undefined, lastEditedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined }>, pages?: Array<{ __typename?: 'TemplateFormPage', sheet?: string | null | undefined }> | null | undefined } };

export type GetCustomPresetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomPresetsQuery = { __typename?: 'Query', customPresets: Array<{ __typename?: 'CustomPreset', createdAt: Date, description: string, id: string, isOwner: boolean, state: CustomPresetState, title: string, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string }, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, myAccess?: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type GetCustomPresetQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomPresetQuery = { __typename?: 'Query', customPreset: { __typename?: 'CustomPreset', allowFileUpload: boolean, basePrompt: string, defaultEffortLevel?: CaraWorkspaceEffortLevel | null | undefined, inheritFromPreset?: CaraWorkspacePreset | null | undefined, createdAt: Date, description: string, id: string, isOwner: boolean, state: CustomPresetState, title: string, updatedAt: Date, customForms: Array<{ __typename?: 'CustomForm', id: string, title: string }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, htmlDocumentTemplates: Array<{ __typename?: 'HtmlDocumentTemplate', id: string, title: string }>, wordDocumentTemplates: Array<{ __typename?: 'WordDocumentTemplate', id: string, title: string }>, agency: { __typename?: 'Agency', id: string, name: string }, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, myAccess?: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type GetCustomPresetShareInfoQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomPresetShareInfoQuery = { __typename?: 'Query', customPreset: { __typename?: 'CustomPreset', id: string, accessList: Array<{ __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }> } };

export type GrantCustomPresetAccessMutationVariables = Exact<{
  customPresetId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
}>;


export type GrantCustomPresetAccessMutation = { __typename?: 'Mutation', grantCustomPresetAccess: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } } };

export type RevokeCustomPresetAccessMutationVariables = Exact<{
  customPresetId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
}>;


export type RevokeCustomPresetAccessMutation = { __typename?: 'Mutation', revokeCustomPresetAccess: boolean };

export type GetHtmlDocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHtmlDocumentTemplatesQuery = { __typename?: 'Query', htmlDocumentTemplates: Array<{ __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined }> };

export type GetHtmlDocumentTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetHtmlDocumentTemplateQuery = { __typename?: 'Query', htmlDocumentTemplate: { __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined } };

export type GetHtmlDocumentTemplateStartersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetHtmlDocumentTemplateStartersQuery = { __typename?: 'Query', htmlDocumentTemplateStarters: Array<{ __typename?: 'HtmlDocumentTemplateStarter', id: string, title: string, description: string }> };

export type CreateHtmlDocumentTemplateFromStarterMutationVariables = Exact<{
  input: CreateHtmlDocumentTemplateFromStarterInput;
}>;


export type CreateHtmlDocumentTemplateFromStarterMutation = { __typename?: 'Mutation', createHtmlDocumentTemplateFromStarter: { __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined } };

export type GetWordDocumentTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWordDocumentTemplatesQuery = { __typename?: 'Query', wordDocumentTemplates: Array<{ __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type GetWordDocumentTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetWordDocumentTemplateQuery = { __typename?: 'Query', wordDocumentTemplate: { __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type GetExcelSpreadsheetTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetExcelSpreadsheetTemplatesQuery = { __typename?: 'Query', excelSpreadsheetTemplates: Array<{ __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type GetExcelSpreadsheetTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetExcelSpreadsheetTemplateQuery = { __typename?: 'Query', excelSpreadsheetTemplate: { __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type CreateCaraWorkspaceMutationVariables = Exact<{
  input: CaraWorkspaceMessageInput;
}>;


export type CreateCaraWorkspaceMutation = { __typename?: 'Mutation', createCaraWorkspace: { __typename?: 'CaraWorkspace', id: string } };

export type AddCaraWorkspaceMessageMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CaraWorkspaceMessageInput;
}>;


export type AddCaraWorkspaceMessageMutation = { __typename?: 'Mutation', addCaraWorkspaceMessage: { __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type ExportCaraWorkspaceMessageMutationVariables = Exact<{
  input: ExportCaraWorkspaceMessageInput;
}>;


export type ExportCaraWorkspaceMessageMutation = { __typename?: 'Mutation', exportCaraWorkspaceMessage: { __typename?: 'CaraWorkspaceMessageExport', contentBase64?: string | null | undefined, downloadUrl?: string | null | undefined, fileName: string, mimeType: string } };

export type StopCaraWorkspaceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type StopCaraWorkspaceMutation = { __typename?: 'Mutation', stopCaraWorkspace: { __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateCaraWorkspacesMutationVariables = Exact<{
  workspaceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateCaraWorkspaceInput;
}>;


export type UpdateCaraWorkspacesMutation = { __typename?: 'Mutation', updateCaraWorkspaces: Array<{ __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type UpdateCaraWorkspaceArtifactMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  input: UpdateCaraWorkspaceArtifactInput;
}>;


export type UpdateCaraWorkspaceArtifactMutation = { __typename?: 'Mutation', updateCaraWorkspaceArtifact: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type SaveTemplateFormFieldsMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  baseVersion: Scalars['Int']['input'];
  fields: Array<TemplateFormFieldEditInput> | TemplateFormFieldEditInput;
}>;


export type SaveTemplateFormFieldsMutation = { __typename?: 'Mutation', saveTemplateFormFields: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type RestoreTemplateFormVersionMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  baseVersion: Scalars['Int']['input'];
}>;


export type RestoreTemplateFormVersionMutation = { __typename?: 'Mutation', restoreTemplateFormVersion: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type UpdateCaraWorkspaceArtifactsMutationVariables = Exact<{
  artifactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateCaraWorkspaceArtifactsInput;
}>;


export type UpdateCaraWorkspaceArtifactsMutation = { __typename?: 'Mutation', updateCaraWorkspaceArtifacts: Array<{ __typename?: 'CaraWorkspaceArtifactSummary', id: string, archivedAt?: Date | null | undefined }> };

export type ArchiveCaraWorkspacesMutationVariables = Exact<{
  workspaceIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveCaraWorkspacesMutation = { __typename?: 'Mutation', updateCaraWorkspaces: Array<{ __typename?: 'CaraWorkspace', id: string, archivedAt?: Date | null | undefined }> };

export type CreateCustomPresetMutationVariables = Exact<{
  input: CustomPresetInput;
}>;


export type CreateCustomPresetMutation = { __typename?: 'Mutation', createCustomPreset: { __typename?: 'CustomPreset', id: string } };

export type UpdateCustomPresetMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: CustomPresetInput;
}>;


export type UpdateCustomPresetMutation = { __typename?: 'Mutation', updateCustomPreset: { __typename?: 'CustomPreset', id: string } };

export type UpdateCustomPresetsMutationVariables = Exact<{
  presetIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateCustomPresetsInput;
}>;


export type UpdateCustomPresetsMutation = { __typename?: 'Mutation', updateCustomPresets: Array<{ __typename?: 'CustomPreset', createdAt: Date, description: string, id: string, isOwner: boolean, state: CustomPresetState, title: string, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string }, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, myAccess?: { __typename?: 'CustomPresetAccess', role: CustomPresetAccessRole, createdAt: Date } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type CreateHtmlDocumentTemplateMutationVariables = Exact<{
  input: HtmlDocumentTemplateInput;
}>;


export type CreateHtmlDocumentTemplateMutation = { __typename?: 'Mutation', createHtmlDocumentTemplate: { __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined } };

export type UpdateHtmlDocumentTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: HtmlDocumentTemplateInput;
}>;


export type UpdateHtmlDocumentTemplateMutation = { __typename?: 'Mutation', updateHtmlDocumentTemplate: { __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined } };

export type UpdateHtmlDocumentTemplatesMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateHtmlDocumentTemplatesInput;
}>;


export type UpdateHtmlDocumentTemplatesMutation = { __typename?: 'Mutation', updateHtmlDocumentTemplates: Array<{ __typename?: 'HtmlDocumentTemplate', baseStyleId?: string | null | undefined, bodyTemplate?: string | null | undefined, description: string, id: string, title: string, createdAt: Date, updatedAt: Date, designId?: string | null | undefined, designSource: TemplateDesignSource, startPages: DocumentPagesSource, endPages: DocumentPagesSource, printsOwnHeaderFooter: boolean, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, headerFooter?: { __typename?: 'HeaderFooterConfig', header: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined }, footer: { __typename?: 'HeaderFooterSlots', left?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, center?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined, right?: { __typename?: 'HeaderFooterSlot', text?: string | null | undefined, image?: { __typename?: 'HeaderFooterImage', maxHeightPt?: number | null | undefined, paddingPt?: number | null | undefined, innerGapPt?: number | null | undefined, file: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } } | null | undefined } | null | undefined } } | null | undefined, prefixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, suffixFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string }>, style: { __typename?: 'HtmlDocumentTemplateStyle', primaryColorHex?: string | null | undefined, primaryColorLightHex?: string | null | undefined, secondaryColorHex?: string | null | undefined, secondaryColorLightHex?: string | null | undefined, page: { __typename?: 'PageStyle', size?: string | null | undefined, backgroundColorHex?: string | null | undefined, margin: { __typename?: 'MarginStyle', topIn?: number | null | undefined, rightIn?: number | null | undefined, bottomIn?: number | null | undefined, leftIn?: number | null | undefined } }, typography: { __typename?: 'TypographyStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, lineHeight?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined }, elements: { __typename?: 'ElementStyles', headings: { __typename?: 'HeadingStyles', h1: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h2: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h3: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h4: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h5: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, h6: { __typename?: 'HeadingStyle', fontSizePt?: number | null | undefined, fontWeight?: number | null | undefined, colorHex?: string | null | undefined, marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, fontFamily?: string | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined } }, paragraph: { __typename?: 'ParagraphStyle', marginTopEm?: number | null | undefined, marginBottomEm?: number | null | undefined, orphans?: number | null | undefined, widows?: number | null | undefined, fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, colorHex?: string | null | undefined, fontWeight?: number | null | undefined, fontStyle?: string | null | undefined, lineHeight?: number | null | undefined, pageBreakBefore?: boolean | null | undefined }, link: { __typename?: 'LinkStyle', colorHex?: string | null | undefined, textDecoration?: string | null | undefined }, list: { __typename?: 'ListStyle', marginLeftEm?: number | null | undefined, marginBottomEm?: number | null | undefined, itemMarginBottomEm?: number | null | undefined }, table: { __typename?: 'TableStyle', widthPct?: number | null | undefined, borderCollapse?: string | null | undefined, marginTopEm?: number | null | undefined, fontSizePt?: number | null | undefined, headerBackgroundColorHex?: string | null | undefined, headerColorHex?: string | null | undefined, headerFontWeight?: number | null | undefined, cellPaddingEm?: number | null | undefined, cellBorder?: string | null | undefined, zebraStripeColorHex?: string | null | undefined, repeatHeaders?: boolean | null | undefined }, image: { __typename?: 'ImageStyle', maxWidthPct?: number | null | undefined, heightAuto: boolean, pageBreakInside?: string | null | undefined }, code: { __typename?: 'CodeStyle', fontFamily?: string | null | undefined, fontSizePt?: number | null | undefined, backgroundColorHex?: string | null | undefined, colorHex?: string | null | undefined, paddingEm?: number | null | undefined, borderRadiusPx?: number | null | undefined } } }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, design?: { __typename?: 'AgencyDesign', id: string, name: string, archived: boolean, includedPages: { __typename?: 'AgencyDesignIncludedPages', before: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }>, after: Array<{ __typename?: 'AgencyDesignPage', fileId: string, printable: boolean, file?: { __typename?: 'File', id: string, name: string, mimeType: string, size: number } | null | undefined }> } } | null | undefined }> };

export type CreateWordDocumentTemplateMutationVariables = Exact<{
  input: WordDocumentTemplateInput;
}>;


export type CreateWordDocumentTemplateMutation = { __typename?: 'Mutation', createWordDocumentTemplate: { __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateWordDocumentTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: WordDocumentTemplateInput;
}>;


export type UpdateWordDocumentTemplateMutation = { __typename?: 'Mutation', updateWordDocumentTemplate: { __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateWordDocumentTemplatesMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateWordDocumentTemplatesInput;
}>;


export type UpdateWordDocumentTemplatesMutation = { __typename?: 'Mutation', updateWordDocumentTemplates: Array<{ __typename?: 'WordDocumentTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: WordDocumentTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, sections: Array<{ __typename?: 'WordDocumentTemplateSection', id: string, title: string, setupGuidance?: string | null | undefined, static: boolean, repeatable: boolean, required: boolean, templateFile: { __typename?: 'File', id: string, name: string, url?: string | null | undefined } }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type CreateExcelSpreadsheetTemplateMutationVariables = Exact<{
  input: ExcelSpreadsheetTemplateInput;
}>;


export type CreateExcelSpreadsheetTemplateMutation = { __typename?: 'Mutation', createExcelSpreadsheetTemplate: { __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateExcelSpreadsheetTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ExcelSpreadsheetTemplateInput;
}>;


export type UpdateExcelSpreadsheetTemplateMutation = { __typename?: 'Mutation', updateExcelSpreadsheetTemplate: { __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateExcelSpreadsheetTemplatesMutationVariables = Exact<{
  templateIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  input: UpdateExcelSpreadsheetTemplatesInput;
}>;


export type UpdateExcelSpreadsheetTemplatesMutation = { __typename?: 'Mutation', updateExcelSpreadsheetTemplates: Array<{ __typename?: 'ExcelSpreadsheetTemplate', id: string, title: string, description: string, fillGuidance?: string | null | undefined, state?: ExcelSpreadsheetTemplateState | null | undefined, error?: string | null | undefined, createdAt: Date, updatedAt: Date, createdBy: { __typename?: 'AgencyUser', id: string, name: string }, templateFile?: { __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined } | null | undefined, tabs: Array<{ __typename?: 'ExcelSpreadsheetTemplateTab', id: string, name: string, setupGuidance?: string | null | undefined, static: boolean, required: boolean, fillGuidance: string, fields: Array<{ __typename?: 'ExcelSpreadsheetTemplateTabField', name: string, cell: string, label: string, fillGuidance: string }> }>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type SetCaraWorkspaceArtifactDesignMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  designId?: InputMaybe<Scalars['String']['input']>;
}>;


export type SetCaraWorkspaceArtifactDesignMutation = { __typename?: 'Mutation', setCaraWorkspaceArtifactDesign: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type EnsureCaraWorkspaceArtifactFitsDesignMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  supersede?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EnsureCaraWorkspaceArtifactFitsDesignMutation = { __typename?: 'Mutation', ensureCaraWorkspaceArtifactFitsDesign: { __typename?: 'CaraWorkspaceArtifactRefitResult', outcome: DocumentRefitOutcome, artifact: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } } };

export type DocumentDesignFitStateFieldsFragment = { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string };

export type GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceArtifactPrintsLegacyLookQuery = { __typename?: 'Query', caraWorkspaceArtifact?: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, version: number, printsLegacyLook: boolean }> } | null | undefined };

export type GetCaraWorkspaceArtifactDesignFitQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceArtifactDesignFitQuery = { __typename?: 'Query', caraWorkspaceArtifact?: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined }> } | null | undefined };

export type MarkCaraWorkspaceArtifactFinalMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
  includeDesignPages?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type MarkCaraWorkspaceArtifactFinalMutation = { __typename?: 'Mutation', markCaraWorkspaceArtifactFinal: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type UnmarkCaraWorkspaceArtifactFinalMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  version: Scalars['Int']['input'];
}>;


export type UnmarkCaraWorkspaceArtifactFinalMutation = { __typename?: 'Mutation', unmarkCaraWorkspaceArtifactFinal: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined } };

export type BuildHtmlDocumentRenderUrlMutationVariables = Exact<{
  input: BuildHtmlDocumentRenderUrlInput;
}>;


export type BuildHtmlDocumentRenderUrlMutation = { __typename?: 'Mutation', buildHtmlDocumentRenderUrl: { __typename?: 'HtmlDocumentRenderUrl', url: string, outcome?: DocumentRefitOutcome | null | undefined } };

export type CreateHtmlDocumentRenderGrantMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  version: Scalars['Int']['input'];
  styleId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateHtmlDocumentRenderGrantMutation = { __typename?: 'Mutation', createHtmlDocumentRenderGrant: { __typename?: 'HtmlDocumentRenderGrant', token: string } };

export type WatchCaraWorkspaceSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WatchCaraWorkspaceSubscription = { __typename?: 'Subscription', watchCaraWorkspace: { __typename?: 'CaraWorkspace', effortLevel?: CaraWorkspaceEffortLevel | null | undefined, effortRaisedReason?: string | null | undefined, effortRaisedMessageId?: string | null | undefined, schemaVersion: CaraWorkspaceSchemaVersion, createdAt: Date, id: string, preset?: CaraWorkspacePreset | null | undefined, state: CaraWorkspaceState, title: string, updatedAt: Date, artifacts: Array<{ __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }>, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, planStages: Array<{ __typename?: 'CaraWorkspacePlanStage', createdAt: Date, endedAt?: Date | null | undefined, id: string, initiatedByMessageId: string, platformUnitsUsed?: string | null | undefined, result: string, startedAt?: Date | null | undefined, state: CaraWorkspacePlanStageState, type: CaraWorkspacePlanStageType, events: Array<{ __typename?: 'CaraWorkspacePlanStageEvent', content?: string | null | undefined, endedAt?: Date | null | undefined, error?: string | null | undefined, id: string, startedAt: Date, title?: string | null | undefined, type: CaraWorkspacePlanStageEventType, toolCall?: { __typename?: 'CaraWorkspaceToolCall', argumentsJson: string, name: string, result: string, type?: CaraWorkspaceTool | null | undefined, invocationSource?: CaraWorkspaceToolInvocationSource | null | undefined, thinkTool?: { __typename?: 'ThinkTool', input: { __typename?: 'ThinkToolInput', title: string, thought: string }, output: { __typename?: 'ThinkToolOutput', success: boolean } } | null | undefined, completeTaskTool?: { __typename?: 'CompleteTaskTool', input: { __typename?: 'CompleteTaskToolInput', clientName: string, keywords: Array<string>, needsAgentInput: boolean }, output: { __typename?: 'CompleteTaskToolOutput', success: boolean } } | null | undefined, draftEmailTool?: { __typename?: 'DraftEmailTool', input: { __typename?: 'DraftEmailToolInput', operation: string, subject: string, bodyHtml?: string | null | undefined, artifactId?: string | null | undefined, body?: string | null | undefined, toEmail?: string | null | undefined, toName?: string | null | undefined, createDraft?: { __typename?: 'DraftEmailToolCreateDraftInput', subject: string, bodyHtml: string, to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, createFromTemplate?: { __typename?: 'DraftEmailToolCreateFromTemplateInput', to: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> } | null | undefined, updateDraft?: { __typename?: 'DraftEmailToolUpdateDraftInput', artifactId: string, subject?: string | null | undefined, bodyHtml?: string | null | undefined, to?: Array<{ __typename?: 'DraftEmailToolRecipientInput', name: string, email: string }> | null | undefined } | null | undefined, to?: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }> | null | undefined }, output: { __typename?: 'DraftEmailToolOutput', artifactId: string, version?: number | null | undefined, bodyHtml?: string | null | undefined } } | null | undefined, bulkEmailDraftTool?: { __typename?: 'BulkEmailDraftTool', input: { __typename?: 'BulkEmailDraftToolInput', operation: string, add?: { __typename?: 'BulkEmailDraftToolAddInput', bulkSendId: string } | null | undefined, remove?: { __typename?: 'BulkEmailDraftToolRemoveInput', bulkSendId: string } | null | undefined, fill?: { __typename?: 'BulkEmailDraftToolFillInput', bulkSendId: string } | null | undefined }, output?: { __typename?: 'BulkEmailDraftToolOutput', bulkSendId: string, name: string, recipients: Array<{ __typename?: 'BulkEmailDraftToolRecipient', recipientId: string }> } | null | undefined } | null | undefined, draftOutboundCallTool?: { __typename?: 'DraftOutboundCallTool', input: { __typename?: 'DraftOutboundCallToolInput', artifactId?: string | null | undefined, customerName?: string | null | undefined, customerPhone?: string | null | undefined, callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, leaveVoicemail: boolean, scheduledAt?: string | null | undefined, timezone: string }, output: { __typename?: 'DraftOutboundCallToolOutput', artifactId: string, outboundCallId?: string | null | undefined, scheduledAt?: Date | null | undefined } } | null | undefined, draftDocumentTool?: { __typename?: 'DraftDocumentTool', input: { __typename?: 'DraftDocumentToolInput', artifactId: string, title: string, htmlContent: string } } | null | undefined, fileEditorTool?: { __typename?: 'FileEditorTool', input: { __typename?: 'FileEditorToolInput', fileId: string, operation: string, replaceText: string, content: string, title: string, requirements: string }, output: { __typename?: 'FileEditorToolOutput', fileId: string, version: number, content?: string | null | undefined, remarks?: string | null | undefined } } | null | undefined, fillTemplateTool?: { __typename?: 'FillTemplateTool', input: { __typename?: 'FillTemplateToolInput', templateId: DocumentType }, output: { __typename?: 'FillTemplateToolOutput', artifactId: string, version: number } } | null | undefined, pdfEditorTool?: { __typename?: 'PDFEditorTool', input: { __typename?: 'PDFEditorToolInput', operation: string, formFillInstructions: string, formId?: string | null | undefined, artifactId?: string | null | undefined, fieldsJson?: string | null | undefined, inputFiles: Array<{ __typename?: 'PDFEditorToolInputFile', fileIdOrArtifactId: string, fileName: string }> }, output: { __typename?: 'PDFEditorToolOutput', fileId?: string | null | undefined, artifactId?: string | null | undefined, version?: number | null | undefined, result: string, forms?: Array<{ __typename?: 'CustomFormListItem', id: string, name: string, description: string }> | null | undefined, form?: { __typename?: 'CustomFormListItem', id: string, name: string, description: string, instructions?: string | null | undefined, schema?: Record<string, unknown> | null | undefined } | null | undefined, artifact?: { __typename?: 'CustomFormToolArtifact', id: string, version: number } | null | undefined } } | null | undefined, searchFileTool?: { __typename?: 'SearchFileTool', input: { __typename?: 'SearchFileToolInput', queries: Array<{ __typename?: 'SearchFileToolQuery', fileId: string, fileIds?: Array<string> | null | undefined, query: string, keywords: string }> }, output: { __typename?: 'SearchFileToolOutput', results: Array<{ __typename?: 'SearchFileToolResult', fileId: string, fileName: string, query: string, answer: string, citations: Array<{ __typename?: 'SearchFileToolResultCitation', link: string }> }> } } | null | undefined, searchKnowledgeBaseTool?: { __typename?: 'SearchKnowledgeBaseTool', input: { __typename?: 'SearchKnowledgeBaseToolInput', userQuery: string, queries: Array<{ __typename?: 'SearchKnowledgeBaseToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeBaseToolOutput', answer: string, citations: Array<{ __typename?: 'SearchKnowledgeBaseToolResultCitation', link: string }>, documents: Array<{ __typename?: 'SearchKnowledgeBaseToolResultDocument', metadata: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string }, relevantPages: Array<{ __typename?: 'SearchKnowledgeBaseToolResultPage', pageIndex: number }> }> } } | null | undefined, searchKnowledgeGraphTool?: { __typename?: 'SearchKnowledgeGraphTool', input: { __typename?: 'SearchKnowledgeGraphToolInput', queries: Array<{ __typename?: 'SearchKnowledgeGraphToolQuery', query: string }> }, output: { __typename?: 'SearchKnowledgeGraphToolOutput', entities: Array<{ __typename?: 'KnowledgeGraphEntity', type: KnowledgeGraphEntityType, displayName: string }> } } | null | undefined, searchIntegrationTool?: { __typename?: 'SearchIntegrationTool', input: { __typename?: 'SearchIntegrationToolInput', find: string, bundles?: Array<string> | null | undefined, where: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined }, include?: Array<{ __typename?: 'SearchIntegrationInclude', relation: string, bundles?: Array<string> | null | undefined, where?: { __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined, and?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined, or?: Array<{ __typename?: 'SearchIntegrationFilter', negate?: boolean | null | undefined, field?: string | null | undefined, op?: string | null | undefined, value?: string | null | undefined, values?: Array<string> | null | undefined }> | null | undefined }> | null | undefined }> | null | undefined } | null | undefined }> | null | undefined }, output?: { __typename?: 'SearchIntegrationToolOutput', source?: string | null | undefined, results?: Array<Record<string, unknown>> | null | undefined, hasMore?: boolean | null | undefined, error?: { __typename?: 'SearchIntegrationError', code: string } | null | undefined } | null | undefined } | null | undefined, searchWebTool?: { __typename?: 'SearchWebTool', input: { __typename?: 'SearchWebToolInput', queries: Array<{ __typename?: 'SearchWebToolQuery', query: string, keywords: string }> }, output: { __typename?: 'SearchWebToolOutput', results: Array<{ __typename?: 'SearchWebToolResult', query: string, answer: string, citations: Array<{ __typename?: 'SearchWebToolResultCitation', url: string, title: string }> }> } } | null | undefined, writeIntegrationTool?: { __typename?: 'WriteIntegrationTool', input: { __typename?: 'WriteIntegrationToolInput', action: string, agentName: string, account: { __typename?: 'WriteIntegrationToolAccount', firstName: string, lastName: string, businessName: string, email: string, phone: string, address: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, zone: string, postalCode: string } }, uploadDocument?: { __typename?: 'WriteIntegrationToolUploadDocumentInput', source: string, description: string, note: string, id: string } | null | undefined, createNote?: { __typename?: 'WriteIntegrationToolCreateNoteInput', title: string, body: string } | null | undefined, createTask?: { __typename?: 'WriteIntegrationToolCreateTaskInput', title: string, description: string, dueDate?: string | null | undefined, assigneeEmail?: string | null | undefined } | null | undefined }, output: { __typename?: 'WriteIntegrationToolOutput', success: boolean, message: string } } | null | undefined, agencyzoomWriteTool?: { __typename?: 'AgencyZoomWriteTool', input: { __typename?: 'AgencyZoomWriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'AgencyZoomCustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, lead?: { __typename?: 'AgencyZoomLeadFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, businessEntity?: string | null | undefined } | null | undefined, opportunity?: { __typename?: 'AgencyZoomOpportunityFields', product?: string | null | undefined, premium?: number | null | undefined } | null | undefined, policy?: { __typename?: 'AgencyZoomPolicyFields', policyNumber?: string | null | undefined, insuredName?: string | null | undefined, premium?: number | null | undefined, lineOfBusiness?: string | null | undefined } | null | undefined, task?: { __typename?: 'AgencyZoomTaskFields', title?: string | null | undefined, comments?: string | null | undefined, dueDatetime?: string | null | undefined } | null | undefined, contacts?: Array<{ __typename?: 'AgencyZoomContactEntry', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined }> | null | undefined }, output: { __typename?: 'AgencyZoomWriteToolOutput', success: boolean, message: string } } | null | undefined, hawksoftWriteTool?: { __typename?: 'HawksoftWriteTool', input: { __typename?: 'HawksoftWriteToolInput', operation?: string | null | undefined, logNote?: { __typename?: 'HawksoftLogNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined, note?: string | null | undefined, taskTitle?: string | null | undefined, policyId?: string | null | undefined } | null | undefined, attachment?: { __typename?: 'HawksoftAttachmentFields', description?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, email?: string | null | undefined } | null | undefined, receipt?: { __typename?: 'HawksoftReceiptFields', clientId?: string | null | undefined, logNote?: string | null | undefined, payMethod?: string | null | undefined } | null | undefined }, output: { __typename?: 'HawksoftWriteToolOutput', success: boolean, message: string } } | null | undefined, qqcatalystWriteTool?: { __typename?: 'QQCatalystWriteTool', input: { __typename?: 'QQCatalystWriteToolInput', operation?: string | null | undefined, contact?: { __typename?: 'QQCatalystContactFields', contactId?: string | null | undefined, firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, dateOfBirth?: string | null | undefined } | null | undefined, file?: { __typename?: 'QQCatalystFileFields', contactId?: string | null | undefined, fileId?: string | null | undefined, fileName?: string | null | undefined, policyId?: string | null | undefined } | null | undefined }, output: { __typename?: 'QQCatalystWriteToolOutput', success: boolean, message: string, contactId?: string | null | undefined, fileId?: string | null | undefined } } | null | undefined, nowcertsWriteTool?: { __typename?: 'NowCertsWriteTool', input: { __typename?: 'NowCertsWriteToolInput', operation?: string | null | undefined, insured?: { __typename?: 'NowCertsInsuredFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, prospect?: { __typename?: 'NowCertsProspectFields', firstName?: string | null | undefined, lastName?: string | null | undefined, commercialName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, note?: { __typename?: 'NowCertsNoteFields', subject?: string | null | undefined, body?: string | null | undefined } | null | undefined, task?: { __typename?: 'NowCertsTaskFields', title?: string | null | undefined, description?: string | null | undefined, status?: string | null | undefined, priority?: string | null | undefined, dueDate?: string | null | undefined } | null | undefined, policy?: { __typename?: 'NowCertsPolicyFields', number?: string | null | undefined, carrierName?: string | null | undefined, lineOfBusinessName?: string | null | undefined, premium?: number | null | undefined, status?: string | null | undefined } | null | undefined, driver?: { __typename?: 'NowCertsDriverFields', firstName?: string | null | undefined, lastName?: string | null | undefined, licenseNumber?: string | null | undefined } | null | undefined, vehicle?: { __typename?: 'NowCertsVehicleFields', year?: number | null | undefined, make?: string | null | undefined, model?: string | null | undefined, vin?: string | null | undefined } | null | undefined, claim?: { __typename?: 'NowCertsClaimFields', claimNumber?: string | null | undefined, descriptionOfLoss?: string | null | undefined, dateOfLoss?: string | null | undefined } | null | undefined, file?: { __typename?: 'NowCertsFileFields', fileId?: string | null | undefined } | null | undefined, call?: { __typename?: 'NowCertsCallFields', fromName?: string | null | undefined, toName?: string | null | undefined, type?: string | null | undefined } | null | undefined }, output: { __typename?: 'NowCertsWriteToolOutput', success: boolean, message: string } } | null | undefined, ezlynxWriteTool?: { __typename?: 'EzlynxWriteTool', input: { __typename?: 'EzlynxWriteToolInput', operation?: string | null | undefined, note?: { __typename?: 'EzlynxNoteFields', firstName?: string | null | undefined, lastName?: string | null | undefined, title?: string | null | undefined, body?: string | null | undefined } | null | undefined, call?: { __typename?: 'EzlynxCallFields', callerName?: string | null | undefined, fromNumber?: string | null | undefined, summary?: string | null | undefined } | null | undefined, policy?: { __typename?: 'EzlynxPolicyFields', policyNumber?: string | null | undefined, writingCompany?: string | null | undefined, lob?: string | null | undefined, annualPremium?: number | null | undefined } | null | undefined }, output: { __typename?: 'EzlynxWriteToolOutput', success: boolean, message: string } } | null | undefined, ams360WriteTool?: { __typename?: 'Ams360WriteTool', input: { __typename?: 'Ams360WriteToolInput', operation?: string | null | undefined, customer?: { __typename?: 'Ams360CustomerFields', firstName?: string | null | undefined, lastName?: string | null | undefined, businessName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined } | null | undefined, customerContact?: { __typename?: 'Ams360CustomerContactFields', name?: string | null | undefined, email?: string | null | undefined } | null | undefined, activity?: { __typename?: 'Ams360ActivityFields', action?: string | null | undefined, comment?: string | null | undefined, description?: string | null | undefined } | null | undefined, activityComment?: { __typename?: 'Ams360ActivityCommentFields', comment?: string | null | undefined } | null | undefined, activityAttachment?: { __typename?: 'Ams360ActivityAttachmentFields', description?: string | null | undefined } | null | undefined, policy?: { __typename?: 'Ams360PolicyFields', policyNo?: string | null | undefined, policyType?: string | null | undefined, writingCompanyName?: string | null | undefined } | null | undefined, policyContact?: { __typename?: 'Ams360PolicyContactFields', name?: string | null | undefined, email?: string | null | undefined, title?: string | null | undefined } | null | undefined, suspense?: { __typename?: 'Ams360SuspenseFields', description?: string | null | undefined, dueDate?: string | null | undefined, assignToEmployeeName?: string | null | undefined } | null | undefined, uploadDocument?: { __typename?: 'Ams360UploadDocumentFields', description?: string | null | undefined, note?: string | null | undefined } | null | undefined }, output: { __typename?: 'Ams360WriteToolOutput', success: boolean, message: string } } | null | undefined, applicationFileGeneratorTool?: { __typename?: 'ApplicationFileGeneratorTool', input: { __typename?: 'ApplicationFileGeneratorToolInput', fileType: string, title: string, sourceFileId?: string | null | undefined, fileId: string }, output: { __typename?: 'ApplicationFileGeneratorToolOutput', fileId: string, version: number, success: boolean, error?: string | null | undefined, stdout?: string | null | undefined, stderr?: string | null | undefined, validationPassed?: boolean | null | undefined, validationMessage?: string | null | undefined } } | null | undefined, docxEditorTool?: { __typename?: 'DocxEditorTool', input: { __typename?: 'DocxEditorToolInput', operation: string, title: string }, output: { __typename?: 'DocxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined } } | null | undefined, xlsxEditorTool?: { __typename?: 'XlsxEditorTool', input: { __typename?: 'XlsxEditorToolInput', operation: string, title: string }, output: { __typename?: 'XlsxEditorToolOutput', artifactId?: string | null | undefined, version?: number | null | undefined, tabs?: Array<{ __typename?: 'XlsxEditorToolTabOutput', templateTabId: string, name: string, description?: string | null | undefined }> | null | undefined } } | null | undefined, codeExecutionTool?: { __typename?: 'CodeExecutionTool', input: { __typename?: 'CodeExecutionToolInput', title: string, pythonScript: string, sourceFileIds?: Array<string> | null | undefined }, output: { __typename?: 'CodeExecutionToolOutput', returnCode: number, stdout?: string | null | undefined, stderr?: string | null | undefined, remarks?: string | null | undefined, outputFiles: Array<{ __typename?: 'CodeExecutionOutputFile', id: string, name: string, mimeType: string, url: string }> } } | null | undefined } | null | undefined }>, processAttachmentsDetails?: { __typename?: 'CaraWorkspacePlanStageProcessAttachmentDetails', progress: Array<{ __typename?: 'CaraWorkspacePlanStageProcessAttachmentFileProgress', error?: string | null | undefined, progress: number, file: { __typename?: 'File', name: string } }> } | null | undefined }>, messages: Array<{ __typename?: 'CaraWorkspaceMessage', content: string, id: string, role: CaraWorkspaceMessageRole, timestamp: Date, useCase?: CaraWorkspaceUseCase | null | undefined, files: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, url?: string | null | undefined }>, followUpOptions?: { __typename?: 'CaraWorkspaceMessageFollowUpOptions', generationStartedAt?: Date | null | undefined, generationCompletedAt?: Date | null | undefined, options?: Array<{ __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string, title: string, type: CaraWorkspaceMessageFollowUpOptionType, prompt: string }> | null | undefined } | null | undefined, selectedFollowUp?: { __typename?: 'CaraWorkspaceMessageFollowUpOption', id: string } | null | undefined, amsContext?: Array<{ __typename?: 'CaraWorkspaceAmsContextEntry', entityId: string, entityType: KnowledgeGraphEntityType, integrationId: string, displayName: string }> | null | undefined, amsRefs?: Array<{ __typename?: 'CaraWorkspaceAmsRefEntry', displayName: string, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> | null | undefined }>, serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } | null | undefined, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined, agencyUser?: { __typename?: 'AgencyUser', email: string, id: string, name: string } | null | undefined, customPreset?: { __typename?: 'CustomPreset', id: string, title: string } | null | undefined, metadata: { __typename?: 'CaraWorkspaceMetadata', clientName?: string | null | undefined, keywords: Array<string> }, triggerRun?: { __typename?: 'TriggerRun', id: string, state: TriggerRunState } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type CaraWorkspaceArtifactCommentFieldsFragment = { __typename?: 'CaraWorkspaceArtifactComment', id: string, workspaceId: string, artifactId: string, body: string, createdAt: Date, resolvedAt?: Date | null | undefined, resolvedBy?: CaraWorkspaceArtifactCommentResolvedBy | null | undefined, anchor: { __typename?: 'CaraWorkspaceArtifactCommentAnchor', quote: string, prefix: string, suffix: string, occurrence: number, occurrenceCount: number }, region?: { __typename?: 'CaraWorkspaceArtifactCommentRegion', page: number, left: number, top: number, width: number, height: number, nearby: boolean, pageWidthPt: number, pageHeightPt: number, version: number, revision: number, styleId?: string | null | undefined } | null | undefined, placement?: { __typename?: 'CaraWorkspaceArtifactCommentPlacement', tier: CaraWorkspaceArtifactCommentTier, matchedText: string, occurrence?: number | null | undefined } | null | undefined };

export type GetCaraWorkspaceArtifactCommentsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type GetCaraWorkspaceArtifactCommentsQuery = { __typename?: 'Query', caraWorkspaceArtifactComments: Array<{ __typename?: 'CaraWorkspaceArtifactComment', id: string, workspaceId: string, artifactId: string, body: string, createdAt: Date, resolvedAt?: Date | null | undefined, resolvedBy?: CaraWorkspaceArtifactCommentResolvedBy | null | undefined, anchor: { __typename?: 'CaraWorkspaceArtifactCommentAnchor', quote: string, prefix: string, suffix: string, occurrence: number, occurrenceCount: number }, region?: { __typename?: 'CaraWorkspaceArtifactCommentRegion', page: number, left: number, top: number, width: number, height: number, nearby: boolean, pageWidthPt: number, pageHeightPt: number, version: number, revision: number, styleId?: string | null | undefined } | null | undefined, placement?: { __typename?: 'CaraWorkspaceArtifactCommentPlacement', tier: CaraWorkspaceArtifactCommentTier, matchedText: string, occurrence?: number | null | undefined } | null | undefined }> };

export type AddCaraWorkspaceArtifactCommentMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
  input: CaraWorkspaceArtifactCommentInput;
}>;


export type AddCaraWorkspaceArtifactCommentMutation = { __typename?: 'Mutation', addCaraWorkspaceArtifactComment: { __typename?: 'CaraWorkspaceArtifactComment', id: string, workspaceId: string, artifactId: string, body: string, createdAt: Date, resolvedAt?: Date | null | undefined, resolvedBy?: CaraWorkspaceArtifactCommentResolvedBy | null | undefined, anchor: { __typename?: 'CaraWorkspaceArtifactCommentAnchor', quote: string, prefix: string, suffix: string, occurrence: number, occurrenceCount: number }, region?: { __typename?: 'CaraWorkspaceArtifactCommentRegion', page: number, left: number, top: number, width: number, height: number, nearby: boolean, pageWidthPt: number, pageHeightPt: number, version: number, revision: number, styleId?: string | null | undefined } | null | undefined, placement?: { __typename?: 'CaraWorkspaceArtifactCommentPlacement', tier: CaraWorkspaceArtifactCommentTier, matchedText: string, occurrence?: number | null | undefined } | null | undefined } };

export type ResolveCaraWorkspaceArtifactCommentMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type ResolveCaraWorkspaceArtifactCommentMutation = { __typename?: 'Mutation', resolveCaraWorkspaceArtifactComment: { __typename?: 'CaraWorkspaceArtifactComment', id: string, workspaceId: string, artifactId: string, body: string, createdAt: Date, resolvedAt?: Date | null | undefined, resolvedBy?: CaraWorkspaceArtifactCommentResolvedBy | null | undefined, anchor: { __typename?: 'CaraWorkspaceArtifactCommentAnchor', quote: string, prefix: string, suffix: string, occurrence: number, occurrenceCount: number }, region?: { __typename?: 'CaraWorkspaceArtifactCommentRegion', page: number, left: number, top: number, width: number, height: number, nearby: boolean, pageWidthPt: number, pageHeightPt: number, version: number, revision: number, styleId?: string | null | undefined } | null | undefined, placement?: { __typename?: 'CaraWorkspaceArtifactCommentPlacement', tier: CaraWorkspaceArtifactCommentTier, matchedText: string, occurrence?: number | null | undefined } | null | undefined } };

export type DeleteCaraWorkspaceArtifactCommentMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  commentId: Scalars['ID']['input'];
}>;


export type DeleteCaraWorkspaceArtifactCommentMutation = { __typename?: 'Mutation', deleteCaraWorkspaceArtifactComment: boolean };

export type CertificateOfLiabilityInsuranceFieldsFragment = { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } };

export type GetCertificateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCertificateQuery = { __typename?: 'Query', certificate?: { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } } | null | undefined };

export type CreateCertificateMutationVariables = Exact<{
  input: CreateCertificateInput;
}>;


export type CreateCertificateMutation = { __typename?: 'Mutation', createCertificate?: { __typename?: 'CertificateOfLiabilityInsurance', id: string, certificateNumber: string, viewUrl: string, downloadUrl: string, createdAt: Date, holder: { __typename?: 'CertificateEntity', name: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } } | null | undefined };

export type MergeCandidateSideFragment = { __typename?: 'Client', id: string, name: string, email?: string | null | undefined, phone?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number } };

export type ClientMergeCandidatesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
}>;


export type ClientMergeCandidatesQuery = { __typename?: 'Query', clientMergeCandidates: { __typename?: 'ClientMergeCandidateConnection', totalCount: number, edges: Array<{ __typename?: 'ClientMergeCandidateEdge', cursor: string, node: { __typename?: 'ClientMergeCandidate', id: string, score: number, reason: ClientMergeCandidateReason, clientA: { __typename?: 'Client', id: string, name: string, email?: string | null | undefined, phone?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number } }, clientB: { __typename?: 'Client', id: string, name: string, email?: string | null | undefined, phone?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number } } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type ClientMergeSideFragment = { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number }, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined };

export type ClientMergeSideQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ClientMergeSideQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number }, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } | null | undefined };

export type MergeManyClientsMutationVariables = Exact<{
  input: ClientGroupMergeInput;
}>;


export type MergeManyClientsMutation = { __typename?: 'Mutation', mergeManyClients: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, associationCounts: { __typename?: 'ClientAssociationCounts', workspaces: number, amsAccounts: number, notes: number }, amsAccounts: Array<{ __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, isPrimary: boolean }>, latestWorkspace?: { __typename?: 'ClientWorkspaceSummary', id: string, title: string, updatedAt: Date } | null | undefined, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type KeepClientsSeparateMutationVariables = Exact<{
  candidateId: Scalars['ID']['input'];
}>;


export type KeepClientsSeparateMutation = { __typename?: 'Mutation', keepClientsSeparate: { __typename?: 'ClientMergeCandidate', id: string, status: ClientMergeCandidateStatus } };

export type ClientMergeCandidateCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientMergeCandidateCountQuery = { __typename?: 'Query', clientMergeCandidates: { __typename?: 'ClientMergeCandidateConnection', totalCount: number } };

export type ClientNoteFieldsFragment = { __typename?: 'ClientNote', id: string, body: string, createdAt: Date, updatedAt: Date, author?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined };

export type GetClientNotesQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
}>;


export type GetClientNotesQuery = { __typename?: 'Query', clientNotes: Array<{ __typename?: 'ClientNote', id: string, body: string, createdAt: Date, updatedAt: Date, author?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined }> };

export type CreateClientNoteMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type CreateClientNoteMutation = { __typename?: 'Mutation', createClientNote: { __typename?: 'ClientNote', id: string, body: string, createdAt: Date, updatedAt: Date, author?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } };

export type UpdateClientNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  body: Scalars['String']['input'];
}>;


export type UpdateClientNoteMutation = { __typename?: 'Mutation', updateClientNote: { __typename?: 'ClientNote', id: string, body: string, createdAt: Date, updatedAt: Date, author?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } };

export type DeleteClientNoteMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteClientNoteMutation = { __typename?: 'Mutation', deleteClientNote: boolean };

export type ClientFieldsFragment = { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined };

export type SearchClientsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFilterInput>;
  sort?: InputMaybe<ClientSortInput>;
}>;


export type SearchClientsQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', totalCount: number, edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type ClientListFieldsFragment = { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, amsAccounts: Array<{ __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, isPrimary: boolean }>, latestWorkspace?: { __typename?: 'ClientWorkspaceSummary', id: string, title: string, updatedAt: Date } | null | undefined, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined };

export type ClientListQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFilterInput>;
  sort?: InputMaybe<ClientSortInput>;
}>;


export type ClientListQuery = { __typename?: 'Query', clients: { __typename?: 'ClientConnection', totalCount: number, edges: Array<{ __typename?: 'ClientEdge', cursor: string, node: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, amsAccounts: Array<{ __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, isPrimary: boolean }>, latestWorkspace?: { __typename?: 'ClientWorkspaceSummary', id: string, title: string, updatedAt: Date } | null | undefined, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type GetClientQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } | null | undefined };

export type ClientAmsAccountFieldsFragment = { __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, amsExternalId: string, isPrimary: boolean, account?: { __typename?: 'KnowledgeGraphEntity', id: string, displayName: string } | null | undefined };

export type ClientFieldProvenanceFieldsFragment = { __typename?: 'ClientFieldProvenance', id: string, field: ClientField, source: FieldSource, value: string, integrationType?: IntegrationType | null | undefined, sourceUpdatedBy?: string | null | undefined, recordedAt: Date, confirmedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined };

export type GetClientOverviewQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetClientOverviewQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, amsAccounts: Array<{ __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, amsExternalId: string, isPrimary: boolean, account?: { __typename?: 'KnowledgeGraphEntity', id: string, displayName: string } | null | undefined }>, fieldProvenance?: Array<{ __typename?: 'ClientFieldProvenance', id: string, field: ClientField, source: FieldSource, value: string, integrationType?: IntegrationType | null | undefined, sourceUpdatedBy?: string | null | undefined, recordedAt: Date, confirmedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined }> | null | undefined, agencyUsers: Array<{ __typename?: 'AgencyUser', id: string, name: string, email: string }>, pendingMergeCandidates: Array<{ __typename?: 'ClientMergeCandidate', id: string, score: number, clientA: { __typename?: 'Client', id: string, name: string }, clientB: { __typename?: 'Client', id: string, name: string } }>, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } | null | undefined };

export type ClientArtifactFieldsFragment = { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, latestVersion: number, createdAt: Date, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, version: number, document?: { __typename?: 'CaraWorkspaceArtifactDocument', final?: { __typename?: 'CaraWorkspaceArtifactFinal', markedAt: Date } | null | undefined } | null | undefined }>, workspace: { __typename?: 'CaraWorkspace', id: string, title: string }, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type GetClientArtifactsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientArtifactFilterInput>;
  sort?: InputMaybe<ClientDocumentSortInput>;
}>;


export type GetClientArtifactsQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, artifacts: { __typename?: 'ClientArtifactConnection', edges: Array<{ __typename?: 'ClientArtifactEdge', cursor: string, node: { __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, latestVersion: number, createdAt: Date, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, version: number, document?: { __typename?: 'CaraWorkspaceArtifactDocument', final?: { __typename?: 'CaraWorkspaceArtifactFinal', markedAt: Date } | null | undefined } | null | undefined }>, workspace: { __typename?: 'CaraWorkspace', id: string, title: string }, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } } | null | undefined };

export type ClientFileFieldsFragment = { __typename?: 'File', id: string, name: string, mimeType: string, size: number, type: FileType, url?: string | null | undefined, createdAt: Date };

export type GetClientFilesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<ClientFileFilterInput>;
  sort?: InputMaybe<ClientDocumentSortInput>;
}>;


export type GetClientFilesQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, files: { __typename?: 'ClientFileConnection', edges: Array<{ __typename?: 'ClientFileEdge', cursor: string, node: { __typename?: 'File', id: string, name: string, mimeType: string, size: number, type: FileType, url?: string | null | undefined, createdAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } } | null | undefined };

export type RemoveClientArtifactMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type RemoveClientArtifactMutation = { __typename?: 'Mutation', removeClientArtifact: { __typename?: 'Client', id: string } };

export type RemoveClientFileMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;


export type RemoveClientFileMutation = { __typename?: 'Mutation', removeClientFile: { __typename?: 'Client', id: string } };

export type CreateClientMutationVariables = Exact<{
  input: ClientInput;
}>;


export type CreateClientMutation = { __typename?: 'Mutation', createClient: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type UpdateClientMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateClientInput;
}>;


export type UpdateClientMutation = { __typename?: 'Mutation', updateClient: { __typename?: 'Client', id: string, name: string, phone?: string | null | undefined, email?: string | null | undefined, isCommercial: boolean, isPersonal: boolean, createdAt: Date, updatedAt: Date, fieldProvenance?: Array<{ __typename?: 'ClientFieldProvenance', id: string, field: ClientField, source: FieldSource, value: string, integrationType?: IntegrationType | null | undefined, sourceUpdatedBy?: string | null | undefined, recordedAt: Date, confirmedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined }> | null | undefined, address?: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string } | null | undefined, agencyUserOwner?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type ConfirmClientFieldMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  field: ClientField;
  value: Scalars['String']['input'];
}>;


export type ConfirmClientFieldMutation = { __typename?: 'Mutation', confirmClientField: { __typename?: 'ClientFieldProvenance', id: string, field: ClientField, source: FieldSource, value: string, integrationType?: IntegrationType | null | undefined, sourceUpdatedBy?: string | null | undefined, recordedAt: Date, confirmedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } };

export type SuggestedAmsAccountsQueryVariables = Exact<{
  clientId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestedAmsAccountsQuery = { __typename?: 'Query', client?: { __typename?: 'Client', id: string, suggestedAmsAccounts: Array<{ __typename?: 'AmsAccountMatch', integrationId: string, externalId: string, displayName?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, accountCode?: string | null | undefined, reason: AmsAccountMatchReason, accountId?: string | null | undefined }> } | null | undefined };

export type LinkClientAmsAccountMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  input: ClientAmsAccountInput;
  isPrimary?: Scalars['Boolean']['input'];
}>;


export type LinkClientAmsAccountMutation = { __typename?: 'Mutation', linkClientAmsAccount: { __typename?: 'ClientAmsAccount', integrationId: string, integrationType: IntegrationType, amsExternalId: string, isPrimary: boolean, account?: { __typename?: 'KnowledgeGraphEntity', id: string, displayName: string } | null | undefined } };

export type UnlinkClientAmsAccountMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  integrationId: Scalars['ID']['input'];
  amsExternalId: Scalars['String']['input'];
}>;


export type UnlinkClientAmsAccountMutation = { __typename?: 'Mutation', unlinkClientAmsAccount: boolean };

export type LinkClientWorkspaceMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
  replaceExisting: Scalars['Boolean']['input'];
}>;


export type LinkClientWorkspaceMutation = { __typename?: 'Mutation', linkClientWorkspace: { __typename?: 'Client', id: string } };

export type UnlinkClientWorkspaceMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  workspaceId: Scalars['ID']['input'];
}>;


export type UnlinkClientWorkspaceMutation = { __typename?: 'Mutation', unlinkClientWorkspace: { __typename?: 'Client', id: string } };

export type GetWorkspaceClientsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceClientsQuery = { __typename?: 'Query', caraWorkspace?: { __typename?: 'CaraWorkspace', id: string, clients: Array<{ __typename?: 'Client', id: string, name: string, isCommercial: boolean, isPersonal: boolean }> } | null | undefined };

export type GetWorkspaceDocumentClientsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
}>;


export type GetWorkspaceDocumentClientsQuery = { __typename?: 'Query', caraWorkspace?: { __typename?: 'CaraWorkspace', id: string, clients: Array<{ __typename?: 'Client', id: string, name: string }>, documentClients: Array<{ __typename?: 'WorkspaceDocumentClients', documentId: string, clients: Array<{ __typename?: 'Client', id: string, name: string }> }> } | null | undefined };

export type SuggestedClientsForWorkspaceQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SuggestedClientsForWorkspaceQuery = { __typename?: 'Query', suggestedClientsForWorkspace: Array<{ __typename?: 'ClientSuggestion', score: number, verdict: ClientMatchVerdict, client: { __typename?: 'Client', id: string, name: string, email?: string | null | undefined, phone?: string | null | undefined, isCommercial: boolean, isPersonal: boolean } }> };

export type SearchWorkspacesForClientQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<SearchCaraWorkspacesFilterInput>;
}>;


export type SearchWorkspacesForClientQuery = { __typename?: 'Query', searchCaraWorkspaces: { __typename?: 'CaraWorkspaceConnection', totalCount: number, edges: Array<{ __typename?: 'CaraWorkspaceEdge', cursor: string, node: { __typename?: 'CaraWorkspace', id: string, title: string, updatedAt: Date, agencyUser?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, clients: Array<{ __typename?: 'Client', id: string, name: string }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type AddClientArtifactMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  artifactId: Scalars['ID']['input'];
}>;


export type AddClientArtifactMutation = { __typename?: 'Mutation', addClientArtifact: { __typename?: 'Client', id: string } };

export type AddClientFileMutationVariables = Exact<{
  clientId: Scalars['ID']['input'];
  fileId: Scalars['ID']['input'];
}>;


export type AddClientFileMutation = { __typename?: 'Mutation', addClientFile: { __typename?: 'Client', id: string } };

export type PickableArtifactsQueryVariables = Exact<{
  filter?: InputMaybe<CaraWorkspaceArtifactFilter>;
}>;


export type PickableArtifactsQuery = { __typename?: 'Query', caraWorkspaceArtifacts: Array<{ __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, type: CaraWorkspaceArtifactType, createdAt: Date, metadata: { __typename?: 'CaraWorkspaceArtifactMetadata', workspaceId: string, workspaceTitle: string } }> };

export type CustomFormListFieldsFragment = { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type CustomFormFieldsFragment = { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type GetCustomFormsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCustomFormsQuery = { __typename?: 'Query', customForms: Array<{ __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type GetCustomFormQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetCustomFormQuery = { __typename?: 'Query', customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UploadCustomFormMutationVariables = Exact<{
  input: UploadCustomFormInput;
}>;


export type UploadCustomFormMutation = { __typename?: 'Mutation', uploadCustomForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateCustomFormMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateCustomFormInput;
}>;


export type UpdateCustomFormMutation = { __typename?: 'Mutation', updateCustomForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus, error?: string | null | undefined, basePrompt: string, fillPrompt: string, ingestionGuidance: string, createdAt: Date, updatedAt: Date, version: number, archivedAt?: Date | null | undefined, templateFile: { __typename?: 'File', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type EmailAmsLogPreferenceFieldsFragment = { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined };

export type EmailAmsLogOptionsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailAmsLogOptionsQuery = { __typename?: 'Query', emailAmsLogOptions: { __typename?: 'EmailAmsLogOptions', destinations: Array<EmailAmsLogDestination>, preference: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined }, activityCodes: Array<{ __typename?: 'EmailAmsLogCodeOption', code: string, label: string }>, companies: Array<{ __typename?: 'EmailAmsLogCodeOption', code: string, label: string }>, employees: Array<{ __typename?: 'EmailAmsLogCodeOption', code: string, label: string }> } };

export type SetIntegrationEmailLogPreferenceMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: EmailAmsLogPreferenceInput;
}>;


export type SetIntegrationEmailLogPreferenceMutation = { __typename?: 'Mutation', setIntegrationEmailLogPreference: { __typename?: 'Integration', id: string, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined } };

export type EmailAmsMatchFieldsFragment = { __typename?: 'EmailAmsMatch', integrationId: string, integrationType: IntegrationType, filingKinds: Array<AmsRefKind>, isSupported: boolean, outcome: EmailAmsMatchOutcome, candidates: Array<{ __typename?: 'EmailAmsCandidate', accountEntityId: string, displayName: string, account: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined }, matchedAddresses: Array<{ __typename?: 'EmailAmsMatchedAddress', address: string }> }>, choice?: { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined } | null | undefined };

export type ResolveEmailAmsAccountsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  artifactId: Scalars['String']['input'];
  toAddresses: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type ResolveEmailAmsAccountsQuery = { __typename?: 'Query', resolveEmailAmsAccounts?: { __typename?: 'EmailAmsMatch', integrationId: string, integrationType: IntegrationType, filingKinds: Array<AmsRefKind>, isSupported: boolean, outcome: EmailAmsMatchOutcome, candidates: Array<{ __typename?: 'EmailAmsCandidate', accountEntityId: string, displayName: string, account: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined }, matchedAddresses: Array<{ __typename?: 'EmailAmsMatchedAddress', address: string }> }>, choice?: { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type MatchAmsAccountsForOutboundEmailQueryVariables = Exact<{
  outboundEmailId: Scalars['ID']['input'];
}>;


export type MatchAmsAccountsForOutboundEmailQuery = { __typename?: 'Query', matchAmsAccountsForOutboundEmail?: { __typename?: 'EmailAmsMatch', integrationId: string, integrationType: IntegrationType, filingKinds: Array<AmsRefKind>, isSupported: boolean, outcome: EmailAmsMatchOutcome, candidates: Array<{ __typename?: 'EmailAmsCandidate', accountEntityId: string, displayName: string, account: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined }, matchedAddresses: Array<{ __typename?: 'EmailAmsMatchedAddress', address: string }> }>, choice?: { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined } | null | undefined } | null | undefined };

export type SearchEmailAmsAccountsQueryVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchEmailAmsAccountsQuery = { __typename?: 'Query', searchEmailAmsAccounts: Array<{ __typename?: 'AmsBrowseAccount', name: string, lookupCode?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> };

export type SearchAmsAccountsForOutboundEmailQueryVariables = Exact<{
  outboundEmailId: Scalars['ID']['input'];
  query: Scalars['String']['input'];
}>;


export type SearchAmsAccountsForOutboundEmailQuery = { __typename?: 'Query', searchAmsAccountsForOutboundEmail: Array<{ __typename?: 'AmsBrowseAccount', name: string, lookupCode?: string | null | undefined, email?: string | null | undefined, phone?: string | null | undefined, address?: string | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } }> };

export type EmailAmsChoiceFieldsFragment = { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined };

export type ImportEmailAmsAccountMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  account: AmsRefInput;
}>;


export type ImportEmailAmsAccountMutation = { __typename?: 'Mutation', importEmailAmsAccount: { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined } };

export type ImportAmsAccountForOutboundEmailMutationVariables = Exact<{
  outboundEmailId: Scalars['ID']['input'];
  account: AmsRefInput;
}>;


export type ImportAmsAccountForOutboundEmailMutation = { __typename?: 'Mutation', importAmsAccountForOutboundEmail: { __typename?: 'EmailAmsChoice', displayName?: string | null | undefined, filingTarget?: { __typename?: 'EmailAmsFilingTarget', folderDisplayName?: string | null | undefined, displayName: string, folder?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined, ref: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } } | null | undefined, target?: { __typename?: 'AmsRef', integrationId: string, kind: AmsRefKind, externalId: string, accountExternalId?: string | null | undefined } | null | undefined } };

export type OutboundEmailAmsLogFieldsFragment = { __typename?: 'OutboundEmailAmsLog', status: AmsLogStatus, integrationType: IntegrationType, accountDisplayName?: string | null | undefined, loggedAt?: Date | null | undefined, notLoggedReason?: AmsNotLoggedReason | null | undefined, failureMessage?: string | null | undefined, canPush: boolean };

export type SentEmailAmsLogQueryVariables = Exact<{
  workspaceArtifactId: Scalars['ID']['input'];
}>;


export type SentEmailAmsLogQuery = { __typename?: 'Query', searchOutboundEmails: { __typename?: 'OutboundEmailConnection', edges: Array<{ __typename?: 'OutboundEmailEdge', node: { __typename?: 'OutboundEmail', id: string, amsLog?: { __typename?: 'OutboundEmailAmsLog', status: AmsLogStatus, integrationType: IntegrationType, accountDisplayName?: string | null | undefined, loggedAt?: Date | null | undefined, notLoggedReason?: AmsNotLoggedReason | null | undefined, failureMessage?: string | null | undefined, canPush: boolean } | null | undefined } }> } };

export type PushOutboundEmailToAmsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: PushOutboundEmailToAmsInput;
}>;


export type PushOutboundEmailToAmsMutation = { __typename?: 'Mutation', pushOutboundEmailToAms: { __typename?: 'PushOutboundEmailToAmsResult', outcome: AmsPushOutcome, email: { __typename?: 'OutboundEmail', id: string, amsLog?: { __typename?: 'OutboundEmailAmsLog', status: AmsLogStatus, integrationType: IntegrationType, accountDisplayName?: string | null | undefined, loggedAt?: Date | null | undefined, notLoggedReason?: AmsNotLoggedReason | null | undefined, failureMessage?: string | null | undefined, canPush: boolean } | null | undefined } } };

export type ClientArtifactsSentEmailsQueryVariables = Exact<{
  workspaceArtifactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ClientArtifactsSentEmailsQuery = { __typename?: 'Query', latestSentOutboundEmails: Array<{ __typename?: 'OutboundEmail', id: string, workspaceArtifactId: string, subject: string, sentAt?: Date | null | undefined, to: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, amsLog?: { __typename?: 'OutboundEmailAmsLog', status: AmsLogStatus, integrationType: IntegrationType, accountDisplayName?: string | null | undefined, loggedAt?: Date | null | undefined, notLoggedReason?: AmsNotLoggedReason | null | undefined, failureMessage?: string | null | undefined, canPush: boolean } | null | undefined }> };

export type EmailBulkDraftCardQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailBulkDraftCardQuery = { __typename?: 'Query', emailBulkSend?: { __typename?: 'EmailBulkSend', id: string, name: string, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number, failed: number } } | null | undefined };

export type EmailBulkSendListFieldsFragment = { __typename?: 'EmailBulkSend', createdAt: Date, id: string, name: string, action?: EmailBulkSendAction | null | undefined, mailboxAccountId?: string | null | undefined, fromAddress?: string | null | undefined, sentAt?: Date | null | undefined, firstSendAt?: Date | null | undefined, cancelledAt?: Date | null | undefined, isWaitingForMailbox: boolean, cancelReturnsToDraft: boolean, canChangeTime: boolean, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number }, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, progress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number, heldBack: number, notSent: number }, outsideBatchProgress: { __typename?: 'EmailBulkSendProgress', total: number, sent: number, failed: number, cancelled: number, inDrafts: number }, roundProgress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number } };

export type EmailBulkSendSummaryFieldsFragment = { __typename?: 'EmailBulkSend', id: string, name: string, action?: EmailBulkSendAction | null | undefined, mailboxAccountId?: string | null | undefined, fromAddress?: string | null | undefined, sentAt?: Date | null | undefined, firstSendAt?: Date | null | undefined, cancelledAt?: Date | null | undefined, isWaitingForMailbox: boolean, cancelReturnsToDraft: boolean, canChangeTime: boolean, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, progress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number, heldBack: number, notSent: number }, outsideBatchProgress: { __typename?: 'EmailBulkSendProgress', total: number, sent: number, failed: number, cancelled: number, inDrafts: number }, roundProgress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number } };

export type EmailBulkSendRecipientFieldsFragment = { __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, amsAccountId?: string | null | undefined, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState, heldBackReason?: string | null | undefined };

export type EmailBulkDraftFieldsFragment = { __typename?: 'EmailBulkSend', id: string, name: string, workspaceId: string, sentAt?: Date | null | undefined, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, amsAccountId?: string | null | undefined, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState, heldBackReason?: string | null | undefined }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number } };

export type EmailBulkSendsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  unsentOnly?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type EmailBulkSendsQuery = { __typename?: 'Query', emailBulkSends: Array<{ __typename?: 'EmailBulkSend', createdAt: Date, id: string, name: string, action?: EmailBulkSendAction | null | undefined, mailboxAccountId?: string | null | undefined, fromAddress?: string | null | undefined, sentAt?: Date | null | undefined, firstSendAt?: Date | null | undefined, cancelledAt?: Date | null | undefined, isWaitingForMailbox: boolean, cancelReturnsToDraft: boolean, canChangeTime: boolean, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number }, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, progress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number, heldBack: number, notSent: number }, outsideBatchProgress: { __typename?: 'EmailBulkSendProgress', total: number, sent: number, failed: number, cancelled: number, inDrafts: number }, roundProgress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number } }> };

export type EmailBulkSendQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailBulkSendQuery = { __typename?: 'Query', emailBulkSend?: { __typename?: 'EmailBulkSend', createdAt: Date, id: string, name: string, action?: EmailBulkSendAction | null | undefined, mailboxAccountId?: string | null | undefined, fromAddress?: string | null | undefined, sentAt?: Date | null | undefined, firstSendAt?: Date | null | undefined, cancelledAt?: Date | null | undefined, isWaitingForMailbox: boolean, cancelReturnsToDraft: boolean, canChangeTime: boolean, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number }, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, progress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number, heldBack: number, notSent: number }, outsideBatchProgress: { __typename?: 'EmailBulkSendProgress', total: number, sent: number, failed: number, cancelled: number, inDrafts: number }, roundProgress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number } } | null | undefined };

export type EmailBulkSendRecipientsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailBulkSendRecipientsQuery = { __typename?: 'Query', emailBulkSend?: { __typename?: 'EmailBulkSend', restCount: number, id: string, name: string, action?: EmailBulkSendAction | null | undefined, mailboxAccountId?: string | null | undefined, fromAddress?: string | null | undefined, sentAt?: Date | null | undefined, firstSendAt?: Date | null | undefined, cancelledAt?: Date | null | undefined, isWaitingForMailbox: boolean, cancelReturnsToDraft: boolean, canChangeTime: boolean, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, heldBackReason?: string | null | undefined, sendStatus?: EmailBulkSendRecipientSendStatus | null | undefined, sendFailureKind?: OutboundEmailFailureKind | null | undefined, isOutsideBatch: boolean }>, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, progress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number, heldBack: number, notSent: number }, outsideBatchProgress: { __typename?: 'EmailBulkSendProgress', total: number, sent: number, failed: number, cancelled: number, inDrafts: number }, roundProgress: { __typename?: 'EmailBulkSendProgress', total: number, sending: number, sent: number, failed: number, cancelled: number, inDrafts: number } } | null | undefined };

export type CancelEmailBulkSendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelEmailBulkSendMutation = { __typename?: 'Mutation', cancelEmailBulkSend: { __typename?: 'EmailBulkSend', id: string, cancelledAt?: Date | null | undefined } };

export type ChangeEmailBulkSendTimeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ChangeEmailBulkSendTimeInput;
}>;


export type ChangeEmailBulkSendTimeMutation = { __typename?: 'Mutation', changeEmailBulkSendTime: { __typename?: 'EmailBulkSend', id: string, firstSendAt?: Date | null | undefined } };

export type EmailBulkDraftQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type EmailBulkDraftQuery = { __typename?: 'Query', emailBulkSend?: { __typename?: 'EmailBulkSend', id: string, name: string, workspaceId: string, sentAt?: Date | null | undefined, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, amsAccountId?: string | null | undefined, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState, heldBackReason?: string | null | undefined }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number } } | null | undefined };

export type BulkDraftEmailsQueryVariables = Exact<{
  artifactIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type BulkDraftEmailsQuery = { __typename?: 'Query', caraWorkspaceArtifacts: Array<{ __typename?: 'CaraWorkspaceArtifactSummary', id: string, title: string, latestVersion: number, versions: Array<{ __typename?: 'CaraWorkspaceArtifact', id: string, version: number, email?: { __typename?: 'CaraWorkspaceArtifactEmail', template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string } | null | undefined, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', email: string }> } | null | undefined }> }> };

export type MailboxBulkSendUsageQueryVariables = Exact<{
  mailboxAccountId: Scalars['String']['input'];
  count: Scalars['Int']['input'];
  notBefore?: InputMaybe<Scalars['Time']['input']>;
}>;


export type MailboxBulkSendUsageQuery = { __typename?: 'Query', mailboxBulkSendUsage: { __typename?: 'MailboxBulkSendUsage', usedInDailyWindow: number, dailyLimit: number, earliestSendAt?: Date | null | undefined } };

export type SendEmailBulkSendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SendEmailBulkSendInput;
}>;


export type SendEmailBulkSendMutation = { __typename?: 'Mutation', sendEmailBulkSend: { __typename?: 'EmailBulkSend', id: string, name: string, sentAt?: Date | null | undefined, action?: EmailBulkSendAction | null | undefined, fromAddress?: string | null | undefined } };

export type SendRestOfEmailBulkSendMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: SendRestOfEmailBulkSendInput;
}>;


export type SendRestOfEmailBulkSendMutation = { __typename?: 'Mutation', sendRestOfEmailBulkSend: { __typename?: 'EmailBulkSend', id: string, name: string, sentAt?: Date | null | undefined, action?: EmailBulkSendAction | null | undefined, fromAddress?: string | null | undefined } };

export type AddEmailBulkSendRecipientsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipients: Array<EmailBulkSendRecipientInput> | EmailBulkSendRecipientInput;
}>;


export type AddEmailBulkSendRecipientsMutation = { __typename?: 'Mutation', addEmailBulkSendRecipients: { __typename?: 'AddEmailBulkSendRecipientsResult', added: number, duplicatesSkipped: number, overCap: number, bulkSend: { __typename?: 'EmailBulkSend', id: string, name: string, workspaceId: string, sentAt?: Date | null | undefined, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, amsAccountId?: string | null | undefined, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState, heldBackReason?: string | null | undefined }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number } } } };

export type RemoveEmailBulkSendRecipientsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  recipientIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type RemoveEmailBulkSendRecipientsMutation = { __typename?: 'Mutation', removeEmailBulkSendRecipients: { __typename?: 'EmailBulkSend', id: string, name: string, workspaceId: string, sentAt?: Date | null | undefined, recipients: Array<{ __typename?: 'EmailBulkSendRecipient', id: string, email?: string | null | undefined, name?: string | null | undefined, amsAccountId?: string | null | undefined, artifactId?: string | null | undefined, draftState: EmailBulkSendDraftState, heldBackReason?: string | null | undefined }>, draftProgress: { __typename?: 'EmailBulkSendDraftProgress', total: number, finished: number } } };

export type BulkDraftClientSearchQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkDraftClientSearchQuery = { __typename?: 'Query', searchRecipients: Array<{ __typename?: 'RecipientSuggestion', email: string, name?: string | null | undefined, description?: string | null | undefined, amsAccountId?: string | null | undefined }> };

export type EmailTemplateListFieldsFragment = { __typename?: 'EmailTemplate', id: string, name: string, subject: string, updatedAt: Date, usageLast30Days?: number | null | undefined, canEdit: boolean, updatedBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type GetEmailTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailTemplatesQuery = { __typename?: 'Query', emailTemplates: Array<{ __typename?: 'EmailTemplate', id: string, name: string, subject: string, updatedAt: Date, usageLast30Days?: number | null | undefined, canEdit: boolean, updatedBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type EmailTemplateEditorFieldsFragment = { __typename?: 'EmailTemplate', id: string, name: string, whenToUse?: string | null | undefined, subject: string, bodyHtml: string, guidelines: Array<string>, version: number, archivedAt?: Date | null | undefined, updatedAt: Date, canEdit: boolean, updatedBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type GetEmailTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailTemplateQuery = { __typename?: 'Query', emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string, whenToUse?: string | null | undefined, subject: string, bodyHtml: string, guidelines: Array<string>, version: number, archivedAt?: Date | null | undefined, updatedAt: Date, canEdit: boolean, updatedBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, createdBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } | null | undefined };

export type GetEmailTemplateChoicesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailTemplateChoicesQuery = { __typename?: 'Query', emailTemplates: Array<{ __typename?: 'EmailTemplate', id: string, name: string, whenToUse?: string | null | undefined }> };

export type GetEmailDraftTemplateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailDraftTemplateQuery = { __typename?: 'Query', emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string, version: number, archivedAt?: Date | null | undefined, updatedAt: Date, updatedBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } | null | undefined };

export type GetEmailTemplateContentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailTemplateContentQuery = { __typename?: 'Query', emailTemplate?: { __typename?: 'EmailTemplate', id: string, name: string, whenToUse?: string | null | undefined, subject: string, bodyHtml: string, guidelines: Array<string>, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } | null | undefined };

export type CreateEmailTemplateMutationVariables = Exact<{
  input: EmailTemplateInput;
}>;


export type CreateEmailTemplateMutation = { __typename?: 'Mutation', createEmailTemplate: { __typename?: 'EmailTemplate', id: string } };

export type UpdateEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  expectedVersion: Scalars['Int64']['input'];
  input: EmailTemplateInput;
}>;


export type UpdateEmailTemplateMutation = { __typename?: 'Mutation', updateEmailTemplate: { __typename?: 'EmailTemplate', id: string, version: number } };

export type ArchiveEmailTemplateMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveEmailTemplateMutation = { __typename?: 'Mutation', archiveEmailTemplate: { __typename?: 'EmailTemplate', id: string } };

export type GetAgencyEmailGuidelinesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyEmailGuidelinesQuery = { __typename?: 'Query', agency?: { __typename?: 'Agency', id: string, configuration: { __typename?: 'AgencyConfiguration', email?: { __typename?: 'AgencyEmailConfiguration', guidelines: Array<string> } | null | undefined } } | null | undefined };

export type UpdateAgencyEmailGuidelinesMutationVariables = Exact<{
  guidelines: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type UpdateAgencyEmailGuidelinesMutation = { __typename?: 'Mutation', updateAgencyEmailGuidelines: { __typename?: 'AgencyEmailConfiguration', guidelines: Array<string> } };

export type EmailFieldsFragment = { __typename?: 'Email', body: string, id: string, senderRole: EmailSenderRole, sentAt: Date, subject: string, from: { __typename?: 'EmailParticipant', name: string, email: string }, to: Array<{ __typename?: 'EmailParticipant', name: string, email: string }> };

export type EmailThreadFieldsFragment = { __typename?: 'EmailThread', fromEmail: string, fromName: string, id: string, state: EmailThreadState, subject: string, waitingFor?: EmailSenderRole | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined };

export type EmailThreadConversationFieldsFragment = { __typename?: 'EmailThread', summary: string, attachments: Array<{ __typename?: 'File', id: string, name: string, url?: string | null | undefined }>, participantEmails: Array<{ __typename?: 'Email', body: string, id: string, senderRole: EmailSenderRole, sentAt: Date, subject: string, from: { __typename?: 'EmailParticipant', name: string, email: string }, to: Array<{ __typename?: 'EmailParticipant', name: string, email: string }> }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, workspace?: { __typename?: 'CaraWorkspace', id: string, title: string, state: CaraWorkspaceState } | null | undefined };

export type GetEmailThreadsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailThreadsQuery = { __typename?: 'Query', emailThreads: Array<{ __typename?: 'EmailThread', fromEmail: string, fromName: string, id: string, state: EmailThreadState, subject: string, waitingFor?: EmailSenderRole | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined }> };

export type GetEmailThreadQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetEmailThreadQuery = { __typename?: 'Query', emailThread: { __typename?: 'EmailThread', fromEmail: string, fromName: string, id: string, state: EmailThreadState, subject: string, waitingFor?: EmailSenderRole | null | undefined, createdAt: Date, updatedAt: Date, summary: string, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, attachments: Array<{ __typename?: 'File', id: string, name: string, url?: string | null | undefined }>, participantEmails: Array<{ __typename?: 'Email', body: string, id: string, senderRole: EmailSenderRole, sentAt: Date, subject: string, from: { __typename?: 'EmailParticipant', name: string, email: string }, to: Array<{ __typename?: 'EmailParticipant', name: string, email: string }> }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, workspace?: { __typename?: 'CaraWorkspace', id: string, title: string, state: CaraWorkspaceState } | null | undefined } };

export type FeedbackFieldsFragment = { __typename?: 'Feedback', id: string, scope: FeedbackScope, rating?: MessageRating | null | undefined, comment?: string | null | undefined, createdAt: Date, updatedAt: Date, deletedAt?: Date | null | undefined, agency: { __typename?: 'Agency', id: string }, agencyUser: { __typename?: 'AgencyUser', id: string }, workspace?: { __typename?: 'CaraWorkspace', id: string } | null | undefined, message?: { __typename?: 'CaraWorkspaceMessage', id: string } | null | undefined, call?: { __typename?: 'Call', id: string } | null | undefined, feedback: { __typename?: 'FeedbackContent', message?: { __typename?: 'MessageFeedback', reasons?: Array<MessageFeedbackNegativeReason> | null | undefined } | null | undefined, call?: { __typename?: 'CallFeedback', reasons?: Array<CallQualityFeedbackNegativeReason> | null | undefined } | null | undefined } };

export type GetFeedbackQueryVariables = Exact<{
  input: GetFeedbackInput;
}>;


export type GetFeedbackQuery = { __typename?: 'Query', getFeedback: Array<{ __typename?: 'Feedback', id: string, scope: FeedbackScope, rating?: MessageRating | null | undefined, comment?: string | null | undefined, createdAt: Date, updatedAt: Date, deletedAt?: Date | null | undefined, agency: { __typename?: 'Agency', id: string }, agencyUser: { __typename?: 'AgencyUser', id: string }, workspace?: { __typename?: 'CaraWorkspace', id: string } | null | undefined, message?: { __typename?: 'CaraWorkspaceMessage', id: string } | null | undefined, call?: { __typename?: 'Call', id: string } | null | undefined, feedback: { __typename?: 'FeedbackContent', message?: { __typename?: 'MessageFeedback', reasons?: Array<MessageFeedbackNegativeReason> | null | undefined } | null | undefined, call?: { __typename?: 'CallFeedback', reasons?: Array<CallQualityFeedbackNegativeReason> | null | undefined } | null | undefined } }> };

export type SubmitMessageRatingMutationVariables = Exact<{
  input: SubmitMessageRatingInput;
}>;


export type SubmitMessageRatingMutation = { __typename?: 'Mutation', submitMessageRating: { __typename?: 'Feedback', id: string, scope: FeedbackScope, rating?: MessageRating | null | undefined, comment?: string | null | undefined, createdAt: Date, updatedAt: Date, deletedAt?: Date | null | undefined, agency: { __typename?: 'Agency', id: string }, agencyUser: { __typename?: 'AgencyUser', id: string }, workspace?: { __typename?: 'CaraWorkspace', id: string } | null | undefined, message?: { __typename?: 'CaraWorkspaceMessage', id: string } | null | undefined, call?: { __typename?: 'Call', id: string } | null | undefined, feedback: { __typename?: 'FeedbackContent', message?: { __typename?: 'MessageFeedback', reasons?: Array<MessageFeedbackNegativeReason> | null | undefined } | null | undefined, call?: { __typename?: 'CallFeedback', reasons?: Array<CallQualityFeedbackNegativeReason> | null | undefined } | null | undefined } } };

export type SubmitCallRatingMutationVariables = Exact<{
  input: SubmitCallRatingInput;
}>;


export type SubmitCallRatingMutation = { __typename?: 'Mutation', submitCallRating: { __typename?: 'Feedback', id: string, scope: FeedbackScope, rating?: MessageRating | null | undefined, comment?: string | null | undefined, createdAt: Date, updatedAt: Date, deletedAt?: Date | null | undefined, agency: { __typename?: 'Agency', id: string }, agencyUser: { __typename?: 'AgencyUser', id: string }, workspace?: { __typename?: 'CaraWorkspace', id: string } | null | undefined, message?: { __typename?: 'CaraWorkspaceMessage', id: string } | null | undefined, call?: { __typename?: 'Call', id: string } | null | undefined, feedback: { __typename?: 'FeedbackContent', message?: { __typename?: 'MessageFeedback', reasons?: Array<MessageFeedbackNegativeReason> | null | undefined } | null | undefined, call?: { __typename?: 'CallFeedback', reasons?: Array<CallQualityFeedbackNegativeReason> | null | undefined } | null | undefined } } };

export type DeleteFeedbackMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteFeedbackMutation = { __typename?: 'Mutation', deleteFeedback: { __typename?: 'Feedback', id: string, scope: FeedbackScope, rating?: MessageRating | null | undefined, comment?: string | null | undefined, createdAt: Date, updatedAt: Date, deletedAt?: Date | null | undefined, agency: { __typename?: 'Agency', id: string }, agencyUser: { __typename?: 'AgencyUser', id: string }, workspace?: { __typename?: 'CaraWorkspace', id: string } | null | undefined, message?: { __typename?: 'CaraWorkspaceMessage', id: string } | null | undefined, call?: { __typename?: 'Call', id: string } | null | undefined, feedback: { __typename?: 'FeedbackContent', message?: { __typename?: 'MessageFeedback', reasons?: Array<MessageFeedbackNegativeReason> | null | undefined } | null | undefined, call?: { __typename?: 'CallFeedback', reasons?: Array<CallQualityFeedbackNegativeReason> | null | undefined } | null | undefined } } };

export type FileFieldsFragment = { __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined };

export type DeleteFileMutationVariables = Exact<{
  fileId: Scalars['ID']['input'];
}>;


export type DeleteFileMutation = { __typename?: 'Mutation', deleteFile?: { __typename?: 'File', createdAt: Date, id: string, mimeType: string, name: string, notes: string, type: FileType, url?: string | null | undefined } | null | undefined };

export type UploadImageToWorkspaceMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  file: UploadFileInput;
}>;


export type UploadImageToWorkspaceMutation = { __typename?: 'Mutation', uploadWorkspaceFile: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } };

export type UploadImageToTemplateMutationVariables = Exact<{
  templateId: Scalars['ID']['input'];
  file: UploadFileInput;
}>;


export type UploadImageToTemplateMutation = { __typename?: 'Mutation', uploadHtmlDocumentTemplateFile: { __typename?: 'File', id: string, url?: string | null | undefined, name: string } };

export type SearchFileResultFieldsFragment = { __typename?: 'SearchFileResult', id: string, name: string, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined };

export type SearchExistingFilesQueryVariables = Exact<{
  filters: SearchFileFilter;
}>;


export type SearchExistingFilesQuery = { __typename?: 'Query', searchFiles: Array<{ __typename?: 'SearchFileResult', id: string, name: string, integration?: { __typename?: 'Integration', id: string, type: IntegrationType } | null | undefined }> };

export type ImportSchemaFieldsFragment = { __typename?: 'ImportSchema', keyColumns: Array<string>, tieBreaker?: string | null | undefined, columns: Array<{ __typename?: 'ImportColumn', key: string, label: string, type: ImportColumnType, required: boolean, multiple: boolean, compareLiterally: boolean, fixedOnceAdded: boolean, addOnly: boolean, enumValues?: Array<string> | null | undefined, optionsFrom?: ImportColumnOptionsSource | null | undefined }> };

export type GetTransferDirectoryImportSchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTransferDirectoryImportSchemaQuery = { __typename?: 'Query', transferDirectoryImportSchema: { __typename?: 'ImportSchema', keyColumns: Array<string>, tieBreaker?: string | null | undefined, columns: Array<{ __typename?: 'ImportColumn', key: string, label: string, type: ImportColumnType, required: boolean, multiple: boolean, compareLiterally: boolean, fixedOnceAdded: boolean, addOnly: boolean, enumValues?: Array<string> | null | undefined, optionsFrom?: ImportColumnOptionsSource | null | undefined }> } };

export type GetAgencyUserImportSchemaQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAgencyUserImportSchemaQuery = { __typename?: 'Query', agencyUserImportSchema: { __typename?: 'ImportSchema', keyColumns: Array<string>, tieBreaker?: string | null | undefined, columns: Array<{ __typename?: 'ImportColumn', key: string, label: string, type: ImportColumnType, required: boolean, multiple: boolean, compareLiterally: boolean, fixedOnceAdded: boolean, addOnly: boolean, enumValues?: Array<string> | null | undefined, optionsFrom?: ImportColumnOptionsSource | null | undefined }> } };

export type IntegrationFieldsFragment = { __typename?: 'Integration', id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean };

export type IntegrationSyncLogFieldsFragment = { __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType };

export type IntegrationDetailFieldsFragment = { __typename?: 'Integration', lastSyncedAt?: Date | null | undefined, canLogSentEmails: boolean, cannotLogSentEmailsReason?: AmsNotLoggedReason | null | undefined, emailLogDestinations: Array<EmailAmsLogDestination>, id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined, configuration: { __typename?: 'IntegrationConfiguration', hawksoft?: { __typename?: 'HawksoftConfiguration', agencyId: string, enableSyncCallNotes: boolean, enableSyncServiceRequests: boolean } | null | undefined, nowcerts?: { __typename?: 'NowCertsConfiguration', username: string, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, prospectReferralSource?: string | null | undefined } | null | undefined, hubspot?: { __typename?: 'HubSpotConfiguration', accessToken: string, enableSyncTasks: boolean, taskSyncType?: HubSpotTaskSyncType | null | undefined, taskPipelineId?: string | null | undefined, taskStageId?: string | null | undefined, enableSyncAccounts: boolean, enableSyncCalls: boolean, callSyncType?: HubSpotCallSyncType | null | undefined, callPipelineId?: string | null | undefined, callStageId?: string | null | undefined, callFieldMappings?: { __typename?: 'HubSpotCallFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined, taskFieldMappings?: { __typename?: 'HubSpotTaskFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined } | null | undefined, zapier?: { __typename?: 'ZapierConfiguration', apiKey: string } | null | undefined, agencyZoom?: { __typename?: 'AgencyZoomConfiguration', username: string, isSSOLogin: boolean, enableSyncAccounts: boolean, enableSyncTasks: boolean } | null | undefined, ams360?: { __typename?: 'AMS360Configuration', appKey: string, agencyNo: string, appAccessToAgencyKey: string, enableSyncAccounts: boolean, enableSyncCalls: boolean, enableSyncTasks: boolean, taskAssignmentMethod?: Ams360TaskAssignmentMethod | null | undefined, defaultTaskDueBusinessDays?: number | null | undefined } | null | undefined, ezlynx?: { __typename?: 'EzLynxConfiguration', clientId?: string | null | undefined, username?: string | null | undefined, integrationGroupId?: string | null | undefined, csvImportOnly: boolean } | null | undefined, appliedEpic?: { __typename?: 'AppliedEpicConfiguration', type: AppliedEpicIntegrationType, sdkCredentials?: { __typename?: 'AppliedEpicSdkCredentials', baseUrl: string, databaseName: string } | null | undefined } | null | undefined, imageRight?: { __typename?: 'ImageRightConfiguration', serverUrl: string, username: string } | null | undefined, qqcatalyst?: { __typename?: 'QQCatalystConfiguration', defaultLocationId?: number | null | undefined, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, taskAssignment?: QqCatalystTaskAssignment | null | undefined, taskAssignmentEmployeeId?: number | null | undefined, locations?: Array<{ __typename?: 'QQCatalystLocation', locationId: number, locationName: string, isDefault: boolean }> | null | undefined, employees?: Array<{ __typename?: 'QQCatalystEmployee', employeeId: number, displayName: string }> | null | undefined, categoryCounts?: Array<{ __typename?: 'QQCatalystCategoryCount', category: string, count: number }> | null | undefined } | null | undefined }, syncLogs: Array<{ __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType }> };

export type GetIntegrationsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIntegrationsQuery = { __typename?: 'Query', integrations: Array<{ __typename?: 'Integration', id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean }> };

export type GetIntegrationQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIntegrationQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', lastSyncedAt?: Date | null | undefined, canLogSentEmails: boolean, cannotLogSentEmailsReason?: AmsNotLoggedReason | null | undefined, emailLogDestinations: Array<EmailAmsLogDestination>, id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined, configuration: { __typename?: 'IntegrationConfiguration', hawksoft?: { __typename?: 'HawksoftConfiguration', agencyId: string, enableSyncCallNotes: boolean, enableSyncServiceRequests: boolean } | null | undefined, nowcerts?: { __typename?: 'NowCertsConfiguration', username: string, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, prospectReferralSource?: string | null | undefined } | null | undefined, hubspot?: { __typename?: 'HubSpotConfiguration', accessToken: string, enableSyncTasks: boolean, taskSyncType?: HubSpotTaskSyncType | null | undefined, taskPipelineId?: string | null | undefined, taskStageId?: string | null | undefined, enableSyncAccounts: boolean, enableSyncCalls: boolean, callSyncType?: HubSpotCallSyncType | null | undefined, callPipelineId?: string | null | undefined, callStageId?: string | null | undefined, callFieldMappings?: { __typename?: 'HubSpotCallFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined, taskFieldMappings?: { __typename?: 'HubSpotTaskFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined } | null | undefined, zapier?: { __typename?: 'ZapierConfiguration', apiKey: string } | null | undefined, agencyZoom?: { __typename?: 'AgencyZoomConfiguration', username: string, isSSOLogin: boolean, enableSyncAccounts: boolean, enableSyncTasks: boolean } | null | undefined, ams360?: { __typename?: 'AMS360Configuration', appKey: string, agencyNo: string, appAccessToAgencyKey: string, enableSyncAccounts: boolean, enableSyncCalls: boolean, enableSyncTasks: boolean, taskAssignmentMethod?: Ams360TaskAssignmentMethod | null | undefined, defaultTaskDueBusinessDays?: number | null | undefined } | null | undefined, ezlynx?: { __typename?: 'EzLynxConfiguration', clientId?: string | null | undefined, username?: string | null | undefined, integrationGroupId?: string | null | undefined, csvImportOnly: boolean } | null | undefined, appliedEpic?: { __typename?: 'AppliedEpicConfiguration', type: AppliedEpicIntegrationType, sdkCredentials?: { __typename?: 'AppliedEpicSdkCredentials', baseUrl: string, databaseName: string } | null | undefined } | null | undefined, imageRight?: { __typename?: 'ImageRightConfiguration', serverUrl: string, username: string } | null | undefined, qqcatalyst?: { __typename?: 'QQCatalystConfiguration', defaultLocationId?: number | null | undefined, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, taskAssignment?: QqCatalystTaskAssignment | null | undefined, taskAssignmentEmployeeId?: number | null | undefined, locations?: Array<{ __typename?: 'QQCatalystLocation', locationId: number, locationName: string, isDefault: boolean }> | null | undefined, employees?: Array<{ __typename?: 'QQCatalystEmployee', employeeId: number, displayName: string }> | null | undefined, categoryCounts?: Array<{ __typename?: 'QQCatalystCategoryCount', category: string, count: number }> | null | undefined } | null | undefined }, syncLogs: Array<{ __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType }> } | null | undefined };

export type CreateIntegrationMutationVariables = Exact<{
  input: CreateIntegrationInput;
}>;


export type CreateIntegrationMutation = { __typename?: 'Mutation', createIntegration?: { __typename?: 'Integration', lastSyncedAt?: Date | null | undefined, canLogSentEmails: boolean, cannotLogSentEmailsReason?: AmsNotLoggedReason | null | undefined, emailLogDestinations: Array<EmailAmsLogDestination>, id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined, configuration: { __typename?: 'IntegrationConfiguration', hawksoft?: { __typename?: 'HawksoftConfiguration', agencyId: string, enableSyncCallNotes: boolean, enableSyncServiceRequests: boolean } | null | undefined, nowcerts?: { __typename?: 'NowCertsConfiguration', username: string, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, prospectReferralSource?: string | null | undefined } | null | undefined, hubspot?: { __typename?: 'HubSpotConfiguration', accessToken: string, enableSyncTasks: boolean, taskSyncType?: HubSpotTaskSyncType | null | undefined, taskPipelineId?: string | null | undefined, taskStageId?: string | null | undefined, enableSyncAccounts: boolean, enableSyncCalls: boolean, callSyncType?: HubSpotCallSyncType | null | undefined, callPipelineId?: string | null | undefined, callStageId?: string | null | undefined, callFieldMappings?: { __typename?: 'HubSpotCallFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined, taskFieldMappings?: { __typename?: 'HubSpotTaskFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined } | null | undefined, zapier?: { __typename?: 'ZapierConfiguration', apiKey: string } | null | undefined, agencyZoom?: { __typename?: 'AgencyZoomConfiguration', username: string, isSSOLogin: boolean, enableSyncAccounts: boolean, enableSyncTasks: boolean } | null | undefined, ams360?: { __typename?: 'AMS360Configuration', appKey: string, agencyNo: string, appAccessToAgencyKey: string, enableSyncAccounts: boolean, enableSyncCalls: boolean, enableSyncTasks: boolean, taskAssignmentMethod?: Ams360TaskAssignmentMethod | null | undefined, defaultTaskDueBusinessDays?: number | null | undefined } | null | undefined, ezlynx?: { __typename?: 'EzLynxConfiguration', clientId?: string | null | undefined, username?: string | null | undefined, integrationGroupId?: string | null | undefined, csvImportOnly: boolean } | null | undefined, appliedEpic?: { __typename?: 'AppliedEpicConfiguration', type: AppliedEpicIntegrationType, sdkCredentials?: { __typename?: 'AppliedEpicSdkCredentials', baseUrl: string, databaseName: string } | null | undefined } | null | undefined, imageRight?: { __typename?: 'ImageRightConfiguration', serverUrl: string, username: string } | null | undefined, qqcatalyst?: { __typename?: 'QQCatalystConfiguration', defaultLocationId?: number | null | undefined, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, taskAssignment?: QqCatalystTaskAssignment | null | undefined, taskAssignmentEmployeeId?: number | null | undefined, locations?: Array<{ __typename?: 'QQCatalystLocation', locationId: number, locationName: string, isDefault: boolean }> | null | undefined, employees?: Array<{ __typename?: 'QQCatalystEmployee', employeeId: number, displayName: string }> | null | undefined, categoryCounts?: Array<{ __typename?: 'QQCatalystCategoryCount', category: string, count: number }> | null | undefined } | null | undefined }, syncLogs: Array<{ __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType }> } | null | undefined };

export type UpdateIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateIntegrationInput;
}>;


export type UpdateIntegrationMutation = { __typename?: 'Mutation', updateIntegration: { __typename?: 'Integration', lastSyncedAt?: Date | null | undefined, canLogSentEmails: boolean, cannotLogSentEmailsReason?: AmsNotLoggedReason | null | undefined, emailLogDestinations: Array<EmailAmsLogDestination>, id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined, configuration: { __typename?: 'IntegrationConfiguration', hawksoft?: { __typename?: 'HawksoftConfiguration', agencyId: string, enableSyncCallNotes: boolean, enableSyncServiceRequests: boolean } | null | undefined, nowcerts?: { __typename?: 'NowCertsConfiguration', username: string, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, prospectReferralSource?: string | null | undefined } | null | undefined, hubspot?: { __typename?: 'HubSpotConfiguration', accessToken: string, enableSyncTasks: boolean, taskSyncType?: HubSpotTaskSyncType | null | undefined, taskPipelineId?: string | null | undefined, taskStageId?: string | null | undefined, enableSyncAccounts: boolean, enableSyncCalls: boolean, callSyncType?: HubSpotCallSyncType | null | undefined, callPipelineId?: string | null | undefined, callStageId?: string | null | undefined, callFieldMappings?: { __typename?: 'HubSpotCallFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined, taskFieldMappings?: { __typename?: 'HubSpotTaskFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined } | null | undefined, zapier?: { __typename?: 'ZapierConfiguration', apiKey: string } | null | undefined, agencyZoom?: { __typename?: 'AgencyZoomConfiguration', username: string, isSSOLogin: boolean, enableSyncAccounts: boolean, enableSyncTasks: boolean } | null | undefined, ams360?: { __typename?: 'AMS360Configuration', appKey: string, agencyNo: string, appAccessToAgencyKey: string, enableSyncAccounts: boolean, enableSyncCalls: boolean, enableSyncTasks: boolean, taskAssignmentMethod?: Ams360TaskAssignmentMethod | null | undefined, defaultTaskDueBusinessDays?: number | null | undefined } | null | undefined, ezlynx?: { __typename?: 'EzLynxConfiguration', clientId?: string | null | undefined, username?: string | null | undefined, integrationGroupId?: string | null | undefined, csvImportOnly: boolean } | null | undefined, appliedEpic?: { __typename?: 'AppliedEpicConfiguration', type: AppliedEpicIntegrationType, sdkCredentials?: { __typename?: 'AppliedEpicSdkCredentials', baseUrl: string, databaseName: string } | null | undefined } | null | undefined, imageRight?: { __typename?: 'ImageRightConfiguration', serverUrl: string, username: string } | null | undefined, qqcatalyst?: { __typename?: 'QQCatalystConfiguration', defaultLocationId?: number | null | undefined, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, taskAssignment?: QqCatalystTaskAssignment | null | undefined, taskAssignmentEmployeeId?: number | null | undefined, locations?: Array<{ __typename?: 'QQCatalystLocation', locationId: number, locationName: string, isDefault: boolean }> | null | undefined, employees?: Array<{ __typename?: 'QQCatalystEmployee', employeeId: number, displayName: string }> | null | undefined, categoryCounts?: Array<{ __typename?: 'QQCatalystCategoryCount', category: string, count: number }> | null | undefined } | null | undefined }, syncLogs: Array<{ __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType }> } };

export type SetIntegrationLogsSentEmailsMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  enabled: Scalars['Boolean']['input'];
}>;


export type SetIntegrationLogsSentEmailsMutation = { __typename?: 'Mutation', setIntegrationLogsSentEmails: { __typename?: 'Integration', id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean } };

export type SyncIntegrationMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncIntegrationMutation = { __typename?: 'Mutation', syncIntegration?: { __typename?: 'Integration', lastSyncedAt?: Date | null | undefined, canLogSentEmails: boolean, cannotLogSentEmailsReason?: AmsNotLoggedReason | null | undefined, emailLogDestinations: Array<EmailAmsLogDestination>, id: string, type: IntegrationType, state: IntegrationState, createdAt: Date, updatedAt: Date, logsSentEmails: boolean, emailLogPreference?: { __typename?: 'EmailAmsLogPreference', destination: EmailAmsLogDestination, activityCode?: string | null | undefined, companyCode?: string | null | undefined, assignToEmployeeCode?: string | null | undefined, assignedByEmployeeCode?: string | null | undefined } | null | undefined, configuration: { __typename?: 'IntegrationConfiguration', hawksoft?: { __typename?: 'HawksoftConfiguration', agencyId: string, enableSyncCallNotes: boolean, enableSyncServiceRequests: boolean } | null | undefined, nowcerts?: { __typename?: 'NowCertsConfiguration', username: string, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, prospectReferralSource?: string | null | undefined } | null | undefined, hubspot?: { __typename?: 'HubSpotConfiguration', accessToken: string, enableSyncTasks: boolean, taskSyncType?: HubSpotTaskSyncType | null | undefined, taskPipelineId?: string | null | undefined, taskStageId?: string | null | undefined, enableSyncAccounts: boolean, enableSyncCalls: boolean, callSyncType?: HubSpotCallSyncType | null | undefined, callPipelineId?: string | null | undefined, callStageId?: string | null | undefined, callFieldMappings?: { __typename?: 'HubSpotCallFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined, taskFieldMappings?: { __typename?: 'HubSpotTaskFieldMappings', ticketFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }>, dealFields: Array<{ __typename?: 'HubSpotFieldMapping', hubspotField: string, caraField: string }> } | null | undefined } | null | undefined, zapier?: { __typename?: 'ZapierConfiguration', apiKey: string } | null | undefined, agencyZoom?: { __typename?: 'AgencyZoomConfiguration', username: string, isSSOLogin: boolean, enableSyncAccounts: boolean, enableSyncTasks: boolean } | null | undefined, ams360?: { __typename?: 'AMS360Configuration', appKey: string, agencyNo: string, appAccessToAgencyKey: string, enableSyncAccounts: boolean, enableSyncCalls: boolean, enableSyncTasks: boolean, taskAssignmentMethod?: Ams360TaskAssignmentMethod | null | undefined, defaultTaskDueBusinessDays?: number | null | undefined } | null | undefined, ezlynx?: { __typename?: 'EzLynxConfiguration', clientId?: string | null | undefined, username?: string | null | undefined, integrationGroupId?: string | null | undefined, csvImportOnly: boolean } | null | undefined, appliedEpic?: { __typename?: 'AppliedEpicConfiguration', type: AppliedEpicIntegrationType, sdkCredentials?: { __typename?: 'AppliedEpicSdkCredentials', baseUrl: string, databaseName: string } | null | undefined } | null | undefined, imageRight?: { __typename?: 'ImageRightConfiguration', serverUrl: string, username: string } | null | undefined, qqcatalyst?: { __typename?: 'QQCatalystConfiguration', defaultLocationId?: number | null | undefined, enableSyncAccounts: boolean, enableSyncTasks: boolean, enableSyncCalls: boolean, taskAssignment?: QqCatalystTaskAssignment | null | undefined, taskAssignmentEmployeeId?: number | null | undefined, locations?: Array<{ __typename?: 'QQCatalystLocation', locationId: number, locationName: string, isDefault: boolean }> | null | undefined, employees?: Array<{ __typename?: 'QQCatalystEmployee', employeeId: number, displayName: string }> | null | undefined, categoryCounts?: Array<{ __typename?: 'QQCatalystCategoryCount', category: string, count: number }> | null | undefined } | null | undefined }, syncLogs: Array<{ __typename?: 'IntegrationSyncLog', completedAt?: Date | null | undefined, entitiesSynced: number, id: string, initiatorType: UpdateInitiatorType, initiatorId: string, lastError?: string | null | undefined, startedAt: Date, state: IntegrationSyncState, type: IntegrationSyncType }> } | null | undefined };

export type GetHubSpotTicketPipelinesQueryVariables = Exact<{
  integrationId: Scalars['ID']['input'];
}>;


export type GetHubSpotTicketPipelinesQuery = { __typename?: 'Query', hubspotTicketPipelines: Array<{ __typename?: 'HubSpotTicketPipeline', id: string, label: string, displayOrder: number, createdAt: string, updatedAt: string, archived: boolean, stages: Array<{ __typename?: 'HubSpotTicketPipelineStage', id: string, label: string, displayOrder: number, archived: boolean, ticketState: string }> }> };

export type GetIntegrationStateQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetIntegrationStateQuery = { __typename?: 'Query', integration?: { __typename?: 'Integration', id: string, state: IntegrationState } | null | undefined };

export type KnowledgeBaseFieldsFragment = { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined };

export type KnowledgeBaseFolderFieldsFragment = { __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date };

export type KnowledgeBaseAccessFieldsFragment = { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } };

export type KnowledgeBaseListFieldsFragment = { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined };

export type KnowledgeBaseDetailFieldsFragment = { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined };

export type KnowledgeBaseDocumentUrlSourceFieldsFragment = { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean };

export type KnowledgeBaseDocumentFieldsFragment = { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined };

export type KnowledgeBaseDocumentVersionFieldsFragment = { __typename?: 'KnowledgeBaseDocument', id: string, versionNumber: number, createdAt: Date, createdBy: { __typename?: 'AgencyUser', name: string }, file?: { __typename?: 'KnowledgeBaseDocumentFile', url?: string | null | undefined } | null | undefined };

export type KnowledgeBaseDocumentDetailFieldsFragment = { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined };

export type GetKnowledgeBasesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKnowledgeBasesQuery = { __typename?: 'Query', knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined }> };

export type KnowledgeBaseDocumentSearchFieldsFragment = { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, updatedAt: Date, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, keywords?: Array<string> | null | undefined } | null | undefined };

export type GetKnowledgeBaseDocumentsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetKnowledgeBaseDocumentsQuery = { __typename?: 'Query', knowledgeBases: Array<{ __typename?: 'KnowledgeBase', id: string, title: string, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, updatedAt: Date, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, keywords?: Array<string> | null | undefined } | null | undefined }> }> };

export type GetKnowledgeBaseQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKnowledgeBaseQuery = { __typename?: 'Query', knowledgeBase?: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } | null | undefined };

export type GetKnowledgeBaseDocumentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKnowledgeBaseDocumentQuery = { __typename?: 'Query', knowledgeBaseDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } | null | undefined };

export type CreateKnowledgeBaseTextDocumentMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  input: CreateKnowledgeBaseTextDocumentInput;
}>;


export type CreateKnowledgeBaseTextDocumentMutation = { __typename?: 'Mutation', createKnowledgeBaseTextDocument: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } };

export type UploadKnowledgeBaseFileDocumentMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  input: UploadKnowledgeBaseFileDocumentInput;
}>;


export type UploadKnowledgeBaseFileDocumentMutation = { __typename?: 'Mutation', uploadKnowledgeBaseFileDocument: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }> };

export type UpdateKnowledgeBaseMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseInput;
}>;


export type UpdateKnowledgeBaseMutation = { __typename?: 'Mutation', updateKnowledgeBase?: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } | null | undefined };

export type CreateKnowledgeBaseFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  name: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateKnowledgeBaseFolderMutation = { __typename?: 'Mutation', createKnowledgeBaseFolder: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type RenameKnowledgeBaseFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  folderId: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type RenameKnowledgeBaseFolderMutation = { __typename?: 'Mutation', renameKnowledgeBaseFolder: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type MoveKnowledgeBaseFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  folderId: Scalars['String']['input'];
  parentFolderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveKnowledgeBaseFolderMutation = { __typename?: 'Mutation', moveKnowledgeBaseFolder: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type DeleteKnowledgeBaseFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  folderId: Scalars['String']['input'];
}>;


export type DeleteKnowledgeBaseFolderMutation = { __typename?: 'Mutation', deleteKnowledgeBaseFolder: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type DeleteKnowledgeBaseItemsMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  folderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type DeleteKnowledgeBaseItemsMutation = { __typename?: 'Mutation', deleteKnowledgeBaseItems: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type MoveKnowledgeBaseDocumentsToFolderMutationVariables = Exact<{
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveKnowledgeBaseDocumentsToFolderMutation = { __typename?: 'Mutation', moveKnowledgeBaseDocumentsToFolder: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }> };

export type MoveKnowledgeBaseItemsToFolderMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  documentIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
  folderIds: Array<Scalars['String']['input']> | Scalars['String']['input'];
  folderId?: InputMaybe<Scalars['String']['input']>;
}>;


export type MoveKnowledgeBaseItemsToFolderMutation = { __typename?: 'Mutation', moveKnowledgeBaseItemsToFolder: { __typename?: 'KnowledgeBase', id: string, title: string, version: KnowledgeBaseVersion, guidedRetrievalEnabled: boolean, createdAt: Date, updatedAt: Date, isOwner: boolean, accessList: Array<{ __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } }>, documents: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined }>, folders: Array<{ __typename?: 'KnowledgeBaseFolder', id: string, name: string, parentFolderId?: string | null | undefined, createdAt: Date, updatedAt: Date }>, myAccess?: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date } | null | undefined, ownerAgency?: { __typename?: 'Agency', id: string, name: string } | null | undefined } };

export type UpdateKnowledgeBaseDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseDocumentInput;
}>;


export type UpdateKnowledgeBaseDocumentMutation = { __typename?: 'Mutation', updateKnowledgeBaseDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } | null | undefined };

export type DeleteKnowledgeBaseDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteKnowledgeBaseDocumentMutation = { __typename?: 'Mutation', deleteKnowledgeBaseDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } | null | undefined };

export type FederatedChildAgencyFieldsFragment = { __typename?: 'Agency', id: string, name: string };

export type GetFederatedChildAgenciesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFederatedChildAgenciesQuery = { __typename?: 'Query', federatedChildAgencies: Array<{ __typename?: 'Agency', id: string, name: string }> };

export type GrantKnowledgeBaseAccessMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
}>;


export type GrantKnowledgeBaseAccessMutation = { __typename?: 'Mutation', grantKnowledgeBaseAccess: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } } };

export type UpdateKnowledgeBaseAccessMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
  role: KnowledgeBaseAccessRole;
}>;


export type UpdateKnowledgeBaseAccessMutation = { __typename?: 'Mutation', updateKnowledgeBaseAccess: { __typename?: 'KnowledgeBaseAccess', role: KnowledgeBaseAccessRole, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string } } };

export type RevokeKnowledgeBaseAccessMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  agencyId: Scalars['ID']['input'];
}>;


export type RevokeKnowledgeBaseAccessMutation = { __typename?: 'Mutation', revokeKnowledgeBaseAccess: boolean };

export type GetKnowledgeBaseDocumentVersionHistoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetKnowledgeBaseDocumentVersionHistoryQuery = { __typename?: 'Query', knowledgeBaseDocument?: { __typename?: 'KnowledgeBaseDocument', id: string, versionHistory: Array<{ __typename?: 'KnowledgeBaseDocument', id: string, versionNumber: number, createdAt: Date, createdBy: { __typename?: 'AgencyUser', name: string }, file?: { __typename?: 'KnowledgeBaseDocumentFile', url?: string | null | undefined } | null | undefined }> } | null | undefined };

export type ReplaceKnowledgeBaseDocumentMutationVariables = Exact<{
  documentId: Scalars['ID']['input'];
  file: Scalars['Upload']['input'];
}>;


export type ReplaceKnowledgeBaseDocumentMutation = { __typename?: 'Mutation', replaceKnowledgeBaseDocument: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } };

export type CreateKnowledgeBaseUrlDocumentMutationVariables = Exact<{
  knowledgeBaseId: Scalars['ID']['input'];
  input: CreateKnowledgeBaseUrlDocumentInput;
}>;


export type CreateKnowledgeBaseUrlDocumentMutation = { __typename?: 'Mutation', createKnowledgeBaseURLDocument: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } };

export type UpdateKnowledgeBaseUrlDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateKnowledgeBaseUrlDocumentInput;
}>;


export type UpdateKnowledgeBaseUrlDocumentMutation = { __typename?: 'Mutation', updateKnowledgeBaseURLDocument: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } };

export type SyncKnowledgeBaseUrlDocumentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SyncKnowledgeBaseUrlDocumentMutation = { __typename?: 'Mutation', syncKnowledgeBaseURLDocument: { __typename?: 'KnowledgeBaseDocument', id: string, title: string, displayName?: string | null | undefined, type: KnowledgeBaseDocumentType, createdAt: Date, updatedAt: Date, documentGroupId: string, versionNumber: number, folderId?: string | null | undefined, exampleQuestions?: string | null | undefined, contextNote?: string | null | undefined, urlSyncStatus?: UrlDocumentSyncState | null | undefined, urlLastSyncedAt?: Date | null | undefined, urlLastSyncError?: string | null | undefined, file?: { __typename?: 'KnowledgeBaseDocumentFile', mimeType: string, name: string, size: number, url?: string | null | undefined } | null | undefined, text?: { __typename?: 'KnowledgeBaseDocumentText', content: string } | null | undefined, createdBy: { __typename?: 'AgencyUser', name: string }, indexingStatus: { __typename?: 'KnowledgeBaseDocumentIndexingStatus', status: IndexingStatus, error?: string | null | undefined, progress?: number | null | undefined, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined }, metadata?: { __typename?: 'KnowledgeBaseDocumentMetadata', title: string, summary: string, purpose: string, keywords?: Array<string> | null | undefined } | null | undefined, urlSource?: { __typename?: 'KnowledgeBaseDocumentURLSource', url: string, sourceType: UrlSourceType, frequency: UrlMonitorFrequency, isPaused: boolean } | null | undefined } };

export type MailboxEventsQueryVariables = Exact<{
  mailboxAccountId: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
  includeMessages: Scalars['Boolean']['input'];
}>;


export type MailboxEventsQuery = { __typename?: 'Query', mailboxEvents: Array<{ __typename?: 'MailboxEvent', id: string, type: MailboxEventType, occurredAt: Date, initiatorType: UpdateInitiatorType, initiatorId: string, mailboxAccountId?: string | null | undefined, mailboxDraftId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion?: number | null | undefined, reason: string, requestedByUserId?: string | null | undefined, notification?: { __typename?: 'MailboxNotificationAudit', receiptId: string, attemptId: string, providerMessageId: string, folderName: string, changeType: string, watchSignal: string, outcome: string, reason: string } | null | undefined }>, mailboxMessageActivity?: Array<{ __typename?: 'MailboxMessageActivity', id: string, mailboxAccountId: string, providerMessageId: string, folderName: string, folderRole?: MailboxFolderRole | null | undefined, recordedAt: Date }> };

export type MailboxMonitoringFieldsFragment = { __typename?: 'MailboxAccount', id: string, monitoring?: { __typename?: 'MailboxMonitoring', maxMonitoredFolders: number, enabled: boolean, processUpdates: boolean, processDeletes: boolean, active: boolean, expiresAt?: Date | null | undefined, recovering: boolean, problem: string, problemKind?: MailboxMonitoringProblemKind | null | undefined, notes: Array<{ __typename?: 'MailboxMonitoringNote', code: MailboxMonitoringNoteCode }>, folders: Array<{ __typename?: 'MailboxMonitoredFolder', id: string, name: string, missing: boolean }> } | null | undefined };

export type MailboxAccountMonitoringQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxAccountMonitoringQuery = { __typename?: 'Query', mailboxAccounts: Array<{ __typename?: 'MailboxAccount', id: string, monitoring?: { __typename?: 'MailboxMonitoring', maxMonitoredFolders: number, enabled: boolean, processUpdates: boolean, processDeletes: boolean, active: boolean, expiresAt?: Date | null | undefined, recovering: boolean, problem: string, problemKind?: MailboxMonitoringProblemKind | null | undefined, notes: Array<{ __typename?: 'MailboxMonitoringNote', code: MailboxMonitoringNoteCode }>, folders: Array<{ __typename?: 'MailboxMonitoredFolder', id: string, name: string, missing: boolean }> } | null | undefined }> };

export type MailboxSettingsAccessQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxSettingsAccessQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', id: string, frontendFlags: Array<string>, permissions: Array<{ __typename?: 'Permission', scope: Scope, resource: Resource, action: Action }>, agency: { __typename?: 'Agency', id: string, entitlements: Array<SubscriptionEntitlement> } } | null | undefined };

export type MailboxOffboardingAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxOffboardingAccountsQuery = { __typename?: 'Query', mailboxOffboardingAccounts: Array<{ __typename?: 'MailboxOffboardingAccount', id: string, emailAddress: string }> };

export type MailboxSharingFieldsFragment = { __typename?: 'MailboxAccount', id: string, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type MailboxAccountSharingQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxAccountSharingQuery = { __typename?: 'Query', mailboxAccounts: Array<{ __typename?: 'MailboxAccount', id: string, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type SetMailboxVisibilityMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  visibility: VisibilityConfigInput;
}>;


export type SetMailboxVisibilityMutation = { __typename?: 'Mutation', setMailboxVisibility: { __typename?: 'MailboxAccount', id: string, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type MailboxAccountFieldsFragment = { __typename?: 'MailboxAccount', id: string, provider: MailboxProvider, status: MailboxAccountStatus, isDefault: boolean, identity: { __typename?: 'MailboxIdentity', email: string, displayName: string } };

export type MailboxSignatureFieldsFragment = { __typename?: 'MailboxSignature', id: string, name: string, bodyHtml: string, isDefault: boolean };

export type MailboxAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxAccountsQuery = { __typename?: 'Query', mailboxAccounts: Array<{ __typename?: 'MailboxAccount', id: string, provider: MailboxProvider, status: MailboxAccountStatus, isDefault: boolean, identity: { __typename?: 'MailboxIdentity', email: string, displayName: string } }> };

export type MailboxComposeLimitsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxComposeLimitsQuery = { __typename?: 'Query', mailboxComposeLimits: { __typename?: 'MailboxComposeLimits', bodyBytes: number, attachmentBytes: number } };

export type MailboxSignaturesQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxSignaturesQuery = { __typename?: 'Query', mailboxSignatures: Array<{ __typename?: 'MailboxSignature', id: string, name: string, bodyHtml: string, isDefault: boolean }> };

export type ScheduleMailboxEmailMutationVariables = Exact<{
  input: ScheduleMailboxEmailInput;
}>;


export type ScheduleMailboxEmailMutation = { __typename?: 'Mutation', scheduleMailboxEmail: { __typename?: 'ScheduleMailboxEmailResult', contentRevision: string, email: { __typename?: 'OutboundEmail', id: string, status: OutboundEmailStatus, sentAt?: Date | null | undefined, sendAfter?: Date | null | undefined, scheduledFor?: Date | null | undefined, sentByUserId?: string | null | undefined, cancellationRemainingMs: number, failureReason: string, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } } };

export type CancelMailboxEmailPreparationMutationVariables = Exact<{
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  attemptId: Scalars['String']['input'];
}>;


export type CancelMailboxEmailPreparationMutation = { __typename?: 'Mutation', cancelMailboxEmailPreparation: boolean };

export type CancelMailboxEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelMailboxEmailMutation = { __typename?: 'Mutation', cancelMailboxEmail: { __typename?: 'OutboundEmail', id: string, status: OutboundEmailStatus, sentAt?: Date | null | undefined, sendAfter?: Date | null | undefined, scheduledFor?: Date | null | undefined, sentByUserId?: string | null | undefined, cancellationRemainingMs: number, failureReason: string, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type RescheduleMailboxEmailMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: RescheduleMailboxEmailInput;
}>;


export type RescheduleMailboxEmailMutation = { __typename?: 'Mutation', rescheduleMailboxEmail: { __typename?: 'OutboundEmail', id: string, status: OutboundEmailStatus, sentAt?: Date | null | undefined, sendAfter?: Date | null | undefined, scheduledFor?: Date | null | undefined, sentByUserId?: string | null | undefined, cancellationRemainingMs: number, failureReason: string, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } };

export type SearchRecipientsQueryVariables = Exact<{
  query: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchRecipientsQuery = { __typename?: 'Query', searchRecipients: Array<{ __typename?: 'RecipientSuggestion', email: string, name?: string | null | undefined, description?: string | null | undefined }> };

export type OutboundEmailAddressFieldsFragment = { __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string };

export type OutboundEmailFieldsFragment = { __typename?: 'OutboundEmail', id: string, status: OutboundEmailStatus, bulkSendId?: string | null | undefined, sendAfter?: Date | null | undefined, scheduledFor?: Date | null | undefined, mailboxAccountId: string, fromAddress: string, subject: string, workspaceId?: string | null | undefined, workspaceArtifactId: string, artifactVersion: number, sentByUserId?: string | null | undefined, sentAt?: Date | null | undefined, sentExternally: boolean, failureReason: string, failureKind?: OutboundEmailFailureKind | null | undefined, sendUnconfirmed: boolean, createdAt: Date, updatedAt: Date, to: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, cc: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, bcc: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, attachments: Array<{ __typename?: 'OutboundEmailAttachment', name: string }>, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined };

export type SearchOutboundEmailsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundEmailsFilterInput>;
  sort?: InputMaybe<OutboundEmailSortInput>;
}>;


export type SearchOutboundEmailsQuery = { __typename?: 'Query', searchOutboundEmails: { __typename?: 'OutboundEmailConnection', totalCount: number, edges: Array<{ __typename?: 'OutboundEmailEdge', cursor: string, node: { __typename?: 'OutboundEmail', cancellationRemainingMs: number, id: string, status: OutboundEmailStatus, bulkSendId?: string | null | undefined, sendAfter?: Date | null | undefined, scheduledFor?: Date | null | undefined, mailboxAccountId: string, fromAddress: string, subject: string, workspaceId?: string | null | undefined, workspaceArtifactId: string, artifactVersion: number, sentByUserId?: string | null | undefined, sentAt?: Date | null | undefined, sentExternally: boolean, failureReason: string, failureKind?: OutboundEmailFailureKind | null | undefined, sendUnconfirmed: boolean, createdAt: Date, updatedAt: Date, amsLog?: { __typename?: 'OutboundEmailAmsLog', status: AmsLogStatus, integrationType: IntegrationType, accountDisplayName?: string | null | undefined, loggedAt?: Date | null | undefined, notLoggedReason?: AmsNotLoggedReason | null | undefined, failureMessage?: string | null | undefined, canPush: boolean } | null | undefined, to: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, cc: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, bcc: Array<{ __typename?: 'OutboundEmailAddress', name?: string | null | undefined, email: string }>, attachments: Array<{ __typename?: 'OutboundEmailAttachment', name: string }>, sentBy?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type MailboxDraftFieldsFragment = { __typename?: 'MailboxDraft', id: string, mailboxAccountId: string, fromAddress: string, webLink: string, subject: string, createdByUserId?: string | null | undefined, workspaceId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion: number, syncState: MailboxDraftSyncState, externallyEdited: boolean, externalEditsCheckedAt?: Date | null | undefined, sentViaCaraAt?: Date | null | undefined, retiredAt?: Date | null | undefined, retiredReason: string, createdAt: Date };

export type CreateMailboxDraftMutationVariables = Exact<{
  mailboxAccountId: Scalars['String']['input'];
  artifactId: Scalars['String']['input'];
  artifactVersion: Scalars['Int']['input'];
  contentRevision?: InputMaybe<Scalars['String']['input']>;
}>;


export type CreateMailboxDraftMutation = { __typename?: 'Mutation', createMailboxDraft: { __typename?: 'MailboxDraft', id: string, mailboxAccountId: string, fromAddress: string, webLink: string, subject: string, createdByUserId?: string | null | undefined, workspaceId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion: number, syncState: MailboxDraftSyncState, externallyEdited: boolean, externalEditsCheckedAt?: Date | null | undefined, sentViaCaraAt?: Date | null | undefined, retiredAt?: Date | null | undefined, retiredReason: string, createdAt: Date } };

export type SearchMailboxDraftsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MailboxDraftsFilterInput>;
}>;


export type SearchMailboxDraftsQuery = { __typename?: 'Query', searchMailboxDrafts: { __typename?: 'MailboxDraftConnection', totalCount: number, edges: Array<{ __typename?: 'MailboxDraftEdge', cursor: string, node: { __typename?: 'MailboxDraft', id: string, mailboxAccountId: string, fromAddress: string, webLink: string, subject: string, createdByUserId?: string | null | undefined, workspaceId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion: number, syncState: MailboxDraftSyncState, externallyEdited: boolean, externalEditsCheckedAt?: Date | null | undefined, sentViaCaraAt?: Date | null | undefined, retiredAt?: Date | null | undefined, retiredReason: string, createdAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type SwitchMailboxDraftMutationVariables = Exact<{
  input: SwitchMailboxDraftInput;
}>;


export type SwitchMailboxDraftMutation = { __typename?: 'Mutation', switchMailboxDraft: { __typename?: 'SwitchMailboxDraftResult', draftError?: string | null | undefined, artifact: { __typename?: 'CaraWorkspaceArtifact', createdAt: Date, editedAt?: Date | null | undefined, revision: number, id: string, type: CaraWorkspaceArtifactType, version: number, designFitState?: { __typename?: 'DocumentDesignFitState', needsRefit: boolean, refused: boolean, layoutKey: string, appearanceKey: string } | null | undefined, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, document?: { __typename?: 'CaraWorkspaceArtifactDocument', title: string, content: string, htmlDocumentTemplateId?: string | null | undefined, sourceFileId?: string | null | undefined, brandApplied?: boolean | null | undefined, designId?: string | null | undefined, final?: { __typename?: 'CaraWorkspaceArtifactFinal', includeDesignPages: boolean, markedAt: Date } | null | undefined, resolvedDesign?: { __typename?: 'CaraWorkspaceArtifactResolvedDesign', designId?: string | null | undefined, name: string, archived: boolean, hasPages: boolean } | null | undefined } | null | undefined, pdf?: { __typename?: 'CaraWorkspaceArtifactPDFFile', title: string, externalUrl?: string | null | undefined, fileId?: string | null | undefined } | null | undefined, customForm?: { __typename?: 'CaraWorkspaceArtifactCustomForm', title: string, customForm: { __typename?: 'CustomForm', id: string, title: string, status: CustomFormStatus } } | null | undefined, templateForm?: { __typename?: 'CaraWorkspaceArtifactTemplateForm', templateId: DocumentType, title: string, label: string, editedByAgencyUserId?: string | null | undefined, restoredFromVersion?: number | null | undefined, editedBy?: { __typename?: 'AgencyUser', id: string, name: string, email: string } | null | undefined } | null | undefined, applicationFile?: { __typename?: 'CaraWorkspaceArtifactApplicationFile', title: string, type: string, sections?: Array<{ __typename?: 'CaraDocxSection', title: string, file: { __typename?: 'File', id: string, url?: string | null | undefined } }> | null | undefined } | null | undefined, email?: { __typename?: 'CaraWorkspaceArtifactEmail', subject: string, bodyHtml: string, attachmentArtifactIds: Array<string>, attachmentFileIds: Array<string>, mailboxAccountId?: string | null | undefined, signatureId?: string | null | undefined, contentRevision: string, to: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, cc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, bcc: Array<{ __typename?: 'CaraWorkspaceEmailRecipient', name: string, email: string }>, attachmentFiles: Array<{ __typename?: 'File', id: string, name: string, mimeType: string, size: number, url?: string | null | undefined }>, template?: { __typename?: 'CaraWorkspaceEmailTemplateUse', templateId: string, templateVersion: number, placeholderLabels: Array<string> } | null | undefined, source?: { __typename?: 'CaraWorkspaceEmailSource', providerMessageId: string, messageId: string, threadId: string, mode: CaraWorkspaceEmailReplyMode } | null | undefined } | null | undefined }, mailboxDraft?: { __typename?: 'MailboxDraft', id: string, mailboxAccountId: string, fromAddress: string, webLink: string, subject: string, createdByUserId?: string | null | undefined, workspaceId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion: number, syncState: MailboxDraftSyncState, externallyEdited: boolean, externalEditsCheckedAt?: Date | null | undefined, sentViaCaraAt?: Date | null | undefined, retiredAt?: Date | null | undefined, retiredReason: string, createdAt: Date } | null | undefined } };

export type UploadEmailAttachmentMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  file: UploadFileInput;
}>;


export type UploadEmailAttachmentMutation = { __typename?: 'Mutation', uploadWorkspaceFile: { __typename?: 'File', id: string, name: string, size: number } };

export type ReconcileMailboxDraftsMutationVariables = Exact<{
  mailboxDraftIds: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ReconcileMailboxDraftsMutation = { __typename?: 'Mutation', reconcileMailboxDrafts: Array<{ __typename?: 'MailboxDraftReconciliationResult', mailboxDraftId: string, reconciliation: MailboxDraftReconciliation, draft: { __typename?: 'MailboxDraft', id: string, mailboxAccountId: string, fromAddress: string, webLink: string, subject: string, createdByUserId?: string | null | undefined, workspaceId?: string | null | undefined, workspaceArtifactId?: string | null | undefined, artifactVersion: number, syncState: MailboxDraftSyncState, externallyEdited: boolean, externalEditsCheckedAt?: Date | null | undefined, sentViaCaraAt?: Date | null | undefined, retiredAt?: Date | null | undefined, retiredReason: string, createdAt: Date } }> };

export type MailboxProvidersQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxProvidersQuery = { __typename?: 'Query', mailboxProviders: Array<MailboxProvider> };

export type DisconnectMailboxMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DisconnectMailboxMutation = { __typename?: 'Mutation', disconnectMailbox: boolean };

export type SetDefaultMailboxMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type SetDefaultMailboxMutation = { __typename?: 'Mutation', setDefaultMailbox: { __typename?: 'MailboxAccount', id: string, provider: MailboxProvider, status: MailboxAccountStatus, isDefault: boolean, identity: { __typename?: 'MailboxIdentity', email: string, displayName: string } } };

export type MailboxSignatureSettingsFieldsFragment = { __typename?: 'MailboxSignature', id: string, name: string, bodyHtml: string, isDefault: boolean, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type MailboxSignaturesForSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type MailboxSignaturesForSettingsQuery = { __typename?: 'Query', mailboxSignatures: Array<{ __typename?: 'MailboxSignature', id: string, name: string, bodyHtml: string, isDefault: boolean, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type UpsertMailboxSignatureMutationVariables = Exact<{
  input: MailboxSignatureInput;
}>;


export type UpsertMailboxSignatureMutation = { __typename?: 'Mutation', upsertMailboxSignature: { __typename?: 'MailboxSignature', id: string, name: string, bodyHtml: string, isDefault: boolean, owner: { __typename?: 'MailboxOwner', agencyUserId: string }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type DeleteMailboxSignatureMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMailboxSignatureMutation = { __typename?: 'Mutation', deleteMailboxSignature: boolean };

export type MemoryListFieldsFragment = { __typename?: 'Memory', id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date };

export type MemoryDetailFieldsFragment = { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date };

export type SearchMemoriesQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<MemorySearchFilterInput>;
}>;


export type SearchMemoriesQuery = { __typename?: 'Query', searchMemories: { __typename?: 'MemoryConnection', totalCount: number, edges: Array<{ __typename?: 'MemoryEdge', cursor: string, node: { __typename?: 'Memory', id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type MemoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type MemoryQuery = { __typename?: 'Query', memory: { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } };

export type UpdateMemoryMutationVariables = Exact<{
  input: UpdateMemoryInput;
}>;


export type UpdateMemoryMutation = { __typename?: 'Mutation', updateMemory: { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } };

export type DeleteMemoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DeleteMemoryMutation = { __typename?: 'Mutation', deleteMemory: { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } };

export type PromoteMemoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PromoteMemoryMutation = { __typename?: 'Mutation', promoteMemory: { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } };

export type DemoteMemoryMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DemoteMemoryMutation = { __typename?: 'Mutation', demoteMemory: { __typename?: 'Memory', keywords: Array<string>, accessCount: number, lastAccessedAt?: Date | null | undefined, updatedAt: Date, id: string, scope: MemoryScope, type: MemoryType, category: MemoryCategory, surface?: MemorySurface | null | undefined, content: string, sticky: boolean, createdAt: Date } };

export type SearchDocumentationQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type SearchDocumentationQuery = { __typename?: 'Query', searchDocumentation: { __typename?: 'SearchDocumentationResult', results: Array<{ __typename?: 'DocumentationResult', title: string, path: string, content: string }> } };

export type OutboundCallFieldsFragment = { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined };

export type OutboundCallReportFieldsFragment = { __typename?: 'OutboundCallReport', totalCalls: number, voicemailEnabledCount: number, statusCounts: Array<{ __typename?: 'OutboundCallStatusCount', status: OutboundCallStatus, count: number }>, dailyCounts: Array<{ __typename?: 'OutboundCallDailyCount', date: Date, totalCalls: number, completed: number, failed: number, scheduled: number }> };

export type GetOutboundCallsQueryVariables = Exact<{
  filter?: InputMaybe<OutboundCallsFilterInput>;
}>;


export type GetOutboundCallsQuery = { __typename?: 'Query', outboundCalls: Array<{ __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined }> };

export type SearchOutboundCallsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<OutboundCallsFilterInput>;
  sort?: InputMaybe<OutboundCallSortInput>;
}>;


export type SearchOutboundCallsQuery = { __typename?: 'Query', searchOutboundCalls: { __typename?: 'OutboundCallConnection', totalCount: number, edges: Array<{ __typename?: 'OutboundCallEdge', cursor: string, node: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type OutboundCallRefreshFieldsFragment = { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined } };

export type GetOutboundCallsRefreshCandidatesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOutboundCallsRefreshCandidatesQuery = { __typename?: 'Query', dialing: { __typename?: 'OutboundCallConnection', edges: Array<{ __typename?: 'OutboundCallEdge', node: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined } } }> }, inProgress: { __typename?: 'OutboundCallConnection', edges: Array<{ __typename?: 'OutboundCallEdge', node: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined } } }> }, scheduled: { __typename?: 'OutboundCallConnection', edges: Array<{ __typename?: 'OutboundCallEdge', node: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined } } }> } };

export type OutboundCallAttemptFieldsFragment = { __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> };

export type OutboundCallDetailFieldsFragment = { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, calls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> }>, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> } | null | undefined, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } };

export type GetOutboundCallQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetOutboundCallQuery = { __typename?: 'Query', outboundCall: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, calls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> }>, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> } | null | undefined, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState } } };

export type GetOutboundCallReportQueryVariables = Exact<{
  filter?: InputMaybe<OutboundCallReportFilterInput>;
}>;


export type GetOutboundCallReportQuery = { __typename?: 'Query', outboundCallReport: { __typename?: 'OutboundCallReport', totalCalls: number, voicemailEnabledCount: number, statusCounts: Array<{ __typename?: 'OutboundCallStatusCount', status: OutboundCallStatus, count: number }>, dailyCounts: Array<{ __typename?: 'OutboundCallDailyCount', date: Date, totalCalls: number, completed: number, failed: number, scheduled: number }> } };

export type GetOutboundCallFrequencyQueryVariables = Exact<{
  phone: Scalars['String']['input'];
  excludeOutboundCallId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetOutboundCallFrequencyQuery = { __typename?: 'Query', outboundCallFrequency: { __typename?: 'OutboundCallFrequency', count: number, limit: number, windowDays: number, remaining: number } };

export type CreateOutboundCallMutationVariables = Exact<{
  input: CreateOutboundCallInput;
}>;


export type CreateOutboundCallMutation = { __typename?: 'Mutation', createOutboundCall: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined } };

export type UpdateOutboundCallMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateOutboundCallInput;
}>;


export type UpdateOutboundCallMutation = { __typename?: 'Mutation', updateOutboundCall: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined } };

export type CancelOutboundCallMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type CancelOutboundCallMutation = { __typename?: 'Mutation', cancelOutboundCall: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined } };

export type ArchiveOutboundCallsMutationVariables = Exact<{
  ids: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type ArchiveOutboundCallsMutation = { __typename?: 'Mutation', archiveOutboundCalls: boolean };

export type DialOutboundCallMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type DialOutboundCallMutation = { __typename?: 'Mutation', dialOutboundCall: { __typename?: 'OutboundCall', id: string, status: OutboundCallStatus, createdAt: Date, updatedAt: Date, customer: { __typename?: 'OutboundCallCustomer', name?: string | null | undefined, phone: string }, schedule: { __typename?: 'OutboundCallSchedule', scheduledAt?: Date | null | undefined, timezone: string }, callConfig: { __typename?: 'OutboundCallConfig', callObjective: string, customerContext?: string | null | undefined, guidelines?: string | null | undefined, callbackPhone?: string | null | undefined, leaveVoicemail: boolean, fileIds: Array<string> }, voiceAgent: { __typename?: 'VoiceAgent', id: string, name: string }, createdBy: { __typename?: 'AgencyUser', id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState }, latestCall?: { __typename?: 'Call', id: string, seenAt?: Date | null | undefined } | null | undefined } };

export type PresetGenerationProgressFieldsFragment = { __typename?: 'CustomPreset', id: string, state: CustomPresetState, generation?: { __typename?: 'PresetGeneration', step?: PresetGenerationStep | null | undefined, error?: string | null | undefined } | null | undefined };

export type PresetClarifyingQuestionFieldsFragment = { __typename?: 'PresetClarifyingQuestion', id: string, question: string, options: Array<string>, allowFreeText: boolean };

export type StartPresetGenerationMutationVariables = Exact<{
  input: StartPresetGenerationInput;
}>;


export type StartPresetGenerationMutation = { __typename?: 'Mutation', startPresetGeneration: { __typename?: 'CustomPreset', id: string, state: CustomPresetState, generation?: { __typename?: 'PresetGeneration', step?: PresetGenerationStep | null | undefined, error?: string | null | undefined } | null | undefined } };

export type GeneratePresetQuestionsMutationVariables = Exact<{
  input: GeneratePresetQuestionsInput;
}>;


export type GeneratePresetQuestionsMutation = { __typename?: 'Mutation', generatePresetQuestions: Array<{ __typename?: 'PresetClarifyingQuestion', id: string, question: string, options: Array<string>, allowFreeText: boolean }> };

export type GetPresetGenerationProgressQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetPresetGenerationProgressQuery = { __typename?: 'Query', customPreset: { __typename?: 'CustomPreset', id: string, state: CustomPresetState, generation?: { __typename?: 'PresetGeneration', step?: PresetGenerationStep | null | undefined, error?: string | null | undefined } | null | undefined } };

export type ServiceRequestFieldsFragment = { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined };

export type ServiceRequestCallFieldsFragment = { __typename?: 'ServiceRequest', calls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> }>, comments: Array<{ __typename?: 'ServiceRequestComment', id: string, content: string, createdAt: Date, agencyUser: { __typename?: 'AgencyUser', name: string } }>, emailThreads: Array<{ __typename?: 'EmailThread', fromEmail: string, fromName: string, id: string, state: EmailThreadState, subject: string, waitingFor?: EmailSenderRole | null | undefined, createdAt: Date, updatedAt: Date, summary: string, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, attachments: Array<{ __typename?: 'File', id: string, name: string, url?: string | null | undefined }>, participantEmails: Array<{ __typename?: 'Email', body: string, id: string, senderRole: EmailSenderRole, sentAt: Date, subject: string, from: { __typename?: 'EmailParticipant', name: string, email: string }, to: Array<{ __typename?: 'EmailParticipant', name: string, email: string }> }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, workspace?: { __typename?: 'CaraWorkspace', id: string, title: string, state: CaraWorkspaceState } | null | undefined }>, versionHistory?: Array<{ __typename?: 'ServiceRequestVersion', createdAt: Date, version: number, updateTypes: Array<ServiceRequestUpdateType>, updateInitiatorType: UpdateInitiatorType, updateInitiatorId: string, serviceRequest: { __typename?: 'ServiceRequest', dueAt?: Date | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } }> | null | undefined };

export type GetServiceRequestsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetServiceRequestsQuery = { __typename?: 'Query', serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }> };

export type GetServiceRequestQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetServiceRequestQuery = { __typename?: 'Query', serviceRequest?: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined, calls: Array<{ __typename?: 'Call', id: string, disconnectionReason?: CallDisconnectionReason | null | undefined, endedAt?: Date | null | undefined, fromName?: string | null | undefined, fromNumber: string, seenAt?: Date | null | undefined, sentiment?: CallSentiment | null | undefined, startedAt: Date, status: CallStatus, recordingUrl?: string | null | undefined, successful?: boolean | null | undefined, summary?: string | null | undefined, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, transcript: Array<{ __typename?: 'CallTranscriptObject', content: string, durationSeconds: number, role: CallTranscriptRole, startTimeOffsetSeconds: number, toolCallId?: string | null | undefined, toolName?: string | null | undefined, toolArgumentsJson?: string | null | undefined }> }>, comments: Array<{ __typename?: 'ServiceRequestComment', id: string, content: string, createdAt: Date, agencyUser: { __typename?: 'AgencyUser', name: string } }>, emailThreads: Array<{ __typename?: 'EmailThread', fromEmail: string, fromName: string, id: string, state: EmailThreadState, subject: string, waitingFor?: EmailSenderRole | null | undefined, createdAt: Date, updatedAt: Date, summary: string, account?: { __typename?: 'Account', id: string, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, attachments: Array<{ __typename?: 'File', id: string, name: string, url?: string | null | undefined }>, participantEmails: Array<{ __typename?: 'Email', body: string, id: string, senderRole: EmailSenderRole, sentAt: Date, subject: string, from: { __typename?: 'EmailParticipant', name: string, email: string }, to: Array<{ __typename?: 'EmailParticipant', name: string, email: string }> }>, serviceRequests: Array<{ __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined }>, workspace?: { __typename?: 'CaraWorkspace', id: string, title: string, state: CaraWorkspaceState } | null | undefined }>, versionHistory?: Array<{ __typename?: 'ServiceRequestVersion', createdAt: Date, version: number, updateTypes: Array<ServiceRequestUpdateType>, updateInitiatorType: UpdateInitiatorType, updateInitiatorId: string, serviceRequest: { __typename?: 'ServiceRequest', dueAt?: Date | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } }> | null | undefined } | null | undefined };

export type ResolveServiceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: ResolveServiceRequestInput;
}>;


export type ResolveServiceRequestMutation = { __typename?: 'Mutation', resolveServiceRequest: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } };

export type UpdateServiceRequestMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: UpdateServiceRequestInput;
}>;


export type UpdateServiceRequestMutation = { __typename?: 'Mutation', updateServiceRequest: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } };

export type AddServiceRequestCommentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: AddServiceRequestCommentInput;
}>;


export type AddServiceRequestCommentMutation = { __typename?: 'Mutation', addServiceRequestComment: { __typename?: 'ServiceRequest', id: string, type: ServiceRequestType, state: ServiceRequestState, clientEmail?: string | null | undefined, clientName?: string | null | undefined, clientPhone?: string | null | undefined, details: string, dueAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, account?: { __typename?: 'Account', type: AccountType, account: { __typename?: 'BusinessAccount', name: string } | { __typename?: 'IndividualAccount', name: string } } | null | undefined, assignee?: { __typename?: 'AgencyUser', id: string, name: string } | null | undefined, addAdditionalInsured?: { __typename?: 'AddAdditionalInsuredRequest', name: string, relationship: string, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, businessPolicy?: { __typename?: 'BusinessPolicy', id: string, type: InsuranceType, carrier: { __typename?: 'InsuranceCarrier', name: string } } | null | undefined, cancelPolicy?: { __typename?: 'CancelPolicyRequest', policyId: string, reason: string } | null | undefined, createCertificate?: { __typename?: 'CreateCertificateRequest', name: string, additionalInsured: boolean, additionalInsuredRelationship?: string | null | undefined, additionalInsuredRelationshipDescription?: string | null | undefined, address: { __typename?: 'Address', line1: string, city: string, zone: string, postalCode: string } } | null | undefined, documentRequest?: { __typename?: 'DocumentRequest', type: DocumentRequestType } | null | undefined, endorsePolicy?: { __typename?: 'EndorsePolicyRequest', policyId: string } | null | undefined, question?: { __typename?: 'QuestionRequest', policyId?: string | null | undefined, question: string, type: QuestionRequestType } | null | undefined, resolution?: { __typename?: 'ServiceRequestResolution', notes: string } | null | undefined } };

export type SmartFillCarrierSiteFieldsFragment = { __typename?: 'SmartFillCarrierSite', id: string, carrier: string, product: string, host: string, questionCount: number };

export type SmartFillFormBucketFieldsFragment = { __typename?: 'SmartFillFormBucket', workspaceId: string, workspaceTitle: string, profileId: string, lineOfBusiness: string, builtAt: Date, carrierSiteId?: string | null | undefined, answerCount: number, bucket: { __typename?: 'SmartFillBucket', id: string, name: string, revision: number, updatedAt: Date }, forms: Array<{ __typename?: 'SmartFillBucketForm', artifactId: string, title: string, version: number }> };

export type SmartFillFormQuestionFieldsFragment = { __typename?: 'SmartFillFormQuestion', ownerType: string, relationPath: string, semanticKey: string, question: string, section?: string | null | undefined, label?: string | null | undefined, fieldType: SmartFillFieldType, options: Array<string>, kind: string, answers: Array<{ __typename?: 'SmartFillFormQuestionAnswer', recordIndex: number, recordLabel: string, recordExists: boolean, value?: string | null | undefined, source: SmartFillAnswerSource }> };

export type SmartFillFormBucketQuestionsFieldsFragment = { __typename?: 'SmartFillFormBucketQuestions', revision: number, answeredCount: number, formBucket: { __typename?: 'SmartFillFormBucket', workspaceId: string, workspaceTitle: string, profileId: string, lineOfBusiness: string, builtAt: Date, carrierSiteId?: string | null | undefined, answerCount: number, bucket: { __typename?: 'SmartFillBucket', id: string, name: string, revision: number, updatedAt: Date }, forms: Array<{ __typename?: 'SmartFillBucketForm', artifactId: string, title: string, version: number }> }, site?: { __typename?: 'SmartFillCarrierSite', id: string, carrier: string, product: string, host: string, questionCount: number } | null | undefined, questions: Array<{ __typename?: 'SmartFillFormQuestion', ownerType: string, relationPath: string, semanticKey: string, question: string, section?: string | null | undefined, label?: string | null | undefined, fieldType: SmartFillFieldType, options: Array<string>, kind: string, answers: Array<{ __typename?: 'SmartFillFormQuestionAnswer', recordIndex: number, recordLabel: string, recordExists: boolean, value?: string | null | undefined, source: SmartFillAnswerSource }> }> };

export type GetSmartFillFormBucketsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmartFillFormBucketsQuery = { __typename?: 'Query', smartFillFormBuckets: Array<{ __typename?: 'SmartFillFormBucket', workspaceId: string, workspaceTitle: string, profileId: string, lineOfBusiness: string, builtAt: Date, carrierSiteId?: string | null | undefined, answerCount: number, bucket: { __typename?: 'SmartFillBucket', id: string, name: string, revision: number, updatedAt: Date }, forms: Array<{ __typename?: 'SmartFillBucketForm', artifactId: string, title: string, version: number }> }> };

export type GetSmartFillCarrierSitesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSmartFillCarrierSitesQuery = { __typename?: 'Query', smartFillCarrierSites: Array<{ __typename?: 'SmartFillCarrierSite', id: string, carrier: string, product: string, host: string, questionCount: number }> };

export type GetSmartFillFormBucketQuestionsQueryVariables = Exact<{
  bucketId: Scalars['ID']['input'];
  carrierSiteId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetSmartFillFormBucketQuestionsQuery = { __typename?: 'Query', smartFillFormBucketQuestions?: { __typename?: 'SmartFillFormBucketQuestions', revision: number, answeredCount: number, formBucket: { __typename?: 'SmartFillFormBucket', workspaceId: string, workspaceTitle: string, profileId: string, lineOfBusiness: string, builtAt: Date, carrierSiteId?: string | null | undefined, answerCount: number, bucket: { __typename?: 'SmartFillBucket', id: string, name: string, revision: number, updatedAt: Date }, forms: Array<{ __typename?: 'SmartFillBucketForm', artifactId: string, title: string, version: number }> }, site?: { __typename?: 'SmartFillCarrierSite', id: string, carrier: string, product: string, host: string, questionCount: number } | null | undefined, questions: Array<{ __typename?: 'SmartFillFormQuestion', ownerType: string, relationPath: string, semanticKey: string, question: string, section?: string | null | undefined, label?: string | null | undefined, fieldType: SmartFillFieldType, options: Array<string>, kind: string, answers: Array<{ __typename?: 'SmartFillFormQuestionAnswer', recordIndex: number, recordLabel: string, recordExists: boolean, value?: string | null | undefined, source: SmartFillAnswerSource }> }> } | null | undefined };

export type AnswerSmartFillFormBucketMutationVariables = Exact<{
  bucketId: Scalars['ID']['input'];
  expectedRevision: Scalars['Int64']['input'];
  carrierSiteId?: InputMaybe<Scalars['ID']['input']>;
  answers: Array<SmartFillFormAnswerInput> | SmartFillFormAnswerInput;
}>;


export type AnswerSmartFillFormBucketMutation = { __typename?: 'Mutation', answerSmartFillFormBucket: { __typename?: 'SmartFillFormBucketQuestions', revision: number, answeredCount: number, formBucket: { __typename?: 'SmartFillFormBucket', workspaceId: string, workspaceTitle: string, profileId: string, lineOfBusiness: string, builtAt: Date, carrierSiteId?: string | null | undefined, answerCount: number, bucket: { __typename?: 'SmartFillBucket', id: string, name: string, revision: number, updatedAt: Date }, forms: Array<{ __typename?: 'SmartFillBucketForm', artifactId: string, title: string, version: number }> }, site?: { __typename?: 'SmartFillCarrierSite', id: string, carrier: string, product: string, host: string, questionCount: number } | null | undefined, questions: Array<{ __typename?: 'SmartFillFormQuestion', ownerType: string, relationPath: string, semanticKey: string, question: string, section?: string | null | undefined, label?: string | null | undefined, fieldType: SmartFillFieldType, options: Array<string>, kind: string, answers: Array<{ __typename?: 'SmartFillFormQuestionAnswer', recordIndex: number, recordLabel: string, recordExists: boolean, value?: string | null | undefined, source: SmartFillAnswerSource }> }> } };

export type GenerateSmartFillWorkspaceBucketMutationVariables = Exact<{
  workspaceId: Scalars['ID']['input'];
  operationId: Scalars['ID']['input'];
}>;


export type GenerateSmartFillWorkspaceBucketMutation = { __typename?: 'Mutation', generateSmartFillWorkspaceBucket: { __typename?: 'SmartFillBucketGeneration', bucketIds: Array<string>, completed: boolean } };

export type TeamFieldsFragment = { __typename?: 'Team', id: string, name: string, description?: string | null | undefined, memberCount: number, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, createdBy: { __typename?: 'AgencyUser', id: string, name: string, email: string }, members: Array<{ __typename?: 'TeamMember', addedAt: Date, user: { __typename?: 'AgencyUser', id: string, name: string, email: string } }> };

export type TeamSummaryFieldsFragment = { __typename?: 'Team', id: string, name: string };

export type GetMyTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMyTeamsQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', id: string, teams: Array<{ __typename?: 'Team', id: string, name: string }> } | null | undefined };

export type GetTeamsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTeamsQuery = { __typename?: 'Query', teams: Array<{ __typename?: 'Team', id: string, name: string, description?: string | null | undefined, memberCount: number, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, createdBy: { __typename?: 'AgencyUser', id: string, name: string, email: string }, members: Array<{ __typename?: 'TeamMember', addedAt: Date, user: { __typename?: 'AgencyUser', id: string, name: string, email: string } }> }> };

export type CreateTeamMutationVariables = Exact<{
  input: TeamInput;
}>;


export type CreateTeamMutation = { __typename?: 'Mutation', createTeam: { __typename?: 'Team', id: string, name: string, description?: string | null | undefined, memberCount: number, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, createdBy: { __typename?: 'AgencyUser', id: string, name: string, email: string }, members: Array<{ __typename?: 'TeamMember', addedAt: Date, user: { __typename?: 'AgencyUser', id: string, name: string, email: string } }> } };

export type UpdateTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: TeamInput;
}>;


export type UpdateTeamMutation = { __typename?: 'Mutation', updateTeam: { __typename?: 'Team', id: string, name: string, description?: string | null | undefined, memberCount: number, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, createdBy: { __typename?: 'AgencyUser', id: string, name: string, email: string }, members: Array<{ __typename?: 'TeamMember', addedAt: Date, user: { __typename?: 'AgencyUser', id: string, name: string, email: string } }> } };

export type ArchiveTeamMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveTeamMutation = { __typename?: 'Mutation', archiveTeam: { __typename?: 'Team', id: string, archivedAt?: Date | null | undefined } };

export type AddTeamMemberMutationVariables = Exact<{
  teamId: Scalars['ID']['input'];
  userId: Scalars['ID']['input'];
}>;


export type AddTeamMemberMutation = { __typename?: 'Mutation', addTeamMember: { __typename?: 'Team', id: string } };

export type TriggerDefinitionFieldsFragment = { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } };

export type GetTriggerDefinitionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTriggerDefinitionsQuery = { __typename?: 'Query', triggerDefinitions: Array<{ __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }> };

export type GetTriggerDefinitionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTriggerDefinitionQuery = { __typename?: 'Query', triggerDefinition?: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } | null | undefined };

export type CreateTriggerDefinitionMutationVariables = Exact<{
  input: CreateTriggerDefinitionInput;
}>;


export type CreateTriggerDefinitionMutation = { __typename?: 'Mutation', createTriggerDefinition: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type UpdateTriggerDefinitionMutationVariables = Exact<{
  input: UpdateTriggerDefinitionInput;
}>;


export type UpdateTriggerDefinitionMutation = { __typename?: 'Mutation', updateTriggerDefinition: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type PauseTriggerDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
}>;


export type PauseTriggerDefinitionMutation = { __typename?: 'Mutation', pauseTriggerDefinition: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type ResumeTriggerDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
}>;


export type ResumeTriggerDefinitionMutation = { __typename?: 'Mutation', resumeTriggerDefinition: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type ArchiveTriggerDefinitionMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type ArchiveTriggerDefinitionMutation = { __typename?: 'Mutation', archiveTriggerDefinition: { __typename?: 'TriggerDefinition', id: string, version: number, name: string, status: TriggerDefinitionStatus, createdAt: Date, updatedAt: Date, archivedAt?: Date | null | undefined, eventMatcher: { __typename?: 'TriggerEventMatcher', eventType: TriggerEventType, caraAddressConfig?: { __typename?: 'TriggerCaraAddressConfig', emailSuffix: string, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, mailboxConfig?: { __typename?: 'TriggerMailboxConfig', integrationId: string, folder?: string | null | undefined, subjectContains?: string | null | undefined, senderDomain?: string | null | undefined, hasAttachments: boolean } | null | undefined, emailConfig?: { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined } | null | undefined, scheduleConfig?: { __typename?: 'TriggerScheduleConfig', cron: string, timezone: string, catchUpHours: number } | null | undefined, callAnalyzedConfig?: { __typename?: 'TriggerCallAnalyzedConfig', callType: TriggerCallType, routing: TriggerCallRouting, minimumDurationSeconds: number } | null | undefined }, target: { __typename?: 'TriggerTarget', type: TriggerTargetType, presetId?: string | null | undefined, preset?: CaraWorkspacePreset | null | undefined, useCase?: CaraWorkspaceUseCase | null | undefined, prompt?: string | null | undefined }, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } } };

export type TriggerEmailTextMatchFieldsFragment = { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean };

export type TriggerEmailAddressMatchFieldsFragment = { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean };

export type TriggerEmailRuleFieldsFragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel8Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel7Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel6Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel5Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel4Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel3Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel2Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailRuleLevel1Fragment = { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined };

export type TriggerEmailConfigFieldsFragment = { __typename?: 'TriggerEmailConfig', schemaVersion: number, arrivals: TriggerEmailArrivalMode, privacy: TriggerEmailPrivacy, timezone?: string | null | undefined, scope: { __typename?: 'TriggerEmailScope', mode: TriggerEmailScopeMode, accounts: Array<{ __typename?: 'TriggerEmailAccountScope', accountId: string, folders: { __typename?: 'TriggerEmailSelectedFolders', ids: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } }>, folders?: { __typename?: 'TriggerEmailAllFolders', standard: Array<MailboxFolderRole>, paths: Array<string>, allFolders: boolean, includeJunkAndDeleted: boolean } | null | undefined }, rule?: { __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind, children: Array<{ __typename?: 'TriggerEmailRule', id: string, kind: TriggerEmailRuleKind }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined }>, phrase?: { __typename?: 'TriggerEmailPhraseCondition', field: TriggerEmailPhraseField, match: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } } | null | undefined, sender?: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } | null | undefined, recipient?: { __typename?: 'TriggerEmailRecipientCondition', field: TriggerEmailRecipientField, match: { __typename?: 'TriggerEmailAddressMatch', kind: TriggerEmailAddressKind, values: Array<string>, valueMode: TriggerEmailValueMode, includeSubdomains: boolean } } | null | undefined, time?: { __typename?: 'TriggerEmailTimeCondition', operator: TriggerEmailTimeOperator, minute: number, endMinute?: number | null | undefined, weekdays: Array<TriggerEmailWeekday> } | null | undefined, attachment?: { __typename?: 'TriggerEmailAttachmentCondition', minimumCount: number, maximumCount?: number | null | undefined, mimeTypes: Array<string>, extensions: Array<string>, minimumBytes?: number | null | undefined, maximumBytes?: number | null | undefined, name?: { __typename?: 'TriggerEmailTextMatch', operator: TriggerEmailTextOperator, values: Array<string>, valueMode: TriggerEmailValueMode, caseSensitive: boolean } | null | undefined } | null | undefined, prompt?: { __typename?: 'TriggerEmailPromptCondition', prompt: string } | null | undefined } | null | undefined };

export type GetTriggerEmailBuilderOptionsQueryVariables = Exact<{
  definitionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTriggerEmailBuilderOptionsQuery = { __typename?: 'Query', triggerEmailBuilderOptions: { __typename?: 'TriggerEmailBuilderOptions', privacySupported: boolean, accounts: Array<{ __typename?: 'TriggerEmailAccountOption', id: string, ownerUserId: string, address: string, status: MailboxAccountStatus }>, users: Array<{ __typename?: 'TriggerEmailUserOption', id: string, name: string, email: string, state: AgencyUserState }>, profiles: Array<{ __typename?: 'TriggerEmailProfileOption', id: string, name: string }>, presets: Array<{ __typename?: 'TriggerEmailPresetOption', id: string, name: string, ready: boolean, visibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> } }>, builtInPresets: Array<{ __typename?: 'TriggerEmailBuiltInPresetOption', preset: CaraWorkspacePreset, useCases: Array<CaraWorkspaceUseCase> }> } };

export type GetTriggerEmailFoldersQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetTriggerEmailFoldersQuery = { __typename?: 'Query', triggerEmailFolders: Array<{ __typename?: 'TriggerEmailFolderOption', id: string, name: string, role?: string | null | undefined, path?: string | null | undefined }> };

export type GetTriggerEmailRunsQueryVariables = Exact<{
  triggerDefinitionId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetTriggerEmailRunsQuery = { __typename?: 'Query', triggerEmailRuns: Array<{ __typename?: 'TriggerEmailRun', id: string, triggerDefinitionId: string, state: TriggerRunState, queuedAt: Date, dispatchedAt?: Date | null | undefined, workspaceId?: string | null | undefined, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined }> };

export type TriggerEventListFieldsFragment = { __typename?: 'TriggerEvent', id: string, eventType: TriggerEventType, sourceType: TriggerSourceType, sourceInstanceId: string, sourceEventId: string, state: TriggerEventState, occurredAt: Date, receivedAt: Date, evaluatedAt?: Date | null | undefined, payload: Record<string, unknown>, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined, runs: Array<{ __typename?: 'TriggerRun', id: string, state: TriggerRunState, executionId?: string | null | undefined, triggerDefinition: { __typename?: 'TriggerDefinition', id: string, name: string } }> };

export type TriggerEventDetailFieldsFragment = { __typename?: 'TriggerEvent', id: string, eventType: TriggerEventType, sourceType: TriggerSourceType, sourceInstanceId: string, sourceEventId: string, state: TriggerEventState, occurredAt: Date, receivedAt: Date, evaluatedAt?: Date | null | undefined, payload: Record<string, unknown>, evaluationSummary?: { __typename?: 'TriggerEvaluationSummary', candidateCount: number, reasonCounts?: Record<string, unknown> | null | undefined } | null | undefined, runs: Array<{ __typename?: 'TriggerRun', id: string, triggerDefinitionVersion: number, state: TriggerRunState, queueReason?: TriggerRunQueueReason | null | undefined, attemptCount: number, targetType: TriggerTargetType, executionType?: TriggerExecutionType | null | undefined, executionId?: string | null | undefined, queuedAt: Date, dispatchStartedAt?: Date | null | undefined, dispatchedAt?: Date | null | undefined, triggerDefinition: { __typename?: 'TriggerDefinition', id: string, name: string }, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined }>, auditLogs: Array<{ __typename?: 'TriggerAuditLog', id: string, triggerRunId?: string | null | undefined, type: TriggerAuditType, level: TriggerAuditLevel, message: string, details?: Record<string, unknown> | null | undefined, createdAt: Date }>, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined };

export type GetTriggerEventsQueryVariables = Exact<{
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  triggerDefinitionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type GetTriggerEventsQuery = { __typename?: 'Query', triggerEvents: { __typename?: 'TriggerEventConnection', totalCount: number, edges: Array<{ __typename?: 'TriggerEventEdge', cursor: string, node: { __typename?: 'TriggerEvent', id: string, eventType: TriggerEventType, sourceType: TriggerSourceType, sourceInstanceId: string, sourceEventId: string, state: TriggerEventState, occurredAt: Date, receivedAt: Date, evaluatedAt?: Date | null | undefined, payload: Record<string, unknown>, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined, runs: Array<{ __typename?: 'TriggerRun', id: string, state: TriggerRunState, executionId?: string | null | undefined, triggerDefinition: { __typename?: 'TriggerDefinition', id: string, name: string } }> } }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type GetTriggerEventQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetTriggerEventQuery = { __typename?: 'Query', triggerEvent?: { __typename?: 'TriggerEvent', id: string, eventType: TriggerEventType, sourceType: TriggerSourceType, sourceInstanceId: string, sourceEventId: string, state: TriggerEventState, occurredAt: Date, receivedAt: Date, evaluatedAt?: Date | null | undefined, payload: Record<string, unknown>, evaluationSummary?: { __typename?: 'TriggerEvaluationSummary', candidateCount: number, reasonCounts?: Record<string, unknown> | null | undefined } | null | undefined, runs: Array<{ __typename?: 'TriggerRun', id: string, triggerDefinitionVersion: number, state: TriggerRunState, queueReason?: TriggerRunQueueReason | null | undefined, attemptCount: number, targetType: TriggerTargetType, executionType?: TriggerExecutionType | null | undefined, executionId?: string | null | undefined, queuedAt: Date, dispatchStartedAt?: Date | null | undefined, dispatchedAt?: Date | null | undefined, triggerDefinition: { __typename?: 'TriggerDefinition', id: string, name: string }, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined }>, auditLogs: Array<{ __typename?: 'TriggerAuditLog', id: string, triggerRunId?: string | null | undefined, type: TriggerAuditType, level: TriggerAuditLevel, message: string, details?: Record<string, unknown> | null | undefined, createdAt: Date }>, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined } | null | undefined };

export type GetTriggerExecutionHistoryQueryVariables = Exact<{
  first?: Scalars['Int']['input'];
  after?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<TriggerExecutionHistoryFilter>;
}>;


export type GetTriggerExecutionHistoryQuery = { __typename?: 'Query', triggerExecutionHistory: { __typename?: 'TriggerExecutionHistoryConnection', edges: Array<{ __typename?: 'TriggerExecutionHistoryEdge', cursor: string, summary: string, event?: { __typename?: 'TriggerEvent', id: string, eventType: TriggerEventType, sourceType: TriggerSourceType, sourceInstanceId: string, sourceEventId: string, state: TriggerEventState, occurredAt: Date, receivedAt: Date, evaluatedAt?: Date | null | undefined, payload: Record<string, unknown>, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined, runs: Array<{ __typename?: 'TriggerRun', id: string, state: TriggerRunState, executionId?: string | null | undefined, triggerDefinition: { __typename?: 'TriggerDefinition', id: string, name: string } }> } | null | undefined, emailRun?: { __typename?: 'TriggerEmailRun', id: string, triggerDefinitionId: string, state: TriggerRunState, queuedAt: Date, dispatchedAt?: Date | null | undefined, workspaceId?: string | null | undefined, error?: { __typename?: 'TriggerEventError', code?: string | null | undefined, message: string } | null | undefined } | null | undefined }>, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null | undefined } } };

export type VisibilityConfigFieldsFragment = { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> };

export type VoiceAgentOverviewFieldsFragment = { __typename?: 'VoiceAgent', id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string, phone: string }, configuration: { __typename?: 'VoiceAgentConfiguration', agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined } } };

export type OutboundVoiceComplianceDisclosureFieldsFragment = { __typename?: 'OutboundVoiceComplianceDisclosure', version: string, title: string, intro: string, acknowledgmentLabel: string, sections: Array<{ __typename?: 'OutboundVoiceComplianceDisclosureSection', heading: string, body: string }> };

export type VoiceAgentConfigurationFieldsFragment = { __typename?: 'VoiceAgentConfiguration', agentName?: string | null | undefined, globalCustomInstructions?: string | null | undefined, introPhrase?: string | null | undefined, languages: Array<VoiceAgentLanguage>, agency: { __typename?: 'VoiceAgentConfigurationAgency', address?: string | null | undefined, businessHours?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, phone?: string | null | undefined, website?: string | null | undefined }, callBehavior: { __typename?: 'VoiceAgentConfigurationCallBehavior', rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding, referencePolicyInfo: boolean, repeatCriticalInfo: boolean, requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>, customRequiredContactInfo: Array<string>, startSpeaker: VoiceAgentStartSpeaker, beginAfterUserSilenceMs?: number | null | undefined }, model: { __typename?: 'VoiceAgentConfigurationModel', responsiveness: number, enableDynamicResponsiveness: boolean, voice: VoiceAgentConfigurationModelVoice, voiceSpeed: number, enableDynamicVoiceSpeed: boolean, voiceTemperature: number, voiceVolume: number }, notifications: { __typename?: 'VoiceAgentConfigurationNotifications', staticEmails: Array<string>, enableDynamicEmailRoutingToAgencyUsers: boolean, dynamicEmailRoutingCustomInstructions?: string | null | undefined }, accountLookup: { __typename?: 'VoiceAgentConfigurationAccountLookup', enabled: boolean, includedDataTypes: Array<VoiceAgentAccountLookupDataType> }, taskBehavior: { __typename?: 'VoiceAgentConfigurationTaskBehavior', businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine, coi: { __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI', enabled: boolean, customInstructions: string }, fnol: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL', enabled: boolean, customInstructions: string, auto: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>, customQuestions: Array<string> } }, lpr: { __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR', enabled: boolean, customInstructions: string }, quote: { __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote', enabled: boolean, qualification: { __typename?: 'VoiceAgentConfigurationQuestionsQualification', questions: Array<VoiceAgentConfigurationQuestionsQualificationType>, customQuestions: Array<string> }, commercialCommon: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon', questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability', questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty', questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>, customQuestions: Array<string> }, auto: { __typename?: 'VoiceAgentConfigurationQuestionsAuto', questions: Array<VoiceAgentConfigurationQuestionsAutoType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation', questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>, customQuestions: Array<string> }, custom: Array<{ __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote', lineOfBusiness: string, questions: Array<string> }> }, service: { __typename?: 'VoiceAgentConfigurationTaskBehaviorService', enabled: boolean, other: string, addDriver: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>, customQuestions: Array<string> }, addLocation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>, customQuestions: Array<string> }, addVehicle: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>, customQuestions: Array<string> } } }, transfer: { __typename?: 'VoiceAgentConfigurationTransfer', behavior: VoiceAgentTransferBehavior, collectPurpose: boolean, enabled: boolean, fallbackAttempts: number, warmTransfer: boolean, transferType: VoiceAgentTransferType, transferMessage: string, useNewColdTransferConversationFlow: boolean, ringDurationMs: number, transferBehaviorQuote: VoiceAgentTransferBehavior, transferBehaviorFnol: VoiceAgentTransferBehavior, transferBehaviorCoi: VoiceAgentTransferBehavior, transferBehaviorService: VoiceAgentTransferBehavior, transferBehaviorCancellation: VoiceAgentTransferBehavior, sipTransferMode?: VoiceAgentSipTransferMode | null | undefined, enableExternalTransfer: boolean, externalTransferBehavior: VoiceAgentExternalTransferBehavior, externalTransferAllowInternalFallback: boolean, externalTransferCallTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessCatalog: Array<{ __typename?: 'VoiceAgentTransferLineOfBusiness', id: string, label: string, description: string, examples: Array<string> }>, directory: Array<{ __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry', label: string, name?: string | null | undefined, department?: string | null | undefined, number: string, transferCriteria: string, extension?: string | null | undefined, entryType?: VoiceAgentTransferDirectoryEntryType | null | undefined, callTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessIds: Array<string>, aliases?: Array<string> | null | undefined, servicingCode?: string | null | undefined }>, hours: { __typename?: 'VoiceAgentConfigurationTransferHours', timezone: string, monday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, tuesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, wednesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, thursday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, friday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, saturday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, sunday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number } }, timeOffSchedules: Array<{ __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule', id: string, type: VoiceAgentTransferTimeOffScheduleType, name?: string | null | undefined, customIntro?: string | null | undefined, additionalInstructions?: string | null | undefined, dailyBreak?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak', daysOfWeek: Array<DayOfWeek>, startHour: number, startMinute: number, endHour: number, endMinute: number } | null | undefined, scheduledClosure?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure', date: string, endDate?: string | null | undefined } | null | undefined }> }, outboundCallBehavior?: { __typename?: 'VoiceAgentConfigurationOutboundCallBehavior', leaveVoicemail: boolean, voicemailMessage: string, verifyIdentity: boolean } | null | undefined };

export type VoiceAgentFieldsFragment = { __typename?: 'VoiceAgent', outboundIntroComplianceDisclosure?: string | null | undefined, id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, configuration: { __typename?: 'VoiceAgentConfiguration', agentName?: string | null | undefined, globalCustomInstructions?: string | null | undefined, introPhrase?: string | null | undefined, languages: Array<VoiceAgentLanguage>, agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined, address?: string | null | undefined, businessHours?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, website?: string | null | undefined }, callBehavior: { __typename?: 'VoiceAgentConfigurationCallBehavior', rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding, referencePolicyInfo: boolean, repeatCriticalInfo: boolean, requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>, customRequiredContactInfo: Array<string>, startSpeaker: VoiceAgentStartSpeaker, beginAfterUserSilenceMs?: number | null | undefined }, model: { __typename?: 'VoiceAgentConfigurationModel', responsiveness: number, enableDynamicResponsiveness: boolean, voice: VoiceAgentConfigurationModelVoice, voiceSpeed: number, enableDynamicVoiceSpeed: boolean, voiceTemperature: number, voiceVolume: number }, notifications: { __typename?: 'VoiceAgentConfigurationNotifications', staticEmails: Array<string>, enableDynamicEmailRoutingToAgencyUsers: boolean, dynamicEmailRoutingCustomInstructions?: string | null | undefined }, accountLookup: { __typename?: 'VoiceAgentConfigurationAccountLookup', enabled: boolean, includedDataTypes: Array<VoiceAgentAccountLookupDataType> }, taskBehavior: { __typename?: 'VoiceAgentConfigurationTaskBehavior', businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine, coi: { __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI', enabled: boolean, customInstructions: string }, fnol: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL', enabled: boolean, customInstructions: string, auto: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>, customQuestions: Array<string> } }, lpr: { __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR', enabled: boolean, customInstructions: string }, quote: { __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote', enabled: boolean, qualification: { __typename?: 'VoiceAgentConfigurationQuestionsQualification', questions: Array<VoiceAgentConfigurationQuestionsQualificationType>, customQuestions: Array<string> }, commercialCommon: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon', questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability', questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty', questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>, customQuestions: Array<string> }, auto: { __typename?: 'VoiceAgentConfigurationQuestionsAuto', questions: Array<VoiceAgentConfigurationQuestionsAutoType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation', questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>, customQuestions: Array<string> }, custom: Array<{ __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote', lineOfBusiness: string, questions: Array<string> }> }, service: { __typename?: 'VoiceAgentConfigurationTaskBehaviorService', enabled: boolean, other: string, addDriver: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>, customQuestions: Array<string> }, addLocation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>, customQuestions: Array<string> }, addVehicle: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>, customQuestions: Array<string> } } }, transfer: { __typename?: 'VoiceAgentConfigurationTransfer', behavior: VoiceAgentTransferBehavior, collectPurpose: boolean, enabled: boolean, fallbackAttempts: number, warmTransfer: boolean, transferType: VoiceAgentTransferType, transferMessage: string, useNewColdTransferConversationFlow: boolean, ringDurationMs: number, transferBehaviorQuote: VoiceAgentTransferBehavior, transferBehaviorFnol: VoiceAgentTransferBehavior, transferBehaviorCoi: VoiceAgentTransferBehavior, transferBehaviorService: VoiceAgentTransferBehavior, transferBehaviorCancellation: VoiceAgentTransferBehavior, sipTransferMode?: VoiceAgentSipTransferMode | null | undefined, enableExternalTransfer: boolean, externalTransferBehavior: VoiceAgentExternalTransferBehavior, externalTransferAllowInternalFallback: boolean, externalTransferCallTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessCatalog: Array<{ __typename?: 'VoiceAgentTransferLineOfBusiness', id: string, label: string, description: string, examples: Array<string> }>, directory: Array<{ __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry', label: string, name?: string | null | undefined, department?: string | null | undefined, number: string, transferCriteria: string, extension?: string | null | undefined, entryType?: VoiceAgentTransferDirectoryEntryType | null | undefined, callTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessIds: Array<string>, aliases?: Array<string> | null | undefined, servicingCode?: string | null | undefined }>, hours: { __typename?: 'VoiceAgentConfigurationTransferHours', timezone: string, monday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, tuesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, wednesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, thursday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, friday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, saturday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, sunday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number } }, timeOffSchedules: Array<{ __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule', id: string, type: VoiceAgentTransferTimeOffScheduleType, name?: string | null | undefined, customIntro?: string | null | undefined, additionalInstructions?: string | null | undefined, dailyBreak?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak', daysOfWeek: Array<DayOfWeek>, startHour: number, startMinute: number, endHour: number, endMinute: number } | null | undefined, scheduledClosure?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure', date: string, endDate?: string | null | undefined } | null | undefined }> }, outboundCallBehavior?: { __typename?: 'VoiceAgentConfigurationOutboundCallBehavior', leaveVoicemail: boolean, voicemailMessage: string, verifyIdentity: boolean } | null | undefined }, agency: { __typename?: 'Agency', id: string, name: string, phone: string } };

export type GetVoiceAgentsQueryVariables = Exact<{
  filter?: InputMaybe<VoiceAgentsFilterInput>;
}>;


export type GetVoiceAgentsQuery = { __typename?: 'Query', voiceAgents: Array<{ __typename?: 'VoiceAgent', id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, agency: { __typename?: 'Agency', id: string, name: string, phone: string }, configuration: { __typename?: 'VoiceAgentConfiguration', agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined } } }> };

export type GetVoiceAgentQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type GetVoiceAgentQuery = { __typename?: 'Query', voiceAgent: { __typename?: 'VoiceAgent', outboundIntroComplianceDisclosure?: string | null | undefined, id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, configuration: { __typename?: 'VoiceAgentConfiguration', agentName?: string | null | undefined, globalCustomInstructions?: string | null | undefined, introPhrase?: string | null | undefined, languages: Array<VoiceAgentLanguage>, agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined, address?: string | null | undefined, businessHours?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, website?: string | null | undefined }, callBehavior: { __typename?: 'VoiceAgentConfigurationCallBehavior', rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding, referencePolicyInfo: boolean, repeatCriticalInfo: boolean, requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>, customRequiredContactInfo: Array<string>, startSpeaker: VoiceAgentStartSpeaker, beginAfterUserSilenceMs?: number | null | undefined }, model: { __typename?: 'VoiceAgentConfigurationModel', responsiveness: number, enableDynamicResponsiveness: boolean, voice: VoiceAgentConfigurationModelVoice, voiceSpeed: number, enableDynamicVoiceSpeed: boolean, voiceTemperature: number, voiceVolume: number }, notifications: { __typename?: 'VoiceAgentConfigurationNotifications', staticEmails: Array<string>, enableDynamicEmailRoutingToAgencyUsers: boolean, dynamicEmailRoutingCustomInstructions?: string | null | undefined }, accountLookup: { __typename?: 'VoiceAgentConfigurationAccountLookup', enabled: boolean, includedDataTypes: Array<VoiceAgentAccountLookupDataType> }, taskBehavior: { __typename?: 'VoiceAgentConfigurationTaskBehavior', businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine, coi: { __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI', enabled: boolean, customInstructions: string }, fnol: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL', enabled: boolean, customInstructions: string, auto: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>, customQuestions: Array<string> } }, lpr: { __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR', enabled: boolean, customInstructions: string }, quote: { __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote', enabled: boolean, qualification: { __typename?: 'VoiceAgentConfigurationQuestionsQualification', questions: Array<VoiceAgentConfigurationQuestionsQualificationType>, customQuestions: Array<string> }, commercialCommon: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon', questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability', questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty', questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>, customQuestions: Array<string> }, auto: { __typename?: 'VoiceAgentConfigurationQuestionsAuto', questions: Array<VoiceAgentConfigurationQuestionsAutoType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation', questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>, customQuestions: Array<string> }, custom: Array<{ __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote', lineOfBusiness: string, questions: Array<string> }> }, service: { __typename?: 'VoiceAgentConfigurationTaskBehaviorService', enabled: boolean, other: string, addDriver: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>, customQuestions: Array<string> }, addLocation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>, customQuestions: Array<string> }, addVehicle: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>, customQuestions: Array<string> } } }, transfer: { __typename?: 'VoiceAgentConfigurationTransfer', behavior: VoiceAgentTransferBehavior, collectPurpose: boolean, enabled: boolean, fallbackAttempts: number, warmTransfer: boolean, transferType: VoiceAgentTransferType, transferMessage: string, useNewColdTransferConversationFlow: boolean, ringDurationMs: number, transferBehaviorQuote: VoiceAgentTransferBehavior, transferBehaviorFnol: VoiceAgentTransferBehavior, transferBehaviorCoi: VoiceAgentTransferBehavior, transferBehaviorService: VoiceAgentTransferBehavior, transferBehaviorCancellation: VoiceAgentTransferBehavior, sipTransferMode?: VoiceAgentSipTransferMode | null | undefined, enableExternalTransfer: boolean, externalTransferBehavior: VoiceAgentExternalTransferBehavior, externalTransferAllowInternalFallback: boolean, externalTransferCallTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessCatalog: Array<{ __typename?: 'VoiceAgentTransferLineOfBusiness', id: string, label: string, description: string, examples: Array<string> }>, directory: Array<{ __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry', label: string, name?: string | null | undefined, department?: string | null | undefined, number: string, transferCriteria: string, extension?: string | null | undefined, entryType?: VoiceAgentTransferDirectoryEntryType | null | undefined, callTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessIds: Array<string>, aliases?: Array<string> | null | undefined, servicingCode?: string | null | undefined }>, hours: { __typename?: 'VoiceAgentConfigurationTransferHours', timezone: string, monday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, tuesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, wednesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, thursday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, friday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, saturday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, sunday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number } }, timeOffSchedules: Array<{ __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule', id: string, type: VoiceAgentTransferTimeOffScheduleType, name?: string | null | undefined, customIntro?: string | null | undefined, additionalInstructions?: string | null | undefined, dailyBreak?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak', daysOfWeek: Array<DayOfWeek>, startHour: number, startMinute: number, endHour: number, endMinute: number } | null | undefined, scheduledClosure?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure', date: string, endDate?: string | null | undefined } | null | undefined }> }, outboundCallBehavior?: { __typename?: 'VoiceAgentConfigurationOutboundCallBehavior', leaveVoicemail: boolean, voicemailMessage: string, verifyIdentity: boolean } | null | undefined }, agency: { __typename?: 'Agency', id: string, name: string, phone: string } } };

export type GetVoiceAgentLanguageSupportQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVoiceAgentLanguageSupportQuery = { __typename?: 'Query', voiceAgentLanguageSupport: { __typename?: 'VoiceAgentLanguageSupport', englishLanguages: Array<VoiceAgentLanguage>, providers: Array<{ __typename?: 'VoiceProviderLanguageSupport', provider: VoiceProvider, languages: Array<VoiceAgentLanguage>, preferredLanguages: Array<VoiceAgentLanguage>, defaultVoice: VoiceAgentConfigurationModelVoice }>, voices: Array<{ __typename?: 'VoiceAgentVoiceProviderSupport', voice: VoiceAgentConfigurationModelVoice, provider: VoiceProvider, custom: boolean }> } };

export type CreateVoiceAgentMutationVariables = Exact<{
  input: CreateVoiceAgentInput;
}>;


export type CreateVoiceAgentMutation = { __typename?: 'Mutation', createVoiceAgent: { __typename?: 'VoiceAgent', outboundIntroComplianceDisclosure?: string | null | undefined, id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, configuration: { __typename?: 'VoiceAgentConfiguration', agentName?: string | null | undefined, globalCustomInstructions?: string | null | undefined, introPhrase?: string | null | undefined, languages: Array<VoiceAgentLanguage>, agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined, address?: string | null | undefined, businessHours?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, website?: string | null | undefined }, callBehavior: { __typename?: 'VoiceAgentConfigurationCallBehavior', rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding, referencePolicyInfo: boolean, repeatCriticalInfo: boolean, requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>, customRequiredContactInfo: Array<string>, startSpeaker: VoiceAgentStartSpeaker, beginAfterUserSilenceMs?: number | null | undefined }, model: { __typename?: 'VoiceAgentConfigurationModel', responsiveness: number, enableDynamicResponsiveness: boolean, voice: VoiceAgentConfigurationModelVoice, voiceSpeed: number, enableDynamicVoiceSpeed: boolean, voiceTemperature: number, voiceVolume: number }, notifications: { __typename?: 'VoiceAgentConfigurationNotifications', staticEmails: Array<string>, enableDynamicEmailRoutingToAgencyUsers: boolean, dynamicEmailRoutingCustomInstructions?: string | null | undefined }, accountLookup: { __typename?: 'VoiceAgentConfigurationAccountLookup', enabled: boolean, includedDataTypes: Array<VoiceAgentAccountLookupDataType> }, taskBehavior: { __typename?: 'VoiceAgentConfigurationTaskBehavior', businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine, coi: { __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI', enabled: boolean, customInstructions: string }, fnol: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL', enabled: boolean, customInstructions: string, auto: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>, customQuestions: Array<string> } }, lpr: { __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR', enabled: boolean, customInstructions: string }, quote: { __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote', enabled: boolean, qualification: { __typename?: 'VoiceAgentConfigurationQuestionsQualification', questions: Array<VoiceAgentConfigurationQuestionsQualificationType>, customQuestions: Array<string> }, commercialCommon: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon', questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability', questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty', questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>, customQuestions: Array<string> }, auto: { __typename?: 'VoiceAgentConfigurationQuestionsAuto', questions: Array<VoiceAgentConfigurationQuestionsAutoType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation', questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>, customQuestions: Array<string> }, custom: Array<{ __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote', lineOfBusiness: string, questions: Array<string> }> }, service: { __typename?: 'VoiceAgentConfigurationTaskBehaviorService', enabled: boolean, other: string, addDriver: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>, customQuestions: Array<string> }, addLocation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>, customQuestions: Array<string> }, addVehicle: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>, customQuestions: Array<string> } } }, transfer: { __typename?: 'VoiceAgentConfigurationTransfer', behavior: VoiceAgentTransferBehavior, collectPurpose: boolean, enabled: boolean, fallbackAttempts: number, warmTransfer: boolean, transferType: VoiceAgentTransferType, transferMessage: string, useNewColdTransferConversationFlow: boolean, ringDurationMs: number, transferBehaviorQuote: VoiceAgentTransferBehavior, transferBehaviorFnol: VoiceAgentTransferBehavior, transferBehaviorCoi: VoiceAgentTransferBehavior, transferBehaviorService: VoiceAgentTransferBehavior, transferBehaviorCancellation: VoiceAgentTransferBehavior, sipTransferMode?: VoiceAgentSipTransferMode | null | undefined, enableExternalTransfer: boolean, externalTransferBehavior: VoiceAgentExternalTransferBehavior, externalTransferAllowInternalFallback: boolean, externalTransferCallTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessCatalog: Array<{ __typename?: 'VoiceAgentTransferLineOfBusiness', id: string, label: string, description: string, examples: Array<string> }>, directory: Array<{ __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry', label: string, name?: string | null | undefined, department?: string | null | undefined, number: string, transferCriteria: string, extension?: string | null | undefined, entryType?: VoiceAgentTransferDirectoryEntryType | null | undefined, callTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessIds: Array<string>, aliases?: Array<string> | null | undefined, servicingCode?: string | null | undefined }>, hours: { __typename?: 'VoiceAgentConfigurationTransferHours', timezone: string, monday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, tuesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, wednesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, thursday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, friday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, saturday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, sunday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number } }, timeOffSchedules: Array<{ __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule', id: string, type: VoiceAgentTransferTimeOffScheduleType, name?: string | null | undefined, customIntro?: string | null | undefined, additionalInstructions?: string | null | undefined, dailyBreak?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak', daysOfWeek: Array<DayOfWeek>, startHour: number, startMinute: number, endHour: number, endMinute: number } | null | undefined, scheduledClosure?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure', date: string, endDate?: string | null | undefined } | null | undefined }> }, outboundCallBehavior?: { __typename?: 'VoiceAgentConfigurationOutboundCallBehavior', leaveVoicemail: boolean, voicemailMessage: string, verifyIdentity: boolean } | null | undefined }, agency: { __typename?: 'Agency', id: string, name: string, phone: string } } };

export type UpdateVoiceAgentMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  input: VoiceAgentInput;
  transferDirectoryChanges?: InputMaybe<Array<TransferDirectoryChangeInput> | TransferDirectoryChangeInput>;
  idempotencyKey?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateVoiceAgentMutation = { __typename?: 'Mutation', updateVoiceAgent: { __typename?: 'VoiceAgent', outboundIntroComplianceDisclosure?: string | null | undefined, id: string, name: string, phoneNumber: string, state: VoiceAgentState, direction: VoiceAgentDirection, createdAt: Date, updatedAt: Date, configuration: { __typename?: 'VoiceAgentConfiguration', agentName?: string | null | undefined, globalCustomInstructions?: string | null | undefined, introPhrase?: string | null | undefined, languages: Array<VoiceAgentLanguage>, agency: { __typename?: 'VoiceAgentConfigurationAgency', phone?: string | null | undefined, address?: string | null | undefined, businessHours?: string | null | undefined, email?: string | null | undefined, name?: string | null | undefined, website?: string | null | undefined }, callBehavior: { __typename?: 'VoiceAgentConfigurationCallBehavior', rapportBuilding: VoiceAgentConfigurationCallBehaviorRapportBuilding, referencePolicyInfo: boolean, repeatCriticalInfo: boolean, requiredContactInfo: Array<VoiceAgentConfigurationCallBehaviorRequiredContactInfoType>, customRequiredContactInfo: Array<string>, startSpeaker: VoiceAgentStartSpeaker, beginAfterUserSilenceMs?: number | null | undefined }, model: { __typename?: 'VoiceAgentConfigurationModel', responsiveness: number, enableDynamicResponsiveness: boolean, voice: VoiceAgentConfigurationModelVoice, voiceSpeed: number, enableDynamicVoiceSpeed: boolean, voiceTemperature: number, voiceVolume: number }, notifications: { __typename?: 'VoiceAgentConfigurationNotifications', staticEmails: Array<string>, enableDynamicEmailRoutingToAgencyUsers: boolean, dynamicEmailRoutingCustomInstructions?: string | null | undefined }, accountLookup: { __typename?: 'VoiceAgentConfigurationAccountLookup', enabled: boolean, includedDataTypes: Array<VoiceAgentAccountLookupDataType> }, taskBehavior: { __typename?: 'VoiceAgentConfigurationTaskBehavior', businessLines: VoiceAgentConfigurationTaskBehaviorBusinessLine, coi: { __typename?: 'VoiceAgentConfigurationTaskBehaviorCOI', enabled: boolean, customInstructions: string }, fnol: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOL', enabled: boolean, customInstructions: string, auto: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLAuto', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolAutoType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialLiability', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLCommercialProperty', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolCommercialPropertyType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorFNOLWorkersCompensation', questions: Array<VoiceAgentConfigurationTaskBehaviorFnolWorkersCompensationType>, customQuestions: Array<string> } }, lpr: { __typename?: 'VoiceAgentConfigurationTaskBehaviorLPR', enabled: boolean, customInstructions: string }, quote: { __typename?: 'VoiceAgentConfigurationTaskBehaviorQuote', enabled: boolean, qualification: { __typename?: 'VoiceAgentConfigurationQuestionsQualification', questions: Array<VoiceAgentConfigurationQuestionsQualificationType>, customQuestions: Array<string> }, commercialCommon: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialCommon', questions: Array<VoiceAgentConfigurationQuestionsCommercialCommonType>, customQuestions: Array<string> }, commercialLiability: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialLiability', questions: Array<VoiceAgentConfigurationQuestionsCommercialLiabilityType>, customQuestions: Array<string> }, commercialProperty: { __typename?: 'VoiceAgentConfigurationQuestionsCommercialProperty', questions: Array<VoiceAgentConfigurationQuestionsCommercialPropertyType>, customQuestions: Array<string> }, auto: { __typename?: 'VoiceAgentConfigurationQuestionsAuto', questions: Array<VoiceAgentConfigurationQuestionsAutoType>, customQuestions: Array<string> }, workersCompensation: { __typename?: 'VoiceAgentConfigurationQuestionsWorkersCompensation', questions: Array<VoiceAgentConfigurationQuestionsWorkersCompensationType>, customQuestions: Array<string> }, custom: Array<{ __typename?: 'VoiceAgentConfigurationQuestionsCustomQuote', lineOfBusiness: string, questions: Array<string> }> }, service: { __typename?: 'VoiceAgentConfigurationTaskBehaviorService', enabled: boolean, other: string, addDriver: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddDriver', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddDriverType>, customQuestions: Array<string> }, addLocation: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddLocation', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddLocationType>, customQuestions: Array<string> }, addVehicle: { __typename?: 'VoiceAgentConfigurationTaskBehaviorServiceAddVehicle', questions: Array<VoiceAgentConfigurationTaskBehaviorServiceAddVehicleType>, customQuestions: Array<string> } } }, transfer: { __typename?: 'VoiceAgentConfigurationTransfer', behavior: VoiceAgentTransferBehavior, collectPurpose: boolean, enabled: boolean, fallbackAttempts: number, warmTransfer: boolean, transferType: VoiceAgentTransferType, transferMessage: string, useNewColdTransferConversationFlow: boolean, ringDurationMs: number, transferBehaviorQuote: VoiceAgentTransferBehavior, transferBehaviorFnol: VoiceAgentTransferBehavior, transferBehaviorCoi: VoiceAgentTransferBehavior, transferBehaviorService: VoiceAgentTransferBehavior, transferBehaviorCancellation: VoiceAgentTransferBehavior, sipTransferMode?: VoiceAgentSipTransferMode | null | undefined, enableExternalTransfer: boolean, externalTransferBehavior: VoiceAgentExternalTransferBehavior, externalTransferAllowInternalFallback: boolean, externalTransferCallTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessCatalog: Array<{ __typename?: 'VoiceAgentTransferLineOfBusiness', id: string, label: string, description: string, examples: Array<string> }>, directory: Array<{ __typename?: 'VoiceAgentConfigurationTransferDirectoryEntry', label: string, name?: string | null | undefined, department?: string | null | undefined, number: string, transferCriteria: string, extension?: string | null | undefined, entryType?: VoiceAgentTransferDirectoryEntryType | null | undefined, callTypes?: Array<VoiceAgentTransferCallType> | null | undefined, lineOfBusinessIds: Array<string>, aliases?: Array<string> | null | undefined, servicingCode?: string | null | undefined }>, hours: { __typename?: 'VoiceAgentConfigurationTransferHours', timezone: string, monday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, tuesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, wednesday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, thursday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, friday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, saturday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number }, sunday: { __typename?: 'VoiceAgentConfigurationTransferHoursDay', enabled: boolean, startHour: number, startMinute: number, endHour: number, endMinute: number } }, timeOffSchedules: Array<{ __typename?: 'VoiceAgentConfigurationTransferTimeOffSchedule', id: string, type: VoiceAgentTransferTimeOffScheduleType, name?: string | null | undefined, customIntro?: string | null | undefined, additionalInstructions?: string | null | undefined, dailyBreak?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffDailyBreak', daysOfWeek: Array<DayOfWeek>, startHour: number, startMinute: number, endHour: number, endMinute: number } | null | undefined, scheduledClosure?: { __typename?: 'VoiceAgentConfigurationTransferTimeOffScheduledClosure', date: string, endDate?: string | null | undefined } | null | undefined }> }, outboundCallBehavior?: { __typename?: 'VoiceAgentConfigurationOutboundCallBehavior', leaveVoicemail: boolean, voicemailMessage: string, verifyIdentity: boolean } | null | undefined }, agency: { __typename?: 'Agency', id: string, name: string, phone: string } } };

export type GetVoiceAgentCreateContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetVoiceAgentCreateContextQuery = { __typename?: 'Query', agencyUser?: { __typename?: 'AgencyUser', lastViewedNewFeatures?: Date | null | undefined, settingsUsageTabEnabled: boolean, frontendFlags: Array<string>, highEffortEnabled: boolean, hasAccessibleMailbox: boolean, outboundCallsEnabled: boolean, id: string, email: string, name: string, roles: Array<Role>, state: AgencyUserState, agency: { __typename?: 'Agency', outboundVoiceComplianceAcknowledgmentRequired: boolean, id: string, name: string, displayName: string, emailNamespace: string, phone: string, nationalProducerNumber: string, floridaLicenseNumber: string, entitlements: Array<SubscriptionEntitlement>, outboundVoiceComplianceDisclosure: { __typename?: 'OutboundVoiceComplianceDisclosure', version: string, title: string, intro: string, acknowledgmentLabel: string, sections: Array<{ __typename?: 'OutboundVoiceComplianceDisclosureSection', heading: string, body: string }> }, mailingAddress: { __typename?: 'Address', line1: string, line2?: string | null | undefined, city: string, subZone?: string | null | undefined, zone: string, postalCode: string }, configuration: { __typename?: 'AgencyConfiguration', hipaaPrivacyMode: { __typename?: 'HipaaPrivacyModeConfiguration', enabled: boolean }, liabilityCOIConfiguration: { __typename?: 'CertificateOfLiabilityAgencyConfiguration', contactName: string, contactEmail: string, contactPhone: string }, visibility: { __typename?: 'AgencyVisibilityPolicy', disallowPrivate: boolean }, acordFormConfiguration: { __typename?: 'ACORDFormConfiguration', descriptionOfOperationsMode?: DescriptionOfOperationsMode | null | undefined, numberFormat?: AcordNumberFormat | null | undefined, producerInformationSource?: AcordProducerInformationSource | null | undefined, idCardLogoBase64Data?: string | null | undefined, appendRules?: Array<{ __typename?: 'ACORDFormAppendRule', formType: AcordFormType, appendTypes: Array<AcordAppendType> }> | null | undefined, rules?: Array<{ __typename?: 'ACORDFormRule', id: string, formType: AcordFormType, section?: AcordFormSection | null | undefined, condition: string, phrasing: string, isPreset: boolean }> | null | undefined } }, subscription?: { __typename?: 'AgencySubscription', agencyId: string, entitlements: Array<SubscriptionEntitlement>, usageCycle?: UsageCycle | null | undefined, nextBillingAmount?: number | null | undefined, nextBillingDate?: Date | null | undefined, numSeats: number, numSeatsActive: number, numSeatsMinimum: number, numVoiceAgents: number, numVoiceAgentsActive: number, period?: SubscriptionPeriod | null | undefined, plan?: SubscriptionPlan | null | undefined, planBillingType?: PlanBillingType | null | undefined, state: SubscriptionState, startDate?: Date | null | undefined, trialEndDate?: Date | null | undefined, standardSunsetRenewalConfirmedAt?: Date | null | undefined, standardSunsetRenewalBannerDismissedAt?: Date | null | undefined, annualRenewalDate?: Date | null | undefined, annualRenewalReviewOpen: boolean } | null | undefined }, teams: Array<{ __typename?: 'Team', id: string }>, profile?: { __typename?: 'AgencyProfile', id: string, name: string, configuration: { __typename?: 'AgencyProfileConfiguration', navigation: Array<NavigationItem>, homeScreen: { __typename?: 'AgencyProfileHomeScreen', askCaraEnabled: boolean, allowUserCustomization: boolean, pins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } } | null | undefined, permissions: Array<{ __typename?: 'Permission', scope: Scope, resource: Resource, action: Action }>, preferences: { __typename?: 'AgencyUserPreferences', overrideCOIConfigurationMode?: CoiConfigurationMode | null | undefined, memoryDisabled: boolean, desktopNotifications: { __typename?: 'AgencyUserDesktopNotificationPreferences', enabled: boolean, workspaceCompletionIntervalMinutes: number }, defaultVisibility: { __typename?: 'VisibilityConfig', level: Visibility, userIds: Array<string>, teamIds: Array<string> }, homePins: Array<{ __typename?: 'AgencyUserHomePin', useCase?: CaraWorkspaceUseCase | null | undefined, customPresetId?: string | null | undefined }> } } | null | undefined };

export type GetWorkflowExecutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWorkflowExecutionsQuery = { __typename?: 'Query', workflowExecutions: Array<{ __typename?: 'WorkflowExecution', id: string, state: WorkflowExecutionState, version: number, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, error?: { __typename?: 'WorkflowExecutionError', message: string, code?: string | null | undefined } | null | undefined, tasks: Array<{ __typename?: 'WorkflowTask', id: string, definitionKey: WorkflowTaskDefinitionKey, state: WorkflowTaskState }> }> };

export type GetWorkflowExecutionQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  version?: InputMaybe<Scalars['Int64']['input']>;
}>;


export type GetWorkflowExecutionQuery = { __typename?: 'Query', workflowExecution?: { __typename?: 'WorkflowExecution', id: string, state: WorkflowExecutionState, version: number, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined, createdAt: Date, updatedAt: Date, error?: { __typename?: 'WorkflowExecutionError', message: string, code?: string | null | undefined } | null | undefined, tasks: Array<{ __typename?: 'WorkflowTask', id: string, definitionKey: WorkflowTaskDefinitionKey, state: WorkflowTaskState }>, outputs: Array<{ __typename?: 'WorkflowOutput', id: string, label: string, type: WorkflowOutputType, artifact?: { __typename?: 'WorkflowArtifact', type: WorkflowArtifactType, name: string, markdown?: { __typename?: 'WorkflowArtifactMarkdown', content: string } | null | undefined, file?: { __typename?: 'WorkflowArtifactFile', fileId: string, mimeType: string, url?: string | null | undefined } | null | undefined } | null | undefined }> } | null | undefined };

export type CreateWorkflowExecutionMutationVariables = Exact<{
  input: CreateWorkflowExecutionInput;
}>;


export type CreateWorkflowExecutionMutation = { __typename?: 'Mutation', createWorkflowExecution: { __typename?: 'WorkflowExecution', id: string, state: WorkflowExecutionState, version: number } };

export type WatchWorkflowExecutionSubscriptionVariables = Exact<{
  id: Scalars['ID']['input'];
  version: Scalars['Int64']['input'];
}>;


export type WatchWorkflowExecutionSubscription = { __typename?: 'Subscription', watchWorkflowExecution: { __typename?: 'WorkflowExecution', id: string, state: WorkflowExecutionState, version: number, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined, updatedAt: Date, error?: { __typename?: 'WorkflowExecutionError', message: string, code?: string | null | undefined } | null | undefined, outputs: Array<{ __typename?: 'WorkflowOutput', id: string, label: string, type: WorkflowOutputType, artifact?: { __typename?: 'WorkflowArtifact', type: WorkflowArtifactType, name: string, markdown?: { __typename?: 'WorkflowArtifactMarkdown', content: string } | null | undefined, file?: { __typename?: 'WorkflowArtifactFile', fileId: string, mimeType: string, url?: string | null | undefined } | null | undefined } | null | undefined }>, tasks: Array<{ __typename?: 'WorkflowTask', id: string, definitionKey: WorkflowTaskDefinitionKey, state: WorkflowTaskState, startedAt?: Date | null | undefined, completedAt?: Date | null | undefined, dependencies: Array<{ __typename?: 'WorkflowTask', id: string }>, error?: { __typename?: 'WorkflowExecutionError', message: string, code?: string | null | undefined } | null | undefined, outputs: Array<{ __typename?: 'WorkflowTaskOutput', id: string, key: string, sequence: number, type: WorkflowTaskOutputType, text?: string | null | undefined, json?: { __typename?: 'WorkflowJSONOutput', data: Record<string, unknown> } | null | undefined, artifact?: { __typename?: 'WorkflowArtifact', type: WorkflowArtifactType, name: string, markdown?: { __typename?: 'WorkflowArtifactMarkdown', content: string } | null | undefined, file?: { __typename?: 'WorkflowArtifactFile', fileId: string, mimeType: string, url?: string | null | undefined } | null | undefined } | null | undefined }>, events: Array<{ __typename?: 'WorkflowTaskEvent', id: string, attempt: number, sequence: number, type: WorkflowTaskEventType, title: string, createdAt: Date, message?: { __typename?: 'WorkflowMessageEvent', content: string, level: WorkflowMessageLevel } | null | undefined, thinking?: { __typename?: 'WorkflowThinkingEvent', content: string } | null | undefined, progress?: { __typename?: 'WorkflowProgressEvent', message: string, percent: number } | null | undefined, retrieval?: { __typename?: 'WorkflowRetrievalEvent', query: string, resultCount: number } | null | undefined, toolCall?: { __typename?: 'WorkflowToolCallEvent', toolName: string, input?: Record<string, unknown> | null | undefined, output?: Record<string, unknown> | null | undefined } | null | undefined, spawnEvent?: { __typename?: 'WorkflowSpawnEvent', spawnedTaskId: string, description: string } | null | undefined, error?: { __typename?: 'WorkflowExecutionError', message: string, code?: string | null | undefined } | null | undefined }> }> } };

export const AccountFieldsFragmentDoc = gql`
    fragment AccountFields on Account {
  account {
    email
    mailingAddress {
      line1
      line2
      city
      zone
      postalCode
    }
    name
    phone
    ... on BusinessAccount {
      dba
      website
    }
  }
  createdAt
  id
  type
}
    `;
export const BusinessPolicyFieldsFragmentDoc = gql`
    fragment BusinessPolicyFields on BusinessPolicy {
  account {
    account {
      email
      name
    }
    id
  }
  carrier {
    id
    name
  }
  expiresAt
  id
  inforceAt
  issuedAt
  policyNumber
  state
  type
}
    `;
export const AccountBusinessPolicyFieldsFragmentDoc = gql`
    fragment AccountBusinessPolicyFields on Account {
  businessPolicies {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export const CertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
    fragment CertificateOfLiabilityInsuranceFields on CertificateOfLiabilityInsurance {
  id
  certificateNumber
  holder {
    name
    address {
      line1
      city
      zone
      postalCode
    }
  }
  viewUrl
  downloadUrl
  createdAt
}
    `;
export const AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc = gql`
    fragment AccountCertificateOfLiabilityInsuranceFields on Account {
  certificatesOfLiabilityInsurance {
    ...CertificateOfLiabilityInsuranceFields
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}`;
export const ContactFieldsFragmentDoc = gql`
    fragment ContactFields on AccountContact {
  email
  id
  name
  phone
}
    `;
export const AccountContactFieldsFragmentDoc = gql`
    fragment AccountContactFields on Account {
  contacts {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;
export const ServiceRequestFieldsFragmentDoc = gql`
    fragment ServiceRequestFields on ServiceRequest {
  id
  type
  state
  clientEmail
  clientName
  clientPhone
  details
  account {
    type
    account {
      name
    }
  }
  assignee {
    id
    name
  }
  dueAt
  addAdditionalInsured {
    address {
      line1
      city
      zone
      postalCode
    }
    name
    relationship
  }
  businessPolicy {
    id
    type
    carrier {
      name
    }
  }
  cancelPolicy {
    policyId
    reason
  }
  createCertificate {
    name
    address {
      line1
      city
      zone
      postalCode
    }
    additionalInsured
    additionalInsuredRelationship
    additionalInsuredRelationshipDescription
  }
  documentRequest {
    type
  }
  endorsePolicy {
    policyId
  }
  question {
    policyId
    question
    type
  }
  resolution {
    notes
  }
  createdAt
  updatedAt
}
    `;
export const AccountServiceRequestFieldsFragmentDoc = gql`
    fragment AccountServiceRequestFields on Account {
  serviceRequests {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export const AgencyProfileAssignmentFieldsFragmentDoc = gql`
    fragment AgencyProfileAssignmentFields on AgencyProfile {
  id
  name
  isDefault
  users {
    id
  }
  teams {
    id
  }
}
    `;
export const AgencyProfileSummaryFieldsFragmentDoc = gql`
    fragment AgencyProfileSummaryFields on AgencyProfile {
  id
  name
  description
  isDefault
  assignedUserCount
  teams {
    id
    name
  }
}
    `;
export const AgencyProfileHomeScreenFieldsFragmentDoc = gql`
    fragment AgencyProfileHomeScreenFields on AgencyProfileHomeScreen {
  askCaraEnabled
  allowUserCustomization
  pins {
    useCase
    customPresetId
  }
}
    `;
export const AgencyProfileFieldsFragmentDoc = gql`
    fragment AgencyProfileFields on AgencyProfile {
  ...AgencyProfileSummaryFields
  configuration {
    navigation
    homeScreen {
      ...AgencyProfileHomeScreenFields
    }
    capabilities
  }
  users {
    id
    name
    email
  }
  createdAt
  updatedAt
}
    ${AgencyProfileSummaryFieldsFragmentDoc}
${AgencyProfileHomeScreenFieldsFragmentDoc}`;
export const AgencyProfileNavigationOptionFieldsFragmentDoc = gql`
    fragment AgencyProfileNavigationOptionFields on AgencyProfileNavigationOption {
  item
  label
}
    `;
export const AgencyProfileOptionFieldsFragmentDoc = gql`
    fragment AgencyProfileOptionFields on AgencyProfile {
  id
  name
  description
}
    `;
export const ProducerInformationFieldsFragmentDoc = gql`
    fragment ProducerInformationFields on ProducerInformation {
  id
  isDefault
  agencyName
  agencyAddress {
    line1
    line2
    city
    zone
    postalCode
  }
  contactName
  contactEmail
  contactPhone
  contactFax
  producerName
  nationalProducerNumber
  floridaLicenseNumber
  producerSignatureJpegBase64
  createdAt
  updatedAt
}
    `;
export const ChildAgencySubscriptionFieldsFragmentDoc = gql`
    fragment ChildAgencySubscriptionFields on AgencySubscription {
  numSeats
  numSeatsActive
  numVoiceAgents
  state
}
    `;
export const AgencyUserFieldsFragmentDoc = gql`
    fragment AgencyUserFields on AgencyUser {
  id
  email
  name
  roles
  state
}
    `;
export const ChildAgencyFieldsFragmentDoc = gql`
    fragment ChildAgencyFields on Agency {
  id
  name
  subscription {
    ...ChildAgencySubscriptionFields
  }
  users {
    ...AgencyUserFields
  }
  voiceAgents {
    id
  }
}
    ${ChildAgencySubscriptionFieldsFragmentDoc}
${AgencyUserFieldsFragmentDoc}`;
export const AppliedAgencyProfileFieldsFragmentDoc = gql`
    fragment AppliedAgencyProfileFields on AgencyProfile {
  id
  name
  configuration {
    navigation
    homeScreen {
      ...AgencyProfileHomeScreenFields
    }
  }
}
    ${AgencyProfileHomeScreenFieldsFragmentDoc}`;
export const VisibilityConfigFieldsFragmentDoc = gql`
    fragment VisibilityConfigFields on VisibilityConfig {
  level
  userIds
  teamIds
}
    `;
export const AcordFormConfigurationFieldsFragmentDoc = gql`
    fragment ACORDFormConfigurationFields on ACORDFormConfiguration {
  descriptionOfOperationsMode
  numberFormat
  producerInformationSource
  idCardLogoBase64Data
  appendRules {
    formType
    appendTypes
  }
  rules {
    id
    formType
    section
    condition
    phrasing
    isPreset
  }
}
    `;
export const AgencySubscriptionFieldsFragmentDoc = gql`
    fragment AgencySubscriptionFields on AgencySubscription {
  agencyId
  entitlements
  usageCycle
  nextBillingAmount
  nextBillingDate
  numSeats
  numSeatsActive
  numSeatsMinimum
  numVoiceAgents
  numVoiceAgentsActive
  period
  plan
  planBillingType
  state
  startDate
  trialEndDate
  standardSunsetRenewalConfirmedAt
  standardSunsetRenewalBannerDismissedAt
  annualRenewalDate
  annualRenewalReviewOpen
}
    `;
export const AgencyFieldsFragmentDoc = gql`
    fragment AgencyFields on Agency {
  id
  name
  displayName
  emailNamespace
  phone
  nationalProducerNumber
  floridaLicenseNumber
  entitlements
  mailingAddress {
    line1
    line2
    city
    subZone
    zone
    postalCode
  }
  configuration {
    hipaaPrivacyMode {
      enabled
    }
    liabilityCOIConfiguration {
      contactName
      contactEmail
      contactPhone
    }
    visibility {
      disallowPrivate
    }
    acordFormConfiguration {
      ...ACORDFormConfigurationFields
    }
  }
  subscription {
    ...AgencySubscriptionFields
  }
}
    ${AcordFormConfigurationFieldsFragmentDoc}
${AgencySubscriptionFieldsFragmentDoc}`;
export const LoggedInAgencyUserFieldsFragmentDoc = gql`
    fragment LoggedInAgencyUserFields on AgencyUser {
  ...AgencyUserFields
  lastViewedNewFeatures
  settingsUsageTabEnabled
  frontendFlags
  highEffortEnabled
  hasAccessibleMailbox
  outboundCallsEnabled
  teams {
    id
  }
  profile {
    ...AppliedAgencyProfileFields
  }
  permissions {
    scope
    resource
    action
  }
  preferences {
    overrideCOIConfigurationMode
    desktopNotifications {
      enabled
      workspaceCompletionIntervalMinutes
    }
    defaultVisibility {
      ...VisibilityConfigFields
    }
    memoryDisabled
    overrideCOIConfigurationMode
    homePins {
      useCase
      customPresetId
    }
  }
  agency {
    ...AgencyFields
  }
}
    ${AgencyUserFieldsFragmentDoc}
${AppliedAgencyProfileFieldsFragmentDoc}
${VisibilityConfigFieldsFragmentDoc}
${AgencyFieldsFragmentDoc}`;
export const PreviewUpdateSubscriptionResultFieldsFragmentDoc = gql`
    fragment PreviewUpdateSubscriptionResultFields on PreviewUpdateSubscriptionResult {
  checkoutUrl
  clientSecret
  invoicePreview {
    lineItems {
      name
      quantity
      unitAmount
      totalAmount
    }
    subTotal
    taxTotal
    discountTotal
    total
    amountPaid
    amountDue
    isNextInvoice
  }
}
    `;
export const AgencySubscriptionUsageFieldsFragmentDoc = gql`
    fragment AgencySubscriptionUsageFields on AgencySubscription {
  agencyId
  platformUnitOverageLimitDollars
  kbPageOverageLimitDollars
  voiceMinuteOverageLimitDollars
  currentUsagePeriod(timezone: $timezone) {
    start
    end
    daysTotal
    daysElapsed
    daysRemaining
    usageCycle
  }
  currentUsageAllowances {
    platformUnits {
      meterCode
      included
      unitLabel
      overageRatePerUnit
    }
    voiceMinutes {
      meterCode
      included
      unitLabel
      overageRatePerUnit
    }
    kbPages {
      meterCode
      included
      unitLabel
      overageRatePerUnit
    }
  }
  currentUsageReport(timezone: $timezone) {
    timezone
    platformUnits {
      meterCode
      used
      daily {
        date
        used
      }
    }
    voiceMinutes {
      meterCode
      used
      daily {
        date
        used
      }
    }
    kbPages {
      meterCode
      used
      daily {
        date
        used
      }
    }
  }
  currentOverageSpendStatus {
    overageUnits
    overageDollars
    equivalentUnitsLimit
    percentOfLimit
    limitReached
    alertThresholdReached
  }
  currentOverageBillEstimate(timezone: $timezone) {
    periodStart
    periodEnd
    estimatedChargeDate
    deliveryMethod
    lineItems {
      meterCode
      overageUnits
      ratePerUnit
      amountDollars
    }
    totalDollars
    isEstimate
  }
}
    `;
export const AgencyUsageFieldsFragmentDoc = gql`
    fragment AgencyUsageFields on Agency {
  id
  users {
    id
    name
    email
    roles
    state
    platformUnitOverageLimitDollars
    currentOverageSpendStatus {
      overageUnits
      overageDollars
      equivalentUnitsLimit
      percentOfLimit
      limitReached
      alertThresholdReached
    }
  }
  subscription {
    ...AgencySubscriptionUsageFields
  }
}
    ${AgencySubscriptionUsageFieldsFragmentDoc}`;
export const AgencyBrandRenderFieldsFragmentDoc = gql`
    fragment AgencyBrandRenderFields on AgencyBrand {
  id
  palette {
    primaryHex
    secondaryHex
    accentHex
    surfaceHex
    textHex
  }
  bodyTypeface
  headingTypeface
  margins {
    enabled
    topIn
    rightIn
    bottomIn
    leftIn
  }
  header {
    enabled
    left
    center
    right
    leftLogo {
      variant
      maxHeightPt
    }
    centerLogo {
      variant
      maxHeightPt
    }
    rightLogo {
      variant
      maxHeightPt
    }
  }
  footer {
    enabled
    left
    center
    right
    leftLogo {
      variant
      maxHeightPt
    }
    centerLogo {
      variant
      maxHeightPt
    }
    rightLogo {
      variant
      maxHeightPt
    }
  }
  logos {
    file {
      id
      url
      name
    }
    variant
  }
  elements {
    element
    fontFamily
    sizePt
    lineHeight
    spaceAbovePt
    spaceBelowPt
    bold
    italic
    colorRole
    fillRole
    linesKeptAtBottom
    linesKeptAtTop
    pageBreakBefore
  }
}
    `;
export const AgencyBrandFieldsFragmentDoc = gql`
    fragment AgencyBrandFields on AgencyBrand {
  ...AgencyBrandRenderFields
  configured
  updatedAt
  voice {
    terminology
    tone
    avoid
  }
}
    ${AgencyBrandRenderFieldsFragmentDoc}`;
export const AgencyDesignPageFieldsFragmentDoc = gql`
    fragment AgencyDesignPageFields on AgencyDesignPage {
  fileId
  printable
  file {
    id
    name
    mimeType
    size
  }
}
    `;
export const AgencyDesignIncludedPagesFieldsFragmentDoc = gql`
    fragment AgencyDesignIncludedPagesFields on AgencyDesignIncludedPages {
  before {
    ...AgencyDesignPageFields
  }
  after {
    ...AgencyDesignPageFields
  }
}
    ${AgencyDesignPageFieldsFragmentDoc}`;
export const AgencyDesignFieldsFragmentDoc = gql`
    fragment AgencyDesignFields on AgencyDesign {
  id
  name
  isDefault
  convertedFromStyle {
    id
    title
  }
  createdBy {
    id
  }
  visibility {
    ...VisibilityConfigFields
  }
  updatedAt
  brand {
    ...AgencyBrandFields
  }
  includedPages {
    ...AgencyDesignIncludedPagesFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}
${AgencyBrandFieldsFragmentDoc}
${AgencyDesignIncludedPagesFieldsFragmentDoc}`;
export const AmsBrowsePageFieldsFragmentDoc = gql`
    fragment AmsBrowsePageFields on AmsBrowsePage {
  nextCursor
  total
}
    `;
export const AmsRefFieldsFragmentDoc = gql`
    fragment AmsRefFields on AmsRef {
  integrationId
  kind
  externalId
  accountExternalId
}
    `;
export const AmsBrowsePolicyFieldsFragmentDoc = gql`
    fragment AmsBrowsePolicyFields on AmsBrowsePolicy {
  ref {
    ...AmsRefFields
  }
  policyNumber
  carrier
  lineOfBusiness
  status
  expirationDate
}
    ${AmsRefFieldsFragmentDoc}`;
export const AmsBrowseAccountFieldsFragmentDoc = gql`
    fragment AmsBrowseAccountFields on AmsBrowseAccount {
  ref {
    ...AmsRefFields
  }
  name
  lookupCode
  email
  phone
  address
}
    ${AmsRefFieldsFragmentDoc}`;
export const AmsAccountSearchResultFieldsFragmentDoc = gql`
    fragment AmsAccountSearchResultFields on KnowledgeGraphEntity {
  id
  externalId
  displayName
  modifiedAt
  searchMetadata {
    account {
      email
      phone
      lookupCode
    }
  }
  integration {
    id
    type
  }
}
    `;
export const AmsFieldVerdictFieldsFragmentDoc = gql`
    fragment AmsFieldVerdictFields on AmsFieldVerdict {
  itemKey
  fieldPath
  fieldLabel
  placement {
    key
    label
    display
    itemDisplay
    record
    matchedOn
    readOnlyReason
  }
  fieldName
  outcome
  comparison
  currentValue
  proposedValue
  sourceQuote
  recommendedAction
  readOnlyReason
  itemReadOnlyReason
  matchedOn
  optionsId
  optionsDependOn
  optionsByValue {
    value
    optionsId
  }
}
    `;
export const AmsCodeListFieldsFragmentDoc = gql`
    fragment AmsCodeListFields on AmsCodeList {
  lookupType
  options {
    code
    label
  }
}
    `;
export const AmsDetectedEntitiesFieldsFragmentDoc = gql`
    fragment AmsDetectedEntitiesFields on AmsDetectedEntities {
  accountName
  accountEmail
  accountPhone
  policyNumber
  generalLiability
  businessAuto
  commercialProperty
  workersCompensation
  personalAuto
  homeowner
  personalUmbrella
  applicant
  contactFirstName
  contactLastName
}
    `;
export const AmsAccountMatchFieldsFragmentDoc = gql`
    fragment AmsAccountMatchFields on AmsAccountMatch {
  integrationId
  externalId
  lookupCode
  accountCode
  displayName
  email
  phone
  reason
  accountId
}
    `;
export const AmsReconciliationTargetFieldsFragmentDoc = gql`
    fragment AmsReconciliationTargetFields on AmsReconciliationTarget {
  id
  lineOfBusiness
  available
  writable
  policyId
  policyGroup {
    id
    label
    detail
  }
  label
  detail
  detectedFromDocument
}
    `;
export const AdminAnalyticsPresetUsageFieldsFragmentDoc = gql`
    fragment AdminAnalyticsPresetUsageFields on AdminAnalyticsPresetUsage {
  key
  label
  isCustomPreset
  customPresetArchived
  workspaceCount
  overTime {
    weekStart
    workspaceCount
  }
  users {
    agencyUserId
    agencyUserName
    agencyUserEmail
    workspaceCount
    lastUsedAt
  }
  withoutUser {
    workspaceCount
    lastUsedAt
  }
}
    `;
export const AdminAnalyticsReportFieldsFragmentDoc = gql`
    fragment AdminAnalyticsReportFields on AdminAnalyticsReport {
  generatedAt
  dateRange {
    after
    before
  }
  totals {
    totalUsers
    activeUsers
    inactiveUsers
    activeDefinition
    totalActivities
    totalWorkspaces
    totalCalls
    totalEmails
    totalKnowledgeBaseUploads
    totalKnowledgeBasePages
    totalPagesReviewed
    totalTemplateReferences
  }
  timeSavings {
    totalMinutes
    breakdown {
      category
      label
      minutes
      activityCount
    }
  }
  incrementalRevenue {
    clientsConsidered
    expectedIncrementalAccounts
    avgCloseLikelihood
    commissionRate
  }
  activityOverTime {
    periodStart
    activityType
    count
  }
  userUsage {
    agencyUserId
    agencyUserName
    agencyUserEmail
    knowledgeBaseUploadCount
  }
  activeUsers {
    agencyUserId
    agencyUserName
    agencyUserEmail
    usedWorkspace
    usedEmail
    createdArtifact
    addedToKnowledgeBase
    loggedIn
    isActive
  }
  workspaceBreakdown {
    label
    preset
    key
    customPreset
    state
    count
    customPresetArchived
  }
  templateBreakdown {
    label
    templateType
    count
  }
  templateLibrary {
    customFormCount
    htmlTemplateCount
    wordTemplateCount
  }
  kbDocumentHistory {
    periodStart
    documentCount
  }
  toolBreakdown {
    toolType
    label
    count
  }
  workspaceStats {
    totalWorkspaces
    avgToolCallsPerWorkspace
    medianToolCallsPerWorkspace
    p90ToolCallsPerWorkspace
    maxToolCallsPerWorkspace
    avgArtifactsPerWorkspace
    medianArtifactsPerWorkspace
    p90ArtifactsPerWorkspace
    maxArtifactsPerWorkspace
    avgPagesPerWorkspace
    medianPagesPerWorkspace
    p90PagesPerWorkspace
    maxPagesPerWorkspace
    toolCallDistribution {
      label
      count
    }
  }
  kbSearchUsage {
    totalSearches
    searcherCount
    perUser {
      agencyUserId
      agencyUserName
      agencyUserEmail
      searchCount
    }
  }
  amsWrites {
    hasIntegration
    recordingStartedAt
    voiceAiExcluded
    succeeded
    failed
    bySource {
      source
      succeeded
    }
    byIntegration {
      integrationType
      succeeded
      failed
    }
    byRecordType {
      recordType
      label
      succeeded
    }
    overTime {
      periodStart
      succeeded
      failed
      recorded
    }
  }
  presetRankings {
    previousPeriod {
      after
      before
    }
    weekCount
    presets {
      rank
      previousRank
      usage {
        ...AdminAnalyticsPresetUsageFields
      }
    }
    noPreset {
      ...AdminAnalyticsPresetUsageFields
    }
  }
  unfilteredSections {
    section
    filters
  }
}
    ${AdminAnalyticsPresetUsageFieldsFragmentDoc}`;
export const AdminAnalyticsExportFieldsFragmentDoc = gql`
    fragment AdminAnalyticsExportFields on AdminAnalyticsExport {
  id
  table
  status
  createdAt
  expiresAt
}
    `;
export const AgencySignInFieldsFragmentDoc = gql`
    fragment AgencySignInFields on AgencySignInResponse {
  agencyUser {
    id
    email
    name
  }
}
    `;
export const BusinessPolicyDetailFieldsFragmentDoc = gql`
    fragment BusinessPolicyDetailFields on BusinessPolicy {
  account {
    contacts {
      ...ContactFields
    }
  }
  agencyUser {
    id
    name
  }
  broker {
    id
    name
  }
  cancellation {
    canceledAt
    canceledBy
    effectiveAt
    type
    reason
    reasonDescription
    returnCommission
    returnPremium
  }
  details {
    blanketAdditionalInsureds {
      type
      description
    }
    carrier {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    coverageDescriptions {
      description
      policyQuotes
      title
    }
    deductible
    exclusionDescriptions {
      description
      policyQuotes
      title
    }
    extraLimits {
      limit
      name
    }
    insured {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    limits {
      cyberAggregateLimit
      cyberRetentionLimit
      glAggregateLimit
      glMedicalPerOccurrenceLimit
      glMedicalPerPersonLimit
      glPerOccurrenceLimit
      glPersonalAndAdvertisingInjuryLimit
      glProductsAndCompletedOperationsLimit
      glRentedPremisesDamageLimit
      propertyBuildingLimit
      propertyContentsLimit
      umbrellaOrExcessAggregateLimit
      umbrellaOrExcessPerOccurrenceLimit
      wcPerAccidentLimit
      wcPerDiseaseEmployeeLimit
      wcPerDiseasePolicyLimit
    }
    locations {
      address {
        line1
        line2
        city
        zone
        postalCode
      }
      limits {
        cyberAggregateLimit
        cyberRetentionLimit
        glAggregateLimit
        glMedicalPerOccurrenceLimit
        glMedicalPerPersonLimit
        glPerOccurrenceLimit
        glPersonalAndAdvertisingInjuryLimit
        glProductsAndCompletedOperationsLimit
        glRentedPremisesDamageLimit
        propertyBuildingLimit
        propertyContentsLimit
        umbrellaOrExcessAggregateLimit
        umbrellaOrExcessPerOccurrenceLimit
        wcPerAccidentLimit
        wcPerDiseaseEmployeeLimit
        wcPerDiseasePolicyLimit
      }
    }
    namedAdditionalInsureds {
      name
      address {
        line1
        line2
        city
        zone
        postalCode
      }
    }
    policyNumber
    summary
  }
  market
  pricing {
    billingType
    premium
    agencyFees
    brokerFees
    policyFees
    otherFees
    taxes
    total
    intervalType
    estimatedCommission
  }
  quoteNumber
  reinstatement {
    reinstatedAt
    effectiveAt
    reasonDescription
  }
  renewal {
    nextPolicies {
      id
    }
    previousPolicies {
      id
    }
  }
}
    ${ContactFieldsFragmentDoc}`;
export const FileFieldsFragmentDoc = gql`
    fragment FileFields on File {
  createdAt
  id
  mimeType
  name
  notes
  type
  url
}
    `;
export const BusinessPolicyFileFieldsFragmentDoc = gql`
    fragment BusinessPolicyFileFields on BusinessPolicy {
  files {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export const InsuranceCarrierFieldsFragmentDoc = gql`
    fragment InsuranceCarrierFields on InsuranceCarrier {
  id
  name
  isCarrier
  isBroker
}
    `;
export const CallReportFieldsFragmentDoc = gql`
    fragment CallReportFields on CallReport {
  dailyCounts {
    date
    totalCalls
    businessHoursCalls
    afterHoursCalls
  }
  hangupCounts {
    total
    underTwentySeconds
  }
  serviceRequestTypeCounts {
    type
    count
  }
}
    `;
export const CaraWorkspaceOverviewFieldsFragmentDoc = gql`
    fragment CaraWorkspaceOverviewFields on CaraWorkspace {
  agencyUser {
    email
    id
    name
  }
  createdAt
  customPreset {
    id
    title
  }
  id
  metadata {
    clientName
    keywords
  }
  integration {
    id
    type
  }
  preset
  state
  title
  triggerRun {
    id
    state
  }
  updatedAt
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const DocumentDesignFitStateFieldsFragmentDoc = gql`
    fragment DocumentDesignFitStateFields on DocumentDesignFitState {
  needsRefit
  refused
  layoutKey
  appearanceKey
}
    `;
export const CaraWorkspaceArtifactFieldsFragmentDoc = gql`
    fragment CaraWorkspaceArtifactFields on CaraWorkspaceArtifact {
  createdAt
  editedAt
  revision
  designFitState {
    ...DocumentDesignFitStateFields
  }
  visibility {
    ...VisibilityConfigFields
  }
  document {
    title
    content
    htmlDocumentTemplateId
    sourceFileId
    brandApplied
    designId
    final {
      includeDesignPages
      markedAt
    }
    resolvedDesign {
      designId
      name
      archived
      hasPages
    }
  }
  pdf {
    title
    externalUrl
    fileId
  }
  customForm {
    title
    customForm {
      id
      title
      status
    }
  }
  templateForm {
    templateId
    title
    label
    editedByAgencyUserId
    editedBy {
      id
      name
      email
    }
    restoredFromVersion
  }
  applicationFile {
    title
    type
    sections {
      title
      file {
        id
        url
      }
    }
  }
  email {
    subject
    bodyHtml
    to {
      name
      email
    }
    cc {
      name
      email
    }
    bcc {
      name
      email
    }
    attachmentArtifactIds
    attachmentFileIds
    attachmentFiles {
      id
      name
      mimeType
      size
      url
    }
    mailboxAccountId
    signatureId
    template {
      templateId
      templateVersion
      placeholderLabels
    }
    source {
      providerMessageId
      messageId
      threadId
      mode
    }
    contentRevision
  }
  id
  type
  version
}
    ${DocumentDesignFitStateFieldsFragmentDoc}
${VisibilityConfigFieldsFragmentDoc}`;
export const FillTemplateToolFieldsFragmentDoc = gql`
    fragment FillTemplateToolFields on FillTemplateTool {
  input {
    templateId
  }
  output {
    artifactId
    version
  }
}
    `;
export const SearchIntegrationFilterLeafFieldsFragmentDoc = gql`
    fragment SearchIntegrationFilterLeafFields on SearchIntegrationFilter {
  negate
  field
  op
  value
  values
}
    `;
export const SearchIntegrationFilterGrandchildFieldsFragmentDoc = gql`
    fragment SearchIntegrationFilterGrandchildFields on SearchIntegrationFilter {
  ...SearchIntegrationFilterLeafFields
  and {
    ...SearchIntegrationFilterLeafFields
  }
  or {
    ...SearchIntegrationFilterLeafFields
  }
}
    ${SearchIntegrationFilterLeafFieldsFragmentDoc}`;
export const SearchIntegrationFilterChildFieldsFragmentDoc = gql`
    fragment SearchIntegrationFilterChildFields on SearchIntegrationFilter {
  ...SearchIntegrationFilterLeafFields
  and {
    ...SearchIntegrationFilterGrandchildFields
  }
  or {
    ...SearchIntegrationFilterGrandchildFields
  }
}
    ${SearchIntegrationFilterLeafFieldsFragmentDoc}
${SearchIntegrationFilterGrandchildFieldsFragmentDoc}`;
export const SearchIntegrationFilterFieldsFragmentDoc = gql`
    fragment SearchIntegrationFilterFields on SearchIntegrationFilter {
  ...SearchIntegrationFilterLeafFields
  and {
    ...SearchIntegrationFilterChildFields
  }
  or {
    ...SearchIntegrationFilterChildFields
  }
}
    ${SearchIntegrationFilterLeafFieldsFragmentDoc}
${SearchIntegrationFilterChildFieldsFragmentDoc}`;
export const ApplicationFileGeneratorToolFieldsFragmentDoc = gql`
    fragment ApplicationFileGeneratorToolFields on ApplicationFileGeneratorTool {
  input {
    fileType
    title
    sourceFileId
    fileId
  }
  output {
    fileId
    version
    success
    error
    stdout
    stderr
    validationPassed
    validationMessage
  }
}
    `;
export const DocxEditorToolFieldsFragmentDoc = gql`
    fragment DocxEditorToolFields on DocxEditorTool {
  input {
    operation
    title
  }
  output {
    artifactId
    version
  }
}
    `;
export const XlsxEditorToolFieldsFragmentDoc = gql`
    fragment XlsxEditorToolFields on XlsxEditorTool {
  input {
    operation
    title
  }
  output {
    artifactId
    version
    tabs {
      templateTabId
      name
      description
    }
  }
}
    `;
export const CodeExecutionToolFieldsFragmentDoc = gql`
    fragment CodeExecutionToolFields on CodeExecutionTool {
  input {
    title
    pythonScript
    sourceFileIds
  }
  output {
    returnCode
    stdout
    stderr
    outputFiles {
      id
      name
      mimeType
      url
    }
    remarks
  }
}
    `;
export const CaraWorkspaceFieldsFragmentDoc = gql`
    fragment CaraWorkspaceFields on CaraWorkspace {
  ...CaraWorkspaceOverviewFields
  artifacts {
    ...CaraWorkspaceArtifactFields
  }
  effortLevel
  effortRaisedReason
  effortRaisedMessageId
  files {
    id
    name
    mimeType
    size
    url
  }
  planStages {
    createdAt
    endedAt
    events {
      content
      endedAt
      error
      id
      startedAt
      title
      toolCall {
        argumentsJson
        name
        result
        type
        invocationSource
        thinkTool {
          input {
            title
            thought
          }
          output {
            success
          }
        }
        completeTaskTool {
          input {
            clientName
            keywords
            needsAgentInput
          }
          output {
            success
          }
        }
        draftEmailTool {
          input {
            operation
            createDraft {
              subject
              bodyHtml
              to {
                name
                email
              }
            }
            createFromTemplate {
              to {
                name
                email
              }
            }
            updateDraft {
              artifactId
              subject
              bodyHtml
              to {
                name
                email
              }
            }
            subject
            bodyHtml
            to {
              name
              email
            }
            artifactId
            body
            toEmail
            toName
          }
          output {
            artifactId
            version
            bodyHtml
          }
        }
        bulkEmailDraftTool {
          input {
            operation
            add {
              bulkSendId
            }
            remove {
              bulkSendId
            }
            fill {
              bulkSendId
            }
          }
          output {
            bulkSendId
            name
            recipients {
              recipientId
            }
          }
        }
        draftOutboundCallTool {
          input {
            artifactId
            customerName
            customerPhone
            callObjective
            customerContext
            guidelines
            leaveVoicemail
            scheduledAt
            timezone
          }
          output {
            artifactId
            outboundCallId
            scheduledAt
          }
        }
        draftDocumentTool {
          input {
            artifactId
            title
            htmlContent
          }
        }
        fileEditorTool {
          input {
            fileId
            operation
            replaceText
            content
            title
            requirements
          }
          output {
            fileId
            version
            content
            remarks
          }
        }
        fillTemplateTool {
          ...FillTemplateToolFields
        }
        pdfEditorTool {
          input {
            inputFiles {
              fileIdOrArtifactId
              fileName
            }
            operation
            formFillInstructions
            formId
            artifactId
            fieldsJson
          }
          output {
            fileId
            artifactId
            version
            result
            forms {
              id
              name
              description
            }
            form {
              id
              name
              description
              instructions
              schema
            }
            artifact {
              id
              version
            }
          }
        }
        searchFileTool {
          input {
            queries {
              fileId
              fileIds
              query
              keywords
            }
          }
          output {
            results {
              fileId
              fileName
              query
              answer
              citations {
                link
              }
            }
          }
        }
        searchKnowledgeBaseTool {
          input {
            userQuery
            queries {
              query
            }
          }
          output {
            answer
            citations {
              link
            }
            documents {
              metadata {
                title
              }
              relevantPages {
                pageIndex
              }
            }
          }
        }
        searchKnowledgeGraphTool {
          input {
            queries {
              query
            }
          }
          output {
            entities {
              type
              displayName
            }
          }
        }
        searchIntegrationTool {
          input {
            find
            where {
              ...SearchIntegrationFilterFields
            }
            bundles
            include {
              relation
              where {
                ...SearchIntegrationFilterFields
              }
              bundles
            }
          }
          output {
            source
            results
            hasMore
            error {
              code
            }
          }
        }
        searchWebTool {
          input {
            queries {
              query
              keywords
            }
          }
          output {
            results {
              query
              answer
              citations {
                url
                title
              }
            }
          }
        }
        writeIntegrationTool {
          input {
            action
            account {
              firstName
              lastName
              businessName
              email
              phone
              address {
                line1
                line2
                city
                zone
                postalCode
              }
            }
            agentName
            uploadDocument {
              source
              description
              note
              id
            }
            createNote {
              title
              body
            }
            createTask {
              title
              description
              dueDate
              assigneeEmail
            }
          }
          output {
            success
            message
          }
        }
        agencyzoomWriteTool {
          input {
            operation
            customer {
              firstName
              lastName
              businessName
              email
              phone
            }
            lead {
              firstName
              lastName
              email
              phone
              businessEntity
            }
            opportunity {
              product
              premium
            }
            policy {
              policyNumber
              insuredName
              premium
              lineOfBusiness
            }
            task {
              title
              comments
              dueDatetime
            }
            contacts {
              firstName
              lastName
              email
              phone
            }
          }
          output {
            success
            message
          }
        }
        hawksoftWriteTool {
          input {
            operation
            logNote {
              firstName
              lastName
              email
              note
              taskTitle
              policyId
            }
            attachment {
              description
              firstName
              lastName
              email
            }
            receipt {
              clientId
              logNote
              payMethod
            }
          }
          output {
            success
            message
          }
        }
        qqcatalystWriteTool {
          input {
            operation
            contact {
              contactId
              firstName
              lastName
              businessName
              dateOfBirth
            }
            file {
              contactId
              fileId
              fileName
              policyId
            }
          }
          output {
            success
            message
            contactId
            fileId
          }
        }
        nowcertsWriteTool {
          input {
            operation
            insured {
              firstName
              lastName
              commercialName
              email
              phone
            }
            prospect {
              firstName
              lastName
              commercialName
              email
              phone
            }
            note {
              subject
              body
            }
            task {
              title
              description
              status
              priority
              dueDate
            }
            policy {
              number
              carrierName
              lineOfBusinessName
              premium
              status
            }
            driver {
              firstName
              lastName
              licenseNumber
            }
            vehicle {
              year
              make
              model
              vin
            }
            claim {
              claimNumber
              descriptionOfLoss
              dateOfLoss
            }
            file {
              fileId
            }
            call {
              fromName
              toName
              type
            }
          }
          output {
            success
            message
          }
        }
        ezlynxWriteTool {
          input {
            operation
            note {
              firstName
              lastName
              title
              body
            }
            call {
              callerName
              fromNumber
              summary
            }
            policy {
              policyNumber
              writingCompany
              lob
              annualPremium
            }
          }
          output {
            success
            message
          }
        }
        ams360WriteTool {
          input {
            operation
            customer {
              firstName
              lastName
              businessName
              email
              phone
            }
            customerContact {
              name
              email
            }
            activity {
              action
              comment
              description
            }
            activityComment {
              comment
            }
            activityAttachment {
              description
            }
            policy {
              policyNo
              policyType
              writingCompanyName
            }
            policyContact {
              name
              email
              title
            }
            suspense {
              description
              dueDate
              assignToEmployeeName
            }
            uploadDocument {
              description
              note
            }
          }
          output {
            success
            message
          }
        }
        applicationFileGeneratorTool {
          ...ApplicationFileGeneratorToolFields
        }
        docxEditorTool {
          ...DocxEditorToolFields
        }
        xlsxEditorTool {
          ...XlsxEditorToolFields
        }
        codeExecutionTool {
          ...CodeExecutionToolFields
        }
      }
      type
    }
    id
    initiatedByMessageId
    platformUnitsUsed
    processAttachmentsDetails {
      progress {
        error
        file {
          name
        }
        progress
      }
    }
    result
    startedAt
    state
    type
  }
  messages {
    content
    id
    role
    timestamp
    useCase
    files {
      id
      name
      mimeType
      url
    }
    followUpOptions {
      generationStartedAt
      generationCompletedAt
      options {
        id
        title
        type
        prompt
      }
    }
    selectedFollowUp {
      id
    }
    amsContext {
      entityId
      entityType
      integrationId
      displayName
    }
    amsRefs {
      ref {
        ...AmsRefFields
      }
      displayName
    }
  }
  schemaVersion
  serviceRequest {
    ...ServiceRequestFields
  }
  integration {
    id
    type
  }
}
    ${CaraWorkspaceOverviewFieldsFragmentDoc}
${CaraWorkspaceArtifactFieldsFragmentDoc}
${FillTemplateToolFieldsFragmentDoc}
${SearchIntegrationFilterFieldsFragmentDoc}
${ApplicationFileGeneratorToolFieldsFragmentDoc}
${DocxEditorToolFieldsFragmentDoc}
${XlsxEditorToolFieldsFragmentDoc}
${CodeExecutionToolFieldsFragmentDoc}
${AmsRefFieldsFragmentDoc}
${ServiceRequestFieldsFragmentDoc}`;
export const CustomPresetFieldsFragmentDoc = gql`
    fragment CustomPresetFields on CustomPreset {
  agency {
    id
    name
  }
  createdAt
  createdBy {
    id
    name
  }
  description
  id
  isOwner
  myAccess {
    role
    createdAt
  }
  state
  title
  updatedAt
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const CustomPresetDetailFieldsFragmentDoc = gql`
    fragment CustomPresetDetailFields on CustomPreset {
  ...CustomPresetFields
  allowFileUpload
  basePrompt
  customForms {
    id
    title
  }
  defaultEffortLevel
  files {
    id
    name
    mimeType
    url
  }
  htmlDocumentTemplates {
    id
    title
  }
  inheritFromPreset
  wordDocumentTemplates {
    id
    title
  }
}
    ${CustomPresetFieldsFragmentDoc}`;
export const CustomPresetAccessFieldsFragmentDoc = gql`
    fragment CustomPresetAccessFields on CustomPresetAccess {
  agency {
    id
    name
  }
  role
  createdAt
  updatedAt
}
    `;
export const HtmlDocumentTemplateFieldsFragmentDoc = gql`
    fragment HtmlDocumentTemplateFields on HtmlDocumentTemplate {
  baseStyleId
  bodyTemplate
  createdBy {
    id
    name
  }
  headerFooter {
    header {
      left {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
      center {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
      right {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
    }
    footer {
      left {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
      center {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
      right {
        text
        image {
          maxHeightPt
          paddingPt
          innerGapPt
          file {
            id
            name
            mimeType
            url
          }
        }
      }
    }
  }
  prefixFiles {
    id
    name
    mimeType
  }
  suffixFiles {
    id
    name
    mimeType
  }
  description
  id
  title
  createdAt
  updatedAt
  style {
    primaryColorHex
    primaryColorLightHex
    secondaryColorHex
    secondaryColorLightHex
    page {
      size
      backgroundColorHex
      margin {
        topIn
        rightIn
        bottomIn
        leftIn
      }
    }
    typography {
      fontFamily
      fontSizePt
      lineHeight
      colorHex
      fontWeight
    }
    elements {
      headings {
        h1 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
        h2 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
        h3 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
        h4 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
        h5 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
        h6 {
          fontSizePt
          fontWeight
          colorHex
          marginTopEm
          marginBottomEm
          fontFamily
          fontStyle
          lineHeight
          pageBreakBefore
        }
      }
      paragraph {
        marginTopEm
        marginBottomEm
        orphans
        widows
        fontFamily
        fontSizePt
        colorHex
        fontWeight
        fontStyle
        lineHeight
        pageBreakBefore
      }
      link {
        colorHex
        textDecoration
      }
      list {
        marginLeftEm
        marginBottomEm
        itemMarginBottomEm
      }
      table {
        widthPct
        borderCollapse
        marginTopEm
        fontSizePt
        headerBackgroundColorHex
        headerColorHex
        headerFontWeight
        cellPaddingEm
        cellBorder
        zebraStripeColorHex
        repeatHeaders
      }
      image {
        maxWidthPct
        heightAuto
        pageBreakInside
      }
      code {
        fontFamily
        fontSizePt
        backgroundColorHex
        colorHex
        paddingEm
        borderRadiusPx
      }
    }
  }
  visibility {
    ...VisibilityConfigFields
  }
  designId
  designSource
  design {
    id
    name
    archived
    includedPages {
      ...AgencyDesignIncludedPagesFields
    }
  }
  startPages
  endPages
  printsOwnHeaderFooter
}
    ${VisibilityConfigFieldsFragmentDoc}
${AgencyDesignIncludedPagesFieldsFragmentDoc}`;
export const WordDocumentTemplateFieldsFragmentDoc = gql`
    fragment WordDocumentTemplateFields on WordDocumentTemplate {
  id
  title
  description
  fillGuidance
  state
  error
  createdAt
  updatedAt
  createdBy {
    id
    name
  }
  templateFile {
    id
    name
    mimeType
    url
  }
  sections {
    id
    title
    setupGuidance
    static
    repeatable
    required
    templateFile {
      id
      name
      url
    }
  }
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const ExcelSpreadsheetTemplateFieldsFragmentDoc = gql`
    fragment ExcelSpreadsheetTemplateFields on ExcelSpreadsheetTemplate {
  id
  title
  description
  fillGuidance
  state
  error
  createdAt
  updatedAt
  createdBy {
    id
    name
  }
  templateFile {
    id
    name
    mimeType
    url
  }
  tabs {
    id
    name
    setupGuidance
    static
    required
    fillGuidance
    fields {
      name
      cell
      label
      fillGuidance
    }
  }
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const CaraWorkspaceArtifactSummaryFieldsFragmentDoc = gql`
    fragment CaraWorkspaceArtifactSummaryFields on CaraWorkspaceArtifactSummary {
  id
  title
  type
  createdAt
  updatedAt
  archivedAt
  metadata {
    clientName
    templateId
    workspaceId
    workspaceUser
    agencyUser {
      id
      name
    }
    workspaceTitle
  }
  versions {
    id
    type
    version
    revision
    createdAt
    visibility {
      ...VisibilityConfigFields
    }
    document {
      title
      htmlDocumentTemplateId
      sourceFileId
      final {
        includeDesignPages
        markedAt
      }
      resolvedDesign {
        designId
        name
        archived
        hasPages
      }
    }
    pdf {
      title
      externalUrl
      fileId
    }
    customForm {
      title
      customForm {
        id
        title
        status
      }
    }
    templateForm {
      templateId
      title
    }
    applicationFile {
      title
      type
    }
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const CaraWorkspaceArtifactSummaryWithContentFieldsFragmentDoc = gql`
    fragment CaraWorkspaceArtifactSummaryWithContentFields on CaraWorkspaceArtifactSummary {
  ...CaraWorkspaceArtifactSummaryFields
  workspace {
    id
    state
  }
  versions {
    designFitState {
      ...DocumentDesignFitStateFields
    }
    document {
      content
    }
  }
}
    ${CaraWorkspaceArtifactSummaryFieldsFragmentDoc}
${DocumentDesignFitStateFieldsFragmentDoc}`;
export const OutboxArtifactFieldsFragmentDoc = gql`
    fragment OutboxArtifactFields on CaraWorkspaceArtifactSummary {
  id
  title
  latestVersion
  composedAt
  metadata {
    workspaceId
  }
  emailMailboxAccountId
  heldBackFromBulkSendId
  heldBackReason
  emailRecipients {
    to {
      name
      email
    }
    cc {
      name
      email
    }
    bcc {
      name
      email
    }
  }
}
    `;
export const TemplateFormFieldStateFieldsFragmentDoc = gql`
    fragment TemplateFormFieldStateFields on TemplateFormFieldState {
  widgetName
  label
  kind
  value
  exportValue
  maxLength
  continuedOn
  provenance
  lastEditedBy {
    id
    name
    email
  }
  lastEditedAt
  suggestion
}
    `;
export const TemplateFormEditorStateFieldsFragmentDoc = gql`
    fragment TemplateFormEditorStateFields on TemplateFormEditorState {
  version
  latestVersion
  editable
  restorable
  printsInAllCaps
  fields {
    ...TemplateFormFieldStateFields
  }
  pages {
    sheet
  }
}
    ${TemplateFormFieldStateFieldsFragmentDoc}`;
export const CaraWorkspaceArtifactCommentFieldsFragmentDoc = gql`
    fragment CaraWorkspaceArtifactCommentFields on CaraWorkspaceArtifactComment {
  id
  workspaceId
  artifactId
  anchor {
    quote
    prefix
    suffix
    occurrence
    occurrenceCount
  }
  body
  createdAt
  resolvedAt
  resolvedBy
  region {
    page
    left
    top
    width
    height
    nearby
    pageWidthPt
    pageHeightPt
    version
    revision
    styleId
  }
  placement {
    tier
    matchedText
    occurrence
  }
}
    `;
export const MergeCandidateSideFragmentDoc = gql`
    fragment MergeCandidateSide on Client {
  id
  name
  email
  phone
  isCommercial
  isPersonal
  createdAt
  associationCounts {
    workspaces
    amsAccounts
    notes
  }
}
    `;
export const ClientFieldsFragmentDoc = gql`
    fragment ClientFields on Client {
  id
  name
  phone
  email
  address {
    line1
    line2
    city
    subZone
    zone
    postalCode
  }
  isCommercial
  isPersonal
  agencyUserOwner {
    id
    name
  }
  createdAt
  updatedAt
}
    `;
export const ClientMergeSideFragmentDoc = gql`
    fragment ClientMergeSide on Client {
  ...ClientFields
  associationCounts {
    workspaces
    amsAccounts
    notes
  }
}
    ${ClientFieldsFragmentDoc}`;
export const ClientNoteFieldsFragmentDoc = gql`
    fragment ClientNoteFields on ClientNote {
  id
  body
  createdAt
  updatedAt
  author {
    id
    name
    email
  }
}
    `;
export const ClientListFieldsFragmentDoc = gql`
    fragment ClientListFields on Client {
  ...ClientFields
  amsAccounts {
    integrationId
    integrationType
    isPrimary
  }
  latestWorkspace {
    id
    title
    updatedAt
  }
}
    ${ClientFieldsFragmentDoc}`;
export const ClientAmsAccountFieldsFragmentDoc = gql`
    fragment ClientAmsAccountFields on ClientAmsAccount {
  integrationId
  integrationType
  amsExternalId
  isPrimary
  account {
    id
    displayName
  }
}
    `;
export const ClientFieldProvenanceFieldsFragmentDoc = gql`
    fragment ClientFieldProvenanceFields on ClientFieldProvenance {
  id
  field
  source
  value
  integrationType
  sourceUpdatedBy
  confirmedBy {
    id
    name
    email
  }
  recordedAt
}
    `;
export const ClientArtifactFieldsFragmentDoc = gql`
    fragment ClientArtifactFields on CaraWorkspaceArtifactSummary {
  id
  title
  type
  latestVersion
  createdAt
  versions {
    id
    version
    document {
      final {
        markedAt
      }
    }
  }
  workspace {
    id
    title
  }
  metadata {
    workspaceId
    agencyUser {
      id
      name
    }
  }
}
    `;
export const ClientFileFieldsFragmentDoc = gql`
    fragment ClientFileFields on File {
  id
  name
  mimeType
  size
  type
  url
  createdAt
}
    `;
export const CustomFormListFieldsFragmentDoc = gql`
    fragment CustomFormListFields on CustomForm {
  id
  title
  status
  error
  templateFile {
    id
    name
  }
  basePrompt
  fillPrompt
  ingestionGuidance
  createdBy {
    ...AgencyUserFields
  }
  createdAt
  updatedAt
  version
  archivedAt
  visibility {
    ...VisibilityConfigFields
  }
}
    ${AgencyUserFieldsFragmentDoc}
${VisibilityConfigFieldsFragmentDoc}`;
export const CustomFormFieldsFragmentDoc = gql`
    fragment CustomFormFields on CustomForm {
  id
  title
  status
  error
  templateFile {
    id
    name
  }
  basePrompt
  fillPrompt
  ingestionGuidance
  createdBy {
    ...AgencyUserFields
  }
  createdAt
  updatedAt
  version
  archivedAt
  visibility {
    ...VisibilityConfigFields
  }
}
    ${AgencyUserFieldsFragmentDoc}
${VisibilityConfigFieldsFragmentDoc}`;
export const EmailAmsChoiceFieldsFragmentDoc = gql`
    fragment EmailAmsChoiceFields on EmailAmsChoice {
  filingTarget {
    folder {
      ...AmsRefFields
    }
    folderDisplayName
    ref {
      ...AmsRefFields
    }
    displayName
  }
  target {
    ...AmsRefFields
  }
  displayName
}
    ${AmsRefFieldsFragmentDoc}`;
export const EmailAmsMatchFieldsFragmentDoc = gql`
    fragment EmailAmsMatchFields on EmailAmsMatch {
  integrationId
  integrationType
  filingKinds
  isSupported
  outcome
  candidates {
    accountEntityId
    displayName
    account {
      ...AmsRefFields
    }
    matchedAddresses {
      address
    }
  }
  choice {
    ...EmailAmsChoiceFields
  }
}
    ${AmsRefFieldsFragmentDoc}
${EmailAmsChoiceFieldsFragmentDoc}`;
export const OutboundEmailAmsLogFieldsFragmentDoc = gql`
    fragment OutboundEmailAmsLogFields on OutboundEmailAmsLog {
  status
  integrationType
  accountDisplayName
  loggedAt
  notLoggedReason
  failureMessage
  canPush
}
    `;
export const EmailBulkSendSummaryFieldsFragmentDoc = gql`
    fragment EmailBulkSendSummaryFields on EmailBulkSend {
  id
  name
  action
  mailboxAccountId
  fromAddress
  sentAt
  firstSendAt
  cancelledAt
  isWaitingForMailbox
  sentBy {
    id
    name
  }
  progress {
    total
    sending
    sent
    failed
    cancelled
    inDrafts
    heldBack
    notSent
  }
  outsideBatchProgress {
    total
    sent
    failed
    cancelled
    inDrafts
  }
  roundProgress {
    total
    sending
    sent
    failed
    cancelled
    inDrafts
  }
  cancelReturnsToDraft
  canChangeTime
}
    `;
export const EmailBulkSendListFieldsFragmentDoc = gql`
    fragment EmailBulkSendListFields on EmailBulkSend {
  ...EmailBulkSendSummaryFields
  createdAt
  recipients {
    id
    artifactId
    draftState
  }
  draftProgress {
    total
    finished
  }
}
    ${EmailBulkSendSummaryFieldsFragmentDoc}`;
export const EmailBulkSendRecipientFieldsFragmentDoc = gql`
    fragment EmailBulkSendRecipientFields on EmailBulkSendRecipient {
  id
  email
  name
  amsAccountId
  artifactId
  draftState
  heldBackReason
}
    `;
export const EmailBulkDraftFieldsFragmentDoc = gql`
    fragment EmailBulkDraftFields on EmailBulkSend {
  id
  name
  workspaceId
  sentAt
  recipients {
    ...EmailBulkSendRecipientFields
  }
  draftProgress {
    total
    finished
  }
}
    ${EmailBulkSendRecipientFieldsFragmentDoc}`;
export const EmailTemplateListFieldsFragmentDoc = gql`
    fragment EmailTemplateListFields on EmailTemplate {
  id
  name
  subject
  updatedAt
  updatedBy {
    id
    name
  }
  usageLast30Days
  canEdit
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const EmailTemplateEditorFieldsFragmentDoc = gql`
    fragment EmailTemplateEditorFields on EmailTemplate {
  id
  name
  whenToUse
  subject
  bodyHtml
  guidelines
  version
  archivedAt
  updatedAt
  updatedBy {
    id
    name
  }
  createdBy {
    id
    name
  }
  canEdit
  visibility {
    ...VisibilityConfigFields
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;
export const FeedbackFieldsFragmentDoc = gql`
    fragment FeedbackFields on Feedback {
  id
  scope
  agency {
    id
  }
  agencyUser {
    id
  }
  workspace {
    id
  }
  message {
    id
  }
  call {
    id
  }
  rating
  comment
  feedback {
    message {
      reasons
    }
    call {
      reasons
    }
  }
  createdAt
  updatedAt
  deletedAt
}
    `;
export const SearchFileResultFieldsFragmentDoc = gql`
    fragment SearchFileResultFields on SearchFileResult {
  id
  name
  integration {
    id
    type
  }
}
    `;
export const ImportSchemaFieldsFragmentDoc = gql`
    fragment ImportSchemaFields on ImportSchema {
  keyColumns
  tieBreaker
  columns {
    key
    label
    type
    required
    multiple
    compareLiterally
    fixedOnceAdded
    addOnly
    enumValues
    optionsFrom
  }
}
    `;
export const IntegrationFieldsFragmentDoc = gql`
    fragment IntegrationFields on Integration {
  id
  type
  state
  createdAt
  updatedAt
  logsSentEmails
}
    `;
export const EmailAmsLogPreferenceFieldsFragmentDoc = gql`
    fragment EmailAmsLogPreferenceFields on EmailAmsLogPreference {
  destination
  activityCode
  companyCode
  assignToEmployeeCode
  assignedByEmployeeCode
}
    `;
export const IntegrationSyncLogFieldsFragmentDoc = gql`
    fragment IntegrationSyncLogFields on IntegrationSyncLog {
  completedAt
  entitiesSynced
  id
  initiatorType
  initiatorId
  lastError
  startedAt
  state
  type
}
    `;
export const IntegrationDetailFieldsFragmentDoc = gql`
    fragment IntegrationDetailFields on Integration {
  ...IntegrationFields
  lastSyncedAt
  canLogSentEmails
  cannotLogSentEmailsReason
  emailLogDestinations
  emailLogPreference {
    ...EmailAmsLogPreferenceFields
  }
  configuration {
    hawksoft {
      agencyId
      enableSyncCallNotes
      enableSyncServiceRequests
    }
    nowcerts {
      username
      enableSyncAccounts
      enableSyncTasks
      enableSyncCalls
      prospectReferralSource
    }
    hubspot {
      accessToken
      enableSyncTasks
      taskSyncType
      taskPipelineId
      taskStageId
      enableSyncAccounts
      enableSyncCalls
      callSyncType
      callPipelineId
      callStageId
      callFieldMappings {
        ticketFields {
          hubspotField
          caraField
        }
        dealFields {
          hubspotField
          caraField
        }
      }
      taskFieldMappings {
        ticketFields {
          hubspotField
          caraField
        }
        dealFields {
          hubspotField
          caraField
        }
      }
    }
    zapier {
      apiKey
    }
    agencyZoom {
      username
      isSSOLogin
      enableSyncAccounts
      enableSyncTasks
    }
    ams360 {
      appKey
      agencyNo
      appAccessToAgencyKey
      enableSyncAccounts
      enableSyncCalls
      enableSyncTasks
      taskAssignmentMethod
      defaultTaskDueBusinessDays
    }
    ezlynx {
      clientId
      username
      integrationGroupId
      csvImportOnly
    }
    appliedEpic {
      type
      sdkCredentials {
        baseUrl
        databaseName
      }
    }
    imageRight {
      serverUrl
      username
    }
    qqcatalyst {
      defaultLocationId
      enableSyncAccounts
      enableSyncTasks
      enableSyncCalls
      taskAssignment
      taskAssignmentEmployeeId
      locations {
        locationId
        locationName
        isDefault
      }
      employees {
        employeeId
        displayName
      }
      categoryCounts {
        category
        count
      }
    }
  }
  syncLogs(type: READ) {
    ...IntegrationSyncLogFields
  }
}
    ${IntegrationFieldsFragmentDoc}
${EmailAmsLogPreferenceFieldsFragmentDoc}
${IntegrationSyncLogFieldsFragmentDoc}`;
export const KnowledgeBaseFolderFieldsFragmentDoc = gql`
    fragment KnowledgeBaseFolderFields on KnowledgeBaseFolder {
  id
  name
  parentFolderId
  createdAt
  updatedAt
}
    `;
export const KnowledgeBaseFieldsFragmentDoc = gql`
    fragment KnowledgeBaseFields on KnowledgeBase {
  id
  title
  version
  guidedRetrievalEnabled
  folders {
    ...KnowledgeBaseFolderFields
  }
  createdAt
  updatedAt
  isOwner
  myAccess {
    role
    createdAt
  }
  ownerAgency {
    id
    name
  }
}
    ${KnowledgeBaseFolderFieldsFragmentDoc}`;
export const KnowledgeBaseListFieldsFragmentDoc = gql`
    fragment KnowledgeBaseListFields on KnowledgeBase {
  ...KnowledgeBaseFields
  documents {
    id
  }
}
    ${KnowledgeBaseFieldsFragmentDoc}`;
export const KnowledgeBaseAccessFieldsFragmentDoc = gql`
    fragment KnowledgeBaseAccessFields on KnowledgeBaseAccess {
  agency {
    id
    name
  }
  role
  createdAt
  updatedAt
}
    `;
export const KnowledgeBaseDocumentUrlSourceFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDocumentURLSourceFields on KnowledgeBaseDocumentURLSource {
  url
  sourceType
  frequency
  isPaused
}
    `;
export const KnowledgeBaseDocumentFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDocumentFields on KnowledgeBaseDocument {
  id
  title
  displayName
  type
  createdAt
  updatedAt
  documentGroupId
  versionNumber
  folderId
  exampleQuestions
  contextNote
  createdBy {
    name
  }
  indexingStatus {
    status
    error
    progress
    startedAt
    completedAt
  }
  file {
    mimeType
    name
    size
    url
  }
  metadata {
    title
    summary
    purpose
    keywords
  }
  text {
    content
  }
  urlSource {
    ...KnowledgeBaseDocumentURLSourceFields
  }
  urlSyncStatus
  urlLastSyncedAt
  urlLastSyncError
}
    ${KnowledgeBaseDocumentUrlSourceFieldsFragmentDoc}`;
export const KnowledgeBaseDetailFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDetailFields on KnowledgeBase {
  ...KnowledgeBaseFields
  accessList {
    ...KnowledgeBaseAccessFields
  }
  documents {
    ...KnowledgeBaseDocumentFields
  }
}
    ${KnowledgeBaseFieldsFragmentDoc}
${KnowledgeBaseAccessFieldsFragmentDoc}
${KnowledgeBaseDocumentFieldsFragmentDoc}`;
export const KnowledgeBaseDocumentVersionFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDocumentVersionFields on KnowledgeBaseDocument {
  id
  versionNumber
  createdAt
  createdBy {
    name
  }
  file {
    url
  }
}
    `;
export const KnowledgeBaseDocumentDetailFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDocumentDetailFields on KnowledgeBaseDocument {
  ...KnowledgeBaseDocumentFields
  file {
    mimeType
    name
    size
    url
  }
  text {
    content
  }
}
    ${KnowledgeBaseDocumentFieldsFragmentDoc}`;
export const KnowledgeBaseDocumentSearchFieldsFragmentDoc = gql`
    fragment KnowledgeBaseDocumentSearchFields on KnowledgeBaseDocument {
  id
  title
  displayName
  updatedAt
  metadata {
    title
    keywords
  }
}
    `;
export const FederatedChildAgencyFieldsFragmentDoc = gql`
    fragment FederatedChildAgencyFields on Agency {
  id
  name
}
    `;
export const MailboxMonitoringFieldsFragmentDoc = gql`
    fragment MailboxMonitoringFields on MailboxAccount {
  id
  monitoring {
    maxMonitoredFolders
    enabled
    processUpdates
    processDeletes
    active
    expiresAt
    recovering
    problem
    problemKind
    notes {
      code
    }
    folders {
      id
      name
      missing
    }
  }
}
    `;
export const MailboxSharingFieldsFragmentDoc = gql`
    fragment MailboxSharingFields on MailboxAccount {
  id
  owner {
    agencyUserId
  }
  visibility {
    level
    userIds
    teamIds
  }
}
    `;
export const MailboxAccountFieldsFragmentDoc = gql`
    fragment MailboxAccountFields on MailboxAccount {
  id
  provider
  status
  isDefault
  identity {
    email
    displayName
  }
}
    `;
export const OutboundEmailAddressFieldsFragmentDoc = gql`
    fragment OutboundEmailAddressFields on OutboundEmailAddress {
  name
  email
}
    `;
export const OutboundEmailFieldsFragmentDoc = gql`
    fragment OutboundEmailFields on OutboundEmail {
  id
  status
  bulkSendId
  sendAfter
  scheduledFor
  mailboxAccountId
  fromAddress
  to {
    ...OutboundEmailAddressFields
  }
  cc {
    ...OutboundEmailAddressFields
  }
  bcc {
    ...OutboundEmailAddressFields
  }
  subject
  attachments {
    name
  }
  workspaceId
  workspaceArtifactId
  artifactVersion
  sentByUserId
  sentBy {
    id
    name
  }
  sentAt
  sentExternally
  failureReason
  failureKind
  sendUnconfirmed
  createdAt
  updatedAt
}
    ${OutboundEmailAddressFieldsFragmentDoc}`;
export const MailboxDraftFieldsFragmentDoc = gql`
    fragment MailboxDraftFields on MailboxDraft {
  id
  mailboxAccountId
  fromAddress
  webLink
  subject
  createdByUserId
  workspaceId
  workspaceArtifactId
  artifactVersion
  syncState
  externallyEdited
  externalEditsCheckedAt
  sentViaCaraAt
  retiredAt
  retiredReason
  createdAt
}
    `;
export const MailboxSignatureFieldsFragmentDoc = gql`
    fragment MailboxSignatureFields on MailboxSignature {
  id
  name
  bodyHtml
  isDefault
}
    `;
export const MailboxSignatureSettingsFieldsFragmentDoc = gql`
    fragment MailboxSignatureSettingsFields on MailboxSignature {
  ...MailboxSignatureFields
  owner {
    agencyUserId
  }
  visibility {
    level
    userIds
    teamIds
  }
}
    ${MailboxSignatureFieldsFragmentDoc}`;
export const MemoryListFieldsFragmentDoc = gql`
    fragment MemoryListFields on Memory {
  id
  scope
  type
  category
  surface
  content
  sticky
  createdAt
}
    `;
export const MemoryDetailFieldsFragmentDoc = gql`
    fragment MemoryDetailFields on Memory {
  ...MemoryListFields
  keywords
  accessCount
  lastAccessedAt
  updatedAt
}
    ${MemoryListFieldsFragmentDoc}`;
export const OutboundCallReportFieldsFragmentDoc = gql`
    fragment OutboundCallReportFields on OutboundCallReport {
  totalCalls
  statusCounts {
    status
    count
  }
  dailyCounts {
    date
    totalCalls
    completed
    failed
    scheduled
  }
  voicemailEnabledCount
}
    `;
export const OutboundCallRefreshFieldsFragmentDoc = gql`
    fragment OutboundCallRefreshFields on OutboundCall {
  id
  status
  schedule {
    scheduledAt
  }
}
    `;
export const OutboundCallFieldsFragmentDoc = gql`
    fragment OutboundCallFields on OutboundCall {
  id
  status
  customer {
    name
    phone
  }
  schedule {
    scheduledAt
    timezone
  }
  callConfig {
    callObjective
    customerContext
    guidelines
    callbackPhone
    leaveVoicemail
    fileIds
  }
  voiceAgent {
    id
    name
  }
  createdBy {
    ...AgencyUserFields
  }
  latestCall {
    id
    seenAt
  }
  createdAt
  updatedAt
}
    ${AgencyUserFieldsFragmentDoc}`;
export const CallFieldsFragmentDoc = gql`
    fragment CallFields on Call {
  id
  account {
    id
    account {
      name
    }
  }
  disconnectionReason
  endedAt
  fromName
  fromNumber
  seenAt
  sentiment
  startedAt
  status
}
    `;
export const CallTranscriptFieldsFragmentDoc = gql`
    fragment CallTranscriptFields on Call {
  recordingUrl
  sentiment
  serviceRequests {
    ...ServiceRequestFields
  }
  successful
  summary
  transcript {
    content
    durationSeconds
    role
    startTimeOffsetSeconds
    toolCallId
    toolName
    toolArgumentsJson
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export const OutboundCallAttemptFieldsFragmentDoc = gql`
    fragment OutboundCallAttemptFields on Call {
  ...CallFields
  ...CallTranscriptFields
}
    ${CallFieldsFragmentDoc}
${CallTranscriptFieldsFragmentDoc}`;
export const OutboundCallDetailFieldsFragmentDoc = gql`
    fragment OutboundCallDetailFields on OutboundCall {
  ...OutboundCallFields
  calls {
    ...OutboundCallAttemptFields
  }
  latestCall {
    ...OutboundCallAttemptFields
  }
}
    ${OutboundCallFieldsFragmentDoc}
${OutboundCallAttemptFieldsFragmentDoc}`;
export const PresetGenerationProgressFieldsFragmentDoc = gql`
    fragment PresetGenerationProgressFields on CustomPreset {
  id
  state
  generation {
    step
    error
  }
}
    `;
export const PresetClarifyingQuestionFieldsFragmentDoc = gql`
    fragment PresetClarifyingQuestionFields on PresetClarifyingQuestion {
  id
  question
  options
  allowFreeText
}
    `;
export const EmailThreadFieldsFragmentDoc = gql`
    fragment EmailThreadFields on EmailThread {
  account {
    id
    account {
      name
    }
  }
  fromEmail
  fromName
  id
  state
  subject
  waitingFor
  createdAt
  updatedAt
}
    `;
export const EmailFieldsFragmentDoc = gql`
    fragment EmailFields on Email {
  body
  from {
    name
    email
  }
  id
  senderRole
  sentAt
  subject
  to {
    name
    email
  }
}
    `;
export const EmailThreadConversationFieldsFragmentDoc = gql`
    fragment EmailThreadConversationFields on EmailThread {
  attachments {
    id
    name
    url
  }
  participantEmails {
    ...EmailFields
  }
  serviceRequests {
    ...ServiceRequestFields
  }
  summary
  workspace {
    id
    title
    state
  }
}
    ${EmailFieldsFragmentDoc}
${ServiceRequestFieldsFragmentDoc}`;
export const ServiceRequestCallFieldsFragmentDoc = gql`
    fragment ServiceRequestCallFields on ServiceRequest {
  calls {
    ...CallFields
    ...CallTranscriptFields
  }
  comments {
    id
    content
    agencyUser {
      name
    }
    createdAt
  }
  emailThreads {
    ...EmailThreadFields
    ...EmailThreadConversationFields
  }
  versionHistory {
    createdAt
    version
    updateTypes
    updateInitiatorType
    updateInitiatorId
    serviceRequest {
      assignee {
        id
        name
      }
      resolution {
        notes
      }
      dueAt
    }
  }
}
    ${CallFieldsFragmentDoc}
${CallTranscriptFieldsFragmentDoc}
${EmailThreadFieldsFragmentDoc}
${EmailThreadConversationFieldsFragmentDoc}`;
export const SmartFillFormBucketFieldsFragmentDoc = gql`
    fragment SmartFillFormBucketFields on SmartFillFormBucket {
  bucket {
    id
    name
    revision
    updatedAt
  }
  workspaceId
  workspaceTitle
  profileId
  lineOfBusiness
  forms {
    artifactId
    title
    version
  }
  builtAt
  carrierSiteId
  answerCount
}
    `;
export const SmartFillCarrierSiteFieldsFragmentDoc = gql`
    fragment SmartFillCarrierSiteFields on SmartFillCarrierSite {
  id
  carrier
  product
  host
  questionCount
}
    `;
export const SmartFillFormQuestionFieldsFragmentDoc = gql`
    fragment SmartFillFormQuestionFields on SmartFillFormQuestion {
  ownerType
  relationPath
  semanticKey
  question
  section
  label
  fieldType
  options
  kind
  answers {
    recordIndex
    recordLabel
    recordExists
    value
    source
  }
}
    `;
export const SmartFillFormBucketQuestionsFieldsFragmentDoc = gql`
    fragment SmartFillFormBucketQuestionsFields on SmartFillFormBucketQuestions {
  formBucket {
    ...SmartFillFormBucketFields
  }
  site {
    ...SmartFillCarrierSiteFields
  }
  revision
  answeredCount
  questions {
    ...SmartFillFormQuestionFields
  }
}
    ${SmartFillFormBucketFieldsFragmentDoc}
${SmartFillCarrierSiteFieldsFragmentDoc}
${SmartFillFormQuestionFieldsFragmentDoc}`;
export const TeamFieldsFragmentDoc = gql`
    fragment TeamFields on Team {
  id
  name
  description
  memberCount
  createdAt
  updatedAt
  archivedAt
  createdBy {
    id
    name
    email
  }
  members {
    addedAt
    user {
      id
      name
      email
    }
  }
}
    `;
export const TeamSummaryFieldsFragmentDoc = gql`
    fragment TeamSummaryFields on Team {
  id
  name
}
    `;
export const TriggerEmailTextMatchFieldsFragmentDoc = gql`
    fragment TriggerEmailTextMatchFields on TriggerEmailTextMatch {
  operator
  values
  valueMode
  caseSensitive
}
    `;
export const TriggerEmailAddressMatchFieldsFragmentDoc = gql`
    fragment TriggerEmailAddressMatchFields on TriggerEmailAddressMatch {
  kind
  values
  valueMode
  includeSubdomains
}
    `;
export const TriggerEmailRuleFieldsFragmentDoc = gql`
    fragment TriggerEmailRuleFields on TriggerEmailRule {
  id
  kind
  phrase {
    field
    match {
      ...TriggerEmailTextMatchFields
    }
  }
  sender {
    ...TriggerEmailAddressMatchFields
  }
  recipient {
    field
    match {
      ...TriggerEmailAddressMatchFields
    }
  }
  time {
    operator
    minute
    endMinute
    weekdays
  }
  attachment {
    minimumCount
    maximumCount
    name {
      ...TriggerEmailTextMatchFields
    }
    mimeTypes
    extensions
    minimumBytes
    maximumBytes
  }
  prompt {
    prompt
  }
}
    ${TriggerEmailTextMatchFieldsFragmentDoc}
${TriggerEmailAddressMatchFieldsFragmentDoc}`;
export const TriggerEmailRuleLevel8FragmentDoc = gql`
    fragment TriggerEmailRuleLevel8 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    id
    kind
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}`;
export const TriggerEmailRuleLevel7FragmentDoc = gql`
    fragment TriggerEmailRuleLevel7 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel8
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel8FragmentDoc}`;
export const TriggerEmailRuleLevel6FragmentDoc = gql`
    fragment TriggerEmailRuleLevel6 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel7
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel7FragmentDoc}`;
export const TriggerEmailRuleLevel5FragmentDoc = gql`
    fragment TriggerEmailRuleLevel5 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel6
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel6FragmentDoc}`;
export const TriggerEmailRuleLevel4FragmentDoc = gql`
    fragment TriggerEmailRuleLevel4 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel5
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel5FragmentDoc}`;
export const TriggerEmailRuleLevel3FragmentDoc = gql`
    fragment TriggerEmailRuleLevel3 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel4
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel4FragmentDoc}`;
export const TriggerEmailRuleLevel2FragmentDoc = gql`
    fragment TriggerEmailRuleLevel2 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel3
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel3FragmentDoc}`;
export const TriggerEmailRuleLevel1FragmentDoc = gql`
    fragment TriggerEmailRuleLevel1 on TriggerEmailRule {
  ...TriggerEmailRuleFields
  children {
    ...TriggerEmailRuleLevel2
  }
}
    ${TriggerEmailRuleFieldsFragmentDoc}
${TriggerEmailRuleLevel2FragmentDoc}`;
export const TriggerEmailConfigFieldsFragmentDoc = gql`
    fragment TriggerEmailConfigFields on TriggerEmailConfig {
  schemaVersion
  scope {
    mode
    accounts {
      accountId
      folders {
        ids
        allFolders
        includeJunkAndDeleted
      }
    }
    folders {
      standard
      paths
      allFolders
      includeJunkAndDeleted
    }
  }
  arrivals
  privacy
  timezone
  rule {
    ...TriggerEmailRuleLevel1
  }
}
    ${TriggerEmailRuleLevel1FragmentDoc}`;
export const TriggerDefinitionFieldsFragmentDoc = gql`
    fragment TriggerDefinitionFields on TriggerDefinition {
  id
  version
  name
  status
  eventMatcher {
    eventType
    caraAddressConfig {
      emailSuffix
      subjectContains
      senderDomain
      hasAttachments
    }
    mailboxConfig {
      integrationId
      folder
      subjectContains
      senderDomain
      hasAttachments
    }
    emailConfig {
      ...TriggerEmailConfigFields
    }
    scheduleConfig {
      cron
      timezone
      catchUpHours
    }
    callAnalyzedConfig {
      callType
      routing
      minimumDurationSeconds
    }
  }
  target {
    type
    presetId
    preset
    useCase
    prompt
  }
  visibility {
    ...VisibilityConfigFields
  }
  createdAt
  updatedAt
  archivedAt
}
    ${TriggerEmailConfigFieldsFragmentDoc}
${VisibilityConfigFieldsFragmentDoc}`;
export const TriggerEventListFieldsFragmentDoc = gql`
    fragment TriggerEventListFields on TriggerEvent {
  id
  eventType
  sourceType
  sourceInstanceId
  sourceEventId
  state
  occurredAt
  receivedAt
  evaluatedAt
  payload
  error {
    code
    message
  }
  runs {
    id
    state
    executionId
    triggerDefinition {
      id
      name
    }
  }
}
    `;
export const TriggerEventDetailFieldsFragmentDoc = gql`
    fragment TriggerEventDetailFields on TriggerEvent {
  ...TriggerEventListFields
  evaluationSummary {
    candidateCount
    reasonCounts
  }
  runs {
    id
    triggerDefinition {
      id
      name
    }
    triggerDefinitionVersion
    state
    queueReason
    attemptCount
    targetType
    executionType
    executionId
    queuedAt
    dispatchStartedAt
    dispatchedAt
    error {
      code
      message
    }
  }
  auditLogs {
    id
    triggerRunId
    type
    level
    message
    details
    createdAt
  }
}
    ${TriggerEventListFieldsFragmentDoc}`;
export const OutboundVoiceComplianceDisclosureFieldsFragmentDoc = gql`
    fragment OutboundVoiceComplianceDisclosureFields on OutboundVoiceComplianceDisclosure {
  version
  title
  intro
  sections {
    heading
    body
  }
  acknowledgmentLabel
}
    `;
export const VoiceAgentOverviewFieldsFragmentDoc = gql`
    fragment VoiceAgentOverviewFields on VoiceAgent {
  id
  name
  phoneNumber
  state
  direction
  createdAt
  updatedAt
  agency {
    id
    name
    phone
  }
  configuration {
    agency {
      phone
    }
  }
}
    `;
export const VoiceAgentConfigurationFieldsFragmentDoc = gql`
    fragment VoiceAgentConfigurationFields on VoiceAgentConfiguration {
  agentName
  globalCustomInstructions
  introPhrase
  languages
  agency {
    address
    businessHours
    email
    name
    phone
    website
  }
  callBehavior {
    rapportBuilding
    referencePolicyInfo
    repeatCriticalInfo
    requiredContactInfo
    customRequiredContactInfo
    startSpeaker
    beginAfterUserSilenceMs
  }
  model {
    responsiveness
    enableDynamicResponsiveness
    voice
    voiceSpeed
    enableDynamicVoiceSpeed
    voiceTemperature
    voiceVolume
  }
  notifications {
    staticEmails
    enableDynamicEmailRoutingToAgencyUsers
    dynamicEmailRoutingCustomInstructions
  }
  accountLookup {
    enabled
    includedDataTypes
  }
  taskBehavior {
    businessLines
    coi {
      enabled
      customInstructions
    }
    fnol {
      enabled
      customInstructions
      auto {
        questions
        customQuestions
      }
      commercialLiability {
        questions
        customQuestions
      }
      commercialProperty {
        questions
        customQuestions
      }
      workersCompensation {
        questions
        customQuestions
      }
    }
    lpr {
      enabled
      customInstructions
    }
    quote {
      enabled
      qualification {
        questions
        customQuestions
      }
      commercialCommon {
        questions
        customQuestions
      }
      commercialLiability {
        questions
        customQuestions
      }
      commercialProperty {
        questions
        customQuestions
      }
      auto {
        questions
        customQuestions
      }
      workersCompensation {
        questions
        customQuestions
      }
      custom {
        lineOfBusiness
        questions
      }
    }
    service {
      enabled
      other
      addDriver {
        questions
        customQuestions
      }
      addLocation {
        questions
        customQuestions
      }
      addVehicle {
        questions
        customQuestions
      }
    }
  }
  transfer {
    behavior
    collectPurpose
    lineOfBusinessCatalog {
      id
      label
      description
      examples
    }
    enabled
    fallbackAttempts
    warmTransfer
    transferType
    transferMessage
    useNewColdTransferConversationFlow
    ringDurationMs
    transferBehaviorQuote
    transferBehaviorFnol
    transferBehaviorCoi
    transferBehaviorService
    transferBehaviorCancellation
    sipTransferMode
    enableExternalTransfer
    externalTransferBehavior
    externalTransferAllowInternalFallback
    externalTransferCallTypes
    directory {
      label
      name
      department
      number
      transferCriteria
      extension
      entryType
      callTypes
      lineOfBusinessIds
      aliases
      servicingCode
    }
    hours {
      timezone
      monday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      tuesday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      wednesday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      thursday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      friday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      saturday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
      sunday {
        enabled
        startHour
        startMinute
        endHour
        endMinute
      }
    }
    timeOffSchedules {
      id
      type
      name
      dailyBreak {
        daysOfWeek
        startHour
        startMinute
        endHour
        endMinute
      }
      scheduledClosure {
        date
        endDate
      }
      customIntro
      additionalInstructions
    }
  }
  outboundCallBehavior {
    leaveVoicemail
    voicemailMessage
    verifyIdentity
  }
}
    `;
export const VoiceAgentFieldsFragmentDoc = gql`
    fragment VoiceAgentFields on VoiceAgent {
  ...VoiceAgentOverviewFields
  outboundIntroComplianceDisclosure
  configuration {
    ...VoiceAgentConfigurationFields
  }
}
    ${VoiceAgentOverviewFieldsFragmentDoc}
${VoiceAgentConfigurationFieldsFragmentDoc}`;
export const GetAccountsDocument = gql`
    query GetAccounts {
  accounts {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;

/**
 * __useGetAccountsQuery__
 *
 * To run a query within a React component, call `useGetAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountsQuery(baseOptions?: Apollo.QueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
      }
export function useGetAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
// @ts-ignore
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountsQuery | undefined, GetAccountsQueryVariables>;
export function useGetAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountsQuery, GetAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountsQuery, GetAccountsQueryVariables>(GetAccountsDocument, options);
        }
export type GetAccountsQueryHookResult = ReturnType<typeof useGetAccountsQuery>;
export type GetAccountsLazyQueryHookResult = ReturnType<typeof useGetAccountsLazyQuery>;
export type GetAccountsSuspenseQueryHookResult = ReturnType<typeof useGetAccountsSuspenseQuery>;
export type GetAccountsQueryResult = Apollo.QueryResult<GetAccountsQuery, GetAccountsQueryVariables>;
export const GetAccountDocument = gql`
    query GetAccount($id: ID!) {
  account(id: $id) {
    ...AccountFields
    ...AccountBusinessPolicyFields
    ...AccountCertificateOfLiabilityInsuranceFields
    ...AccountContactFields
    ...AccountServiceRequestFields
  }
}
    ${AccountFieldsFragmentDoc}
${AccountBusinessPolicyFieldsFragmentDoc}
${AccountCertificateOfLiabilityInsuranceFieldsFragmentDoc}
${AccountContactFieldsFragmentDoc}
${AccountServiceRequestFieldsFragmentDoc}`;

/**
 * __useGetAccountQuery__
 *
 * To run a query within a React component, call `useGetAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAccountQuery(baseOptions: Apollo.QueryHookOptions<GetAccountQuery, GetAccountQueryVariables> & ({ variables: GetAccountQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
      }
export function useGetAccountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
// @ts-ignore
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>): Apollo.UseSuspenseQueryResult<GetAccountQuery | undefined, GetAccountQueryVariables>;
export function useGetAccountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAccountQuery, GetAccountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAccountQuery, GetAccountQueryVariables>(GetAccountDocument, options);
        }
export type GetAccountQueryHookResult = ReturnType<typeof useGetAccountQuery>;
export type GetAccountLazyQueryHookResult = ReturnType<typeof useGetAccountLazyQuery>;
export type GetAccountSuspenseQueryHookResult = ReturnType<typeof useGetAccountSuspenseQuery>;
export type GetAccountQueryResult = Apollo.QueryResult<GetAccountQuery, GetAccountQueryVariables>;
export const GetContactsDocument = gql`
    query GetContacts {
  contacts {
    ...ContactFields
  }
}
    ${ContactFieldsFragmentDoc}`;

/**
 * __useGetContactsQuery__
 *
 * To run a query within a React component, call `useGetContactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContactsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContactsQuery(baseOptions?: Apollo.QueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
      }
export function useGetContactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
// @ts-ignore
export function useGetContactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContactsQuery, GetContactsQueryVariables>;
export function useGetContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetContactsQuery | undefined, GetContactsQueryVariables>;
export function useGetContactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetContactsQuery, GetContactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetContactsQuery, GetContactsQueryVariables>(GetContactsDocument, options);
        }
export type GetContactsQueryHookResult = ReturnType<typeof useGetContactsQuery>;
export type GetContactsLazyQueryHookResult = ReturnType<typeof useGetContactsLazyQuery>;
export type GetContactsSuspenseQueryHookResult = ReturnType<typeof useGetContactsSuspenseQuery>;
export type GetContactsQueryResult = Apollo.QueryResult<GetContactsQuery, GetContactsQueryVariables>;
export const CreateAccountDocument = gql`
    mutation CreateAccount($input: CreateAccountInput!) {
  createAccount(input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export type CreateAccountMutationFn = Apollo.MutationFunction<CreateAccountMutation, CreateAccountMutationVariables>;

/**
 * __useCreateAccountMutation__
 *
 * To run a mutation, you first call `useCreateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAccountMutation, { data, loading, error }] = useCreateAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAccountMutation, CreateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAccountMutation, CreateAccountMutationVariables>(CreateAccountDocument, options);
      }
export type CreateAccountMutationHookResult = ReturnType<typeof useCreateAccountMutation>;
export type CreateAccountMutationResult = Apollo.MutationResult<CreateAccountMutation>;
export type CreateAccountMutationOptions = Apollo.BaseMutationOptions<CreateAccountMutation, CreateAccountMutationVariables>;
export const UpdateAccountDocument = gql`
    mutation UpdateAccount($id: ID!, $input: UpdateAccountInput!) {
  updateAccount(id: $id, input: $input) {
    ...AccountFields
  }
}
    ${AccountFieldsFragmentDoc}`;
export type UpdateAccountMutationFn = Apollo.MutationFunction<UpdateAccountMutation, UpdateAccountMutationVariables>;

/**
 * __useUpdateAccountMutation__
 *
 * To run a mutation, you first call `useUpdateAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAccountMutation, { data, loading, error }] = useUpdateAccountMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAccountMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAccountMutation, UpdateAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAccountMutation, UpdateAccountMutationVariables>(UpdateAccountDocument, options);
      }
export type UpdateAccountMutationHookResult = ReturnType<typeof useUpdateAccountMutation>;
export type UpdateAccountMutationResult = Apollo.MutationResult<UpdateAccountMutation>;
export type UpdateAccountMutationOptions = Apollo.BaseMutationOptions<UpdateAccountMutation, UpdateAccountMutationVariables>;
export const CreateAgencyDocument = gql`
    mutation CreateAgency($input: CreateAgencyInput!) {
  createAgency(input: $input) {
    id
  }
}
    `;
export type CreateAgencyMutationFn = Apollo.MutationFunction<CreateAgencyMutation, CreateAgencyMutationVariables>;

/**
 * __useCreateAgencyMutation__
 *
 * To run a mutation, you first call `useCreateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyMutation, { data, loading, error }] = useCreateAgencyMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyMutation, CreateAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyMutation, CreateAgencyMutationVariables>(CreateAgencyDocument, options);
      }
export type CreateAgencyMutationHookResult = ReturnType<typeof useCreateAgencyMutation>;
export type CreateAgencyMutationResult = Apollo.MutationResult<CreateAgencyMutation>;
export type CreateAgencyMutationOptions = Apollo.BaseMutationOptions<CreateAgencyMutation, CreateAgencyMutationVariables>;
export const GetAgencyProfilesDocument = gql`
    query GetAgencyProfiles {
  agencyProfiles {
    ...AgencyProfileSummaryFields
  }
}
    ${AgencyProfileSummaryFieldsFragmentDoc}`;

/**
 * __useGetAgencyProfilesQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfilesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyProfilesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>(GetAgencyProfilesDocument, options);
      }
export function useGetAgencyProfilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>(GetAgencyProfilesDocument, options);
        }
// @ts-ignore
export function useGetAgencyProfilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>;
export function useGetAgencyProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfilesQuery | undefined, GetAgencyProfilesQueryVariables>;
export function useGetAgencyProfilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>(GetAgencyProfilesDocument, options);
        }
export type GetAgencyProfilesQueryHookResult = ReturnType<typeof useGetAgencyProfilesQuery>;
export type GetAgencyProfilesLazyQueryHookResult = ReturnType<typeof useGetAgencyProfilesLazyQuery>;
export type GetAgencyProfilesSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfilesSuspenseQuery>;
export type GetAgencyProfilesQueryResult = Apollo.QueryResult<GetAgencyProfilesQuery, GetAgencyProfilesQueryVariables>;
export const GetAgencyProfileAssignmentsDocument = gql`
    query GetAgencyProfileAssignments {
  agencyProfiles {
    ...AgencyProfileAssignmentFields
  }
}
    ${AgencyProfileAssignmentFieldsFragmentDoc}`;

/**
 * __useGetAgencyProfileAssignmentsQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfileAssignmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfileAssignmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfileAssignmentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyProfileAssignmentsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>(GetAgencyProfileAssignmentsDocument, options);
      }
export function useGetAgencyProfileAssignmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>(GetAgencyProfileAssignmentsDocument, options);
        }
// @ts-ignore
export function useGetAgencyProfileAssignmentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>;
export function useGetAgencyProfileAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileAssignmentsQuery | undefined, GetAgencyProfileAssignmentsQueryVariables>;
export function useGetAgencyProfileAssignmentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>(GetAgencyProfileAssignmentsDocument, options);
        }
export type GetAgencyProfileAssignmentsQueryHookResult = ReturnType<typeof useGetAgencyProfileAssignmentsQuery>;
export type GetAgencyProfileAssignmentsLazyQueryHookResult = ReturnType<typeof useGetAgencyProfileAssignmentsLazyQuery>;
export type GetAgencyProfileAssignmentsSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfileAssignmentsSuspenseQuery>;
export type GetAgencyProfileAssignmentsQueryResult = Apollo.QueryResult<GetAgencyProfileAssignmentsQuery, GetAgencyProfileAssignmentsQueryVariables>;
export const GetAgencyProfileDocument = gql`
    query GetAgencyProfile($id: ID!) {
  agencyProfile(id: $id) {
    ...AgencyProfileFields
  }
}
    ${AgencyProfileFieldsFragmentDoc}`;

/**
 * __useGetAgencyProfileQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfileQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetAgencyProfileQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyProfileQuery, GetAgencyProfileQueryVariables> & ({ variables: GetAgencyProfileQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>(GetAgencyProfileDocument, options);
      }
export function useGetAgencyProfileLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>(GetAgencyProfileDocument, options);
        }
// @ts-ignore
export function useGetAgencyProfileSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>;
export function useGetAgencyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileQuery | undefined, GetAgencyProfileQueryVariables>;
export function useGetAgencyProfileSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>(GetAgencyProfileDocument, options);
        }
export type GetAgencyProfileQueryHookResult = ReturnType<typeof useGetAgencyProfileQuery>;
export type GetAgencyProfileLazyQueryHookResult = ReturnType<typeof useGetAgencyProfileLazyQuery>;
export type GetAgencyProfileSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfileSuspenseQuery>;
export type GetAgencyProfileQueryResult = Apollo.QueryResult<GetAgencyProfileQuery, GetAgencyProfileQueryVariables>;
export const GetAgencyProfileCapabilityCatalogDocument = gql`
    query GetAgencyProfileCapabilityCatalog {
  agencyProfileCapabilityCatalog {
    groups {
      title
      hint
      sections {
        title
        hint
        capabilities {
          capability
          label
          hint
          requires
          grants {
            resource
            actions
          }
          navigation {
            ...AgencyProfileNavigationOptionFields
          }
        }
      }
    }
  }
}
    ${AgencyProfileNavigationOptionFieldsFragmentDoc}`;

/**
 * __useGetAgencyProfileCapabilityCatalogQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfileCapabilityCatalogQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfileCapabilityCatalogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfileCapabilityCatalogQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyProfileCapabilityCatalogQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>(GetAgencyProfileCapabilityCatalogDocument, options);
      }
export function useGetAgencyProfileCapabilityCatalogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>(GetAgencyProfileCapabilityCatalogDocument, options);
        }
// @ts-ignore
export function useGetAgencyProfileCapabilityCatalogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>;
export function useGetAgencyProfileCapabilityCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileCapabilityCatalogQuery | undefined, GetAgencyProfileCapabilityCatalogQueryVariables>;
export function useGetAgencyProfileCapabilityCatalogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>(GetAgencyProfileCapabilityCatalogDocument, options);
        }
export type GetAgencyProfileCapabilityCatalogQueryHookResult = ReturnType<typeof useGetAgencyProfileCapabilityCatalogQuery>;
export type GetAgencyProfileCapabilityCatalogLazyQueryHookResult = ReturnType<typeof useGetAgencyProfileCapabilityCatalogLazyQuery>;
export type GetAgencyProfileCapabilityCatalogSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfileCapabilityCatalogSuspenseQuery>;
export type GetAgencyProfileCapabilityCatalogQueryResult = Apollo.QueryResult<GetAgencyProfileCapabilityCatalogQuery, GetAgencyProfileCapabilityCatalogQueryVariables>;
export const CreateAgencyProfileDocument = gql`
    mutation CreateAgencyProfile($input: CreateAgencyProfileInput!) {
  createAgencyProfile(input: $input) {
    ...AgencyProfileFields
  }
}
    ${AgencyProfileFieldsFragmentDoc}`;
export type CreateAgencyProfileMutationFn = Apollo.MutationFunction<CreateAgencyProfileMutation, CreateAgencyProfileMutationVariables>;

/**
 * __useCreateAgencyProfileMutation__
 *
 * To run a mutation, you first call `useCreateAgencyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyProfileMutation, { data, loading, error }] = useCreateAgencyProfileMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyProfileMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyProfileMutation, CreateAgencyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyProfileMutation, CreateAgencyProfileMutationVariables>(CreateAgencyProfileDocument, options);
      }
export type CreateAgencyProfileMutationHookResult = ReturnType<typeof useCreateAgencyProfileMutation>;
export type CreateAgencyProfileMutationResult = Apollo.MutationResult<CreateAgencyProfileMutation>;
export type CreateAgencyProfileMutationOptions = Apollo.BaseMutationOptions<CreateAgencyProfileMutation, CreateAgencyProfileMutationVariables>;
export const UpdateAgencyProfileDocument = gql`
    mutation UpdateAgencyProfile($id: ID!, $input: AgencyProfileInput!) {
  updateAgencyProfile(id: $id, input: $input) {
    ...AgencyProfileFields
  }
}
    ${AgencyProfileFieldsFragmentDoc}`;
export type UpdateAgencyProfileMutationFn = Apollo.MutationFunction<UpdateAgencyProfileMutation, UpdateAgencyProfileMutationVariables>;

/**
 * __useUpdateAgencyProfileMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyProfileMutation, { data, loading, error }] = useUpdateAgencyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyProfileMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyProfileMutation, UpdateAgencyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyProfileMutation, UpdateAgencyProfileMutationVariables>(UpdateAgencyProfileDocument, options);
      }
export type UpdateAgencyProfileMutationHookResult = ReturnType<typeof useUpdateAgencyProfileMutation>;
export type UpdateAgencyProfileMutationResult = Apollo.MutationResult<UpdateAgencyProfileMutation>;
export type UpdateAgencyProfileMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyProfileMutation, UpdateAgencyProfileMutationVariables>;
export const ArchiveAgencyProfileDocument = gql`
    mutation ArchiveAgencyProfile($id: ID!) {
  archiveAgencyProfile(id: $id) {
    id
    archivedAt
  }
}
    `;
export type ArchiveAgencyProfileMutationFn = Apollo.MutationFunction<ArchiveAgencyProfileMutation, ArchiveAgencyProfileMutationVariables>;

/**
 * __useArchiveAgencyProfileMutation__
 *
 * To run a mutation, you first call `useArchiveAgencyProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAgencyProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAgencyProfileMutation, { data, loading, error }] = useArchiveAgencyProfileMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveAgencyProfileMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAgencyProfileMutation, ArchiveAgencyProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAgencyProfileMutation, ArchiveAgencyProfileMutationVariables>(ArchiveAgencyProfileDocument, options);
      }
export type ArchiveAgencyProfileMutationHookResult = ReturnType<typeof useArchiveAgencyProfileMutation>;
export type ArchiveAgencyProfileMutationResult = Apollo.MutationResult<ArchiveAgencyProfileMutation>;
export type ArchiveAgencyProfileMutationOptions = Apollo.BaseMutationOptions<ArchiveAgencyProfileMutation, ArchiveAgencyProfileMutationVariables>;
export const GetAgencyProfileOptionsDocument = gql`
    query GetAgencyProfileOptions($agencyId: ID) {
  agencyProfiles(agencyId: $agencyId) {
    ...AgencyProfileOptionFields
  }
}
    ${AgencyProfileOptionFieldsFragmentDoc}`;

/**
 * __useGetAgencyProfileOptionsQuery__
 *
 * To run a query within a React component, call `useGetAgencyProfileOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProfileOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProfileOptionsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGetAgencyProfileOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>(GetAgencyProfileOptionsDocument, options);
      }
export function useGetAgencyProfileOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>(GetAgencyProfileOptionsDocument, options);
        }
// @ts-ignore
export function useGetAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>;
export function useGetAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProfileOptionsQuery | undefined, GetAgencyProfileOptionsQueryVariables>;
export function useGetAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>(GetAgencyProfileOptionsDocument, options);
        }
export type GetAgencyProfileOptionsQueryHookResult = ReturnType<typeof useGetAgencyProfileOptionsQuery>;
export type GetAgencyProfileOptionsLazyQueryHookResult = ReturnType<typeof useGetAgencyProfileOptionsLazyQuery>;
export type GetAgencyProfileOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProfileOptionsSuspenseQuery>;
export type GetAgencyProfileOptionsQueryResult = Apollo.QueryResult<GetAgencyProfileOptionsQuery, GetAgencyProfileOptionsQueryVariables>;
export const GetAgencyUserProfileOptionsDocument = gql`
    query GetAgencyUserProfileOptions($agencyId: ID, $agencyUserId: ID!) {
  agencyProfiles(agencyId: $agencyId) {
    ...AgencyProfileOptionFields
  }
  agencyUserProfileAssignment(agencyUserId: $agencyUserId) {
    source
    profile {
      ...AgencyProfileOptionFields
    }
    team {
      id
      name
    }
  }
}
    ${AgencyProfileOptionFieldsFragmentDoc}`;

/**
 * __useGetAgencyUserProfileOptionsQuery__
 *
 * To run a query within a React component, call `useGetAgencyUserProfileOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUserProfileOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUserProfileOptionsQuery({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      agencyUserId: // value for 'agencyUserId'
 *   },
 * });
 */
export function useGetAgencyUserProfileOptionsQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables> & ({ variables: GetAgencyUserProfileOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>(GetAgencyUserProfileOptionsDocument, options);
      }
export function useGetAgencyUserProfileOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>(GetAgencyUserProfileOptionsDocument, options);
        }
// @ts-ignore
export function useGetAgencyUserProfileOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>;
export function useGetAgencyUserProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserProfileOptionsQuery | undefined, GetAgencyUserProfileOptionsQueryVariables>;
export function useGetAgencyUserProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>(GetAgencyUserProfileOptionsDocument, options);
        }
export type GetAgencyUserProfileOptionsQueryHookResult = ReturnType<typeof useGetAgencyUserProfileOptionsQuery>;
export type GetAgencyUserProfileOptionsLazyQueryHookResult = ReturnType<typeof useGetAgencyUserProfileOptionsLazyQuery>;
export type GetAgencyUserProfileOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUserProfileOptionsSuspenseQuery>;
export type GetAgencyUserProfileOptionsQueryResult = Apollo.QueryResult<GetAgencyUserProfileOptionsQuery, GetAgencyUserProfileOptionsQueryVariables>;
export const GetAgencyUserDocument = gql`
    query GetAgencyUser {
  agencyUser {
    ...LoggedInAgencyUserFields
  }
}
    ${LoggedInAgencyUserFieldsFragmentDoc}`;

/**
 * __useGetAgencyUserQuery__
 *
 * To run a query within a React component, call `useGetAgencyUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyUserQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(GetAgencyUserDocument, options);
      }
export function useGetAgencyUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(GetAgencyUserDocument, options);
        }
// @ts-ignore
export function useGetAgencyUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserQuery, GetAgencyUserQueryVariables>;
export function useGetAgencyUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserQuery | undefined, GetAgencyUserQueryVariables>;
export function useGetAgencyUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserQuery, GetAgencyUserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUserQuery, GetAgencyUserQueryVariables>(GetAgencyUserDocument, options);
        }
export type GetAgencyUserQueryHookResult = ReturnType<typeof useGetAgencyUserQuery>;
export type GetAgencyUserLazyQueryHookResult = ReturnType<typeof useGetAgencyUserLazyQuery>;
export type GetAgencyUserSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUserSuspenseQuery>;
export type GetAgencyUserQueryResult = Apollo.QueryResult<GetAgencyUserQuery, GetAgencyUserQueryVariables>;
export const GetDefaultAcordFormConfigurationDocument = gql`
    query GetDefaultACORDFormConfiguration {
  defaultACORDFormConfiguration {
    ...ACORDFormConfigurationFields
  }
}
    ${AcordFormConfigurationFieldsFragmentDoc}`;

/**
 * __useGetDefaultAcordFormConfigurationQuery__
 *
 * To run a query within a React component, call `useGetDefaultAcordFormConfigurationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDefaultAcordFormConfigurationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDefaultAcordFormConfigurationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetDefaultAcordFormConfigurationQuery(baseOptions?: Apollo.QueryHookOptions<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>(GetDefaultAcordFormConfigurationDocument, options);
      }
export function useGetDefaultAcordFormConfigurationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>(GetDefaultAcordFormConfigurationDocument, options);
        }
// @ts-ignore
export function useGetDefaultAcordFormConfigurationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>;
export function useGetDefaultAcordFormConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>): Apollo.UseSuspenseQueryResult<GetDefaultAcordFormConfigurationQuery | undefined, GetDefaultAcordFormConfigurationQueryVariables>;
export function useGetDefaultAcordFormConfigurationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>(GetDefaultAcordFormConfigurationDocument, options);
        }
export type GetDefaultAcordFormConfigurationQueryHookResult = ReturnType<typeof useGetDefaultAcordFormConfigurationQuery>;
export type GetDefaultAcordFormConfigurationLazyQueryHookResult = ReturnType<typeof useGetDefaultAcordFormConfigurationLazyQuery>;
export type GetDefaultAcordFormConfigurationSuspenseQueryHookResult = ReturnType<typeof useGetDefaultAcordFormConfigurationSuspenseQuery>;
export type GetDefaultAcordFormConfigurationQueryResult = Apollo.QueryResult<GetDefaultAcordFormConfigurationQuery, GetDefaultAcordFormConfigurationQueryVariables>;
export const GetAgencyUsageDocument = gql`
    query GetAgencyUsage($timezone: String) {
  agencyUser {
    agency {
      ...AgencyUsageFields
    }
  }
}
    ${AgencyUsageFieldsFragmentDoc}`;

/**
 * __useGetAgencyUsageQuery__
 *
 * To run a query within a React component, call `useGetAgencyUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUsageQuery({
 *   variables: {
 *      timezone: // value for 'timezone'
 *   },
 * });
 */
export function useGetAgencyUsageQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>(GetAgencyUsageDocument, options);
      }
export function useGetAgencyUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>(GetAgencyUsageDocument, options);
        }
// @ts-ignore
export function useGetAgencyUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>;
export function useGetAgencyUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsageQuery | undefined, GetAgencyUsageQueryVariables>;
export function useGetAgencyUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>(GetAgencyUsageDocument, options);
        }
export type GetAgencyUsageQueryHookResult = ReturnType<typeof useGetAgencyUsageQuery>;
export type GetAgencyUsageLazyQueryHookResult = ReturnType<typeof useGetAgencyUsageLazyQuery>;
export type GetAgencyUsageSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUsageSuspenseQuery>;
export type GetAgencyUsageQueryResult = Apollo.QueryResult<GetAgencyUsageQuery, GetAgencyUsageQueryVariables>;
export const GetUsageOverageInvoicesDocument = gql`
    query GetUsageOverageInvoices($limit: Int, $cursor: String) {
  agencyUser {
    agency {
      subscription {
        usageOverageInvoices(limit: $limit, cursor: $cursor) {
          edges {
            cursor
            node {
              id
              periodStart
              periodEnd
              status
              totalDollars
              hostedInvoiceUrl
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetUsageOverageInvoicesQuery__
 *
 * To run a query within a React component, call `useGetUsageOverageInvoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsageOverageInvoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsageOverageInvoicesQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      cursor: // value for 'cursor'
 *   },
 * });
 */
export function useGetUsageOverageInvoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>(GetUsageOverageInvoicesDocument, options);
      }
export function useGetUsageOverageInvoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>(GetUsageOverageInvoicesDocument, options);
        }
// @ts-ignore
export function useGetUsageOverageInvoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>;
export function useGetUsageOverageInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetUsageOverageInvoicesQuery | undefined, GetUsageOverageInvoicesQueryVariables>;
export function useGetUsageOverageInvoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>(GetUsageOverageInvoicesDocument, options);
        }
export type GetUsageOverageInvoicesQueryHookResult = ReturnType<typeof useGetUsageOverageInvoicesQuery>;
export type GetUsageOverageInvoicesLazyQueryHookResult = ReturnType<typeof useGetUsageOverageInvoicesLazyQuery>;
export type GetUsageOverageInvoicesSuspenseQueryHookResult = ReturnType<typeof useGetUsageOverageInvoicesSuspenseQuery>;
export type GetUsageOverageInvoicesQueryResult = Apollo.QueryResult<GetUsageOverageInvoicesQuery, GetUsageOverageInvoicesQueryVariables>;
export const GetAgencyUsageHistoryDocument = gql`
    query GetAgencyUsageHistory($window: AgencyUsageWindow!, $timezone: String, $startDay: Time, $endDay: Time) {
  agencyUser {
    agency {
      subscription {
        usageHistory(
          window: $window
          timezone: $timezone
          startDay: $startDay
          endDay: $endDay
        ) {
          start
          end
          timezone
          agencyTotals {
            voiceMinutes
            kbPages
          }
          platformUnitsByUser {
            agencyUserId
            used
          }
        }
      }
    }
  }
}
    `;

/**
 * __useGetAgencyUsageHistoryQuery__
 *
 * To run a query within a React component, call `useGetAgencyUsageHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUsageHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUsageHistoryQuery({
 *   variables: {
 *      window: // value for 'window'
 *      timezone: // value for 'timezone'
 *      startDay: // value for 'startDay'
 *      endDay: // value for 'endDay'
 *   },
 * });
 */
export function useGetAgencyUsageHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables> & ({ variables: GetAgencyUsageHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>(GetAgencyUsageHistoryDocument, options);
      }
export function useGetAgencyUsageHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>(GetAgencyUsageHistoryDocument, options);
        }
// @ts-ignore
export function useGetAgencyUsageHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>;
export function useGetAgencyUsageHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsageHistoryQuery | undefined, GetAgencyUsageHistoryQueryVariables>;
export function useGetAgencyUsageHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>(GetAgencyUsageHistoryDocument, options);
        }
export type GetAgencyUsageHistoryQueryHookResult = ReturnType<typeof useGetAgencyUsageHistoryQuery>;
export type GetAgencyUsageHistoryLazyQueryHookResult = ReturnType<typeof useGetAgencyUsageHistoryLazyQuery>;
export type GetAgencyUsageHistorySuspenseQueryHookResult = ReturnType<typeof useGetAgencyUsageHistorySuspenseQuery>;
export type GetAgencyUsageHistoryQueryResult = Apollo.QueryResult<GetAgencyUsageHistoryQuery, GetAgencyUsageHistoryQueryVariables>;
export const GetAgencyUsersDocument = gql`
    query GetAgencyUsers {
  agencyUsers {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;

/**
 * __useGetAgencyUsersQuery__
 *
 * To run a query within a React component, call `useGetAgencyUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(GetAgencyUsersDocument, options);
      }
export function useGetAgencyUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(GetAgencyUsersDocument, options);
        }
// @ts-ignore
export function useGetAgencyUsersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>;
export function useGetAgencyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUsersQuery | undefined, GetAgencyUsersQueryVariables>;
export function useGetAgencyUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>(GetAgencyUsersDocument, options);
        }
export type GetAgencyUsersQueryHookResult = ReturnType<typeof useGetAgencyUsersQuery>;
export type GetAgencyUsersLazyQueryHookResult = ReturnType<typeof useGetAgencyUsersLazyQuery>;
export type GetAgencyUsersSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUsersSuspenseQuery>;
export type GetAgencyUsersQueryResult = Apollo.QueryResult<GetAgencyUsersQuery, GetAgencyUsersQueryVariables>;
export const GetChildAgenciesDocument = gql`
    query GetChildAgencies {
  agencyUser {
    agency {
      childAgencies {
        ...ChildAgencyFields
      }
    }
  }
}
    ${ChildAgencyFieldsFragmentDoc}`;

/**
 * __useGetChildAgenciesQuery__
 *
 * To run a query within a React component, call `useGetChildAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetChildAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetChildAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetChildAgenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>(GetChildAgenciesDocument, options);
      }
export function useGetChildAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>(GetChildAgenciesDocument, options);
        }
// @ts-ignore
export function useGetChildAgenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>;
export function useGetChildAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetChildAgenciesQuery | undefined, GetChildAgenciesQueryVariables>;
export function useGetChildAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>(GetChildAgenciesDocument, options);
        }
export type GetChildAgenciesQueryHookResult = ReturnType<typeof useGetChildAgenciesQuery>;
export type GetChildAgenciesLazyQueryHookResult = ReturnType<typeof useGetChildAgenciesLazyQuery>;
export type GetChildAgenciesSuspenseQueryHookResult = ReturnType<typeof useGetChildAgenciesSuspenseQuery>;
export type GetChildAgenciesQueryResult = Apollo.QueryResult<GetChildAgenciesQuery, GetChildAgenciesQueryVariables>;
export const UpdateAgencyUserPreferencesDocument = gql`
    mutation UpdateAgencyUserPreferences($input: AgencyUserPreferencesInput!) {
  updateAgencyUserPreferences(input: $input) {
    ...LoggedInAgencyUserFields
  }
}
    ${LoggedInAgencyUserFieldsFragmentDoc}`;
export type UpdateAgencyUserPreferencesMutationFn = Apollo.MutationFunction<UpdateAgencyUserPreferencesMutation, UpdateAgencyUserPreferencesMutationVariables>;

/**
 * __useUpdateAgencyUserPreferencesMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyUserPreferencesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyUserPreferencesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyUserPreferencesMutation, { data, loading, error }] = useUpdateAgencyUserPreferencesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyUserPreferencesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyUserPreferencesMutation, UpdateAgencyUserPreferencesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyUserPreferencesMutation, UpdateAgencyUserPreferencesMutationVariables>(UpdateAgencyUserPreferencesDocument, options);
      }
export type UpdateAgencyUserPreferencesMutationHookResult = ReturnType<typeof useUpdateAgencyUserPreferencesMutation>;
export type UpdateAgencyUserPreferencesMutationResult = Apollo.MutationResult<UpdateAgencyUserPreferencesMutation>;
export type UpdateAgencyUserPreferencesMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyUserPreferencesMutation, UpdateAgencyUserPreferencesMutationVariables>;
export const CreateAgencyUserDocument = gql`
    mutation CreateAgencyUser($input: AgencyUserInput!) {
  createAgencyUser(input: $input) {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;
export type CreateAgencyUserMutationFn = Apollo.MutationFunction<CreateAgencyUserMutation, CreateAgencyUserMutationVariables>;

/**
 * __useCreateAgencyUserMutation__
 *
 * To run a mutation, you first call `useCreateAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyUserMutation, { data, loading, error }] = useCreateAgencyUserMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyUserMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyUserMutation, CreateAgencyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyUserMutation, CreateAgencyUserMutationVariables>(CreateAgencyUserDocument, options);
      }
export type CreateAgencyUserMutationHookResult = ReturnType<typeof useCreateAgencyUserMutation>;
export type CreateAgencyUserMutationResult = Apollo.MutationResult<CreateAgencyUserMutation>;
export type CreateAgencyUserMutationOptions = Apollo.BaseMutationOptions<CreateAgencyUserMutation, CreateAgencyUserMutationVariables>;
export const CreateAgencyUsersDocument = gql`
    mutation CreateAgencyUsers($inputs: [AgencyUserImportInput!]!, $idempotencyKey: String) {
  createAgencyUsers(inputs: $inputs, idempotencyKey: $idempotencyKey) {
    email
    user {
      id
    }
    error
  }
}
    `;
export type CreateAgencyUsersMutationFn = Apollo.MutationFunction<CreateAgencyUsersMutation, CreateAgencyUsersMutationVariables>;

/**
 * __useCreateAgencyUsersMutation__
 *
 * To run a mutation, you first call `useCreateAgencyUsersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyUsersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyUsersMutation, { data, loading, error }] = useCreateAgencyUsersMutation({
 *   variables: {
 *      inputs: // value for 'inputs'
 *      idempotencyKey: // value for 'idempotencyKey'
 *   },
 * });
 */
export function useCreateAgencyUsersMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyUsersMutation, CreateAgencyUsersMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyUsersMutation, CreateAgencyUsersMutationVariables>(CreateAgencyUsersDocument, options);
      }
export type CreateAgencyUsersMutationHookResult = ReturnType<typeof useCreateAgencyUsersMutation>;
export type CreateAgencyUsersMutationResult = Apollo.MutationResult<CreateAgencyUsersMutation>;
export type CreateAgencyUsersMutationOptions = Apollo.BaseMutationOptions<CreateAgencyUsersMutation, CreateAgencyUsersMutationVariables>;
export const UpdateAgencyUserDocument = gql`
    mutation UpdateAgencyUser($id: ID!, $input: UpdateAgencyUserInput!) {
  updateAgencyUser(id: $id, input: $input) {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;
export type UpdateAgencyUserMutationFn = Apollo.MutationFunction<UpdateAgencyUserMutation, UpdateAgencyUserMutationVariables>;

/**
 * __useUpdateAgencyUserMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyUserMutation, { data, loading, error }] = useUpdateAgencyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyUserMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyUserMutation, UpdateAgencyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyUserMutation, UpdateAgencyUserMutationVariables>(UpdateAgencyUserDocument, options);
      }
export type UpdateAgencyUserMutationHookResult = ReturnType<typeof useUpdateAgencyUserMutation>;
export type UpdateAgencyUserMutationResult = Apollo.MutationResult<UpdateAgencyUserMutation>;
export type UpdateAgencyUserMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyUserMutation, UpdateAgencyUserMutationVariables>;
export const DisableAgencyUserDocument = gql`
    mutation DisableAgencyUser($id: ID!) {
  disableAgencyUser(id: $id) {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;
export type DisableAgencyUserMutationFn = Apollo.MutationFunction<DisableAgencyUserMutation, DisableAgencyUserMutationVariables>;

/**
 * __useDisableAgencyUserMutation__
 *
 * To run a mutation, you first call `useDisableAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisableAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disableAgencyUserMutation, { data, loading, error }] = useDisableAgencyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisableAgencyUserMutation(baseOptions?: Apollo.MutationHookOptions<DisableAgencyUserMutation, DisableAgencyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisableAgencyUserMutation, DisableAgencyUserMutationVariables>(DisableAgencyUserDocument, options);
      }
export type DisableAgencyUserMutationHookResult = ReturnType<typeof useDisableAgencyUserMutation>;
export type DisableAgencyUserMutationResult = Apollo.MutationResult<DisableAgencyUserMutation>;
export type DisableAgencyUserMutationOptions = Apollo.BaseMutationOptions<DisableAgencyUserMutation, DisableAgencyUserMutationVariables>;
export const EnableAgencyUserDocument = gql`
    mutation EnableAgencyUser($id: ID!) {
  enableAgencyUser(id: $id) {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;
export type EnableAgencyUserMutationFn = Apollo.MutationFunction<EnableAgencyUserMutation, EnableAgencyUserMutationVariables>;

/**
 * __useEnableAgencyUserMutation__
 *
 * To run a mutation, you first call `useEnableAgencyUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnableAgencyUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enableAgencyUserMutation, { data, loading, error }] = useEnableAgencyUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEnableAgencyUserMutation(baseOptions?: Apollo.MutationHookOptions<EnableAgencyUserMutation, EnableAgencyUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnableAgencyUserMutation, EnableAgencyUserMutationVariables>(EnableAgencyUserDocument, options);
      }
export type EnableAgencyUserMutationHookResult = ReturnType<typeof useEnableAgencyUserMutation>;
export type EnableAgencyUserMutationResult = Apollo.MutationResult<EnableAgencyUserMutation>;
export type EnableAgencyUserMutationOptions = Apollo.BaseMutationOptions<EnableAgencyUserMutation, EnableAgencyUserMutationVariables>;
export const GetSubscriptionUpdateLinkDocument = gql`
    query GetSubscriptionUpdateLink($input: UpdateSubscriptionInput!) {
  subscriptionManagementLinks {
    previewUpdateSubscription(input: $input) {
      ...PreviewUpdateSubscriptionResultFields
    }
  }
}
    ${PreviewUpdateSubscriptionResultFieldsFragmentDoc}`;

/**
 * __useGetSubscriptionUpdateLinkQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionUpdateLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionUpdateLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionUpdateLinkQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetSubscriptionUpdateLinkQuery(baseOptions: Apollo.QueryHookOptions<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables> & ({ variables: GetSubscriptionUpdateLinkQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>(GetSubscriptionUpdateLinkDocument, options);
      }
export function useGetSubscriptionUpdateLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>(GetSubscriptionUpdateLinkDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionUpdateLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>;
export function useGetSubscriptionUpdateLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionUpdateLinkQuery | undefined, GetSubscriptionUpdateLinkQueryVariables>;
export function useGetSubscriptionUpdateLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>(GetSubscriptionUpdateLinkDocument, options);
        }
export type GetSubscriptionUpdateLinkQueryHookResult = ReturnType<typeof useGetSubscriptionUpdateLinkQuery>;
export type GetSubscriptionUpdateLinkLazyQueryHookResult = ReturnType<typeof useGetSubscriptionUpdateLinkLazyQuery>;
export type GetSubscriptionUpdateLinkSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionUpdateLinkSuspenseQuery>;
export type GetSubscriptionUpdateLinkQueryResult = Apollo.QueryResult<GetSubscriptionUpdateLinkQuery, GetSubscriptionUpdateLinkQueryVariables>;
export const GetSubscriptionUpdatePaymentLinkDocument = gql`
    query GetSubscriptionUpdatePaymentLink {
  subscriptionManagementLinks {
    updatePaymentMethodUrl
  }
}
    `;

/**
 * __useGetSubscriptionUpdatePaymentLinkQuery__
 *
 * To run a query within a React component, call `useGetSubscriptionUpdatePaymentLinkQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSubscriptionUpdatePaymentLinkQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSubscriptionUpdatePaymentLinkQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSubscriptionUpdatePaymentLinkQuery(baseOptions?: Apollo.QueryHookOptions<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>(GetSubscriptionUpdatePaymentLinkDocument, options);
      }
export function useGetSubscriptionUpdatePaymentLinkLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>(GetSubscriptionUpdatePaymentLinkDocument, options);
        }
// @ts-ignore
export function useGetSubscriptionUpdatePaymentLinkSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>;
export function useGetSubscriptionUpdatePaymentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>): Apollo.UseSuspenseQueryResult<GetSubscriptionUpdatePaymentLinkQuery | undefined, GetSubscriptionUpdatePaymentLinkQueryVariables>;
export function useGetSubscriptionUpdatePaymentLinkSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>(GetSubscriptionUpdatePaymentLinkDocument, options);
        }
export type GetSubscriptionUpdatePaymentLinkQueryHookResult = ReturnType<typeof useGetSubscriptionUpdatePaymentLinkQuery>;
export type GetSubscriptionUpdatePaymentLinkLazyQueryHookResult = ReturnType<typeof useGetSubscriptionUpdatePaymentLinkLazyQuery>;
export type GetSubscriptionUpdatePaymentLinkSuspenseQueryHookResult = ReturnType<typeof useGetSubscriptionUpdatePaymentLinkSuspenseQuery>;
export type GetSubscriptionUpdatePaymentLinkQueryResult = Apollo.QueryResult<GetSubscriptionUpdatePaymentLinkQuery, GetSubscriptionUpdatePaymentLinkQueryVariables>;
export const UpdateSubscriptionDocument = gql`
    mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
  updateSubscription(input: $input) {
    plan
    period
    numSeats
    numVoiceAgents
  }
}
    `;
export type UpdateSubscriptionMutationFn = Apollo.MutationFunction<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;

/**
 * __useUpdateSubscriptionMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionMutation, { data, loading, error }] = useUpdateSubscriptionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateSubscriptionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>(UpdateSubscriptionDocument, options);
      }
export type UpdateSubscriptionMutationHookResult = ReturnType<typeof useUpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationResult = Apollo.MutationResult<UpdateSubscriptionMutation>;
export type UpdateSubscriptionMutationOptions = Apollo.BaseMutationOptions<UpdateSubscriptionMutation, UpdateSubscriptionMutationVariables>;
export const DismissStandardSunsetRenewalBannerDocument = gql`
    mutation DismissStandardSunsetRenewalBanner {
  dismissStandardSunsetRenewalBanner {
    ...AgencySubscriptionFields
  }
}
    ${AgencySubscriptionFieldsFragmentDoc}`;
export type DismissStandardSunsetRenewalBannerMutationFn = Apollo.MutationFunction<DismissStandardSunsetRenewalBannerMutation, DismissStandardSunsetRenewalBannerMutationVariables>;

/**
 * __useDismissStandardSunsetRenewalBannerMutation__
 *
 * To run a mutation, you first call `useDismissStandardSunsetRenewalBannerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDismissStandardSunsetRenewalBannerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dismissStandardSunsetRenewalBannerMutation, { data, loading, error }] = useDismissStandardSunsetRenewalBannerMutation({
 *   variables: {
 *   },
 * });
 */
export function useDismissStandardSunsetRenewalBannerMutation(baseOptions?: Apollo.MutationHookOptions<DismissStandardSunsetRenewalBannerMutation, DismissStandardSunsetRenewalBannerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DismissStandardSunsetRenewalBannerMutation, DismissStandardSunsetRenewalBannerMutationVariables>(DismissStandardSunsetRenewalBannerDocument, options);
      }
export type DismissStandardSunsetRenewalBannerMutationHookResult = ReturnType<typeof useDismissStandardSunsetRenewalBannerMutation>;
export type DismissStandardSunsetRenewalBannerMutationResult = Apollo.MutationResult<DismissStandardSunsetRenewalBannerMutation>;
export type DismissStandardSunsetRenewalBannerMutationOptions = Apollo.BaseMutationOptions<DismissStandardSunsetRenewalBannerMutation, DismissStandardSunsetRenewalBannerMutationVariables>;
export const ConfirmAnnualRenewalDocument = gql`
    mutation ConfirmAnnualRenewal {
  confirmAnnualRenewal {
    ...AgencySubscriptionFields
  }
}
    ${AgencySubscriptionFieldsFragmentDoc}`;
export type ConfirmAnnualRenewalMutationFn = Apollo.MutationFunction<ConfirmAnnualRenewalMutation, ConfirmAnnualRenewalMutationVariables>;

/**
 * __useConfirmAnnualRenewalMutation__
 *
 * To run a mutation, you first call `useConfirmAnnualRenewalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmAnnualRenewalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmAnnualRenewalMutation, { data, loading, error }] = useConfirmAnnualRenewalMutation({
 *   variables: {
 *   },
 * });
 */
export function useConfirmAnnualRenewalMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmAnnualRenewalMutation, ConfirmAnnualRenewalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmAnnualRenewalMutation, ConfirmAnnualRenewalMutationVariables>(ConfirmAnnualRenewalDocument, options);
      }
export type ConfirmAnnualRenewalMutationHookResult = ReturnType<typeof useConfirmAnnualRenewalMutation>;
export type ConfirmAnnualRenewalMutationResult = Apollo.MutationResult<ConfirmAnnualRenewalMutation>;
export type ConfirmAnnualRenewalMutationOptions = Apollo.BaseMutationOptions<ConfirmAnnualRenewalMutation, ConfirmAnnualRenewalMutationVariables>;
export const CreateAgencyUserForAgencyDocument = gql`
    mutation CreateAgencyUserForAgency($agencyId: ID!, $input: AgencyUserInput!) {
  createAgencyUser(agencyId: $agencyId, input: $input) {
    ...AgencyUserFields
  }
}
    ${AgencyUserFieldsFragmentDoc}`;
export type CreateAgencyUserForAgencyMutationFn = Apollo.MutationFunction<CreateAgencyUserForAgencyMutation, CreateAgencyUserForAgencyMutationVariables>;

/**
 * __useCreateAgencyUserForAgencyMutation__
 *
 * To run a mutation, you first call `useCreateAgencyUserForAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyUserForAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyUserForAgencyMutation, { data, loading, error }] = useCreateAgencyUserForAgencyMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyUserForAgencyMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyUserForAgencyMutation, CreateAgencyUserForAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyUserForAgencyMutation, CreateAgencyUserForAgencyMutationVariables>(CreateAgencyUserForAgencyDocument, options);
      }
export type CreateAgencyUserForAgencyMutationHookResult = ReturnType<typeof useCreateAgencyUserForAgencyMutation>;
export type CreateAgencyUserForAgencyMutationResult = Apollo.MutationResult<CreateAgencyUserForAgencyMutation>;
export type CreateAgencyUserForAgencyMutationOptions = Apollo.BaseMutationOptions<CreateAgencyUserForAgencyMutation, CreateAgencyUserForAgencyMutationVariables>;
export const UpdateLastViewedNewFeaturesDocument = gql`
    mutation UpdateLastViewedNewFeatures {
  updateLastViewedNewFeatures
}
    `;
export type UpdateLastViewedNewFeaturesMutationFn = Apollo.MutationFunction<UpdateLastViewedNewFeaturesMutation, UpdateLastViewedNewFeaturesMutationVariables>;

/**
 * __useUpdateLastViewedNewFeaturesMutation__
 *
 * To run a mutation, you first call `useUpdateLastViewedNewFeaturesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateLastViewedNewFeaturesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateLastViewedNewFeaturesMutation, { data, loading, error }] = useUpdateLastViewedNewFeaturesMutation({
 *   variables: {
 *   },
 * });
 */
export function useUpdateLastViewedNewFeaturesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateLastViewedNewFeaturesMutation, UpdateLastViewedNewFeaturesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateLastViewedNewFeaturesMutation, UpdateLastViewedNewFeaturesMutationVariables>(UpdateLastViewedNewFeaturesDocument, options);
      }
export type UpdateLastViewedNewFeaturesMutationHookResult = ReturnType<typeof useUpdateLastViewedNewFeaturesMutation>;
export type UpdateLastViewedNewFeaturesMutationResult = Apollo.MutationResult<UpdateLastViewedNewFeaturesMutation>;
export type UpdateLastViewedNewFeaturesMutationOptions = Apollo.BaseMutationOptions<UpdateLastViewedNewFeaturesMutation, UpdateLastViewedNewFeaturesMutationVariables>;
export const UpdateAgencyDocument = gql`
    mutation UpdateAgency($id: ID!, $input: UpdateAgencyInput!) {
  updateAgency(id: $id, input: $input) {
    ...AgencyFields
  }
}
    ${AgencyFieldsFragmentDoc}`;
export type UpdateAgencyMutationFn = Apollo.MutationFunction<UpdateAgencyMutation, UpdateAgencyMutationVariables>;

/**
 * __useUpdateAgencyMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyMutation, { data, loading, error }] = useUpdateAgencyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyMutation, UpdateAgencyMutationVariables>(UpdateAgencyDocument, options);
      }
export type UpdateAgencyMutationHookResult = ReturnType<typeof useUpdateAgencyMutation>;
export type UpdateAgencyMutationResult = Apollo.MutationResult<UpdateAgencyMutation>;
export type UpdateAgencyMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyMutation, UpdateAgencyMutationVariables>;
export const GetAgencyProducerInformationsDocument = gql`
    query GetAgencyProducerInformations {
  agencyUser {
    agency {
      producerInformations {
        ...ProducerInformationFields
      }
    }
  }
}
    ${ProducerInformationFieldsFragmentDoc}`;

/**
 * __useGetAgencyProducerInformationsQuery__
 *
 * To run a query within a React component, call `useGetAgencyProducerInformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyProducerInformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyProducerInformationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyProducerInformationsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>(GetAgencyProducerInformationsDocument, options);
      }
export function useGetAgencyProducerInformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>(GetAgencyProducerInformationsDocument, options);
        }
// @ts-ignore
export function useGetAgencyProducerInformationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>;
export function useGetAgencyProducerInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyProducerInformationsQuery | undefined, GetAgencyProducerInformationsQueryVariables>;
export function useGetAgencyProducerInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>(GetAgencyProducerInformationsDocument, options);
        }
export type GetAgencyProducerInformationsQueryHookResult = ReturnType<typeof useGetAgencyProducerInformationsQuery>;
export type GetAgencyProducerInformationsLazyQueryHookResult = ReturnType<typeof useGetAgencyProducerInformationsLazyQuery>;
export type GetAgencyProducerInformationsSuspenseQueryHookResult = ReturnType<typeof useGetAgencyProducerInformationsSuspenseQuery>;
export type GetAgencyProducerInformationsQueryResult = Apollo.QueryResult<GetAgencyProducerInformationsQuery, GetAgencyProducerInformationsQueryVariables>;
export const CreateAgencyProducerInformationDocument = gql`
    mutation CreateAgencyProducerInformation($agencyId: ID!, $input: ProducerInformationInput!) {
  createAgencyProducerInformation(agencyId: $agencyId, input: $input) {
    ...ProducerInformationFields
  }
}
    ${ProducerInformationFieldsFragmentDoc}`;
export type CreateAgencyProducerInformationMutationFn = Apollo.MutationFunction<CreateAgencyProducerInformationMutation, CreateAgencyProducerInformationMutationVariables>;

/**
 * __useCreateAgencyProducerInformationMutation__
 *
 * To run a mutation, you first call `useCreateAgencyProducerInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyProducerInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyProducerInformationMutation, { data, loading, error }] = useCreateAgencyProducerInformationMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyProducerInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyProducerInformationMutation, CreateAgencyProducerInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyProducerInformationMutation, CreateAgencyProducerInformationMutationVariables>(CreateAgencyProducerInformationDocument, options);
      }
export type CreateAgencyProducerInformationMutationHookResult = ReturnType<typeof useCreateAgencyProducerInformationMutation>;
export type CreateAgencyProducerInformationMutationResult = Apollo.MutationResult<CreateAgencyProducerInformationMutation>;
export type CreateAgencyProducerInformationMutationOptions = Apollo.BaseMutationOptions<CreateAgencyProducerInformationMutation, CreateAgencyProducerInformationMutationVariables>;
export const UpdateProducerInformationDocument = gql`
    mutation UpdateProducerInformation($id: ID!, $input: ProducerInformationInput!) {
  updateProducerInformation(id: $id, input: $input) {
    ...ProducerInformationFields
  }
}
    ${ProducerInformationFieldsFragmentDoc}`;
export type UpdateProducerInformationMutationFn = Apollo.MutationFunction<UpdateProducerInformationMutation, UpdateProducerInformationMutationVariables>;

/**
 * __useUpdateProducerInformationMutation__
 *
 * To run a mutation, you first call `useUpdateProducerInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateProducerInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateProducerInformationMutation, { data, loading, error }] = useUpdateProducerInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateProducerInformationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateProducerInformationMutation, UpdateProducerInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateProducerInformationMutation, UpdateProducerInformationMutationVariables>(UpdateProducerInformationDocument, options);
      }
export type UpdateProducerInformationMutationHookResult = ReturnType<typeof useUpdateProducerInformationMutation>;
export type UpdateProducerInformationMutationResult = Apollo.MutationResult<UpdateProducerInformationMutation>;
export type UpdateProducerInformationMutationOptions = Apollo.BaseMutationOptions<UpdateProducerInformationMutation, UpdateProducerInformationMutationVariables>;
export const DeleteProducerInformationDocument = gql`
    mutation DeleteProducerInformation($id: ID!) {
  deleteProducerInformation(id: $id)
}
    `;
export type DeleteProducerInformationMutationFn = Apollo.MutationFunction<DeleteProducerInformationMutation, DeleteProducerInformationMutationVariables>;

/**
 * __useDeleteProducerInformationMutation__
 *
 * To run a mutation, you first call `useDeleteProducerInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteProducerInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteProducerInformationMutation, { data, loading, error }] = useDeleteProducerInformationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteProducerInformationMutation(baseOptions?: Apollo.MutationHookOptions<DeleteProducerInformationMutation, DeleteProducerInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteProducerInformationMutation, DeleteProducerInformationMutationVariables>(DeleteProducerInformationDocument, options);
      }
export type DeleteProducerInformationMutationHookResult = ReturnType<typeof useDeleteProducerInformationMutation>;
export type DeleteProducerInformationMutationResult = Apollo.MutationResult<DeleteProducerInformationMutation>;
export type DeleteProducerInformationMutationOptions = Apollo.BaseMutationOptions<DeleteProducerInformationMutation, DeleteProducerInformationMutationVariables>;
export const GetUserProducerInformationsDocument = gql`
    query GetUserProducerInformations {
  agencyUser {
    producerInformations {
      ...ProducerInformationFields
    }
  }
}
    ${ProducerInformationFieldsFragmentDoc}`;

/**
 * __useGetUserProducerInformationsQuery__
 *
 * To run a query within a React component, call `useGetUserProducerInformationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserProducerInformationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserProducerInformationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserProducerInformationsQuery(baseOptions?: Apollo.QueryHookOptions<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>(GetUserProducerInformationsDocument, options);
      }
export function useGetUserProducerInformationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>(GetUserProducerInformationsDocument, options);
        }
// @ts-ignore
export function useGetUserProducerInformationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>;
export function useGetUserProducerInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetUserProducerInformationsQuery | undefined, GetUserProducerInformationsQueryVariables>;
export function useGetUserProducerInformationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>(GetUserProducerInformationsDocument, options);
        }
export type GetUserProducerInformationsQueryHookResult = ReturnType<typeof useGetUserProducerInformationsQuery>;
export type GetUserProducerInformationsLazyQueryHookResult = ReturnType<typeof useGetUserProducerInformationsLazyQuery>;
export type GetUserProducerInformationsSuspenseQueryHookResult = ReturnType<typeof useGetUserProducerInformationsSuspenseQuery>;
export type GetUserProducerInformationsQueryResult = Apollo.QueryResult<GetUserProducerInformationsQuery, GetUserProducerInformationsQueryVariables>;
export const CreateAgencyUserProducerInformationDocument = gql`
    mutation CreateAgencyUserProducerInformation($agencyUserId: ID!, $input: ProducerInformationInput!) {
  createAgencyUserProducerInformation(agencyUserId: $agencyUserId, input: $input) {
    ...ProducerInformationFields
  }
}
    ${ProducerInformationFieldsFragmentDoc}`;
export type CreateAgencyUserProducerInformationMutationFn = Apollo.MutationFunction<CreateAgencyUserProducerInformationMutation, CreateAgencyUserProducerInformationMutationVariables>;

/**
 * __useCreateAgencyUserProducerInformationMutation__
 *
 * To run a mutation, you first call `useCreateAgencyUserProducerInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyUserProducerInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyUserProducerInformationMutation, { data, loading, error }] = useCreateAgencyUserProducerInformationMutation({
 *   variables: {
 *      agencyUserId: // value for 'agencyUserId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyUserProducerInformationMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyUserProducerInformationMutation, CreateAgencyUserProducerInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyUserProducerInformationMutation, CreateAgencyUserProducerInformationMutationVariables>(CreateAgencyUserProducerInformationDocument, options);
      }
export type CreateAgencyUserProducerInformationMutationHookResult = ReturnType<typeof useCreateAgencyUserProducerInformationMutation>;
export type CreateAgencyUserProducerInformationMutationResult = Apollo.MutationResult<CreateAgencyUserProducerInformationMutation>;
export type CreateAgencyUserProducerInformationMutationOptions = Apollo.BaseMutationOptions<CreateAgencyUserProducerInformationMutation, CreateAgencyUserProducerInformationMutationVariables>;
export const SetAgencyMeterOverageLimitDocument = gql`
    mutation SetAgencyMeterOverageLimit($agencyId: ID!, $meterCode: ConsumptionMeterCode!, $limitDollars: Float) {
  setAgencyMeterOverageLimit(
    agencyId: $agencyId
    meterCode: $meterCode
    limitDollars: $limitDollars
  ) {
    agencyId
    platformUnitOverageLimitDollars
    kbPageOverageLimitDollars
    voiceMinuteOverageLimitDollars
  }
}
    `;
export type SetAgencyMeterOverageLimitMutationFn = Apollo.MutationFunction<SetAgencyMeterOverageLimitMutation, SetAgencyMeterOverageLimitMutationVariables>;

/**
 * __useSetAgencyMeterOverageLimitMutation__
 *
 * To run a mutation, you first call `useSetAgencyMeterOverageLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgencyMeterOverageLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgencyMeterOverageLimitMutation, { data, loading, error }] = useSetAgencyMeterOverageLimitMutation({
 *   variables: {
 *      agencyId: // value for 'agencyId'
 *      meterCode: // value for 'meterCode'
 *      limitDollars: // value for 'limitDollars'
 *   },
 * });
 */
export function useSetAgencyMeterOverageLimitMutation(baseOptions?: Apollo.MutationHookOptions<SetAgencyMeterOverageLimitMutation, SetAgencyMeterOverageLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAgencyMeterOverageLimitMutation, SetAgencyMeterOverageLimitMutationVariables>(SetAgencyMeterOverageLimitDocument, options);
      }
export type SetAgencyMeterOverageLimitMutationHookResult = ReturnType<typeof useSetAgencyMeterOverageLimitMutation>;
export type SetAgencyMeterOverageLimitMutationResult = Apollo.MutationResult<SetAgencyMeterOverageLimitMutation>;
export type SetAgencyMeterOverageLimitMutationOptions = Apollo.BaseMutationOptions<SetAgencyMeterOverageLimitMutation, SetAgencyMeterOverageLimitMutationVariables>;
export const SetAgencyUserOverageLimitDocument = gql`
    mutation SetAgencyUserOverageLimit($agencyUserId: ID!, $limitDollars: Float) {
  setAgencyUserOverageLimit(
    agencyUserId: $agencyUserId
    limitDollars: $limitDollars
  ) {
    id
    platformUnitOverageLimitDollars
  }
}
    `;
export type SetAgencyUserOverageLimitMutationFn = Apollo.MutationFunction<SetAgencyUserOverageLimitMutation, SetAgencyUserOverageLimitMutationVariables>;

/**
 * __useSetAgencyUserOverageLimitMutation__
 *
 * To run a mutation, you first call `useSetAgencyUserOverageLimitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetAgencyUserOverageLimitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setAgencyUserOverageLimitMutation, { data, loading, error }] = useSetAgencyUserOverageLimitMutation({
 *   variables: {
 *      agencyUserId: // value for 'agencyUserId'
 *      limitDollars: // value for 'limitDollars'
 *   },
 * });
 */
export function useSetAgencyUserOverageLimitMutation(baseOptions?: Apollo.MutationHookOptions<SetAgencyUserOverageLimitMutation, SetAgencyUserOverageLimitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetAgencyUserOverageLimitMutation, SetAgencyUserOverageLimitMutationVariables>(SetAgencyUserOverageLimitDocument, options);
      }
export type SetAgencyUserOverageLimitMutationHookResult = ReturnType<typeof useSetAgencyUserOverageLimitMutation>;
export type SetAgencyUserOverageLimitMutationResult = Apollo.MutationResult<SetAgencyUserOverageLimitMutation>;
export type SetAgencyUserOverageLimitMutationOptions = Apollo.BaseMutationOptions<SetAgencyUserOverageLimitMutation, SetAgencyUserOverageLimitMutationVariables>;
export const GetAgencyDesignsDocument = gql`
    query GetAgencyDesigns {
  agency {
    id
    brand {
      ...AgencyBrandFields
    }
    designs {
      ...AgencyDesignFields
    }
    defaultDesign {
      id
    }
  }
  brandTypefaces {
    family
    metricAlias
    cssStack
  }
  brandColorSchemes {
    key
    name
    note
    palette {
      primaryHex
      secondaryHex
      accentHex
      surfaceHex
      textHex
    }
  }
  brandElementDefaults {
    element
    fontFamily
    sizePt
    lineHeight
    spaceAbovePt
    spaceBelowPt
    bold
    italic
    colorRole
    fillRole
    linesKeptAtBottom
    linesKeptAtTop
    pageBreakBefore
  }
}
    ${AgencyBrandFieldsFragmentDoc}
${AgencyDesignFieldsFragmentDoc}`;

/**
 * __useGetAgencyDesignsQuery__
 *
 * To run a query within a React component, call `useGetAgencyDesignsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyDesignsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyDesignsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyDesignsQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>(GetAgencyDesignsDocument, options);
      }
export function useGetAgencyDesignsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>(GetAgencyDesignsDocument, options);
        }
// @ts-ignore
export function useGetAgencyDesignsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>;
export function useGetAgencyDesignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyDesignsQuery | undefined, GetAgencyDesignsQueryVariables>;
export function useGetAgencyDesignsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>(GetAgencyDesignsDocument, options);
        }
export type GetAgencyDesignsQueryHookResult = ReturnType<typeof useGetAgencyDesignsQuery>;
export type GetAgencyDesignsLazyQueryHookResult = ReturnType<typeof useGetAgencyDesignsLazyQuery>;
export type GetAgencyDesignsSuspenseQueryHookResult = ReturnType<typeof useGetAgencyDesignsSuspenseQuery>;
export type GetAgencyDesignsQueryResult = Apollo.QueryResult<GetAgencyDesignsQuery, GetAgencyDesignsQueryVariables>;
export const UploadAgencyBrandLogoDocument = gql`
    mutation UploadAgencyBrandLogo($file: UploadFileInput!) {
  uploadAgencyBrandLogo(file: $file) {
    id
    url
    name
  }
}
    `;
export type UploadAgencyBrandLogoMutationFn = Apollo.MutationFunction<UploadAgencyBrandLogoMutation, UploadAgencyBrandLogoMutationVariables>;

/**
 * __useUploadAgencyBrandLogoMutation__
 *
 * To run a mutation, you first call `useUploadAgencyBrandLogoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAgencyBrandLogoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAgencyBrandLogoMutation, { data, loading, error }] = useUploadAgencyBrandLogoMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAgencyBrandLogoMutation(baseOptions?: Apollo.MutationHookOptions<UploadAgencyBrandLogoMutation, UploadAgencyBrandLogoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAgencyBrandLogoMutation, UploadAgencyBrandLogoMutationVariables>(UploadAgencyBrandLogoDocument, options);
      }
export type UploadAgencyBrandLogoMutationHookResult = ReturnType<typeof useUploadAgencyBrandLogoMutation>;
export type UploadAgencyBrandLogoMutationResult = Apollo.MutationResult<UploadAgencyBrandLogoMutation>;
export type UploadAgencyBrandLogoMutationOptions = Apollo.BaseMutationOptions<UploadAgencyBrandLogoMutation, UploadAgencyBrandLogoMutationVariables>;
export const UploadAgencyDesignPageDocument = gql`
    mutation UploadAgencyDesignPage($file: UploadFileInput!) {
  uploadAgencyDesignPage(file: $file) {
    id
    name
    mimeType
  }
}
    `;
export type UploadAgencyDesignPageMutationFn = Apollo.MutationFunction<UploadAgencyDesignPageMutation, UploadAgencyDesignPageMutationVariables>;

/**
 * __useUploadAgencyDesignPageMutation__
 *
 * To run a mutation, you first call `useUploadAgencyDesignPageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadAgencyDesignPageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadAgencyDesignPageMutation, { data, loading, error }] = useUploadAgencyDesignPageMutation({
 *   variables: {
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadAgencyDesignPageMutation(baseOptions?: Apollo.MutationHookOptions<UploadAgencyDesignPageMutation, UploadAgencyDesignPageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadAgencyDesignPageMutation, UploadAgencyDesignPageMutationVariables>(UploadAgencyDesignPageDocument, options);
      }
export type UploadAgencyDesignPageMutationHookResult = ReturnType<typeof useUploadAgencyDesignPageMutation>;
export type UploadAgencyDesignPageMutationResult = Apollo.MutationResult<UploadAgencyDesignPageMutation>;
export type UploadAgencyDesignPageMutationOptions = Apollo.BaseMutationOptions<UploadAgencyDesignPageMutation, UploadAgencyDesignPageMutationVariables>;
export const CreateAgencyDesignDocument = gql`
    mutation CreateAgencyDesign($input: AgencyDesignInput!) {
  createAgencyDesign(input: $input) {
    ...AgencyDesignFields
  }
}
    ${AgencyDesignFieldsFragmentDoc}`;
export type CreateAgencyDesignMutationFn = Apollo.MutationFunction<CreateAgencyDesignMutation, CreateAgencyDesignMutationVariables>;

/**
 * __useCreateAgencyDesignMutation__
 *
 * To run a mutation, you first call `useCreateAgencyDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAgencyDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAgencyDesignMutation, { data, loading, error }] = useCreateAgencyDesignMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAgencyDesignMutation(baseOptions?: Apollo.MutationHookOptions<CreateAgencyDesignMutation, CreateAgencyDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAgencyDesignMutation, CreateAgencyDesignMutationVariables>(CreateAgencyDesignDocument, options);
      }
export type CreateAgencyDesignMutationHookResult = ReturnType<typeof useCreateAgencyDesignMutation>;
export type CreateAgencyDesignMutationResult = Apollo.MutationResult<CreateAgencyDesignMutation>;
export type CreateAgencyDesignMutationOptions = Apollo.BaseMutationOptions<CreateAgencyDesignMutation, CreateAgencyDesignMutationVariables>;
export const UpdateAgencyDesignDocument = gql`
    mutation UpdateAgencyDesign($id: ID!, $input: AgencyDesignInput!) {
  updateAgencyDesign(id: $id, input: $input) {
    ...AgencyDesignFields
  }
}
    ${AgencyDesignFieldsFragmentDoc}`;
export type UpdateAgencyDesignMutationFn = Apollo.MutationFunction<UpdateAgencyDesignMutation, UpdateAgencyDesignMutationVariables>;

/**
 * __useUpdateAgencyDesignMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyDesignMutation, { data, loading, error }] = useUpdateAgencyDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateAgencyDesignMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyDesignMutation, UpdateAgencyDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyDesignMutation, UpdateAgencyDesignMutationVariables>(UpdateAgencyDesignDocument, options);
      }
export type UpdateAgencyDesignMutationHookResult = ReturnType<typeof useUpdateAgencyDesignMutation>;
export type UpdateAgencyDesignMutationResult = Apollo.MutationResult<UpdateAgencyDesignMutation>;
export type UpdateAgencyDesignMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyDesignMutation, UpdateAgencyDesignMutationVariables>;
export const DuplicateAgencyDesignDocument = gql`
    mutation DuplicateAgencyDesign($id: ID!) {
  duplicateAgencyDesign(id: $id) {
    id
  }
}
    `;
export type DuplicateAgencyDesignMutationFn = Apollo.MutationFunction<DuplicateAgencyDesignMutation, DuplicateAgencyDesignMutationVariables>;

/**
 * __useDuplicateAgencyDesignMutation__
 *
 * To run a mutation, you first call `useDuplicateAgencyDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDuplicateAgencyDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [duplicateAgencyDesignMutation, { data, loading, error }] = useDuplicateAgencyDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDuplicateAgencyDesignMutation(baseOptions?: Apollo.MutationHookOptions<DuplicateAgencyDesignMutation, DuplicateAgencyDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DuplicateAgencyDesignMutation, DuplicateAgencyDesignMutationVariables>(DuplicateAgencyDesignDocument, options);
      }
export type DuplicateAgencyDesignMutationHookResult = ReturnType<typeof useDuplicateAgencyDesignMutation>;
export type DuplicateAgencyDesignMutationResult = Apollo.MutationResult<DuplicateAgencyDesignMutation>;
export type DuplicateAgencyDesignMutationOptions = Apollo.BaseMutationOptions<DuplicateAgencyDesignMutation, DuplicateAgencyDesignMutationVariables>;
export const ArchiveAgencyDesignDocument = gql`
    mutation ArchiveAgencyDesign($id: ID!) {
  archiveAgencyDesign(id: $id) {
    id
    archived
  }
}
    `;
export type ArchiveAgencyDesignMutationFn = Apollo.MutationFunction<ArchiveAgencyDesignMutation, ArchiveAgencyDesignMutationVariables>;

/**
 * __useArchiveAgencyDesignMutation__
 *
 * To run a mutation, you first call `useArchiveAgencyDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveAgencyDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveAgencyDesignMutation, { data, loading, error }] = useArchiveAgencyDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveAgencyDesignMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveAgencyDesignMutation, ArchiveAgencyDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveAgencyDesignMutation, ArchiveAgencyDesignMutationVariables>(ArchiveAgencyDesignDocument, options);
      }
export type ArchiveAgencyDesignMutationHookResult = ReturnType<typeof useArchiveAgencyDesignMutation>;
export type ArchiveAgencyDesignMutationResult = Apollo.MutationResult<ArchiveAgencyDesignMutation>;
export type ArchiveAgencyDesignMutationOptions = Apollo.BaseMutationOptions<ArchiveAgencyDesignMutation, ArchiveAgencyDesignMutationVariables>;
export const SetDefaultAgencyDesignDocument = gql`
    mutation SetDefaultAgencyDesign($id: ID!) {
  setDefaultAgencyDesign(id: $id) {
    id
    isDefault
  }
}
    `;
export type SetDefaultAgencyDesignMutationFn = Apollo.MutationFunction<SetDefaultAgencyDesignMutation, SetDefaultAgencyDesignMutationVariables>;

/**
 * __useSetDefaultAgencyDesignMutation__
 *
 * To run a mutation, you first call `useSetDefaultAgencyDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultAgencyDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultAgencyDesignMutation, { data, loading, error }] = useSetDefaultAgencyDesignMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultAgencyDesignMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultAgencyDesignMutation, SetDefaultAgencyDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultAgencyDesignMutation, SetDefaultAgencyDesignMutationVariables>(SetDefaultAgencyDesignDocument, options);
      }
export type SetDefaultAgencyDesignMutationHookResult = ReturnType<typeof useSetDefaultAgencyDesignMutation>;
export type SetDefaultAgencyDesignMutationResult = Apollo.MutationResult<SetDefaultAgencyDesignMutation>;
export type SetDefaultAgencyDesignMutationOptions = Apollo.BaseMutationOptions<SetDefaultAgencyDesignMutation, SetDefaultAgencyDesignMutationVariables>;
export const GetAgencyDesignChoicesDocument = gql`
    query GetAgencyDesignChoices {
  agency {
    id
    designs {
      id
      name
      isDefault
      visibility {
        level
      }
      includedPages {
        ...AgencyDesignIncludedPagesFields
      }
    }
  }
}
    ${AgencyDesignIncludedPagesFieldsFragmentDoc}`;

/**
 * __useGetAgencyDesignChoicesQuery__
 *
 * To run a query within a React component, call `useGetAgencyDesignChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyDesignChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyDesignChoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyDesignChoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>(GetAgencyDesignChoicesDocument, options);
      }
export function useGetAgencyDesignChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>(GetAgencyDesignChoicesDocument, options);
        }
// @ts-ignore
export function useGetAgencyDesignChoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>;
export function useGetAgencyDesignChoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyDesignChoicesQuery | undefined, GetAgencyDesignChoicesQueryVariables>;
export function useGetAgencyDesignChoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>(GetAgencyDesignChoicesDocument, options);
        }
export type GetAgencyDesignChoicesQueryHookResult = ReturnType<typeof useGetAgencyDesignChoicesQuery>;
export type GetAgencyDesignChoicesLazyQueryHookResult = ReturnType<typeof useGetAgencyDesignChoicesLazyQuery>;
export type GetAgencyDesignChoicesSuspenseQueryHookResult = ReturnType<typeof useGetAgencyDesignChoicesSuspenseQuery>;
export type GetAgencyDesignChoicesQueryResult = Apollo.QueryResult<GetAgencyDesignChoicesQuery, GetAgencyDesignChoicesQueryVariables>;
export const AmsBrowseCapabilitiesDocument = gql`
    query AmsBrowseCapabilities {
  amsBrowseCapabilities {
    integrationId
    integrationType
    displayName
    pickableKinds
    filesBrowsable
  }
}
    `;

/**
 * __useAmsBrowseCapabilitiesQuery__
 *
 * To run a query within a React component, call `useAmsBrowseCapabilitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseCapabilitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseCapabilitiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useAmsBrowseCapabilitiesQuery(baseOptions?: Apollo.QueryHookOptions<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>(AmsBrowseCapabilitiesDocument, options);
      }
export function useAmsBrowseCapabilitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>(AmsBrowseCapabilitiesDocument, options);
        }
// @ts-ignore
export function useAmsBrowseCapabilitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>;
export function useAmsBrowseCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseCapabilitiesQuery | undefined, AmsBrowseCapabilitiesQueryVariables>;
export function useAmsBrowseCapabilitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>(AmsBrowseCapabilitiesDocument, options);
        }
export type AmsBrowseCapabilitiesQueryHookResult = ReturnType<typeof useAmsBrowseCapabilitiesQuery>;
export type AmsBrowseCapabilitiesLazyQueryHookResult = ReturnType<typeof useAmsBrowseCapabilitiesLazyQuery>;
export type AmsBrowseCapabilitiesSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseCapabilitiesSuspenseQuery>;
export type AmsBrowseCapabilitiesQueryResult = Apollo.QueryResult<AmsBrowseCapabilitiesQuery, AmsBrowseCapabilitiesQueryVariables>;
export const AmsBrowseAccountsDocument = gql`
    query AmsBrowseAccounts($input: AmsBrowseAccountsInput!) {
  amsBrowseAccounts(input: $input) {
    accounts {
      ...AmsBrowseAccountFields
    }
    page {
      ...AmsBrowsePageFields
    }
  }
}
    ${AmsBrowseAccountFieldsFragmentDoc}
${AmsBrowsePageFieldsFragmentDoc}`;

/**
 * __useAmsBrowseAccountsQuery__
 *
 * To run a query within a React component, call `useAmsBrowseAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseAccountsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowseAccountsQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables> & ({ variables: AmsBrowseAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>(AmsBrowseAccountsDocument, options);
      }
export function useAmsBrowseAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>(AmsBrowseAccountsDocument, options);
        }
// @ts-ignore
export function useAmsBrowseAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>;
export function useAmsBrowseAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseAccountsQuery | undefined, AmsBrowseAccountsQueryVariables>;
export function useAmsBrowseAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>(AmsBrowseAccountsDocument, options);
        }
export type AmsBrowseAccountsQueryHookResult = ReturnType<typeof useAmsBrowseAccountsQuery>;
export type AmsBrowseAccountsLazyQueryHookResult = ReturnType<typeof useAmsBrowseAccountsLazyQuery>;
export type AmsBrowseAccountsSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseAccountsSuspenseQuery>;
export type AmsBrowseAccountsQueryResult = Apollo.QueryResult<AmsBrowseAccountsQuery, AmsBrowseAccountsQueryVariables>;
export const AmsBrowsePolicySearchDocument = gql`
    query AmsBrowsePolicySearch($input: AmsBrowsePolicySearchInput!) {
  amsBrowsePolicySearch(input: $input) {
    matches {
      policy {
        ...AmsBrowsePolicyFields
      }
      account {
        ...AmsBrowseAccountFields
      }
    }
    page {
      ...AmsBrowsePageFields
    }
  }
}
    ${AmsBrowsePolicyFieldsFragmentDoc}
${AmsBrowseAccountFieldsFragmentDoc}
${AmsBrowsePageFieldsFragmentDoc}`;

/**
 * __useAmsBrowsePolicySearchQuery__
 *
 * To run a query within a React component, call `useAmsBrowsePolicySearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowsePolicySearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowsePolicySearchQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowsePolicySearchQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables> & ({ variables: AmsBrowsePolicySearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>(AmsBrowsePolicySearchDocument, options);
      }
export function useAmsBrowsePolicySearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>(AmsBrowsePolicySearchDocument, options);
        }
// @ts-ignore
export function useAmsBrowsePolicySearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>;
export function useAmsBrowsePolicySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowsePolicySearchQuery | undefined, AmsBrowsePolicySearchQueryVariables>;
export function useAmsBrowsePolicySearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>(AmsBrowsePolicySearchDocument, options);
        }
export type AmsBrowsePolicySearchQueryHookResult = ReturnType<typeof useAmsBrowsePolicySearchQuery>;
export type AmsBrowsePolicySearchLazyQueryHookResult = ReturnType<typeof useAmsBrowsePolicySearchLazyQuery>;
export type AmsBrowsePolicySearchSuspenseQueryHookResult = ReturnType<typeof useAmsBrowsePolicySearchSuspenseQuery>;
export type AmsBrowsePolicySearchQueryResult = Apollo.QueryResult<AmsBrowsePolicySearchQuery, AmsBrowsePolicySearchQueryVariables>;
export const AmsBrowsePoliciesDocument = gql`
    query AmsBrowsePolicies($input: AmsBrowsePoliciesInput!) {
  amsBrowsePolicies(input: $input) {
    policies {
      ...AmsBrowsePolicyFields
    }
    page {
      ...AmsBrowsePageFields
    }
  }
}
    ${AmsBrowsePolicyFieldsFragmentDoc}
${AmsBrowsePageFieldsFragmentDoc}`;

/**
 * __useAmsBrowsePoliciesQuery__
 *
 * To run a query within a React component, call `useAmsBrowsePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowsePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowsePoliciesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowsePoliciesQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables> & ({ variables: AmsBrowsePoliciesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>(AmsBrowsePoliciesDocument, options);
      }
export function useAmsBrowsePoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>(AmsBrowsePoliciesDocument, options);
        }
// @ts-ignore
export function useAmsBrowsePoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>;
export function useAmsBrowsePoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowsePoliciesQuery | undefined, AmsBrowsePoliciesQueryVariables>;
export function useAmsBrowsePoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>(AmsBrowsePoliciesDocument, options);
        }
export type AmsBrowsePoliciesQueryHookResult = ReturnType<typeof useAmsBrowsePoliciesQuery>;
export type AmsBrowsePoliciesLazyQueryHookResult = ReturnType<typeof useAmsBrowsePoliciesLazyQuery>;
export type AmsBrowsePoliciesSuspenseQueryHookResult = ReturnType<typeof useAmsBrowsePoliciesSuspenseQuery>;
export type AmsBrowsePoliciesQueryResult = Apollo.QueryResult<AmsBrowsePoliciesQuery, AmsBrowsePoliciesQueryVariables>;
export const AmsBrowseCertificatesDocument = gql`
    query AmsBrowseCertificates($input: AmsBrowseCertificatesInput!) {
  amsBrowseCertificates(input: $input) {
    certificates {
      ref {
        ...AmsRefFields
      }
      title
      holder
      issuedAt
    }
    page {
      ...AmsBrowsePageFields
    }
  }
}
    ${AmsRefFieldsFragmentDoc}
${AmsBrowsePageFieldsFragmentDoc}`;

/**
 * __useAmsBrowseCertificatesQuery__
 *
 * To run a query within a React component, call `useAmsBrowseCertificatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseCertificatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseCertificatesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowseCertificatesQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables> & ({ variables: AmsBrowseCertificatesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>(AmsBrowseCertificatesDocument, options);
      }
export function useAmsBrowseCertificatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>(AmsBrowseCertificatesDocument, options);
        }
// @ts-ignore
export function useAmsBrowseCertificatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>;
export function useAmsBrowseCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseCertificatesQuery | undefined, AmsBrowseCertificatesQueryVariables>;
export function useAmsBrowseCertificatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>(AmsBrowseCertificatesDocument, options);
        }
export type AmsBrowseCertificatesQueryHookResult = ReturnType<typeof useAmsBrowseCertificatesQuery>;
export type AmsBrowseCertificatesLazyQueryHookResult = ReturnType<typeof useAmsBrowseCertificatesLazyQuery>;
export type AmsBrowseCertificatesSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseCertificatesSuspenseQuery>;
export type AmsBrowseCertificatesQueryResult = Apollo.QueryResult<AmsBrowseCertificatesQuery, AmsBrowseCertificatesQueryVariables>;
export const AmsBrowseFilesDocument = gql`
    query AmsBrowseFiles($input: AmsBrowseFilesInput!) {
  amsBrowseFiles(input: $input) {
    files {
      ref {
        ...AmsRefFields
      }
      title
      extension
      attachedAt
      folderPath
      selectable
      unselectableReason
    }
    page {
      ...AmsBrowsePageFields
    }
  }
}
    ${AmsRefFieldsFragmentDoc}
${AmsBrowsePageFieldsFragmentDoc}`;

/**
 * __useAmsBrowseFilesQuery__
 *
 * To run a query within a React component, call `useAmsBrowseFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseFilesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowseFilesQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables> & ({ variables: AmsBrowseFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>(AmsBrowseFilesDocument, options);
      }
export function useAmsBrowseFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>(AmsBrowseFilesDocument, options);
        }
// @ts-ignore
export function useAmsBrowseFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>;
export function useAmsBrowseFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseFilesQuery | undefined, AmsBrowseFilesQueryVariables>;
export function useAmsBrowseFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>(AmsBrowseFilesDocument, options);
        }
export type AmsBrowseFilesQueryHookResult = ReturnType<typeof useAmsBrowseFilesQuery>;
export type AmsBrowseFilesLazyQueryHookResult = ReturnType<typeof useAmsBrowseFilesLazyQuery>;
export type AmsBrowseFilesSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseFilesSuspenseQuery>;
export type AmsBrowseFilesQueryResult = Apollo.QueryResult<AmsBrowseFilesQuery, AmsBrowseFilesQueryVariables>;
export const AmsBrowseFoldersDocument = gql`
    query AmsBrowseFolders($input: AmsBrowseFoldersInput!) {
  amsBrowseFolders(input: $input) {
    ref {
      ...AmsRefFields
    }
    displayName
  }
}
    ${AmsRefFieldsFragmentDoc}`;

/**
 * __useAmsBrowseFoldersQuery__
 *
 * To run a query within a React component, call `useAmsBrowseFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseFoldersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowseFoldersQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables> & ({ variables: AmsBrowseFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>(AmsBrowseFoldersDocument, options);
      }
export function useAmsBrowseFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>(AmsBrowseFoldersDocument, options);
        }
// @ts-ignore
export function useAmsBrowseFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>;
export function useAmsBrowseFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseFoldersQuery | undefined, AmsBrowseFoldersQueryVariables>;
export function useAmsBrowseFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>(AmsBrowseFoldersDocument, options);
        }
export type AmsBrowseFoldersQueryHookResult = ReturnType<typeof useAmsBrowseFoldersQuery>;
export type AmsBrowseFoldersLazyQueryHookResult = ReturnType<typeof useAmsBrowseFoldersLazyQuery>;
export type AmsBrowseFoldersSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseFoldersSuspenseQuery>;
export type AmsBrowseFoldersQueryResult = Apollo.QueryResult<AmsBrowseFoldersQuery, AmsBrowseFoldersQueryVariables>;
export const AmsBrowseActivitiesDocument = gql`
    query AmsBrowseActivities($input: AmsBrowseActivitiesInput!) {
  amsBrowseActivities(input: $input) {
    ref {
      integrationId
      kind
      externalId
      accountExternalId
    }
    displayName
  }
}
    `;

/**
 * __useAmsBrowseActivitiesQuery__
 *
 * To run a query within a React component, call `useAmsBrowseActivitiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsBrowseActivitiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsBrowseActivitiesQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsBrowseActivitiesQuery(baseOptions: Apollo.QueryHookOptions<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables> & ({ variables: AmsBrowseActivitiesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>(AmsBrowseActivitiesDocument, options);
      }
export function useAmsBrowseActivitiesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>(AmsBrowseActivitiesDocument, options);
        }
// @ts-ignore
export function useAmsBrowseActivitiesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>;
export function useAmsBrowseActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>): Apollo.UseSuspenseQueryResult<AmsBrowseActivitiesQuery | undefined, AmsBrowseActivitiesQueryVariables>;
export function useAmsBrowseActivitiesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>(AmsBrowseActivitiesDocument, options);
        }
export type AmsBrowseActivitiesQueryHookResult = ReturnType<typeof useAmsBrowseActivitiesQuery>;
export type AmsBrowseActivitiesLazyQueryHookResult = ReturnType<typeof useAmsBrowseActivitiesLazyQuery>;
export type AmsBrowseActivitiesSuspenseQueryHookResult = ReturnType<typeof useAmsBrowseActivitiesSuspenseQuery>;
export type AmsBrowseActivitiesQueryResult = Apollo.QueryResult<AmsBrowseActivitiesQuery, AmsBrowseActivitiesQueryVariables>;
export const SearchAmsAccountsDocument = gql`
    query SearchAmsAccounts($query: String!, $limit: Int) {
  searchAmsAccounts(query: $query, limit: $limit) {
    entities {
      ...AmsAccountSearchResultFields
    }
    noSupportedAms
  }
}
    ${AmsAccountSearchResultFieldsFragmentDoc}`;

/**
 * __useSearchAmsAccountsQuery__
 *
 * To run a query within a React component, call `useSearchAmsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAmsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAmsAccountsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchAmsAccountsQuery(baseOptions: Apollo.QueryHookOptions<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables> & ({ variables: SearchAmsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>(SearchAmsAccountsDocument, options);
      }
export function useSearchAmsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>(SearchAmsAccountsDocument, options);
        }
// @ts-ignore
export function useSearchAmsAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>;
export function useSearchAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsQuery | undefined, SearchAmsAccountsQueryVariables>;
export function useSearchAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>(SearchAmsAccountsDocument, options);
        }
export type SearchAmsAccountsQueryHookResult = ReturnType<typeof useSearchAmsAccountsQuery>;
export type SearchAmsAccountsLazyQueryHookResult = ReturnType<typeof useSearchAmsAccountsLazyQuery>;
export type SearchAmsAccountsSuspenseQueryHookResult = ReturnType<typeof useSearchAmsAccountsSuspenseQuery>;
export type SearchAmsAccountsQueryResult = Apollo.QueryResult<SearchAmsAccountsQuery, SearchAmsAccountsQueryVariables>;
export const RequestAmsAccountRefreshDocument = gql`
    mutation RequestAmsAccountRefresh($accountId: ID!, $force: Boolean!, $scope: AmsAccountSyncScope) {
  requestAmsAccountRefresh(accountId: $accountId, force: $force, scope: $scope) {
    enqueued
    syncedAt
  }
}
    `;
export type RequestAmsAccountRefreshMutationFn = Apollo.MutationFunction<RequestAmsAccountRefreshMutation, RequestAmsAccountRefreshMutationVariables>;

/**
 * __useRequestAmsAccountRefreshMutation__
 *
 * To run a mutation, you first call `useRequestAmsAccountRefreshMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRequestAmsAccountRefreshMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [requestAmsAccountRefreshMutation, { data, loading, error }] = useRequestAmsAccountRefreshMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *      force: // value for 'force'
 *      scope: // value for 'scope'
 *   },
 * });
 */
export function useRequestAmsAccountRefreshMutation(baseOptions?: Apollo.MutationHookOptions<RequestAmsAccountRefreshMutation, RequestAmsAccountRefreshMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RequestAmsAccountRefreshMutation, RequestAmsAccountRefreshMutationVariables>(RequestAmsAccountRefreshDocument, options);
      }
export type RequestAmsAccountRefreshMutationHookResult = ReturnType<typeof useRequestAmsAccountRefreshMutation>;
export type RequestAmsAccountRefreshMutationResult = Apollo.MutationResult<RequestAmsAccountRefreshMutation>;
export type RequestAmsAccountRefreshMutationOptions = Apollo.BaseMutationOptions<RequestAmsAccountRefreshMutation, RequestAmsAccountRefreshMutationVariables>;
export const RunAmsReconciliationDocument = gql`
    mutation RunAmsReconciliation($input: RunAmsReconciliationInput!) {
  runAmsReconciliation(input: $input) {
    verdicts {
      ...AmsFieldVerdictFields
    }
    codeLists {
      ...AmsCodeListFields
    }
  }
}
    ${AmsFieldVerdictFieldsFragmentDoc}
${AmsCodeListFieldsFragmentDoc}`;
export type RunAmsReconciliationMutationFn = Apollo.MutationFunction<RunAmsReconciliationMutation, RunAmsReconciliationMutationVariables>;

/**
 * __useRunAmsReconciliationMutation__
 *
 * To run a mutation, you first call `useRunAmsReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAmsReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAmsReconciliationMutation, { data, loading, error }] = useRunAmsReconciliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAmsReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<RunAmsReconciliationMutation, RunAmsReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RunAmsReconciliationMutation, RunAmsReconciliationMutationVariables>(RunAmsReconciliationDocument, options);
      }
export type RunAmsReconciliationMutationHookResult = ReturnType<typeof useRunAmsReconciliationMutation>;
export type RunAmsReconciliationMutationResult = Apollo.MutationResult<RunAmsReconciliationMutation>;
export type RunAmsReconciliationMutationOptions = Apollo.BaseMutationOptions<RunAmsReconciliationMutation, RunAmsReconciliationMutationVariables>;
export const PrepareAmsReconciliationDocument = gql`
    mutation PrepareAmsReconciliation($input: PrepareAmsReconciliationInput!) {
  prepareAmsReconciliation(input: $input) {
    startingState
    detected {
      ...AmsDetectedEntitiesFields
    }
    workspaceClientAccount {
      ...AmsAccountMatchFields
    }
    suggestedAccounts {
      ...AmsAccountMatchFields
    }
    integrationId
    newAccountTargets {
      ...AmsReconciliationTargetFields
    }
  }
}
    ${AmsDetectedEntitiesFieldsFragmentDoc}
${AmsAccountMatchFieldsFragmentDoc}
${AmsReconciliationTargetFieldsFragmentDoc}`;
export type PrepareAmsReconciliationMutationFn = Apollo.MutationFunction<PrepareAmsReconciliationMutation, PrepareAmsReconciliationMutationVariables>;

/**
 * __usePrepareAmsReconciliationMutation__
 *
 * To run a mutation, you first call `usePrepareAmsReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePrepareAmsReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [prepareAmsReconciliationMutation, { data, loading, error }] = usePrepareAmsReconciliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePrepareAmsReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<PrepareAmsReconciliationMutation, PrepareAmsReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PrepareAmsReconciliationMutation, PrepareAmsReconciliationMutationVariables>(PrepareAmsReconciliationDocument, options);
      }
export type PrepareAmsReconciliationMutationHookResult = ReturnType<typeof usePrepareAmsReconciliationMutation>;
export type PrepareAmsReconciliationMutationResult = Apollo.MutationResult<PrepareAmsReconciliationMutation>;
export type PrepareAmsReconciliationMutationOptions = Apollo.BaseMutationOptions<PrepareAmsReconciliationMutation, PrepareAmsReconciliationMutationVariables>;
export const AmsReconciliationTargetsDocument = gql`
    query AmsReconciliationTargets($input: AmsReconciliationTargetsInput!) {
  amsReconciliationTargets(input: $input) {
    syncing
    targets {
      ...AmsReconciliationTargetFields
    }
  }
}
    ${AmsReconciliationTargetFieldsFragmentDoc}`;

/**
 * __useAmsReconciliationTargetsQuery__
 *
 * To run a query within a React component, call `useAmsReconciliationTargetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsReconciliationTargetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsReconciliationTargetsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAmsReconciliationTargetsQuery(baseOptions: Apollo.QueryHookOptions<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables> & ({ variables: AmsReconciliationTargetsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>(AmsReconciliationTargetsDocument, options);
      }
export function useAmsReconciliationTargetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>(AmsReconciliationTargetsDocument, options);
        }
// @ts-ignore
export function useAmsReconciliationTargetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>;
export function useAmsReconciliationTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>): Apollo.UseSuspenseQueryResult<AmsReconciliationTargetsQuery | undefined, AmsReconciliationTargetsQueryVariables>;
export function useAmsReconciliationTargetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>(AmsReconciliationTargetsDocument, options);
        }
export type AmsReconciliationTargetsQueryHookResult = ReturnType<typeof useAmsReconciliationTargetsQuery>;
export type AmsReconciliationTargetsLazyQueryHookResult = ReturnType<typeof useAmsReconciliationTargetsLazyQuery>;
export type AmsReconciliationTargetsSuspenseQueryHookResult = ReturnType<typeof useAmsReconciliationTargetsSuspenseQuery>;
export type AmsReconciliationTargetsQueryResult = Apollo.QueryResult<AmsReconciliationTargetsQuery, AmsReconciliationTargetsQueryVariables>;
export const ImportAmsAccountByExternalIdDocument = gql`
    mutation ImportAmsAccountByExternalId($input: ImportAmsAccountByExternalIdInput!) {
  importAmsAccountByExternalId(input: $input) {
    accountId
    displayName
    syncing
  }
}
    `;
export type ImportAmsAccountByExternalIdMutationFn = Apollo.MutationFunction<ImportAmsAccountByExternalIdMutation, ImportAmsAccountByExternalIdMutationVariables>;

/**
 * __useImportAmsAccountByExternalIdMutation__
 *
 * To run a mutation, you first call `useImportAmsAccountByExternalIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAmsAccountByExternalIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAmsAccountByExternalIdMutation, { data, loading, error }] = useImportAmsAccountByExternalIdMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useImportAmsAccountByExternalIdMutation(baseOptions?: Apollo.MutationHookOptions<ImportAmsAccountByExternalIdMutation, ImportAmsAccountByExternalIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportAmsAccountByExternalIdMutation, ImportAmsAccountByExternalIdMutationVariables>(ImportAmsAccountByExternalIdDocument, options);
      }
export type ImportAmsAccountByExternalIdMutationHookResult = ReturnType<typeof useImportAmsAccountByExternalIdMutation>;
export type ImportAmsAccountByExternalIdMutationResult = Apollo.MutationResult<ImportAmsAccountByExternalIdMutation>;
export type ImportAmsAccountByExternalIdMutationOptions = Apollo.BaseMutationOptions<ImportAmsAccountByExternalIdMutation, ImportAmsAccountByExternalIdMutationVariables>;
export const CreateAmsAccountDocument = gql`
    mutation CreateAmsAccount($input: CreateAmsAccountInput!) {
  createAmsAccount(input: $input) {
    accountId
    displayName
    syncing
  }
}
    `;
export type CreateAmsAccountMutationFn = Apollo.MutationFunction<CreateAmsAccountMutation, CreateAmsAccountMutationVariables>;

/**
 * __useCreateAmsAccountMutation__
 *
 * To run a mutation, you first call `useCreateAmsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAmsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAmsAccountMutation, { data, loading, error }] = useCreateAmsAccountMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateAmsAccountMutation(baseOptions?: Apollo.MutationHookOptions<CreateAmsAccountMutation, CreateAmsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAmsAccountMutation, CreateAmsAccountMutationVariables>(CreateAmsAccountDocument, options);
      }
export type CreateAmsAccountMutationHookResult = ReturnType<typeof useCreateAmsAccountMutation>;
export type CreateAmsAccountMutationResult = Apollo.MutationResult<CreateAmsAccountMutation>;
export type CreateAmsAccountMutationOptions = Apollo.BaseMutationOptions<CreateAmsAccountMutation, CreateAmsAccountMutationVariables>;
export const ApplyAmsReconciliationDocument = gql`
    mutation ApplyAmsReconciliation($input: ApplyAmsReconciliationInput!) {
  applyAmsReconciliation(input: $input) {
    written
    refused {
      itemKey
      parentKeys
      fieldPath
      kind
      message
    }
  }
}
    `;
export type ApplyAmsReconciliationMutationFn = Apollo.MutationFunction<ApplyAmsReconciliationMutation, ApplyAmsReconciliationMutationVariables>;

/**
 * __useApplyAmsReconciliationMutation__
 *
 * To run a mutation, you first call `useApplyAmsReconciliationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApplyAmsReconciliationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [applyAmsReconciliationMutation, { data, loading, error }] = useApplyAmsReconciliationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApplyAmsReconciliationMutation(baseOptions?: Apollo.MutationHookOptions<ApplyAmsReconciliationMutation, ApplyAmsReconciliationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApplyAmsReconciliationMutation, ApplyAmsReconciliationMutationVariables>(ApplyAmsReconciliationDocument, options);
      }
export type ApplyAmsReconciliationMutationHookResult = ReturnType<typeof useApplyAmsReconciliationMutation>;
export type ApplyAmsReconciliationMutationResult = Apollo.MutationResult<ApplyAmsReconciliationMutation>;
export type ApplyAmsReconciliationMutationOptions = Apollo.BaseMutationOptions<ApplyAmsReconciliationMutation, ApplyAmsReconciliationMutationVariables>;
export const SearchAmsAccountsLiveDocument = gql`
    query SearchAmsAccountsLive($input: SearchAmsAccountsLiveInput!) {
  searchAmsAccountsLive(input: $input) {
    ...AmsAccountMatchFields
  }
}
    ${AmsAccountMatchFieldsFragmentDoc}`;

/**
 * __useSearchAmsAccountsLiveQuery__
 *
 * To run a query within a React component, call `useSearchAmsAccountsLiveQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAmsAccountsLiveQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAmsAccountsLiveQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchAmsAccountsLiveQuery(baseOptions: Apollo.QueryHookOptions<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables> & ({ variables: SearchAmsAccountsLiveQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>(SearchAmsAccountsLiveDocument, options);
      }
export function useSearchAmsAccountsLiveLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>(SearchAmsAccountsLiveDocument, options);
        }
// @ts-ignore
export function useSearchAmsAccountsLiveSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>;
export function useSearchAmsAccountsLiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsLiveQuery | undefined, SearchAmsAccountsLiveQueryVariables>;
export function useSearchAmsAccountsLiveSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>(SearchAmsAccountsLiveDocument, options);
        }
export type SearchAmsAccountsLiveQueryHookResult = ReturnType<typeof useSearchAmsAccountsLiveQuery>;
export type SearchAmsAccountsLiveLazyQueryHookResult = ReturnType<typeof useSearchAmsAccountsLiveLazyQuery>;
export type SearchAmsAccountsLiveSuspenseQueryHookResult = ReturnType<typeof useSearchAmsAccountsLiveSuspenseQuery>;
export type SearchAmsAccountsLiveQueryResult = Apollo.QueryResult<SearchAmsAccountsLiveQuery, SearchAmsAccountsLiveQueryVariables>;
export const AmsAgencyStructureDocument = gql`
    query AmsAgencyStructure($integrationId: ID!) {
  amsAgencyStructure(integrationId: $integrationId) {
    code
    label
    branches {
      code
      label
    }
  }
}
    `;

/**
 * __useAmsAgencyStructureQuery__
 *
 * To run a query within a React component, call `useAmsAgencyStructureQuery` and pass it any options that fit your needs.
 * When your component renders, `useAmsAgencyStructureQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAmsAgencyStructureQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useAmsAgencyStructureQuery(baseOptions: Apollo.QueryHookOptions<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables> & ({ variables: AmsAgencyStructureQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>(AmsAgencyStructureDocument, options);
      }
export function useAmsAgencyStructureLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>(AmsAgencyStructureDocument, options);
        }
// @ts-ignore
export function useAmsAgencyStructureSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>): Apollo.UseSuspenseQueryResult<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>;
export function useAmsAgencyStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>): Apollo.UseSuspenseQueryResult<AmsAgencyStructureQuery | undefined, AmsAgencyStructureQueryVariables>;
export function useAmsAgencyStructureSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>(AmsAgencyStructureDocument, options);
        }
export type AmsAgencyStructureQueryHookResult = ReturnType<typeof useAmsAgencyStructureQuery>;
export type AmsAgencyStructureLazyQueryHookResult = ReturnType<typeof useAmsAgencyStructureLazyQuery>;
export type AmsAgencyStructureSuspenseQueryHookResult = ReturnType<typeof useAmsAgencyStructureSuspenseQuery>;
export type AmsAgencyStructureQueryResult = Apollo.QueryResult<AmsAgencyStructureQuery, AmsAgencyStructureQueryVariables>;
export const GetAdminAnalyticsReportDocument = gql`
    query GetAdminAnalyticsReport($filter: AdminAnalyticsFilterInput) {
  adminAnalyticsReport(filter: $filter) {
    ...AdminAnalyticsReportFields
  }
}
    ${AdminAnalyticsReportFieldsFragmentDoc}`;

/**
 * __useGetAdminAnalyticsReportQuery__
 *
 * To run a query within a React component, call `useGetAdminAnalyticsReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAnalyticsReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAnalyticsReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetAdminAnalyticsReportQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>(GetAdminAnalyticsReportDocument, options);
      }
export function useGetAdminAnalyticsReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>(GetAdminAnalyticsReportDocument, options);
        }
// @ts-ignore
export function useGetAdminAnalyticsReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>;
export function useGetAdminAnalyticsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsReportQuery | undefined, GetAdminAnalyticsReportQueryVariables>;
export function useGetAdminAnalyticsReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>(GetAdminAnalyticsReportDocument, options);
        }
export type GetAdminAnalyticsReportQueryHookResult = ReturnType<typeof useGetAdminAnalyticsReportQuery>;
export type GetAdminAnalyticsReportLazyQueryHookResult = ReturnType<typeof useGetAdminAnalyticsReportLazyQuery>;
export type GetAdminAnalyticsReportSuspenseQueryHookResult = ReturnType<typeof useGetAdminAnalyticsReportSuspenseQuery>;
export type GetAdminAnalyticsReportQueryResult = Apollo.QueryResult<GetAdminAnalyticsReportQuery, GetAdminAnalyticsReportQueryVariables>;
export const GetAdminAnalyticsAgencyProfileOptionsDocument = gql`
    query GetAdminAnalyticsAgencyProfileOptions($subagencyId: ID) {
  adminAnalyticsAgencyProfileOptions(subagencyId: $subagencyId) {
    agencyProfileId
    name
    isDefault
  }
}
    `;

/**
 * __useGetAdminAnalyticsAgencyProfileOptionsQuery__
 *
 * To run a query within a React component, call `useGetAdminAnalyticsAgencyProfileOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAnalyticsAgencyProfileOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAnalyticsAgencyProfileOptionsQuery({
 *   variables: {
 *      subagencyId: // value for 'subagencyId'
 *   },
 * });
 */
export function useGetAdminAnalyticsAgencyProfileOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>(GetAdminAnalyticsAgencyProfileOptionsDocument, options);
      }
export function useGetAdminAnalyticsAgencyProfileOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>(GetAdminAnalyticsAgencyProfileOptionsDocument, options);
        }
// @ts-ignore
export function useGetAdminAnalyticsAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>;
export function useGetAdminAnalyticsAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsAgencyProfileOptionsQuery | undefined, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>;
export function useGetAdminAnalyticsAgencyProfileOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>(GetAdminAnalyticsAgencyProfileOptionsDocument, options);
        }
export type GetAdminAnalyticsAgencyProfileOptionsQueryHookResult = ReturnType<typeof useGetAdminAnalyticsAgencyProfileOptionsQuery>;
export type GetAdminAnalyticsAgencyProfileOptionsLazyQueryHookResult = ReturnType<typeof useGetAdminAnalyticsAgencyProfileOptionsLazyQuery>;
export type GetAdminAnalyticsAgencyProfileOptionsSuspenseQueryHookResult = ReturnType<typeof useGetAdminAnalyticsAgencyProfileOptionsSuspenseQuery>;
export type GetAdminAnalyticsAgencyProfileOptionsQueryResult = Apollo.QueryResult<GetAdminAnalyticsAgencyProfileOptionsQuery, GetAdminAnalyticsAgencyProfileOptionsQueryVariables>;
export const GetAdminAnalyticsExportsDocument = gql`
    query GetAdminAnalyticsExports {
  adminAnalyticsExports {
    ...AdminAnalyticsExportFields
  }
}
    ${AdminAnalyticsExportFieldsFragmentDoc}`;

/**
 * __useGetAdminAnalyticsExportsQuery__
 *
 * To run a query within a React component, call `useGetAdminAnalyticsExportsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAdminAnalyticsExportsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAdminAnalyticsExportsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAdminAnalyticsExportsQuery(baseOptions?: Apollo.QueryHookOptions<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>(GetAdminAnalyticsExportsDocument, options);
      }
export function useGetAdminAnalyticsExportsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>(GetAdminAnalyticsExportsDocument, options);
        }
// @ts-ignore
export function useGetAdminAnalyticsExportsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>;
export function useGetAdminAnalyticsExportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>): Apollo.UseSuspenseQueryResult<GetAdminAnalyticsExportsQuery | undefined, GetAdminAnalyticsExportsQueryVariables>;
export function useGetAdminAnalyticsExportsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>(GetAdminAnalyticsExportsDocument, options);
        }
export type GetAdminAnalyticsExportsQueryHookResult = ReturnType<typeof useGetAdminAnalyticsExportsQuery>;
export type GetAdminAnalyticsExportsLazyQueryHookResult = ReturnType<typeof useGetAdminAnalyticsExportsLazyQuery>;
export type GetAdminAnalyticsExportsSuspenseQueryHookResult = ReturnType<typeof useGetAdminAnalyticsExportsSuspenseQuery>;
export type GetAdminAnalyticsExportsQueryResult = Apollo.QueryResult<GetAdminAnalyticsExportsQuery, GetAdminAnalyticsExportsQueryVariables>;
export const StartAdminAnalyticsExportDocument = gql`
    mutation StartAdminAnalyticsExport($input: StartAdminAnalyticsExportInput!) {
  startAdminAnalyticsExport(input: $input) {
    ...AdminAnalyticsExportFields
  }
}
    ${AdminAnalyticsExportFieldsFragmentDoc}`;
export type StartAdminAnalyticsExportMutationFn = Apollo.MutationFunction<StartAdminAnalyticsExportMutation, StartAdminAnalyticsExportMutationVariables>;

/**
 * __useStartAdminAnalyticsExportMutation__
 *
 * To run a mutation, you first call `useStartAdminAnalyticsExportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartAdminAnalyticsExportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startAdminAnalyticsExportMutation, { data, loading, error }] = useStartAdminAnalyticsExportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartAdminAnalyticsExportMutation(baseOptions?: Apollo.MutationHookOptions<StartAdminAnalyticsExportMutation, StartAdminAnalyticsExportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartAdminAnalyticsExportMutation, StartAdminAnalyticsExportMutationVariables>(StartAdminAnalyticsExportDocument, options);
      }
export type StartAdminAnalyticsExportMutationHookResult = ReturnType<typeof useStartAdminAnalyticsExportMutation>;
export type StartAdminAnalyticsExportMutationResult = Apollo.MutationResult<StartAdminAnalyticsExportMutation>;
export type StartAdminAnalyticsExportMutationOptions = Apollo.BaseMutationOptions<StartAdminAnalyticsExportMutation, StartAdminAnalyticsExportMutationVariables>;
export const CreateAdminAnalyticsExportDownloadUrlDocument = gql`
    mutation CreateAdminAnalyticsExportDownloadUrl($id: ID!) {
  createAdminAnalyticsExportDownloadUrl(id: $id)
}
    `;
export type CreateAdminAnalyticsExportDownloadUrlMutationFn = Apollo.MutationFunction<CreateAdminAnalyticsExportDownloadUrlMutation, CreateAdminAnalyticsExportDownloadUrlMutationVariables>;

/**
 * __useCreateAdminAnalyticsExportDownloadUrlMutation__
 *
 * To run a mutation, you first call `useCreateAdminAnalyticsExportDownloadUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateAdminAnalyticsExportDownloadUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createAdminAnalyticsExportDownloadUrlMutation, { data, loading, error }] = useCreateAdminAnalyticsExportDownloadUrlMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCreateAdminAnalyticsExportDownloadUrlMutation(baseOptions?: Apollo.MutationHookOptions<CreateAdminAnalyticsExportDownloadUrlMutation, CreateAdminAnalyticsExportDownloadUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateAdminAnalyticsExportDownloadUrlMutation, CreateAdminAnalyticsExportDownloadUrlMutationVariables>(CreateAdminAnalyticsExportDownloadUrlDocument, options);
      }
export type CreateAdminAnalyticsExportDownloadUrlMutationHookResult = ReturnType<typeof useCreateAdminAnalyticsExportDownloadUrlMutation>;
export type CreateAdminAnalyticsExportDownloadUrlMutationResult = Apollo.MutationResult<CreateAdminAnalyticsExportDownloadUrlMutation>;
export type CreateAdminAnalyticsExportDownloadUrlMutationOptions = Apollo.BaseMutationOptions<CreateAdminAnalyticsExportDownloadUrlMutation, CreateAdminAnalyticsExportDownloadUrlMutationVariables>;
export const SignInDocument = gql`
    mutation SignIn($email: String!) {
  agencySignIn(email: $email) {
    ...AgencySignInFields
  }
}
    ${AgencySignInFieldsFragmentDoc}`;
export type SignInMutationFn = Apollo.MutationFunction<SignInMutation, SignInMutationVariables>;

/**
 * __useSignInMutation__
 *
 * To run a mutation, you first call `useSignInMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInMutation, { data, loading, error }] = useSignInMutation({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useSignInMutation(baseOptions?: Apollo.MutationHookOptions<SignInMutation, SignInMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInMutation, SignInMutationVariables>(SignInDocument, options);
      }
export type SignInMutationHookResult = ReturnType<typeof useSignInMutation>;
export type SignInMutationResult = Apollo.MutationResult<SignInMutation>;
export type SignInMutationOptions = Apollo.BaseMutationOptions<SignInMutation, SignInMutationVariables>;
export const SignInCompleteDocument = gql`
    mutation SignInComplete($email: String!, $code: String!) {
  agencySignIn(email: $email, code: $code) {
    ...AgencySignInFields
  }
}
    ${AgencySignInFieldsFragmentDoc}`;
export type SignInCompleteMutationFn = Apollo.MutationFunction<SignInCompleteMutation, SignInCompleteMutationVariables>;

/**
 * __useSignInCompleteMutation__
 *
 * To run a mutation, you first call `useSignInCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignInCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signInCompleteMutation, { data, loading, error }] = useSignInCompleteMutation({
 *   variables: {
 *      email: // value for 'email'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useSignInCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SignInCompleteMutation, SignInCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignInCompleteMutation, SignInCompleteMutationVariables>(SignInCompleteDocument, options);
      }
export type SignInCompleteMutationHookResult = ReturnType<typeof useSignInCompleteMutation>;
export type SignInCompleteMutationResult = Apollo.MutationResult<SignInCompleteMutation>;
export type SignInCompleteMutationOptions = Apollo.BaseMutationOptions<SignInCompleteMutation, SignInCompleteMutationVariables>;
export const SignOutDocument = gql`
    mutation SignOut {
  agencySignOut
}
    `;
export type SignOutMutationFn = Apollo.MutationFunction<SignOutMutation, SignOutMutationVariables>;

/**
 * __useSignOutMutation__
 *
 * To run a mutation, you first call `useSignOutMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignOutMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signOutMutation, { data, loading, error }] = useSignOutMutation({
 *   variables: {
 *   },
 * });
 */
export function useSignOutMutation(baseOptions?: Apollo.MutationHookOptions<SignOutMutation, SignOutMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignOutMutation, SignOutMutationVariables>(SignOutDocument, options);
      }
export type SignOutMutationHookResult = ReturnType<typeof useSignOutMutation>;
export type SignOutMutationResult = Apollo.MutationResult<SignOutMutation>;
export type SignOutMutationOptions = Apollo.BaseMutationOptions<SignOutMutation, SignOutMutationVariables>;
export const GetInsuranceCarriersDocument = gql`
    query GetInsuranceCarriers {
  carriers {
    ...InsuranceCarrierFields
  }
}
    ${InsuranceCarrierFieldsFragmentDoc}`;

/**
 * __useGetInsuranceCarriersQuery__
 *
 * To run a query within a React component, call `useGetInsuranceCarriersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceCarriersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceCarriersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsuranceCarriersQuery(baseOptions?: Apollo.QueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(GetInsuranceCarriersDocument, options);
      }
export function useGetInsuranceCarriersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(GetInsuranceCarriersDocument, options);
        }
// @ts-ignore
export function useGetInsuranceCarriersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>;
export function useGetInsuranceCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>): Apollo.UseSuspenseQueryResult<GetInsuranceCarriersQuery | undefined, GetInsuranceCarriersQueryVariables>;
export function useGetInsuranceCarriersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>(GetInsuranceCarriersDocument, options);
        }
export type GetInsuranceCarriersQueryHookResult = ReturnType<typeof useGetInsuranceCarriersQuery>;
export type GetInsuranceCarriersLazyQueryHookResult = ReturnType<typeof useGetInsuranceCarriersLazyQuery>;
export type GetInsuranceCarriersSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceCarriersSuspenseQuery>;
export type GetInsuranceCarriersQueryResult = Apollo.QueryResult<GetInsuranceCarriersQuery, GetInsuranceCarriersQueryVariables>;
export const GetBusinessPoliciesDocument = gql`
    query GetBusinessPolicies {
  businessPolicies {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;

/**
 * __useGetBusinessPoliciesQuery__
 *
 * To run a query within a React component, call `useGetBusinessPoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetBusinessPoliciesQuery(baseOptions?: Apollo.QueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
      }
export function useGetBusinessPoliciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
        }
// @ts-ignore
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>;
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPoliciesQuery | undefined, GetBusinessPoliciesQueryVariables>;
export function useGetBusinessPoliciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>(GetBusinessPoliciesDocument, options);
        }
export type GetBusinessPoliciesQueryHookResult = ReturnType<typeof useGetBusinessPoliciesQuery>;
export type GetBusinessPoliciesLazyQueryHookResult = ReturnType<typeof useGetBusinessPoliciesLazyQuery>;
export type GetBusinessPoliciesSuspenseQueryHookResult = ReturnType<typeof useGetBusinessPoliciesSuspenseQuery>;
export type GetBusinessPoliciesQueryResult = Apollo.QueryResult<GetBusinessPoliciesQuery, GetBusinessPoliciesQueryVariables>;
export const GetBusinessPolicyDocument = gql`
    query GetBusinessPolicy($id: ID!) {
  businessPolicy(id: $id) {
    ...BusinessPolicyFields
    ...BusinessPolicyDetailFields
    ...BusinessPolicyFileFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}
${BusinessPolicyDetailFieldsFragmentDoc}
${BusinessPolicyFileFieldsFragmentDoc}`;

/**
 * __useGetBusinessPolicyQuery__
 *
 * To run a query within a React component, call `useGetBusinessPolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetBusinessPolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetBusinessPolicyQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetBusinessPolicyQuery(baseOptions: Apollo.QueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables> & ({ variables: GetBusinessPolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
      }
export function useGetBusinessPolicyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
        }
// @ts-ignore
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>;
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>): Apollo.UseSuspenseQueryResult<GetBusinessPolicyQuery | undefined, GetBusinessPolicyQueryVariables>;
export function useGetBusinessPolicySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>(GetBusinessPolicyDocument, options);
        }
export type GetBusinessPolicyQueryHookResult = ReturnType<typeof useGetBusinessPolicyQuery>;
export type GetBusinessPolicyLazyQueryHookResult = ReturnType<typeof useGetBusinessPolicyLazyQuery>;
export type GetBusinessPolicySuspenseQueryHookResult = ReturnType<typeof useGetBusinessPolicySuspenseQuery>;
export type GetBusinessPolicyQueryResult = Apollo.QueryResult<GetBusinessPolicyQuery, GetBusinessPolicyQueryVariables>;
export const CreateBusinessPoliciesDocument = gql`
    mutation CreateBusinessPolicies($input: CreateBusinessPoliciesInput!) {
  createBusinessPolicies(req: $input) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type CreateBusinessPoliciesMutationFn = Apollo.MutationFunction<CreateBusinessPoliciesMutation, CreateBusinessPoliciesMutationVariables>;

/**
 * __useCreateBusinessPoliciesMutation__
 *
 * To run a mutation, you first call `useCreateBusinessPoliciesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateBusinessPoliciesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createBusinessPoliciesMutation, { data, loading, error }] = useCreateBusinessPoliciesMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateBusinessPoliciesMutation(baseOptions?: Apollo.MutationHookOptions<CreateBusinessPoliciesMutation, CreateBusinessPoliciesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateBusinessPoliciesMutation, CreateBusinessPoliciesMutationVariables>(CreateBusinessPoliciesDocument, options);
      }
export type CreateBusinessPoliciesMutationHookResult = ReturnType<typeof useCreateBusinessPoliciesMutation>;
export type CreateBusinessPoliciesMutationResult = Apollo.MutationResult<CreateBusinessPoliciesMutation>;
export type CreateBusinessPoliciesMutationOptions = Apollo.BaseMutationOptions<CreateBusinessPoliciesMutation, CreateBusinessPoliciesMutationVariables>;
export const UpdateBusinessPolicyDocument = gql`
    mutation UpdateBusinessPolicy($id: ID!, $input: UpdateBusinessPolicyInput!) {
  updateBusinessPolicy(id: $id, req: $input) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type UpdateBusinessPolicyMutationFn = Apollo.MutationFunction<UpdateBusinessPolicyMutation, UpdateBusinessPolicyMutationVariables>;

/**
 * __useUpdateBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useUpdateBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateBusinessPolicyMutation, { data, loading, error }] = useUpdateBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateBusinessPolicyMutation(baseOptions?: Apollo.MutationHookOptions<UpdateBusinessPolicyMutation, UpdateBusinessPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateBusinessPolicyMutation, UpdateBusinessPolicyMutationVariables>(UpdateBusinessPolicyDocument, options);
      }
export type UpdateBusinessPolicyMutationHookResult = ReturnType<typeof useUpdateBusinessPolicyMutation>;
export type UpdateBusinessPolicyMutationResult = Apollo.MutationResult<UpdateBusinessPolicyMutation>;
export type UpdateBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<UpdateBusinessPolicyMutation, UpdateBusinessPolicyMutationVariables>;
export const DeleteBusinessPolicyDocument = gql`
    mutation DeleteBusinessPolicy($id: ID!) {
  deleteBusinessPolicy(id: $id) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type DeleteBusinessPolicyMutationFn = Apollo.MutationFunction<DeleteBusinessPolicyMutation, DeleteBusinessPolicyMutationVariables>;

/**
 * __useDeleteBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useDeleteBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteBusinessPolicyMutation, { data, loading, error }] = useDeleteBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteBusinessPolicyMutation(baseOptions?: Apollo.MutationHookOptions<DeleteBusinessPolicyMutation, DeleteBusinessPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteBusinessPolicyMutation, DeleteBusinessPolicyMutationVariables>(DeleteBusinessPolicyDocument, options);
      }
export type DeleteBusinessPolicyMutationHookResult = ReturnType<typeof useDeleteBusinessPolicyMutation>;
export type DeleteBusinessPolicyMutationResult = Apollo.MutationResult<DeleteBusinessPolicyMutation>;
export type DeleteBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<DeleteBusinessPolicyMutation, DeleteBusinessPolicyMutationVariables>;
export const CancelBusinessPolicyDocument = gql`
    mutation CancelBusinessPolicy($id: ID!, $input: CancelBusinessPolicyInput!) {
  cancelBusinessPolicy(id: $id, req: $input) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type CancelBusinessPolicyMutationFn = Apollo.MutationFunction<CancelBusinessPolicyMutation, CancelBusinessPolicyMutationVariables>;

/**
 * __useCancelBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useCancelBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelBusinessPolicyMutation, { data, loading, error }] = useCancelBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelBusinessPolicyMutation(baseOptions?: Apollo.MutationHookOptions<CancelBusinessPolicyMutation, CancelBusinessPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelBusinessPolicyMutation, CancelBusinessPolicyMutationVariables>(CancelBusinessPolicyDocument, options);
      }
export type CancelBusinessPolicyMutationHookResult = ReturnType<typeof useCancelBusinessPolicyMutation>;
export type CancelBusinessPolicyMutationResult = Apollo.MutationResult<CancelBusinessPolicyMutation>;
export type CancelBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<CancelBusinessPolicyMutation, CancelBusinessPolicyMutationVariables>;
export const RenewBusinessPolicyDocument = gql`
    mutation RenewBusinessPolicy($id: ID!, $input: RenewBusinessPolicyInput!) {
  renewBusinessPolicy(id: $id, req: $input) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type RenewBusinessPolicyMutationFn = Apollo.MutationFunction<RenewBusinessPolicyMutation, RenewBusinessPolicyMutationVariables>;

/**
 * __useRenewBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useRenewBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenewBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renewBusinessPolicyMutation, { data, loading, error }] = useRenewBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRenewBusinessPolicyMutation(baseOptions?: Apollo.MutationHookOptions<RenewBusinessPolicyMutation, RenewBusinessPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenewBusinessPolicyMutation, RenewBusinessPolicyMutationVariables>(RenewBusinessPolicyDocument, options);
      }
export type RenewBusinessPolicyMutationHookResult = ReturnType<typeof useRenewBusinessPolicyMutation>;
export type RenewBusinessPolicyMutationResult = Apollo.MutationResult<RenewBusinessPolicyMutation>;
export type RenewBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<RenewBusinessPolicyMutation, RenewBusinessPolicyMutationVariables>;
export const ReinstateBusinessPolicyDocument = gql`
    mutation ReinstateBusinessPolicy($id: ID!, $input: ReinstateBusinessPolicyInput!) {
  reinstateBusinessPolicy(id: $id, req: $input) {
    ...BusinessPolicyFields
  }
}
    ${BusinessPolicyFieldsFragmentDoc}`;
export type ReinstateBusinessPolicyMutationFn = Apollo.MutationFunction<ReinstateBusinessPolicyMutation, ReinstateBusinessPolicyMutationVariables>;

/**
 * __useReinstateBusinessPolicyMutation__
 *
 * To run a mutation, you first call `useReinstateBusinessPolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateBusinessPolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateBusinessPolicyMutation, { data, loading, error }] = useReinstateBusinessPolicyMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useReinstateBusinessPolicyMutation(baseOptions?: Apollo.MutationHookOptions<ReinstateBusinessPolicyMutation, ReinstateBusinessPolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinstateBusinessPolicyMutation, ReinstateBusinessPolicyMutationVariables>(ReinstateBusinessPolicyDocument, options);
      }
export type ReinstateBusinessPolicyMutationHookResult = ReturnType<typeof useReinstateBusinessPolicyMutation>;
export type ReinstateBusinessPolicyMutationResult = Apollo.MutationResult<ReinstateBusinessPolicyMutation>;
export type ReinstateBusinessPolicyMutationOptions = Apollo.BaseMutationOptions<ReinstateBusinessPolicyMutation, ReinstateBusinessPolicyMutationVariables>;
export const UploadPolicyFileDocument = gql`
    mutation UploadPolicyFile($policyId: ID!, $file: UploadFileInput!) {
  uploadPolicyFile(policyId: $policyId, file: $file) {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export type UploadPolicyFileMutationFn = Apollo.MutationFunction<UploadPolicyFileMutation, UploadPolicyFileMutationVariables>;

/**
 * __useUploadPolicyFileMutation__
 *
 * To run a mutation, you first call `useUploadPolicyFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadPolicyFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadPolicyFileMutation, { data, loading, error }] = useUploadPolicyFileMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadPolicyFileMutation(baseOptions?: Apollo.MutationHookOptions<UploadPolicyFileMutation, UploadPolicyFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadPolicyFileMutation, UploadPolicyFileMutationVariables>(UploadPolicyFileDocument, options);
      }
export type UploadPolicyFileMutationHookResult = ReturnType<typeof useUploadPolicyFileMutation>;
export type UploadPolicyFileMutationResult = Apollo.MutationResult<UploadPolicyFileMutation>;
export type UploadPolicyFileMutationOptions = Apollo.BaseMutationOptions<UploadPolicyFileMutation, UploadPolicyFileMutationVariables>;
export const GetCallsDocument = gql`
    query GetCalls($filter: CallFilterInput) {
  calls(filter: $filter) {
    ...CallFields
  }
}
    ${CallFieldsFragmentDoc}`;

/**
 * __useGetCallsQuery__
 *
 * To run a query within a React component, call `useGetCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCallsQuery(baseOptions?: Apollo.QueryHookOptions<GetCallsQuery, GetCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
      }
export function useGetCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
        }
// @ts-ignore
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallsQuery, GetCallsQueryVariables>;
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallsQuery | undefined, GetCallsQueryVariables>;
export function useGetCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallsQuery, GetCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallsQuery, GetCallsQueryVariables>(GetCallsDocument, options);
        }
export type GetCallsQueryHookResult = ReturnType<typeof useGetCallsQuery>;
export type GetCallsLazyQueryHookResult = ReturnType<typeof useGetCallsLazyQuery>;
export type GetCallsSuspenseQueryHookResult = ReturnType<typeof useGetCallsSuspenseQuery>;
export type GetCallsQueryResult = Apollo.QueryResult<GetCallsQuery, GetCallsQueryVariables>;
export const SearchCallsDocument = gql`
    query SearchCalls($first: Int, $after: String, $filter: CallFilterInput, $sort: CallSortInput) {
  searchCalls(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...CallFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${CallFieldsFragmentDoc}`;

/**
 * __useSearchCallsQuery__
 *
 * To run a query within a React component, call `useSearchCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCallsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchCallsQuery(baseOptions?: Apollo.QueryHookOptions<SearchCallsQuery, SearchCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCallsQuery, SearchCallsQueryVariables>(SearchCallsDocument, options);
      }
export function useSearchCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCallsQuery, SearchCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCallsQuery, SearchCallsQueryVariables>(SearchCallsDocument, options);
        }
// @ts-ignore
export function useSearchCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCallsQuery, SearchCallsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCallsQuery, SearchCallsQueryVariables>;
export function useSearchCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCallsQuery, SearchCallsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCallsQuery | undefined, SearchCallsQueryVariables>;
export function useSearchCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCallsQuery, SearchCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCallsQuery, SearchCallsQueryVariables>(SearchCallsDocument, options);
        }
export type SearchCallsQueryHookResult = ReturnType<typeof useSearchCallsQuery>;
export type SearchCallsLazyQueryHookResult = ReturnType<typeof useSearchCallsLazyQuery>;
export type SearchCallsSuspenseQueryHookResult = ReturnType<typeof useSearchCallsSuspenseQuery>;
export type SearchCallsQueryResult = Apollo.QueryResult<SearchCallsQuery, SearchCallsQueryVariables>;
export const GetCallDocument = gql`
    query GetCall($id: ID!) {
  call(id: $id) {
    ...CallFields
    ...CallTranscriptFields
  }
}
    ${CallFieldsFragmentDoc}
${CallTranscriptFieldsFragmentDoc}`;

/**
 * __useGetCallQuery__
 *
 * To run a query within a React component, call `useGetCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCallQuery(baseOptions: Apollo.QueryHookOptions<GetCallQuery, GetCallQueryVariables> & ({ variables: GetCallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
      }
export function useGetCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallQuery, GetCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
        }
// @ts-ignore
export function useGetCallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallQuery, GetCallQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallQuery, GetCallQueryVariables>;
export function useGetCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallQuery, GetCallQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallQuery | undefined, GetCallQueryVariables>;
export function useGetCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallQuery, GetCallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallQuery, GetCallQueryVariables>(GetCallDocument, options);
        }
export type GetCallQueryHookResult = ReturnType<typeof useGetCallQuery>;
export type GetCallLazyQueryHookResult = ReturnType<typeof useGetCallLazyQuery>;
export type GetCallSuspenseQueryHookResult = ReturnType<typeof useGetCallSuspenseQuery>;
export type GetCallQueryResult = Apollo.QueryResult<GetCallQuery, GetCallQueryVariables>;
export const GetCallReportDocument = gql`
    query GetCallReport($filter: CallFilterInput) {
  callReport(filter: $filter) {
    ...CallReportFields
  }
}
    ${CallReportFieldsFragmentDoc}`;

/**
 * __useGetCallReportQuery__
 *
 * To run a query within a React component, call `useGetCallReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCallReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCallReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCallReportQuery(baseOptions?: Apollo.QueryHookOptions<GetCallReportQuery, GetCallReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCallReportQuery, GetCallReportQueryVariables>(GetCallReportDocument, options);
      }
export function useGetCallReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCallReportQuery, GetCallReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCallReportQuery, GetCallReportQueryVariables>(GetCallReportDocument, options);
        }
// @ts-ignore
export function useGetCallReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCallReportQuery, GetCallReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallReportQuery, GetCallReportQueryVariables>;
export function useGetCallReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallReportQuery, GetCallReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetCallReportQuery | undefined, GetCallReportQueryVariables>;
export function useGetCallReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCallReportQuery, GetCallReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCallReportQuery, GetCallReportQueryVariables>(GetCallReportDocument, options);
        }
export type GetCallReportQueryHookResult = ReturnType<typeof useGetCallReportQuery>;
export type GetCallReportLazyQueryHookResult = ReturnType<typeof useGetCallReportLazyQuery>;
export type GetCallReportSuspenseQueryHookResult = ReturnType<typeof useGetCallReportSuspenseQuery>;
export type GetCallReportQueryResult = Apollo.QueryResult<GetCallReportQuery, GetCallReportQueryVariables>;
export const UpdateCallsDocument = gql`
    mutation UpdateCalls($callIds: [ID!]!, $input: UpdateCallInput!) {
  updateCalls(callIds: $callIds, input: $input) {
    ...CallFields
  }
}
    ${CallFieldsFragmentDoc}`;
export type UpdateCallsMutationFn = Apollo.MutationFunction<UpdateCallsMutation, UpdateCallsMutationVariables>;

/**
 * __useUpdateCallsMutation__
 *
 * To run a mutation, you first call `useUpdateCallsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCallsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCallsMutation, { data, loading, error }] = useUpdateCallsMutation({
 *   variables: {
 *      callIds: // value for 'callIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCallsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCallsMutation, UpdateCallsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCallsMutation, UpdateCallsMutationVariables>(UpdateCallsDocument, options);
      }
export type UpdateCallsMutationHookResult = ReturnType<typeof useUpdateCallsMutation>;
export type UpdateCallsMutationResult = Apollo.MutationResult<UpdateCallsMutation>;
export type UpdateCallsMutationOptions = Apollo.BaseMutationOptions<UpdateCallsMutation, UpdateCallsMutationVariables>;
export const GetCaraWorkspaceDocument = gql`
    query GetCaraWorkspace($id: ID!) {
  caraWorkspace(id: $id) {
    ...CaraWorkspaceFields
  }
}
    ${CaraWorkspaceFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspaceQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCaraWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables> & ({ variables: GetCaraWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(GetCaraWorkspaceDocument, options);
      }
export function useGetCaraWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(GetCaraWorkspaceDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>;
export function useGetCaraWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceQuery | undefined, GetCaraWorkspaceQueryVariables>;
export function useGetCaraWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>(GetCaraWorkspaceDocument, options);
        }
export type GetCaraWorkspaceQueryHookResult = ReturnType<typeof useGetCaraWorkspaceQuery>;
export type GetCaraWorkspaceLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceLazyQuery>;
export type GetCaraWorkspaceSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceSuspenseQuery>;
export type GetCaraWorkspaceQueryResult = Apollo.QueryResult<GetCaraWorkspaceQuery, GetCaraWorkspaceQueryVariables>;
export const GetCaraWorkspacesDocument = gql`
    query GetCaraWorkspaces {
  caraWorkspaces {
    ...CaraWorkspaceOverviewFields
  }
}
    ${CaraWorkspaceOverviewFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspacesQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspacesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCaraWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(GetCaraWorkspacesDocument, options);
      }
export function useGetCaraWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(GetCaraWorkspacesDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>;
export function useGetCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspacesQuery | undefined, GetCaraWorkspacesQueryVariables>;
export function useGetCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>(GetCaraWorkspacesDocument, options);
        }
export type GetCaraWorkspacesQueryHookResult = ReturnType<typeof useGetCaraWorkspacesQuery>;
export type GetCaraWorkspacesLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspacesLazyQuery>;
export type GetCaraWorkspacesSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspacesSuspenseQuery>;
export type GetCaraWorkspacesQueryResult = Apollo.QueryResult<GetCaraWorkspacesQuery, GetCaraWorkspacesQueryVariables>;
export const SearchCaraWorkspacesDocument = gql`
    query SearchCaraWorkspaces($first: Int, $after: String, $filter: SearchCaraWorkspacesFilterInput, $sort: CaraWorkspaceSortInput) {
  searchCaraWorkspaces(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...CaraWorkspaceOverviewFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${CaraWorkspaceOverviewFieldsFragmentDoc}`;

/**
 * __useSearchCaraWorkspacesQuery__
 *
 * To run a query within a React component, call `useSearchCaraWorkspacesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCaraWorkspacesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCaraWorkspacesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchCaraWorkspacesQuery(baseOptions?: Apollo.QueryHookOptions<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>(SearchCaraWorkspacesDocument, options);
      }
export function useSearchCaraWorkspacesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>(SearchCaraWorkspacesDocument, options);
        }
// @ts-ignore
export function useSearchCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>;
export function useSearchCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchCaraWorkspacesQuery | undefined, SearchCaraWorkspacesQueryVariables>;
export function useSearchCaraWorkspacesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>(SearchCaraWorkspacesDocument, options);
        }
export type SearchCaraWorkspacesQueryHookResult = ReturnType<typeof useSearchCaraWorkspacesQuery>;
export type SearchCaraWorkspacesLazyQueryHookResult = ReturnType<typeof useSearchCaraWorkspacesLazyQuery>;
export type SearchCaraWorkspacesSuspenseQueryHookResult = ReturnType<typeof useSearchCaraWorkspacesSuspenseQuery>;
export type SearchCaraWorkspacesQueryResult = Apollo.QueryResult<SearchCaraWorkspacesQuery, SearchCaraWorkspacesQueryVariables>;
export const GetCaraWorkspaceArtifactsDocument = gql`
    query GetCaraWorkspaceArtifacts($filter: CaraWorkspaceArtifactFilter) {
  caraWorkspaceArtifacts(filter: $filter) {
    ...CaraWorkspaceArtifactSummaryFields
  }
}
    ${CaraWorkspaceArtifactSummaryFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspaceArtifactsQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceArtifactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetCaraWorkspaceArtifactsQuery(baseOptions?: Apollo.QueryHookOptions<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>(GetCaraWorkspaceArtifactsDocument, options);
      }
export function useGetCaraWorkspaceArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>(GetCaraWorkspaceArtifactsDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>;
export function useGetCaraWorkspaceArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactsQuery | undefined, GetCaraWorkspaceArtifactsQueryVariables>;
export function useGetCaraWorkspaceArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>(GetCaraWorkspaceArtifactsDocument, options);
        }
export type GetCaraWorkspaceArtifactsQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactsQuery>;
export type GetCaraWorkspaceArtifactsLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactsLazyQuery>;
export type GetCaraWorkspaceArtifactsSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactsSuspenseQuery>;
export type GetCaraWorkspaceArtifactsQueryResult = Apollo.QueryResult<GetCaraWorkspaceArtifactsQuery, GetCaraWorkspaceArtifactsQueryVariables>;
export const SearchOutboxArtifactsDocument = gql`
    query SearchOutboxArtifacts($first: Int, $after: String, $filter: CaraWorkspaceArtifactsFilterInput) {
  searchCaraWorkspaceArtifacts(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        ...OutboxArtifactFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${OutboxArtifactFieldsFragmentDoc}`;

/**
 * __useSearchOutboxArtifactsQuery__
 *
 * To run a query within a React component, call `useSearchOutboxArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutboxArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutboxArtifactsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchOutboxArtifactsQuery(baseOptions?: Apollo.QueryHookOptions<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>(SearchOutboxArtifactsDocument, options);
      }
export function useSearchOutboxArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>(SearchOutboxArtifactsDocument, options);
        }
// @ts-ignore
export function useSearchOutboxArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>;
export function useSearchOutboxArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboxArtifactsQuery | undefined, SearchOutboxArtifactsQueryVariables>;
export function useSearchOutboxArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>(SearchOutboxArtifactsDocument, options);
        }
export type SearchOutboxArtifactsQueryHookResult = ReturnType<typeof useSearchOutboxArtifactsQuery>;
export type SearchOutboxArtifactsLazyQueryHookResult = ReturnType<typeof useSearchOutboxArtifactsLazyQuery>;
export type SearchOutboxArtifactsSuspenseQueryHookResult = ReturnType<typeof useSearchOutboxArtifactsSuspenseQuery>;
export type SearchOutboxArtifactsQueryResult = Apollo.QueryResult<SearchOutboxArtifactsQuery, SearchOutboxArtifactsQueryVariables>;
export const SearchAttachableArtifactsDocument = gql`
    query SearchAttachableArtifacts($filter: CaraWorkspaceArtifactFilter) {
  caraWorkspaceArtifacts(filter: $filter) {
    id
    title
    type
    updatedAt
    metadata {
      workspaceId
      workspaceTitle
      clientName
    }
  }
}
    `;

/**
 * __useSearchAttachableArtifactsQuery__
 *
 * To run a query within a React component, call `useSearchAttachableArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAttachableArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAttachableArtifactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchAttachableArtifactsQuery(baseOptions?: Apollo.QueryHookOptions<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>(SearchAttachableArtifactsDocument, options);
      }
export function useSearchAttachableArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>(SearchAttachableArtifactsDocument, options);
        }
// @ts-ignore
export function useSearchAttachableArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>;
export function useSearchAttachableArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAttachableArtifactsQuery | undefined, SearchAttachableArtifactsQueryVariables>;
export function useSearchAttachableArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>(SearchAttachableArtifactsDocument, options);
        }
export type SearchAttachableArtifactsQueryHookResult = ReturnType<typeof useSearchAttachableArtifactsQuery>;
export type SearchAttachableArtifactsLazyQueryHookResult = ReturnType<typeof useSearchAttachableArtifactsLazyQuery>;
export type SearchAttachableArtifactsSuspenseQueryHookResult = ReturnType<typeof useSearchAttachableArtifactsSuspenseQuery>;
export type SearchAttachableArtifactsQueryResult = Apollo.QueryResult<SearchAttachableArtifactsQuery, SearchAttachableArtifactsQueryVariables>;
export const GetCaraWorkspaceEmailArtifactDocument = gql`
    query GetCaraWorkspaceEmailArtifact($workspaceId: ID!, $artifactId: ID!) {
  caraWorkspaceArtifact(workspaceId: $workspaceId, artifactId: $artifactId) {
    id
    versions {
      version
      email {
        bodyHtml
        contentRevision
      }
    }
  }
}
    `;

/**
 * __useGetCaraWorkspaceEmailArtifactQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceEmailArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceEmailArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceEmailArtifactQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetCaraWorkspaceEmailArtifactQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables> & ({ variables: GetCaraWorkspaceEmailArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>(GetCaraWorkspaceEmailArtifactDocument, options);
      }
export function useGetCaraWorkspaceEmailArtifactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>(GetCaraWorkspaceEmailArtifactDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceEmailArtifactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>;
export function useGetCaraWorkspaceEmailArtifactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceEmailArtifactQuery | undefined, GetCaraWorkspaceEmailArtifactQueryVariables>;
export function useGetCaraWorkspaceEmailArtifactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>(GetCaraWorkspaceEmailArtifactDocument, options);
        }
export type GetCaraWorkspaceEmailArtifactQueryHookResult = ReturnType<typeof useGetCaraWorkspaceEmailArtifactQuery>;
export type GetCaraWorkspaceEmailArtifactLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceEmailArtifactLazyQuery>;
export type GetCaraWorkspaceEmailArtifactSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceEmailArtifactSuspenseQuery>;
export type GetCaraWorkspaceEmailArtifactQueryResult = Apollo.QueryResult<GetCaraWorkspaceEmailArtifactQuery, GetCaraWorkspaceEmailArtifactQueryVariables>;
export const GetCaraWorkspaceArtifactDocument = gql`
    query GetCaraWorkspaceArtifact($workspaceId: ID!, $artifactId: ID!) {
  caraWorkspaceArtifact(workspaceId: $workspaceId, artifactId: $artifactId) {
    ...CaraWorkspaceArtifactSummaryWithContentFields
  }
}
    ${CaraWorkspaceArtifactSummaryWithContentFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspaceArtifactQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceArtifactQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceArtifactQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceArtifactQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetCaraWorkspaceArtifactQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables> & ({ variables: GetCaraWorkspaceArtifactQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>(GetCaraWorkspaceArtifactDocument, options);
      }
export function useGetCaraWorkspaceArtifactLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>(GetCaraWorkspaceArtifactDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceArtifactSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>;
export function useGetCaraWorkspaceArtifactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactQuery | undefined, GetCaraWorkspaceArtifactQueryVariables>;
export function useGetCaraWorkspaceArtifactSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>(GetCaraWorkspaceArtifactDocument, options);
        }
export type GetCaraWorkspaceArtifactQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactQuery>;
export type GetCaraWorkspaceArtifactLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactLazyQuery>;
export type GetCaraWorkspaceArtifactSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactSuspenseQuery>;
export type GetCaraWorkspaceArtifactQueryResult = Apollo.QueryResult<GetCaraWorkspaceArtifactQuery, GetCaraWorkspaceArtifactQueryVariables>;
export const GetTemplateFormEditorStateDocument = gql`
    query GetTemplateFormEditorState($workspaceId: ID!, $artifactId: ID!, $version: Int) {
  templateFormEditorState(
    workspaceId: $workspaceId
    artifactId: $artifactId
    version: $version
  ) {
    ...TemplateFormEditorStateFields
  }
}
    ${TemplateFormEditorStateFieldsFragmentDoc}`;

/**
 * __useGetTemplateFormEditorStateQuery__
 *
 * To run a query within a React component, call `useGetTemplateFormEditorStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTemplateFormEditorStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTemplateFormEditorStateQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetTemplateFormEditorStateQuery(baseOptions: Apollo.QueryHookOptions<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables> & ({ variables: GetTemplateFormEditorStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>(GetTemplateFormEditorStateDocument, options);
      }
export function useGetTemplateFormEditorStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>(GetTemplateFormEditorStateDocument, options);
        }
// @ts-ignore
export function useGetTemplateFormEditorStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>;
export function useGetTemplateFormEditorStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetTemplateFormEditorStateQuery | undefined, GetTemplateFormEditorStateQueryVariables>;
export function useGetTemplateFormEditorStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>(GetTemplateFormEditorStateDocument, options);
        }
export type GetTemplateFormEditorStateQueryHookResult = ReturnType<typeof useGetTemplateFormEditorStateQuery>;
export type GetTemplateFormEditorStateLazyQueryHookResult = ReturnType<typeof useGetTemplateFormEditorStateLazyQuery>;
export type GetTemplateFormEditorStateSuspenseQueryHookResult = ReturnType<typeof useGetTemplateFormEditorStateSuspenseQuery>;
export type GetTemplateFormEditorStateQueryResult = Apollo.QueryResult<GetTemplateFormEditorStateQuery, GetTemplateFormEditorStateQueryVariables>;
export const GetCustomPresetsDocument = gql`
    query GetCustomPresets {
  customPresets {
    ...CustomPresetFields
  }
}
    ${CustomPresetFieldsFragmentDoc}`;

/**
 * __useGetCustomPresetsQuery__
 *
 * To run a query within a React component, call `useGetCustomPresetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPresetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPresetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomPresetsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(GetCustomPresetsDocument, options);
      }
export function useGetCustomPresetsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(GetCustomPresetsDocument, options);
        }
// @ts-ignore
export function useGetCustomPresetsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>;
export function useGetCustomPresetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetsQuery | undefined, GetCustomPresetsQueryVariables>;
export function useGetCustomPresetsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>(GetCustomPresetsDocument, options);
        }
export type GetCustomPresetsQueryHookResult = ReturnType<typeof useGetCustomPresetsQuery>;
export type GetCustomPresetsLazyQueryHookResult = ReturnType<typeof useGetCustomPresetsLazyQuery>;
export type GetCustomPresetsSuspenseQueryHookResult = ReturnType<typeof useGetCustomPresetsSuspenseQuery>;
export type GetCustomPresetsQueryResult = Apollo.QueryResult<GetCustomPresetsQuery, GetCustomPresetsQueryVariables>;
export const GetCustomPresetDocument = gql`
    query GetCustomPreset($id: ID!) {
  customPreset(id: $id) {
    ...CustomPresetDetailFields
  }
}
    ${CustomPresetDetailFieldsFragmentDoc}`;

/**
 * __useGetCustomPresetQuery__
 *
 * To run a query within a React component, call `useGetCustomPresetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPresetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPresetQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomPresetQuery(baseOptions: Apollo.QueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables> & ({ variables: GetCustomPresetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(GetCustomPresetDocument, options);
      }
export function useGetCustomPresetLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(GetCustomPresetDocument, options);
        }
// @ts-ignore
export function useGetCustomPresetSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetQuery, GetCustomPresetQueryVariables>;
export function useGetCustomPresetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetQuery | undefined, GetCustomPresetQueryVariables>;
export function useGetCustomPresetSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetQuery, GetCustomPresetQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomPresetQuery, GetCustomPresetQueryVariables>(GetCustomPresetDocument, options);
        }
export type GetCustomPresetQueryHookResult = ReturnType<typeof useGetCustomPresetQuery>;
export type GetCustomPresetLazyQueryHookResult = ReturnType<typeof useGetCustomPresetLazyQuery>;
export type GetCustomPresetSuspenseQueryHookResult = ReturnType<typeof useGetCustomPresetSuspenseQuery>;
export type GetCustomPresetQueryResult = Apollo.QueryResult<GetCustomPresetQuery, GetCustomPresetQueryVariables>;
export const GetCustomPresetShareInfoDocument = gql`
    query GetCustomPresetShareInfo($id: ID!) {
  customPreset(id: $id) {
    id
    accessList {
      ...CustomPresetAccessFields
    }
  }
}
    ${CustomPresetAccessFieldsFragmentDoc}`;

/**
 * __useGetCustomPresetShareInfoQuery__
 *
 * To run a query within a React component, call `useGetCustomPresetShareInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomPresetShareInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomPresetShareInfoQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomPresetShareInfoQuery(baseOptions: Apollo.QueryHookOptions<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables> & ({ variables: GetCustomPresetShareInfoQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>(GetCustomPresetShareInfoDocument, options);
      }
export function useGetCustomPresetShareInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>(GetCustomPresetShareInfoDocument, options);
        }
// @ts-ignore
export function useGetCustomPresetShareInfoSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>;
export function useGetCustomPresetShareInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomPresetShareInfoQuery | undefined, GetCustomPresetShareInfoQueryVariables>;
export function useGetCustomPresetShareInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>(GetCustomPresetShareInfoDocument, options);
        }
export type GetCustomPresetShareInfoQueryHookResult = ReturnType<typeof useGetCustomPresetShareInfoQuery>;
export type GetCustomPresetShareInfoLazyQueryHookResult = ReturnType<typeof useGetCustomPresetShareInfoLazyQuery>;
export type GetCustomPresetShareInfoSuspenseQueryHookResult = ReturnType<typeof useGetCustomPresetShareInfoSuspenseQuery>;
export type GetCustomPresetShareInfoQueryResult = Apollo.QueryResult<GetCustomPresetShareInfoQuery, GetCustomPresetShareInfoQueryVariables>;
export const GrantCustomPresetAccessDocument = gql`
    mutation GrantCustomPresetAccess($customPresetId: ID!, $agencyId: ID!) {
  grantCustomPresetAccess(customPresetId: $customPresetId, agencyId: $agencyId) {
    ...CustomPresetAccessFields
  }
}
    ${CustomPresetAccessFieldsFragmentDoc}`;
export type GrantCustomPresetAccessMutationFn = Apollo.MutationFunction<GrantCustomPresetAccessMutation, GrantCustomPresetAccessMutationVariables>;

/**
 * __useGrantCustomPresetAccessMutation__
 *
 * To run a mutation, you first call `useGrantCustomPresetAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantCustomPresetAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantCustomPresetAccessMutation, { data, loading, error }] = useGrantCustomPresetAccessMutation({
 *   variables: {
 *      customPresetId: // value for 'customPresetId'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useGrantCustomPresetAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantCustomPresetAccessMutation, GrantCustomPresetAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantCustomPresetAccessMutation, GrantCustomPresetAccessMutationVariables>(GrantCustomPresetAccessDocument, options);
      }
export type GrantCustomPresetAccessMutationHookResult = ReturnType<typeof useGrantCustomPresetAccessMutation>;
export type GrantCustomPresetAccessMutationResult = Apollo.MutationResult<GrantCustomPresetAccessMutation>;
export type GrantCustomPresetAccessMutationOptions = Apollo.BaseMutationOptions<GrantCustomPresetAccessMutation, GrantCustomPresetAccessMutationVariables>;
export const RevokeCustomPresetAccessDocument = gql`
    mutation RevokeCustomPresetAccess($customPresetId: ID!, $agencyId: ID!) {
  revokeCustomPresetAccess(customPresetId: $customPresetId, agencyId: $agencyId)
}
    `;
export type RevokeCustomPresetAccessMutationFn = Apollo.MutationFunction<RevokeCustomPresetAccessMutation, RevokeCustomPresetAccessMutationVariables>;

/**
 * __useRevokeCustomPresetAccessMutation__
 *
 * To run a mutation, you first call `useRevokeCustomPresetAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeCustomPresetAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeCustomPresetAccessMutation, { data, loading, error }] = useRevokeCustomPresetAccessMutation({
 *   variables: {
 *      customPresetId: // value for 'customPresetId'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useRevokeCustomPresetAccessMutation(baseOptions?: Apollo.MutationHookOptions<RevokeCustomPresetAccessMutation, RevokeCustomPresetAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeCustomPresetAccessMutation, RevokeCustomPresetAccessMutationVariables>(RevokeCustomPresetAccessDocument, options);
      }
export type RevokeCustomPresetAccessMutationHookResult = ReturnType<typeof useRevokeCustomPresetAccessMutation>;
export type RevokeCustomPresetAccessMutationResult = Apollo.MutationResult<RevokeCustomPresetAccessMutation>;
export type RevokeCustomPresetAccessMutationOptions = Apollo.BaseMutationOptions<RevokeCustomPresetAccessMutation, RevokeCustomPresetAccessMutationVariables>;
export const GetHtmlDocumentTemplatesDocument = gql`
    query GetHtmlDocumentTemplates {
  htmlDocumentTemplates {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;

/**
 * __useGetHtmlDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetHtmlDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHtmlDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHtmlDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHtmlDocumentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>(GetHtmlDocumentTemplatesDocument, options);
      }
export function useGetHtmlDocumentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>(GetHtmlDocumentTemplatesDocument, options);
        }
// @ts-ignore
export function useGetHtmlDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>;
export function useGetHtmlDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplatesQuery | undefined, GetHtmlDocumentTemplatesQueryVariables>;
export function useGetHtmlDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>(GetHtmlDocumentTemplatesDocument, options);
        }
export type GetHtmlDocumentTemplatesQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplatesQuery>;
export type GetHtmlDocumentTemplatesLazyQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplatesLazyQuery>;
export type GetHtmlDocumentTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplatesSuspenseQuery>;
export type GetHtmlDocumentTemplatesQueryResult = Apollo.QueryResult<GetHtmlDocumentTemplatesQuery, GetHtmlDocumentTemplatesQueryVariables>;
export const GetHtmlDocumentTemplateDocument = gql`
    query GetHtmlDocumentTemplate($id: ID!) {
  htmlDocumentTemplate(id: $id) {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;

/**
 * __useGetHtmlDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetHtmlDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHtmlDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHtmlDocumentTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetHtmlDocumentTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables> & ({ variables: GetHtmlDocumentTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>(GetHtmlDocumentTemplateDocument, options);
      }
export function useGetHtmlDocumentTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>(GetHtmlDocumentTemplateDocument, options);
        }
// @ts-ignore
export function useGetHtmlDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>;
export function useGetHtmlDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplateQuery | undefined, GetHtmlDocumentTemplateQueryVariables>;
export function useGetHtmlDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>(GetHtmlDocumentTemplateDocument, options);
        }
export type GetHtmlDocumentTemplateQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateQuery>;
export type GetHtmlDocumentTemplateLazyQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateLazyQuery>;
export type GetHtmlDocumentTemplateSuspenseQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateSuspenseQuery>;
export type GetHtmlDocumentTemplateQueryResult = Apollo.QueryResult<GetHtmlDocumentTemplateQuery, GetHtmlDocumentTemplateQueryVariables>;
export const GetHtmlDocumentTemplateStartersDocument = gql`
    query GetHtmlDocumentTemplateStarters {
  htmlDocumentTemplateStarters {
    id
    title
    description
  }
}
    `;

/**
 * __useGetHtmlDocumentTemplateStartersQuery__
 *
 * To run a query within a React component, call `useGetHtmlDocumentTemplateStartersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHtmlDocumentTemplateStartersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHtmlDocumentTemplateStartersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetHtmlDocumentTemplateStartersQuery(baseOptions?: Apollo.QueryHookOptions<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>(GetHtmlDocumentTemplateStartersDocument, options);
      }
export function useGetHtmlDocumentTemplateStartersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>(GetHtmlDocumentTemplateStartersDocument, options);
        }
// @ts-ignore
export function useGetHtmlDocumentTemplateStartersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>;
export function useGetHtmlDocumentTemplateStartersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>): Apollo.UseSuspenseQueryResult<GetHtmlDocumentTemplateStartersQuery | undefined, GetHtmlDocumentTemplateStartersQueryVariables>;
export function useGetHtmlDocumentTemplateStartersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>(GetHtmlDocumentTemplateStartersDocument, options);
        }
export type GetHtmlDocumentTemplateStartersQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateStartersQuery>;
export type GetHtmlDocumentTemplateStartersLazyQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateStartersLazyQuery>;
export type GetHtmlDocumentTemplateStartersSuspenseQueryHookResult = ReturnType<typeof useGetHtmlDocumentTemplateStartersSuspenseQuery>;
export type GetHtmlDocumentTemplateStartersQueryResult = Apollo.QueryResult<GetHtmlDocumentTemplateStartersQuery, GetHtmlDocumentTemplateStartersQueryVariables>;
export const CreateHtmlDocumentTemplateFromStarterDocument = gql`
    mutation CreateHtmlDocumentTemplateFromStarter($input: CreateHtmlDocumentTemplateFromStarterInput!) {
  createHtmlDocumentTemplateFromStarter(input: $input) {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;
export type CreateHtmlDocumentTemplateFromStarterMutationFn = Apollo.MutationFunction<CreateHtmlDocumentTemplateFromStarterMutation, CreateHtmlDocumentTemplateFromStarterMutationVariables>;

/**
 * __useCreateHtmlDocumentTemplateFromStarterMutation__
 *
 * To run a mutation, you first call `useCreateHtmlDocumentTemplateFromStarterMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHtmlDocumentTemplateFromStarterMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHtmlDocumentTemplateFromStarterMutation, { data, loading, error }] = useCreateHtmlDocumentTemplateFromStarterMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHtmlDocumentTemplateFromStarterMutation(baseOptions?: Apollo.MutationHookOptions<CreateHtmlDocumentTemplateFromStarterMutation, CreateHtmlDocumentTemplateFromStarterMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHtmlDocumentTemplateFromStarterMutation, CreateHtmlDocumentTemplateFromStarterMutationVariables>(CreateHtmlDocumentTemplateFromStarterDocument, options);
      }
export type CreateHtmlDocumentTemplateFromStarterMutationHookResult = ReturnType<typeof useCreateHtmlDocumentTemplateFromStarterMutation>;
export type CreateHtmlDocumentTemplateFromStarterMutationResult = Apollo.MutationResult<CreateHtmlDocumentTemplateFromStarterMutation>;
export type CreateHtmlDocumentTemplateFromStarterMutationOptions = Apollo.BaseMutationOptions<CreateHtmlDocumentTemplateFromStarterMutation, CreateHtmlDocumentTemplateFromStarterMutationVariables>;
export const GetWordDocumentTemplatesDocument = gql`
    query GetWordDocumentTemplates {
  wordDocumentTemplates {
    ...WordDocumentTemplateFields
  }
}
    ${WordDocumentTemplateFieldsFragmentDoc}`;

/**
 * __useGetWordDocumentTemplatesQuery__
 *
 * To run a query within a React component, call `useGetWordDocumentTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordDocumentTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWordDocumentTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWordDocumentTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>(GetWordDocumentTemplatesDocument, options);
      }
export function useGetWordDocumentTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>(GetWordDocumentTemplatesDocument, options);
        }
// @ts-ignore
export function useGetWordDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>;
export function useGetWordDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetWordDocumentTemplatesQuery | undefined, GetWordDocumentTemplatesQueryVariables>;
export function useGetWordDocumentTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>(GetWordDocumentTemplatesDocument, options);
        }
export type GetWordDocumentTemplatesQueryHookResult = ReturnType<typeof useGetWordDocumentTemplatesQuery>;
export type GetWordDocumentTemplatesLazyQueryHookResult = ReturnType<typeof useGetWordDocumentTemplatesLazyQuery>;
export type GetWordDocumentTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetWordDocumentTemplatesSuspenseQuery>;
export type GetWordDocumentTemplatesQueryResult = Apollo.QueryResult<GetWordDocumentTemplatesQuery, GetWordDocumentTemplatesQueryVariables>;
export const GetWordDocumentTemplateDocument = gql`
    query GetWordDocumentTemplate($id: ID!) {
  wordDocumentTemplate(id: $id) {
    ...WordDocumentTemplateFields
  }
}
    ${WordDocumentTemplateFieldsFragmentDoc}`;

/**
 * __useGetWordDocumentTemplateQuery__
 *
 * To run a query within a React component, call `useGetWordDocumentTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWordDocumentTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWordDocumentTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetWordDocumentTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables> & ({ variables: GetWordDocumentTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>(GetWordDocumentTemplateDocument, options);
      }
export function useGetWordDocumentTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>(GetWordDocumentTemplateDocument, options);
        }
// @ts-ignore
export function useGetWordDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>;
export function useGetWordDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetWordDocumentTemplateQuery | undefined, GetWordDocumentTemplateQueryVariables>;
export function useGetWordDocumentTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>(GetWordDocumentTemplateDocument, options);
        }
export type GetWordDocumentTemplateQueryHookResult = ReturnType<typeof useGetWordDocumentTemplateQuery>;
export type GetWordDocumentTemplateLazyQueryHookResult = ReturnType<typeof useGetWordDocumentTemplateLazyQuery>;
export type GetWordDocumentTemplateSuspenseQueryHookResult = ReturnType<typeof useGetWordDocumentTemplateSuspenseQuery>;
export type GetWordDocumentTemplateQueryResult = Apollo.QueryResult<GetWordDocumentTemplateQuery, GetWordDocumentTemplateQueryVariables>;
export const GetExcelSpreadsheetTemplatesDocument = gql`
    query GetExcelSpreadsheetTemplates {
  excelSpreadsheetTemplates {
    ...ExcelSpreadsheetTemplateFields
  }
}
    ${ExcelSpreadsheetTemplateFieldsFragmentDoc}`;

/**
 * __useGetExcelSpreadsheetTemplatesQuery__
 *
 * To run a query within a React component, call `useGetExcelSpreadsheetTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcelSpreadsheetTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcelSpreadsheetTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetExcelSpreadsheetTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>(GetExcelSpreadsheetTemplatesDocument, options);
      }
export function useGetExcelSpreadsheetTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>(GetExcelSpreadsheetTemplatesDocument, options);
        }
// @ts-ignore
export function useGetExcelSpreadsheetTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>;
export function useGetExcelSpreadsheetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetExcelSpreadsheetTemplatesQuery | undefined, GetExcelSpreadsheetTemplatesQueryVariables>;
export function useGetExcelSpreadsheetTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>(GetExcelSpreadsheetTemplatesDocument, options);
        }
export type GetExcelSpreadsheetTemplatesQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplatesQuery>;
export type GetExcelSpreadsheetTemplatesLazyQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplatesLazyQuery>;
export type GetExcelSpreadsheetTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplatesSuspenseQuery>;
export type GetExcelSpreadsheetTemplatesQueryResult = Apollo.QueryResult<GetExcelSpreadsheetTemplatesQuery, GetExcelSpreadsheetTemplatesQueryVariables>;
export const GetExcelSpreadsheetTemplateDocument = gql`
    query GetExcelSpreadsheetTemplate($id: ID!) {
  excelSpreadsheetTemplate(id: $id) {
    ...ExcelSpreadsheetTemplateFields
  }
}
    ${ExcelSpreadsheetTemplateFieldsFragmentDoc}`;

/**
 * __useGetExcelSpreadsheetTemplateQuery__
 *
 * To run a query within a React component, call `useGetExcelSpreadsheetTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetExcelSpreadsheetTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetExcelSpreadsheetTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetExcelSpreadsheetTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables> & ({ variables: GetExcelSpreadsheetTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>(GetExcelSpreadsheetTemplateDocument, options);
      }
export function useGetExcelSpreadsheetTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>(GetExcelSpreadsheetTemplateDocument, options);
        }
// @ts-ignore
export function useGetExcelSpreadsheetTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>;
export function useGetExcelSpreadsheetTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetExcelSpreadsheetTemplateQuery | undefined, GetExcelSpreadsheetTemplateQueryVariables>;
export function useGetExcelSpreadsheetTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>(GetExcelSpreadsheetTemplateDocument, options);
        }
export type GetExcelSpreadsheetTemplateQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplateQuery>;
export type GetExcelSpreadsheetTemplateLazyQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplateLazyQuery>;
export type GetExcelSpreadsheetTemplateSuspenseQueryHookResult = ReturnType<typeof useGetExcelSpreadsheetTemplateSuspenseQuery>;
export type GetExcelSpreadsheetTemplateQueryResult = Apollo.QueryResult<GetExcelSpreadsheetTemplateQuery, GetExcelSpreadsheetTemplateQueryVariables>;
export const CreateCaraWorkspaceDocument = gql`
    mutation CreateCaraWorkspace($input: CaraWorkspaceMessageInput!) {
  createCaraWorkspace(input: $input) {
    id
  }
}
    `;
export type CreateCaraWorkspaceMutationFn = Apollo.MutationFunction<CreateCaraWorkspaceMutation, CreateCaraWorkspaceMutationVariables>;

/**
 * __useCreateCaraWorkspaceMutation__
 *
 * To run a mutation, you first call `useCreateCaraWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCaraWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCaraWorkspaceMutation, { data, loading, error }] = useCreateCaraWorkspaceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCaraWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<CreateCaraWorkspaceMutation, CreateCaraWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCaraWorkspaceMutation, CreateCaraWorkspaceMutationVariables>(CreateCaraWorkspaceDocument, options);
      }
export type CreateCaraWorkspaceMutationHookResult = ReturnType<typeof useCreateCaraWorkspaceMutation>;
export type CreateCaraWorkspaceMutationResult = Apollo.MutationResult<CreateCaraWorkspaceMutation>;
export type CreateCaraWorkspaceMutationOptions = Apollo.BaseMutationOptions<CreateCaraWorkspaceMutation, CreateCaraWorkspaceMutationVariables>;
export const AddCaraWorkspaceMessageDocument = gql`
    mutation AddCaraWorkspaceMessage($id: ID!, $input: CaraWorkspaceMessageInput!) {
  addCaraWorkspaceMessage(id: $id, input: $input) {
    ...CaraWorkspaceFields
  }
}
    ${CaraWorkspaceFieldsFragmentDoc}`;
export type AddCaraWorkspaceMessageMutationFn = Apollo.MutationFunction<AddCaraWorkspaceMessageMutation, AddCaraWorkspaceMessageMutationVariables>;

/**
 * __useAddCaraWorkspaceMessageMutation__
 *
 * To run a mutation, you first call `useAddCaraWorkspaceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaraWorkspaceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaraWorkspaceMessageMutation, { data, loading, error }] = useAddCaraWorkspaceMessageMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCaraWorkspaceMessageMutation(baseOptions?: Apollo.MutationHookOptions<AddCaraWorkspaceMessageMutation, AddCaraWorkspaceMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaraWorkspaceMessageMutation, AddCaraWorkspaceMessageMutationVariables>(AddCaraWorkspaceMessageDocument, options);
      }
export type AddCaraWorkspaceMessageMutationHookResult = ReturnType<typeof useAddCaraWorkspaceMessageMutation>;
export type AddCaraWorkspaceMessageMutationResult = Apollo.MutationResult<AddCaraWorkspaceMessageMutation>;
export type AddCaraWorkspaceMessageMutationOptions = Apollo.BaseMutationOptions<AddCaraWorkspaceMessageMutation, AddCaraWorkspaceMessageMutationVariables>;
export const ExportCaraWorkspaceMessageDocument = gql`
    mutation ExportCaraWorkspaceMessage($input: ExportCaraWorkspaceMessageInput!) {
  exportCaraWorkspaceMessage(input: $input) {
    contentBase64
    downloadUrl
    fileName
    mimeType
  }
}
    `;
export type ExportCaraWorkspaceMessageMutationFn = Apollo.MutationFunction<ExportCaraWorkspaceMessageMutation, ExportCaraWorkspaceMessageMutationVariables>;

/**
 * __useExportCaraWorkspaceMessageMutation__
 *
 * To run a mutation, you first call `useExportCaraWorkspaceMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExportCaraWorkspaceMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [exportCaraWorkspaceMessageMutation, { data, loading, error }] = useExportCaraWorkspaceMessageMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useExportCaraWorkspaceMessageMutation(baseOptions?: Apollo.MutationHookOptions<ExportCaraWorkspaceMessageMutation, ExportCaraWorkspaceMessageMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExportCaraWorkspaceMessageMutation, ExportCaraWorkspaceMessageMutationVariables>(ExportCaraWorkspaceMessageDocument, options);
      }
export type ExportCaraWorkspaceMessageMutationHookResult = ReturnType<typeof useExportCaraWorkspaceMessageMutation>;
export type ExportCaraWorkspaceMessageMutationResult = Apollo.MutationResult<ExportCaraWorkspaceMessageMutation>;
export type ExportCaraWorkspaceMessageMutationOptions = Apollo.BaseMutationOptions<ExportCaraWorkspaceMessageMutation, ExportCaraWorkspaceMessageMutationVariables>;
export const StopCaraWorkspaceDocument = gql`
    mutation StopCaraWorkspace($id: ID!) {
  stopCaraWorkspace(id: $id) {
    ...CaraWorkspaceFields
  }
}
    ${CaraWorkspaceFieldsFragmentDoc}`;
export type StopCaraWorkspaceMutationFn = Apollo.MutationFunction<StopCaraWorkspaceMutation, StopCaraWorkspaceMutationVariables>;

/**
 * __useStopCaraWorkspaceMutation__
 *
 * To run a mutation, you first call `useStopCaraWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStopCaraWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [stopCaraWorkspaceMutation, { data, loading, error }] = useStopCaraWorkspaceMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStopCaraWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<StopCaraWorkspaceMutation, StopCaraWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StopCaraWorkspaceMutation, StopCaraWorkspaceMutationVariables>(StopCaraWorkspaceDocument, options);
      }
export type StopCaraWorkspaceMutationHookResult = ReturnType<typeof useStopCaraWorkspaceMutation>;
export type StopCaraWorkspaceMutationResult = Apollo.MutationResult<StopCaraWorkspaceMutation>;
export type StopCaraWorkspaceMutationOptions = Apollo.BaseMutationOptions<StopCaraWorkspaceMutation, StopCaraWorkspaceMutationVariables>;
export const UpdateCaraWorkspacesDocument = gql`
    mutation UpdateCaraWorkspaces($workspaceIds: [ID!]!, $input: UpdateCaraWorkspaceInput!) {
  updateCaraWorkspaces(workspaceIds: $workspaceIds, input: $input) {
    ...CaraWorkspaceFields
  }
}
    ${CaraWorkspaceFieldsFragmentDoc}`;
export type UpdateCaraWorkspacesMutationFn = Apollo.MutationFunction<UpdateCaraWorkspacesMutation, UpdateCaraWorkspacesMutationVariables>;

/**
 * __useUpdateCaraWorkspacesMutation__
 *
 * To run a mutation, you first call `useUpdateCaraWorkspacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaraWorkspacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaraWorkspacesMutation, { data, loading, error }] = useUpdateCaraWorkspacesMutation({
 *   variables: {
 *      workspaceIds: // value for 'workspaceIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaraWorkspacesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaraWorkspacesMutation, UpdateCaraWorkspacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaraWorkspacesMutation, UpdateCaraWorkspacesMutationVariables>(UpdateCaraWorkspacesDocument, options);
      }
export type UpdateCaraWorkspacesMutationHookResult = ReturnType<typeof useUpdateCaraWorkspacesMutation>;
export type UpdateCaraWorkspacesMutationResult = Apollo.MutationResult<UpdateCaraWorkspacesMutation>;
export type UpdateCaraWorkspacesMutationOptions = Apollo.BaseMutationOptions<UpdateCaraWorkspacesMutation, UpdateCaraWorkspacesMutationVariables>;
export const UpdateCaraWorkspaceArtifactDocument = gql`
    mutation UpdateCaraWorkspaceArtifact($workspaceId: ID!, $artifactId: ID!, $version: Int!, $input: UpdateCaraWorkspaceArtifactInput!) {
  updateCaraWorkspaceArtifact(
    workspaceId: $workspaceId
    artifactId: $artifactId
    version: $version
    input: $input
  ) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type UpdateCaraWorkspaceArtifactMutationFn = Apollo.MutationFunction<UpdateCaraWorkspaceArtifactMutation, UpdateCaraWorkspaceArtifactMutationVariables>;

/**
 * __useUpdateCaraWorkspaceArtifactMutation__
 *
 * To run a mutation, you first call `useUpdateCaraWorkspaceArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaraWorkspaceArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaraWorkspaceArtifactMutation, { data, loading, error }] = useUpdateCaraWorkspaceArtifactMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaraWorkspaceArtifactMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaraWorkspaceArtifactMutation, UpdateCaraWorkspaceArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaraWorkspaceArtifactMutation, UpdateCaraWorkspaceArtifactMutationVariables>(UpdateCaraWorkspaceArtifactDocument, options);
      }
export type UpdateCaraWorkspaceArtifactMutationHookResult = ReturnType<typeof useUpdateCaraWorkspaceArtifactMutation>;
export type UpdateCaraWorkspaceArtifactMutationResult = Apollo.MutationResult<UpdateCaraWorkspaceArtifactMutation>;
export type UpdateCaraWorkspaceArtifactMutationOptions = Apollo.BaseMutationOptions<UpdateCaraWorkspaceArtifactMutation, UpdateCaraWorkspaceArtifactMutationVariables>;
export const SaveTemplateFormFieldsDocument = gql`
    mutation SaveTemplateFormFields($workspaceId: ID!, $artifactId: ID!, $baseVersion: Int!, $fields: [TemplateFormFieldEditInput!]!) {
  saveTemplateFormFields(
    workspaceId: $workspaceId
    artifactId: $artifactId
    baseVersion: $baseVersion
    fields: $fields
  ) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type SaveTemplateFormFieldsMutationFn = Apollo.MutationFunction<SaveTemplateFormFieldsMutation, SaveTemplateFormFieldsMutationVariables>;

/**
 * __useSaveTemplateFormFieldsMutation__
 *
 * To run a mutation, you first call `useSaveTemplateFormFieldsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSaveTemplateFormFieldsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [saveTemplateFormFieldsMutation, { data, loading, error }] = useSaveTemplateFormFieldsMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      baseVersion: // value for 'baseVersion'
 *      fields: // value for 'fields'
 *   },
 * });
 */
export function useSaveTemplateFormFieldsMutation(baseOptions?: Apollo.MutationHookOptions<SaveTemplateFormFieldsMutation, SaveTemplateFormFieldsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SaveTemplateFormFieldsMutation, SaveTemplateFormFieldsMutationVariables>(SaveTemplateFormFieldsDocument, options);
      }
export type SaveTemplateFormFieldsMutationHookResult = ReturnType<typeof useSaveTemplateFormFieldsMutation>;
export type SaveTemplateFormFieldsMutationResult = Apollo.MutationResult<SaveTemplateFormFieldsMutation>;
export type SaveTemplateFormFieldsMutationOptions = Apollo.BaseMutationOptions<SaveTemplateFormFieldsMutation, SaveTemplateFormFieldsMutationVariables>;
export const RestoreTemplateFormVersionDocument = gql`
    mutation RestoreTemplateFormVersion($workspaceId: ID!, $artifactId: ID!, $version: Int!, $baseVersion: Int!) {
  restoreTemplateFormVersion(
    workspaceId: $workspaceId
    artifactId: $artifactId
    version: $version
    baseVersion: $baseVersion
  ) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type RestoreTemplateFormVersionMutationFn = Apollo.MutationFunction<RestoreTemplateFormVersionMutation, RestoreTemplateFormVersionMutationVariables>;

/**
 * __useRestoreTemplateFormVersionMutation__
 *
 * To run a mutation, you first call `useRestoreTemplateFormVersionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRestoreTemplateFormVersionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [restoreTemplateFormVersionMutation, { data, loading, error }] = useRestoreTemplateFormVersionMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *      baseVersion: // value for 'baseVersion'
 *   },
 * });
 */
export function useRestoreTemplateFormVersionMutation(baseOptions?: Apollo.MutationHookOptions<RestoreTemplateFormVersionMutation, RestoreTemplateFormVersionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RestoreTemplateFormVersionMutation, RestoreTemplateFormVersionMutationVariables>(RestoreTemplateFormVersionDocument, options);
      }
export type RestoreTemplateFormVersionMutationHookResult = ReturnType<typeof useRestoreTemplateFormVersionMutation>;
export type RestoreTemplateFormVersionMutationResult = Apollo.MutationResult<RestoreTemplateFormVersionMutation>;
export type RestoreTemplateFormVersionMutationOptions = Apollo.BaseMutationOptions<RestoreTemplateFormVersionMutation, RestoreTemplateFormVersionMutationVariables>;
export const UpdateCaraWorkspaceArtifactsDocument = gql`
    mutation UpdateCaraWorkspaceArtifacts($artifactIds: [ID!]!, $input: UpdateCaraWorkspaceArtifactsInput!) {
  updateCaraWorkspaceArtifacts(artifactIds: $artifactIds, input: $input) {
    id
    archivedAt
  }
}
    `;
export type UpdateCaraWorkspaceArtifactsMutationFn = Apollo.MutationFunction<UpdateCaraWorkspaceArtifactsMutation, UpdateCaraWorkspaceArtifactsMutationVariables>;

/**
 * __useUpdateCaraWorkspaceArtifactsMutation__
 *
 * To run a mutation, you first call `useUpdateCaraWorkspaceArtifactsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCaraWorkspaceArtifactsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCaraWorkspaceArtifactsMutation, { data, loading, error }] = useUpdateCaraWorkspaceArtifactsMutation({
 *   variables: {
 *      artifactIds: // value for 'artifactIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCaraWorkspaceArtifactsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCaraWorkspaceArtifactsMutation, UpdateCaraWorkspaceArtifactsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCaraWorkspaceArtifactsMutation, UpdateCaraWorkspaceArtifactsMutationVariables>(UpdateCaraWorkspaceArtifactsDocument, options);
      }
export type UpdateCaraWorkspaceArtifactsMutationHookResult = ReturnType<typeof useUpdateCaraWorkspaceArtifactsMutation>;
export type UpdateCaraWorkspaceArtifactsMutationResult = Apollo.MutationResult<UpdateCaraWorkspaceArtifactsMutation>;
export type UpdateCaraWorkspaceArtifactsMutationOptions = Apollo.BaseMutationOptions<UpdateCaraWorkspaceArtifactsMutation, UpdateCaraWorkspaceArtifactsMutationVariables>;
export const ArchiveCaraWorkspacesDocument = gql`
    mutation ArchiveCaraWorkspaces($workspaceIds: [ID!]!) {
  updateCaraWorkspaces(workspaceIds: $workspaceIds, input: {archive: true}) {
    id
    archivedAt
  }
}
    `;
export type ArchiveCaraWorkspacesMutationFn = Apollo.MutationFunction<ArchiveCaraWorkspacesMutation, ArchiveCaraWorkspacesMutationVariables>;

/**
 * __useArchiveCaraWorkspacesMutation__
 *
 * To run a mutation, you first call `useArchiveCaraWorkspacesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveCaraWorkspacesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveCaraWorkspacesMutation, { data, loading, error }] = useArchiveCaraWorkspacesMutation({
 *   variables: {
 *      workspaceIds: // value for 'workspaceIds'
 *   },
 * });
 */
export function useArchiveCaraWorkspacesMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveCaraWorkspacesMutation, ArchiveCaraWorkspacesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveCaraWorkspacesMutation, ArchiveCaraWorkspacesMutationVariables>(ArchiveCaraWorkspacesDocument, options);
      }
export type ArchiveCaraWorkspacesMutationHookResult = ReturnType<typeof useArchiveCaraWorkspacesMutation>;
export type ArchiveCaraWorkspacesMutationResult = Apollo.MutationResult<ArchiveCaraWorkspacesMutation>;
export type ArchiveCaraWorkspacesMutationOptions = Apollo.BaseMutationOptions<ArchiveCaraWorkspacesMutation, ArchiveCaraWorkspacesMutationVariables>;
export const CreateCustomPresetDocument = gql`
    mutation CreateCustomPreset($input: CustomPresetInput!) {
  createCustomPreset(input: $input) {
    id
  }
}
    `;
export type CreateCustomPresetMutationFn = Apollo.MutationFunction<CreateCustomPresetMutation, CreateCustomPresetMutationVariables>;

/**
 * __useCreateCustomPresetMutation__
 *
 * To run a mutation, you first call `useCreateCustomPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCustomPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCustomPresetMutation, { data, loading, error }] = useCreateCustomPresetMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCustomPresetMutation(baseOptions?: Apollo.MutationHookOptions<CreateCustomPresetMutation, CreateCustomPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCustomPresetMutation, CreateCustomPresetMutationVariables>(CreateCustomPresetDocument, options);
      }
export type CreateCustomPresetMutationHookResult = ReturnType<typeof useCreateCustomPresetMutation>;
export type CreateCustomPresetMutationResult = Apollo.MutationResult<CreateCustomPresetMutation>;
export type CreateCustomPresetMutationOptions = Apollo.BaseMutationOptions<CreateCustomPresetMutation, CreateCustomPresetMutationVariables>;
export const UpdateCustomPresetDocument = gql`
    mutation UpdateCustomPreset($id: ID!, $input: CustomPresetInput!) {
  updateCustomPreset(id: $id, input: $input) {
    id
  }
}
    `;
export type UpdateCustomPresetMutationFn = Apollo.MutationFunction<UpdateCustomPresetMutation, UpdateCustomPresetMutationVariables>;

/**
 * __useUpdateCustomPresetMutation__
 *
 * To run a mutation, you first call `useUpdateCustomPresetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomPresetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomPresetMutation, { data, loading, error }] = useUpdateCustomPresetMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomPresetMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomPresetMutation, UpdateCustomPresetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomPresetMutation, UpdateCustomPresetMutationVariables>(UpdateCustomPresetDocument, options);
      }
export type UpdateCustomPresetMutationHookResult = ReturnType<typeof useUpdateCustomPresetMutation>;
export type UpdateCustomPresetMutationResult = Apollo.MutationResult<UpdateCustomPresetMutation>;
export type UpdateCustomPresetMutationOptions = Apollo.BaseMutationOptions<UpdateCustomPresetMutation, UpdateCustomPresetMutationVariables>;
export const UpdateCustomPresetsDocument = gql`
    mutation UpdateCustomPresets($presetIds: [ID!]!, $input: UpdateCustomPresetsInput!) {
  updateCustomPresets(presetIds: $presetIds, input: $input) {
    ...CustomPresetFields
  }
}
    ${CustomPresetFieldsFragmentDoc}`;
export type UpdateCustomPresetsMutationFn = Apollo.MutationFunction<UpdateCustomPresetsMutation, UpdateCustomPresetsMutationVariables>;

/**
 * __useUpdateCustomPresetsMutation__
 *
 * To run a mutation, you first call `useUpdateCustomPresetsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomPresetsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomPresetsMutation, { data, loading, error }] = useUpdateCustomPresetsMutation({
 *   variables: {
 *      presetIds: // value for 'presetIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomPresetsMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomPresetsMutation, UpdateCustomPresetsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomPresetsMutation, UpdateCustomPresetsMutationVariables>(UpdateCustomPresetsDocument, options);
      }
export type UpdateCustomPresetsMutationHookResult = ReturnType<typeof useUpdateCustomPresetsMutation>;
export type UpdateCustomPresetsMutationResult = Apollo.MutationResult<UpdateCustomPresetsMutation>;
export type UpdateCustomPresetsMutationOptions = Apollo.BaseMutationOptions<UpdateCustomPresetsMutation, UpdateCustomPresetsMutationVariables>;
export const CreateHtmlDocumentTemplateDocument = gql`
    mutation CreateHtmlDocumentTemplate($input: HtmlDocumentTemplateInput!) {
  createHtmlDocumentTemplate(input: $input) {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;
export type CreateHtmlDocumentTemplateMutationFn = Apollo.MutationFunction<CreateHtmlDocumentTemplateMutation, CreateHtmlDocumentTemplateMutationVariables>;

/**
 * __useCreateHtmlDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateHtmlDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHtmlDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHtmlDocumentTemplateMutation, { data, loading, error }] = useCreateHtmlDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateHtmlDocumentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateHtmlDocumentTemplateMutation, CreateHtmlDocumentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHtmlDocumentTemplateMutation, CreateHtmlDocumentTemplateMutationVariables>(CreateHtmlDocumentTemplateDocument, options);
      }
export type CreateHtmlDocumentTemplateMutationHookResult = ReturnType<typeof useCreateHtmlDocumentTemplateMutation>;
export type CreateHtmlDocumentTemplateMutationResult = Apollo.MutationResult<CreateHtmlDocumentTemplateMutation>;
export type CreateHtmlDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<CreateHtmlDocumentTemplateMutation, CreateHtmlDocumentTemplateMutationVariables>;
export const UpdateHtmlDocumentTemplateDocument = gql`
    mutation UpdateHtmlDocumentTemplate($id: ID!, $input: HtmlDocumentTemplateInput!) {
  updateHtmlDocumentTemplate(id: $id, input: $input) {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;
export type UpdateHtmlDocumentTemplateMutationFn = Apollo.MutationFunction<UpdateHtmlDocumentTemplateMutation, UpdateHtmlDocumentTemplateMutationVariables>;

/**
 * __useUpdateHtmlDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateHtmlDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHtmlDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHtmlDocumentTemplateMutation, { data, loading, error }] = useUpdateHtmlDocumentTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHtmlDocumentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHtmlDocumentTemplateMutation, UpdateHtmlDocumentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHtmlDocumentTemplateMutation, UpdateHtmlDocumentTemplateMutationVariables>(UpdateHtmlDocumentTemplateDocument, options);
      }
export type UpdateHtmlDocumentTemplateMutationHookResult = ReturnType<typeof useUpdateHtmlDocumentTemplateMutation>;
export type UpdateHtmlDocumentTemplateMutationResult = Apollo.MutationResult<UpdateHtmlDocumentTemplateMutation>;
export type UpdateHtmlDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateHtmlDocumentTemplateMutation, UpdateHtmlDocumentTemplateMutationVariables>;
export const UpdateHtmlDocumentTemplatesDocument = gql`
    mutation UpdateHtmlDocumentTemplates($templateIds: [ID!]!, $input: UpdateHtmlDocumentTemplatesInput!) {
  updateHtmlDocumentTemplates(templateIds: $templateIds, input: $input) {
    ...HtmlDocumentTemplateFields
  }
}
    ${HtmlDocumentTemplateFieldsFragmentDoc}`;
export type UpdateHtmlDocumentTemplatesMutationFn = Apollo.MutationFunction<UpdateHtmlDocumentTemplatesMutation, UpdateHtmlDocumentTemplatesMutationVariables>;

/**
 * __useUpdateHtmlDocumentTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdateHtmlDocumentTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateHtmlDocumentTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateHtmlDocumentTemplatesMutation, { data, loading, error }] = useUpdateHtmlDocumentTemplatesMutation({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateHtmlDocumentTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateHtmlDocumentTemplatesMutation, UpdateHtmlDocumentTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateHtmlDocumentTemplatesMutation, UpdateHtmlDocumentTemplatesMutationVariables>(UpdateHtmlDocumentTemplatesDocument, options);
      }
export type UpdateHtmlDocumentTemplatesMutationHookResult = ReturnType<typeof useUpdateHtmlDocumentTemplatesMutation>;
export type UpdateHtmlDocumentTemplatesMutationResult = Apollo.MutationResult<UpdateHtmlDocumentTemplatesMutation>;
export type UpdateHtmlDocumentTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdateHtmlDocumentTemplatesMutation, UpdateHtmlDocumentTemplatesMutationVariables>;
export const CreateWordDocumentTemplateDocument = gql`
    mutation CreateWordDocumentTemplate($input: WordDocumentTemplateInput!) {
  createWordDocumentTemplate(input: $input) {
    ...WordDocumentTemplateFields
  }
}
    ${WordDocumentTemplateFieldsFragmentDoc}`;
export type CreateWordDocumentTemplateMutationFn = Apollo.MutationFunction<CreateWordDocumentTemplateMutation, CreateWordDocumentTemplateMutationVariables>;

/**
 * __useCreateWordDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useCreateWordDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWordDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWordDocumentTemplateMutation, { data, loading, error }] = useCreateWordDocumentTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWordDocumentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateWordDocumentTemplateMutation, CreateWordDocumentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWordDocumentTemplateMutation, CreateWordDocumentTemplateMutationVariables>(CreateWordDocumentTemplateDocument, options);
      }
export type CreateWordDocumentTemplateMutationHookResult = ReturnType<typeof useCreateWordDocumentTemplateMutation>;
export type CreateWordDocumentTemplateMutationResult = Apollo.MutationResult<CreateWordDocumentTemplateMutation>;
export type CreateWordDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<CreateWordDocumentTemplateMutation, CreateWordDocumentTemplateMutationVariables>;
export const UpdateWordDocumentTemplateDocument = gql`
    mutation UpdateWordDocumentTemplate($id: ID!, $input: WordDocumentTemplateInput!) {
  updateWordDocumentTemplate(id: $id, input: $input) {
    ...WordDocumentTemplateFields
  }
}
    ${WordDocumentTemplateFieldsFragmentDoc}`;
export type UpdateWordDocumentTemplateMutationFn = Apollo.MutationFunction<UpdateWordDocumentTemplateMutation, UpdateWordDocumentTemplateMutationVariables>;

/**
 * __useUpdateWordDocumentTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateWordDocumentTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWordDocumentTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWordDocumentTemplateMutation, { data, loading, error }] = useUpdateWordDocumentTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWordDocumentTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWordDocumentTemplateMutation, UpdateWordDocumentTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWordDocumentTemplateMutation, UpdateWordDocumentTemplateMutationVariables>(UpdateWordDocumentTemplateDocument, options);
      }
export type UpdateWordDocumentTemplateMutationHookResult = ReturnType<typeof useUpdateWordDocumentTemplateMutation>;
export type UpdateWordDocumentTemplateMutationResult = Apollo.MutationResult<UpdateWordDocumentTemplateMutation>;
export type UpdateWordDocumentTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateWordDocumentTemplateMutation, UpdateWordDocumentTemplateMutationVariables>;
export const UpdateWordDocumentTemplatesDocument = gql`
    mutation UpdateWordDocumentTemplates($templateIds: [ID!]!, $input: UpdateWordDocumentTemplatesInput!) {
  updateWordDocumentTemplates(templateIds: $templateIds, input: $input) {
    ...WordDocumentTemplateFields
  }
}
    ${WordDocumentTemplateFieldsFragmentDoc}`;
export type UpdateWordDocumentTemplatesMutationFn = Apollo.MutationFunction<UpdateWordDocumentTemplatesMutation, UpdateWordDocumentTemplatesMutationVariables>;

/**
 * __useUpdateWordDocumentTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdateWordDocumentTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateWordDocumentTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateWordDocumentTemplatesMutation, { data, loading, error }] = useUpdateWordDocumentTemplatesMutation({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateWordDocumentTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateWordDocumentTemplatesMutation, UpdateWordDocumentTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateWordDocumentTemplatesMutation, UpdateWordDocumentTemplatesMutationVariables>(UpdateWordDocumentTemplatesDocument, options);
      }
export type UpdateWordDocumentTemplatesMutationHookResult = ReturnType<typeof useUpdateWordDocumentTemplatesMutation>;
export type UpdateWordDocumentTemplatesMutationResult = Apollo.MutationResult<UpdateWordDocumentTemplatesMutation>;
export type UpdateWordDocumentTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdateWordDocumentTemplatesMutation, UpdateWordDocumentTemplatesMutationVariables>;
export const CreateExcelSpreadsheetTemplateDocument = gql`
    mutation CreateExcelSpreadsheetTemplate($input: ExcelSpreadsheetTemplateInput!) {
  createExcelSpreadsheetTemplate(input: $input) {
    ...ExcelSpreadsheetTemplateFields
  }
}
    ${ExcelSpreadsheetTemplateFieldsFragmentDoc}`;
export type CreateExcelSpreadsheetTemplateMutationFn = Apollo.MutationFunction<CreateExcelSpreadsheetTemplateMutation, CreateExcelSpreadsheetTemplateMutationVariables>;

/**
 * __useCreateExcelSpreadsheetTemplateMutation__
 *
 * To run a mutation, you first call `useCreateExcelSpreadsheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateExcelSpreadsheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createExcelSpreadsheetTemplateMutation, { data, loading, error }] = useCreateExcelSpreadsheetTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateExcelSpreadsheetTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateExcelSpreadsheetTemplateMutation, CreateExcelSpreadsheetTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateExcelSpreadsheetTemplateMutation, CreateExcelSpreadsheetTemplateMutationVariables>(CreateExcelSpreadsheetTemplateDocument, options);
      }
export type CreateExcelSpreadsheetTemplateMutationHookResult = ReturnType<typeof useCreateExcelSpreadsheetTemplateMutation>;
export type CreateExcelSpreadsheetTemplateMutationResult = Apollo.MutationResult<CreateExcelSpreadsheetTemplateMutation>;
export type CreateExcelSpreadsheetTemplateMutationOptions = Apollo.BaseMutationOptions<CreateExcelSpreadsheetTemplateMutation, CreateExcelSpreadsheetTemplateMutationVariables>;
export const UpdateExcelSpreadsheetTemplateDocument = gql`
    mutation UpdateExcelSpreadsheetTemplate($id: ID!, $input: ExcelSpreadsheetTemplateInput!) {
  updateExcelSpreadsheetTemplate(id: $id, input: $input) {
    ...ExcelSpreadsheetTemplateFields
  }
}
    ${ExcelSpreadsheetTemplateFieldsFragmentDoc}`;
export type UpdateExcelSpreadsheetTemplateMutationFn = Apollo.MutationFunction<UpdateExcelSpreadsheetTemplateMutation, UpdateExcelSpreadsheetTemplateMutationVariables>;

/**
 * __useUpdateExcelSpreadsheetTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateExcelSpreadsheetTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcelSpreadsheetTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcelSpreadsheetTemplateMutation, { data, loading, error }] = useUpdateExcelSpreadsheetTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExcelSpreadsheetTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcelSpreadsheetTemplateMutation, UpdateExcelSpreadsheetTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcelSpreadsheetTemplateMutation, UpdateExcelSpreadsheetTemplateMutationVariables>(UpdateExcelSpreadsheetTemplateDocument, options);
      }
export type UpdateExcelSpreadsheetTemplateMutationHookResult = ReturnType<typeof useUpdateExcelSpreadsheetTemplateMutation>;
export type UpdateExcelSpreadsheetTemplateMutationResult = Apollo.MutationResult<UpdateExcelSpreadsheetTemplateMutation>;
export type UpdateExcelSpreadsheetTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateExcelSpreadsheetTemplateMutation, UpdateExcelSpreadsheetTemplateMutationVariables>;
export const UpdateExcelSpreadsheetTemplatesDocument = gql`
    mutation UpdateExcelSpreadsheetTemplates($templateIds: [ID!]!, $input: UpdateExcelSpreadsheetTemplatesInput!) {
  updateExcelSpreadsheetTemplates(templateIds: $templateIds, input: $input) {
    ...ExcelSpreadsheetTemplateFields
  }
}
    ${ExcelSpreadsheetTemplateFieldsFragmentDoc}`;
export type UpdateExcelSpreadsheetTemplatesMutationFn = Apollo.MutationFunction<UpdateExcelSpreadsheetTemplatesMutation, UpdateExcelSpreadsheetTemplatesMutationVariables>;

/**
 * __useUpdateExcelSpreadsheetTemplatesMutation__
 *
 * To run a mutation, you first call `useUpdateExcelSpreadsheetTemplatesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateExcelSpreadsheetTemplatesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateExcelSpreadsheetTemplatesMutation, { data, loading, error }] = useUpdateExcelSpreadsheetTemplatesMutation({
 *   variables: {
 *      templateIds: // value for 'templateIds'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateExcelSpreadsheetTemplatesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateExcelSpreadsheetTemplatesMutation, UpdateExcelSpreadsheetTemplatesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateExcelSpreadsheetTemplatesMutation, UpdateExcelSpreadsheetTemplatesMutationVariables>(UpdateExcelSpreadsheetTemplatesDocument, options);
      }
export type UpdateExcelSpreadsheetTemplatesMutationHookResult = ReturnType<typeof useUpdateExcelSpreadsheetTemplatesMutation>;
export type UpdateExcelSpreadsheetTemplatesMutationResult = Apollo.MutationResult<UpdateExcelSpreadsheetTemplatesMutation>;
export type UpdateExcelSpreadsheetTemplatesMutationOptions = Apollo.BaseMutationOptions<UpdateExcelSpreadsheetTemplatesMutation, UpdateExcelSpreadsheetTemplatesMutationVariables>;
export const SetCaraWorkspaceArtifactDesignDocument = gql`
    mutation SetCaraWorkspaceArtifactDesign($artifactId: String!, $designId: String) {
  setCaraWorkspaceArtifactDesign(artifactId: $artifactId, designId: $designId) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type SetCaraWorkspaceArtifactDesignMutationFn = Apollo.MutationFunction<SetCaraWorkspaceArtifactDesignMutation, SetCaraWorkspaceArtifactDesignMutationVariables>;

/**
 * __useSetCaraWorkspaceArtifactDesignMutation__
 *
 * To run a mutation, you first call `useSetCaraWorkspaceArtifactDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetCaraWorkspaceArtifactDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setCaraWorkspaceArtifactDesignMutation, { data, loading, error }] = useSetCaraWorkspaceArtifactDesignMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      designId: // value for 'designId'
 *   },
 * });
 */
export function useSetCaraWorkspaceArtifactDesignMutation(baseOptions?: Apollo.MutationHookOptions<SetCaraWorkspaceArtifactDesignMutation, SetCaraWorkspaceArtifactDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetCaraWorkspaceArtifactDesignMutation, SetCaraWorkspaceArtifactDesignMutationVariables>(SetCaraWorkspaceArtifactDesignDocument, options);
      }
export type SetCaraWorkspaceArtifactDesignMutationHookResult = ReturnType<typeof useSetCaraWorkspaceArtifactDesignMutation>;
export type SetCaraWorkspaceArtifactDesignMutationResult = Apollo.MutationResult<SetCaraWorkspaceArtifactDesignMutation>;
export type SetCaraWorkspaceArtifactDesignMutationOptions = Apollo.BaseMutationOptions<SetCaraWorkspaceArtifactDesignMutation, SetCaraWorkspaceArtifactDesignMutationVariables>;
export const EnsureCaraWorkspaceArtifactFitsDesignDocument = gql`
    mutation EnsureCaraWorkspaceArtifactFitsDesign($artifactId: String!, $supersede: Boolean) {
  ensureCaraWorkspaceArtifactFitsDesign(
    artifactId: $artifactId
    supersede: $supersede
  ) {
    outcome
    artifact {
      ...CaraWorkspaceArtifactFields
    }
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type EnsureCaraWorkspaceArtifactFitsDesignMutationFn = Apollo.MutationFunction<EnsureCaraWorkspaceArtifactFitsDesignMutation, EnsureCaraWorkspaceArtifactFitsDesignMutationVariables>;

/**
 * __useEnsureCaraWorkspaceArtifactFitsDesignMutation__
 *
 * To run a mutation, you first call `useEnsureCaraWorkspaceArtifactFitsDesignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnsureCaraWorkspaceArtifactFitsDesignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [ensureCaraWorkspaceArtifactFitsDesignMutation, { data, loading, error }] = useEnsureCaraWorkspaceArtifactFitsDesignMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      supersede: // value for 'supersede'
 *   },
 * });
 */
export function useEnsureCaraWorkspaceArtifactFitsDesignMutation(baseOptions?: Apollo.MutationHookOptions<EnsureCaraWorkspaceArtifactFitsDesignMutation, EnsureCaraWorkspaceArtifactFitsDesignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EnsureCaraWorkspaceArtifactFitsDesignMutation, EnsureCaraWorkspaceArtifactFitsDesignMutationVariables>(EnsureCaraWorkspaceArtifactFitsDesignDocument, options);
      }
export type EnsureCaraWorkspaceArtifactFitsDesignMutationHookResult = ReturnType<typeof useEnsureCaraWorkspaceArtifactFitsDesignMutation>;
export type EnsureCaraWorkspaceArtifactFitsDesignMutationResult = Apollo.MutationResult<EnsureCaraWorkspaceArtifactFitsDesignMutation>;
export type EnsureCaraWorkspaceArtifactFitsDesignMutationOptions = Apollo.BaseMutationOptions<EnsureCaraWorkspaceArtifactFitsDesignMutation, EnsureCaraWorkspaceArtifactFitsDesignMutationVariables>;
export const GetCaraWorkspaceArtifactPrintsLegacyLookDocument = gql`
    query GetCaraWorkspaceArtifactPrintsLegacyLook($workspaceId: ID!, $artifactId: ID!) {
  caraWorkspaceArtifact(workspaceId: $workspaceId, artifactId: $artifactId) {
    id
    versions {
      id
      version
      printsLegacyLook
    }
  }
}
    `;

/**
 * __useGetCaraWorkspaceArtifactPrintsLegacyLookQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceArtifactPrintsLegacyLookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceArtifactPrintsLegacyLookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceArtifactPrintsLegacyLookQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetCaraWorkspaceArtifactPrintsLegacyLookQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables> & ({ variables: GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>(GetCaraWorkspaceArtifactPrintsLegacyLookDocument, options);
      }
export function useGetCaraWorkspaceArtifactPrintsLegacyLookLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>(GetCaraWorkspaceArtifactPrintsLegacyLookDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceArtifactPrintsLegacyLookSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>;
export function useGetCaraWorkspaceArtifactPrintsLegacyLookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactPrintsLegacyLookQuery | undefined, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>;
export function useGetCaraWorkspaceArtifactPrintsLegacyLookSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>(GetCaraWorkspaceArtifactPrintsLegacyLookDocument, options);
        }
export type GetCaraWorkspaceArtifactPrintsLegacyLookQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactPrintsLegacyLookQuery>;
export type GetCaraWorkspaceArtifactPrintsLegacyLookLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactPrintsLegacyLookLazyQuery>;
export type GetCaraWorkspaceArtifactPrintsLegacyLookSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactPrintsLegacyLookSuspenseQuery>;
export type GetCaraWorkspaceArtifactPrintsLegacyLookQueryResult = Apollo.QueryResult<GetCaraWorkspaceArtifactPrintsLegacyLookQuery, GetCaraWorkspaceArtifactPrintsLegacyLookQueryVariables>;
export const GetCaraWorkspaceArtifactDesignFitDocument = gql`
    query GetCaraWorkspaceArtifactDesignFit($workspaceId: ID!, $artifactId: ID!) {
  caraWorkspaceArtifact(workspaceId: $workspaceId, artifactId: $artifactId) {
    id
    versions {
      version
      designFitState {
        ...DocumentDesignFitStateFields
      }
    }
  }
}
    ${DocumentDesignFitStateFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspaceArtifactDesignFitQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceArtifactDesignFitQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceArtifactDesignFitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceArtifactDesignFitQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetCaraWorkspaceArtifactDesignFitQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables> & ({ variables: GetCaraWorkspaceArtifactDesignFitQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>(GetCaraWorkspaceArtifactDesignFitDocument, options);
      }
export function useGetCaraWorkspaceArtifactDesignFitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>(GetCaraWorkspaceArtifactDesignFitDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceArtifactDesignFitSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>;
export function useGetCaraWorkspaceArtifactDesignFitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactDesignFitQuery | undefined, GetCaraWorkspaceArtifactDesignFitQueryVariables>;
export function useGetCaraWorkspaceArtifactDesignFitSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>(GetCaraWorkspaceArtifactDesignFitDocument, options);
        }
export type GetCaraWorkspaceArtifactDesignFitQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactDesignFitQuery>;
export type GetCaraWorkspaceArtifactDesignFitLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactDesignFitLazyQuery>;
export type GetCaraWorkspaceArtifactDesignFitSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactDesignFitSuspenseQuery>;
export type GetCaraWorkspaceArtifactDesignFitQueryResult = Apollo.QueryResult<GetCaraWorkspaceArtifactDesignFitQuery, GetCaraWorkspaceArtifactDesignFitQueryVariables>;
export const MarkCaraWorkspaceArtifactFinalDocument = gql`
    mutation MarkCaraWorkspaceArtifactFinal($artifactId: String!, $version: Int!, $includeDesignPages: Boolean) {
  markCaraWorkspaceArtifactFinal(
    artifactId: $artifactId
    version: $version
    includeDesignPages: $includeDesignPages
  ) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type MarkCaraWorkspaceArtifactFinalMutationFn = Apollo.MutationFunction<MarkCaraWorkspaceArtifactFinalMutation, MarkCaraWorkspaceArtifactFinalMutationVariables>;

/**
 * __useMarkCaraWorkspaceArtifactFinalMutation__
 *
 * To run a mutation, you first call `useMarkCaraWorkspaceArtifactFinalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkCaraWorkspaceArtifactFinalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markCaraWorkspaceArtifactFinalMutation, { data, loading, error }] = useMarkCaraWorkspaceArtifactFinalMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *      includeDesignPages: // value for 'includeDesignPages'
 *   },
 * });
 */
export function useMarkCaraWorkspaceArtifactFinalMutation(baseOptions?: Apollo.MutationHookOptions<MarkCaraWorkspaceArtifactFinalMutation, MarkCaraWorkspaceArtifactFinalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkCaraWorkspaceArtifactFinalMutation, MarkCaraWorkspaceArtifactFinalMutationVariables>(MarkCaraWorkspaceArtifactFinalDocument, options);
      }
export type MarkCaraWorkspaceArtifactFinalMutationHookResult = ReturnType<typeof useMarkCaraWorkspaceArtifactFinalMutation>;
export type MarkCaraWorkspaceArtifactFinalMutationResult = Apollo.MutationResult<MarkCaraWorkspaceArtifactFinalMutation>;
export type MarkCaraWorkspaceArtifactFinalMutationOptions = Apollo.BaseMutationOptions<MarkCaraWorkspaceArtifactFinalMutation, MarkCaraWorkspaceArtifactFinalMutationVariables>;
export const UnmarkCaraWorkspaceArtifactFinalDocument = gql`
    mutation UnmarkCaraWorkspaceArtifactFinal($artifactId: String!, $version: Int!) {
  unmarkCaraWorkspaceArtifactFinal(artifactId: $artifactId, version: $version) {
    ...CaraWorkspaceArtifactFields
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}`;
export type UnmarkCaraWorkspaceArtifactFinalMutationFn = Apollo.MutationFunction<UnmarkCaraWorkspaceArtifactFinalMutation, UnmarkCaraWorkspaceArtifactFinalMutationVariables>;

/**
 * __useUnmarkCaraWorkspaceArtifactFinalMutation__
 *
 * To run a mutation, you first call `useUnmarkCaraWorkspaceArtifactFinalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkCaraWorkspaceArtifactFinalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkCaraWorkspaceArtifactFinalMutation, { data, loading, error }] = useUnmarkCaraWorkspaceArtifactFinalMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useUnmarkCaraWorkspaceArtifactFinalMutation(baseOptions?: Apollo.MutationHookOptions<UnmarkCaraWorkspaceArtifactFinalMutation, UnmarkCaraWorkspaceArtifactFinalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmarkCaraWorkspaceArtifactFinalMutation, UnmarkCaraWorkspaceArtifactFinalMutationVariables>(UnmarkCaraWorkspaceArtifactFinalDocument, options);
      }
export type UnmarkCaraWorkspaceArtifactFinalMutationHookResult = ReturnType<typeof useUnmarkCaraWorkspaceArtifactFinalMutation>;
export type UnmarkCaraWorkspaceArtifactFinalMutationResult = Apollo.MutationResult<UnmarkCaraWorkspaceArtifactFinalMutation>;
export type UnmarkCaraWorkspaceArtifactFinalMutationOptions = Apollo.BaseMutationOptions<UnmarkCaraWorkspaceArtifactFinalMutation, UnmarkCaraWorkspaceArtifactFinalMutationVariables>;
export const BuildHtmlDocumentRenderUrlDocument = gql`
    mutation BuildHtmlDocumentRenderUrl($input: BuildHtmlDocumentRenderUrlInput!) {
  buildHtmlDocumentRenderUrl(input: $input) {
    url
    outcome
  }
}
    `;
export type BuildHtmlDocumentRenderUrlMutationFn = Apollo.MutationFunction<BuildHtmlDocumentRenderUrlMutation, BuildHtmlDocumentRenderUrlMutationVariables>;

/**
 * __useBuildHtmlDocumentRenderUrlMutation__
 *
 * To run a mutation, you first call `useBuildHtmlDocumentRenderUrlMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useBuildHtmlDocumentRenderUrlMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [buildHtmlDocumentRenderUrlMutation, { data, loading, error }] = useBuildHtmlDocumentRenderUrlMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useBuildHtmlDocumentRenderUrlMutation(baseOptions?: Apollo.MutationHookOptions<BuildHtmlDocumentRenderUrlMutation, BuildHtmlDocumentRenderUrlMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<BuildHtmlDocumentRenderUrlMutation, BuildHtmlDocumentRenderUrlMutationVariables>(BuildHtmlDocumentRenderUrlDocument, options);
      }
export type BuildHtmlDocumentRenderUrlMutationHookResult = ReturnType<typeof useBuildHtmlDocumentRenderUrlMutation>;
export type BuildHtmlDocumentRenderUrlMutationResult = Apollo.MutationResult<BuildHtmlDocumentRenderUrlMutation>;
export type BuildHtmlDocumentRenderUrlMutationOptions = Apollo.BaseMutationOptions<BuildHtmlDocumentRenderUrlMutation, BuildHtmlDocumentRenderUrlMutationVariables>;
export const CreateHtmlDocumentRenderGrantDocument = gql`
    mutation CreateHtmlDocumentRenderGrant($workspaceId: ID!, $artifactId: ID!, $version: Int!, $styleId: String) {
  createHtmlDocumentRenderGrant(
    workspaceId: $workspaceId
    artifactId: $artifactId
    version: $version
    styleId: $styleId
  ) {
    token
  }
}
    `;
export type CreateHtmlDocumentRenderGrantMutationFn = Apollo.MutationFunction<CreateHtmlDocumentRenderGrantMutation, CreateHtmlDocumentRenderGrantMutationVariables>;

/**
 * __useCreateHtmlDocumentRenderGrantMutation__
 *
 * To run a mutation, you first call `useCreateHtmlDocumentRenderGrantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateHtmlDocumentRenderGrantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createHtmlDocumentRenderGrantMutation, { data, loading, error }] = useCreateHtmlDocumentRenderGrantMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      version: // value for 'version'
 *      styleId: // value for 'styleId'
 *   },
 * });
 */
export function useCreateHtmlDocumentRenderGrantMutation(baseOptions?: Apollo.MutationHookOptions<CreateHtmlDocumentRenderGrantMutation, CreateHtmlDocumentRenderGrantMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateHtmlDocumentRenderGrantMutation, CreateHtmlDocumentRenderGrantMutationVariables>(CreateHtmlDocumentRenderGrantDocument, options);
      }
export type CreateHtmlDocumentRenderGrantMutationHookResult = ReturnType<typeof useCreateHtmlDocumentRenderGrantMutation>;
export type CreateHtmlDocumentRenderGrantMutationResult = Apollo.MutationResult<CreateHtmlDocumentRenderGrantMutation>;
export type CreateHtmlDocumentRenderGrantMutationOptions = Apollo.BaseMutationOptions<CreateHtmlDocumentRenderGrantMutation, CreateHtmlDocumentRenderGrantMutationVariables>;
export const WatchCaraWorkspaceDocument = gql`
    subscription WatchCaraWorkspace($id: ID!) {
  watchCaraWorkspace(id: $id) {
    ...CaraWorkspaceFields
  }
}
    ${CaraWorkspaceFieldsFragmentDoc}`;

/**
 * __useWatchCaraWorkspaceSubscription__
 *
 * To run a query within a React component, call `useWatchCaraWorkspaceSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchCaraWorkspaceSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchCaraWorkspaceSubscription({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useWatchCaraWorkspaceSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchCaraWorkspaceSubscription, WatchCaraWorkspaceSubscriptionVariables> & ({ variables: WatchCaraWorkspaceSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchCaraWorkspaceSubscription, WatchCaraWorkspaceSubscriptionVariables>(WatchCaraWorkspaceDocument, options);
      }
export type WatchCaraWorkspaceSubscriptionHookResult = ReturnType<typeof useWatchCaraWorkspaceSubscription>;
export type WatchCaraWorkspaceSubscriptionResult = Apollo.SubscriptionResult<WatchCaraWorkspaceSubscription>;
export const GetCaraWorkspaceArtifactCommentsDocument = gql`
    query GetCaraWorkspaceArtifactComments($workspaceId: ID!, $artifactId: ID!) {
  caraWorkspaceArtifactComments(
    workspaceId: $workspaceId
    artifactId: $artifactId
  ) {
    ...CaraWorkspaceArtifactCommentFields
  }
}
    ${CaraWorkspaceArtifactCommentFieldsFragmentDoc}`;

/**
 * __useGetCaraWorkspaceArtifactCommentsQuery__
 *
 * To run a query within a React component, call `useGetCaraWorkspaceArtifactCommentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCaraWorkspaceArtifactCommentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCaraWorkspaceArtifactCommentsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useGetCaraWorkspaceArtifactCommentsQuery(baseOptions: Apollo.QueryHookOptions<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables> & ({ variables: GetCaraWorkspaceArtifactCommentsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>(GetCaraWorkspaceArtifactCommentsDocument, options);
      }
export function useGetCaraWorkspaceArtifactCommentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>(GetCaraWorkspaceArtifactCommentsDocument, options);
        }
// @ts-ignore
export function useGetCaraWorkspaceArtifactCommentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>;
export function useGetCaraWorkspaceArtifactCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCaraWorkspaceArtifactCommentsQuery | undefined, GetCaraWorkspaceArtifactCommentsQueryVariables>;
export function useGetCaraWorkspaceArtifactCommentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>(GetCaraWorkspaceArtifactCommentsDocument, options);
        }
export type GetCaraWorkspaceArtifactCommentsQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactCommentsQuery>;
export type GetCaraWorkspaceArtifactCommentsLazyQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactCommentsLazyQuery>;
export type GetCaraWorkspaceArtifactCommentsSuspenseQueryHookResult = ReturnType<typeof useGetCaraWorkspaceArtifactCommentsSuspenseQuery>;
export type GetCaraWorkspaceArtifactCommentsQueryResult = Apollo.QueryResult<GetCaraWorkspaceArtifactCommentsQuery, GetCaraWorkspaceArtifactCommentsQueryVariables>;
export const AddCaraWorkspaceArtifactCommentDocument = gql`
    mutation AddCaraWorkspaceArtifactComment($workspaceId: ID!, $artifactId: ID!, $input: CaraWorkspaceArtifactCommentInput!) {
  addCaraWorkspaceArtifactComment(
    workspaceId: $workspaceId
    artifactId: $artifactId
    input: $input
  ) {
    ...CaraWorkspaceArtifactCommentFields
  }
}
    ${CaraWorkspaceArtifactCommentFieldsFragmentDoc}`;
export type AddCaraWorkspaceArtifactCommentMutationFn = Apollo.MutationFunction<AddCaraWorkspaceArtifactCommentMutation, AddCaraWorkspaceArtifactCommentMutationVariables>;

/**
 * __useAddCaraWorkspaceArtifactCommentMutation__
 *
 * To run a mutation, you first call `useAddCaraWorkspaceArtifactCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddCaraWorkspaceArtifactCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addCaraWorkspaceArtifactCommentMutation, { data, loading, error }] = useAddCaraWorkspaceArtifactCommentMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddCaraWorkspaceArtifactCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddCaraWorkspaceArtifactCommentMutation, AddCaraWorkspaceArtifactCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddCaraWorkspaceArtifactCommentMutation, AddCaraWorkspaceArtifactCommentMutationVariables>(AddCaraWorkspaceArtifactCommentDocument, options);
      }
export type AddCaraWorkspaceArtifactCommentMutationHookResult = ReturnType<typeof useAddCaraWorkspaceArtifactCommentMutation>;
export type AddCaraWorkspaceArtifactCommentMutationResult = Apollo.MutationResult<AddCaraWorkspaceArtifactCommentMutation>;
export type AddCaraWorkspaceArtifactCommentMutationOptions = Apollo.BaseMutationOptions<AddCaraWorkspaceArtifactCommentMutation, AddCaraWorkspaceArtifactCommentMutationVariables>;
export const ResolveCaraWorkspaceArtifactCommentDocument = gql`
    mutation ResolveCaraWorkspaceArtifactComment($workspaceId: ID!, $commentId: ID!) {
  resolveCaraWorkspaceArtifactComment(
    workspaceId: $workspaceId
    commentId: $commentId
  ) {
    ...CaraWorkspaceArtifactCommentFields
  }
}
    ${CaraWorkspaceArtifactCommentFieldsFragmentDoc}`;
export type ResolveCaraWorkspaceArtifactCommentMutationFn = Apollo.MutationFunction<ResolveCaraWorkspaceArtifactCommentMutation, ResolveCaraWorkspaceArtifactCommentMutationVariables>;

/**
 * __useResolveCaraWorkspaceArtifactCommentMutation__
 *
 * To run a mutation, you first call `useResolveCaraWorkspaceArtifactCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveCaraWorkspaceArtifactCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveCaraWorkspaceArtifactCommentMutation, { data, loading, error }] = useResolveCaraWorkspaceArtifactCommentMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useResolveCaraWorkspaceArtifactCommentMutation(baseOptions?: Apollo.MutationHookOptions<ResolveCaraWorkspaceArtifactCommentMutation, ResolveCaraWorkspaceArtifactCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveCaraWorkspaceArtifactCommentMutation, ResolveCaraWorkspaceArtifactCommentMutationVariables>(ResolveCaraWorkspaceArtifactCommentDocument, options);
      }
export type ResolveCaraWorkspaceArtifactCommentMutationHookResult = ReturnType<typeof useResolveCaraWorkspaceArtifactCommentMutation>;
export type ResolveCaraWorkspaceArtifactCommentMutationResult = Apollo.MutationResult<ResolveCaraWorkspaceArtifactCommentMutation>;
export type ResolveCaraWorkspaceArtifactCommentMutationOptions = Apollo.BaseMutationOptions<ResolveCaraWorkspaceArtifactCommentMutation, ResolveCaraWorkspaceArtifactCommentMutationVariables>;
export const DeleteCaraWorkspaceArtifactCommentDocument = gql`
    mutation DeleteCaraWorkspaceArtifactComment($workspaceId: ID!, $commentId: ID!) {
  deleteCaraWorkspaceArtifactComment(
    workspaceId: $workspaceId
    commentId: $commentId
  )
}
    `;
export type DeleteCaraWorkspaceArtifactCommentMutationFn = Apollo.MutationFunction<DeleteCaraWorkspaceArtifactCommentMutation, DeleteCaraWorkspaceArtifactCommentMutationVariables>;

/**
 * __useDeleteCaraWorkspaceArtifactCommentMutation__
 *
 * To run a mutation, you first call `useDeleteCaraWorkspaceArtifactCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteCaraWorkspaceArtifactCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteCaraWorkspaceArtifactCommentMutation, { data, loading, error }] = useDeleteCaraWorkspaceArtifactCommentMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      commentId: // value for 'commentId'
 *   },
 * });
 */
export function useDeleteCaraWorkspaceArtifactCommentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteCaraWorkspaceArtifactCommentMutation, DeleteCaraWorkspaceArtifactCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteCaraWorkspaceArtifactCommentMutation, DeleteCaraWorkspaceArtifactCommentMutationVariables>(DeleteCaraWorkspaceArtifactCommentDocument, options);
      }
export type DeleteCaraWorkspaceArtifactCommentMutationHookResult = ReturnType<typeof useDeleteCaraWorkspaceArtifactCommentMutation>;
export type DeleteCaraWorkspaceArtifactCommentMutationResult = Apollo.MutationResult<DeleteCaraWorkspaceArtifactCommentMutation>;
export type DeleteCaraWorkspaceArtifactCommentMutationOptions = Apollo.BaseMutationOptions<DeleteCaraWorkspaceArtifactCommentMutation, DeleteCaraWorkspaceArtifactCommentMutationVariables>;
export const GetCertificateDocument = gql`
    query GetCertificate($id: ID!) {
  certificate(id: $id) {
    ...CertificateOfLiabilityInsuranceFields
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}`;

/**
 * __useGetCertificateQuery__
 *
 * To run a query within a React component, call `useGetCertificateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCertificateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCertificateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCertificateQuery(baseOptions: Apollo.QueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables> & ({ variables: GetCertificateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
      }
export function useGetCertificateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
// @ts-ignore
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>): Apollo.UseSuspenseQueryResult<GetCertificateQuery, GetCertificateQueryVariables>;
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>): Apollo.UseSuspenseQueryResult<GetCertificateQuery | undefined, GetCertificateQueryVariables>;
export function useGetCertificateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCertificateQuery, GetCertificateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCertificateQuery, GetCertificateQueryVariables>(GetCertificateDocument, options);
        }
export type GetCertificateQueryHookResult = ReturnType<typeof useGetCertificateQuery>;
export type GetCertificateLazyQueryHookResult = ReturnType<typeof useGetCertificateLazyQuery>;
export type GetCertificateSuspenseQueryHookResult = ReturnType<typeof useGetCertificateSuspenseQuery>;
export type GetCertificateQueryResult = Apollo.QueryResult<GetCertificateQuery, GetCertificateQueryVariables>;
export const CreateCertificateDocument = gql`
    mutation CreateCertificate($input: CreateCertificateInput!) {
  createCertificate(input: $input) {
    ...CertificateOfLiabilityInsuranceFields
  }
}
    ${CertificateOfLiabilityInsuranceFieldsFragmentDoc}`;
export type CreateCertificateMutationFn = Apollo.MutationFunction<CreateCertificateMutation, CreateCertificateMutationVariables>;

/**
 * __useCreateCertificateMutation__
 *
 * To run a mutation, you first call `useCreateCertificateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateCertificateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createCertificateMutation, { data, loading, error }] = useCreateCertificateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateCertificateMutation(baseOptions?: Apollo.MutationHookOptions<CreateCertificateMutation, CreateCertificateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateCertificateMutation, CreateCertificateMutationVariables>(CreateCertificateDocument, options);
      }
export type CreateCertificateMutationHookResult = ReturnType<typeof useCreateCertificateMutation>;
export type CreateCertificateMutationResult = Apollo.MutationResult<CreateCertificateMutation>;
export type CreateCertificateMutationOptions = Apollo.BaseMutationOptions<CreateCertificateMutation, CreateCertificateMutationVariables>;
export const ClientMergeCandidatesDocument = gql`
    query ClientMergeCandidates($first: Int, $after: String) {
  clientMergeCandidates(first: $first, after: $after) {
    edges {
      cursor
      node {
        id
        score
        reason
        clientA {
          ...MergeCandidateSide
        }
        clientB {
          ...MergeCandidateSide
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${MergeCandidateSideFragmentDoc}`;

/**
 * __useClientMergeCandidatesQuery__
 *
 * To run a query within a React component, call `useClientMergeCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMergeCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMergeCandidatesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *   },
 * });
 */
export function useClientMergeCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>(ClientMergeCandidatesDocument, options);
      }
export function useClientMergeCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>(ClientMergeCandidatesDocument, options);
        }
// @ts-ignore
export function useClientMergeCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>;
export function useClientMergeCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeCandidatesQuery | undefined, ClientMergeCandidatesQueryVariables>;
export function useClientMergeCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>(ClientMergeCandidatesDocument, options);
        }
export type ClientMergeCandidatesQueryHookResult = ReturnType<typeof useClientMergeCandidatesQuery>;
export type ClientMergeCandidatesLazyQueryHookResult = ReturnType<typeof useClientMergeCandidatesLazyQuery>;
export type ClientMergeCandidatesSuspenseQueryHookResult = ReturnType<typeof useClientMergeCandidatesSuspenseQuery>;
export type ClientMergeCandidatesQueryResult = Apollo.QueryResult<ClientMergeCandidatesQuery, ClientMergeCandidatesQueryVariables>;
export const ClientMergeSideDocument = gql`
    query ClientMergeSide($id: ID!) {
  client(id: $id) {
    ...ClientMergeSide
  }
}
    ${ClientMergeSideFragmentDoc}`;

/**
 * __useClientMergeSideQuery__
 *
 * To run a query within a React component, call `useClientMergeSideQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMergeSideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMergeSideQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useClientMergeSideQuery(baseOptions: Apollo.QueryHookOptions<ClientMergeSideQuery, ClientMergeSideQueryVariables> & ({ variables: ClientMergeSideQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientMergeSideQuery, ClientMergeSideQueryVariables>(ClientMergeSideDocument, options);
      }
export function useClientMergeSideLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientMergeSideQuery, ClientMergeSideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientMergeSideQuery, ClientMergeSideQueryVariables>(ClientMergeSideDocument, options);
        }
// @ts-ignore
export function useClientMergeSideSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientMergeSideQuery, ClientMergeSideQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeSideQuery, ClientMergeSideQueryVariables>;
export function useClientMergeSideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeSideQuery, ClientMergeSideQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeSideQuery | undefined, ClientMergeSideQueryVariables>;
export function useClientMergeSideSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeSideQuery, ClientMergeSideQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientMergeSideQuery, ClientMergeSideQueryVariables>(ClientMergeSideDocument, options);
        }
export type ClientMergeSideQueryHookResult = ReturnType<typeof useClientMergeSideQuery>;
export type ClientMergeSideLazyQueryHookResult = ReturnType<typeof useClientMergeSideLazyQuery>;
export type ClientMergeSideSuspenseQueryHookResult = ReturnType<typeof useClientMergeSideSuspenseQuery>;
export type ClientMergeSideQueryResult = Apollo.QueryResult<ClientMergeSideQuery, ClientMergeSideQueryVariables>;
export const MergeManyClientsDocument = gql`
    mutation MergeManyClients($input: ClientGroupMergeInput!) {
  mergeManyClients(input: $input) {
    ...ClientMergeSide
    ...ClientListFields
  }
}
    ${ClientMergeSideFragmentDoc}
${ClientListFieldsFragmentDoc}`;
export type MergeManyClientsMutationFn = Apollo.MutationFunction<MergeManyClientsMutation, MergeManyClientsMutationVariables>;

/**
 * __useMergeManyClientsMutation__
 *
 * To run a mutation, you first call `useMergeManyClientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMergeManyClientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [mergeManyClientsMutation, { data, loading, error }] = useMergeManyClientsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMergeManyClientsMutation(baseOptions?: Apollo.MutationHookOptions<MergeManyClientsMutation, MergeManyClientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MergeManyClientsMutation, MergeManyClientsMutationVariables>(MergeManyClientsDocument, options);
      }
export type MergeManyClientsMutationHookResult = ReturnType<typeof useMergeManyClientsMutation>;
export type MergeManyClientsMutationResult = Apollo.MutationResult<MergeManyClientsMutation>;
export type MergeManyClientsMutationOptions = Apollo.BaseMutationOptions<MergeManyClientsMutation, MergeManyClientsMutationVariables>;
export const KeepClientsSeparateDocument = gql`
    mutation KeepClientsSeparate($candidateId: ID!) {
  keepClientsSeparate(candidateId: $candidateId) {
    id
    status
  }
}
    `;
export type KeepClientsSeparateMutationFn = Apollo.MutationFunction<KeepClientsSeparateMutation, KeepClientsSeparateMutationVariables>;

/**
 * __useKeepClientsSeparateMutation__
 *
 * To run a mutation, you first call `useKeepClientsSeparateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKeepClientsSeparateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [keepClientsSeparateMutation, { data, loading, error }] = useKeepClientsSeparateMutation({
 *   variables: {
 *      candidateId: // value for 'candidateId'
 *   },
 * });
 */
export function useKeepClientsSeparateMutation(baseOptions?: Apollo.MutationHookOptions<KeepClientsSeparateMutation, KeepClientsSeparateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<KeepClientsSeparateMutation, KeepClientsSeparateMutationVariables>(KeepClientsSeparateDocument, options);
      }
export type KeepClientsSeparateMutationHookResult = ReturnType<typeof useKeepClientsSeparateMutation>;
export type KeepClientsSeparateMutationResult = Apollo.MutationResult<KeepClientsSeparateMutation>;
export type KeepClientsSeparateMutationOptions = Apollo.BaseMutationOptions<KeepClientsSeparateMutation, KeepClientsSeparateMutationVariables>;
export const ClientMergeCandidateCountDocument = gql`
    query ClientMergeCandidateCount {
  clientMergeCandidates(first: 1) {
    totalCount
  }
}
    `;

/**
 * __useClientMergeCandidateCountQuery__
 *
 * To run a query within a React component, call `useClientMergeCandidateCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientMergeCandidateCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientMergeCandidateCountQuery({
 *   variables: {
 *   },
 * });
 */
export function useClientMergeCandidateCountQuery(baseOptions?: Apollo.QueryHookOptions<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>(ClientMergeCandidateCountDocument, options);
      }
export function useClientMergeCandidateCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>(ClientMergeCandidateCountDocument, options);
        }
// @ts-ignore
export function useClientMergeCandidateCountSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>;
export function useClientMergeCandidateCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>): Apollo.UseSuspenseQueryResult<ClientMergeCandidateCountQuery | undefined, ClientMergeCandidateCountQueryVariables>;
export function useClientMergeCandidateCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>(ClientMergeCandidateCountDocument, options);
        }
export type ClientMergeCandidateCountQueryHookResult = ReturnType<typeof useClientMergeCandidateCountQuery>;
export type ClientMergeCandidateCountLazyQueryHookResult = ReturnType<typeof useClientMergeCandidateCountLazyQuery>;
export type ClientMergeCandidateCountSuspenseQueryHookResult = ReturnType<typeof useClientMergeCandidateCountSuspenseQuery>;
export type ClientMergeCandidateCountQueryResult = Apollo.QueryResult<ClientMergeCandidateCountQuery, ClientMergeCandidateCountQueryVariables>;
export const GetClientNotesDocument = gql`
    query GetClientNotes($clientId: ID!) {
  clientNotes(clientId: $clientId) {
    ...ClientNoteFields
  }
}
    ${ClientNoteFieldsFragmentDoc}`;

/**
 * __useGetClientNotesQuery__
 *
 * To run a query within a React component, call `useGetClientNotesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientNotesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientNotesQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *   },
 * });
 */
export function useGetClientNotesQuery(baseOptions: Apollo.QueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables> & ({ variables: GetClientNotesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
      }
export function useGetClientNotesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
        }
// @ts-ignore
export function useGetClientNotesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientNotesQuery, GetClientNotesQueryVariables>;
export function useGetClientNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientNotesQuery | undefined, GetClientNotesQueryVariables>;
export function useGetClientNotesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientNotesQuery, GetClientNotesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientNotesQuery, GetClientNotesQueryVariables>(GetClientNotesDocument, options);
        }
export type GetClientNotesQueryHookResult = ReturnType<typeof useGetClientNotesQuery>;
export type GetClientNotesLazyQueryHookResult = ReturnType<typeof useGetClientNotesLazyQuery>;
export type GetClientNotesSuspenseQueryHookResult = ReturnType<typeof useGetClientNotesSuspenseQuery>;
export type GetClientNotesQueryResult = Apollo.QueryResult<GetClientNotesQuery, GetClientNotesQueryVariables>;
export const CreateClientNoteDocument = gql`
    mutation CreateClientNote($clientId: ID!, $body: String!) {
  createClientNote(clientId: $clientId, body: $body) {
    ...ClientNoteFields
  }
}
    ${ClientNoteFieldsFragmentDoc}`;
export type CreateClientNoteMutationFn = Apollo.MutationFunction<CreateClientNoteMutation, CreateClientNoteMutationVariables>;

/**
 * __useCreateClientNoteMutation__
 *
 * To run a mutation, you first call `useCreateClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientNoteMutation, { data, loading, error }] = useCreateClientNoteMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientNoteMutation, CreateClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientNoteMutation, CreateClientNoteMutationVariables>(CreateClientNoteDocument, options);
      }
export type CreateClientNoteMutationHookResult = ReturnType<typeof useCreateClientNoteMutation>;
export type CreateClientNoteMutationResult = Apollo.MutationResult<CreateClientNoteMutation>;
export type CreateClientNoteMutationOptions = Apollo.BaseMutationOptions<CreateClientNoteMutation, CreateClientNoteMutationVariables>;
export const UpdateClientNoteDocument = gql`
    mutation UpdateClientNote($id: ID!, $body: String!) {
  updateClientNote(id: $id, body: $body) {
    ...ClientNoteFields
  }
}
    ${ClientNoteFieldsFragmentDoc}`;
export type UpdateClientNoteMutationFn = Apollo.MutationFunction<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>;

/**
 * __useUpdateClientNoteMutation__
 *
 * To run a mutation, you first call `useUpdateClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientNoteMutation, { data, loading, error }] = useUpdateClientNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>(UpdateClientNoteDocument, options);
      }
export type UpdateClientNoteMutationHookResult = ReturnType<typeof useUpdateClientNoteMutation>;
export type UpdateClientNoteMutationResult = Apollo.MutationResult<UpdateClientNoteMutation>;
export type UpdateClientNoteMutationOptions = Apollo.BaseMutationOptions<UpdateClientNoteMutation, UpdateClientNoteMutationVariables>;
export const DeleteClientNoteDocument = gql`
    mutation DeleteClientNote($id: ID!) {
  deleteClientNote(id: $id)
}
    `;
export type DeleteClientNoteMutationFn = Apollo.MutationFunction<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>;

/**
 * __useDeleteClientNoteMutation__
 *
 * To run a mutation, you first call `useDeleteClientNoteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteClientNoteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteClientNoteMutation, { data, loading, error }] = useDeleteClientNoteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteClientNoteMutation(baseOptions?: Apollo.MutationHookOptions<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>(DeleteClientNoteDocument, options);
      }
export type DeleteClientNoteMutationHookResult = ReturnType<typeof useDeleteClientNoteMutation>;
export type DeleteClientNoteMutationResult = Apollo.MutationResult<DeleteClientNoteMutation>;
export type DeleteClientNoteMutationOptions = Apollo.BaseMutationOptions<DeleteClientNoteMutation, DeleteClientNoteMutationVariables>;
export const SearchClientsDocument = gql`
    query SearchClients($first: Int, $after: String, $filter: ClientFilterInput, $sort: ClientSortInput) {
  clients(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...ClientFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useSearchClientsQuery__
 *
 * To run a query within a React component, call `useSearchClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchClientsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchClientsQuery(baseOptions?: Apollo.QueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, options);
      }
export function useSearchClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, options);
        }
// @ts-ignore
export function useSearchClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchClientsQuery, SearchClientsQueryVariables>;
export function useSearchClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchClientsQuery | undefined, SearchClientsQueryVariables>;
export function useSearchClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchClientsQuery, SearchClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchClientsQuery, SearchClientsQueryVariables>(SearchClientsDocument, options);
        }
export type SearchClientsQueryHookResult = ReturnType<typeof useSearchClientsQuery>;
export type SearchClientsLazyQueryHookResult = ReturnType<typeof useSearchClientsLazyQuery>;
export type SearchClientsSuspenseQueryHookResult = ReturnType<typeof useSearchClientsSuspenseQuery>;
export type SearchClientsQueryResult = Apollo.QueryResult<SearchClientsQuery, SearchClientsQueryVariables>;
export const ClientListDocument = gql`
    query ClientList($first: Int, $after: String, $filter: ClientFilterInput, $sort: ClientSortInput) {
  clients(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...ClientListFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${ClientListFieldsFragmentDoc}`;

/**
 * __useClientListQuery__
 *
 * To run a query within a React component, call `useClientListQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientListQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useClientListQuery(baseOptions?: Apollo.QueryHookOptions<ClientListQuery, ClientListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
      }
export function useClientListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientListQuery, ClientListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
        }
// @ts-ignore
export function useClientListSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientListQuery, ClientListQueryVariables>): Apollo.UseSuspenseQueryResult<ClientListQuery, ClientListQueryVariables>;
export function useClientListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientListQuery, ClientListQueryVariables>): Apollo.UseSuspenseQueryResult<ClientListQuery | undefined, ClientListQueryVariables>;
export function useClientListSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientListQuery, ClientListQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientListQuery, ClientListQueryVariables>(ClientListDocument, options);
        }
export type ClientListQueryHookResult = ReturnType<typeof useClientListQuery>;
export type ClientListLazyQueryHookResult = ReturnType<typeof useClientListLazyQuery>;
export type ClientListSuspenseQueryHookResult = ReturnType<typeof useClientListSuspenseQuery>;
export type ClientListQueryResult = Apollo.QueryResult<ClientListQuery, ClientListQueryVariables>;
export const GetClientDocument = gql`
    query GetClient($id: ID!) {
  client(id: $id) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;

/**
 * __useGetClientQuery__
 *
 * To run a query within a React component, call `useGetClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientQuery(baseOptions: Apollo.QueryHookOptions<GetClientQuery, GetClientQueryVariables> & ({ variables: GetClientQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
      }
export function useGetClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
// @ts-ignore
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientQuery | undefined, GetClientQueryVariables>;
export function useGetClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientQuery, GetClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientQuery, GetClientQueryVariables>(GetClientDocument, options);
        }
export type GetClientQueryHookResult = ReturnType<typeof useGetClientQuery>;
export type GetClientLazyQueryHookResult = ReturnType<typeof useGetClientLazyQuery>;
export type GetClientSuspenseQueryHookResult = ReturnType<typeof useGetClientSuspenseQuery>;
export type GetClientQueryResult = Apollo.QueryResult<GetClientQuery, GetClientQueryVariables>;
export const GetClientOverviewDocument = gql`
    query GetClientOverview($id: ID!) {
  client(id: $id) {
    ...ClientFields
    amsAccounts {
      ...ClientAmsAccountFields
    }
    fieldProvenance {
      ...ClientFieldProvenanceFields
    }
    agencyUsers {
      id
      name
      email
    }
    pendingMergeCandidates {
      id
      score
      clientA {
        id
        name
      }
      clientB {
        id
        name
      }
    }
  }
}
    ${ClientFieldsFragmentDoc}
${ClientAmsAccountFieldsFragmentDoc}
${ClientFieldProvenanceFieldsFragmentDoc}`;

/**
 * __useGetClientOverviewQuery__
 *
 * To run a query within a React component, call `useGetClientOverviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientOverviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientOverviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientOverviewQuery(baseOptions: Apollo.QueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables> & ({ variables: GetClientOverviewQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientOverviewQuery, GetClientOverviewQueryVariables>(GetClientOverviewDocument, options);
      }
export function useGetClientOverviewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientOverviewQuery, GetClientOverviewQueryVariables>(GetClientOverviewDocument, options);
        }
// @ts-ignore
export function useGetClientOverviewSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOverviewQuery, GetClientOverviewQueryVariables>;
export function useGetClientOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientOverviewQuery | undefined, GetClientOverviewQueryVariables>;
export function useGetClientOverviewSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientOverviewQuery, GetClientOverviewQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientOverviewQuery, GetClientOverviewQueryVariables>(GetClientOverviewDocument, options);
        }
export type GetClientOverviewQueryHookResult = ReturnType<typeof useGetClientOverviewQuery>;
export type GetClientOverviewLazyQueryHookResult = ReturnType<typeof useGetClientOverviewLazyQuery>;
export type GetClientOverviewSuspenseQueryHookResult = ReturnType<typeof useGetClientOverviewSuspenseQuery>;
export type GetClientOverviewQueryResult = Apollo.QueryResult<GetClientOverviewQuery, GetClientOverviewQueryVariables>;
export const GetClientArtifactsDocument = gql`
    query GetClientArtifacts($id: ID!, $first: Int, $after: String, $filter: ClientArtifactFilterInput, $sort: ClientDocumentSortInput) {
  client(id: $id) {
    id
    artifacts(first: $first, after: $after, filter: $filter, sort: $sort) {
      edges {
        cursor
        node {
          ...ClientArtifactFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientArtifactFieldsFragmentDoc}`;

/**
 * __useGetClientArtifactsQuery__
 *
 * To run a query within a React component, call `useGetClientArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientArtifactsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetClientArtifactsQuery(baseOptions: Apollo.QueryHookOptions<GetClientArtifactsQuery, GetClientArtifactsQueryVariables> & ({ variables: GetClientArtifactsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>(GetClientArtifactsDocument, options);
      }
export function useGetClientArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>(GetClientArtifactsDocument, options);
        }
// @ts-ignore
export function useGetClientArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>;
export function useGetClientArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientArtifactsQuery | undefined, GetClientArtifactsQueryVariables>;
export function useGetClientArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>(GetClientArtifactsDocument, options);
        }
export type GetClientArtifactsQueryHookResult = ReturnType<typeof useGetClientArtifactsQuery>;
export type GetClientArtifactsLazyQueryHookResult = ReturnType<typeof useGetClientArtifactsLazyQuery>;
export type GetClientArtifactsSuspenseQueryHookResult = ReturnType<typeof useGetClientArtifactsSuspenseQuery>;
export type GetClientArtifactsQueryResult = Apollo.QueryResult<GetClientArtifactsQuery, GetClientArtifactsQueryVariables>;
export const GetClientFilesDocument = gql`
    query GetClientFiles($id: ID!, $first: Int, $after: String, $filter: ClientFileFilterInput, $sort: ClientDocumentSortInput) {
  client(id: $id) {
    id
    files(first: $first, after: $after, filter: $filter, sort: $sort) {
      edges {
        cursor
        node {
          ...ClientFileFields
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
    }
  }
}
    ${ClientFileFieldsFragmentDoc}`;

/**
 * __useGetClientFilesQuery__
 *
 * To run a query within a React component, call `useGetClientFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientFilesQuery({
 *   variables: {
 *      id: // value for 'id'
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetClientFilesQuery(baseOptions: Apollo.QueryHookOptions<GetClientFilesQuery, GetClientFilesQueryVariables> & ({ variables: GetClientFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetClientFilesQuery, GetClientFilesQueryVariables>(GetClientFilesDocument, options);
      }
export function useGetClientFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetClientFilesQuery, GetClientFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetClientFilesQuery, GetClientFilesQueryVariables>(GetClientFilesDocument, options);
        }
// @ts-ignore
export function useGetClientFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetClientFilesQuery, GetClientFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientFilesQuery, GetClientFilesQueryVariables>;
export function useGetClientFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientFilesQuery, GetClientFilesQueryVariables>): Apollo.UseSuspenseQueryResult<GetClientFilesQuery | undefined, GetClientFilesQueryVariables>;
export function useGetClientFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetClientFilesQuery, GetClientFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetClientFilesQuery, GetClientFilesQueryVariables>(GetClientFilesDocument, options);
        }
export type GetClientFilesQueryHookResult = ReturnType<typeof useGetClientFilesQuery>;
export type GetClientFilesLazyQueryHookResult = ReturnType<typeof useGetClientFilesLazyQuery>;
export type GetClientFilesSuspenseQueryHookResult = ReturnType<typeof useGetClientFilesSuspenseQuery>;
export type GetClientFilesQueryResult = Apollo.QueryResult<GetClientFilesQuery, GetClientFilesQueryVariables>;
export const RemoveClientArtifactDocument = gql`
    mutation RemoveClientArtifact($clientId: ID!, $artifactId: ID!) {
  removeClientArtifact(clientId: $clientId, artifactId: $artifactId) {
    id
  }
}
    `;
export type RemoveClientArtifactMutationFn = Apollo.MutationFunction<RemoveClientArtifactMutation, RemoveClientArtifactMutationVariables>;

/**
 * __useRemoveClientArtifactMutation__
 *
 * To run a mutation, you first call `useRemoveClientArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClientArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClientArtifactMutation, { data, loading, error }] = useRemoveClientArtifactMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useRemoveClientArtifactMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClientArtifactMutation, RemoveClientArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClientArtifactMutation, RemoveClientArtifactMutationVariables>(RemoveClientArtifactDocument, options);
      }
export type RemoveClientArtifactMutationHookResult = ReturnType<typeof useRemoveClientArtifactMutation>;
export type RemoveClientArtifactMutationResult = Apollo.MutationResult<RemoveClientArtifactMutation>;
export type RemoveClientArtifactMutationOptions = Apollo.BaseMutationOptions<RemoveClientArtifactMutation, RemoveClientArtifactMutationVariables>;
export const RemoveClientFileDocument = gql`
    mutation RemoveClientFile($clientId: ID!, $fileId: ID!) {
  removeClientFile(clientId: $clientId, fileId: $fileId) {
    id
  }
}
    `;
export type RemoveClientFileMutationFn = Apollo.MutationFunction<RemoveClientFileMutation, RemoveClientFileMutationVariables>;

/**
 * __useRemoveClientFileMutation__
 *
 * To run a mutation, you first call `useRemoveClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeClientFileMutation, { data, loading, error }] = useRemoveClientFileMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useRemoveClientFileMutation(baseOptions?: Apollo.MutationHookOptions<RemoveClientFileMutation, RemoveClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveClientFileMutation, RemoveClientFileMutationVariables>(RemoveClientFileDocument, options);
      }
export type RemoveClientFileMutationHookResult = ReturnType<typeof useRemoveClientFileMutation>;
export type RemoveClientFileMutationResult = Apollo.MutationResult<RemoveClientFileMutation>;
export type RemoveClientFileMutationOptions = Apollo.BaseMutationOptions<RemoveClientFileMutation, RemoveClientFileMutationVariables>;
export const CreateClientDocument = gql`
    mutation CreateClient($input: ClientInput!) {
  createClient(input: $input) {
    ...ClientFields
  }
}
    ${ClientFieldsFragmentDoc}`;
export type CreateClientMutationFn = Apollo.MutationFunction<CreateClientMutation, CreateClientMutationVariables>;

/**
 * __useCreateClientMutation__
 *
 * To run a mutation, you first call `useCreateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createClientMutation, { data, loading, error }] = useCreateClientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateClientMutation(baseOptions?: Apollo.MutationHookOptions<CreateClientMutation, CreateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateClientMutation, CreateClientMutationVariables>(CreateClientDocument, options);
      }
export type CreateClientMutationHookResult = ReturnType<typeof useCreateClientMutation>;
export type CreateClientMutationResult = Apollo.MutationResult<CreateClientMutation>;
export type CreateClientMutationOptions = Apollo.BaseMutationOptions<CreateClientMutation, CreateClientMutationVariables>;
export const UpdateClientDocument = gql`
    mutation UpdateClient($id: ID!, $input: UpdateClientInput!) {
  updateClient(id: $id, input: $input) {
    ...ClientFields
    fieldProvenance {
      ...ClientFieldProvenanceFields
    }
  }
}
    ${ClientFieldsFragmentDoc}
${ClientFieldProvenanceFieldsFragmentDoc}`;
export type UpdateClientMutationFn = Apollo.MutationFunction<UpdateClientMutation, UpdateClientMutationVariables>;

/**
 * __useUpdateClientMutation__
 *
 * To run a mutation, you first call `useUpdateClientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateClientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateClientMutation, { data, loading, error }] = useUpdateClientMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateClientMutation(baseOptions?: Apollo.MutationHookOptions<UpdateClientMutation, UpdateClientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateClientMutation, UpdateClientMutationVariables>(UpdateClientDocument, options);
      }
export type UpdateClientMutationHookResult = ReturnType<typeof useUpdateClientMutation>;
export type UpdateClientMutationResult = Apollo.MutationResult<UpdateClientMutation>;
export type UpdateClientMutationOptions = Apollo.BaseMutationOptions<UpdateClientMutation, UpdateClientMutationVariables>;
export const ConfirmClientFieldDocument = gql`
    mutation ConfirmClientField($clientId: ID!, $field: ClientField!, $value: String!) {
  confirmClientField(clientId: $clientId, field: $field, value: $value) {
    ...ClientFieldProvenanceFields
  }
}
    ${ClientFieldProvenanceFieldsFragmentDoc}`;
export type ConfirmClientFieldMutationFn = Apollo.MutationFunction<ConfirmClientFieldMutation, ConfirmClientFieldMutationVariables>;

/**
 * __useConfirmClientFieldMutation__
 *
 * To run a mutation, you first call `useConfirmClientFieldMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmClientFieldMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmClientFieldMutation, { data, loading, error }] = useConfirmClientFieldMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      field: // value for 'field'
 *      value: // value for 'value'
 *   },
 * });
 */
export function useConfirmClientFieldMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmClientFieldMutation, ConfirmClientFieldMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmClientFieldMutation, ConfirmClientFieldMutationVariables>(ConfirmClientFieldDocument, options);
      }
export type ConfirmClientFieldMutationHookResult = ReturnType<typeof useConfirmClientFieldMutation>;
export type ConfirmClientFieldMutationResult = Apollo.MutationResult<ConfirmClientFieldMutation>;
export type ConfirmClientFieldMutationOptions = Apollo.BaseMutationOptions<ConfirmClientFieldMutation, ConfirmClientFieldMutationVariables>;
export const SuggestedAmsAccountsDocument = gql`
    query SuggestedAmsAccounts($clientId: ID!, $limit: Int) {
  client(id: $clientId) {
    id
    suggestedAmsAccounts(limit: $limit) {
      integrationId
      externalId
      displayName
      email
      phone
      accountCode
      reason
      accountId
    }
  }
}
    `;

/**
 * __useSuggestedAmsAccountsQuery__
 *
 * To run a query within a React component, call `useSuggestedAmsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedAmsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedAmsAccountsQuery({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSuggestedAmsAccountsQuery(baseOptions: Apollo.QueryHookOptions<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables> & ({ variables: SuggestedAmsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>(SuggestedAmsAccountsDocument, options);
      }
export function useSuggestedAmsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>(SuggestedAmsAccountsDocument, options);
        }
// @ts-ignore
export function useSuggestedAmsAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>;
export function useSuggestedAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedAmsAccountsQuery | undefined, SuggestedAmsAccountsQueryVariables>;
export function useSuggestedAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>(SuggestedAmsAccountsDocument, options);
        }
export type SuggestedAmsAccountsQueryHookResult = ReturnType<typeof useSuggestedAmsAccountsQuery>;
export type SuggestedAmsAccountsLazyQueryHookResult = ReturnType<typeof useSuggestedAmsAccountsLazyQuery>;
export type SuggestedAmsAccountsSuspenseQueryHookResult = ReturnType<typeof useSuggestedAmsAccountsSuspenseQuery>;
export type SuggestedAmsAccountsQueryResult = Apollo.QueryResult<SuggestedAmsAccountsQuery, SuggestedAmsAccountsQueryVariables>;
export const LinkClientAmsAccountDocument = gql`
    mutation LinkClientAmsAccount($clientId: ID!, $input: ClientAmsAccountInput!, $isPrimary: Boolean! = false) {
  linkClientAmsAccount(clientId: $clientId, input: $input, isPrimary: $isPrimary) {
    ...ClientAmsAccountFields
  }
}
    ${ClientAmsAccountFieldsFragmentDoc}`;
export type LinkClientAmsAccountMutationFn = Apollo.MutationFunction<LinkClientAmsAccountMutation, LinkClientAmsAccountMutationVariables>;

/**
 * __useLinkClientAmsAccountMutation__
 *
 * To run a mutation, you first call `useLinkClientAmsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkClientAmsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkClientAmsAccountMutation, { data, loading, error }] = useLinkClientAmsAccountMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      input: // value for 'input'
 *      isPrimary: // value for 'isPrimary'
 *   },
 * });
 */
export function useLinkClientAmsAccountMutation(baseOptions?: Apollo.MutationHookOptions<LinkClientAmsAccountMutation, LinkClientAmsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkClientAmsAccountMutation, LinkClientAmsAccountMutationVariables>(LinkClientAmsAccountDocument, options);
      }
export type LinkClientAmsAccountMutationHookResult = ReturnType<typeof useLinkClientAmsAccountMutation>;
export type LinkClientAmsAccountMutationResult = Apollo.MutationResult<LinkClientAmsAccountMutation>;
export type LinkClientAmsAccountMutationOptions = Apollo.BaseMutationOptions<LinkClientAmsAccountMutation, LinkClientAmsAccountMutationVariables>;
export const UnlinkClientAmsAccountDocument = gql`
    mutation UnlinkClientAmsAccount($clientId: ID!, $integrationId: ID!, $amsExternalId: String!) {
  unlinkClientAmsAccount(
    clientId: $clientId
    integrationId: $integrationId
    amsExternalId: $amsExternalId
  )
}
    `;
export type UnlinkClientAmsAccountMutationFn = Apollo.MutationFunction<UnlinkClientAmsAccountMutation, UnlinkClientAmsAccountMutationVariables>;

/**
 * __useUnlinkClientAmsAccountMutation__
 *
 * To run a mutation, you first call `useUnlinkClientAmsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkClientAmsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkClientAmsAccountMutation, { data, loading, error }] = useUnlinkClientAmsAccountMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      integrationId: // value for 'integrationId'
 *      amsExternalId: // value for 'amsExternalId'
 *   },
 * });
 */
export function useUnlinkClientAmsAccountMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkClientAmsAccountMutation, UnlinkClientAmsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkClientAmsAccountMutation, UnlinkClientAmsAccountMutationVariables>(UnlinkClientAmsAccountDocument, options);
      }
export type UnlinkClientAmsAccountMutationHookResult = ReturnType<typeof useUnlinkClientAmsAccountMutation>;
export type UnlinkClientAmsAccountMutationResult = Apollo.MutationResult<UnlinkClientAmsAccountMutation>;
export type UnlinkClientAmsAccountMutationOptions = Apollo.BaseMutationOptions<UnlinkClientAmsAccountMutation, UnlinkClientAmsAccountMutationVariables>;
export const LinkClientWorkspaceDocument = gql`
    mutation LinkClientWorkspace($clientId: ID!, $workspaceId: ID!, $replaceExisting: Boolean!) {
  linkClientWorkspace(
    clientId: $clientId
    workspaceId: $workspaceId
    replaceExisting: $replaceExisting
  ) {
    id
  }
}
    `;
export type LinkClientWorkspaceMutationFn = Apollo.MutationFunction<LinkClientWorkspaceMutation, LinkClientWorkspaceMutationVariables>;

/**
 * __useLinkClientWorkspaceMutation__
 *
 * To run a mutation, you first call `useLinkClientWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLinkClientWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [linkClientWorkspaceMutation, { data, loading, error }] = useLinkClientWorkspaceMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      workspaceId: // value for 'workspaceId'
 *      replaceExisting: // value for 'replaceExisting'
 *   },
 * });
 */
export function useLinkClientWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<LinkClientWorkspaceMutation, LinkClientWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LinkClientWorkspaceMutation, LinkClientWorkspaceMutationVariables>(LinkClientWorkspaceDocument, options);
      }
export type LinkClientWorkspaceMutationHookResult = ReturnType<typeof useLinkClientWorkspaceMutation>;
export type LinkClientWorkspaceMutationResult = Apollo.MutationResult<LinkClientWorkspaceMutation>;
export type LinkClientWorkspaceMutationOptions = Apollo.BaseMutationOptions<LinkClientWorkspaceMutation, LinkClientWorkspaceMutationVariables>;
export const UnlinkClientWorkspaceDocument = gql`
    mutation UnlinkClientWorkspace($clientId: ID!, $workspaceId: ID!) {
  unlinkClientWorkspace(clientId: $clientId, workspaceId: $workspaceId) {
    id
  }
}
    `;
export type UnlinkClientWorkspaceMutationFn = Apollo.MutationFunction<UnlinkClientWorkspaceMutation, UnlinkClientWorkspaceMutationVariables>;

/**
 * __useUnlinkClientWorkspaceMutation__
 *
 * To run a mutation, you first call `useUnlinkClientWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnlinkClientWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unlinkClientWorkspaceMutation, { data, loading, error }] = useUnlinkClientWorkspaceMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useUnlinkClientWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UnlinkClientWorkspaceMutation, UnlinkClientWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnlinkClientWorkspaceMutation, UnlinkClientWorkspaceMutationVariables>(UnlinkClientWorkspaceDocument, options);
      }
export type UnlinkClientWorkspaceMutationHookResult = ReturnType<typeof useUnlinkClientWorkspaceMutation>;
export type UnlinkClientWorkspaceMutationResult = Apollo.MutationResult<UnlinkClientWorkspaceMutation>;
export type UnlinkClientWorkspaceMutationOptions = Apollo.BaseMutationOptions<UnlinkClientWorkspaceMutation, UnlinkClientWorkspaceMutationVariables>;
export const GetWorkspaceClientsDocument = gql`
    query GetWorkspaceClients($workspaceId: ID!) {
  caraWorkspace(id: $workspaceId) {
    id
    clients {
      id
      name
      isCommercial
      isPersonal
    }
  }
}
    `;

/**
 * __useGetWorkspaceClientsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceClientsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceClientsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables> & ({ variables: GetWorkspaceClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>(GetWorkspaceClientsDocument, options);
      }
export function useGetWorkspaceClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>(GetWorkspaceClientsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>;
export function useGetWorkspaceClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceClientsQuery | undefined, GetWorkspaceClientsQueryVariables>;
export function useGetWorkspaceClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>(GetWorkspaceClientsDocument, options);
        }
export type GetWorkspaceClientsQueryHookResult = ReturnType<typeof useGetWorkspaceClientsQuery>;
export type GetWorkspaceClientsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceClientsLazyQuery>;
export type GetWorkspaceClientsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceClientsSuspenseQuery>;
export type GetWorkspaceClientsQueryResult = Apollo.QueryResult<GetWorkspaceClientsQuery, GetWorkspaceClientsQueryVariables>;
export const GetWorkspaceDocumentClientsDocument = gql`
    query GetWorkspaceDocumentClients($workspaceId: ID!) {
  caraWorkspace(id: $workspaceId) {
    id
    clients {
      id
      name
    }
    documentClients {
      documentId
      clients {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useGetWorkspaceDocumentClientsQuery__
 *
 * To run a query within a React component, call `useGetWorkspaceDocumentClientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkspaceDocumentClientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkspaceDocumentClientsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *   },
 * });
 */
export function useGetWorkspaceDocumentClientsQuery(baseOptions: Apollo.QueryHookOptions<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables> & ({ variables: GetWorkspaceDocumentClientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>(GetWorkspaceDocumentClientsDocument, options);
      }
export function useGetWorkspaceDocumentClientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>(GetWorkspaceDocumentClientsDocument, options);
        }
// @ts-ignore
export function useGetWorkspaceDocumentClientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>;
export function useGetWorkspaceDocumentClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkspaceDocumentClientsQuery | undefined, GetWorkspaceDocumentClientsQueryVariables>;
export function useGetWorkspaceDocumentClientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>(GetWorkspaceDocumentClientsDocument, options);
        }
export type GetWorkspaceDocumentClientsQueryHookResult = ReturnType<typeof useGetWorkspaceDocumentClientsQuery>;
export type GetWorkspaceDocumentClientsLazyQueryHookResult = ReturnType<typeof useGetWorkspaceDocumentClientsLazyQuery>;
export type GetWorkspaceDocumentClientsSuspenseQueryHookResult = ReturnType<typeof useGetWorkspaceDocumentClientsSuspenseQuery>;
export type GetWorkspaceDocumentClientsQueryResult = Apollo.QueryResult<GetWorkspaceDocumentClientsQuery, GetWorkspaceDocumentClientsQueryVariables>;
export const SuggestedClientsForWorkspaceDocument = gql`
    query SuggestedClientsForWorkspace($workspaceId: ID!, $limit: Int) {
  suggestedClientsForWorkspace(workspaceId: $workspaceId, limit: $limit) {
    score
    verdict
    client {
      id
      name
      email
      phone
      isCommercial
      isPersonal
    }
  }
}
    `;

/**
 * __useSuggestedClientsForWorkspaceQuery__
 *
 * To run a query within a React component, call `useSuggestedClientsForWorkspaceQuery` and pass it any options that fit your needs.
 * When your component renders, `useSuggestedClientsForWorkspaceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSuggestedClientsForWorkspaceQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSuggestedClientsForWorkspaceQuery(baseOptions: Apollo.QueryHookOptions<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables> & ({ variables: SuggestedClientsForWorkspaceQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>(SuggestedClientsForWorkspaceDocument, options);
      }
export function useSuggestedClientsForWorkspaceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>(SuggestedClientsForWorkspaceDocument, options);
        }
// @ts-ignore
export function useSuggestedClientsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>;
export function useSuggestedClientsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>): Apollo.UseSuspenseQueryResult<SuggestedClientsForWorkspaceQuery | undefined, SuggestedClientsForWorkspaceQueryVariables>;
export function useSuggestedClientsForWorkspaceSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>(SuggestedClientsForWorkspaceDocument, options);
        }
export type SuggestedClientsForWorkspaceQueryHookResult = ReturnType<typeof useSuggestedClientsForWorkspaceQuery>;
export type SuggestedClientsForWorkspaceLazyQueryHookResult = ReturnType<typeof useSuggestedClientsForWorkspaceLazyQuery>;
export type SuggestedClientsForWorkspaceSuspenseQueryHookResult = ReturnType<typeof useSuggestedClientsForWorkspaceSuspenseQuery>;
export type SuggestedClientsForWorkspaceQueryResult = Apollo.QueryResult<SuggestedClientsForWorkspaceQuery, SuggestedClientsForWorkspaceQueryVariables>;
export const SearchWorkspacesForClientDocument = gql`
    query SearchWorkspacesForClient($first: Int, $after: String, $filter: SearchCaraWorkspacesFilterInput) {
  searchCaraWorkspaces(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        id
        title
        updatedAt
        agencyUser {
          id
          name
        }
        clients {
          id
          name
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    `;

/**
 * __useSearchWorkspacesForClientQuery__
 *
 * To run a query within a React component, call `useSearchWorkspacesForClientQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchWorkspacesForClientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchWorkspacesForClientQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchWorkspacesForClientQuery(baseOptions?: Apollo.QueryHookOptions<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>(SearchWorkspacesForClientDocument, options);
      }
export function useSearchWorkspacesForClientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>(SearchWorkspacesForClientDocument, options);
        }
// @ts-ignore
export function useSearchWorkspacesForClientSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>): Apollo.UseSuspenseQueryResult<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>;
export function useSearchWorkspacesForClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>): Apollo.UseSuspenseQueryResult<SearchWorkspacesForClientQuery | undefined, SearchWorkspacesForClientQueryVariables>;
export function useSearchWorkspacesForClientSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>(SearchWorkspacesForClientDocument, options);
        }
export type SearchWorkspacesForClientQueryHookResult = ReturnType<typeof useSearchWorkspacesForClientQuery>;
export type SearchWorkspacesForClientLazyQueryHookResult = ReturnType<typeof useSearchWorkspacesForClientLazyQuery>;
export type SearchWorkspacesForClientSuspenseQueryHookResult = ReturnType<typeof useSearchWorkspacesForClientSuspenseQuery>;
export type SearchWorkspacesForClientQueryResult = Apollo.QueryResult<SearchWorkspacesForClientQuery, SearchWorkspacesForClientQueryVariables>;
export const AddClientArtifactDocument = gql`
    mutation AddClientArtifact($clientId: ID!, $artifactId: ID!) {
  addClientArtifact(clientId: $clientId, artifactId: $artifactId) {
    id
  }
}
    `;
export type AddClientArtifactMutationFn = Apollo.MutationFunction<AddClientArtifactMutation, AddClientArtifactMutationVariables>;

/**
 * __useAddClientArtifactMutation__
 *
 * To run a mutation, you first call `useAddClientArtifactMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientArtifactMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientArtifactMutation, { data, loading, error }] = useAddClientArtifactMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      artifactId: // value for 'artifactId'
 *   },
 * });
 */
export function useAddClientArtifactMutation(baseOptions?: Apollo.MutationHookOptions<AddClientArtifactMutation, AddClientArtifactMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientArtifactMutation, AddClientArtifactMutationVariables>(AddClientArtifactDocument, options);
      }
export type AddClientArtifactMutationHookResult = ReturnType<typeof useAddClientArtifactMutation>;
export type AddClientArtifactMutationResult = Apollo.MutationResult<AddClientArtifactMutation>;
export type AddClientArtifactMutationOptions = Apollo.BaseMutationOptions<AddClientArtifactMutation, AddClientArtifactMutationVariables>;
export const AddClientFileDocument = gql`
    mutation AddClientFile($clientId: ID!, $fileId: ID!) {
  addClientFile(clientId: $clientId, fileId: $fileId) {
    id
  }
}
    `;
export type AddClientFileMutationFn = Apollo.MutationFunction<AddClientFileMutation, AddClientFileMutationVariables>;

/**
 * __useAddClientFileMutation__
 *
 * To run a mutation, you first call `useAddClientFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddClientFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addClientFileMutation, { data, loading, error }] = useAddClientFileMutation({
 *   variables: {
 *      clientId: // value for 'clientId'
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useAddClientFileMutation(baseOptions?: Apollo.MutationHookOptions<AddClientFileMutation, AddClientFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddClientFileMutation, AddClientFileMutationVariables>(AddClientFileDocument, options);
      }
export type AddClientFileMutationHookResult = ReturnType<typeof useAddClientFileMutation>;
export type AddClientFileMutationResult = Apollo.MutationResult<AddClientFileMutation>;
export type AddClientFileMutationOptions = Apollo.BaseMutationOptions<AddClientFileMutation, AddClientFileMutationVariables>;
export const PickableArtifactsDocument = gql`
    query PickableArtifacts($filter: CaraWorkspaceArtifactFilter) {
  caraWorkspaceArtifacts(filter: $filter) {
    id
    title
    type
    createdAt
    metadata {
      workspaceId
      workspaceTitle
    }
  }
}
    `;

/**
 * __usePickableArtifactsQuery__
 *
 * To run a query within a React component, call `usePickableArtifactsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePickableArtifactsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePickableArtifactsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function usePickableArtifactsQuery(baseOptions?: Apollo.QueryHookOptions<PickableArtifactsQuery, PickableArtifactsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PickableArtifactsQuery, PickableArtifactsQueryVariables>(PickableArtifactsDocument, options);
      }
export function usePickableArtifactsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PickableArtifactsQuery, PickableArtifactsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PickableArtifactsQuery, PickableArtifactsQueryVariables>(PickableArtifactsDocument, options);
        }
// @ts-ignore
export function usePickableArtifactsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<PickableArtifactsQuery, PickableArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<PickableArtifactsQuery, PickableArtifactsQueryVariables>;
export function usePickableArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickableArtifactsQuery, PickableArtifactsQueryVariables>): Apollo.UseSuspenseQueryResult<PickableArtifactsQuery | undefined, PickableArtifactsQueryVariables>;
export function usePickableArtifactsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PickableArtifactsQuery, PickableArtifactsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PickableArtifactsQuery, PickableArtifactsQueryVariables>(PickableArtifactsDocument, options);
        }
export type PickableArtifactsQueryHookResult = ReturnType<typeof usePickableArtifactsQuery>;
export type PickableArtifactsLazyQueryHookResult = ReturnType<typeof usePickableArtifactsLazyQuery>;
export type PickableArtifactsSuspenseQueryHookResult = ReturnType<typeof usePickableArtifactsSuspenseQuery>;
export type PickableArtifactsQueryResult = Apollo.QueryResult<PickableArtifactsQuery, PickableArtifactsQueryVariables>;
export const GetCustomFormsDocument = gql`
    query GetCustomForms {
  customForms {
    ...CustomFormListFields
  }
}
    ${CustomFormListFieldsFragmentDoc}`;

/**
 * __useGetCustomFormsQuery__
 *
 * To run a query within a React component, call `useGetCustomFormsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFormsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFormsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCustomFormsQuery(baseOptions?: Apollo.QueryHookOptions<GetCustomFormsQuery, GetCustomFormsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFormsQuery, GetCustomFormsQueryVariables>(GetCustomFormsDocument, options);
      }
export function useGetCustomFormsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFormsQuery, GetCustomFormsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFormsQuery, GetCustomFormsQueryVariables>(GetCustomFormsDocument, options);
        }
// @ts-ignore
export function useGetCustomFormsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomFormsQuery, GetCustomFormsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomFormsQuery, GetCustomFormsQueryVariables>;
export function useGetCustomFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomFormsQuery, GetCustomFormsQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomFormsQuery | undefined, GetCustomFormsQueryVariables>;
export function useGetCustomFormsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomFormsQuery, GetCustomFormsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomFormsQuery, GetCustomFormsQueryVariables>(GetCustomFormsDocument, options);
        }
export type GetCustomFormsQueryHookResult = ReturnType<typeof useGetCustomFormsQuery>;
export type GetCustomFormsLazyQueryHookResult = ReturnType<typeof useGetCustomFormsLazyQuery>;
export type GetCustomFormsSuspenseQueryHookResult = ReturnType<typeof useGetCustomFormsSuspenseQuery>;
export type GetCustomFormsQueryResult = Apollo.QueryResult<GetCustomFormsQuery, GetCustomFormsQueryVariables>;
export const GetCustomFormDocument = gql`
    query GetCustomForm($id: ID!) {
  customForm(id: $id) {
    ...CustomFormFields
  }
}
    ${CustomFormFieldsFragmentDoc}`;

/**
 * __useGetCustomFormQuery__
 *
 * To run a query within a React component, call `useGetCustomFormQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCustomFormQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCustomFormQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetCustomFormQuery(baseOptions: Apollo.QueryHookOptions<GetCustomFormQuery, GetCustomFormQueryVariables> & ({ variables: GetCustomFormQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetCustomFormQuery, GetCustomFormQueryVariables>(GetCustomFormDocument, options);
      }
export function useGetCustomFormLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetCustomFormQuery, GetCustomFormQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetCustomFormQuery, GetCustomFormQueryVariables>(GetCustomFormDocument, options);
        }
// @ts-ignore
export function useGetCustomFormSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetCustomFormQuery, GetCustomFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomFormQuery, GetCustomFormQueryVariables>;
export function useGetCustomFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomFormQuery, GetCustomFormQueryVariables>): Apollo.UseSuspenseQueryResult<GetCustomFormQuery | undefined, GetCustomFormQueryVariables>;
export function useGetCustomFormSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetCustomFormQuery, GetCustomFormQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetCustomFormQuery, GetCustomFormQueryVariables>(GetCustomFormDocument, options);
        }
export type GetCustomFormQueryHookResult = ReturnType<typeof useGetCustomFormQuery>;
export type GetCustomFormLazyQueryHookResult = ReturnType<typeof useGetCustomFormLazyQuery>;
export type GetCustomFormSuspenseQueryHookResult = ReturnType<typeof useGetCustomFormSuspenseQuery>;
export type GetCustomFormQueryResult = Apollo.QueryResult<GetCustomFormQuery, GetCustomFormQueryVariables>;
export const UploadCustomFormDocument = gql`
    mutation UploadCustomForm($input: UploadCustomFormInput!) {
  uploadCustomForm(input: $input) {
    ...CustomFormFields
  }
}
    ${CustomFormFieldsFragmentDoc}`;
export type UploadCustomFormMutationFn = Apollo.MutationFunction<UploadCustomFormMutation, UploadCustomFormMutationVariables>;

/**
 * __useUploadCustomFormMutation__
 *
 * To run a mutation, you first call `useUploadCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadCustomFormMutation, { data, loading, error }] = useUploadCustomFormMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadCustomFormMutation(baseOptions?: Apollo.MutationHookOptions<UploadCustomFormMutation, UploadCustomFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadCustomFormMutation, UploadCustomFormMutationVariables>(UploadCustomFormDocument, options);
      }
export type UploadCustomFormMutationHookResult = ReturnType<typeof useUploadCustomFormMutation>;
export type UploadCustomFormMutationResult = Apollo.MutationResult<UploadCustomFormMutation>;
export type UploadCustomFormMutationOptions = Apollo.BaseMutationOptions<UploadCustomFormMutation, UploadCustomFormMutationVariables>;
export const UpdateCustomFormDocument = gql`
    mutation UpdateCustomForm($id: ID!, $input: UpdateCustomFormInput!) {
  updateCustomForm(id: $id, input: $input) {
    ...CustomFormFields
  }
}
    ${CustomFormFieldsFragmentDoc}`;
export type UpdateCustomFormMutationFn = Apollo.MutationFunction<UpdateCustomFormMutation, UpdateCustomFormMutationVariables>;

/**
 * __useUpdateCustomFormMutation__
 *
 * To run a mutation, you first call `useUpdateCustomFormMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCustomFormMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCustomFormMutation, { data, loading, error }] = useUpdateCustomFormMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateCustomFormMutation(baseOptions?: Apollo.MutationHookOptions<UpdateCustomFormMutation, UpdateCustomFormMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateCustomFormMutation, UpdateCustomFormMutationVariables>(UpdateCustomFormDocument, options);
      }
export type UpdateCustomFormMutationHookResult = ReturnType<typeof useUpdateCustomFormMutation>;
export type UpdateCustomFormMutationResult = Apollo.MutationResult<UpdateCustomFormMutation>;
export type UpdateCustomFormMutationOptions = Apollo.BaseMutationOptions<UpdateCustomFormMutation, UpdateCustomFormMutationVariables>;
export const EmailAmsLogOptionsDocument = gql`
    query EmailAmsLogOptions($id: ID!) {
  emailAmsLogOptions(id: $id) {
    preference {
      ...EmailAmsLogPreferenceFields
    }
    destinations
    activityCodes {
      code
      label
    }
    companies {
      code
      label
    }
    employees {
      code
      label
    }
  }
}
    ${EmailAmsLogPreferenceFieldsFragmentDoc}`;

/**
 * __useEmailAmsLogOptionsQuery__
 *
 * To run a query within a React component, call `useEmailAmsLogOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailAmsLogOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailAmsLogOptionsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailAmsLogOptionsQuery(baseOptions: Apollo.QueryHookOptions<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables> & ({ variables: EmailAmsLogOptionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>(EmailAmsLogOptionsDocument, options);
      }
export function useEmailAmsLogOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>(EmailAmsLogOptionsDocument, options);
        }
// @ts-ignore
export function useEmailAmsLogOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>;
export function useEmailAmsLogOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailAmsLogOptionsQuery | undefined, EmailAmsLogOptionsQueryVariables>;
export function useEmailAmsLogOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>(EmailAmsLogOptionsDocument, options);
        }
export type EmailAmsLogOptionsQueryHookResult = ReturnType<typeof useEmailAmsLogOptionsQuery>;
export type EmailAmsLogOptionsLazyQueryHookResult = ReturnType<typeof useEmailAmsLogOptionsLazyQuery>;
export type EmailAmsLogOptionsSuspenseQueryHookResult = ReturnType<typeof useEmailAmsLogOptionsSuspenseQuery>;
export type EmailAmsLogOptionsQueryResult = Apollo.QueryResult<EmailAmsLogOptionsQuery, EmailAmsLogOptionsQueryVariables>;
export const SetIntegrationEmailLogPreferenceDocument = gql`
    mutation SetIntegrationEmailLogPreference($id: ID!, $input: EmailAmsLogPreferenceInput!) {
  setIntegrationEmailLogPreference(id: $id, input: $input) {
    id
    emailLogPreference {
      ...EmailAmsLogPreferenceFields
    }
  }
}
    ${EmailAmsLogPreferenceFieldsFragmentDoc}`;
export type SetIntegrationEmailLogPreferenceMutationFn = Apollo.MutationFunction<SetIntegrationEmailLogPreferenceMutation, SetIntegrationEmailLogPreferenceMutationVariables>;

/**
 * __useSetIntegrationEmailLogPreferenceMutation__
 *
 * To run a mutation, you first call `useSetIntegrationEmailLogPreferenceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationEmailLogPreferenceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationEmailLogPreferenceMutation, { data, loading, error }] = useSetIntegrationEmailLogPreferenceMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSetIntegrationEmailLogPreferenceMutation(baseOptions?: Apollo.MutationHookOptions<SetIntegrationEmailLogPreferenceMutation, SetIntegrationEmailLogPreferenceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIntegrationEmailLogPreferenceMutation, SetIntegrationEmailLogPreferenceMutationVariables>(SetIntegrationEmailLogPreferenceDocument, options);
      }
export type SetIntegrationEmailLogPreferenceMutationHookResult = ReturnType<typeof useSetIntegrationEmailLogPreferenceMutation>;
export type SetIntegrationEmailLogPreferenceMutationResult = Apollo.MutationResult<SetIntegrationEmailLogPreferenceMutation>;
export type SetIntegrationEmailLogPreferenceMutationOptions = Apollo.BaseMutationOptions<SetIntegrationEmailLogPreferenceMutation, SetIntegrationEmailLogPreferenceMutationVariables>;
export const ResolveEmailAmsAccountsDocument = gql`
    query ResolveEmailAmsAccounts($workspaceId: ID!, $artifactId: String!, $toAddresses: [String!]!) {
  resolveEmailAmsAccounts(
    workspaceId: $workspaceId
    artifactId: $artifactId
    toAddresses: $toAddresses
  ) {
    ...EmailAmsMatchFields
  }
}
    ${EmailAmsMatchFieldsFragmentDoc}`;

/**
 * __useResolveEmailAmsAccountsQuery__
 *
 * To run a query within a React component, call `useResolveEmailAmsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useResolveEmailAmsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useResolveEmailAmsAccountsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      artifactId: // value for 'artifactId'
 *      toAddresses: // value for 'toAddresses'
 *   },
 * });
 */
export function useResolveEmailAmsAccountsQuery(baseOptions: Apollo.QueryHookOptions<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables> & ({ variables: ResolveEmailAmsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>(ResolveEmailAmsAccountsDocument, options);
      }
export function useResolveEmailAmsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>(ResolveEmailAmsAccountsDocument, options);
        }
// @ts-ignore
export function useResolveEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>;
export function useResolveEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<ResolveEmailAmsAccountsQuery | undefined, ResolveEmailAmsAccountsQueryVariables>;
export function useResolveEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>(ResolveEmailAmsAccountsDocument, options);
        }
export type ResolveEmailAmsAccountsQueryHookResult = ReturnType<typeof useResolveEmailAmsAccountsQuery>;
export type ResolveEmailAmsAccountsLazyQueryHookResult = ReturnType<typeof useResolveEmailAmsAccountsLazyQuery>;
export type ResolveEmailAmsAccountsSuspenseQueryHookResult = ReturnType<typeof useResolveEmailAmsAccountsSuspenseQuery>;
export type ResolveEmailAmsAccountsQueryResult = Apollo.QueryResult<ResolveEmailAmsAccountsQuery, ResolveEmailAmsAccountsQueryVariables>;
export const MatchAmsAccountsForOutboundEmailDocument = gql`
    query MatchAmsAccountsForOutboundEmail($outboundEmailId: ID!) {
  matchAmsAccountsForOutboundEmail(outboundEmailId: $outboundEmailId) {
    ...EmailAmsMatchFields
  }
}
    ${EmailAmsMatchFieldsFragmentDoc}`;

/**
 * __useMatchAmsAccountsForOutboundEmailQuery__
 *
 * To run a query within a React component, call `useMatchAmsAccountsForOutboundEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useMatchAmsAccountsForOutboundEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMatchAmsAccountsForOutboundEmailQuery({
 *   variables: {
 *      outboundEmailId: // value for 'outboundEmailId'
 *   },
 * });
 */
export function useMatchAmsAccountsForOutboundEmailQuery(baseOptions: Apollo.QueryHookOptions<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables> & ({ variables: MatchAmsAccountsForOutboundEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>(MatchAmsAccountsForOutboundEmailDocument, options);
      }
export function useMatchAmsAccountsForOutboundEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>(MatchAmsAccountsForOutboundEmailDocument, options);
        }
// @ts-ignore
export function useMatchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>): Apollo.UseSuspenseQueryResult<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>;
export function useMatchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>): Apollo.UseSuspenseQueryResult<MatchAmsAccountsForOutboundEmailQuery | undefined, MatchAmsAccountsForOutboundEmailQueryVariables>;
export function useMatchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>(MatchAmsAccountsForOutboundEmailDocument, options);
        }
export type MatchAmsAccountsForOutboundEmailQueryHookResult = ReturnType<typeof useMatchAmsAccountsForOutboundEmailQuery>;
export type MatchAmsAccountsForOutboundEmailLazyQueryHookResult = ReturnType<typeof useMatchAmsAccountsForOutboundEmailLazyQuery>;
export type MatchAmsAccountsForOutboundEmailSuspenseQueryHookResult = ReturnType<typeof useMatchAmsAccountsForOutboundEmailSuspenseQuery>;
export type MatchAmsAccountsForOutboundEmailQueryResult = Apollo.QueryResult<MatchAmsAccountsForOutboundEmailQuery, MatchAmsAccountsForOutboundEmailQueryVariables>;
export const SearchEmailAmsAccountsDocument = gql`
    query SearchEmailAmsAccounts($workspaceId: ID!, $query: String!) {
  searchEmailAmsAccounts(workspaceId: $workspaceId, query: $query) {
    ...AmsBrowseAccountFields
  }
}
    ${AmsBrowseAccountFieldsFragmentDoc}`;

/**
 * __useSearchEmailAmsAccountsQuery__
 *
 * To run a query within a React component, call `useSearchEmailAmsAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchEmailAmsAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchEmailAmsAccountsQuery({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchEmailAmsAccountsQuery(baseOptions: Apollo.QueryHookOptions<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables> & ({ variables: SearchEmailAmsAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>(SearchEmailAmsAccountsDocument, options);
      }
export function useSearchEmailAmsAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>(SearchEmailAmsAccountsDocument, options);
        }
// @ts-ignore
export function useSearchEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>;
export function useSearchEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchEmailAmsAccountsQuery | undefined, SearchEmailAmsAccountsQueryVariables>;
export function useSearchEmailAmsAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>(SearchEmailAmsAccountsDocument, options);
        }
export type SearchEmailAmsAccountsQueryHookResult = ReturnType<typeof useSearchEmailAmsAccountsQuery>;
export type SearchEmailAmsAccountsLazyQueryHookResult = ReturnType<typeof useSearchEmailAmsAccountsLazyQuery>;
export type SearchEmailAmsAccountsSuspenseQueryHookResult = ReturnType<typeof useSearchEmailAmsAccountsSuspenseQuery>;
export type SearchEmailAmsAccountsQueryResult = Apollo.QueryResult<SearchEmailAmsAccountsQuery, SearchEmailAmsAccountsQueryVariables>;
export const SearchAmsAccountsForOutboundEmailDocument = gql`
    query SearchAmsAccountsForOutboundEmail($outboundEmailId: ID!, $query: String!) {
  searchAmsAccountsForOutboundEmail(
    outboundEmailId: $outboundEmailId
    query: $query
  ) {
    ...AmsBrowseAccountFields
  }
}
    ${AmsBrowseAccountFieldsFragmentDoc}`;

/**
 * __useSearchAmsAccountsForOutboundEmailQuery__
 *
 * To run a query within a React component, call `useSearchAmsAccountsForOutboundEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchAmsAccountsForOutboundEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchAmsAccountsForOutboundEmailQuery({
 *   variables: {
 *      outboundEmailId: // value for 'outboundEmailId'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchAmsAccountsForOutboundEmailQuery(baseOptions: Apollo.QueryHookOptions<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables> & ({ variables: SearchAmsAccountsForOutboundEmailQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>(SearchAmsAccountsForOutboundEmailDocument, options);
      }
export function useSearchAmsAccountsForOutboundEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>(SearchAmsAccountsForOutboundEmailDocument, options);
        }
// @ts-ignore
export function useSearchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>;
export function useSearchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>): Apollo.UseSuspenseQueryResult<SearchAmsAccountsForOutboundEmailQuery | undefined, SearchAmsAccountsForOutboundEmailQueryVariables>;
export function useSearchAmsAccountsForOutboundEmailSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>(SearchAmsAccountsForOutboundEmailDocument, options);
        }
export type SearchAmsAccountsForOutboundEmailQueryHookResult = ReturnType<typeof useSearchAmsAccountsForOutboundEmailQuery>;
export type SearchAmsAccountsForOutboundEmailLazyQueryHookResult = ReturnType<typeof useSearchAmsAccountsForOutboundEmailLazyQuery>;
export type SearchAmsAccountsForOutboundEmailSuspenseQueryHookResult = ReturnType<typeof useSearchAmsAccountsForOutboundEmailSuspenseQuery>;
export type SearchAmsAccountsForOutboundEmailQueryResult = Apollo.QueryResult<SearchAmsAccountsForOutboundEmailQuery, SearchAmsAccountsForOutboundEmailQueryVariables>;
export const ImportEmailAmsAccountDocument = gql`
    mutation ImportEmailAmsAccount($workspaceId: ID!, $account: AmsRefInput!) {
  importEmailAmsAccount(workspaceId: $workspaceId, account: $account) {
    ...EmailAmsChoiceFields
  }
}
    ${EmailAmsChoiceFieldsFragmentDoc}`;
export type ImportEmailAmsAccountMutationFn = Apollo.MutationFunction<ImportEmailAmsAccountMutation, ImportEmailAmsAccountMutationVariables>;

/**
 * __useImportEmailAmsAccountMutation__
 *
 * To run a mutation, you first call `useImportEmailAmsAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportEmailAmsAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importEmailAmsAccountMutation, { data, loading, error }] = useImportEmailAmsAccountMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useImportEmailAmsAccountMutation(baseOptions?: Apollo.MutationHookOptions<ImportEmailAmsAccountMutation, ImportEmailAmsAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportEmailAmsAccountMutation, ImportEmailAmsAccountMutationVariables>(ImportEmailAmsAccountDocument, options);
      }
export type ImportEmailAmsAccountMutationHookResult = ReturnType<typeof useImportEmailAmsAccountMutation>;
export type ImportEmailAmsAccountMutationResult = Apollo.MutationResult<ImportEmailAmsAccountMutation>;
export type ImportEmailAmsAccountMutationOptions = Apollo.BaseMutationOptions<ImportEmailAmsAccountMutation, ImportEmailAmsAccountMutationVariables>;
export const ImportAmsAccountForOutboundEmailDocument = gql`
    mutation ImportAmsAccountForOutboundEmail($outboundEmailId: ID!, $account: AmsRefInput!) {
  importAmsAccountForOutboundEmail(
    outboundEmailId: $outboundEmailId
    account: $account
  ) {
    ...EmailAmsChoiceFields
  }
}
    ${EmailAmsChoiceFieldsFragmentDoc}`;
export type ImportAmsAccountForOutboundEmailMutationFn = Apollo.MutationFunction<ImportAmsAccountForOutboundEmailMutation, ImportAmsAccountForOutboundEmailMutationVariables>;

/**
 * __useImportAmsAccountForOutboundEmailMutation__
 *
 * To run a mutation, you first call `useImportAmsAccountForOutboundEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useImportAmsAccountForOutboundEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [importAmsAccountForOutboundEmailMutation, { data, loading, error }] = useImportAmsAccountForOutboundEmailMutation({
 *   variables: {
 *      outboundEmailId: // value for 'outboundEmailId'
 *      account: // value for 'account'
 *   },
 * });
 */
export function useImportAmsAccountForOutboundEmailMutation(baseOptions?: Apollo.MutationHookOptions<ImportAmsAccountForOutboundEmailMutation, ImportAmsAccountForOutboundEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ImportAmsAccountForOutboundEmailMutation, ImportAmsAccountForOutboundEmailMutationVariables>(ImportAmsAccountForOutboundEmailDocument, options);
      }
export type ImportAmsAccountForOutboundEmailMutationHookResult = ReturnType<typeof useImportAmsAccountForOutboundEmailMutation>;
export type ImportAmsAccountForOutboundEmailMutationResult = Apollo.MutationResult<ImportAmsAccountForOutboundEmailMutation>;
export type ImportAmsAccountForOutboundEmailMutationOptions = Apollo.BaseMutationOptions<ImportAmsAccountForOutboundEmailMutation, ImportAmsAccountForOutboundEmailMutationVariables>;
export const SentEmailAmsLogDocument = gql`
    query SentEmailAmsLog($workspaceArtifactId: ID!) {
  searchOutboundEmails(filter: {workspaceArtifactId: $workspaceArtifactId}) {
    edges {
      node {
        id
        amsLog {
          ...OutboundEmailAmsLogFields
        }
      }
    }
  }
}
    ${OutboundEmailAmsLogFieldsFragmentDoc}`;

/**
 * __useSentEmailAmsLogQuery__
 *
 * To run a query within a React component, call `useSentEmailAmsLogQuery` and pass it any options that fit your needs.
 * When your component renders, `useSentEmailAmsLogQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSentEmailAmsLogQuery({
 *   variables: {
 *      workspaceArtifactId: // value for 'workspaceArtifactId'
 *   },
 * });
 */
export function useSentEmailAmsLogQuery(baseOptions: Apollo.QueryHookOptions<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables> & ({ variables: SentEmailAmsLogQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>(SentEmailAmsLogDocument, options);
      }
export function useSentEmailAmsLogLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>(SentEmailAmsLogDocument, options);
        }
// @ts-ignore
export function useSentEmailAmsLogSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>): Apollo.UseSuspenseQueryResult<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>;
export function useSentEmailAmsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>): Apollo.UseSuspenseQueryResult<SentEmailAmsLogQuery | undefined, SentEmailAmsLogQueryVariables>;
export function useSentEmailAmsLogSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>(SentEmailAmsLogDocument, options);
        }
export type SentEmailAmsLogQueryHookResult = ReturnType<typeof useSentEmailAmsLogQuery>;
export type SentEmailAmsLogLazyQueryHookResult = ReturnType<typeof useSentEmailAmsLogLazyQuery>;
export type SentEmailAmsLogSuspenseQueryHookResult = ReturnType<typeof useSentEmailAmsLogSuspenseQuery>;
export type SentEmailAmsLogQueryResult = Apollo.QueryResult<SentEmailAmsLogQuery, SentEmailAmsLogQueryVariables>;
export const PushOutboundEmailToAmsDocument = gql`
    mutation PushOutboundEmailToAms($id: ID!, $input: PushOutboundEmailToAmsInput!) {
  pushOutboundEmailToAms(id: $id, input: $input) {
    email {
      id
      amsLog {
        ...OutboundEmailAmsLogFields
      }
    }
    outcome
  }
}
    ${OutboundEmailAmsLogFieldsFragmentDoc}`;
export type PushOutboundEmailToAmsMutationFn = Apollo.MutationFunction<PushOutboundEmailToAmsMutation, PushOutboundEmailToAmsMutationVariables>;

/**
 * __usePushOutboundEmailToAmsMutation__
 *
 * To run a mutation, you first call `usePushOutboundEmailToAmsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePushOutboundEmailToAmsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pushOutboundEmailToAmsMutation, { data, loading, error }] = usePushOutboundEmailToAmsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function usePushOutboundEmailToAmsMutation(baseOptions?: Apollo.MutationHookOptions<PushOutboundEmailToAmsMutation, PushOutboundEmailToAmsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PushOutboundEmailToAmsMutation, PushOutboundEmailToAmsMutationVariables>(PushOutboundEmailToAmsDocument, options);
      }
export type PushOutboundEmailToAmsMutationHookResult = ReturnType<typeof usePushOutboundEmailToAmsMutation>;
export type PushOutboundEmailToAmsMutationResult = Apollo.MutationResult<PushOutboundEmailToAmsMutation>;
export type PushOutboundEmailToAmsMutationOptions = Apollo.BaseMutationOptions<PushOutboundEmailToAmsMutation, PushOutboundEmailToAmsMutationVariables>;
export const ClientArtifactsSentEmailsDocument = gql`
    query ClientArtifactsSentEmails($workspaceArtifactIds: [ID!]!) {
  latestSentOutboundEmails(workspaceArtifactIds: $workspaceArtifactIds) {
    id
    workspaceArtifactId
    subject
    to {
      name
      email
    }
    sentAt
    amsLog {
      ...OutboundEmailAmsLogFields
    }
  }
}
    ${OutboundEmailAmsLogFieldsFragmentDoc}`;

/**
 * __useClientArtifactsSentEmailsQuery__
 *
 * To run a query within a React component, call `useClientArtifactsSentEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useClientArtifactsSentEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useClientArtifactsSentEmailsQuery({
 *   variables: {
 *      workspaceArtifactIds: // value for 'workspaceArtifactIds'
 *   },
 * });
 */
export function useClientArtifactsSentEmailsQuery(baseOptions: Apollo.QueryHookOptions<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables> & ({ variables: ClientArtifactsSentEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>(ClientArtifactsSentEmailsDocument, options);
      }
export function useClientArtifactsSentEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>(ClientArtifactsSentEmailsDocument, options);
        }
// @ts-ignore
export function useClientArtifactsSentEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>;
export function useClientArtifactsSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<ClientArtifactsSentEmailsQuery | undefined, ClientArtifactsSentEmailsQueryVariables>;
export function useClientArtifactsSentEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>(ClientArtifactsSentEmailsDocument, options);
        }
export type ClientArtifactsSentEmailsQueryHookResult = ReturnType<typeof useClientArtifactsSentEmailsQuery>;
export type ClientArtifactsSentEmailsLazyQueryHookResult = ReturnType<typeof useClientArtifactsSentEmailsLazyQuery>;
export type ClientArtifactsSentEmailsSuspenseQueryHookResult = ReturnType<typeof useClientArtifactsSentEmailsSuspenseQuery>;
export type ClientArtifactsSentEmailsQueryResult = Apollo.QueryResult<ClientArtifactsSentEmailsQuery, ClientArtifactsSentEmailsQueryVariables>;
export const EmailBulkDraftCardDocument = gql`
    query EmailBulkDraftCard($id: ID!) {
  emailBulkSend(id: $id) {
    id
    name
    recipients {
      id
      artifactId
      draftState
    }
    draftProgress {
      total
      finished
      failed
    }
  }
}
    `;

/**
 * __useEmailBulkDraftCardQuery__
 *
 * To run a query within a React component, call `useEmailBulkDraftCardQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBulkDraftCardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBulkDraftCardQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailBulkDraftCardQuery(baseOptions: Apollo.QueryHookOptions<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables> & ({ variables: EmailBulkDraftCardQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>(EmailBulkDraftCardDocument, options);
      }
export function useEmailBulkDraftCardLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>(EmailBulkDraftCardDocument, options);
        }
// @ts-ignore
export function useEmailBulkDraftCardSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>;
export function useEmailBulkDraftCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkDraftCardQuery | undefined, EmailBulkDraftCardQueryVariables>;
export function useEmailBulkDraftCardSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>(EmailBulkDraftCardDocument, options);
        }
export type EmailBulkDraftCardQueryHookResult = ReturnType<typeof useEmailBulkDraftCardQuery>;
export type EmailBulkDraftCardLazyQueryHookResult = ReturnType<typeof useEmailBulkDraftCardLazyQuery>;
export type EmailBulkDraftCardSuspenseQueryHookResult = ReturnType<typeof useEmailBulkDraftCardSuspenseQuery>;
export type EmailBulkDraftCardQueryResult = Apollo.QueryResult<EmailBulkDraftCardQuery, EmailBulkDraftCardQueryVariables>;
export const EmailBulkSendsDocument = gql`
    query EmailBulkSends($first: Int, $unsentOnly: Boolean) {
  emailBulkSends(first: $first, unsentOnly: $unsentOnly) {
    ...EmailBulkSendListFields
  }
}
    ${EmailBulkSendListFieldsFragmentDoc}`;

/**
 * __useEmailBulkSendsQuery__
 *
 * To run a query within a React component, call `useEmailBulkSendsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBulkSendsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBulkSendsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      unsentOnly: // value for 'unsentOnly'
 *   },
 * });
 */
export function useEmailBulkSendsQuery(baseOptions?: Apollo.QueryHookOptions<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>(EmailBulkSendsDocument, options);
      }
export function useEmailBulkSendsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>(EmailBulkSendsDocument, options);
        }
// @ts-ignore
export function useEmailBulkSendsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>;
export function useEmailBulkSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendsQuery | undefined, EmailBulkSendsQueryVariables>;
export function useEmailBulkSendsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>(EmailBulkSendsDocument, options);
        }
export type EmailBulkSendsQueryHookResult = ReturnType<typeof useEmailBulkSendsQuery>;
export type EmailBulkSendsLazyQueryHookResult = ReturnType<typeof useEmailBulkSendsLazyQuery>;
export type EmailBulkSendsSuspenseQueryHookResult = ReturnType<typeof useEmailBulkSendsSuspenseQuery>;
export type EmailBulkSendsQueryResult = Apollo.QueryResult<EmailBulkSendsQuery, EmailBulkSendsQueryVariables>;
export const EmailBulkSendDocument = gql`
    query EmailBulkSend($id: ID!) {
  emailBulkSend(id: $id) {
    ...EmailBulkSendListFields
  }
}
    ${EmailBulkSendListFieldsFragmentDoc}`;

/**
 * __useEmailBulkSendQuery__
 *
 * To run a query within a React component, call `useEmailBulkSendQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBulkSendQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBulkSendQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailBulkSendQuery(baseOptions: Apollo.QueryHookOptions<EmailBulkSendQuery, EmailBulkSendQueryVariables> & ({ variables: EmailBulkSendQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBulkSendQuery, EmailBulkSendQueryVariables>(EmailBulkSendDocument, options);
      }
export function useEmailBulkSendLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBulkSendQuery, EmailBulkSendQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBulkSendQuery, EmailBulkSendQueryVariables>(EmailBulkSendDocument, options);
        }
// @ts-ignore
export function useEmailBulkSendSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBulkSendQuery, EmailBulkSendQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendQuery, EmailBulkSendQueryVariables>;
export function useEmailBulkSendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendQuery, EmailBulkSendQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendQuery | undefined, EmailBulkSendQueryVariables>;
export function useEmailBulkSendSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendQuery, EmailBulkSendQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBulkSendQuery, EmailBulkSendQueryVariables>(EmailBulkSendDocument, options);
        }
export type EmailBulkSendQueryHookResult = ReturnType<typeof useEmailBulkSendQuery>;
export type EmailBulkSendLazyQueryHookResult = ReturnType<typeof useEmailBulkSendLazyQuery>;
export type EmailBulkSendSuspenseQueryHookResult = ReturnType<typeof useEmailBulkSendSuspenseQuery>;
export type EmailBulkSendQueryResult = Apollo.QueryResult<EmailBulkSendQuery, EmailBulkSendQueryVariables>;
export const EmailBulkSendRecipientsDocument = gql`
    query EmailBulkSendRecipients($id: ID!) {
  emailBulkSend(id: $id) {
    ...EmailBulkSendSummaryFields
    restCount
    recipients {
      id
      email
      name
      heldBackReason
      sendStatus
      sendFailureKind
      isOutsideBatch
    }
  }
}
    ${EmailBulkSendSummaryFieldsFragmentDoc}`;

/**
 * __useEmailBulkSendRecipientsQuery__
 *
 * To run a query within a React component, call `useEmailBulkSendRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBulkSendRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBulkSendRecipientsQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailBulkSendRecipientsQuery(baseOptions: Apollo.QueryHookOptions<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables> & ({ variables: EmailBulkSendRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>(EmailBulkSendRecipientsDocument, options);
      }
export function useEmailBulkSendRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>(EmailBulkSendRecipientsDocument, options);
        }
// @ts-ignore
export function useEmailBulkSendRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>;
export function useEmailBulkSendRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkSendRecipientsQuery | undefined, EmailBulkSendRecipientsQueryVariables>;
export function useEmailBulkSendRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>(EmailBulkSendRecipientsDocument, options);
        }
export type EmailBulkSendRecipientsQueryHookResult = ReturnType<typeof useEmailBulkSendRecipientsQuery>;
export type EmailBulkSendRecipientsLazyQueryHookResult = ReturnType<typeof useEmailBulkSendRecipientsLazyQuery>;
export type EmailBulkSendRecipientsSuspenseQueryHookResult = ReturnType<typeof useEmailBulkSendRecipientsSuspenseQuery>;
export type EmailBulkSendRecipientsQueryResult = Apollo.QueryResult<EmailBulkSendRecipientsQuery, EmailBulkSendRecipientsQueryVariables>;
export const CancelEmailBulkSendDocument = gql`
    mutation CancelEmailBulkSend($id: ID!) {
  cancelEmailBulkSend(id: $id) {
    id
    cancelledAt
  }
}
    `;
export type CancelEmailBulkSendMutationFn = Apollo.MutationFunction<CancelEmailBulkSendMutation, CancelEmailBulkSendMutationVariables>;

/**
 * __useCancelEmailBulkSendMutation__
 *
 * To run a mutation, you first call `useCancelEmailBulkSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEmailBulkSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEmailBulkSendMutation, { data, loading, error }] = useCancelEmailBulkSendMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelEmailBulkSendMutation(baseOptions?: Apollo.MutationHookOptions<CancelEmailBulkSendMutation, CancelEmailBulkSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEmailBulkSendMutation, CancelEmailBulkSendMutationVariables>(CancelEmailBulkSendDocument, options);
      }
export type CancelEmailBulkSendMutationHookResult = ReturnType<typeof useCancelEmailBulkSendMutation>;
export type CancelEmailBulkSendMutationResult = Apollo.MutationResult<CancelEmailBulkSendMutation>;
export type CancelEmailBulkSendMutationOptions = Apollo.BaseMutationOptions<CancelEmailBulkSendMutation, CancelEmailBulkSendMutationVariables>;
export const ChangeEmailBulkSendTimeDocument = gql`
    mutation ChangeEmailBulkSendTime($id: ID!, $input: ChangeEmailBulkSendTimeInput!) {
  changeEmailBulkSendTime(id: $id, input: $input) {
    id
    firstSendAt
  }
}
    `;
export type ChangeEmailBulkSendTimeMutationFn = Apollo.MutationFunction<ChangeEmailBulkSendTimeMutation, ChangeEmailBulkSendTimeMutationVariables>;

/**
 * __useChangeEmailBulkSendTimeMutation__
 *
 * To run a mutation, you first call `useChangeEmailBulkSendTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeEmailBulkSendTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeEmailBulkSendTimeMutation, { data, loading, error }] = useChangeEmailBulkSendTimeMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useChangeEmailBulkSendTimeMutation(baseOptions?: Apollo.MutationHookOptions<ChangeEmailBulkSendTimeMutation, ChangeEmailBulkSendTimeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeEmailBulkSendTimeMutation, ChangeEmailBulkSendTimeMutationVariables>(ChangeEmailBulkSendTimeDocument, options);
      }
export type ChangeEmailBulkSendTimeMutationHookResult = ReturnType<typeof useChangeEmailBulkSendTimeMutation>;
export type ChangeEmailBulkSendTimeMutationResult = Apollo.MutationResult<ChangeEmailBulkSendTimeMutation>;
export type ChangeEmailBulkSendTimeMutationOptions = Apollo.BaseMutationOptions<ChangeEmailBulkSendTimeMutation, ChangeEmailBulkSendTimeMutationVariables>;
export const EmailBulkDraftDocument = gql`
    query EmailBulkDraft($id: ID!) {
  emailBulkSend(id: $id) {
    ...EmailBulkDraftFields
  }
}
    ${EmailBulkDraftFieldsFragmentDoc}`;

/**
 * __useEmailBulkDraftQuery__
 *
 * To run a query within a React component, call `useEmailBulkDraftQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmailBulkDraftQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmailBulkDraftQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEmailBulkDraftQuery(baseOptions: Apollo.QueryHookOptions<EmailBulkDraftQuery, EmailBulkDraftQueryVariables> & ({ variables: EmailBulkDraftQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>(EmailBulkDraftDocument, options);
      }
export function useEmailBulkDraftLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>(EmailBulkDraftDocument, options);
        }
// @ts-ignore
export function useEmailBulkDraftSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>;
export function useEmailBulkDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>): Apollo.UseSuspenseQueryResult<EmailBulkDraftQuery | undefined, EmailBulkDraftQueryVariables>;
export function useEmailBulkDraftSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>(EmailBulkDraftDocument, options);
        }
export type EmailBulkDraftQueryHookResult = ReturnType<typeof useEmailBulkDraftQuery>;
export type EmailBulkDraftLazyQueryHookResult = ReturnType<typeof useEmailBulkDraftLazyQuery>;
export type EmailBulkDraftSuspenseQueryHookResult = ReturnType<typeof useEmailBulkDraftSuspenseQuery>;
export type EmailBulkDraftQueryResult = Apollo.QueryResult<EmailBulkDraftQuery, EmailBulkDraftQueryVariables>;
export const BulkDraftEmailsDocument = gql`
    query BulkDraftEmails($artifactIds: [ID!]!) {
  caraWorkspaceArtifacts(filter: {ids: $artifactIds, types: [EMAIL]}) {
    id
    title
    latestVersion
    versions {
      id
      version
      email {
        template {
          templateId
        }
        cc {
          email
        }
        bcc {
          email
        }
      }
    }
  }
}
    `;

/**
 * __useBulkDraftEmailsQuery__
 *
 * To run a query within a React component, call `useBulkDraftEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDraftEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDraftEmailsQuery({
 *   variables: {
 *      artifactIds: // value for 'artifactIds'
 *   },
 * });
 */
export function useBulkDraftEmailsQuery(baseOptions: Apollo.QueryHookOptions<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables> & ({ variables: BulkDraftEmailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>(BulkDraftEmailsDocument, options);
      }
export function useBulkDraftEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>(BulkDraftEmailsDocument, options);
        }
// @ts-ignore
export function useBulkDraftEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>;
export function useBulkDraftEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<BulkDraftEmailsQuery | undefined, BulkDraftEmailsQueryVariables>;
export function useBulkDraftEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>(BulkDraftEmailsDocument, options);
        }
export type BulkDraftEmailsQueryHookResult = ReturnType<typeof useBulkDraftEmailsQuery>;
export type BulkDraftEmailsLazyQueryHookResult = ReturnType<typeof useBulkDraftEmailsLazyQuery>;
export type BulkDraftEmailsSuspenseQueryHookResult = ReturnType<typeof useBulkDraftEmailsSuspenseQuery>;
export type BulkDraftEmailsQueryResult = Apollo.QueryResult<BulkDraftEmailsQuery, BulkDraftEmailsQueryVariables>;
export const MailboxBulkSendUsageDocument = gql`
    query MailboxBulkSendUsage($mailboxAccountId: String!, $count: Int!, $notBefore: Time) {
  mailboxBulkSendUsage(mailboxAccountId: $mailboxAccountId) {
    usedInDailyWindow
    dailyLimit
    earliestSendAt(count: $count, notBefore: $notBefore)
  }
}
    `;

/**
 * __useMailboxBulkSendUsageQuery__
 *
 * To run a query within a React component, call `useMailboxBulkSendUsageQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxBulkSendUsageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxBulkSendUsageQuery({
 *   variables: {
 *      mailboxAccountId: // value for 'mailboxAccountId'
 *      count: // value for 'count'
 *      notBefore: // value for 'notBefore'
 *   },
 * });
 */
export function useMailboxBulkSendUsageQuery(baseOptions: Apollo.QueryHookOptions<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables> & ({ variables: MailboxBulkSendUsageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>(MailboxBulkSendUsageDocument, options);
      }
export function useMailboxBulkSendUsageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>(MailboxBulkSendUsageDocument, options);
        }
// @ts-ignore
export function useMailboxBulkSendUsageSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>;
export function useMailboxBulkSendUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxBulkSendUsageQuery | undefined, MailboxBulkSendUsageQueryVariables>;
export function useMailboxBulkSendUsageSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>(MailboxBulkSendUsageDocument, options);
        }
export type MailboxBulkSendUsageQueryHookResult = ReturnType<typeof useMailboxBulkSendUsageQuery>;
export type MailboxBulkSendUsageLazyQueryHookResult = ReturnType<typeof useMailboxBulkSendUsageLazyQuery>;
export type MailboxBulkSendUsageSuspenseQueryHookResult = ReturnType<typeof useMailboxBulkSendUsageSuspenseQuery>;
export type MailboxBulkSendUsageQueryResult = Apollo.QueryResult<MailboxBulkSendUsageQuery, MailboxBulkSendUsageQueryVariables>;
export const SendEmailBulkSendDocument = gql`
    mutation SendEmailBulkSend($id: ID!, $input: SendEmailBulkSendInput!) {
  sendEmailBulkSend(id: $id, input: $input) {
    id
    name
    sentAt
    action
    fromAddress
  }
}
    `;
export type SendEmailBulkSendMutationFn = Apollo.MutationFunction<SendEmailBulkSendMutation, SendEmailBulkSendMutationVariables>;

/**
 * __useSendEmailBulkSendMutation__
 *
 * To run a mutation, you first call `useSendEmailBulkSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEmailBulkSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEmailBulkSendMutation, { data, loading, error }] = useSendEmailBulkSendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendEmailBulkSendMutation(baseOptions?: Apollo.MutationHookOptions<SendEmailBulkSendMutation, SendEmailBulkSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEmailBulkSendMutation, SendEmailBulkSendMutationVariables>(SendEmailBulkSendDocument, options);
      }
export type SendEmailBulkSendMutationHookResult = ReturnType<typeof useSendEmailBulkSendMutation>;
export type SendEmailBulkSendMutationResult = Apollo.MutationResult<SendEmailBulkSendMutation>;
export type SendEmailBulkSendMutationOptions = Apollo.BaseMutationOptions<SendEmailBulkSendMutation, SendEmailBulkSendMutationVariables>;
export const SendRestOfEmailBulkSendDocument = gql`
    mutation SendRestOfEmailBulkSend($id: ID!, $input: SendRestOfEmailBulkSendInput!) {
  sendRestOfEmailBulkSend(id: $id, input: $input) {
    id
    name
    sentAt
    action
    fromAddress
  }
}
    `;
export type SendRestOfEmailBulkSendMutationFn = Apollo.MutationFunction<SendRestOfEmailBulkSendMutation, SendRestOfEmailBulkSendMutationVariables>;

/**
 * __useSendRestOfEmailBulkSendMutation__
 *
 * To run a mutation, you first call `useSendRestOfEmailBulkSendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendRestOfEmailBulkSendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendRestOfEmailBulkSendMutation, { data, loading, error }] = useSendRestOfEmailBulkSendMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSendRestOfEmailBulkSendMutation(baseOptions?: Apollo.MutationHookOptions<SendRestOfEmailBulkSendMutation, SendRestOfEmailBulkSendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendRestOfEmailBulkSendMutation, SendRestOfEmailBulkSendMutationVariables>(SendRestOfEmailBulkSendDocument, options);
      }
export type SendRestOfEmailBulkSendMutationHookResult = ReturnType<typeof useSendRestOfEmailBulkSendMutation>;
export type SendRestOfEmailBulkSendMutationResult = Apollo.MutationResult<SendRestOfEmailBulkSendMutation>;
export type SendRestOfEmailBulkSendMutationOptions = Apollo.BaseMutationOptions<SendRestOfEmailBulkSendMutation, SendRestOfEmailBulkSendMutationVariables>;
export const AddEmailBulkSendRecipientsDocument = gql`
    mutation AddEmailBulkSendRecipients($id: ID!, $recipients: [EmailBulkSendRecipientInput!]!) {
  addEmailBulkSendRecipients(id: $id, recipients: $recipients) {
    bulkSend {
      ...EmailBulkDraftFields
    }
    added
    duplicatesSkipped
    overCap
  }
}
    ${EmailBulkDraftFieldsFragmentDoc}`;
export type AddEmailBulkSendRecipientsMutationFn = Apollo.MutationFunction<AddEmailBulkSendRecipientsMutation, AddEmailBulkSendRecipientsMutationVariables>;

/**
 * __useAddEmailBulkSendRecipientsMutation__
 *
 * To run a mutation, you first call `useAddEmailBulkSendRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmailBulkSendRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmailBulkSendRecipientsMutation, { data, loading, error }] = useAddEmailBulkSendRecipientsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      recipients: // value for 'recipients'
 *   },
 * });
 */
export function useAddEmailBulkSendRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<AddEmailBulkSendRecipientsMutation, AddEmailBulkSendRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmailBulkSendRecipientsMutation, AddEmailBulkSendRecipientsMutationVariables>(AddEmailBulkSendRecipientsDocument, options);
      }
export type AddEmailBulkSendRecipientsMutationHookResult = ReturnType<typeof useAddEmailBulkSendRecipientsMutation>;
export type AddEmailBulkSendRecipientsMutationResult = Apollo.MutationResult<AddEmailBulkSendRecipientsMutation>;
export type AddEmailBulkSendRecipientsMutationOptions = Apollo.BaseMutationOptions<AddEmailBulkSendRecipientsMutation, AddEmailBulkSendRecipientsMutationVariables>;
export const RemoveEmailBulkSendRecipientsDocument = gql`
    mutation RemoveEmailBulkSendRecipients($id: ID!, $recipientIds: [String!]!) {
  removeEmailBulkSendRecipients(id: $id, recipientIds: $recipientIds) {
    ...EmailBulkDraftFields
  }
}
    ${EmailBulkDraftFieldsFragmentDoc}`;
export type RemoveEmailBulkSendRecipientsMutationFn = Apollo.MutationFunction<RemoveEmailBulkSendRecipientsMutation, RemoveEmailBulkSendRecipientsMutationVariables>;

/**
 * __useRemoveEmailBulkSendRecipientsMutation__
 *
 * To run a mutation, you first call `useRemoveEmailBulkSendRecipientsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveEmailBulkSendRecipientsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeEmailBulkSendRecipientsMutation, { data, loading, error }] = useRemoveEmailBulkSendRecipientsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      recipientIds: // value for 'recipientIds'
 *   },
 * });
 */
export function useRemoveEmailBulkSendRecipientsMutation(baseOptions?: Apollo.MutationHookOptions<RemoveEmailBulkSendRecipientsMutation, RemoveEmailBulkSendRecipientsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveEmailBulkSendRecipientsMutation, RemoveEmailBulkSendRecipientsMutationVariables>(RemoveEmailBulkSendRecipientsDocument, options);
      }
export type RemoveEmailBulkSendRecipientsMutationHookResult = ReturnType<typeof useRemoveEmailBulkSendRecipientsMutation>;
export type RemoveEmailBulkSendRecipientsMutationResult = Apollo.MutationResult<RemoveEmailBulkSendRecipientsMutation>;
export type RemoveEmailBulkSendRecipientsMutationOptions = Apollo.BaseMutationOptions<RemoveEmailBulkSendRecipientsMutation, RemoveEmailBulkSendRecipientsMutationVariables>;
export const BulkDraftClientSearchDocument = gql`
    query BulkDraftClientSearch($query: String!, $limit: Int) {
  searchRecipients(query: $query, limit: $limit, entityTypes: [ACCOUNT]) {
    email
    name
    description
    amsAccountId
  }
}
    `;

/**
 * __useBulkDraftClientSearchQuery__
 *
 * To run a query within a React component, call `useBulkDraftClientSearchQuery` and pass it any options that fit your needs.
 * When your component renders, `useBulkDraftClientSearchQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBulkDraftClientSearchQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useBulkDraftClientSearchQuery(baseOptions: Apollo.QueryHookOptions<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables> & ({ variables: BulkDraftClientSearchQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>(BulkDraftClientSearchDocument, options);
      }
export function useBulkDraftClientSearchLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>(BulkDraftClientSearchDocument, options);
        }
// @ts-ignore
export function useBulkDraftClientSearchSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>): Apollo.UseSuspenseQueryResult<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>;
export function useBulkDraftClientSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>): Apollo.UseSuspenseQueryResult<BulkDraftClientSearchQuery | undefined, BulkDraftClientSearchQueryVariables>;
export function useBulkDraftClientSearchSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>(BulkDraftClientSearchDocument, options);
        }
export type BulkDraftClientSearchQueryHookResult = ReturnType<typeof useBulkDraftClientSearchQuery>;
export type BulkDraftClientSearchLazyQueryHookResult = ReturnType<typeof useBulkDraftClientSearchLazyQuery>;
export type BulkDraftClientSearchSuspenseQueryHookResult = ReturnType<typeof useBulkDraftClientSearchSuspenseQuery>;
export type BulkDraftClientSearchQueryResult = Apollo.QueryResult<BulkDraftClientSearchQuery, BulkDraftClientSearchQueryVariables>;
export const GetEmailTemplatesDocument = gql`
    query GetEmailTemplates {
  emailTemplates {
    ...EmailTemplateListFields
  }
}
    ${EmailTemplateListFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplatesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailTemplatesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
      }
export function useGetEmailTemplatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
// @ts-ignore
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplatesQuery | undefined, GetEmailTemplatesQueryVariables>;
export function useGetEmailTemplatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>(GetEmailTemplatesDocument, options);
        }
export type GetEmailTemplatesQueryHookResult = ReturnType<typeof useGetEmailTemplatesQuery>;
export type GetEmailTemplatesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplatesLazyQuery>;
export type GetEmailTemplatesSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplatesSuspenseQuery>;
export type GetEmailTemplatesQueryResult = Apollo.QueryResult<GetEmailTemplatesQuery, GetEmailTemplatesQueryVariables>;
export const GetEmailTemplateDocument = gql`
    query GetEmailTemplate($id: ID!) {
  emailTemplate(id: $id) {
    ...EmailTemplateEditorFields
  }
}
    ${EmailTemplateEditorFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables> & ({ variables: GetEmailTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
      }
export function useGetEmailTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
// @ts-ignore
export function useGetEmailTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export function useGetEmailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateQuery | undefined, GetEmailTemplateQueryVariables>;
export function useGetEmailTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>(GetEmailTemplateDocument, options);
        }
export type GetEmailTemplateQueryHookResult = ReturnType<typeof useGetEmailTemplateQuery>;
export type GetEmailTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateLazyQuery>;
export type GetEmailTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplateSuspenseQuery>;
export type GetEmailTemplateQueryResult = Apollo.QueryResult<GetEmailTemplateQuery, GetEmailTemplateQueryVariables>;
export const GetEmailTemplateChoicesDocument = gql`
    query GetEmailTemplateChoices {
  emailTemplates {
    id
    name
    whenToUse
  }
}
    `;

/**
 * __useGetEmailTemplateChoicesQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateChoicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateChoicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateChoicesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailTemplateChoicesQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>(GetEmailTemplateChoicesDocument, options);
      }
export function useGetEmailTemplateChoicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>(GetEmailTemplateChoicesDocument, options);
        }
// @ts-ignore
export function useGetEmailTemplateChoicesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>;
export function useGetEmailTemplateChoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateChoicesQuery | undefined, GetEmailTemplateChoicesQueryVariables>;
export function useGetEmailTemplateChoicesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>(GetEmailTemplateChoicesDocument, options);
        }
export type GetEmailTemplateChoicesQueryHookResult = ReturnType<typeof useGetEmailTemplateChoicesQuery>;
export type GetEmailTemplateChoicesLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateChoicesLazyQuery>;
export type GetEmailTemplateChoicesSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplateChoicesSuspenseQuery>;
export type GetEmailTemplateChoicesQueryResult = Apollo.QueryResult<GetEmailTemplateChoicesQuery, GetEmailTemplateChoicesQueryVariables>;
export const GetEmailDraftTemplateDocument = gql`
    query GetEmailDraftTemplate($id: ID!) {
  emailTemplate(id: $id) {
    id
    name
    version
    archivedAt
    updatedAt
    updatedBy {
      id
      name
    }
  }
}
    `;

/**
 * __useGetEmailDraftTemplateQuery__
 *
 * To run a query within a React component, call `useGetEmailDraftTemplateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailDraftTemplateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailDraftTemplateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailDraftTemplateQuery(baseOptions: Apollo.QueryHookOptions<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables> & ({ variables: GetEmailDraftTemplateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>(GetEmailDraftTemplateDocument, options);
      }
export function useGetEmailDraftTemplateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>(GetEmailDraftTemplateDocument, options);
        }
// @ts-ignore
export function useGetEmailDraftTemplateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>;
export function useGetEmailDraftTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailDraftTemplateQuery | undefined, GetEmailDraftTemplateQueryVariables>;
export function useGetEmailDraftTemplateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>(GetEmailDraftTemplateDocument, options);
        }
export type GetEmailDraftTemplateQueryHookResult = ReturnType<typeof useGetEmailDraftTemplateQuery>;
export type GetEmailDraftTemplateLazyQueryHookResult = ReturnType<typeof useGetEmailDraftTemplateLazyQuery>;
export type GetEmailDraftTemplateSuspenseQueryHookResult = ReturnType<typeof useGetEmailDraftTemplateSuspenseQuery>;
export type GetEmailDraftTemplateQueryResult = Apollo.QueryResult<GetEmailDraftTemplateQuery, GetEmailDraftTemplateQueryVariables>;
export const GetEmailTemplateContentDocument = gql`
    query GetEmailTemplateContent($id: ID!) {
  emailTemplate(id: $id) {
    id
    name
    whenToUse
    subject
    bodyHtml
    guidelines
    visibility {
      ...VisibilityConfigFields
    }
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;

/**
 * __useGetEmailTemplateContentQuery__
 *
 * To run a query within a React component, call `useGetEmailTemplateContentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailTemplateContentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailTemplateContentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailTemplateContentQuery(baseOptions: Apollo.QueryHookOptions<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables> & ({ variables: GetEmailTemplateContentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>(GetEmailTemplateContentDocument, options);
      }
export function useGetEmailTemplateContentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>(GetEmailTemplateContentDocument, options);
        }
// @ts-ignore
export function useGetEmailTemplateContentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>;
export function useGetEmailTemplateContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailTemplateContentQuery | undefined, GetEmailTemplateContentQueryVariables>;
export function useGetEmailTemplateContentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>(GetEmailTemplateContentDocument, options);
        }
export type GetEmailTemplateContentQueryHookResult = ReturnType<typeof useGetEmailTemplateContentQuery>;
export type GetEmailTemplateContentLazyQueryHookResult = ReturnType<typeof useGetEmailTemplateContentLazyQuery>;
export type GetEmailTemplateContentSuspenseQueryHookResult = ReturnType<typeof useGetEmailTemplateContentSuspenseQuery>;
export type GetEmailTemplateContentQueryResult = Apollo.QueryResult<GetEmailTemplateContentQuery, GetEmailTemplateContentQueryVariables>;
export const CreateEmailTemplateDocument = gql`
    mutation CreateEmailTemplate($input: EmailTemplateInput!) {
  createEmailTemplate(input: $input) {
    id
  }
}
    `;
export type CreateEmailTemplateMutationFn = Apollo.MutationFunction<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;

/**
 * __useCreateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useCreateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createEmailTemplateMutation, { data, loading, error }] = useCreateEmailTemplateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>(CreateEmailTemplateDocument, options);
      }
export type CreateEmailTemplateMutationHookResult = ReturnType<typeof useCreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationResult = Apollo.MutationResult<CreateEmailTemplateMutation>;
export type CreateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<CreateEmailTemplateMutation, CreateEmailTemplateMutationVariables>;
export const UpdateEmailTemplateDocument = gql`
    mutation UpdateEmailTemplate($id: ID!, $expectedVersion: Int64!, $input: EmailTemplateInput!) {
  updateEmailTemplate(id: $id, expectedVersion: $expectedVersion, input: $input) {
    id
    version
  }
}
    `;
export type UpdateEmailTemplateMutationFn = Apollo.MutationFunction<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;

/**
 * __useUpdateEmailTemplateMutation__
 *
 * To run a mutation, you first call `useUpdateEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmailTemplateMutation, { data, loading, error }] = useUpdateEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      expectedVersion: // value for 'expectedVersion'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>(UpdateEmailTemplateDocument, options);
      }
export type UpdateEmailTemplateMutationHookResult = ReturnType<typeof useUpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationResult = Apollo.MutationResult<UpdateEmailTemplateMutation>;
export type UpdateEmailTemplateMutationOptions = Apollo.BaseMutationOptions<UpdateEmailTemplateMutation, UpdateEmailTemplateMutationVariables>;
export const ArchiveEmailTemplateDocument = gql`
    mutation ArchiveEmailTemplate($id: ID!) {
  archiveEmailTemplate(id: $id) {
    id
  }
}
    `;
export type ArchiveEmailTemplateMutationFn = Apollo.MutationFunction<ArchiveEmailTemplateMutation, ArchiveEmailTemplateMutationVariables>;

/**
 * __useArchiveEmailTemplateMutation__
 *
 * To run a mutation, you first call `useArchiveEmailTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveEmailTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveEmailTemplateMutation, { data, loading, error }] = useArchiveEmailTemplateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveEmailTemplateMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveEmailTemplateMutation, ArchiveEmailTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveEmailTemplateMutation, ArchiveEmailTemplateMutationVariables>(ArchiveEmailTemplateDocument, options);
      }
export type ArchiveEmailTemplateMutationHookResult = ReturnType<typeof useArchiveEmailTemplateMutation>;
export type ArchiveEmailTemplateMutationResult = Apollo.MutationResult<ArchiveEmailTemplateMutation>;
export type ArchiveEmailTemplateMutationOptions = Apollo.BaseMutationOptions<ArchiveEmailTemplateMutation, ArchiveEmailTemplateMutationVariables>;
export const GetAgencyEmailGuidelinesDocument = gql`
    query GetAgencyEmailGuidelines {
  agency {
    id
    configuration {
      email {
        guidelines
      }
    }
  }
}
    `;

/**
 * __useGetAgencyEmailGuidelinesQuery__
 *
 * To run a query within a React component, call `useGetAgencyEmailGuidelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyEmailGuidelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyEmailGuidelinesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyEmailGuidelinesQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>(GetAgencyEmailGuidelinesDocument, options);
      }
export function useGetAgencyEmailGuidelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>(GetAgencyEmailGuidelinesDocument, options);
        }
// @ts-ignore
export function useGetAgencyEmailGuidelinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>;
export function useGetAgencyEmailGuidelinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyEmailGuidelinesQuery | undefined, GetAgencyEmailGuidelinesQueryVariables>;
export function useGetAgencyEmailGuidelinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>(GetAgencyEmailGuidelinesDocument, options);
        }
export type GetAgencyEmailGuidelinesQueryHookResult = ReturnType<typeof useGetAgencyEmailGuidelinesQuery>;
export type GetAgencyEmailGuidelinesLazyQueryHookResult = ReturnType<typeof useGetAgencyEmailGuidelinesLazyQuery>;
export type GetAgencyEmailGuidelinesSuspenseQueryHookResult = ReturnType<typeof useGetAgencyEmailGuidelinesSuspenseQuery>;
export type GetAgencyEmailGuidelinesQueryResult = Apollo.QueryResult<GetAgencyEmailGuidelinesQuery, GetAgencyEmailGuidelinesQueryVariables>;
export const UpdateAgencyEmailGuidelinesDocument = gql`
    mutation UpdateAgencyEmailGuidelines($guidelines: [String!]!) {
  updateAgencyEmailGuidelines(guidelines: $guidelines) {
    guidelines
  }
}
    `;
export type UpdateAgencyEmailGuidelinesMutationFn = Apollo.MutationFunction<UpdateAgencyEmailGuidelinesMutation, UpdateAgencyEmailGuidelinesMutationVariables>;

/**
 * __useUpdateAgencyEmailGuidelinesMutation__
 *
 * To run a mutation, you first call `useUpdateAgencyEmailGuidelinesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateAgencyEmailGuidelinesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateAgencyEmailGuidelinesMutation, { data, loading, error }] = useUpdateAgencyEmailGuidelinesMutation({
 *   variables: {
 *      guidelines: // value for 'guidelines'
 *   },
 * });
 */
export function useUpdateAgencyEmailGuidelinesMutation(baseOptions?: Apollo.MutationHookOptions<UpdateAgencyEmailGuidelinesMutation, UpdateAgencyEmailGuidelinesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateAgencyEmailGuidelinesMutation, UpdateAgencyEmailGuidelinesMutationVariables>(UpdateAgencyEmailGuidelinesDocument, options);
      }
export type UpdateAgencyEmailGuidelinesMutationHookResult = ReturnType<typeof useUpdateAgencyEmailGuidelinesMutation>;
export type UpdateAgencyEmailGuidelinesMutationResult = Apollo.MutationResult<UpdateAgencyEmailGuidelinesMutation>;
export type UpdateAgencyEmailGuidelinesMutationOptions = Apollo.BaseMutationOptions<UpdateAgencyEmailGuidelinesMutation, UpdateAgencyEmailGuidelinesMutationVariables>;
export const GetEmailThreadsDocument = gql`
    query GetEmailThreads {
  emailThreads {
    ...EmailThreadFields
  }
}
    ${EmailThreadFieldsFragmentDoc}`;

/**
 * __useGetEmailThreadsQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailThreadsQuery(baseOptions?: Apollo.QueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(GetEmailThreadsDocument, options);
      }
export function useGetEmailThreadsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(GetEmailThreadsDocument, options);
        }
// @ts-ignore
export function useGetEmailThreadsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>;
export function useGetEmailThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailThreadsQuery | undefined, GetEmailThreadsQueryVariables>;
export function useGetEmailThreadsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>(GetEmailThreadsDocument, options);
        }
export type GetEmailThreadsQueryHookResult = ReturnType<typeof useGetEmailThreadsQuery>;
export type GetEmailThreadsLazyQueryHookResult = ReturnType<typeof useGetEmailThreadsLazyQuery>;
export type GetEmailThreadsSuspenseQueryHookResult = ReturnType<typeof useGetEmailThreadsSuspenseQuery>;
export type GetEmailThreadsQueryResult = Apollo.QueryResult<GetEmailThreadsQuery, GetEmailThreadsQueryVariables>;
export const GetEmailThreadDocument = gql`
    query GetEmailThread($id: ID!) {
  emailThread(id: $id) {
    ...EmailThreadFields
    ...EmailThreadConversationFields
  }
}
    ${EmailThreadFieldsFragmentDoc}
${EmailThreadConversationFieldsFragmentDoc}`;

/**
 * __useGetEmailThreadQuery__
 *
 * To run a query within a React component, call `useGetEmailThreadQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailThreadQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailThreadQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetEmailThreadQuery(baseOptions: Apollo.QueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables> & ({ variables: GetEmailThreadQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options);
      }
export function useGetEmailThreadLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options);
        }
// @ts-ignore
export function useGetEmailThreadSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailThreadQuery, GetEmailThreadQueryVariables>;
export function useGetEmailThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>): Apollo.UseSuspenseQueryResult<GetEmailThreadQuery | undefined, GetEmailThreadQueryVariables>;
export function useGetEmailThreadSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetEmailThreadQuery, GetEmailThreadQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetEmailThreadQuery, GetEmailThreadQueryVariables>(GetEmailThreadDocument, options);
        }
export type GetEmailThreadQueryHookResult = ReturnType<typeof useGetEmailThreadQuery>;
export type GetEmailThreadLazyQueryHookResult = ReturnType<typeof useGetEmailThreadLazyQuery>;
export type GetEmailThreadSuspenseQueryHookResult = ReturnType<typeof useGetEmailThreadSuspenseQuery>;
export type GetEmailThreadQueryResult = Apollo.QueryResult<GetEmailThreadQuery, GetEmailThreadQueryVariables>;
export const GetFeedbackDocument = gql`
    query GetFeedback($input: GetFeedbackInput!) {
  getFeedback(input: $input) {
    ...FeedbackFields
  }
}
    ${FeedbackFieldsFragmentDoc}`;

/**
 * __useGetFeedbackQuery__
 *
 * To run a query within a React component, call `useGetFeedbackQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeedbackQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeedbackQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGetFeedbackQuery(baseOptions: Apollo.QueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables> & ({ variables: GetFeedbackQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
      }
export function useGetFeedbackLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
        }
// @ts-ignore
export function useGetFeedbackSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedbackQuery, GetFeedbackQueryVariables>;
export function useGetFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>): Apollo.UseSuspenseQueryResult<GetFeedbackQuery | undefined, GetFeedbackQueryVariables>;
export function useGetFeedbackSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFeedbackQuery, GetFeedbackQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFeedbackQuery, GetFeedbackQueryVariables>(GetFeedbackDocument, options);
        }
export type GetFeedbackQueryHookResult = ReturnType<typeof useGetFeedbackQuery>;
export type GetFeedbackLazyQueryHookResult = ReturnType<typeof useGetFeedbackLazyQuery>;
export type GetFeedbackSuspenseQueryHookResult = ReturnType<typeof useGetFeedbackSuspenseQuery>;
export type GetFeedbackQueryResult = Apollo.QueryResult<GetFeedbackQuery, GetFeedbackQueryVariables>;
export const SubmitMessageRatingDocument = gql`
    mutation SubmitMessageRating($input: SubmitMessageRatingInput!) {
  submitMessageRating(input: $input) {
    ...FeedbackFields
  }
}
    ${FeedbackFieldsFragmentDoc}`;
export type SubmitMessageRatingMutationFn = Apollo.MutationFunction<SubmitMessageRatingMutation, SubmitMessageRatingMutationVariables>;

/**
 * __useSubmitMessageRatingMutation__
 *
 * To run a mutation, you first call `useSubmitMessageRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitMessageRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitMessageRatingMutation, { data, loading, error }] = useSubmitMessageRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitMessageRatingMutation(baseOptions?: Apollo.MutationHookOptions<SubmitMessageRatingMutation, SubmitMessageRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitMessageRatingMutation, SubmitMessageRatingMutationVariables>(SubmitMessageRatingDocument, options);
      }
export type SubmitMessageRatingMutationHookResult = ReturnType<typeof useSubmitMessageRatingMutation>;
export type SubmitMessageRatingMutationResult = Apollo.MutationResult<SubmitMessageRatingMutation>;
export type SubmitMessageRatingMutationOptions = Apollo.BaseMutationOptions<SubmitMessageRatingMutation, SubmitMessageRatingMutationVariables>;
export const SubmitCallRatingDocument = gql`
    mutation SubmitCallRating($input: SubmitCallRatingInput!) {
  submitCallRating(input: $input) {
    ...FeedbackFields
  }
}
    ${FeedbackFieldsFragmentDoc}`;
export type SubmitCallRatingMutationFn = Apollo.MutationFunction<SubmitCallRatingMutation, SubmitCallRatingMutationVariables>;

/**
 * __useSubmitCallRatingMutation__
 *
 * To run a mutation, you first call `useSubmitCallRatingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitCallRatingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitCallRatingMutation, { data, loading, error }] = useSubmitCallRatingMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSubmitCallRatingMutation(baseOptions?: Apollo.MutationHookOptions<SubmitCallRatingMutation, SubmitCallRatingMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitCallRatingMutation, SubmitCallRatingMutationVariables>(SubmitCallRatingDocument, options);
      }
export type SubmitCallRatingMutationHookResult = ReturnType<typeof useSubmitCallRatingMutation>;
export type SubmitCallRatingMutationResult = Apollo.MutationResult<SubmitCallRatingMutation>;
export type SubmitCallRatingMutationOptions = Apollo.BaseMutationOptions<SubmitCallRatingMutation, SubmitCallRatingMutationVariables>;
export const DeleteFeedbackDocument = gql`
    mutation DeleteFeedback($id: ID!) {
  deleteFeedback(id: $id) {
    ...FeedbackFields
  }
}
    ${FeedbackFieldsFragmentDoc}`;
export type DeleteFeedbackMutationFn = Apollo.MutationFunction<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>;

/**
 * __useDeleteFeedbackMutation__
 *
 * To run a mutation, you first call `useDeleteFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFeedbackMutation, { data, loading, error }] = useDeleteFeedbackMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>(DeleteFeedbackDocument, options);
      }
export type DeleteFeedbackMutationHookResult = ReturnType<typeof useDeleteFeedbackMutation>;
export type DeleteFeedbackMutationResult = Apollo.MutationResult<DeleteFeedbackMutation>;
export type DeleteFeedbackMutationOptions = Apollo.BaseMutationOptions<DeleteFeedbackMutation, DeleteFeedbackMutationVariables>;
export const DeleteFileDocument = gql`
    mutation DeleteFile($fileId: ID!) {
  deleteFile(fileId: $fileId) {
    ...FileFields
  }
}
    ${FileFieldsFragmentDoc}`;
export type DeleteFileMutationFn = Apollo.MutationFunction<DeleteFileMutation, DeleteFileMutationVariables>;

/**
 * __useDeleteFileMutation__
 *
 * To run a mutation, you first call `useDeleteFileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFileMutation, { data, loading, error }] = useDeleteFileMutation({
 *   variables: {
 *      fileId: // value for 'fileId'
 *   },
 * });
 */
export function useDeleteFileMutation(baseOptions?: Apollo.MutationHookOptions<DeleteFileMutation, DeleteFileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, options);
      }
export type DeleteFileMutationHookResult = ReturnType<typeof useDeleteFileMutation>;
export type DeleteFileMutationResult = Apollo.MutationResult<DeleteFileMutation>;
export type DeleteFileMutationOptions = Apollo.BaseMutationOptions<DeleteFileMutation, DeleteFileMutationVariables>;
export const UploadImageToWorkspaceDocument = gql`
    mutation UploadImageToWorkspace($workspaceId: ID!, $file: UploadFileInput!) {
  uploadWorkspaceFile(workspaceId: $workspaceId, file: $file) {
    id
    url
    name
  }
}
    `;
export type UploadImageToWorkspaceMutationFn = Apollo.MutationFunction<UploadImageToWorkspaceMutation, UploadImageToWorkspaceMutationVariables>;

/**
 * __useUploadImageToWorkspaceMutation__
 *
 * To run a mutation, you first call `useUploadImageToWorkspaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageToWorkspaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageToWorkspaceMutation, { data, loading, error }] = useUploadImageToWorkspaceMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadImageToWorkspaceMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageToWorkspaceMutation, UploadImageToWorkspaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageToWorkspaceMutation, UploadImageToWorkspaceMutationVariables>(UploadImageToWorkspaceDocument, options);
      }
export type UploadImageToWorkspaceMutationHookResult = ReturnType<typeof useUploadImageToWorkspaceMutation>;
export type UploadImageToWorkspaceMutationResult = Apollo.MutationResult<UploadImageToWorkspaceMutation>;
export type UploadImageToWorkspaceMutationOptions = Apollo.BaseMutationOptions<UploadImageToWorkspaceMutation, UploadImageToWorkspaceMutationVariables>;
export const UploadImageToTemplateDocument = gql`
    mutation UploadImageToTemplate($templateId: ID!, $file: UploadFileInput!) {
  uploadHtmlDocumentTemplateFile(templateId: $templateId, file: $file) {
    id
    url
    name
  }
}
    `;
export type UploadImageToTemplateMutationFn = Apollo.MutationFunction<UploadImageToTemplateMutation, UploadImageToTemplateMutationVariables>;

/**
 * __useUploadImageToTemplateMutation__
 *
 * To run a mutation, you first call `useUploadImageToTemplateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadImageToTemplateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadImageToTemplateMutation, { data, loading, error }] = useUploadImageToTemplateMutation({
 *   variables: {
 *      templateId: // value for 'templateId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadImageToTemplateMutation(baseOptions?: Apollo.MutationHookOptions<UploadImageToTemplateMutation, UploadImageToTemplateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadImageToTemplateMutation, UploadImageToTemplateMutationVariables>(UploadImageToTemplateDocument, options);
      }
export type UploadImageToTemplateMutationHookResult = ReturnType<typeof useUploadImageToTemplateMutation>;
export type UploadImageToTemplateMutationResult = Apollo.MutationResult<UploadImageToTemplateMutation>;
export type UploadImageToTemplateMutationOptions = Apollo.BaseMutationOptions<UploadImageToTemplateMutation, UploadImageToTemplateMutationVariables>;
export const SearchExistingFilesDocument = gql`
    query SearchExistingFiles($filters: SearchFileFilter!) {
  searchFiles(filters: $filters) {
    ...SearchFileResultFields
  }
}
    ${SearchFileResultFieldsFragmentDoc}`;

/**
 * __useSearchExistingFilesQuery__
 *
 * To run a query within a React component, call `useSearchExistingFilesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchExistingFilesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchExistingFilesQuery({
 *   variables: {
 *      filters: // value for 'filters'
 *   },
 * });
 */
export function useSearchExistingFilesQuery(baseOptions: Apollo.QueryHookOptions<SearchExistingFilesQuery, SearchExistingFilesQueryVariables> & ({ variables: SearchExistingFilesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>(SearchExistingFilesDocument, options);
      }
export function useSearchExistingFilesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>(SearchExistingFilesDocument, options);
        }
// @ts-ignore
export function useSearchExistingFilesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>;
export function useSearchExistingFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchExistingFilesQuery | undefined, SearchExistingFilesQueryVariables>;
export function useSearchExistingFilesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>(SearchExistingFilesDocument, options);
        }
export type SearchExistingFilesQueryHookResult = ReturnType<typeof useSearchExistingFilesQuery>;
export type SearchExistingFilesLazyQueryHookResult = ReturnType<typeof useSearchExistingFilesLazyQuery>;
export type SearchExistingFilesSuspenseQueryHookResult = ReturnType<typeof useSearchExistingFilesSuspenseQuery>;
export type SearchExistingFilesQueryResult = Apollo.QueryResult<SearchExistingFilesQuery, SearchExistingFilesQueryVariables>;
export const GetTransferDirectoryImportSchemaDocument = gql`
    query GetTransferDirectoryImportSchema {
  transferDirectoryImportSchema {
    ...ImportSchemaFields
  }
}
    ${ImportSchemaFieldsFragmentDoc}`;

/**
 * __useGetTransferDirectoryImportSchemaQuery__
 *
 * To run a query within a React component, call `useGetTransferDirectoryImportSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransferDirectoryImportSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransferDirectoryImportSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTransferDirectoryImportSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>(GetTransferDirectoryImportSchemaDocument, options);
      }
export function useGetTransferDirectoryImportSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>(GetTransferDirectoryImportSchemaDocument, options);
        }
// @ts-ignore
export function useGetTransferDirectoryImportSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>;
export function useGetTransferDirectoryImportSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetTransferDirectoryImportSchemaQuery | undefined, GetTransferDirectoryImportSchemaQueryVariables>;
export function useGetTransferDirectoryImportSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>(GetTransferDirectoryImportSchemaDocument, options);
        }
export type GetTransferDirectoryImportSchemaQueryHookResult = ReturnType<typeof useGetTransferDirectoryImportSchemaQuery>;
export type GetTransferDirectoryImportSchemaLazyQueryHookResult = ReturnType<typeof useGetTransferDirectoryImportSchemaLazyQuery>;
export type GetTransferDirectoryImportSchemaSuspenseQueryHookResult = ReturnType<typeof useGetTransferDirectoryImportSchemaSuspenseQuery>;
export type GetTransferDirectoryImportSchemaQueryResult = Apollo.QueryResult<GetTransferDirectoryImportSchemaQuery, GetTransferDirectoryImportSchemaQueryVariables>;
export const GetAgencyUserImportSchemaDocument = gql`
    query GetAgencyUserImportSchema {
  agencyUserImportSchema {
    ...ImportSchemaFields
  }
}
    ${ImportSchemaFieldsFragmentDoc}`;

/**
 * __useGetAgencyUserImportSchemaQuery__
 *
 * To run a query within a React component, call `useGetAgencyUserImportSchemaQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAgencyUserImportSchemaQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAgencyUserImportSchemaQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAgencyUserImportSchemaQuery(baseOptions?: Apollo.QueryHookOptions<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>(GetAgencyUserImportSchemaDocument, options);
      }
export function useGetAgencyUserImportSchemaLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>(GetAgencyUserImportSchemaDocument, options);
        }
// @ts-ignore
export function useGetAgencyUserImportSchemaSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>;
export function useGetAgencyUserImportSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>): Apollo.UseSuspenseQueryResult<GetAgencyUserImportSchemaQuery | undefined, GetAgencyUserImportSchemaQueryVariables>;
export function useGetAgencyUserImportSchemaSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>(GetAgencyUserImportSchemaDocument, options);
        }
export type GetAgencyUserImportSchemaQueryHookResult = ReturnType<typeof useGetAgencyUserImportSchemaQuery>;
export type GetAgencyUserImportSchemaLazyQueryHookResult = ReturnType<typeof useGetAgencyUserImportSchemaLazyQuery>;
export type GetAgencyUserImportSchemaSuspenseQueryHookResult = ReturnType<typeof useGetAgencyUserImportSchemaSuspenseQuery>;
export type GetAgencyUserImportSchemaQueryResult = Apollo.QueryResult<GetAgencyUserImportSchemaQuery, GetAgencyUserImportSchemaQueryVariables>;
export const GetIntegrationsDocument = gql`
    query GetIntegrations {
  integrations {
    ...IntegrationFields
  }
}
    ${IntegrationFieldsFragmentDoc}`;

/**
 * __useGetIntegrationsQuery__
 *
 * To run a query within a React component, call `useGetIntegrationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIntegrationsQuery(baseOptions?: Apollo.QueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
      }
export function useGetIntegrationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
// @ts-ignore
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationsQuery | undefined, GetIntegrationsQueryVariables>;
export function useGetIntegrationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationsQuery, GetIntegrationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationsQuery, GetIntegrationsQueryVariables>(GetIntegrationsDocument, options);
        }
export type GetIntegrationsQueryHookResult = ReturnType<typeof useGetIntegrationsQuery>;
export type GetIntegrationsLazyQueryHookResult = ReturnType<typeof useGetIntegrationsLazyQuery>;
export type GetIntegrationsSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationsSuspenseQuery>;
export type GetIntegrationsQueryResult = Apollo.QueryResult<GetIntegrationsQuery, GetIntegrationsQueryVariables>;
export const GetIntegrationDocument = gql`
    query GetIntegration($id: ID!) {
  integration(id: $id) {
    ...IntegrationDetailFields
  }
}
    ${IntegrationDetailFieldsFragmentDoc}`;

/**
 * __useGetIntegrationQuery__
 *
 * To run a query within a React component, call `useGetIntegrationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables> & ({ variables: GetIntegrationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
      }
export function useGetIntegrationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
// @ts-ignore
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationQuery | undefined, GetIntegrationQueryVariables>;
export function useGetIntegrationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationQuery, GetIntegrationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationQuery, GetIntegrationQueryVariables>(GetIntegrationDocument, options);
        }
export type GetIntegrationQueryHookResult = ReturnType<typeof useGetIntegrationQuery>;
export type GetIntegrationLazyQueryHookResult = ReturnType<typeof useGetIntegrationLazyQuery>;
export type GetIntegrationSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationSuspenseQuery>;
export type GetIntegrationQueryResult = Apollo.QueryResult<GetIntegrationQuery, GetIntegrationQueryVariables>;
export const CreateIntegrationDocument = gql`
    mutation CreateIntegration($input: CreateIntegrationInput!) {
  createIntegration(input: $input) {
    ...IntegrationDetailFields
  }
}
    ${IntegrationDetailFieldsFragmentDoc}`;
export type CreateIntegrationMutationFn = Apollo.MutationFunction<CreateIntegrationMutation, CreateIntegrationMutationVariables>;

/**
 * __useCreateIntegrationMutation__
 *
 * To run a mutation, you first call `useCreateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createIntegrationMutation, { data, loading, error }] = useCreateIntegrationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateIntegrationMutation, CreateIntegrationMutationVariables>(CreateIntegrationDocument, options);
      }
export type CreateIntegrationMutationHookResult = ReturnType<typeof useCreateIntegrationMutation>;
export type CreateIntegrationMutationResult = Apollo.MutationResult<CreateIntegrationMutation>;
export type CreateIntegrationMutationOptions = Apollo.BaseMutationOptions<CreateIntegrationMutation, CreateIntegrationMutationVariables>;
export const UpdateIntegrationDocument = gql`
    mutation UpdateIntegration($id: ID!, $input: UpdateIntegrationInput!) {
  updateIntegration(id: $id, input: $input) {
    ...IntegrationDetailFields
  }
}
    ${IntegrationDetailFieldsFragmentDoc}`;
export type UpdateIntegrationMutationFn = Apollo.MutationFunction<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;

/**
 * __useUpdateIntegrationMutation__
 *
 * To run a mutation, you first call `useUpdateIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIntegrationMutation, { data, loading, error }] = useUpdateIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>(UpdateIntegrationDocument, options);
      }
export type UpdateIntegrationMutationHookResult = ReturnType<typeof useUpdateIntegrationMutation>;
export type UpdateIntegrationMutationResult = Apollo.MutationResult<UpdateIntegrationMutation>;
export type UpdateIntegrationMutationOptions = Apollo.BaseMutationOptions<UpdateIntegrationMutation, UpdateIntegrationMutationVariables>;
export const SetIntegrationLogsSentEmailsDocument = gql`
    mutation SetIntegrationLogsSentEmails($id: ID!, $enabled: Boolean!) {
  setIntegrationLogsSentEmails(id: $id, enabled: $enabled) {
    ...IntegrationFields
  }
}
    ${IntegrationFieldsFragmentDoc}`;
export type SetIntegrationLogsSentEmailsMutationFn = Apollo.MutationFunction<SetIntegrationLogsSentEmailsMutation, SetIntegrationLogsSentEmailsMutationVariables>;

/**
 * __useSetIntegrationLogsSentEmailsMutation__
 *
 * To run a mutation, you first call `useSetIntegrationLogsSentEmailsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetIntegrationLogsSentEmailsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setIntegrationLogsSentEmailsMutation, { data, loading, error }] = useSetIntegrationLogsSentEmailsMutation({
 *   variables: {
 *      id: // value for 'id'
 *      enabled: // value for 'enabled'
 *   },
 * });
 */
export function useSetIntegrationLogsSentEmailsMutation(baseOptions?: Apollo.MutationHookOptions<SetIntegrationLogsSentEmailsMutation, SetIntegrationLogsSentEmailsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetIntegrationLogsSentEmailsMutation, SetIntegrationLogsSentEmailsMutationVariables>(SetIntegrationLogsSentEmailsDocument, options);
      }
export type SetIntegrationLogsSentEmailsMutationHookResult = ReturnType<typeof useSetIntegrationLogsSentEmailsMutation>;
export type SetIntegrationLogsSentEmailsMutationResult = Apollo.MutationResult<SetIntegrationLogsSentEmailsMutation>;
export type SetIntegrationLogsSentEmailsMutationOptions = Apollo.BaseMutationOptions<SetIntegrationLogsSentEmailsMutation, SetIntegrationLogsSentEmailsMutationVariables>;
export const SyncIntegrationDocument = gql`
    mutation SyncIntegration($id: ID!) {
  syncIntegration(id: $id) {
    ...IntegrationDetailFields
  }
}
    ${IntegrationDetailFieldsFragmentDoc}`;
export type SyncIntegrationMutationFn = Apollo.MutationFunction<SyncIntegrationMutation, SyncIntegrationMutationVariables>;

/**
 * __useSyncIntegrationMutation__
 *
 * To run a mutation, you first call `useSyncIntegrationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncIntegrationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncIntegrationMutation, { data, loading, error }] = useSyncIntegrationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncIntegrationMutation(baseOptions?: Apollo.MutationHookOptions<SyncIntegrationMutation, SyncIntegrationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncIntegrationMutation, SyncIntegrationMutationVariables>(SyncIntegrationDocument, options);
      }
export type SyncIntegrationMutationHookResult = ReturnType<typeof useSyncIntegrationMutation>;
export type SyncIntegrationMutationResult = Apollo.MutationResult<SyncIntegrationMutation>;
export type SyncIntegrationMutationOptions = Apollo.BaseMutationOptions<SyncIntegrationMutation, SyncIntegrationMutationVariables>;
export const GetHubSpotTicketPipelinesDocument = gql`
    query GetHubSpotTicketPipelines($integrationId: ID!) {
  hubspotTicketPipelines(integrationId: $integrationId) {
    id
    label
    displayOrder
    stages {
      id
      label
      displayOrder
      archived
      ticketState
    }
    createdAt
    updatedAt
    archived
  }
}
    `;

/**
 * __useGetHubSpotTicketPipelinesQuery__
 *
 * To run a query within a React component, call `useGetHubSpotTicketPipelinesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetHubSpotTicketPipelinesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetHubSpotTicketPipelinesQuery({
 *   variables: {
 *      integrationId: // value for 'integrationId'
 *   },
 * });
 */
export function useGetHubSpotTicketPipelinesQuery(baseOptions: Apollo.QueryHookOptions<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables> & ({ variables: GetHubSpotTicketPipelinesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>(GetHubSpotTicketPipelinesDocument, options);
      }
export function useGetHubSpotTicketPipelinesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>(GetHubSpotTicketPipelinesDocument, options);
        }
// @ts-ignore
export function useGetHubSpotTicketPipelinesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>;
export function useGetHubSpotTicketPipelinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>): Apollo.UseSuspenseQueryResult<GetHubSpotTicketPipelinesQuery | undefined, GetHubSpotTicketPipelinesQueryVariables>;
export function useGetHubSpotTicketPipelinesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>(GetHubSpotTicketPipelinesDocument, options);
        }
export type GetHubSpotTicketPipelinesQueryHookResult = ReturnType<typeof useGetHubSpotTicketPipelinesQuery>;
export type GetHubSpotTicketPipelinesLazyQueryHookResult = ReturnType<typeof useGetHubSpotTicketPipelinesLazyQuery>;
export type GetHubSpotTicketPipelinesSuspenseQueryHookResult = ReturnType<typeof useGetHubSpotTicketPipelinesSuspenseQuery>;
export type GetHubSpotTicketPipelinesQueryResult = Apollo.QueryResult<GetHubSpotTicketPipelinesQuery, GetHubSpotTicketPipelinesQueryVariables>;
export const GetIntegrationStateDocument = gql`
    query GetIntegrationState($id: ID!) {
  integration(id: $id) {
    id
    state
  }
}
    `;

/**
 * __useGetIntegrationStateQuery__
 *
 * To run a query within a React component, call `useGetIntegrationStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIntegrationStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIntegrationStateQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetIntegrationStateQuery(baseOptions: Apollo.QueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables> & ({ variables: GetIntegrationStateQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(GetIntegrationStateDocument, options);
      }
export function useGetIntegrationStateLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(GetIntegrationStateDocument, options);
        }
// @ts-ignore
export function useGetIntegrationStateSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>;
export function useGetIntegrationStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>): Apollo.UseSuspenseQueryResult<GetIntegrationStateQuery | undefined, GetIntegrationStateQueryVariables>;
export function useGetIntegrationStateSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>(GetIntegrationStateDocument, options);
        }
export type GetIntegrationStateQueryHookResult = ReturnType<typeof useGetIntegrationStateQuery>;
export type GetIntegrationStateLazyQueryHookResult = ReturnType<typeof useGetIntegrationStateLazyQuery>;
export type GetIntegrationStateSuspenseQueryHookResult = ReturnType<typeof useGetIntegrationStateSuspenseQuery>;
export type GetIntegrationStateQueryResult = Apollo.QueryResult<GetIntegrationStateQuery, GetIntegrationStateQueryVariables>;
export const GetKnowledgeBasesDocument = gql`
    query GetKnowledgeBases {
  knowledgeBases {
    ...KnowledgeBaseListFields
  }
}
    ${KnowledgeBaseListFieldsFragmentDoc}`;

/**
 * __useGetKnowledgeBasesQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBasesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBasesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBasesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKnowledgeBasesQuery(baseOptions?: Apollo.QueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
      }
export function useGetKnowledgeBasesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>;
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBasesQuery | undefined, GetKnowledgeBasesQueryVariables>;
export function useGetKnowledgeBasesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>(GetKnowledgeBasesDocument, options);
        }
export type GetKnowledgeBasesQueryHookResult = ReturnType<typeof useGetKnowledgeBasesQuery>;
export type GetKnowledgeBasesLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBasesLazyQuery>;
export type GetKnowledgeBasesSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBasesSuspenseQuery>;
export type GetKnowledgeBasesQueryResult = Apollo.QueryResult<GetKnowledgeBasesQuery, GetKnowledgeBasesQueryVariables>;
export const GetKnowledgeBaseDocumentsDocument = gql`
    query GetKnowledgeBaseDocuments {
  knowledgeBases {
    id
    title
    documents {
      ...KnowledgeBaseDocumentSearchFields
    }
  }
}
    ${KnowledgeBaseDocumentSearchFieldsFragmentDoc}`;

/**
 * __useGetKnowledgeBaseDocumentsQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentsQuery(baseOptions?: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
      }
export function useGetKnowledgeBaseDocumentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>;
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentsQuery | undefined, GetKnowledgeBaseDocumentsQueryVariables>;
export function useGetKnowledgeBaseDocumentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>(GetKnowledgeBaseDocumentsDocument, options);
        }
export type GetKnowledgeBaseDocumentsQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsQuery>;
export type GetKnowledgeBaseDocumentsLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsLazyQuery>;
export type GetKnowledgeBaseDocumentsSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentsSuspenseQuery>;
export type GetKnowledgeBaseDocumentsQueryResult = Apollo.QueryResult<GetKnowledgeBaseDocumentsQuery, GetKnowledgeBaseDocumentsQueryVariables>;
export const GetKnowledgeBaseDocument = gql`
    query GetKnowledgeBase($id: ID!) {
  knowledgeBase(id: $id) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;

/**
 * __useGetKnowledgeBaseQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables> & ({ variables: GetKnowledgeBaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
      }
export function useGetKnowledgeBaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>;
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseQuery | undefined, GetKnowledgeBaseQueryVariables>;
export function useGetKnowledgeBaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>(GetKnowledgeBaseDocument, options);
        }
export type GetKnowledgeBaseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseQuery>;
export type GetKnowledgeBaseLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseLazyQuery>;
export type GetKnowledgeBaseSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseSuspenseQuery>;
export type GetKnowledgeBaseQueryResult = Apollo.QueryResult<GetKnowledgeBaseQuery, GetKnowledgeBaseQueryVariables>;
export const GetKnowledgeBaseDocumentDocument = gql`
    query GetKnowledgeBaseDocument($id: ID!) {
  knowledgeBaseDocument(id: $id) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;

/**
 * __useGetKnowledgeBaseDocumentQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables> & ({ variables: GetKnowledgeBaseDocumentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>(GetKnowledgeBaseDocumentDocument, options);
      }
export function useGetKnowledgeBaseDocumentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>(GetKnowledgeBaseDocumentDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseDocumentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>;
export function useGetKnowledgeBaseDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentQuery | undefined, GetKnowledgeBaseDocumentQueryVariables>;
export function useGetKnowledgeBaseDocumentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>(GetKnowledgeBaseDocumentDocument, options);
        }
export type GetKnowledgeBaseDocumentQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentQuery>;
export type GetKnowledgeBaseDocumentLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentLazyQuery>;
export type GetKnowledgeBaseDocumentSuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentSuspenseQuery>;
export type GetKnowledgeBaseDocumentQueryResult = Apollo.QueryResult<GetKnowledgeBaseDocumentQuery, GetKnowledgeBaseDocumentQueryVariables>;
export const CreateKnowledgeBaseTextDocumentDocument = gql`
    mutation CreateKnowledgeBaseTextDocument($knowledgeBaseId: ID!, $input: CreateKnowledgeBaseTextDocumentInput!) {
  createKnowledgeBaseTextDocument(
    knowledgeBaseId: $knowledgeBaseId
    input: $input
  ) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type CreateKnowledgeBaseTextDocumentMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseTextDocumentMutation, CreateKnowledgeBaseTextDocumentMutationVariables>;

/**
 * __useCreateKnowledgeBaseTextDocumentMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseTextDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseTextDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseTextDocumentMutation, { data, loading, error }] = useCreateKnowledgeBaseTextDocumentMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKnowledgeBaseTextDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseTextDocumentMutation, CreateKnowledgeBaseTextDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseTextDocumentMutation, CreateKnowledgeBaseTextDocumentMutationVariables>(CreateKnowledgeBaseTextDocumentDocument, options);
      }
export type CreateKnowledgeBaseTextDocumentMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseTextDocumentMutation>;
export type CreateKnowledgeBaseTextDocumentMutationResult = Apollo.MutationResult<CreateKnowledgeBaseTextDocumentMutation>;
export type CreateKnowledgeBaseTextDocumentMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseTextDocumentMutation, CreateKnowledgeBaseTextDocumentMutationVariables>;
export const UploadKnowledgeBaseFileDocumentDocument = gql`
    mutation UploadKnowledgeBaseFileDocument($knowledgeBaseId: ID!, $input: UploadKnowledgeBaseFileDocumentInput!) {
  uploadKnowledgeBaseFileDocument(
    knowledgeBaseId: $knowledgeBaseId
    input: $input
  ) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type UploadKnowledgeBaseFileDocumentMutationFn = Apollo.MutationFunction<UploadKnowledgeBaseFileDocumentMutation, UploadKnowledgeBaseFileDocumentMutationVariables>;

/**
 * __useUploadKnowledgeBaseFileDocumentMutation__
 *
 * To run a mutation, you first call `useUploadKnowledgeBaseFileDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadKnowledgeBaseFileDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadKnowledgeBaseFileDocumentMutation, { data, loading, error }] = useUploadKnowledgeBaseFileDocumentMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUploadKnowledgeBaseFileDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UploadKnowledgeBaseFileDocumentMutation, UploadKnowledgeBaseFileDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadKnowledgeBaseFileDocumentMutation, UploadKnowledgeBaseFileDocumentMutationVariables>(UploadKnowledgeBaseFileDocumentDocument, options);
      }
export type UploadKnowledgeBaseFileDocumentMutationHookResult = ReturnType<typeof useUploadKnowledgeBaseFileDocumentMutation>;
export type UploadKnowledgeBaseFileDocumentMutationResult = Apollo.MutationResult<UploadKnowledgeBaseFileDocumentMutation>;
export type UploadKnowledgeBaseFileDocumentMutationOptions = Apollo.BaseMutationOptions<UploadKnowledgeBaseFileDocumentMutation, UploadKnowledgeBaseFileDocumentMutationVariables>;
export const UpdateKnowledgeBaseDocument = gql`
    mutation UpdateKnowledgeBase($id: ID!, $input: UpdateKnowledgeBaseInput!) {
  updateKnowledgeBase(id: $id, input: $input) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type UpdateKnowledgeBaseMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;

/**
 * __useUpdateKnowledgeBaseMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseMutation, { data, loading, error }] = useUpdateKnowledgeBaseMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>(UpdateKnowledgeBaseDocument, options);
      }
export type UpdateKnowledgeBaseMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseMutation>;
export type UpdateKnowledgeBaseMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseMutation, UpdateKnowledgeBaseMutationVariables>;
export const CreateKnowledgeBaseFolderDocument = gql`
    mutation CreateKnowledgeBaseFolder($knowledgeBaseId: ID!, $name: String!, $parentFolderId: String) {
  createKnowledgeBaseFolder(
    knowledgeBaseId: $knowledgeBaseId
    name: $name
    parentFolderId: $parentFolderId
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type CreateKnowledgeBaseFolderMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>;

/**
 * __useCreateKnowledgeBaseFolderMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseFolderMutation, { data, loading, error }] = useCreateKnowledgeBaseFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      name: // value for 'name'
 *      parentFolderId: // value for 'parentFolderId'
 *   },
 * });
 */
export function useCreateKnowledgeBaseFolderMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>(CreateKnowledgeBaseFolderDocument, options);
      }
export type CreateKnowledgeBaseFolderMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseFolderMutation>;
export type CreateKnowledgeBaseFolderMutationResult = Apollo.MutationResult<CreateKnowledgeBaseFolderMutation>;
export type CreateKnowledgeBaseFolderMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseFolderMutation, CreateKnowledgeBaseFolderMutationVariables>;
export const RenameKnowledgeBaseFolderDocument = gql`
    mutation RenameKnowledgeBaseFolder($knowledgeBaseId: ID!, $folderId: String!, $name: String!) {
  renameKnowledgeBaseFolder(
    knowledgeBaseId: $knowledgeBaseId
    folderId: $folderId
    name: $name
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type RenameKnowledgeBaseFolderMutationFn = Apollo.MutationFunction<RenameKnowledgeBaseFolderMutation, RenameKnowledgeBaseFolderMutationVariables>;

/**
 * __useRenameKnowledgeBaseFolderMutation__
 *
 * To run a mutation, you first call `useRenameKnowledgeBaseFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRenameKnowledgeBaseFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [renameKnowledgeBaseFolderMutation, { data, loading, error }] = useRenameKnowledgeBaseFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      folderId: // value for 'folderId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useRenameKnowledgeBaseFolderMutation(baseOptions?: Apollo.MutationHookOptions<RenameKnowledgeBaseFolderMutation, RenameKnowledgeBaseFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RenameKnowledgeBaseFolderMutation, RenameKnowledgeBaseFolderMutationVariables>(RenameKnowledgeBaseFolderDocument, options);
      }
export type RenameKnowledgeBaseFolderMutationHookResult = ReturnType<typeof useRenameKnowledgeBaseFolderMutation>;
export type RenameKnowledgeBaseFolderMutationResult = Apollo.MutationResult<RenameKnowledgeBaseFolderMutation>;
export type RenameKnowledgeBaseFolderMutationOptions = Apollo.BaseMutationOptions<RenameKnowledgeBaseFolderMutation, RenameKnowledgeBaseFolderMutationVariables>;
export const MoveKnowledgeBaseFolderDocument = gql`
    mutation MoveKnowledgeBaseFolder($knowledgeBaseId: ID!, $folderId: String!, $parentFolderId: String) {
  moveKnowledgeBaseFolder(
    knowledgeBaseId: $knowledgeBaseId
    folderId: $folderId
    parentFolderId: $parentFolderId
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type MoveKnowledgeBaseFolderMutationFn = Apollo.MutationFunction<MoveKnowledgeBaseFolderMutation, MoveKnowledgeBaseFolderMutationVariables>;

/**
 * __useMoveKnowledgeBaseFolderMutation__
 *
 * To run a mutation, you first call `useMoveKnowledgeBaseFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveKnowledgeBaseFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveKnowledgeBaseFolderMutation, { data, loading, error }] = useMoveKnowledgeBaseFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      folderId: // value for 'folderId'
 *      parentFolderId: // value for 'parentFolderId'
 *   },
 * });
 */
export function useMoveKnowledgeBaseFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveKnowledgeBaseFolderMutation, MoveKnowledgeBaseFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveKnowledgeBaseFolderMutation, MoveKnowledgeBaseFolderMutationVariables>(MoveKnowledgeBaseFolderDocument, options);
      }
export type MoveKnowledgeBaseFolderMutationHookResult = ReturnType<typeof useMoveKnowledgeBaseFolderMutation>;
export type MoveKnowledgeBaseFolderMutationResult = Apollo.MutationResult<MoveKnowledgeBaseFolderMutation>;
export type MoveKnowledgeBaseFolderMutationOptions = Apollo.BaseMutationOptions<MoveKnowledgeBaseFolderMutation, MoveKnowledgeBaseFolderMutationVariables>;
export const DeleteKnowledgeBaseFolderDocument = gql`
    mutation DeleteKnowledgeBaseFolder($knowledgeBaseId: ID!, $folderId: String!) {
  deleteKnowledgeBaseFolder(
    knowledgeBaseId: $knowledgeBaseId
    folderId: $folderId
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type DeleteKnowledgeBaseFolderMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseFolderMutation, DeleteKnowledgeBaseFolderMutationVariables>;

/**
 * __useDeleteKnowledgeBaseFolderMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseFolderMutation, { data, loading, error }] = useDeleteKnowledgeBaseFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseFolderMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseFolderMutation, DeleteKnowledgeBaseFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseFolderMutation, DeleteKnowledgeBaseFolderMutationVariables>(DeleteKnowledgeBaseFolderDocument, options);
      }
export type DeleteKnowledgeBaseFolderMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseFolderMutation>;
export type DeleteKnowledgeBaseFolderMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseFolderMutation>;
export type DeleteKnowledgeBaseFolderMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseFolderMutation, DeleteKnowledgeBaseFolderMutationVariables>;
export const DeleteKnowledgeBaseItemsDocument = gql`
    mutation DeleteKnowledgeBaseItems($knowledgeBaseId: ID!, $documentIds: [ID!]!, $folderIds: [String!]!) {
  deleteKnowledgeBaseItems(
    knowledgeBaseId: $knowledgeBaseId
    documentIds: $documentIds
    folderIds: $folderIds
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type DeleteKnowledgeBaseItemsMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseItemsMutation, DeleteKnowledgeBaseItemsMutationVariables>;

/**
 * __useDeleteKnowledgeBaseItemsMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseItemsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseItemsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseItemsMutation, { data, loading, error }] = useDeleteKnowledgeBaseItemsMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      documentIds: // value for 'documentIds'
 *      folderIds: // value for 'folderIds'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseItemsMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseItemsMutation, DeleteKnowledgeBaseItemsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseItemsMutation, DeleteKnowledgeBaseItemsMutationVariables>(DeleteKnowledgeBaseItemsDocument, options);
      }
export type DeleteKnowledgeBaseItemsMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseItemsMutation>;
export type DeleteKnowledgeBaseItemsMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseItemsMutation>;
export type DeleteKnowledgeBaseItemsMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseItemsMutation, DeleteKnowledgeBaseItemsMutationVariables>;
export const MoveKnowledgeBaseDocumentsToFolderDocument = gql`
    mutation MoveKnowledgeBaseDocumentsToFolder($documentIds: [ID!]!, $folderId: String) {
  moveKnowledgeBaseDocumentsToFolder(
    documentIds: $documentIds
    folderId: $folderId
  ) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type MoveKnowledgeBaseDocumentsToFolderMutationFn = Apollo.MutationFunction<MoveKnowledgeBaseDocumentsToFolderMutation, MoveKnowledgeBaseDocumentsToFolderMutationVariables>;

/**
 * __useMoveKnowledgeBaseDocumentsToFolderMutation__
 *
 * To run a mutation, you first call `useMoveKnowledgeBaseDocumentsToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveKnowledgeBaseDocumentsToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveKnowledgeBaseDocumentsToFolderMutation, { data, loading, error }] = useMoveKnowledgeBaseDocumentsToFolderMutation({
 *   variables: {
 *      documentIds: // value for 'documentIds'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useMoveKnowledgeBaseDocumentsToFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveKnowledgeBaseDocumentsToFolderMutation, MoveKnowledgeBaseDocumentsToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveKnowledgeBaseDocumentsToFolderMutation, MoveKnowledgeBaseDocumentsToFolderMutationVariables>(MoveKnowledgeBaseDocumentsToFolderDocument, options);
      }
export type MoveKnowledgeBaseDocumentsToFolderMutationHookResult = ReturnType<typeof useMoveKnowledgeBaseDocumentsToFolderMutation>;
export type MoveKnowledgeBaseDocumentsToFolderMutationResult = Apollo.MutationResult<MoveKnowledgeBaseDocumentsToFolderMutation>;
export type MoveKnowledgeBaseDocumentsToFolderMutationOptions = Apollo.BaseMutationOptions<MoveKnowledgeBaseDocumentsToFolderMutation, MoveKnowledgeBaseDocumentsToFolderMutationVariables>;
export const MoveKnowledgeBaseItemsToFolderDocument = gql`
    mutation MoveKnowledgeBaseItemsToFolder($knowledgeBaseId: ID!, $documentIds: [ID!]!, $folderIds: [String!]!, $folderId: String) {
  moveKnowledgeBaseItemsToFolder(
    knowledgeBaseId: $knowledgeBaseId
    documentIds: $documentIds
    folderIds: $folderIds
    folderId: $folderId
  ) {
    ...KnowledgeBaseDetailFields
  }
}
    ${KnowledgeBaseDetailFieldsFragmentDoc}`;
export type MoveKnowledgeBaseItemsToFolderMutationFn = Apollo.MutationFunction<MoveKnowledgeBaseItemsToFolderMutation, MoveKnowledgeBaseItemsToFolderMutationVariables>;

/**
 * __useMoveKnowledgeBaseItemsToFolderMutation__
 *
 * To run a mutation, you first call `useMoveKnowledgeBaseItemsToFolderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveKnowledgeBaseItemsToFolderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveKnowledgeBaseItemsToFolderMutation, { data, loading, error }] = useMoveKnowledgeBaseItemsToFolderMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      documentIds: // value for 'documentIds'
 *      folderIds: // value for 'folderIds'
 *      folderId: // value for 'folderId'
 *   },
 * });
 */
export function useMoveKnowledgeBaseItemsToFolderMutation(baseOptions?: Apollo.MutationHookOptions<MoveKnowledgeBaseItemsToFolderMutation, MoveKnowledgeBaseItemsToFolderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveKnowledgeBaseItemsToFolderMutation, MoveKnowledgeBaseItemsToFolderMutationVariables>(MoveKnowledgeBaseItemsToFolderDocument, options);
      }
export type MoveKnowledgeBaseItemsToFolderMutationHookResult = ReturnType<typeof useMoveKnowledgeBaseItemsToFolderMutation>;
export type MoveKnowledgeBaseItemsToFolderMutationResult = Apollo.MutationResult<MoveKnowledgeBaseItemsToFolderMutation>;
export type MoveKnowledgeBaseItemsToFolderMutationOptions = Apollo.BaseMutationOptions<MoveKnowledgeBaseItemsToFolderMutation, MoveKnowledgeBaseItemsToFolderMutationVariables>;
export const UpdateKnowledgeBaseDocumentDocument = gql`
    mutation UpdateKnowledgeBaseDocument($id: ID!, $input: UpdateKnowledgeBaseDocumentInput!) {
  updateKnowledgeBaseDocument(id: $id, input: $input) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type UpdateKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseDocumentMutation, UpdateKnowledgeBaseDocumentMutationVariables>;

/**
 * __useUpdateKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseDocumentMutation, { data, loading, error }] = useUpdateKnowledgeBaseDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseDocumentMutation, UpdateKnowledgeBaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseDocumentMutation, UpdateKnowledgeBaseDocumentMutationVariables>(UpdateKnowledgeBaseDocumentDocument, options);
      }
export type UpdateKnowledgeBaseDocumentMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseDocumentMutation>;
export type UpdateKnowledgeBaseDocumentMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseDocumentMutation>;
export type UpdateKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseDocumentMutation, UpdateKnowledgeBaseDocumentMutationVariables>;
export const DeleteKnowledgeBaseDocumentDocument = gql`
    mutation DeleteKnowledgeBaseDocument($id: ID!) {
  deleteKnowledgeBaseDocument(id: $id) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type DeleteKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>;

/**
 * __useDeleteKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useDeleteKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteKnowledgeBaseDocumentMutation, { data, loading, error }] = useDeleteKnowledgeBaseDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteKnowledgeBaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>(DeleteKnowledgeBaseDocumentDocument, options);
      }
export type DeleteKnowledgeBaseDocumentMutationHookResult = ReturnType<typeof useDeleteKnowledgeBaseDocumentMutation>;
export type DeleteKnowledgeBaseDocumentMutationResult = Apollo.MutationResult<DeleteKnowledgeBaseDocumentMutation>;
export type DeleteKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<DeleteKnowledgeBaseDocumentMutation, DeleteKnowledgeBaseDocumentMutationVariables>;
export const GetFederatedChildAgenciesDocument = gql`
    query GetFederatedChildAgencies {
  federatedChildAgencies {
    ...FederatedChildAgencyFields
  }
}
    ${FederatedChildAgencyFieldsFragmentDoc}`;

/**
 * __useGetFederatedChildAgenciesQuery__
 *
 * To run a query within a React component, call `useGetFederatedChildAgenciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFederatedChildAgenciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFederatedChildAgenciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFederatedChildAgenciesQuery(baseOptions?: Apollo.QueryHookOptions<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>(GetFederatedChildAgenciesDocument, options);
      }
export function useGetFederatedChildAgenciesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>(GetFederatedChildAgenciesDocument, options);
        }
// @ts-ignore
export function useGetFederatedChildAgenciesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>;
export function useGetFederatedChildAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>): Apollo.UseSuspenseQueryResult<GetFederatedChildAgenciesQuery | undefined, GetFederatedChildAgenciesQueryVariables>;
export function useGetFederatedChildAgenciesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>(GetFederatedChildAgenciesDocument, options);
        }
export type GetFederatedChildAgenciesQueryHookResult = ReturnType<typeof useGetFederatedChildAgenciesQuery>;
export type GetFederatedChildAgenciesLazyQueryHookResult = ReturnType<typeof useGetFederatedChildAgenciesLazyQuery>;
export type GetFederatedChildAgenciesSuspenseQueryHookResult = ReturnType<typeof useGetFederatedChildAgenciesSuspenseQuery>;
export type GetFederatedChildAgenciesQueryResult = Apollo.QueryResult<GetFederatedChildAgenciesQuery, GetFederatedChildAgenciesQueryVariables>;
export const GrantKnowledgeBaseAccessDocument = gql`
    mutation GrantKnowledgeBaseAccess($knowledgeBaseId: ID!, $agencyId: ID!, $role: KnowledgeBaseAccessRole!) {
  grantKnowledgeBaseAccess(
    knowledgeBaseId: $knowledgeBaseId
    agencyId: $agencyId
    role: $role
  ) {
    ...KnowledgeBaseAccessFields
  }
}
    ${KnowledgeBaseAccessFieldsFragmentDoc}`;
export type GrantKnowledgeBaseAccessMutationFn = Apollo.MutationFunction<GrantKnowledgeBaseAccessMutation, GrantKnowledgeBaseAccessMutationVariables>;

/**
 * __useGrantKnowledgeBaseAccessMutation__
 *
 * To run a mutation, you first call `useGrantKnowledgeBaseAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGrantKnowledgeBaseAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [grantKnowledgeBaseAccessMutation, { data, loading, error }] = useGrantKnowledgeBaseAccessMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      agencyId: // value for 'agencyId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useGrantKnowledgeBaseAccessMutation(baseOptions?: Apollo.MutationHookOptions<GrantKnowledgeBaseAccessMutation, GrantKnowledgeBaseAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GrantKnowledgeBaseAccessMutation, GrantKnowledgeBaseAccessMutationVariables>(GrantKnowledgeBaseAccessDocument, options);
      }
export type GrantKnowledgeBaseAccessMutationHookResult = ReturnType<typeof useGrantKnowledgeBaseAccessMutation>;
export type GrantKnowledgeBaseAccessMutationResult = Apollo.MutationResult<GrantKnowledgeBaseAccessMutation>;
export type GrantKnowledgeBaseAccessMutationOptions = Apollo.BaseMutationOptions<GrantKnowledgeBaseAccessMutation, GrantKnowledgeBaseAccessMutationVariables>;
export const UpdateKnowledgeBaseAccessDocument = gql`
    mutation UpdateKnowledgeBaseAccess($knowledgeBaseId: ID!, $agencyId: ID!, $role: KnowledgeBaseAccessRole!) {
  updateKnowledgeBaseAccess(
    knowledgeBaseId: $knowledgeBaseId
    agencyId: $agencyId
    role: $role
  ) {
    ...KnowledgeBaseAccessFields
  }
}
    ${KnowledgeBaseAccessFieldsFragmentDoc}`;
export type UpdateKnowledgeBaseAccessMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseAccessMutation, UpdateKnowledgeBaseAccessMutationVariables>;

/**
 * __useUpdateKnowledgeBaseAccessMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseAccessMutation, { data, loading, error }] = useUpdateKnowledgeBaseAccessMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      agencyId: // value for 'agencyId'
 *      role: // value for 'role'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseAccessMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseAccessMutation, UpdateKnowledgeBaseAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseAccessMutation, UpdateKnowledgeBaseAccessMutationVariables>(UpdateKnowledgeBaseAccessDocument, options);
      }
export type UpdateKnowledgeBaseAccessMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseAccessMutation>;
export type UpdateKnowledgeBaseAccessMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseAccessMutation>;
export type UpdateKnowledgeBaseAccessMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseAccessMutation, UpdateKnowledgeBaseAccessMutationVariables>;
export const RevokeKnowledgeBaseAccessDocument = gql`
    mutation RevokeKnowledgeBaseAccess($knowledgeBaseId: ID!, $agencyId: ID!) {
  revokeKnowledgeBaseAccess(
    knowledgeBaseId: $knowledgeBaseId
    agencyId: $agencyId
  )
}
    `;
export type RevokeKnowledgeBaseAccessMutationFn = Apollo.MutationFunction<RevokeKnowledgeBaseAccessMutation, RevokeKnowledgeBaseAccessMutationVariables>;

/**
 * __useRevokeKnowledgeBaseAccessMutation__
 *
 * To run a mutation, you first call `useRevokeKnowledgeBaseAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRevokeKnowledgeBaseAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [revokeKnowledgeBaseAccessMutation, { data, loading, error }] = useRevokeKnowledgeBaseAccessMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      agencyId: // value for 'agencyId'
 *   },
 * });
 */
export function useRevokeKnowledgeBaseAccessMutation(baseOptions?: Apollo.MutationHookOptions<RevokeKnowledgeBaseAccessMutation, RevokeKnowledgeBaseAccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RevokeKnowledgeBaseAccessMutation, RevokeKnowledgeBaseAccessMutationVariables>(RevokeKnowledgeBaseAccessDocument, options);
      }
export type RevokeKnowledgeBaseAccessMutationHookResult = ReturnType<typeof useRevokeKnowledgeBaseAccessMutation>;
export type RevokeKnowledgeBaseAccessMutationResult = Apollo.MutationResult<RevokeKnowledgeBaseAccessMutation>;
export type RevokeKnowledgeBaseAccessMutationOptions = Apollo.BaseMutationOptions<RevokeKnowledgeBaseAccessMutation, RevokeKnowledgeBaseAccessMutationVariables>;
export const GetKnowledgeBaseDocumentVersionHistoryDocument = gql`
    query GetKnowledgeBaseDocumentVersionHistory($id: ID!) {
  knowledgeBaseDocument(id: $id) {
    id
    versionHistory {
      ...KnowledgeBaseDocumentVersionFields
    }
  }
}
    ${KnowledgeBaseDocumentVersionFieldsFragmentDoc}`;

/**
 * __useGetKnowledgeBaseDocumentVersionHistoryQuery__
 *
 * To run a query within a React component, call `useGetKnowledgeBaseDocumentVersionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetKnowledgeBaseDocumentVersionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetKnowledgeBaseDocumentVersionHistoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetKnowledgeBaseDocumentVersionHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables> & ({ variables: GetKnowledgeBaseDocumentVersionHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>(GetKnowledgeBaseDocumentVersionHistoryDocument, options);
      }
export function useGetKnowledgeBaseDocumentVersionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>(GetKnowledgeBaseDocumentVersionHistoryDocument, options);
        }
// @ts-ignore
export function useGetKnowledgeBaseDocumentVersionHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>;
export function useGetKnowledgeBaseDocumentVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetKnowledgeBaseDocumentVersionHistoryQuery | undefined, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>;
export function useGetKnowledgeBaseDocumentVersionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>(GetKnowledgeBaseDocumentVersionHistoryDocument, options);
        }
export type GetKnowledgeBaseDocumentVersionHistoryQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentVersionHistoryQuery>;
export type GetKnowledgeBaseDocumentVersionHistoryLazyQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentVersionHistoryLazyQuery>;
export type GetKnowledgeBaseDocumentVersionHistorySuspenseQueryHookResult = ReturnType<typeof useGetKnowledgeBaseDocumentVersionHistorySuspenseQuery>;
export type GetKnowledgeBaseDocumentVersionHistoryQueryResult = Apollo.QueryResult<GetKnowledgeBaseDocumentVersionHistoryQuery, GetKnowledgeBaseDocumentVersionHistoryQueryVariables>;
export const ReplaceKnowledgeBaseDocumentDocument = gql`
    mutation ReplaceKnowledgeBaseDocument($documentId: ID!, $file: Upload!) {
  replaceKnowledgeBaseDocument(documentId: $documentId, file: $file) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type ReplaceKnowledgeBaseDocumentMutationFn = Apollo.MutationFunction<ReplaceKnowledgeBaseDocumentMutation, ReplaceKnowledgeBaseDocumentMutationVariables>;

/**
 * __useReplaceKnowledgeBaseDocumentMutation__
 *
 * To run a mutation, you first call `useReplaceKnowledgeBaseDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReplaceKnowledgeBaseDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [replaceKnowledgeBaseDocumentMutation, { data, loading, error }] = useReplaceKnowledgeBaseDocumentMutation({
 *   variables: {
 *      documentId: // value for 'documentId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useReplaceKnowledgeBaseDocumentMutation(baseOptions?: Apollo.MutationHookOptions<ReplaceKnowledgeBaseDocumentMutation, ReplaceKnowledgeBaseDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReplaceKnowledgeBaseDocumentMutation, ReplaceKnowledgeBaseDocumentMutationVariables>(ReplaceKnowledgeBaseDocumentDocument, options);
      }
export type ReplaceKnowledgeBaseDocumentMutationHookResult = ReturnType<typeof useReplaceKnowledgeBaseDocumentMutation>;
export type ReplaceKnowledgeBaseDocumentMutationResult = Apollo.MutationResult<ReplaceKnowledgeBaseDocumentMutation>;
export type ReplaceKnowledgeBaseDocumentMutationOptions = Apollo.BaseMutationOptions<ReplaceKnowledgeBaseDocumentMutation, ReplaceKnowledgeBaseDocumentMutationVariables>;
export const CreateKnowledgeBaseUrlDocumentDocument = gql`
    mutation CreateKnowledgeBaseURLDocument($knowledgeBaseId: ID!, $input: CreateKnowledgeBaseURLDocumentInput!) {
  createKnowledgeBaseURLDocument(knowledgeBaseId: $knowledgeBaseId, input: $input) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type CreateKnowledgeBaseUrlDocumentMutationFn = Apollo.MutationFunction<CreateKnowledgeBaseUrlDocumentMutation, CreateKnowledgeBaseUrlDocumentMutationVariables>;

/**
 * __useCreateKnowledgeBaseUrlDocumentMutation__
 *
 * To run a mutation, you first call `useCreateKnowledgeBaseUrlDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateKnowledgeBaseUrlDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createKnowledgeBaseUrlDocumentMutation, { data, loading, error }] = useCreateKnowledgeBaseUrlDocumentMutation({
 *   variables: {
 *      knowledgeBaseId: // value for 'knowledgeBaseId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateKnowledgeBaseUrlDocumentMutation(baseOptions?: Apollo.MutationHookOptions<CreateKnowledgeBaseUrlDocumentMutation, CreateKnowledgeBaseUrlDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateKnowledgeBaseUrlDocumentMutation, CreateKnowledgeBaseUrlDocumentMutationVariables>(CreateKnowledgeBaseUrlDocumentDocument, options);
      }
export type CreateKnowledgeBaseUrlDocumentMutationHookResult = ReturnType<typeof useCreateKnowledgeBaseUrlDocumentMutation>;
export type CreateKnowledgeBaseUrlDocumentMutationResult = Apollo.MutationResult<CreateKnowledgeBaseUrlDocumentMutation>;
export type CreateKnowledgeBaseUrlDocumentMutationOptions = Apollo.BaseMutationOptions<CreateKnowledgeBaseUrlDocumentMutation, CreateKnowledgeBaseUrlDocumentMutationVariables>;
export const UpdateKnowledgeBaseUrlDocumentDocument = gql`
    mutation UpdateKnowledgeBaseURLDocument($id: ID!, $input: UpdateKnowledgeBaseURLDocumentInput!) {
  updateKnowledgeBaseURLDocument(id: $id, input: $input) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type UpdateKnowledgeBaseUrlDocumentMutationFn = Apollo.MutationFunction<UpdateKnowledgeBaseUrlDocumentMutation, UpdateKnowledgeBaseUrlDocumentMutationVariables>;

/**
 * __useUpdateKnowledgeBaseUrlDocumentMutation__
 *
 * To run a mutation, you first call `useUpdateKnowledgeBaseUrlDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateKnowledgeBaseUrlDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateKnowledgeBaseUrlDocumentMutation, { data, loading, error }] = useUpdateKnowledgeBaseUrlDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateKnowledgeBaseUrlDocumentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateKnowledgeBaseUrlDocumentMutation, UpdateKnowledgeBaseUrlDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateKnowledgeBaseUrlDocumentMutation, UpdateKnowledgeBaseUrlDocumentMutationVariables>(UpdateKnowledgeBaseUrlDocumentDocument, options);
      }
export type UpdateKnowledgeBaseUrlDocumentMutationHookResult = ReturnType<typeof useUpdateKnowledgeBaseUrlDocumentMutation>;
export type UpdateKnowledgeBaseUrlDocumentMutationResult = Apollo.MutationResult<UpdateKnowledgeBaseUrlDocumentMutation>;
export type UpdateKnowledgeBaseUrlDocumentMutationOptions = Apollo.BaseMutationOptions<UpdateKnowledgeBaseUrlDocumentMutation, UpdateKnowledgeBaseUrlDocumentMutationVariables>;
export const SyncKnowledgeBaseUrlDocumentDocument = gql`
    mutation SyncKnowledgeBaseURLDocument($id: ID!) {
  syncKnowledgeBaseURLDocument(id: $id) {
    ...KnowledgeBaseDocumentDetailFields
  }
}
    ${KnowledgeBaseDocumentDetailFieldsFragmentDoc}`;
export type SyncKnowledgeBaseUrlDocumentMutationFn = Apollo.MutationFunction<SyncKnowledgeBaseUrlDocumentMutation, SyncKnowledgeBaseUrlDocumentMutationVariables>;

/**
 * __useSyncKnowledgeBaseUrlDocumentMutation__
 *
 * To run a mutation, you first call `useSyncKnowledgeBaseUrlDocumentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSyncKnowledgeBaseUrlDocumentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [syncKnowledgeBaseUrlDocumentMutation, { data, loading, error }] = useSyncKnowledgeBaseUrlDocumentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSyncKnowledgeBaseUrlDocumentMutation(baseOptions?: Apollo.MutationHookOptions<SyncKnowledgeBaseUrlDocumentMutation, SyncKnowledgeBaseUrlDocumentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SyncKnowledgeBaseUrlDocumentMutation, SyncKnowledgeBaseUrlDocumentMutationVariables>(SyncKnowledgeBaseUrlDocumentDocument, options);
      }
export type SyncKnowledgeBaseUrlDocumentMutationHookResult = ReturnType<typeof useSyncKnowledgeBaseUrlDocumentMutation>;
export type SyncKnowledgeBaseUrlDocumentMutationResult = Apollo.MutationResult<SyncKnowledgeBaseUrlDocumentMutation>;
export type SyncKnowledgeBaseUrlDocumentMutationOptions = Apollo.BaseMutationOptions<SyncKnowledgeBaseUrlDocumentMutation, SyncKnowledgeBaseUrlDocumentMutationVariables>;
export const MailboxEventsDocument = gql`
    query MailboxEvents($mailboxAccountId: String!, $limit: Int!, $includeMessages: Boolean!) {
  mailboxEvents(
    filter: {mailboxAccountId: $mailboxAccountId, notificationActivity: $includeMessages}
    limit: $limit
  ) {
    id
    type
    occurredAt
    initiatorType
    initiatorId
    mailboxAccountId
    mailboxDraftId
    workspaceArtifactId
    artifactVersion
    reason
    requestedByUserId
    notification {
      receiptId
      attemptId
      providerMessageId
      folderName
      changeType
      watchSignal
      outcome
      reason
    }
  }
  mailboxMessageActivity(mailboxAccountId: $mailboxAccountId, limit: $limit) @include(if: $includeMessages) {
    id
    mailboxAccountId
    providerMessageId
    folderName
    folderRole
    recordedAt
  }
}
    `;

/**
 * __useMailboxEventsQuery__
 *
 * To run a query within a React component, call `useMailboxEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxEventsQuery({
 *   variables: {
 *      mailboxAccountId: // value for 'mailboxAccountId'
 *      limit: // value for 'limit'
 *      includeMessages: // value for 'includeMessages'
 *   },
 * });
 */
export function useMailboxEventsQuery(baseOptions: Apollo.QueryHookOptions<MailboxEventsQuery, MailboxEventsQueryVariables> & ({ variables: MailboxEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxEventsQuery, MailboxEventsQueryVariables>(MailboxEventsDocument, options);
      }
export function useMailboxEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxEventsQuery, MailboxEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxEventsQuery, MailboxEventsQueryVariables>(MailboxEventsDocument, options);
        }
// @ts-ignore
export function useMailboxEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxEventsQuery, MailboxEventsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxEventsQuery, MailboxEventsQueryVariables>;
export function useMailboxEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxEventsQuery, MailboxEventsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxEventsQuery | undefined, MailboxEventsQueryVariables>;
export function useMailboxEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxEventsQuery, MailboxEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxEventsQuery, MailboxEventsQueryVariables>(MailboxEventsDocument, options);
        }
export type MailboxEventsQueryHookResult = ReturnType<typeof useMailboxEventsQuery>;
export type MailboxEventsLazyQueryHookResult = ReturnType<typeof useMailboxEventsLazyQuery>;
export type MailboxEventsSuspenseQueryHookResult = ReturnType<typeof useMailboxEventsSuspenseQuery>;
export type MailboxEventsQueryResult = Apollo.QueryResult<MailboxEventsQuery, MailboxEventsQueryVariables>;
export const MailboxAccountMonitoringDocument = gql`
    query MailboxAccountMonitoring {
  mailboxAccounts {
    ...MailboxMonitoringFields
  }
}
    ${MailboxMonitoringFieldsFragmentDoc}`;

/**
 * __useMailboxAccountMonitoringQuery__
 *
 * To run a query within a React component, call `useMailboxAccountMonitoringQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxAccountMonitoringQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxAccountMonitoringQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxAccountMonitoringQuery(baseOptions?: Apollo.QueryHookOptions<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>(MailboxAccountMonitoringDocument, options);
      }
export function useMailboxAccountMonitoringLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>(MailboxAccountMonitoringDocument, options);
        }
// @ts-ignore
export function useMailboxAccountMonitoringSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>;
export function useMailboxAccountMonitoringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountMonitoringQuery | undefined, MailboxAccountMonitoringQueryVariables>;
export function useMailboxAccountMonitoringSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>(MailboxAccountMonitoringDocument, options);
        }
export type MailboxAccountMonitoringQueryHookResult = ReturnType<typeof useMailboxAccountMonitoringQuery>;
export type MailboxAccountMonitoringLazyQueryHookResult = ReturnType<typeof useMailboxAccountMonitoringLazyQuery>;
export type MailboxAccountMonitoringSuspenseQueryHookResult = ReturnType<typeof useMailboxAccountMonitoringSuspenseQuery>;
export type MailboxAccountMonitoringQueryResult = Apollo.QueryResult<MailboxAccountMonitoringQuery, MailboxAccountMonitoringQueryVariables>;
export const MailboxSettingsAccessDocument = gql`
    query MailboxSettingsAccess {
  agencyUser {
    id
    frontendFlags
    permissions {
      scope
      resource
      action
    }
    agency {
      id
      entitlements
    }
  }
}
    `;

/**
 * __useMailboxSettingsAccessQuery__
 *
 * To run a query within a React component, call `useMailboxSettingsAccessQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxSettingsAccessQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxSettingsAccessQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxSettingsAccessQuery(baseOptions?: Apollo.QueryHookOptions<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>(MailboxSettingsAccessDocument, options);
      }
export function useMailboxSettingsAccessLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>(MailboxSettingsAccessDocument, options);
        }
// @ts-ignore
export function useMailboxSettingsAccessSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>;
export function useMailboxSettingsAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSettingsAccessQuery | undefined, MailboxSettingsAccessQueryVariables>;
export function useMailboxSettingsAccessSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>(MailboxSettingsAccessDocument, options);
        }
export type MailboxSettingsAccessQueryHookResult = ReturnType<typeof useMailboxSettingsAccessQuery>;
export type MailboxSettingsAccessLazyQueryHookResult = ReturnType<typeof useMailboxSettingsAccessLazyQuery>;
export type MailboxSettingsAccessSuspenseQueryHookResult = ReturnType<typeof useMailboxSettingsAccessSuspenseQuery>;
export type MailboxSettingsAccessQueryResult = Apollo.QueryResult<MailboxSettingsAccessQuery, MailboxSettingsAccessQueryVariables>;
export const MailboxOffboardingAccountsDocument = gql`
    query MailboxOffboardingAccounts {
  mailboxOffboardingAccounts {
    id
    emailAddress
  }
}
    `;

/**
 * __useMailboxOffboardingAccountsQuery__
 *
 * To run a query within a React component, call `useMailboxOffboardingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxOffboardingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxOffboardingAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxOffboardingAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>(MailboxOffboardingAccountsDocument, options);
      }
export function useMailboxOffboardingAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>(MailboxOffboardingAccountsDocument, options);
        }
// @ts-ignore
export function useMailboxOffboardingAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>;
export function useMailboxOffboardingAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxOffboardingAccountsQuery | undefined, MailboxOffboardingAccountsQueryVariables>;
export function useMailboxOffboardingAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>(MailboxOffboardingAccountsDocument, options);
        }
export type MailboxOffboardingAccountsQueryHookResult = ReturnType<typeof useMailboxOffboardingAccountsQuery>;
export type MailboxOffboardingAccountsLazyQueryHookResult = ReturnType<typeof useMailboxOffboardingAccountsLazyQuery>;
export type MailboxOffboardingAccountsSuspenseQueryHookResult = ReturnType<typeof useMailboxOffboardingAccountsSuspenseQuery>;
export type MailboxOffboardingAccountsQueryResult = Apollo.QueryResult<MailboxOffboardingAccountsQuery, MailboxOffboardingAccountsQueryVariables>;
export const MailboxAccountSharingDocument = gql`
    query MailboxAccountSharing {
  mailboxAccounts {
    ...MailboxSharingFields
  }
}
    ${MailboxSharingFieldsFragmentDoc}`;

/**
 * __useMailboxAccountSharingQuery__
 *
 * To run a query within a React component, call `useMailboxAccountSharingQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxAccountSharingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxAccountSharingQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxAccountSharingQuery(baseOptions?: Apollo.QueryHookOptions<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>(MailboxAccountSharingDocument, options);
      }
export function useMailboxAccountSharingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>(MailboxAccountSharingDocument, options);
        }
// @ts-ignore
export function useMailboxAccountSharingSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>;
export function useMailboxAccountSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountSharingQuery | undefined, MailboxAccountSharingQueryVariables>;
export function useMailboxAccountSharingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>(MailboxAccountSharingDocument, options);
        }
export type MailboxAccountSharingQueryHookResult = ReturnType<typeof useMailboxAccountSharingQuery>;
export type MailboxAccountSharingLazyQueryHookResult = ReturnType<typeof useMailboxAccountSharingLazyQuery>;
export type MailboxAccountSharingSuspenseQueryHookResult = ReturnType<typeof useMailboxAccountSharingSuspenseQuery>;
export type MailboxAccountSharingQueryResult = Apollo.QueryResult<MailboxAccountSharingQuery, MailboxAccountSharingQueryVariables>;
export const SetMailboxVisibilityDocument = gql`
    mutation SetMailboxVisibility($id: ID!, $visibility: VisibilityConfigInput!) {
  setMailboxVisibility(id: $id, visibility: $visibility) {
    ...MailboxSharingFields
  }
}
    ${MailboxSharingFieldsFragmentDoc}`;
export type SetMailboxVisibilityMutationFn = Apollo.MutationFunction<SetMailboxVisibilityMutation, SetMailboxVisibilityMutationVariables>;

/**
 * __useSetMailboxVisibilityMutation__
 *
 * To run a mutation, you first call `useSetMailboxVisibilityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetMailboxVisibilityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setMailboxVisibilityMutation, { data, loading, error }] = useSetMailboxVisibilityMutation({
 *   variables: {
 *      id: // value for 'id'
 *      visibility: // value for 'visibility'
 *   },
 * });
 */
export function useSetMailboxVisibilityMutation(baseOptions?: Apollo.MutationHookOptions<SetMailboxVisibilityMutation, SetMailboxVisibilityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetMailboxVisibilityMutation, SetMailboxVisibilityMutationVariables>(SetMailboxVisibilityDocument, options);
      }
export type SetMailboxVisibilityMutationHookResult = ReturnType<typeof useSetMailboxVisibilityMutation>;
export type SetMailboxVisibilityMutationResult = Apollo.MutationResult<SetMailboxVisibilityMutation>;
export type SetMailboxVisibilityMutationOptions = Apollo.BaseMutationOptions<SetMailboxVisibilityMutation, SetMailboxVisibilityMutationVariables>;
export const MailboxAccountsDocument = gql`
    query MailboxAccounts {
  mailboxAccounts {
    ...MailboxAccountFields
  }
}
    ${MailboxAccountFieldsFragmentDoc}`;

/**
 * __useMailboxAccountsQuery__
 *
 * To run a query within a React component, call `useMailboxAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxAccountsQuery(baseOptions?: Apollo.QueryHookOptions<MailboxAccountsQuery, MailboxAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxAccountsQuery, MailboxAccountsQueryVariables>(MailboxAccountsDocument, options);
      }
export function useMailboxAccountsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxAccountsQuery, MailboxAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxAccountsQuery, MailboxAccountsQueryVariables>(MailboxAccountsDocument, options);
        }
// @ts-ignore
export function useMailboxAccountsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxAccountsQuery, MailboxAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountsQuery, MailboxAccountsQueryVariables>;
export function useMailboxAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountsQuery, MailboxAccountsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxAccountsQuery | undefined, MailboxAccountsQueryVariables>;
export function useMailboxAccountsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxAccountsQuery, MailboxAccountsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxAccountsQuery, MailboxAccountsQueryVariables>(MailboxAccountsDocument, options);
        }
export type MailboxAccountsQueryHookResult = ReturnType<typeof useMailboxAccountsQuery>;
export type MailboxAccountsLazyQueryHookResult = ReturnType<typeof useMailboxAccountsLazyQuery>;
export type MailboxAccountsSuspenseQueryHookResult = ReturnType<typeof useMailboxAccountsSuspenseQuery>;
export type MailboxAccountsQueryResult = Apollo.QueryResult<MailboxAccountsQuery, MailboxAccountsQueryVariables>;
export const MailboxComposeLimitsDocument = gql`
    query MailboxComposeLimits {
  mailboxComposeLimits {
    bodyBytes
    attachmentBytes
  }
}
    `;

/**
 * __useMailboxComposeLimitsQuery__
 *
 * To run a query within a React component, call `useMailboxComposeLimitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxComposeLimitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxComposeLimitsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxComposeLimitsQuery(baseOptions?: Apollo.QueryHookOptions<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>(MailboxComposeLimitsDocument, options);
      }
export function useMailboxComposeLimitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>(MailboxComposeLimitsDocument, options);
        }
// @ts-ignore
export function useMailboxComposeLimitsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>;
export function useMailboxComposeLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxComposeLimitsQuery | undefined, MailboxComposeLimitsQueryVariables>;
export function useMailboxComposeLimitsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>(MailboxComposeLimitsDocument, options);
        }
export type MailboxComposeLimitsQueryHookResult = ReturnType<typeof useMailboxComposeLimitsQuery>;
export type MailboxComposeLimitsLazyQueryHookResult = ReturnType<typeof useMailboxComposeLimitsLazyQuery>;
export type MailboxComposeLimitsSuspenseQueryHookResult = ReturnType<typeof useMailboxComposeLimitsSuspenseQuery>;
export type MailboxComposeLimitsQueryResult = Apollo.QueryResult<MailboxComposeLimitsQuery, MailboxComposeLimitsQueryVariables>;
export const MailboxSignaturesDocument = gql`
    query MailboxSignatures {
  mailboxSignatures {
    ...MailboxSignatureFields
  }
}
    ${MailboxSignatureFieldsFragmentDoc}`;

/**
 * __useMailboxSignaturesQuery__
 *
 * To run a query within a React component, call `useMailboxSignaturesQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxSignaturesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxSignaturesQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxSignaturesQuery(baseOptions?: Apollo.QueryHookOptions<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>(MailboxSignaturesDocument, options);
      }
export function useMailboxSignaturesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>(MailboxSignaturesDocument, options);
        }
// @ts-ignore
export function useMailboxSignaturesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>;
export function useMailboxSignaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSignaturesQuery | undefined, MailboxSignaturesQueryVariables>;
export function useMailboxSignaturesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>(MailboxSignaturesDocument, options);
        }
export type MailboxSignaturesQueryHookResult = ReturnType<typeof useMailboxSignaturesQuery>;
export type MailboxSignaturesLazyQueryHookResult = ReturnType<typeof useMailboxSignaturesLazyQuery>;
export type MailboxSignaturesSuspenseQueryHookResult = ReturnType<typeof useMailboxSignaturesSuspenseQuery>;
export type MailboxSignaturesQueryResult = Apollo.QueryResult<MailboxSignaturesQuery, MailboxSignaturesQueryVariables>;
export const ScheduleMailboxEmailDocument = gql`
    mutation ScheduleMailboxEmail($input: ScheduleMailboxEmailInput!) {
  scheduleMailboxEmail(input: $input) {
    contentRevision
    email {
      id
      status
      sentAt
      sendAfter
      scheduledFor
      sentByUserId
      sentBy {
        id
        name
      }
      cancellationRemainingMs
      failureReason
    }
  }
}
    `;
export type ScheduleMailboxEmailMutationFn = Apollo.MutationFunction<ScheduleMailboxEmailMutation, ScheduleMailboxEmailMutationVariables>;

/**
 * __useScheduleMailboxEmailMutation__
 *
 * To run a mutation, you first call `useScheduleMailboxEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useScheduleMailboxEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [scheduleMailboxEmailMutation, { data, loading, error }] = useScheduleMailboxEmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useScheduleMailboxEmailMutation(baseOptions?: Apollo.MutationHookOptions<ScheduleMailboxEmailMutation, ScheduleMailboxEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ScheduleMailboxEmailMutation, ScheduleMailboxEmailMutationVariables>(ScheduleMailboxEmailDocument, options);
      }
export type ScheduleMailboxEmailMutationHookResult = ReturnType<typeof useScheduleMailboxEmailMutation>;
export type ScheduleMailboxEmailMutationResult = Apollo.MutationResult<ScheduleMailboxEmailMutation>;
export type ScheduleMailboxEmailMutationOptions = Apollo.BaseMutationOptions<ScheduleMailboxEmailMutation, ScheduleMailboxEmailMutationVariables>;
export const CancelMailboxEmailPreparationDocument = gql`
    mutation CancelMailboxEmailPreparation($artifactId: String!, $artifactVersion: Int!, $attemptId: String!) {
  cancelMailboxEmailPreparation(
    artifactId: $artifactId
    artifactVersion: $artifactVersion
    attemptId: $attemptId
  )
}
    `;
export type CancelMailboxEmailPreparationMutationFn = Apollo.MutationFunction<CancelMailboxEmailPreparationMutation, CancelMailboxEmailPreparationMutationVariables>;

/**
 * __useCancelMailboxEmailPreparationMutation__
 *
 * To run a mutation, you first call `useCancelMailboxEmailPreparationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMailboxEmailPreparationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMailboxEmailPreparationMutation, { data, loading, error }] = useCancelMailboxEmailPreparationMutation({
 *   variables: {
 *      artifactId: // value for 'artifactId'
 *      artifactVersion: // value for 'artifactVersion'
 *      attemptId: // value for 'attemptId'
 *   },
 * });
 */
export function useCancelMailboxEmailPreparationMutation(baseOptions?: Apollo.MutationHookOptions<CancelMailboxEmailPreparationMutation, CancelMailboxEmailPreparationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMailboxEmailPreparationMutation, CancelMailboxEmailPreparationMutationVariables>(CancelMailboxEmailPreparationDocument, options);
      }
export type CancelMailboxEmailPreparationMutationHookResult = ReturnType<typeof useCancelMailboxEmailPreparationMutation>;
export type CancelMailboxEmailPreparationMutationResult = Apollo.MutationResult<CancelMailboxEmailPreparationMutation>;
export type CancelMailboxEmailPreparationMutationOptions = Apollo.BaseMutationOptions<CancelMailboxEmailPreparationMutation, CancelMailboxEmailPreparationMutationVariables>;
export const CancelMailboxEmailDocument = gql`
    mutation CancelMailboxEmail($id: ID!) {
  cancelMailboxEmail(id: $id) {
    id
    status
    sentAt
    sendAfter
    scheduledFor
    sentByUserId
    sentBy {
      id
      name
    }
    cancellationRemainingMs
    failureReason
  }
}
    `;
export type CancelMailboxEmailMutationFn = Apollo.MutationFunction<CancelMailboxEmailMutation, CancelMailboxEmailMutationVariables>;

/**
 * __useCancelMailboxEmailMutation__
 *
 * To run a mutation, you first call `useCancelMailboxEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelMailboxEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelMailboxEmailMutation, { data, loading, error }] = useCancelMailboxEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelMailboxEmailMutation(baseOptions?: Apollo.MutationHookOptions<CancelMailboxEmailMutation, CancelMailboxEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelMailboxEmailMutation, CancelMailboxEmailMutationVariables>(CancelMailboxEmailDocument, options);
      }
export type CancelMailboxEmailMutationHookResult = ReturnType<typeof useCancelMailboxEmailMutation>;
export type CancelMailboxEmailMutationResult = Apollo.MutationResult<CancelMailboxEmailMutation>;
export type CancelMailboxEmailMutationOptions = Apollo.BaseMutationOptions<CancelMailboxEmailMutation, CancelMailboxEmailMutationVariables>;
export const RescheduleMailboxEmailDocument = gql`
    mutation RescheduleMailboxEmail($id: ID!, $input: RescheduleMailboxEmailInput!) {
  rescheduleMailboxEmail(id: $id, input: $input) {
    id
    status
    sentAt
    sendAfter
    scheduledFor
    sentByUserId
    sentBy {
      id
      name
    }
    cancellationRemainingMs
    failureReason
  }
}
    `;
export type RescheduleMailboxEmailMutationFn = Apollo.MutationFunction<RescheduleMailboxEmailMutation, RescheduleMailboxEmailMutationVariables>;

/**
 * __useRescheduleMailboxEmailMutation__
 *
 * To run a mutation, you first call `useRescheduleMailboxEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRescheduleMailboxEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rescheduleMailboxEmailMutation, { data, loading, error }] = useRescheduleMailboxEmailMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRescheduleMailboxEmailMutation(baseOptions?: Apollo.MutationHookOptions<RescheduleMailboxEmailMutation, RescheduleMailboxEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RescheduleMailboxEmailMutation, RescheduleMailboxEmailMutationVariables>(RescheduleMailboxEmailDocument, options);
      }
export type RescheduleMailboxEmailMutationHookResult = ReturnType<typeof useRescheduleMailboxEmailMutation>;
export type RescheduleMailboxEmailMutationResult = Apollo.MutationResult<RescheduleMailboxEmailMutation>;
export type RescheduleMailboxEmailMutationOptions = Apollo.BaseMutationOptions<RescheduleMailboxEmailMutation, RescheduleMailboxEmailMutationVariables>;
export const SearchRecipientsDocument = gql`
    query SearchRecipients($query: String!, $limit: Int) {
  searchRecipients(query: $query, limit: $limit) {
    email
    name
    description
  }
}
    `;

/**
 * __useSearchRecipientsQuery__
 *
 * To run a query within a React component, call `useSearchRecipientsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchRecipientsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchRecipientsQuery({
 *   variables: {
 *      query: // value for 'query'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useSearchRecipientsQuery(baseOptions: Apollo.QueryHookOptions<SearchRecipientsQuery, SearchRecipientsQueryVariables> & ({ variables: SearchRecipientsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchRecipientsQuery, SearchRecipientsQueryVariables>(SearchRecipientsDocument, options);
      }
export function useSearchRecipientsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchRecipientsQuery, SearchRecipientsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchRecipientsQuery, SearchRecipientsQueryVariables>(SearchRecipientsDocument, options);
        }
// @ts-ignore
export function useSearchRecipientsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchRecipientsQuery, SearchRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchRecipientsQuery, SearchRecipientsQueryVariables>;
export function useSearchRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchRecipientsQuery, SearchRecipientsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchRecipientsQuery | undefined, SearchRecipientsQueryVariables>;
export function useSearchRecipientsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchRecipientsQuery, SearchRecipientsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchRecipientsQuery, SearchRecipientsQueryVariables>(SearchRecipientsDocument, options);
        }
export type SearchRecipientsQueryHookResult = ReturnType<typeof useSearchRecipientsQuery>;
export type SearchRecipientsLazyQueryHookResult = ReturnType<typeof useSearchRecipientsLazyQuery>;
export type SearchRecipientsSuspenseQueryHookResult = ReturnType<typeof useSearchRecipientsSuspenseQuery>;
export type SearchRecipientsQueryResult = Apollo.QueryResult<SearchRecipientsQuery, SearchRecipientsQueryVariables>;
export const SearchOutboundEmailsDocument = gql`
    query SearchOutboundEmails($first: Int, $after: String, $filter: OutboundEmailsFilterInput, $sort: OutboundEmailSortInput) {
  searchOutboundEmails(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...OutboundEmailFields
        cancellationRemainingMs
        amsLog {
          ...OutboundEmailAmsLogFields
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${OutboundEmailFieldsFragmentDoc}
${OutboundEmailAmsLogFieldsFragmentDoc}`;

/**
 * __useSearchOutboundEmailsQuery__
 *
 * To run a query within a React component, call `useSearchOutboundEmailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutboundEmailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutboundEmailsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchOutboundEmailsQuery(baseOptions?: Apollo.QueryHookOptions<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>(SearchOutboundEmailsDocument, options);
      }
export function useSearchOutboundEmailsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>(SearchOutboundEmailsDocument, options);
        }
// @ts-ignore
export function useSearchOutboundEmailsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>;
export function useSearchOutboundEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboundEmailsQuery | undefined, SearchOutboundEmailsQueryVariables>;
export function useSearchOutboundEmailsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>(SearchOutboundEmailsDocument, options);
        }
export type SearchOutboundEmailsQueryHookResult = ReturnType<typeof useSearchOutboundEmailsQuery>;
export type SearchOutboundEmailsLazyQueryHookResult = ReturnType<typeof useSearchOutboundEmailsLazyQuery>;
export type SearchOutboundEmailsSuspenseQueryHookResult = ReturnType<typeof useSearchOutboundEmailsSuspenseQuery>;
export type SearchOutboundEmailsQueryResult = Apollo.QueryResult<SearchOutboundEmailsQuery, SearchOutboundEmailsQueryVariables>;
export const CreateMailboxDraftDocument = gql`
    mutation CreateMailboxDraft($mailboxAccountId: String!, $artifactId: String!, $artifactVersion: Int!, $contentRevision: String) {
  createMailboxDraft(
    mailboxAccountId: $mailboxAccountId
    artifactId: $artifactId
    artifactVersion: $artifactVersion
    contentRevision: $contentRevision
  ) {
    ...MailboxDraftFields
  }
}
    ${MailboxDraftFieldsFragmentDoc}`;
export type CreateMailboxDraftMutationFn = Apollo.MutationFunction<CreateMailboxDraftMutation, CreateMailboxDraftMutationVariables>;

/**
 * __useCreateMailboxDraftMutation__
 *
 * To run a mutation, you first call `useCreateMailboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateMailboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createMailboxDraftMutation, { data, loading, error }] = useCreateMailboxDraftMutation({
 *   variables: {
 *      mailboxAccountId: // value for 'mailboxAccountId'
 *      artifactId: // value for 'artifactId'
 *      artifactVersion: // value for 'artifactVersion'
 *      contentRevision: // value for 'contentRevision'
 *   },
 * });
 */
export function useCreateMailboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<CreateMailboxDraftMutation, CreateMailboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateMailboxDraftMutation, CreateMailboxDraftMutationVariables>(CreateMailboxDraftDocument, options);
      }
export type CreateMailboxDraftMutationHookResult = ReturnType<typeof useCreateMailboxDraftMutation>;
export type CreateMailboxDraftMutationResult = Apollo.MutationResult<CreateMailboxDraftMutation>;
export type CreateMailboxDraftMutationOptions = Apollo.BaseMutationOptions<CreateMailboxDraftMutation, CreateMailboxDraftMutationVariables>;
export const SearchMailboxDraftsDocument = gql`
    query SearchMailboxDrafts($first: Int, $after: String, $filter: MailboxDraftsFilterInput) {
  searchMailboxDrafts(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        ...MailboxDraftFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${MailboxDraftFieldsFragmentDoc}`;

/**
 * __useSearchMailboxDraftsQuery__
 *
 * To run a query within a React component, call `useSearchMailboxDraftsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMailboxDraftsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMailboxDraftsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchMailboxDraftsQuery(baseOptions?: Apollo.QueryHookOptions<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>(SearchMailboxDraftsDocument, options);
      }
export function useSearchMailboxDraftsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>(SearchMailboxDraftsDocument, options);
        }
// @ts-ignore
export function useSearchMailboxDraftsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>;
export function useSearchMailboxDraftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMailboxDraftsQuery | undefined, SearchMailboxDraftsQueryVariables>;
export function useSearchMailboxDraftsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>(SearchMailboxDraftsDocument, options);
        }
export type SearchMailboxDraftsQueryHookResult = ReturnType<typeof useSearchMailboxDraftsQuery>;
export type SearchMailboxDraftsLazyQueryHookResult = ReturnType<typeof useSearchMailboxDraftsLazyQuery>;
export type SearchMailboxDraftsSuspenseQueryHookResult = ReturnType<typeof useSearchMailboxDraftsSuspenseQuery>;
export type SearchMailboxDraftsQueryResult = Apollo.QueryResult<SearchMailboxDraftsQuery, SearchMailboxDraftsQueryVariables>;
export const SwitchMailboxDraftDocument = gql`
    mutation SwitchMailboxDraft($input: SwitchMailboxDraftInput!) {
  switchMailboxDraft(input: $input) {
    artifact {
      ...CaraWorkspaceArtifactFields
    }
    mailboxDraft {
      ...MailboxDraftFields
    }
    draftError
  }
}
    ${CaraWorkspaceArtifactFieldsFragmentDoc}
${MailboxDraftFieldsFragmentDoc}`;
export type SwitchMailboxDraftMutationFn = Apollo.MutationFunction<SwitchMailboxDraftMutation, SwitchMailboxDraftMutationVariables>;

/**
 * __useSwitchMailboxDraftMutation__
 *
 * To run a mutation, you first call `useSwitchMailboxDraftMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitchMailboxDraftMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switchMailboxDraftMutation, { data, loading, error }] = useSwitchMailboxDraftMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSwitchMailboxDraftMutation(baseOptions?: Apollo.MutationHookOptions<SwitchMailboxDraftMutation, SwitchMailboxDraftMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitchMailboxDraftMutation, SwitchMailboxDraftMutationVariables>(SwitchMailboxDraftDocument, options);
      }
export type SwitchMailboxDraftMutationHookResult = ReturnType<typeof useSwitchMailboxDraftMutation>;
export type SwitchMailboxDraftMutationResult = Apollo.MutationResult<SwitchMailboxDraftMutation>;
export type SwitchMailboxDraftMutationOptions = Apollo.BaseMutationOptions<SwitchMailboxDraftMutation, SwitchMailboxDraftMutationVariables>;
export const UploadEmailAttachmentDocument = gql`
    mutation UploadEmailAttachment($workspaceId: ID!, $file: UploadFileInput!) {
  uploadWorkspaceFile(workspaceId: $workspaceId, file: $file) {
    id
    name
    size
  }
}
    `;
export type UploadEmailAttachmentMutationFn = Apollo.MutationFunction<UploadEmailAttachmentMutation, UploadEmailAttachmentMutationVariables>;

/**
 * __useUploadEmailAttachmentMutation__
 *
 * To run a mutation, you first call `useUploadEmailAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUploadEmailAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [uploadEmailAttachmentMutation, { data, loading, error }] = useUploadEmailAttachmentMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      file: // value for 'file'
 *   },
 * });
 */
export function useUploadEmailAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<UploadEmailAttachmentMutation, UploadEmailAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UploadEmailAttachmentMutation, UploadEmailAttachmentMutationVariables>(UploadEmailAttachmentDocument, options);
      }
export type UploadEmailAttachmentMutationHookResult = ReturnType<typeof useUploadEmailAttachmentMutation>;
export type UploadEmailAttachmentMutationResult = Apollo.MutationResult<UploadEmailAttachmentMutation>;
export type UploadEmailAttachmentMutationOptions = Apollo.BaseMutationOptions<UploadEmailAttachmentMutation, UploadEmailAttachmentMutationVariables>;
export const ReconcileMailboxDraftsDocument = gql`
    mutation ReconcileMailboxDrafts($mailboxDraftIds: [ID!]!) {
  reconcileMailboxDrafts(mailboxDraftIds: $mailboxDraftIds) {
    mailboxDraftId
    reconciliation
    draft {
      ...MailboxDraftFields
    }
  }
}
    ${MailboxDraftFieldsFragmentDoc}`;
export type ReconcileMailboxDraftsMutationFn = Apollo.MutationFunction<ReconcileMailboxDraftsMutation, ReconcileMailboxDraftsMutationVariables>;

/**
 * __useReconcileMailboxDraftsMutation__
 *
 * To run a mutation, you first call `useReconcileMailboxDraftsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReconcileMailboxDraftsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reconcileMailboxDraftsMutation, { data, loading, error }] = useReconcileMailboxDraftsMutation({
 *   variables: {
 *      mailboxDraftIds: // value for 'mailboxDraftIds'
 *   },
 * });
 */
export function useReconcileMailboxDraftsMutation(baseOptions?: Apollo.MutationHookOptions<ReconcileMailboxDraftsMutation, ReconcileMailboxDraftsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReconcileMailboxDraftsMutation, ReconcileMailboxDraftsMutationVariables>(ReconcileMailboxDraftsDocument, options);
      }
export type ReconcileMailboxDraftsMutationHookResult = ReturnType<typeof useReconcileMailboxDraftsMutation>;
export type ReconcileMailboxDraftsMutationResult = Apollo.MutationResult<ReconcileMailboxDraftsMutation>;
export type ReconcileMailboxDraftsMutationOptions = Apollo.BaseMutationOptions<ReconcileMailboxDraftsMutation, ReconcileMailboxDraftsMutationVariables>;
export const MailboxProvidersDocument = gql`
    query MailboxProviders {
  mailboxProviders
}
    `;

/**
 * __useMailboxProvidersQuery__
 *
 * To run a query within a React component, call `useMailboxProvidersQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxProvidersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxProvidersQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxProvidersQuery(baseOptions?: Apollo.QueryHookOptions<MailboxProvidersQuery, MailboxProvidersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxProvidersQuery, MailboxProvidersQueryVariables>(MailboxProvidersDocument, options);
      }
export function useMailboxProvidersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxProvidersQuery, MailboxProvidersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxProvidersQuery, MailboxProvidersQueryVariables>(MailboxProvidersDocument, options);
        }
// @ts-ignore
export function useMailboxProvidersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxProvidersQuery, MailboxProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxProvidersQuery, MailboxProvidersQueryVariables>;
export function useMailboxProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxProvidersQuery, MailboxProvidersQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxProvidersQuery | undefined, MailboxProvidersQueryVariables>;
export function useMailboxProvidersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxProvidersQuery, MailboxProvidersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxProvidersQuery, MailboxProvidersQueryVariables>(MailboxProvidersDocument, options);
        }
export type MailboxProvidersQueryHookResult = ReturnType<typeof useMailboxProvidersQuery>;
export type MailboxProvidersLazyQueryHookResult = ReturnType<typeof useMailboxProvidersLazyQuery>;
export type MailboxProvidersSuspenseQueryHookResult = ReturnType<typeof useMailboxProvidersSuspenseQuery>;
export type MailboxProvidersQueryResult = Apollo.QueryResult<MailboxProvidersQuery, MailboxProvidersQueryVariables>;
export const DisconnectMailboxDocument = gql`
    mutation DisconnectMailbox($id: ID!) {
  disconnectMailbox(id: $id)
}
    `;
export type DisconnectMailboxMutationFn = Apollo.MutationFunction<DisconnectMailboxMutation, DisconnectMailboxMutationVariables>;

/**
 * __useDisconnectMailboxMutation__
 *
 * To run a mutation, you first call `useDisconnectMailboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDisconnectMailboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [disconnectMailboxMutation, { data, loading, error }] = useDisconnectMailboxMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDisconnectMailboxMutation(baseOptions?: Apollo.MutationHookOptions<DisconnectMailboxMutation, DisconnectMailboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DisconnectMailboxMutation, DisconnectMailboxMutationVariables>(DisconnectMailboxDocument, options);
      }
export type DisconnectMailboxMutationHookResult = ReturnType<typeof useDisconnectMailboxMutation>;
export type DisconnectMailboxMutationResult = Apollo.MutationResult<DisconnectMailboxMutation>;
export type DisconnectMailboxMutationOptions = Apollo.BaseMutationOptions<DisconnectMailboxMutation, DisconnectMailboxMutationVariables>;
export const SetDefaultMailboxDocument = gql`
    mutation SetDefaultMailbox($id: ID!) {
  setDefaultMailbox(id: $id) {
    ...MailboxAccountFields
  }
}
    ${MailboxAccountFieldsFragmentDoc}`;
export type SetDefaultMailboxMutationFn = Apollo.MutationFunction<SetDefaultMailboxMutation, SetDefaultMailboxMutationVariables>;

/**
 * __useSetDefaultMailboxMutation__
 *
 * To run a mutation, you first call `useSetDefaultMailboxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetDefaultMailboxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setDefaultMailboxMutation, { data, loading, error }] = useSetDefaultMailboxMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSetDefaultMailboxMutation(baseOptions?: Apollo.MutationHookOptions<SetDefaultMailboxMutation, SetDefaultMailboxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SetDefaultMailboxMutation, SetDefaultMailboxMutationVariables>(SetDefaultMailboxDocument, options);
      }
export type SetDefaultMailboxMutationHookResult = ReturnType<typeof useSetDefaultMailboxMutation>;
export type SetDefaultMailboxMutationResult = Apollo.MutationResult<SetDefaultMailboxMutation>;
export type SetDefaultMailboxMutationOptions = Apollo.BaseMutationOptions<SetDefaultMailboxMutation, SetDefaultMailboxMutationVariables>;
export const MailboxSignaturesForSettingsDocument = gql`
    query MailboxSignaturesForSettings {
  mailboxSignatures {
    ...MailboxSignatureSettingsFields
  }
}
    ${MailboxSignatureSettingsFieldsFragmentDoc}`;

/**
 * __useMailboxSignaturesForSettingsQuery__
 *
 * To run a query within a React component, call `useMailboxSignaturesForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useMailboxSignaturesForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMailboxSignaturesForSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useMailboxSignaturesForSettingsQuery(baseOptions?: Apollo.QueryHookOptions<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>(MailboxSignaturesForSettingsDocument, options);
      }
export function useMailboxSignaturesForSettingsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>(MailboxSignaturesForSettingsDocument, options);
        }
// @ts-ignore
export function useMailboxSignaturesForSettingsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>;
export function useMailboxSignaturesForSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>): Apollo.UseSuspenseQueryResult<MailboxSignaturesForSettingsQuery | undefined, MailboxSignaturesForSettingsQueryVariables>;
export function useMailboxSignaturesForSettingsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>(MailboxSignaturesForSettingsDocument, options);
        }
export type MailboxSignaturesForSettingsQueryHookResult = ReturnType<typeof useMailboxSignaturesForSettingsQuery>;
export type MailboxSignaturesForSettingsLazyQueryHookResult = ReturnType<typeof useMailboxSignaturesForSettingsLazyQuery>;
export type MailboxSignaturesForSettingsSuspenseQueryHookResult = ReturnType<typeof useMailboxSignaturesForSettingsSuspenseQuery>;
export type MailboxSignaturesForSettingsQueryResult = Apollo.QueryResult<MailboxSignaturesForSettingsQuery, MailboxSignaturesForSettingsQueryVariables>;
export const UpsertMailboxSignatureDocument = gql`
    mutation UpsertMailboxSignature($input: MailboxSignatureInput!) {
  upsertMailboxSignature(input: $input) {
    ...MailboxSignatureSettingsFields
  }
}
    ${MailboxSignatureSettingsFieldsFragmentDoc}`;
export type UpsertMailboxSignatureMutationFn = Apollo.MutationFunction<UpsertMailboxSignatureMutation, UpsertMailboxSignatureMutationVariables>;

/**
 * __useUpsertMailboxSignatureMutation__
 *
 * To run a mutation, you first call `useUpsertMailboxSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertMailboxSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertMailboxSignatureMutation, { data, loading, error }] = useUpsertMailboxSignatureMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpsertMailboxSignatureMutation(baseOptions?: Apollo.MutationHookOptions<UpsertMailboxSignatureMutation, UpsertMailboxSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpsertMailboxSignatureMutation, UpsertMailboxSignatureMutationVariables>(UpsertMailboxSignatureDocument, options);
      }
export type UpsertMailboxSignatureMutationHookResult = ReturnType<typeof useUpsertMailboxSignatureMutation>;
export type UpsertMailboxSignatureMutationResult = Apollo.MutationResult<UpsertMailboxSignatureMutation>;
export type UpsertMailboxSignatureMutationOptions = Apollo.BaseMutationOptions<UpsertMailboxSignatureMutation, UpsertMailboxSignatureMutationVariables>;
export const DeleteMailboxSignatureDocument = gql`
    mutation DeleteMailboxSignature($id: ID!) {
  deleteMailboxSignature(id: $id)
}
    `;
export type DeleteMailboxSignatureMutationFn = Apollo.MutationFunction<DeleteMailboxSignatureMutation, DeleteMailboxSignatureMutationVariables>;

/**
 * __useDeleteMailboxSignatureMutation__
 *
 * To run a mutation, you first call `useDeleteMailboxSignatureMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMailboxSignatureMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMailboxSignatureMutation, { data, loading, error }] = useDeleteMailboxSignatureMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMailboxSignatureMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMailboxSignatureMutation, DeleteMailboxSignatureMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMailboxSignatureMutation, DeleteMailboxSignatureMutationVariables>(DeleteMailboxSignatureDocument, options);
      }
export type DeleteMailboxSignatureMutationHookResult = ReturnType<typeof useDeleteMailboxSignatureMutation>;
export type DeleteMailboxSignatureMutationResult = Apollo.MutationResult<DeleteMailboxSignatureMutation>;
export type DeleteMailboxSignatureMutationOptions = Apollo.BaseMutationOptions<DeleteMailboxSignatureMutation, DeleteMailboxSignatureMutationVariables>;
export const SearchMemoriesDocument = gql`
    query SearchMemories($first: Int, $after: String, $filter: MemorySearchFilterInput) {
  searchMemories(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      node {
        ...MemoryListFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${MemoryListFieldsFragmentDoc}`;

/**
 * __useSearchMemoriesQuery__
 *
 * To run a query within a React component, call `useSearchMemoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchMemoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchMemoriesQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useSearchMemoriesQuery(baseOptions?: Apollo.QueryHookOptions<SearchMemoriesQuery, SearchMemoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchMemoriesQuery, SearchMemoriesQueryVariables>(SearchMemoriesDocument, options);
      }
export function useSearchMemoriesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchMemoriesQuery, SearchMemoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchMemoriesQuery, SearchMemoriesQueryVariables>(SearchMemoriesDocument, options);
        }
// @ts-ignore
export function useSearchMemoriesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchMemoriesQuery, SearchMemoriesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMemoriesQuery, SearchMemoriesQueryVariables>;
export function useSearchMemoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMemoriesQuery, SearchMemoriesQueryVariables>): Apollo.UseSuspenseQueryResult<SearchMemoriesQuery | undefined, SearchMemoriesQueryVariables>;
export function useSearchMemoriesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchMemoriesQuery, SearchMemoriesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchMemoriesQuery, SearchMemoriesQueryVariables>(SearchMemoriesDocument, options);
        }
export type SearchMemoriesQueryHookResult = ReturnType<typeof useSearchMemoriesQuery>;
export type SearchMemoriesLazyQueryHookResult = ReturnType<typeof useSearchMemoriesLazyQuery>;
export type SearchMemoriesSuspenseQueryHookResult = ReturnType<typeof useSearchMemoriesSuspenseQuery>;
export type SearchMemoriesQueryResult = Apollo.QueryResult<SearchMemoriesQuery, SearchMemoriesQueryVariables>;
export const MemoryDocument = gql`
    query Memory($id: ID!) {
  memory(id: $id) {
    ...MemoryDetailFields
  }
}
    ${MemoryDetailFieldsFragmentDoc}`;

/**
 * __useMemoryQuery__
 *
 * To run a query within a React component, call `useMemoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemoryQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMemoryQuery(baseOptions: Apollo.QueryHookOptions<MemoryQuery, MemoryQueryVariables> & ({ variables: MemoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemoryQuery, MemoryQueryVariables>(MemoryDocument, options);
      }
export function useMemoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemoryQuery, MemoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemoryQuery, MemoryQueryVariables>(MemoryDocument, options);
        }
// @ts-ignore
export function useMemorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<MemoryQuery, MemoryQueryVariables>): Apollo.UseSuspenseQueryResult<MemoryQuery, MemoryQueryVariables>;
export function useMemorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemoryQuery, MemoryQueryVariables>): Apollo.UseSuspenseQueryResult<MemoryQuery | undefined, MemoryQueryVariables>;
export function useMemorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemoryQuery, MemoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemoryQuery, MemoryQueryVariables>(MemoryDocument, options);
        }
export type MemoryQueryHookResult = ReturnType<typeof useMemoryQuery>;
export type MemoryLazyQueryHookResult = ReturnType<typeof useMemoryLazyQuery>;
export type MemorySuspenseQueryHookResult = ReturnType<typeof useMemorySuspenseQuery>;
export type MemoryQueryResult = Apollo.QueryResult<MemoryQuery, MemoryQueryVariables>;
export const UpdateMemoryDocument = gql`
    mutation UpdateMemory($input: UpdateMemoryInput!) {
  updateMemory(input: $input) {
    ...MemoryDetailFields
  }
}
    ${MemoryDetailFieldsFragmentDoc}`;
export type UpdateMemoryMutationFn = Apollo.MutationFunction<UpdateMemoryMutation, UpdateMemoryMutationVariables>;

/**
 * __useUpdateMemoryMutation__
 *
 * To run a mutation, you first call `useUpdateMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateMemoryMutation, { data, loading, error }] = useUpdateMemoryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateMemoryMutation(baseOptions?: Apollo.MutationHookOptions<UpdateMemoryMutation, UpdateMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateMemoryMutation, UpdateMemoryMutationVariables>(UpdateMemoryDocument, options);
      }
export type UpdateMemoryMutationHookResult = ReturnType<typeof useUpdateMemoryMutation>;
export type UpdateMemoryMutationResult = Apollo.MutationResult<UpdateMemoryMutation>;
export type UpdateMemoryMutationOptions = Apollo.BaseMutationOptions<UpdateMemoryMutation, UpdateMemoryMutationVariables>;
export const DeleteMemoryDocument = gql`
    mutation DeleteMemory($id: ID!) {
  deleteMemory(id: $id) {
    ...MemoryDetailFields
  }
}
    ${MemoryDetailFieldsFragmentDoc}`;
export type DeleteMemoryMutationFn = Apollo.MutationFunction<DeleteMemoryMutation, DeleteMemoryMutationVariables>;

/**
 * __useDeleteMemoryMutation__
 *
 * To run a mutation, you first call `useDeleteMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteMemoryMutation, { data, loading, error }] = useDeleteMemoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteMemoryMutation(baseOptions?: Apollo.MutationHookOptions<DeleteMemoryMutation, DeleteMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteMemoryMutation, DeleteMemoryMutationVariables>(DeleteMemoryDocument, options);
      }
export type DeleteMemoryMutationHookResult = ReturnType<typeof useDeleteMemoryMutation>;
export type DeleteMemoryMutationResult = Apollo.MutationResult<DeleteMemoryMutation>;
export type DeleteMemoryMutationOptions = Apollo.BaseMutationOptions<DeleteMemoryMutation, DeleteMemoryMutationVariables>;
export const PromoteMemoryDocument = gql`
    mutation PromoteMemory($id: ID!) {
  promoteMemory(id: $id) {
    ...MemoryDetailFields
  }
}
    ${MemoryDetailFieldsFragmentDoc}`;
export type PromoteMemoryMutationFn = Apollo.MutationFunction<PromoteMemoryMutation, PromoteMemoryMutationVariables>;

/**
 * __usePromoteMemoryMutation__
 *
 * To run a mutation, you first call `usePromoteMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePromoteMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [promoteMemoryMutation, { data, loading, error }] = usePromoteMemoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePromoteMemoryMutation(baseOptions?: Apollo.MutationHookOptions<PromoteMemoryMutation, PromoteMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PromoteMemoryMutation, PromoteMemoryMutationVariables>(PromoteMemoryDocument, options);
      }
export type PromoteMemoryMutationHookResult = ReturnType<typeof usePromoteMemoryMutation>;
export type PromoteMemoryMutationResult = Apollo.MutationResult<PromoteMemoryMutation>;
export type PromoteMemoryMutationOptions = Apollo.BaseMutationOptions<PromoteMemoryMutation, PromoteMemoryMutationVariables>;
export const DemoteMemoryDocument = gql`
    mutation DemoteMemory($id: ID!) {
  demoteMemory(id: $id) {
    ...MemoryDetailFields
  }
}
    ${MemoryDetailFieldsFragmentDoc}`;
export type DemoteMemoryMutationFn = Apollo.MutationFunction<DemoteMemoryMutation, DemoteMemoryMutationVariables>;

/**
 * __useDemoteMemoryMutation__
 *
 * To run a mutation, you first call `useDemoteMemoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDemoteMemoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [demoteMemoryMutation, { data, loading, error }] = useDemoteMemoryMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDemoteMemoryMutation(baseOptions?: Apollo.MutationHookOptions<DemoteMemoryMutation, DemoteMemoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DemoteMemoryMutation, DemoteMemoryMutationVariables>(DemoteMemoryDocument, options);
      }
export type DemoteMemoryMutationHookResult = ReturnType<typeof useDemoteMemoryMutation>;
export type DemoteMemoryMutationResult = Apollo.MutationResult<DemoteMemoryMutation>;
export type DemoteMemoryMutationOptions = Apollo.BaseMutationOptions<DemoteMemoryMutation, DemoteMemoryMutationVariables>;
export const SearchDocumentationDocument = gql`
    query SearchDocumentation($query: String!) {
  searchDocumentation(query: $query) {
    results {
      title
      path
      content
    }
  }
}
    `;

/**
 * __useSearchDocumentationQuery__
 *
 * To run a query within a React component, call `useSearchDocumentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchDocumentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchDocumentationQuery({
 *   variables: {
 *      query: // value for 'query'
 *   },
 * });
 */
export function useSearchDocumentationQuery(baseOptions: Apollo.QueryHookOptions<SearchDocumentationQuery, SearchDocumentationQueryVariables> & ({ variables: SearchDocumentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchDocumentationQuery, SearchDocumentationQueryVariables>(SearchDocumentationDocument, options);
      }
export function useSearchDocumentationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchDocumentationQuery, SearchDocumentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchDocumentationQuery, SearchDocumentationQueryVariables>(SearchDocumentationDocument, options);
        }
// @ts-ignore
export function useSearchDocumentationSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchDocumentationQuery, SearchDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchDocumentationQuery, SearchDocumentationQueryVariables>;
export function useSearchDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDocumentationQuery, SearchDocumentationQueryVariables>): Apollo.UseSuspenseQueryResult<SearchDocumentationQuery | undefined, SearchDocumentationQueryVariables>;
export function useSearchDocumentationSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchDocumentationQuery, SearchDocumentationQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchDocumentationQuery, SearchDocumentationQueryVariables>(SearchDocumentationDocument, options);
        }
export type SearchDocumentationQueryHookResult = ReturnType<typeof useSearchDocumentationQuery>;
export type SearchDocumentationLazyQueryHookResult = ReturnType<typeof useSearchDocumentationLazyQuery>;
export type SearchDocumentationSuspenseQueryHookResult = ReturnType<typeof useSearchDocumentationSuspenseQuery>;
export type SearchDocumentationQueryResult = Apollo.QueryResult<SearchDocumentationQuery, SearchDocumentationQueryVariables>;
export const GetOutboundCallsDocument = gql`
    query GetOutboundCalls($filter: OutboundCallsFilterInput) {
  outboundCalls(filter: $filter) {
    ...OutboundCallFields
  }
}
    ${OutboundCallFieldsFragmentDoc}`;

/**
 * __useGetOutboundCallsQuery__
 *
 * To run a query within a React component, call `useGetOutboundCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutboundCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutboundCallsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOutboundCallsQuery(baseOptions?: Apollo.QueryHookOptions<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>(GetOutboundCallsDocument, options);
      }
export function useGetOutboundCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>(GetOutboundCallsDocument, options);
        }
// @ts-ignore
export function useGetOutboundCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>;
export function useGetOutboundCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallsQuery | undefined, GetOutboundCallsQueryVariables>;
export function useGetOutboundCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>(GetOutboundCallsDocument, options);
        }
export type GetOutboundCallsQueryHookResult = ReturnType<typeof useGetOutboundCallsQuery>;
export type GetOutboundCallsLazyQueryHookResult = ReturnType<typeof useGetOutboundCallsLazyQuery>;
export type GetOutboundCallsSuspenseQueryHookResult = ReturnType<typeof useGetOutboundCallsSuspenseQuery>;
export type GetOutboundCallsQueryResult = Apollo.QueryResult<GetOutboundCallsQuery, GetOutboundCallsQueryVariables>;
export const SearchOutboundCallsDocument = gql`
    query SearchOutboundCalls($first: Int, $after: String, $filter: OutboundCallsFilterInput, $sort: OutboundCallSortInput) {
  searchOutboundCalls(first: $first, after: $after, filter: $filter, sort: $sort) {
    edges {
      cursor
      node {
        ...OutboundCallFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${OutboundCallFieldsFragmentDoc}`;

/**
 * __useSearchOutboundCallsQuery__
 *
 * To run a query within a React component, call `useSearchOutboundCallsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchOutboundCallsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchOutboundCallsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useSearchOutboundCallsQuery(baseOptions?: Apollo.QueryHookOptions<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>(SearchOutboundCallsDocument, options);
      }
export function useSearchOutboundCallsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>(SearchOutboundCallsDocument, options);
        }
// @ts-ignore
export function useSearchOutboundCallsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>;
export function useSearchOutboundCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>): Apollo.UseSuspenseQueryResult<SearchOutboundCallsQuery | undefined, SearchOutboundCallsQueryVariables>;
export function useSearchOutboundCallsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>(SearchOutboundCallsDocument, options);
        }
export type SearchOutboundCallsQueryHookResult = ReturnType<typeof useSearchOutboundCallsQuery>;
export type SearchOutboundCallsLazyQueryHookResult = ReturnType<typeof useSearchOutboundCallsLazyQuery>;
export type SearchOutboundCallsSuspenseQueryHookResult = ReturnType<typeof useSearchOutboundCallsSuspenseQuery>;
export type SearchOutboundCallsQueryResult = Apollo.QueryResult<SearchOutboundCallsQuery, SearchOutboundCallsQueryVariables>;
export const GetOutboundCallsRefreshCandidatesDocument = gql`
    query GetOutboundCallsRefreshCandidates {
  dialing: searchOutboundCalls(first: 1, filter: {status: DIALING}) {
    edges {
      node {
        ...OutboundCallRefreshFields
      }
    }
  }
  inProgress: searchOutboundCalls(first: 1, filter: {status: IN_PROGRESS}) {
    edges {
      node {
        ...OutboundCallRefreshFields
      }
    }
  }
  scheduled: searchOutboundCalls(
    first: 1
    filter: {status: SCHEDULED}
    sort: {field: SCHEDULED_AT, direction: ASC}
  ) {
    edges {
      node {
        ...OutboundCallRefreshFields
      }
    }
  }
}
    ${OutboundCallRefreshFieldsFragmentDoc}`;

/**
 * __useGetOutboundCallsRefreshCandidatesQuery__
 *
 * To run a query within a React component, call `useGetOutboundCallsRefreshCandidatesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutboundCallsRefreshCandidatesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutboundCallsRefreshCandidatesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetOutboundCallsRefreshCandidatesQuery(baseOptions?: Apollo.QueryHookOptions<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>(GetOutboundCallsRefreshCandidatesDocument, options);
      }
export function useGetOutboundCallsRefreshCandidatesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>(GetOutboundCallsRefreshCandidatesDocument, options);
        }
// @ts-ignore
export function useGetOutboundCallsRefreshCandidatesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>;
export function useGetOutboundCallsRefreshCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallsRefreshCandidatesQuery | undefined, GetOutboundCallsRefreshCandidatesQueryVariables>;
export function useGetOutboundCallsRefreshCandidatesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>(GetOutboundCallsRefreshCandidatesDocument, options);
        }
export type GetOutboundCallsRefreshCandidatesQueryHookResult = ReturnType<typeof useGetOutboundCallsRefreshCandidatesQuery>;
export type GetOutboundCallsRefreshCandidatesLazyQueryHookResult = ReturnType<typeof useGetOutboundCallsRefreshCandidatesLazyQuery>;
export type GetOutboundCallsRefreshCandidatesSuspenseQueryHookResult = ReturnType<typeof useGetOutboundCallsRefreshCandidatesSuspenseQuery>;
export type GetOutboundCallsRefreshCandidatesQueryResult = Apollo.QueryResult<GetOutboundCallsRefreshCandidatesQuery, GetOutboundCallsRefreshCandidatesQueryVariables>;
export const GetOutboundCallDocument = gql`
    query GetOutboundCall($id: ID!) {
  outboundCall(id: $id) {
    ...OutboundCallDetailFields
  }
}
    ${OutboundCallDetailFieldsFragmentDoc}`;

/**
 * __useGetOutboundCallQuery__
 *
 * To run a query within a React component, call `useGetOutboundCallQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutboundCallQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutboundCallQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetOutboundCallQuery(baseOptions: Apollo.QueryHookOptions<GetOutboundCallQuery, GetOutboundCallQueryVariables> & ({ variables: GetOutboundCallQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutboundCallQuery, GetOutboundCallQueryVariables>(GetOutboundCallDocument, options);
      }
export function useGetOutboundCallLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutboundCallQuery, GetOutboundCallQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutboundCallQuery, GetOutboundCallQueryVariables>(GetOutboundCallDocument, options);
        }
// @ts-ignore
export function useGetOutboundCallSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutboundCallQuery, GetOutboundCallQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallQuery, GetOutboundCallQueryVariables>;
export function useGetOutboundCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallQuery, GetOutboundCallQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallQuery | undefined, GetOutboundCallQueryVariables>;
export function useGetOutboundCallSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallQuery, GetOutboundCallQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutboundCallQuery, GetOutboundCallQueryVariables>(GetOutboundCallDocument, options);
        }
export type GetOutboundCallQueryHookResult = ReturnType<typeof useGetOutboundCallQuery>;
export type GetOutboundCallLazyQueryHookResult = ReturnType<typeof useGetOutboundCallLazyQuery>;
export type GetOutboundCallSuspenseQueryHookResult = ReturnType<typeof useGetOutboundCallSuspenseQuery>;
export type GetOutboundCallQueryResult = Apollo.QueryResult<GetOutboundCallQuery, GetOutboundCallQueryVariables>;
export const GetOutboundCallReportDocument = gql`
    query GetOutboundCallReport($filter: OutboundCallReportFilterInput) {
  outboundCallReport(filter: $filter) {
    ...OutboundCallReportFields
  }
}
    ${OutboundCallReportFieldsFragmentDoc}`;

/**
 * __useGetOutboundCallReportQuery__
 *
 * To run a query within a React component, call `useGetOutboundCallReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutboundCallReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutboundCallReportQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetOutboundCallReportQuery(baseOptions?: Apollo.QueryHookOptions<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>(GetOutboundCallReportDocument, options);
      }
export function useGetOutboundCallReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>(GetOutboundCallReportDocument, options);
        }
// @ts-ignore
export function useGetOutboundCallReportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>;
export function useGetOutboundCallReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallReportQuery | undefined, GetOutboundCallReportQueryVariables>;
export function useGetOutboundCallReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>(GetOutboundCallReportDocument, options);
        }
export type GetOutboundCallReportQueryHookResult = ReturnType<typeof useGetOutboundCallReportQuery>;
export type GetOutboundCallReportLazyQueryHookResult = ReturnType<typeof useGetOutboundCallReportLazyQuery>;
export type GetOutboundCallReportSuspenseQueryHookResult = ReturnType<typeof useGetOutboundCallReportSuspenseQuery>;
export type GetOutboundCallReportQueryResult = Apollo.QueryResult<GetOutboundCallReportQuery, GetOutboundCallReportQueryVariables>;
export const GetOutboundCallFrequencyDocument = gql`
    query GetOutboundCallFrequency($phone: String!, $excludeOutboundCallId: ID) {
  outboundCallFrequency(
    phone: $phone
    excludeOutboundCallId: $excludeOutboundCallId
  ) {
    count
    limit
    windowDays
    remaining
  }
}
    `;

/**
 * __useGetOutboundCallFrequencyQuery__
 *
 * To run a query within a React component, call `useGetOutboundCallFrequencyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetOutboundCallFrequencyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetOutboundCallFrequencyQuery({
 *   variables: {
 *      phone: // value for 'phone'
 *      excludeOutboundCallId: // value for 'excludeOutboundCallId'
 *   },
 * });
 */
export function useGetOutboundCallFrequencyQuery(baseOptions: Apollo.QueryHookOptions<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables> & ({ variables: GetOutboundCallFrequencyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>(GetOutboundCallFrequencyDocument, options);
      }
export function useGetOutboundCallFrequencyLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>(GetOutboundCallFrequencyDocument, options);
        }
// @ts-ignore
export function useGetOutboundCallFrequencySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>;
export function useGetOutboundCallFrequencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>): Apollo.UseSuspenseQueryResult<GetOutboundCallFrequencyQuery | undefined, GetOutboundCallFrequencyQueryVariables>;
export function useGetOutboundCallFrequencySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>(GetOutboundCallFrequencyDocument, options);
        }
export type GetOutboundCallFrequencyQueryHookResult = ReturnType<typeof useGetOutboundCallFrequencyQuery>;
export type GetOutboundCallFrequencyLazyQueryHookResult = ReturnType<typeof useGetOutboundCallFrequencyLazyQuery>;
export type GetOutboundCallFrequencySuspenseQueryHookResult = ReturnType<typeof useGetOutboundCallFrequencySuspenseQuery>;
export type GetOutboundCallFrequencyQueryResult = Apollo.QueryResult<GetOutboundCallFrequencyQuery, GetOutboundCallFrequencyQueryVariables>;
export const CreateOutboundCallDocument = gql`
    mutation CreateOutboundCall($input: CreateOutboundCallInput!) {
  createOutboundCall(input: $input) {
    ...OutboundCallFields
  }
}
    ${OutboundCallFieldsFragmentDoc}`;
export type CreateOutboundCallMutationFn = Apollo.MutationFunction<CreateOutboundCallMutation, CreateOutboundCallMutationVariables>;

/**
 * __useCreateOutboundCallMutation__
 *
 * To run a mutation, you first call `useCreateOutboundCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOutboundCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOutboundCallMutation, { data, loading, error }] = useCreateOutboundCallMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateOutboundCallMutation(baseOptions?: Apollo.MutationHookOptions<CreateOutboundCallMutation, CreateOutboundCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateOutboundCallMutation, CreateOutboundCallMutationVariables>(CreateOutboundCallDocument, options);
      }
export type CreateOutboundCallMutationHookResult = ReturnType<typeof useCreateOutboundCallMutation>;
export type CreateOutboundCallMutationResult = Apollo.MutationResult<CreateOutboundCallMutation>;
export type CreateOutboundCallMutationOptions = Apollo.BaseMutationOptions<CreateOutboundCallMutation, CreateOutboundCallMutationVariables>;
export const UpdateOutboundCallDocument = gql`
    mutation UpdateOutboundCall($id: ID!, $input: UpdateOutboundCallInput!) {
  updateOutboundCall(id: $id, input: $input) {
    ...OutboundCallFields
  }
}
    ${OutboundCallFieldsFragmentDoc}`;
export type UpdateOutboundCallMutationFn = Apollo.MutationFunction<UpdateOutboundCallMutation, UpdateOutboundCallMutationVariables>;

/**
 * __useUpdateOutboundCallMutation__
 *
 * To run a mutation, you first call `useUpdateOutboundCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOutboundCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOutboundCallMutation, { data, loading, error }] = useUpdateOutboundCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOutboundCallMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOutboundCallMutation, UpdateOutboundCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOutboundCallMutation, UpdateOutboundCallMutationVariables>(UpdateOutboundCallDocument, options);
      }
export type UpdateOutboundCallMutationHookResult = ReturnType<typeof useUpdateOutboundCallMutation>;
export type UpdateOutboundCallMutationResult = Apollo.MutationResult<UpdateOutboundCallMutation>;
export type UpdateOutboundCallMutationOptions = Apollo.BaseMutationOptions<UpdateOutboundCallMutation, UpdateOutboundCallMutationVariables>;
export const CancelOutboundCallDocument = gql`
    mutation CancelOutboundCall($id: ID!) {
  cancelOutboundCall(id: $id) {
    ...OutboundCallFields
  }
}
    ${OutboundCallFieldsFragmentDoc}`;
export type CancelOutboundCallMutationFn = Apollo.MutationFunction<CancelOutboundCallMutation, CancelOutboundCallMutationVariables>;

/**
 * __useCancelOutboundCallMutation__
 *
 * To run a mutation, you first call `useCancelOutboundCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelOutboundCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelOutboundCallMutation, { data, loading, error }] = useCancelOutboundCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelOutboundCallMutation(baseOptions?: Apollo.MutationHookOptions<CancelOutboundCallMutation, CancelOutboundCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelOutboundCallMutation, CancelOutboundCallMutationVariables>(CancelOutboundCallDocument, options);
      }
export type CancelOutboundCallMutationHookResult = ReturnType<typeof useCancelOutboundCallMutation>;
export type CancelOutboundCallMutationResult = Apollo.MutationResult<CancelOutboundCallMutation>;
export type CancelOutboundCallMutationOptions = Apollo.BaseMutationOptions<CancelOutboundCallMutation, CancelOutboundCallMutationVariables>;
export const ArchiveOutboundCallsDocument = gql`
    mutation ArchiveOutboundCalls($ids: [ID!]!) {
  archiveOutboundCalls(ids: $ids)
}
    `;
export type ArchiveOutboundCallsMutationFn = Apollo.MutationFunction<ArchiveOutboundCallsMutation, ArchiveOutboundCallsMutationVariables>;

/**
 * __useArchiveOutboundCallsMutation__
 *
 * To run a mutation, you first call `useArchiveOutboundCallsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveOutboundCallsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveOutboundCallsMutation, { data, loading, error }] = useArchiveOutboundCallsMutation({
 *   variables: {
 *      ids: // value for 'ids'
 *   },
 * });
 */
export function useArchiveOutboundCallsMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveOutboundCallsMutation, ArchiveOutboundCallsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveOutboundCallsMutation, ArchiveOutboundCallsMutationVariables>(ArchiveOutboundCallsDocument, options);
      }
export type ArchiveOutboundCallsMutationHookResult = ReturnType<typeof useArchiveOutboundCallsMutation>;
export type ArchiveOutboundCallsMutationResult = Apollo.MutationResult<ArchiveOutboundCallsMutation>;
export type ArchiveOutboundCallsMutationOptions = Apollo.BaseMutationOptions<ArchiveOutboundCallsMutation, ArchiveOutboundCallsMutationVariables>;
export const DialOutboundCallDocument = gql`
    mutation DialOutboundCall($id: ID!) {
  dialOutboundCall(id: $id) {
    ...OutboundCallFields
  }
}
    ${OutboundCallFieldsFragmentDoc}`;
export type DialOutboundCallMutationFn = Apollo.MutationFunction<DialOutboundCallMutation, DialOutboundCallMutationVariables>;

/**
 * __useDialOutboundCallMutation__
 *
 * To run a mutation, you first call `useDialOutboundCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDialOutboundCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [dialOutboundCallMutation, { data, loading, error }] = useDialOutboundCallMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDialOutboundCallMutation(baseOptions?: Apollo.MutationHookOptions<DialOutboundCallMutation, DialOutboundCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DialOutboundCallMutation, DialOutboundCallMutationVariables>(DialOutboundCallDocument, options);
      }
export type DialOutboundCallMutationHookResult = ReturnType<typeof useDialOutboundCallMutation>;
export type DialOutboundCallMutationResult = Apollo.MutationResult<DialOutboundCallMutation>;
export type DialOutboundCallMutationOptions = Apollo.BaseMutationOptions<DialOutboundCallMutation, DialOutboundCallMutationVariables>;
export const StartPresetGenerationDocument = gql`
    mutation StartPresetGeneration($input: StartPresetGenerationInput!) {
  startPresetGeneration(input: $input) {
    ...PresetGenerationProgressFields
  }
}
    ${PresetGenerationProgressFieldsFragmentDoc}`;
export type StartPresetGenerationMutationFn = Apollo.MutationFunction<StartPresetGenerationMutation, StartPresetGenerationMutationVariables>;

/**
 * __useStartPresetGenerationMutation__
 *
 * To run a mutation, you first call `useStartPresetGenerationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartPresetGenerationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startPresetGenerationMutation, { data, loading, error }] = useStartPresetGenerationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useStartPresetGenerationMutation(baseOptions?: Apollo.MutationHookOptions<StartPresetGenerationMutation, StartPresetGenerationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartPresetGenerationMutation, StartPresetGenerationMutationVariables>(StartPresetGenerationDocument, options);
      }
export type StartPresetGenerationMutationHookResult = ReturnType<typeof useStartPresetGenerationMutation>;
export type StartPresetGenerationMutationResult = Apollo.MutationResult<StartPresetGenerationMutation>;
export type StartPresetGenerationMutationOptions = Apollo.BaseMutationOptions<StartPresetGenerationMutation, StartPresetGenerationMutationVariables>;
export const GeneratePresetQuestionsDocument = gql`
    mutation GeneratePresetQuestions($input: GeneratePresetQuestionsInput!) {
  generatePresetQuestions(input: $input) {
    ...PresetClarifyingQuestionFields
  }
}
    ${PresetClarifyingQuestionFieldsFragmentDoc}`;
export type GeneratePresetQuestionsMutationFn = Apollo.MutationFunction<GeneratePresetQuestionsMutation, GeneratePresetQuestionsMutationVariables>;

/**
 * __useGeneratePresetQuestionsMutation__
 *
 * To run a mutation, you first call `useGeneratePresetQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGeneratePresetQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generatePresetQuestionsMutation, { data, loading, error }] = useGeneratePresetQuestionsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useGeneratePresetQuestionsMutation(baseOptions?: Apollo.MutationHookOptions<GeneratePresetQuestionsMutation, GeneratePresetQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GeneratePresetQuestionsMutation, GeneratePresetQuestionsMutationVariables>(GeneratePresetQuestionsDocument, options);
      }
export type GeneratePresetQuestionsMutationHookResult = ReturnType<typeof useGeneratePresetQuestionsMutation>;
export type GeneratePresetQuestionsMutationResult = Apollo.MutationResult<GeneratePresetQuestionsMutation>;
export type GeneratePresetQuestionsMutationOptions = Apollo.BaseMutationOptions<GeneratePresetQuestionsMutation, GeneratePresetQuestionsMutationVariables>;
export const GetPresetGenerationProgressDocument = gql`
    query GetPresetGenerationProgress($id: ID!) {
  customPreset(id: $id) {
    ...PresetGenerationProgressFields
  }
}
    ${PresetGenerationProgressFieldsFragmentDoc}`;

/**
 * __useGetPresetGenerationProgressQuery__
 *
 * To run a query within a React component, call `useGetPresetGenerationProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPresetGenerationProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPresetGenerationProgressQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetPresetGenerationProgressQuery(baseOptions: Apollo.QueryHookOptions<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables> & ({ variables: GetPresetGenerationProgressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>(GetPresetGenerationProgressDocument, options);
      }
export function useGetPresetGenerationProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>(GetPresetGenerationProgressDocument, options);
        }
// @ts-ignore
export function useGetPresetGenerationProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>;
export function useGetPresetGenerationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>): Apollo.UseSuspenseQueryResult<GetPresetGenerationProgressQuery | undefined, GetPresetGenerationProgressQueryVariables>;
export function useGetPresetGenerationProgressSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>(GetPresetGenerationProgressDocument, options);
        }
export type GetPresetGenerationProgressQueryHookResult = ReturnType<typeof useGetPresetGenerationProgressQuery>;
export type GetPresetGenerationProgressLazyQueryHookResult = ReturnType<typeof useGetPresetGenerationProgressLazyQuery>;
export type GetPresetGenerationProgressSuspenseQueryHookResult = ReturnType<typeof useGetPresetGenerationProgressSuspenseQuery>;
export type GetPresetGenerationProgressQueryResult = Apollo.QueryResult<GetPresetGenerationProgressQuery, GetPresetGenerationProgressQueryVariables>;
export const GetServiceRequestsDocument = gql`
    query GetServiceRequests {
  serviceRequests {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;

/**
 * __useGetServiceRequestsQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetServiceRequestsQuery(baseOptions?: Apollo.QueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(GetServiceRequestsDocument, options);
      }
export function useGetServiceRequestsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(GetServiceRequestsDocument, options);
        }
// @ts-ignore
export function useGetServiceRequestsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>;
export function useGetServiceRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestsQuery | undefined, GetServiceRequestsQueryVariables>;
export function useGetServiceRequestsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>(GetServiceRequestsDocument, options);
        }
export type GetServiceRequestsQueryHookResult = ReturnType<typeof useGetServiceRequestsQuery>;
export type GetServiceRequestsLazyQueryHookResult = ReturnType<typeof useGetServiceRequestsLazyQuery>;
export type GetServiceRequestsSuspenseQueryHookResult = ReturnType<typeof useGetServiceRequestsSuspenseQuery>;
export type GetServiceRequestsQueryResult = Apollo.QueryResult<GetServiceRequestsQuery, GetServiceRequestsQueryVariables>;
export const GetServiceRequestDocument = gql`
    query GetServiceRequest($id: ID!) {
  serviceRequest(id: $id) {
    ...ServiceRequestFields
    ...ServiceRequestCallFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}
${ServiceRequestCallFieldsFragmentDoc}`;

/**
 * __useGetServiceRequestQuery__
 *
 * To run a query within a React component, call `useGetServiceRequestQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetServiceRequestQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetServiceRequestQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetServiceRequestQuery(baseOptions: Apollo.QueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables> & ({ variables: GetServiceRequestQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
      }
export function useGetServiceRequestLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
        }
// @ts-ignore
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>): Apollo.UseSuspenseQueryResult<GetServiceRequestQuery | undefined, GetServiceRequestQueryVariables>;
export function useGetServiceRequestSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetServiceRequestQuery, GetServiceRequestQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetServiceRequestQuery, GetServiceRequestQueryVariables>(GetServiceRequestDocument, options);
        }
export type GetServiceRequestQueryHookResult = ReturnType<typeof useGetServiceRequestQuery>;
export type GetServiceRequestLazyQueryHookResult = ReturnType<typeof useGetServiceRequestLazyQuery>;
export type GetServiceRequestSuspenseQueryHookResult = ReturnType<typeof useGetServiceRequestSuspenseQuery>;
export type GetServiceRequestQueryResult = Apollo.QueryResult<GetServiceRequestQuery, GetServiceRequestQueryVariables>;
export const ResolveServiceRequestDocument = gql`
    mutation ResolveServiceRequest($id: ID!, $input: ResolveServiceRequestInput!) {
  resolveServiceRequest(id: $id, input: $input) {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export type ResolveServiceRequestMutationFn = Apollo.MutationFunction<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>;

/**
 * __useResolveServiceRequestMutation__
 *
 * To run a mutation, you first call `useResolveServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResolveServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resolveServiceRequestMutation, { data, loading, error }] = useResolveServiceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResolveServiceRequestMutation(baseOptions?: Apollo.MutationHookOptions<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>(ResolveServiceRequestDocument, options);
      }
export type ResolveServiceRequestMutationHookResult = ReturnType<typeof useResolveServiceRequestMutation>;
export type ResolveServiceRequestMutationResult = Apollo.MutationResult<ResolveServiceRequestMutation>;
export type ResolveServiceRequestMutationOptions = Apollo.BaseMutationOptions<ResolveServiceRequestMutation, ResolveServiceRequestMutationVariables>;
export const UpdateServiceRequestDocument = gql`
    mutation UpdateServiceRequest($id: ID!, $input: UpdateServiceRequestInput!) {
  updateServiceRequest(id: $id, input: $input) {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export type UpdateServiceRequestMutationFn = Apollo.MutationFunction<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>;

/**
 * __useUpdateServiceRequestMutation__
 *
 * To run a mutation, you first call `useUpdateServiceRequestMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceRequestMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceRequestMutation, { data, loading, error }] = useUpdateServiceRequestMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceRequestMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>(UpdateServiceRequestDocument, options);
      }
export type UpdateServiceRequestMutationHookResult = ReturnType<typeof useUpdateServiceRequestMutation>;
export type UpdateServiceRequestMutationResult = Apollo.MutationResult<UpdateServiceRequestMutation>;
export type UpdateServiceRequestMutationOptions = Apollo.BaseMutationOptions<UpdateServiceRequestMutation, UpdateServiceRequestMutationVariables>;
export const AddServiceRequestCommentDocument = gql`
    mutation AddServiceRequestComment($id: ID!, $input: AddServiceRequestCommentInput!) {
  addServiceRequestComment(id: $id, input: $input) {
    ...ServiceRequestFields
  }
}
    ${ServiceRequestFieldsFragmentDoc}`;
export type AddServiceRequestCommentMutationFn = Apollo.MutationFunction<AddServiceRequestCommentMutation, AddServiceRequestCommentMutationVariables>;

/**
 * __useAddServiceRequestCommentMutation__
 *
 * To run a mutation, you first call `useAddServiceRequestCommentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceRequestCommentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceRequestCommentMutation, { data, loading, error }] = useAddServiceRequestCommentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddServiceRequestCommentMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceRequestCommentMutation, AddServiceRequestCommentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceRequestCommentMutation, AddServiceRequestCommentMutationVariables>(AddServiceRequestCommentDocument, options);
      }
export type AddServiceRequestCommentMutationHookResult = ReturnType<typeof useAddServiceRequestCommentMutation>;
export type AddServiceRequestCommentMutationResult = Apollo.MutationResult<AddServiceRequestCommentMutation>;
export type AddServiceRequestCommentMutationOptions = Apollo.BaseMutationOptions<AddServiceRequestCommentMutation, AddServiceRequestCommentMutationVariables>;
export const GetSmartFillFormBucketsDocument = gql`
    query GetSmartFillFormBuckets {
  smartFillFormBuckets {
    ...SmartFillFormBucketFields
  }
}
    ${SmartFillFormBucketFieldsFragmentDoc}`;

/**
 * __useGetSmartFillFormBucketsQuery__
 *
 * To run a query within a React component, call `useGetSmartFillFormBucketsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmartFillFormBucketsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmartFillFormBucketsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmartFillFormBucketsQuery(baseOptions?: Apollo.QueryHookOptions<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>(GetSmartFillFormBucketsDocument, options);
      }
export function useGetSmartFillFormBucketsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>(GetSmartFillFormBucketsDocument, options);
        }
// @ts-ignore
export function useGetSmartFillFormBucketsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>;
export function useGetSmartFillFormBucketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillFormBucketsQuery | undefined, GetSmartFillFormBucketsQueryVariables>;
export function useGetSmartFillFormBucketsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>(GetSmartFillFormBucketsDocument, options);
        }
export type GetSmartFillFormBucketsQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketsQuery>;
export type GetSmartFillFormBucketsLazyQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketsLazyQuery>;
export type GetSmartFillFormBucketsSuspenseQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketsSuspenseQuery>;
export type GetSmartFillFormBucketsQueryResult = Apollo.QueryResult<GetSmartFillFormBucketsQuery, GetSmartFillFormBucketsQueryVariables>;
export const GetSmartFillCarrierSitesDocument = gql`
    query GetSmartFillCarrierSites {
  smartFillCarrierSites {
    ...SmartFillCarrierSiteFields
  }
}
    ${SmartFillCarrierSiteFieldsFragmentDoc}`;

/**
 * __useGetSmartFillCarrierSitesQuery__
 *
 * To run a query within a React component, call `useGetSmartFillCarrierSitesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmartFillCarrierSitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmartFillCarrierSitesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSmartFillCarrierSitesQuery(baseOptions?: Apollo.QueryHookOptions<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>(GetSmartFillCarrierSitesDocument, options);
      }
export function useGetSmartFillCarrierSitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>(GetSmartFillCarrierSitesDocument, options);
        }
// @ts-ignore
export function useGetSmartFillCarrierSitesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>;
export function useGetSmartFillCarrierSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillCarrierSitesQuery | undefined, GetSmartFillCarrierSitesQueryVariables>;
export function useGetSmartFillCarrierSitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>(GetSmartFillCarrierSitesDocument, options);
        }
export type GetSmartFillCarrierSitesQueryHookResult = ReturnType<typeof useGetSmartFillCarrierSitesQuery>;
export type GetSmartFillCarrierSitesLazyQueryHookResult = ReturnType<typeof useGetSmartFillCarrierSitesLazyQuery>;
export type GetSmartFillCarrierSitesSuspenseQueryHookResult = ReturnType<typeof useGetSmartFillCarrierSitesSuspenseQuery>;
export type GetSmartFillCarrierSitesQueryResult = Apollo.QueryResult<GetSmartFillCarrierSitesQuery, GetSmartFillCarrierSitesQueryVariables>;
export const GetSmartFillFormBucketQuestionsDocument = gql`
    query GetSmartFillFormBucketQuestions($bucketId: ID!, $carrierSiteId: ID) {
  smartFillFormBucketQuestions(bucketId: $bucketId, carrierSiteId: $carrierSiteId) {
    ...SmartFillFormBucketQuestionsFields
  }
}
    ${SmartFillFormBucketQuestionsFieldsFragmentDoc}`;

/**
 * __useGetSmartFillFormBucketQuestionsQuery__
 *
 * To run a query within a React component, call `useGetSmartFillFormBucketQuestionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSmartFillFormBucketQuestionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSmartFillFormBucketQuestionsQuery({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      carrierSiteId: // value for 'carrierSiteId'
 *   },
 * });
 */
export function useGetSmartFillFormBucketQuestionsQuery(baseOptions: Apollo.QueryHookOptions<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables> & ({ variables: GetSmartFillFormBucketQuestionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>(GetSmartFillFormBucketQuestionsDocument, options);
      }
export function useGetSmartFillFormBucketQuestionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>(GetSmartFillFormBucketQuestionsDocument, options);
        }
// @ts-ignore
export function useGetSmartFillFormBucketQuestionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>;
export function useGetSmartFillFormBucketQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetSmartFillFormBucketQuestionsQuery | undefined, GetSmartFillFormBucketQuestionsQueryVariables>;
export function useGetSmartFillFormBucketQuestionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>(GetSmartFillFormBucketQuestionsDocument, options);
        }
export type GetSmartFillFormBucketQuestionsQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketQuestionsQuery>;
export type GetSmartFillFormBucketQuestionsLazyQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketQuestionsLazyQuery>;
export type GetSmartFillFormBucketQuestionsSuspenseQueryHookResult = ReturnType<typeof useGetSmartFillFormBucketQuestionsSuspenseQuery>;
export type GetSmartFillFormBucketQuestionsQueryResult = Apollo.QueryResult<GetSmartFillFormBucketQuestionsQuery, GetSmartFillFormBucketQuestionsQueryVariables>;
export const AnswerSmartFillFormBucketDocument = gql`
    mutation AnswerSmartFillFormBucket($bucketId: ID!, $expectedRevision: Int64!, $carrierSiteId: ID, $answers: [SmartFillFormAnswerInput!]!) {
  answerSmartFillFormBucket(
    bucketId: $bucketId
    expectedRevision: $expectedRevision
    carrierSiteId: $carrierSiteId
    answers: $answers
  ) {
    ...SmartFillFormBucketQuestionsFields
  }
}
    ${SmartFillFormBucketQuestionsFieldsFragmentDoc}`;
export type AnswerSmartFillFormBucketMutationFn = Apollo.MutationFunction<AnswerSmartFillFormBucketMutation, AnswerSmartFillFormBucketMutationVariables>;

/**
 * __useAnswerSmartFillFormBucketMutation__
 *
 * To run a mutation, you first call `useAnswerSmartFillFormBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAnswerSmartFillFormBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [answerSmartFillFormBucketMutation, { data, loading, error }] = useAnswerSmartFillFormBucketMutation({
 *   variables: {
 *      bucketId: // value for 'bucketId'
 *      expectedRevision: // value for 'expectedRevision'
 *      carrierSiteId: // value for 'carrierSiteId'
 *      answers: // value for 'answers'
 *   },
 * });
 */
export function useAnswerSmartFillFormBucketMutation(baseOptions?: Apollo.MutationHookOptions<AnswerSmartFillFormBucketMutation, AnswerSmartFillFormBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AnswerSmartFillFormBucketMutation, AnswerSmartFillFormBucketMutationVariables>(AnswerSmartFillFormBucketDocument, options);
      }
export type AnswerSmartFillFormBucketMutationHookResult = ReturnType<typeof useAnswerSmartFillFormBucketMutation>;
export type AnswerSmartFillFormBucketMutationResult = Apollo.MutationResult<AnswerSmartFillFormBucketMutation>;
export type AnswerSmartFillFormBucketMutationOptions = Apollo.BaseMutationOptions<AnswerSmartFillFormBucketMutation, AnswerSmartFillFormBucketMutationVariables>;
export const GenerateSmartFillWorkspaceBucketDocument = gql`
    mutation GenerateSmartFillWorkspaceBucket($workspaceId: ID!, $operationId: ID!) {
  generateSmartFillWorkspaceBucket(
    workspaceId: $workspaceId
    operationId: $operationId
  ) {
    bucketIds
    completed
  }
}
    `;
export type GenerateSmartFillWorkspaceBucketMutationFn = Apollo.MutationFunction<GenerateSmartFillWorkspaceBucketMutation, GenerateSmartFillWorkspaceBucketMutationVariables>;

/**
 * __useGenerateSmartFillWorkspaceBucketMutation__
 *
 * To run a mutation, you first call `useGenerateSmartFillWorkspaceBucketMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useGenerateSmartFillWorkspaceBucketMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [generateSmartFillWorkspaceBucketMutation, { data, loading, error }] = useGenerateSmartFillWorkspaceBucketMutation({
 *   variables: {
 *      workspaceId: // value for 'workspaceId'
 *      operationId: // value for 'operationId'
 *   },
 * });
 */
export function useGenerateSmartFillWorkspaceBucketMutation(baseOptions?: Apollo.MutationHookOptions<GenerateSmartFillWorkspaceBucketMutation, GenerateSmartFillWorkspaceBucketMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<GenerateSmartFillWorkspaceBucketMutation, GenerateSmartFillWorkspaceBucketMutationVariables>(GenerateSmartFillWorkspaceBucketDocument, options);
      }
export type GenerateSmartFillWorkspaceBucketMutationHookResult = ReturnType<typeof useGenerateSmartFillWorkspaceBucketMutation>;
export type GenerateSmartFillWorkspaceBucketMutationResult = Apollo.MutationResult<GenerateSmartFillWorkspaceBucketMutation>;
export type GenerateSmartFillWorkspaceBucketMutationOptions = Apollo.BaseMutationOptions<GenerateSmartFillWorkspaceBucketMutation, GenerateSmartFillWorkspaceBucketMutationVariables>;
export const GetMyTeamsDocument = gql`
    query GetMyTeams {
  agencyUser {
    id
    teams {
      ...TeamSummaryFields
    }
  }
}
    ${TeamSummaryFieldsFragmentDoc}`;

/**
 * __useGetMyTeamsQuery__
 *
 * To run a query within a React component, call `useGetMyTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMyTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMyTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMyTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetMyTeamsQuery, GetMyTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(GetMyTeamsDocument, options);
      }
export function useGetMyTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMyTeamsQuery, GetMyTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(GetMyTeamsDocument, options);
        }
// @ts-ignore
export function useGetMyTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMyTeamsQuery, GetMyTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyTeamsQuery, GetMyTeamsQueryVariables>;
export function useGetMyTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTeamsQuery, GetMyTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetMyTeamsQuery | undefined, GetMyTeamsQueryVariables>;
export function useGetMyTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetMyTeamsQuery, GetMyTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMyTeamsQuery, GetMyTeamsQueryVariables>(GetMyTeamsDocument, options);
        }
export type GetMyTeamsQueryHookResult = ReturnType<typeof useGetMyTeamsQuery>;
export type GetMyTeamsLazyQueryHookResult = ReturnType<typeof useGetMyTeamsLazyQuery>;
export type GetMyTeamsSuspenseQueryHookResult = ReturnType<typeof useGetMyTeamsSuspenseQuery>;
export type GetMyTeamsQueryResult = Apollo.QueryResult<GetMyTeamsQuery, GetMyTeamsQueryVariables>;
export const GetTeamsDocument = gql`
    query GetTeams {
  teams {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;

/**
 * __useGetTeamsQuery__
 *
 * To run a query within a React component, call `useGetTeamsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTeamsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTeamsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTeamsQuery(baseOptions?: Apollo.QueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
      }
export function useGetTeamsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
// @ts-ignore
export function useGetTeamsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export function useGetTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTeamsQuery | undefined, GetTeamsQueryVariables>;
export function useGetTeamsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTeamsQuery, GetTeamsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTeamsQuery, GetTeamsQueryVariables>(GetTeamsDocument, options);
        }
export type GetTeamsQueryHookResult = ReturnType<typeof useGetTeamsQuery>;
export type GetTeamsLazyQueryHookResult = ReturnType<typeof useGetTeamsLazyQuery>;
export type GetTeamsSuspenseQueryHookResult = ReturnType<typeof useGetTeamsSuspenseQuery>;
export type GetTeamsQueryResult = Apollo.QueryResult<GetTeamsQuery, GetTeamsQueryVariables>;
export const CreateTeamDocument = gql`
    mutation CreateTeam($input: TeamInput!) {
  createTeam(input: $input) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type CreateTeamMutationFn = Apollo.MutationFunction<CreateTeamMutation, CreateTeamMutationVariables>;

/**
 * __useCreateTeamMutation__
 *
 * To run a mutation, you first call `useCreateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTeamMutation, { data, loading, error }] = useCreateTeamMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTeamMutation(baseOptions?: Apollo.MutationHookOptions<CreateTeamMutation, CreateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTeamMutation, CreateTeamMutationVariables>(CreateTeamDocument, options);
      }
export type CreateTeamMutationHookResult = ReturnType<typeof useCreateTeamMutation>;
export type CreateTeamMutationResult = Apollo.MutationResult<CreateTeamMutation>;
export type CreateTeamMutationOptions = Apollo.BaseMutationOptions<CreateTeamMutation, CreateTeamMutationVariables>;
export const UpdateTeamDocument = gql`
    mutation UpdateTeam($id: ID!, $input: TeamInput!) {
  updateTeam(id: $id, input: $input) {
    ...TeamFields
  }
}
    ${TeamFieldsFragmentDoc}`;
export type UpdateTeamMutationFn = Apollo.MutationFunction<UpdateTeamMutation, UpdateTeamMutationVariables>;

/**
 * __useUpdateTeamMutation__
 *
 * To run a mutation, you first call `useUpdateTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTeamMutation, { data, loading, error }] = useUpdateTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTeamMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTeamMutation, UpdateTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTeamMutation, UpdateTeamMutationVariables>(UpdateTeamDocument, options);
      }
export type UpdateTeamMutationHookResult = ReturnType<typeof useUpdateTeamMutation>;
export type UpdateTeamMutationResult = Apollo.MutationResult<UpdateTeamMutation>;
export type UpdateTeamMutationOptions = Apollo.BaseMutationOptions<UpdateTeamMutation, UpdateTeamMutationVariables>;
export const ArchiveTeamDocument = gql`
    mutation ArchiveTeam($id: ID!) {
  archiveTeam(id: $id) {
    id
    archivedAt
  }
}
    `;
export type ArchiveTeamMutationFn = Apollo.MutationFunction<ArchiveTeamMutation, ArchiveTeamMutationVariables>;

/**
 * __useArchiveTeamMutation__
 *
 * To run a mutation, you first call `useArchiveTeamMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTeamMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTeamMutation, { data, loading, error }] = useArchiveTeamMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveTeamMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTeamMutation, ArchiveTeamMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTeamMutation, ArchiveTeamMutationVariables>(ArchiveTeamDocument, options);
      }
export type ArchiveTeamMutationHookResult = ReturnType<typeof useArchiveTeamMutation>;
export type ArchiveTeamMutationResult = Apollo.MutationResult<ArchiveTeamMutation>;
export type ArchiveTeamMutationOptions = Apollo.BaseMutationOptions<ArchiveTeamMutation, ArchiveTeamMutationVariables>;
export const AddTeamMemberDocument = gql`
    mutation AddTeamMember($teamId: ID!, $userId: ID!) {
  addTeamMember(teamId: $teamId, userId: $userId) {
    id
  }
}
    `;
export type AddTeamMemberMutationFn = Apollo.MutationFunction<AddTeamMemberMutation, AddTeamMemberMutationVariables>;

/**
 * __useAddTeamMemberMutation__
 *
 * To run a mutation, you first call `useAddTeamMemberMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTeamMemberMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTeamMemberMutation, { data, loading, error }] = useAddTeamMemberMutation({
 *   variables: {
 *      teamId: // value for 'teamId'
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useAddTeamMemberMutation(baseOptions?: Apollo.MutationHookOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTeamMemberMutation, AddTeamMemberMutationVariables>(AddTeamMemberDocument, options);
      }
export type AddTeamMemberMutationHookResult = ReturnType<typeof useAddTeamMemberMutation>;
export type AddTeamMemberMutationResult = Apollo.MutationResult<AddTeamMemberMutation>;
export type AddTeamMemberMutationOptions = Apollo.BaseMutationOptions<AddTeamMemberMutation, AddTeamMemberMutationVariables>;
export const GetTriggerDefinitionsDocument = gql`
    query GetTriggerDefinitions {
  triggerDefinitions {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;

/**
 * __useGetTriggerDefinitionsQuery__
 *
 * To run a query within a React component, call `useGetTriggerDefinitionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerDefinitionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerDefinitionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTriggerDefinitionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>(GetTriggerDefinitionsDocument, options);
      }
export function useGetTriggerDefinitionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>(GetTriggerDefinitionsDocument, options);
        }
// @ts-ignore
export function useGetTriggerDefinitionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>;
export function useGetTriggerDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerDefinitionsQuery | undefined, GetTriggerDefinitionsQueryVariables>;
export function useGetTriggerDefinitionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>(GetTriggerDefinitionsDocument, options);
        }
export type GetTriggerDefinitionsQueryHookResult = ReturnType<typeof useGetTriggerDefinitionsQuery>;
export type GetTriggerDefinitionsLazyQueryHookResult = ReturnType<typeof useGetTriggerDefinitionsLazyQuery>;
export type GetTriggerDefinitionsSuspenseQueryHookResult = ReturnType<typeof useGetTriggerDefinitionsSuspenseQuery>;
export type GetTriggerDefinitionsQueryResult = Apollo.QueryResult<GetTriggerDefinitionsQuery, GetTriggerDefinitionsQueryVariables>;
export const GetTriggerDefinitionDocument = gql`
    query GetTriggerDefinition($id: ID!) {
  triggerDefinition(id: $id) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;

/**
 * __useGetTriggerDefinitionQuery__
 *
 * To run a query within a React component, call `useGetTriggerDefinitionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerDefinitionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerDefinitionQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTriggerDefinitionQuery(baseOptions: Apollo.QueryHookOptions<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables> & ({ variables: GetTriggerDefinitionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>(GetTriggerDefinitionDocument, options);
      }
export function useGetTriggerDefinitionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>(GetTriggerDefinitionDocument, options);
        }
// @ts-ignore
export function useGetTriggerDefinitionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>;
export function useGetTriggerDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerDefinitionQuery | undefined, GetTriggerDefinitionQueryVariables>;
export function useGetTriggerDefinitionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>(GetTriggerDefinitionDocument, options);
        }
export type GetTriggerDefinitionQueryHookResult = ReturnType<typeof useGetTriggerDefinitionQuery>;
export type GetTriggerDefinitionLazyQueryHookResult = ReturnType<typeof useGetTriggerDefinitionLazyQuery>;
export type GetTriggerDefinitionSuspenseQueryHookResult = ReturnType<typeof useGetTriggerDefinitionSuspenseQuery>;
export type GetTriggerDefinitionQueryResult = Apollo.QueryResult<GetTriggerDefinitionQuery, GetTriggerDefinitionQueryVariables>;
export const CreateTriggerDefinitionDocument = gql`
    mutation CreateTriggerDefinition($input: CreateTriggerDefinitionInput!) {
  createTriggerDefinition(input: $input) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;
export type CreateTriggerDefinitionMutationFn = Apollo.MutationFunction<CreateTriggerDefinitionMutation, CreateTriggerDefinitionMutationVariables>;

/**
 * __useCreateTriggerDefinitionMutation__
 *
 * To run a mutation, you first call `useCreateTriggerDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTriggerDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTriggerDefinitionMutation, { data, loading, error }] = useCreateTriggerDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateTriggerDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<CreateTriggerDefinitionMutation, CreateTriggerDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateTriggerDefinitionMutation, CreateTriggerDefinitionMutationVariables>(CreateTriggerDefinitionDocument, options);
      }
export type CreateTriggerDefinitionMutationHookResult = ReturnType<typeof useCreateTriggerDefinitionMutation>;
export type CreateTriggerDefinitionMutationResult = Apollo.MutationResult<CreateTriggerDefinitionMutation>;
export type CreateTriggerDefinitionMutationOptions = Apollo.BaseMutationOptions<CreateTriggerDefinitionMutation, CreateTriggerDefinitionMutationVariables>;
export const UpdateTriggerDefinitionDocument = gql`
    mutation UpdateTriggerDefinition($input: UpdateTriggerDefinitionInput!) {
  updateTriggerDefinition(input: $input) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;
export type UpdateTriggerDefinitionMutationFn = Apollo.MutationFunction<UpdateTriggerDefinitionMutation, UpdateTriggerDefinitionMutationVariables>;

/**
 * __useUpdateTriggerDefinitionMutation__
 *
 * To run a mutation, you first call `useUpdateTriggerDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTriggerDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTriggerDefinitionMutation, { data, loading, error }] = useUpdateTriggerDefinitionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTriggerDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTriggerDefinitionMutation, UpdateTriggerDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTriggerDefinitionMutation, UpdateTriggerDefinitionMutationVariables>(UpdateTriggerDefinitionDocument, options);
      }
export type UpdateTriggerDefinitionMutationHookResult = ReturnType<typeof useUpdateTriggerDefinitionMutation>;
export type UpdateTriggerDefinitionMutationResult = Apollo.MutationResult<UpdateTriggerDefinitionMutation>;
export type UpdateTriggerDefinitionMutationOptions = Apollo.BaseMutationOptions<UpdateTriggerDefinitionMutation, UpdateTriggerDefinitionMutationVariables>;
export const PauseTriggerDefinitionDocument = gql`
    mutation PauseTriggerDefinition($id: ID!, $version: Int64!) {
  pauseTriggerDefinition(id: $id, version: $version) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;
export type PauseTriggerDefinitionMutationFn = Apollo.MutationFunction<PauseTriggerDefinitionMutation, PauseTriggerDefinitionMutationVariables>;

/**
 * __usePauseTriggerDefinitionMutation__
 *
 * To run a mutation, you first call `usePauseTriggerDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePauseTriggerDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [pauseTriggerDefinitionMutation, { data, loading, error }] = usePauseTriggerDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function usePauseTriggerDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<PauseTriggerDefinitionMutation, PauseTriggerDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PauseTriggerDefinitionMutation, PauseTriggerDefinitionMutationVariables>(PauseTriggerDefinitionDocument, options);
      }
export type PauseTriggerDefinitionMutationHookResult = ReturnType<typeof usePauseTriggerDefinitionMutation>;
export type PauseTriggerDefinitionMutationResult = Apollo.MutationResult<PauseTriggerDefinitionMutation>;
export type PauseTriggerDefinitionMutationOptions = Apollo.BaseMutationOptions<PauseTriggerDefinitionMutation, PauseTriggerDefinitionMutationVariables>;
export const ResumeTriggerDefinitionDocument = gql`
    mutation ResumeTriggerDefinition($id: ID!, $version: Int64!) {
  resumeTriggerDefinition(id: $id, version: $version) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;
export type ResumeTriggerDefinitionMutationFn = Apollo.MutationFunction<ResumeTriggerDefinitionMutation, ResumeTriggerDefinitionMutationVariables>;

/**
 * __useResumeTriggerDefinitionMutation__
 *
 * To run a mutation, you first call `useResumeTriggerDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResumeTriggerDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resumeTriggerDefinitionMutation, { data, loading, error }] = useResumeTriggerDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useResumeTriggerDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<ResumeTriggerDefinitionMutation, ResumeTriggerDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResumeTriggerDefinitionMutation, ResumeTriggerDefinitionMutationVariables>(ResumeTriggerDefinitionDocument, options);
      }
export type ResumeTriggerDefinitionMutationHookResult = ReturnType<typeof useResumeTriggerDefinitionMutation>;
export type ResumeTriggerDefinitionMutationResult = Apollo.MutationResult<ResumeTriggerDefinitionMutation>;
export type ResumeTriggerDefinitionMutationOptions = Apollo.BaseMutationOptions<ResumeTriggerDefinitionMutation, ResumeTriggerDefinitionMutationVariables>;
export const ArchiveTriggerDefinitionDocument = gql`
    mutation ArchiveTriggerDefinition($id: ID!) {
  archiveTriggerDefinition(id: $id) {
    ...TriggerDefinitionFields
  }
}
    ${TriggerDefinitionFieldsFragmentDoc}`;
export type ArchiveTriggerDefinitionMutationFn = Apollo.MutationFunction<ArchiveTriggerDefinitionMutation, ArchiveTriggerDefinitionMutationVariables>;

/**
 * __useArchiveTriggerDefinitionMutation__
 *
 * To run a mutation, you first call `useArchiveTriggerDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useArchiveTriggerDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [archiveTriggerDefinitionMutation, { data, loading, error }] = useArchiveTriggerDefinitionMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useArchiveTriggerDefinitionMutation(baseOptions?: Apollo.MutationHookOptions<ArchiveTriggerDefinitionMutation, ArchiveTriggerDefinitionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ArchiveTriggerDefinitionMutation, ArchiveTriggerDefinitionMutationVariables>(ArchiveTriggerDefinitionDocument, options);
      }
export type ArchiveTriggerDefinitionMutationHookResult = ReturnType<typeof useArchiveTriggerDefinitionMutation>;
export type ArchiveTriggerDefinitionMutationResult = Apollo.MutationResult<ArchiveTriggerDefinitionMutation>;
export type ArchiveTriggerDefinitionMutationOptions = Apollo.BaseMutationOptions<ArchiveTriggerDefinitionMutation, ArchiveTriggerDefinitionMutationVariables>;
export const GetTriggerEmailBuilderOptionsDocument = gql`
    query GetTriggerEmailBuilderOptions($definitionId: ID) {
  triggerEmailBuilderOptions(definitionId: $definitionId) {
    accounts {
      id
      ownerUserId
      address
      status
    }
    users {
      id
      name
      email
      state
    }
    profiles {
      id
      name
    }
    presets {
      id
      name
      ready
      visibility {
        ...VisibilityConfigFields
      }
    }
    builtInPresets {
      preset
      useCases
    }
    privacySupported
  }
}
    ${VisibilityConfigFieldsFragmentDoc}`;

/**
 * __useGetTriggerEmailBuilderOptionsQuery__
 *
 * To run a query within a React component, call `useGetTriggerEmailBuilderOptionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerEmailBuilderOptionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerEmailBuilderOptionsQuery({
 *   variables: {
 *      definitionId: // value for 'definitionId'
 *   },
 * });
 */
export function useGetTriggerEmailBuilderOptionsQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>(GetTriggerEmailBuilderOptionsDocument, options);
      }
export function useGetTriggerEmailBuilderOptionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>(GetTriggerEmailBuilderOptionsDocument, options);
        }
// @ts-ignore
export function useGetTriggerEmailBuilderOptionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>;
export function useGetTriggerEmailBuilderOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailBuilderOptionsQuery | undefined, GetTriggerEmailBuilderOptionsQueryVariables>;
export function useGetTriggerEmailBuilderOptionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>(GetTriggerEmailBuilderOptionsDocument, options);
        }
export type GetTriggerEmailBuilderOptionsQueryHookResult = ReturnType<typeof useGetTriggerEmailBuilderOptionsQuery>;
export type GetTriggerEmailBuilderOptionsLazyQueryHookResult = ReturnType<typeof useGetTriggerEmailBuilderOptionsLazyQuery>;
export type GetTriggerEmailBuilderOptionsSuspenseQueryHookResult = ReturnType<typeof useGetTriggerEmailBuilderOptionsSuspenseQuery>;
export type GetTriggerEmailBuilderOptionsQueryResult = Apollo.QueryResult<GetTriggerEmailBuilderOptionsQuery, GetTriggerEmailBuilderOptionsQueryVariables>;
export const GetTriggerEmailFoldersDocument = gql`
    query GetTriggerEmailFolders($accountId: ID!) {
  triggerEmailFolders(accountId: $accountId) {
    id
    name
    role
    path
  }
}
    `;

/**
 * __useGetTriggerEmailFoldersQuery__
 *
 * To run a query within a React component, call `useGetTriggerEmailFoldersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerEmailFoldersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerEmailFoldersQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetTriggerEmailFoldersQuery(baseOptions: Apollo.QueryHookOptions<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables> & ({ variables: GetTriggerEmailFoldersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>(GetTriggerEmailFoldersDocument, options);
      }
export function useGetTriggerEmailFoldersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>(GetTriggerEmailFoldersDocument, options);
        }
// @ts-ignore
export function useGetTriggerEmailFoldersSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>;
export function useGetTriggerEmailFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailFoldersQuery | undefined, GetTriggerEmailFoldersQueryVariables>;
export function useGetTriggerEmailFoldersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>(GetTriggerEmailFoldersDocument, options);
        }
export type GetTriggerEmailFoldersQueryHookResult = ReturnType<typeof useGetTriggerEmailFoldersQuery>;
export type GetTriggerEmailFoldersLazyQueryHookResult = ReturnType<typeof useGetTriggerEmailFoldersLazyQuery>;
export type GetTriggerEmailFoldersSuspenseQueryHookResult = ReturnType<typeof useGetTriggerEmailFoldersSuspenseQuery>;
export type GetTriggerEmailFoldersQueryResult = Apollo.QueryResult<GetTriggerEmailFoldersQuery, GetTriggerEmailFoldersQueryVariables>;
export const GetTriggerEmailRunsDocument = gql`
    query GetTriggerEmailRuns($triggerDefinitionId: ID, $first: Int) {
  triggerEmailRuns(triggerDefinitionId: $triggerDefinitionId, first: $first) {
    id
    triggerDefinitionId
    state
    queuedAt
    dispatchedAt
    workspaceId
    error {
      code
      message
    }
  }
}
    `;

/**
 * __useGetTriggerEmailRunsQuery__
 *
 * To run a query within a React component, call `useGetTriggerEmailRunsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerEmailRunsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerEmailRunsQuery({
 *   variables: {
 *      triggerDefinitionId: // value for 'triggerDefinitionId'
 *      first: // value for 'first'
 *   },
 * });
 */
export function useGetTriggerEmailRunsQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>(GetTriggerEmailRunsDocument, options);
      }
export function useGetTriggerEmailRunsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>(GetTriggerEmailRunsDocument, options);
        }
// @ts-ignore
export function useGetTriggerEmailRunsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>;
export function useGetTriggerEmailRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEmailRunsQuery | undefined, GetTriggerEmailRunsQueryVariables>;
export function useGetTriggerEmailRunsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>(GetTriggerEmailRunsDocument, options);
        }
export type GetTriggerEmailRunsQueryHookResult = ReturnType<typeof useGetTriggerEmailRunsQuery>;
export type GetTriggerEmailRunsLazyQueryHookResult = ReturnType<typeof useGetTriggerEmailRunsLazyQuery>;
export type GetTriggerEmailRunsSuspenseQueryHookResult = ReturnType<typeof useGetTriggerEmailRunsSuspenseQuery>;
export type GetTriggerEmailRunsQueryResult = Apollo.QueryResult<GetTriggerEmailRunsQuery, GetTriggerEmailRunsQueryVariables>;
export const GetTriggerEventsDocument = gql`
    query GetTriggerEvents($first: Int, $after: String, $triggerDefinitionId: ID) {
  triggerEvents(
    first: $first
    after: $after
    triggerDefinitionId: $triggerDefinitionId
  ) {
    edges {
      cursor
      node {
        ...TriggerEventListFields
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
    totalCount
  }
}
    ${TriggerEventListFieldsFragmentDoc}`;

/**
 * __useGetTriggerEventsQuery__
 *
 * To run a query within a React component, call `useGetTriggerEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerEventsQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      triggerDefinitionId: // value for 'triggerDefinitionId'
 *   },
 * });
 */
export function useGetTriggerEventsQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>(GetTriggerEventsDocument, options);
      }
export function useGetTriggerEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>(GetTriggerEventsDocument, options);
        }
// @ts-ignore
export function useGetTriggerEventsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>;
export function useGetTriggerEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEventsQuery | undefined, GetTriggerEventsQueryVariables>;
export function useGetTriggerEventsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>(GetTriggerEventsDocument, options);
        }
export type GetTriggerEventsQueryHookResult = ReturnType<typeof useGetTriggerEventsQuery>;
export type GetTriggerEventsLazyQueryHookResult = ReturnType<typeof useGetTriggerEventsLazyQuery>;
export type GetTriggerEventsSuspenseQueryHookResult = ReturnType<typeof useGetTriggerEventsSuspenseQuery>;
export type GetTriggerEventsQueryResult = Apollo.QueryResult<GetTriggerEventsQuery, GetTriggerEventsQueryVariables>;
export const GetTriggerEventDocument = gql`
    query GetTriggerEvent($id: ID!) {
  triggerEvent(id: $id) {
    ...TriggerEventDetailFields
  }
}
    ${TriggerEventDetailFieldsFragmentDoc}`;

/**
 * __useGetTriggerEventQuery__
 *
 * To run a query within a React component, call `useGetTriggerEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetTriggerEventQuery(baseOptions: Apollo.QueryHookOptions<GetTriggerEventQuery, GetTriggerEventQueryVariables> & ({ variables: GetTriggerEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerEventQuery, GetTriggerEventQueryVariables>(GetTriggerEventDocument, options);
      }
export function useGetTriggerEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerEventQuery, GetTriggerEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerEventQuery, GetTriggerEventQueryVariables>(GetTriggerEventDocument, options);
        }
// @ts-ignore
export function useGetTriggerEventSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerEventQuery, GetTriggerEventQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEventQuery, GetTriggerEventQueryVariables>;
export function useGetTriggerEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEventQuery, GetTriggerEventQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerEventQuery | undefined, GetTriggerEventQueryVariables>;
export function useGetTriggerEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerEventQuery, GetTriggerEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerEventQuery, GetTriggerEventQueryVariables>(GetTriggerEventDocument, options);
        }
export type GetTriggerEventQueryHookResult = ReturnType<typeof useGetTriggerEventQuery>;
export type GetTriggerEventLazyQueryHookResult = ReturnType<typeof useGetTriggerEventLazyQuery>;
export type GetTriggerEventSuspenseQueryHookResult = ReturnType<typeof useGetTriggerEventSuspenseQuery>;
export type GetTriggerEventQueryResult = Apollo.QueryResult<GetTriggerEventQuery, GetTriggerEventQueryVariables>;
export const GetTriggerExecutionHistoryDocument = gql`
    query GetTriggerExecutionHistory($first: Int! = 50, $after: String, $filter: TriggerExecutionHistoryFilter) {
  triggerExecutionHistory(first: $first, after: $after, filter: $filter) {
    edges {
      cursor
      summary
      event {
        ...TriggerEventListFields
      }
      emailRun {
        id
        triggerDefinitionId
        state
        queuedAt
        dispatchedAt
        workspaceId
        error {
          code
          message
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    ${TriggerEventListFieldsFragmentDoc}`;

/**
 * __useGetTriggerExecutionHistoryQuery__
 *
 * To run a query within a React component, call `useGetTriggerExecutionHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTriggerExecutionHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTriggerExecutionHistoryQuery({
 *   variables: {
 *      first: // value for 'first'
 *      after: // value for 'after'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetTriggerExecutionHistoryQuery(baseOptions?: Apollo.QueryHookOptions<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>(GetTriggerExecutionHistoryDocument, options);
      }
export function useGetTriggerExecutionHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>(GetTriggerExecutionHistoryDocument, options);
        }
// @ts-ignore
export function useGetTriggerExecutionHistorySuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>;
export function useGetTriggerExecutionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>): Apollo.UseSuspenseQueryResult<GetTriggerExecutionHistoryQuery | undefined, GetTriggerExecutionHistoryQueryVariables>;
export function useGetTriggerExecutionHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>(GetTriggerExecutionHistoryDocument, options);
        }
export type GetTriggerExecutionHistoryQueryHookResult = ReturnType<typeof useGetTriggerExecutionHistoryQuery>;
export type GetTriggerExecutionHistoryLazyQueryHookResult = ReturnType<typeof useGetTriggerExecutionHistoryLazyQuery>;
export type GetTriggerExecutionHistorySuspenseQueryHookResult = ReturnType<typeof useGetTriggerExecutionHistorySuspenseQuery>;
export type GetTriggerExecutionHistoryQueryResult = Apollo.QueryResult<GetTriggerExecutionHistoryQuery, GetTriggerExecutionHistoryQueryVariables>;
export const GetVoiceAgentsDocument = gql`
    query GetVoiceAgents($filter: VoiceAgentsFilterInput) {
  voiceAgents(filter: $filter) {
    ...VoiceAgentOverviewFields
  }
}
    ${VoiceAgentOverviewFieldsFragmentDoc}`;

/**
 * __useGetVoiceAgentsQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetVoiceAgentsQuery(baseOptions?: Apollo.QueryHookOptions<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>(GetVoiceAgentsDocument, options);
      }
export function useGetVoiceAgentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>(GetVoiceAgentsDocument, options);
        }
// @ts-ignore
export function useGetVoiceAgentsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>;
export function useGetVoiceAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentsQuery | undefined, GetVoiceAgentsQueryVariables>;
export function useGetVoiceAgentsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>(GetVoiceAgentsDocument, options);
        }
export type GetVoiceAgentsQueryHookResult = ReturnType<typeof useGetVoiceAgentsQuery>;
export type GetVoiceAgentsLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentsLazyQuery>;
export type GetVoiceAgentsSuspenseQueryHookResult = ReturnType<typeof useGetVoiceAgentsSuspenseQuery>;
export type GetVoiceAgentsQueryResult = Apollo.QueryResult<GetVoiceAgentsQuery, GetVoiceAgentsQueryVariables>;
export const GetVoiceAgentDocument = gql`
    query GetVoiceAgent($id: ID!) {
  voiceAgent(id: $id) {
    ...VoiceAgentFields
  }
}
    ${VoiceAgentFieldsFragmentDoc}`;

/**
 * __useGetVoiceAgentQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetVoiceAgentQuery(baseOptions: Apollo.QueryHookOptions<GetVoiceAgentQuery, GetVoiceAgentQueryVariables> & ({ variables: GetVoiceAgentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>(GetVoiceAgentDocument, options);
      }
export function useGetVoiceAgentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>(GetVoiceAgentDocument, options);
        }
// @ts-ignore
export function useGetVoiceAgentSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>;
export function useGetVoiceAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentQuery | undefined, GetVoiceAgentQueryVariables>;
export function useGetVoiceAgentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>(GetVoiceAgentDocument, options);
        }
export type GetVoiceAgentQueryHookResult = ReturnType<typeof useGetVoiceAgentQuery>;
export type GetVoiceAgentLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentLazyQuery>;
export type GetVoiceAgentSuspenseQueryHookResult = ReturnType<typeof useGetVoiceAgentSuspenseQuery>;
export type GetVoiceAgentQueryResult = Apollo.QueryResult<GetVoiceAgentQuery, GetVoiceAgentQueryVariables>;
export const GetVoiceAgentLanguageSupportDocument = gql`
    query GetVoiceAgentLanguageSupport {
  voiceAgentLanguageSupport {
    providers {
      provider
      languages
      preferredLanguages
      defaultVoice
    }
    voices {
      voice
      provider
      custom
    }
    englishLanguages
  }
}
    `;

/**
 * __useGetVoiceAgentLanguageSupportQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentLanguageSupportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentLanguageSupportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentLanguageSupportQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVoiceAgentLanguageSupportQuery(baseOptions?: Apollo.QueryHookOptions<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>(GetVoiceAgentLanguageSupportDocument, options);
      }
export function useGetVoiceAgentLanguageSupportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>(GetVoiceAgentLanguageSupportDocument, options);
        }
// @ts-ignore
export function useGetVoiceAgentLanguageSupportSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>;
export function useGetVoiceAgentLanguageSupportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentLanguageSupportQuery | undefined, GetVoiceAgentLanguageSupportQueryVariables>;
export function useGetVoiceAgentLanguageSupportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>(GetVoiceAgentLanguageSupportDocument, options);
        }
export type GetVoiceAgentLanguageSupportQueryHookResult = ReturnType<typeof useGetVoiceAgentLanguageSupportQuery>;
export type GetVoiceAgentLanguageSupportLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentLanguageSupportLazyQuery>;
export type GetVoiceAgentLanguageSupportSuspenseQueryHookResult = ReturnType<typeof useGetVoiceAgentLanguageSupportSuspenseQuery>;
export type GetVoiceAgentLanguageSupportQueryResult = Apollo.QueryResult<GetVoiceAgentLanguageSupportQuery, GetVoiceAgentLanguageSupportQueryVariables>;
export const CreateVoiceAgentDocument = gql`
    mutation CreateVoiceAgent($input: CreateVoiceAgentInput!) {
  createVoiceAgent(input: $input) {
    ...VoiceAgentFields
  }
}
    ${VoiceAgentFieldsFragmentDoc}`;
export type CreateVoiceAgentMutationFn = Apollo.MutationFunction<CreateVoiceAgentMutation, CreateVoiceAgentMutationVariables>;

/**
 * __useCreateVoiceAgentMutation__
 *
 * To run a mutation, you first call `useCreateVoiceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateVoiceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createVoiceAgentMutation, { data, loading, error }] = useCreateVoiceAgentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateVoiceAgentMutation(baseOptions?: Apollo.MutationHookOptions<CreateVoiceAgentMutation, CreateVoiceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateVoiceAgentMutation, CreateVoiceAgentMutationVariables>(CreateVoiceAgentDocument, options);
      }
export type CreateVoiceAgentMutationHookResult = ReturnType<typeof useCreateVoiceAgentMutation>;
export type CreateVoiceAgentMutationResult = Apollo.MutationResult<CreateVoiceAgentMutation>;
export type CreateVoiceAgentMutationOptions = Apollo.BaseMutationOptions<CreateVoiceAgentMutation, CreateVoiceAgentMutationVariables>;
export const UpdateVoiceAgentDocument = gql`
    mutation UpdateVoiceAgent($id: ID!, $input: VoiceAgentInput!, $transferDirectoryChanges: [TransferDirectoryChangeInput!], $idempotencyKey: String) {
  updateVoiceAgent(
    id: $id
    input: $input
    transferDirectoryChanges: $transferDirectoryChanges
    idempotencyKey: $idempotencyKey
  ) {
    ...VoiceAgentFields
  }
}
    ${VoiceAgentFieldsFragmentDoc}`;
export type UpdateVoiceAgentMutationFn = Apollo.MutationFunction<UpdateVoiceAgentMutation, UpdateVoiceAgentMutationVariables>;

/**
 * __useUpdateVoiceAgentMutation__
 *
 * To run a mutation, you first call `useUpdateVoiceAgentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateVoiceAgentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateVoiceAgentMutation, { data, loading, error }] = useUpdateVoiceAgentMutation({
 *   variables: {
 *      id: // value for 'id'
 *      input: // value for 'input'
 *      transferDirectoryChanges: // value for 'transferDirectoryChanges'
 *      idempotencyKey: // value for 'idempotencyKey'
 *   },
 * });
 */
export function useUpdateVoiceAgentMutation(baseOptions?: Apollo.MutationHookOptions<UpdateVoiceAgentMutation, UpdateVoiceAgentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateVoiceAgentMutation, UpdateVoiceAgentMutationVariables>(UpdateVoiceAgentDocument, options);
      }
export type UpdateVoiceAgentMutationHookResult = ReturnType<typeof useUpdateVoiceAgentMutation>;
export type UpdateVoiceAgentMutationResult = Apollo.MutationResult<UpdateVoiceAgentMutation>;
export type UpdateVoiceAgentMutationOptions = Apollo.BaseMutationOptions<UpdateVoiceAgentMutation, UpdateVoiceAgentMutationVariables>;
export const GetVoiceAgentCreateContextDocument = gql`
    query GetVoiceAgentCreateContext {
  agencyUser {
    ...LoggedInAgencyUserFields
    agency {
      outboundVoiceComplianceAcknowledgmentRequired
      outboundVoiceComplianceDisclosure {
        ...OutboundVoiceComplianceDisclosureFields
      }
    }
  }
}
    ${LoggedInAgencyUserFieldsFragmentDoc}
${OutboundVoiceComplianceDisclosureFieldsFragmentDoc}`;

/**
 * __useGetVoiceAgentCreateContextQuery__
 *
 * To run a query within a React component, call `useGetVoiceAgentCreateContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetVoiceAgentCreateContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetVoiceAgentCreateContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetVoiceAgentCreateContextQuery(baseOptions?: Apollo.QueryHookOptions<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>(GetVoiceAgentCreateContextDocument, options);
      }
export function useGetVoiceAgentCreateContextLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>(GetVoiceAgentCreateContextDocument, options);
        }
// @ts-ignore
export function useGetVoiceAgentCreateContextSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>;
export function useGetVoiceAgentCreateContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>): Apollo.UseSuspenseQueryResult<GetVoiceAgentCreateContextQuery | undefined, GetVoiceAgentCreateContextQueryVariables>;
export function useGetVoiceAgentCreateContextSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>(GetVoiceAgentCreateContextDocument, options);
        }
export type GetVoiceAgentCreateContextQueryHookResult = ReturnType<typeof useGetVoiceAgentCreateContextQuery>;
export type GetVoiceAgentCreateContextLazyQueryHookResult = ReturnType<typeof useGetVoiceAgentCreateContextLazyQuery>;
export type GetVoiceAgentCreateContextSuspenseQueryHookResult = ReturnType<typeof useGetVoiceAgentCreateContextSuspenseQuery>;
export type GetVoiceAgentCreateContextQueryResult = Apollo.QueryResult<GetVoiceAgentCreateContextQuery, GetVoiceAgentCreateContextQueryVariables>;
export const GetWorkflowExecutionsDocument = gql`
    query GetWorkflowExecutions {
  workflowExecutions {
    id
    state
    version
    startedAt
    completedAt
    createdAt
    updatedAt
    error {
      message
      code
    }
    tasks {
      id
      definitionKey
      state
    }
  }
}
    `;

/**
 * __useGetWorkflowExecutionsQuery__
 *
 * To run a query within a React component, call `useGetWorkflowExecutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowExecutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowExecutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWorkflowExecutionsQuery(baseOptions?: Apollo.QueryHookOptions<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>(GetWorkflowExecutionsDocument, options);
      }
export function useGetWorkflowExecutionsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>(GetWorkflowExecutionsDocument, options);
        }
// @ts-ignore
export function useGetWorkflowExecutionsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>;
export function useGetWorkflowExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowExecutionsQuery | undefined, GetWorkflowExecutionsQueryVariables>;
export function useGetWorkflowExecutionsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>(GetWorkflowExecutionsDocument, options);
        }
export type GetWorkflowExecutionsQueryHookResult = ReturnType<typeof useGetWorkflowExecutionsQuery>;
export type GetWorkflowExecutionsLazyQueryHookResult = ReturnType<typeof useGetWorkflowExecutionsLazyQuery>;
export type GetWorkflowExecutionsSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowExecutionsSuspenseQuery>;
export type GetWorkflowExecutionsQueryResult = Apollo.QueryResult<GetWorkflowExecutionsQuery, GetWorkflowExecutionsQueryVariables>;
export const GetWorkflowExecutionDocument = gql`
    query GetWorkflowExecution($id: ID!, $version: Int64) {
  workflowExecution(id: $id, version: $version) {
    id
    state
    version
    startedAt
    completedAt
    createdAt
    updatedAt
    error {
      message
      code
    }
    tasks {
      id
      definitionKey
      state
    }
    outputs {
      id
      label
      type
      artifact {
        type
        name
        markdown {
          content
        }
        file {
          fileId
          mimeType
          url
        }
      }
    }
  }
}
    `;

/**
 * __useGetWorkflowExecutionQuery__
 *
 * To run a query within a React component, call `useGetWorkflowExecutionQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWorkflowExecutionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWorkflowExecutionQuery({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useGetWorkflowExecutionQuery(baseOptions: Apollo.QueryHookOptions<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables> & ({ variables: GetWorkflowExecutionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>(GetWorkflowExecutionDocument, options);
      }
export function useGetWorkflowExecutionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>(GetWorkflowExecutionDocument, options);
        }
// @ts-ignore
export function useGetWorkflowExecutionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>;
export function useGetWorkflowExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>): Apollo.UseSuspenseQueryResult<GetWorkflowExecutionQuery | undefined, GetWorkflowExecutionQueryVariables>;
export function useGetWorkflowExecutionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>(GetWorkflowExecutionDocument, options);
        }
export type GetWorkflowExecutionQueryHookResult = ReturnType<typeof useGetWorkflowExecutionQuery>;
export type GetWorkflowExecutionLazyQueryHookResult = ReturnType<typeof useGetWorkflowExecutionLazyQuery>;
export type GetWorkflowExecutionSuspenseQueryHookResult = ReturnType<typeof useGetWorkflowExecutionSuspenseQuery>;
export type GetWorkflowExecutionQueryResult = Apollo.QueryResult<GetWorkflowExecutionQuery, GetWorkflowExecutionQueryVariables>;
export const CreateWorkflowExecutionDocument = gql`
    mutation CreateWorkflowExecution($input: CreateWorkflowExecutionInput!) {
  createWorkflowExecution(input: $input) {
    id
    state
    version
  }
}
    `;
export type CreateWorkflowExecutionMutationFn = Apollo.MutationFunction<CreateWorkflowExecutionMutation, CreateWorkflowExecutionMutationVariables>;

/**
 * __useCreateWorkflowExecutionMutation__
 *
 * To run a mutation, you first call `useCreateWorkflowExecutionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateWorkflowExecutionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createWorkflowExecutionMutation, { data, loading, error }] = useCreateWorkflowExecutionMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreateWorkflowExecutionMutation(baseOptions?: Apollo.MutationHookOptions<CreateWorkflowExecutionMutation, CreateWorkflowExecutionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateWorkflowExecutionMutation, CreateWorkflowExecutionMutationVariables>(CreateWorkflowExecutionDocument, options);
      }
export type CreateWorkflowExecutionMutationHookResult = ReturnType<typeof useCreateWorkflowExecutionMutation>;
export type CreateWorkflowExecutionMutationResult = Apollo.MutationResult<CreateWorkflowExecutionMutation>;
export type CreateWorkflowExecutionMutationOptions = Apollo.BaseMutationOptions<CreateWorkflowExecutionMutation, CreateWorkflowExecutionMutationVariables>;
export const WatchWorkflowExecutionDocument = gql`
    subscription WatchWorkflowExecution($id: ID!, $version: Int64!) {
  watchWorkflowExecution(id: $id, version: $version) {
    id
    state
    version
    startedAt
    completedAt
    updatedAt
    error {
      message
      code
    }
    outputs {
      id
      label
      type
      artifact {
        type
        name
        markdown {
          content
        }
        file {
          fileId
          mimeType
          url
        }
      }
    }
    tasks {
      id
      definitionKey
      state
      startedAt
      completedAt
      dependencies {
        id
      }
      error {
        message
        code
      }
      outputs {
        id
        key
        sequence
        type
        text
        json {
          data
        }
        artifact {
          type
          name
          markdown {
            content
          }
          file {
            fileId
            mimeType
            url
          }
        }
      }
      events {
        id
        attempt
        sequence
        type
        title
        createdAt
        message {
          content
          level
        }
        thinking {
          content
        }
        progress {
          message
          percent
        }
        retrieval {
          query
          resultCount
        }
        toolCall {
          toolName
          input
          output
        }
        spawnEvent {
          spawnedTaskId
          description
        }
        error {
          message
          code
        }
      }
    }
  }
}
    `;

/**
 * __useWatchWorkflowExecutionSubscription__
 *
 * To run a query within a React component, call `useWatchWorkflowExecutionSubscription` and pass it any options that fit your needs.
 * When your component renders, `useWatchWorkflowExecutionSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWatchWorkflowExecutionSubscription({
 *   variables: {
 *      id: // value for 'id'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useWatchWorkflowExecutionSubscription(baseOptions: Apollo.SubscriptionHookOptions<WatchWorkflowExecutionSubscription, WatchWorkflowExecutionSubscriptionVariables> & ({ variables: WatchWorkflowExecutionSubscriptionVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useSubscription<WatchWorkflowExecutionSubscription, WatchWorkflowExecutionSubscriptionVariables>(WatchWorkflowExecutionDocument, options);
      }
export type WatchWorkflowExecutionSubscriptionHookResult = ReturnType<typeof useWatchWorkflowExecutionSubscription>;
export type WatchWorkflowExecutionSubscriptionResult = Apollo.SubscriptionResult<WatchWorkflowExecutionSubscription>;